import './style.css';
var yZ = Object.defineProperty;
var xZ = (e, t, r) => t in e ? yZ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var df = (e, t, r) => (xZ(e, typeof t != "symbol" ? t + "" : t, r), r);
import { openBlock as ie, createElementBlock as Ve, createElementVNode as Ye, provide as tr, defineComponent as oe, ref as G, getCurrentInstance as uh, inject as lt, onBeforeUnmount as Gr, withDirectives as Jn, toRef as tt, computed as j, h as b, Teleport as AM, onMounted as br, watch as Gt, nextTick as an, renderSlot as nt, onActivated as $B, onDeactivated as EM, mergeProps as ir, Fragment as Lr, Transition as jn, watchEffect as On, vShow as Ra, cloneVNode as db, Text as wZ, TransitionGroup as jO, onBeforeUpdate as Nc, onUpdated as fi, markRaw as qN, onUnmounted as FO, createBlock as Pe, unref as B, withCtx as we, createVNode as Re, normalizeClass as Jr, createTextVNode as zr, Comment as BO, readonly as vc, onBeforeMount as ch, reactive as UO, normalizeStyle as Jf, useSlots as pn, createCommentVNode as yt, createSlots as fb, resolveDynamicComponent as mi, toDisplayString as ar, normalizeProps as OB, guardReactiveProps as _B, renderList as Fl, isVNode as MZ, vModelText as LB, pushScopeId as PB, popScopeId as RB, withModifiers as HO, resolveComponent as ff } from "vue";
function CZ(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4 19c.021.392.07.67.177.908.17.376.443.682.778.874.38.218.879.218 1.875.218h.534c.997 0 1.495 0 1.876-.218.335-.192.607-.498.778-.874.194-.428.194-.988.194-2.108V6.2c0-1.12 0-1.68-.194-2.108a1.905 1.905 0 00-.778-.874C8.86 3 8.361 3 7.364 3H6.83c-.996 0-1.495 0-1.875.218a1.905 1.905 0 00-.778.874C4.069 4.33 4.02 4.608 4 5m12.619-2h.534c.996 0 1.495 0 1.875.218.335.192.607.498.778.874C20 4.52 20 5.08 20 6.2v11.6c0 1.12 0 1.68-.194 2.108-.17.376-.443.682-.778.874-.38.218-.879.218-1.875.218h-.534c-.997 0-1.495 0-1.876-.218a1.904 1.904 0 01-.778-.874c-.194-.428-.194-.988-.194-2.108V6.2c0-1.12 0-1.68.194-2.108.17-.376.443-.682.778-.874C15.123 3 15.622 3 16.619 3zM4 9v6m-3-3h6"
    })
  ]);
}
function SZ(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M20 19c-.021.392-.07.67-.177.908-.17.376-.443.682-.778.874-.38.218-.879.218-1.875.218h-.534c-.997 0-1.495 0-1.876-.218a1.905 1.905 0 01-.778-.874c-.194-.428-.194-.988-.194-2.108V6.2c0-1.12 0-1.68.194-2.108.17-.376.443-.682.778-.874C15.14 3 15.639 3 16.636 3h.534c.996 0 1.495 0 1.875.218.335.192.607.498.778.874.108.238.156.516.177.908M7.381 3h-.534c-.996 0-1.495 0-1.875.218a1.905 1.905 0 00-.778.874C4 4.52 4 5.08 4 6.2v11.6c0 1.12 0 1.68.194 2.108.17.376.443.682.778.874.38.218.879.218 1.875.218h.534c.997 0 1.495 0 1.876-.218.335-.192.607-.498.778-.874.194-.428.194-.988.194-2.108V6.2c0-1.12 0-1.68-.194-2.108a1.905 1.905 0 00-.778-.874C8.877 3 8.378 3 7.381 3zM20 9v6m-3-3h6"
    })
  ]);
}
function TZ(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5 20.002c-.392-.022-.67-.07-.908-.177a1.905 1.905 0 01-.874-.777C3 18.668 3 18.17 3 17.174v-.533c0-.996 0-1.494.218-1.874.192-.335.498-.606.874-.777.428-.194.988-.194 2.108-.194h11.6c1.12 0 1.68 0 2.108.194.376.17.682.442.874.777.218.38.218.878.218 1.874v.533c0 .996 0 1.494-.218 1.874a1.904 1.904 0 01-.874.777c-.238.107-.516.155-.908.177M3 7.396v-.533c0-.996 0-1.494.218-1.874.192-.334.498-.606.874-.777.428-.193.988-.193 2.108-.193h11.6c1.12 0 1.68 0 2.108.193.376.17.682.443.874.777.218.38.218.878.218 1.874v.533c0 .996 0 1.494-.218 1.874a1.904 1.904 0 01-.874.777c-.428.194-.988.194-2.108.194H6.2c-1.12 0-1.68 0-2.108-.194a1.904 1.904 0 01-.874-.777C3 8.89 3 8.392 3 7.396zM12 17v6m-3-3h6"
    })
  ]);
}
function kZ(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5 4.017c-.392.021-.67.07-.908.177-.376.17-.682.442-.874.777C3 5.35 3 5.849 3 6.844v.534c0 .995 0 1.493.218 1.874.192.334.498.606.874.776.428.194.988.194 2.108.194h11.6c1.12 0 1.68 0 2.108-.194.376-.17.682-.442.874-.776.218-.38.218-.879.218-1.874v-.534c0-.995 0-1.493-.218-1.873a1.904 1.904 0 00-.874-.777c-.238-.108-.516-.156-.908-.177M3 16.622v.534c0 .995 0 1.493.218 1.873.192.335.498.607.874.777C4.52 20 5.08 20 6.2 20h11.6c1.12 0 1.68 0 2.108-.194.376-.17.682-.442.874-.777.218-.38.218-.878.218-1.873v-.534c0-.995 0-1.493-.218-1.873a1.904 1.904 0 00-.874-.777c-.428-.194-.988-.194-2.108-.194H6.2c-1.12 0-1.68 0-2.108.194-.376.17-.682.442-.874.777C3 15.129 3 15.627 3 16.622zM12 1v6M9 4h6"
    })
  ]);
}
function DZ(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M18 10H6m15-4H3m18 8H3m15 4H6"
    })
  ]);
}
function AZ(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 10H3m18 8H3M21 6H3m18 8H3"
    })
  ]);
}
function EZ(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16 10H3m17-4H3m17 8H3m13 4H3"
    })
  ]);
}
function IZ(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 10H8m13-4H4m17 8H4m17 4H8"
    })
  ]);
}
function NZ(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 12h8a4 4 0 000-8H6v8zm0 0h9a4 4 0 010 8H6v-8z"
    })
  ]);
}
function zZ(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M17 17l5-5-5-5M7 7l-5 5 5 5m7-14l-4 18"
    })
  ]);
}
function $Z(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M14.5 15l3-3-3-3m-5 0l-3 3 3 3m-1.7 6h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 001.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 00-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311C5.28 21 6.12 21 7.8 21z"
    })
  ]);
}
function OZ(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M20 19c-.021.392-.07.67-.177.908-.17.376-.443.682-.778.874-.38.218-.879.218-1.875.218h-.534c-.997 0-1.495 0-1.876-.218a1.905 1.905 0 01-.778-.874c-.107-.238-.155-.516-.177-.908M20 5c-.021-.392-.07-.67-.177-.908a1.905 1.905 0 00-.778-.874C18.665 3 18.166 3 17.17 3h-.534c-.997 0-1.495 0-1.876.218a1.905 1.905 0 00-.778.874c-.107.238-.155.516-.177.908M7.381 3h-.534c-.996 0-1.495 0-1.875.218a1.905 1.905 0 00-.778.874C4 4.52 4 5.08 4 6.2v11.6c0 1.12 0 1.68.194 2.108.17.376.443.682.778.874.38.218.879.218 1.875.218h.534c.997 0 1.495 0 1.876-.218.335-.192.607-.498.778-.874.194-.428.194-.988.194-2.108V6.2c0-1.12 0-1.68-.194-2.108a1.905 1.905 0 00-.778-.874C8.877 3 8.378 3 7.381 3z"
    }),
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M20 9l-6 6m0-6l6 6"
    })
  ]);
}
function jB(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16.2 21H6.931c-.605 0-.908 0-1.049-.12a.5.5 0 01-.173-.42c.014-.183.228-.397.657-.826l8.503-8.503c.396-.396.594-.594.822-.668a1 1 0 01.618 0c.228.074.426.272.822.668L21 15v1.2M16.2 21c1.68 0 2.52 0 3.162-.327a3 3 0 001.311-1.311C21 18.72 21 17.88 21 16.2M16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 01-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 011.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 011.311 1.311C21 5.28 21 6.12 21 7.8v8.4M10.5 8.5a2 2 0 11-4 0 2 2 0 014 0z"
    })
  ]);
}
function _Z(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19 4h-9m4 16H5M15 4L9 20"
    })
  ]);
}
function LZ(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3 9h18M3 15h18M12 3v18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 011.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 01-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 01-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 011.311-1.311C5.28 3 6.12 3 7.8 3z"
    })
  ]);
}
function PZ(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 17H7A5 5 0 017 7h2m6 10h2a5 5 0 000-10h-2m-8 5h10"
    })
  ]);
}
function RZ(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M17 10V8A5 5 0 007 8v2m5 4.5v2M8.8 21h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 001.311-1.311C20 18.72 20 17.88 20 16.2v-1.4c0-1.68 0-2.52-.327-3.162a3 3 0 00-1.311-1.311C17.72 10 16.88 10 15.2 10H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311C4 12.28 4 13.12 4 14.8v1.4c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311C6.28 21 7.12 21 8.8 21z"
    })
  ]);
}
function jZ(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7 10V8a5 5 0 019.584-2M12 14.5v2M8.8 21h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 001.311-1.311C20 18.72 20 17.88 20 16.2v-1.4c0-1.68 0-2.52-.327-3.162a3 3 0 00-1.311-1.311C17.72 10 16.88 10 15.2 10H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311C4 12.28 4 13.12 4 14.8v1.4c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311C6.28 21 7.12 21 8.8 21z"
    })
  ]);
}
function FZ(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9.21 19c-.02.392-.068.67-.176.908-.17.376-.443.682-.778.874-.38.218-.879.218-1.875.218h-.534c-.997 0-1.495 0-1.876-.218a1.905 1.905 0 01-.778-.874C3 19.48 3 18.92 3 17.8V6.2c0-1.12 0-1.68.194-2.108.17-.376.443-.682.778-.874C4.35 3 4.85 3 5.847 3h.534c.996 0 1.495 0 1.875.218.335.192.607.498.778.874.108.238.156.516.177.908m5.578 14c.021.392.07.67.177.908.17.376.443.682.778.874.38.218.879.218 1.875.218h.534c.997 0 1.495 0 1.876-.218.335-.192.607-.498.778-.874C21 19.48 21 18.92 21 17.8V6.2c0-1.12 0-1.68-.194-2.108a1.904 1.904 0 00-.778-.874C19.65 3 19.15 3 18.153 3h-.534c-.996 0-1.495 0-1.875.218a1.904 1.904 0 00-.778.874c-.108.238-.156.516-.177.908M10 12L7 9m3 3l-3 3m3-3H3m11 0l3-3m-3 3l3 3m-3-3h7"
    })
  ]);
}
function BZ(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5 20.002c-.392-.022-.67-.07-.908-.177a1.905 1.905 0 01-.874-.777C3 18.668 3 18.17 3 17.174v-.533c0-.996 0-1.494.218-1.874.192-.335.498-.606.874-.777.238-.107.516-.155.908-.177m14 6.188c.392-.02.67-.069.908-.176.376-.17.682-.443.874-.777.218-.38.218-.878.218-1.874v-.533c0-.996 0-1.494-.218-1.874a1.904 1.904 0 00-.874-.777c-.238-.107-.516-.155-.908-.177M3 7.396v-.533c0-.996 0-1.494.218-1.874.192-.334.498-.606.874-.777.428-.193.988-.193 2.108-.193h11.6c1.12 0 1.68 0 2.108.193.376.17.682.443.874.777.218.38.218.878.218 1.874v.533c0 .996 0 1.494-.218 1.874a1.904 1.904 0 01-.874.777c-.428.194-.988.194-2.108.194H6.2c-1.12 0-1.68 0-2.108-.194a1.904 1.904 0 01-.874-.777C3 8.89 3 8.392 3 7.396z"
    }),
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15 14l-6 6m0-6l6 6"
    })
  ]);
}
function UZ(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3 19c.021.392.07.67.177.908.17.376.443.682.778.874.38.218.879.218 1.875.218h.534c.997 0 1.495 0 1.876-.218.335-.192.607-.498.778-.874.194-.428.194-.988.194-2.108V6.2c0-1.12 0-1.68-.194-2.108a1.905 1.905 0 00-.778-.874C7.86 3 7.361 3 6.364 3H5.83c-.996 0-1.495 0-1.875.218a1.905 1.905 0 00-.778.874C3.069 4.33 3.02 4.608 3 5m18 14c-.021.392-.07.67-.177.908-.17.376-.443.682-.778.874-.38.218-.879.218-1.875.218h-.534c-.997 0-1.495 0-1.876-.218a1.905 1.905 0 01-.778-.874c-.194-.428-.194-.988-.194-2.108V6.2c0-1.12 0-1.68.194-2.108.17-.376.443-.682.778-.874C16.14 3 16.639 3 17.636 3h.534c.996 0 1.495 0 1.875.218.335.192.607.498.778.874.108.238.156.516.177.908M2 12l3-3m-3 3l3 3m-3-3h7m13 0l-3-3m3 3l-3 3m3-3h-7"
    })
  ]);
}
function HZ(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 16a4 4 0 004 4h4a4 4 0 000-8m4-4a4 4 0 00-4-4h-4a4 4 0 00-4 4m-3 4h18"
    })
  ]);
}
function WZ(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311C3 5.28 3 6.12 3 7.8V9m9-6h4.2c1.68 0 2.52 0 3.162.327a3 3 0 011.311 1.311C21 5.28 21 6.12 21 7.8V9m-9-6v6m9 0v6m0-6h-9m9 6v1.2c0 1.68 0 2.52-.327 3.162a3 3 0 01-1.311 1.311M21 15h-2.5M3 15v1.2c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311M3 15V9m0 6h2.5M3 9h9m0 0v3.5m3 2.5l-3 3m0 0l-3 3m3-3l-3-3m3 3l3 3"
    })
  ]);
}
function VZ(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8 8h.01M2 5.2v4.475c0 .489 0 .733.055.963.05.204.13.4.24.579.123.201.296.374.642.72l7.669 7.669c1.188 1.188 1.782 1.782 2.467 2.004a3 3 0 001.854 0c.685-.222 1.28-.816 2.467-2.004l2.212-2.212c1.188-1.188 1.782-1.782 2.004-2.467a3 3 0 000-1.854c-.222-.685-.816-1.28-2.004-2.467l-7.669-7.669c-.346-.346-.519-.519-.72-.642a2.001 2.001 0 00-.579-.24C10.409 2 10.165 2 9.676 2H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 00-.874.874C2 3.52 2 4.08 2 5.2zM8.5 8a.5.5 0 11-1 0 .5.5 0 011 0z"
    })
  ]);
}
function YZ(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8 20h8m-5.75-9.5V20m3.5-6v6M3 3l18 18M4 7V6c0-.541.215-1.032.564-1.392M9.5 4H17c.932 0 1.398 0 1.765.152a2 2 0 011.083 1.083C20 5.602 20 6.068 20 7m-9.75-3v1m3.5-1v4"
    })
  ]);
}
function QZ(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M18 4v7a6 6 0 01-12 0V4M4 21h16"
    })
  ]);
}
const Sn = "toolbar_button", Qb = "toolbar_select", Ya = "floating_menu", Er = {
  toolbarButtonBold: `${Sn}--bold`,
  toolbarButtonItalic: `${Sn}--italic`,
  toolbarButtonUnderline: `${Sn}--underline`,
  toolbarButtonStrike: `${Sn}--strike`,
  toolbarSelectFontFamily: `${Qb}--font_family`,
  toolbarSelectFontSize: `${Qb}--font_size`,
  toolbarSelectTextBlock: `${Qb}--text_block`,
  toolbarSelectLineHeight: `${Qb}--line_height`,
  toolbarButtonTextAlignLeft: `${Sn}--text_align_left`,
  toolbarButtonTextAlignRight: `${Sn}--text_align_right`,
  toolbarButtonTextAlignCenter: `${Sn}--text_align_center`,
  toolbarButtonTextAlignJustify: `${Sn}--text_align_justify`,
  toolbarButtonShowLinkEmbed: `${Sn}--show_link_embed`,
  floatingMenuImageAlignLeft: `${Ya}--image_picker_menu--align_left`,
  floatingMenuImageAlignRight: `${Ya}--image_picker_menu--align_right`,
  floatingMenuImageAlignCenter: `${Ya}--image_picker_menu--align_center`,
  floatingMenuImageJustifyLeft: `${Ya}--image_picker_menu--justify_left`,
  floatingMenuImageJustifyRight: `${Ya}--image_picker_menu--justify_right`,
  floatingMenuImageShowPicker: `${Ya}--image_picker_menu--show_picker`,
  floatingMenuVideoAlignLeft: `${Ya}--Video_picker_menu--align_left`,
  floatingMenuVideoAlignRight: `${Ya}--Video_picker_menu--align_right`,
  floatingMenuVideoAlignCenter: `${Ya}--Video_picker_menu--align_center`,
  floatingMenuVideoJustifyLeft: `${Ya}--Video_picker_menu--justify_left`,
  floatingMenuVideoJustifyRight: `${Ya}--Video_picker_menu--justify_right`,
  floatingMenuVideoShowPicker: `${Ya}--Video_picker_menu--show_picker`,
  toolbarButtonFormatStyles: `${Sn}--format_styles`,
  toolbarButtonOrderedList: `${Sn}--ordered_list`,
  toolbarButtonUnOrderedList: `${Sn}--unordered_list`,
  toolbarButtonTaskList: `${Sn}--task_list`,
  toolbarButtonUndo: `${Sn}--history--undo`,
  toolbarButtonRedo: `${Sn}--history--redo`,
  toolbarButtonInlineCode: `${Sn}--inline_code`,
  toolbarButtonCodeBlock: `${Sn}--code_block`,
  toolbarButtonSuper: `${Sn}--super`,
  toolbarButtonSub: `${Sn}--sub`,
  toolbarButtonCircleList: `${Sn}--circle_list`,
  toolbarButtonSquareList: `${Sn}--square_list`,
  toolbarButtonLowerAlphaList: `${Sn}--lower_alpha_list`,
  toolbarButtonLowerGreekList: `${Sn}--lower_greek_list`,
  toolbarButtonLowerRomanList: `${Sn}--lower_roman_list`,
  toolbarButtonUpperAlphaList: `${Sn}--upper_alpha_list`,
  toolbarButtonUpperRomanList: `${Sn}--upper_roman_list`,
  toolbarButtonQuote: `${Sn}--quote`,
  toolbarButtonColorPicker: `${Sn}--color-picker`
}, FB = {
  cancel: "Afbestille",
  save: "Gem",
  left: "Venstre",
  right: "Højre",
  center: "Center",
  justify: "Retfærdiggøre",
  bold: "Bold",
  italic: "Kursiv",
  strike: "strejke",
  underline: "Understrege",
  remove: "Fjern",
  update: "Opdatering",
  action: "Handling",
  blockquote: "citatboks",
  code: "Kode",
  fileUpload: "Fil upload",
  invalidURL: "Ugyldig URL",
  url: "Uniform Resource Locator",
  valueMissing: "Værdi mangler",
  targetNeeded: "Der er brug for et mål",
  customControl: "Brugerdefineret kontrol",
  externalEmbed: "Extern indlejring",
  invalidOption: "Ugyldig valgmulighed angivet"
}, BB = {
  fontFamily: "Skrifttypefamilie",
  fontSize: "Skriftstørrelse",
  lineHeight: "Linjehøjde"
}, UB = {
  tooltip: "Tilføj link",
  title: "Indlejr link",
  urlFieldLabel: "Tilføj URL",
  actionFieldLabel: "Vælg handling",
  validations: {
    href: "Gyldig URL er nødvendig",
    target: "Mål er nødvendigt"
  }
}, HB = {
  tooltip: "Tilføj billede",
  alignmentTooltip: "Justér billede til {align}",
  wrapTooltip: "Pak billede ind til {align}",
  editTitle: "Rediger billede",
  embedTitle: "Indlejr billede",
  validations: {
    url: "Gyldig billede-URL er påkrævet",
    width: "Ugyldig bredde angivet",
    height: "Ugyldig højde angivet",
    alt: "Angiv venligst alternativ tekst",
    imageLink: "Gyldig URL er nødvendig",
    target: "Ugyldigt mål er angivet"
  },
  labels: {
    url: "Billed-URL",
    width: "Indstil bredde",
    height: "Indstil højde",
    alt: "Alternativ tekst",
    imageLink: "Billedhandlingslink",
    target: "Åbn link i",
    target_self: "I det samme vindue",
    target_blank: "I det nye vindue"
  },
  placeholders: {
    url: "Venligst tilføj en gyldig billed-URL"
  },
  lockAspect: "Lås forholdet mellem længde og bredde",
  unlockAspect: "Lås sideforhold"
}, WB = {
  width: "bil",
  height: "bil",
  alt: "Angiv en alternativ tekst",
  imageLink: "Indsæt et link til at åbne ved at klikke på billedet",
  target: "ignorer",
  tooltip: "Tilføj video",
  alignmentTooltip: "Juster video til {align}",
  wrapTooltip: "Ombryd video til {align}",
  editTitle: "Rediger video",
  embedTitle: "Indlejr video",
  validations: {
    src: "Gyldig video-URL er påkrævet",
    width: "Ugyldig bredde angivet",
    height: "Ugyldig højde angivet",
    fileType: "Ugyldig filtype"
  },
  labels: {
    linkSource: "Video kilde",
    width: "Bredde (px)",
    height: "Højde (px)",
    src: "Video-URL",
    source_native: "Indsæt fra et link",
    source_youtube: "Tilføj Youtube-URL"
  },
  placeholders: {
    src: "ignorer",
    width: "Standardbredde",
    height: "Standardhøjde",
    alt: "Angiv en alternativ tekst",
    imageLink: "Indsæt et link til at åbne ved at klikke på billedet",
    target: "ignorere"
  },
  updateVideo: "Opdater video"
}, VB = {
  tooltip: "Tilføj linjehøjde"
}, YB = {
  bulletListTooltip: "Tilføj punktopstilling",
  orderedListTooltip: "Tilføj nummereret liste",
  taskListTooltip: "Tilføj opgaveliste",
  list: "Liste",
  circleList: "Cirkelliste",
  discList: "Diskliste",
  squareList: "Firkantet liste",
  upperAlphaList: "Øvre alfabetiske liste",
  upperRomanList: "Øvre romerske liste",
  decimalList: "Decimalliste",
  lowerAlphaList: "Lavere alfabetisk liste",
  lowerGreekList: "Lavgræsk liste",
  lowerRomanList: "Nedre romersk liste"
}, QB = {
  formatAllTooltip: "Formater alle dokumenter",
  formatSelectedTooltip: "Formatet er valgt"
}, qB = {
  undo: "Fortryd",
  redo: "Gør igen"
}, GB = {
  alignTooltip: "Juster tekst til {align}",
  subScript: "Underskrevet skrift",
  superScript: "Super Skript"
}, ZB = {
  self: "Selv",
  newWindow: "Nyt vindue",
  linkTitle: "Link overskrift",
  textNeeded: "Link tekst er nødvendig",
  invalidCustomLink: "Ugyldigt brugerdefineret integreringslink"
}, KB = {
  textColor: "Tekstfarve",
  textHighlight: "Tekst fremhævning"
}, XB = {
  paragraph: "Afsnit",
  heading1: "Overskrift 1",
  heading2: "Overskrift 2",
  heading3: "Rubrik 3",
  heading4: "Overskrift 4",
  heading5: "Overskrift 5"
}, JB = {
  insertTable: "Indsæt tabel",
  deleteTable: "Slet tabel",
  deleteColumn: "Slet kolonne",
  deleteRow: "Slet række",
  addColumnBefore: "Tilføj kolonne før",
  addColumnAfter: "Tilføj kolonne efter",
  addRowBefore: "Tilføj række før",
  addRowAfter: "Tilføj række efter",
  mergeCell: "Flet celler",
  splitCell: "Opdel celle"
}, qZ = {
  common: FB,
  placeholders: BB,
  linkEmbed: UB,
  imageEmbed: HB,
  videoEmbed: WB,
  lineHeight: VB,
  list: YB,
  resetStyles: QB,
  history: qB,
  textAlign: GB,
  link: ZB,
  color: KB,
  paragraph: XB,
  table: JB
}, GZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: KB,
  common: FB,
  default: qZ,
  history: qB,
  imageEmbed: HB,
  lineHeight: VB,
  link: ZB,
  linkEmbed: UB,
  list: YB,
  paragraph: XB,
  placeholders: BB,
  resetStyles: QB,
  table: JB,
  textAlign: GB,
  videoEmbed: WB
}, Symbol.toStringTag, { value: "Module" })), e6 = {
  cancel: "Abbrechen",
  save: "Speichern",
  left: "Links",
  right: "Richtig",
  center: "Einmitten",
  justify: "Rechtfertigen",
  bold: "Fett",
  italic: "Kursiv",
  strike: "Durchstreichen",
  underline: "Unterstreichen",
  remove: "Entfernen",
  update: "Aktualisieren",
  action: "Aktion",
  blockquote: "Blockzitat",
  code: "Code",
  fileUpload: "Datei hochladen",
  invalidURL: "Ungültige URL",
  url: "Uniformer Ressourcen-Zeiger",
  valueMissing: "Wert fehlt",
  targetNeeded: "Ziel wird benötigt",
  customControl: "Benutzerdefinierte Steuerung",
  externalEmbed: "Externer Einbettungscode",
  invalidOption: "Ungültige Option angegeben"
}, t6 = {
  fontFamily: "Schriftart",
  fontSize: "Schriftgröße",
  lineHeight: "Zeilenhöhe"
}, r6 = {
  tooltip: "Fügen Sie einen Link hinzu",
  title: "Link einbetten",
  urlFieldLabel: "URL hinzufügen",
  actionFieldLabel: "Aktion auswählen",
  validations: {
    href: "Eine gültige URL ist erforderlich",
    target: "Ziel ist erforderlich"
  }
}, n6 = {
  tooltip: "Bild hinzufügen",
  alignmentTooltip: "Bild an {align} ausrichten",
  wrapTooltip: "Bild umbrechen auf {align}",
  editTitle: "Bild bearbeiten",
  embedTitle: "Bild einbetten",
  validations: {
    url: "Eine gültige Bild-URL ist erforderlich",
    width: "Ungültige Breite angegeben",
    height: "Ungültige Höhe angegeben",
    alt: "Bitte geben Sie einen alternativen Text an",
    imageLink: "Eine gültige URL ist erforderlich",
    target: "Ungültiges Ziel angegeben"
  },
  labels: {
    url: "Bild-URL",
    width: "Breite festlegen",
    height: "Höhe einstellen",
    alt: "Alt-Text",
    imageLink: "Bild Aktionslink",
    target: "Öffne den Link",
    target_self: "Im selben Fenster",
    target_blank: "In dem neuen Fenster"
  },
  placeholders: {
    url: "Bitte fügen Sie eine gültige Bild-URL hinzu"
  },
  lockAspect: "Aspektverhältnis sperren",
  unlockAspect: "Aspektverhältnis entsperren"
}, i6 = {
  width: "Auto",
  height: "Auto",
  alt: "Geben Sie einen alternativen Text an",
  imageLink: "Fügen Sie einen Link ein, um das Bild beim Klicken zu öffnen",
  target: "ignorieren",
  tooltip: "Video hinzufügen",
  alignmentTooltip: "Video an {align} ausrichten",
  wrapTooltip: "Video an {align} anpassen",
  editTitle: "Video bearbeiten",
  embedTitle: "Video einbetten",
  validations: {
    src: "Eine gültige Video-URL ist erforderlich",
    width: "Ungültige Breite angegeben",
    height: "Ungültige Höhe angegeben",
    fileType: "Ungültiger Dateityp"
  },
  labels: {
    linkSource: "Videoquelle",
    width: "Breite (px)",
    height: "Höhe (px)",
    src: "Video-URL",
    source_native: "Einfügen von einem Link",
    source_youtube: "Fügen Sie die YouTube-URL hinzu"
  },
  placeholders: {
    src: "ignore",
    width: "Standardbreite",
    height: "Standardhöhe",
    alt: "Geben Sie einen alternativen Text an",
    imageLink: "Fügen Sie einen Link ein, um das Bild beim Klicken zu öffnen",
    target: "ignore"
  },
  updateVideo: "Aktualisierungsvideo"
}, o6 = {
  tooltip: "Zeilenhöhe hinzufügen"
}, a6 = {
  bulletListTooltip: "Liste mit Aufzählungszeichen hinzufügen",
  orderedListTooltip: "Fügen Sie eine nummerierte Liste hinzu",
  taskListTooltip: "Fügen Sie eine To-Do-Liste hinzu",
  list: "Liste",
  circleList: "Kreisliste",
  discList: "Disc-Liste",
  squareList: "Listenplatz",
  upperAlphaList: "Obere Alpha-Liste",
  upperRomanList: "Obere Römische Liste",
  decimalList: "Dezimalliste",
  lowerAlphaList: "Untere Alphabetische Liste",
  lowerGreekList: "Untere griechische Liste",
  lowerRomanList: "Untere römische Liste"
}, l6 = {
  formatAllTooltip: "Alle Dokumente formatieren",
  formatSelectedTooltip: "Ausgewähltes Format"
}, s6 = {
  undo: "Rückgängig machen",
  redo: "Mach es noch einmal"
}, u6 = {
  alignTooltip: "Text an {align} ausrichten",
  subScript: "Unter-Skript",
  superScript: "Super Skript"
}, c6 = {
  self: "Selbst",
  newWindow: "Neues Fenster",
  linkTitle: "Linktitel",
  textNeeded: "Linktext wird benötigt",
  invalidCustomLink: "Ungültiger benutzerdefinierter Einbettungslink"
}, d6 = {
  textColor: "Textfarbe",
  textHighlight: "Text-Hervorhebung"
}, f6 = {
  paragraph: "Absatz",
  heading1: "Überschrift 1",
  heading2: "Überschrift 2",
  heading3: "Überschrift 3",
  heading4: "Überschrift 4",
  heading5: "Überschrift 5"
}, h6 = {
  insertTable: "Tabelle einfügen",
  deleteTable: "Tabelle löschen",
  deleteColumn: "Spalte löschen",
  deleteRow: "Zeile löschen",
  addColumnBefore: "Spalte davor hinzufügen",
  addColumnAfter: "Spalte danach hinzufügen",
  addRowBefore: "Zeile davor hinzufügen",
  addRowAfter: "Zeile danach hinzufügen",
  mergeCell: "Zellen zusammenführen",
  splitCell: "Zelle aufteilen"
}, ZZ = {
  common: e6,
  placeholders: t6,
  linkEmbed: r6,
  imageEmbed: n6,
  videoEmbed: i6,
  lineHeight: o6,
  list: a6,
  resetStyles: l6,
  history: s6,
  textAlign: u6,
  link: c6,
  color: d6,
  paragraph: f6,
  table: h6
}, KZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: d6,
  common: e6,
  default: ZZ,
  history: s6,
  imageEmbed: n6,
  lineHeight: o6,
  link: c6,
  linkEmbed: r6,
  list: a6,
  paragraph: f6,
  placeholders: t6,
  resetStyles: l6,
  table: h6,
  textAlign: u6,
  videoEmbed: i6
}, Symbol.toStringTag, { value: "Module" })), p6 = {
  cancel: "Cancel",
  save: "Save",
  left: "Left",
  right: "Right",
  center: "Center",
  justify: "Justify",
  bold: "Bold",
  italic: "Italic",
  strike: "Strike",
  underline: "Underline",
  remove: "Remove",
  update: "Update",
  action: "Action",
  blockquote: "Blockquote",
  code: "Code",
  fileUpload: "File Upload",
  invalidURL: "Invalid URL",
  url: "URL",
  valueMissing: "Value is missing",
  targetNeeded: "Target is needed",
  customControl: "Custom control",
  externalEmbed: "External Embed",
  invalidOption: "Invalid option provided"
}, g6 = {
  fontFamily: "Font family",
  fontSize: "Font size",
  lineHeight: "Line Height"
}, m6 = {
  tooltip: "Add Link",
  title: "Embed Link",
  urlFieldLabel: "Add URL",
  actionFieldLabel: "Select Action",
  validations: {
    href: "Valid URL is needed",
    target: "Target is needed"
  }
}, v6 = {
  tooltip: "Add Image",
  alignmentTooltip: "Align image to {align}",
  wrapTooltip: "Wrap image to {align}",
  editTitle: "Edit Image",
  embedTitle: "Embed Image",
  validations: {
    url: "Valid image URL is needed",
    width: "Invalid width provided",
    height: "Invalid height provided",
    alt: "Please specify alternate text",
    imageLink: "Valid URL is needed",
    target: "Invalid target provided"
  },
  labels: {
    url: "Image URL",
    width: "Set Width",
    height: "Set Height",
    alt: "Alt text",
    imageLink: "Image Action Link",
    target: "Open link in",
    target_self: "In the same window",
    target_blank: "In the new window"
  },
  placeholders: {
    url: "Please add a valid image url"
  },
  lockAspect: "Lock aspect ratio",
  unlockAspect: "Un-lock aspect ratio"
}, b6 = {
  width: "auto",
  height: "auto",
  alt: "Specify an alternate text",
  imageLink: "Paste a link to open on clicking on image",
  target: "ignore",
  tooltip: "Add video",
  alignmentTooltip: "Align video to {align}",
  wrapTooltip: "Wrap video to {align}",
  editTitle: "Edit Video",
  embedTitle: "Embed Video",
  validations: {
    src: "Valid video URL is needed",
    width: "Invalid width provided",
    height: "Invalid height provided",
    fileType: "Invalid File type"
  },
  labels: {
    linkSource: "Video Source",
    width: "Width (px)",
    height: "Height (px)",
    src: "Video URL",
    source_native: "Insert from a link",
    source_youtube: "Add Youtube URL"
  },
  placeholders: {
    src: "ignore",
    width: "Default width",
    height: "Default height",
    alt: "Specify an alternate text",
    imageLink: "Paste a link to open on clicking on image",
    target: "ignore"
  },
  updateVideo: "Update Video"
}, y6 = {
  tooltip: "Add line Height"
}, x6 = {
  bulletListTooltip: "Add Bulleted List",
  orderedListTooltip: "Add Numbered List",
  taskListTooltip: "Add Todo List",
  list: "List",
  circleList: "Circle List",
  discList: "Disc List",
  squareList: "Square List",
  upperAlphaList: "Upper Alpha List",
  upperRomanList: "Upper Roman List",
  decimalList: "Decimal List",
  lowerAlphaList: "Lower Alpha List",
  lowerGreekList: "Lower Greek List",
  lowerRomanList: "Lower Roman List"
}, w6 = {
  formatAllTooltip: "Format all document",
  formatSelectedTooltip: "Format selected"
}, M6 = {
  undo: "Undo",
  redo: "Redo"
}, C6 = {
  alignTooltip: "Align text to {align}",
  subScript: "Sub Script",
  superScript: "Super Script"
}, S6 = {
  self: "Self",
  newWindow: "New window",
  linkTitle: "Link Title",
  textNeeded: "Link text is needed",
  invalidCustomLink: "Invalid custom embed link"
}, T6 = {
  textColor: "Text Color",
  textHighlight: "Text Highlight"
}, k6 = {
  paragraph: "Paragraph",
  heading1: "Heading 1",
  heading2: "Heading 2",
  heading3: "Heading 3",
  heading4: "Heading 4",
  heading5: "Heading 5"
}, D6 = {
  insertTable: "Insert Table",
  deleteTable: "Delete Table",
  deleteColumn: "Delete Column",
  deleteRow: "Delete Row",
  addColumnBefore: "Add Column Before",
  addColumnAfter: "Add Column After",
  addRowBefore: "Add Row Before",
  addRowAfter: "Add Row After",
  mergeCell: "Merge Cells",
  splitCell: "Split Cell"
}, XZ = {
  common: p6,
  placeholders: g6,
  linkEmbed: m6,
  imageEmbed: v6,
  videoEmbed: b6,
  lineHeight: y6,
  list: x6,
  resetStyles: w6,
  history: M6,
  textAlign: C6,
  link: S6,
  color: T6,
  paragraph: k6,
  table: D6
}, JZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: T6,
  common: p6,
  default: XZ,
  history: M6,
  imageEmbed: v6,
  lineHeight: y6,
  link: S6,
  linkEmbed: m6,
  list: x6,
  paragraph: k6,
  placeholders: g6,
  resetStyles: w6,
  table: D6,
  textAlign: C6,
  videoEmbed: b6
}, Symbol.toStringTag, { value: "Module" })), A6 = {
  cancel: "Guardar",
  save: "Izquierda",
  left: "¡Correcto!",
  right: "Centro",
  center: "Justificar",
  justify: "Audaz",
  bold: "Itálico",
  italic: "Huelga",
  strike: "Subrayar",
  underline: "Quitar",
  remove: "Actualizar",
  update: "Familia de fuentes",
  action: "Acción",
  blockquote: "Cita en bloque",
  code: "Código",
  fileUpload: "Carga de archivos",
  invalidURL: "URL inválida",
  url: "Localizador Uniforme de Recursos",
  valueMissing: "Valor faltante",
  targetNeeded: "Se necesita un objetivo",
  customControl: "control personalizado",
  externalEmbed: "Incrustación externa",
  invalidOption: "Opción inválida proporcionada"
}, E6 = {
  fontFamily: "Tamaño de fuente",
  fontSize: "Altura de línea",
  lineHeight: "Agregar enlace"
}, I6 = {
  tooltip: "Incrustar enlace",
  title: "Agregar URL",
  urlFieldLabel: "Seleccionar Acción",
  actionFieldLabel: "Se necesita una URL válida",
  validations: {
    href: "Se necesita un objetivo",
    target: "Añadir imagen"
  }
}, N6 = {
  tooltip: "Agregar imagen",
  alignmentTooltip: "Alinear imagen a {align}",
  wrapTooltip: "Envolver imagen para {align}",
  editTitle: "Editar imagen",
  embedTitle: "Incrustar imagen",
  validations: {
    url: "Se necesita una URL de imagen válida",
    width: "Ancho inválido proporcionado",
    height: "Altura inválida proporcionada",
    alt: "Por favor especifique un texto alternativo",
    imageLink: "Se necesita una URL válida",
    target: "Destino no válido proporcionado"
  },
  labels: {
    url: "URL de imagen",
    width: "Establecer ancho",
    height: "Establecer altura",
    alt: "Texto alternativo",
    imageLink: "Enlace de acción de imagen",
    target: "Abrir enlace en",
    target_self: "En la misma ventana",
    target_blank: "En la nueva ventana"
  },
  placeholders: {
    url: "Por favor, agregue una URL de imagen válida"
  },
  lockAspect: "Bloquear relación de aspecto",
  unlockAspect: "Desbloquear relación de aspecto"
}, z6 = {
  width: "Auto",
  height: "Auto",
  alt: "Especificar un texto alternativo",
  imageLink: "Pegar un enlace para abrir al hacer clic en la imagen",
  target: "ignore",
  tooltip: "Agregar video",
  alignmentTooltip: "Alinear video a {align}",
  wrapTooltip: "Envolver video a {align}",
  editTitle: "Editar video",
  embedTitle: "Incrustar video",
  validations: {
    src: "Se necesita una URL de video válida",
    width: "Ancho inválido proporcionado",
    height: "Altura inválida proporcionada",
    fileType: "Tipo de archivo no válido"
  },
  labels: {
    linkSource: "Fuente de video",
    width: "Ancho (px)",
    height: "Altura (px)",
    src: "URL del vídeo",
    source_native: "Inserte desde un enlace",
    source_youtube: "Agregar URL de Youtube"
  },
  placeholders: {
    src: "ignore",
    width: "Ancho predeterminado",
    height: "Altura predeterminada",
    alt: "Especificar un texto alternativo",
    imageLink: "Pegar un enlace para abrir al hacer clic en la imagen",
    target: "ignore"
  },
  updateVideo: "Actualizar video"
}, $6 = {
  tooltip: "Agregar altura de línea"
}, O6 = {
  bulletListTooltip: "Agregar lista con viñetas",
  orderedListTooltip: "Agregar lista numerada",
  taskListTooltip: "Agregar lista de tareas",
  list: "Lista",
  circleList: "Lista de círculo",
  discList: "Lista de discos",
  squareList: "Lista Cuadrada",
  upperAlphaList: "Lista alfabética superior",
  upperRomanList: "Lista romana superior",
  decimalList: "Lista decimal",
  lowerAlphaList: "Lista alfa inferior",
  lowerGreekList: "Lista griega inferior",
  lowerRomanList: "Lista romana inferior"
}, _6 = {
  formatAllTooltip: "Formatear todos los documentos",
  formatSelectedTooltip: "Formato seleccionado"
}, L6 = {
  undo: "Deshacer",
  redo: "Volver a hacer"
}, P6 = {
  alignTooltip: "Alinear el texto a {align}",
  subScript: "Subíndice",
  superScript: "Superíndice"
}, R6 = {
  self: "Uno mismo",
  newWindow: "Nueva ventana",
  linkTitle: "Título del enlace",
  textNeeded: "Se necesita un texto de enlace",
  invalidCustomLink: "Enlace personalizado de incrustación no válido"
}, j6 = {
  textColor: "Color del texto",
  textHighlight: "Resaltado de texto"
}, F6 = {
  paragraph: "Párrafo",
  heading1: "Título 1",
  heading2: "Título 2",
  heading3: "Encabezado 3",
  heading4: "Título 4",
  heading5: "Encabezado 5"
}, B6 = {
  insertTable: "Insertar tabla",
  deleteTable: "Eliminar tabla",
  deleteColumn: "Eliminar columna",
  deleteRow: "Eliminar fila",
  addColumnBefore: "Agregar columna antes",
  addColumnAfter: "Agregar columna después",
  addRowBefore: "Agregar fila antes",
  addRowAfter: "Agregar fila después",
  mergeCell: "Combinar celdas",
  splitCell: "Dividir celda"
}, eK = {
  common: A6,
  placeholders: E6,
  linkEmbed: I6,
  imageEmbed: N6,
  videoEmbed: z6,
  lineHeight: $6,
  list: O6,
  resetStyles: _6,
  history: L6,
  textAlign: P6,
  link: R6,
  color: j6,
  paragraph: F6,
  table: B6
}, tK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: j6,
  common: A6,
  default: eK,
  history: L6,
  imageEmbed: N6,
  lineHeight: $6,
  link: R6,
  linkEmbed: I6,
  list: O6,
  paragraph: F6,
  placeholders: E6,
  resetStyles: _6,
  table: B6,
  textAlign: P6,
  videoEmbed: z6
}, Symbol.toStringTag, { value: "Module" })), U6 = {
  cancel: "Peruuta",
  save: "Tallentaa",
  left: "vasen",
  right: "Oikea",
  center: "keskus",
  justify: "perustella",
  bold: "Rohkea",
  italic: "kursiivi",
  strike: "Lakko",
  underline: "Alleviivata",
  remove: "Poista",
  update: "Päivitys",
  action: "Toiminta",
  blockquote: "Lainaus",
  code: "Koodi",
  fileUpload: "Tiedoston lähetys",
  invalidURL: "Virheellinen URL",
  url: "Uniform Resource Locators",
  valueMissing: "Arvo puuttuu",
  targetNeeded: "Kohde tarvitaan",
  customControl: "Räätälöity ohjaus",
  externalEmbed: "Ulkoista upotusta",
  invalidOption: "Virheellinen valinta annettu"
}, H6 = {
  fontFamily: "Fonttiperhe",
  fontSize: "Fonttikoko",
  lineHeight: "Riviväli"
}, W6 = {
  tooltip: "Lisää linkki",
  title: "Upota linkki",
  urlFieldLabel: "Lisää URL-osoite",
  actionFieldLabel: "Valitse toiminto",
  validations: {
    href: "Tarvitaan voimassa oleva URL-osoite",
    target: "Kohde tarvitaan"
  }
}, V6 = {
  tooltip: "Lisää kuva",
  alignmentTooltip: "Kohdista kuva {align} suuntaan",
  wrapTooltip: "Kääri kuva {align}iin",
  editTitle: "Muokkaa kuvaa",
  embedTitle: "Upota kuva",
  validations: {
    url: "Kelvollinen kuvan URL-osoite tarvitaan",
    width: "Virheellinen leveys annettu",
    height: "Virheellinen pituus annettu",
    alt: "Ole hyvä ja määrittele vaihtoehtoinen teksti",
    imageLink: "Tarvitaan kelvollinen URL-osoite",
    target: "Virheellinen kohde annettu"
  },
  labels: {
    url: "Kuvan URL-osoite",
    width: "Aseta leveys",
    height: "Aseta korkeus",
    alt: "Vaihtoehtoinen teksti",
    imageLink: "Kuvan toimintolinkki",
    target: "Avaa linkki",
    target_self: "Samassa ikkunassa",
    target_blank: "Uudessa ikkunassa"
  },
  placeholders: {
    url: "Ole hyvä ja lisää pätevä kuvake URL"
  },
  lockAspect: "Lukitse kuvasuhteen oikea kääntö",
  unlockAspect: "Avaa kuvasuhteen lukitus"
}, Y6 = {
  width: "auto",
  height: "auto",
  alt: "Määritä vaihtoehtoinen teksti",
  imageLink: "Liitä linkki avattavaksi napsauttamalla kuvaa",
  target: "unohtaa",
  tooltip: "Lisää video",
  alignmentTooltip: "Kohdista video {align}-asentoon",
  wrapTooltip: "Pakkaa video {align} mukaiseksi",
  editTitle: "Muokkaa videota",
  embedTitle: "Upota video",
  validations: {
    src: "Tarvitaan voimassa oleva videon URL-osoite",
    width: "Epäkelpo leveys annettu",
    height: "Virheellinen korkeus annettu",
    fileType: "Virheellinen tiedostotyyppi"
  },
  labels: {
    linkSource: "Videon lähde",
    width: "Leveys (px)",
    height: "Korkeus (px)",
    src: "Videon URL-osoite",
    source_native: "Lisää linkistä",
    source_youtube: "Lisää Youtube URL-osoite"
  },
  placeholders: {
    src: "ohittaa",
    width: "Oletusleveys",
    height: "Oletuskorkeus",
    alt: "Määritä vaihtoehtoinen teksti",
    imageLink: "Liitä linkki avautumaan kuvaa napsauttamalla",
    target: "unohtaa"
  },
  updateVideo: "Päivitä video"
}, Q6 = {
  tooltip: "Lisää riviväli"
}, q6 = {
  bulletListTooltip: "Lisää luettelomerkit",
  orderedListTooltip: "Lisää numerointiluettelo",
  taskListTooltip: "Lisää tehtävälista",
  list: "Listan",
  circleList: "Ympyrälista",
  discList: "Levylista",
  squareList: "Neliöluettelo",
  upperAlphaList: "Ylätunnuslista",
  upperRomanList: "Yläroomalainen luettelo",
  decimalList: "Desimaalilista",
  lowerAlphaList: "Aakkosjärjestetty alarajainen lista",
  lowerGreekList: "Alempi kreikkalainen lista",
  lowerRomanList: "Alemmainen roomalainen luettelo"
}, G6 = {
  formatAllTooltip: "Muotoile koko asiakirja",
  formatSelectedTooltip: "Tiedostomuoto valittu"
}, Z6 = {
  undo: "Kumoa",
  redo: "Teke uudelleen"
}, K6 = {
  alignTooltip: "Kohdista teksti {align}-asentoon",
  subScript: "Subskriptio",
  superScript: "Ylöskirjoitus"
}, X6 = {
  self: "Itse",
  newWindow: "Uusi ikkuna",
  linkTitle: "Linkin otsikko",
  textNeeded: "Linkkitekstiä tarvitaan",
  invalidCustomLink: "Virheellinen mukautettu upotuslinkki"
}, J6 = {
  textColor: "Tekstin väri",
  textHighlight: "Tekstin korostus"
}, e8 = {
  paragraph: "Kappale",
  heading1: "Otsikko 1",
  heading2: "Otsikko 2",
  heading3: "Otsikko 3",
  heading4: "Otsikko 4",
  heading5: "Ylätunniste 5"
}, t8 = {
  insertTable: "Lisää taulukko",
  deleteTable: "Poista taulukko",
  deleteColumn: "Poista sarake",
  deleteRow: "Poista rivi",
  addColumnBefore: "Lisää sarake ennen",
  addColumnAfter: "Lisää sarake jälkeen",
  addRowBefore: "Lisää rivi ennen",
  addRowAfter: "Lisää rivi jälkeen",
  mergeCell: "Yhdistä solut",
  splitCell: "Jaa solu"
}, rK = {
  common: U6,
  placeholders: H6,
  linkEmbed: W6,
  imageEmbed: V6,
  videoEmbed: Y6,
  lineHeight: Q6,
  list: q6,
  resetStyles: G6,
  history: Z6,
  textAlign: K6,
  link: X6,
  color: J6,
  paragraph: e8,
  table: t8
}, nK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: J6,
  common: U6,
  default: rK,
  history: Z6,
  imageEmbed: V6,
  lineHeight: Q6,
  link: X6,
  linkEmbed: W6,
  list: q6,
  paragraph: e8,
  placeholders: H6,
  resetStyles: G6,
  table: t8,
  textAlign: K6,
  videoEmbed: Y6
}, Symbol.toStringTag, { value: "Module" })), r8 = {
  cancel: "Annuler",
  save: "Sauvegarder",
  left: "Gauche",
  right: "Droit",
  center: "Centre",
  justify: "Justifier",
  bold: "Gras",
  italic: "Italique",
  strike: "Grève",
  underline: "Souligner",
  remove: "Supprimer",
  update: "Mise à jour",
  action: "Action",
  blockquote: "Extrait de texte",
  code: "Code",
  fileUpload: "Transfert de fichier",
  invalidURL: "URL invalide",
  url: "adresse URL",
  valueMissing: "Valeur manquante",
  targetNeeded: "La cible est nécessaire",
  customControl: "Contrôle personnalisé",
  externalEmbed: "Incorporation externe",
  invalidOption: "Option invalide fournie"
}, n8 = {
  fontFamily: "Famille de polices",
  fontSize: "Taille de police",
  lineHeight: "Hauteur de ligne"
}, i8 = {
  tooltip: "Ajouter un lien",
  title: "Lien intégré",
  urlFieldLabel: "Ajouter l'URL",
  actionFieldLabel: "Sélectionner une action",
  validations: {
    href: "Une URL valide est nécessaire",
    target: "Une cible est nécessaire"
  }
}, o8 = {
  tooltip: "Ajouter une image",
  alignmentTooltip: "Aligner l'image à {align}",
  wrapTooltip: "Aligner l'image à {align}",
  editTitle: "Modifier l'image",
  embedTitle: "Image intégrée",
  validations: {
    url: "Une URL d'image valide est nécessaire",
    width: "Largeur invalide fournie",
    height: "Hauteur invalide fournie",
    alt: "Veuillez préciser un texte alternatif",
    imageLink: "Une URL valide est nécessaire",
    target: "Cible invalide fournie"
  },
  labels: {
    url: "URL de l'image",
    width: "Largeur de l'ensemble",
    height: "Hauteur définie",
    alt: "Texte alternatif",
    imageLink: "Lien d'action d'image",
    target: "Ouvrir le lien dans",
    target_self: "Dans la même fenêtre",
    target_blank: "Dans la nouvelle fenêtre"
  },
  placeholders: {
    url: "Veuillez ajouter une URL d'image valide"
  },
  lockAspect: "Verrouiller le ratio d'aspect",
  unlockAspect: "Déverrouiller le rapport d'aspect"
}, a8 = {
  width: "voiture",
  height: "voiture",
  alt: "Spécifiez un texte alternatif",
  imageLink: "Coller un lien pour ouvrir en cliquant sur l'image",
  target: "ignore",
  tooltip: "Ajouter une vidéo",
  alignmentTooltip: "Aligner la vidéo à {align}",
  wrapTooltip: "Aligner la vidéo à {align}",
  editTitle: "Modifier la vidéo",
  embedTitle: "Intégrer une vidéo",
  validations: {
    src: "Une URL vidéo valide est nécessaire",
    width: "Largeur invalide fournie",
    height: "Hauteur invalide fournie",
    fileType: "Type de fichier invalide"
  },
  labels: {
    linkSource: "Source vidéo",
    width: "Largeur (px)",
    height: "Hauteur (px)",
    src: "URL de la vidéo",
    source_native: "Insérer à partir d'un lien",
    source_youtube: "Ajouter l'URL de Youtube"
  },
  placeholders: {
    src: "#ERROR!",
    width: "Largeur par défaut",
    height: "Hauteur par défaut",
    alt: "Spécifiez un texte alternatif",
    imageLink: "Coller un lien pour ouvrir en cliquant sur l'image",
    target: "#ERROR!"
  },
  updateVideo: "Mise à jour vidéo"
}, l8 = {
  tooltip: "Ajouter la hauteur de ligne"
}, s8 = {
  bulletListTooltip: "Ajouter une liste à puces",
  orderedListTooltip: "Ajouter une liste numérotée",
  taskListTooltip: "Ajouter une liste de tâches à faire",
  list: "Liste",
  circleList: "Liste de cercle",
  discList: "Liste de disques",
  squareList: "Liste Carrée",
  upperAlphaList: "Liste alpha supérieure",
  upperRomanList: "Liste romaine supérieure",
  decimalList: "Liste décimale",
  lowerAlphaList: "Liste alphabétique inférieure",
  lowerGreekList: "Liste grecque inférieure",
  lowerRomanList: "Liste en chiffres romains minuscules"
}, u8 = {
  formatAllTooltip: "Formatez tous les documents",
  formatSelectedTooltip: "Format sélectionné"
}, c8 = {
  undo: "Annuler",
  redo: "Refaire"
}, d8 = {
  alignTooltip: "Aligner le texte à {align}",
  subScript: "Sous-Script",
  superScript: "Super minutieux"
}, f8 = {
  self: "Soi",
  newWindow: "Nouvelle fenêtre",
  linkTitle: "Titre du lien",
  textNeeded: "Un lien texte est nécessaire",
  invalidCustomLink: "Lien d'intégration personnalisée invalide"
}, h8 = {
  textColor: "Couleur de texte",
  textHighlight: "Surlignage de texte"
}, p8 = {
  paragraph: "Paragraphe",
  heading1: "Titre 1",
  heading2: "Titre 2",
  heading3: "Titre 3",
  heading4: "Titre 4",
  heading5: "Titre 5"
}, g8 = {
  insertTable: "Insérer un tableau",
  deleteTable: "Supprimer le tableau",
  deleteColumn: "Supprimer la colonne",
  deleteRow: "Supprimer la ligne",
  addColumnBefore: "Ajouter une colonne avant",
  addColumnAfter: "Ajouter une colonne après",
  addRowBefore: "Ajouter une ligne avant",
  addRowAfter: "Ajouter une ligne après",
  mergeCell: "Fusionner les cellules",
  splitCell: "Diviser la cellule"
}, iK = {
  common: r8,
  placeholders: n8,
  linkEmbed: i8,
  imageEmbed: o8,
  videoEmbed: a8,
  lineHeight: l8,
  list: s8,
  resetStyles: u8,
  history: c8,
  textAlign: d8,
  link: f8,
  color: h8,
  paragraph: p8,
  table: g8
}, oK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: h8,
  common: r8,
  default: iK,
  history: c8,
  imageEmbed: o8,
  lineHeight: l8,
  link: f8,
  linkEmbed: i8,
  list: s8,
  paragraph: p8,
  placeholders: n8,
  resetStyles: u8,
  table: g8,
  textAlign: d8,
  videoEmbed: a8
}, Symbol.toStringTag, { value: "Module" })), m8 = {
  cancel: "Annuler",
  save: "Sauvegarder",
  left: "Gauche",
  right: "Droit",
  center: "Centre",
  justify: "Justifier",
  bold: "Gras",
  italic: "Italic",
  strike: "Grève",
  underline: "Souligner",
  remove: "Supprimer",
  update: "Mise à jour",
  action: "l'action",
  blockquote: "Bloc de citation",
  code: "le code",
  fileUpload: "Téléchargement de fichier",
  invalidURL: "URL invalide",
  url: "Identifiant de ressource uniforme",
  valueMissing: "La valeur est manquante",
  targetNeeded: "La cible est nécessaire",
  customControl: "Contrôle douanier",
  externalEmbed: "Incorporation externe",
  invalidOption: "Option incorrecte fournie"
}, v8 = {
  fontFamily: "Famille de polices",
  fontSize: "Taille de police",
  lineHeight: "Hauteur de ligne"
}, b8 = {
  tooltip: "Ajouter un lien",
  title: "Lien intégré",
  urlFieldLabel: "Ajouter une URL",
  actionFieldLabel: "Sélectionner une action",
  validations: {
    href: "Une URL valide est nécessaire",
    target: "Une cible est nécessaire"
  }
}, y8 = {
  tooltip: "Ajouter une image",
  alignmentTooltip: "Aligner l'image à {align}",
  wrapTooltip: "Aligner l'image à {align}",
  editTitle: "Modifier l'image",
  embedTitle: "Incorporer l'image",
  validations: {
    url: "Une URL d'image valide est nécessaire",
    width: "Largeur invalide fournie",
    height: "Hauteur invalide fournie",
    alt: "Veuillez préciser un texte alternatif",
    imageLink: "Une URL valide est nécessaire",
    target: "Cible invalide fournie"
  },
  labels: {
    url: "URL de l'image",
    width: "Largeur de l'ensemble",
    height: "Hauteur définie",
    alt: "Texte alternatif",
    imageLink: "Lien d'action d'image",
    target: "Ouvrir le lien dans",
    target_self: "Dans la même fenêtre",
    target_blank: "Dans la nouvelle fenêtre"
  },
  placeholders: {
    url: "Veuillez ajouter une URL d'image valide"
  },
  lockAspect: "Verrouiller le rapport d'aspect",
  unlockAspect: "Déverrouiller le ratio d'aspect"
}, x8 = {
  width: "auto",
  height: "auto",
  alt: "Spécifiez un texte alternatif",
  imageLink: "Collez un lien pour ouvrir en cliquant sur l'image",
  target: "#ERROR!",
  tooltip: "Ajouter une vidéo",
  alignmentTooltip: "Aligner la vidéo sur {align}",
  wrapTooltip: "Aligner la vidéo sur {align}",
  editTitle: "Modifier la vidéo",
  embedTitle: "Incorporer la vidéo",
  validations: {
    src: "Une URL vidéo valide est nécessaire",
    width: "Largeur invalide fournie",
    height: "Hauteur invalide fournie",
    fileType: "Type de fichier invalide"
  },
  labels: {
    linkSource: "Source vidéo",
    width: "Largeur (px)",
    height: "Hauteur (px)",
    src: "URL de la vidéo",
    source_native: "Insérer à partir d'un lien",
    source_youtube: "Ajouter l'URL de Youtube"
  },
  placeholders: {
    src: "#ERROR!",
    width: "Largeur par défaut",
    height: "Hauteur par défaut",
    alt: "Spécifiez un texte alternatif",
    imageLink: "Collez un lien pour ouvrir en cliquant sur l'image",
    target: "#ERROR!"
  },
  updateVideo: "Mise à jour vidéo"
}, w8 = {
  tooltip: "Ajouter la hauteur de ligne"
}, M8 = {
  bulletListTooltip: "Ajouter une liste à puces",
  orderedListTooltip: "Ajouter une liste numérotée",
  taskListTooltip: "Ajouter une liste de tâches à faire",
  list: "La liste",
  circleList: "Liste circulaire",
  discList: "Liste des disques",
  squareList: "Liste carrée",
  upperAlphaList: "Liste Alpha Supérieure",
  upperRomanList: "Liste romaine supérieure",
  decimalList: "Liste décimale",
  lowerAlphaList: "Liste alphabétique inférieure",
  lowerGreekList: "Liste grecque inférieure",
  lowerRomanList: "Liste romaine inférieure"
}, C8 = {
  formatAllTooltip: "Formater tout le document",
  formatSelectedTooltip: "Format sélectionné"
}, S8 = {
  undo: "Annuler",
  redo: "Refaire"
}, T8 = {
  alignTooltip: "Aligner le texte à {align}",
  subScript: "Sous-titre",
  superScript: "Super Script"
}, k8 = {
  self: "soi",
  newWindow: "Nouvelle fenêtre",
  linkTitle: "Titre du lien",
  textNeeded: "Lien texte est nécessaire",
  invalidCustomLink: "Lien intégré personnalisé invalide"
}, D8 = {
  textColor: "Couleur du texte",
  textHighlight: "Texte surligné"
}, A8 = {
  paragraph: "paragraphe",
  heading1: "Titre 1",
  heading2: "Rubrique 2",
  heading3: "Titre 3",
  heading4: "En-tête 4",
  heading5: "Titre 5"
}, E8 = {
  insertTable: "Insérer un tableau",
  deleteTable: "Supprimer le tableau",
  deleteColumn: "Supprimer la colonne",
  deleteRow: "Supprimer la ligne",
  addColumnBefore: "Ajouter une colonne avant",
  addColumnAfter: "Ajouter une colonne après",
  addRowBefore: "Ajouter une ligne avant",
  addRowAfter: "Ajouter une ligne après",
  mergeCell: "Fusionner les cellules",
  splitCell: "Diviser la cellule"
}, aK = {
  common: m8,
  placeholders: v8,
  linkEmbed: b8,
  imageEmbed: y8,
  videoEmbed: x8,
  lineHeight: w8,
  list: M8,
  resetStyles: C8,
  history: S8,
  textAlign: T8,
  link: k8,
  color: D8,
  paragraph: A8,
  table: E8
}, lK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: D8,
  common: m8,
  default: aK,
  history: S8,
  imageEmbed: y8,
  lineHeight: w8,
  link: k8,
  linkEmbed: b8,
  list: M8,
  paragraph: A8,
  placeholders: v8,
  resetStyles: C8,
  table: E8,
  textAlign: T8,
  videoEmbed: x8
}, Symbol.toStringTag, { value: "Module" })), I8 = {
  cancel: "Annulla",
  save: "Salvare",
  left: "Sinistra",
  right: "Destra",
  center: "Centro",
  justify: "giustificare",
  bold: "Audace",
  italic: "italico",
  strike: "Sciopero",
  underline: "Sottolinea",
  remove: "rimuovi",
  update: "Aggiornamento",
  action: "Action",
  blockquote: "Blockquote",
  code: "Code",
  fileUpload: "File Upload",
  invalidURL: "Invalid URL",
  url: "URL",
  valueMissing: "Value is missing",
  targetNeeded: "Target is needed",
  customControl: "Custom control",
  externalEmbed: "External Embed",
  invalidOption: "Invalid option provided"
}, N8 = {
  fontFamily: "Famiglia di font",
  fontSize: "Dimensione carattere",
  lineHeight: "Altezza riga"
}, z8 = {
  tooltip: "Aggiungi collegamento",
  title: "Incorpora link",
  urlFieldLabel: "Aggiungi URL",
  actionFieldLabel: "Selezionare azione",
  validations: {
    href: "È necessario un URL valido",
    target: "È necessario un obiettivo"
  }
}, $8 = {
  tooltip: "Aggiungi immagine",
  alignmentTooltip: "Allineare immagine a {align}",
  wrapTooltip: "Inserisci immagine allineata a {align}",
  editTitle: "Modifica immagine",
  embedTitle: "Incorpora immagine",
  validations: {
    url: "È necessario un URL di immagine valido",
    width: "Larghezza non valida fornita",
    height: "Altezza fornita non valida",
    alt: "Per favore, specifica il testo alternativo",
    imageLink: "È necessario un URL valido",
    target: "Obiettivo non valido fornito"
  },
  labels: {
    url: "URL dell'immagine",
    width: "Imposta larghezza",
    height: "Altezza impostata",
    alt: "Testo alternativo",
    imageLink: "Immagine collegamento azione",
    target: "Apri link in",
    target_self: "Nella stessa finestra",
    target_blank: "Nella nuova finestra"
  },
  placeholders: {
    url: "Per favore inserisci un URL di immagine valido"
  },
  lockAspect: "Lock aspect ratio",
  unlockAspect: "Un-lock aspect ratio"
}, O8 = {
  width: "automobile",
  height: "auto",
  alt: "Specifica un testo alternativo",
  imageLink: "Incolla un link da aprire cliccando sull'immagine",
  target: "ignorare",
  tooltip: "Aggiungi video",
  alignmentTooltip: "Allinea il video a {align}",
  wrapTooltip: "Includi il video in {align}",
  editTitle: "Modifica video",
  embedTitle: "Incorpora video",
  validations: {
    src: "È necessario un URL valido del video",
    width: "Larghezza non valida fornita",
    height: "Altezza non valida fornita",
    fileType: "Tipo di file non valido"
  },
  labels: {
    linkSource: "Sorgente del video",
    width: "Larghezza (px)",
    height: "altezza (px)",
    src: "URL del video",
    source_native: "Inserisci da un link",
    source_youtube: "Aggiungi URL di Youtube"
  },
  placeholders: {
    src: "ignorare",
    width: "Larghezza di default",
    height: "Altezza predefinita",
    alt: "Specificare un testo alternativo",
    imageLink: "Incolla un link per aprire cliccando sull'immagine",
    target: "ignorare"
  },
  updateVideo: "Update Video"
}, _8 = {
  tooltip: "Aggiungi altezza riga"
}, L8 = {
  bulletListTooltip: "Aggiungi elenco puntato",
  orderedListTooltip: "Aggiungi lista numerata",
  taskListTooltip: "Aggiungi lista di cose da fare",
  list: "List",
  circleList: "Circle List",
  discList: "Disc List",
  squareList: "Square List",
  upperAlphaList: "Upper Alpha List",
  upperRomanList: "Upper Roman List",
  decimalList: "Decimal List",
  lowerAlphaList: "Lower Alpha List",
  lowerGreekList: "Lower Greek List",
  lowerRomanList: "Lower Roman List"
}, P8 = {
  formatAllTooltip: "Formatta tutto il documento",
  formatSelectedTooltip: "Formato selezionato"
}, R8 = {
  undo: "Annulla",
  redo: "Rifare"
}, j8 = {
  alignTooltip: "Allineare il testo a {align}",
  subScript: "Sub Script",
  superScript: "Super Script"
}, F8 = {
  self: "Self",
  newWindow: "New window",
  linkTitle: "Link Title",
  textNeeded: "Link text is needed",
  invalidCustomLink: "Invalid custom embed link"
}, B8 = {
  textColor: "Text Color",
  textHighlight: "Text Highlight"
}, U8 = {
  paragraph: "Paragraph",
  heading1: "Heading 1",
  heading2: "Heading 2",
  heading3: "Heading 3",
  heading4: "Heading 4",
  heading5: "Heading 5"
}, H8 = {
  insertTable: "Inserisci tabella",
  deleteTable: "Elimina tabella",
  deleteColumn: "Elimina colonna",
  deleteRow: "Elimina riga",
  addColumnBefore: "Aggiungi colonna prima",
  addColumnAfter: "Aggiungi colonna dopo",
  addRowBefore: "Aggiungi riga prima",
  addRowAfter: "Aggiungi riga dopo",
  mergeCell: "Unisci celle",
  splitCell: "Dividi cella"
}, sK = {
  common: I8,
  placeholders: N8,
  linkEmbed: z8,
  imageEmbed: $8,
  videoEmbed: O8,
  lineHeight: _8,
  list: L8,
  resetStyles: P8,
  history: R8,
  textAlign: j8,
  link: F8,
  color: B8,
  paragraph: U8,
  table: H8
}, uK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: B8,
  common: I8,
  default: sK,
  history: R8,
  imageEmbed: $8,
  lineHeight: _8,
  link: F8,
  linkEmbed: z8,
  list: L8,
  paragraph: U8,
  placeholders: N8,
  resetStyles: P8,
  table: H8,
  textAlign: j8,
  videoEmbed: O8
}, Symbol.toStringTag, { value: "Module" })), W8 = {
  cancel: "Annuleren",
  save: "Opslaan",
  left: "Links",
  right: "Juist",
  center: "Centrum",
  justify: "rechtvaardigen",
  bold: "Vetgedrukt",
  italic: "Schuingedrukt",
  strike: "Staking",
  underline: "Onderstrepen",
  remove: "Verwijderen",
  update: "Update",
  action: "Actie",
  blockquote: "Citaatblok",
  code: "Code",
  fileUpload: "Bestand uploaden",
  invalidURL: "Ongeldige URL",
  url: "URL - Uniform Resource Locator",
  valueMissing: "Waarde ontbreekt",
  targetNeeded: "Doelwit is nodig",
  customControl: "Aangepaste besturing",
  externalEmbed: "Externe Insluiting",
  invalidOption: "Ongeldige optie opgegeven"
}, V8 = {
  fontFamily: "Lettertypefamilie",
  fontSize: "Lettergrootte",
  lineHeight: "Regelhoogte"
}, Y8 = {
  tooltip: "Voeg link toe",
  title: "Insluiten Link",
  urlFieldLabel: "Voeg URL toe",
  actionFieldLabel: "Selecteer actie",
  validations: {
    href: "Een geldige URL is vereist",
    target: "Er is een doelwit nodig"
  }
}, Q8 = {
  tooltip: "Voeg afbeelding toe",
  alignmentTooltip: "Uitlijnen afbeelding naar {align}",
  wrapTooltip: "Omhul afbeelding met {align}",
  editTitle: "Bewerk afbeelding",
  embedTitle: "Insluiten afbeelding",
  validations: {
    url: "Een geldige afbeeldings-URL is vereist",
    width: "Ongeldige breedte opgegeven",
    height: "Ongeldige hoogte opgegeven",
    alt: "Gelieve alternatieve tekst op te geven",
    imageLink: "Een geldige URL is vereist",
    target: "Ongeldige doelwit opgegeven"
  },
  labels: {
    url: "Beeld-URL",
    width: "Breedte instellen",
    height: "Stel hoogte in",
    alt: "Alternatieve tekst",
    imageLink: "Afbeelding Actie Link",
    target: "Open link in",
    target_self: "In hetzelfde venster",
    target_blank: "In het nieuwe venster"
  },
  placeholders: {
    url: "Voeg alstublieft een geldige afbeeldings-URL toe"
  },
  lockAspect: "Verhouding vergrendelen",
  unlockAspect: "Ontgrendel aspectverhouding"
}, q8 = {
  width: "auto",
  height: "auto",
  alt: "Geef een alternatieve tekst op",
  imageLink: "Plak een link om te openen bij het klikken op de afbeelding",
  target: "ignore",
  tooltip: "Voeg video toe",
  alignmentTooltip: "Video uitlijnen op {align}",
  wrapTooltip: "Plaats video in {align}",
  editTitle: "Bewerk video",
  embedTitle: "Insluiten video",
  validations: {
    src: "Een geldige video-URL is vereist",
    width: "Ongeldige breedte opgegeven",
    height: "Ongeldige hoogte opgegeven",
    fileType: "Ongeldig bestandstype"
  },
  labels: {
    linkSource: "Videobron",
    width: "Breedte (px)",
    height: "Hoogte (px)",
    src: "Videolink",
    source_native: "Invoegen vanuit een link",
    source_youtube: "Voeg Youtube URL toe"
  },
  placeholders: {
    src: "ignore",
    width: "Standaard breedte",
    height: "Standaardhoogte",
    alt: "Geef een alternatieve tekst op",
    imageLink: "Plak een link om te openen bij het klikken op de afbeelding",
    target: "ignore"
  },
  updateVideo: "Bijwerken video"
}, G8 = {
  tooltip: "Voeg regelhoogte toe"
}, Z8 = {
  bulletListTooltip: "Voeg opsommingstekens toe",
  orderedListTooltip: "Voeg genummerde lijst toe",
  taskListTooltip: "Voeg takenlijst toe",
  list: "Lijst",
  circleList: "Cirkellijst",
  discList: "Schijflijst",
  squareList: "Vierkante lijst",
  upperAlphaList: "Bovenaan Alpha Lijst",
  upperRomanList: "Bovenaan Romeinse lijst",
  decimalList: "Decimale lijst",
  lowerAlphaList: "Lagere alfabetische lijst",
  lowerGreekList: "Lager Griekse Lijst",
  lowerRomanList: "Lagere Romeinse lijst"
}, K8 = {
  formatAllTooltip: "Formatteer het hele document",
  formatSelectedTooltip: "Geselecteerd formaat"
}, X8 = {
  undo: "Ongedaan maken",
  redo: "Opnieuw doen"
}, J8 = {
  alignTooltip: "Tekst uitlijnen naar {align}",
  subScript: "Sub Script   Dutch translation: Onderstrepingsteken (or) Subscriptie",
  superScript: "Super Script"
}, e9 = {
  self: "Zelf",
  newWindow: "Nieuw venster",
  linkTitle: "Link titel",
  textNeeded: "Linktekst is nodig",
  invalidCustomLink: "Ongeldige aangepaste embed-link"
}, t9 = {
  textColor: "Tekstkleur",
  textHighlight: "Tekst markeren"
}, r9 = {
  paragraph: "Paragraaf",
  heading1: "Kop 1",
  heading2: "Kop 2",
  heading3: "Koptekst 3",
  heading4: "Kop 4",
  heading5: "Kop 5"
}, n9 = {
  insertTable: "Tabel invoegen",
  deleteTable: "Tabel verwijderen",
  deleteColumn: "Kolom verwijderen",
  deleteRow: "Rij verwijderen",
  addColumnBefore: "Kolom toevoegen voor",
  addColumnAfter: "Kolom toevoegen na",
  addRowBefore: "Rij toevoegen voor",
  addRowAfter: "Rij toevoegen na",
  mergeCell: "Cellen samenvoegen",
  splitCell: "Cel splitsen"
}, cK = {
  common: W8,
  placeholders: V8,
  linkEmbed: Y8,
  imageEmbed: Q8,
  videoEmbed: q8,
  lineHeight: G8,
  list: Z8,
  resetStyles: K8,
  history: X8,
  textAlign: J8,
  link: e9,
  color: t9,
  paragraph: r9,
  table: n9
}, dK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: t9,
  common: W8,
  default: cK,
  history: X8,
  imageEmbed: Q8,
  lineHeight: G8,
  link: e9,
  linkEmbed: Y8,
  list: Z8,
  paragraph: r9,
  placeholders: V8,
  resetStyles: K8,
  table: n9,
  textAlign: J8,
  videoEmbed: q8
}, Symbol.toStringTag, { value: "Module" })), i9 = {
  cancel: "Avbryte",
  save: "Lagre",
  left: "Venstre",
  right: "Riktig",
  center: "Senter",
  justify: "retteferdiggjøre",
  bold: "Modig",
  italic: "Kursiv",
  strike: "Streik",
  underline: "Understrek",
  remove: "Fjerne",
  update: "Oppdatering",
  action: "Handling",
  blockquote: "Blockquote",
  code: "Kode",
  fileUpload: "Filopplasting",
  invalidURL: "Ugyldig URL",
  url: "nettadresse",
  valueMissing: "Verdi mangler",
  targetNeeded: "Målet er nødvendig",
  customControl: "Tilpasset kontroll",
  externalEmbed: "Ekstern innbygging",
  invalidOption: "Ugyldig valg gitt"
}, o9 = {
  fontFamily: "Skriftfamilie",
  fontSize: "Skriftstørrelse",
  lineHeight: "Linjehøyde"
}, a9 = {
  tooltip: "Legg til lenke",
  title: "Innbettet lenke",
  urlFieldLabel: "Legg til URL",
  actionFieldLabel: "Velg handling",
  validations: {
    href: "Gyldig URL er nødvendig",
    target: "Mål er nødvendig"
  }
}, l9 = {
  tooltip: "Legg til bilde",
  alignmentTooltip: "Juster bilde til {align}",
  wrapTooltip: "Omslutt bilde til {align}",
  editTitle: "Rediger bilde",
  embedTitle: "Innbettet bilde",
  validations: {
    url: "Gyldig bilde-URL er nødvendig",
    width: "Ugyldig bredde oppgitt",
    height: "Ugyldig høyde oppgitt",
    alt: "Vennligst spesifiser alternativ tekst",
    imageLink: "En gyldig URL er nødvendig",
    target: "Ugyldig mål gitt"
  },
  labels: {
    url: "Bilde-URL",
    width: "Sett bredde",
    height: "Sett høyde",
    alt: "Alternativ tekst",
    imageLink: "Bildehandlingslenke",
    target: "Åpne lenke i",
    target_self: "I samme vindu",
    target_blank: "I det nye vinduet"
  },
  placeholders: {
    url: "Vennligst legg til en gyldig bilde-URL"
  },
  lockAspect: "Lås sideforhold",
  unlockAspect: "Lås opp sideforhold"
}, s9 = {
  width: "bil",
  height: "bil",
  alt: "Angi en alternativ tekst",
  imageLink: "Lim inn en lenke for å åpne ved å klikke på bilde",
  target: "ignorere",
  tooltip: "Legg til video",
  alignmentTooltip: "Juster videoen til {align}",
  wrapTooltip: "Pakk inn video til {align}",
  editTitle: "Rediger video",
  embedTitle: "Bygg inn video",
  validations: {
    src: "Gyldig videolenke kreves",
    width: "Ugyldig bredde angitt",
    height: "Ugyldig høyde oppgitt",
    fileType: "Ugyldig filtype"
  },
  labels: {
    linkSource: "Video kilde",
    width: "Bredde (px)",
    height: "Høyde (px)",
    src: "Video-URL",
    source_native: "Sett inn fra en lenke",
    source_youtube: "Legg til YouTube-URL"
  },
  placeholders: {
    src: "ignorere",
    width: "Standardbredde",
    height: "Standard høyde",
    alt: "Angi en alternativ tekst",
    imageLink: "Lim inn en lenke for å åpne ved å klikke på bildet",
    target: "ignorere"
  },
  updateVideo: "Oppdater video"
}, u9 = {
  tooltip: "Legg til linjehøyde"
}, c9 = {
  bulletListTooltip: "Legg til punktliste",
  orderedListTooltip: "Legg til nummerert liste",
  taskListTooltip: "Legg til gjøremålsliste",
  list: "Liste",
  circleList: "Sirkelliste",
  discList: "Plateoversikt",
  squareList: "Kvadratisk liste",
  upperAlphaList: "Øvre alfabetliste",
  upperRomanList: "Øvre romersk liste",
  decimalList: "liste",
  lowerAlphaList: "Nedre alfabetiske liste",
  lowerGreekList: "Lavere greskliste",
  lowerRomanList: "Lavere romersk liste"
}, d9 = {
  formatAllTooltip: "Formatere hele dokumentet",
  formatSelectedTooltip: "Format valgt"
}, f9 = {
  undo: "Angre",
  redo: "Gjøre om"
}, h9 = {
  alignTooltip: "Juster tekst til {align}",
  subScript: "Undertekst",
  superScript: "Overordnet skrift"
}, p9 = {
  self: "Selv",
  newWindow: "Nytt vindu",
  linkTitle: "Link Tittel",
  textNeeded: "Det trengs en koblingstekst",
  invalidCustomLink: "Ugyldig tilpasset innebyggingslink"
}, g9 = {
  textColor: "Tekstfarge",
  textHighlight: "Tekstmarkering"
}, m9 = {
  paragraph: "Avsnitt",
  heading1: "Overskrift 1",
  heading2: "Overskrift 2",
  heading3: "Overskrift 3",
  heading4: "Overskrift 4",
  heading5: "Overskrift 5"
}, v9 = {
  insertTable: "Sett inn tabell",
  deleteTable: "Slett tabell",
  deleteColumn: "Slett kolonne",
  deleteRow: "Slett rad",
  addColumnBefore: "Legg til kolonne før",
  addColumnAfter: "Legg til kolonne etter",
  addRowBefore: "Legg til rad før",
  addRowAfter: "Legg til rad etter",
  mergeCell: "Slå sammen celler",
  splitCell: "Del celle"
}, fK = {
  common: i9,
  placeholders: o9,
  linkEmbed: a9,
  imageEmbed: l9,
  videoEmbed: s9,
  lineHeight: u9,
  list: c9,
  resetStyles: d9,
  history: f9,
  textAlign: h9,
  link: p9,
  color: g9,
  paragraph: m9,
  table: v9
}, hK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: g9,
  common: i9,
  default: fK,
  history: f9,
  imageEmbed: l9,
  lineHeight: u9,
  link: p9,
  linkEmbed: a9,
  list: c9,
  paragraph: m9,
  placeholders: o9,
  resetStyles: d9,
  table: v9,
  textAlign: h9,
  videoEmbed: s9
}, Symbol.toStringTag, { value: "Module" })), b9 = {
  cancel: "Cancelar",
  save: "Salvar",
  left: "Esquerda",
  right: "Certo",
  center: "Centro",
  justify: "Justificar",
  bold: "Negrito",
  italic: "Texto em itálico",
  strike: "Greve",
  underline: "Sublinhar",
  remove: "Remover",
  update: "Atualização",
  action: "Ação",
  blockquote: "Citação de bloco",
  code: "Código",
  fileUpload: "Envio de Arquivo",
  invalidURL: "URL inválida",
  url: "URL",
  valueMissing: "Valor está faltando",
  targetNeeded: "Alvo é necessário",
  customControl: "Controle personalizado",
  externalEmbed: "Incorporação externa",
  invalidOption: "Opção inválida fornecida"
}, y9 = {
  fontFamily: "Família de fontes",
  fontSize: "Tamanho da fonte",
  lineHeight: "Altura da linha"
}, x9 = {
  tooltip: "Adicionar link",
  title: "Link de incorporação",
  urlFieldLabel: "Adicionar URL",
  actionFieldLabel: "Selecionar Ação",
  validations: {
    href: "É necessário um URL válido",
    target: "É necessário um alvo"
  }
}, w9 = {
  tooltip: "Adicionar imagem",
  alignmentTooltip: "Alinhar imagem para {align}",
  wrapTooltip: "Envolver imagem em {align}",
  editTitle: "Editar imagem",
  embedTitle: "Incorporar imagem",
  validations: {
    url: "É necessário um URL de imagem válido",
    width: "Largura inválida fornecida",
    height: "Altura fornecida inválida",
    alt: "Por favor, especifique um texto alternativo",
    imageLink: "É necessário um URL válido",
    target: "Alvo inválido fornecido"
  },
  labels: {
    url: "URL da imagem",
    width: "Largura definida",
    height: "Definir altura",
    alt: "Texto alternativo",
    imageLink: "Link de Ação da Imagem",
    target: "Abrir link em",
    target_self: "Na mesma janela",
    target_blank: "Na nova janela"
  },
  placeholders: {
    url: "Por favor, adicione uma URL de imagem válida"
  },
  lockAspect: "Bloquear proporção de aspecto",
  unlockAspect: "Desbloquear proporção de aspecto"
}, M9 = {
  width: "auto",
  height: "auto",
  alt: "Especifique um texto alternativo",
  imageLink: "Cole um link para abrir ao clicar na imagem",
  target: "ignorar",
  tooltip: "Adicionar vídeo",
  alignmentTooltip: "Alinhar vídeo para {align}",
  wrapTooltip: "Encaixar vídeo em {align}",
  editTitle: "Editar vídeo",
  embedTitle: "Incorporar vídeo",
  validations: {
    src: "É necessário um URL de vídeo válido",
    width: "Largura inválida fornecida",
    height: "Altura fornecida inválida",
    fileType: "Tipo de arquivo inválido"
  },
  labels: {
    linkSource: "Fonte do vídeo",
    width: "Largura (px)",
    height: "Altura (px)",
    src: "URL do vídeo",
    source_native: "Inserir a partir de um link",
    source_youtube: "Adicionar URL do Youtube"
  },
  placeholders: {
    src: "ignorar",
    width: "Largura padrão",
    height: "Altura padrão",
    alt: "Especifique um texto alternativo",
    imageLink: "Cole um link para abrir ao clicar na imagem",
    target: "ignorar"
  },
  updateVideo: "Atualizar vídeo"
}, C9 = {
  tooltip: "Adicionar altura de linha"
}, S9 = {
  bulletListTooltip: "Adicionar lista com marcadores",
  orderedListTooltip: "Adicionar Lista Numerada",
  taskListTooltip: "Adicionar Lista de Tarefas",
  list: "Lista",
  circleList: "Lista de Círculo",
  discList: "Lista de discos",
  squareList: "Lista Quadrada",
  upperAlphaList: "Lista Alfabética Superior",
  upperRomanList: "Lista Romana Superior",
  decimalList: "Lista Decimal",
  lowerAlphaList: "Lista Alfabética Inferior",
  lowerGreekList: "Lista em grego inferior",
  lowerRomanList: "Lista em Romano Minúsculo"
}, T9 = {
  formatAllTooltip: "Formate todo o documento",
  formatSelectedTooltip: "Formato selecionado"
}, k9 = {
  undo: "Desfazer",
  redo: "Refazer"
}, D9 = {
  alignTooltip: "Alinhar texto para {align}",
  subScript: "Subscrito",
  superScript: "Super Script"
}, A9 = {
  self: "Eu mesmo or Mulher",
  newWindow: "Nova janela",
  linkTitle: "Título do Link",
  textNeeded: "Link de texto é necessário",
  invalidCustomLink: "Link personalizado inválido"
}, E9 = {
  textColor: "Cor da fonte",
  textHighlight: "Destaque de texto"
}, I9 = {
  paragraph: "Parágrafo",
  heading1: "Título 1",
  heading2: "Título 2",
  heading3: "Título 3",
  heading4: "Título 4",
  heading5: "Titulo 5"
}, N9 = {
  insertTable: "Inserir Tabela",
  deleteTable: "Excluir Tabela",
  deleteColumn: "Excluir Coluna",
  deleteRow: "Excluir Linha",
  addColumnBefore: "Adicionar Coluna Antes",
  addColumnAfter: "Adicionar Coluna Depois",
  addRowBefore: "Adicionar Linha Antes",
  addRowAfter: "Adicionar Linha Depois",
  mergeCell: "Mesclar Células",
  splitCell: "Dividir Célula"
}, pK = {
  common: b9,
  placeholders: y9,
  linkEmbed: x9,
  imageEmbed: w9,
  videoEmbed: M9,
  lineHeight: C9,
  list: S9,
  resetStyles: T9,
  history: k9,
  textAlign: D9,
  link: A9,
  color: E9,
  paragraph: I9,
  table: N9
}, gK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: E9,
  common: b9,
  default: pK,
  history: k9,
  imageEmbed: w9,
  lineHeight: C9,
  link: A9,
  linkEmbed: x9,
  list: S9,
  paragraph: I9,
  placeholders: y9,
  resetStyles: T9,
  table: N9,
  textAlign: D9,
  videoEmbed: M9
}, Symbol.toStringTag, { value: "Module" })), z9 = {
  cancel: "Cancelar",
  save: "Guardar",
  left: "Esquerda",
  right: "Certo",
  center: "Centro",
  justify: "Justificar",
  bold: "Negrito",
  italic: "Texto em itálico",
  strike: "Greve",
  underline: "Sublinhar",
  remove: "Remover",
  update: "Atualização",
  action: "Ação",
  blockquote: "Citação em bloco",
  code: "Código",
  fileUpload: "Transferência de ficheiro",
  invalidURL: "URL inválido",
  url: "endereço URL",
  valueMissing: "Falta valor",
  targetNeeded: "É necessário um alvo",
  customControl: "Controlo personalizado",
  externalEmbed: "Incorporação Externa",
  invalidOption: "Opção inválida fornecida"
}, $9 = {
  fontFamily: "Família de fontes",
  fontSize: "Tamanho da fonte",
  lineHeight: "Altura da linha"
}, O9 = {
  tooltip: "Adicionar Link",
  title: "Incorporar Link",
  urlFieldLabel: "Adicionar URL",
  actionFieldLabel: "Selecionar Ação",
  validations: {
    href: "É necessário um URL válido",
    target: "É necessário um alvo"
  }
}, _9 = {
  tooltip: "Adicionar imagem",
  alignmentTooltip: "Alinhar imagem para {align}",
  wrapTooltip: "Envolver imagem em {align}",
  editTitle: "Editar imagem",
  embedTitle: "Incorporar imagem",
  validations: {
    url: "É necessário um URL de imagem válido",
    width: "Largura inválida fornecida",
    height: "Altura inválida fornecida",
    alt: "Por favor, especifique um texto alternativo",
    imageLink: "É necessário um URL válido",
    target: "Alvo inválido fornecido"
  },
  labels: {
    url: "URL da imagem",
    width: "Largura definida",
    height: "Definir Altura",
    alt: "Texto alternativo",
    imageLink: "Ligação de Ação de Imagem",
    target: "Abrir ligação em",
    target_self: "Na mesma janela",
    target_blank: "Na nova janela"
  },
  placeholders: {
    url: "Por favor, adicione um URL de imagem válido"
  },
  lockAspect: "Bloquear proporção de aspecto",
  unlockAspect: "De-stravar relação de aspecto"
}, L9 = {
  width: "auto",
  height: "auto",
  alt: "Especificar um texto alternativo",
  imageLink: "Cole um link para abrir ao clicar na imagem",
  target: "ignore",
  tooltip: "Adicionar vídeo",
  alignmentTooltip: "Alinhar vídeo para {align}",
  wrapTooltip: "Encaixar vídeo em {align}",
  editTitle: "Editar vídeo",
  embedTitle: "Incorporar vídeo",
  validations: {
    src: "É necessário um URL de vídeo válido",
    width: "Largura inválida fornecida",
    height: "Altura inválida fornecida",
    fileType: "Tipo de ficheiro inválido"
  },
  labels: {
    linkSource: "Fonte de vídeo",
    width: "Largura (px)",
    height: "Altura (px)",
    src: "URL do vídeo",
    source_native: "Inserir a partir de um link",
    source_youtube: "Adicionar URL do Youtube"
  },
  placeholders: {
    src: "ignore",
    width: "Largura padrão",
    height: "Altura padrão",
    alt: "Especificar um texto alternativo",
    imageLink: "Cole um link para abrir ao clicar na imagem",
    target: "ignore"
  },
  updateVideo: "Atualizar Vídeo"
}, P9 = {
  tooltip: "Adicionar altura de linha"
}, R9 = {
  bulletListTooltip: "Adicionar lista com marcadores",
  orderedListTooltip: "Adicionar Lista Numerada",
  taskListTooltip: "Adicionar Lista de Tarefas",
  list: "Lista",
  circleList: "Lista de Círculo",
  discList: "Lista de discos",
  squareList: "Lista Quadrada",
  upperAlphaList: "Lista de Alfa Superior",
  upperRomanList: "Lista Romana Superior",
  decimalList: "Lista Decimal",
  lowerAlphaList: "Lista Alfabética Inferior",
  lowerGreekList: "Lista grega inferior",
  lowerRomanList: "Lista Romana Inferior"
}, j9 = {
  formatAllTooltip: "Formatar todo o documento",
  formatSelectedTooltip: "Formato selecionado"
}, F9 = {
  undo: "Desfazer",
  redo: "Refazer"
}, B9 = {
  alignTooltip: "Alinhar texto para {align}",
  subScript: "Subscripto",
  superScript: "Super Roteiro"
}, U9 = {
  self: "eu mesmo",
  newWindow: "Nova janela",
  linkTitle: "Título do Link",
  textNeeded: "É necessário um texto de ligação",
  invalidCustomLink: "Link personalizado inválido"
}, H9 = {
  textColor: "Cor de Texto",
  textHighlight: "Destaque de texto"
}, W9 = {
  paragraph: "Parágrafo",
  heading1: "Titulo 1",
  heading2: "Título 2",
  heading3: "Título 3",
  heading4: "Título 4",
  heading5: "Título de Nível 5"
}, V9 = {
  insertTable: "Inserir Tabela",
  deleteTable: "Eliminar Tabela",
  deleteColumn: "Eliminar Coluna",
  deleteRow: "Eliminar Linha",
  addColumnBefore: "Adicionar Coluna Antes",
  addColumnAfter: "Adicionar Coluna Depois",
  addRowBefore: "Adicionar Linha Antes",
  addRowAfter: "Adicionar Linha Depois",
  mergeCell: "Unir Células",
  splitCell: "Dividir Célula"
}, mK = {
  common: z9,
  placeholders: $9,
  linkEmbed: O9,
  imageEmbed: _9,
  videoEmbed: L9,
  lineHeight: P9,
  list: R9,
  resetStyles: j9,
  history: F9,
  textAlign: B9,
  link: U9,
  color: H9,
  paragraph: W9,
  table: V9
}, vK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: H9,
  common: z9,
  default: mK,
  history: F9,
  imageEmbed: _9,
  lineHeight: P9,
  link: U9,
  linkEmbed: O9,
  list: R9,
  paragraph: W9,
  placeholders: $9,
  resetStyles: j9,
  table: V9,
  textAlign: B9,
  videoEmbed: L9
}, Symbol.toStringTag, { value: "Module" })), Y9 = {
  cancel: "Avbryt",
  save: "Spara",
  left: "Vänster",
  right: "Rätt",
  center: "Centrum",
  justify: "motivera",
  bold: "Djärv",
  italic: "kursiv",
  strike: "Strejk",
  underline: "Understryk",
  remove: "Ta bort",
  update: "Uppdatering",
  action: "Handling",
  blockquote: "Blockcitat",
  code: "Kod",
  fileUpload: "Filöverföring",
  invalidURL: "Ogiltig URL",
  url: "Uniform Resource Locator",
  valueMissing: "Värdet saknas",
  targetNeeded: "Målet behövs",
  customControl: "Anpassad kontroll",
  externalEmbed: "Extern inbäddning",
  invalidOption: "Ogiltigt alternativ angetts"
}, Q9 = {
  fontFamily: "Typsnittsfamilj",
  fontSize: "Teckenstorlek",
  lineHeight: "Radavstånd"
}, q9 = {
  tooltip: "Lägg till länk",
  title: "Bädda in länk",
  urlFieldLabel: "Lägg till URL",
  actionFieldLabel: "Välj Åtgärd",
  validations: {
    href: "En giltig URL behövs",
    target: "Målintresse behövs"
  }
}, G9 = {
  tooltip: "Lägg till bild",
  alignmentTooltip: "Justera bild till {align}",
  wrapTooltip: "Omslut bild till {align}",
  editTitle: "Redigera bild",
  embedTitle: "Bädda in bild",
  validations: {
    url: "Giltig bild-URL krävs",
    width: "Ogiltig bredd angiven",
    height: "Ogiltig höjd angiven",
    alt: "Ange alternativ text, tack",
    imageLink: "En giltig URL krävs",
    target: "Ogiltigt mål angivet"
  },
  labels: {
    url: "Bild-URL",
    width: "Sätt bredd",
    height: "Sätt höjd",
    alt: "Alternativtext",
    imageLink: "Bildåtgärds länk",
    target: "Öppna länk i",
    target_self: "I samma fönster",
    target_blank: "I det nya fönstret"
  },
  placeholders: {
    url: "Var god lägg till en giltig bild-URL"
  },
  lockAspect: "Lås sidoförhållande",
  unlockAspect: "Lås upp aspektratio"
}, Z9 = {
  width: "bil",
  height: "bil",
  alt: "Specificera en alternativ text",
  imageLink: "Klistra in en länk för att öppna vid klick på bild",
  target: "ignorera",
  tooltip: "Lägg till video",
  alignmentTooltip: "Justera video till {align}",
  wrapTooltip: "Omslut video till {align}",
  editTitle: "Redigera video",
  embedTitle: "Bädda in video",
  validations: {
    src: "En giltig videolänk behövs",
    width: "Ogiltig bredd angiven",
    height: "Ogiltig höjd angiven",
    fileType: "Ogiltig filtyp"
  },
  labels: {
    linkSource: "Videokälla",
    width: "Bredd (px)",
    height: "Höjd (px)",
    src: "Videolänk",
    source_native: "Infoga från en länk",
    source_youtube: "Lägg till Youtube-URL"
  },
  placeholders: {
    src: "ignorera",
    width: "Standardbredd",
    height: "Standardhöjd",
    alt: "Ange en alternativ text",
    imageLink: "Klistra in en länk för att öppnas vid klick på bild",
    target: "ignorera"
  },
  updateVideo: "Uppdateringsvideo"
}, K9 = {
  tooltip: "Lägg till radhöjd"
}, X9 = {
  bulletListTooltip: "Lägg till punktlista",
  orderedListTooltip: "Lägg till numrerad lista",
  taskListTooltip: "Lägg till att göra-lista",
  list: "Lista",
  circleList: "Cirkellista",
  discList: "Skivlista",
  squareList: "Kvadratlista",
  upperAlphaList: "Övre alfabetlista",
  upperRomanList: "Övre romersk lista",
  decimalList: "Decimal lista",
  lowerAlphaList: "Nedre alfabetisk lista",
  lowerGreekList: "Lägre grekisk lista",
  lowerRomanList: "Lägre romersk lista"
}, J9 = {
  formatAllTooltip: "Formatera hela dokumentet",
  formatSelectedTooltip: "Valt format"
}, eU = {
  undo: "Ångra",
  redo: "Klar"
}, tU = {
  alignTooltip: "Justera text till {align}",
  subScript: "Undertext",
  superScript: "höjdtecken"
}, rU = {
  self: "Själv",
  newWindow: "Nytt fönster",
  linkTitle: "Länktitel",
  textNeeded: "Länktext krävs",
  invalidCustomLink: "Ogiltig anpassad inbäddningslänk"
}, nU = {
  textColor: "Textfärg",
  textHighlight: "Textmarkering"
}, iU = {
  paragraph: "Stycke",
  heading1: "Rubrik 1",
  heading2: "Rubrik 2",
  heading3: "Rubrik 3",
  heading4: "Rubrik 4",
  heading5: "Rubrik 5"
}, oU = {
  insertTable: "Infoga tabell",
  deleteTable: "Radera tabell",
  deleteColumn: "Radera kolumn",
  deleteRow: "Radera rad",
  addColumnBefore: "Lägg till kolumn före",
  addColumnAfter: "Lägg till kolumn efter",
  addRowBefore: "Lägg till rad före",
  addRowAfter: "Lägg till rad efter",
  mergeCell: "Sammanfoga celler",
  splitCell: "Dela cell"
}, bK = {
  common: Y9,
  placeholders: Q9,
  linkEmbed: q9,
  imageEmbed: G9,
  videoEmbed: Z9,
  lineHeight: K9,
  list: X9,
  resetStyles: J9,
  history: eU,
  textAlign: tU,
  link: rU,
  color: nU,
  paragraph: iU,
  table: oU
}, yK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: nU,
  common: Y9,
  default: bK,
  history: eU,
  imageEmbed: G9,
  lineHeight: K9,
  link: rU,
  linkEmbed: q9,
  list: X9,
  paragraph: iU,
  placeholders: Q9,
  resetStyles: J9,
  table: oU,
  textAlign: tU,
  videoEmbed: Z9
}, Symbol.toStringTag, { value: "Module" }));
var Cn = /* @__PURE__ */ ((e) => (e.English_US = "en-US", e.Danish = "da", e.German = "de", e.Spanish = "es", e.Finnish = "fi", e.French_CA = "fr-CA", e.French_FR = "fr-FR", e.Italian = "it", e.Dutch = "nl", e.Norwegian = "no", e.Portuguese_BR = "pt-BR", e.Portuguese_PT = "pt-PT", e.Swedish = "sv", e))(Cn || {});
const Dn = {
  [
    "en-US"
    /* English_US */
  ]: JZ,
  da: GZ,
  de: KZ,
  es: tK,
  fi: nK,
  [
    "fr-CA"
    /* French_CA */
  ]: oK,
  [
    "fr-FR"
    /* French_FR */
  ]: lK,
  it: uK,
  nl: dK,
  no: hK,
  [
    "pt-BR"
    /* Portuguese_BR */
  ]: gK,
  [
    "pt-PT"
    /* Portuguese_PT */
  ]: vK,
  sv: yK
};
function IL(e) {
  tr("language", e), tr("locale", Dn[e]);
}
var Ou = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, hn = {}, xK = {
  get exports() {
    return hn;
  },
  set exports(e) {
    hn = e;
  }
};
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
(function(e, t) {
  (function() {
    var r, n = "4.17.21", i = 200, o = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a = "Expected a function", s = "Invalid `variable` option passed into `_.template`", u = "__lodash_hash_undefined__", d = 500, f = "__lodash_placeholder__", h = 1, g = 2, m = 4, v = 1, w = 2, x = 1, y = 2, C = 4, S = 8, T = 16, A = 32, D = 64, E = 128, N = 256, I = 512, $ = 30, _ = "...", R = 800, U = 16, Q = 1, Z = 2, X = 3, re = 1 / 0, ue = 9007199254740991, he = 17976931348623157e292, te = 0 / 0, de = 4294967295, De = de - 1, Oe = de >>> 1, Qe = [
      ["ary", E],
      ["bind", x],
      ["bindKey", y],
      ["curry", S],
      ["curryRight", T],
      ["flip", I],
      ["partial", A],
      ["partialRight", D],
      ["rearg", N]
    ], Ae = "[object Arguments]", Ne = "[object Array]", $e = "[object AsyncFunction]", et = "[object Boolean]", Ge = "[object Date]", Ee = "[object DOMException]", qe = "[object Error]", Ue = "[object Function]", ot = "[object GeneratorFunction]", Ie = "[object Map]", rt = "[object Number]", W = "[object Null]", P = "[object Object]", H = "[object Promise]", se = "[object Proxy]", pe = "[object RegExp]", ae = "[object Set]", Me = "[object String]", fe = "[object Symbol]", ke = "[object Undefined]", Le = "[object WeakMap]", dt = "[object WeakSet]", Mt = "[object ArrayBuffer]", Ct = "[object DataView]", er = "[object Float32Array]", Vt = "[object Float64Array]", jt = "[object Int8Array]", at = "[object Int16Array]", St = "[object Int32Array]", ve = "[object Uint8Array]", We = "[object Uint8ClampedArray]", ne = "[object Uint16Array]", Se = "[object Uint32Array]", _e = /\b__p \+= '';/g, ut = /\b(__p \+=) '' \+/g, ht = /(__e\(.*?\)|\b__t\)) \+\n'';/g, ye = /&(?:amp|lt|gt|quot|#39);/g, Ze = /[&<>"']/g, st = RegExp(ye.source), Nt = RegExp(Ze.source), Te = /<%-([\s\S]+?)%>/g, Ke = /<%([\s\S]+?)%>/g, xe = /<%=([\s\S]+?)%>/g, Xe = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, At = /^\w*$/, Ht = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, zt = /[\\^$.*+?()[\]{}|]/g, ge = RegExp(zt.source), Fe = /^\s+/, Tt = /\s/, lr = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, gr = /\{\n\/\* \[wrapped with (.+)\] \*/, Or = /,? & /, ri = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, xi = /[()=,{}\[\]\/\s]/, wi = /\\(\\)?/g, Pi = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Mi = /\w*$/, ze = /^[-+]0x[0-9a-f]+$/i, wt = /^0b[01]+$/i, Ut = /^\[object .+?Constructor\]$/, Wr = /^0o[0-7]+$/i, ct = /^(?:0|[1-9]\d*)$/, en = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Ci = /($^)/, na = /['\n\r\u2028\u2029\\]/g, kr = "\\ud800-\\udfff", Xi = "\\u0300-\\u036f", hi = "\\ufe20-\\ufe2f", gl = "\\u20d0-\\u20ff", so = Xi + hi + gl, ia = "\\u2700-\\u27bf", Os = "a-z\\xdf-\\xf6\\xf8-\\xff", Qc = "\\xac\\xb1\\xd7\\xf7", qc = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Gc = "\\u2000-\\u206f", Zc = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", _s = "A-Z\\xc0-\\xd6\\xd8-\\xde", Ls = "\\ufe0e\\ufe0f", Ps = Qc + qc + Gc + Zc, Rs = "['’]", lg = "[" + kr + "]", Kc = "[" + Ps + "]", ml = "[" + so + "]", Xc = "\\d+", sg = "[" + ia + "]", Jc = "[" + Os + "]", ed = "[^" + kr + Ps + Xc + ia + Os + _s + "]", js = "\\ud83c[\\udffb-\\udfff]", ug = "(?:" + ml + "|" + js + ")", td = "[^" + kr + "]", Fs = "(?:\\ud83c[\\udde6-\\uddff]){2}", Bs = "[\\ud800-\\udbff][\\udc00-\\udfff]", Po = "[" + _s + "]", rd = "\\u200d", nd = "(?:" + Jc + "|" + ed + ")", cg = "(?:" + Po + "|" + ed + ")", dg = "(?:" + Rs + "(?:d|ll|m|re|s|t|ve))?", fg = "(?:" + Rs + "(?:D|LL|M|RE|S|T|VE))?", hg = ug + "?", pg = "[" + Ls + "]?", MC = "(?:" + rd + "(?:" + [td, Fs, Bs].join("|") + ")" + pg + hg + ")*", CC = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", SC = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", gg = pg + hg + MC, TC = "(?:" + [sg, Fs, Bs].join("|") + ")" + gg, kC = "(?:" + [td + ml + "?", ml, Fs, Bs, lg].join("|") + ")", DC = RegExp(Rs, "g"), AC = RegExp(ml, "g"), id = RegExp(js + "(?=" + js + ")|" + kC + gg, "g"), EC = RegExp([
      Po + "?" + Jc + "+" + dg + "(?=" + [Kc, Po, "$"].join("|") + ")",
      cg + "+" + fg + "(?=" + [Kc, Po + nd, "$"].join("|") + ")",
      Po + "?" + nd + "+" + dg,
      Po + "+" + fg,
      SC,
      CC,
      Xc,
      TC
    ].join("|"), "g"), IC = RegExp("[" + rd + kr + so + Ls + "]"), NC = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, zC = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], $C = -1, dr = {};
    dr[er] = dr[Vt] = dr[jt] = dr[at] = dr[St] = dr[ve] = dr[We] = dr[ne] = dr[Se] = !0, dr[Ae] = dr[Ne] = dr[Mt] = dr[et] = dr[Ct] = dr[Ge] = dr[qe] = dr[Ue] = dr[Ie] = dr[rt] = dr[P] = dr[pe] = dr[ae] = dr[Me] = dr[Le] = !1;
    var sr = {};
    sr[Ae] = sr[Ne] = sr[Mt] = sr[Ct] = sr[et] = sr[Ge] = sr[er] = sr[Vt] = sr[jt] = sr[at] = sr[St] = sr[Ie] = sr[rt] = sr[P] = sr[pe] = sr[ae] = sr[Me] = sr[fe] = sr[ve] = sr[We] = sr[ne] = sr[Se] = !0, sr[qe] = sr[Ue] = sr[Le] = !1;
    var OC = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, _C = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, LC = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, PC = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, RC = parseFloat, jC = parseInt, mg = typeof Ou == "object" && Ou && Ou.Object === Object && Ou, FC = typeof self == "object" && self && self.Object === Object && self, Vr = mg || FC || Function("return this")(), od = t && !t.nodeType && t, Ro = od && !0 && e && !e.nodeType && e, vg = Ro && Ro.exports === od, ad = vg && mg.process, Bn = function() {
      try {
        var J = Ro && Ro.require && Ro.require("util").types;
        return J || ad && ad.binding && ad.binding("util");
      } catch {
      }
    }(), bg = Bn && Bn.isArrayBuffer, yg = Bn && Bn.isDate, xg = Bn && Bn.isMap, wg = Bn && Bn.isRegExp, Mg = Bn && Bn.isSet, Cg = Bn && Bn.isTypedArray;
    function An(J, ce, le) {
      switch (le.length) {
        case 0:
          return J.call(ce);
        case 1:
          return J.call(ce, le[0]);
        case 2:
          return J.call(ce, le[0], le[1]);
        case 3:
          return J.call(ce, le[0], le[1], le[2]);
      }
      return J.apply(ce, le);
    }
    function BC(J, ce, le, Je) {
      for (var kt = -1, qt = J == null ? 0 : J.length; ++kt < qt; ) {
        var Pr = J[kt];
        ce(Je, Pr, le(Pr), J);
      }
      return Je;
    }
    function Un(J, ce) {
      for (var le = -1, Je = J == null ? 0 : J.length; ++le < Je && ce(J[le], le, J) !== !1; )
        ;
      return J;
    }
    function UC(J, ce) {
      for (var le = J == null ? 0 : J.length; le-- && ce(J[le], le, J) !== !1; )
        ;
      return J;
    }
    function Sg(J, ce) {
      for (var le = -1, Je = J == null ? 0 : J.length; ++le < Je; )
        if (!ce(J[le], le, J))
          return !1;
      return !0;
    }
    function uo(J, ce) {
      for (var le = -1, Je = J == null ? 0 : J.length, kt = 0, qt = []; ++le < Je; ) {
        var Pr = J[le];
        ce(Pr, le, J) && (qt[kt++] = Pr);
      }
      return qt;
    }
    function Us(J, ce) {
      var le = J == null ? 0 : J.length;
      return !!le && ba(J, ce, 0) > -1;
    }
    function ld(J, ce, le) {
      for (var Je = -1, kt = J == null ? 0 : J.length; ++Je < kt; )
        if (le(ce, J[Je]))
          return !0;
      return !1;
    }
    function mr(J, ce) {
      for (var le = -1, Je = J == null ? 0 : J.length, kt = Array(Je); ++le < Je; )
        kt[le] = ce(J[le], le, J);
      return kt;
    }
    function co(J, ce) {
      for (var le = -1, Je = ce.length, kt = J.length; ++le < Je; )
        J[kt + le] = ce[le];
      return J;
    }
    function sd(J, ce, le, Je) {
      var kt = -1, qt = J == null ? 0 : J.length;
      for (Je && qt && (le = J[++kt]); ++kt < qt; )
        le = ce(le, J[kt], kt, J);
      return le;
    }
    function HC(J, ce, le, Je) {
      var kt = J == null ? 0 : J.length;
      for (Je && kt && (le = J[--kt]); kt--; )
        le = ce(le, J[kt], kt, J);
      return le;
    }
    function ud(J, ce) {
      for (var le = -1, Je = J == null ? 0 : J.length; ++le < Je; )
        if (ce(J[le], le, J))
          return !0;
      return !1;
    }
    var WC = cd("length");
    function VC(J) {
      return J.split("");
    }
    function YC(J) {
      return J.match(ri) || [];
    }
    function Tg(J, ce, le) {
      var Je;
      return le(J, function(kt, qt, Pr) {
        if (ce(kt, qt, Pr))
          return Je = qt, !1;
      }), Je;
    }
    function Hs(J, ce, le, Je) {
      for (var kt = J.length, qt = le + (Je ? 1 : -1); Je ? qt-- : ++qt < kt; )
        if (ce(J[qt], qt, J))
          return qt;
      return -1;
    }
    function ba(J, ce, le) {
      return ce === ce ? iS(J, ce, le) : Hs(J, kg, le);
    }
    function QC(J, ce, le, Je) {
      for (var kt = le - 1, qt = J.length; ++kt < qt; )
        if (Je(J[kt], ce))
          return kt;
      return -1;
    }
    function kg(J) {
      return J !== J;
    }
    function Dg(J, ce) {
      var le = J == null ? 0 : J.length;
      return le ? fd(J, ce) / le : te;
    }
    function cd(J) {
      return function(ce) {
        return ce == null ? r : ce[J];
      };
    }
    function dd(J) {
      return function(ce) {
        return J == null ? r : J[ce];
      };
    }
    function Ag(J, ce, le, Je, kt) {
      return kt(J, function(qt, Pr, or) {
        le = Je ? (Je = !1, qt) : ce(le, qt, Pr, or);
      }), le;
    }
    function qC(J, ce) {
      var le = J.length;
      for (J.sort(ce); le--; )
        J[le] = J[le].value;
      return J;
    }
    function fd(J, ce) {
      for (var le, Je = -1, kt = J.length; ++Je < kt; ) {
        var qt = ce(J[Je]);
        qt !== r && (le = le === r ? qt : le + qt);
      }
      return le;
    }
    function hd(J, ce) {
      for (var le = -1, Je = Array(J); ++le < J; )
        Je[le] = ce(le);
      return Je;
    }
    function GC(J, ce) {
      return mr(ce, function(le) {
        return [le, J[le]];
      });
    }
    function Eg(J) {
      return J && J.slice(0, $g(J) + 1).replace(Fe, "");
    }
    function En(J) {
      return function(ce) {
        return J(ce);
      };
    }
    function pd(J, ce) {
      return mr(ce, function(le) {
        return J[le];
      });
    }
    function vl(J, ce) {
      return J.has(ce);
    }
    function Ig(J, ce) {
      for (var le = -1, Je = J.length; ++le < Je && ba(ce, J[le], 0) > -1; )
        ;
      return le;
    }
    function Ng(J, ce) {
      for (var le = J.length; le-- && ba(ce, J[le], 0) > -1; )
        ;
      return le;
    }
    function ZC(J, ce) {
      for (var le = J.length, Je = 0; le--; )
        J[le] === ce && ++Je;
      return Je;
    }
    var KC = dd(OC), XC = dd(_C);
    function JC(J) {
      return "\\" + PC[J];
    }
    function eS(J, ce) {
      return J == null ? r : J[ce];
    }
    function ya(J) {
      return IC.test(J);
    }
    function tS(J) {
      return NC.test(J);
    }
    function rS(J) {
      for (var ce, le = []; !(ce = J.next()).done; )
        le.push(ce.value);
      return le;
    }
    function gd(J) {
      var ce = -1, le = Array(J.size);
      return J.forEach(function(Je, kt) {
        le[++ce] = [kt, Je];
      }), le;
    }
    function zg(J, ce) {
      return function(le) {
        return J(ce(le));
      };
    }
    function fo(J, ce) {
      for (var le = -1, Je = J.length, kt = 0, qt = []; ++le < Je; ) {
        var Pr = J[le];
        (Pr === ce || Pr === f) && (J[le] = f, qt[kt++] = le);
      }
      return qt;
    }
    function Ws(J) {
      var ce = -1, le = Array(J.size);
      return J.forEach(function(Je) {
        le[++ce] = Je;
      }), le;
    }
    function nS(J) {
      var ce = -1, le = Array(J.size);
      return J.forEach(function(Je) {
        le[++ce] = [Je, Je];
      }), le;
    }
    function iS(J, ce, le) {
      for (var Je = le - 1, kt = J.length; ++Je < kt; )
        if (J[Je] === ce)
          return Je;
      return -1;
    }
    function oS(J, ce, le) {
      for (var Je = le + 1; Je--; )
        if (J[Je] === ce)
          return Je;
      return Je;
    }
    function xa(J) {
      return ya(J) ? lS(J) : WC(J);
    }
    function ni(J) {
      return ya(J) ? sS(J) : VC(J);
    }
    function $g(J) {
      for (var ce = J.length; ce-- && Tt.test(J.charAt(ce)); )
        ;
      return ce;
    }
    var aS = dd(LC);
    function lS(J) {
      for (var ce = id.lastIndex = 0; id.test(J); )
        ++ce;
      return ce;
    }
    function sS(J) {
      return J.match(id) || [];
    }
    function uS(J) {
      return J.match(EC) || [];
    }
    var cS = function J(ce) {
      ce = ce == null ? Vr : wa.defaults(Vr.Object(), ce, wa.pick(Vr, zC));
      var le = ce.Array, Je = ce.Date, kt = ce.Error, qt = ce.Function, Pr = ce.Math, or = ce.Object, md = ce.RegExp, dS = ce.String, Hn = ce.TypeError, Vs = le.prototype, fS = qt.prototype, Ma = or.prototype, Ys = ce["__core-js_shared__"], Qs = fS.toString, Jt = Ma.hasOwnProperty, hS = 0, Og = function() {
        var l = /[^.]+$/.exec(Ys && Ys.keys && Ys.keys.IE_PROTO || "");
        return l ? "Symbol(src)_1." + l : "";
      }(), qs = Ma.toString, pS = Qs.call(or), gS = Vr._, mS = md(
        "^" + Qs.call(Jt).replace(zt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Gs = vg ? ce.Buffer : r, ho = ce.Symbol, Zs = ce.Uint8Array, _g = Gs ? Gs.allocUnsafe : r, Ks = zg(or.getPrototypeOf, or), Lg = or.create, Pg = Ma.propertyIsEnumerable, Xs = Vs.splice, Rg = ho ? ho.isConcatSpreadable : r, bl = ho ? ho.iterator : r, jo = ho ? ho.toStringTag : r, Js = function() {
        try {
          var l = Wo(or, "defineProperty");
          return l({}, "", {}), l;
        } catch {
        }
      }(), vS = ce.clearTimeout !== Vr.clearTimeout && ce.clearTimeout, bS = Je && Je.now !== Vr.Date.now && Je.now, yS = ce.setTimeout !== Vr.setTimeout && ce.setTimeout, eu = Pr.ceil, tu = Pr.floor, vd = or.getOwnPropertySymbols, xS = Gs ? Gs.isBuffer : r, jg = ce.isFinite, wS = Vs.join, MS = zg(or.keys, or), Rr = Pr.max, tn = Pr.min, CS = Je.now, SS = ce.parseInt, Fg = Pr.random, TS = Vs.reverse, bd = Wo(ce, "DataView"), yl = Wo(ce, "Map"), yd = Wo(ce, "Promise"), Ca = Wo(ce, "Set"), xl = Wo(ce, "WeakMap"), wl = Wo(or, "create"), ru = xl && new xl(), Sa = {}, kS = Vo(bd), DS = Vo(yl), AS = Vo(yd), ES = Vo(Ca), IS = Vo(xl), nu = ho ? ho.prototype : r, Ml = nu ? nu.valueOf : r, Bg = nu ? nu.toString : r;
      function z(l) {
        if (Dr(l) && !Et(l) && !(l instanceof Rt)) {
          if (l instanceof Wn)
            return l;
          if (Jt.call(l, "__wrapped__"))
            return Um(l);
        }
        return new Wn(l);
      }
      var Ta = function() {
        function l() {
        }
        return function(c) {
          if (!yr(c))
            return {};
          if (Lg)
            return Lg(c);
          l.prototype = c;
          var p = new l();
          return l.prototype = r, p;
        };
      }();
      function iu() {
      }
      function Wn(l, c) {
        this.__wrapped__ = l, this.__actions__ = [], this.__chain__ = !!c, this.__index__ = 0, this.__values__ = r;
      }
      z.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Te,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Ke,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: xe,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: z
        }
      }, z.prototype = iu.prototype, z.prototype.constructor = z, Wn.prototype = Ta(iu.prototype), Wn.prototype.constructor = Wn;
      function Rt(l) {
        this.__wrapped__ = l, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = de, this.__views__ = [];
      }
      function NS() {
        var l = new Rt(this.__wrapped__);
        return l.__actions__ = gn(this.__actions__), l.__dir__ = this.__dir__, l.__filtered__ = this.__filtered__, l.__iteratees__ = gn(this.__iteratees__), l.__takeCount__ = this.__takeCount__, l.__views__ = gn(this.__views__), l;
      }
      function zS() {
        if (this.__filtered__) {
          var l = new Rt(this);
          l.__dir__ = -1, l.__filtered__ = !0;
        } else
          l = this.clone(), l.__dir__ *= -1;
        return l;
      }
      function $S() {
        var l = this.__wrapped__.value(), c = this.__dir__, p = Et(l), M = c < 0, k = p ? l.length : 0, O = VT(0, k, this.__views__), F = O.start, V = O.end, ee = V - F, me = M ? V : F - 1, be = this.__iteratees__, Ce = be.length, He = 0, it = tn(ee, this.__takeCount__);
        if (!p || !M && k == ee && it == ee)
          return dm(l, this.__actions__);
        var gt = [];
        e:
          for (; ee-- && He < it; ) {
            me += c;
            for (var $t = -1, mt = l[me]; ++$t < Ce; ) {
              var Pt = be[$t], Ft = Pt.iteratee, zn = Pt.type, un = Ft(mt);
              if (zn == Z)
                mt = un;
              else if (!un) {
                if (zn == Q)
                  continue e;
                break e;
              }
            }
            gt[He++] = mt;
          }
        return gt;
      }
      Rt.prototype = Ta(iu.prototype), Rt.prototype.constructor = Rt;
      function Fo(l) {
        var c = -1, p = l == null ? 0 : l.length;
        for (this.clear(); ++c < p; ) {
          var M = l[c];
          this.set(M[0], M[1]);
        }
      }
      function OS() {
        this.__data__ = wl ? wl(null) : {}, this.size = 0;
      }
      function _S(l) {
        var c = this.has(l) && delete this.__data__[l];
        return this.size -= c ? 1 : 0, c;
      }
      function LS(l) {
        var c = this.__data__;
        if (wl) {
          var p = c[l];
          return p === u ? r : p;
        }
        return Jt.call(c, l) ? c[l] : r;
      }
      function PS(l) {
        var c = this.__data__;
        return wl ? c[l] !== r : Jt.call(c, l);
      }
      function RS(l, c) {
        var p = this.__data__;
        return this.size += this.has(l) ? 0 : 1, p[l] = wl && c === r ? u : c, this;
      }
      Fo.prototype.clear = OS, Fo.prototype.delete = _S, Fo.prototype.get = LS, Fo.prototype.has = PS, Fo.prototype.set = RS;
      function Ri(l) {
        var c = -1, p = l == null ? 0 : l.length;
        for (this.clear(); ++c < p; ) {
          var M = l[c];
          this.set(M[0], M[1]);
        }
      }
      function jS() {
        this.__data__ = [], this.size = 0;
      }
      function FS(l) {
        var c = this.__data__, p = ou(c, l);
        if (p < 0)
          return !1;
        var M = c.length - 1;
        return p == M ? c.pop() : Xs.call(c, p, 1), --this.size, !0;
      }
      function BS(l) {
        var c = this.__data__, p = ou(c, l);
        return p < 0 ? r : c[p][1];
      }
      function US(l) {
        return ou(this.__data__, l) > -1;
      }
      function HS(l, c) {
        var p = this.__data__, M = ou(p, l);
        return M < 0 ? (++this.size, p.push([l, c])) : p[M][1] = c, this;
      }
      Ri.prototype.clear = jS, Ri.prototype.delete = FS, Ri.prototype.get = BS, Ri.prototype.has = US, Ri.prototype.set = HS;
      function ji(l) {
        var c = -1, p = l == null ? 0 : l.length;
        for (this.clear(); ++c < p; ) {
          var M = l[c];
          this.set(M[0], M[1]);
        }
      }
      function WS() {
        this.size = 0, this.__data__ = {
          hash: new Fo(),
          map: new (yl || Ri)(),
          string: new Fo()
        };
      }
      function VS(l) {
        var c = vu(this, l).delete(l);
        return this.size -= c ? 1 : 0, c;
      }
      function YS(l) {
        return vu(this, l).get(l);
      }
      function QS(l) {
        return vu(this, l).has(l);
      }
      function qS(l, c) {
        var p = vu(this, l), M = p.size;
        return p.set(l, c), this.size += p.size == M ? 0 : 1, this;
      }
      ji.prototype.clear = WS, ji.prototype.delete = VS, ji.prototype.get = YS, ji.prototype.has = QS, ji.prototype.set = qS;
      function Bo(l) {
        var c = -1, p = l == null ? 0 : l.length;
        for (this.__data__ = new ji(); ++c < p; )
          this.add(l[c]);
      }
      function GS(l) {
        return this.__data__.set(l, u), this;
      }
      function ZS(l) {
        return this.__data__.has(l);
      }
      Bo.prototype.add = Bo.prototype.push = GS, Bo.prototype.has = ZS;
      function ii(l) {
        var c = this.__data__ = new Ri(l);
        this.size = c.size;
      }
      function KS() {
        this.__data__ = new Ri(), this.size = 0;
      }
      function XS(l) {
        var c = this.__data__, p = c.delete(l);
        return this.size = c.size, p;
      }
      function JS(l) {
        return this.__data__.get(l);
      }
      function eT(l) {
        return this.__data__.has(l);
      }
      function tT(l, c) {
        var p = this.__data__;
        if (p instanceof Ri) {
          var M = p.__data__;
          if (!yl || M.length < i - 1)
            return M.push([l, c]), this.size = ++p.size, this;
          p = this.__data__ = new ji(M);
        }
        return p.set(l, c), this.size = p.size, this;
      }
      ii.prototype.clear = KS, ii.prototype.delete = XS, ii.prototype.get = JS, ii.prototype.has = eT, ii.prototype.set = tT;
      function Ug(l, c) {
        var p = Et(l), M = !p && Yo(l), k = !p && !M && bo(l), O = !p && !M && !k && Ea(l), F = p || M || k || O, V = F ? hd(l.length, dS) : [], ee = V.length;
        for (var me in l)
          (c || Jt.call(l, me)) && !(F && // Safari 9 has enumerable `arguments.length` in strict mode.
          (me == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          k && (me == "offset" || me == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          O && (me == "buffer" || me == "byteLength" || me == "byteOffset") || // Skip index properties.
          Hi(me, ee))) && V.push(me);
        return V;
      }
      function Hg(l) {
        var c = l.length;
        return c ? l[Id(0, c - 1)] : r;
      }
      function rT(l, c) {
        return bu(gn(l), Uo(c, 0, l.length));
      }
      function nT(l) {
        return bu(gn(l));
      }
      function xd(l, c, p) {
        (p !== r && !oi(l[c], p) || p === r && !(c in l)) && Fi(l, c, p);
      }
      function Cl(l, c, p) {
        var M = l[c];
        (!(Jt.call(l, c) && oi(M, p)) || p === r && !(c in l)) && Fi(l, c, p);
      }
      function ou(l, c) {
        for (var p = l.length; p--; )
          if (oi(l[p][0], c))
            return p;
        return -1;
      }
      function iT(l, c, p, M) {
        return po(l, function(k, O, F) {
          c(M, k, p(k), F);
        }), M;
      }
      function Wg(l, c) {
        return l && Ti(c, Ur(c), l);
      }
      function oT(l, c) {
        return l && Ti(c, vn(c), l);
      }
      function Fi(l, c, p) {
        c == "__proto__" && Js ? Js(l, c, {
          configurable: !0,
          enumerable: !0,
          value: p,
          writable: !0
        }) : l[c] = p;
      }
      function wd(l, c) {
        for (var p = -1, M = c.length, k = le(M), O = l == null; ++p < M; )
          k[p] = O ? r : tf(l, c[p]);
        return k;
      }
      function Uo(l, c, p) {
        return l === l && (p !== r && (l = l <= p ? l : p), c !== r && (l = l >= c ? l : c)), l;
      }
      function Vn(l, c, p, M, k, O) {
        var F, V = c & h, ee = c & g, me = c & m;
        if (p && (F = k ? p(l, M, k, O) : p(l)), F !== r)
          return F;
        if (!yr(l))
          return l;
        var be = Et(l);
        if (be) {
          if (F = QT(l), !V)
            return gn(l, F);
        } else {
          var Ce = rn(l), He = Ce == Ue || Ce == ot;
          if (bo(l))
            return pm(l, V);
          if (Ce == P || Ce == Ae || He && !k) {
            if (F = ee || He ? {} : $m(l), !V)
              return ee ? LT(l, oT(F, l)) : _T(l, Wg(F, l));
          } else {
            if (!sr[Ce])
              return k ? l : {};
            F = qT(l, Ce, V);
          }
        }
        O || (O = new ii());
        var it = O.get(l);
        if (it)
          return it;
        O.set(l, F), sv(l) ? l.forEach(function(mt) {
          F.add(Vn(mt, c, p, mt, l, O));
        }) : av(l) && l.forEach(function(mt, Pt) {
          F.set(Pt, Vn(mt, c, p, Pt, l, O));
        });
        var gt = me ? ee ? Bd : Fd : ee ? vn : Ur, $t = be ? r : gt(l);
        return Un($t || l, function(mt, Pt) {
          $t && (Pt = mt, mt = l[Pt]), Cl(F, Pt, Vn(mt, c, p, Pt, l, O));
        }), F;
      }
      function aT(l) {
        var c = Ur(l);
        return function(p) {
          return Vg(p, l, c);
        };
      }
      function Vg(l, c, p) {
        var M = p.length;
        if (l == null)
          return !M;
        for (l = or(l); M--; ) {
          var k = p[M], O = c[k], F = l[k];
          if (F === r && !(k in l) || !O(F))
            return !1;
        }
        return !0;
      }
      function Yg(l, c, p) {
        if (typeof l != "function")
          throw new Hn(a);
        return Il(function() {
          l.apply(r, p);
        }, c);
      }
      function Sl(l, c, p, M) {
        var k = -1, O = Us, F = !0, V = l.length, ee = [], me = c.length;
        if (!V)
          return ee;
        p && (c = mr(c, En(p))), M ? (O = ld, F = !1) : c.length >= i && (O = vl, F = !1, c = new Bo(c));
        e:
          for (; ++k < V; ) {
            var be = l[k], Ce = p == null ? be : p(be);
            if (be = M || be !== 0 ? be : 0, F && Ce === Ce) {
              for (var He = me; He--; )
                if (c[He] === Ce)
                  continue e;
              ee.push(be);
            } else
              O(c, Ce, M) || ee.push(be);
          }
        return ee;
      }
      var po = ym(Si), Qg = ym(Cd, !0);
      function lT(l, c) {
        var p = !0;
        return po(l, function(M, k, O) {
          return p = !!c(M, k, O), p;
        }), p;
      }
      function au(l, c, p) {
        for (var M = -1, k = l.length; ++M < k; ) {
          var O = l[M], F = c(O);
          if (F != null && (V === r ? F === F && !Nn(F) : p(F, V)))
            var V = F, ee = O;
        }
        return ee;
      }
      function sT(l, c, p, M) {
        var k = l.length;
        for (p = It(p), p < 0 && (p = -p > k ? 0 : k + p), M = M === r || M > k ? k : It(M), M < 0 && (M += k), M = p > M ? 0 : cv(M); p < M; )
          l[p++] = c;
        return l;
      }
      function qg(l, c) {
        var p = [];
        return po(l, function(M, k, O) {
          c(M, k, O) && p.push(M);
        }), p;
      }
      function Yr(l, c, p, M, k) {
        var O = -1, F = l.length;
        for (p || (p = ZT), k || (k = []); ++O < F; ) {
          var V = l[O];
          c > 0 && p(V) ? c > 1 ? Yr(V, c - 1, p, M, k) : co(k, V) : M || (k[k.length] = V);
        }
        return k;
      }
      var Md = xm(), Gg = xm(!0);
      function Si(l, c) {
        return l && Md(l, c, Ur);
      }
      function Cd(l, c) {
        return l && Gg(l, c, Ur);
      }
      function lu(l, c) {
        return uo(c, function(p) {
          return Wi(l[p]);
        });
      }
      function Ho(l, c) {
        c = mo(c, l);
        for (var p = 0, M = c.length; l != null && p < M; )
          l = l[ki(c[p++])];
        return p && p == M ? l : r;
      }
      function Zg(l, c, p) {
        var M = c(l);
        return Et(l) ? M : co(M, p(l));
      }
      function ln(l) {
        return l == null ? l === r ? ke : W : jo && jo in or(l) ? WT(l) : nk(l);
      }
      function Sd(l, c) {
        return l > c;
      }
      function uT(l, c) {
        return l != null && Jt.call(l, c);
      }
      function cT(l, c) {
        return l != null && c in or(l);
      }
      function dT(l, c, p) {
        return l >= tn(c, p) && l < Rr(c, p);
      }
      function Td(l, c, p) {
        for (var M = p ? ld : Us, k = l[0].length, O = l.length, F = O, V = le(O), ee = 1 / 0, me = []; F--; ) {
          var be = l[F];
          F && c && (be = mr(be, En(c))), ee = tn(be.length, ee), V[F] = !p && (c || k >= 120 && be.length >= 120) ? new Bo(F && be) : r;
        }
        be = l[0];
        var Ce = -1, He = V[0];
        e:
          for (; ++Ce < k && me.length < ee; ) {
            var it = be[Ce], gt = c ? c(it) : it;
            if (it = p || it !== 0 ? it : 0, !(He ? vl(He, gt) : M(me, gt, p))) {
              for (F = O; --F; ) {
                var $t = V[F];
                if (!($t ? vl($t, gt) : M(l[F], gt, p)))
                  continue e;
              }
              He && He.push(gt), me.push(it);
            }
          }
        return me;
      }
      function fT(l, c, p, M) {
        return Si(l, function(k, O, F) {
          c(M, p(k), O, F);
        }), M;
      }
      function Tl(l, c, p) {
        c = mo(c, l), l = Pm(l, c);
        var M = l == null ? l : l[ki(Qn(c))];
        return M == null ? r : An(M, l, p);
      }
      function Kg(l) {
        return Dr(l) && ln(l) == Ae;
      }
      function hT(l) {
        return Dr(l) && ln(l) == Mt;
      }
      function pT(l) {
        return Dr(l) && ln(l) == Ge;
      }
      function kl(l, c, p, M, k) {
        return l === c ? !0 : l == null || c == null || !Dr(l) && !Dr(c) ? l !== l && c !== c : gT(l, c, p, M, kl, k);
      }
      function gT(l, c, p, M, k, O) {
        var F = Et(l), V = Et(c), ee = F ? Ne : rn(l), me = V ? Ne : rn(c);
        ee = ee == Ae ? P : ee, me = me == Ae ? P : me;
        var be = ee == P, Ce = me == P, He = ee == me;
        if (He && bo(l)) {
          if (!bo(c))
            return !1;
          F = !0, be = !1;
        }
        if (He && !be)
          return O || (O = new ii()), F || Ea(l) ? Im(l, c, p, M, k, O) : UT(l, c, ee, p, M, k, O);
        if (!(p & v)) {
          var it = be && Jt.call(l, "__wrapped__"), gt = Ce && Jt.call(c, "__wrapped__");
          if (it || gt) {
            var $t = it ? l.value() : l, mt = gt ? c.value() : c;
            return O || (O = new ii()), k($t, mt, p, M, O);
          }
        }
        return He ? (O || (O = new ii()), HT(l, c, p, M, k, O)) : !1;
      }
      function mT(l) {
        return Dr(l) && rn(l) == Ie;
      }
      function kd(l, c, p, M) {
        var k = p.length, O = k, F = !M;
        if (l == null)
          return !O;
        for (l = or(l); k--; ) {
          var V = p[k];
          if (F && V[2] ? V[1] !== l[V[0]] : !(V[0] in l))
            return !1;
        }
        for (; ++k < O; ) {
          V = p[k];
          var ee = V[0], me = l[ee], be = V[1];
          if (F && V[2]) {
            if (me === r && !(ee in l))
              return !1;
          } else {
            var Ce = new ii();
            if (M)
              var He = M(me, be, ee, l, c, Ce);
            if (!(He === r ? kl(be, me, v | w, M, Ce) : He))
              return !1;
          }
        }
        return !0;
      }
      function Xg(l) {
        if (!yr(l) || XT(l))
          return !1;
        var c = Wi(l) ? mS : Ut;
        return c.test(Vo(l));
      }
      function vT(l) {
        return Dr(l) && ln(l) == pe;
      }
      function bT(l) {
        return Dr(l) && rn(l) == ae;
      }
      function yT(l) {
        return Dr(l) && Su(l.length) && !!dr[ln(l)];
      }
      function Jg(l) {
        return typeof l == "function" ? l : l == null ? bn : typeof l == "object" ? Et(l) ? rm(l[0], l[1]) : tm(l) : wv(l);
      }
      function Dd(l) {
        if (!El(l))
          return MS(l);
        var c = [];
        for (var p in or(l))
          Jt.call(l, p) && p != "constructor" && c.push(p);
        return c;
      }
      function xT(l) {
        if (!yr(l))
          return rk(l);
        var c = El(l), p = [];
        for (var M in l)
          M == "constructor" && (c || !Jt.call(l, M)) || p.push(M);
        return p;
      }
      function Ad(l, c) {
        return l < c;
      }
      function em(l, c) {
        var p = -1, M = mn(l) ? le(l.length) : [];
        return po(l, function(k, O, F) {
          M[++p] = c(k, O, F);
        }), M;
      }
      function tm(l) {
        var c = Hd(l);
        return c.length == 1 && c[0][2] ? _m(c[0][0], c[0][1]) : function(p) {
          return p === l || kd(p, l, c);
        };
      }
      function rm(l, c) {
        return Vd(l) && Om(c) ? _m(ki(l), c) : function(p) {
          var M = tf(p, l);
          return M === r && M === c ? rf(p, l) : kl(c, M, v | w);
        };
      }
      function su(l, c, p, M, k) {
        l !== c && Md(c, function(O, F) {
          if (k || (k = new ii()), yr(O))
            wT(l, c, F, p, su, M, k);
          else {
            var V = M ? M(Qd(l, F), O, F + "", l, c, k) : r;
            V === r && (V = O), xd(l, F, V);
          }
        }, vn);
      }
      function wT(l, c, p, M, k, O, F) {
        var V = Qd(l, p), ee = Qd(c, p), me = F.get(ee);
        if (me) {
          xd(l, p, me);
          return;
        }
        var be = O ? O(V, ee, p + "", l, c, F) : r, Ce = be === r;
        if (Ce) {
          var He = Et(ee), it = !He && bo(ee), gt = !He && !it && Ea(ee);
          be = ee, He || it || gt ? Et(V) ? be = V : Ir(V) ? be = gn(V) : it ? (Ce = !1, be = pm(ee, !0)) : gt ? (Ce = !1, be = gm(ee, !0)) : be = [] : Nl(ee) || Yo(ee) ? (be = V, Yo(V) ? be = dv(V) : (!yr(V) || Wi(V)) && (be = $m(ee))) : Ce = !1;
        }
        Ce && (F.set(ee, be), k(be, ee, M, O, F), F.delete(ee)), xd(l, p, be);
      }
      function nm(l, c) {
        var p = l.length;
        if (p)
          return c += c < 0 ? p : 0, Hi(c, p) ? l[c] : r;
      }
      function im(l, c, p) {
        c.length ? c = mr(c, function(O) {
          return Et(O) ? function(F) {
            return Ho(F, O.length === 1 ? O[0] : O);
          } : O;
        }) : c = [bn];
        var M = -1;
        c = mr(c, En(pt()));
        var k = em(l, function(O, F, V) {
          var ee = mr(c, function(me) {
            return me(O);
          });
          return { criteria: ee, index: ++M, value: O };
        });
        return qC(k, function(O, F) {
          return OT(O, F, p);
        });
      }
      function MT(l, c) {
        return om(l, c, function(p, M) {
          return rf(l, M);
        });
      }
      function om(l, c, p) {
        for (var M = -1, k = c.length, O = {}; ++M < k; ) {
          var F = c[M], V = Ho(l, F);
          p(V, F) && Dl(O, mo(F, l), V);
        }
        return O;
      }
      function CT(l) {
        return function(c) {
          return Ho(c, l);
        };
      }
      function Ed(l, c, p, M) {
        var k = M ? QC : ba, O = -1, F = c.length, V = l;
        for (l === c && (c = gn(c)), p && (V = mr(l, En(p))); ++O < F; )
          for (var ee = 0, me = c[O], be = p ? p(me) : me; (ee = k(V, be, ee, M)) > -1; )
            V !== l && Xs.call(V, ee, 1), Xs.call(l, ee, 1);
        return l;
      }
      function am(l, c) {
        for (var p = l ? c.length : 0, M = p - 1; p--; ) {
          var k = c[p];
          if (p == M || k !== O) {
            var O = k;
            Hi(k) ? Xs.call(l, k, 1) : $d(l, k);
          }
        }
        return l;
      }
      function Id(l, c) {
        return l + tu(Fg() * (c - l + 1));
      }
      function ST(l, c, p, M) {
        for (var k = -1, O = Rr(eu((c - l) / (p || 1)), 0), F = le(O); O--; )
          F[M ? O : ++k] = l, l += p;
        return F;
      }
      function Nd(l, c) {
        var p = "";
        if (!l || c < 1 || c > ue)
          return p;
        do
          c % 2 && (p += l), c = tu(c / 2), c && (l += l);
        while (c);
        return p;
      }
      function _t(l, c) {
        return qd(Lm(l, c, bn), l + "");
      }
      function TT(l) {
        return Hg(Ia(l));
      }
      function kT(l, c) {
        var p = Ia(l);
        return bu(p, Uo(c, 0, p.length));
      }
      function Dl(l, c, p, M) {
        if (!yr(l))
          return l;
        c = mo(c, l);
        for (var k = -1, O = c.length, F = O - 1, V = l; V != null && ++k < O; ) {
          var ee = ki(c[k]), me = p;
          if (ee === "__proto__" || ee === "constructor" || ee === "prototype")
            return l;
          if (k != F) {
            var be = V[ee];
            me = M ? M(be, ee, V) : r, me === r && (me = yr(be) ? be : Hi(c[k + 1]) ? [] : {});
          }
          Cl(V, ee, me), V = V[ee];
        }
        return l;
      }
      var lm = ru ? function(l, c) {
        return ru.set(l, c), l;
      } : bn, DT = Js ? function(l, c) {
        return Js(l, "toString", {
          configurable: !0,
          enumerable: !1,
          value: of(c),
          writable: !0
        });
      } : bn;
      function AT(l) {
        return bu(Ia(l));
      }
      function Yn(l, c, p) {
        var M = -1, k = l.length;
        c < 0 && (c = -c > k ? 0 : k + c), p = p > k ? k : p, p < 0 && (p += k), k = c > p ? 0 : p - c >>> 0, c >>>= 0;
        for (var O = le(k); ++M < k; )
          O[M] = l[M + c];
        return O;
      }
      function ET(l, c) {
        var p;
        return po(l, function(M, k, O) {
          return p = c(M, k, O), !p;
        }), !!p;
      }
      function uu(l, c, p) {
        var M = 0, k = l == null ? M : l.length;
        if (typeof c == "number" && c === c && k <= Oe) {
          for (; M < k; ) {
            var O = M + k >>> 1, F = l[O];
            F !== null && !Nn(F) && (p ? F <= c : F < c) ? M = O + 1 : k = O;
          }
          return k;
        }
        return zd(l, c, bn, p);
      }
      function zd(l, c, p, M) {
        var k = 0, O = l == null ? 0 : l.length;
        if (O === 0)
          return 0;
        c = p(c);
        for (var F = c !== c, V = c === null, ee = Nn(c), me = c === r; k < O; ) {
          var be = tu((k + O) / 2), Ce = p(l[be]), He = Ce !== r, it = Ce === null, gt = Ce === Ce, $t = Nn(Ce);
          if (F)
            var mt = M || gt;
          else
            me ? mt = gt && (M || He) : V ? mt = gt && He && (M || !it) : ee ? mt = gt && He && !it && (M || !$t) : it || $t ? mt = !1 : mt = M ? Ce <= c : Ce < c;
          mt ? k = be + 1 : O = be;
        }
        return tn(O, De);
      }
      function sm(l, c) {
        for (var p = -1, M = l.length, k = 0, O = []; ++p < M; ) {
          var F = l[p], V = c ? c(F) : F;
          if (!p || !oi(V, ee)) {
            var ee = V;
            O[k++] = F === 0 ? 0 : F;
          }
        }
        return O;
      }
      function um(l) {
        return typeof l == "number" ? l : Nn(l) ? te : +l;
      }
      function In(l) {
        if (typeof l == "string")
          return l;
        if (Et(l))
          return mr(l, In) + "";
        if (Nn(l))
          return Bg ? Bg.call(l) : "";
        var c = l + "";
        return c == "0" && 1 / l == -re ? "-0" : c;
      }
      function go(l, c, p) {
        var M = -1, k = Us, O = l.length, F = !0, V = [], ee = V;
        if (p)
          F = !1, k = ld;
        else if (O >= i) {
          var me = c ? null : FT(l);
          if (me)
            return Ws(me);
          F = !1, k = vl, ee = new Bo();
        } else
          ee = c ? [] : V;
        e:
          for (; ++M < O; ) {
            var be = l[M], Ce = c ? c(be) : be;
            if (be = p || be !== 0 ? be : 0, F && Ce === Ce) {
              for (var He = ee.length; He--; )
                if (ee[He] === Ce)
                  continue e;
              c && ee.push(Ce), V.push(be);
            } else
              k(ee, Ce, p) || (ee !== V && ee.push(Ce), V.push(be));
          }
        return V;
      }
      function $d(l, c) {
        return c = mo(c, l), l = Pm(l, c), l == null || delete l[ki(Qn(c))];
      }
      function cm(l, c, p, M) {
        return Dl(l, c, p(Ho(l, c)), M);
      }
      function cu(l, c, p, M) {
        for (var k = l.length, O = M ? k : -1; (M ? O-- : ++O < k) && c(l[O], O, l); )
          ;
        return p ? Yn(l, M ? 0 : O, M ? O + 1 : k) : Yn(l, M ? O + 1 : 0, M ? k : O);
      }
      function dm(l, c) {
        var p = l;
        return p instanceof Rt && (p = p.value()), sd(c, function(M, k) {
          return k.func.apply(k.thisArg, co([M], k.args));
        }, p);
      }
      function Od(l, c, p) {
        var M = l.length;
        if (M < 2)
          return M ? go(l[0]) : [];
        for (var k = -1, O = le(M); ++k < M; )
          for (var F = l[k], V = -1; ++V < M; )
            V != k && (O[k] = Sl(O[k] || F, l[V], c, p));
        return go(Yr(O, 1), c, p);
      }
      function fm(l, c, p) {
        for (var M = -1, k = l.length, O = c.length, F = {}; ++M < k; ) {
          var V = M < O ? c[M] : r;
          p(F, l[M], V);
        }
        return F;
      }
      function _d(l) {
        return Ir(l) ? l : [];
      }
      function Ld(l) {
        return typeof l == "function" ? l : bn;
      }
      function mo(l, c) {
        return Et(l) ? l : Vd(l, c) ? [l] : Bm(Zt(l));
      }
      var IT = _t;
      function vo(l, c, p) {
        var M = l.length;
        return p = p === r ? M : p, !c && p >= M ? l : Yn(l, c, p);
      }
      var hm = vS || function(l) {
        return Vr.clearTimeout(l);
      };
      function pm(l, c) {
        if (c)
          return l.slice();
        var p = l.length, M = _g ? _g(p) : new l.constructor(p);
        return l.copy(M), M;
      }
      function Pd(l) {
        var c = new l.constructor(l.byteLength);
        return new Zs(c).set(new Zs(l)), c;
      }
      function NT(l, c) {
        var p = c ? Pd(l.buffer) : l.buffer;
        return new l.constructor(p, l.byteOffset, l.byteLength);
      }
      function zT(l) {
        var c = new l.constructor(l.source, Mi.exec(l));
        return c.lastIndex = l.lastIndex, c;
      }
      function $T(l) {
        return Ml ? or(Ml.call(l)) : {};
      }
      function gm(l, c) {
        var p = c ? Pd(l.buffer) : l.buffer;
        return new l.constructor(p, l.byteOffset, l.length);
      }
      function mm(l, c) {
        if (l !== c) {
          var p = l !== r, M = l === null, k = l === l, O = Nn(l), F = c !== r, V = c === null, ee = c === c, me = Nn(c);
          if (!V && !me && !O && l > c || O && F && ee && !V && !me || M && F && ee || !p && ee || !k)
            return 1;
          if (!M && !O && !me && l < c || me && p && k && !M && !O || V && p && k || !F && k || !ee)
            return -1;
        }
        return 0;
      }
      function OT(l, c, p) {
        for (var M = -1, k = l.criteria, O = c.criteria, F = k.length, V = p.length; ++M < F; ) {
          var ee = mm(k[M], O[M]);
          if (ee) {
            if (M >= V)
              return ee;
            var me = p[M];
            return ee * (me == "desc" ? -1 : 1);
          }
        }
        return l.index - c.index;
      }
      function vm(l, c, p, M) {
        for (var k = -1, O = l.length, F = p.length, V = -1, ee = c.length, me = Rr(O - F, 0), be = le(ee + me), Ce = !M; ++V < ee; )
          be[V] = c[V];
        for (; ++k < F; )
          (Ce || k < O) && (be[p[k]] = l[k]);
        for (; me--; )
          be[V++] = l[k++];
        return be;
      }
      function bm(l, c, p, M) {
        for (var k = -1, O = l.length, F = -1, V = p.length, ee = -1, me = c.length, be = Rr(O - V, 0), Ce = le(be + me), He = !M; ++k < be; )
          Ce[k] = l[k];
        for (var it = k; ++ee < me; )
          Ce[it + ee] = c[ee];
        for (; ++F < V; )
          (He || k < O) && (Ce[it + p[F]] = l[k++]);
        return Ce;
      }
      function gn(l, c) {
        var p = -1, M = l.length;
        for (c || (c = le(M)); ++p < M; )
          c[p] = l[p];
        return c;
      }
      function Ti(l, c, p, M) {
        var k = !p;
        p || (p = {});
        for (var O = -1, F = c.length; ++O < F; ) {
          var V = c[O], ee = M ? M(p[V], l[V], V, p, l) : r;
          ee === r && (ee = l[V]), k ? Fi(p, V, ee) : Cl(p, V, ee);
        }
        return p;
      }
      function _T(l, c) {
        return Ti(l, Wd(l), c);
      }
      function LT(l, c) {
        return Ti(l, Nm(l), c);
      }
      function du(l, c) {
        return function(p, M) {
          var k = Et(p) ? BC : iT, O = c ? c() : {};
          return k(p, l, pt(M, 2), O);
        };
      }
      function ka(l) {
        return _t(function(c, p) {
          var M = -1, k = p.length, O = k > 1 ? p[k - 1] : r, F = k > 2 ? p[2] : r;
          for (O = l.length > 3 && typeof O == "function" ? (k--, O) : r, F && sn(p[0], p[1], F) && (O = k < 3 ? r : O, k = 1), c = or(c); ++M < k; ) {
            var V = p[M];
            V && l(c, V, M, O);
          }
          return c;
        });
      }
      function ym(l, c) {
        return function(p, M) {
          if (p == null)
            return p;
          if (!mn(p))
            return l(p, M);
          for (var k = p.length, O = c ? k : -1, F = or(p); (c ? O-- : ++O < k) && M(F[O], O, F) !== !1; )
            ;
          return p;
        };
      }
      function xm(l) {
        return function(c, p, M) {
          for (var k = -1, O = or(c), F = M(c), V = F.length; V--; ) {
            var ee = F[l ? V : ++k];
            if (p(O[ee], ee, O) === !1)
              break;
          }
          return c;
        };
      }
      function PT(l, c, p) {
        var M = c & x, k = Al(l);
        function O() {
          var F = this && this !== Vr && this instanceof O ? k : l;
          return F.apply(M ? p : this, arguments);
        }
        return O;
      }
      function wm(l) {
        return function(c) {
          c = Zt(c);
          var p = ya(c) ? ni(c) : r, M = p ? p[0] : c.charAt(0), k = p ? vo(p, 1).join("") : c.slice(1);
          return M[l]() + k;
        };
      }
      function Da(l) {
        return function(c) {
          return sd(yv(bv(c).replace(DC, "")), l, "");
        };
      }
      function Al(l) {
        return function() {
          var c = arguments;
          switch (c.length) {
            case 0:
              return new l();
            case 1:
              return new l(c[0]);
            case 2:
              return new l(c[0], c[1]);
            case 3:
              return new l(c[0], c[1], c[2]);
            case 4:
              return new l(c[0], c[1], c[2], c[3]);
            case 5:
              return new l(c[0], c[1], c[2], c[3], c[4]);
            case 6:
              return new l(c[0], c[1], c[2], c[3], c[4], c[5]);
            case 7:
              return new l(c[0], c[1], c[2], c[3], c[4], c[5], c[6]);
          }
          var p = Ta(l.prototype), M = l.apply(p, c);
          return yr(M) ? M : p;
        };
      }
      function RT(l, c, p) {
        var M = Al(l);
        function k() {
          for (var O = arguments.length, F = le(O), V = O, ee = Aa(k); V--; )
            F[V] = arguments[V];
          var me = O < 3 && F[0] !== ee && F[O - 1] !== ee ? [] : fo(F, ee);
          if (O -= me.length, O < p)
            return km(
              l,
              c,
              fu,
              k.placeholder,
              r,
              F,
              me,
              r,
              r,
              p - O
            );
          var be = this && this !== Vr && this instanceof k ? M : l;
          return An(be, this, F);
        }
        return k;
      }
      function Mm(l) {
        return function(c, p, M) {
          var k = or(c);
          if (!mn(c)) {
            var O = pt(p, 3);
            c = Ur(c), p = function(V) {
              return O(k[V], V, k);
            };
          }
          var F = l(c, p, M);
          return F > -1 ? k[O ? c[F] : F] : r;
        };
      }
      function Cm(l) {
        return Ui(function(c) {
          var p = c.length, M = p, k = Wn.prototype.thru;
          for (l && c.reverse(); M--; ) {
            var O = c[M];
            if (typeof O != "function")
              throw new Hn(a);
            if (k && !F && mu(O) == "wrapper")
              var F = new Wn([], !0);
          }
          for (M = F ? M : p; ++M < p; ) {
            O = c[M];
            var V = mu(O), ee = V == "wrapper" ? Ud(O) : r;
            ee && Yd(ee[0]) && ee[1] == (E | S | A | N) && !ee[4].length && ee[9] == 1 ? F = F[mu(ee[0])].apply(F, ee[3]) : F = O.length == 1 && Yd(O) ? F[V]() : F.thru(O);
          }
          return function() {
            var me = arguments, be = me[0];
            if (F && me.length == 1 && Et(be))
              return F.plant(be).value();
            for (var Ce = 0, He = p ? c[Ce].apply(this, me) : be; ++Ce < p; )
              He = c[Ce].call(this, He);
            return He;
          };
        });
      }
      function fu(l, c, p, M, k, O, F, V, ee, me) {
        var be = c & E, Ce = c & x, He = c & y, it = c & (S | T), gt = c & I, $t = He ? r : Al(l);
        function mt() {
          for (var Pt = arguments.length, Ft = le(Pt), zn = Pt; zn--; )
            Ft[zn] = arguments[zn];
          if (it)
            var un = Aa(mt), $n = ZC(Ft, un);
          if (M && (Ft = vm(Ft, M, k, it)), O && (Ft = bm(Ft, O, F, it)), Pt -= $n, it && Pt < me) {
            var Nr = fo(Ft, un);
            return km(
              l,
              c,
              fu,
              mt.placeholder,
              p,
              Ft,
              Nr,
              V,
              ee,
              me - Pt
            );
          }
          var ai = Ce ? p : this, Yi = He ? ai[l] : l;
          return Pt = Ft.length, V ? Ft = ik(Ft, V) : gt && Pt > 1 && Ft.reverse(), be && ee < Pt && (Ft.length = ee), this && this !== Vr && this instanceof mt && (Yi = $t || Al(Yi)), Yi.apply(ai, Ft);
        }
        return mt;
      }
      function Sm(l, c) {
        return function(p, M) {
          return fT(p, l, c(M), {});
        };
      }
      function hu(l, c) {
        return function(p, M) {
          var k;
          if (p === r && M === r)
            return c;
          if (p !== r && (k = p), M !== r) {
            if (k === r)
              return M;
            typeof p == "string" || typeof M == "string" ? (p = In(p), M = In(M)) : (p = um(p), M = um(M)), k = l(p, M);
          }
          return k;
        };
      }
      function Rd(l) {
        return Ui(function(c) {
          return c = mr(c, En(pt())), _t(function(p) {
            var M = this;
            return l(c, function(k) {
              return An(k, M, p);
            });
          });
        });
      }
      function pu(l, c) {
        c = c === r ? " " : In(c);
        var p = c.length;
        if (p < 2)
          return p ? Nd(c, l) : c;
        var M = Nd(c, eu(l / xa(c)));
        return ya(c) ? vo(ni(M), 0, l).join("") : M.slice(0, l);
      }
      function jT(l, c, p, M) {
        var k = c & x, O = Al(l);
        function F() {
          for (var V = -1, ee = arguments.length, me = -1, be = M.length, Ce = le(be + ee), He = this && this !== Vr && this instanceof F ? O : l; ++me < be; )
            Ce[me] = M[me];
          for (; ee--; )
            Ce[me++] = arguments[++V];
          return An(He, k ? p : this, Ce);
        }
        return F;
      }
      function Tm(l) {
        return function(c, p, M) {
          return M && typeof M != "number" && sn(c, p, M) && (p = M = r), c = Vi(c), p === r ? (p = c, c = 0) : p = Vi(p), M = M === r ? c < p ? 1 : -1 : Vi(M), ST(c, p, M, l);
        };
      }
      function gu(l) {
        return function(c, p) {
          return typeof c == "string" && typeof p == "string" || (c = qn(c), p = qn(p)), l(c, p);
        };
      }
      function km(l, c, p, M, k, O, F, V, ee, me) {
        var be = c & S, Ce = be ? F : r, He = be ? r : F, it = be ? O : r, gt = be ? r : O;
        c |= be ? A : D, c &= ~(be ? D : A), c & C || (c &= ~(x | y));
        var $t = [
          l,
          c,
          k,
          it,
          Ce,
          gt,
          He,
          V,
          ee,
          me
        ], mt = p.apply(r, $t);
        return Yd(l) && Rm(mt, $t), mt.placeholder = M, jm(mt, l, c);
      }
      function jd(l) {
        var c = Pr[l];
        return function(p, M) {
          if (p = qn(p), M = M == null ? 0 : tn(It(M), 292), M && jg(p)) {
            var k = (Zt(p) + "e").split("e"), O = c(k[0] + "e" + (+k[1] + M));
            return k = (Zt(O) + "e").split("e"), +(k[0] + "e" + (+k[1] - M));
          }
          return c(p);
        };
      }
      var FT = Ca && 1 / Ws(new Ca([, -0]))[1] == re ? function(l) {
        return new Ca(l);
      } : sf;
      function Dm(l) {
        return function(c) {
          var p = rn(c);
          return p == Ie ? gd(c) : p == ae ? nS(c) : GC(c, l(c));
        };
      }
      function Bi(l, c, p, M, k, O, F, V) {
        var ee = c & y;
        if (!ee && typeof l != "function")
          throw new Hn(a);
        var me = M ? M.length : 0;
        if (me || (c &= ~(A | D), M = k = r), F = F === r ? F : Rr(It(F), 0), V = V === r ? V : It(V), me -= k ? k.length : 0, c & D) {
          var be = M, Ce = k;
          M = k = r;
        }
        var He = ee ? r : Ud(l), it = [
          l,
          c,
          p,
          M,
          k,
          be,
          Ce,
          O,
          F,
          V
        ];
        if (He && tk(it, He), l = it[0], c = it[1], p = it[2], M = it[3], k = it[4], V = it[9] = it[9] === r ? ee ? 0 : l.length : Rr(it[9] - me, 0), !V && c & (S | T) && (c &= ~(S | T)), !c || c == x)
          var gt = PT(l, c, p);
        else
          c == S || c == T ? gt = RT(l, c, V) : (c == A || c == (x | A)) && !k.length ? gt = jT(l, c, p, M) : gt = fu.apply(r, it);
        var $t = He ? lm : Rm;
        return jm($t(gt, it), l, c);
      }
      function Am(l, c, p, M) {
        return l === r || oi(l, Ma[p]) && !Jt.call(M, p) ? c : l;
      }
      function Em(l, c, p, M, k, O) {
        return yr(l) && yr(c) && (O.set(c, l), su(l, c, r, Em, O), O.delete(c)), l;
      }
      function BT(l) {
        return Nl(l) ? r : l;
      }
      function Im(l, c, p, M, k, O) {
        var F = p & v, V = l.length, ee = c.length;
        if (V != ee && !(F && ee > V))
          return !1;
        var me = O.get(l), be = O.get(c);
        if (me && be)
          return me == c && be == l;
        var Ce = -1, He = !0, it = p & w ? new Bo() : r;
        for (O.set(l, c), O.set(c, l); ++Ce < V; ) {
          var gt = l[Ce], $t = c[Ce];
          if (M)
            var mt = F ? M($t, gt, Ce, c, l, O) : M(gt, $t, Ce, l, c, O);
          if (mt !== r) {
            if (mt)
              continue;
            He = !1;
            break;
          }
          if (it) {
            if (!ud(c, function(Pt, Ft) {
              if (!vl(it, Ft) && (gt === Pt || k(gt, Pt, p, M, O)))
                return it.push(Ft);
            })) {
              He = !1;
              break;
            }
          } else if (!(gt === $t || k(gt, $t, p, M, O))) {
            He = !1;
            break;
          }
        }
        return O.delete(l), O.delete(c), He;
      }
      function UT(l, c, p, M, k, O, F) {
        switch (p) {
          case Ct:
            if (l.byteLength != c.byteLength || l.byteOffset != c.byteOffset)
              return !1;
            l = l.buffer, c = c.buffer;
          case Mt:
            return !(l.byteLength != c.byteLength || !O(new Zs(l), new Zs(c)));
          case et:
          case Ge:
          case rt:
            return oi(+l, +c);
          case qe:
            return l.name == c.name && l.message == c.message;
          case pe:
          case Me:
            return l == c + "";
          case Ie:
            var V = gd;
          case ae:
            var ee = M & v;
            if (V || (V = Ws), l.size != c.size && !ee)
              return !1;
            var me = F.get(l);
            if (me)
              return me == c;
            M |= w, F.set(l, c);
            var be = Im(V(l), V(c), M, k, O, F);
            return F.delete(l), be;
          case fe:
            if (Ml)
              return Ml.call(l) == Ml.call(c);
        }
        return !1;
      }
      function HT(l, c, p, M, k, O) {
        var F = p & v, V = Fd(l), ee = V.length, me = Fd(c), be = me.length;
        if (ee != be && !F)
          return !1;
        for (var Ce = ee; Ce--; ) {
          var He = V[Ce];
          if (!(F ? He in c : Jt.call(c, He)))
            return !1;
        }
        var it = O.get(l), gt = O.get(c);
        if (it && gt)
          return it == c && gt == l;
        var $t = !0;
        O.set(l, c), O.set(c, l);
        for (var mt = F; ++Ce < ee; ) {
          He = V[Ce];
          var Pt = l[He], Ft = c[He];
          if (M)
            var zn = F ? M(Ft, Pt, He, c, l, O) : M(Pt, Ft, He, l, c, O);
          if (!(zn === r ? Pt === Ft || k(Pt, Ft, p, M, O) : zn)) {
            $t = !1;
            break;
          }
          mt || (mt = He == "constructor");
        }
        if ($t && !mt) {
          var un = l.constructor, $n = c.constructor;
          un != $n && "constructor" in l && "constructor" in c && !(typeof un == "function" && un instanceof un && typeof $n == "function" && $n instanceof $n) && ($t = !1);
        }
        return O.delete(l), O.delete(c), $t;
      }
      function Ui(l) {
        return qd(Lm(l, r, Vm), l + "");
      }
      function Fd(l) {
        return Zg(l, Ur, Wd);
      }
      function Bd(l) {
        return Zg(l, vn, Nm);
      }
      var Ud = ru ? function(l) {
        return ru.get(l);
      } : sf;
      function mu(l) {
        for (var c = l.name + "", p = Sa[c], M = Jt.call(Sa, c) ? p.length : 0; M--; ) {
          var k = p[M], O = k.func;
          if (O == null || O == l)
            return k.name;
        }
        return c;
      }
      function Aa(l) {
        var c = Jt.call(z, "placeholder") ? z : l;
        return c.placeholder;
      }
      function pt() {
        var l = z.iteratee || af;
        return l = l === af ? Jg : l, arguments.length ? l(arguments[0], arguments[1]) : l;
      }
      function vu(l, c) {
        var p = l.__data__;
        return KT(c) ? p[typeof c == "string" ? "string" : "hash"] : p.map;
      }
      function Hd(l) {
        for (var c = Ur(l), p = c.length; p--; ) {
          var M = c[p], k = l[M];
          c[p] = [M, k, Om(k)];
        }
        return c;
      }
      function Wo(l, c) {
        var p = eS(l, c);
        return Xg(p) ? p : r;
      }
      function WT(l) {
        var c = Jt.call(l, jo), p = l[jo];
        try {
          l[jo] = r;
          var M = !0;
        } catch {
        }
        var k = qs.call(l);
        return M && (c ? l[jo] = p : delete l[jo]), k;
      }
      var Wd = vd ? function(l) {
        return l == null ? [] : (l = or(l), uo(vd(l), function(c) {
          return Pg.call(l, c);
        }));
      } : uf, Nm = vd ? function(l) {
        for (var c = []; l; )
          co(c, Wd(l)), l = Ks(l);
        return c;
      } : uf, rn = ln;
      (bd && rn(new bd(new ArrayBuffer(1))) != Ct || yl && rn(new yl()) != Ie || yd && rn(yd.resolve()) != H || Ca && rn(new Ca()) != ae || xl && rn(new xl()) != Le) && (rn = function(l) {
        var c = ln(l), p = c == P ? l.constructor : r, M = p ? Vo(p) : "";
        if (M)
          switch (M) {
            case kS:
              return Ct;
            case DS:
              return Ie;
            case AS:
              return H;
            case ES:
              return ae;
            case IS:
              return Le;
          }
        return c;
      });
      function VT(l, c, p) {
        for (var M = -1, k = p.length; ++M < k; ) {
          var O = p[M], F = O.size;
          switch (O.type) {
            case "drop":
              l += F;
              break;
            case "dropRight":
              c -= F;
              break;
            case "take":
              c = tn(c, l + F);
              break;
            case "takeRight":
              l = Rr(l, c - F);
              break;
          }
        }
        return { start: l, end: c };
      }
      function YT(l) {
        var c = l.match(gr);
        return c ? c[1].split(Or) : [];
      }
      function zm(l, c, p) {
        c = mo(c, l);
        for (var M = -1, k = c.length, O = !1; ++M < k; ) {
          var F = ki(c[M]);
          if (!(O = l != null && p(l, F)))
            break;
          l = l[F];
        }
        return O || ++M != k ? O : (k = l == null ? 0 : l.length, !!k && Su(k) && Hi(F, k) && (Et(l) || Yo(l)));
      }
      function QT(l) {
        var c = l.length, p = new l.constructor(c);
        return c && typeof l[0] == "string" && Jt.call(l, "index") && (p.index = l.index, p.input = l.input), p;
      }
      function $m(l) {
        return typeof l.constructor == "function" && !El(l) ? Ta(Ks(l)) : {};
      }
      function qT(l, c, p) {
        var M = l.constructor;
        switch (c) {
          case Mt:
            return Pd(l);
          case et:
          case Ge:
            return new M(+l);
          case Ct:
            return NT(l, p);
          case er:
          case Vt:
          case jt:
          case at:
          case St:
          case ve:
          case We:
          case ne:
          case Se:
            return gm(l, p);
          case Ie:
            return new M();
          case rt:
          case Me:
            return new M(l);
          case pe:
            return zT(l);
          case ae:
            return new M();
          case fe:
            return $T(l);
        }
      }
      function GT(l, c) {
        var p = c.length;
        if (!p)
          return l;
        var M = p - 1;
        return c[M] = (p > 1 ? "& " : "") + c[M], c = c.join(p > 2 ? ", " : " "), l.replace(lr, `{
/* [wrapped with ` + c + `] */
`);
      }
      function ZT(l) {
        return Et(l) || Yo(l) || !!(Rg && l && l[Rg]);
      }
      function Hi(l, c) {
        var p = typeof l;
        return c = c ?? ue, !!c && (p == "number" || p != "symbol" && ct.test(l)) && l > -1 && l % 1 == 0 && l < c;
      }
      function sn(l, c, p) {
        if (!yr(p))
          return !1;
        var M = typeof c;
        return (M == "number" ? mn(p) && Hi(c, p.length) : M == "string" && c in p) ? oi(p[c], l) : !1;
      }
      function Vd(l, c) {
        if (Et(l))
          return !1;
        var p = typeof l;
        return p == "number" || p == "symbol" || p == "boolean" || l == null || Nn(l) ? !0 : At.test(l) || !Xe.test(l) || c != null && l in or(c);
      }
      function KT(l) {
        var c = typeof l;
        return c == "string" || c == "number" || c == "symbol" || c == "boolean" ? l !== "__proto__" : l === null;
      }
      function Yd(l) {
        var c = mu(l), p = z[c];
        if (typeof p != "function" || !(c in Rt.prototype))
          return !1;
        if (l === p)
          return !0;
        var M = Ud(p);
        return !!M && l === M[0];
      }
      function XT(l) {
        return !!Og && Og in l;
      }
      var JT = Ys ? Wi : cf;
      function El(l) {
        var c = l && l.constructor, p = typeof c == "function" && c.prototype || Ma;
        return l === p;
      }
      function Om(l) {
        return l === l && !yr(l);
      }
      function _m(l, c) {
        return function(p) {
          return p == null ? !1 : p[l] === c && (c !== r || l in or(p));
        };
      }
      function ek(l) {
        var c = Mu(l, function(M) {
          return p.size === d && p.clear(), M;
        }), p = c.cache;
        return c;
      }
      function tk(l, c) {
        var p = l[1], M = c[1], k = p | M, O = k < (x | y | E), F = M == E && p == S || M == E && p == N && l[7].length <= c[8] || M == (E | N) && c[7].length <= c[8] && p == S;
        if (!(O || F))
          return l;
        M & x && (l[2] = c[2], k |= p & x ? 0 : C);
        var V = c[3];
        if (V) {
          var ee = l[3];
          l[3] = ee ? vm(ee, V, c[4]) : V, l[4] = ee ? fo(l[3], f) : c[4];
        }
        return V = c[5], V && (ee = l[5], l[5] = ee ? bm(ee, V, c[6]) : V, l[6] = ee ? fo(l[5], f) : c[6]), V = c[7], V && (l[7] = V), M & E && (l[8] = l[8] == null ? c[8] : tn(l[8], c[8])), l[9] == null && (l[9] = c[9]), l[0] = c[0], l[1] = k, l;
      }
      function rk(l) {
        var c = [];
        if (l != null)
          for (var p in or(l))
            c.push(p);
        return c;
      }
      function nk(l) {
        return qs.call(l);
      }
      function Lm(l, c, p) {
        return c = Rr(c === r ? l.length - 1 : c, 0), function() {
          for (var M = arguments, k = -1, O = Rr(M.length - c, 0), F = le(O); ++k < O; )
            F[k] = M[c + k];
          k = -1;
          for (var V = le(c + 1); ++k < c; )
            V[k] = M[k];
          return V[c] = p(F), An(l, this, V);
        };
      }
      function Pm(l, c) {
        return c.length < 2 ? l : Ho(l, Yn(c, 0, -1));
      }
      function ik(l, c) {
        for (var p = l.length, M = tn(c.length, p), k = gn(l); M--; ) {
          var O = c[M];
          l[M] = Hi(O, p) ? k[O] : r;
        }
        return l;
      }
      function Qd(l, c) {
        if (!(c === "constructor" && typeof l[c] == "function") && c != "__proto__")
          return l[c];
      }
      var Rm = Fm(lm), Il = yS || function(l, c) {
        return Vr.setTimeout(l, c);
      }, qd = Fm(DT);
      function jm(l, c, p) {
        var M = c + "";
        return qd(l, GT(M, ok(YT(M), p)));
      }
      function Fm(l) {
        var c = 0, p = 0;
        return function() {
          var M = CS(), k = U - (M - p);
          if (p = M, k > 0) {
            if (++c >= R)
              return arguments[0];
          } else
            c = 0;
          return l.apply(r, arguments);
        };
      }
      function bu(l, c) {
        var p = -1, M = l.length, k = M - 1;
        for (c = c === r ? M : c; ++p < c; ) {
          var O = Id(p, k), F = l[O];
          l[O] = l[p], l[p] = F;
        }
        return l.length = c, l;
      }
      var Bm = ek(function(l) {
        var c = [];
        return l.charCodeAt(0) === 46 && c.push(""), l.replace(Ht, function(p, M, k, O) {
          c.push(k ? O.replace(wi, "$1") : M || p);
        }), c;
      });
      function ki(l) {
        if (typeof l == "string" || Nn(l))
          return l;
        var c = l + "";
        return c == "0" && 1 / l == -re ? "-0" : c;
      }
      function Vo(l) {
        if (l != null) {
          try {
            return Qs.call(l);
          } catch {
          }
          try {
            return l + "";
          } catch {
          }
        }
        return "";
      }
      function ok(l, c) {
        return Un(Qe, function(p) {
          var M = "_." + p[0];
          c & p[1] && !Us(l, M) && l.push(M);
        }), l.sort();
      }
      function Um(l) {
        if (l instanceof Rt)
          return l.clone();
        var c = new Wn(l.__wrapped__, l.__chain__);
        return c.__actions__ = gn(l.__actions__), c.__index__ = l.__index__, c.__values__ = l.__values__, c;
      }
      function ak(l, c, p) {
        (p ? sn(l, c, p) : c === r) ? c = 1 : c = Rr(It(c), 0);
        var M = l == null ? 0 : l.length;
        if (!M || c < 1)
          return [];
        for (var k = 0, O = 0, F = le(eu(M / c)); k < M; )
          F[O++] = Yn(l, k, k += c);
        return F;
      }
      function lk(l) {
        for (var c = -1, p = l == null ? 0 : l.length, M = 0, k = []; ++c < p; ) {
          var O = l[c];
          O && (k[M++] = O);
        }
        return k;
      }
      function sk() {
        var l = arguments.length;
        if (!l)
          return [];
        for (var c = le(l - 1), p = arguments[0], M = l; M--; )
          c[M - 1] = arguments[M];
        return co(Et(p) ? gn(p) : [p], Yr(c, 1));
      }
      var uk = _t(function(l, c) {
        return Ir(l) ? Sl(l, Yr(c, 1, Ir, !0)) : [];
      }), ck = _t(function(l, c) {
        var p = Qn(c);
        return Ir(p) && (p = r), Ir(l) ? Sl(l, Yr(c, 1, Ir, !0), pt(p, 2)) : [];
      }), dk = _t(function(l, c) {
        var p = Qn(c);
        return Ir(p) && (p = r), Ir(l) ? Sl(l, Yr(c, 1, Ir, !0), r, p) : [];
      });
      function fk(l, c, p) {
        var M = l == null ? 0 : l.length;
        return M ? (c = p || c === r ? 1 : It(c), Yn(l, c < 0 ? 0 : c, M)) : [];
      }
      function hk(l, c, p) {
        var M = l == null ? 0 : l.length;
        return M ? (c = p || c === r ? 1 : It(c), c = M - c, Yn(l, 0, c < 0 ? 0 : c)) : [];
      }
      function pk(l, c) {
        return l && l.length ? cu(l, pt(c, 3), !0, !0) : [];
      }
      function gk(l, c) {
        return l && l.length ? cu(l, pt(c, 3), !0) : [];
      }
      function mk(l, c, p, M) {
        var k = l == null ? 0 : l.length;
        return k ? (p && typeof p != "number" && sn(l, c, p) && (p = 0, M = k), sT(l, c, p, M)) : [];
      }
      function Hm(l, c, p) {
        var M = l == null ? 0 : l.length;
        if (!M)
          return -1;
        var k = p == null ? 0 : It(p);
        return k < 0 && (k = Rr(M + k, 0)), Hs(l, pt(c, 3), k);
      }
      function Wm(l, c, p) {
        var M = l == null ? 0 : l.length;
        if (!M)
          return -1;
        var k = M - 1;
        return p !== r && (k = It(p), k = p < 0 ? Rr(M + k, 0) : tn(k, M - 1)), Hs(l, pt(c, 3), k, !0);
      }
      function Vm(l) {
        var c = l == null ? 0 : l.length;
        return c ? Yr(l, 1) : [];
      }
      function vk(l) {
        var c = l == null ? 0 : l.length;
        return c ? Yr(l, re) : [];
      }
      function bk(l, c) {
        var p = l == null ? 0 : l.length;
        return p ? (c = c === r ? 1 : It(c), Yr(l, c)) : [];
      }
      function yk(l) {
        for (var c = -1, p = l == null ? 0 : l.length, M = {}; ++c < p; ) {
          var k = l[c];
          M[k[0]] = k[1];
        }
        return M;
      }
      function Ym(l) {
        return l && l.length ? l[0] : r;
      }
      function xk(l, c, p) {
        var M = l == null ? 0 : l.length;
        if (!M)
          return -1;
        var k = p == null ? 0 : It(p);
        return k < 0 && (k = Rr(M + k, 0)), ba(l, c, k);
      }
      function wk(l) {
        var c = l == null ? 0 : l.length;
        return c ? Yn(l, 0, -1) : [];
      }
      var Mk = _t(function(l) {
        var c = mr(l, _d);
        return c.length && c[0] === l[0] ? Td(c) : [];
      }), Ck = _t(function(l) {
        var c = Qn(l), p = mr(l, _d);
        return c === Qn(p) ? c = r : p.pop(), p.length && p[0] === l[0] ? Td(p, pt(c, 2)) : [];
      }), Sk = _t(function(l) {
        var c = Qn(l), p = mr(l, _d);
        return c = typeof c == "function" ? c : r, c && p.pop(), p.length && p[0] === l[0] ? Td(p, r, c) : [];
      });
      function Tk(l, c) {
        return l == null ? "" : wS.call(l, c);
      }
      function Qn(l) {
        var c = l == null ? 0 : l.length;
        return c ? l[c - 1] : r;
      }
      function kk(l, c, p) {
        var M = l == null ? 0 : l.length;
        if (!M)
          return -1;
        var k = M;
        return p !== r && (k = It(p), k = k < 0 ? Rr(M + k, 0) : tn(k, M - 1)), c === c ? oS(l, c, k) : Hs(l, kg, k, !0);
      }
      function Dk(l, c) {
        return l && l.length ? nm(l, It(c)) : r;
      }
      var Ak = _t(Qm);
      function Qm(l, c) {
        return l && l.length && c && c.length ? Ed(l, c) : l;
      }
      function Ek(l, c, p) {
        return l && l.length && c && c.length ? Ed(l, c, pt(p, 2)) : l;
      }
      function Ik(l, c, p) {
        return l && l.length && c && c.length ? Ed(l, c, r, p) : l;
      }
      var Nk = Ui(function(l, c) {
        var p = l == null ? 0 : l.length, M = wd(l, c);
        return am(l, mr(c, function(k) {
          return Hi(k, p) ? +k : k;
        }).sort(mm)), M;
      });
      function zk(l, c) {
        var p = [];
        if (!(l && l.length))
          return p;
        var M = -1, k = [], O = l.length;
        for (c = pt(c, 3); ++M < O; ) {
          var F = l[M];
          c(F, M, l) && (p.push(F), k.push(M));
        }
        return am(l, k), p;
      }
      function Gd(l) {
        return l == null ? l : TS.call(l);
      }
      function $k(l, c, p) {
        var M = l == null ? 0 : l.length;
        return M ? (p && typeof p != "number" && sn(l, c, p) ? (c = 0, p = M) : (c = c == null ? 0 : It(c), p = p === r ? M : It(p)), Yn(l, c, p)) : [];
      }
      function Ok(l, c) {
        return uu(l, c);
      }
      function _k(l, c, p) {
        return zd(l, c, pt(p, 2));
      }
      function Lk(l, c) {
        var p = l == null ? 0 : l.length;
        if (p) {
          var M = uu(l, c);
          if (M < p && oi(l[M], c))
            return M;
        }
        return -1;
      }
      function Pk(l, c) {
        return uu(l, c, !0);
      }
      function Rk(l, c, p) {
        return zd(l, c, pt(p, 2), !0);
      }
      function jk(l, c) {
        var p = l == null ? 0 : l.length;
        if (p) {
          var M = uu(l, c, !0) - 1;
          if (oi(l[M], c))
            return M;
        }
        return -1;
      }
      function Fk(l) {
        return l && l.length ? sm(l) : [];
      }
      function Bk(l, c) {
        return l && l.length ? sm(l, pt(c, 2)) : [];
      }
      function Uk(l) {
        var c = l == null ? 0 : l.length;
        return c ? Yn(l, 1, c) : [];
      }
      function Hk(l, c, p) {
        return l && l.length ? (c = p || c === r ? 1 : It(c), Yn(l, 0, c < 0 ? 0 : c)) : [];
      }
      function Wk(l, c, p) {
        var M = l == null ? 0 : l.length;
        return M ? (c = p || c === r ? 1 : It(c), c = M - c, Yn(l, c < 0 ? 0 : c, M)) : [];
      }
      function Vk(l, c) {
        return l && l.length ? cu(l, pt(c, 3), !1, !0) : [];
      }
      function Yk(l, c) {
        return l && l.length ? cu(l, pt(c, 3)) : [];
      }
      var Qk = _t(function(l) {
        return go(Yr(l, 1, Ir, !0));
      }), qk = _t(function(l) {
        var c = Qn(l);
        return Ir(c) && (c = r), go(Yr(l, 1, Ir, !0), pt(c, 2));
      }), Gk = _t(function(l) {
        var c = Qn(l);
        return c = typeof c == "function" ? c : r, go(Yr(l, 1, Ir, !0), r, c);
      });
      function Zk(l) {
        return l && l.length ? go(l) : [];
      }
      function Kk(l, c) {
        return l && l.length ? go(l, pt(c, 2)) : [];
      }
      function Xk(l, c) {
        return c = typeof c == "function" ? c : r, l && l.length ? go(l, r, c) : [];
      }
      function Zd(l) {
        if (!(l && l.length))
          return [];
        var c = 0;
        return l = uo(l, function(p) {
          if (Ir(p))
            return c = Rr(p.length, c), !0;
        }), hd(c, function(p) {
          return mr(l, cd(p));
        });
      }
      function qm(l, c) {
        if (!(l && l.length))
          return [];
        var p = Zd(l);
        return c == null ? p : mr(p, function(M) {
          return An(c, r, M);
        });
      }
      var Jk = _t(function(l, c) {
        return Ir(l) ? Sl(l, c) : [];
      }), eD = _t(function(l) {
        return Od(uo(l, Ir));
      }), tD = _t(function(l) {
        var c = Qn(l);
        return Ir(c) && (c = r), Od(uo(l, Ir), pt(c, 2));
      }), rD = _t(function(l) {
        var c = Qn(l);
        return c = typeof c == "function" ? c : r, Od(uo(l, Ir), r, c);
      }), nD = _t(Zd);
      function iD(l, c) {
        return fm(l || [], c || [], Cl);
      }
      function oD(l, c) {
        return fm(l || [], c || [], Dl);
      }
      var aD = _t(function(l) {
        var c = l.length, p = c > 1 ? l[c - 1] : r;
        return p = typeof p == "function" ? (l.pop(), p) : r, qm(l, p);
      });
      function Gm(l) {
        var c = z(l);
        return c.__chain__ = !0, c;
      }
      function lD(l, c) {
        return c(l), l;
      }
      function yu(l, c) {
        return c(l);
      }
      var sD = Ui(function(l) {
        var c = l.length, p = c ? l[0] : 0, M = this.__wrapped__, k = function(O) {
          return wd(O, l);
        };
        return c > 1 || this.__actions__.length || !(M instanceof Rt) || !Hi(p) ? this.thru(k) : (M = M.slice(p, +p + (c ? 1 : 0)), M.__actions__.push({
          func: yu,
          args: [k],
          thisArg: r
        }), new Wn(M, this.__chain__).thru(function(O) {
          return c && !O.length && O.push(r), O;
        }));
      });
      function uD() {
        return Gm(this);
      }
      function cD() {
        return new Wn(this.value(), this.__chain__);
      }
      function dD() {
        this.__values__ === r && (this.__values__ = uv(this.value()));
        var l = this.__index__ >= this.__values__.length, c = l ? r : this.__values__[this.__index__++];
        return { done: l, value: c };
      }
      function fD() {
        return this;
      }
      function hD(l) {
        for (var c, p = this; p instanceof iu; ) {
          var M = Um(p);
          M.__index__ = 0, M.__values__ = r, c ? k.__wrapped__ = M : c = M;
          var k = M;
          p = p.__wrapped__;
        }
        return k.__wrapped__ = l, c;
      }
      function pD() {
        var l = this.__wrapped__;
        if (l instanceof Rt) {
          var c = l;
          return this.__actions__.length && (c = new Rt(this)), c = c.reverse(), c.__actions__.push({
            func: yu,
            args: [Gd],
            thisArg: r
          }), new Wn(c, this.__chain__);
        }
        return this.thru(Gd);
      }
      function gD() {
        return dm(this.__wrapped__, this.__actions__);
      }
      var mD = du(function(l, c, p) {
        Jt.call(l, p) ? ++l[p] : Fi(l, p, 1);
      });
      function vD(l, c, p) {
        var M = Et(l) ? Sg : lT;
        return p && sn(l, c, p) && (c = r), M(l, pt(c, 3));
      }
      function bD(l, c) {
        var p = Et(l) ? uo : qg;
        return p(l, pt(c, 3));
      }
      var yD = Mm(Hm), xD = Mm(Wm);
      function wD(l, c) {
        return Yr(xu(l, c), 1);
      }
      function MD(l, c) {
        return Yr(xu(l, c), re);
      }
      function CD(l, c, p) {
        return p = p === r ? 1 : It(p), Yr(xu(l, c), p);
      }
      function Zm(l, c) {
        var p = Et(l) ? Un : po;
        return p(l, pt(c, 3));
      }
      function Km(l, c) {
        var p = Et(l) ? UC : Qg;
        return p(l, pt(c, 3));
      }
      var SD = du(function(l, c, p) {
        Jt.call(l, p) ? l[p].push(c) : Fi(l, p, [c]);
      });
      function TD(l, c, p, M) {
        l = mn(l) ? l : Ia(l), p = p && !M ? It(p) : 0;
        var k = l.length;
        return p < 0 && (p = Rr(k + p, 0)), Tu(l) ? p <= k && l.indexOf(c, p) > -1 : !!k && ba(l, c, p) > -1;
      }
      var kD = _t(function(l, c, p) {
        var M = -1, k = typeof c == "function", O = mn(l) ? le(l.length) : [];
        return po(l, function(F) {
          O[++M] = k ? An(c, F, p) : Tl(F, c, p);
        }), O;
      }), DD = du(function(l, c, p) {
        Fi(l, p, c);
      });
      function xu(l, c) {
        var p = Et(l) ? mr : em;
        return p(l, pt(c, 3));
      }
      function AD(l, c, p, M) {
        return l == null ? [] : (Et(c) || (c = c == null ? [] : [c]), p = M ? r : p, Et(p) || (p = p == null ? [] : [p]), im(l, c, p));
      }
      var ED = du(function(l, c, p) {
        l[p ? 0 : 1].push(c);
      }, function() {
        return [[], []];
      });
      function ID(l, c, p) {
        var M = Et(l) ? sd : Ag, k = arguments.length < 3;
        return M(l, pt(c, 4), p, k, po);
      }
      function ND(l, c, p) {
        var M = Et(l) ? HC : Ag, k = arguments.length < 3;
        return M(l, pt(c, 4), p, k, Qg);
      }
      function zD(l, c) {
        var p = Et(l) ? uo : qg;
        return p(l, Cu(pt(c, 3)));
      }
      function $D(l) {
        var c = Et(l) ? Hg : TT;
        return c(l);
      }
      function OD(l, c, p) {
        (p ? sn(l, c, p) : c === r) ? c = 1 : c = It(c);
        var M = Et(l) ? rT : kT;
        return M(l, c);
      }
      function _D(l) {
        var c = Et(l) ? nT : AT;
        return c(l);
      }
      function LD(l) {
        if (l == null)
          return 0;
        if (mn(l))
          return Tu(l) ? xa(l) : l.length;
        var c = rn(l);
        return c == Ie || c == ae ? l.size : Dd(l).length;
      }
      function PD(l, c, p) {
        var M = Et(l) ? ud : ET;
        return p && sn(l, c, p) && (c = r), M(l, pt(c, 3));
      }
      var RD = _t(function(l, c) {
        if (l == null)
          return [];
        var p = c.length;
        return p > 1 && sn(l, c[0], c[1]) ? c = [] : p > 2 && sn(c[0], c[1], c[2]) && (c = [c[0]]), im(l, Yr(c, 1), []);
      }), wu = bS || function() {
        return Vr.Date.now();
      };
      function jD(l, c) {
        if (typeof c != "function")
          throw new Hn(a);
        return l = It(l), function() {
          if (--l < 1)
            return c.apply(this, arguments);
        };
      }
      function Xm(l, c, p) {
        return c = p ? r : c, c = l && c == null ? l.length : c, Bi(l, E, r, r, r, r, c);
      }
      function Jm(l, c) {
        var p;
        if (typeof c != "function")
          throw new Hn(a);
        return l = It(l), function() {
          return --l > 0 && (p = c.apply(this, arguments)), l <= 1 && (c = r), p;
        };
      }
      var Kd = _t(function(l, c, p) {
        var M = x;
        if (p.length) {
          var k = fo(p, Aa(Kd));
          M |= A;
        }
        return Bi(l, M, c, p, k);
      }), ev = _t(function(l, c, p) {
        var M = x | y;
        if (p.length) {
          var k = fo(p, Aa(ev));
          M |= A;
        }
        return Bi(c, M, l, p, k);
      });
      function tv(l, c, p) {
        c = p ? r : c;
        var M = Bi(l, S, r, r, r, r, r, c);
        return M.placeholder = tv.placeholder, M;
      }
      function rv(l, c, p) {
        c = p ? r : c;
        var M = Bi(l, T, r, r, r, r, r, c);
        return M.placeholder = rv.placeholder, M;
      }
      function nv(l, c, p) {
        var M, k, O, F, V, ee, me = 0, be = !1, Ce = !1, He = !0;
        if (typeof l != "function")
          throw new Hn(a);
        c = qn(c) || 0, yr(p) && (be = !!p.leading, Ce = "maxWait" in p, O = Ce ? Rr(qn(p.maxWait) || 0, c) : O, He = "trailing" in p ? !!p.trailing : He);
        function it(Nr) {
          var ai = M, Yi = k;
          return M = k = r, me = Nr, F = l.apply(Yi, ai), F;
        }
        function gt(Nr) {
          return me = Nr, V = Il(Pt, c), be ? it(Nr) : F;
        }
        function $t(Nr) {
          var ai = Nr - ee, Yi = Nr - me, Mv = c - ai;
          return Ce ? tn(Mv, O - Yi) : Mv;
        }
        function mt(Nr) {
          var ai = Nr - ee, Yi = Nr - me;
          return ee === r || ai >= c || ai < 0 || Ce && Yi >= O;
        }
        function Pt() {
          var Nr = wu();
          if (mt(Nr))
            return Ft(Nr);
          V = Il(Pt, $t(Nr));
        }
        function Ft(Nr) {
          return V = r, He && M ? it(Nr) : (M = k = r, F);
        }
        function zn() {
          V !== r && hm(V), me = 0, M = ee = k = V = r;
        }
        function un() {
          return V === r ? F : Ft(wu());
        }
        function $n() {
          var Nr = wu(), ai = mt(Nr);
          if (M = arguments, k = this, ee = Nr, ai) {
            if (V === r)
              return gt(ee);
            if (Ce)
              return hm(V), V = Il(Pt, c), it(ee);
          }
          return V === r && (V = Il(Pt, c)), F;
        }
        return $n.cancel = zn, $n.flush = un, $n;
      }
      var FD = _t(function(l, c) {
        return Yg(l, 1, c);
      }), BD = _t(function(l, c, p) {
        return Yg(l, qn(c) || 0, p);
      });
      function UD(l) {
        return Bi(l, I);
      }
      function Mu(l, c) {
        if (typeof l != "function" || c != null && typeof c != "function")
          throw new Hn(a);
        var p = function() {
          var M = arguments, k = c ? c.apply(this, M) : M[0], O = p.cache;
          if (O.has(k))
            return O.get(k);
          var F = l.apply(this, M);
          return p.cache = O.set(k, F) || O, F;
        };
        return p.cache = new (Mu.Cache || ji)(), p;
      }
      Mu.Cache = ji;
      function Cu(l) {
        if (typeof l != "function")
          throw new Hn(a);
        return function() {
          var c = arguments;
          switch (c.length) {
            case 0:
              return !l.call(this);
            case 1:
              return !l.call(this, c[0]);
            case 2:
              return !l.call(this, c[0], c[1]);
            case 3:
              return !l.call(this, c[0], c[1], c[2]);
          }
          return !l.apply(this, c);
        };
      }
      function HD(l) {
        return Jm(2, l);
      }
      var WD = IT(function(l, c) {
        c = c.length == 1 && Et(c[0]) ? mr(c[0], En(pt())) : mr(Yr(c, 1), En(pt()));
        var p = c.length;
        return _t(function(M) {
          for (var k = -1, O = tn(M.length, p); ++k < O; )
            M[k] = c[k].call(this, M[k]);
          return An(l, this, M);
        });
      }), Xd = _t(function(l, c) {
        var p = fo(c, Aa(Xd));
        return Bi(l, A, r, c, p);
      }), iv = _t(function(l, c) {
        var p = fo(c, Aa(iv));
        return Bi(l, D, r, c, p);
      }), VD = Ui(function(l, c) {
        return Bi(l, N, r, r, r, c);
      });
      function YD(l, c) {
        if (typeof l != "function")
          throw new Hn(a);
        return c = c === r ? c : It(c), _t(l, c);
      }
      function QD(l, c) {
        if (typeof l != "function")
          throw new Hn(a);
        return c = c == null ? 0 : Rr(It(c), 0), _t(function(p) {
          var M = p[c], k = vo(p, 0, c);
          return M && co(k, M), An(l, this, k);
        });
      }
      function qD(l, c, p) {
        var M = !0, k = !0;
        if (typeof l != "function")
          throw new Hn(a);
        return yr(p) && (M = "leading" in p ? !!p.leading : M, k = "trailing" in p ? !!p.trailing : k), nv(l, c, {
          leading: M,
          maxWait: c,
          trailing: k
        });
      }
      function GD(l) {
        return Xm(l, 1);
      }
      function ZD(l, c) {
        return Xd(Ld(c), l);
      }
      function KD() {
        if (!arguments.length)
          return [];
        var l = arguments[0];
        return Et(l) ? l : [l];
      }
      function XD(l) {
        return Vn(l, m);
      }
      function JD(l, c) {
        return c = typeof c == "function" ? c : r, Vn(l, m, c);
      }
      function eA(l) {
        return Vn(l, h | m);
      }
      function tA(l, c) {
        return c = typeof c == "function" ? c : r, Vn(l, h | m, c);
      }
      function rA(l, c) {
        return c == null || Vg(l, c, Ur(c));
      }
      function oi(l, c) {
        return l === c || l !== l && c !== c;
      }
      var nA = gu(Sd), iA = gu(function(l, c) {
        return l >= c;
      }), Yo = Kg(function() {
        return arguments;
      }()) ? Kg : function(l) {
        return Dr(l) && Jt.call(l, "callee") && !Pg.call(l, "callee");
      }, Et = le.isArray, oA = bg ? En(bg) : hT;
      function mn(l) {
        return l != null && Su(l.length) && !Wi(l);
      }
      function Ir(l) {
        return Dr(l) && mn(l);
      }
      function aA(l) {
        return l === !0 || l === !1 || Dr(l) && ln(l) == et;
      }
      var bo = xS || cf, lA = yg ? En(yg) : pT;
      function sA(l) {
        return Dr(l) && l.nodeType === 1 && !Nl(l);
      }
      function uA(l) {
        if (l == null)
          return !0;
        if (mn(l) && (Et(l) || typeof l == "string" || typeof l.splice == "function" || bo(l) || Ea(l) || Yo(l)))
          return !l.length;
        var c = rn(l);
        if (c == Ie || c == ae)
          return !l.size;
        if (El(l))
          return !Dd(l).length;
        for (var p in l)
          if (Jt.call(l, p))
            return !1;
        return !0;
      }
      function cA(l, c) {
        return kl(l, c);
      }
      function dA(l, c, p) {
        p = typeof p == "function" ? p : r;
        var M = p ? p(l, c) : r;
        return M === r ? kl(l, c, r, p) : !!M;
      }
      function Jd(l) {
        if (!Dr(l))
          return !1;
        var c = ln(l);
        return c == qe || c == Ee || typeof l.message == "string" && typeof l.name == "string" && !Nl(l);
      }
      function fA(l) {
        return typeof l == "number" && jg(l);
      }
      function Wi(l) {
        if (!yr(l))
          return !1;
        var c = ln(l);
        return c == Ue || c == ot || c == $e || c == se;
      }
      function ov(l) {
        return typeof l == "number" && l == It(l);
      }
      function Su(l) {
        return typeof l == "number" && l > -1 && l % 1 == 0 && l <= ue;
      }
      function yr(l) {
        var c = typeof l;
        return l != null && (c == "object" || c == "function");
      }
      function Dr(l) {
        return l != null && typeof l == "object";
      }
      var av = xg ? En(xg) : mT;
      function hA(l, c) {
        return l === c || kd(l, c, Hd(c));
      }
      function pA(l, c, p) {
        return p = typeof p == "function" ? p : r, kd(l, c, Hd(c), p);
      }
      function gA(l) {
        return lv(l) && l != +l;
      }
      function mA(l) {
        if (JT(l))
          throw new kt(o);
        return Xg(l);
      }
      function vA(l) {
        return l === null;
      }
      function bA(l) {
        return l == null;
      }
      function lv(l) {
        return typeof l == "number" || Dr(l) && ln(l) == rt;
      }
      function Nl(l) {
        if (!Dr(l) || ln(l) != P)
          return !1;
        var c = Ks(l);
        if (c === null)
          return !0;
        var p = Jt.call(c, "constructor") && c.constructor;
        return typeof p == "function" && p instanceof p && Qs.call(p) == pS;
      }
      var ef = wg ? En(wg) : vT;
      function yA(l) {
        return ov(l) && l >= -ue && l <= ue;
      }
      var sv = Mg ? En(Mg) : bT;
      function Tu(l) {
        return typeof l == "string" || !Et(l) && Dr(l) && ln(l) == Me;
      }
      function Nn(l) {
        return typeof l == "symbol" || Dr(l) && ln(l) == fe;
      }
      var Ea = Cg ? En(Cg) : yT;
      function xA(l) {
        return l === r;
      }
      function wA(l) {
        return Dr(l) && rn(l) == Le;
      }
      function MA(l) {
        return Dr(l) && ln(l) == dt;
      }
      var CA = gu(Ad), SA = gu(function(l, c) {
        return l <= c;
      });
      function uv(l) {
        if (!l)
          return [];
        if (mn(l))
          return Tu(l) ? ni(l) : gn(l);
        if (bl && l[bl])
          return rS(l[bl]());
        var c = rn(l), p = c == Ie ? gd : c == ae ? Ws : Ia;
        return p(l);
      }
      function Vi(l) {
        if (!l)
          return l === 0 ? l : 0;
        if (l = qn(l), l === re || l === -re) {
          var c = l < 0 ? -1 : 1;
          return c * he;
        }
        return l === l ? l : 0;
      }
      function It(l) {
        var c = Vi(l), p = c % 1;
        return c === c ? p ? c - p : c : 0;
      }
      function cv(l) {
        return l ? Uo(It(l), 0, de) : 0;
      }
      function qn(l) {
        if (typeof l == "number")
          return l;
        if (Nn(l))
          return te;
        if (yr(l)) {
          var c = typeof l.valueOf == "function" ? l.valueOf() : l;
          l = yr(c) ? c + "" : c;
        }
        if (typeof l != "string")
          return l === 0 ? l : +l;
        l = Eg(l);
        var p = wt.test(l);
        return p || Wr.test(l) ? jC(l.slice(2), p ? 2 : 8) : ze.test(l) ? te : +l;
      }
      function dv(l) {
        return Ti(l, vn(l));
      }
      function TA(l) {
        return l ? Uo(It(l), -ue, ue) : l === 0 ? l : 0;
      }
      function Zt(l) {
        return l == null ? "" : In(l);
      }
      var kA = ka(function(l, c) {
        if (El(c) || mn(c)) {
          Ti(c, Ur(c), l);
          return;
        }
        for (var p in c)
          Jt.call(c, p) && Cl(l, p, c[p]);
      }), fv = ka(function(l, c) {
        Ti(c, vn(c), l);
      }), ku = ka(function(l, c, p, M) {
        Ti(c, vn(c), l, M);
      }), DA = ka(function(l, c, p, M) {
        Ti(c, Ur(c), l, M);
      }), AA = Ui(wd);
      function EA(l, c) {
        var p = Ta(l);
        return c == null ? p : Wg(p, c);
      }
      var IA = _t(function(l, c) {
        l = or(l);
        var p = -1, M = c.length, k = M > 2 ? c[2] : r;
        for (k && sn(c[0], c[1], k) && (M = 1); ++p < M; )
          for (var O = c[p], F = vn(O), V = -1, ee = F.length; ++V < ee; ) {
            var me = F[V], be = l[me];
            (be === r || oi(be, Ma[me]) && !Jt.call(l, me)) && (l[me] = O[me]);
          }
        return l;
      }), NA = _t(function(l) {
        return l.push(r, Em), An(hv, r, l);
      });
      function zA(l, c) {
        return Tg(l, pt(c, 3), Si);
      }
      function $A(l, c) {
        return Tg(l, pt(c, 3), Cd);
      }
      function OA(l, c) {
        return l == null ? l : Md(l, pt(c, 3), vn);
      }
      function _A(l, c) {
        return l == null ? l : Gg(l, pt(c, 3), vn);
      }
      function LA(l, c) {
        return l && Si(l, pt(c, 3));
      }
      function PA(l, c) {
        return l && Cd(l, pt(c, 3));
      }
      function RA(l) {
        return l == null ? [] : lu(l, Ur(l));
      }
      function jA(l) {
        return l == null ? [] : lu(l, vn(l));
      }
      function tf(l, c, p) {
        var M = l == null ? r : Ho(l, c);
        return M === r ? p : M;
      }
      function FA(l, c) {
        return l != null && zm(l, c, uT);
      }
      function rf(l, c) {
        return l != null && zm(l, c, cT);
      }
      var BA = Sm(function(l, c, p) {
        c != null && typeof c.toString != "function" && (c = qs.call(c)), l[c] = p;
      }, of(bn)), UA = Sm(function(l, c, p) {
        c != null && typeof c.toString != "function" && (c = qs.call(c)), Jt.call(l, c) ? l[c].push(p) : l[c] = [p];
      }, pt), HA = _t(Tl);
      function Ur(l) {
        return mn(l) ? Ug(l) : Dd(l);
      }
      function vn(l) {
        return mn(l) ? Ug(l, !0) : xT(l);
      }
      function WA(l, c) {
        var p = {};
        return c = pt(c, 3), Si(l, function(M, k, O) {
          Fi(p, c(M, k, O), M);
        }), p;
      }
      function VA(l, c) {
        var p = {};
        return c = pt(c, 3), Si(l, function(M, k, O) {
          Fi(p, k, c(M, k, O));
        }), p;
      }
      var YA = ka(function(l, c, p) {
        su(l, c, p);
      }), hv = ka(function(l, c, p, M) {
        su(l, c, p, M);
      }), QA = Ui(function(l, c) {
        var p = {};
        if (l == null)
          return p;
        var M = !1;
        c = mr(c, function(O) {
          return O = mo(O, l), M || (M = O.length > 1), O;
        }), Ti(l, Bd(l), p), M && (p = Vn(p, h | g | m, BT));
        for (var k = c.length; k--; )
          $d(p, c[k]);
        return p;
      });
      function qA(l, c) {
        return pv(l, Cu(pt(c)));
      }
      var GA = Ui(function(l, c) {
        return l == null ? {} : MT(l, c);
      });
      function pv(l, c) {
        if (l == null)
          return {};
        var p = mr(Bd(l), function(M) {
          return [M];
        });
        return c = pt(c), om(l, p, function(M, k) {
          return c(M, k[0]);
        });
      }
      function ZA(l, c, p) {
        c = mo(c, l);
        var M = -1, k = c.length;
        for (k || (k = 1, l = r); ++M < k; ) {
          var O = l == null ? r : l[ki(c[M])];
          O === r && (M = k, O = p), l = Wi(O) ? O.call(l) : O;
        }
        return l;
      }
      function KA(l, c, p) {
        return l == null ? l : Dl(l, c, p);
      }
      function XA(l, c, p, M) {
        return M = typeof M == "function" ? M : r, l == null ? l : Dl(l, c, p, M);
      }
      var gv = Dm(Ur), mv = Dm(vn);
      function JA(l, c, p) {
        var M = Et(l), k = M || bo(l) || Ea(l);
        if (c = pt(c, 4), p == null) {
          var O = l && l.constructor;
          k ? p = M ? new O() : [] : yr(l) ? p = Wi(O) ? Ta(Ks(l)) : {} : p = {};
        }
        return (k ? Un : Si)(l, function(F, V, ee) {
          return c(p, F, V, ee);
        }), p;
      }
      function eE(l, c) {
        return l == null ? !0 : $d(l, c);
      }
      function tE(l, c, p) {
        return l == null ? l : cm(l, c, Ld(p));
      }
      function rE(l, c, p, M) {
        return M = typeof M == "function" ? M : r, l == null ? l : cm(l, c, Ld(p), M);
      }
      function Ia(l) {
        return l == null ? [] : pd(l, Ur(l));
      }
      function nE(l) {
        return l == null ? [] : pd(l, vn(l));
      }
      function iE(l, c, p) {
        return p === r && (p = c, c = r), p !== r && (p = qn(p), p = p === p ? p : 0), c !== r && (c = qn(c), c = c === c ? c : 0), Uo(qn(l), c, p);
      }
      function oE(l, c, p) {
        return c = Vi(c), p === r ? (p = c, c = 0) : p = Vi(p), l = qn(l), dT(l, c, p);
      }
      function aE(l, c, p) {
        if (p && typeof p != "boolean" && sn(l, c, p) && (c = p = r), p === r && (typeof c == "boolean" ? (p = c, c = r) : typeof l == "boolean" && (p = l, l = r)), l === r && c === r ? (l = 0, c = 1) : (l = Vi(l), c === r ? (c = l, l = 0) : c = Vi(c)), l > c) {
          var M = l;
          l = c, c = M;
        }
        if (p || l % 1 || c % 1) {
          var k = Fg();
          return tn(l + k * (c - l + RC("1e-" + ((k + "").length - 1))), c);
        }
        return Id(l, c);
      }
      var lE = Da(function(l, c, p) {
        return c = c.toLowerCase(), l + (p ? vv(c) : c);
      });
      function vv(l) {
        return nf(Zt(l).toLowerCase());
      }
      function bv(l) {
        return l = Zt(l), l && l.replace(en, KC).replace(AC, "");
      }
      function sE(l, c, p) {
        l = Zt(l), c = In(c);
        var M = l.length;
        p = p === r ? M : Uo(It(p), 0, M);
        var k = p;
        return p -= c.length, p >= 0 && l.slice(p, k) == c;
      }
      function uE(l) {
        return l = Zt(l), l && Nt.test(l) ? l.replace(Ze, XC) : l;
      }
      function cE(l) {
        return l = Zt(l), l && ge.test(l) ? l.replace(zt, "\\$&") : l;
      }
      var dE = Da(function(l, c, p) {
        return l + (p ? "-" : "") + c.toLowerCase();
      }), fE = Da(function(l, c, p) {
        return l + (p ? " " : "") + c.toLowerCase();
      }), hE = wm("toLowerCase");
      function pE(l, c, p) {
        l = Zt(l), c = It(c);
        var M = c ? xa(l) : 0;
        if (!c || M >= c)
          return l;
        var k = (c - M) / 2;
        return pu(tu(k), p) + l + pu(eu(k), p);
      }
      function gE(l, c, p) {
        l = Zt(l), c = It(c);
        var M = c ? xa(l) : 0;
        return c && M < c ? l + pu(c - M, p) : l;
      }
      function mE(l, c, p) {
        l = Zt(l), c = It(c);
        var M = c ? xa(l) : 0;
        return c && M < c ? pu(c - M, p) + l : l;
      }
      function vE(l, c, p) {
        return p || c == null ? c = 0 : c && (c = +c), SS(Zt(l).replace(Fe, ""), c || 0);
      }
      function bE(l, c, p) {
        return (p ? sn(l, c, p) : c === r) ? c = 1 : c = It(c), Nd(Zt(l), c);
      }
      function yE() {
        var l = arguments, c = Zt(l[0]);
        return l.length < 3 ? c : c.replace(l[1], l[2]);
      }
      var xE = Da(function(l, c, p) {
        return l + (p ? "_" : "") + c.toLowerCase();
      });
      function wE(l, c, p) {
        return p && typeof p != "number" && sn(l, c, p) && (c = p = r), p = p === r ? de : p >>> 0, p ? (l = Zt(l), l && (typeof c == "string" || c != null && !ef(c)) && (c = In(c), !c && ya(l)) ? vo(ni(l), 0, p) : l.split(c, p)) : [];
      }
      var ME = Da(function(l, c, p) {
        return l + (p ? " " : "") + nf(c);
      });
      function CE(l, c, p) {
        return l = Zt(l), p = p == null ? 0 : Uo(It(p), 0, l.length), c = In(c), l.slice(p, p + c.length) == c;
      }
      function SE(l, c, p) {
        var M = z.templateSettings;
        p && sn(l, c, p) && (c = r), l = Zt(l), c = ku({}, c, M, Am);
        var k = ku({}, c.imports, M.imports, Am), O = Ur(k), F = pd(k, O), V, ee, me = 0, be = c.interpolate || Ci, Ce = "__p += '", He = md(
          (c.escape || Ci).source + "|" + be.source + "|" + (be === xe ? Pi : Ci).source + "|" + (c.evaluate || Ci).source + "|$",
          "g"
        ), it = "//# sourceURL=" + (Jt.call(c, "sourceURL") ? (c.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++$C + "]") + `
`;
        l.replace(He, function(mt, Pt, Ft, zn, un, $n) {
          return Ft || (Ft = zn), Ce += l.slice(me, $n).replace(na, JC), Pt && (V = !0, Ce += `' +
__e(` + Pt + `) +
'`), un && (ee = !0, Ce += `';
` + un + `;
__p += '`), Ft && (Ce += `' +
((__t = (` + Ft + `)) == null ? '' : __t) +
'`), me = $n + mt.length, mt;
        }), Ce += `';
`;
        var gt = Jt.call(c, "variable") && c.variable;
        if (!gt)
          Ce = `with (obj) {
` + Ce + `
}
`;
        else if (xi.test(gt))
          throw new kt(s);
        Ce = (ee ? Ce.replace(_e, "") : Ce).replace(ut, "$1").replace(ht, "$1;"), Ce = "function(" + (gt || "obj") + `) {
` + (gt ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (V ? ", __e = _.escape" : "") + (ee ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Ce + `return __p
}`;
        var $t = xv(function() {
          return qt(O, it + "return " + Ce).apply(r, F);
        });
        if ($t.source = Ce, Jd($t))
          throw $t;
        return $t;
      }
      function TE(l) {
        return Zt(l).toLowerCase();
      }
      function kE(l) {
        return Zt(l).toUpperCase();
      }
      function DE(l, c, p) {
        if (l = Zt(l), l && (p || c === r))
          return Eg(l);
        if (!l || !(c = In(c)))
          return l;
        var M = ni(l), k = ni(c), O = Ig(M, k), F = Ng(M, k) + 1;
        return vo(M, O, F).join("");
      }
      function AE(l, c, p) {
        if (l = Zt(l), l && (p || c === r))
          return l.slice(0, $g(l) + 1);
        if (!l || !(c = In(c)))
          return l;
        var M = ni(l), k = Ng(M, ni(c)) + 1;
        return vo(M, 0, k).join("");
      }
      function EE(l, c, p) {
        if (l = Zt(l), l && (p || c === r))
          return l.replace(Fe, "");
        if (!l || !(c = In(c)))
          return l;
        var M = ni(l), k = Ig(M, ni(c));
        return vo(M, k).join("");
      }
      function IE(l, c) {
        var p = $, M = _;
        if (yr(c)) {
          var k = "separator" in c ? c.separator : k;
          p = "length" in c ? It(c.length) : p, M = "omission" in c ? In(c.omission) : M;
        }
        l = Zt(l);
        var O = l.length;
        if (ya(l)) {
          var F = ni(l);
          O = F.length;
        }
        if (p >= O)
          return l;
        var V = p - xa(M);
        if (V < 1)
          return M;
        var ee = F ? vo(F, 0, V).join("") : l.slice(0, V);
        if (k === r)
          return ee + M;
        if (F && (V += ee.length - V), ef(k)) {
          if (l.slice(V).search(k)) {
            var me, be = ee;
            for (k.global || (k = md(k.source, Zt(Mi.exec(k)) + "g")), k.lastIndex = 0; me = k.exec(be); )
              var Ce = me.index;
            ee = ee.slice(0, Ce === r ? V : Ce);
          }
        } else if (l.indexOf(In(k), V) != V) {
          var He = ee.lastIndexOf(k);
          He > -1 && (ee = ee.slice(0, He));
        }
        return ee + M;
      }
      function NE(l) {
        return l = Zt(l), l && st.test(l) ? l.replace(ye, aS) : l;
      }
      var zE = Da(function(l, c, p) {
        return l + (p ? " " : "") + c.toUpperCase();
      }), nf = wm("toUpperCase");
      function yv(l, c, p) {
        return l = Zt(l), c = p ? r : c, c === r ? tS(l) ? uS(l) : YC(l) : l.match(c) || [];
      }
      var xv = _t(function(l, c) {
        try {
          return An(l, r, c);
        } catch (p) {
          return Jd(p) ? p : new kt(p);
        }
      }), $E = Ui(function(l, c) {
        return Un(c, function(p) {
          p = ki(p), Fi(l, p, Kd(l[p], l));
        }), l;
      });
      function OE(l) {
        var c = l == null ? 0 : l.length, p = pt();
        return l = c ? mr(l, function(M) {
          if (typeof M[1] != "function")
            throw new Hn(a);
          return [p(M[0]), M[1]];
        }) : [], _t(function(M) {
          for (var k = -1; ++k < c; ) {
            var O = l[k];
            if (An(O[0], this, M))
              return An(O[1], this, M);
          }
        });
      }
      function _E(l) {
        return aT(Vn(l, h));
      }
      function of(l) {
        return function() {
          return l;
        };
      }
      function LE(l, c) {
        return l == null || l !== l ? c : l;
      }
      var PE = Cm(), RE = Cm(!0);
      function bn(l) {
        return l;
      }
      function af(l) {
        return Jg(typeof l == "function" ? l : Vn(l, h));
      }
      function jE(l) {
        return tm(Vn(l, h));
      }
      function FE(l, c) {
        return rm(l, Vn(c, h));
      }
      var BE = _t(function(l, c) {
        return function(p) {
          return Tl(p, l, c);
        };
      }), UE = _t(function(l, c) {
        return function(p) {
          return Tl(l, p, c);
        };
      });
      function lf(l, c, p) {
        var M = Ur(c), k = lu(c, M);
        p == null && !(yr(c) && (k.length || !M.length)) && (p = c, c = l, l = this, k = lu(c, Ur(c)));
        var O = !(yr(p) && "chain" in p) || !!p.chain, F = Wi(l);
        return Un(k, function(V) {
          var ee = c[V];
          l[V] = ee, F && (l.prototype[V] = function() {
            var me = this.__chain__;
            if (O || me) {
              var be = l(this.__wrapped__), Ce = be.__actions__ = gn(this.__actions__);
              return Ce.push({ func: ee, args: arguments, thisArg: l }), be.__chain__ = me, be;
            }
            return ee.apply(l, co([this.value()], arguments));
          });
        }), l;
      }
      function HE() {
        return Vr._ === this && (Vr._ = gS), this;
      }
      function sf() {
      }
      function WE(l) {
        return l = It(l), _t(function(c) {
          return nm(c, l);
        });
      }
      var VE = Rd(mr), YE = Rd(Sg), QE = Rd(ud);
      function wv(l) {
        return Vd(l) ? cd(ki(l)) : CT(l);
      }
      function qE(l) {
        return function(c) {
          return l == null ? r : Ho(l, c);
        };
      }
      var GE = Tm(), ZE = Tm(!0);
      function uf() {
        return [];
      }
      function cf() {
        return !1;
      }
      function KE() {
        return {};
      }
      function XE() {
        return "";
      }
      function JE() {
        return !0;
      }
      function eI(l, c) {
        if (l = It(l), l < 1 || l > ue)
          return [];
        var p = de, M = tn(l, de);
        c = pt(c), l -= de;
        for (var k = hd(M, c); ++p < l; )
          c(p);
        return k;
      }
      function tI(l) {
        return Et(l) ? mr(l, ki) : Nn(l) ? [l] : gn(Bm(Zt(l)));
      }
      function rI(l) {
        var c = ++hS;
        return Zt(l) + c;
      }
      var nI = hu(function(l, c) {
        return l + c;
      }, 0), iI = jd("ceil"), oI = hu(function(l, c) {
        return l / c;
      }, 1), aI = jd("floor");
      function lI(l) {
        return l && l.length ? au(l, bn, Sd) : r;
      }
      function sI(l, c) {
        return l && l.length ? au(l, pt(c, 2), Sd) : r;
      }
      function uI(l) {
        return Dg(l, bn);
      }
      function cI(l, c) {
        return Dg(l, pt(c, 2));
      }
      function dI(l) {
        return l && l.length ? au(l, bn, Ad) : r;
      }
      function fI(l, c) {
        return l && l.length ? au(l, pt(c, 2), Ad) : r;
      }
      var hI = hu(function(l, c) {
        return l * c;
      }, 1), pI = jd("round"), gI = hu(function(l, c) {
        return l - c;
      }, 0);
      function mI(l) {
        return l && l.length ? fd(l, bn) : 0;
      }
      function vI(l, c) {
        return l && l.length ? fd(l, pt(c, 2)) : 0;
      }
      return z.after = jD, z.ary = Xm, z.assign = kA, z.assignIn = fv, z.assignInWith = ku, z.assignWith = DA, z.at = AA, z.before = Jm, z.bind = Kd, z.bindAll = $E, z.bindKey = ev, z.castArray = KD, z.chain = Gm, z.chunk = ak, z.compact = lk, z.concat = sk, z.cond = OE, z.conforms = _E, z.constant = of, z.countBy = mD, z.create = EA, z.curry = tv, z.curryRight = rv, z.debounce = nv, z.defaults = IA, z.defaultsDeep = NA, z.defer = FD, z.delay = BD, z.difference = uk, z.differenceBy = ck, z.differenceWith = dk, z.drop = fk, z.dropRight = hk, z.dropRightWhile = pk, z.dropWhile = gk, z.fill = mk, z.filter = bD, z.flatMap = wD, z.flatMapDeep = MD, z.flatMapDepth = CD, z.flatten = Vm, z.flattenDeep = vk, z.flattenDepth = bk, z.flip = UD, z.flow = PE, z.flowRight = RE, z.fromPairs = yk, z.functions = RA, z.functionsIn = jA, z.groupBy = SD, z.initial = wk, z.intersection = Mk, z.intersectionBy = Ck, z.intersectionWith = Sk, z.invert = BA, z.invertBy = UA, z.invokeMap = kD, z.iteratee = af, z.keyBy = DD, z.keys = Ur, z.keysIn = vn, z.map = xu, z.mapKeys = WA, z.mapValues = VA, z.matches = jE, z.matchesProperty = FE, z.memoize = Mu, z.merge = YA, z.mergeWith = hv, z.method = BE, z.methodOf = UE, z.mixin = lf, z.negate = Cu, z.nthArg = WE, z.omit = QA, z.omitBy = qA, z.once = HD, z.orderBy = AD, z.over = VE, z.overArgs = WD, z.overEvery = YE, z.overSome = QE, z.partial = Xd, z.partialRight = iv, z.partition = ED, z.pick = GA, z.pickBy = pv, z.property = wv, z.propertyOf = qE, z.pull = Ak, z.pullAll = Qm, z.pullAllBy = Ek, z.pullAllWith = Ik, z.pullAt = Nk, z.range = GE, z.rangeRight = ZE, z.rearg = VD, z.reject = zD, z.remove = zk, z.rest = YD, z.reverse = Gd, z.sampleSize = OD, z.set = KA, z.setWith = XA, z.shuffle = _D, z.slice = $k, z.sortBy = RD, z.sortedUniq = Fk, z.sortedUniqBy = Bk, z.split = wE, z.spread = QD, z.tail = Uk, z.take = Hk, z.takeRight = Wk, z.takeRightWhile = Vk, z.takeWhile = Yk, z.tap = lD, z.throttle = qD, z.thru = yu, z.toArray = uv, z.toPairs = gv, z.toPairsIn = mv, z.toPath = tI, z.toPlainObject = dv, z.transform = JA, z.unary = GD, z.union = Qk, z.unionBy = qk, z.unionWith = Gk, z.uniq = Zk, z.uniqBy = Kk, z.uniqWith = Xk, z.unset = eE, z.unzip = Zd, z.unzipWith = qm, z.update = tE, z.updateWith = rE, z.values = Ia, z.valuesIn = nE, z.without = Jk, z.words = yv, z.wrap = ZD, z.xor = eD, z.xorBy = tD, z.xorWith = rD, z.zip = nD, z.zipObject = iD, z.zipObjectDeep = oD, z.zipWith = aD, z.entries = gv, z.entriesIn = mv, z.extend = fv, z.extendWith = ku, lf(z, z), z.add = nI, z.attempt = xv, z.camelCase = lE, z.capitalize = vv, z.ceil = iI, z.clamp = iE, z.clone = XD, z.cloneDeep = eA, z.cloneDeepWith = tA, z.cloneWith = JD, z.conformsTo = rA, z.deburr = bv, z.defaultTo = LE, z.divide = oI, z.endsWith = sE, z.eq = oi, z.escape = uE, z.escapeRegExp = cE, z.every = vD, z.find = yD, z.findIndex = Hm, z.findKey = zA, z.findLast = xD, z.findLastIndex = Wm, z.findLastKey = $A, z.floor = aI, z.forEach = Zm, z.forEachRight = Km, z.forIn = OA, z.forInRight = _A, z.forOwn = LA, z.forOwnRight = PA, z.get = tf, z.gt = nA, z.gte = iA, z.has = FA, z.hasIn = rf, z.head = Ym, z.identity = bn, z.includes = TD, z.indexOf = xk, z.inRange = oE, z.invoke = HA, z.isArguments = Yo, z.isArray = Et, z.isArrayBuffer = oA, z.isArrayLike = mn, z.isArrayLikeObject = Ir, z.isBoolean = aA, z.isBuffer = bo, z.isDate = lA, z.isElement = sA, z.isEmpty = uA, z.isEqual = cA, z.isEqualWith = dA, z.isError = Jd, z.isFinite = fA, z.isFunction = Wi, z.isInteger = ov, z.isLength = Su, z.isMap = av, z.isMatch = hA, z.isMatchWith = pA, z.isNaN = gA, z.isNative = mA, z.isNil = bA, z.isNull = vA, z.isNumber = lv, z.isObject = yr, z.isObjectLike = Dr, z.isPlainObject = Nl, z.isRegExp = ef, z.isSafeInteger = yA, z.isSet = sv, z.isString = Tu, z.isSymbol = Nn, z.isTypedArray = Ea, z.isUndefined = xA, z.isWeakMap = wA, z.isWeakSet = MA, z.join = Tk, z.kebabCase = dE, z.last = Qn, z.lastIndexOf = kk, z.lowerCase = fE, z.lowerFirst = hE, z.lt = CA, z.lte = SA, z.max = lI, z.maxBy = sI, z.mean = uI, z.meanBy = cI, z.min = dI, z.minBy = fI, z.stubArray = uf, z.stubFalse = cf, z.stubObject = KE, z.stubString = XE, z.stubTrue = JE, z.multiply = hI, z.nth = Dk, z.noConflict = HE, z.noop = sf, z.now = wu, z.pad = pE, z.padEnd = gE, z.padStart = mE, z.parseInt = vE, z.random = aE, z.reduce = ID, z.reduceRight = ND, z.repeat = bE, z.replace = yE, z.result = ZA, z.round = pI, z.runInContext = J, z.sample = $D, z.size = LD, z.snakeCase = xE, z.some = PD, z.sortedIndex = Ok, z.sortedIndexBy = _k, z.sortedIndexOf = Lk, z.sortedLastIndex = Pk, z.sortedLastIndexBy = Rk, z.sortedLastIndexOf = jk, z.startCase = ME, z.startsWith = CE, z.subtract = gI, z.sum = mI, z.sumBy = vI, z.template = SE, z.times = eI, z.toFinite = Vi, z.toInteger = It, z.toLength = cv, z.toLower = TE, z.toNumber = qn, z.toSafeInteger = TA, z.toString = Zt, z.toUpper = kE, z.trim = DE, z.trimEnd = AE, z.trimStart = EE, z.truncate = IE, z.unescape = NE, z.uniqueId = rI, z.upperCase = zE, z.upperFirst = nf, z.each = Zm, z.eachRight = Km, z.first = Ym, lf(z, function() {
        var l = {};
        return Si(z, function(c, p) {
          Jt.call(z.prototype, p) || (l[p] = c);
        }), l;
      }(), { chain: !1 }), z.VERSION = n, Un(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(l) {
        z[l].placeholder = z;
      }), Un(["drop", "take"], function(l, c) {
        Rt.prototype[l] = function(p) {
          p = p === r ? 1 : Rr(It(p), 0);
          var M = this.__filtered__ && !c ? new Rt(this) : this.clone();
          return M.__filtered__ ? M.__takeCount__ = tn(p, M.__takeCount__) : M.__views__.push({
            size: tn(p, de),
            type: l + (M.__dir__ < 0 ? "Right" : "")
          }), M;
        }, Rt.prototype[l + "Right"] = function(p) {
          return this.reverse()[l](p).reverse();
        };
      }), Un(["filter", "map", "takeWhile"], function(l, c) {
        var p = c + 1, M = p == Q || p == X;
        Rt.prototype[l] = function(k) {
          var O = this.clone();
          return O.__iteratees__.push({
            iteratee: pt(k, 3),
            type: p
          }), O.__filtered__ = O.__filtered__ || M, O;
        };
      }), Un(["head", "last"], function(l, c) {
        var p = "take" + (c ? "Right" : "");
        Rt.prototype[l] = function() {
          return this[p](1).value()[0];
        };
      }), Un(["initial", "tail"], function(l, c) {
        var p = "drop" + (c ? "" : "Right");
        Rt.prototype[l] = function() {
          return this.__filtered__ ? new Rt(this) : this[p](1);
        };
      }), Rt.prototype.compact = function() {
        return this.filter(bn);
      }, Rt.prototype.find = function(l) {
        return this.filter(l).head();
      }, Rt.prototype.findLast = function(l) {
        return this.reverse().find(l);
      }, Rt.prototype.invokeMap = _t(function(l, c) {
        return typeof l == "function" ? new Rt(this) : this.map(function(p) {
          return Tl(p, l, c);
        });
      }), Rt.prototype.reject = function(l) {
        return this.filter(Cu(pt(l)));
      }, Rt.prototype.slice = function(l, c) {
        l = It(l);
        var p = this;
        return p.__filtered__ && (l > 0 || c < 0) ? new Rt(p) : (l < 0 ? p = p.takeRight(-l) : l && (p = p.drop(l)), c !== r && (c = It(c), p = c < 0 ? p.dropRight(-c) : p.take(c - l)), p);
      }, Rt.prototype.takeRightWhile = function(l) {
        return this.reverse().takeWhile(l).reverse();
      }, Rt.prototype.toArray = function() {
        return this.take(de);
      }, Si(Rt.prototype, function(l, c) {
        var p = /^(?:filter|find|map|reject)|While$/.test(c), M = /^(?:head|last)$/.test(c), k = z[M ? "take" + (c == "last" ? "Right" : "") : c], O = M || /^find/.test(c);
        k && (z.prototype[c] = function() {
          var F = this.__wrapped__, V = M ? [1] : arguments, ee = F instanceof Rt, me = V[0], be = ee || Et(F), Ce = function(Pt) {
            var Ft = k.apply(z, co([Pt], V));
            return M && He ? Ft[0] : Ft;
          };
          be && p && typeof me == "function" && me.length != 1 && (ee = be = !1);
          var He = this.__chain__, it = !!this.__actions__.length, gt = O && !He, $t = ee && !it;
          if (!O && be) {
            F = $t ? F : new Rt(this);
            var mt = l.apply(F, V);
            return mt.__actions__.push({ func: yu, args: [Ce], thisArg: r }), new Wn(mt, He);
          }
          return gt && $t ? l.apply(this, V) : (mt = this.thru(Ce), gt ? M ? mt.value()[0] : mt.value() : mt);
        });
      }), Un(["pop", "push", "shift", "sort", "splice", "unshift"], function(l) {
        var c = Vs[l], p = /^(?:push|sort|unshift)$/.test(l) ? "tap" : "thru", M = /^(?:pop|shift)$/.test(l);
        z.prototype[l] = function() {
          var k = arguments;
          if (M && !this.__chain__) {
            var O = this.value();
            return c.apply(Et(O) ? O : [], k);
          }
          return this[p](function(F) {
            return c.apply(Et(F) ? F : [], k);
          });
        };
      }), Si(Rt.prototype, function(l, c) {
        var p = z[c];
        if (p) {
          var M = p.name + "";
          Jt.call(Sa, M) || (Sa[M] = []), Sa[M].push({ name: c, func: p });
        }
      }), Sa[fu(r, y).name] = [{
        name: "wrapper",
        func: r
      }], Rt.prototype.clone = NS, Rt.prototype.reverse = zS, Rt.prototype.value = $S, z.prototype.at = sD, z.prototype.chain = uD, z.prototype.commit = cD, z.prototype.next = dD, z.prototype.plant = hD, z.prototype.reverse = pD, z.prototype.toJSON = z.prototype.valueOf = z.prototype.value = gD, z.prototype.first = z.prototype.head, bl && (z.prototype[bl] = fD), z;
    }, wa = cS();
    Ro ? ((Ro.exports = wa)._ = wa, od._ = wa) : Vr._ = wa;
  }).call(Ou);
})(xK, hn);
const NL = (e, t = !0) => t ? Math.round(e * Math.pow(10, -6)) : (e * Math.pow(10, -6)).toFixed(1), wK = hn.memoize((e) => new Promise((t, r) => {
  const n = new XMLHttpRequest();
  n.open("GET", e, !0), n.responseType = "blob", n.onload = function() {
    t({ resourceDetails: n.response });
  }, n.onerror = r, n.send();
})), ma = (e, t = "") => {
  if (!e)
    throw new Error("Editor instance is missing");
  return (e == null ? void 0 : e.extensionManager.extensions.some(
    (n) => n.name === t
  )) ? !0 : (console.warn(
    `Unable to ${t} extension, Please check if the extension is passed`
  ), !1);
}, MK = ({ r: e, g: t, b: r, a: n }) => `rgba(${e},${t},${r},${n})`;
var CK = Object.defineProperty, SK = Object.defineProperties, TK = Object.getOwnPropertyDescriptors, H1 = Object.getOwnPropertySymbols, aU = Object.prototype.hasOwnProperty, lU = Object.prototype.propertyIsEnumerable, zL = (e, t, r) => t in e ? CK(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, vt = (e, t) => {
  for (var r in t || (t = {}))
    aU.call(t, r) && zL(e, r, t[r]);
  if (H1)
    for (var r of H1(t))
      lU.call(t, r) && zL(e, r, t[r]);
  return e;
}, Qt = (e, t) => SK(e, TK(t)), kK = (e, t) => {
  var r = {};
  for (var n in e)
    aU.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && H1)
    for (var n of H1(e))
      t.indexOf(n) < 0 && lU.call(e, n) && (r[n] = e[n]);
  return r;
};
let W1 = [];
const sU = /* @__PURE__ */ new WeakMap();
function DK() {
  W1.forEach((e) => e(...sU.get(e))), W1 = [];
}
function m0(e, ...t) {
  sU.set(e, t), !W1.includes(e) && W1.push(e) === 1 && requestAnimationFrame(DK);
}
function Bl(e, t) {
  let { target: r } = e;
  for (; r; ) {
    if (r.dataset && r.dataset[t] !== void 0)
      return !0;
    r = r.parentElement;
  }
  return !1;
}
function Ul(e) {
  return e.composedPath()[0] || null;
}
function wo(e) {
  return typeof e == "string" ? e.endsWith("px") ? Number(e.slice(0, e.length - 2)) : Number(e) : e;
}
function Ko(e) {
  if (e != null)
    return typeof e == "number" ? `${e}px` : e.endsWith("px") ? e : `${e}px`;
}
function Ll(e, t) {
  const r = e.trim().split(/\s+/g), n = {
    top: r[0]
  };
  switch (r.length) {
    case 1:
      n.right = r[0], n.bottom = r[0], n.left = r[0];
      break;
    case 2:
      n.right = r[1], n.left = r[1], n.bottom = r[0];
      break;
    case 3:
      n.right = r[1], n.bottom = r[2], n.left = r[1];
      break;
    case 4:
      n.right = r[1], n.bottom = r[2], n.left = r[3];
      break;
    default:
      throw new Error("[seemly/getMargin]:" + e + " is not a valid value.");
  }
  return t === void 0 ? n : n[t];
}
function AK(e, t) {
  const [r, n] = e.split(" ");
  return t ? t === "row" ? r : n : {
    row: r,
    col: n || r
  };
}
var $L = {
  black: "#000",
  silver: "#C0C0C0",
  gray: "#808080",
  white: "#FFF",
  maroon: "#800000",
  red: "#F00",
  purple: "#800080",
  fuchsia: "#F0F",
  green: "#008000",
  lime: "#0F0",
  olive: "#808000",
  yellow: "#FF0",
  navy: "#000080",
  blue: "#00F",
  teal: "#008080",
  aqua: "#0FF",
  transparent: "#0000"
};
function uU(e, t, r) {
  t /= 100, r /= 100;
  const n = t * Math.min(r, 1 - r) + r;
  return [e, n ? (2 - 2 * r / n) * 100 : 0, n * 100];
}
function Yy(e, t, r) {
  t /= 100, r /= 100;
  const n = r - r * t / 2, i = Math.min(n, 1 - n);
  return [e, i ? (r - n) / i * 100 : 0, n * 100];
}
function oc(e, t, r) {
  t /= 100, r /= 100;
  let n = (i, o = (i + e / 60) % 6) => r - r * t * Math.max(Math.min(o, 4 - o, 1), 0);
  return [n(5) * 255, n(3) * 255, n(1) * 255];
}
function GN(e, t, r) {
  e /= 255, t /= 255, r /= 255;
  let n = Math.max(e, t, r), i = n - Math.min(e, t, r), o = i && (n == e ? (t - r) / i : n == t ? 2 + (r - e) / i : 4 + (e - t) / i);
  return [60 * (o < 0 ? o + 6 : o), n && i / n * 100, n * 100];
}
function ZN(e, t, r) {
  e /= 255, t /= 255, r /= 255;
  let n = Math.max(e, t, r), i = n - Math.min(e, t, r), o = 1 - Math.abs(n + n - i - 1), a = i && (n == e ? (t - r) / i : n == t ? 2 + (r - e) / i : 4 + (e - t) / i);
  return [60 * (a < 0 ? a + 6 : a), o ? i / o * 100 : 0, (n + n - i) * 50];
}
function KN(e, t, r) {
  t /= 100, r /= 100;
  let n = t * Math.min(r, 1 - r), i = (o, a = (o + e / 30) % 12) => r - n * Math.max(Math.min(a - 3, 9 - a, 1), -1);
  return [i(0) * 255, i(8) * 255, i(4) * 255];
}
const As = "^\\s*", Es = "\\s*$", bc = "\\s*((\\.\\d+)|(\\d+(\\.\\d*)?))%\\s*", _a = "\\s*((\\.\\d+)|(\\d+(\\.\\d*)?))\\s*", Of = "([0-9A-Fa-f])", _f = "([0-9A-Fa-f]{2})", EK = new RegExp(`${As}hsl\\s*\\(${_a},${bc},${bc}\\)${Es}`), IK = new RegExp(`${As}hsv\\s*\\(${_a},${bc},${bc}\\)${Es}`), NK = new RegExp(`${As}hsla\\s*\\(${_a},${bc},${bc},${_a}\\)${Es}`), zK = new RegExp(`${As}hsva\\s*\\(${_a},${bc},${bc},${_a}\\)${Es}`), $K = new RegExp(`${As}rgb\\s*\\(${_a},${_a},${_a}\\)${Es}`), OK = new RegExp(`${As}rgba\\s*\\(${_a},${_a},${_a},${_a}\\)${Es}`), WO = new RegExp(`${As}#${Of}${Of}${Of}${Es}`), VO = new RegExp(`${As}#${_f}${_f}${_f}${Es}`), YO = new RegExp(`${As}#${Of}${Of}${Of}${Of}${Es}`), QO = new RegExp(`${As}#${_f}${_f}${_f}${_f}${Es}`);
function oa(e) {
  return parseInt(e, 16);
}
function ep(e) {
  try {
    let t;
    if (t = NK.exec(e))
      return [
        Cs(t[1]),
        _i(t[5]),
        _i(t[9]),
        Ru(t[13])
      ];
    if (t = EK.exec(e))
      return [Cs(t[1]), _i(t[5]), _i(t[9]), 1];
    throw new Error(`[seemly/hsla]: Invalid color value ${e}.`);
  } catch (t) {
    throw t;
  }
}
function jf(e) {
  try {
    let t;
    if (t = zK.exec(e))
      return [
        Cs(t[1]),
        _i(t[5]),
        _i(t[9]),
        Ru(t[13])
      ];
    if (t = IK.exec(e))
      return [Cs(t[1]), _i(t[5]), _i(t[9]), 1];
    throw new Error(`[seemly/hsva]: Invalid color value ${e}.`);
  } catch (t) {
    throw t;
  }
}
function ro(e) {
  try {
    let t;
    if (t = VO.exec(e))
      return [oa(t[1]), oa(t[2]), oa(t[3]), 1];
    if (t = $K.exec(e))
      return [pi(t[1]), pi(t[5]), pi(t[9]), 1];
    if (t = OK.exec(e))
      return [
        pi(t[1]),
        pi(t[5]),
        pi(t[9]),
        Ru(t[13])
      ];
    if (t = WO.exec(e))
      return [
        oa(t[1] + t[1]),
        oa(t[2] + t[2]),
        oa(t[3] + t[3]),
        1
      ];
    if (t = QO.exec(e))
      return [
        oa(t[1]),
        oa(t[2]),
        oa(t[3]),
        Ru(oa(t[4]) / 255)
      ];
    if (t = YO.exec(e))
      return [
        oa(t[1] + t[1]),
        oa(t[2] + t[2]),
        oa(t[3] + t[3]),
        Ru(oa(t[4] + t[4]) / 255)
      ];
    if (e in $L)
      return ro($L[e]);
    throw new Error(`[seemly/rgba]: Invalid color value ${e}.`);
  } catch (t) {
    throw t;
  }
}
function _K(e) {
  return e > 1 ? 1 : e < 0 ? 0 : e;
}
function LK(e, t, r) {
  return `rgb(${pi(e)}, ${pi(t)}, ${pi(r)})`;
}
function XN(e, t, r, n) {
  return `rgba(${pi(e)}, ${pi(t)}, ${pi(r)}, ${_K(n)})`;
}
function bI(e, t, r, n, i) {
  return pi((e * t * (1 - n) + r * n) / i);
}
function nn(e, t) {
  Array.isArray(e) || (e = ro(e)), Array.isArray(t) || (t = ro(t));
  const r = e[3], n = t[3], i = Ru(r + n - r * n);
  return XN(bI(e[0], r, t[0], n, i), bI(e[1], r, t[1], n, i), bI(e[2], r, t[2], n, i), i);
}
function nr(e, t) {
  const [r, n, i, o = 1] = Array.isArray(e) ? e : ro(e);
  return t.alpha ? XN(r, n, i, t.alpha) : XN(r, n, i, o);
}
function qb(e, t) {
  const [r, n, i, o = 1] = Array.isArray(e) ? e : ro(e), { lightness: a = 1, alpha: s = 1 } = t;
  return gs([r * a, n * a, i * a, o * s]);
}
function Ru(e) {
  const t = Math.round(Number(e) * 100) / 100;
  return t > 1 ? 1 : t < 0 ? 0 : t;
}
function Cs(e) {
  const t = Math.round(Number(e));
  return t >= 360 || t < 0 ? 0 : t;
}
function pi(e) {
  const t = Math.round(Number(e));
  return t > 255 ? 255 : t < 0 ? 0 : t;
}
function _i(e) {
  const t = Math.round(Number(e));
  return t > 100 ? 100 : t < 0 ? 0 : t;
}
function JN(e) {
  const [t, r, n] = Array.isArray(e) ? e : ro(e);
  return LK(t, r, n);
}
function gs(e) {
  const [t, r, n] = e;
  return 3 in e ? `rgba(${pi(t)}, ${pi(r)}, ${pi(n)}, ${Ru(e[3])})` : `rgba(${pi(t)}, ${pi(r)}, ${pi(n)}, 1)`;
}
function ez(e) {
  return `hsv(${Cs(e[0])}, ${_i(e[1])}%, ${_i(e[2])}%)`;
}
function Ff(e) {
  const [t, r, n] = e;
  return 3 in e ? `hsva(${Cs(t)}, ${_i(r)}%, ${_i(n)}%, ${Ru(e[3])})` : `hsva(${Cs(t)}, ${_i(r)}%, ${_i(n)}%, 1)`;
}
function tz(e) {
  return `hsl(${Cs(e[0])}, ${_i(e[1])}%, ${_i(e[2])}%)`;
}
function hc(e) {
  const [t, r, n] = e;
  return 3 in e ? `hsla(${Cs(t)}, ${_i(r)}%, ${_i(n)}%, ${Ru(e[3])})` : `hsla(${Cs(t)}, ${_i(r)}%, ${_i(n)}%, 1)`;
}
function pc(e) {
  if (typeof e == "string") {
    let n;
    if (n = VO.exec(e))
      return `${n[0]}FF`;
    if (n = QO.exec(e))
      return n[0];
    if (n = WO.exec(e))
      return `#${n[1]}${n[1]}${n[2]}${n[2]}${n[3]}${n[3]}FF`;
    if (n = YO.exec(e))
      return `#${n[1]}${n[1]}${n[2]}${n[2]}${n[3]}${n[3]}${n[4]}${n[4]}`;
    throw new Error(`[seemly/toHexString]: Invalid hex value ${e}.`);
  }
  const t = `#${e.slice(0, 3).map((n) => pi(n).toString(16).toUpperCase().padStart(2, "0")).join("")}`, r = e.length === 3 ? "FF" : pi(e[3] * 255).toString(16).padStart(2, "0").toUpperCase();
  return t + r;
}
function qv(e) {
  if (typeof e == "string") {
    let t;
    if (t = VO.exec(e))
      return t[0];
    if (t = QO.exec(e))
      return t[0].slice(0, 7);
    if (t = WO.exec(e) || YO.exec(e))
      return `#${t[1]}${t[1]}${t[2]}${t[2]}${t[3]}${t[3]}`;
    throw new Error(`[seemly/toHexString]: Invalid hex value ${e}.`);
  }
  return `#${e.slice(0, 3).map((t) => pi(t).toString(16).toUpperCase().padStart(2, "0")).join("")}`;
}
function Ss(e = 8) {
  return Math.random().toString(16).slice(2, 2 + e);
}
function PK(e, t) {
  const r = [];
  for (let n = 0; n < e; ++n)
    r.push(t);
  return r;
}
function RK(e, t) {
  const r = [];
  if (!t) {
    for (let n = 0; n < e; ++n)
      r.push(n);
    return r;
  }
  for (let n = 0; n < e; ++n)
    r.push(t(n));
  return r;
}
function qO(e, t = "default", r = []) {
  const i = e.$slots[t];
  return i === void 0 ? r : i();
}
function il(e, t = [], r) {
  const n = {};
  return t.forEach((i) => {
    n[i] = e[i];
  }), Object.assign(n, r);
}
function IM(e, t = [], r) {
  const n = {};
  return Object.getOwnPropertyNames(e).forEach((o) => {
    t.includes(o) || (n[o] = e[o]);
  }), Object.assign(n, r);
}
function ms(e, t = !0, r = []) {
  return e.forEach((n) => {
    if (n !== null) {
      if (typeof n != "object") {
        (typeof n == "string" || typeof n == "number") && r.push(zr(String(n)));
        return;
      }
      if (Array.isArray(n)) {
        ms(n, t, r);
        return;
      }
      if (n.type === Lr) {
        if (n.children === null)
          return;
        Array.isArray(n.children) && ms(n.children, t, r);
      } else
        n.type !== BO && r.push(n);
    }
  }), r;
}
function je(e, ...t) {
  if (Array.isArray(e))
    e.forEach((r) => je(r, ...t));
  else
    return e(...t);
}
function Ts(e) {
  return Object.keys(e);
}
const xn = (e, ...t) => typeof e == "function" ? e(...t) : typeof e == "string" ? zr(e) : typeof e == "number" ? zr(String(e)) : null;
function ja(e, t) {
  console.error(`[naive/${e}]: ${t}`);
}
function Ql(e, t) {
  throw new Error(`[naive/${e}]: ${t}`);
}
function rz(e) {
  switch (e) {
    case "tiny":
      return "mini";
    case "small":
      return "tiny";
    case "medium":
      return "small";
    case "large":
      return "medium";
    case "huge":
      return "large";
  }
  throw Error(`${e} has no smaller size.`);
}
function cU(e) {
  switch (typeof e) {
    case "string":
      return e || void 0;
    case "number":
      return String(e);
    default:
      return;
  }
}
function nz(e, t = "default", r = void 0) {
  const n = e[t];
  if (!n)
    return ja("getFirstSlotVNode", `slot[${t}] is empty`), null;
  const i = ms(n(r));
  return i.length === 1 ? i[0] : (ja("getFirstSlotVNode", `slot[${t}] should have exactly one child`), null);
}
function dU(e) {
  return (t) => {
    t ? e.value = t.$el : e.value = null;
  };
}
function Fp(e) {
  return e.some((t) => MZ(t) ? !(t.type === BO || t.type === Lr && !Fp(t.children)) : !0) ? e : null;
}
function vr(e, t) {
  return e && Fp(e()) || t();
}
function v0(e, t, r) {
  return e && Fp(e(t)) || r(t);
}
function Fr(e, t) {
  const r = e && Fp(e());
  return t(r || null);
}
function jK(e, t, r) {
  const n = e && Fp(e(t));
  return r(n || null);
}
function Bf(e) {
  return !(e && Fp(e()));
}
function Gv(e) {
  const t = e.filter((r) => r !== void 0);
  if (t.length !== 0)
    return t.length === 1 ? t[0] : (r) => {
      e.forEach((n) => {
        n && n(r);
      });
    };
}
const iz = oe({
  render() {
    var e, t;
    return (t = (e = this.$slots).default) === null || t === void 0 ? void 0 : t.call(e);
  }
}), FK = /^(\d|\.)+$/, OL = /(\d|\.)+/;
function Rn(e, { c: t = 1, offset: r = 0, attachPx: n = !0 } = {}) {
  if (typeof e == "number") {
    const i = (e + r) * t;
    return i === 0 ? "0" : `${i}px`;
  } else if (typeof e == "string")
    if (FK.test(e)) {
      const i = (Number(e) + r) * t;
      return n ? i === 0 ? "0" : `${i}px` : `${i}`;
    } else {
      const i = OL.exec(e);
      return i ? e.replace(OL, String((Number(i[0]) + r) * t)) : e;
    }
  return e;
}
function hp(e) {
  return e.replace(/#|\(|\)|,|\s/g, "_");
}
function BK(e) {
  let t = 0;
  for (let r = 0; r < e.length; ++r)
    e[r] === "&" && ++t;
  return t;
}
const fU = /\s*,(?![^(]*\))\s*/g, UK = /\s+/g;
function HK(e, t) {
  const r = [];
  return t.split(fU).forEach((n) => {
    let i = BK(n);
    if (i) {
      if (i === 1) {
        e.forEach((a) => {
          r.push(n.replace("&", a));
        });
        return;
      }
    } else {
      e.forEach((a) => {
        r.push((a && a + " ") + n);
      });
      return;
    }
    let o = [
      n
    ];
    for (; i--; ) {
      const a = [];
      o.forEach((s) => {
        e.forEach((u) => {
          a.push(s.replace("&", u));
        });
      }), o = a;
    }
    o.forEach((a) => r.push(a));
  }), r;
}
function WK(e, t) {
  const r = [];
  return t.split(fU).forEach((n) => {
    e.forEach((i) => {
      r.push((i && i + " ") + n);
    });
  }), r;
}
function VK(e) {
  let t = [""];
  return e.forEach((r) => {
    r = r && r.trim(), r && (r.includes("&") ? t = HK(t, r) : t = WK(t, r));
  }), t.join(", ").replace(UK, " ");
}
function _L(e) {
  if (!e)
    return;
  const t = e.parentElement;
  t && t.removeChild(e);
}
function NM(e) {
  return document.head.querySelector(`style[cssr-id="${e}"]`);
}
function YK(e) {
  const t = document.createElement("style");
  return t.setAttribute("cssr-id", e), t;
}
function Gb(e) {
  return e ? /^\s*@(s|m)/.test(e) : !1;
}
const QK = /[A-Z]/g;
function hU(e) {
  return e.replace(QK, (t) => "-" + t.toLowerCase());
}
function qK(e, t = "  ") {
  return typeof e == "object" && e !== null ? ` {
` + Object.entries(e).map((r) => t + `  ${hU(r[0])}: ${r[1]};`).join(`
`) + `
` + t + "}" : `: ${e};`;
}
function GK(e, t, r) {
  return typeof e == "function" ? e({
    context: t.context,
    props: r
  }) : e;
}
function LL(e, t, r, n) {
  if (!t)
    return "";
  const i = GK(t, r, n);
  if (!i)
    return "";
  if (typeof i == "string")
    return `${e} {
${i}
}`;
  const o = Object.keys(i);
  if (o.length === 0)
    return r.config.keepEmptyBlock ? e + ` {
}` : "";
  const a = e ? [
    e + " {"
  ] : [];
  return o.forEach((s) => {
    const u = i[s];
    if (s === "raw") {
      a.push(`
` + u + `
`);
      return;
    }
    s = hU(s), u != null && a.push(`  ${s}${qK(u)}`);
  }), e && a.push("}"), a.join(`
`);
}
function oz(e, t, r) {
  e && e.forEach((n) => {
    if (Array.isArray(n))
      oz(n, t, r);
    else if (typeof n == "function") {
      const i = n(t);
      Array.isArray(i) ? oz(i, t, r) : i && r(i);
    } else
      n && r(n);
  });
}
function pU(e, t, r, n, i, o) {
  const a = e.$;
  let s = "";
  if (!a || typeof a == "string")
    Gb(a) ? s = a : t.push(a);
  else if (typeof a == "function") {
    const f = a({
      context: n.context,
      props: i
    });
    Gb(f) ? s = f : t.push(f);
  } else if (a.before && a.before(n.context), !a.$ || typeof a.$ == "string")
    Gb(a.$) ? s = a.$ : t.push(a.$);
  else if (a.$) {
    const f = a.$({
      context: n.context,
      props: i
    });
    Gb(f) ? s = f : t.push(f);
  }
  const u = VK(t), d = LL(u, e.props, n, i);
  s ? (r.push(`${s} {`), o && d && o.insertRule(`${s} {
${d}
}
`)) : (o && d && o.insertRule(d), !o && d.length && r.push(d)), e.children && oz(e.children, {
    context: n.context,
    props: i
  }, (f) => {
    if (typeof f == "string") {
      const h = LL(u, { raw: f }, n, i);
      o ? o.insertRule(h) : r.push(h);
    } else
      pU(f, t, r, n, i, o);
  }), t.pop(), s && r.push("}"), a && a.after && a.after(n.context);
}
function gU(e, t, r, n = !1) {
  const i = [];
  return pU(e, [], i, t, r, n ? e.instance.__styleSheet : void 0), n ? "" : i.join(`

`);
}
function b0(e) {
  for (var t = 0, r, n = 0, i = e.length; i >= 4; ++n, i -= 4)
    r = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, r = (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= r >>> 24, t = (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      t ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(n) & 255, t = (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
typeof window < "u" && (window.__cssrContext = {});
function ZK(e, t, r) {
  const { els: n } = t;
  if (r === void 0)
    n.forEach(_L), t.els = [];
  else {
    const i = NM(r);
    i && n.includes(i) && (_L(i), t.els = n.filter((o) => o !== i));
  }
}
function PL(e, t) {
  e.push(t);
}
function KK(e, t, r, n, i, o, a, s, u) {
  if (o && !u) {
    if (r === void 0) {
      console.error("[css-render/mount]: `id` is required in `silent` mode.");
      return;
    }
    const g = window.__cssrContext;
    g[r] || (g[r] = !0, gU(t, e, n, o));
    return;
  }
  let d;
  if (r === void 0 && (d = t.render(n), r = b0(d)), u) {
    u.adapter(r, d ?? t.render(n));
    return;
  }
  const f = NM(r);
  if (f !== null && !a)
    return f;
  const h = f ?? YK(r);
  if (d === void 0 && (d = t.render(n)), h.textContent = d, f !== null)
    return f;
  if (s) {
    const g = document.head.querySelector(`meta[name="${s}"]`);
    if (g)
      return document.head.insertBefore(h, g), PL(t.els, h), h;
  }
  return i ? document.head.insertBefore(h, document.head.querySelector("style, link")) : document.head.appendChild(h), PL(t.els, h), h;
}
function XK(e) {
  return gU(this, this.instance, e);
}
function JK(e = {}) {
  const { id: t, ssr: r, props: n, head: i = !1, silent: o = !1, force: a = !1, anchorMetaName: s } = e;
  return KK(this.instance, this, t, n, i, o, a, s, r);
}
function eX(e = {}) {
  const { id: t } = e;
  ZK(this.instance, this, t);
}
const Zb = function(e, t, r, n) {
  return {
    instance: e,
    $: t,
    props: r,
    children: n,
    els: [],
    render: XK,
    mount: JK,
    unmount: eX
  };
}, tX = function(e, t, r, n) {
  return Array.isArray(t) ? Zb(e, { $: null }, null, t) : Array.isArray(r) ? Zb(e, t, null, r) : Array.isArray(n) ? Zb(e, t, r, n) : Zb(e, t, r, null);
};
function mU(e = {}) {
  let t = null;
  const r = {
    c: (...n) => tX(r, ...n),
    use: (n, ...i) => n.install(r, ...i),
    find: NM,
    context: {},
    config: e,
    get __styleSheet() {
      if (!t) {
        const n = document.createElement("style");
        return document.head.appendChild(n), t = document.styleSheets[document.styleSheets.length - 1], t;
      }
      return t;
    }
  };
  return r;
}
function rX(e, t) {
  if (e === void 0)
    return !1;
  if (t) {
    const { context: { ids: r } } = t;
    return r.has(e);
  }
  return NM(e) !== null;
}
function nX(e) {
  let t = ".", r = "__", n = "--", i;
  if (e) {
    let v = e.blockPrefix;
    v && (t = v), v = e.elementPrefix, v && (r = v), v = e.modifierPrefix, v && (n = v);
  }
  const o = {
    install(v) {
      i = v.c;
      const w = v.context;
      w.bem = {}, w.bem.b = null, w.bem.els = null;
    }
  };
  function a(v) {
    let w, x;
    return {
      before(y) {
        w = y.bem.b, x = y.bem.els, y.bem.els = null;
      },
      after(y) {
        y.bem.b = w, y.bem.els = x;
      },
      $({ context: y, props: C }) {
        return v = typeof v == "string" ? v : v({ context: y, props: C }), y.bem.b = v, `${(C == null ? void 0 : C.bPrefix) || t}${y.bem.b}`;
      }
    };
  }
  function s(v) {
    let w;
    return {
      before(x) {
        w = x.bem.els;
      },
      after(x) {
        x.bem.els = w;
      },
      $({ context: x, props: y }) {
        return v = typeof v == "string" ? v : v({ context: x, props: y }), x.bem.els = v.split(",").map((C) => C.trim()), x.bem.els.map((C) => `${(y == null ? void 0 : y.bPrefix) || t}${x.bem.b}${r}${C}`).join(", ");
      }
    };
  }
  function u(v) {
    return {
      $({ context: w, props: x }) {
        v = typeof v == "string" ? v : v({ context: w, props: x });
        const y = v.split(",").map((T) => T.trim());
        function C(T) {
          return y.map((A) => `&${(x == null ? void 0 : x.bPrefix) || t}${w.bem.b}${T !== void 0 ? `${r}${T}` : ""}${n}${A}`).join(", ");
        }
        const S = w.bem.els;
        return S !== null ? C(S[0]) : C();
      }
    };
  }
  function d(v) {
    return {
      $({ context: w, props: x }) {
        v = typeof v == "string" ? v : v({ context: w, props: x });
        const y = w.bem.els;
        return `&:not(${(x == null ? void 0 : x.bPrefix) || t}${w.bem.b}${y !== null && y.length > 0 ? `${r}${y[0]}` : ""}${n}${v})`;
      }
    };
  }
  return Object.assign(o, {
    cB: (...v) => i(a(v[0]), v[1], v[2]),
    cE: (...v) => i(s(v[0]), v[1], v[2]),
    cM: (...v) => i(u(v[0]), v[1], v[2]),
    cNotM: (...v) => i(d(v[0]), v[1], v[2])
  }), o;
}
function Be(e, t) {
  return e + (t === "default" ? "" : t.replace(/^[a-z]/, (r) => r.toUpperCase()));
}
Be("abc", "def");
const iX = "n", y0 = `.${iX}-`, oX = "__", aX = "--", vU = mU(), bU = nX({
  blockPrefix: y0,
  elementPrefix: oX,
  modifierPrefix: aX
});
vU.use(bU);
const { c: Y, find: oKe } = vU, { cB: L, cE: q, cM: K, cNotM: wr } = bU;
function Bp(e) {
  return Y(({ props: { bPrefix: t } }) => `${t || y0}modal, ${t || y0}drawer`, [e]);
}
function hb(e) {
  return Y(({ props: { bPrefix: t } }) => `${t || y0}popover`, [e]);
}
function yU(e) {
  return Y(({ props: { bPrefix: t } }) => `&${t || y0}modal`, e);
}
const lX = (...e) => Y(">", [L(...e)]);
let yI;
function sX() {
  return yI === void 0 && (yI = navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom")), yI;
}
const Is = typeof document < "u" && typeof window < "u", xU = /* @__PURE__ */ new WeakSet();
function x0(e) {
  xU.add(e);
}
function wU(e) {
  return !xU.has(e);
}
function uX(e, t, r) {
  var n;
  const i = lt(e, null);
  if (i === null)
    return;
  const o = (n = uh()) === null || n === void 0 ? void 0 : n.proxy;
  Gt(r, a), a(r.value), Gr(() => {
    a(void 0, r.value);
  });
  function a(d, f) {
    const h = i[t];
    f !== void 0 && s(h, f), d !== void 0 && u(h, d);
  }
  function s(d, f) {
    d[f] || (d[f] = []), d[f].splice(d[f].findIndex((h) => h === o), 1);
  }
  function u(d, f) {
    d[f] || (d[f] = []), ~d[f].findIndex((h) => h === o) || d[f].push(o);
  }
}
function cX(e, t, r) {
  if (!t)
    return e;
  const n = G(e.value);
  let i = null;
  return Gt(e, (o) => {
    i !== null && window.clearTimeout(i), o === !0 ? r && !r.value ? n.value = !0 : i = window.setTimeout(() => {
      n.value = !0;
    }, t) : n.value = !1;
  }), n;
}
function MU(e) {
  const t = G(!!e.value);
  if (t.value)
    return vc(t);
  const r = Gt(e, (n) => {
    n && (t.value = !0, r());
  });
  return vc(t);
}
function _r(e) {
  const t = j(e), r = G(t.value);
  return Gt(t, (n) => {
    r.value = n;
  }), typeof e == "function" ? r : {
    __v_isRef: !0,
    get value() {
      return r.value;
    },
    set value(n) {
      e.set(n);
    }
  };
}
function GO() {
  return uh() !== null;
}
const ZO = typeof window < "u";
let tp, Zv;
const dX = () => {
  var e, t;
  tp = ZO ? (t = (e = document) === null || e === void 0 ? void 0 : e.fonts) === null || t === void 0 ? void 0 : t.ready : void 0, Zv = !1, tp !== void 0 ? tp.then(() => {
    Zv = !0;
  }) : Zv = !0;
};
dX();
function CU(e) {
  if (Zv)
    return;
  let t = !1;
  br(() => {
    Zv || tp == null || tp.then(() => {
      t || e();
    });
  }), Gr(() => {
    t = !0;
  });
}
function Qy(e) {
  return e.composedPath()[0];
}
const fX = {
  mousemoveoutside: /* @__PURE__ */ new WeakMap(),
  clickoutside: /* @__PURE__ */ new WeakMap()
};
function hX(e, t, r) {
  if (e === "mousemoveoutside") {
    const n = (i) => {
      t.contains(Qy(i)) || r(i);
    };
    return {
      mousemove: n,
      touchstart: n
    };
  } else if (e === "clickoutside") {
    let n = !1;
    const i = (a) => {
      n = !t.contains(Qy(a));
    }, o = (a) => {
      n && (t.contains(Qy(a)) || r(a));
    };
    return {
      mousedown: i,
      mouseup: o,
      touchstart: i,
      touchend: o
    };
  }
  return console.error(`[evtd/create-trap-handler]: name \`${e}\` is invalid. This could be a bug of evtd.`), {};
}
function SU(e, t, r) {
  const n = fX[e];
  let i = n.get(t);
  i === void 0 && n.set(t, i = /* @__PURE__ */ new WeakMap());
  let o = i.get(r);
  return o === void 0 && i.set(r, o = hX(e, t, r)), o;
}
function pX(e, t, r, n) {
  if (e === "mousemoveoutside" || e === "clickoutside") {
    const i = SU(e, t, r);
    return Object.keys(i).forEach((o) => {
      Mr(o, document, i[o], n);
    }), !0;
  }
  return !1;
}
function gX(e, t, r, n) {
  if (e === "mousemoveoutside" || e === "clickoutside") {
    const i = SU(e, t, r);
    return Object.keys(i).forEach((o) => {
      hr(o, document, i[o], n);
    }), !0;
  }
  return !1;
}
function mX() {
  if (typeof window > "u")
    return {
      on: () => {
      },
      off: () => {
      }
    };
  const e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap();
  function r() {
    e.set(this, !0);
  }
  function n() {
    e.set(this, !0), t.set(this, !0);
  }
  function i(E, N, I) {
    const $ = E[N];
    return E[N] = function() {
      return I.apply(E, arguments), $.apply(E, arguments);
    }, E;
  }
  function o(E, N) {
    E[N] = Event.prototype[N];
  }
  const a = /* @__PURE__ */ new WeakMap(), s = Object.getOwnPropertyDescriptor(Event.prototype, "currentTarget");
  function u() {
    var E;
    return (E = a.get(this)) !== null && E !== void 0 ? E : null;
  }
  function d(E, N) {
    s !== void 0 && Object.defineProperty(E, "currentTarget", {
      configurable: !0,
      enumerable: !0,
      get: N ?? s.get
    });
  }
  const f = {
    bubble: {},
    capture: {}
  }, h = {};
  function g() {
    const E = function(N) {
      const { type: I, eventPhase: $, bubbles: _ } = N, R = Qy(N);
      if ($ === 2)
        return;
      const U = $ === 1 ? "capture" : "bubble";
      let Q = R;
      const Z = [];
      for (; Q === null && (Q = window), Z.push(Q), Q !== window; )
        Q = Q.parentNode || null;
      const X = f.capture[I], re = f.bubble[I];
      if (i(N, "stopPropagation", r), i(N, "stopImmediatePropagation", n), d(N, u), U === "capture") {
        if (X === void 0)
          return;
        for (let ue = Z.length - 1; ue >= 0 && !e.has(N); --ue) {
          const he = Z[ue], te = X.get(he);
          if (te !== void 0) {
            a.set(N, he);
            for (const de of te) {
              if (t.has(N))
                break;
              de(N);
            }
          }
          if (ue === 0 && !_ && re !== void 0) {
            const de = re.get(he);
            if (de !== void 0)
              for (const De of de) {
                if (t.has(N))
                  break;
                De(N);
              }
          }
        }
      } else if (U === "bubble") {
        if (re === void 0)
          return;
        for (let ue = 0; ue < Z.length && !e.has(N); ++ue) {
          const he = Z[ue], te = re.get(he);
          if (te !== void 0) {
            a.set(N, he);
            for (const de of te) {
              if (t.has(N))
                break;
              de(N);
            }
          }
        }
      }
      o(N, "stopPropagation"), o(N, "stopImmediatePropagation"), d(N);
    };
    return E.displayName = "evtdUnifiedHandler", E;
  }
  function m() {
    const E = function(N) {
      const { type: I, eventPhase: $ } = N;
      if ($ !== 2)
        return;
      const _ = h[I];
      _ !== void 0 && _.forEach((R) => R(N));
    };
    return E.displayName = "evtdUnifiedWindowEventHandler", E;
  }
  const v = g(), w = m();
  function x(E, N) {
    const I = f[E];
    return I[N] === void 0 && (I[N] = /* @__PURE__ */ new Map(), window.addEventListener(N, v, E === "capture")), I[N];
  }
  function y(E) {
    return h[E] === void 0 && (h[E] = /* @__PURE__ */ new Set(), window.addEventListener(E, w)), h[E];
  }
  function C(E, N) {
    let I = E.get(N);
    return I === void 0 && E.set(N, I = /* @__PURE__ */ new Set()), I;
  }
  function S(E, N, I, $) {
    const _ = f[N][I];
    if (_ !== void 0) {
      const R = _.get(E);
      if (R !== void 0 && R.has($))
        return !0;
    }
    return !1;
  }
  function T(E, N) {
    const I = h[E];
    return !!(I !== void 0 && I.has(N));
  }
  function A(E, N, I, $) {
    let _;
    if (typeof $ == "object" && $.once === !0 ? _ = (X) => {
      D(E, N, _, $), I(X);
    } : _ = I, pX(E, N, _, $))
      return;
    const U = $ === !0 || typeof $ == "object" && $.capture === !0 ? "capture" : "bubble", Q = x(U, E), Z = C(Q, N);
    if (Z.has(_) || Z.add(_), N === window) {
      const X = y(E);
      X.has(_) || X.add(_);
    }
  }
  function D(E, N, I, $) {
    if (gX(E, N, I, $))
      return;
    const R = $ === !0 || typeof $ == "object" && $.capture === !0, U = R ? "capture" : "bubble", Q = x(U, E), Z = C(Q, N);
    if (N === window && !S(N, R ? "bubble" : "capture", E, I) && T(E, I)) {
      const re = h[E];
      re.delete(I), re.size === 0 && (window.removeEventListener(E, w), h[E] = void 0);
    }
    Z.has(I) && Z.delete(I), Z.size === 0 && Q.delete(N), Q.size === 0 && (window.removeEventListener(E, v, U === "capture"), f[U][E] = void 0);
  }
  return {
    on: A,
    off: D
  };
}
const { on: Mr, off: hr } = mX(), Ov = G(null);
function RL(e) {
  if (e.clientX > 0 || e.clientY > 0)
    Ov.value = {
      x: e.clientX,
      y: e.clientY
    };
  else {
    const { target: t } = e;
    if (t instanceof Element) {
      const { left: r, top: n, width: i, height: o } = t.getBoundingClientRect();
      r > 0 || n > 0 ? Ov.value = {
        x: r + i / 2,
        y: n + o / 2
      } : Ov.value = { x: 0, y: 0 };
    } else
      Ov.value = null;
  }
}
let Kb = 0, jL = !0;
function vX() {
  if (!ZO)
    return vc(G(null));
  Kb === 0 && Mr("click", document, RL, !0);
  const e = () => {
    Kb += 1;
  };
  return jL && (jL = GO()) ? (ch(e), Gr(() => {
    Kb -= 1, Kb === 0 && hr("click", document, RL, !0);
  })) : e(), vc(Ov);
}
const bX = G(void 0);
let Xb = 0;
function FL() {
  bX.value = Date.now();
}
let BL = !0;
function yX(e) {
  if (!ZO)
    return vc(G(!1));
  const t = G(!1);
  let r = null;
  function n() {
    r !== null && window.clearTimeout(r);
  }
  function i() {
    n(), t.value = !0, r = window.setTimeout(() => {
      t.value = !1;
    }, e);
  }
  Xb === 0 && Mr("click", window, FL, !0);
  const o = () => {
    Xb += 1, Mr("click", window, i, !0);
  };
  return BL && (BL = GO()) ? (ch(o), Gr(() => {
    Xb -= 1, Xb === 0 && hr("click", window, FL, !0), hr("click", window, i, !0), n();
  })) : o(), vc(t);
}
function dn(e, t) {
  return Gt(e, (r) => {
    r !== void 0 && (t.value = r);
  }), j(() => e.value === void 0 ? t.value : e.value);
}
function ql() {
  const e = G(!1);
  return br(() => {
    e.value = !0;
  }), vc(e);
}
function pp(e, t) {
  return j(() => {
    for (const r of t)
      if (e[r] !== void 0)
        return e[r];
    return e[t[t.length - 1]];
  });
}
const xX = (typeof window > "u" ? !1 : /iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) && !window.MSStream;
function wX() {
  return xX;
}
function KO(e = {}, t) {
  const r = UO({
    ctrl: !1,
    command: !1,
    win: !1,
    shift: !1,
    tab: !1
  }), { keydown: n, keyup: i } = e, o = (u) => {
    switch (u.key) {
      case "Control":
        r.ctrl = !0;
        break;
      case "Meta":
        r.command = !0, r.win = !0;
        break;
      case "Shift":
        r.shift = !0;
        break;
      case "Tab":
        r.tab = !0;
        break;
    }
    n !== void 0 && Object.keys(n).forEach((d) => {
      if (d !== u.key)
        return;
      const f = n[d];
      if (typeof f == "function")
        f(u);
      else {
        const { stop: h = !1, prevent: g = !1 } = f;
        h && u.stopPropagation(), g && u.preventDefault(), f.handler(u);
      }
    });
  }, a = (u) => {
    switch (u.key) {
      case "Control":
        r.ctrl = !1;
        break;
      case "Meta":
        r.command = !1, r.win = !1;
        break;
      case "Shift":
        r.shift = !1;
        break;
      case "Tab":
        r.tab = !1;
        break;
    }
    i !== void 0 && Object.keys(i).forEach((d) => {
      if (d !== u.key)
        return;
      const f = i[d];
      if (typeof f == "function")
        f(u);
      else {
        const { stop: h = !1, prevent: g = !1 } = f;
        h && u.stopPropagation(), g && u.preventDefault(), f.handler(u);
      }
    });
  }, s = () => {
    (t === void 0 || t.value) && (Mr("keydown", document, o), Mr("keyup", document, a)), t !== void 0 && Gt(t, (u) => {
      u ? (Mr("keydown", document, o), Mr("keyup", document, a)) : (hr("keydown", document, o), hr("keyup", document, a));
    });
  };
  return GO() ? (ch(s), Gr(() => {
    (t === void 0 || t.value) && (hr("keydown", document, o), hr("keyup", document, a));
  })) : s(), vc(r);
}
const XO = "n-internal-select-menu", TU = "n-internal-select-menu-body", pb = "n-modal-body", kU = "n-modal", gb = "n-drawer-body", JO = "n-drawer", Up = "n-popover-body", DU = "__disabled__";
function vi(e) {
  const t = lt(pb, null), r = lt(gb, null), n = lt(Up, null), i = lt(TU, null), o = G();
  if (typeof document < "u") {
    o.value = document.fullscreenElement;
    const a = () => {
      o.value = document.fullscreenElement;
    };
    br(() => {
      Mr("fullscreenchange", document, a);
    }), Gr(() => {
      hr("fullscreenchange", document, a);
    });
  }
  return _r(() => {
    var a;
    const { to: s } = e;
    return s !== void 0 ? s === !1 ? DU : s === !0 ? o.value || "body" : s : t != null && t.value ? (a = t.value.$el) !== null && a !== void 0 ? a : t.value : r != null && r.value ? r.value : n != null && n.value ? n.value : i != null && i.value ? i.value : s ?? (o.value || "body");
  });
}
vi.tdkey = DU;
vi.propTo = {
  type: [String, Object, Boolean],
  default: void 0
};
let UL = !1;
function MX() {
  if (Is && window.CSS && !UL && (UL = !0, "registerProperty" in (window == null ? void 0 : window.CSS)))
    try {
      CSS.registerProperty({
        name: "--n-color-start",
        syntax: "<color>",
        inherits: !1,
        initialValue: "#0000"
      }), CSS.registerProperty({
        name: "--n-color-end",
        syntax: "<color>",
        inherits: !1,
        initialValue: "#0000"
      });
    } catch {
    }
}
function az(e, t, r = "default") {
  const n = t[r];
  if (n === void 0)
    throw new Error(`[vueuc/${e}]: slot[${r}] is empty.`);
  return n();
}
function lz(e, t = !0, r = []) {
  return e.forEach((n) => {
    if (n !== null) {
      if (typeof n != "object") {
        (typeof n == "string" || typeof n == "number") && r.push(zr(String(n)));
        return;
      }
      if (Array.isArray(n)) {
        lz(n, t, r);
        return;
      }
      if (n.type === Lr) {
        if (n.children === null)
          return;
        Array.isArray(n.children) && lz(n.children, t, r);
      } else
        n.type !== BO && r.push(n);
    }
  }), r;
}
function HL(e, t, r = "default") {
  const n = t[r];
  if (n === void 0)
    throw new Error(`[vueuc/${e}]: slot[${r}] is empty.`);
  const i = lz(n());
  if (i.length === 1)
    return i[0];
  throw new Error(`[vueuc/${e}]: slot[${r}] should have exactly one child.`);
}
let qu = null;
function AU() {
  if (qu === null && (qu = document.getElementById("v-binder-view-measurer"), qu === null)) {
    qu = document.createElement("div"), qu.id = "v-binder-view-measurer";
    const { style: e } = qu;
    e.position = "fixed", e.left = "0", e.right = "0", e.top = "0", e.bottom = "0", e.pointerEvents = "none", e.visibility = "hidden", document.body.appendChild(qu);
  }
  return qu.getBoundingClientRect();
}
function CX(e, t) {
  const r = AU();
  return {
    top: t,
    left: e,
    height: 0,
    width: 0,
    right: r.width - e,
    bottom: r.height - t
  };
}
function xI(e) {
  const t = e.getBoundingClientRect(), r = AU();
  return {
    left: t.left - r.left,
    top: t.top - r.top,
    bottom: r.height + r.top - t.bottom,
    right: r.width + r.left - t.right,
    width: t.width,
    height: t.height
  };
}
function SX(e) {
  return e.nodeType === 9 ? null : e.parentNode;
}
function EU(e) {
  if (e === null)
    return null;
  const t = SX(e);
  if (t === null)
    return null;
  if (t.nodeType === 9)
    return document;
  if (t.nodeType === 1) {
    const { overflow: r, overflowX: n, overflowY: i } = getComputedStyle(t);
    if (/(auto|scroll|overlay)/.test(r + i + n))
      return t;
  }
  return EU(t);
}
const TX = oe({
  name: "Binder",
  props: {
    syncTargetWithParent: Boolean,
    syncTarget: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    var t;
    tr("VBinder", (t = uh()) === null || t === void 0 ? void 0 : t.proxy);
    const r = lt("VBinder", null), n = G(null), i = (y) => {
      n.value = y, r && e.syncTargetWithParent && r.setTargetRef(y);
    };
    let o = [];
    const a = () => {
      let y = n.value;
      for (; y = EU(y), y !== null; )
        o.push(y);
      for (const C of o)
        Mr("scroll", C, h, !0);
    }, s = () => {
      for (const y of o)
        hr("scroll", y, h, !0);
      o = [];
    }, u = /* @__PURE__ */ new Set(), d = (y) => {
      u.size === 0 && a(), u.has(y) || u.add(y);
    }, f = (y) => {
      u.has(y) && u.delete(y), u.size === 0 && s();
    }, h = () => {
      m0(g);
    }, g = () => {
      u.forEach((y) => y());
    }, m = /* @__PURE__ */ new Set(), v = (y) => {
      m.size === 0 && Mr("resize", window, x), m.has(y) || m.add(y);
    }, w = (y) => {
      m.has(y) && m.delete(y), m.size === 0 && hr("resize", window, x);
    }, x = () => {
      m.forEach((y) => y());
    };
    return Gr(() => {
      hr("resize", window, x), s();
    }), {
      targetRef: n,
      setTargetRef: i,
      addScrollListener: d,
      removeScrollListener: f,
      addResizeListener: v,
      removeResizeListener: w
    };
  },
  render() {
    return az("binder", this.$slots);
  }
});
var zc = TX, $c = oe({
  name: "Target",
  setup() {
    const { setTargetRef: e, syncTarget: t } = lt("VBinder");
    return {
      syncTarget: t,
      setTargetDirective: {
        mounted: e,
        updated: e
      }
    };
  },
  render() {
    const { syncTarget: e, setTargetDirective: t } = this;
    return e ? Jn(HL("follower", this.$slots), [
      [t]
    ]) : HL("follower", this.$slots);
  }
});
const Ch = "@@mmoContext", kX = {
  mounted(e, { value: t }) {
    e[Ch] = {
      handler: void 0
    }, typeof t == "function" && (e[Ch].handler = t, Mr("mousemoveoutside", e, t));
  },
  updated(e, { value: t }) {
    const r = e[Ch];
    typeof t == "function" ? r.handler ? r.handler !== t && (hr("mousemoveoutside", e, r.handler), r.handler = t, Mr("mousemoveoutside", e, t)) : (e[Ch].handler = t, Mr("mousemoveoutside", e, t)) : r.handler && (hr("mousemoveoutside", e, r.handler), r.handler = void 0);
  },
  unmounted(e) {
    const { handler: t } = e[Ch];
    t && hr("mousemoveoutside", e, t), e[Ch].handler = void 0;
  }
};
var DX = kX;
const Sh = "@@coContext", AX = {
  mounted(e, { value: t, modifiers: r }) {
    e[Sh] = {
      handler: void 0
    }, typeof t == "function" && (e[Sh].handler = t, Mr("clickoutside", e, t, {
      capture: r.capture
    }));
  },
  updated(e, { value: t, modifiers: r }) {
    const n = e[Sh];
    typeof t == "function" ? n.handler ? n.handler !== t && (hr("clickoutside", e, n.handler, {
      capture: r.capture
    }), n.handler = t, Mr("clickoutside", e, t, {
      capture: r.capture
    })) : (e[Sh].handler = t, Mr("clickoutside", e, t, {
      capture: r.capture
    })) : n.handler && (hr("clickoutside", e, n.handler, {
      capture: r.capture
    }), n.handler = void 0);
  },
  unmounted(e, { modifiers: t }) {
    const { handler: r } = e[Sh];
    r && hr("clickoutside", e, r, {
      capture: t.capture
    }), e[Sh].handler = void 0;
  }
};
var ks = AX;
function EX(e, t) {
  console.error(`[vdirs/${e}]: ${t}`);
}
class IX {
  constructor() {
    this.elementZIndex = /* @__PURE__ */ new Map(), this.nextZIndex = 2e3;
  }
  get elementCount() {
    return this.elementZIndex.size;
  }
  ensureZIndex(t, r) {
    const { elementZIndex: n } = this;
    if (r !== void 0) {
      t.style.zIndex = `${r}`, n.delete(t);
      return;
    }
    const { nextZIndex: i } = this;
    n.has(t) && n.get(t) + 1 === this.nextZIndex || (t.style.zIndex = `${i}`, n.set(t, i), this.nextZIndex = i + 1, this.squashState());
  }
  unregister(t, r) {
    const { elementZIndex: n } = this;
    n.has(t) ? n.delete(t) : r === void 0 && EX("z-index-manager/unregister-element", "Element not found when unregistering."), this.squashState();
  }
  squashState() {
    const { elementCount: t } = this;
    t || (this.nextZIndex = 2e3), this.nextZIndex - t > 2500 && this.rearrange();
  }
  rearrange() {
    const t = Array.from(this.elementZIndex.entries());
    t.sort((r, n) => r[1] - n[1]), this.nextZIndex = 2e3, t.forEach((r) => {
      const n = r[0], i = this.nextZIndex++;
      `${i}` !== n.style.zIndex && (n.style.zIndex = `${i}`);
    });
  }
}
var wI = new IX();
const Th = "@@ziContext", NX = {
  mounted(e, t) {
    const { value: r = {} } = t, { zIndex: n, enabled: i } = r;
    e[Th] = {
      enabled: !!i,
      initialized: !1
    }, i && (wI.ensureZIndex(e, n), e[Th].initialized = !0);
  },
  updated(e, t) {
    const { value: r = {} } = t, { zIndex: n, enabled: i } = r, o = e[Th].enabled;
    i && !o && (wI.ensureZIndex(e, n), e[Th].initialized = !0), e[Th].enabled = !!i;
  },
  unmounted(e, t) {
    if (!e[Th].initialized)
      return;
    const { value: r = {} } = t, { zIndex: n } = r;
    wI.unregister(e, n);
  }
};
var mb = NX;
const IU = Symbol("@css-render/vue3-ssr");
function zX(e, t) {
  return `<style cssr-id="${e}">
${t}
</style>`;
}
function $X(e, t) {
  const r = lt(IU, null);
  if (r === null) {
    console.error("[css-render/vue3-ssr]: no ssr context found.");
    return;
  }
  const { styles: n, ids: i } = r;
  i.has(e) || n !== null && (i.add(e), n.push(zX(e, t)));
}
const OX = typeof document < "u";
function Oc() {
  if (OX)
    return;
  const e = lt(IU, null);
  if (e !== null)
    return {
      adapter: $X,
      context: e
    };
}
function WL(e, t) {
  console.error(`[vueuc/${e}]: ${t}`);
}
const { c: fs } = mU(), zM = "vueuc-style";
function VL(e) {
  return e & -e;
}
class _X {
  constructor(t, r) {
    this.l = t, this.min = r;
    const n = new Array(t + 1);
    for (let i = 0; i < t + 1; ++i)
      n[i] = 0;
    this.ft = n;
  }
  add(t, r) {
    if (r === 0)
      return;
    const { l: n, ft: i } = this;
    for (t += 1; t <= n; )
      i[t] += r, t += VL(t);
  }
  get(t) {
    return this.sum(t + 1) - this.sum(t);
  }
  sum(t) {
    if (t === void 0 && (t = this.l), t <= 0)
      return 0;
    const { ft: r, min: n, l: i } = this;
    if (t > i)
      throw new Error("[FinweckTree.sum]: `i` is larger than length.");
    let o = t * n;
    for (; t > 0; )
      o += r[t], t -= VL(t);
    return o;
  }
  getBound(t) {
    let r = 0, n = this.l;
    for (; n > r; ) {
      const i = Math.floor((r + n) / 2), o = this.sum(i);
      if (o > t) {
        n = i;
        continue;
      } else if (o < t) {
        if (r === i)
          return this.sum(r + 1) <= t ? r + 1 : i;
        r = i;
      } else
        return i;
    }
    return r;
  }
}
function YL(e) {
  return typeof e == "string" ? document.querySelector(e) : e();
}
var $M = oe({
  name: "LazyTeleport",
  props: {
    to: {
      type: [String, Object],
      default: void 0
    },
    disabled: Boolean,
    show: {
      type: Boolean,
      required: !0
    }
  },
  setup(e) {
    return {
      showTeleport: MU(tt(e, "show")),
      mergedTo: j(() => {
        const { to: t } = e;
        return t ?? "body";
      })
    };
  },
  render() {
    return this.showTeleport ? this.disabled ? az("lazy-teleport", this.$slots) : b(AM, {
      disabled: this.disabled,
      to: this.mergedTo
    }, az("lazy-teleport", this.$slots)) : null;
  }
});
const Jb = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, QL = {
  start: "end",
  center: "center",
  end: "start"
}, MI = {
  top: "height",
  bottom: "height",
  left: "width",
  right: "width"
}, LX = {
  "bottom-start": "top left",
  bottom: "top center",
  "bottom-end": "top right",
  "top-start": "bottom left",
  top: "bottom center",
  "top-end": "bottom right",
  "right-start": "top left",
  right: "center left",
  "right-end": "bottom left",
  "left-start": "top right",
  left: "center right",
  "left-end": "bottom right"
}, PX = {
  "bottom-start": "bottom left",
  bottom: "bottom center",
  "bottom-end": "bottom right",
  "top-start": "top left",
  top: "top center",
  "top-end": "top right",
  "right-start": "top right",
  right: "center right",
  "right-end": "bottom right",
  "left-start": "top left",
  left: "center left",
  "left-end": "bottom left"
}, RX = {
  "bottom-start": "right",
  "bottom-end": "left",
  "top-start": "right",
  "top-end": "left",
  "right-start": "bottom",
  "right-end": "top",
  "left-start": "bottom",
  "left-end": "top"
}, qL = {
  top: !0,
  bottom: !1,
  left: !0,
  right: !1
}, GL = {
  top: "end",
  bottom: "start",
  left: "end",
  right: "start"
};
function jX(e, t, r, n, i, o) {
  if (!i || o)
    return { placement: e, top: 0, left: 0 };
  const [a, s] = e.split("-");
  let u = s ?? "center", d = {
    top: 0,
    left: 0
  };
  const f = (m, v, w) => {
    let x = 0, y = 0;
    const C = r[m] - t[v] - t[m];
    return C > 0 && n && (w ? y = qL[v] ? C : -C : x = qL[v] ? C : -C), {
      left: x,
      top: y
    };
  }, h = a === "left" || a === "right";
  if (u !== "center") {
    const m = RX[e], v = Jb[m], w = MI[m];
    if (r[w] > t[w]) {
      if (t[m] + t[w] < r[w]) {
        const x = (r[w] - t[w]) / 2;
        t[m] < x || t[v] < x ? t[m] < t[v] ? (u = QL[s], d = f(w, v, h)) : d = f(w, m, h) : u = "center";
      }
    } else
      r[w] < t[w] && t[v] < 0 && t[m] > t[v] && (u = QL[s]);
  } else {
    const m = a === "bottom" || a === "top" ? "left" : "top", v = Jb[m], w = MI[m], x = (r[w] - t[w]) / 2;
    (t[m] < x || t[v] < x) && (t[m] > t[v] ? (u = GL[m], d = f(w, m, h)) : (u = GL[v], d = f(w, v, h)));
  }
  let g = a;
  return t[a] < r[MI[a]] && t[a] < t[Jb[a]] && (g = Jb[a]), {
    placement: u !== "center" ? `${g}-${u}` : g,
    left: d.left,
    top: d.top
  };
}
function FX(e, t) {
  return t ? PX[e] : LX[e];
}
function BX(e, t, r, n, i, o) {
  if (o)
    switch (e) {
      case "bottom-start":
        return {
          top: `${Math.round(r.top - t.top + r.height)}px`,
          left: `${Math.round(r.left - t.left)}px`,
          transform: "translateY(-100%)"
        };
      case "bottom-end":
        return {
          top: `${Math.round(r.top - t.top + r.height)}px`,
          left: `${Math.round(r.left - t.left + r.width)}px`,
          transform: "translateX(-100%) translateY(-100%)"
        };
      case "top-start":
        return {
          top: `${Math.round(r.top - t.top)}px`,
          left: `${Math.round(r.left - t.left)}px`,
          transform: ""
        };
      case "top-end":
        return {
          top: `${Math.round(r.top - t.top)}px`,
          left: `${Math.round(r.left - t.left + r.width)}px`,
          transform: "translateX(-100%)"
        };
      case "right-start":
        return {
          top: `${Math.round(r.top - t.top)}px`,
          left: `${Math.round(r.left - t.left + r.width)}px`,
          transform: "translateX(-100%)"
        };
      case "right-end":
        return {
          top: `${Math.round(r.top - t.top + r.height)}px`,
          left: `${Math.round(r.left - t.left + r.width)}px`,
          transform: "translateX(-100%) translateY(-100%)"
        };
      case "left-start":
        return {
          top: `${Math.round(r.top - t.top)}px`,
          left: `${Math.round(r.left - t.left)}px`,
          transform: ""
        };
      case "left-end":
        return {
          top: `${Math.round(r.top - t.top + r.height)}px`,
          left: `${Math.round(r.left - t.left)}px`,
          transform: "translateY(-100%)"
        };
      case "top":
        return {
          top: `${Math.round(r.top - t.top)}px`,
          left: `${Math.round(r.left - t.left + r.width / 2)}px`,
          transform: "translateX(-50%)"
        };
      case "right":
        return {
          top: `${Math.round(r.top - t.top + r.height / 2)}px`,
          left: `${Math.round(r.left - t.left + r.width)}px`,
          transform: "translateX(-100%) translateY(-50%)"
        };
      case "left":
        return {
          top: `${Math.round(r.top - t.top + r.height / 2)}px`,
          left: `${Math.round(r.left - t.left)}px`,
          transform: "translateY(-50%)"
        };
      case "bottom":
      default:
        return {
          top: `${Math.round(r.top - t.top + r.height)}px`,
          left: `${Math.round(r.left - t.left + r.width / 2)}px`,
          transform: "translateX(-50%) translateY(-100%)"
        };
    }
  switch (e) {
    case "bottom-start":
      return {
        top: `${Math.round(r.top - t.top + r.height + n)}px`,
        left: `${Math.round(r.left - t.left + i)}px`,
        transform: ""
      };
    case "bottom-end":
      return {
        top: `${Math.round(r.top - t.top + r.height + n)}px`,
        left: `${Math.round(r.left - t.left + r.width + i)}px`,
        transform: "translateX(-100%)"
      };
    case "top-start":
      return {
        top: `${Math.round(r.top - t.top + n)}px`,
        left: `${Math.round(r.left - t.left + i)}px`,
        transform: "translateY(-100%)"
      };
    case "top-end":
      return {
        top: `${Math.round(r.top - t.top + n)}px`,
        left: `${Math.round(r.left - t.left + r.width + i)}px`,
        transform: "translateX(-100%) translateY(-100%)"
      };
    case "right-start":
      return {
        top: `${Math.round(r.top - t.top + n)}px`,
        left: `${Math.round(r.left - t.left + r.width + i)}px`,
        transform: ""
      };
    case "right-end":
      return {
        top: `${Math.round(r.top - t.top + r.height + n)}px`,
        left: `${Math.round(r.left - t.left + r.width + i)}px`,
        transform: "translateY(-100%)"
      };
    case "left-start":
      return {
        top: `${Math.round(r.top - t.top + n)}px`,
        left: `${Math.round(r.left - t.left + i)}px`,
        transform: "translateX(-100%)"
      };
    case "left-end":
      return {
        top: `${Math.round(r.top - t.top + r.height + n)}px`,
        left: `${Math.round(r.left - t.left + i)}px`,
        transform: "translateX(-100%) translateY(-100%)"
      };
    case "top":
      return {
        top: `${Math.round(r.top - t.top + n)}px`,
        left: `${Math.round(r.left - t.left + r.width / 2 + i)}px`,
        transform: "translateY(-100%) translateX(-50%)"
      };
    case "right":
      return {
        top: `${Math.round(r.top - t.top + r.height / 2 + n)}px`,
        left: `${Math.round(r.left - t.left + r.width + i)}px`,
        transform: "translateY(-50%)"
      };
    case "left":
      return {
        top: `${Math.round(r.top - t.top + r.height / 2 + n)}px`,
        left: `${Math.round(r.left - t.left + i)}px`,
        transform: "translateY(-50%) translateX(-100%)"
      };
    case "bottom":
    default:
      return {
        top: `${Math.round(r.top - t.top + r.height + n)}px`,
        left: `${Math.round(r.left - t.left + r.width / 2 + i)}px`,
        transform: "translateX(-50%)"
      };
  }
}
const UX = fs([
  fs(".v-binder-follower-container", {
    position: "absolute",
    left: "0",
    right: "0",
    top: "0",
    height: "0",
    pointerEvents: "none",
    zIndex: "auto"
  }),
  fs(".v-binder-follower-content", {
    position: "absolute",
    zIndex: "auto"
  }, [
    fs("> *", {
      pointerEvents: "all"
    })
  ])
]);
var _c = oe({
  name: "Follower",
  inheritAttrs: !1,
  props: {
    show: Boolean,
    enabled: {
      type: Boolean,
      default: void 0
    },
    placement: {
      type: String,
      default: "bottom"
    },
    syncTrigger: {
      type: Array,
      default: ["resize", "scroll"]
    },
    to: [String, Object],
    flip: {
      type: Boolean,
      default: !0
    },
    internalShift: Boolean,
    x: Number,
    y: Number,
    width: String,
    minWidth: String,
    containerClass: String,
    teleportDisabled: Boolean,
    zindexable: {
      type: Boolean,
      default: !0
    },
    zIndex: Number,
    overlap: Boolean
  },
  setup(e) {
    const t = lt("VBinder"), r = _r(() => e.enabled !== void 0 ? e.enabled : e.show), n = G(null), i = G(null), o = () => {
      const { syncTrigger: g } = e;
      g.includes("scroll") && t.addScrollListener(u), g.includes("resize") && t.addResizeListener(u);
    }, a = () => {
      t.removeScrollListener(u), t.removeResizeListener(u);
    };
    br(() => {
      r.value && (u(), o());
    });
    const s = Oc();
    UX.mount({
      id: "vueuc/binder",
      head: !0,
      anchorMetaName: zM,
      ssr: s
    }), Gr(() => {
      a();
    }), CU(() => {
      r.value && u();
    });
    const u = () => {
      if (!r.value)
        return;
      const g = n.value;
      if (g === null)
        return;
      const m = t.targetRef, { x: v, y: w, overlap: x } = e, y = v !== void 0 && w !== void 0 ? CX(v, w) : xI(m);
      g.style.setProperty("--v-target-width", `${Math.round(y.width)}px`), g.style.setProperty("--v-target-height", `${Math.round(y.height)}px`);
      const { width: C, minWidth: S, placement: T, internalShift: A, flip: D } = e;
      g.setAttribute("v-placement", T), x ? g.setAttribute("v-overlap", "") : g.removeAttribute("v-overlap");
      const { style: E } = g;
      C === "target" ? E.width = `${y.width}px` : C !== void 0 ? E.width = C : E.width = "", S === "target" ? E.minWidth = `${y.width}px` : S !== void 0 ? E.minWidth = S : E.minWidth = "";
      const N = xI(g), I = xI(i.value), { left: $, top: _, placement: R } = jX(T, y, N, A, D, x), U = FX(R, x), { left: Q, top: Z, transform: X } = BX(R, I, y, _, $, x);
      g.setAttribute("v-placement", R), g.style.setProperty("--v-offset-left", `${Math.round($)}px`), g.style.setProperty("--v-offset-top", `${Math.round(_)}px`), g.style.transform = `translateX(${Q}) translateY(${Z}) ${X}`, g.style.setProperty("--v-transform-origin", U), g.style.transformOrigin = U;
    };
    Gt(r, (g) => {
      g ? (o(), d()) : a();
    });
    const d = () => {
      an().then(u).catch((g) => console.error(g));
    };
    [
      "placement",
      "x",
      "y",
      "internalShift",
      "flip",
      "width",
      "overlap",
      "minWidth"
    ].forEach((g) => {
      Gt(tt(e, g), u);
    }), ["teleportDisabled"].forEach((g) => {
      Gt(tt(e, g), d);
    }), Gt(tt(e, "syncTrigger"), (g) => {
      g.includes("resize") ? t.addResizeListener(u) : t.removeResizeListener(u), g.includes("scroll") ? t.addScrollListener(u) : t.removeScrollListener(u);
    });
    const f = ql(), h = _r(() => {
      const { to: g } = e;
      if (g !== void 0)
        return g;
      f.value;
    });
    return {
      VBinder: t,
      mergedEnabled: r,
      offsetContainerRef: i,
      followerRef: n,
      mergedTo: h,
      syncPosition: u
    };
  },
  render() {
    return b($M, {
      show: this.show,
      to: this.mergedTo,
      disabled: this.teleportDisabled
    }, {
      default: () => {
        var e, t;
        const r = b("div", {
          class: ["v-binder-follower-container", this.containerClass],
          ref: "offsetContainerRef"
        }, [
          b("div", {
            class: "v-binder-follower-content",
            ref: "followerRef"
          }, (t = (e = this.$slots).default) === null || t === void 0 ? void 0 : t.call(e))
        ]);
        return this.zindexable ? Jn(r, [
          [
            mb,
            {
              enabled: this.mergedEnabled,
              zIndex: this.zIndex
            }
          ]
        ]) : r;
      }
    });
  }
}), Uf = [], HX = function() {
  return Uf.some(function(e) {
    return e.activeTargets.length > 0;
  });
}, WX = function() {
  return Uf.some(function(e) {
    return e.skippedTargets.length > 0;
  });
}, ZL = "ResizeObserver loop completed with undelivered notifications.", VX = function() {
  var e;
  typeof ErrorEvent == "function" ? e = new ErrorEvent("error", {
    message: ZL
  }) : (e = document.createEvent("Event"), e.initEvent("error", !1, !1), e.message = ZL), window.dispatchEvent(e);
}, w0;
(function(e) {
  e.BORDER_BOX = "border-box", e.CONTENT_BOX = "content-box", e.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
})(w0 || (w0 = {}));
var Hf = function(e) {
  return Object.freeze(e);
}, YX = function() {
  function e(t, r) {
    this.inlineSize = t, this.blockSize = r, Hf(this);
  }
  return e;
}(), NU = function() {
  function e(t, r, n, i) {
    return this.x = t, this.y = r, this.width = n, this.height = i, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, Hf(this);
  }
  return e.prototype.toJSON = function() {
    var t = this, r = t.x, n = t.y, i = t.top, o = t.right, a = t.bottom, s = t.left, u = t.width, d = t.height;
    return { x: r, y: n, top: i, right: o, bottom: a, left: s, width: u, height: d };
  }, e.fromRect = function(t) {
    return new e(t.x, t.y, t.width, t.height);
  }, e;
}(), e4 = function(e) {
  return e instanceof SVGElement && "getBBox" in e;
}, zU = function(e) {
  if (e4(e)) {
    var t = e.getBBox(), r = t.width, n = t.height;
    return !r && !n;
  }
  var i = e, o = i.offsetWidth, a = i.offsetHeight;
  return !(o || a || e.getClientRects().length);
}, KL = function(e) {
  var t;
  if (e instanceof Element)
    return !0;
  var r = (t = e == null ? void 0 : e.ownerDocument) === null || t === void 0 ? void 0 : t.defaultView;
  return !!(r && e instanceof r.Element);
}, QX = function(e) {
  switch (e.tagName) {
    case "INPUT":
      if (e.type !== "image")
        break;
    case "VIDEO":
    case "AUDIO":
    case "EMBED":
    case "OBJECT":
    case "CANVAS":
    case "IFRAME":
    case "IMG":
      return !0;
  }
  return !1;
}, Kv = typeof window < "u" ? window : {}, ey = /* @__PURE__ */ new WeakMap(), XL = /auto|scroll/, qX = /^tb|vertical/, GX = /msie|trident/i.test(Kv.navigator && Kv.navigator.userAgent), rs = function(e) {
  return parseFloat(e || "0");
}, rp = function(e, t, r) {
  return e === void 0 && (e = 0), t === void 0 && (t = 0), r === void 0 && (r = !1), new YX((r ? t : e) || 0, (r ? e : t) || 0);
}, JL = Hf({
  devicePixelContentBoxSize: rp(),
  borderBoxSize: rp(),
  contentBoxSize: rp(),
  contentRect: new NU(0, 0, 0, 0)
}), $U = function(e, t) {
  if (t === void 0 && (t = !1), ey.has(e) && !t)
    return ey.get(e);
  if (zU(e))
    return ey.set(e, JL), JL;
  var r = getComputedStyle(e), n = e4(e) && e.ownerSVGElement && e.getBBox(), i = !GX && r.boxSizing === "border-box", o = qX.test(r.writingMode || ""), a = !n && XL.test(r.overflowY || ""), s = !n && XL.test(r.overflowX || ""), u = n ? 0 : rs(r.paddingTop), d = n ? 0 : rs(r.paddingRight), f = n ? 0 : rs(r.paddingBottom), h = n ? 0 : rs(r.paddingLeft), g = n ? 0 : rs(r.borderTopWidth), m = n ? 0 : rs(r.borderRightWidth), v = n ? 0 : rs(r.borderBottomWidth), w = n ? 0 : rs(r.borderLeftWidth), x = h + d, y = u + f, C = w + m, S = g + v, T = s ? e.offsetHeight - S - e.clientHeight : 0, A = a ? e.offsetWidth - C - e.clientWidth : 0, D = i ? x + C : 0, E = i ? y + S : 0, N = n ? n.width : rs(r.width) - D - A, I = n ? n.height : rs(r.height) - E - T, $ = N + x + A + C, _ = I + y + T + S, R = Hf({
    devicePixelContentBoxSize: rp(Math.round(N * devicePixelRatio), Math.round(I * devicePixelRatio), o),
    borderBoxSize: rp($, _, o),
    contentBoxSize: rp(N, I, o),
    contentRect: new NU(h, u, N, I)
  });
  return ey.set(e, R), R;
}, OU = function(e, t, r) {
  var n = $U(e, r), i = n.borderBoxSize, o = n.contentBoxSize, a = n.devicePixelContentBoxSize;
  switch (t) {
    case w0.DEVICE_PIXEL_CONTENT_BOX:
      return a;
    case w0.BORDER_BOX:
      return i;
    default:
      return o;
  }
}, ZX = function() {
  function e(t) {
    var r = $U(t);
    this.target = t, this.contentRect = r.contentRect, this.borderBoxSize = Hf([r.borderBoxSize]), this.contentBoxSize = Hf([r.contentBoxSize]), this.devicePixelContentBoxSize = Hf([r.devicePixelContentBoxSize]);
  }
  return e;
}(), _U = function(e) {
  if (zU(e))
    return 1 / 0;
  for (var t = 0, r = e.parentNode; r; )
    t += 1, r = r.parentNode;
  return t;
}, KX = function() {
  var e = 1 / 0, t = [];
  Uf.forEach(function(a) {
    if (a.activeTargets.length !== 0) {
      var s = [];
      a.activeTargets.forEach(function(d) {
        var f = new ZX(d.target), h = _U(d.target);
        s.push(f), d.lastReportedSize = OU(d.target, d.observedBox), h < e && (e = h);
      }), t.push(function() {
        a.callback.call(a.observer, s, a.observer);
      }), a.activeTargets.splice(0, a.activeTargets.length);
    }
  });
  for (var r = 0, n = t; r < n.length; r++) {
    var i = n[r];
    i();
  }
  return e;
}, e3 = function(e) {
  Uf.forEach(function(r) {
    r.activeTargets.splice(0, r.activeTargets.length), r.skippedTargets.splice(0, r.skippedTargets.length), r.observationTargets.forEach(function(i) {
      i.isActive() && (_U(i.target) > e ? r.activeTargets.push(i) : r.skippedTargets.push(i));
    });
  });
}, XX = function() {
  var e = 0;
  for (e3(e); HX(); )
    e = KX(), e3(e);
  return WX() && VX(), e > 0;
}, CI, LU = [], JX = function() {
  return LU.splice(0).forEach(function(e) {
    return e();
  });
}, eJ = function(e) {
  if (!CI) {
    var t = 0, r = document.createTextNode(""), n = { characterData: !0 };
    new MutationObserver(function() {
      return JX();
    }).observe(r, n), CI = function() {
      r.textContent = "".concat(t ? t-- : t++);
    };
  }
  LU.push(e), CI();
}, tJ = function(e) {
  eJ(function() {
    requestAnimationFrame(e);
  });
}, qy = 0, rJ = function() {
  return !!qy;
}, nJ = 250, iJ = { attributes: !0, characterData: !0, childList: !0, subtree: !0 }, t3 = [
  "resize",
  "load",
  "transitionend",
  "animationend",
  "animationstart",
  "animationiteration",
  "keyup",
  "keydown",
  "mouseup",
  "mousedown",
  "mouseover",
  "mouseout",
  "blur",
  "focus"
], r3 = function(e) {
  return e === void 0 && (e = 0), Date.now() + e;
}, SI = !1, oJ = function() {
  function e() {
    var t = this;
    this.stopped = !0, this.listener = function() {
      return t.schedule();
    };
  }
  return e.prototype.run = function(t) {
    var r = this;
    if (t === void 0 && (t = nJ), !SI) {
      SI = !0;
      var n = r3(t);
      tJ(function() {
        var i = !1;
        try {
          i = XX();
        } finally {
          if (SI = !1, t = n - r3(), !rJ())
            return;
          i ? r.run(1e3) : t > 0 ? r.run(t) : r.start();
        }
      });
    }
  }, e.prototype.schedule = function() {
    this.stop(), this.run();
  }, e.prototype.observe = function() {
    var t = this, r = function() {
      return t.observer && t.observer.observe(document.body, iJ);
    };
    document.body ? r() : Kv.addEventListener("DOMContentLoaded", r);
  }, e.prototype.start = function() {
    var t = this;
    this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), t3.forEach(function(r) {
      return Kv.addEventListener(r, t.listener, !0);
    }));
  }, e.prototype.stop = function() {
    var t = this;
    this.stopped || (this.observer && this.observer.disconnect(), t3.forEach(function(r) {
      return Kv.removeEventListener(r, t.listener, !0);
    }), this.stopped = !0);
  }, e;
}(), sz = new oJ(), n3 = function(e) {
  !qy && e > 0 && sz.start(), qy += e, !qy && sz.stop();
}, aJ = function(e) {
  return !e4(e) && !QX(e) && getComputedStyle(e).display === "inline";
}, lJ = function() {
  function e(t, r) {
    this.target = t, this.observedBox = r || w0.CONTENT_BOX, this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }
  return e.prototype.isActive = function() {
    var t = OU(this.target, this.observedBox, !0);
    return aJ(this.target) && (this.lastReportedSize = t), this.lastReportedSize.inlineSize !== t.inlineSize || this.lastReportedSize.blockSize !== t.blockSize;
  }, e;
}(), sJ = function() {
  function e(t, r) {
    this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = t, this.callback = r;
  }
  return e;
}(), ty = /* @__PURE__ */ new WeakMap(), i3 = function(e, t) {
  for (var r = 0; r < e.length; r += 1)
    if (e[r].target === t)
      return r;
  return -1;
}, ry = function() {
  function e() {
  }
  return e.connect = function(t, r) {
    var n = new sJ(t, r);
    ty.set(t, n);
  }, e.observe = function(t, r, n) {
    var i = ty.get(t), o = i.observationTargets.length === 0;
    i3(i.observationTargets, r) < 0 && (o && Uf.push(i), i.observationTargets.push(new lJ(r, n && n.box)), n3(1), sz.schedule());
  }, e.unobserve = function(t, r) {
    var n = ty.get(t), i = i3(n.observationTargets, r), o = n.observationTargets.length === 1;
    i >= 0 && (o && Uf.splice(Uf.indexOf(n), 1), n.observationTargets.splice(i, 1), n3(-1));
  }, e.disconnect = function(t) {
    var r = this, n = ty.get(t);
    n.observationTargets.slice().forEach(function(i) {
      return r.unobserve(t, i.target);
    }), n.activeTargets.splice(0, n.activeTargets.length);
  }, e;
}(), uJ = function() {
  function e(t) {
    if (arguments.length === 0)
      throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
    if (typeof t != "function")
      throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
    ry.connect(this, t);
  }
  return e.prototype.observe = function(t, r) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!KL(t))
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
    ry.observe(this, t, r);
  }, e.prototype.unobserve = function(t) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!KL(t))
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
    ry.unobserve(this, t);
  }, e.prototype.disconnect = function() {
    ry.disconnect(this);
  }, e.toString = function() {
    return "function ResizeObserver () { [polyfill code] }";
  }, e;
}();
class cJ {
  constructor() {
    this.handleResize = this.handleResize.bind(this), this.observer = new (typeof window < "u" && window.ResizeObserver || uJ)(this.handleResize), this.elHandlersMap = /* @__PURE__ */ new Map();
  }
  handleResize(t) {
    for (const r of t) {
      const n = this.elHandlersMap.get(r.target);
      n !== void 0 && n(r);
    }
  }
  registerHandler(t, r) {
    this.elHandlersMap.set(t, r), this.observer.observe(t);
  }
  unregisterHandler(t) {
    this.elHandlersMap.has(t) && (this.elHandlersMap.delete(t), this.observer.unobserve(t));
  }
}
var V1 = new cJ(), Hl = oe({
  name: "ResizeObserver",
  props: {
    onResize: Function
  },
  setup(e) {
    let t = !1;
    const r = uh().proxy;
    function n(i) {
      const { onResize: o } = e;
      o !== void 0 && o(i);
    }
    br(() => {
      const i = r.$el;
      if (i === void 0) {
        WL("resize-observer", "$el does not exist.");
        return;
      }
      if (i.nextElementSibling !== i.nextSibling && i.nodeType === 3 && i.nodeValue !== "") {
        WL("resize-observer", "$el can not be observed (it may be a text node).");
        return;
      }
      i.nextElementSibling !== null && (V1.registerHandler(i.nextElementSibling, n), t = !0);
    }), Gr(() => {
      t && V1.unregisterHandler(r.$el.nextElementSibling);
    });
  },
  render() {
    return nt(this.$slots, "default");
  }
});
let ny;
function dJ() {
  return ny === void 0 && ("matchMedia" in window ? ny = window.matchMedia("(pointer:coarse)").matches : ny = !1), ny;
}
let TI;
function o3() {
  return TI === void 0 && (TI = "chrome" in window ? window.devicePixelRatio : 1), TI;
}
const fJ = fs(".v-vl", {
  maxHeight: "inherit",
  height: "100%",
  overflow: "auto",
  minWidth: "1px"
}, [
  fs("&:not(.v-vl--show-scrollbar)", {
    scrollbarWidth: "none"
  }, [
    fs("&::-webkit-scrollbar, &::-webkit-scrollbar-track-piece, &::-webkit-scrollbar-thumb", {
      width: 0,
      height: 0,
      display: "none"
    })
  ])
]);
var M0 = oe({
  name: "VirtualList",
  inheritAttrs: !1,
  props: {
    showScrollbar: {
      type: Boolean,
      default: !0
    },
    items: {
      type: Array,
      default: () => []
    },
    itemSize: {
      type: Number,
      required: !0
    },
    itemResizable: Boolean,
    itemsStyle: [String, Object],
    visibleItemsTag: {
      type: [String, Object],
      default: "div"
    },
    visibleItemsProps: Object,
    ignoreItemResize: Boolean,
    onScroll: Function,
    onWheel: Function,
    onResize: Function,
    defaultScrollKey: [Number, String],
    defaultScrollIndex: Number,
    keyField: {
      type: String,
      default: "key"
    },
    paddingTop: {
      type: [Number, String],
      default: 0
    },
    paddingBottom: {
      type: [Number, String],
      default: 0
    }
  },
  setup(e) {
    const t = Oc();
    fJ.mount({
      id: "vueuc/virtual-list",
      head: !0,
      anchorMetaName: zM,
      ssr: t
    }), br(() => {
      const { defaultScrollIndex: _, defaultScrollKey: R } = e;
      _ != null ? v({ index: _ }) : R != null && v({ key: R });
    });
    let r = !1, n = !1;
    $B(() => {
      if (r = !1, !n) {
        n = !0;
        return;
      }
      v({ top: h.value, left: f });
    }), EM(() => {
      r = !0, n || (n = !0);
    });
    const i = j(() => {
      const _ = /* @__PURE__ */ new Map(), { keyField: R } = e;
      return e.items.forEach((U, Q) => {
        _.set(U[R], Q);
      }), _;
    }), o = G(null), a = G(void 0), s = /* @__PURE__ */ new Map(), u = j(() => {
      const { items: _, itemSize: R, keyField: U } = e, Q = new _X(_.length, R);
      return _.forEach((Z, X) => {
        const re = Z[U], ue = s.get(re);
        ue !== void 0 && Q.add(X, ue);
      }), Q;
    }), d = G(0);
    let f = 0;
    const h = G(0), g = _r(() => Math.max(u.value.getBound(h.value - wo(e.paddingTop)) - 1, 0)), m = j(() => {
      const { value: _ } = a;
      if (_ === void 0)
        return [];
      const { items: R, itemSize: U } = e, Q = g.value, Z = Math.min(Q + Math.ceil(_ / U + 1), R.length - 1), X = [];
      for (let re = Q; re <= Z; ++re)
        X.push(R[re]);
      return X;
    }), v = (_, R) => {
      if (typeof _ == "number") {
        C(_, R, "auto");
        return;
      }
      const { left: U, top: Q, index: Z, key: X, position: re, behavior: ue, debounce: he = !0 } = _;
      if (U !== void 0 || Q !== void 0)
        C(U, Q, ue);
      else if (Z !== void 0)
        y(Z, ue, he);
      else if (X !== void 0) {
        const te = i.value.get(X);
        te !== void 0 && y(te, ue, he);
      } else
        re === "bottom" ? C(0, Number.MAX_SAFE_INTEGER, ue) : re === "top" && C(0, 0, ue);
    };
    let w, x = null;
    function y(_, R, U) {
      const { value: Q } = u, Z = Q.sum(_) + wo(e.paddingTop);
      if (!U)
        o.value.scrollTo({
          left: 0,
          top: Z,
          behavior: R
        });
      else {
        w = _, x !== null && window.clearTimeout(x), x = window.setTimeout(() => {
          w = void 0, x = null;
        }, 16);
        const { scrollTop: X, offsetHeight: re } = o.value;
        if (Z > X) {
          const ue = Q.get(_);
          Z + ue <= X + re || o.value.scrollTo({
            left: 0,
            top: Z + ue - re,
            behavior: R
          });
        } else
          o.value.scrollTo({
            left: 0,
            top: Z,
            behavior: R
          });
      }
    }
    function C(_, R, U) {
      o.value.scrollTo({
        left: _,
        top: R,
        behavior: U
      });
    }
    function S(_, R) {
      var U, Q, Z;
      if (r || e.ignoreItemResize || $(R.target))
        return;
      const { value: X } = u, re = i.value.get(_), ue = X.get(re), he = (Z = (Q = (U = R.borderBoxSize) === null || U === void 0 ? void 0 : U[0]) === null || Q === void 0 ? void 0 : Q.blockSize) !== null && Z !== void 0 ? Z : R.contentRect.height;
      if (he === ue)
        return;
      he - e.itemSize === 0 ? s.delete(_) : s.set(_, he - e.itemSize);
      const de = he - ue;
      if (de === 0)
        return;
      X.add(re, de);
      const De = o.value;
      if (De != null) {
        if (w === void 0) {
          const Oe = X.sum(re);
          De.scrollTop > Oe && De.scrollBy(0, de);
        } else if (re < w)
          De.scrollBy(0, de);
        else if (re === w) {
          const Oe = X.sum(re);
          he + Oe > De.scrollTop + De.offsetHeight && De.scrollBy(0, de);
        }
        I();
      }
      d.value++;
    }
    const T = !dJ();
    let A = !1;
    function D(_) {
      var R;
      (R = e.onScroll) === null || R === void 0 || R.call(e, _), (!T || !A) && I();
    }
    function E(_) {
      var R;
      if ((R = e.onWheel) === null || R === void 0 || R.call(e, _), T) {
        const U = o.value;
        if (U != null) {
          if (_.deltaX === 0 && (U.scrollTop === 0 && _.deltaY <= 0 || U.scrollTop + U.offsetHeight >= U.scrollHeight && _.deltaY >= 0))
            return;
          _.preventDefault(), U.scrollTop += _.deltaY / o3(), U.scrollLeft += _.deltaX / o3(), I(), A = !0, m0(() => {
            A = !1;
          });
        }
      }
    }
    function N(_) {
      if (r || $(_.target) || _.contentRect.height === a.value)
        return;
      a.value = _.contentRect.height;
      const { onResize: R } = e;
      R !== void 0 && R(_);
    }
    function I() {
      const { value: _ } = o;
      _ != null && (h.value = _.scrollTop, f = _.scrollLeft);
    }
    function $(_) {
      let R = _;
      for (; R !== null; ) {
        if (R.style.display === "none")
          return !0;
        R = R.parentElement;
      }
      return !1;
    }
    return {
      listHeight: a,
      listStyle: {
        overflow: "auto"
      },
      keyToIndex: i,
      itemsStyle: j(() => {
        const { itemResizable: _ } = e, R = Ko(u.value.sum());
        return d.value, [
          e.itemsStyle,
          {
            boxSizing: "content-box",
            height: _ ? "" : R,
            minHeight: _ ? R : "",
            paddingTop: Ko(e.paddingTop),
            paddingBottom: Ko(e.paddingBottom)
          }
        ];
      }),
      visibleItemsStyle: j(() => (d.value, {
        transform: `translateY(${Ko(u.value.sum(g.value))})`
      })),
      viewportItems: m,
      listElRef: o,
      itemsElRef: G(null),
      scrollTo: v,
      handleListResize: N,
      handleListScroll: D,
      handleListWheel: E,
      handleItemResize: S
    };
  },
  render() {
    const { itemResizable: e, keyField: t, keyToIndex: r, visibleItemsTag: n } = this;
    return b(Hl, {
      onResize: this.handleListResize
    }, {
      default: () => {
        var i, o;
        return b("div", ir(this.$attrs, {
          class: ["v-vl", this.showScrollbar && "v-vl--show-scrollbar"],
          onScroll: this.handleListScroll,
          onWheel: this.handleListWheel,
          ref: "listElRef"
        }), [
          this.items.length !== 0 ? b("div", {
            ref: "itemsElRef",
            class: "v-vl-items",
            style: this.itemsStyle
          }, [
            b(n, Object.assign({
              class: "v-vl-visible-items",
              style: this.visibleItemsStyle
            }, this.visibleItemsProps), {
              default: () => this.viewportItems.map((a) => {
                const s = a[t], u = r.get(s), d = this.$slots.default({
                  item: a,
                  index: u
                })[0];
                return e ? b(Hl, {
                  key: s,
                  onResize: (f) => this.handleItemResize(s, f)
                }, {
                  default: () => d
                }) : (d.key = s, d);
              })
            })
          ]) : (o = (i = this.$slots).empty) === null || o === void 0 ? void 0 : o.call(i)
        ]);
      }
    });
  }
});
const hJ = fs(".v-x-scroll", {
  overflow: "auto",
  scrollbarWidth: "none"
}, [
  fs("&::-webkit-scrollbar", {
    width: 0,
    height: 0
  })
]);
var pJ = oe({
  name: "XScroll",
  props: {
    disabled: Boolean,
    onScroll: Function
  },
  setup() {
    const e = G(null);
    function t(i) {
      !(i.currentTarget.offsetWidth < i.currentTarget.scrollWidth) || i.deltaY === 0 || (i.currentTarget.scrollLeft += i.deltaY + i.deltaX, i.preventDefault());
    }
    const r = Oc();
    return hJ.mount({
      id: "vueuc/x-scroll",
      head: !0,
      anchorMetaName: zM,
      ssr: r
    }), Object.assign({
      selfRef: e,
      handleWheel: t
    }, {
      scrollTo(...i) {
        var o;
        (o = e.value) === null || o === void 0 || o.scrollTo(...i);
      }
    });
  },
  render() {
    return b("div", {
      ref: "selfRef",
      onScroll: this.onScroll,
      onWheel: this.disabled ? void 0 : this.handleWheel,
      class: "v-x-scroll"
    }, this.$slots);
  }
});
const hf = "v-hidden", gJ = fs("[v-hidden]", {
  display: "none!important"
});
var a3 = oe({
  name: "Overflow",
  props: {
    getCounter: Function,
    getTail: Function,
    updateCounter: Function,
    onUpdateOverflow: Function
  },
  setup(e, { slots: t }) {
    const r = G(null), n = G(null);
    function i() {
      const { value: a } = r, { getCounter: s, getTail: u } = e;
      let d;
      if (s !== void 0 ? d = s() : d = n.value, !a || !d)
        return;
      d.hasAttribute(hf) && d.removeAttribute(hf);
      const { children: f } = a, h = a.offsetWidth, g = [], m = t.tail ? u == null ? void 0 : u() : null;
      let v = m ? m.offsetWidth : 0, w = !1;
      const x = a.children.length - (t.tail ? 1 : 0);
      for (let C = 0; C < x - 1; ++C) {
        if (C < 0)
          continue;
        const S = f[C];
        if (w) {
          S.hasAttribute(hf) || S.setAttribute(hf, "");
          continue;
        } else
          S.hasAttribute(hf) && S.removeAttribute(hf);
        const T = S.offsetWidth;
        if (v += T, g[C] = T, v > h) {
          const { updateCounter: A } = e;
          for (let D = C; D >= 0; --D) {
            const E = x - 1 - D;
            A !== void 0 ? A(E) : d.textContent = `${E}`;
            const N = d.offsetWidth;
            if (v -= g[D], v + N <= h || D === 0) {
              w = !0, C = D - 1, m && (C === -1 ? (m.style.maxWidth = `${h - N}px`, m.style.boxSizing = "border-box") : m.style.maxWidth = "");
              break;
            }
          }
        }
      }
      const { onUpdateOverflow: y } = e;
      w ? y !== void 0 && y(!0) : (y !== void 0 && y(!1), d.setAttribute(hf, ""));
    }
    const o = Oc();
    return gJ.mount({
      id: "vueuc/overflow",
      head: !0,
      anchorMetaName: zM,
      ssr: o
    }), br(i), {
      selfRef: r,
      counterRef: n,
      sync: i
    };
  },
  render() {
    const { $slots: e } = this;
    return an(this.sync), b("div", {
      class: "v-overflow",
      ref: "selfRef"
    }, [
      nt(e, "default"),
      e.counter ? e.counter() : b("span", {
        style: {
          display: "inline-block"
        },
        ref: "counterRef"
      }),
      e.tail ? e.tail() : null
    ]);
  }
});
function PU(e) {
  return e instanceof HTMLElement;
}
function RU(e) {
  for (let t = 0; t < e.childNodes.length; t++) {
    const r = e.childNodes[t];
    if (PU(r) && (FU(r) || RU(r)))
      return !0;
  }
  return !1;
}
function jU(e) {
  for (let t = e.childNodes.length - 1; t >= 0; t--) {
    const r = e.childNodes[t];
    if (PU(r) && (FU(r) || jU(r)))
      return !0;
  }
  return !1;
}
function FU(e) {
  if (!mJ(e))
    return !1;
  try {
    e.focus({ preventScroll: !0 });
  } catch {
  }
  return document.activeElement === e;
}
function mJ(e) {
  if (e.tabIndex > 0 || e.tabIndex === 0 && e.getAttribute("tabIndex") !== null)
    return !0;
  if (e.getAttribute("disabled"))
    return !1;
  switch (e.nodeName) {
    case "A":
      return !!e.href && e.rel !== "ignore";
    case "INPUT":
      return e.type !== "hidden" && e.type !== "file";
    case "BUTTON":
    case "SELECT":
    case "TEXTAREA":
      return !0;
    default:
      return !1;
  }
}
let Cv = [];
const t4 = oe({
  name: "FocusTrap",
  props: {
    disabled: Boolean,
    active: Boolean,
    autoFocus: {
      type: Boolean,
      default: !0
    },
    onEsc: Function,
    initialFocusTo: String,
    finalFocusTo: String,
    returnFocusOnDeactivated: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const t = Ss(), r = G(null), n = G(null);
    let i = !1, o = !1;
    const a = typeof document > "u" ? null : document.activeElement;
    function s() {
      return Cv[Cv.length - 1] === t;
    }
    function u(x) {
      var y;
      x.code === "Escape" && s() && ((y = e.onEsc) === null || y === void 0 || y.call(e, x));
    }
    br(() => {
      Gt(() => e.active, (x) => {
        x ? (h(), Mr("keydown", document, u)) : (hr("keydown", document, u), i && g());
      }, {
        immediate: !0
      });
    }), Gr(() => {
      hr("keydown", document, u), i && g();
    });
    function d(x) {
      if (!o && s()) {
        const y = f();
        if (y === null || y.contains(Ul(x)))
          return;
        m("first");
      }
    }
    function f() {
      const x = r.value;
      if (x === null)
        return null;
      let y = x;
      for (; y = y.nextSibling, !(y === null || y instanceof Element && y.tagName === "DIV"); )
        ;
      return y;
    }
    function h() {
      var x;
      if (!e.disabled) {
        if (Cv.push(t), e.autoFocus) {
          const { initialFocusTo: y } = e;
          y === void 0 ? m("first") : (x = YL(y)) === null || x === void 0 || x.focus({ preventScroll: !0 });
        }
        i = !0, document.addEventListener("focus", d, !0);
      }
    }
    function g() {
      var x;
      if (e.disabled || (document.removeEventListener("focus", d, !0), Cv = Cv.filter((C) => C !== t), s()))
        return;
      const { finalFocusTo: y } = e;
      y !== void 0 ? (x = YL(y)) === null || x === void 0 || x.focus({ preventScroll: !0 }) : e.returnFocusOnDeactivated && a instanceof HTMLElement && (o = !0, a.focus({ preventScroll: !0 }), o = !1);
    }
    function m(x) {
      if (s() && e.active) {
        const y = r.value, C = n.value;
        if (y !== null && C !== null) {
          const S = f();
          if (S == null || S === C) {
            o = !0, y.focus({ preventScroll: !0 }), o = !1;
            return;
          }
          o = !0;
          const T = x === "first" ? RU(S) : jU(S);
          o = !1, T || (o = !0, y.focus({ preventScroll: !0 }), o = !1);
        }
      }
    }
    function v(x) {
      if (o)
        return;
      const y = f();
      y !== null && (x.relatedTarget !== null && y.contains(x.relatedTarget) ? m("last") : m("first"));
    }
    function w(x) {
      o || (x.relatedTarget !== null && x.relatedTarget === r.value ? m("last") : m("first"));
    }
    return {
      focusableStartRef: r,
      focusableEndRef: n,
      focusableStyle: "position: absolute; height: 0; width: 0;",
      handleStartFocus: v,
      handleEndFocus: w
    };
  },
  render() {
    const { default: e } = this.$slots;
    if (e === void 0)
      return null;
    if (this.disabled)
      return e();
    const { active: t, focusableStyle: r } = this;
    return b(Lr, null, [
      b("div", {
        "aria-hidden": "true",
        tabindex: t ? "0" : "-1",
        ref: "focusableStartRef",
        style: r,
        onFocus: this.handleStartFocus
      }),
      e(),
      b("div", {
        "aria-hidden": "true",
        style: r,
        ref: "focusableEndRef",
        tabindex: t ? "0" : "-1",
        onFocus: this.handleEndFocus
      })
    ]);
  }
});
function BU(e, t) {
  t && (br(() => {
    const { value: r } = e;
    r && V1.registerHandler(r, t);
  }), Gr(() => {
    const { value: r } = e;
    r && V1.unregisterHandler(r);
  }));
}
let kh = 0, l3 = "", s3 = "", u3 = "", c3 = "";
const d3 = G("0px");
function UU(e) {
  if (typeof document > "u")
    return;
  const t = document.documentElement;
  let r, n = !1;
  const i = () => {
    t.style.marginRight = l3, t.style.overflow = s3, t.style.overflowX = u3, t.style.overflowY = c3, d3.value = "0px";
  };
  br(() => {
    r = Gt(e, (o) => {
      if (o) {
        if (!kh) {
          const a = window.innerWidth - t.offsetWidth;
          a > 0 && (l3 = t.style.marginRight, t.style.marginRight = `${a}px`, d3.value = `${a}px`), s3 = t.style.overflow, u3 = t.style.overflowX, c3 = t.style.overflowY, t.style.overflow = "hidden", t.style.overflowX = "hidden", t.style.overflowY = "hidden";
        }
        n = !0, kh++;
      } else
        kh--, kh || i(), n = !1;
    }, {
      immediate: !0
    });
  }), Gr(() => {
    r == null || r(), n && (kh--, kh || i(), n = !1);
  });
}
const r4 = G(!1), f3 = () => {
  r4.value = !0;
}, h3 = () => {
  r4.value = !1;
};
let Sv = 0;
const HU = () => (Is && (ch(() => {
  Sv || (window.addEventListener("compositionstart", f3), window.addEventListener("compositionend", h3)), Sv++;
}), Gr(() => {
  Sv <= 1 ? (window.removeEventListener("compositionstart", f3), window.removeEventListener("compositionend", h3), Sv = 0) : Sv--;
})), r4);
function vJ(e) {
  const t = { isDeactivated: !1 };
  let r = !1;
  return $B(() => {
    if (t.isDeactivated = !1, !r) {
      r = !0;
      return;
    }
    e();
  }), EM(() => {
    t.isDeactivated = !0, r || (r = !0);
  }), t;
}
const uz = "n-form-item";
function ta(e, { defaultSize: t = "medium", mergedSize: r, mergedDisabled: n } = {}) {
  const i = lt(uz, null);
  tr(uz, null);
  const o = j(r ? () => r(i) : () => {
    const { size: u } = e;
    if (u)
      return u;
    if (i) {
      const { mergedSize: d } = i;
      if (d.value !== void 0)
        return d.value;
    }
    return t;
  }), a = j(n ? () => n(i) : () => {
    const { disabled: u } = e;
    return u !== void 0 ? u : i ? i.disabled.value : !1;
  }), s = j(() => {
    const { status: u } = e;
    return u || (i == null ? void 0 : i.mergedValidationStatus.value);
  });
  return Gr(() => {
    i && i.restoreValidation();
  }), {
    mergedSizeRef: o,
    mergedDisabledRef: a,
    mergedStatusRef: s,
    nTriggerFormBlur() {
      i && i.handleContentBlur();
    },
    nTriggerFormChange() {
      i && i.handleContentChange();
    },
    nTriggerFormFocus() {
      i && i.handleContentFocus();
    },
    nTriggerFormInput() {
      i && i.handleContentInput();
    }
  };
}
var bJ = typeof global == "object" && global && global.Object === Object && global, WU = bJ, yJ = typeof self == "object" && self && self.Object === Object && self, xJ = WU || yJ || Function("return this")(), Gl = xJ, wJ = Gl.Symbol, yc = wJ, VU = Object.prototype, MJ = VU.hasOwnProperty, CJ = VU.toString, Tv = yc ? yc.toStringTag : void 0;
function SJ(e) {
  var t = MJ.call(e, Tv), r = e[Tv];
  try {
    e[Tv] = void 0;
    var n = !0;
  } catch {
  }
  var i = CJ.call(e);
  return n && (t ? e[Tv] = r : delete e[Tv]), i;
}
var TJ = Object.prototype, kJ = TJ.toString;
function DJ(e) {
  return kJ.call(e);
}
var AJ = "[object Null]", EJ = "[object Undefined]", p3 = yc ? yc.toStringTag : void 0;
function dh(e) {
  return e == null ? e === void 0 ? EJ : AJ : p3 && p3 in Object(e) ? SJ(e) : DJ(e);
}
function xc(e) {
  return e != null && typeof e == "object";
}
var IJ = "[object Symbol]";
function OM(e) {
  return typeof e == "symbol" || xc(e) && dh(e) == IJ;
}
function YU(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, i = Array(n); ++r < n; )
    i[r] = t(e[r], r, e);
  return i;
}
var NJ = Array.isArray, al = NJ, zJ = 1 / 0, g3 = yc ? yc.prototype : void 0, m3 = g3 ? g3.toString : void 0;
function QU(e) {
  if (typeof e == "string")
    return e;
  if (al(e))
    return YU(e, QU) + "";
  if (OM(e))
    return m3 ? m3.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -zJ ? "-0" : t;
}
var $J = /\s/;
function OJ(e) {
  for (var t = e.length; t-- && $J.test(e.charAt(t)); )
    ;
  return t;
}
var _J = /^\s+/;
function LJ(e) {
  return e && e.slice(0, OJ(e) + 1).replace(_J, "");
}
function ll(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var v3 = 0 / 0, PJ = /^[-+]0x[0-9a-f]+$/i, RJ = /^0b[01]+$/i, jJ = /^0o[0-7]+$/i, FJ = parseInt;
function b3(e) {
  if (typeof e == "number")
    return e;
  if (OM(e))
    return v3;
  if (ll(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = ll(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = LJ(e);
  var r = RJ.test(e);
  return r || jJ.test(e) ? FJ(e.slice(2), r ? 2 : 8) : PJ.test(e) ? v3 : +e;
}
function n4(e) {
  return e;
}
var BJ = "[object AsyncFunction]", UJ = "[object Function]", HJ = "[object GeneratorFunction]", WJ = "[object Proxy]";
function i4(e) {
  if (!ll(e))
    return !1;
  var t = dh(e);
  return t == UJ || t == HJ || t == BJ || t == WJ;
}
var VJ = Gl["__core-js_shared__"], kI = VJ, y3 = function() {
  var e = /[^.]+$/.exec(kI && kI.keys && kI.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function YJ(e) {
  return !!y3 && y3 in e;
}
var QJ = Function.prototype, qJ = QJ.toString;
function fh(e) {
  if (e != null) {
    try {
      return qJ.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var GJ = /[\\^$.*+?()[\]{}|]/g, ZJ = /^\[object .+?Constructor\]$/, KJ = Function.prototype, XJ = Object.prototype, JJ = KJ.toString, eee = XJ.hasOwnProperty, tee = RegExp("^" + JJ.call(eee).replace(GJ, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function ree(e) {
  if (!ll(e) || YJ(e))
    return !1;
  var t = i4(e) ? tee : ZJ;
  return t.test(fh(e));
}
function nee(e, t) {
  return e == null ? void 0 : e[t];
}
function hh(e, t) {
  var r = nee(e, t);
  return ree(r) ? r : void 0;
}
var iee = hh(Gl, "WeakMap"), cz = iee, x3 = Object.create, oee = function() {
  function e() {
  }
  return function(t) {
    if (!ll(t))
      return {};
    if (x3)
      return x3(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}(), aee = oee;
function lee(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
function see(e, t) {
  var r = -1, n = e.length;
  for (t || (t = Array(n)); ++r < n; )
    t[r] = e[r];
  return t;
}
var uee = 800, cee = 16, dee = Date.now;
function fee(e) {
  var t = 0, r = 0;
  return function() {
    var n = dee(), i = cee - (n - r);
    if (r = n, i > 0) {
      if (++t >= uee)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
function hee(e) {
  return function() {
    return e;
  };
}
var pee = function() {
  try {
    var e = hh(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Y1 = pee, gee = Y1 ? function(e, t) {
  return Y1(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: hee(t),
    writable: !0
  });
} : n4, mee = gee, vee = fee(mee), bee = vee, yee = 9007199254740991, xee = /^(?:0|[1-9]\d*)$/;
function o4(e, t) {
  var r = typeof e;
  return t = t ?? yee, !!t && (r == "number" || r != "symbol" && xee.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function a4(e, t, r) {
  t == "__proto__" && Y1 ? Y1(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
function vb(e, t) {
  return e === t || e !== e && t !== t;
}
var wee = Object.prototype, Mee = wee.hasOwnProperty;
function Cee(e, t, r) {
  var n = e[t];
  (!(Mee.call(e, t) && vb(n, r)) || r === void 0 && !(t in e)) && a4(e, t, r);
}
function See(e, t, r, n) {
  var i = !r;
  r || (r = {});
  for (var o = -1, a = t.length; ++o < a; ) {
    var s = t[o], u = n ? n(r[s], e[s], s, r, e) : void 0;
    u === void 0 && (u = e[s]), i ? a4(r, s, u) : Cee(r, s, u);
  }
  return r;
}
var w3 = Math.max;
function Tee(e, t, r) {
  return t = w3(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, i = -1, o = w3(n.length - t, 0), a = Array(o); ++i < o; )
      a[i] = n[t + i];
    i = -1;
    for (var s = Array(t + 1); ++i < t; )
      s[i] = n[i];
    return s[t] = r(a), lee(e, this, s);
  };
}
function kee(e, t) {
  return bee(Tee(e, t, n4), e + "");
}
var Dee = 9007199254740991;
function l4(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Dee;
}
function Hp(e) {
  return e != null && l4(e.length) && !i4(e);
}
function Aee(e, t, r) {
  if (!ll(r))
    return !1;
  var n = typeof t;
  return (n == "number" ? Hp(r) && o4(t, r.length) : n == "string" && t in r) ? vb(r[t], e) : !1;
}
function Eee(e) {
  return kee(function(t, r) {
    var n = -1, i = r.length, o = i > 1 ? r[i - 1] : void 0, a = i > 2 ? r[2] : void 0;
    for (o = e.length > 3 && typeof o == "function" ? (i--, o) : void 0, a && Aee(r[0], r[1], a) && (o = i < 3 ? void 0 : o, i = 1), t = Object(t); ++n < i; ) {
      var s = r[n];
      s && e(t, s, n, o);
    }
    return t;
  });
}
var Iee = Object.prototype;
function s4(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || Iee;
  return e === r;
}
function Nee(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var zee = "[object Arguments]";
function M3(e) {
  return xc(e) && dh(e) == zee;
}
var qU = Object.prototype, $ee = qU.hasOwnProperty, Oee = qU.propertyIsEnumerable, _ee = M3(function() {
  return arguments;
}()) ? M3 : function(e) {
  return xc(e) && $ee.call(e, "callee") && !Oee.call(e, "callee");
}, Q1 = _ee;
function Lee() {
  return !1;
}
var GU = typeof exports == "object" && exports && !exports.nodeType && exports, C3 = GU && typeof module == "object" && module && !module.nodeType && module, Pee = C3 && C3.exports === GU, S3 = Pee ? Gl.Buffer : void 0, Ree = S3 ? S3.isBuffer : void 0, jee = Ree || Lee, q1 = jee, Fee = "[object Arguments]", Bee = "[object Array]", Uee = "[object Boolean]", Hee = "[object Date]", Wee = "[object Error]", Vee = "[object Function]", Yee = "[object Map]", Qee = "[object Number]", qee = "[object Object]", Gee = "[object RegExp]", Zee = "[object Set]", Kee = "[object String]", Xee = "[object WeakMap]", Jee = "[object ArrayBuffer]", ete = "[object DataView]", tte = "[object Float32Array]", rte = "[object Float64Array]", nte = "[object Int8Array]", ite = "[object Int16Array]", ote = "[object Int32Array]", ate = "[object Uint8Array]", lte = "[object Uint8ClampedArray]", ste = "[object Uint16Array]", ute = "[object Uint32Array]", Zn = {};
Zn[tte] = Zn[rte] = Zn[nte] = Zn[ite] = Zn[ote] = Zn[ate] = Zn[lte] = Zn[ste] = Zn[ute] = !0;
Zn[Fee] = Zn[Bee] = Zn[Jee] = Zn[Uee] = Zn[ete] = Zn[Hee] = Zn[Wee] = Zn[Vee] = Zn[Yee] = Zn[Qee] = Zn[qee] = Zn[Gee] = Zn[Zee] = Zn[Kee] = Zn[Xee] = !1;
function cte(e) {
  return xc(e) && l4(e.length) && !!Zn[dh(e)];
}
function dte(e) {
  return function(t) {
    return e(t);
  };
}
var ZU = typeof exports == "object" && exports && !exports.nodeType && exports, Xv = ZU && typeof module == "object" && module && !module.nodeType && module, fte = Xv && Xv.exports === ZU, DI = fte && WU.process, hte = function() {
  try {
    var e = Xv && Xv.require && Xv.require("util").types;
    return e || DI && DI.binding && DI.binding("util");
  } catch {
  }
}(), T3 = hte, k3 = T3 && T3.isTypedArray, pte = k3 ? dte(k3) : cte, u4 = pte, gte = Object.prototype, mte = gte.hasOwnProperty;
function KU(e, t) {
  var r = al(e), n = !r && Q1(e), i = !r && !n && q1(e), o = !r && !n && !i && u4(e), a = r || n || i || o, s = a ? Nee(e.length, String) : [], u = s.length;
  for (var d in e)
    (t || mte.call(e, d)) && !(a && (d == "length" || i && (d == "offset" || d == "parent") || o && (d == "buffer" || d == "byteLength" || d == "byteOffset") || o4(d, u))) && s.push(d);
  return s;
}
function XU(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var vte = XU(Object.keys, Object), bte = vte, yte = Object.prototype, xte = yte.hasOwnProperty;
function wte(e) {
  if (!s4(e))
    return bte(e);
  var t = [];
  for (var r in Object(e))
    xte.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
function c4(e) {
  return Hp(e) ? KU(e) : wte(e);
}
function Mte(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var Cte = Object.prototype, Ste = Cte.hasOwnProperty;
function Tte(e) {
  if (!ll(e))
    return Mte(e);
  var t = s4(e), r = [];
  for (var n in e)
    n == "constructor" && (t || !Ste.call(e, n)) || r.push(n);
  return r;
}
function JU(e) {
  return Hp(e) ? KU(e, !0) : Tte(e);
}
var kte = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Dte = /^\w*$/;
function d4(e, t) {
  if (al(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || OM(e) ? !0 : Dte.test(e) || !kte.test(e) || t != null && e in Object(t);
}
var Ate = hh(Object, "create"), C0 = Ate;
function Ete() {
  this.__data__ = C0 ? C0(null) : {}, this.size = 0;
}
function Ite(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Nte = "__lodash_hash_undefined__", zte = Object.prototype, $te = zte.hasOwnProperty;
function Ote(e) {
  var t = this.__data__;
  if (C0) {
    var r = t[e];
    return r === Nte ? void 0 : r;
  }
  return $te.call(t, e) ? t[e] : void 0;
}
var _te = Object.prototype, Lte = _te.hasOwnProperty;
function Pte(e) {
  var t = this.__data__;
  return C0 ? t[e] !== void 0 : Lte.call(t, e);
}
var Rte = "__lodash_hash_undefined__";
function jte(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = C0 && t === void 0 ? Rte : t, this;
}
function eh(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
eh.prototype.clear = Ete;
eh.prototype.delete = Ite;
eh.prototype.get = Ote;
eh.prototype.has = Pte;
eh.prototype.set = jte;
function Fte() {
  this.__data__ = [], this.size = 0;
}
function _M(e, t) {
  for (var r = e.length; r--; )
    if (vb(e[r][0], t))
      return r;
  return -1;
}
var Bte = Array.prototype, Ute = Bte.splice;
function Hte(e) {
  var t = this.__data__, r = _M(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : Ute.call(t, r, 1), --this.size, !0;
}
function Wte(e) {
  var t = this.__data__, r = _M(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function Vte(e) {
  return _M(this.__data__, e) > -1;
}
function Yte(e, t) {
  var r = this.__data__, n = _M(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
function Hu(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Hu.prototype.clear = Fte;
Hu.prototype.delete = Hte;
Hu.prototype.get = Wte;
Hu.prototype.has = Vte;
Hu.prototype.set = Yte;
var Qte = hh(Gl, "Map"), S0 = Qte;
function qte() {
  this.size = 0, this.__data__ = {
    hash: new eh(),
    map: new (S0 || Hu)(),
    string: new eh()
  };
}
function Gte(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function LM(e, t) {
  var r = e.__data__;
  return Gte(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function Zte(e) {
  var t = LM(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function Kte(e) {
  return LM(this, e).get(e);
}
function Xte(e) {
  return LM(this, e).has(e);
}
function Jte(e, t) {
  var r = LM(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
function Wu(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Wu.prototype.clear = qte;
Wu.prototype.delete = Zte;
Wu.prototype.get = Kte;
Wu.prototype.has = Xte;
Wu.prototype.set = Jte;
var ere = "Expected a function";
function f4(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(ere);
  var r = function() {
    var n = arguments, i = t ? t.apply(this, n) : n[0], o = r.cache;
    if (o.has(i))
      return o.get(i);
    var a = e.apply(this, n);
    return r.cache = o.set(i, a) || o, a;
  };
  return r.cache = new (f4.Cache || Wu)(), r;
}
f4.Cache = Wu;
var tre = 500;
function rre(e) {
  var t = f4(e, function(n) {
    return r.size === tre && r.clear(), n;
  }), r = t.cache;
  return t;
}
var nre = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ire = /\\(\\)?/g, ore = rre(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(nre, function(r, n, i, o) {
    t.push(i ? o.replace(ire, "$1") : n || r);
  }), t;
}), are = ore;
function bb(e) {
  return e == null ? "" : QU(e);
}
function e7(e, t) {
  return al(e) ? e : d4(e, t) ? [e] : are(bb(e));
}
var lre = 1 / 0;
function PM(e) {
  if (typeof e == "string" || OM(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -lre ? "-0" : t;
}
function t7(e, t) {
  t = e7(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[PM(t[r++])];
  return r && r == n ? e : void 0;
}
function T0(e, t, r) {
  var n = e == null ? void 0 : t7(e, t);
  return n === void 0 ? r : n;
}
function sre(e, t) {
  for (var r = -1, n = t.length, i = e.length; ++r < n; )
    e[i + r] = t[r];
  return e;
}
var ure = XU(Object.getPrototypeOf, Object), r7 = ure, cre = "[object Object]", dre = Function.prototype, fre = Object.prototype, n7 = dre.toString, hre = fre.hasOwnProperty, pre = n7.call(Object);
function gre(e) {
  if (!xc(e) || dh(e) != cre)
    return !1;
  var t = r7(e);
  if (t === null)
    return !0;
  var r = hre.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && n7.call(r) == pre;
}
function mre(e, t, r) {
  var n = -1, i = e.length;
  t < 0 && (t = -t > i ? 0 : i + t), r = r > i ? i : r, r < 0 && (r += i), i = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var o = Array(i); ++n < i; )
    o[n] = e[n + t];
  return o;
}
function vre(e, t, r) {
  var n = e.length;
  return r = r === void 0 ? n : r, !t && r >= n ? e : mre(e, t, r);
}
var bre = "\\ud800-\\udfff", yre = "\\u0300-\\u036f", xre = "\\ufe20-\\ufe2f", wre = "\\u20d0-\\u20ff", Mre = yre + xre + wre, Cre = "\\ufe0e\\ufe0f", Sre = "\\u200d", Tre = RegExp("[" + Sre + bre + Mre + Cre + "]");
function i7(e) {
  return Tre.test(e);
}
function kre(e) {
  return e.split("");
}
var o7 = "\\ud800-\\udfff", Dre = "\\u0300-\\u036f", Are = "\\ufe20-\\ufe2f", Ere = "\\u20d0-\\u20ff", Ire = Dre + Are + Ere, Nre = "\\ufe0e\\ufe0f", zre = "[" + o7 + "]", dz = "[" + Ire + "]", fz = "\\ud83c[\\udffb-\\udfff]", $re = "(?:" + dz + "|" + fz + ")", a7 = "[^" + o7 + "]", l7 = "(?:\\ud83c[\\udde6-\\uddff]){2}", s7 = "[\\ud800-\\udbff][\\udc00-\\udfff]", Ore = "\\u200d", u7 = $re + "?", c7 = "[" + Nre + "]?", _re = "(?:" + Ore + "(?:" + [a7, l7, s7].join("|") + ")" + c7 + u7 + ")*", Lre = c7 + u7 + _re, Pre = "(?:" + [a7 + dz + "?", dz, l7, s7, zre].join("|") + ")", Rre = RegExp(fz + "(?=" + fz + ")|" + Pre + Lre, "g");
function jre(e) {
  return e.match(Rre) || [];
}
function Fre(e) {
  return i7(e) ? jre(e) : kre(e);
}
function Bre(e) {
  return function(t) {
    t = bb(t);
    var r = i7(t) ? Fre(t) : void 0, n = r ? r[0] : t.charAt(0), i = r ? vre(r, 1).join("") : t.slice(1);
    return n[e]() + i;
  };
}
var Ure = Bre("toUpperCase"), d7 = Ure;
function Hre(e) {
  return d7(bb(e).toLowerCase());
}
function Wre(e, t, r, n) {
  var i = -1, o = e == null ? 0 : e.length;
  for (n && o && (r = e[++i]); ++i < o; )
    r = t(r, e[i], i, e);
  return r;
}
function Vre(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var Yre = {
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, Qre = Vre(Yre), qre = Qre, Gre = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Zre = "\\u0300-\\u036f", Kre = "\\ufe20-\\ufe2f", Xre = "\\u20d0-\\u20ff", Jre = Zre + Kre + Xre, ene = "[" + Jre + "]", tne = RegExp(ene, "g");
function rne(e) {
  return e = bb(e), e && e.replace(Gre, qre).replace(tne, "");
}
var nne = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function ine(e) {
  return e.match(nne) || [];
}
var one = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function ane(e) {
  return one.test(e);
}
var f7 = "\\ud800-\\udfff", lne = "\\u0300-\\u036f", sne = "\\ufe20-\\ufe2f", une = "\\u20d0-\\u20ff", cne = lne + sne + une, h7 = "\\u2700-\\u27bf", p7 = "a-z\\xdf-\\xf6\\xf8-\\xff", dne = "\\xac\\xb1\\xd7\\xf7", fne = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", hne = "\\u2000-\\u206f", pne = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", g7 = "A-Z\\xc0-\\xd6\\xd8-\\xde", gne = "\\ufe0e\\ufe0f", m7 = dne + fne + hne + pne, v7 = "['’]", D3 = "[" + m7 + "]", mne = "[" + cne + "]", b7 = "\\d+", vne = "[" + h7 + "]", y7 = "[" + p7 + "]", x7 = "[^" + f7 + m7 + b7 + h7 + p7 + g7 + "]", bne = "\\ud83c[\\udffb-\\udfff]", yne = "(?:" + mne + "|" + bne + ")", xne = "[^" + f7 + "]", w7 = "(?:\\ud83c[\\udde6-\\uddff]){2}", M7 = "[\\ud800-\\udbff][\\udc00-\\udfff]", Bh = "[" + g7 + "]", wne = "\\u200d", A3 = "(?:" + y7 + "|" + x7 + ")", Mne = "(?:" + Bh + "|" + x7 + ")", E3 = "(?:" + v7 + "(?:d|ll|m|re|s|t|ve))?", I3 = "(?:" + v7 + "(?:D|LL|M|RE|S|T|VE))?", C7 = yne + "?", S7 = "[" + gne + "]?", Cne = "(?:" + wne + "(?:" + [xne, w7, M7].join("|") + ")" + S7 + C7 + ")*", Sne = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Tne = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", kne = S7 + C7 + Cne, Dne = "(?:" + [vne, w7, M7].join("|") + ")" + kne, Ane = RegExp([
  Bh + "?" + y7 + "+" + E3 + "(?=" + [D3, Bh, "$"].join("|") + ")",
  Mne + "+" + I3 + "(?=" + [D3, Bh + A3, "$"].join("|") + ")",
  Bh + "?" + A3 + "+" + E3,
  Bh + "+" + I3,
  Tne,
  Sne,
  b7,
  Dne
].join("|"), "g");
function Ene(e) {
  return e.match(Ane) || [];
}
function Ine(e, t, r) {
  return e = bb(e), t = r ? void 0 : t, t === void 0 ? ane(e) ? Ene(e) : ine(e) : e.match(t) || [];
}
var Nne = "['’]", zne = RegExp(Nne, "g");
function T7(e) {
  return function(t) {
    return Wre(Ine(rne(t).replace(zne, "")), e, "");
  };
}
var $ne = T7(function(e, t, r) {
  return t = t.toLowerCase(), e + (r ? Hre(t) : t);
}), N3 = $ne;
function One() {
  this.__data__ = new Hu(), this.size = 0;
}
function _ne(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
function Lne(e) {
  return this.__data__.get(e);
}
function Pne(e) {
  return this.__data__.has(e);
}
var Rne = 200;
function jne(e, t) {
  var r = this.__data__;
  if (r instanceof Hu) {
    var n = r.__data__;
    if (!S0 || n.length < Rne - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new Wu(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
function vs(e) {
  var t = this.__data__ = new Hu(e);
  this.size = t.size;
}
vs.prototype.clear = One;
vs.prototype.delete = _ne;
vs.prototype.get = Lne;
vs.prototype.has = Pne;
vs.prototype.set = jne;
var k7 = typeof exports == "object" && exports && !exports.nodeType && exports, z3 = k7 && typeof module == "object" && module && !module.nodeType && module, Fne = z3 && z3.exports === k7, $3 = Fne ? Gl.Buffer : void 0, O3 = $3 ? $3.allocUnsafe : void 0;
function Bne(e, t) {
  if (t)
    return e.slice();
  var r = e.length, n = O3 ? O3(r) : new e.constructor(r);
  return e.copy(n), n;
}
function Une(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, i = 0, o = []; ++r < n; ) {
    var a = e[r];
    t(a, r, e) && (o[i++] = a);
  }
  return o;
}
function Hne() {
  return [];
}
var Wne = Object.prototype, Vne = Wne.propertyIsEnumerable, _3 = Object.getOwnPropertySymbols, Yne = _3 ? function(e) {
  return e == null ? [] : (e = Object(e), Une(_3(e), function(t) {
    return Vne.call(e, t);
  }));
} : Hne, Qne = Yne;
function qne(e, t, r) {
  var n = t(e);
  return al(e) ? n : sre(n, r(e));
}
function L3(e) {
  return qne(e, c4, Qne);
}
var Gne = hh(Gl, "DataView"), hz = Gne, Zne = hh(Gl, "Promise"), pz = Zne, Kne = hh(Gl, "Set"), gz = Kne, P3 = "[object Map]", Xne = "[object Object]", R3 = "[object Promise]", j3 = "[object Set]", F3 = "[object WeakMap]", B3 = "[object DataView]", Jne = fh(hz), eie = fh(S0), tie = fh(pz), rie = fh(gz), nie = fh(cz), Cf = dh;
(hz && Cf(new hz(new ArrayBuffer(1))) != B3 || S0 && Cf(new S0()) != P3 || pz && Cf(pz.resolve()) != R3 || gz && Cf(new gz()) != j3 || cz && Cf(new cz()) != F3) && (Cf = function(e) {
  var t = dh(e), r = t == Xne ? e.constructor : void 0, n = r ? fh(r) : "";
  if (n)
    switch (n) {
      case Jne:
        return B3;
      case eie:
        return P3;
      case tie:
        return R3;
      case rie:
        return j3;
      case nie:
        return F3;
    }
  return t;
});
var U3 = Cf, iie = Gl.Uint8Array, G1 = iie;
function oie(e) {
  var t = new e.constructor(e.byteLength);
  return new G1(t).set(new G1(e)), t;
}
function aie(e, t) {
  var r = t ? oie(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
function lie(e) {
  return typeof e.constructor == "function" && !s4(e) ? aee(r7(e)) : {};
}
var sie = "__lodash_hash_undefined__";
function uie(e) {
  return this.__data__.set(e, sie), this;
}
function cie(e) {
  return this.__data__.has(e);
}
function Z1(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new Wu(); ++t < r; )
    this.add(e[t]);
}
Z1.prototype.add = Z1.prototype.push = uie;
Z1.prototype.has = cie;
function die(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
function fie(e, t) {
  return e.has(t);
}
var hie = 1, pie = 2;
function D7(e, t, r, n, i, o) {
  var a = r & hie, s = e.length, u = t.length;
  if (s != u && !(a && u > s))
    return !1;
  var d = o.get(e), f = o.get(t);
  if (d && f)
    return d == t && f == e;
  var h = -1, g = !0, m = r & pie ? new Z1() : void 0;
  for (o.set(e, t), o.set(t, e); ++h < s; ) {
    var v = e[h], w = t[h];
    if (n)
      var x = a ? n(w, v, h, t, e, o) : n(v, w, h, e, t, o);
    if (x !== void 0) {
      if (x)
        continue;
      g = !1;
      break;
    }
    if (m) {
      if (!die(t, function(y, C) {
        if (!fie(m, C) && (v === y || i(v, y, r, n, o)))
          return m.push(C);
      })) {
        g = !1;
        break;
      }
    } else if (!(v === w || i(v, w, r, n, o))) {
      g = !1;
      break;
    }
  }
  return o.delete(e), o.delete(t), g;
}
function gie(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, i) {
    r[++t] = [i, n];
  }), r;
}
function mie(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var vie = 1, bie = 2, yie = "[object Boolean]", xie = "[object Date]", wie = "[object Error]", Mie = "[object Map]", Cie = "[object Number]", Sie = "[object RegExp]", Tie = "[object Set]", kie = "[object String]", Die = "[object Symbol]", Aie = "[object ArrayBuffer]", Eie = "[object DataView]", H3 = yc ? yc.prototype : void 0, AI = H3 ? H3.valueOf : void 0;
function Iie(e, t, r, n, i, o, a) {
  switch (r) {
    case Eie:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case Aie:
      return !(e.byteLength != t.byteLength || !o(new G1(e), new G1(t)));
    case yie:
    case xie:
    case Cie:
      return vb(+e, +t);
    case wie:
      return e.name == t.name && e.message == t.message;
    case Sie:
    case kie:
      return e == t + "";
    case Mie:
      var s = gie;
    case Tie:
      var u = n & vie;
      if (s || (s = mie), e.size != t.size && !u)
        return !1;
      var d = a.get(e);
      if (d)
        return d == t;
      n |= bie, a.set(e, t);
      var f = D7(s(e), s(t), n, i, o, a);
      return a.delete(e), f;
    case Die:
      if (AI)
        return AI.call(e) == AI.call(t);
  }
  return !1;
}
var Nie = 1, zie = Object.prototype, $ie = zie.hasOwnProperty;
function Oie(e, t, r, n, i, o) {
  var a = r & Nie, s = L3(e), u = s.length, d = L3(t), f = d.length;
  if (u != f && !a)
    return !1;
  for (var h = u; h--; ) {
    var g = s[h];
    if (!(a ? g in t : $ie.call(t, g)))
      return !1;
  }
  var m = o.get(e), v = o.get(t);
  if (m && v)
    return m == t && v == e;
  var w = !0;
  o.set(e, t), o.set(t, e);
  for (var x = a; ++h < u; ) {
    g = s[h];
    var y = e[g], C = t[g];
    if (n)
      var S = a ? n(C, y, g, t, e, o) : n(y, C, g, e, t, o);
    if (!(S === void 0 ? y === C || i(y, C, r, n, o) : S)) {
      w = !1;
      break;
    }
    x || (x = g == "constructor");
  }
  if (w && !x) {
    var T = e.constructor, A = t.constructor;
    T != A && "constructor" in e && "constructor" in t && !(typeof T == "function" && T instanceof T && typeof A == "function" && A instanceof A) && (w = !1);
  }
  return o.delete(e), o.delete(t), w;
}
var _ie = 1, W3 = "[object Arguments]", V3 = "[object Array]", iy = "[object Object]", Lie = Object.prototype, Y3 = Lie.hasOwnProperty;
function Pie(e, t, r, n, i, o) {
  var a = al(e), s = al(t), u = a ? V3 : U3(e), d = s ? V3 : U3(t);
  u = u == W3 ? iy : u, d = d == W3 ? iy : d;
  var f = u == iy, h = d == iy, g = u == d;
  if (g && q1(e)) {
    if (!q1(t))
      return !1;
    a = !0, f = !1;
  }
  if (g && !f)
    return o || (o = new vs()), a || u4(e) ? D7(e, t, r, n, i, o) : Iie(e, t, u, r, n, i, o);
  if (!(r & _ie)) {
    var m = f && Y3.call(e, "__wrapped__"), v = h && Y3.call(t, "__wrapped__");
    if (m || v) {
      var w = m ? e.value() : e, x = v ? t.value() : t;
      return o || (o = new vs()), i(w, x, r, n, o);
    }
  }
  return g ? (o || (o = new vs()), Oie(e, t, r, n, i, o)) : !1;
}
function h4(e, t, r, n, i) {
  return e === t ? !0 : e == null || t == null || !xc(e) && !xc(t) ? e !== e && t !== t : Pie(e, t, r, n, h4, i);
}
var Rie = 1, jie = 2;
function Fie(e, t, r, n) {
  var i = r.length, o = i, a = !n;
  if (e == null)
    return !o;
  for (e = Object(e); i--; ) {
    var s = r[i];
    if (a && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++i < o; ) {
    s = r[i];
    var u = s[0], d = e[u], f = s[1];
    if (a && s[2]) {
      if (d === void 0 && !(u in e))
        return !1;
    } else {
      var h = new vs();
      if (n)
        var g = n(d, f, u, e, t, h);
      if (!(g === void 0 ? h4(f, d, Rie | jie, n, h) : g))
        return !1;
    }
  }
  return !0;
}
function A7(e) {
  return e === e && !ll(e);
}
function Bie(e) {
  for (var t = c4(e), r = t.length; r--; ) {
    var n = t[r], i = e[n];
    t[r] = [n, i, A7(i)];
  }
  return t;
}
function E7(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
function Uie(e) {
  var t = Bie(e);
  return t.length == 1 && t[0][2] ? E7(t[0][0], t[0][1]) : function(r) {
    return r === e || Fie(r, e, t);
  };
}
function Hie(e, t) {
  return e != null && t in Object(e);
}
function Wie(e, t, r) {
  t = e7(t, e);
  for (var n = -1, i = t.length, o = !1; ++n < i; ) {
    var a = PM(t[n]);
    if (!(o = e != null && r(e, a)))
      break;
    e = e[a];
  }
  return o || ++n != i ? o : (i = e == null ? 0 : e.length, !!i && l4(i) && o4(a, i) && (al(e) || Q1(e)));
}
function Vie(e, t) {
  return e != null && Wie(e, t, Hie);
}
var Yie = 1, Qie = 2;
function qie(e, t) {
  return d4(e) && A7(t) ? E7(PM(e), t) : function(r) {
    var n = T0(r, e);
    return n === void 0 && n === t ? Vie(r, e) : h4(t, n, Yie | Qie);
  };
}
function Gie(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function Zie(e) {
  return function(t) {
    return t7(t, e);
  };
}
function Kie(e) {
  return d4(e) ? Gie(PM(e)) : Zie(e);
}
function Xie(e) {
  return typeof e == "function" ? e : e == null ? n4 : typeof e == "object" ? al(e) ? qie(e[0], e[1]) : Uie(e) : Kie(e);
}
function Jie(e) {
  return function(t, r, n) {
    for (var i = -1, o = Object(t), a = n(t), s = a.length; s--; ) {
      var u = a[e ? s : ++i];
      if (r(o[u], u, o) === !1)
        break;
    }
    return t;
  };
}
var eoe = Jie(), I7 = eoe;
function toe(e, t) {
  return e && I7(e, t, c4);
}
function roe(e, t) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!Hp(r))
      return e(r, n);
    for (var i = r.length, o = t ? i : -1, a = Object(r); (t ? o-- : ++o < i) && n(a[o], o, a) !== !1; )
      ;
    return r;
  };
}
var noe = roe(toe), ioe = noe, ooe = function() {
  return Gl.Date.now();
}, EI = ooe, aoe = "Expected a function", loe = Math.max, soe = Math.min;
function uoe(e, t, r) {
  var n, i, o, a, s, u, d = 0, f = !1, h = !1, g = !0;
  if (typeof e != "function")
    throw new TypeError(aoe);
  t = b3(t) || 0, ll(r) && (f = !!r.leading, h = "maxWait" in r, o = h ? loe(b3(r.maxWait) || 0, t) : o, g = "trailing" in r ? !!r.trailing : g);
  function m(D) {
    var E = n, N = i;
    return n = i = void 0, d = D, a = e.apply(N, E), a;
  }
  function v(D) {
    return d = D, s = setTimeout(y, t), f ? m(D) : a;
  }
  function w(D) {
    var E = D - u, N = D - d, I = t - E;
    return h ? soe(I, o - N) : I;
  }
  function x(D) {
    var E = D - u, N = D - d;
    return u === void 0 || E >= t || E < 0 || h && N >= o;
  }
  function y() {
    var D = EI();
    if (x(D))
      return C(D);
    s = setTimeout(y, w(D));
  }
  function C(D) {
    return s = void 0, g && n ? m(D) : (n = i = void 0, a);
  }
  function S() {
    s !== void 0 && clearTimeout(s), d = 0, n = u = i = s = void 0;
  }
  function T() {
    return s === void 0 ? a : C(EI());
  }
  function A() {
    var D = EI(), E = x(D);
    if (n = arguments, i = this, u = D, E) {
      if (s === void 0)
        return v(u);
      if (h)
        return clearTimeout(s), s = setTimeout(y, t), m(u);
    }
    return s === void 0 && (s = setTimeout(y, t)), a;
  }
  return A.cancel = S, A.flush = T, A;
}
function mz(e, t, r) {
  (r !== void 0 && !vb(e[t], r) || r === void 0 && !(t in e)) && a4(e, t, r);
}
function coe(e) {
  return xc(e) && Hp(e);
}
function vz(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
function doe(e) {
  return See(e, JU(e));
}
function foe(e, t, r, n, i, o, a) {
  var s = vz(e, r), u = vz(t, r), d = a.get(u);
  if (d) {
    mz(e, r, d);
    return;
  }
  var f = o ? o(s, u, r + "", e, t, a) : void 0, h = f === void 0;
  if (h) {
    var g = al(u), m = !g && q1(u), v = !g && !m && u4(u);
    f = u, g || m || v ? al(s) ? f = s : coe(s) ? f = see(s) : m ? (h = !1, f = Bne(u, !0)) : v ? (h = !1, f = aie(u, !0)) : f = [] : gre(u) || Q1(u) ? (f = s, Q1(s) ? f = doe(s) : (!ll(s) || i4(s)) && (f = lie(u))) : h = !1;
  }
  h && (a.set(u, f), i(f, u, n, o, a), a.delete(u)), mz(e, r, f);
}
function N7(e, t, r, n, i) {
  e !== t && I7(t, function(o, a) {
    if (i || (i = new vs()), ll(o))
      foe(e, t, a, r, N7, n, i);
    else {
      var s = n ? n(vz(e, a), o, a + "", e, t, i) : void 0;
      s === void 0 && (s = o), mz(e, a, s);
    }
  }, JU);
}
function hoe(e, t) {
  var r = -1, n = Hp(e) ? Array(e.length) : [];
  return ioe(e, function(i, o, a) {
    n[++r] = t(i, o, a);
  }), n;
}
function poe(e, t) {
  var r = al(e) ? YU : hoe;
  return r(e, Xie(t));
}
var goe = T7(function(e, t, r) {
  return e + (r ? "-" : "") + t.toLowerCase();
}), moe = goe, voe = Eee(function(e, t, r) {
  N7(e, t, r);
}), _v = voe, boe = "Expected a function";
function II(e, t, r) {
  var n = !0, i = !0;
  if (typeof e != "function")
    throw new TypeError(boe);
  return ll(r) && (n = "leading" in r ? !!r.leading : n, i = "trailing" in r ? !!r.trailing : i), uoe(e, t, {
    leading: n,
    maxWait: t,
    trailing: i
  });
}
var Wa = {
  fontFamily: 'v-sans, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  fontFamilyMono: "v-mono, SFMono-Regular, Menlo, Consolas, Courier, monospace",
  fontWeight: "400",
  fontWeightStrong: "500",
  cubicBezierEaseInOut: "cubic-bezier(.4, 0, .2, 1)",
  cubicBezierEaseOut: "cubic-bezier(0, 0, .2, 1)",
  cubicBezierEaseIn: "cubic-bezier(.4, 0, 1, 1)",
  borderRadius: "3px",
  borderRadiusSmall: "2px",
  fontSize: "14px",
  fontSizeMini: "12px",
  fontSizeTiny: "12px",
  fontSizeSmall: "14px",
  fontSizeMedium: "14px",
  fontSizeLarge: "15px",
  fontSizeHuge: "16px",
  lineHeight: "1.6",
  heightMini: "16px",
  heightTiny: "22px",
  heightSmall: "28px",
  heightMedium: "34px",
  heightLarge: "40px",
  heightHuge: "46px"
};
const {
  fontSize: yoe,
  fontFamily: xoe,
  lineHeight: woe
} = Wa;
var z7 = Y("body", `
 margin: 0;
 font-size: ${yoe};
 font-family: ${xoe};
 line-height: ${woe};
 -webkit-text-size-adjust: 100%;
 -webkit-tap-highlight-color: transparent;
`, [Y("input", `
 font-family: inherit;
 font-size: inherit;
 `)]);
const ju = "n-config-provider", gp = "naive-ui-style";
function ft(e, t, r, n, i, o) {
  const a = Oc(), s = lt(ju, null);
  if (r) {
    const d = () => {
      const f = o == null ? void 0 : o.value;
      r.mount({
        id: f === void 0 ? t : f + t,
        head: !0,
        props: {
          bPrefix: f ? `.${f}-` : void 0
        },
        anchorMetaName: gp,
        ssr: a
      }), s != null && s.preflightStyleDisabled || z7.mount({
        id: "n-global",
        head: !0,
        anchorMetaName: gp,
        ssr: a
      });
    };
    a ? d() : ch(d);
  }
  return j(() => {
    var d;
    const { theme: { common: f, self: h, peers: g = {} } = {}, themeOverrides: m = {}, builtinThemeOverrides: v = {} } = i, { common: w, peers: x } = m, { common: y = void 0, [e]: { common: C = void 0, self: S = void 0, peers: T = {} } = {} } = (s == null ? void 0 : s.mergedThemeRef.value) || {}, { common: A = void 0, [e]: D = {} } = (s == null ? void 0 : s.mergedThemeOverridesRef.value) || {}, { common: E, peers: N = {} } = D, I = _v({}, f || C || y || n.common, A, E, w), $ = _v((d = h || S || n.self) === null || d === void 0 ? void 0 : d(I), v, D, m);
    return {
      common: I,
      self: $,
      peers: _v({}, n.peers, T, g),
      peerOverrides: _v({}, v.peers, N, x)
    };
  });
}
ft.props = {
  theme: Object,
  themeOverrides: Object,
  builtinThemeOverrides: Object
};
const $7 = "n";
function Yt(e = {}, t = {
  defaultBordered: !0
}) {
  const r = lt(ju, null);
  return {
    inlineThemeDisabled: r == null ? void 0 : r.inlineThemeDisabled,
    mergedRtlRef: r == null ? void 0 : r.mergedRtlRef,
    mergedComponentPropsRef: r == null ? void 0 : r.mergedComponentPropsRef,
    mergedBreakpointsRef: r == null ? void 0 : r.mergedBreakpointsRef,
    mergedBorderedRef: j(() => {
      var n, i;
      const { bordered: o } = e;
      return o !== void 0 ? o : (i = (n = r == null ? void 0 : r.mergedBorderedRef.value) !== null && n !== void 0 ? n : t.defaultBordered) !== null && i !== void 0 ? i : !0;
    }),
    mergedClsPrefixRef: j(() => (r == null ? void 0 : r.mergedClsPrefixRef.value) || $7),
    namespaceRef: j(() => r == null ? void 0 : r.mergedNamespaceRef.value)
  };
}
const Moe = {
  name: "en-US",
  global: {
    undo: "Undo",
    redo: "Redo",
    confirm: "Confirm",
    clear: "Clear"
  },
  Popconfirm: {
    positiveText: "Confirm",
    negativeText: "Cancel"
  },
  Cascader: {
    placeholder: "Please Select",
    loading: "Loading",
    loadingRequiredMessage: (e) => `Please load all ${e}'s descendants before checking it.`
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Clear",
    now: "Now",
    confirm: "Confirm",
    selectTime: "Select Time",
    selectDate: "Select Date",
    datePlaceholder: "Select Date",
    datetimePlaceholder: "Select Date and Time",
    monthPlaceholder: "Select Month",
    yearPlaceholder: "Select Year",
    quarterPlaceholder: "Select Quarter",
    startDatePlaceholder: "Start Date",
    endDatePlaceholder: "End Date",
    startDatetimePlaceholder: "Start Date and Time",
    endDatetimePlaceholder: "End Date and Time",
    startMonthPlaceholder: "Start Month",
    endMonthPlaceholder: "End Month",
    monthBeforeYear: !0,
    firstDayOfWeek: 6,
    today: "Today"
  },
  DataTable: {
    checkTableAll: "Select all in the table",
    uncheckTableAll: "Unselect all in the table",
    confirm: "Confirm",
    clear: "Clear"
  },
  LegacyTransfer: {
    sourceTitle: "Source",
    targetTitle: "Target"
  },
  Transfer: {
    selectAll: "Select all",
    unselectAll: "Unselect all",
    clearAll: "Clear",
    total: (e) => `Total ${e} items`,
    selected: (e) => `${e} items selected`
  },
  Empty: {
    description: "No Data"
  },
  Select: {
    placeholder: "Please Select"
  },
  TimePicker: {
    placeholder: "Select Time",
    positiveText: "OK",
    negativeText: "Cancel",
    now: "Now"
  },
  Pagination: {
    goto: "Goto",
    selectionSuffix: "page"
  },
  DynamicTags: {
    add: "Add"
  },
  Log: {
    loading: "Loading"
  },
  Input: {
    placeholder: "Please Input"
  },
  InputNumber: {
    placeholder: "Please Input"
  },
  DynamicInput: {
    create: "Create"
  },
  ThemeEditor: {
    title: "Theme Editor",
    clearAllVars: "Clear All Variables",
    clearSearch: "Clear Search",
    filterCompName: "Filter Component Name",
    filterVarName: "Filter Variable Name",
    import: "Import",
    export: "Export",
    restore: "Reset to Default"
  },
  Image: {
    tipPrevious: "Previous picture (←)",
    tipNext: "Next picture (→)",
    tipCounterclockwise: "Counterclockwise",
    tipClockwise: "Clockwise",
    tipZoomOut: "Zoom out",
    tipZoomIn: "Zoom in",
    tipClose: "Close (Esc)",
    tipOriginalSize: "Zoom to original size"
  }
};
var Coe = Moe;
function jr(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.width ? String(t.width) : e.defaultWidth, n = e.formats[r] || e.formats[e.defaultWidth];
    return n;
  };
}
function cr(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function Tr(e) {
  cr(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), new Date(NaN));
}
function wn(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
var Soe = {};
function Wp() {
  return Soe;
}
function Fu(e, t) {
  var r, n, i, o, a, s, u, d;
  cr(1, arguments);
  var f = Wp(), h = wn((r = (n = (i = (o = t == null ? void 0 : t.weekStartsOn) !== null && o !== void 0 ? o : t == null || (a = t.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && i !== void 0 ? i : f.weekStartsOn) !== null && n !== void 0 ? n : (u = f.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(h >= 0 && h <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var g = Tr(e), m = g.getUTCDay(), v = (m < h ? 7 : 0) + m - h;
  return g.setUTCDate(g.getUTCDate() - v), g.setUTCHours(0, 0, 0, 0), g;
}
function Q3(e, t, r) {
  cr(2, arguments);
  var n = Fu(e, r), i = Fu(t, r);
  return n.getTime() === i.getTime();
}
function Kt(e) {
  return function(t, r) {
    var n = r != null && r.context ? String(r.context) : "standalone", i;
    if (n === "formatting" && e.formattingValues) {
      var o = e.defaultFormattingWidth || e.defaultWidth, a = r != null && r.width ? String(r.width) : o;
      i = e.formattingValues[a] || e.formattingValues[o];
    } else {
      var s = e.defaultWidth, u = r != null && r.width ? String(r.width) : e.defaultWidth;
      i = e.values[u] || e.values[s];
    }
    var d = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[d];
  };
}
function Xt(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.width, i = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], o = t.match(i);
    if (!o)
      return null;
    var a = o[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], u = Array.isArray(s) ? koe(s, function(h) {
      return h.test(a);
    }) : Toe(s, function(h) {
      return h.test(a);
    }), d;
    d = e.valueCallback ? e.valueCallback(u) : u, d = r.valueCallback ? r.valueCallback(d) : d;
    var f = t.slice(a.length);
    return {
      value: d,
      rest: f
    };
  };
}
function Toe(e, t) {
  for (var r in e)
    if (e.hasOwnProperty(r) && t(e[r]))
      return r;
}
function koe(e, t) {
  for (var r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function hl(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.match(e.matchPattern);
    if (!n)
      return null;
    var i = n[0], o = t.match(e.parsePattern);
    if (!o)
      return null;
    var a = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    a = r.valueCallback ? r.valueCallback(a) : a;
    var s = t.slice(i.length);
    return {
      value: a,
      rest: s
    };
  };
}
var Doe = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Aoe = function(e, t, r) {
  var n, i = Doe[e];
  return typeof i == "string" ? n = i : t === 1 ? n = i.one : n = i.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
}, Eoe = Aoe, Ioe = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Noe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, zoe = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, $oe = {
  date: jr({
    formats: Ioe,
    defaultWidth: "full"
  }),
  time: jr({
    formats: Noe,
    defaultWidth: "full"
  }),
  dateTime: jr({
    formats: zoe,
    defaultWidth: "full"
  })
}, Ooe = $oe, _oe = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Loe = function(e, t, r, n) {
  return _oe[e];
}, Poe = Loe, Roe = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, joe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Foe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, Boe = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, Uoe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Hoe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Woe = function(e, t) {
  var r = Number(e), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, Voe = {
  ordinalNumber: Woe,
  era: Kt({
    values: Roe,
    defaultWidth: "wide"
  }),
  quarter: Kt({
    values: joe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: Kt({
    values: Foe,
    defaultWidth: "wide"
  }),
  day: Kt({
    values: Boe,
    defaultWidth: "wide"
  }),
  dayPeriod: Kt({
    values: Uoe,
    defaultWidth: "wide",
    formattingValues: Hoe,
    defaultFormattingWidth: "wide"
  })
}, Yoe = Voe, Qoe = /^(\d+)(th|st|nd|rd)?/i, qoe = /\d+/i, Goe = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Zoe = {
  any: [/^b/i, /^(a|c)/i]
}, Koe = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Xoe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Joe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, eae = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, tae = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, rae = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, nae = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, iae = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, oae = {
  ordinalNumber: hl({
    matchPattern: Qoe,
    parsePattern: qoe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Xt({
    matchPatterns: Goe,
    defaultMatchWidth: "wide",
    parsePatterns: Zoe,
    defaultParseWidth: "any"
  }),
  quarter: Xt({
    matchPatterns: Koe,
    defaultMatchWidth: "wide",
    parsePatterns: Xoe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: Xt({
    matchPatterns: Joe,
    defaultMatchWidth: "wide",
    parsePatterns: eae,
    defaultParseWidth: "any"
  }),
  day: Xt({
    matchPatterns: tae,
    defaultMatchWidth: "wide",
    parsePatterns: rae,
    defaultParseWidth: "any"
  }),
  dayPeriod: Xt({
    matchPatterns: nae,
    defaultMatchWidth: "any",
    parsePatterns: iae,
    defaultParseWidth: "any"
  })
}, aae = oae, lae = {
  code: "en-US",
  formatDistance: Eoe,
  formatLong: Ooe,
  formatRelative: Poe,
  localize: Yoe,
  match: aae,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, RM = lae;
const sae = {
  name: "en-US",
  locale: RM
};
var uae = sae;
function oy(e, t) {
  cr(2, arguments);
  var r = Tr(e), n = wn(t);
  return isNaN(n) ? new Date(NaN) : (n && r.setDate(r.getDate() + n), r);
}
function yo(e, t) {
  cr(2, arguments);
  var r = Tr(e), n = wn(t);
  if (isNaN(n))
    return new Date(NaN);
  if (!n)
    return r;
  var i = r.getDate(), o = new Date(r.getTime());
  o.setMonth(r.getMonth() + n + 1, 0);
  var a = o.getDate();
  return i >= a ? o : (r.setFullYear(o.getFullYear(), o.getMonth(), i), r);
}
function cae(e, t) {
  cr(2, arguments);
  var r = Tr(e).getTime(), n = wn(t);
  return new Date(r + n);
}
function O7(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function K1(e) {
  cr(1, arguments);
  var t = Tr(e);
  return t.setHours(0, 0, 0, 0), t;
}
function dae(e, t) {
  cr(2, arguments);
  var r = wn(t), n = r * 3;
  return yo(e, n);
}
function bz(e, t) {
  cr(2, arguments);
  var r = wn(t);
  return yo(e, r * 12);
}
var fae = 6e4, hae = 36e5, pae = 1e3;
function gae(e, t) {
  cr(2, arguments);
  var r = K1(e), n = K1(t);
  return r.getTime() === n.getTime();
}
function mae(e) {
  return cr(1, arguments), e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function rl(e) {
  if (cr(1, arguments), !mae(e) && typeof e != "number")
    return !1;
  var t = Tr(e);
  return !isNaN(Number(t));
}
function vae(e) {
  cr(1, arguments);
  var t = Tr(e), r = Math.floor(t.getMonth() / 3) + 1;
  return r;
}
function bae(e) {
  cr(1, arguments);
  var t = Tr(e);
  return t.setSeconds(0, 0), t;
}
function k0(e) {
  cr(1, arguments);
  var t = Tr(e), r = t.getMonth(), n = r - r % 3;
  return t.setMonth(n, 1), t.setHours(0, 0, 0, 0), t;
}
function Iu(e) {
  cr(1, arguments);
  var t = Tr(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function p4(e) {
  cr(1, arguments);
  var t = Tr(e), r = new Date(0);
  return r.setFullYear(t.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
function _7(e, t) {
  cr(2, arguments);
  var r = wn(t);
  return cae(e, -r);
}
var yae = 864e5;
function xae(e) {
  cr(1, arguments);
  var t = Tr(e), r = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var n = t.getTime(), i = r - n;
  return Math.floor(i / yae) + 1;
}
function mp(e) {
  cr(1, arguments);
  var t = 1, r = Tr(e), n = r.getUTCDay(), i = (n < t ? 7 : 0) + n - t;
  return r.setUTCDate(r.getUTCDate() - i), r.setUTCHours(0, 0, 0, 0), r;
}
function L7(e) {
  cr(1, arguments);
  var t = Tr(e), r = t.getUTCFullYear(), n = new Date(0);
  n.setUTCFullYear(r + 1, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var i = mp(n), o = new Date(0);
  o.setUTCFullYear(r, 0, 4), o.setUTCHours(0, 0, 0, 0);
  var a = mp(o);
  return t.getTime() >= i.getTime() ? r + 1 : t.getTime() >= a.getTime() ? r : r - 1;
}
function wae(e) {
  cr(1, arguments);
  var t = L7(e), r = new Date(0);
  r.setUTCFullYear(t, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var n = mp(r);
  return n;
}
var Mae = 6048e5;
function P7(e) {
  cr(1, arguments);
  var t = Tr(e), r = mp(t).getTime() - wae(t).getTime();
  return Math.round(r / Mae) + 1;
}
function g4(e, t) {
  var r, n, i, o, a, s, u, d;
  cr(1, arguments);
  var f = Tr(e), h = f.getUTCFullYear(), g = Wp(), m = wn((r = (n = (i = (o = t == null ? void 0 : t.firstWeekContainsDate) !== null && o !== void 0 ? o : t == null || (a = t.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : g.firstWeekContainsDate) !== null && n !== void 0 ? n : (u = g.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(m >= 1 && m <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var v = new Date(0);
  v.setUTCFullYear(h + 1, 0, m), v.setUTCHours(0, 0, 0, 0);
  var w = Fu(v, t), x = new Date(0);
  x.setUTCFullYear(h, 0, m), x.setUTCHours(0, 0, 0, 0);
  var y = Fu(x, t);
  return f.getTime() >= w.getTime() ? h + 1 : f.getTime() >= y.getTime() ? h : h - 1;
}
function Cae(e, t) {
  var r, n, i, o, a, s, u, d;
  cr(1, arguments);
  var f = Wp(), h = wn((r = (n = (i = (o = t == null ? void 0 : t.firstWeekContainsDate) !== null && o !== void 0 ? o : t == null || (a = t.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : f.firstWeekContainsDate) !== null && n !== void 0 ? n : (u = f.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), g = g4(e, t), m = new Date(0);
  m.setUTCFullYear(g, 0, h), m.setUTCHours(0, 0, 0, 0);
  var v = Fu(m, t);
  return v;
}
var Sae = 6048e5;
function R7(e, t) {
  cr(1, arguments);
  var r = Tr(e), n = Fu(r, t).getTime() - Cae(r, t).getTime();
  return Math.round(n / Sae) + 1;
}
function yn(e, t) {
  for (var r = e < 0 ? "-" : "", n = Math.abs(e).toString(); n.length < t; )
    n = "0" + n;
  return r + n;
}
var Tae = {
  y: function(e, t) {
    var r = e.getUTCFullYear(), n = r > 0 ? r : 1 - r;
    return yn(t === "yy" ? n % 100 : n, t.length);
  },
  M: function(e, t) {
    var r = e.getUTCMonth();
    return t === "M" ? String(r + 1) : yn(r + 1, 2);
  },
  d: function(e, t) {
    return yn(e.getUTCDate(), t.length);
  },
  a: function(e, t) {
    var r = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  h: function(e, t) {
    return yn(e.getUTCHours() % 12 || 12, t.length);
  },
  H: function(e, t) {
    return yn(e.getUTCHours(), t.length);
  },
  m: function(e, t) {
    return yn(e.getUTCMinutes(), t.length);
  },
  s: function(e, t) {
    return yn(e.getUTCSeconds(), t.length);
  },
  S: function(e, t) {
    var r = t.length, n = e.getUTCMilliseconds(), i = Math.floor(n * Math.pow(10, r - 3));
    return yn(i, t.length);
  }
}, Gu = Tae, Dh = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, kae = {
  G: function(e, t, r) {
    var n = e.getUTCFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(n, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(n, {
          width: "wide"
        });
    }
  },
  y: function(e, t, r) {
    if (t === "yo") {
      var n = e.getUTCFullYear(), i = n > 0 ? n : 1 - n;
      return r.ordinalNumber(i, {
        unit: "year"
      });
    }
    return Gu.y(e, t);
  },
  Y: function(e, t, r, n) {
    var i = g4(e, n), o = i > 0 ? i : 1 - i;
    if (t === "YY") {
      var a = o % 100;
      return yn(a, 2);
    }
    return t === "Yo" ? r.ordinalNumber(o, {
      unit: "year"
    }) : yn(o, t.length);
  },
  R: function(e, t) {
    var r = L7(e);
    return yn(r, t.length);
  },
  u: function(e, t) {
    var r = e.getUTCFullYear();
    return yn(r, t.length);
  },
  Q: function(e, t, r) {
    var n = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(n);
      case "QQ":
        return yn(n, 2);
      case "Qo":
        return r.ordinalNumber(n, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  q: function(e, t, r) {
    var n = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(n);
      case "qq":
        return yn(n, 2);
      case "qo":
        return r.ordinalNumber(n, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  M: function(e, t, r) {
    var n = e.getUTCMonth();
    switch (t) {
      case "M":
      case "MM":
        return Gu.M(e, t);
      case "Mo":
        return r.ordinalNumber(n + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  L: function(e, t, r) {
    var n = e.getUTCMonth();
    switch (t) {
      case "L":
        return String(n + 1);
      case "LL":
        return yn(n + 1, 2);
      case "Lo":
        return r.ordinalNumber(n + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  w: function(e, t, r, n) {
    var i = R7(e, n);
    return t === "wo" ? r.ordinalNumber(i, {
      unit: "week"
    }) : yn(i, t.length);
  },
  I: function(e, t, r) {
    var n = P7(e);
    return t === "Io" ? r.ordinalNumber(n, {
      unit: "week"
    }) : yn(n, t.length);
  },
  d: function(e, t, r) {
    return t === "do" ? r.ordinalNumber(e.getUTCDate(), {
      unit: "date"
    }) : Gu.d(e, t);
  },
  D: function(e, t, r) {
    var n = xae(e);
    return t === "Do" ? r.ordinalNumber(n, {
      unit: "dayOfYear"
    }) : yn(n, t.length);
  },
  E: function(e, t, r) {
    var n = e.getUTCDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  e: function(e, t, r, n) {
    var i = e.getUTCDay(), o = (i - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(o);
      case "ee":
        return yn(o, 2);
      case "eo":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  c: function(e, t, r, n) {
    var i = e.getUTCDay(), o = (i - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(o);
      case "cc":
        return yn(o, t.length);
      case "co":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return r.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  i: function(e, t, r) {
    var n = e.getUTCDay(), i = n === 0 ? 7 : n;
    switch (t) {
      case "i":
        return String(i);
      case "ii":
        return yn(i, t.length);
      case "io":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "iii":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  a: function(e, t, r) {
    var n = e.getUTCHours(), i = n / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  b: function(e, t, r) {
    var n = e.getUTCHours(), i;
    switch (n === 12 ? i = Dh.noon : n === 0 ? i = Dh.midnight : i = n / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  B: function(e, t, r) {
    var n = e.getUTCHours(), i;
    switch (n >= 17 ? i = Dh.evening : n >= 12 ? i = Dh.afternoon : n >= 4 ? i = Dh.morning : i = Dh.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  h: function(e, t, r) {
    if (t === "ho") {
      var n = e.getUTCHours() % 12;
      return n === 0 && (n = 12), r.ordinalNumber(n, {
        unit: "hour"
      });
    }
    return Gu.h(e, t);
  },
  H: function(e, t, r) {
    return t === "Ho" ? r.ordinalNumber(e.getUTCHours(), {
      unit: "hour"
    }) : Gu.H(e, t);
  },
  K: function(e, t, r) {
    var n = e.getUTCHours() % 12;
    return t === "Ko" ? r.ordinalNumber(n, {
      unit: "hour"
    }) : yn(n, t.length);
  },
  k: function(e, t, r) {
    var n = e.getUTCHours();
    return n === 0 && (n = 24), t === "ko" ? r.ordinalNumber(n, {
      unit: "hour"
    }) : yn(n, t.length);
  },
  m: function(e, t, r) {
    return t === "mo" ? r.ordinalNumber(e.getUTCMinutes(), {
      unit: "minute"
    }) : Gu.m(e, t);
  },
  s: function(e, t, r) {
    return t === "so" ? r.ordinalNumber(e.getUTCSeconds(), {
      unit: "second"
    }) : Gu.s(e, t);
  },
  S: function(e, t) {
    return Gu.S(e, t);
  },
  X: function(e, t, r, n) {
    var i = n._originalDate || e, o = i.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (t) {
      case "X":
        return G3(o);
      case "XXXX":
      case "XX":
        return Sf(o);
      case "XXXXX":
      case "XXX":
      default:
        return Sf(o, ":");
    }
  },
  x: function(e, t, r, n) {
    var i = n._originalDate || e, o = i.getTimezoneOffset();
    switch (t) {
      case "x":
        return G3(o);
      case "xxxx":
      case "xx":
        return Sf(o);
      case "xxxxx":
      case "xxx":
      default:
        return Sf(o, ":");
    }
  },
  O: function(e, t, r, n) {
    var i = n._originalDate || e, o = i.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + q3(o, ":");
      case "OOOO":
      default:
        return "GMT" + Sf(o, ":");
    }
  },
  z: function(e, t, r, n) {
    var i = n._originalDate || e, o = i.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + q3(o, ":");
      case "zzzz":
      default:
        return "GMT" + Sf(o, ":");
    }
  },
  t: function(e, t, r, n) {
    var i = n._originalDate || e, o = Math.floor(i.getTime() / 1e3);
    return yn(o, t.length);
  },
  T: function(e, t, r, n) {
    var i = n._originalDate || e, o = i.getTime();
    return yn(o, t.length);
  }
};
function q3(e, t) {
  var r = e > 0 ? "-" : "+", n = Math.abs(e), i = Math.floor(n / 60), o = n % 60;
  if (o === 0)
    return r + String(i);
  var a = t || "";
  return r + String(i) + a + yn(o, 2);
}
function G3(e, t) {
  if (e % 60 === 0) {
    var r = e > 0 ? "-" : "+";
    return r + yn(Math.abs(e) / 60, 2);
  }
  return Sf(e, t);
}
function Sf(e, t) {
  var r = t || "", n = e > 0 ? "-" : "+", i = Math.abs(e), o = yn(Math.floor(i / 60), 2), a = yn(i % 60, 2);
  return n + o + r + a;
}
var Dae = kae, Z3 = function(e, t) {
  switch (e) {
    case "P":
      return t.date({
        width: "short"
      });
    case "PP":
      return t.date({
        width: "medium"
      });
    case "PPP":
      return t.date({
        width: "long"
      });
    case "PPPP":
    default:
      return t.date({
        width: "full"
      });
  }
}, j7 = function(e, t) {
  switch (e) {
    case "p":
      return t.time({
        width: "short"
      });
    case "pp":
      return t.time({
        width: "medium"
      });
    case "ppp":
      return t.time({
        width: "long"
      });
    case "pppp":
    default:
      return t.time({
        width: "full"
      });
  }
}, Aae = function(e, t) {
  var r = e.match(/(P+)(p+)?/) || [], n = r[1], i = r[2];
  if (!i)
    return Z3(e, t);
  var o;
  switch (n) {
    case "P":
      o = t.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = t.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = t.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = t.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", Z3(n, t)).replace("{{time}}", j7(i, t));
}, Eae = {
  p: j7,
  P: Aae
}, yz = Eae, Iae = ["D", "DD"], Nae = ["YY", "YYYY"];
function F7(e) {
  return Iae.indexOf(e) !== -1;
}
function B7(e) {
  return Nae.indexOf(e) !== -1;
}
function X1(e, t, r) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var zae = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, $ae = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Oae = /^'([^]*?)'?$/, _ae = /''/g, Lae = /[a-zA-Z]/;
function Xn(e, t, r) {
  var n, i, o, a, s, u, d, f, h, g, m, v, w, x, y, C, S, T;
  cr(2, arguments);
  var A = String(t), D = Wp(), E = (n = (i = r == null ? void 0 : r.locale) !== null && i !== void 0 ? i : D.locale) !== null && n !== void 0 ? n : RM, N = wn((o = (a = (s = (u = r == null ? void 0 : r.firstWeekContainsDate) !== null && u !== void 0 ? u : r == null || (d = r.locale) === null || d === void 0 || (f = d.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && s !== void 0 ? s : D.firstWeekContainsDate) !== null && a !== void 0 ? a : (h = D.locale) === null || h === void 0 || (g = h.options) === null || g === void 0 ? void 0 : g.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(N >= 1 && N <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var I = wn((m = (v = (w = (x = r == null ? void 0 : r.weekStartsOn) !== null && x !== void 0 ? x : r == null || (y = r.locale) === null || y === void 0 || (C = y.options) === null || C === void 0 ? void 0 : C.weekStartsOn) !== null && w !== void 0 ? w : D.weekStartsOn) !== null && v !== void 0 ? v : (S = D.locale) === null || S === void 0 || (T = S.options) === null || T === void 0 ? void 0 : T.weekStartsOn) !== null && m !== void 0 ? m : 0);
  if (!(I >= 0 && I <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!E.localize)
    throw new RangeError("locale must contain localize property");
  if (!E.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var $ = Tr(e);
  if (!rl($))
    throw new RangeError("Invalid time value");
  var _ = O7($), R = _7($, _), U = {
    firstWeekContainsDate: N,
    weekStartsOn: I,
    locale: E,
    _originalDate: $
  }, Q = A.match($ae).map(function(Z) {
    var X = Z[0];
    if (X === "p" || X === "P") {
      var re = yz[X];
      return re(Z, E.formatLong);
    }
    return Z;
  }).join("").match(zae).map(function(Z) {
    if (Z === "''")
      return "'";
    var X = Z[0];
    if (X === "'")
      return Pae(Z);
    var re = Dae[X];
    if (re)
      return !(r != null && r.useAdditionalWeekYearTokens) && B7(Z) && X1(Z, t, String(e)), !(r != null && r.useAdditionalDayOfYearTokens) && F7(Z) && X1(Z, t, String(e)), re(R, Z, E.localize, U);
    if (X.match(Lae))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + X + "`");
    return Z;
  }).join("");
  return Q;
}
function Pae(e) {
  var t = e.match(Oae);
  return t ? t[1].replace(_ae, "'") : e;
}
function Rae(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
  return e;
}
function $l(e) {
  cr(1, arguments);
  var t = Tr(e), r = t.getDate();
  return r;
}
function jae(e) {
  cr(1, arguments);
  var t = Tr(e), r = t.getDay();
  return r;
}
function Fae(e) {
  cr(1, arguments);
  var t = Tr(e), r = t.getFullYear(), n = t.getMonth(), i = new Date(0);
  return i.setFullYear(r, n + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function ac(e) {
  cr(1, arguments);
  var t = Tr(e), r = t.getHours();
  return r;
}
function J1(e) {
  cr(1, arguments);
  var t = Tr(e), r = t.getMinutes();
  return r;
}
function Gn(e) {
  cr(1, arguments);
  var t = Tr(e), r = t.getMonth();
  return r;
}
function ex(e) {
  cr(1, arguments);
  var t = Tr(e), r = t.getSeconds();
  return r;
}
function Lt(e) {
  cr(1, arguments);
  var t = Tr(e), r = t.getTime();
  return r;
}
function si(e) {
  return cr(1, arguments), Tr(e).getFullYear();
}
function tx(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var Bae = 10;
class U7 {
  constructor() {
    tx(this, "priority", void 0), tx(this, "subPriority", 0);
  }
  validate(t, r) {
    return !0;
  }
}
class Uae extends U7 {
  constructor(t, r, n, i, o) {
    super(), this.value = t, this.validateValue = r, this.setValue = n, this.priority = i, o && (this.subPriority = o);
  }
  validate(t, r) {
    return this.validateValue(t, this.value, r);
  }
  set(t, r, n) {
    return this.setValue(t, r, this.value, n);
  }
}
class Hae extends U7 {
  constructor() {
    super(...arguments), tx(this, "priority", Bae), tx(this, "subPriority", -1);
  }
  set(t, r) {
    if (r.timestampIsSet)
      return t;
    var n = new Date(0);
    return n.setFullYear(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()), n.setHours(t.getUTCHours(), t.getUTCMinutes(), t.getUTCSeconds(), t.getUTCMilliseconds()), n;
  }
}
function NI(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class fn {
  constructor() {
    NI(this, "incompatibleTokens", void 0), NI(this, "priority", void 0), NI(this, "subPriority", void 0);
  }
  run(t, r, n, i) {
    var o = this.parse(t, r, n, i);
    return o ? {
      setter: new Uae(o.value, this.validate, this.set, this.priority, this.subPriority),
      rest: o.rest
    } : null;
  }
  validate(t, r, n) {
    return !0;
  }
}
function K3(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class Wae extends fn {
  constructor() {
    super(...arguments), K3(this, "priority", 140), K3(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, r, n) {
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(t, {
          width: "abbreviated"
        }) || n.era(t, {
          width: "narrow"
        });
      case "GGGGG":
        return n.era(t, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return n.era(t, {
          width: "wide"
        }) || n.era(t, {
          width: "abbreviated"
        }) || n.era(t, {
          width: "narrow"
        });
    }
  }
  set(t, r, n) {
    return r.era = n, t.setUTCFullYear(n, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
  }
}
var Ii = {
  month: /^(1[0-2]|0?\d)/,
  date: /^(3[0-1]|[0-2]?\d)/,
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  week: /^(5[0-3]|[0-4]?\d)/,
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  hour11h: /^(1[0-1]|0?\d)/,
  hour12h: /^(1[0-2]|0?\d)/,
  minute: /^[0-5]?\d/,
  second: /^[0-5]?\d/,
  singleDigit: /^\d/,
  twoDigits: /^\d{1,2}/,
  threeDigits: /^\d{1,3}/,
  fourDigits: /^\d{1,4}/,
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  twoDigitsSigned: /^-?\d{1,2}/,
  threeDigitsSigned: /^-?\d{1,3}/,
  fourDigitsSigned: /^-?\d{1,4}/
}, us = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Ni(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function ci(e, t) {
  var r = t.match(e);
  return r ? {
    value: parseInt(r[0], 10),
    rest: t.slice(r[0].length)
  } : null;
}
function cs(e, t) {
  var r = t.match(e);
  if (!r)
    return null;
  if (r[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var n = r[1] === "+" ? 1 : -1, i = r[2] ? parseInt(r[2], 10) : 0, o = r[3] ? parseInt(r[3], 10) : 0, a = r[5] ? parseInt(r[5], 10) : 0;
  return {
    value: n * (i * hae + o * fae + a * pae),
    rest: t.slice(r[0].length)
  };
}
function H7(e) {
  return ci(Ii.anyDigitsSigned, e);
}
function bi(e, t) {
  switch (e) {
    case 1:
      return ci(Ii.singleDigit, t);
    case 2:
      return ci(Ii.twoDigits, t);
    case 3:
      return ci(Ii.threeDigits, t);
    case 4:
      return ci(Ii.fourDigits, t);
    default:
      return ci(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function rx(e, t) {
  switch (e) {
    case 1:
      return ci(Ii.singleDigitSigned, t);
    case 2:
      return ci(Ii.twoDigitsSigned, t);
    case 3:
      return ci(Ii.threeDigitsSigned, t);
    case 4:
      return ci(Ii.fourDigitsSigned, t);
    default:
      return ci(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function m4(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function W7(e, t) {
  var r = t > 0, n = r ? t : 1 - t, i;
  if (n <= 50)
    i = e || 100;
  else {
    var o = n + 50, a = Math.floor(o / 100) * 100, s = e >= o % 100;
    i = e + a - (s ? 100 : 0);
  }
  return r ? i : 1 - i;
}
function V7(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function X3(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class Vae extends fn {
  constructor() {
    super(...arguments), X3(this, "priority", 130), X3(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, r, n) {
    var i = function(o) {
      return {
        year: o,
        isTwoDigitYear: r === "yy"
      };
    };
    switch (r) {
      case "y":
        return Ni(bi(4, t), i);
      case "yo":
        return Ni(n.ordinalNumber(t, {
          unit: "year"
        }), i);
      default:
        return Ni(bi(r.length, t), i);
    }
  }
  validate(t, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(t, r, n) {
    var i = t.getUTCFullYear();
    if (n.isTwoDigitYear) {
      var o = W7(n.year, i);
      return t.setUTCFullYear(o, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
    }
    var a = !("era" in r) || r.era === 1 ? n.year : 1 - n.year;
    return t.setUTCFullYear(a, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
  }
}
function J3(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class Yae extends fn {
  constructor() {
    super(...arguments), J3(this, "priority", 130), J3(this, "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]);
  }
  parse(t, r, n) {
    var i = function(o) {
      return {
        year: o,
        isTwoDigitYear: r === "YY"
      };
    };
    switch (r) {
      case "Y":
        return Ni(bi(4, t), i);
      case "Yo":
        return Ni(n.ordinalNumber(t, {
          unit: "year"
        }), i);
      default:
        return Ni(bi(r.length, t), i);
    }
  }
  validate(t, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(t, r, n, i) {
    var o = g4(t, i);
    if (n.isTwoDigitYear) {
      var a = W7(n.year, o);
      return t.setUTCFullYear(a, 0, i.firstWeekContainsDate), t.setUTCHours(0, 0, 0, 0), Fu(t, i);
    }
    var s = !("era" in r) || r.era === 1 ? n.year : 1 - n.year;
    return t.setUTCFullYear(s, 0, i.firstWeekContainsDate), t.setUTCHours(0, 0, 0, 0), Fu(t, i);
  }
}
function eP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class Qae extends fn {
  constructor() {
    super(...arguments), eP(this, "priority", 130), eP(this, "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]);
  }
  parse(t, r) {
    return rx(r === "R" ? 4 : r.length, t);
  }
  set(t, r, n) {
    var i = new Date(0);
    return i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0), mp(i);
  }
}
function tP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class qae extends fn {
  constructor() {
    super(...arguments), tP(this, "priority", 130), tP(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, r) {
    return rx(r === "u" ? 4 : r.length, t);
  }
  set(t, r, n) {
    return t.setUTCFullYear(n, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
  }
}
function rP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class Gae extends fn {
  constructor() {
    super(...arguments), rP(this, "priority", 120), rP(this, "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]);
  }
  parse(t, r, n) {
    switch (r) {
      case "Q":
      case "QQ":
        return bi(r.length, t);
      case "Qo":
        return n.ordinalNumber(t, {
          unit: "quarter"
        });
      case "QQQ":
        return n.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || n.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 4;
  }
  set(t, r, n) {
    return t.setUTCMonth((n - 1) * 3, 1), t.setUTCHours(0, 0, 0, 0), t;
  }
}
function nP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class Zae extends fn {
  constructor() {
    super(...arguments), nP(this, "priority", 120), nP(this, "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]);
  }
  parse(t, r, n) {
    switch (r) {
      case "q":
      case "qq":
        return bi(r.length, t);
      case "qo":
        return n.ordinalNumber(t, {
          unit: "quarter"
        });
      case "qqq":
        return n.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || n.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || n.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || n.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 4;
  }
  set(t, r, n) {
    return t.setUTCMonth((n - 1) * 3, 1), t.setUTCHours(0, 0, 0, 0), t;
  }
}
function iP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class Kae extends fn {
  constructor() {
    super(...arguments), iP(this, "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), iP(this, "priority", 110);
  }
  parse(t, r, n) {
    var i = function(o) {
      return o - 1;
    };
    switch (r) {
      case "M":
        return Ni(ci(Ii.month, t), i);
      case "MM":
        return Ni(bi(2, t), i);
      case "Mo":
        return Ni(n.ordinalNumber(t, {
          unit: "month"
        }), i);
      case "MMM":
        return n.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(t, {
          width: "wide",
          context: "formatting"
        }) || n.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.month(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, n) {
    return t.setUTCMonth(n, 1), t.setUTCHours(0, 0, 0, 0), t;
  }
}
function oP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class Xae extends fn {
  constructor() {
    super(...arguments), oP(this, "priority", 110), oP(this, "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]);
  }
  parse(t, r, n) {
    var i = function(o) {
      return o - 1;
    };
    switch (r) {
      case "L":
        return Ni(ci(Ii.month, t), i);
      case "LL":
        return Ni(bi(2, t), i);
      case "Lo":
        return Ni(n.ordinalNumber(t, {
          unit: "month"
        }), i);
      case "LLL":
        return n.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || n.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(t, {
          width: "wide",
          context: "standalone"
        }) || n.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || n.month(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, n) {
    return t.setUTCMonth(n, 1), t.setUTCHours(0, 0, 0, 0), t;
  }
}
function Jae(e, t, r) {
  cr(2, arguments);
  var n = Tr(e), i = wn(t), o = R7(n, r) - i;
  return n.setUTCDate(n.getUTCDate() - o * 7), n;
}
function aP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class ele extends fn {
  constructor() {
    super(...arguments), aP(this, "priority", 100), aP(this, "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]);
  }
  parse(t, r, n) {
    switch (r) {
      case "w":
        return ci(Ii.week, t);
      case "wo":
        return n.ordinalNumber(t, {
          unit: "week"
        });
      default:
        return bi(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 53;
  }
  set(t, r, n, i) {
    return Fu(Jae(t, n, i), i);
  }
}
function tle(e, t) {
  cr(2, arguments);
  var r = Tr(e), n = wn(t), i = P7(r) - n;
  return r.setUTCDate(r.getUTCDate() - i * 7), r;
}
function lP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class rle extends fn {
  constructor() {
    super(...arguments), lP(this, "priority", 100), lP(this, "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]);
  }
  parse(t, r, n) {
    switch (r) {
      case "I":
        return ci(Ii.week, t);
      case "Io":
        return n.ordinalNumber(t, {
          unit: "week"
        });
      default:
        return bi(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 53;
  }
  set(t, r, n) {
    return mp(tle(t, n));
  }
}
function zI(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var nle = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], ile = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
class ole extends fn {
  constructor() {
    super(...arguments), zI(this, "priority", 90), zI(this, "subPriority", 1), zI(this, "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]);
  }
  parse(t, r, n) {
    switch (r) {
      case "d":
        return ci(Ii.date, t);
      case "do":
        return n.ordinalNumber(t, {
          unit: "date"
        });
      default:
        return bi(r.length, t);
    }
  }
  validate(t, r) {
    var n = t.getUTCFullYear(), i = V7(n), o = t.getUTCMonth();
    return i ? r >= 1 && r <= ile[o] : r >= 1 && r <= nle[o];
  }
  set(t, r, n) {
    return t.setUTCDate(n), t.setUTCHours(0, 0, 0, 0), t;
  }
}
function $I(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class ale extends fn {
  constructor() {
    super(...arguments), $I(this, "priority", 90), $I(this, "subpriority", 1), $I(this, "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]);
  }
  parse(t, r, n) {
    switch (r) {
      case "D":
      case "DD":
        return ci(Ii.dayOfYear, t);
      case "Do":
        return n.ordinalNumber(t, {
          unit: "date"
        });
      default:
        return bi(r.length, t);
    }
  }
  validate(t, r) {
    var n = t.getUTCFullYear(), i = V7(n);
    return i ? r >= 1 && r <= 366 : r >= 1 && r <= 365;
  }
  set(t, r, n) {
    return t.setUTCMonth(0, n), t.setUTCHours(0, 0, 0, 0), t;
  }
}
function v4(e, t, r) {
  var n, i, o, a, s, u, d, f;
  cr(2, arguments);
  var h = Wp(), g = wn((n = (i = (o = (a = r == null ? void 0 : r.weekStartsOn) !== null && a !== void 0 ? a : r == null || (s = r.locale) === null || s === void 0 || (u = s.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && o !== void 0 ? o : h.weekStartsOn) !== null && i !== void 0 ? i : (d = h.locale) === null || d === void 0 || (f = d.options) === null || f === void 0 ? void 0 : f.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(g >= 0 && g <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var m = Tr(e), v = wn(t), w = m.getUTCDay(), x = v % 7, y = (x + 7) % 7, C = (y < g ? 7 : 0) + v - w;
  return m.setUTCDate(m.getUTCDate() + C), m;
}
function sP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class lle extends fn {
  constructor() {
    super(...arguments), sP(this, "priority", 90), sP(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, r, n) {
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.day(t, {
          width: "short",
          context: "formatting"
        }) || n.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(t, {
          width: "short",
          context: "formatting"
        }) || n.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(t, {
          width: "wide",
          context: "formatting"
        }) || n.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.day(t, {
          width: "short",
          context: "formatting"
        }) || n.day(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, n, i) {
    return t = v4(t, n, i), t.setUTCHours(0, 0, 0, 0), t;
  }
}
function uP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class sle extends fn {
  constructor() {
    super(...arguments), uP(this, "priority", 90), uP(this, "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]);
  }
  parse(t, r, n, i) {
    var o = function(a) {
      var s = Math.floor((a - 1) / 7) * 7;
      return (a + i.weekStartsOn + 6) % 7 + s;
    };
    switch (r) {
      case "e":
      case "ee":
        return Ni(bi(r.length, t), o);
      case "eo":
        return Ni(n.ordinalNumber(t, {
          unit: "day"
        }), o);
      case "eee":
        return n.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.day(t, {
          width: "short",
          context: "formatting"
        }) || n.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeee":
        return n.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(t, {
          width: "short",
          context: "formatting"
        }) || n.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(t, {
          width: "wide",
          context: "formatting"
        }) || n.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.day(t, {
          width: "short",
          context: "formatting"
        }) || n.day(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, n, i) {
    return t = v4(t, n, i), t.setUTCHours(0, 0, 0, 0), t;
  }
}
function cP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class ule extends fn {
  constructor() {
    super(...arguments), cP(this, "priority", 90), cP(this, "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]);
  }
  parse(t, r, n, i) {
    var o = function(a) {
      var s = Math.floor((a - 1) / 7) * 7;
      return (a + i.weekStartsOn + 6) % 7 + s;
    };
    switch (r) {
      case "c":
      case "cc":
        return Ni(bi(r.length, t), o);
      case "co":
        return Ni(n.ordinalNumber(t, {
          unit: "day"
        }), o);
      case "ccc":
        return n.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || n.day(t, {
          width: "short",
          context: "standalone"
        }) || n.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "ccccc":
        return n.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(t, {
          width: "short",
          context: "standalone"
        }) || n.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(t, {
          width: "wide",
          context: "standalone"
        }) || n.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || n.day(t, {
          width: "short",
          context: "standalone"
        }) || n.day(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, n, i) {
    return t = v4(t, n, i), t.setUTCHours(0, 0, 0, 0), t;
  }
}
function cle(e, t) {
  cr(2, arguments);
  var r = wn(t);
  r % 7 === 0 && (r = r - 7);
  var n = 1, i = Tr(e), o = i.getUTCDay(), a = r % 7, s = (a + 7) % 7, u = (s < n ? 7 : 0) + r - o;
  return i.setUTCDate(i.getUTCDate() + u), i;
}
function dP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class dle extends fn {
  constructor() {
    super(...arguments), dP(this, "priority", 90), dP(this, "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]);
  }
  parse(t, r, n) {
    var i = function(o) {
      return o === 0 ? 7 : o;
    };
    switch (r) {
      case "i":
      case "ii":
        return bi(r.length, t);
      case "io":
        return n.ordinalNumber(t, {
          unit: "day"
        });
      case "iii":
        return Ni(n.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.day(t, {
          width: "short",
          context: "formatting"
        }) || n.day(t, {
          width: "narrow",
          context: "formatting"
        }), i);
      case "iiiii":
        return Ni(n.day(t, {
          width: "narrow",
          context: "formatting"
        }), i);
      case "iiiiii":
        return Ni(n.day(t, {
          width: "short",
          context: "formatting"
        }) || n.day(t, {
          width: "narrow",
          context: "formatting"
        }), i);
      case "iiii":
      default:
        return Ni(n.day(t, {
          width: "wide",
          context: "formatting"
        }) || n.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.day(t, {
          width: "short",
          context: "formatting"
        }) || n.day(t, {
          width: "narrow",
          context: "formatting"
        }), i);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 7;
  }
  set(t, r, n) {
    return t = cle(t, n), t.setUTCHours(0, 0, 0, 0), t;
  }
}
function fP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class fle extends fn {
  constructor() {
    super(...arguments), fP(this, "priority", 80), fP(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, r, n) {
    switch (r) {
      case "a":
      case "aa":
      case "aaa":
        return n.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, n) {
    return t.setUTCHours(m4(n), 0, 0, 0), t;
  }
}
function hP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class hle extends fn {
  constructor() {
    super(...arguments), hP(this, "priority", 80), hP(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, r, n) {
    switch (r) {
      case "b":
      case "bb":
      case "bbb":
        return n.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, n) {
    return t.setUTCHours(m4(n), 0, 0, 0), t;
  }
}
function pP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class ple extends fn {
  constructor() {
    super(...arguments), pP(this, "priority", 80), pP(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, r, n) {
    switch (r) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, n) {
    return t.setUTCHours(m4(n), 0, 0, 0), t;
  }
}
function gP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class gle extends fn {
  constructor() {
    super(...arguments), gP(this, "priority", 70), gP(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, r, n) {
    switch (r) {
      case "h":
        return ci(Ii.hour12h, t);
      case "ho":
        return n.ordinalNumber(t, {
          unit: "hour"
        });
      default:
        return bi(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 12;
  }
  set(t, r, n) {
    var i = t.getUTCHours() >= 12;
    return i && n < 12 ? t.setUTCHours(n + 12, 0, 0, 0) : !i && n === 12 ? t.setUTCHours(0, 0, 0, 0) : t.setUTCHours(n, 0, 0, 0), t;
  }
}
function mP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class mle extends fn {
  constructor() {
    super(...arguments), mP(this, "priority", 70), mP(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, r, n) {
    switch (r) {
      case "H":
        return ci(Ii.hour23h, t);
      case "Ho":
        return n.ordinalNumber(t, {
          unit: "hour"
        });
      default:
        return bi(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 23;
  }
  set(t, r, n) {
    return t.setUTCHours(n, 0, 0, 0), t;
  }
}
function vP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class vle extends fn {
  constructor() {
    super(...arguments), vP(this, "priority", 70), vP(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, r, n) {
    switch (r) {
      case "K":
        return ci(Ii.hour11h, t);
      case "Ko":
        return n.ordinalNumber(t, {
          unit: "hour"
        });
      default:
        return bi(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, n) {
    var i = t.getUTCHours() >= 12;
    return i && n < 12 ? t.setUTCHours(n + 12, 0, 0, 0) : t.setUTCHours(n, 0, 0, 0), t;
  }
}
function bP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class ble extends fn {
  constructor() {
    super(...arguments), bP(this, "priority", 70), bP(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, r, n) {
    switch (r) {
      case "k":
        return ci(Ii.hour24h, t);
      case "ko":
        return n.ordinalNumber(t, {
          unit: "hour"
        });
      default:
        return bi(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 24;
  }
  set(t, r, n) {
    var i = n <= 24 ? n % 24 : n;
    return t.setUTCHours(i, 0, 0, 0), t;
  }
}
function yP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class yle extends fn {
  constructor() {
    super(...arguments), yP(this, "priority", 60), yP(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r, n) {
    switch (r) {
      case "m":
        return ci(Ii.minute, t);
      case "mo":
        return n.ordinalNumber(t, {
          unit: "minute"
        });
      default:
        return bi(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 59;
  }
  set(t, r, n) {
    return t.setUTCMinutes(n, 0, 0), t;
  }
}
function xP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class xle extends fn {
  constructor() {
    super(...arguments), xP(this, "priority", 50), xP(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r, n) {
    switch (r) {
      case "s":
        return ci(Ii.second, t);
      case "so":
        return n.ordinalNumber(t, {
          unit: "second"
        });
      default:
        return bi(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 59;
  }
  set(t, r, n) {
    return t.setUTCSeconds(n, 0), t;
  }
}
function wP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class wle extends fn {
  constructor() {
    super(...arguments), wP(this, "priority", 30), wP(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r) {
    var n = function(i) {
      return Math.floor(i * Math.pow(10, -r.length + 3));
    };
    return Ni(bi(r.length, t), n);
  }
  set(t, r, n) {
    return t.setUTCMilliseconds(n), t;
  }
}
function MP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class Mle extends fn {
  constructor() {
    super(...arguments), MP(this, "priority", 10), MP(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, r) {
    switch (r) {
      case "X":
        return cs(us.basicOptionalMinutes, t);
      case "XX":
        return cs(us.basic, t);
      case "XXXX":
        return cs(us.basicOptionalSeconds, t);
      case "XXXXX":
        return cs(us.extendedOptionalSeconds, t);
      case "XXX":
      default:
        return cs(us.extended, t);
    }
  }
  set(t, r, n) {
    return r.timestampIsSet ? t : new Date(t.getTime() - n);
  }
}
function CP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class Cle extends fn {
  constructor() {
    super(...arguments), CP(this, "priority", 10), CP(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, r) {
    switch (r) {
      case "x":
        return cs(us.basicOptionalMinutes, t);
      case "xx":
        return cs(us.basic, t);
      case "xxxx":
        return cs(us.basicOptionalSeconds, t);
      case "xxxxx":
        return cs(us.extendedOptionalSeconds, t);
      case "xxx":
      default:
        return cs(us.extended, t);
    }
  }
  set(t, r, n) {
    return r.timestampIsSet ? t : new Date(t.getTime() - n);
  }
}
function SP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class Sle extends fn {
  constructor() {
    super(...arguments), SP(this, "priority", 40), SP(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return H7(t);
  }
  set(t, r, n) {
    return [new Date(n * 1e3), {
      timestampIsSet: !0
    }];
  }
}
function TP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
class Tle extends fn {
  constructor() {
    super(...arguments), TP(this, "priority", 20), TP(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return H7(t);
  }
  set(t, r, n) {
    return [new Date(n), {
      timestampIsSet: !0
    }];
  }
}
var kle = {
  G: new Wae(),
  y: new Vae(),
  Y: new Yae(),
  R: new Qae(),
  u: new qae(),
  Q: new Gae(),
  q: new Zae(),
  M: new Kae(),
  L: new Xae(),
  w: new ele(),
  I: new rle(),
  d: new ole(),
  D: new ale(),
  E: new lle(),
  e: new sle(),
  c: new ule(),
  i: new dle(),
  a: new fle(),
  b: new hle(),
  B: new ple(),
  h: new gle(),
  H: new mle(),
  K: new vle(),
  k: new ble(),
  m: new yle(),
  s: new xle(),
  S: new wle(),
  X: new Mle(),
  x: new Cle(),
  t: new Sle(),
  T: new Tle()
}, Dle = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Ale = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ele = /^'([^]*?)'?$/, Ile = /''/g, Nle = /\S/, zle = /[a-zA-Z]/;
function $le(e, t, r, n) {
  var i, o, a, s, u, d, f, h, g, m, v, w, x, y, C, S, T, A;
  cr(3, arguments);
  var D = String(e), E = String(t), N = Wp(), I = (i = (o = n == null ? void 0 : n.locale) !== null && o !== void 0 ? o : N.locale) !== null && i !== void 0 ? i : RM;
  if (!I.match)
    throw new RangeError("locale must contain match property");
  var $ = wn((a = (s = (u = (d = n == null ? void 0 : n.firstWeekContainsDate) !== null && d !== void 0 ? d : n == null || (f = n.locale) === null || f === void 0 || (h = f.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && u !== void 0 ? u : N.firstWeekContainsDate) !== null && s !== void 0 ? s : (g = N.locale) === null || g === void 0 || (m = g.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!($ >= 1 && $ <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var _ = wn((v = (w = (x = (y = n == null ? void 0 : n.weekStartsOn) !== null && y !== void 0 ? y : n == null || (C = n.locale) === null || C === void 0 || (S = C.options) === null || S === void 0 ? void 0 : S.weekStartsOn) !== null && x !== void 0 ? x : N.weekStartsOn) !== null && w !== void 0 ? w : (T = N.locale) === null || T === void 0 || (A = T.options) === null || A === void 0 ? void 0 : A.weekStartsOn) !== null && v !== void 0 ? v : 0);
  if (!(_ >= 0 && _ <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (E === "")
    return D === "" ? Tr(r) : new Date(NaN);
  var R = {
    firstWeekContainsDate: $,
    weekStartsOn: _,
    locale: I
  }, U = [new Hae()], Q = E.match(Ale).map(function(Ae) {
    var Ne = Ae[0];
    if (Ne in yz) {
      var $e = yz[Ne];
      return $e(Ae, I.formatLong);
    }
    return Ae;
  }).join("").match(Dle), Z = [], X = function(Ae) {
    !(n != null && n.useAdditionalWeekYearTokens) && B7(Ae) && X1(Ae, E, e), !(n != null && n.useAdditionalDayOfYearTokens) && F7(Ae) && X1(Ae, E, e);
    var Ne = Ae[0], $e = kle[Ne];
    if ($e) {
      var et = $e.incompatibleTokens;
      if (Array.isArray(et)) {
        var Ge = Z.find(function(qe) {
          return et.includes(qe.token) || qe.token === Ne;
        });
        if (Ge)
          throw new RangeError("The format string mustn't contain `".concat(Ge.fullToken, "` and `").concat(Ae, "` at the same time"));
      } else if ($e.incompatibleTokens === "*" && Z.length > 0)
        throw new RangeError("The format string mustn't contain `".concat(Ae, "` and any other token at the same time"));
      Z.push({
        token: Ne,
        fullToken: Ae
      });
      var Ee = $e.run(D, Ae, I.match, R);
      if (!Ee)
        return re = Ae, {
          v: new Date(NaN)
        };
      U.push(Ee.setter), D = Ee.rest;
    } else {
      if (Ne.match(zle))
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + Ne + "`");
      if (Ae === "''" ? Ae = "'" : Ne === "'" && (Ae = Ole(Ae)), D.indexOf(Ae) === 0)
        D = D.slice(Ae.length);
      else
        return re = Ae, {
          v: new Date(NaN)
        };
    }
    re = Ae;
  };
  for (var re of Q) {
    var ue = X(re);
    if (typeof ue == "object")
      return ue.v;
  }
  if (D.length > 0 && Nle.test(D))
    return new Date(NaN);
  var he = U.map(function(Ae) {
    return Ae.priority;
  }).sort(function(Ae, Ne) {
    return Ne - Ae;
  }).filter(function(Ae, Ne, $e) {
    return $e.indexOf(Ae) === Ne;
  }).map(function(Ae) {
    return U.filter(function(Ne) {
      return Ne.priority === Ae;
    }).sort(function(Ne, $e) {
      return $e.subPriority - Ne.subPriority;
    });
  }).map(function(Ae) {
    return Ae[0];
  }), te = Tr(r);
  if (isNaN(te.getTime()))
    return new Date(NaN);
  var de = _7(te, O7(te)), De = {};
  for (var Oe of he) {
    if (!Oe.validate(de, R))
      return new Date(NaN);
    var Qe = Oe.set(de, De, R);
    Array.isArray(Qe) ? (de = Qe[0], Rae(De, Qe[1])) : de = Qe;
  }
  return de;
}
function Ole(e) {
  return e.match(Ele)[1].replace(Ile, "'");
}
function _le(e) {
  cr(1, arguments);
  var t = Tr(e);
  return t.setMinutes(0, 0, 0), t;
}
function jM(e, t) {
  cr(2, arguments);
  var r = Tr(e), n = Tr(t);
  return r.getFullYear() === n.getFullYear() && r.getMonth() === n.getMonth();
}
function Y7(e, t) {
  cr(2, arguments);
  var r = k0(e), n = k0(t);
  return r.getTime() === n.getTime();
}
function b4(e) {
  cr(1, arguments);
  var t = Tr(e);
  return t.setMilliseconds(0), t;
}
function Q7(e, t) {
  cr(2, arguments);
  var r = Tr(e), n = Tr(t);
  return r.getFullYear() === n.getFullYear();
}
function y4(e, t) {
  cr(2, arguments);
  var r = Tr(e), n = wn(t), i = r.getFullYear(), o = r.getDate(), a = new Date(0);
  a.setFullYear(i, n, 15), a.setHours(0, 0, 0, 0);
  var s = Fae(a);
  return r.setMonth(n, Math.min(o, s)), r;
}
function xo(e, t) {
  if (cr(2, arguments), typeof t != "object" || t === null)
    throw new RangeError("values parameter must be an object");
  var r = Tr(e);
  return isNaN(r.getTime()) ? new Date(NaN) : (t.year != null && r.setFullYear(t.year), t.month != null && (r = y4(r, t.month)), t.date != null && r.setDate(wn(t.date)), t.hours != null && r.setHours(wn(t.hours)), t.minutes != null && r.setMinutes(wn(t.minutes)), t.seconds != null && r.setSeconds(wn(t.seconds)), t.milliseconds != null && r.setMilliseconds(wn(t.milliseconds)), r);
}
function pf(e, t) {
  cr(2, arguments);
  var r = Tr(e), n = wn(t);
  return r.setHours(n), r;
}
function OI(e, t) {
  cr(2, arguments);
  var r = Tr(e), n = wn(t);
  return r.setMinutes(n), r;
}
function Lle(e, t) {
  cr(2, arguments);
  var r = Tr(e), n = wn(t), i = Math.floor(r.getMonth() / 3) + 1, o = n - i;
  return y4(r, r.getMonth() + o * 3);
}
function _I(e, t) {
  cr(2, arguments);
  var r = Tr(e), n = wn(t);
  return r.setSeconds(n), r;
}
function kP(e, t) {
  cr(2, arguments);
  var r = Tr(e), n = wn(t);
  return isNaN(r.getTime()) ? new Date(NaN) : (r.setFullYear(n), r);
}
var DP = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "halbe Minute",
    withPreposition: "halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
}, Ple = function(e, t, r) {
  var n, i = r != null && r.addSuffix ? DP[e].withPreposition : DP[e].standalone;
  return typeof i == "string" ? n = i : t === 1 ? n = i.one : n = i.other.replace("{{count}}", String(t)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : "vor " + n : n;
}, Rle = Ple, jle = {
  full: "EEEE, do MMMM y",
  long: "do MMMM y",
  medium: "do MMM y",
  short: "dd.MM.y"
}, Fle = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Ble = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Ule = {
  date: jr({
    formats: jle,
    defaultWidth: "full"
  }),
  time: jr({
    formats: Fle,
    defaultWidth: "full"
  }),
  dateTime: jr({
    formats: Ble,
    defaultWidth: "full"
  })
}, Hle = Ule, Wle = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, Vle = function(e, t, r, n) {
  return Wle[e];
}, Yle = Vle, Qle = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, qle = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, xz = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
  wide: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
}, Gle = {
  narrow: xz.narrow,
  abbreviated: ["Jan.", "Feb.", "März", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
  wide: xz.wide
}, Zle = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
}, Kle = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, Xle = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, Jle = function(e) {
  var t = Number(e);
  return t + ".";
}, ese = {
  ordinalNumber: Jle,
  era: Kt({
    values: Qle,
    defaultWidth: "wide"
  }),
  quarter: Kt({
    values: qle,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: Kt({
    values: xz,
    formattingValues: Gle,
    defaultWidth: "wide"
  }),
  day: Kt({
    values: Zle,
    defaultWidth: "wide"
  }),
  dayPeriod: Kt({
    values: Kle,
    defaultWidth: "wide",
    formattingValues: Xle,
    defaultFormattingWidth: "wide"
  })
}, tse = ese, rse = /^(\d+)(\.)?/i, nse = /\d+/i, ise = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
}, ose = {
  any: [/^v/i, /^n/i]
}, ase = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, lse = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, sse = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
}, use = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, cse = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
}, dse = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
}, fse = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
}, hse = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    evening: /abends/i,
    night: /nachts/i
  }
}, pse = {
  ordinalNumber: hl({
    matchPattern: rse,
    parsePattern: nse,
    valueCallback: function(e) {
      return parseInt(e);
    }
  }),
  era: Xt({
    matchPatterns: ise,
    defaultMatchWidth: "wide",
    parsePatterns: ose,
    defaultParseWidth: "any"
  }),
  quarter: Xt({
    matchPatterns: ase,
    defaultMatchWidth: "wide",
    parsePatterns: lse,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: Xt({
    matchPatterns: sse,
    defaultMatchWidth: "wide",
    parsePatterns: use,
    defaultParseWidth: "any"
  }),
  day: Xt({
    matchPatterns: cse,
    defaultMatchWidth: "wide",
    parsePatterns: dse,
    defaultParseWidth: "any"
  }),
  dayPeriod: Xt({
    matchPatterns: fse,
    defaultMatchWidth: "wide",
    parsePatterns: hse,
    defaultParseWidth: "any"
  })
}, gse = pse, mse = {
  code: "de",
  formatDistance: Rle,
  formatLong: Hle,
  formatRelative: Yle,
  localize: tse,
  match: gse,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, vse = mse, bse = {
  lessThanXSeconds: {
    one: "mindre enn ett sekund",
    other: "mindre enn {{count}} sekunder"
  },
  xSeconds: {
    one: "ett sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "et halvt minutt",
  lessThanXMinutes: {
    one: "mindre enn ett minutt",
    other: "mindre enn {{count}} minutter"
  },
  xMinutes: {
    one: "ett minutt",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "omtrent en time",
    other: "omtrent {{count}} timer"
  },
  xHours: {
    one: "en time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dager"
  },
  aboutXWeeks: {
    one: "omtrent en uke",
    other: "omtrent {{count}} uker"
  },
  xWeeks: {
    one: "en uke",
    other: "{{count}} uker"
  },
  aboutXMonths: {
    one: "omtrent en måned",
    other: "omtrent {{count}} måneder"
  },
  xMonths: {
    one: "en måned",
    other: "{{count}} måneder"
  },
  aboutXYears: {
    one: "omtrent ett år",
    other: "omtrent {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over ett år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "nesten ett år",
    other: "nesten {{count}} år"
  }
}, yse = function(e, t, r) {
  var n, i = bse[e];
  return typeof i == "string" ? n = i : t === 1 ? n = i.one : n = i.other.replace("{{count}}", String(t)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "om " + n : n + " siden" : n;
}, xse = yse, wse = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y"
}, Mse = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Cse = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Sse = {
  date: jr({
    formats: wse,
    defaultWidth: "full"
  }),
  time: jr({
    formats: Mse,
    defaultWidth: "full"
  }),
  dateTime: jr({
    formats: Cse,
    defaultWidth: "full"
  })
}, Tse = Sse, kse = {
  lastWeek: "'forrige' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, Dse = function(e, t, r, n) {
  return kse[e];
}, Ase = Dse, Ese = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["før Kristus", "etter Kristus"]
}, Ise = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, Nse = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apr.", "mai", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "des."],
  wide: ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"]
}, zse = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn", "man", "tir", "ons", "tor", "fre", "lør"],
  wide: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"]
}, $se = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natten"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgenen",
    afternoon: "på ettermiddagen",
    evening: "på kvelden",
    night: "på natten"
  }
}, Ose = function(e, t) {
  var r = Number(e);
  return r + ".";
}, _se = {
  ordinalNumber: Ose,
  era: Kt({
    values: Ese,
    defaultWidth: "wide"
  }),
  quarter: Kt({
    values: Ise,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: Kt({
    values: Nse,
    defaultWidth: "wide"
  }),
  day: Kt({
    values: zse,
    defaultWidth: "wide"
  }),
  dayPeriod: Kt({
    values: $se,
    defaultWidth: "wide"
  })
}, Lse = _se, Pse = /^(\d+)\.?/i, Rse = /\d+/i, jse = {
  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
}, Fse = {
  any: [/^f/i, /^e/i]
}, Bse = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartal/i
}, Use = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Hse = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
}, Wse = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Vse = {
  narrow: /^[smtofl]/i,
  short: /^(sø|ma|ti|on|to|fr|lø)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, Yse = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, Qse = {
  narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
}, qse = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgen/i,
    afternoon: /ettermiddag/i,
    evening: /kveld/i,
    night: /natt/i
  }
}, Gse = {
  ordinalNumber: hl({
    matchPattern: Pse,
    parsePattern: Rse,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Xt({
    matchPatterns: jse,
    defaultMatchWidth: "wide",
    parsePatterns: Fse,
    defaultParseWidth: "any"
  }),
  quarter: Xt({
    matchPatterns: Bse,
    defaultMatchWidth: "wide",
    parsePatterns: Use,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: Xt({
    matchPatterns: Hse,
    defaultMatchWidth: "wide",
    parsePatterns: Wse,
    defaultParseWidth: "any"
  }),
  day: Xt({
    matchPatterns: Vse,
    defaultMatchWidth: "wide",
    parsePatterns: Yse,
    defaultParseWidth: "any"
  }),
  dayPeriod: Xt({
    matchPatterns: Qse,
    defaultMatchWidth: "any",
    parsePatterns: qse,
    defaultParseWidth: "any"
  })
}, Zse = Gse, Kse = {
  code: "nb",
  formatDistance: xse,
  formatLong: Tse,
  formatRelative: Ase,
  localize: Lse,
  match: Zse,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Xse = Kse, Jse = {
  lessThanXSeconds: {
    one: "minder dan een seconde",
    other: "minder dan {{count}} seconden"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} seconden"
  },
  halfAMinute: "een halve minuut",
  lessThanXMinutes: {
    one: "minder dan een minuut",
    other: "minder dan {{count}} minuten"
  },
  xMinutes: {
    one: "een minuut",
    other: "{{count}} minuten"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} uur"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} uur"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dagen"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weken"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weken"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maanden"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maanden"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer dan 1 jaar",
    other: "meer dan {{count}} jaar"
  },
  almostXYears: {
    one: "bijna 1 jaar",
    other: "bijna {{count}} jaar"
  }
}, eue = function(e, t, r) {
  var n, i = Jse[e];
  return typeof i == "string" ? n = i : t === 1 ? n = i.one : n = i.other.replace("{{count}}", String(t)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "over " + n : n + " geleden" : n;
}, tue = eue, rue = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd-MM-y"
}, nue = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, iue = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, oue = {
  date: jr({
    formats: rue,
    defaultWidth: "full"
  }),
  time: jr({
    formats: nue,
    defaultWidth: "full"
  }),
  dateTime: jr({
    formats: iue,
    defaultWidth: "full"
  })
}, aue = oue, lue = {
  lastWeek: "'afgelopen' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, sue = function(e, t, r, n) {
  return lue[e];
}, uue = sue, cue = {
  narrow: ["v.C.", "n.C."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["voor Christus", "na Christus"]
}, due = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
}, fue = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mrt.", "apr.", "mei", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"]
}, hue = {
  narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
  short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
  wide: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"]
}, pue = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  }
}, gue = function(e, t) {
  var r = Number(e);
  return r + "e";
}, mue = {
  ordinalNumber: gue,
  era: Kt({
    values: cue,
    defaultWidth: "wide"
  }),
  quarter: Kt({
    values: due,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: Kt({
    values: fue,
    defaultWidth: "wide"
  }),
  day: Kt({
    values: hue,
    defaultWidth: "wide"
  }),
  dayPeriod: Kt({
    values: pue,
    defaultWidth: "wide"
  })
}, vue = mue, bue = /^(\d+)e?/i, yue = /\d+/i, xue = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
}, wue = {
  any: [/^v/, /^n/]
}, Mue = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
}, Cue = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Sue = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
}, Tue = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
}, kue = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
}, Due = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
}, Aue = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
}, Eue = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
}, Iue = {
  ordinalNumber: hl({
    matchPattern: bue,
    parsePattern: yue,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Xt({
    matchPatterns: xue,
    defaultMatchWidth: "wide",
    parsePatterns: wue,
    defaultParseWidth: "any"
  }),
  quarter: Xt({
    matchPatterns: Mue,
    defaultMatchWidth: "wide",
    parsePatterns: Cue,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: Xt({
    matchPatterns: Sue,
    defaultMatchWidth: "wide",
    parsePatterns: Tue,
    defaultParseWidth: "any"
  }),
  day: Xt({
    matchPatterns: kue,
    defaultMatchWidth: "wide",
    parsePatterns: Due,
    defaultParseWidth: "any"
  }),
  dayPeriod: Xt({
    matchPatterns: Aue,
    defaultMatchWidth: "any",
    parsePatterns: Eue,
    defaultParseWidth: "any"
  })
}, Nue = Iue, zue = {
  code: "nl",
  formatDistance: tue,
  formatLong: aue,
  formatRelative: uue,
  localize: vue,
  match: Nue,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, $ue = zue, Oue = {
  lessThanXSeconds: {
    one: "moins d’une seconde",
    other: "moins de {{count}} secondes"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} secondes"
  },
  halfAMinute: "30 secondes",
  lessThanXMinutes: {
    one: "moins d’une minute",
    other: "moins de {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "environ 1 heure",
    other: "environ {{count}} heures"
  },
  xHours: {
    one: "1 heure",
    other: "{{count}} heures"
  },
  xDays: {
    one: "1 jour",
    other: "{{count}} jours"
  },
  aboutXWeeks: {
    one: "environ 1 semaine",
    other: "environ {{count}} semaines"
  },
  xWeeks: {
    one: "1 semaine",
    other: "{{count}} semaines"
  },
  aboutXMonths: {
    one: "environ 1 mois",
    other: "environ {{count}} mois"
  },
  xMonths: {
    one: "1 mois",
    other: "{{count}} mois"
  },
  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ans"
  },
  overXYears: {
    one: "plus d’un an",
    other: "plus de {{count}} ans"
  },
  almostXYears: {
    one: "presqu’un an",
    other: "presque {{count}} ans"
  }
}, _ue = function(e, t, r) {
  var n, i = Oue[e];
  return typeof i == "string" ? n = i : t === 1 ? n = i.one : n = i.other.replace("{{count}}", String(t)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "dans " + n : "il y a " + n : n;
}, q7 = _ue, Lue = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, Pue = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Rue = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, jue = {
  date: jr({
    formats: Lue,
    defaultWidth: "full"
  }),
  time: jr({
    formats: Pue,
    defaultWidth: "full"
  }),
  dateTime: jr({
    formats: Rue,
    defaultWidth: "full"
  })
}, Fue = jue, Bue = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: "P"
}, Uue = function(e, t, r, n) {
  return Bue[e];
}, G7 = Uue, Hue = {
  narrow: ["av. J.-C", "ap. J.-C"],
  abbreviated: ["av. J.-C", "ap. J.-C"],
  wide: ["avant Jésus-Christ", "après Jésus-Christ"]
}, Wue = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
  wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
}, Vue = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."],
  wide: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"]
}, Yue = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
  abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
  wide: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
}, Que = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "soir",
    night: "mat."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "matin",
    afternoon: "après-midi",
    evening: "soir",
    night: "matin"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "du matin",
    afternoon: "de l’après-midi",
    evening: "du soir",
    night: "du matin"
  }
}, que = function(e, t) {
  var r = Number(e), n = t == null ? void 0 : t.unit;
  if (r === 0)
    return "0";
  var i = ["year", "week", "hour", "minute", "second"], o;
  return r === 1 ? o = n && i.includes(n) ? "ère" : "er" : o = "ème", r + o;
}, Gue = {
  ordinalNumber: que,
  era: Kt({
    values: Hue,
    defaultWidth: "wide"
  }),
  quarter: Kt({
    values: Wue,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: Kt({
    values: Vue,
    defaultWidth: "wide"
  }),
  day: Kt({
    values: Yue,
    defaultWidth: "wide"
  }),
  dayPeriod: Kt({
    values: Que,
    defaultWidth: "wide"
  })
}, Z7 = Gue, Zue = /^(\d+)(ième|ère|ème|er|e)?/i, Kue = /\d+/i, Xue = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
}, Jue = {
  any: [/^av/i, /^ap/i]
}, ece = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
}, tce = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, rce = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
}, nce = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, ice = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
}, oce = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
}, ace = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
}, lce = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
}, sce = {
  ordinalNumber: hl({
    matchPattern: Zue,
    parsePattern: Kue,
    valueCallback: function(e) {
      return parseInt(e);
    }
  }),
  era: Xt({
    matchPatterns: Xue,
    defaultMatchWidth: "wide",
    parsePatterns: Jue,
    defaultParseWidth: "any"
  }),
  quarter: Xt({
    matchPatterns: ece,
    defaultMatchWidth: "wide",
    parsePatterns: tce,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: Xt({
    matchPatterns: rce,
    defaultMatchWidth: "wide",
    parsePatterns: nce,
    defaultParseWidth: "any"
  }),
  day: Xt({
    matchPatterns: ice,
    defaultMatchWidth: "wide",
    parsePatterns: oce,
    defaultParseWidth: "any"
  }),
  dayPeriod: Xt({
    matchPatterns: ace,
    defaultMatchWidth: "any",
    parsePatterns: lce,
    defaultParseWidth: "any"
  })
}, K7 = sce, uce = {
  code: "fr",
  formatDistance: q7,
  formatLong: Fue,
  formatRelative: G7,
  localize: Z7,
  match: K7,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, cce = uce, dce = {
  lessThanXSeconds: {
    one: "menos de un segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos de un minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "alrededor de 1 hora",
    other: "alrededor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 día",
    other: "{{count}} días"
  },
  aboutXWeeks: {
    one: "alrededor de 1 semana",
    other: "alrededor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "alrededor de 1 mes",
    other: "alrededor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "alrededor de 1 año",
    other: "alrededor de {{count}} años"
  },
  xYears: {
    one: "1 año",
    other: "{{count}} años"
  },
  overXYears: {
    one: "más de 1 año",
    other: "más de {{count}} años"
  },
  almostXYears: {
    one: "casi 1 año",
    other: "casi {{count}} años"
  }
}, fce = function(e, t, r) {
  var n, i = dce[e];
  return typeof i == "string" ? n = i : t === 1 ? n = i.one : n = i.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "en " + n : "hace " + n : n;
}, hce = fce, pce = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, gce = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, mce = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, vce = {
  date: jr({
    formats: pce,
    defaultWidth: "full"
  }),
  time: jr({
    formats: gce,
    defaultWidth: "full"
  }),
  dateTime: jr({
    formats: mce,
    defaultWidth: "full"
  })
}, bce = vce, yce = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
}, xce = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: "P"
}, wce = function(e, t, r, n) {
  return t.getUTCHours() !== 1 ? xce[e] : yce[e];
}, Mce = wce, Cce = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "después de cristo"]
}, Sce = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, Tce = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
  wide: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
}, kce = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
  abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  wide: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"]
}, Dce = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  }
}, Ace = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  }
}, Ece = function(e, t) {
  var r = Number(e);
  return r + "º";
}, Ice = {
  ordinalNumber: Ece,
  era: Kt({
    values: Cce,
    defaultWidth: "wide"
  }),
  quarter: Kt({
    values: Sce,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return Number(e) - 1;
    }
  }),
  month: Kt({
    values: Tce,
    defaultWidth: "wide"
  }),
  day: Kt({
    values: kce,
    defaultWidth: "wide"
  }),
  dayPeriod: Kt({
    values: Dce,
    defaultWidth: "wide",
    formattingValues: Ace,
    defaultFormattingWidth: "wide"
  })
}, Nce = Ice, zce = /^(\d+)(º)?/i, $ce = /\d+/i, Oce = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
}, _ce = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
}, Lce = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, Pce = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Rce = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
}, jce = {
  narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
}, Fce = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
}, Bce = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
}, Uce = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
}, Hce = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
}, Wce = {
  ordinalNumber: hl({
    matchPattern: zce,
    parsePattern: $ce,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Xt({
    matchPatterns: Oce,
    defaultMatchWidth: "wide",
    parsePatterns: _ce,
    defaultParseWidth: "any"
  }),
  quarter: Xt({
    matchPatterns: Lce,
    defaultMatchWidth: "wide",
    parsePatterns: Pce,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: Xt({
    matchPatterns: Rce,
    defaultMatchWidth: "wide",
    parsePatterns: jce,
    defaultParseWidth: "any"
  }),
  day: Xt({
    matchPatterns: Fce,
    defaultMatchWidth: "wide",
    parsePatterns: Bce,
    defaultParseWidth: "any"
  }),
  dayPeriod: Xt({
    matchPatterns: Uce,
    defaultMatchWidth: "any",
    parsePatterns: Hce,
    defaultParseWidth: "any"
  })
}, Vce = Wce, Yce = {
  code: "es",
  formatDistance: hce,
  formatLong: bce,
  formatRelative: Mce,
  localize: Nce,
  match: Vce,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, Qce = Yce, qce = {
  lessThanXSeconds: {
    one: "meno di un secondo",
    other: "meno di {{count}} secondi"
  },
  xSeconds: {
    one: "un secondo",
    other: "{{count}} secondi"
  },
  halfAMinute: "alcuni secondi",
  lessThanXMinutes: {
    one: "meno di un minuto",
    other: "meno di {{count}} minuti"
  },
  xMinutes: {
    one: "un minuto",
    other: "{{count}} minuti"
  },
  aboutXHours: {
    one: "circa un'ora",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "un'ora",
    other: "{{count}} ore"
  },
  xDays: {
    one: "un giorno",
    other: "{{count}} giorni"
  },
  aboutXWeeks: {
    one: "circa una settimana",
    other: "circa {{count}} settimane"
  },
  xWeeks: {
    one: "una settimana",
    other: "{{count}} settimane"
  },
  aboutXMonths: {
    one: "circa un mese",
    other: "circa {{count}} mesi"
  },
  xMonths: {
    one: "un mese",
    other: "{{count}} mesi"
  },
  aboutXYears: {
    one: "circa un anno",
    other: "circa {{count}} anni"
  },
  xYears: {
    one: "un anno",
    other: "{{count}} anni"
  },
  overXYears: {
    one: "più di un anno",
    other: "più di {{count}} anni"
  },
  almostXYears: {
    one: "quasi un anno",
    other: "quasi {{count}} anni"
  }
}, Gce = function(e, t, r) {
  var n, i = qce[e];
  return typeof i == "string" ? n = i : t === 1 ? n = i.one : n = i.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "tra " + n : n + " fa" : n;
}, Zce = Gce, Kce = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, Xce = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Jce = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, ede = {
  date: jr({
    formats: Kce,
    defaultWidth: "full"
  }),
  time: jr({
    formats: Xce,
    defaultWidth: "full"
  }),
  dateTime: jr({
    formats: Jce,
    defaultWidth: "full"
  })
}, tde = ede, x4 = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
function rde(e) {
  switch (e) {
    case 0:
      return "'domenica scorsa alle' p";
    default:
      return "'" + x4[e] + " scorso alle' p";
  }
}
function AP(e) {
  return "'" + x4[e] + " alle' p";
}
function nde(e) {
  switch (e) {
    case 0:
      return "'domenica prossima alle' p";
    default:
      return "'" + x4[e] + " prossimo alle' p";
  }
}
var ide = {
  lastWeek: function(e, t, r) {
    var n = e.getUTCDay();
    return Q3(e, t, r) ? AP(n) : rde(n);
  },
  yesterday: "'ieri alle' p",
  today: "'oggi alle' p",
  tomorrow: "'domani alle' p",
  nextWeek: function(e, t, r) {
    var n = e.getUTCDay();
    return Q3(e, t, r) ? AP(n) : nde(n);
  },
  other: "P"
}, ode = function(e, t, r, n) {
  var i = ide[e];
  return typeof i == "function" ? i(t, r, n) : i;
}, ade = ode, lde = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["avanti Cristo", "dopo Cristo"]
}, sde = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, ude = {
  narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
  abbreviated: ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"],
  wide: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
}, cde = {
  narrow: ["D", "L", "M", "M", "G", "V", "S"],
  short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  wide: ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"]
}, dde = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  }
}, fde = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  }
}, hde = function(e, t) {
  var r = Number(e);
  return String(r);
}, pde = {
  ordinalNumber: hde,
  era: Kt({
    values: lde,
    defaultWidth: "wide"
  }),
  quarter: Kt({
    values: sde,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: Kt({
    values: ude,
    defaultWidth: "wide"
  }),
  day: Kt({
    values: cde,
    defaultWidth: "wide"
  }),
  dayPeriod: Kt({
    values: dde,
    defaultWidth: "wide",
    formattingValues: fde,
    defaultFormattingWidth: "wide"
  })
}, gde = pde, mde = /^(\d+)(º)?/i, vde = /\d+/i, bde = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
}, yde = {
  any: [/^a/i, /^(d|e)/i]
}, xde = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, wde = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Mde = {
  narrow: /^[gfmalsond]/i,
  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
}, Cde = {
  narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Sde = {
  narrow: /^[dlmgvs]/i,
  short: /^(do|lu|ma|me|gi|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
}, Tde = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
}, kde = {
  narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
}, Dde = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mezza/i,
    noon: /^mezzo/i,
    morning: /mattina/i,
    afternoon: /pomeriggio/i,
    evening: /sera/i,
    night: /notte/i
  }
}, Ade = {
  ordinalNumber: hl({
    matchPattern: mde,
    parsePattern: vde,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Xt({
    matchPatterns: bde,
    defaultMatchWidth: "wide",
    parsePatterns: yde,
    defaultParseWidth: "any"
  }),
  quarter: Xt({
    matchPatterns: xde,
    defaultMatchWidth: "wide",
    parsePatterns: wde,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: Xt({
    matchPatterns: Mde,
    defaultMatchWidth: "wide",
    parsePatterns: Cde,
    defaultParseWidth: "any"
  }),
  day: Xt({
    matchPatterns: Sde,
    defaultMatchWidth: "wide",
    parsePatterns: Tde,
    defaultParseWidth: "any"
  }),
  dayPeriod: Xt({
    matchPatterns: kde,
    defaultMatchWidth: "any",
    parsePatterns: Dde,
    defaultParseWidth: "any"
  })
}, Ede = Ade, Ide = {
  code: "it",
  formatDistance: Zce,
  formatLong: tde,
  formatRelative: ade,
  localize: gde,
  match: Ede,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Nde = Ide, zde = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "cerca de 1 hora",
    other: "cerca de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "cerca de 1 semana",
    other: "cerca de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "cerca de 1 mês",
    other: "cerca de {{count}} meses"
  },
  xMonths: {
    one: "1 mês",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "cerca de 1 ano",
    other: "cerca de {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
}, $de = function(e, t, r) {
  var n, i = zde[e];
  return typeof i == "string" ? n = i : t === 1 ? n = i.one : n = i.other.replace("{{count}}", String(t)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "em " + n : "há " + n : n;
}, Ode = $de, _de = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, Lde = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Pde = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Rde = {
  date: jr({
    formats: _de,
    defaultWidth: "full"
  }),
  time: jr({
    formats: Lde,
    defaultWidth: "full"
  }),
  dateTime: jr({
    formats: Pde,
    defaultWidth: "full"
  })
}, jde = Rde, Fde = {
  lastWeek: function(e) {
    var t = e.getUTCDay(), r = t === 0 || t === 6 ? "último" : "última";
    return "'" + r + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P"
}, Bde = function(e, t, r, n) {
  var i = Fde[e];
  return typeof i == "function" ? i(t) : i;
}, Ude = Bde, Hde = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "depois de cristo"]
}, Wde = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, Vde = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
  wide: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
}, Yde = {
  narrow: ["D", "S", "T", "Q", "Q", "S", "S"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
  abbreviated: ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"],
  wide: ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"]
}, Qde = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  }
}, qde = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  }
}, Gde = function(e, t) {
  var r = Number(e);
  return (t == null ? void 0 : t.unit) === "week" ? r + "ª" : r + "º";
}, Zde = {
  ordinalNumber: Gde,
  era: Kt({
    values: Hde,
    defaultWidth: "wide"
  }),
  quarter: Kt({
    values: Wde,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: Kt({
    values: Vde,
    defaultWidth: "wide"
  }),
  day: Kt({
    values: Yde,
    defaultWidth: "wide"
  }),
  dayPeriod: Kt({
    values: Qde,
    defaultWidth: "wide",
    formattingValues: qde,
    defaultFormattingWidth: "wide"
  })
}, Kde = Zde, Xde = /^(\d+)[ºªo]?/i, Jde = /\d+/i, efe = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
  wide: /^(antes de cristo|depois de cristo)/i
}, tfe = {
  any: [/^ac/i, /^dc/i],
  wide: [/^antes de cristo/i, /^depois de cristo/i]
}, rfe = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, nfe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ife = {
  narrow: /^[jfmajsond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
}, ofe = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^fev/i, /^mar/i, /^abr/i, /^mai/i, /^jun/i, /^jul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dez/i]
}, afe = {
  narrow: /^(dom|[23456]ª?|s[aá]b)/i,
  short: /^(dom|[23456]ª?|s[aá]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
  wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
}, lfe = {
  short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
}, sfe = {
  narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
}, ufe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn|^meia[-\s]noite/i,
    noon: /^md|^meio[-\s]dia/i,
    morning: /manhã/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noite/i
  }
}, cfe = {
  ordinalNumber: hl({
    matchPattern: Xde,
    parsePattern: Jde,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Xt({
    matchPatterns: efe,
    defaultMatchWidth: "wide",
    parsePatterns: tfe,
    defaultParseWidth: "any"
  }),
  quarter: Xt({
    matchPatterns: rfe,
    defaultMatchWidth: "wide",
    parsePatterns: nfe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: Xt({
    matchPatterns: ife,
    defaultMatchWidth: "wide",
    parsePatterns: ofe,
    defaultParseWidth: "any"
  }),
  day: Xt({
    matchPatterns: afe,
    defaultMatchWidth: "wide",
    parsePatterns: lfe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Xt({
    matchPatterns: sfe,
    defaultMatchWidth: "any",
    parsePatterns: ufe,
    defaultParseWidth: "any"
  })
}, dfe = cfe, ffe = {
  code: "pt-BR",
  formatDistance: Ode,
  formatLong: jde,
  formatRelative: Ude,
  localize: Kde,
  match: dfe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, hfe = ffe;
function Zl(e) {
  const { mergedLocaleRef: t, mergedDateLocaleRef: r } = lt(ju, null) || {}, n = j(() => {
    var o, a;
    return (a = (o = t == null ? void 0 : t.value) === null || o === void 0 ? void 0 : o[e]) !== null && a !== void 0 ? a : Coe[e];
  });
  return {
    dateLocaleRef: j(() => {
      var o;
      return (o = r == null ? void 0 : r.value) !== null && o !== void 0 ? o : uae;
    }),
    localeRef: n
  };
}
function Vu(e, t, r) {
  if (!t)
    return;
  const n = Oc(), i = lt(ju, null), o = () => {
    const a = r == null ? void 0 : r.value;
    t.mount({
      id: a === void 0 ? e : a + e,
      head: !0,
      anchorMetaName: gp,
      props: {
        bPrefix: a ? `.${a}-` : void 0
      },
      ssr: n
    }), i != null && i.preflightStyleDisabled || z7.mount({
      id: "n-global",
      head: !0,
      anchorMetaName: gp,
      ssr: n
    });
  };
  n ? o() : ch(o);
}
function Cr(e, t, r, n) {
  var i;
  r || Ql("useThemeClass", "cssVarsRef is not passed");
  const o = (i = lt(ju, null)) === null || i === void 0 ? void 0 : i.mergedThemeHashRef, a = G(""), s = Oc();
  let u;
  const d = `__${e}`, f = () => {
    let h = d;
    const g = t ? t.value : void 0, m = o == null ? void 0 : o.value;
    m && (h += "-" + m), g && (h += "-" + g);
    const { themeOverrides: v, builtinThemeOverrides: w } = n;
    v && (h += "-" + b0(JSON.stringify(v))), w && (h += "-" + b0(JSON.stringify(w))), a.value = h, u = () => {
      const x = r.value;
      let y = "";
      for (const C in x)
        y += `${C}: ${x[C]};`;
      Y(`.${h}`, y).mount({
        id: h,
        ssr: s
      }), u = void 0;
    };
  };
  return On(() => {
    f();
  }), {
    themeClass: a,
    onRender: () => {
      u == null || u();
    }
  };
}
function Li(e, t, r) {
  if (!t)
    return;
  const n = Oc(), i = j(() => {
    const { value: a } = t;
    if (!a)
      return;
    const s = a[e];
    if (s)
      return s;
  }), o = () => {
    On(() => {
      const { value: a } = r, s = `${a}${e}Rtl`;
      if (rX(s, n))
        return;
      const { value: u } = i;
      u && u.style.mount({
        id: s,
        head: !0,
        anchorMetaName: gp,
        props: {
          bPrefix: a ? `.${a}-` : void 0
        },
        ssr: n
      });
    });
  };
  return n ? o() : ch(o), i;
}
var FM = oe({
  name: "Add",
  render() {
    return b("svg", { width: "512", height: "512", viewBox: "0 0 512 512", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, b("path", { d: "M256 112V400M400 256H112", stroke: "currentColor", "stroke-width": "32", "stroke-linecap": "round", "stroke-linejoin": "round" }));
  }
}), pfe = oe({
  name: "ArrowDown",
  render() {
    return b("svg", { viewBox: "0 0 28 28", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, b("g", { stroke: "none", "stroke-width": "1", "fill-rule": "evenodd" }, b("g", { "fill-rule": "nonzero" }, b("path", { d: "M23.7916,15.2664 C24.0788,14.9679 24.0696,14.4931 23.7711,14.206 C23.4726,13.9188 22.9978,13.928 22.7106,14.2265 L14.7511,22.5007 L14.7511,3.74792 C14.7511,3.33371 14.4153,2.99792 14.0011,2.99792 C13.5869,2.99792 13.2511,3.33371 13.2511,3.74793 L13.2511,22.4998 L5.29259,14.2265 C5.00543,13.928 4.53064,13.9188 4.23213,14.206 C3.93361,14.4931 3.9244,14.9679 4.21157,15.2664 L13.2809,24.6944 C13.6743,25.1034 14.3289,25.1034 14.7223,24.6944 L23.7916,15.2664 Z" }))));
  }
});
function lo(e, t) {
  return oe({
    name: d7(e),
    setup() {
      var r;
      const n = (r = lt(ju, null)) === null || r === void 0 ? void 0 : r.mergedIconsRef;
      return () => {
        var i;
        const o = (i = n == null ? void 0 : n.value) === null || i === void 0 ? void 0 : i[e];
        return o ? o() : t;
      };
    }
  });
}
var gfe = lo("attach", b("svg", { viewBox: "0 0 16 16", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, b("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" }, b("g", { fill: "currentColor", "fill-rule": "nonzero" }, b("path", { d: "M3.25735931,8.70710678 L7.85355339,4.1109127 C8.82986412,3.13460197 10.4127766,3.13460197 11.3890873,4.1109127 C12.365398,5.08722343 12.365398,6.67013588 11.3890873,7.64644661 L6.08578644,12.9497475 C5.69526215,13.3402718 5.06209717,13.3402718 4.67157288,12.9497475 C4.28104858,12.5592232 4.28104858,11.9260582 4.67157288,11.5355339 L9.97487373,6.23223305 C10.1701359,6.0369709 10.1701359,5.72038841 9.97487373,5.52512627 C9.77961159,5.32986412 9.4630291,5.32986412 9.26776695,5.52512627 L3.96446609,10.8284271 C3.18341751,11.6094757 3.18341751,12.8758057 3.96446609,13.6568542 C4.74551468,14.4379028 6.01184464,14.4379028 6.79289322,13.6568542 L12.0961941,8.35355339 C13.4630291,6.98671837 13.4630291,4.77064094 12.0961941,3.40380592 C10.7293591,2.0369709 8.51328163,2.0369709 7.14644661,3.40380592 L2.55025253,8 C2.35499039,8.19526215 2.35499039,8.51184464 2.55025253,8.70710678 C2.74551468,8.90236893 3.06209717,8.90236893 3.25735931,8.70710678 Z" }))))), wc = oe({
  name: "Backward",
  render() {
    return b("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, b("path", { d: "M12.2674 15.793C11.9675 16.0787 11.4927 16.0672 11.2071 15.7673L6.20572 10.5168C5.9298 10.2271 5.9298 9.7719 6.20572 9.48223L11.2071 4.23177C11.4927 3.93184 11.9675 3.92031 12.2674 4.206C12.5673 4.49169 12.5789 4.96642 12.2932 5.26634L7.78458 9.99952L12.2932 14.7327C12.5789 15.0326 12.5673 15.5074 12.2674 15.793Z", fill: "currentColor" }));
  }
}), EP = lo("date", b("svg", { width: "28px", height: "28px", viewBox: "0 0 28 28", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, b("g", { stroke: "none", "stroke-width": "1", "fill-rule": "evenodd" }, b("g", { "fill-rule": "nonzero" }, b("path", { d: "M21.75,3 C23.5449254,3 25,4.45507456 25,6.25 L25,21.75 C25,23.5449254 23.5449254,25 21.75,25 L6.25,25 C4.45507456,25 3,23.5449254 3,21.75 L3,6.25 C3,4.45507456 4.45507456,3 6.25,3 L21.75,3 Z M23.5,9.503 L4.5,9.503 L4.5,21.75 C4.5,22.7164983 5.28350169,23.5 6.25,23.5 L21.75,23.5 C22.7164983,23.5 23.5,22.7164983 23.5,21.75 L23.5,9.503 Z M21.75,4.5 L6.25,4.5 C5.28350169,4.5 4.5,5.28350169 4.5,6.25 L4.5,8.003 L23.5,8.003 L23.5,6.25 C23.5,5.28350169 22.7164983,4.5 21.75,4.5 Z" }))))), X7 = oe({
  name: "Checkmark",
  render() {
    return b("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" }, b("g", { fill: "none" }, b("path", { d: "M14.046 3.486a.75.75 0 0 1-.032 1.06l-7.93 7.474a.85.85 0 0 1-1.188-.022l-2.68-2.72a.75.75 0 1 1 1.068-1.053l2.234 2.267l7.468-7.038a.75.75 0 0 1 1.06.032z", fill: "currentColor" })));
  }
}), mfe = oe({
  name: "ChevronLeft",
  render() {
    return b("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, b("path", { d: "M10.3536 3.14645C10.5488 3.34171 10.5488 3.65829 10.3536 3.85355L6.20711 8L10.3536 12.1464C10.5488 12.3417 10.5488 12.6583 10.3536 12.8536C10.1583 13.0488 9.84171 13.0488 9.64645 12.8536L5.14645 8.35355C4.95118 8.15829 4.95118 7.84171 5.14645 7.64645L9.64645 3.14645C9.84171 2.95118 10.1583 2.95118 10.3536 3.14645Z", fill: "currentColor" }));
  }
}), w4 = oe({
  name: "ChevronRight",
  render() {
    return b("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, b("path", { d: "M5.64645 3.14645C5.45118 3.34171 5.45118 3.65829 5.64645 3.85355L9.79289 8L5.64645 12.1464C5.45118 12.3417 5.45118 12.6583 5.64645 12.8536C5.84171 13.0488 6.15829 13.0488 6.35355 12.8536L10.8536 8.35355C11.0488 8.15829 11.0488 7.84171 10.8536 7.64645L6.35355 3.14645C6.15829 2.95118 5.84171 2.95118 5.64645 3.14645Z", fill: "currentColor" }));
  }
}), J7 = lo("close", b("svg", { viewBox: "0 0 12 12", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": !0 }, b("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" }, b("g", { fill: "currentColor", "fill-rule": "nonzero" }, b("path", { d: "M2.08859116,2.2156945 L2.14644661,2.14644661 C2.32001296,1.97288026 2.58943736,1.95359511 2.7843055,2.08859116 L2.85355339,2.14644661 L6,5.293 L9.14644661,2.14644661 C9.34170876,1.95118446 9.65829124,1.95118446 9.85355339,2.14644661 C10.0488155,2.34170876 10.0488155,2.65829124 9.85355339,2.85355339 L6.707,6 L9.85355339,9.14644661 C10.0271197,9.32001296 10.0464049,9.58943736 9.91140884,9.7843055 L9.85355339,9.85355339 C9.67998704,10.0271197 9.41056264,10.0464049 9.2156945,9.91140884 L9.14644661,9.85355339 L6,6.707 L2.85355339,9.85355339 C2.65829124,10.0488155 2.34170876,10.0488155 2.14644661,9.85355339 C1.95118446,9.65829124 1.95118446,9.34170876 2.14644661,9.14644661 L5.293,6 L2.14644661,2.85355339 C1.97288026,2.67998704 1.95359511,2.41056264 2.08859116,2.2156945 L2.14644661,2.14644661 L2.08859116,2.2156945 Z" }))))), eH = oe({
  name: "Eye",
  render() {
    return b("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" }, b("path", { d: "M255.66 112c-77.94 0-157.89 45.11-220.83 135.33a16 16 0 0 0-.27 17.77C82.92 340.8 161.8 400 255.66 400c92.84 0 173.34-59.38 221.79-135.25a16.14 16.14 0 0 0 0-17.47C428.89 172.28 347.8 112 255.66 112z", fill: "none", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "32" }), b("circle", { cx: "256", cy: "256", r: "80", fill: "none", stroke: "currentColor", "stroke-miterlimit": "10", "stroke-width": "32" }));
  }
}), vfe = oe({
  name: "EyeOff",
  render() {
    return b("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" }, b("path", { d: "M432 448a15.92 15.92 0 0 1-11.31-4.69l-352-352a16 16 0 0 1 22.62-22.62l352 352A16 16 0 0 1 432 448z", fill: "currentColor" }), b("path", { d: "M255.66 384c-41.49 0-81.5-12.28-118.92-36.5c-34.07-22-64.74-53.51-88.7-91v-.08c19.94-28.57 41.78-52.73 65.24-72.21a2 2 0 0 0 .14-2.94L93.5 161.38a2 2 0 0 0-2.71-.12c-24.92 21-48.05 46.76-69.08 76.92a31.92 31.92 0 0 0-.64 35.54c26.41 41.33 60.4 76.14 98.28 100.65C162 402 207.9 416 255.66 416a239.13 239.13 0 0 0 75.8-12.58a2 2 0 0 0 .77-3.31l-21.58-21.58a4 4 0 0 0-3.83-1a204.8 204.8 0 0 1-51.16 6.47z", fill: "currentColor" }), b("path", { d: "M490.84 238.6c-26.46-40.92-60.79-75.68-99.27-100.53C349 110.55 302 96 255.66 96a227.34 227.34 0 0 0-74.89 12.83a2 2 0 0 0-.75 3.31l21.55 21.55a4 4 0 0 0 3.88 1a192.82 192.82 0 0 1 50.21-6.69c40.69 0 80.58 12.43 118.55 37c34.71 22.4 65.74 53.88 89.76 91a.13.13 0 0 1 0 .16a310.72 310.72 0 0 1-64.12 72.73a2 2 0 0 0-.15 2.95l19.9 19.89a2 2 0 0 0 2.7.13a343.49 343.49 0 0 0 68.64-78.48a32.2 32.2 0 0 0-.1-34.78z", fill: "currentColor" }), b("path", { d: "M256 160a95.88 95.88 0 0 0-21.37 2.4a2 2 0 0 0-1 3.38l112.59 112.56a2 2 0 0 0 3.38-1A96 96 0 0 0 256 160z", fill: "currentColor" }), b("path", { d: "M165.78 233.66a2 2 0 0 0-3.38 1a96 96 0 0 0 115 115a2 2 0 0 0 1-3.38z", fill: "currentColor" }));
  }
}), bfe = lo("trash", b("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" }, b("path", { d: "M432,144,403.33,419.74A32,32,0,0,1,371.55,448H140.46a32,32,0,0,1-31.78-28.26L80,144", style: "fill: none; stroke: currentcolor; stroke-linecap: round; stroke-linejoin: round; stroke-width: 32px;" }), b("rect", { x: "32", y: "64", width: "448", height: "80", rx: "16", ry: "16", style: "fill: none; stroke: currentcolor; stroke-linecap: round; stroke-linejoin: round; stroke-width: 32px;" }), b("line", { x1: "312", y1: "240", x2: "200", y2: "352", style: "fill: none; stroke: currentcolor; stroke-linecap: round; stroke-linejoin: round; stroke-width: 32px;" }), b("line", { x1: "312", y1: "352", x2: "200", y2: "240", style: "fill: none; stroke: currentcolor; stroke-linecap: round; stroke-linejoin: round; stroke-width: 32px;" }))), yfe = lo("download", b("svg", { viewBox: "0 0 16 16", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, b("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" }, b("g", { fill: "currentColor", "fill-rule": "nonzero" }, b("path", { d: "M3.5,13 L12.5,13 C12.7761424,13 13,13.2238576 13,13.5 C13,13.7454599 12.8231248,13.9496084 12.5898756,13.9919443 L12.5,14 L3.5,14 C3.22385763,14 3,13.7761424 3,13.5 C3,13.2545401 3.17687516,13.0503916 3.41012437,13.0080557 L3.5,13 L12.5,13 L3.5,13 Z M7.91012437,1.00805567 L8,1 C8.24545989,1 8.44960837,1.17687516 8.49194433,1.41012437 L8.5,1.5 L8.5,10.292 L11.1819805,7.6109127 C11.3555469,7.43734635 11.6249713,7.4180612 11.8198394,7.55305725 L11.8890873,7.6109127 C12.0626536,7.78447906 12.0819388,8.05390346 11.9469427,8.2487716 L11.8890873,8.31801948 L8.35355339,11.8535534 C8.17998704,12.0271197 7.91056264,12.0464049 7.7156945,11.9114088 L7.64644661,11.8535534 L4.1109127,8.31801948 C3.91565056,8.12275734 3.91565056,7.80617485 4.1109127,7.6109127 C4.28447906,7.43734635 4.55390346,7.4180612 4.7487716,7.55305725 L4.81801948,7.6109127 L7.5,10.292 L7.5,1.5 C7.5,1.25454011 7.67687516,1.05039163 7.91012437,1.00805567 L8,1 L7.91012437,1.00805567 Z" }))))), xfe = oe({
  name: "Empty",
  render() {
    return b("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, b("path", { d: "M26 7.5C26 11.0899 23.0899 14 19.5 14C15.9101 14 13 11.0899 13 7.5C13 3.91015 15.9101 1 19.5 1C23.0899 1 26 3.91015 26 7.5ZM16.8536 4.14645C16.6583 3.95118 16.3417 3.95118 16.1464 4.14645C15.9512 4.34171 15.9512 4.65829 16.1464 4.85355L18.7929 7.5L16.1464 10.1464C15.9512 10.3417 15.9512 10.6583 16.1464 10.8536C16.3417 11.0488 16.6583 11.0488 16.8536 10.8536L19.5 8.20711L22.1464 10.8536C22.3417 11.0488 22.6583 11.0488 22.8536 10.8536C23.0488 10.6583 23.0488 10.3417 22.8536 10.1464L20.2071 7.5L22.8536 4.85355C23.0488 4.65829 23.0488 4.34171 22.8536 4.14645C22.6583 3.95118 22.3417 3.95118 22.1464 4.14645L19.5 6.79289L16.8536 4.14645Z", fill: "currentColor" }), b("path", { d: "M25 22.75V12.5991C24.5572 13.0765 24.053 13.4961 23.5 13.8454V16H17.5L17.3982 16.0068C17.0322 16.0565 16.75 16.3703 16.75 16.75C16.75 18.2688 15.5188 19.5 14 19.5C12.4812 19.5 11.25 18.2688 11.25 16.75L11.2432 16.6482C11.1935 16.2822 10.8797 16 10.5 16H4.5V7.25C4.5 6.2835 5.2835 5.5 6.25 5.5H12.2696C12.4146 4.97463 12.6153 4.47237 12.865 4H6.25C4.45507 4 3 5.45507 3 7.25V22.75C3 24.5449 4.45507 26 6.25 26H21.75C23.5449 26 25 24.5449 25 22.75ZM4.5 22.75V17.5H9.81597L9.85751 17.7041C10.2905 19.5919 11.9808 21 14 21L14.215 20.9947C16.2095 20.8953 17.842 19.4209 18.184 17.5H23.5V22.75C23.5 23.7165 22.7165 24.5 21.75 24.5H6.25C5.2835 24.5 4.5 23.7165 4.5 22.75Z", fill: "currentColor" }));
  }
}), yb = lo("error", b("svg", { viewBox: "0 0 48 48", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, b("g", { stroke: "none", "stroke-width": "1", "fill-rule": "evenodd" }, b("g", { "fill-rule": "nonzero" }, b("path", { d: "M24,4 C35.045695,4 44,12.954305 44,24 C44,35.045695 35.045695,44 24,44 C12.954305,44 4,35.045695 4,24 C4,12.954305 12.954305,4 24,4 Z M17.8838835,16.1161165 L17.7823881,16.0249942 C17.3266086,15.6583353 16.6733914,15.6583353 16.2176119,16.0249942 L16.1161165,16.1161165 L16.0249942,16.2176119 C15.6583353,16.6733914 15.6583353,17.3266086 16.0249942,17.7823881 L16.1161165,17.8838835 L22.233,24 L16.1161165,30.1161165 L16.0249942,30.2176119 C15.6583353,30.6733914 15.6583353,31.3266086 16.0249942,31.7823881 L16.1161165,31.8838835 L16.2176119,31.9750058 C16.6733914,32.3416647 17.3266086,32.3416647 17.7823881,31.9750058 L17.8838835,31.8838835 L24,25.767 L30.1161165,31.8838835 L30.2176119,31.9750058 C30.6733914,32.3416647 31.3266086,32.3416647 31.7823881,31.9750058 L31.8838835,31.8838835 L31.9750058,31.7823881 C32.3416647,31.3266086 32.3416647,30.6733914 31.9750058,30.2176119 L31.8838835,30.1161165 L25.767,24 L31.8838835,17.8838835 L31.9750058,17.7823881 C32.3416647,17.3266086 32.3416647,16.6733914 31.9750058,16.2176119 L31.8838835,16.1161165 L31.7823881,16.0249942 C31.3266086,15.6583353 30.6733914,15.6583353 30.2176119,16.0249942 L30.1161165,16.1161165 L24,22.233 L17.8838835,16.1161165 L17.7823881,16.0249942 L17.8838835,16.1161165 Z" }))))), Mc = oe({
  name: "FastBackward",
  render() {
    return b("svg", { viewBox: "0 0 20 20", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, b("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" }, b("g", { fill: "currentColor", "fill-rule": "nonzero" }, b("path", { d: "M8.73171,16.7949 C9.03264,17.0795 9.50733,17.0663 9.79196,16.7654 C10.0766,16.4644 10.0634,15.9897 9.76243,15.7051 L4.52339,10.75 L17.2471,10.75 C17.6613,10.75 17.9971,10.4142 17.9971,10 C17.9971,9.58579 17.6613,9.25 17.2471,9.25 L4.52112,9.25 L9.76243,4.29275 C10.0634,4.00812 10.0766,3.53343 9.79196,3.2325 C9.50733,2.93156 9.03264,2.91834 8.73171,3.20297 L2.31449,9.27241 C2.14819,9.4297 2.04819,9.62981 2.01448,9.8386 C2.00308,9.89058 1.99707,9.94459 1.99707,10 C1.99707,10.0576 2.00356,10.1137 2.01585,10.1675 C2.05084,10.3733 2.15039,10.5702 2.31449,10.7254 L8.73171,16.7949 Z" }))));
  }
}), Cc = oe({
  name: "FastForward",
  render() {
    return b("svg", { viewBox: "0 0 20 20", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, b("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" }, b("g", { fill: "currentColor", "fill-rule": "nonzero" }, b("path", { d: "M11.2654,3.20511 C10.9644,2.92049 10.4897,2.93371 10.2051,3.23464 C9.92049,3.53558 9.93371,4.01027 10.2346,4.29489 L15.4737,9.25 L2.75,9.25 C2.33579,9.25 2,9.58579 2,10.0000012 C2,10.4142 2.33579,10.75 2.75,10.75 L15.476,10.75 L10.2346,15.7073 C9.93371,15.9919 9.92049,16.4666 10.2051,16.7675 C10.4897,17.0684 10.9644,17.0817 11.2654,16.797 L17.6826,10.7276 C17.8489,10.5703 17.9489,10.3702 17.9826,10.1614 C17.994,10.1094 18,10.0554 18,10.0000012 C18,9.94241 17.9935,9.88633 17.9812,9.83246 C17.9462,9.62667 17.8467,9.42976 17.6826,9.27455 L11.2654,3.20511 Z" }))));
  }
}), wfe = oe({
  name: "Filter",
  render() {
    return b("svg", { viewBox: "0 0 28 28", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, b("g", { stroke: "none", "stroke-width": "1", "fill-rule": "evenodd" }, b("g", { "fill-rule": "nonzero" }, b("path", { d: "M17,19 C17.5522847,19 18,19.4477153 18,20 C18,20.5522847 17.5522847,21 17,21 L11,21 C10.4477153,21 10,20.5522847 10,20 C10,19.4477153 10.4477153,19 11,19 L17,19 Z M21,13 C21.5522847,13 22,13.4477153 22,14 C22,14.5522847 21.5522847,15 21,15 L7,15 C6.44771525,15 6,14.5522847 6,14 C6,13.4477153 6.44771525,13 7,13 L21,13 Z M24,7 C24.5522847,7 25,7.44771525 25,8 C25,8.55228475 24.5522847,9 24,9 L4,9 C3.44771525,9 3,8.55228475 3,8 C3,7.44771525 3.44771525,7 4,7 L24,7 Z" }))));
  }
}), Sc = oe({
  name: "Forward",
  render() {
    return b("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, b("path", { d: "M7.73271 4.20694C8.03263 3.92125 8.50737 3.93279 8.79306 4.23271L13.7944 9.48318C14.0703 9.77285 14.0703 10.2281 13.7944 10.5178L8.79306 15.7682C8.50737 16.0681 8.03263 16.0797 7.73271 15.794C7.43279 15.5083 7.42125 15.0336 7.70694 14.7336L12.2155 10.0005L7.70694 5.26729C7.42125 4.96737 7.43279 4.49264 7.73271 4.20694Z", fill: "currentColor" }));
  }
}), vp = lo("info", b("svg", { viewBox: "0 0 28 28", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, b("g", { stroke: "none", "stroke-width": "1", "fill-rule": "evenodd" }, b("g", { "fill-rule": "nonzero" }, b("path", { d: "M14,2 C20.6274,2 26,7.37258 26,14 C26,20.6274 20.6274,26 14,26 C7.37258,26 2,20.6274 2,14 C2,7.37258 7.37258,2 14,2 Z M14,11 C13.4477,11 13,11.4477 13,12 L13,12 L13,20 C13,20.5523 13.4477,21 14,21 C14.5523,21 15,20.5523 15,20 L15,20 L15,12 C15,11.4477 14.5523,11 14,11 Z M14,6.75 C13.3096,6.75 12.75,7.30964 12.75,8 C12.75,8.69036 13.3096,9.25 14,9.25 C14.6904,9.25 15.25,8.69036 15.25,8 C15.25,7.30964 14.6904,6.75 14,6.75 Z" }))))), IP = oe({
  name: "More",
  render() {
    return b("svg", { viewBox: "0 0 16 16", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, b("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" }, b("g", { fill: "currentColor", "fill-rule": "nonzero" }, b("path", { d: "M4,7 C4.55228,7 5,7.44772 5,8 C5,8.55229 4.55228,9 4,9 C3.44772,9 3,8.55229 3,8 C3,7.44772 3.44772,7 4,7 Z M8,7 C8.55229,7 9,7.44772 9,8 C9,8.55229 8.55229,9 8,9 C7.44772,9 7,8.55229 7,8 C7,7.44772 7.44772,7 8,7 Z M12,7 C12.5523,7 13,7.44772 13,8 C13,8.55229 12.5523,9 12,9 C11.4477,9 11,8.55229 11,8 C11,7.44772 11.4477,7 12,7 Z" }))));
  }
}), Mfe = oe({
  name: "Remove",
  render() {
    return b("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" }, b("line", { x1: "400", y1: "256", x2: "112", y2: "256", style: `
        fill: none;
        stroke: currentColor;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 32px;
      ` }));
  }
}), xb = lo("success", b("svg", { viewBox: "0 0 48 48", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, b("g", { stroke: "none", "stroke-width": "1", "fill-rule": "evenodd" }, b("g", { "fill-rule": "nonzero" }, b("path", { d: "M24,4 C35.045695,4 44,12.954305 44,24 C44,35.045695 35.045695,44 24,44 C12.954305,44 4,35.045695 4,24 C4,12.954305 12.954305,4 24,4 Z M32.6338835,17.6161165 C32.1782718,17.1605048 31.4584514,17.1301307 30.9676119,17.5249942 L30.8661165,17.6161165 L20.75,27.732233 L17.1338835,24.1161165 C16.6457281,23.6279612 15.8542719,23.6279612 15.3661165,24.1161165 C14.9105048,24.5717282 14.8801307,25.2915486 15.2749942,25.7823881 L15.3661165,25.8838835 L19.8661165,30.3838835 C20.3217282,30.8394952 21.0415486,30.8698693 21.5323881,30.4750058 L21.6338835,30.3838835 L32.6338835,19.3838835 C33.1220388,18.8957281 33.1220388,18.1042719 32.6338835,17.6161165 Z" }))))), Cfe = lo("time", b("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" }, b("path", { d: "M256,64C150,64,64,150,64,256s86,192,192,192,192-86,192-192S362,64,256,64Z", style: `
        fill: none;
        stroke: currentColor;
        stroke-miterlimit: 10;
        stroke-width: 32px;
      ` }), b("polyline", { points: "256 128 256 272 352 272", style: `
        fill: none;
        stroke: currentColor;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 32px;
      ` }))), wb = lo("warning", b("svg", { viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, b("g", { stroke: "none", "stroke-width": "1", "fill-rule": "evenodd" }, b("g", { "fill-rule": "nonzero" }, b("path", { d: "M12,2 C17.523,2 22,6.478 22,12 C22,17.522 17.523,22 12,22 C6.477,22 2,17.522 2,12 C2,6.478 6.477,2 12,2 Z M12.0018002,15.0037242 C11.450254,15.0037242 11.0031376,15.4508407 11.0031376,16.0023869 C11.0031376,16.553933 11.450254,17.0010495 12.0018002,17.0010495 C12.5533463,17.0010495 13.0004628,16.553933 13.0004628,16.0023869 C13.0004628,15.4508407 12.5533463,15.0037242 12.0018002,15.0037242 Z M11.99964,7 C11.4868042,7.00018474 11.0642719,7.38637706 11.0066858,7.8837365 L11,8.00036004 L11.0018003,13.0012393 L11.00857,13.117858 C11.0665141,13.6151758 11.4893244,14.0010638 12.0021602,14.0008793 C12.514996,14.0006946 12.9375283,13.6145023 12.9951144,13.1171428 L13.0018002,13.0005193 L13,7.99964009 L12.9932303,7.8830214 C12.9352861,7.38570354 12.5124758,6.99981552 11.99964,7 Z" }))))), Sfe = lo("cancel", b("svg", { viewBox: "0 0 16 16", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, b("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" }, b("g", { fill: "currentColor", "fill-rule": "nonzero" }, b("path", { d: "M2.58859116,2.7156945 L2.64644661,2.64644661 C2.82001296,2.47288026 3.08943736,2.45359511 3.2843055,2.58859116 L3.35355339,2.64644661 L8,7.293 L12.6464466,2.64644661 C12.8417088,2.45118446 13.1582912,2.45118446 13.3535534,2.64644661 C13.5488155,2.84170876 13.5488155,3.15829124 13.3535534,3.35355339 L8.707,8 L13.3535534,12.6464466 C13.5271197,12.820013 13.5464049,13.0894374 13.4114088,13.2843055 L13.3535534,13.3535534 C13.179987,13.5271197 12.9105626,13.5464049 12.7156945,13.4114088 L12.6464466,13.3535534 L8,8.707 L3.35355339,13.3535534 C3.15829124,13.5488155 2.84170876,13.5488155 2.64644661,13.3535534 C2.45118446,13.1582912 2.45118446,12.8417088 2.64644661,12.6464466 L7.293,8 L2.64644661,3.35355339 C2.47288026,3.17998704 2.45359511,2.91056264 2.58859116,2.7156945 L2.64644661,2.64644661 L2.58859116,2.7156945 Z" }))))), tH = oe({
  name: "ChevronDown",
  render() {
    return b("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, b("path", { d: "M3.14645 5.64645C3.34171 5.45118 3.65829 5.45118 3.85355 5.64645L8 9.79289L12.1464 5.64645C12.3417 5.45118 12.6583 5.45118 12.8536 5.64645C13.0488 5.84171 13.0488 6.15829 12.8536 6.35355L8.35355 10.8536C8.15829 11.0488 7.84171 11.0488 7.64645 10.8536L3.14645 6.35355C2.95118 6.15829 2.95118 5.84171 3.14645 5.64645Z", fill: "currentColor" }));
  }
}), Tfe = lo("clear", b("svg", { viewBox: "0 0 16 16", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, b("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" }, b("g", { fill: "currentColor", "fill-rule": "nonzero" }, b("path", { d: "M8,2 C11.3137085,2 14,4.6862915 14,8 C14,11.3137085 11.3137085,14 8,14 C4.6862915,14 2,11.3137085 2,8 C2,4.6862915 4.6862915,2 8,2 Z M6.5343055,5.83859116 C6.33943736,5.70359511 6.07001296,5.72288026 5.89644661,5.89644661 L5.89644661,5.89644661 L5.83859116,5.9656945 C5.70359511,6.16056264 5.72288026,6.42998704 5.89644661,6.60355339 L5.89644661,6.60355339 L7.293,8 L5.89644661,9.39644661 L5.83859116,9.4656945 C5.70359511,9.66056264 5.72288026,9.92998704 5.89644661,10.1035534 L5.89644661,10.1035534 L5.9656945,10.1614088 C6.16056264,10.2964049 6.42998704,10.2771197 6.60355339,10.1035534 L6.60355339,10.1035534 L8,8.707 L9.39644661,10.1035534 L9.4656945,10.1614088 C9.66056264,10.2964049 9.92998704,10.2771197 10.1035534,10.1035534 L10.1035534,10.1035534 L10.1614088,10.0343055 C10.2964049,9.83943736 10.2771197,9.57001296 10.1035534,9.39644661 L10.1035534,9.39644661 L8.707,8 L10.1035534,6.60355339 L10.1614088,6.5343055 C10.2964049,6.33943736 10.2771197,6.07001296 10.1035534,5.89644661 L10.1035534,5.89644661 L10.0343055,5.83859116 C9.83943736,5.70359511 9.57001296,5.72288026 9.39644661,5.89644661 L9.39644661,5.89644661 L8,7.293 L6.60355339,5.89644661 Z" }))))), kfe = oe({
  name: "ChevronDownFilled",
  render() {
    return b("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, b("path", { d: "M3.20041 5.73966C3.48226 5.43613 3.95681 5.41856 4.26034 5.70041L8 9.22652L11.7397 5.70041C12.0432 5.41856 12.5177 5.43613 12.7996 5.73966C13.0815 6.0432 13.0639 6.51775 12.7603 6.7996L8.51034 10.7996C8.22258 11.0668 7.77743 11.0668 7.48967 10.7996L3.23966 6.7996C2.93613 6.51775 2.91856 6.0432 3.20041 5.73966Z", fill: "currentColor" }));
  }
}), Dfe = lo("to", b("svg", { viewBox: "0 0 20 20", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, b("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" }, b("g", { fill: "currentColor", "fill-rule": "nonzero" }, b("path", { d: "M11.2654,3.20511 C10.9644,2.92049 10.4897,2.93371 10.2051,3.23464 C9.92049,3.53558 9.93371,4.01027 10.2346,4.29489 L15.4737,9.25 L2.75,9.25 C2.33579,9.25 2,9.58579 2,10.0000012 C2,10.4142 2.33579,10.75 2.75,10.75 L15.476,10.75 L10.2346,15.7073 C9.93371,15.9919 9.92049,16.4666 10.2051,16.7675 C10.4897,17.0684 10.9644,17.0817 11.2654,16.797 L17.6826,10.7276 C17.8489,10.5703 17.9489,10.3702 17.9826,10.1614 C17.994,10.1094 18,10.0554 18,10.0000012 C18,9.94241 17.9935,9.88633 17.9812,9.83246 C17.9462,9.62667 17.8467,9.42976 17.6826,9.27455 L11.2654,3.20511 Z" }))))), Afe = lo("retry", b("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" }, b("path", { d: "M320,146s24.36-12-64-12A160,160,0,1,0,416,294", style: "fill: none; stroke: currentcolor; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 32px;" }), b("polyline", { points: "256 58 336 138 256 218", style: "fill: none; stroke: currentcolor; stroke-linecap: round; stroke-linejoin: round; stroke-width: 32px;" }))), Efe = lo("rotateClockwise", b("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, b("path", { d: "M3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 12.7916 15.3658 15.2026 13 16.3265V14.5C13 14.2239 12.7761 14 12.5 14C12.2239 14 12 14.2239 12 14.5V17.5C12 17.7761 12.2239 18 12.5 18H15.5C15.7761 18 16 17.7761 16 17.5C16 17.2239 15.7761 17 15.5 17H13.8758C16.3346 15.6357 18 13.0128 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 10.2761 2.22386 10.5 2.5 10.5C2.77614 10.5 3 10.2761 3 10Z", fill: "currentColor" }), b("path", { d: "M10 12C11.1046 12 12 11.1046 12 10C12 8.89543 11.1046 8 10 8C8.89543 8 8 8.89543 8 10C8 11.1046 8.89543 12 10 12ZM10 11C9.44772 11 9 10.5523 9 10C9 9.44772 9.44772 9 10 9C10.5523 9 11 9.44772 11 10C11 10.5523 10.5523 11 10 11Z", fill: "currentColor" }))), Ife = lo("rotateClockwise", b("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, b("path", { d: "M17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 12.7916 4.63419 15.2026 7 16.3265V14.5C7 14.2239 7.22386 14 7.5 14C7.77614 14 8 14.2239 8 14.5V17.5C8 17.7761 7.77614 18 7.5 18H4.5C4.22386 18 4 17.7761 4 17.5C4 17.2239 4.22386 17 4.5 17H6.12422C3.66539 15.6357 2 13.0128 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 10.2761 17.7761 10.5 17.5 10.5C17.2239 10.5 17 10.2761 17 10Z", fill: "currentColor" }), b("path", { d: "M10 12C8.89543 12 8 11.1046 8 10C8 8.89543 8.89543 8 10 8C11.1046 8 12 8.89543 12 10C12 11.1046 11.1046 12 10 12ZM10 11C10.5523 11 11 10.5523 11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11Z", fill: "currentColor" }))), Nfe = lo("zoomIn", b("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, b("path", { d: "M11.5 8.5C11.5 8.22386 11.2761 8 11 8H9V6C9 5.72386 8.77614 5.5 8.5 5.5C8.22386 5.5 8 5.72386 8 6V8H6C5.72386 8 5.5 8.22386 5.5 8.5C5.5 8.77614 5.72386 9 6 9H8V11C8 11.2761 8.22386 11.5 8.5 11.5C8.77614 11.5 9 11.2761 9 11V9H11C11.2761 9 11.5 8.77614 11.5 8.5Z", fill: "currentColor" }), b("path", { d: "M8.5 3C11.5376 3 14 5.46243 14 8.5C14 9.83879 13.5217 11.0659 12.7266 12.0196L16.8536 16.1464C17.0488 16.3417 17.0488 16.6583 16.8536 16.8536C16.68 17.0271 16.4106 17.0464 16.2157 16.9114L16.1464 16.8536L12.0196 12.7266C11.0659 13.5217 9.83879 14 8.5 14C5.46243 14 3 11.5376 3 8.5C3 5.46243 5.46243 3 8.5 3ZM8.5 4C6.01472 4 4 6.01472 4 8.5C4 10.9853 6.01472 13 8.5 13C10.9853 13 13 10.9853 13 8.5C13 6.01472 10.9853 4 8.5 4Z", fill: "currentColor" }))), zfe = lo("zoomOut", b("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, b("path", { d: "M11 8C11.2761 8 11.5 8.22386 11.5 8.5C11.5 8.77614 11.2761 9 11 9H6C5.72386 9 5.5 8.77614 5.5 8.5C5.5 8.22386 5.72386 8 6 8H11Z", fill: "currentColor" }), b("path", { d: "M14 8.5C14 5.46243 11.5376 3 8.5 3C5.46243 3 3 5.46243 3 8.5C3 11.5376 5.46243 14 8.5 14C9.83879 14 11.0659 13.5217 12.0196 12.7266L16.1464 16.8536L16.2157 16.9114C16.4106 17.0464 16.68 17.0271 16.8536 16.8536C17.0488 16.6583 17.0488 16.3417 16.8536 16.1464L12.7266 12.0196C13.5217 11.0659 14 9.83879 14 8.5ZM4 8.5C4 6.01472 6.01472 4 8.5 4C10.9853 4 13 6.01472 13 8.5C13 10.9853 10.9853 13 8.5 13C6.01472 13 4 10.9853 4 8.5Z", fill: "currentColor" }))), $fe = oe({
  name: "ResizeSmall",
  render() {
    return b("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" }, b("g", { fill: "none" }, b("path", { d: "M5.5 4A1.5 1.5 0 0 0 4 5.5v1a.5.5 0 0 1-1 0v-1A2.5 2.5 0 0 1 5.5 3h1a.5.5 0 0 1 0 1h-1zM16 5.5A1.5 1.5 0 0 0 14.5 4h-1a.5.5 0 0 1 0-1h1A2.5 2.5 0 0 1 17 5.5v1a.5.5 0 0 1-1 0v-1zm0 9a1.5 1.5 0 0 1-1.5 1.5h-1a.5.5 0 0 0 0 1h1a2.5 2.5 0 0 0 2.5-2.5v-1a.5.5 0 0 0-1 0v1zm-12 0A1.5 1.5 0 0 0 5.5 16h1.25a.5.5 0 0 1 0 1H5.5A2.5 2.5 0 0 1 3 14.5v-1.25a.5.5 0 0 1 1 0v1.25zM8.5 7A1.5 1.5 0 0 0 7 8.5v3A1.5 1.5 0 0 0 8.5 13h3a1.5 1.5 0 0 0 1.5-1.5v-3A1.5 1.5 0 0 0 11.5 7h-3zM8 8.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3z", fill: "currentColor" })));
  }
}), Lc = oe({
  name: "BaseIconSwitchTransition",
  setup(e, { slots: t }) {
    const r = ql();
    return () => b(jn, { name: "icon-switch-transition", appear: r.value }, t);
  }
}), ph = oe({
  name: "FadeInExpandTransition",
  props: {
    appear: Boolean,
    group: Boolean,
    mode: String,
    onLeave: Function,
    onAfterLeave: Function,
    onAfterEnter: Function,
    width: Boolean,
    reverse: Boolean
  },
  setup(e, { slots: t }) {
    function r(s) {
      e.width ? s.style.maxWidth = `${s.offsetWidth}px` : s.style.maxHeight = `${s.offsetHeight}px`, s.offsetWidth;
    }
    function n(s) {
      e.width ? s.style.maxWidth = "0" : s.style.maxHeight = "0", s.offsetWidth;
      const { onLeave: u } = e;
      u && u();
    }
    function i(s) {
      e.width ? s.style.maxWidth = "" : s.style.maxHeight = "";
      const { onAfterLeave: u } = e;
      u && u();
    }
    function o(s) {
      if (s.style.transition = "none", e.width) {
        const u = s.offsetWidth;
        s.style.maxWidth = "0", s.offsetWidth, s.style.transition = "", s.style.maxWidth = `${u}px`;
      } else if (e.reverse)
        s.style.maxHeight = `${s.offsetHeight}px`, s.offsetHeight, s.style.transition = "", s.style.maxHeight = "0";
      else {
        const u = s.offsetHeight;
        s.style.maxHeight = "0", s.offsetWidth, s.style.transition = "", s.style.maxHeight = `${u}px`;
      }
      s.offsetWidth;
    }
    function a(s) {
      var u;
      e.width ? s.style.maxWidth = "" : e.reverse || (s.style.maxHeight = ""), (u = e.onAfterEnter) === null || u === void 0 || u.call(e);
    }
    return () => {
      const { group: s, width: u, appear: d, mode: f } = e, h = s ? jO : jn, g = {
        name: u ? "fade-in-width-expand-transition" : "fade-in-height-expand-transition",
        appear: d,
        onEnter: o,
        onAfterEnter: a,
        onBeforeLeave: r,
        onLeave: n,
        onAfterLeave: i
      };
      return s || (g.mode = f), b(h, g, t);
    };
  }
}), Ofe = L("base-icon", `
 height: 1em;
 width: 1em;
 line-height: 1em;
 text-align: center;
 display: inline-block;
 position: relative;
 fill: currentColor;
 transform: translateZ(0);
`, [Y("svg", `
 height: 1em;
 width: 1em;
 `)]), fr = oe({
  name: "BaseIcon",
  props: {
    role: String,
    ariaLabel: String,
    ariaDisabled: {
      type: Boolean,
      default: void 0
    },
    ariaHidden: {
      type: Boolean,
      default: void 0
    },
    clsPrefix: {
      type: String,
      required: !0
    },
    onClick: Function,
    onMousedown: Function,
    onMouseup: Function
  },
  setup(e) {
    Vu("-base-icon", Ofe, tt(e, "clsPrefix"));
  },
  render() {
    return b("i", { class: `${this.clsPrefix}-base-icon`, onClick: this.onClick, onMousedown: this.onMousedown, onMouseup: this.onMouseup, role: this.role, "aria-label": this.ariaLabel, "aria-hidden": this.ariaHidden, "aria-disabled": this.ariaDisabled }, this.$slots);
  }
}), _fe = L("base-close", `
 display: flex;
 align-items: center;
 justify-content: center;
 cursor: pointer;
 background-color: transparent;
 color: var(--n-close-icon-color);
 border-radius: var(--n-close-border-radius);
 height: var(--n-close-size);
 width: var(--n-close-size);
 font-size: var(--n-close-icon-size);
 outline: none;
 border: none;
 position: relative;
 padding: 0;
`, [K("absolute", `
 height: var(--n-close-icon-size);
 width: var(--n-close-icon-size);
 `), Y("&::before", `
 content: "";
 position: absolute;
 width: var(--n-close-size);
 height: var(--n-close-size);
 left: 50%;
 top: 50%;
 transform: translateY(-50%) translateX(-50%);
 transition: inherit;
 border-radius: inherit;
 `), wr("disabled", [Y("&:hover", `
 color: var(--n-close-icon-color-hover);
 `), Y("&:hover::before", `
 background-color: var(--n-close-color-hover);
 `), Y("&:focus::before", `
 background-color: var(--n-close-color-hover);
 `), Y("&:active", `
 color: var(--n-close-icon-color-pressed);
 `), Y("&:active::before", `
 background-color: var(--n-close-color-pressed);
 `)]), K("disabled", `
 cursor: not-allowed;
 color: var(--n-close-icon-color-disabled);
 background-color: transparent;
 `), K("round", [Y("&::before", `
 border-radius: 50%;
 `)])]), gh = oe({
  name: "BaseClose",
  props: {
    isButtonTag: {
      type: Boolean,
      default: !0
    },
    clsPrefix: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    focusable: {
      type: Boolean,
      default: !0
    },
    round: Boolean,
    onClick: Function,
    absolute: Boolean
  },
  setup(e) {
    return Vu("-base-close", _fe, tt(e, "clsPrefix")), () => {
      const { clsPrefix: t, disabled: r, absolute: n, round: i, isButtonTag: o } = e;
      return b(o ? "button" : "div", { type: o ? "button" : void 0, tabindex: r || !e.focusable ? -1 : 0, "aria-disabled": r, "aria-label": "close", role: o ? void 0 : "button", disabled: r, class: [
        `${t}-base-close`,
        n && `${t}-base-close--absolute`,
        r && `${t}-base-close--disabled`,
        i && `${t}-base-close--round`
      ], onMousedown: (s) => {
        e.focusable || s.preventDefault();
      }, onClick: e.onClick }, b(fr, { clsPrefix: t }, {
        default: () => b(J7, null)
      }));
    };
  }
}), Pc = oe({
  props: {
    onFocus: Function,
    onBlur: Function
  },
  setup(e) {
    return () => b("div", { style: "width: 0; height: 0", tabindex: 0, onFocus: e.onFocus, onBlur: e.onBlur });
  }
});
const {
  cubicBezierEaseInOut: Lfe
} = Wa;
function Io({
  originalTransform: e = "",
  left: t = 0,
  top: r = 0,
  transition: n = `all .3s ${Lfe} !important`
} = {}) {
  return [Y("&.icon-switch-transition-enter-from, &.icon-switch-transition-leave-to", {
    transform: e + " scale(0.75)",
    left: t,
    top: r,
    opacity: 0
  }), Y("&.icon-switch-transition-enter-to, &.icon-switch-transition-leave-from", {
    transform: `scale(1) ${e}`,
    left: t,
    top: r,
    opacity: 1
  }), Y("&.icon-switch-transition-enter-active, &.icon-switch-transition-leave-active", {
    transformOrigin: "center",
    position: "absolute",
    left: t,
    top: r,
    transition: n
  })];
}
var Pfe = Y([Y("@keyframes loading-container-rotate", `
 to {
 -webkit-transform: rotate(360deg);
 transform: rotate(360deg);
 }
 `), Y("@keyframes loading-layer-rotate", `
 12.5% {
 -webkit-transform: rotate(135deg);
 transform: rotate(135deg);
 }
 25% {
 -webkit-transform: rotate(270deg);
 transform: rotate(270deg);
 }
 37.5% {
 -webkit-transform: rotate(405deg);
 transform: rotate(405deg);
 }
 50% {
 -webkit-transform: rotate(540deg);
 transform: rotate(540deg);
 }
 62.5% {
 -webkit-transform: rotate(675deg);
 transform: rotate(675deg);
 }
 75% {
 -webkit-transform: rotate(810deg);
 transform: rotate(810deg);
 }
 87.5% {
 -webkit-transform: rotate(945deg);
 transform: rotate(945deg);
 }
 100% {
 -webkit-transform: rotate(1080deg);
 transform: rotate(1080deg);
 } 
 `), Y("@keyframes loading-left-spin", `
 from {
 -webkit-transform: rotate(265deg);
 transform: rotate(265deg);
 }
 50% {
 -webkit-transform: rotate(130deg);
 transform: rotate(130deg);
 }
 to {
 -webkit-transform: rotate(265deg);
 transform: rotate(265deg);
 }
 `), Y("@keyframes loading-right-spin", `
 from {
 -webkit-transform: rotate(-265deg);
 transform: rotate(-265deg);
 }
 50% {
 -webkit-transform: rotate(-130deg);
 transform: rotate(-130deg);
 }
 to {
 -webkit-transform: rotate(-265deg);
 transform: rotate(-265deg);
 }
 `), L("base-loading", `
 position: relative;
 line-height: 0;
 width: 1em;
 height: 1em;
 `, [q("transition-wrapper", `
 position: absolute;
 width: 100%;
 height: 100%;
 `, [Io()]), q("container", `
 display: inline-flex;
 position: relative;
 direction: ltr;
 line-height: 0;
 animation: loading-container-rotate 1568.2352941176ms linear infinite;
 font-size: 0;
 letter-spacing: 0;
 white-space: nowrap;
 opacity: 1;
 width: 100%;
 height: 100%;
 `, [q("svg", `
 stroke: var(--n-text-color);
 fill: transparent;
 position: absolute;
 height: 100%;
 overflow: hidden;
 `), q("container-layer", `
 position: absolute;
 width: 100%;
 height: 100%;
 animation: loading-layer-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
 `, [q("container-layer-left", `
 display: inline-flex;
 position: relative;
 width: 50%;
 height: 100%;
 overflow: hidden;
 `, [q("svg", `
 animation: loading-left-spin 1333ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
 width: 200%;
 `)]), q("container-layer-patch", `
 position: absolute;
 top: 0;
 left: 47.5%;
 box-sizing: border-box;
 width: 5%;
 height: 100%;
 overflow: hidden;
 `, [q("svg", `
 left: -900%;
 width: 2000%;
 transform: rotate(180deg);
 `)]), q("container-layer-right", `
 display: inline-flex;
 position: relative;
 width: 50%;
 height: 100%;
 overflow: hidden;
 `, [q("svg", `
 animation: loading-right-spin 1333ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
 left: -100%;
 width: 200%;
 `)])])]), q("placeholder", `
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 `, [Io({
  left: "50%",
  top: "50%",
  originalTransform: "translateX(-50%) translateY(-50%)"
})])])]);
const Rfe = {
  strokeWidth: {
    type: Number,
    default: 28
  },
  stroke: {
    type: String,
    default: void 0
  }
};
var mh = oe({
  name: "BaseLoading",
  props: Object.assign({ clsPrefix: {
    type: String,
    required: !0
  }, show: {
    type: Boolean,
    default: !0
  }, scale: {
    type: Number,
    default: 1
  }, radius: {
    type: Number,
    default: 100
  } }, Rfe),
  setup(e) {
    Vu("-base-loading", Pfe, tt(e, "clsPrefix"));
  },
  render() {
    const { clsPrefix: e, radius: t, strokeWidth: r, stroke: n, scale: i } = this, o = t / i;
    return b("div", { class: `${e}-base-loading`, role: "img", "aria-label": "loading" }, b(Lc, null, {
      default: () => this.show ? b("div", { key: "icon", class: `${e}-base-loading__transition-wrapper` }, b("div", { class: `${e}-base-loading__container` }, b("div", { class: `${e}-base-loading__container-layer` }, b("div", { class: `${e}-base-loading__container-layer-left` }, b("svg", { class: `${e}-base-loading__svg`, viewBox: `0 0 ${2 * o} ${2 * o}`, xmlns: "http://www.w3.org/2000/svg", style: { color: n } }, b("circle", { fill: "none", stroke: "currentColor", "stroke-width": r, "stroke-linecap": "round", cx: o, cy: o, r: t - r / 2, "stroke-dasharray": 4.91 * t, "stroke-dashoffset": 2.46 * t }))), b("div", { class: `${e}-base-loading__container-layer-patch` }, b("svg", { class: `${e}-base-loading__svg`, viewBox: `0 0 ${2 * o} ${2 * o}`, xmlns: "http://www.w3.org/2000/svg", style: { color: n } }, b("circle", { fill: "none", stroke: "currentColor", "stroke-width": r, "stroke-linecap": "round", cx: o, cy: o, r: t - r / 2, "stroke-dasharray": 4.91 * t, "stroke-dashoffset": 2.46 * t }))), b("div", { class: `${e}-base-loading__container-layer-right` }, b("svg", { class: `${e}-base-loading__svg`, viewBox: `0 0 ${2 * o} ${2 * o}`, xmlns: "http://www.w3.org/2000/svg", style: { color: n } }, b("circle", { fill: "none", stroke: "currentColor", "stroke-width": r, "stroke-linecap": "round", cx: o, cy: o, r: t - r / 2, "stroke-dasharray": 4.91 * t, "stroke-dashoffset": 2.46 * t })))))) : b("div", { key: "placeholder", class: `${e}-base-loading__placeholder` }, this.$slots)
    }));
  }
});
function NP(e) {
  return Array.isArray(e) ? e : [e];
}
const wz = {
  STOP: "STOP"
};
function rH(e, t) {
  const r = t(e);
  e.children !== void 0 && r !== wz.STOP && e.children.forEach((n) => rH(n, t));
}
function jfe(e, t = {}) {
  const { preserveGroup: r = !1 } = t, n = [], i = r ? (a) => {
    a.isLeaf || (n.push(a.key), o(a.children));
  } : (a) => {
    a.isLeaf || (a.isGroup || n.push(a.key), o(a.children));
  };
  function o(a) {
    a.forEach(i);
  }
  return o(e), n;
}
function Ffe(e, t) {
  const { isLeaf: r } = e;
  return r !== void 0 ? r : !t(e);
}
function Bfe(e) {
  return e.children;
}
function Ufe(e) {
  return e.key;
}
function Hfe() {
  return !1;
}
function Wfe(e, t) {
  const { isLeaf: r } = e;
  return !(r === !1 && !Array.isArray(t(e)));
}
function Vfe(e) {
  return e.disabled === !0;
}
function Yfe(e, t) {
  return e.isLeaf === !1 && !Array.isArray(t(e));
}
function LI(e) {
  var t;
  return e == null ? [] : Array.isArray(e) ? e : (t = e.checkedKeys) !== null && t !== void 0 ? t : [];
}
function PI(e) {
  var t;
  return e == null || Array.isArray(e) ? [] : (t = e.indeterminateKeys) !== null && t !== void 0 ? t : [];
}
function Qfe(e, t) {
  const r = new Set(e);
  return t.forEach((n) => {
    r.has(n) || r.add(n);
  }), Array.from(r);
}
function qfe(e, t) {
  const r = new Set(e);
  return t.forEach((n) => {
    r.has(n) && r.delete(n);
  }), Array.from(r);
}
function Gfe(e) {
  return (e == null ? void 0 : e.type) === "group";
}
function Zfe(e) {
  const t = /* @__PURE__ */ new Map();
  return e.forEach((r, n) => {
    t.set(r.key, n);
  }), (r) => {
    var n;
    return (n = t.get(r)) !== null && n !== void 0 ? n : null;
  };
}
class Kfe extends Error {
  constructor() {
    super(), this.message = "SubtreeNotLoadedError: checking a subtree whose required nodes are not fully loaded.";
  }
}
function Xfe(e, t, r, n) {
  return nx(t.concat(e), r, n, !1);
}
function Jfe(e, t) {
  const r = /* @__PURE__ */ new Set();
  return e.forEach((n) => {
    const i = t.treeNodeMap.get(n);
    if (i !== void 0) {
      let o = i.parent;
      for (; o !== null && !(o.disabled || r.has(o.key)); )
        r.add(o.key), o = o.parent;
    }
  }), r;
}
function ehe(e, t, r, n) {
  const i = nx(t, r, n, !1), o = nx(e, r, n, !0), a = Jfe(e, r), s = [];
  return i.forEach((u) => {
    (o.has(u) || a.has(u)) && s.push(u);
  }), s.forEach((u) => i.delete(u)), i;
}
function RI(e, t) {
  const { checkedKeys: r, keysToCheck: n, keysToUncheck: i, indeterminateKeys: o, cascade: a, leafOnly: s, checkStrategy: u, allowNotLoaded: d } = e;
  if (!a)
    return n !== void 0 ? {
      checkedKeys: Qfe(r, n),
      indeterminateKeys: Array.from(o)
    } : i !== void 0 ? {
      checkedKeys: qfe(r, i),
      indeterminateKeys: Array.from(o)
    } : {
      checkedKeys: Array.from(r),
      indeterminateKeys: Array.from(o)
    };
  const { levelTreeNodeMap: f } = t;
  let h;
  i !== void 0 ? h = ehe(i, r, t, d) : n !== void 0 ? h = Xfe(n, r, t, d) : h = nx(r, t, d, !1);
  const g = u === "parent", m = u === "child" || s, v = h, w = /* @__PURE__ */ new Set(), x = Math.max.apply(null, Array.from(f.keys()));
  for (let y = x; y >= 0; y -= 1) {
    const C = y === 0, S = f.get(y);
    for (const T of S) {
      if (T.isLeaf)
        continue;
      const { key: A, shallowLoaded: D } = T;
      if (m && D && T.children.forEach(($) => {
        !$.disabled && !$.isLeaf && $.shallowLoaded && v.has($.key) && v.delete($.key);
      }), T.disabled || !D)
        continue;
      let E = !0, N = !1, I = !0;
      for (const $ of T.children) {
        const _ = $.key;
        if (!$.disabled) {
          if (I && (I = !1), v.has(_))
            N = !0;
          else if (w.has(_)) {
            N = !0, E = !1;
            break;
          } else if (E = !1, N)
            break;
        }
      }
      E && !I ? (g && T.children.forEach(($) => {
        !$.disabled && v.has($.key) && v.delete($.key);
      }), v.add(A)) : N && w.add(A), C && m && v.has(A) && v.delete(A);
    }
  }
  return {
    checkedKeys: Array.from(v),
    indeterminateKeys: Array.from(w)
  };
}
function nx(e, t, r, n) {
  const { treeNodeMap: i, getChildren: o } = t, a = /* @__PURE__ */ new Set(), s = new Set(e);
  return e.forEach((u) => {
    const d = i.get(u);
    d !== void 0 && rH(d, (f) => {
      if (f.disabled)
        return wz.STOP;
      const { key: h } = f;
      if (!a.has(h) && (a.add(h), s.add(h), Yfe(f.rawNode, o))) {
        if (n)
          return wz.STOP;
        if (!r)
          throw new Kfe();
      }
    });
  }), s;
}
function the(e, { includeGroup: t = !1, includeSelf: r = !0 }, n) {
  var i;
  const o = n.treeNodeMap;
  let a = e == null ? null : (i = o.get(e)) !== null && i !== void 0 ? i : null;
  const s = {
    keyPath: [],
    treeNodePath: [],
    treeNode: a
  };
  if (a != null && a.ignored)
    return s.treeNode = null, s;
  for (; a; )
    !a.ignored && (t || !a.isGroup) && s.treeNodePath.push(a), a = a.parent;
  return s.treeNodePath.reverse(), r || s.treeNodePath.pop(), s.keyPath = s.treeNodePath.map((u) => u.key), s;
}
function rhe(e) {
  if (e.length === 0)
    return null;
  const t = e[0];
  return t.isGroup || t.ignored || t.disabled ? t.getNext() : t;
}
function nhe(e, t) {
  const r = e.siblings, n = r.length, { index: i } = e;
  return t ? r[(i + 1) % n] : i === r.length - 1 ? null : r[i + 1];
}
function zP(e, t, { loop: r = !1, includeDisabled: n = !1 } = {}) {
  const i = t === "prev" ? ihe : nhe, o = {
    reverse: t === "prev"
  };
  let a = !1, s = null;
  function u(d) {
    if (d !== null) {
      if (d === e) {
        if (!a)
          a = !0;
        else if (!e.disabled && !e.isGroup) {
          s = e;
          return;
        }
      } else if ((!d.disabled || n) && !d.ignored && !d.isGroup) {
        s = d;
        return;
      }
      if (d.isGroup) {
        const f = M4(d, o);
        f !== null ? s = f : u(i(d, r));
      } else {
        const f = i(d, !1);
        if (f !== null)
          u(f);
        else {
          const h = ohe(d);
          h != null && h.isGroup ? u(i(h, r)) : r && u(i(d, !0));
        }
      }
    }
  }
  return u(e), s;
}
function ihe(e, t) {
  const r = e.siblings, n = r.length, { index: i } = e;
  return t ? r[(i - 1 + n) % n] : i === 0 ? null : r[i - 1];
}
function ohe(e) {
  return e.parent;
}
function M4(e, t = {}) {
  const { reverse: r = !1 } = t, { children: n } = e;
  if (n) {
    const { length: i } = n, o = r ? i - 1 : 0, a = r ? -1 : i, s = r ? -1 : 1;
    for (let u = o; u !== a; u += s) {
      const d = n[u];
      if (!d.disabled && !d.ignored)
        if (d.isGroup) {
          const f = M4(d, t);
          if (f !== null)
            return f;
        } else
          return d;
    }
  }
  return null;
}
const ahe = {
  getChild() {
    return this.ignored ? null : M4(this);
  },
  getParent() {
    const { parent: e } = this;
    return e != null && e.isGroup ? e.getParent() : e;
  },
  getNext(e = {}) {
    return zP(this, "next", e);
  },
  getPrev(e = {}) {
    return zP(this, "prev", e);
  }
};
function lhe(e, t) {
  const r = t ? new Set(t) : void 0, n = [];
  function i(o) {
    o.forEach((a) => {
      n.push(a), !(a.isLeaf || !a.children || a.ignored) && (a.isGroup || r === void 0 || r.has(a.key)) && i(a.children);
    });
  }
  return i(e), n;
}
function she(e, t) {
  const r = e.key;
  for (; t; ) {
    if (t.key === r)
      return !0;
    t = t.parent;
  }
  return !1;
}
function nH(e, t, r, n, i, o = null, a = 0) {
  const s = [];
  return e.forEach((u, d) => {
    var f;
    const h = Object.create(n);
    if (h.rawNode = u, h.siblings = s, h.level = a, h.index = d, h.isFirstChild = d === 0, h.isLastChild = d + 1 === e.length, h.parent = o, !h.ignored) {
      const g = i(u);
      Array.isArray(g) && (h.children = nH(g, t, r, n, i, h, a + 1));
    }
    s.push(h), t.set(h.key, h), r.has(a) || r.set(a, []), (f = r.get(a)) === null || f === void 0 || f.push(h);
  }), s;
}
function Mb(e, t = {}) {
  var r;
  const n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), { getDisabled: o = Vfe, getIgnored: a = Hfe, getIsGroup: s = Gfe, getKey: u = Ufe } = t, d = (r = t.getChildren) !== null && r !== void 0 ? r : Bfe, f = t.ignoreEmptyChildren ? (T) => {
    const A = d(T);
    return Array.isArray(A) ? A.length ? A : null : A;
  } : d, h = Object.assign({
    get key() {
      return u(this.rawNode);
    },
    get disabled() {
      return o(this.rawNode);
    },
    get isGroup() {
      return s(this.rawNode);
    },
    get isLeaf() {
      return Ffe(this.rawNode, f);
    },
    get shallowLoaded() {
      return Wfe(this.rawNode, f);
    },
    get ignored() {
      return a(this.rawNode);
    },
    contains(T) {
      return she(this, T);
    }
  }, ahe), g = nH(e, n, i, h, f);
  function m(T) {
    if (T == null)
      return null;
    const A = n.get(T);
    return A && !A.isGroup && !A.ignored ? A : null;
  }
  function v(T) {
    if (T == null)
      return null;
    const A = n.get(T);
    return A && !A.ignored ? A : null;
  }
  function w(T, A) {
    const D = v(T);
    return D ? D.getPrev(A) : null;
  }
  function x(T, A) {
    const D = v(T);
    return D ? D.getNext(A) : null;
  }
  function y(T) {
    const A = v(T);
    return A ? A.getParent() : null;
  }
  function C(T) {
    const A = v(T);
    return A ? A.getChild() : null;
  }
  const S = {
    treeNodes: g,
    treeNodeMap: n,
    levelTreeNodeMap: i,
    maxLevel: Math.max(...i.keys()),
    getChildren: f,
    getFlattenedNodes(T) {
      return lhe(g, T);
    },
    getNode: m,
    getPrev: w,
    getNext: x,
    getParent: y,
    getChild: C,
    getFirstAvailableNode() {
      return rhe(g);
    },
    getPath(T, A = {}) {
      return the(T, A, S);
    },
    getCheckedKeys(T, A = {}) {
      const { cascade: D = !0, leafOnly: E = !1, checkStrategy: N = "all", allowNotLoaded: I = !1 } = A;
      return RI({
        checkedKeys: LI(T),
        indeterminateKeys: PI(T),
        cascade: D,
        leafOnly: E,
        checkStrategy: N,
        allowNotLoaded: I
      }, S);
    },
    check(T, A, D = {}) {
      const { cascade: E = !0, leafOnly: N = !1, checkStrategy: I = "all", allowNotLoaded: $ = !1 } = D;
      return RI({
        checkedKeys: LI(A),
        indeterminateKeys: PI(A),
        keysToCheck: T == null ? [] : NP(T),
        cascade: E,
        leafOnly: N,
        checkStrategy: I,
        allowNotLoaded: $
      }, S);
    },
    uncheck(T, A, D = {}) {
      const { cascade: E = !0, leafOnly: N = !1, checkStrategy: I = "all", allowNotLoaded: $ = !1 } = D;
      return RI({
        checkedKeys: LI(A),
        indeterminateKeys: PI(A),
        keysToUncheck: T == null ? [] : NP(T),
        cascade: E,
        leafOnly: N,
        checkStrategy: I,
        allowNotLoaded: $
      }, S);
    },
    getNonLeafKeys(T = {}) {
      return jfe(g, T);
    }
  };
  return S;
}
const ur = {
  neutralBase: "#FFF",
  neutralInvertBase: "#000",
  neutralTextBase: "#000",
  neutralPopover: "#fff",
  neutralCard: "#fff",
  neutralModal: "#fff",
  neutralBody: "#fff",
  alpha1: "0.82",
  alpha2: "0.72",
  alpha3: "0.38",
  alpha4: "0.24",
  alpha5: "0.18",
  alphaClose: "0.6",
  alphaDisabled: "0.5",
  alphaDisabledInput: "0.02",
  alphaPending: "0.05",
  alphaTablePending: "0.02",
  alphaPressed: "0.07",
  alphaAvatar: "0.2",
  alphaRail: "0.14",
  alphaProgressRail: ".08",
  alphaBorder: "0.12",
  alphaDivider: "0.06",
  alphaInput: "0",
  alphaAction: "0.02",
  alphaTab: "0.04",
  alphaScrollbar: "0.25",
  alphaScrollbarHover: "0.4",
  alphaCode: "0.05",
  alphaTag: "0.02",
  primaryHover: "#36ad6a",
  primaryDefault: "#18a058",
  primaryActive: "#0c7a43",
  primarySuppl: "#36ad6a",
  infoHover: "#4098fc",
  infoDefault: "#2080f0",
  infoActive: "#1060c9",
  infoSuppl: "#4098fc",
  errorHover: "#de576d",
  errorDefault: "#d03050",
  errorActive: "#ab1f3f",
  errorSuppl: "#de576d",
  warningHover: "#fcb040",
  warningDefault: "#f0a020",
  warningActive: "#c97c10",
  warningSuppl: "#fcb040",
  successHover: "#36ad6a",
  successDefault: "#18a058",
  successActive: "#0c7a43",
  successSuppl: "#36ad6a"
}, uhe = ro(ur.neutralBase), iH = ro(ur.neutralInvertBase), che = "rgba(" + iH.slice(0, 3).join(", ") + ", ";
function $P(e) {
  return che + String(e) + ")";
}
function ko(e) {
  const t = Array.from(iH);
  return t[3] = Number(e), nn(uhe, t);
}
const dhe = Object.assign(Object.assign({ name: "common" }, Wa), {
  baseColor: ur.neutralBase,
  primaryColor: ur.primaryDefault,
  primaryColorHover: ur.primaryHover,
  primaryColorPressed: ur.primaryActive,
  primaryColorSuppl: ur.primarySuppl,
  infoColor: ur.infoDefault,
  infoColorHover: ur.infoHover,
  infoColorPressed: ur.infoActive,
  infoColorSuppl: ur.infoSuppl,
  successColor: ur.successDefault,
  successColorHover: ur.successHover,
  successColorPressed: ur.successActive,
  successColorSuppl: ur.successSuppl,
  warningColor: ur.warningDefault,
  warningColorHover: ur.warningHover,
  warningColorPressed: ur.warningActive,
  warningColorSuppl: ur.warningSuppl,
  errorColor: ur.errorDefault,
  errorColorHover: ur.errorHover,
  errorColorPressed: ur.errorActive,
  errorColorSuppl: ur.errorSuppl,
  textColorBase: ur.neutralTextBase,
  textColor1: "rgb(31, 34, 37)",
  textColor2: "rgb(51, 54, 57)",
  textColor3: "rgb(118, 124, 130)",
  textColorDisabled: ko(ur.alpha4),
  placeholderColor: ko(ur.alpha4),
  placeholderColorDisabled: ko(ur.alpha5),
  iconColor: ko(ur.alpha4),
  iconColorHover: qb(ko(ur.alpha4), { lightness: 0.75 }),
  iconColorPressed: qb(ko(ur.alpha4), { lightness: 0.9 }),
  iconColorDisabled: ko(ur.alpha5),
  opacity1: ur.alpha1,
  opacity2: ur.alpha2,
  opacity3: ur.alpha3,
  opacity4: ur.alpha4,
  opacity5: ur.alpha5,
  dividerColor: "rgb(239, 239, 245)",
  borderColor: "rgb(224, 224, 230)",
  closeIconColor: ko(Number(ur.alphaClose)),
  closeIconColorHover: ko(Number(ur.alphaClose)),
  closeIconColorPressed: ko(Number(ur.alphaClose)),
  closeColorHover: "rgba(0, 0, 0, .09)",
  closeColorPressed: "rgba(0, 0, 0, .13)",
  clearColor: ko(ur.alpha4),
  clearColorHover: qb(ko(ur.alpha4), { lightness: 0.75 }),
  clearColorPressed: qb(ko(ur.alpha4), { lightness: 0.9 }),
  scrollbarColor: $P(ur.alphaScrollbar),
  scrollbarColorHover: $P(ur.alphaScrollbarHover),
  scrollbarWidth: "5px",
  scrollbarHeight: "5px",
  scrollbarBorderRadius: "5px",
  progressRailColor: ko(ur.alphaProgressRail),
  railColor: "rgb(219, 219, 223)",
  popoverColor: ur.neutralPopover,
  tableColor: ur.neutralCard,
  cardColor: ur.neutralCard,
  modalColor: ur.neutralModal,
  bodyColor: ur.neutralBody,
  tagColor: "#eee",
  avatarColor: ko(ur.alphaAvatar),
  invertedColor: "rgb(0, 20, 40)",
  inputColor: ko(ur.alphaInput),
  codeColor: "rgb(244, 244, 248)",
  tabColor: "rgb(247, 247, 250)",
  actionColor: "rgb(250, 250, 252)",
  tableHeaderColor: "rgb(250, 250, 252)",
  hoverColor: "rgb(243, 243, 245)",
  tableColorHover: "rgba(0, 0, 100, 0.03)",
  tableColorStriped: "rgba(0, 0, 100, 0.02)",
  pressedColor: "rgb(237, 237, 239)",
  opacityDisabled: ur.alphaDisabled,
  inputColorDisabled: "rgb(250, 250, 252)",
  buttonColor2: "rgba(46, 51, 56, .05)",
  buttonColor2Hover: "rgba(46, 51, 56, .09)",
  buttonColor2Pressed: "rgba(46, 51, 56, .13)",
  boxShadow1: "0 1px 2px -2px rgba(0, 0, 0, .08), 0 3px 6px 0 rgba(0, 0, 0, .06), 0 5px 12px 4px rgba(0, 0, 0, .04)",
  boxShadow2: "0 3px 6px -4px rgba(0, 0, 0, .12), 0 6px 16px 0 rgba(0, 0, 0, .08), 0 9px 28px 8px rgba(0, 0, 0, .05)",
  boxShadow3: "0 6px 16px -9px rgba(0, 0, 0, .08), 0 9px 28px 0 rgba(0, 0, 0, .05), 0 12px 48px 16px rgba(0, 0, 0, .03)"
});
var Sr = dhe, fhe = {
  iconSizeSmall: "34px",
  iconSizeMedium: "40px",
  iconSizeLarge: "46px",
  iconSizeHuge: "52px"
};
const hhe = (e) => {
  const { textColorDisabled: t, iconColor: r, textColor2: n, fontSizeSmall: i, fontSizeMedium: o, fontSizeLarge: a, fontSizeHuge: s } = e;
  return Object.assign(Object.assign({}, fhe), {
    fontSizeSmall: i,
    fontSizeMedium: o,
    fontSizeLarge: a,
    fontSizeHuge: s,
    textColor: t,
    iconColor: r,
    extraTextColor: n
  });
}, phe = {
  name: "Empty",
  common: Sr,
  self: hhe
};
var C4 = phe, ghe = L("empty", `
 display: flex;
 flex-direction: column;
 align-items: center;
 font-size: var(--n-font-size);
`, [q("icon", `
 width: var(--n-icon-size);
 height: var(--n-icon-size);
 font-size: var(--n-icon-size);
 line-height: var(--n-icon-size);
 color: var(--n-icon-color);
 transition:
 color .3s var(--n-bezier);
 `, [Y("+", [q("description", `
 margin-top: 8px;
 `)])]), q("description", `
 transition: color .3s var(--n-bezier);
 color: var(--n-text-color);
 `), q("extra", `
 text-align: center;
 transition: color .3s var(--n-bezier);
 margin-top: 12px;
 color: var(--n-extra-text-color);
 `)]);
const mhe = Object.assign(Object.assign({}, ft.props), { description: String, showDescription: {
  type: Boolean,
  default: !0
}, showIcon: {
  type: Boolean,
  default: !0
}, size: {
  type: String,
  default: "medium"
}, renderIcon: Function });
var oH = oe({
  name: "Empty",
  props: mhe,
  setup(e) {
    const { mergedClsPrefixRef: t, inlineThemeDisabled: r } = Yt(e), n = ft("Empty", "-empty", ghe, C4, e, t), { localeRef: i } = Zl("Empty"), o = lt(ju, null), a = j(() => {
      var f, h, g;
      return (f = e.description) !== null && f !== void 0 ? f : (g = (h = o == null ? void 0 : o.mergedComponentPropsRef.value) === null || h === void 0 ? void 0 : h.Empty) === null || g === void 0 ? void 0 : g.description;
    }), s = j(() => {
      var f, h;
      return ((h = (f = o == null ? void 0 : o.mergedComponentPropsRef.value) === null || f === void 0 ? void 0 : f.Empty) === null || h === void 0 ? void 0 : h.renderIcon) || (() => b(xfe, null));
    }), u = j(() => {
      const { size: f } = e, { common: { cubicBezierEaseInOut: h }, self: { [Be("iconSize", f)]: g, [Be("fontSize", f)]: m, textColor: v, iconColor: w, extraTextColor: x } } = n.value;
      return {
        "--n-icon-size": g,
        "--n-font-size": m,
        "--n-bezier": h,
        "--n-text-color": v,
        "--n-icon-color": w,
        "--n-extra-text-color": x
      };
    }), d = r ? Cr("empty", j(() => {
      let f = "";
      const { size: h } = e;
      return f += h[0], f;
    }), u, e) : void 0;
    return {
      mergedClsPrefix: t,
      mergedRenderIcon: s,
      localizedDescription: j(() => a.value || i.value.description),
      cssVars: r ? void 0 : u,
      themeClass: d == null ? void 0 : d.themeClass,
      onRender: d == null ? void 0 : d.onRender
    };
  },
  render() {
    const { $slots: e, mergedClsPrefix: t, onRender: r } = this;
    return r == null || r(), b("div", { class: [`${t}-empty`, this.themeClass], style: this.cssVars }, this.showIcon ? b("div", { class: `${t}-empty__icon` }, e.icon ? e.icon() : b(fr, { clsPrefix: t }, { default: this.mergedRenderIcon })) : null, this.showDescription ? b("div", { class: `${t}-empty__description` }, e.default ? e.default() : this.localizedDescription) : null, e.extra ? b("div", { class: `${t}-empty__extra` }, e.extra()) : null);
  }
});
const vhe = (e) => {
  const { scrollbarColor: t, scrollbarColorHover: r } = e;
  return {
    color: t,
    colorHover: r
  };
}, bhe = {
  name: "Scrollbar",
  common: Sr,
  self: vhe
};
var Rc = bhe;
const {
  cubicBezierEaseInOut: OP
} = Wa;
function bp({
  name: e = "fade-in",
  enterDuration: t = "0.2s",
  leaveDuration: r = "0.2s",
  enterCubicBezier: n = OP,
  leaveCubicBezier: i = OP
} = {}) {
  return [Y(`&.${e}-transition-enter-active`, {
    transition: `all ${t} ${n}!important`
  }), Y(`&.${e}-transition-leave-active`, {
    transition: `all ${r} ${i}!important`
  }), Y(`&.${e}-transition-enter-from, &.${e}-transition-leave-to`, {
    opacity: 0
  }), Y(`&.${e}-transition-leave-from, &.${e}-transition-enter-to`, {
    opacity: 1
  })];
}
var yhe = L("scrollbar", `
 overflow: hidden;
 position: relative;
 z-index: auto;
 height: 100%;
 width: 100%;
`, [Y(">", [L("scrollbar-container", `
 width: 100%;
 overflow: scroll;
 height: 100%;
 max-height: inherit;
 scrollbar-width: none;
 `, [Y("&::-webkit-scrollbar, &::-webkit-scrollbar-track-piece, &::-webkit-scrollbar-thumb", `
 width: 0;
 height: 0;
 display: none;
 `), Y(">", [L("scrollbar-content", `
 box-sizing: border-box;
 min-width: 100%;
 `)])])]), Y(">, +", [L("scrollbar-rail", `
 position: absolute;
 pointer-events: none;
 user-select: none;
 -webkit-user-select: none;
 `, [K("horizontal", `
 left: 2px;
 right: 2px;
 bottom: 4px;
 height: var(--n-scrollbar-height);
 `, [Y(">", [q("scrollbar", `
 height: var(--n-scrollbar-height);
 border-radius: var(--n-scrollbar-border-radius);
 right: 0;
 `)])]), K("vertical", `
 right: 4px;
 top: 2px;
 bottom: 2px;
 width: var(--n-scrollbar-width);
 `, [Y(">", [q("scrollbar", `
 width: var(--n-scrollbar-width);
 border-radius: var(--n-scrollbar-border-radius);
 bottom: 0;
 `)])]), K("disabled", [Y(">", [q("scrollbar", {
  pointerEvents: "none"
})])]), Y(">", [q("scrollbar", `
 position: absolute;
 cursor: pointer;
 pointer-events: all;
 background-color: var(--n-scrollbar-color);
 transition: background-color .2s var(--n-scrollbar-bezier);
 `, [bp(), Y("&:hover", {
  backgroundColor: "var(--n-scrollbar-color-hover)"
})])])])])]);
const xhe = Object.assign(Object.assign({}, ft.props), {
  size: {
    type: Number,
    default: 5
  },
  duration: {
    type: Number,
    default: 0
  },
  scrollable: {
    type: Boolean,
    default: !0
  },
  xScrollable: Boolean,
  trigger: {
    type: String,
    default: "hover"
  },
  useUnifiedContainer: Boolean,
  triggerDisplayManually: Boolean,
  container: Function,
  content: Function,
  containerClass: String,
  containerStyle: [String, Object],
  contentClass: String,
  contentStyle: [String, Object],
  horizontalRailStyle: [String, Object],
  verticalRailStyle: [String, Object],
  onScroll: Function,
  onWheel: Function,
  onResize: Function,
  internalOnUpdateScrollLeft: Function,
  internalHoistYRail: Boolean
}), aH = oe({
  name: "Scrollbar",
  props: xhe,
  inheritAttrs: !1,
  setup(e) {
    const { mergedClsPrefixRef: t, inlineThemeDisabled: r, mergedRtlRef: n } = Yt(e), i = Li("Scrollbar", n, t), o = G(null), a = G(null), s = G(null), u = G(null), d = G(null), f = G(null), h = G(null), g = G(null), m = G(null), v = G(null), w = G(null), x = G(0), y = G(0), C = G(!1), S = G(!1);
    let T = !1, A = !1, D, E, N = 0, I = 0, $ = 0, _ = 0;
    const R = wX(), U = j(() => {
      const { value: ne } = g, { value: Se } = f, { value: _e } = v;
      return ne === null || Se === null || _e === null ? 0 : Math.min(ne, _e * ne / Se + e.size * 1.5);
    }), Q = j(() => `${U.value}px`), Z = j(() => {
      const { value: ne } = m, { value: Se } = h, { value: _e } = w;
      return ne === null || Se === null || _e === null ? 0 : _e * ne / Se + e.size * 1.5;
    }), X = j(() => `${Z.value}px`), re = j(() => {
      const { value: ne } = g, { value: Se } = x, { value: _e } = f, { value: ut } = v;
      if (ne === null || _e === null || ut === null)
        return 0;
      {
        const ht = _e - ne;
        return ht ? Se / ht * (ut - U.value) : 0;
      }
    }), ue = j(() => `${re.value}px`), he = j(() => {
      const { value: ne } = m, { value: Se } = y, { value: _e } = h, { value: ut } = w;
      if (ne === null || _e === null || ut === null)
        return 0;
      {
        const ht = _e - ne;
        return ht ? Se / ht * (ut - Z.value) : 0;
      }
    }), te = j(() => `${he.value}px`), de = j(() => {
      const { value: ne } = g, { value: Se } = f;
      return ne !== null && Se !== null && Se > ne;
    }), De = j(() => {
      const { value: ne } = m, { value: Se } = h;
      return ne !== null && Se !== null && Se > ne;
    }), Oe = j(() => {
      const { trigger: ne } = e;
      return ne === "none" || C.value;
    }), Qe = j(() => {
      const { trigger: ne } = e;
      return ne === "none" || S.value;
    }), Ae = j(() => {
      const { container: ne } = e;
      return ne ? ne() : a.value;
    }), Ne = j(() => {
      const { content: ne } = e;
      return ne ? ne() : s.value;
    }), $e = vJ(() => {
      e.container || Ee({
        top: x.value,
        left: y.value
      });
    }), et = () => {
      $e.isDeactivated || ke();
    }, Ge = (ne) => {
      if ($e.isDeactivated)
        return;
      const { onResize: Se } = e;
      Se && Se(ne), ke();
    }, Ee = (ne, Se) => {
      if (!e.scrollable)
        return;
      if (typeof ne == "number") {
        Ue(Se ?? 0, ne, 0, !1, "auto");
        return;
      }
      const { left: _e, top: ut, index: ht, elSize: ye, position: Ze, behavior: st, el: Nt, debounce: Te = !0 } = ne;
      (_e !== void 0 || ut !== void 0) && Ue(_e ?? 0, ut ?? 0, 0, !1, st), Nt !== void 0 ? Ue(0, Nt.offsetTop, Nt.offsetHeight, Te, st) : ht !== void 0 && ye !== void 0 ? Ue(0, ht * ye, ye, Te, st) : Ze === "bottom" ? Ue(0, Number.MAX_SAFE_INTEGER, 0, !1, st) : Ze === "top" && Ue(0, 0, 0, !1, st);
    }, qe = (ne, Se) => {
      if (!e.scrollable)
        return;
      const { value: _e } = Ae;
      _e && (typeof ne == "object" ? _e.scrollBy(ne) : _e.scrollBy(ne, Se || 0));
    };
    function Ue(ne, Se, _e, ut, ht) {
      const { value: ye } = Ae;
      if (ye) {
        if (ut) {
          const { scrollTop: Ze, offsetHeight: st } = ye;
          if (Se > Ze) {
            Se + _e <= Ze + st || ye.scrollTo({
              left: ne,
              top: Se + _e - st,
              behavior: ht
            });
            return;
          }
        }
        ye.scrollTo({
          left: ne,
          top: Se,
          behavior: ht
        });
      }
    }
    function ot() {
      H(), se(), ke();
    }
    function Ie() {
      rt();
    }
    function rt() {
      W(), P();
    }
    function W() {
      E !== void 0 && window.clearTimeout(E), E = window.setTimeout(() => {
        S.value = !1;
      }, e.duration);
    }
    function P() {
      D !== void 0 && window.clearTimeout(D), D = window.setTimeout(() => {
        C.value = !1;
      }, e.duration);
    }
    function H() {
      D !== void 0 && window.clearTimeout(D), C.value = !0;
    }
    function se() {
      E !== void 0 && window.clearTimeout(E), S.value = !0;
    }
    function pe(ne) {
      const { onScroll: Se } = e;
      Se && Se(ne), ae();
    }
    function ae() {
      const { value: ne } = Ae;
      ne && (x.value = ne.scrollTop, y.value = ne.scrollLeft * (i != null && i.value ? -1 : 1));
    }
    function Me() {
      const { value: ne } = Ne;
      ne && (f.value = ne.offsetHeight, h.value = ne.offsetWidth);
      const { value: Se } = Ae;
      Se && (g.value = Se.offsetHeight, m.value = Se.offsetWidth);
      const { value: _e } = d, { value: ut } = u;
      _e && (w.value = _e.offsetWidth), ut && (v.value = ut.offsetHeight);
    }
    function fe() {
      const { value: ne } = Ae;
      ne && (x.value = ne.scrollTop, y.value = ne.scrollLeft * (i != null && i.value ? -1 : 1), g.value = ne.offsetHeight, m.value = ne.offsetWidth, f.value = ne.scrollHeight, h.value = ne.scrollWidth);
      const { value: Se } = d, { value: _e } = u;
      Se && (w.value = Se.offsetWidth), _e && (v.value = _e.offsetHeight);
    }
    function ke() {
      e.scrollable && (e.useUnifiedContainer ? fe() : (Me(), ae()));
    }
    function Le(ne) {
      var Se;
      return !(!((Se = o.value) === null || Se === void 0) && Se.contains(Ul(ne)));
    }
    function dt(ne) {
      ne.preventDefault(), ne.stopPropagation(), A = !0, Mr("mousemove", window, Mt, !0), Mr("mouseup", window, Ct, !0), I = y.value, $ = i != null && i.value ? window.innerWidth - ne.clientX : ne.clientX;
    }
    function Mt(ne) {
      if (!A)
        return;
      D !== void 0 && window.clearTimeout(D), E !== void 0 && window.clearTimeout(E);
      const { value: Se } = m, { value: _e } = h, { value: ut } = Z;
      if (Se === null || _e === null)
        return;
      const ye = (i != null && i.value ? window.innerWidth - ne.clientX - $ : ne.clientX - $) * (_e - Se) / (Se - ut), Ze = _e - Se;
      let st = I + ye;
      st = Math.min(Ze, st), st = Math.max(st, 0);
      const { value: Nt } = Ae;
      if (Nt) {
        Nt.scrollLeft = st * (i != null && i.value ? -1 : 1);
        const { internalOnUpdateScrollLeft: Te } = e;
        Te && Te(st);
      }
    }
    function Ct(ne) {
      ne.preventDefault(), ne.stopPropagation(), hr("mousemove", window, Mt, !0), hr("mouseup", window, Ct, !0), A = !1, ke(), Le(ne) && rt();
    }
    function er(ne) {
      ne.preventDefault(), ne.stopPropagation(), T = !0, Mr("mousemove", window, Vt, !0), Mr("mouseup", window, jt, !0), N = x.value, _ = ne.clientY;
    }
    function Vt(ne) {
      if (!T)
        return;
      D !== void 0 && window.clearTimeout(D), E !== void 0 && window.clearTimeout(E);
      const { value: Se } = g, { value: _e } = f, { value: ut } = U;
      if (Se === null || _e === null)
        return;
      const ye = (ne.clientY - _) * (_e - Se) / (Se - ut), Ze = _e - Se;
      let st = N + ye;
      st = Math.min(Ze, st), st = Math.max(st, 0);
      const { value: Nt } = Ae;
      Nt && (Nt.scrollTop = st);
    }
    function jt(ne) {
      ne.preventDefault(), ne.stopPropagation(), hr("mousemove", window, Vt, !0), hr("mouseup", window, jt, !0), T = !1, ke(), Le(ne) && rt();
    }
    On(() => {
      const { value: ne } = De, { value: Se } = de, { value: _e } = t, { value: ut } = d, { value: ht } = u;
      ut && (ne ? ut.classList.remove(`${_e}-scrollbar-rail--disabled`) : ut.classList.add(`${_e}-scrollbar-rail--disabled`)), ht && (Se ? ht.classList.remove(`${_e}-scrollbar-rail--disabled`) : ht.classList.add(`${_e}-scrollbar-rail--disabled`));
    }), br(() => {
      e.container || ke();
    }), Gr(() => {
      D !== void 0 && window.clearTimeout(D), E !== void 0 && window.clearTimeout(E), hr("mousemove", window, Vt, !0), hr("mouseup", window, jt, !0);
    });
    const at = ft("Scrollbar", "-scrollbar", yhe, Rc, e, t), St = j(() => {
      const { common: { cubicBezierEaseInOut: ne, scrollbarBorderRadius: Se, scrollbarHeight: _e, scrollbarWidth: ut }, self: { color: ht, colorHover: ye } } = at.value;
      return {
        "--n-scrollbar-bezier": ne,
        "--n-scrollbar-color": ht,
        "--n-scrollbar-color-hover": ye,
        "--n-scrollbar-border-radius": Se,
        "--n-scrollbar-width": ut,
        "--n-scrollbar-height": _e
      };
    }), ve = r ? Cr("scrollbar", void 0, St, e) : void 0;
    return Object.assign(Object.assign({}, {
      scrollTo: Ee,
      scrollBy: qe,
      sync: ke,
      syncUnifiedContainer: fe,
      handleMouseEnterWrapper: ot,
      handleMouseLeaveWrapper: Ie
    }), {
      mergedClsPrefix: t,
      rtlEnabled: i,
      containerScrollTop: x,
      wrapperRef: o,
      containerRef: a,
      contentRef: s,
      yRailRef: u,
      xRailRef: d,
      needYBar: de,
      needXBar: De,
      yBarSizePx: Q,
      xBarSizePx: X,
      yBarTopPx: ue,
      xBarLeftPx: te,
      isShowXBar: Oe,
      isShowYBar: Qe,
      isIos: R,
      handleScroll: pe,
      handleContentResize: et,
      handleContainerResize: Ge,
      handleYScrollMouseDown: er,
      handleXScrollMouseDown: dt,
      cssVars: r ? void 0 : St,
      themeClass: ve == null ? void 0 : ve.themeClass,
      onRender: ve == null ? void 0 : ve.onRender
    });
  },
  render() {
    var e;
    const { $slots: t, mergedClsPrefix: r, triggerDisplayManually: n, rtlEnabled: i, internalHoistYRail: o } = this;
    if (!this.scrollable)
      return (e = t.default) === null || e === void 0 ? void 0 : e.call(t);
    const a = this.trigger === "none", s = () => b("div", { ref: "yRailRef", class: [
      `${r}-scrollbar-rail`,
      `${r}-scrollbar-rail--vertical`
    ], "data-scrollbar-rail": !0, style: this.verticalRailStyle, "aria-hidden": !0 }, b(a ? iz : jn, a ? null : { name: "fade-in-transition" }, {
      default: () => this.needYBar && this.isShowYBar && !this.isIos ? b("div", { class: `${r}-scrollbar-rail__scrollbar`, style: {
        height: this.yBarSizePx,
        top: this.yBarTopPx
      }, onMousedown: this.handleYScrollMouseDown }) : null
    })), u = () => {
      var f, h;
      return (f = this.onRender) === null || f === void 0 || f.call(this), b("div", ir(this.$attrs, {
        role: "none",
        ref: "wrapperRef",
        class: [
          `${r}-scrollbar`,
          this.themeClass,
          i && `${r}-scrollbar--rtl`
        ],
        style: this.cssVars,
        onMouseenter: n ? void 0 : this.handleMouseEnterWrapper,
        onMouseleave: n ? void 0 : this.handleMouseLeaveWrapper
      }), [
        this.container ? (h = t.default) === null || h === void 0 ? void 0 : h.call(t) : b("div", { role: "none", ref: "containerRef", class: [
          `${r}-scrollbar-container`,
          this.containerClass
        ], style: this.containerStyle, onScroll: this.handleScroll, onWheel: this.onWheel }, b(Hl, { onResize: this.handleContentResize }, {
          default: () => b("div", { ref: "contentRef", role: "none", style: [
            {
              width: this.xScrollable ? "fit-content" : null
            },
            this.contentStyle
          ], class: [
            `${r}-scrollbar-content`,
            this.contentClass
          ] }, t)
        })),
        o ? null : s(),
        this.xScrollable && b("div", { ref: "xRailRef", class: [
          `${r}-scrollbar-rail`,
          `${r}-scrollbar-rail--horizontal`
        ], style: this.horizontalRailStyle, "data-scrollbar-rail": !0, "aria-hidden": !0 }, b(a ? iz : jn, a ? null : { name: "fade-in-transition" }, {
          default: () => this.needXBar && this.isShowXBar && !this.isIos ? b("div", { class: `${r}-scrollbar-rail__scrollbar`, style: {
            width: this.xBarSizePx,
            right: i ? this.xBarLeftPx : void 0,
            left: i ? void 0 : this.xBarLeftPx
          }, onMousedown: this.handleXScrollMouseDown }) : null
        }))
      ]);
    }, d = this.container ? u() : b(Hl, { onResize: this.handleContainerResize }, {
      default: u
    });
    return o ? b(Lr, null, d, s()) : d;
  }
});
var no = aH;
const lH = aH;
var whe = {
  height: "calc(var(--n-option-height) * 7.6)",
  paddingSmall: "4px 0",
  paddingMedium: "4px 0",
  paddingLarge: "4px 0",
  paddingHuge: "4px 0",
  optionPaddingSmall: "0 12px",
  optionPaddingMedium: "0 12px",
  optionPaddingLarge: "0 12px",
  optionPaddingHuge: "0 12px",
  loadingSize: "18px"
};
const Mhe = (e) => {
  const { borderRadius: t, popoverColor: r, textColor3: n, dividerColor: i, textColor2: o, primaryColorPressed: a, textColorDisabled: s, primaryColor: u, opacityDisabled: d, hoverColor: f, fontSizeSmall: h, fontSizeMedium: g, fontSizeLarge: m, fontSizeHuge: v, heightSmall: w, heightMedium: x, heightLarge: y, heightHuge: C } = e;
  return Object.assign(Object.assign({}, whe), { optionFontSizeSmall: h, optionFontSizeMedium: g, optionFontSizeLarge: m, optionFontSizeHuge: v, optionHeightSmall: w, optionHeightMedium: x, optionHeightLarge: y, optionHeightHuge: C, borderRadius: t, color: r, groupHeaderTextColor: n, actionDividerColor: i, optionTextColor: o, optionTextColorPressed: a, optionTextColorDisabled: s, optionTextColorActive: u, optionOpacityDisabled: d, optionCheckColor: u, optionColorPending: f, optionColorActive: "rgba(0, 0, 0, 0)", optionColorActivePending: f, actionTextColor: o, loadingColor: u });
}, Che = {
  name: "InternalSelectMenu",
  common: Sr,
  peers: {
    Scrollbar: Rc,
    Empty: C4
  },
  self: Mhe
};
var S4 = Che;
function She(e, t) {
  return b(jn, { name: "fade-in-scale-up-transition" }, {
    default: () => e ? b(fr, { clsPrefix: t, class: `${t}-base-select-option__check` }, {
      default: () => b(X7)
    }) : null
  });
}
var _P = oe({
  name: "NBaseSelectOption",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    tmNode: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const {
      valueRef: t,
      pendingTmNodeRef: r,
      multipleRef: n,
      valueSetRef: i,
      renderLabelRef: o,
      renderOptionRef: a,
      labelFieldRef: s,
      valueFieldRef: u,
      showCheckmarkRef: d,
      nodePropsRef: f,
      handleOptionClick: h,
      handleOptionMouseEnter: g
    } = lt(XO), m = _r(() => {
      const { value: y } = r;
      return y ? e.tmNode.key === y.key : !1;
    });
    function v(y) {
      const { tmNode: C } = e;
      C.disabled || h(y, C);
    }
    function w(y) {
      const { tmNode: C } = e;
      C.disabled || g(y, C);
    }
    function x(y) {
      const { tmNode: C } = e, { value: S } = m;
      C.disabled || S || g(y, C);
    }
    return {
      multiple: n,
      isGrouped: _r(() => {
        const { tmNode: y } = e, { parent: C } = y;
        return C && C.rawNode.type === "group";
      }),
      showCheckmark: d,
      nodeProps: f,
      isPending: m,
      isSelected: _r(() => {
        const { value: y } = t, { value: C } = n;
        if (y === null)
          return !1;
        const S = e.tmNode.rawNode[u.value];
        if (C) {
          const { value: T } = i;
          return T.has(S);
        } else
          return y === S;
      }),
      labelField: s,
      renderLabel: o,
      renderOption: a,
      handleMouseMove: x,
      handleMouseEnter: w,
      handleClick: v
    };
  },
  render() {
    const { clsPrefix: e, tmNode: { rawNode: t }, isSelected: r, isPending: n, isGrouped: i, showCheckmark: o, nodeProps: a, renderOption: s, renderLabel: u, handleClick: d, handleMouseEnter: f, handleMouseMove: h } = this, g = She(r, e), m = u ? [u(t, r), o && g] : [
      xn(t[this.labelField], t, r),
      o && g
    ], v = a == null ? void 0 : a(t), w = b("div", Object.assign({}, v, { class: [
      `${e}-base-select-option`,
      t.class,
      v == null ? void 0 : v.class,
      {
        [`${e}-base-select-option--disabled`]: t.disabled,
        [`${e}-base-select-option--selected`]: r,
        [`${e}-base-select-option--grouped`]: i,
        [`${e}-base-select-option--pending`]: n,
        [`${e}-base-select-option--show-checkmark`]: o
      }
    ], style: [(v == null ? void 0 : v.style) || "", t.style || ""], onClick: Gv([d, v == null ? void 0 : v.onClick]), onMouseenter: Gv([
      f,
      v == null ? void 0 : v.onMouseenter
    ]), onMousemove: Gv([h, v == null ? void 0 : v.onMousemove]) }), b("div", { class: `${e}-base-select-option__content` }, m));
    return t.render ? t.render({ node: w, option: t, selected: r }) : s ? s({ node: w, option: t, selected: r }) : w;
  }
}), LP = oe({
  name: "NBaseSelectGroupHeader",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    tmNode: {
      type: Object,
      required: !0
    }
  },
  setup() {
    const {
      renderLabelRef: e,
      renderOptionRef: t,
      labelFieldRef: r,
      nodePropsRef: n
    } = lt(XO);
    return {
      labelField: r,
      nodeProps: n,
      renderLabel: e,
      renderOption: t
    };
  },
  render() {
    const { clsPrefix: e, renderLabel: t, renderOption: r, nodeProps: n, tmNode: { rawNode: i } } = this, o = n == null ? void 0 : n(i), a = t ? t(i, !1) : xn(i[this.labelField], i, !1), s = b("div", Object.assign({}, o, { class: [`${e}-base-select-group-header`, o == null ? void 0 : o.class] }), a);
    return i.render ? i.render({ node: s, option: i }) : r ? r({ node: s, option: i, selected: !1 }) : s;
  }
});
const {
  cubicBezierEaseIn: PP,
  cubicBezierEaseOut: RP
} = Wa;
function Fa({
  transformOrigin: e = "inherit",
  duration: t = ".2s",
  enterScale: r = ".9",
  originalTransform: n = "",
  originalTransition: i = ""
} = {}) {
  return [Y("&.fade-in-scale-up-transition-leave-active", {
    transformOrigin: e,
    transition: `opacity ${t} ${PP}, transform ${t} ${PP} ${i && "," + i}`
  }), Y("&.fade-in-scale-up-transition-enter-active", {
    transformOrigin: e,
    transition: `opacity ${t} ${RP}, transform ${t} ${RP} ${i && "," + i}`
  }), Y("&.fade-in-scale-up-transition-enter-from, &.fade-in-scale-up-transition-leave-to", {
    opacity: 0,
    transform: `${n} scale(${r})`
  }), Y("&.fade-in-scale-up-transition-leave-from, &.fade-in-scale-up-transition-enter-to", {
    opacity: 1,
    transform: `${n} scale(1)`
  })];
}
var The = L("base-select-menu", `
 line-height: 1.5;
 outline: none;
 z-index: 0;
 position: relative;
 border-radius: var(--n-border-radius);
 transition:
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 background-color: var(--n-color);
`, [L("scrollbar", `
 max-height: var(--n-height);
 `), L("virtual-list", `
 max-height: var(--n-height);
 `), L("base-select-option", `
 min-height: var(--n-option-height);
 font-size: var(--n-option-font-size);
 display: flex;
 align-items: center;
 `, [q("content", `
 z-index: 1;
 white-space: nowrap;
 text-overflow: ellipsis;
 overflow: hidden;
 `)]), L("base-select-group-header", `
 min-height: var(--n-option-height);
 font-size: .93em;
 display: flex;
 align-items: center;
 `), L("base-select-menu-option-wrapper", `
 position: relative;
 width: 100%;
 `), q("loading, empty", `
 display: flex;
 padding: 12px 32px;
 flex: 1;
 justify-content: center;
 `), q("loading", `
 color: var(--n-loading-color);
 font-size: var(--n-loading-size);
 `), q("action", `
 padding: 8px var(--n-option-padding-left);
 font-size: var(--n-option-font-size);
 transition: 
 color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 border-top: 1px solid var(--n-action-divider-color);
 color: var(--n-action-text-color);
 `), L("base-select-group-header", `
 position: relative;
 cursor: default;
 padding: var(--n-option-padding);
 color: var(--n-group-header-text-color);
 `), L("base-select-option", `
 cursor: pointer;
 position: relative;
 padding: var(--n-option-padding);
 transition:
 color .3s var(--n-bezier),
 opacity .3s var(--n-bezier);
 box-sizing: border-box;
 color: var(--n-option-text-color);
 opacity: 1;
 `, [K("show-checkmark", `
 padding-right: calc(var(--n-option-padding-right) + 20px);
 `), Y("&::before", `
 content: "";
 position: absolute;
 left: 4px;
 right: 4px;
 top: 0;
 bottom: 0;
 border-radius: var(--n-border-radius);
 transition: background-color .3s var(--n-bezier);
 `), Y("&:active", `
 color: var(--n-option-text-color-pressed);
 `), K("grouped", `
 padding-left: calc(var(--n-option-padding-left) * 1.5);
 `), K("pending", [Y("&::before", `
 background-color: var(--n-option-color-pending);
 `)]), K("selected", `
 color: var(--n-option-text-color-active);
 `, [Y("&::before", `
 background-color: var(--n-option-color-active);
 `), K("pending", [Y("&::before", `
 background-color: var(--n-option-color-active-pending);
 `)])]), K("disabled", `
 cursor: not-allowed;
 `, [wr("selected", `
 color: var(--n-option-text-color-disabled);
 `), K("selected", `
 opacity: var(--n-option-opacity-disabled);
 `)]), q("check", `
 font-size: 16px;
 position: absolute;
 right: calc(var(--n-option-padding-right) - 4px);
 top: calc(50% - 7px);
 color: var(--n-option-check-color);
 transition: color .3s var(--n-bezier);
 `, [Fa({
  enterScale: "0.5"
})])])]), sH = oe({
  name: "InternalSelectMenu",
  props: Object.assign(Object.assign({}, ft.props), {
    clsPrefix: {
      type: String,
      required: !0
    },
    scrollable: {
      type: Boolean,
      default: !0
    },
    treeMate: {
      type: Object,
      required: !0
    },
    multiple: Boolean,
    size: {
      type: String,
      default: "medium"
    },
    value: {
      type: [String, Number, Array],
      default: null
    },
    autoPending: Boolean,
    virtualScroll: {
      type: Boolean,
      default: !0
    },
    show: {
      type: Boolean,
      default: !0
    },
    labelField: {
      type: String,
      default: "label"
    },
    valueField: {
      type: String,
      default: "value"
    },
    loading: Boolean,
    focusable: Boolean,
    renderLabel: Function,
    renderOption: Function,
    nodeProps: Function,
    showCheckmark: { type: Boolean, default: !0 },
    onMousedown: Function,
    onScroll: Function,
    onFocus: Function,
    onBlur: Function,
    onKeyup: Function,
    onKeydown: Function,
    onTabOut: Function,
    onMouseenter: Function,
    onMouseleave: Function,
    onResize: Function,
    resetMenuOnOptionsChange: {
      type: Boolean,
      default: !0
    },
    inlineThemeDisabled: Boolean,
    onToggle: Function
  }),
  setup(e) {
    const t = ft("InternalSelectMenu", "-internal-select-menu", The, S4, e, tt(e, "clsPrefix")), r = G(null), n = G(null), i = G(null), o = j(() => e.treeMate.getFlattenedNodes()), a = j(() => Zfe(o.value)), s = G(null);
    function u() {
      const { treeMate: he } = e;
      let te = null;
      const { value: de } = e;
      de === null ? te = he.getFirstAvailableNode() : (e.multiple ? te = he.getNode((de || [])[(de || []).length - 1]) : te = he.getNode(de), (!te || te.disabled) && (te = he.getFirstAvailableNode())), _(te || null);
    }
    function d() {
      const { value: he } = s;
      he && !e.treeMate.getNode(he.key) && (s.value = null);
    }
    let f;
    Gt(() => e.show, (he) => {
      he ? f = Gt(() => e.treeMate, () => {
        e.resetMenuOnOptionsChange ? (e.autoPending ? u() : d(), an(R)) : d();
      }, {
        immediate: !0
      }) : f == null || f();
    }, {
      immediate: !0
    }), Gr(() => {
      f == null || f();
    });
    const h = j(() => wo(t.value.self[Be("optionHeight", e.size)])), g = j(() => Ll(t.value.self[Be("padding", e.size)])), m = j(() => e.multiple && Array.isArray(e.value) ? new Set(e.value) : /* @__PURE__ */ new Set()), v = j(() => {
      const he = o.value;
      return he && he.length === 0;
    });
    function w(he) {
      const { onToggle: te } = e;
      te && te(he);
    }
    function x(he) {
      const { onScroll: te } = e;
      te && te(he);
    }
    function y(he) {
      var te;
      (te = i.value) === null || te === void 0 || te.sync(), x(he);
    }
    function C() {
      var he;
      (he = i.value) === null || he === void 0 || he.sync();
    }
    function S() {
      const { value: he } = s;
      return he || null;
    }
    function T(he, te) {
      te.disabled || _(te, !1);
    }
    function A(he, te) {
      te.disabled || w(te);
    }
    function D(he) {
      var te;
      Bl(he, "action") || (te = e.onKeyup) === null || te === void 0 || te.call(e, he);
    }
    function E(he) {
      var te;
      Bl(he, "action") || (te = e.onKeydown) === null || te === void 0 || te.call(e, he);
    }
    function N(he) {
      var te;
      (te = e.onMousedown) === null || te === void 0 || te.call(e, he), !e.focusable && he.preventDefault();
    }
    function I() {
      const { value: he } = s;
      he && _(he.getNext({ loop: !0 }), !0);
    }
    function $() {
      const { value: he } = s;
      he && _(he.getPrev({ loop: !0 }), !0);
    }
    function _(he, te = !1) {
      s.value = he, te && R();
    }
    function R() {
      var he, te;
      const de = s.value;
      if (!de)
        return;
      const De = a.value(de.key);
      De !== null && (e.virtualScroll ? (he = n.value) === null || he === void 0 || he.scrollTo({ index: De }) : (te = i.value) === null || te === void 0 || te.scrollTo({
        index: De,
        elSize: h.value
      }));
    }
    function U(he) {
      var te, de;
      !((te = r.value) === null || te === void 0) && te.contains(he.target) && ((de = e.onFocus) === null || de === void 0 || de.call(e, he));
    }
    function Q(he) {
      var te, de;
      !((te = r.value) === null || te === void 0) && te.contains(he.relatedTarget) || (de = e.onBlur) === null || de === void 0 || de.call(e, he);
    }
    tr(XO, {
      handleOptionMouseEnter: T,
      handleOptionClick: A,
      valueSetRef: m,
      pendingTmNodeRef: s,
      nodePropsRef: tt(e, "nodeProps"),
      showCheckmarkRef: tt(e, "showCheckmark"),
      multipleRef: tt(e, "multiple"),
      valueRef: tt(e, "value"),
      renderLabelRef: tt(e, "renderLabel"),
      renderOptionRef: tt(e, "renderOption"),
      labelFieldRef: tt(e, "labelField"),
      valueFieldRef: tt(e, "valueField")
    }), tr(TU, r), br(() => {
      const { value: he } = i;
      he && he.sync();
    });
    const Z = j(() => {
      const { size: he } = e, { common: { cubicBezierEaseInOut: te }, self: { height: de, borderRadius: De, color: Oe, groupHeaderTextColor: Qe, actionDividerColor: Ae, optionTextColorPressed: Ne, optionTextColor: $e, optionTextColorDisabled: et, optionTextColorActive: Ge, optionOpacityDisabled: Ee, optionCheckColor: qe, actionTextColor: Ue, optionColorPending: ot, optionColorActive: Ie, loadingColor: rt, loadingSize: W, optionColorActivePending: P, [Be("optionFontSize", he)]: H, [Be("optionHeight", he)]: se, [Be("optionPadding", he)]: pe } } = t.value;
      return {
        "--n-height": de,
        "--n-action-divider-color": Ae,
        "--n-action-text-color": Ue,
        "--n-bezier": te,
        "--n-border-radius": De,
        "--n-color": Oe,
        "--n-option-font-size": H,
        "--n-group-header-text-color": Qe,
        "--n-option-check-color": qe,
        "--n-option-color-pending": ot,
        "--n-option-color-active": Ie,
        "--n-option-color-active-pending": P,
        "--n-option-height": se,
        "--n-option-opacity-disabled": Ee,
        "--n-option-text-color": $e,
        "--n-option-text-color-active": Ge,
        "--n-option-text-color-disabled": et,
        "--n-option-text-color-pressed": Ne,
        "--n-option-padding": pe,
        "--n-option-padding-left": Ll(pe, "left"),
        "--n-option-padding-right": Ll(pe, "right"),
        "--n-loading-color": rt,
        "--n-loading-size": W
      };
    }), { inlineThemeDisabled: X } = e, re = X ? Cr("internal-select-menu", j(() => e.size[0]), Z, e) : void 0, ue = {
      selfRef: r,
      next: I,
      prev: $,
      getPendingTmNode: S
    };
    return BU(r, e.onResize), Object.assign({
      mergedTheme: t,
      virtualListRef: n,
      scrollbarRef: i,
      itemSize: h,
      padding: g,
      flattenedNodes: o,
      empty: v,
      virtualListContainer() {
        const { value: he } = n;
        return he == null ? void 0 : he.listElRef;
      },
      virtualListContent() {
        const { value: he } = n;
        return he == null ? void 0 : he.itemsElRef;
      },
      doScroll: x,
      handleFocusin: U,
      handleFocusout: Q,
      handleKeyUp: D,
      handleKeyDown: E,
      handleMouseDown: N,
      handleVirtualListResize: C,
      handleVirtualListScroll: y,
      cssVars: X ? void 0 : Z,
      themeClass: re == null ? void 0 : re.themeClass,
      onRender: re == null ? void 0 : re.onRender
    }, ue);
  },
  render() {
    const { $slots: e, virtualScroll: t, clsPrefix: r, mergedTheme: n, themeClass: i, onRender: o } = this;
    return o == null || o(), b("div", { ref: "selfRef", tabindex: this.focusable ? 0 : -1, class: [
      `${r}-base-select-menu`,
      i,
      this.multiple && `${r}-base-select-menu--multiple`
    ], style: this.cssVars, onFocusin: this.handleFocusin, onFocusout: this.handleFocusout, onKeyup: this.handleKeyUp, onKeydown: this.handleKeyDown, onMousedown: this.handleMouseDown, onMouseenter: this.onMouseenter, onMouseleave: this.onMouseleave }, this.loading ? b("div", { class: `${r}-base-select-menu__loading` }, b(mh, { clsPrefix: r, strokeWidth: 20 })) : this.empty ? b("div", { class: `${r}-base-select-menu__empty`, "data-empty": !0 }, vr(e.empty, () => [
      b(oH, { theme: n.peers.Empty, themeOverrides: n.peerOverrides.Empty })
    ])) : b(no, { ref: "scrollbarRef", theme: n.peers.Scrollbar, themeOverrides: n.peerOverrides.Scrollbar, scrollable: this.scrollable, container: t ? this.virtualListContainer : void 0, content: t ? this.virtualListContent : void 0, onScroll: t ? void 0 : this.doScroll }, {
      default: () => t ? b(M0, { ref: "virtualListRef", class: `${r}-virtual-list`, items: this.flattenedNodes, itemSize: this.itemSize, showScrollbar: !1, paddingTop: this.padding.top, paddingBottom: this.padding.bottom, onResize: this.handleVirtualListResize, onScroll: this.handleVirtualListScroll, itemResizable: !0 }, {
        default: ({ item: a }) => a.isGroup ? b(LP, { key: a.key, clsPrefix: r, tmNode: a }) : a.ignored ? null : b(_P, { clsPrefix: r, key: a.key, tmNode: a })
      }) : b("div", { class: `${r}-base-select-menu-option-wrapper`, style: {
        paddingTop: this.padding.top,
        paddingBottom: this.padding.bottom
      } }, this.flattenedNodes.map((a) => a.isGroup ? b(LP, { key: a.key, clsPrefix: r, tmNode: a }) : b(_P, { clsPrefix: r, key: a.key, tmNode: a })))
    }), Fr(e.action, (a) => a && [
      b("div", { class: `${r}-base-select-menu__action`, "data-action": !0, key: "action" }, a),
      b(Pc, { onFocus: this.onTabOut, key: "focus-detector" })
    ]));
  }
}), khe = L("base-wave", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border-radius: inherit;
`), uH = oe({
  name: "BaseWave",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    Vu("-base-wave", khe, tt(e, "clsPrefix"));
    const t = G(null), r = G(!1);
    let n = null;
    return Gr(() => {
      n !== null && window.clearTimeout(n);
    }), {
      active: r,
      selfRef: t,
      play() {
        n !== null && (window.clearTimeout(n), r.value = !1, n = null), an(() => {
          var i;
          (i = t.value) === null || i === void 0 || i.offsetHeight, r.value = !0, n = window.setTimeout(() => {
            r.value = !1, n = null;
          }, 1e3);
        });
      }
    };
  },
  render() {
    const { clsPrefix: e } = this;
    return b("div", { ref: "selfRef", "aria-hidden": !0, class: [
      `${e}-base-wave`,
      this.active && `${e}-base-wave--active`
    ] });
  }
}), Dhe = {
  space: "6px",
  spaceArrow: "10px",
  arrowOffset: "10px",
  arrowOffsetVertical: "10px",
  arrowHeight: "6px",
  padding: "8px 14px"
};
const Ahe = (e) => {
  const { boxShadow2: t, popoverColor: r, textColor2: n, borderRadius: i, fontSize: o, dividerColor: a } = e;
  return Object.assign(Object.assign({}, Dhe), {
    fontSize: o,
    borderRadius: i,
    color: r,
    dividerColor: a,
    textColor: n,
    boxShadow: t
  });
}, Ehe = {
  name: "Popover",
  common: Sr,
  self: Ahe
};
var Vp = Ehe;
const jI = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, Qi = "var(--n-arrow-height) * 1.414";
var Ihe = Y([L("popover", `
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 position: relative;
 font-size: var(--n-font-size);
 color: var(--n-text-color);
 box-shadow: var(--n-box-shadow);
 word-break: break-word;
 `, [Y(">", [L("scrollbar", `
 height: inherit;
 max-height: inherit;
 `)]), wr("raw", `
 background-color: var(--n-color);
 border-radius: var(--n-border-radius);
 `, [wr("scrollable", [wr("show-header-or-footer", "padding: var(--n-padding);")])]), q("header", `
 padding: var(--n-padding);
 border-bottom: 1px solid var(--n-divider-color);
 transition: border-color .3s var(--n-bezier);
 `), q("footer", `
 padding: var(--n-padding);
 border-top: 1px solid var(--n-divider-color);
 transition: border-color .3s var(--n-bezier);
 `), K("scrollable, show-header-or-footer", [q("content", `
 padding: var(--n-padding);
 `)])]), L("popover-shared", `
 transform-origin: inherit;
 `, [
  L("popover-arrow-wrapper", `
 position: absolute;
 overflow: hidden;
 pointer-events: none;
 `, [L("popover-arrow", `
 transition: background-color .3s var(--n-bezier);
 position: absolute;
 display: block;
 width: calc(${Qi});
 height: calc(${Qi});
 box-shadow: 0 0 8px 0 rgba(0, 0, 0, .12);
 transform: rotate(45deg);
 background-color: var(--n-color);
 pointer-events: all;
 `)]),
  Y("&.popover-transition-enter-from, &.popover-transition-leave-to", `
 opacity: 0;
 transform: scale(.85);
 `),
  Y("&.popover-transition-enter-to, &.popover-transition-leave-from", `
 transform: scale(1);
 opacity: 1;
 `),
  Y("&.popover-transition-enter-active", `
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 opacity .15s var(--n-bezier-ease-out),
 transform .15s var(--n-bezier-ease-out);
 `),
  Y("&.popover-transition-leave-active", `
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 opacity .15s var(--n-bezier-ease-in),
 transform .15s var(--n-bezier-ease-in);
 `)
]), Qa("top-start", `
 top: calc(${Qi} / -2);
 left: calc(${Du("top-start")} - var(--v-offset-left));
 `), Qa("top", `
 top: calc(${Qi} / -2);
 transform: translateX(calc(${Qi} / -2)) rotate(45deg);
 left: 50%;
 `), Qa("top-end", `
 top: calc(${Qi} / -2);
 right: calc(${Du("top-end")} + var(--v-offset-left));
 `), Qa("bottom-start", `
 bottom: calc(${Qi} / -2);
 left: calc(${Du("bottom-start")} - var(--v-offset-left));
 `), Qa("bottom", `
 bottom: calc(${Qi} / -2);
 transform: translateX(calc(${Qi} / -2)) rotate(45deg);
 left: 50%;
 `), Qa("bottom-end", `
 bottom: calc(${Qi} / -2);
 right: calc(${Du("bottom-end")} + var(--v-offset-left));
 `), Qa("left-start", `
 left: calc(${Qi} / -2);
 top: calc(${Du("left-start")} - var(--v-offset-top));
 `), Qa("left", `
 left: calc(${Qi} / -2);
 transform: translateY(calc(${Qi} / -2)) rotate(45deg);
 top: 50%;
 `), Qa("left-end", `
 left: calc(${Qi} / -2);
 bottom: calc(${Du("left-end")} + var(--v-offset-top));
 `), Qa("right-start", `
 right: calc(${Qi} / -2);
 top: calc(${Du("right-start")} - var(--v-offset-top));
 `), Qa("right", `
 right: calc(${Qi} / -2);
 transform: translateY(calc(${Qi} / -2)) rotate(45deg);
 top: 50%;
 `), Qa("right-end", `
 right: calc(${Qi} / -2);
 bottom: calc(${Du("right-end")} + var(--v-offset-top));
 `), ...poe({
  top: ["right-start", "left-start"],
  right: ["top-end", "bottom-end"],
  bottom: ["right-end", "left-end"],
  left: ["top-start", "bottom-start"]
}, (e, t) => {
  const r = ["right", "left"].includes(t), n = r ? "width" : "height";
  return e.map((i) => {
    const o = i.split("-")[1] === "end", s = `calc((${`var(--v-target-${n}, 0px)`} - ${Qi}) / 2)`, u = Du(i);
    return Y(`[v-placement="${i}"] >`, [L("popover-shared", [K("center-arrow", [L("popover-arrow", `${t}: calc(max(${s}, ${u}) ${o ? "+" : "-"} var(--v-offset-${r ? "left" : "top"}));`)])])]);
  });
})]);
function Du(e) {
  return ["top", "bottom"].includes(e.split("-")[0]) ? "var(--n-arrow-offset)" : "var(--n-arrow-offset-vertical)";
}
function Qa(e, t) {
  const r = e.split("-")[0], n = ["top", "bottom"].includes(r) ? "height: var(--n-space-arrow);" : "width: var(--n-space-arrow);";
  return Y(`[v-placement="${e}"] >`, [L("popover-shared", `
 margin-${jI[r]}: var(--n-space);
 `, [K("show-arrow", `
 margin-${jI[r]}: var(--n-space-arrow);
 `), K("overlap", `
 margin: 0;
 `), lX("popover-arrow-wrapper", `
 right: 0;
 left: 0;
 top: 0;
 bottom: 0;
 ${r}: 100%;
 ${jI[r]}: auto;
 ${n}
 `, [L("popover-arrow", t)])])]);
}
const cH = Object.assign(Object.assign({}, ft.props), {
  to: vi.propTo,
  show: Boolean,
  trigger: String,
  showArrow: Boolean,
  delay: Number,
  duration: Number,
  raw: Boolean,
  arrowPointToCenter: Boolean,
  arrowStyle: [String, Object],
  displayDirective: String,
  x: Number,
  y: Number,
  flip: Boolean,
  overlap: Boolean,
  placement: String,
  width: [Number, String],
  keepAliveOnHover: Boolean,
  scrollable: Boolean,
  contentStyle: [Object, String],
  headerStyle: [Object, String],
  footerStyle: [Object, String],
  internalDeactivateImmediately: Boolean,
  animated: Boolean,
  onClickoutside: Function,
  internalTrapFocus: Boolean,
  internalOnAfterLeave: Function,
  minWidth: Number,
  maxWidth: Number
}), dH = ({ arrowStyle: e, clsPrefix: t }) => b("div", { key: "__popover-arrow__", class: `${t}-popover-arrow-wrapper` }, b("div", { class: `${t}-popover-arrow`, style: e }));
var Nhe = oe({
  name: "PopoverBody",
  inheritAttrs: !1,
  props: cH,
  setup(e, { slots: t, attrs: r }) {
    const { namespaceRef: n, mergedClsPrefixRef: i, inlineThemeDisabled: o } = Yt(e), a = ft("Popover", "-popover", Ihe, Vp, e, i), s = G(null), u = lt("NPopover"), d = G(null), f = G(e.show), h = G(!1);
    On(() => {
      const { show: E } = e;
      E && !sX() && !e.internalDeactivateImmediately && (h.value = !0);
    });
    const g = j(() => {
      const { trigger: E, onClickoutside: N } = e, I = [], { positionManuallyRef: { value: $ } } = u;
      return $ || (E === "click" && !N && I.push([
        ks,
        T,
        void 0,
        { capture: !0 }
      ]), E === "hover" && I.push([DX, S])), N && I.push([
        ks,
        T,
        void 0,
        { capture: !0 }
      ]), (e.displayDirective === "show" || e.animated && h.value) && I.push([Ra, e.show]), I;
    }), m = j(() => {
      const E = e.width === "trigger" ? void 0 : Rn(e.width), N = [];
      E && N.push({ width: E });
      const { maxWidth: I, minWidth: $ } = e;
      return I && N.push({ maxWidth: Rn(I) }), $ && N.push({ maxWidth: Rn($) }), o || N.push(v.value), N;
    }), v = j(() => {
      const { common: { cubicBezierEaseInOut: E, cubicBezierEaseIn: N, cubicBezierEaseOut: I }, self: { space: $, spaceArrow: _, padding: R, fontSize: U, textColor: Q, dividerColor: Z, color: X, boxShadow: re, borderRadius: ue, arrowHeight: he, arrowOffset: te, arrowOffsetVertical: de } } = a.value;
      return {
        "--n-box-shadow": re,
        "--n-bezier": E,
        "--n-bezier-ease-in": N,
        "--n-bezier-ease-out": I,
        "--n-font-size": U,
        "--n-text-color": Q,
        "--n-color": X,
        "--n-divider-color": Z,
        "--n-border-radius": ue,
        "--n-arrow-height": he,
        "--n-arrow-offset": te,
        "--n-arrow-offset-vertical": de,
        "--n-padding": R,
        "--n-space": $,
        "--n-space-arrow": _
      };
    }), w = o ? Cr("popover", void 0, v, e) : void 0;
    u.setBodyInstance({
      syncPosition: x
    }), Gr(() => {
      u.setBodyInstance(null);
    }), Gt(tt(e, "show"), (E) => {
      e.animated || (E ? f.value = !0 : f.value = !1);
    });
    function x() {
      var E;
      (E = s.value) === null || E === void 0 || E.syncPosition();
    }
    function y(E) {
      e.trigger === "hover" && e.keepAliveOnHover && e.show && u.handleMouseEnter(E);
    }
    function C(E) {
      e.trigger === "hover" && e.keepAliveOnHover && u.handleMouseLeave(E);
    }
    function S(E) {
      e.trigger === "hover" && !A().contains(Ul(E)) && u.handleMouseMoveOutside(E);
    }
    function T(E) {
      (e.trigger === "click" && !A().contains(Ul(E)) || e.onClickoutside) && u.handleClickOutside(E);
    }
    function A() {
      return u.getTriggerElement();
    }
    tr(Up, d), tr(gb, null), tr(pb, null);
    function D() {
      if (w == null || w.onRender(), !(e.displayDirective === "show" || e.show || e.animated && h.value))
        return null;
      let N;
      const I = u.internalRenderBodyRef.value, { value: $ } = i;
      if (I)
        N = I([
          `${$}-popover-shared`,
          w == null ? void 0 : w.themeClass.value,
          e.overlap && `${$}-popover-shared--overlap`,
          e.showArrow && `${$}-popover-shared--show-arrow`,
          e.arrowPointToCenter && `${$}-popover-shared--center-arrow`
        ], d, m.value, y, C);
      else {
        const { value: _ } = u.extraClassRef, { internalTrapFocus: R } = e, U = !Bf(t.header) || !Bf(t.footer), Q = () => {
          var Z;
          const X = U ? b(Lr, null, Fr(t.header, (he) => he ? b("div", { class: `${$}-popover__header`, style: e.headerStyle }, he) : null), Fr(t.default, (he) => he ? b("div", { class: `${$}-popover__content`, style: e.contentStyle }, t) : null), Fr(t.footer, (he) => he ? b("div", { class: `${$}-popover__footer`, style: e.footerStyle }, he) : null)) : e.scrollable ? (Z = t.default) === null || Z === void 0 ? void 0 : Z.call(t) : b("div", { class: `${$}-popover__content`, style: e.contentStyle }, t), re = e.scrollable ? b(lH, { contentClass: U ? void 0 : `${$}-popover__content`, contentStyle: U ? void 0 : e.contentStyle }, {
            default: () => X
          }) : X, ue = e.showArrow ? dH({
            arrowStyle: e.arrowStyle,
            clsPrefix: $
          }) : null;
          return [re, ue];
        };
        N = b("div", ir({
          class: [
            `${$}-popover`,
            `${$}-popover-shared`,
            w == null ? void 0 : w.themeClass.value,
            _.map((Z) => `${$}-${Z}`),
            {
              [`${$}-popover--scrollable`]: e.scrollable,
              [`${$}-popover--show-header-or-footer`]: U,
              [`${$}-popover--raw`]: e.raw,
              [`${$}-popover-shared--overlap`]: e.overlap,
              [`${$}-popover-shared--show-arrow`]: e.showArrow,
              [`${$}-popover-shared--center-arrow`]: e.arrowPointToCenter
            }
          ],
          ref: d,
          style: m.value,
          onKeydown: u.handleKeydown,
          onMouseenter: y,
          onMouseleave: C
        }, r), R ? b(t4, { active: e.show, autoFocus: !0 }, { default: Q }) : Q());
      }
      return Jn(N, g.value);
    }
    return {
      displayed: h,
      namespace: n,
      isMounted: u.isMountedRef,
      zIndex: u.zIndexRef,
      followerRef: s,
      adjustedTo: vi(e),
      followerEnabled: f,
      renderContentNode: D
    };
  },
  render() {
    return b(_c, { ref: "followerRef", zIndex: this.zIndex, show: this.show, enabled: this.followerEnabled, to: this.adjustedTo, x: this.x, y: this.y, flip: this.flip, placement: this.placement, containerClass: this.namespace, overlap: this.overlap, width: this.width === "trigger" ? "target" : void 0, teleportDisabled: this.adjustedTo === vi.tdkey }, {
      default: () => this.animated ? b(jn, {
        name: "popover-transition",
        appear: this.isMounted,
        onEnter: () => {
          this.followerEnabled = !0;
        },
        onAfterLeave: () => {
          var e;
          (e = this.internalOnAfterLeave) === null || e === void 0 || e.call(this), this.followerEnabled = !1, this.displayed = !1;
        }
      }, {
        default: this.renderContentNode
      }) : this.renderContentNode()
    });
  }
});
const zhe = Object.keys(cH), $he = {
  focus: ["onFocus", "onBlur"],
  click: ["onClick"],
  hover: ["onMouseenter", "onMouseleave"],
  manual: [],
  nested: ["onFocus", "onBlur", "onMouseenter", "onMouseleave", "onClick"]
};
function Ohe(e, t, r) {
  $he[t].forEach((n) => {
    e.props ? e.props = Object.assign({}, e.props) : e.props = {};
    const i = e.props[n], o = r[n];
    i ? e.props[n] = (...a) => {
      i(...a), o(...a);
    } : e.props[n] = o;
  });
}
const yp = {
  show: {
    type: Boolean,
    default: void 0
  },
  defaultShow: Boolean,
  showArrow: {
    type: Boolean,
    default: !0
  },
  trigger: {
    type: String,
    default: "hover"
  },
  delay: {
    type: Number,
    default: 100
  },
  duration: {
    type: Number,
    default: 100
  },
  raw: Boolean,
  placement: {
    type: String,
    default: "top"
  },
  x: Number,
  y: Number,
  arrowPointToCenter: Boolean,
  disabled: Boolean,
  getDisabled: Function,
  displayDirective: {
    type: String,
    default: "if"
  },
  arrowStyle: [String, Object],
  flip: {
    type: Boolean,
    default: !0
  },
  animated: {
    type: Boolean,
    default: !0
  },
  width: {
    type: [Number, String],
    default: void 0
  },
  overlap: Boolean,
  keepAliveOnHover: {
    type: Boolean,
    default: !0
  },
  zIndex: Number,
  to: vi.propTo,
  scrollable: Boolean,
  contentStyle: [Object, String],
  headerStyle: [Object, String],
  footerStyle: [Object, String],
  onClickoutside: Function,
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  internalDeactivateImmediately: Boolean,
  internalSyncTargetWithParent: Boolean,
  internalInheritedEventHandlers: {
    type: Array,
    default: () => []
  },
  internalTrapFocus: Boolean,
  internalExtraClass: {
    type: Array,
    default: () => []
  },
  onShow: [Function, Array],
  onHide: [Function, Array],
  arrow: {
    type: Boolean,
    default: void 0
  },
  minWidth: Number,
  maxWidth: Number
}, _he = Object.assign(Object.assign(Object.assign({}, ft.props), yp), { internalOnAfterLeave: Function, internalRenderBody: Function });
var jc = oe({
  name: "Popover",
  inheritAttrs: !1,
  props: _he,
  __popover__: !0,
  setup(e) {
    const t = ql(), r = G(null), n = j(() => e.show), i = G(e.defaultShow), o = dn(n, i), a = _r(() => e.disabled ? !1 : o.value), s = () => {
      if (e.disabled)
        return !0;
      const { getDisabled: Q } = e;
      return !!(Q != null && Q());
    }, u = () => s() ? !1 : o.value, d = pp(e, ["arrow", "showArrow"]), f = j(() => e.overlap ? !1 : d.value);
    let h = null;
    const g = G(null), m = G(null), v = _r(() => e.x !== void 0 && e.y !== void 0);
    function w(Q) {
      const { "onUpdate:show": Z, onUpdateShow: X, onShow: re, onHide: ue } = e;
      i.value = Q, Z && je(Z, Q), X && je(X, Q), Q && re && je(re, !0), Q && ue && je(ue, !1);
    }
    function x() {
      h && h.syncPosition();
    }
    function y() {
      const { value: Q } = g;
      Q && (window.clearTimeout(Q), g.value = null);
    }
    function C() {
      const { value: Q } = m;
      Q && (window.clearTimeout(Q), m.value = null);
    }
    function S() {
      const Q = s();
      if (e.trigger === "focus" && !Q) {
        if (u())
          return;
        w(!0);
      }
    }
    function T() {
      const Q = s();
      if (e.trigger === "focus" && !Q) {
        if (!u())
          return;
        w(!1);
      }
    }
    function A() {
      const Q = s();
      if (e.trigger === "hover" && !Q) {
        if (C(), g.value !== null || u())
          return;
        const Z = () => {
          w(!0), g.value = null;
        }, { delay: X } = e;
        X === 0 ? Z() : g.value = window.setTimeout(Z, X);
      }
    }
    function D() {
      const Q = s();
      if (e.trigger === "hover" && !Q) {
        if (y(), m.value !== null || !u())
          return;
        const Z = () => {
          w(!1), m.value = null;
        }, { duration: X } = e;
        X === 0 ? Z() : m.value = window.setTimeout(Z, X);
      }
    }
    function E() {
      D();
    }
    function N(Q) {
      var Z;
      u() && (e.trigger === "click" && (y(), C(), w(!1)), (Z = e.onClickoutside) === null || Z === void 0 || Z.call(e, Q));
    }
    function I() {
      if (e.trigger === "click" && !s()) {
        y(), C();
        const Q = !u();
        w(Q);
      }
    }
    function $(Q) {
      e.internalTrapFocus && Q.key === "Escape" && (y(), C(), w(!1));
    }
    function _(Q) {
      i.value = Q;
    }
    function R() {
      var Q;
      return (Q = r.value) === null || Q === void 0 ? void 0 : Q.targetRef;
    }
    function U(Q) {
      h = Q;
    }
    return tr("NPopover", {
      getTriggerElement: R,
      handleKeydown: $,
      handleMouseEnter: A,
      handleMouseLeave: D,
      handleClickOutside: N,
      handleMouseMoveOutside: E,
      setBodyInstance: U,
      positionManuallyRef: v,
      isMountedRef: t,
      zIndexRef: tt(e, "zIndex"),
      extraClassRef: tt(e, "internalExtraClass"),
      internalRenderBodyRef: tt(e, "internalRenderBody")
    }), On(() => {
      o.value && s() && w(!1);
    }), {
      binderInstRef: r,
      positionManually: v,
      mergedShowConsideringDisabledProp: a,
      uncontrolledShow: i,
      mergedShowArrow: f,
      getMergedShow: u,
      setShow: _,
      handleClick: I,
      handleMouseEnter: A,
      handleMouseLeave: D,
      handleFocus: S,
      handleBlur: T,
      syncPosition: x
    };
  },
  render() {
    var e;
    const { positionManually: t, $slots: r } = this;
    let n, i = !1;
    if (!t && (r.activator ? n = nz(r, "activator") : n = nz(r, "trigger"), n)) {
      n = db(n), n = n.type === wZ ? b("span", [n]) : n;
      const o = {
        onClick: this.handleClick,
        onMouseenter: this.handleMouseEnter,
        onMouseleave: this.handleMouseLeave,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      };
      if (!((e = n.type) === null || e === void 0) && e.__popover__)
        i = !0, n.props || (n.props = {
          internalSyncTargetWithParent: !0,
          internalInheritedEventHandlers: []
        }), n.props.internalSyncTargetWithParent = !0, n.props.internalInheritedEventHandlers ? n.props.internalInheritedEventHandlers = [
          o,
          ...n.props.internalInheritedEventHandlers
        ] : n.props.internalInheritedEventHandlers = [o];
      else {
        const { internalInheritedEventHandlers: a } = this, s = [
          o,
          ...a
        ], u = {
          onBlur: (d) => {
            s.forEach((f) => {
              f.onBlur(d);
            });
          },
          onFocus: (d) => {
            s.forEach((f) => {
              f.onFocus(d);
            });
          },
          onClick: (d) => {
            s.forEach((f) => {
              f.onClick(d);
            });
          },
          onMouseenter: (d) => {
            s.forEach((f) => {
              f.onMouseenter(d);
            });
          },
          onMouseleave: (d) => {
            s.forEach((f) => {
              f.onMouseleave(d);
            });
          }
        };
        Ohe(n, a ? "nested" : t ? "manual" : this.trigger, u);
      }
    }
    return b(zc, { ref: "binderInstRef", syncTarget: !i, syncTargetWithParent: this.internalSyncTargetWithParent }, {
      default: () => {
        this.mergedShowConsideringDisabledProp;
        const o = this.getMergedShow();
        return [
          this.internalTrapFocus && o ? Jn(b("div", { style: { position: "fixed", inset: 0 } }), [
            [
              mb,
              {
                enabled: o,
                zIndex: this.zIndex
              }
            ]
          ]) : null,
          t ? null : b($c, null, {
            default: () => n
          }),
          b(Nhe, il(this.$props, zhe, Object.assign(Object.assign({}, this.$attrs), { showArrow: this.mergedShowArrow, show: o })), {
            default: () => {
              var a, s;
              return (s = (a = this.$slots).default) === null || s === void 0 ? void 0 : s.call(a);
            },
            header: () => {
              var a, s;
              return (s = (a = this.$slots).header) === null || s === void 0 ? void 0 : s.call(a);
            },
            footer: () => {
              var a, s;
              return (s = (a = this.$slots).footer) === null || s === void 0 ? void 0 : s.call(a);
            }
          })
        ];
      }
    });
  }
}), Lhe = {
  closeIconSizeTiny: "12px",
  closeIconSizeSmall: "12px",
  closeIconSizeMedium: "14px",
  closeIconSizeLarge: "14px",
  closeSizeTiny: "16px",
  closeSizeSmall: "16px",
  closeSizeMedium: "18px",
  closeSizeLarge: "18px",
  padding: "0 7px",
  closeMargin: "0 0 0 4px",
  closeMarginRtl: "0 4px 0 0"
};
const Phe = (e) => {
  const { textColor2: t, primaryColorHover: r, primaryColorPressed: n, primaryColor: i, infoColor: o, successColor: a, warningColor: s, errorColor: u, baseColor: d, borderColor: f, opacityDisabled: h, tagColor: g, closeIconColor: m, closeIconColorHover: v, closeIconColorPressed: w, borderRadiusSmall: x, fontSizeMini: y, fontSizeTiny: C, fontSizeSmall: S, fontSizeMedium: T, heightMini: A, heightTiny: D, heightSmall: E, heightMedium: N, closeColorHover: I, closeColorPressed: $, buttonColor2Hover: _, buttonColor2Pressed: R, fontWeightStrong: U } = e;
  return Object.assign(Object.assign({}, Lhe), {
    closeBorderRadius: x,
    heightTiny: A,
    heightSmall: D,
    heightMedium: E,
    heightLarge: N,
    borderRadius: x,
    opacityDisabled: h,
    fontSizeTiny: y,
    fontSizeSmall: C,
    fontSizeMedium: S,
    fontSizeLarge: T,
    fontWeightStrong: U,
    textColorCheckable: t,
    textColorHoverCheckable: t,
    textColorPressedCheckable: t,
    textColorChecked: d,
    colorCheckable: "#0000",
    colorHoverCheckable: _,
    colorPressedCheckable: R,
    colorChecked: i,
    colorCheckedHover: r,
    colorCheckedPressed: n,
    border: `1px solid ${f}`,
    textColor: t,
    color: g,
    colorBordered: "rgb(250, 250, 252)",
    closeIconColor: m,
    closeIconColorHover: v,
    closeIconColorPressed: w,
    closeColorHover: I,
    closeColorPressed: $,
    borderPrimary: `1px solid ${nr(i, { alpha: 0.3 })}`,
    textColorPrimary: i,
    colorPrimary: nr(i, { alpha: 0.12 }),
    colorBorderedPrimary: nr(i, { alpha: 0.1 }),
    closeIconColorPrimary: i,
    closeIconColorHoverPrimary: i,
    closeIconColorPressedPrimary: i,
    closeColorHoverPrimary: nr(i, { alpha: 0.12 }),
    closeColorPressedPrimary: nr(i, { alpha: 0.18 }),
    borderInfo: `1px solid ${nr(o, { alpha: 0.3 })}`,
    textColorInfo: o,
    colorInfo: nr(o, { alpha: 0.12 }),
    colorBorderedInfo: nr(o, { alpha: 0.1 }),
    closeIconColorInfo: o,
    closeIconColorHoverInfo: o,
    closeIconColorPressedInfo: o,
    closeColorHoverInfo: nr(o, { alpha: 0.12 }),
    closeColorPressedInfo: nr(o, { alpha: 0.18 }),
    borderSuccess: `1px solid ${nr(a, { alpha: 0.3 })}`,
    textColorSuccess: a,
    colorSuccess: nr(a, { alpha: 0.12 }),
    colorBorderedSuccess: nr(a, { alpha: 0.1 }),
    closeIconColorSuccess: a,
    closeIconColorHoverSuccess: a,
    closeIconColorPressedSuccess: a,
    closeColorHoverSuccess: nr(a, { alpha: 0.12 }),
    closeColorPressedSuccess: nr(a, { alpha: 0.18 }),
    borderWarning: `1px solid ${nr(s, { alpha: 0.35 })}`,
    textColorWarning: s,
    colorWarning: nr(s, { alpha: 0.15 }),
    colorBorderedWarning: nr(s, { alpha: 0.12 }),
    closeIconColorWarning: s,
    closeIconColorHoverWarning: s,
    closeIconColorPressedWarning: s,
    closeColorHoverWarning: nr(s, { alpha: 0.12 }),
    closeColorPressedWarning: nr(s, { alpha: 0.18 }),
    borderError: `1px solid ${nr(u, { alpha: 0.23 })}`,
    textColorError: u,
    colorError: nr(u, { alpha: 0.1 }),
    colorBorderedError: nr(u, { alpha: 0.08 }),
    closeIconColorError: u,
    closeIconColorHoverError: u,
    closeIconColorPressedError: u,
    closeColorHoverError: nr(u, { alpha: 0.12 }),
    closeColorPressedError: nr(u, { alpha: 0.18 })
  });
}, Rhe = {
  name: "Tag",
  common: Sr,
  self: Phe
};
var fH = Rhe, hH = {
  color: Object,
  type: {
    type: String,
    default: "default"
  },
  round: Boolean,
  size: {
    type: String,
    default: "medium"
  },
  closable: Boolean,
  disabled: {
    type: Boolean,
    default: void 0
  }
}, jhe = L("tag", `
 white-space: nowrap;
 position: relative;
 box-sizing: border-box;
 cursor: default;
 display: inline-flex;
 align-items: center;
 flex-wrap: nowrap;
 padding: var(--n-padding);
 border-radius: var(--n-border-radius);
 color: var(--n-text-color);
 background-color: var(--n-color);
 transition: 
 border-color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 opacity .3s var(--n-bezier);
 line-height: 1;
 height: var(--n-height);
 font-size: var(--n-font-size);
`, [K("strong", `
 font-weight: var(--n-font-weight-strong);
 `), q("border", `
 pointer-events: none;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border-radius: inherit;
 border: var(--n-border);
 transition: border-color .3s var(--n-bezier);
 `), q("icon", `
 display: flex;
 margin: 0 4px 0 0;
 color: var(--n-text-color);
 transition: color .3s var(--n-bezier);
 font-size: var(--n-avatar-size-override);
 `), q("avatar", `
 display: flex;
 margin: 0 6px 0 0;
 `), q("close", `
 margin: var(--n-close-margin);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `), K("round", `
 padding: 0 calc(var(--n-height) / 3);
 border-radius: calc(var(--n-height) / 2);
 `, [q("icon", `
 margin: 0 4px 0 calc((var(--n-height) - 8px) / -2);
 `), q("avatar", `
 margin: 0 6px 0 calc((var(--n-height) - 8px) / -2);
 `), K("closable", `
 padding: 0 calc(var(--n-height) / 4) 0 calc(var(--n-height) / 3);
 `)]), K("icon, avatar", [K("round", `
 padding: 0 calc(var(--n-height) / 3) 0 calc(var(--n-height) / 2);
 `)]), K("disabled", `
 cursor: not-allowed !important;
 opacity: var(--n-opacity-disabled);
 `), K("checkable", `
 cursor: pointer;
 box-shadow: none;
 color: var(--n-text-color-checkable);
 background-color: var(--n-color-checkable);
 `, [wr("disabled", [Y("&:hover", "background-color: var(--n-color-hover-checkable);", [wr("checked", "color: var(--n-text-color-hover-checkable);")]), Y("&:active", "background-color: var(--n-color-pressed-checkable);", [wr("checked", "color: var(--n-text-color-pressed-checkable);")])]), K("checked", `
 color: var(--n-text-color-checked);
 background-color: var(--n-color-checked);
 `, [wr("disabled", [Y("&:hover", "background-color: var(--n-color-checked-hover);"), Y("&:active", "background-color: var(--n-color-checked-pressed);")])])])]);
const Fhe = Object.assign(Object.assign(Object.assign({}, ft.props), hH), {
  bordered: {
    type: Boolean,
    default: void 0
  },
  checked: Boolean,
  checkable: Boolean,
  strong: Boolean,
  triggerClickOnClose: Boolean,
  onClose: [Array, Function],
  onMouseenter: Function,
  onMouseleave: Function,
  "onUpdate:checked": Function,
  onUpdateChecked: Function,
  internalCloseFocusable: {
    type: Boolean,
    default: !0
  },
  internalCloseIsButtonTag: {
    type: Boolean,
    default: !0
  },
  onCheckedChange: Function
}), pH = "n-tag";
var Jv = oe({
  name: "Tag",
  props: Fhe,
  setup(e) {
    const t = G(null), { mergedBorderedRef: r, mergedClsPrefixRef: n, inlineThemeDisabled: i, mergedRtlRef: o } = Yt(e), a = ft("Tag", "-tag", jhe, fH, e, n);
    tr(pH, {
      roundRef: tt(e, "round")
    });
    function s(m) {
      if (!e.disabled && e.checkable) {
        const { checked: v, onCheckedChange: w, onUpdateChecked: x, "onUpdate:checked": y } = e;
        x && x(!v), y && y(!v), w && w(!v);
      }
    }
    function u(m) {
      if (e.triggerClickOnClose || m.stopPropagation(), !e.disabled) {
        const { onClose: v } = e;
        v && je(v, m);
      }
    }
    const d = {
      setTextContent(m) {
        const { value: v } = t;
        v && (v.textContent = m);
      }
    }, f = Li("Tag", o, n), h = j(() => {
      const { type: m, size: v, color: { color: w, textColor: x } = {} } = e, { common: { cubicBezierEaseInOut: y }, self: { padding: C, closeMargin: S, closeMarginRtl: T, borderRadius: A, opacityDisabled: D, textColorCheckable: E, textColorHoverCheckable: N, textColorPressedCheckable: I, textColorChecked: $, colorCheckable: _, colorHoverCheckable: R, colorPressedCheckable: U, colorChecked: Q, colorCheckedHover: Z, colorCheckedPressed: X, closeBorderRadius: re, fontWeightStrong: ue, [Be("colorBordered", m)]: he, [Be("closeSize", v)]: te, [Be("closeIconSize", v)]: de, [Be("fontSize", v)]: De, [Be("height", v)]: Oe, [Be("color", m)]: Qe, [Be("textColor", m)]: Ae, [Be("border", m)]: Ne, [Be("closeIconColor", m)]: $e, [Be("closeIconColorHover", m)]: et, [Be("closeIconColorPressed", m)]: Ge, [Be("closeColorHover", m)]: Ee, [Be("closeColorPressed", m)]: qe } } = a.value;
      return {
        "--n-font-weight-strong": ue,
        "--n-avatar-size-override": `calc(${Oe} - 8px)`,
        "--n-bezier": y,
        "--n-border-radius": A,
        "--n-border": Ne,
        "--n-close-icon-size": de,
        "--n-close-color-pressed": qe,
        "--n-close-color-hover": Ee,
        "--n-close-border-radius": re,
        "--n-close-icon-color": $e,
        "--n-close-icon-color-hover": et,
        "--n-close-icon-color-pressed": Ge,
        "--n-close-icon-color-disabled": $e,
        "--n-close-margin": S,
        "--n-close-margin-rtl": T,
        "--n-close-size": te,
        "--n-color": w || (r.value ? he : Qe),
        "--n-color-checkable": _,
        "--n-color-checked": Q,
        "--n-color-checked-hover": Z,
        "--n-color-checked-pressed": X,
        "--n-color-hover-checkable": R,
        "--n-color-pressed-checkable": U,
        "--n-font-size": De,
        "--n-height": Oe,
        "--n-opacity-disabled": D,
        "--n-padding": C,
        "--n-text-color": x || Ae,
        "--n-text-color-checkable": E,
        "--n-text-color-checked": $,
        "--n-text-color-hover-checkable": N,
        "--n-text-color-pressed-checkable": I
      };
    }), g = i ? Cr("tag", j(() => {
      let m = "";
      const { type: v, size: w, color: { color: x, textColor: y } = {} } = e;
      return m += v[0], m += w[0], x && (m += `a${hp(x)}`), y && (m += `b${hp(y)}`), r.value && (m += "c"), m;
    }), h, e) : void 0;
    return Object.assign(Object.assign({}, d), {
      rtlEnabled: f,
      mergedClsPrefix: n,
      contentRef: t,
      mergedBordered: r,
      handleClick: s,
      handleCloseClick: u,
      cssVars: i ? void 0 : h,
      themeClass: g == null ? void 0 : g.themeClass,
      onRender: g == null ? void 0 : g.onRender
    });
  },
  render() {
    var e, t;
    const { mergedClsPrefix: r, rtlEnabled: n, closable: i, color: { borderColor: o } = {}, round: a, onRender: s, $slots: u } = this;
    s == null || s();
    const d = Fr(u.avatar, (h) => h && b("div", { class: `${r}-tag__avatar` }, h)), f = Fr(u.icon, (h) => h && b("div", { class: `${r}-tag__icon` }, h));
    return b("div", { class: [
      `${r}-tag`,
      this.themeClass,
      {
        [`${r}-tag--rtl`]: n,
        [`${r}-tag--strong`]: this.strong,
        [`${r}-tag--disabled`]: this.disabled,
        [`${r}-tag--checkable`]: this.checkable,
        [`${r}-tag--checked`]: this.checkable && this.checked,
        [`${r}-tag--round`]: a,
        [`${r}-tag--avatar`]: d,
        [`${r}-tag--icon`]: f,
        [`${r}-tag--closable`]: i
      }
    ], style: this.cssVars, onClick: this.handleClick, onMouseenter: this.onMouseenter, onMouseleave: this.onMouseleave }, f || d, b("span", { class: `${r}-tag__content`, ref: "contentRef" }, (t = (e = this.$slots).default) === null || t === void 0 ? void 0 : t.call(e)), !this.checkable && i ? b(gh, { clsPrefix: r, class: `${r}-tag__close`, disabled: this.disabled, onClick: this.handleCloseClick, focusable: this.internalCloseFocusable, round: a, isButtonTag: this.internalCloseIsButtonTag, absolute: !0 }) : null, !this.checkable && this.mergedBordered ? b("div", { class: `${r}-tag__border`, style: { borderColor: o } }) : null);
  }
}), Bhe = L("base-clear", `
 flex-shrink: 0;
 height: 1em;
 width: 1em;
 position: relative;
`, [Y(">", [q("clear", `
 font-size: var(--n-clear-size);
 height: 1em;
 width: 1em;
 cursor: pointer;
 color: var(--n-clear-color);
 transition: color .3s var(--n-bezier);
 display: flex;
 `, [Y("&:hover", `
 color: var(--n-clear-color-hover)!important;
 `), Y("&:active", `
 color: var(--n-clear-color-pressed)!important;
 `)]), q("placeholder", `
 display: flex;
 `), q("clear, placeholder", `
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 `, [Io({
  originalTransform: "translateX(-50%) translateY(-50%)",
  left: "50%",
  top: "50%"
})])])]), Mz = oe({
  name: "BaseClear",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    show: Boolean,
    onClear: Function
  },
  setup(e) {
    return Vu("-base-clear", Bhe, tt(e, "clsPrefix")), {
      handleMouseDown(t) {
        t.preventDefault();
      }
    };
  },
  render() {
    const { clsPrefix: e } = this;
    return b("div", { class: `${e}-base-clear` }, b(Lc, null, {
      default: () => {
        var t, r;
        return this.show ? b("div", { key: "dismiss", class: `${e}-base-clear__clear`, onClick: this.onClear, onMousedown: this.handleMouseDown, "data-clear": !0 }, vr(this.$slots.icon, () => [
          b(fr, { clsPrefix: e }, {
            default: () => b(Tfe, null)
          })
        ])) : b("div", { key: "icon", class: `${e}-base-clear__placeholder` }, (r = (t = this.$slots).placeholder) === null || r === void 0 ? void 0 : r.call(t));
      }
    }));
  }
}), gH = oe({
  name: "InternalSelectionSuffix",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    showArrow: {
      type: Boolean,
      default: void 0
    },
    showClear: {
      type: Boolean,
      default: void 0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    onClear: Function
  },
  setup(e, { slots: t }) {
    return () => {
      const { clsPrefix: r } = e;
      return b(mh, { clsPrefix: r, class: `${r}-base-suffix`, strokeWidth: 24, scale: 0.85, show: e.loading }, {
        default: () => e.showArrow ? b(Mz, { clsPrefix: r, show: e.showClear, onClear: e.onClear }, {
          placeholder: () => b(fr, { clsPrefix: r, class: `${r}-base-suffix__arrow` }, {
            default: () => vr(t.default, () => [
              b(tH, null)
            ])
          })
        }) : null
      });
    };
  }
}), Uhe = {
  paddingSingle: "0 26px 0 12px",
  paddingMultiple: "3px 26px 0 12px",
  clearSize: "16px",
  arrowSize: "16px"
};
const Hhe = (e) => {
  const { borderRadius: t, textColor2: r, textColorDisabled: n, inputColor: i, inputColorDisabled: o, primaryColor: a, primaryColorHover: s, warningColor: u, warningColorHover: d, errorColor: f, errorColorHover: h, borderColor: g, iconColor: m, iconColorDisabled: v, clearColor: w, clearColorHover: x, clearColorPressed: y, placeholderColor: C, placeholderColorDisabled: S, fontSizeTiny: T, fontSizeSmall: A, fontSizeMedium: D, fontSizeLarge: E, heightTiny: N, heightSmall: I, heightMedium: $, heightLarge: _ } = e;
  return Object.assign(Object.assign({}, Uhe), {
    fontSizeTiny: T,
    fontSizeSmall: A,
    fontSizeMedium: D,
    fontSizeLarge: E,
    heightTiny: N,
    heightSmall: I,
    heightMedium: $,
    heightLarge: _,
    borderRadius: t,
    textColor: r,
    textColorDisabled: n,
    placeholderColor: C,
    placeholderColorDisabled: S,
    color: i,
    colorDisabled: o,
    colorActive: i,
    border: `1px solid ${g}`,
    borderHover: `1px solid ${s}`,
    borderActive: `1px solid ${a}`,
    borderFocus: `1px solid ${s}`,
    boxShadowHover: "none",
    boxShadowActive: `0 0 0 2px ${nr(a, {
      alpha: 0.2
    })}`,
    boxShadowFocus: `0 0 0 2px ${nr(a, {
      alpha: 0.2
    })}`,
    caretColor: a,
    arrowColor: m,
    arrowColorDisabled: v,
    loadingColor: a,
    borderWarning: `1px solid ${u}`,
    borderHoverWarning: `1px solid ${d}`,
    borderActiveWarning: `1px solid ${u}`,
    borderFocusWarning: `1px solid ${d}`,
    boxShadowHoverWarning: "none",
    boxShadowActiveWarning: `0 0 0 2px ${nr(u, {
      alpha: 0.2
    })}`,
    boxShadowFocusWarning: `0 0 0 2px ${nr(u, {
      alpha: 0.2
    })}`,
    colorActiveWarning: i,
    caretColorWarning: u,
    borderError: `1px solid ${f}`,
    borderHoverError: `1px solid ${h}`,
    borderActiveError: `1px solid ${f}`,
    borderFocusError: `1px solid ${h}`,
    boxShadowHoverError: "none",
    boxShadowActiveError: `0 0 0 2px ${nr(f, {
      alpha: 0.2
    })}`,
    boxShadowFocusError: `0 0 0 2px ${nr(f, {
      alpha: 0.2
    })}`,
    colorActiveError: i,
    caretColorError: f,
    clearColor: w,
    clearColorHover: x,
    clearColorPressed: y
  });
}, Whe = {
  name: "InternalSelection",
  common: Sr,
  peers: {
    Popover: Vp
  },
  self: Hhe
};
var mH = Whe, Vhe = Y([L("base-selection", `
 position: relative;
 z-index: auto;
 box-shadow: none;
 width: 100%;
 max-width: 100%;
 display: inline-block;
 vertical-align: bottom;
 border-radius: var(--n-border-radius);
 min-height: var(--n-height);
 line-height: 1.5;
 font-size: var(--n-font-size);
 `, [L("base-loading", `
 color: var(--n-loading-color);
 `), L("base-selection-tags", "min-height: var(--n-height);"), q("border, state-border", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 pointer-events: none;
 border: var(--n-border);
 border-radius: inherit;
 transition:
 box-shadow .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `), q("state-border", `
 z-index: 1;
 border-color: #0000;
 `), L("base-suffix", `
 cursor: pointer;
 position: absolute;
 top: 50%;
 transform: translateY(-50%);
 right: 10px;
 `, [q("arrow", `
 font-size: var(--n-arrow-size);
 color: var(--n-arrow-color);
 transition: color .3s var(--n-bezier);
 `)]), L("base-selection-overlay", `
 display: flex;
 align-items: center;
 white-space: nowrap;
 pointer-events: none;
 position: absolute;
 top: 0;
 right: 0;
 bottom: 0;
 left: 0;
 padding: var(--n-padding-single);
 transition: color .3s var(--n-bezier);
 `, [q("wrapper", `
 flex-basis: 0;
 flex-grow: 1;
 overflow: hidden;
 text-overflow: ellipsis;
 `)]), L("base-selection-placeholder", `
 color: var(--n-placeholder-color);
 `, [q("inner", `
 max-width: 100%;
 overflow: hidden;
 `)]), L("base-selection-tags", `
 cursor: pointer;
 outline: none;
 box-sizing: border-box;
 position: relative;
 z-index: auto;
 display: flex;
 padding: var(--n-padding-multiple);
 flex-wrap: wrap;
 align-items: center;
 width: 100%;
 vertical-align: bottom;
 background-color: var(--n-color);
 border-radius: inherit;
 transition:
 color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 `), L("base-selection-label", `
 height: var(--n-height);
 display: inline-flex;
 width: 100%;
 vertical-align: bottom;
 cursor: pointer;
 outline: none;
 z-index: auto;
 box-sizing: border-box;
 position: relative;
 transition:
 color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 border-radius: inherit;
 background-color: var(--n-color);
 align-items: center;
 `, [L("base-selection-input", `
 font-size: inherit;
 line-height: inherit;
 outline: none;
 cursor: pointer;
 box-sizing: border-box;
 border:none;
 width: 100%;
 padding: var(--n-padding-single);
 background-color: #0000;
 color: var(--n-text-color);
 transition: color .3s var(--n-bezier);
 caret-color: var(--n-caret-color);
 `, [q("content", `
 text-overflow: ellipsis;
 overflow: hidden;
 white-space: nowrap; 
 `)]), q("render-label", `
 color: var(--n-text-color);
 `)]), wr("disabled", [Y("&:hover", [q("state-border", `
 box-shadow: var(--n-box-shadow-hover);
 border: var(--n-border-hover);
 `)]), K("focus", [q("state-border", `
 box-shadow: var(--n-box-shadow-focus);
 border: var(--n-border-focus);
 `)]), K("active", [q("state-border", `
 box-shadow: var(--n-box-shadow-active);
 border: var(--n-border-active);
 `), L("base-selection-label", "background-color: var(--n-color-active);"), L("base-selection-tags", "background-color: var(--n-color-active);")])]), K("disabled", "cursor: not-allowed;", [q("arrow", `
 color: var(--n-arrow-color-disabled);
 `), L("base-selection-label", `
 cursor: not-allowed;
 background-color: var(--n-color-disabled);
 `, [L("base-selection-input", `
 cursor: not-allowed;
 color: var(--n-text-color-disabled);
 `), q("render-label", `
 color: var(--n-text-color-disabled);
 `)]), L("base-selection-tags", `
 cursor: not-allowed;
 background-color: var(--n-color-disabled);
 `), L("base-selection-placeholder", `
 cursor: not-allowed;
 color: var(--n-placeholder-color-disabled);
 `)]), L("base-selection-input-tag", `
 height: calc(var(--n-height) - 6px);
 line-height: calc(var(--n-height) - 6px);
 outline: none;
 display: none;
 position: relative;
 margin-bottom: 3px;
 max-width: 100%;
 vertical-align: bottom;
 `, [q("input", `
 font-size: inherit;
 font-family: inherit;
 min-width: 1px;
 padding: 0;
 background-color: #0000;
 outline: none;
 border: none;
 max-width: 100%;
 overflow: hidden;
 width: 1em;
 line-height: inherit;
 cursor: pointer;
 color: var(--n-text-color);
 caret-color: var(--n-caret-color);
 `), q("mirror", `
 position: absolute;
 left: 0;
 top: 0;
 white-space: pre;
 visibility: hidden;
 user-select: none;
 -webkit-user-select: none;
 opacity: 0;
 `)]), ["warning", "error"].map((e) => K(`${e}-status`, [q("state-border", `border: var(--n-border-${e});`), wr("disabled", [Y("&:hover", [q("state-border", `
 box-shadow: var(--n-box-shadow-hover-${e});
 border: var(--n-border-hover-${e});
 `)]), K("active", [q("state-border", `
 box-shadow: var(--n-box-shadow-active-${e});
 border: var(--n-border-active-${e});
 `), L("base-selection-label", `background-color: var(--n-color-active-${e});`), L("base-selection-tags", `background-color: var(--n-color-active-${e});`)]), K("focus", [q("state-border", `
 box-shadow: var(--n-box-shadow-focus-${e});
 border: var(--n-border-focus-${e});
 `)])])]))]), L("base-selection-popover", `
 margin-bottom: -3px;
 display: flex;
 flex-wrap: wrap;
 margin-right: -8px;
 `), L("base-selection-tag-wrapper", `
 max-width: 100%;
 display: inline-flex;
 padding: 0 7px 3px 0;
 `, [Y("&:last-child", "padding-right: 0;"), L("tag", `
 font-size: 14px;
 max-width: 100%;
 `, [q("content", `
 line-height: 1.25;
 text-overflow: ellipsis;
 overflow: hidden;
 `)])])]), Yhe = oe({
  name: "InternalSelection",
  props: Object.assign(Object.assign({}, ft.props), { clsPrefix: {
    type: String,
    required: !0
  }, bordered: {
    type: Boolean,
    default: void 0
  }, active: Boolean, pattern: {
    type: String,
    default: ""
  }, placeholder: String, selectedOption: {
    type: Object,
    default: null
  }, selectedOptions: {
    type: Array,
    default: null
  }, labelField: { type: String, default: "label" }, valueField: {
    type: String,
    default: "value"
  }, multiple: Boolean, filterable: Boolean, clearable: Boolean, disabled: Boolean, size: {
    type: String,
    default: "medium"
  }, loading: Boolean, autofocus: Boolean, showArrow: {
    type: Boolean,
    default: !0
  }, inputProps: Object, focused: Boolean, renderTag: Function, onKeydown: Function, onClick: Function, onBlur: Function, onFocus: Function, onDeleteOption: Function, maxTagCount: [String, Number], onClear: Function, onPatternInput: Function, onPatternFocus: Function, onPatternBlur: Function, renderLabel: Function, status: String, inlineThemeDisabled: Boolean, ignoreComposition: { type: Boolean, default: !0 }, onResize: Function }),
  setup(e) {
    const t = G(null), r = G(null), n = G(null), i = G(null), o = G(null), a = G(null), s = G(null), u = G(null), d = G(null), f = G(null), h = G(!1), g = G(!1), m = G(!1), v = ft("InternalSelection", "-internal-selection", Vhe, mH, e, tt(e, "clsPrefix")), w = j(() => e.clearable && !e.disabled && (m.value || e.active)), x = j(() => e.selectedOption ? e.renderTag ? e.renderTag({
      option: e.selectedOption,
      handleClose: () => {
      }
    }) : e.renderLabel ? e.renderLabel(e.selectedOption, !0) : xn(e.selectedOption[e.labelField], e.selectedOption, !0) : e.placeholder), y = j(() => {
      const ae = e.selectedOption;
      if (ae)
        return ae[e.labelField];
    }), C = j(() => e.multiple ? !!(Array.isArray(e.selectedOptions) && e.selectedOptions.length) : e.selectedOption !== null);
    function S() {
      var ae;
      const { value: Me } = t;
      if (Me) {
        const { value: fe } = r;
        fe && (fe.style.width = `${Me.offsetWidth}px`, e.maxTagCount !== "responsive" && ((ae = d.value) === null || ae === void 0 || ae.sync()));
      }
    }
    function T() {
      const { value: ae } = f;
      ae && (ae.style.display = "none");
    }
    function A() {
      const { value: ae } = f;
      ae && (ae.style.display = "inline-block");
    }
    Gt(tt(e, "active"), (ae) => {
      ae || T();
    }), Gt(tt(e, "pattern"), () => {
      e.multiple && an(S);
    });
    function D(ae) {
      const { onFocus: Me } = e;
      Me && Me(ae);
    }
    function E(ae) {
      const { onBlur: Me } = e;
      Me && Me(ae);
    }
    function N(ae) {
      const { onDeleteOption: Me } = e;
      Me && Me(ae);
    }
    function I(ae) {
      const { onClear: Me } = e;
      Me && Me(ae);
    }
    function $(ae) {
      const { onPatternInput: Me } = e;
      Me && Me(ae);
    }
    function _(ae) {
      var Me;
      (!ae.relatedTarget || !(!((Me = n.value) === null || Me === void 0) && Me.contains(ae.relatedTarget))) && D(ae);
    }
    function R(ae) {
      var Me;
      !((Me = n.value) === null || Me === void 0) && Me.contains(ae.relatedTarget) || E(ae);
    }
    function U(ae) {
      I(ae);
    }
    function Q() {
      m.value = !0;
    }
    function Z() {
      m.value = !1;
    }
    function X(ae) {
      !e.active || !e.filterable || ae.target !== r.value && ae.preventDefault();
    }
    function re(ae) {
      N(ae);
    }
    function ue(ae) {
      if (ae.key === "Backspace" && !he.value && !e.pattern.length) {
        const { selectedOptions: Me } = e;
        Me != null && Me.length && re(Me[Me.length - 1]);
      }
    }
    const he = G(!1);
    let te = null;
    function de(ae) {
      const { value: Me } = t;
      if (Me) {
        const fe = ae.target.value;
        Me.textContent = fe, S();
      }
      e.ignoreComposition && he.value ? te = ae : $(ae);
    }
    function De() {
      he.value = !0;
    }
    function Oe() {
      he.value = !1, e.ignoreComposition && $(te), te = null;
    }
    function Qe(ae) {
      var Me;
      g.value = !0, (Me = e.onPatternFocus) === null || Me === void 0 || Me.call(e, ae);
    }
    function Ae(ae) {
      var Me;
      g.value = !1, (Me = e.onPatternBlur) === null || Me === void 0 || Me.call(e, ae);
    }
    function Ne() {
      var ae, Me;
      if (e.filterable)
        g.value = !1, (ae = a.value) === null || ae === void 0 || ae.blur(), (Me = r.value) === null || Me === void 0 || Me.blur();
      else if (e.multiple) {
        const { value: fe } = i;
        fe == null || fe.blur();
      } else {
        const { value: fe } = o;
        fe == null || fe.blur();
      }
    }
    function $e() {
      var ae, Me, fe;
      e.filterable ? (g.value = !1, (ae = a.value) === null || ae === void 0 || ae.focus()) : e.multiple ? (Me = i.value) === null || Me === void 0 || Me.focus() : (fe = o.value) === null || fe === void 0 || fe.focus();
    }
    function et() {
      const { value: ae } = r;
      ae && (A(), ae.focus());
    }
    function Ge() {
      const { value: ae } = r;
      ae && ae.blur();
    }
    function Ee(ae) {
      const { value: Me } = s;
      Me && Me.setTextContent(`+${ae}`);
    }
    function qe() {
      const { value: ae } = u;
      return ae;
    }
    function Ue() {
      return r.value;
    }
    let ot = null;
    function Ie() {
      ot !== null && window.clearTimeout(ot);
    }
    function rt() {
      e.disabled || e.active || (Ie(), ot = window.setTimeout(() => {
        C.value && (h.value = !0);
      }, 100));
    }
    function W() {
      Ie();
    }
    function P(ae) {
      ae || (Ie(), h.value = !1);
    }
    Gt(C, (ae) => {
      ae || (h.value = !1);
    }), br(() => {
      On(() => {
        const ae = a.value;
        ae && (ae.tabIndex = e.disabled || g.value ? -1 : 0);
      });
    }), BU(n, e.onResize);
    const { inlineThemeDisabled: H } = e, se = j(() => {
      const { size: ae } = e, { common: { cubicBezierEaseInOut: Me }, self: {
        borderRadius: fe,
        color: ke,
        placeholderColor: Le,
        textColor: dt,
        paddingSingle: Mt,
        paddingMultiple: Ct,
        caretColor: er,
        colorDisabled: Vt,
        textColorDisabled: jt,
        placeholderColorDisabled: at,
        colorActive: St,
        boxShadowFocus: ve,
        boxShadowActive: We,
        boxShadowHover: ne,
        border: Se,
        borderFocus: _e,
        borderHover: ut,
        borderActive: ht,
        arrowColor: ye,
        arrowColorDisabled: Ze,
        loadingColor: st,
        colorActiveWarning: Nt,
        boxShadowFocusWarning: Te,
        boxShadowActiveWarning: Ke,
        boxShadowHoverWarning: xe,
        borderWarning: Xe,
        borderFocusWarning: At,
        borderHoverWarning: Ht,
        borderActiveWarning: zt,
        colorActiveError: ge,
        boxShadowFocusError: Fe,
        boxShadowActiveError: Tt,
        boxShadowHoverError: lr,
        borderError: gr,
        borderFocusError: Or,
        borderHoverError: ri,
        borderActiveError: xi,
        clearColor: wi,
        clearColorHover: Pi,
        clearColorPressed: Mi,
        clearSize: ze,
        arrowSize: wt,
        [Be("height", ae)]: Ut,
        [Be("fontSize", ae)]: Wr
      } } = v.value;
      return {
        "--n-bezier": Me,
        "--n-border": Se,
        "--n-border-active": ht,
        "--n-border-focus": _e,
        "--n-border-hover": ut,
        "--n-border-radius": fe,
        "--n-box-shadow-active": We,
        "--n-box-shadow-focus": ve,
        "--n-box-shadow-hover": ne,
        "--n-caret-color": er,
        "--n-color": ke,
        "--n-color-active": St,
        "--n-color-disabled": Vt,
        "--n-font-size": Wr,
        "--n-height": Ut,
        "--n-padding-single": Mt,
        "--n-padding-multiple": Ct,
        "--n-placeholder-color": Le,
        "--n-placeholder-color-disabled": at,
        "--n-text-color": dt,
        "--n-text-color-disabled": jt,
        "--n-arrow-color": ye,
        "--n-arrow-color-disabled": Ze,
        "--n-loading-color": st,
        "--n-color-active-warning": Nt,
        "--n-box-shadow-focus-warning": Te,
        "--n-box-shadow-active-warning": Ke,
        "--n-box-shadow-hover-warning": xe,
        "--n-border-warning": Xe,
        "--n-border-focus-warning": At,
        "--n-border-hover-warning": Ht,
        "--n-border-active-warning": zt,
        "--n-color-active-error": ge,
        "--n-box-shadow-focus-error": Fe,
        "--n-box-shadow-active-error": Tt,
        "--n-box-shadow-hover-error": lr,
        "--n-border-error": gr,
        "--n-border-focus-error": Or,
        "--n-border-hover-error": ri,
        "--n-border-active-error": xi,
        "--n-clear-size": ze,
        "--n-clear-color": wi,
        "--n-clear-color-hover": Pi,
        "--n-clear-color-pressed": Mi,
        "--n-arrow-size": wt
      };
    }), pe = H ? Cr("internal-selection", j(() => e.size[0]), se, e) : void 0;
    return {
      mergedTheme: v,
      mergedClearable: w,
      patternInputFocused: g,
      filterablePlaceholder: x,
      label: y,
      selected: C,
      showTagsPanel: h,
      isComposing: he,
      counterRef: s,
      counterWrapperRef: u,
      patternInputMirrorRef: t,
      patternInputRef: r,
      selfRef: n,
      multipleElRef: i,
      singleElRef: o,
      patternInputWrapperRef: a,
      overflowRef: d,
      inputTagElRef: f,
      handleMouseDown: X,
      handleFocusin: _,
      handleClear: U,
      handleMouseEnter: Q,
      handleMouseLeave: Z,
      handleDeleteOption: re,
      handlePatternKeyDown: ue,
      handlePatternInputInput: de,
      handlePatternInputBlur: Ae,
      handlePatternInputFocus: Qe,
      handleMouseEnterCounter: rt,
      handleMouseLeaveCounter: W,
      handleFocusout: R,
      handleCompositionEnd: Oe,
      handleCompositionStart: De,
      onPopoverUpdateShow: P,
      focus: $e,
      focusInput: et,
      blur: Ne,
      blurInput: Ge,
      updateCounter: Ee,
      getCounter: qe,
      getTail: Ue,
      renderLabel: e.renderLabel,
      cssVars: H ? void 0 : se,
      themeClass: pe == null ? void 0 : pe.themeClass,
      onRender: pe == null ? void 0 : pe.onRender
    };
  },
  render() {
    const { status: e, multiple: t, size: r, disabled: n, filterable: i, maxTagCount: o, bordered: a, clsPrefix: s, onRender: u, renderTag: d, renderLabel: f } = this;
    u == null || u();
    const h = o === "responsive", g = typeof o == "number", m = h || g, v = b(iz, null, {
      default: () => b(gH, { clsPrefix: s, loading: this.loading, showArrow: this.showArrow, showClear: this.mergedClearable && this.selected, onClear: this.handleClear }, {
        default: () => {
          var x, y;
          return (y = (x = this.$slots).arrow) === null || y === void 0 ? void 0 : y.call(x);
        }
      })
    });
    let w;
    if (t) {
      const { labelField: x } = this, y = (R) => b("div", { class: `${s}-base-selection-tag-wrapper`, key: R.value }, d ? d({
        option: R,
        handleClose: () => {
          this.handleDeleteOption(R);
        }
      }) : b(Jv, { size: r, closable: !R.disabled, disabled: n, onClose: () => {
        this.handleDeleteOption(R);
      }, internalCloseIsButtonTag: !1, internalCloseFocusable: !1 }, {
        default: () => f ? f(R, !0) : xn(R[x], R, !0)
      })), C = () => (g ? this.selectedOptions.slice(0, o) : this.selectedOptions).map(y), S = i ? b("div", { class: `${s}-base-selection-input-tag`, ref: "inputTagElRef", key: "__input-tag__" }, b("input", Object.assign({}, this.inputProps, { ref: "patternInputRef", tabindex: -1, disabled: n, value: this.pattern, autofocus: this.autofocus, class: `${s}-base-selection-input-tag__input`, onBlur: this.handlePatternInputBlur, onFocus: this.handlePatternInputFocus, onKeydown: this.handlePatternKeyDown, onInput: this.handlePatternInputInput, onCompositionstart: this.handleCompositionStart, onCompositionend: this.handleCompositionEnd })), b("span", { ref: "patternInputMirrorRef", class: `${s}-base-selection-input-tag__mirror` }, this.pattern)) : null, T = h ? () => b("div", { class: `${s}-base-selection-tag-wrapper`, ref: "counterWrapperRef" }, b(Jv, { size: r, ref: "counterRef", onMouseenter: this.handleMouseEnterCounter, onMouseleave: this.handleMouseLeaveCounter, disabled: n })) : void 0;
      let A;
      if (g) {
        const R = this.selectedOptions.length - o;
        R > 0 && (A = b("div", { class: `${s}-base-selection-tag-wrapper`, key: "__counter__" }, b(Jv, { size: r, ref: "counterRef", onMouseenter: this.handleMouseEnterCounter, disabled: n }, {
          default: () => `+${R}`
        })));
      }
      const D = h ? i ? b(a3, { ref: "overflowRef", updateCounter: this.updateCounter, getCounter: this.getCounter, getTail: this.getTail, style: {
        width: "100%",
        display: "flex",
        overflow: "hidden"
      } }, {
        default: C,
        counter: T,
        tail: () => S
      }) : b(a3, { ref: "overflowRef", updateCounter: this.updateCounter, getCounter: this.getCounter, style: {
        width: "100%",
        display: "flex",
        overflow: "hidden"
      } }, {
        default: C,
        counter: T
      }) : g ? C().concat(A) : C(), E = m ? () => b("div", { class: `${s}-base-selection-popover` }, h ? C() : this.selectedOptions.map(y)) : void 0, N = m ? {
        show: this.showTagsPanel,
        trigger: "hover",
        overlap: !0,
        placement: "top",
        width: "trigger",
        onUpdateShow: this.onPopoverUpdateShow,
        theme: this.mergedTheme.peers.Popover,
        themeOverrides: this.mergedTheme.peerOverrides.Popover
      } : null, $ = (this.selected ? !1 : this.active ? !this.pattern && !this.isComposing : !0) ? b("div", { class: `${s}-base-selection-placeholder ${s}-base-selection-overlay` }, b("div", { class: `${s}-base-selection-placeholder__inner` }, this.placeholder)) : null, _ = i ? b("div", { ref: "patternInputWrapperRef", class: `${s}-base-selection-tags` }, D, h ? null : S, v) : b("div", { ref: "multipleElRef", class: `${s}-base-selection-tags`, tabindex: n ? void 0 : 0 }, D, v);
      w = b(Lr, null, m ? b(jc, Object.assign({}, N, { scrollable: !0, style: "max-height: calc(var(--v-target-height) * 6.6);" }), {
        trigger: () => _,
        default: E
      }) : _, $);
    } else if (i) {
      const x = this.pattern || this.isComposing, y = this.active ? !x : !this.selected, C = this.active ? !1 : this.selected;
      w = b("div", { ref: "patternInputWrapperRef", class: `${s}-base-selection-label` }, b("input", Object.assign({}, this.inputProps, { ref: "patternInputRef", class: `${s}-base-selection-input`, value: this.active ? this.pattern : "", placeholder: "", readonly: n, disabled: n, tabindex: -1, autofocus: this.autofocus, onFocus: this.handlePatternInputFocus, onBlur: this.handlePatternInputBlur, onInput: this.handlePatternInputInput, onCompositionstart: this.handleCompositionStart, onCompositionend: this.handleCompositionEnd })), C ? b("div", { class: `${s}-base-selection-label__render-label ${s}-base-selection-overlay`, key: "input" }, b("div", { class: `${s}-base-selection-overlay__wrapper` }, d ? d({
        option: this.selectedOption,
        handleClose: () => {
        }
      }) : f ? f(this.selectedOption, !0) : xn(this.label, this.selectedOption, !0))) : null, y ? b("div", { class: `${s}-base-selection-placeholder ${s}-base-selection-overlay`, key: "placeholder" }, b("div", { class: `${s}-base-selection-overlay__wrapper` }, this.filterablePlaceholder)) : null, v);
    } else
      w = b("div", { ref: "singleElRef", class: `${s}-base-selection-label`, tabindex: this.disabled ? void 0 : 0 }, this.label !== void 0 ? b("div", { class: `${s}-base-selection-input`, title: cU(this.label), key: "input" }, b("div", { class: `${s}-base-selection-input__content` }, d ? d({
        option: this.selectedOption,
        handleClose: () => {
        }
      }) : f ? f(this.selectedOption, !0) : xn(this.label, this.selectedOption, !0))) : b("div", { class: `${s}-base-selection-placeholder ${s}-base-selection-overlay`, key: "placeholder" }, b("div", { class: `${s}-base-selection-placeholder__inner` }, this.placeholder)), v);
    return b("div", { ref: "selfRef", class: [
      `${s}-base-selection`,
      this.themeClass,
      e && `${s}-base-selection--${e}-status`,
      {
        [`${s}-base-selection--active`]: this.active,
        [`${s}-base-selection--selected`]: this.selected || this.active && this.pattern,
        [`${s}-base-selection--disabled`]: this.disabled,
        [`${s}-base-selection--multiple`]: this.multiple,
        [`${s}-base-selection--focus`]: this.focused
      }
    ], style: this.cssVars, onClick: this.onClick, onMouseenter: this.handleMouseEnter, onMouseleave: this.handleMouseLeave, onKeydown: this.onKeydown, onFocusin: this.handleFocusin, onFocusout: this.handleFocusout, onMousedown: this.handleMouseDown }, w, a ? b("div", { class: `${s}-base-selection__border` }) : null, a ? b("div", { class: `${s}-base-selection__state-border` }) : null);
  }
}), jP = oe({
  name: "SlotMachineNumber",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    value: {
      type: [Number, String],
      required: !0
    },
    oldOriginalNumber: {
      type: Number,
      default: void 0
    },
    newOriginalNumber: {
      type: Number,
      default: void 0
    }
  },
  setup(e) {
    const t = G(null), r = G(e.value), n = G(e.value), i = G("up"), o = G(!1), a = j(() => o.value ? `${e.clsPrefix}-base-slot-machine-current-number--${i.value}-scroll` : null), s = j(() => o.value ? `${e.clsPrefix}-base-slot-machine-old-number--${i.value}-scroll` : null);
    Gt(tt(e, "value"), (f, h) => {
      r.value = h, n.value = f, an(u);
    });
    function u() {
      const f = e.newOriginalNumber, h = e.oldOriginalNumber;
      h === void 0 || f === void 0 || (f > h ? d("up") : h > f && d("down"));
    }
    function d(f) {
      i.value = f, o.value = !1, an(() => {
        var h;
        (h = t.value) === null || h === void 0 || h.offsetWidth, o.value = !0;
      });
    }
    return () => {
      const { clsPrefix: f } = e;
      return b("span", { ref: t, class: `${f}-base-slot-machine-number` }, r.value !== null ? b("span", { class: [
        `${f}-base-slot-machine-old-number ${f}-base-slot-machine-old-number--top`,
        s.value
      ] }, r.value) : null, b("span", { class: [
        `${f}-base-slot-machine-current-number`,
        a.value
      ] }, b("span", { ref: "numberWrapper", class: [
        `${f}-base-slot-machine-current-number__inner`,
        typeof e.value != "number" && `${f}-base-slot-machine-current-number__inner--not-number`
      ] }, n.value)), r.value !== null ? b("span", { class: [
        `${f}-base-slot-machine-old-number ${f}-base-slot-machine-old-number--bottom`,
        s.value
      ] }, r.value) : null);
    };
  }
});
const {
  cubicBezierEaseInOut: Zu
} = Wa;
function vH({
  duration: e = ".2s",
  delay: t = ".1s"
} = {}) {
  return [Y("&.fade-in-width-expand-transition-leave-from, &.fade-in-width-expand-transition-enter-to", {
    opacity: 1
  }), Y("&.fade-in-width-expand-transition-leave-to, &.fade-in-width-expand-transition-enter-from", `
 opacity: 0!important;
 margin-left: 0!important;
 margin-right: 0!important;
 `), Y("&.fade-in-width-expand-transition-leave-active", `
 overflow: hidden;
 transition:
 opacity ${e} ${Zu},
 max-width ${e} ${Zu} ${t},
 margin-left ${e} ${Zu} ${t},
 margin-right ${e} ${Zu} ${t};
 `), Y("&.fade-in-width-expand-transition-enter-active", `
 overflow: hidden;
 transition:
 opacity ${e} ${Zu} ${t},
 max-width ${e} ${Zu},
 margin-left ${e} ${Zu},
 margin-right ${e} ${Zu};
 `)];
}
const {
  cubicBezierEaseOut: Ah
} = Wa;
function Qhe({
  duration: e = ".2s"
} = {}) {
  return [Y("&.fade-up-width-expand-transition-leave-active", {
    transition: `
 opacity ${e} ${Ah},
 max-width ${e} ${Ah},
 transform ${e} ${Ah}
 `
  }), Y("&.fade-up-width-expand-transition-enter-active", {
    transition: `
 opacity ${e} ${Ah},
 max-width ${e} ${Ah},
 transform ${e} ${Ah}
 `
  }), Y("&.fade-up-width-expand-transition-enter-to", {
    opacity: 1,
    transform: "translateX(0) translateY(0)"
  }), Y("&.fade-up-width-expand-transition-enter-from", {
    maxWidth: "0 !important",
    opacity: 0,
    transform: "translateY(60%)"
  }), Y("&.fade-up-width-expand-transition-leave-from", {
    opacity: 1,
    transform: "translateY(0)"
  }), Y("&.fade-up-width-expand-transition-leave-to", {
    maxWidth: "0 !important",
    opacity: 0,
    transform: "translateY(60%)"
  })];
}
var qhe = Y([Y("@keyframes n-base-slot-machine-fade-up-in", `
 from {
 transform: translateY(60%);
 opacity: 0;
 }
 to {
 transform: translateY(0);
 opacity: 1;
 }
 `), Y("@keyframes n-base-slot-machine-fade-down-in", `
 from {
 transform: translateY(-60%);
 opacity: 0;
 }
 to {
 transform: translateY(0);
 opacity: 1;
 }
 `), Y("@keyframes n-base-slot-machine-fade-up-out", `
 from {
 transform: translateY(0%);
 opacity: 1;
 }
 to {
 transform: translateY(-60%);
 opacity: 0;
 }
 `), Y("@keyframes n-base-slot-machine-fade-down-out", `
 from {
 transform: translateY(0%);
 opacity: 1;
 }
 to {
 transform: translateY(60%);
 opacity: 0;
 }
 `), L("base-slot-machine", `
 overflow: hidden;
 white-space: nowrap;
 display: inline-block;
 height: 18px;
 line-height: 18px;
 `, [L("base-slot-machine-number", `
 display: inline-block;
 position: relative;
 height: 18px;
 width: .6em;
 max-width: .6em;
 `, [
  Qhe({
    duration: ".2s"
  }),
  vH({
    duration: ".2s",
    delay: "0s"
  }),
  L("base-slot-machine-old-number", `
 display: inline-block;
 opacity: 0;
 position: absolute;
 left: 0;
 right: 0;
 `, [K("top", {
    transform: "translateY(-100%)"
  }), K("bottom", {
    transform: "translateY(100%)"
  }), K("down-scroll", {
    animation: "n-base-slot-machine-fade-down-out .2s cubic-bezier(0, 0, .2, 1)",
    animationIterationCount: 1
  }), K("up-scroll", {
    animation: "n-base-slot-machine-fade-up-out .2s cubic-bezier(0, 0, .2, 1)",
    animationIterationCount: 1
  })]),
  L("base-slot-machine-current-number", `
 display: inline-block;
 position: absolute;
 left: 0;
 top: 0;
 bottom: 0;
 right: 0;
 opacity: 1;
 transform: translateY(0);
 width: .6em;
 `, [K("down-scroll", {
    animation: "n-base-slot-machine-fade-down-in .2s cubic-bezier(0, 0, .2, 1)",
    animationIterationCount: 1
  }), K("up-scroll", {
    animation: "n-base-slot-machine-fade-up-in .2s cubic-bezier(0, 0, .2, 1)",
    animationIterationCount: 1
  }), q("inner", `
 display: inline-block;
 position: absolute;
 right: 0;
 top: 0;
 width: .6em;
 `, [K("not-number", `
 right: unset;
 left: 0;
 `)])])
])])]), Ghe = oe({
  name: "BaseSlotMachine",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    value: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: Number,
      default: void 0
    },
    appeared: {
      type: Boolean,
      required: !0
    }
  },
  setup(e) {
    Vu("-base-slot-machine", qhe, tt(e, "clsPrefix"));
    const t = G(), r = G(), n = j(() => {
      if (typeof e.value == "string")
        return [];
      if (e.value < 1)
        return [0];
      const i = [];
      let o = e.value;
      for (e.max !== void 0 && (o = Math.min(e.max, o)); o >= 1; )
        i.push(o % 10), o /= 10, o = Math.floor(o);
      return i.reverse(), i;
    });
    return Gt(tt(e, "value"), (i, o) => {
      typeof i == "string" ? (r.value = void 0, t.value = void 0) : typeof o == "string" ? (r.value = i, t.value = void 0) : (r.value = i, t.value = o);
    }), () => {
      const { value: i, clsPrefix: o } = e;
      return typeof i == "number" ? b("span", { class: `${o}-base-slot-machine` }, b(jO, { name: "fade-up-width-expand-transition", tag: "span" }, {
        default: () => n.value.map((a, s) => b(jP, { clsPrefix: o, key: n.value.length - s - 1, oldOriginalNumber: t.value, newOriginalNumber: r.value, value: a }))
      }), b(ph, { key: "+", width: !0 }, {
        default: () => e.max !== void 0 && e.max < i ? b(jP, { clsPrefix: o, value: "+" }) : null
      })) : b("span", { class: `${o}-base-slot-machine` }, i);
    };
  }
}), Zhe = {
  iconMargin: "11px 8px 0 12px",
  iconMarginRtl: "11px 12px 0 8px",
  iconSize: "24px",
  closeIconSize: "16px",
  closeSize: "20px",
  closeMargin: "13px 14px 0 0",
  closeMarginRtl: "13px 0 0 14px",
  padding: "13px"
};
const Khe = (e) => {
  const { lineHeight: t, borderRadius: r, fontWeightStrong: n, baseColor: i, dividerColor: o, actionColor: a, textColor1: s, textColor2: u, closeColorHover: d, closeColorPressed: f, closeIconColor: h, closeIconColorHover: g, closeIconColorPressed: m, infoColor: v, successColor: w, warningColor: x, errorColor: y, fontSize: C } = e;
  return Object.assign(Object.assign({}, Zhe), {
    fontSize: C,
    lineHeight: t,
    titleFontWeight: n,
    borderRadius: r,
    border: `1px solid ${o}`,
    color: a,
    titleTextColor: s,
    iconColor: u,
    contentTextColor: u,
    closeBorderRadius: r,
    closeColorHover: d,
    closeColorPressed: f,
    closeIconColor: h,
    closeIconColorHover: g,
    closeIconColorPressed: m,
    borderInfo: `1px solid ${nn(i, nr(v, { alpha: 0.25 }))}`,
    colorInfo: nn(i, nr(v, { alpha: 0.08 })),
    titleTextColorInfo: s,
    iconColorInfo: v,
    contentTextColorInfo: u,
    closeColorHoverInfo: d,
    closeColorPressedInfo: f,
    closeIconColorInfo: h,
    closeIconColorHoverInfo: g,
    closeIconColorPressedInfo: m,
    borderSuccess: `1px solid ${nn(i, nr(w, { alpha: 0.25 }))}`,
    colorSuccess: nn(i, nr(w, { alpha: 0.08 })),
    titleTextColorSuccess: s,
    iconColorSuccess: w,
    contentTextColorSuccess: u,
    closeColorHoverSuccess: d,
    closeColorPressedSuccess: f,
    closeIconColorSuccess: h,
    closeIconColorHoverSuccess: g,
    closeIconColorPressedSuccess: m,
    borderWarning: `1px solid ${nn(i, nr(x, { alpha: 0.33 }))}`,
    colorWarning: nn(i, nr(x, { alpha: 0.08 })),
    titleTextColorWarning: s,
    iconColorWarning: x,
    contentTextColorWarning: u,
    closeColorHoverWarning: d,
    closeColorPressedWarning: f,
    closeIconColorWarning: h,
    closeIconColorHoverWarning: g,
    closeIconColorPressedWarning: m,
    borderError: `1px solid ${nn(i, nr(y, { alpha: 0.25 }))}`,
    colorError: nn(i, nr(y, { alpha: 0.08 })),
    titleTextColorError: s,
    iconColorError: y,
    contentTextColorError: u,
    closeColorHoverError: d,
    closeColorPressedError: f,
    closeIconColorError: h,
    closeIconColorHoverError: g,
    closeIconColorPressedError: m
  });
}, Xhe = {
  name: "Alert",
  common: Sr,
  self: Khe
};
var Jhe = Xhe;
const {
  cubicBezierEaseInOut: ns,
  cubicBezierEaseOut: epe,
  cubicBezierEaseIn: tpe
} = Wa;
function D0({
  overflow: e = "hidden",
  duration: t = ".3s",
  originalTransition: r = "",
  leavingDelay: n = "0s",
  foldPadding: i = !1,
  enterToProps: o = void 0,
  leaveToProps: a = void 0,
  reverse: s = !1
} = {}) {
  const u = s ? "leave" : "enter", d = s ? "enter" : "leave";
  return [Y(`&.fade-in-height-expand-transition-${d}-from,
 &.fade-in-height-expand-transition-${u}-to`, Object.assign(Object.assign({}, o), {
    opacity: 1
  })), Y(`&.fade-in-height-expand-transition-${d}-to,
 &.fade-in-height-expand-transition-${u}-from`, Object.assign(Object.assign({}, a), {
    opacity: 0,
    marginTop: "0 !important",
    marginBottom: "0 !important",
    paddingTop: i ? "0 !important" : void 0,
    paddingBottom: i ? "0 !important" : void 0
  })), Y(`&.fade-in-height-expand-transition-${d}-active`, `
 overflow: ${e};
 transition:
 max-height ${t} ${ns} ${n},
 opacity ${t} ${epe} ${n},
 margin-top ${t} ${ns} ${n},
 margin-bottom ${t} ${ns} ${n},
 padding-top ${t} ${ns} ${n},
 padding-bottom ${t} ${ns} ${n}
 ${r ? "," + r : ""}
 `), Y(`&.fade-in-height-expand-transition-${u}-active`, `
 overflow: ${e};
 transition:
 max-height ${t} ${ns},
 opacity ${t} ${tpe},
 margin-top ${t} ${ns},
 margin-bottom ${t} ${ns},
 padding-top ${t} ${ns},
 padding-bottom ${t} ${ns}
 ${r ? "," + r : ""}
 `)];
}
var rpe = L("alert", `
 line-height: var(--n-line-height);
 border-radius: var(--n-border-radius);
 position: relative;
 transition: background-color .3s var(--n-bezier);
 background-color: var(--n-color);
 text-align: start;
 word-break: break-word;
`, [q("border", `
 border-radius: inherit;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 transition: border-color .3s var(--n-bezier);
 border: var(--n-border);
 pointer-events: none;
 `), K("closable", [L("alert-body", [q("title", `
 padding-right: 24px;
 `)])]), q("icon", {
  color: "var(--n-icon-color)"
}), L("alert-body", {
  padding: "var(--n-padding)"
}, [q("title", {
  color: "var(--n-title-text-color)"
}), q("content", {
  color: "var(--n-content-text-color)"
})]), D0({
  originalTransition: "transform .3s var(--n-bezier)",
  enterToProps: {
    transform: "scale(1)"
  },
  leaveToProps: {
    transform: "scale(0.9)"
  }
}), q("icon", `
 position: absolute;
 left: 0;
 top: 0;
 align-items: center;
 justify-content: center;
 display: flex;
 width: var(--n-icon-size);
 height: var(--n-icon-size);
 font-size: var(--n-icon-size);
 margin: var(--n-icon-margin);
 `), q("close", `
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 position: absolute;
 right: 0;
 top: 0;
 margin: var(--n-close-margin);
 `), K("show-icon", [L("alert-body", {
  paddingLeft: "calc(var(--n-icon-margin-left) + var(--n-icon-size) + var(--n-icon-margin-right))"
})]), L("alert-body", `
 border-radius: var(--n-border-radius);
 transition: border-color .3s var(--n-bezier);
 `, [q("title", `
 transition: color .3s var(--n-bezier);
 font-size: 16px;
 line-height: 19px;
 font-weight: var(--n-title-font-weight);
 `, [Y("& +", [q("content", {
  marginTop: "9px"
})])]), q("content", {
  transition: "color .3s var(--n-bezier)",
  fontSize: "var(--n-font-size)"
})]), q("icon", {
  transition: "color .3s var(--n-bezier)"
})]);
const npe = Object.assign(Object.assign({}, ft.props), {
  title: String,
  showIcon: {
    type: Boolean,
    default: !0
  },
  type: {
    type: String,
    default: "default"
  },
  bordered: {
    type: Boolean,
    default: !0
  },
  closable: Boolean,
  onClose: Function,
  onAfterLeave: Function,
  onAfterHide: Function
});
var ipe = oe({
  name: "Alert",
  inheritAttrs: !1,
  props: npe,
  setup(e) {
    const { mergedClsPrefixRef: t, mergedBorderedRef: r, inlineThemeDisabled: n, mergedRtlRef: i } = Yt(e), o = ft("Alert", "-alert", rpe, Jhe, e, t), a = Li("Alert", i, t), s = j(() => {
      const { common: { cubicBezierEaseInOut: m }, self: v } = o.value, { fontSize: w, borderRadius: x, titleFontWeight: y, lineHeight: C, iconSize: S, iconMargin: T, iconMarginRtl: A, closeIconSize: D, closeBorderRadius: E, closeSize: N, closeMargin: I, closeMarginRtl: $, padding: _ } = v, { type: R } = e, { left: U, right: Q } = Ll(T);
      return {
        "--n-bezier": m,
        "--n-color": v[Be("color", R)],
        "--n-close-icon-size": D,
        "--n-close-border-radius": E,
        "--n-close-color-hover": v[Be("closeColorHover", R)],
        "--n-close-color-pressed": v[Be("closeColorPressed", R)],
        "--n-close-icon-color": v[Be("closeIconColor", R)],
        "--n-close-icon-color-hover": v[Be("closeIconColorHover", R)],
        "--n-close-icon-color-pressed": v[Be("closeIconColorPressed", R)],
        "--n-icon-color": v[Be("iconColor", R)],
        "--n-border": v[Be("border", R)],
        "--n-title-text-color": v[Be("titleTextColor", R)],
        "--n-content-text-color": v[Be("contentTextColor", R)],
        "--n-line-height": C,
        "--n-border-radius": x,
        "--n-font-size": w,
        "--n-title-font-weight": y,
        "--n-icon-size": S,
        "--n-icon-margin": T,
        "--n-icon-margin-rtl": A,
        "--n-close-size": N,
        "--n-close-margin": I,
        "--n-close-margin-rtl": $,
        "--n-padding": _,
        "--n-icon-margin-left": U,
        "--n-icon-margin-right": Q
      };
    }), u = n ? Cr("alert", j(() => e.type[0]), s, e) : void 0, d = G(!0), f = () => {
      const {
        onAfterLeave: m,
        onAfterHide: v
      } = e;
      m && m(), v && v();
    };
    return {
      rtlEnabled: a,
      mergedClsPrefix: t,
      mergedBordered: r,
      visible: d,
      handleCloseClick: () => {
        var m;
        Promise.resolve((m = e.onClose) === null || m === void 0 ? void 0 : m.call(e)).then((v) => {
          v !== !1 && (d.value = !1);
        });
      },
      handleAfterLeave: () => {
        f();
      },
      mergedTheme: o,
      cssVars: n ? void 0 : s,
      themeClass: u == null ? void 0 : u.themeClass,
      onRender: u == null ? void 0 : u.onRender
    };
  },
  render() {
    var e;
    return (e = this.onRender) === null || e === void 0 || e.call(this), b(ph, { onAfterLeave: this.handleAfterLeave }, {
      default: () => {
        const { mergedClsPrefix: t, $slots: r } = this, n = {
          class: [
            `${t}-alert`,
            this.themeClass,
            this.closable && `${t}-alert--closable`,
            this.showIcon && `${t}-alert--show-icon`,
            this.rtlEnabled && `${t}-alert--rtl`
          ],
          style: this.cssVars,
          role: "alert"
        };
        return this.visible ? b("div", Object.assign({}, ir(this.$attrs, n)), this.closable && b(gh, { clsPrefix: t, class: `${t}-alert__close`, onClick: this.handleCloseClick }), this.bordered && b("div", { class: `${t}-alert__border` }), this.showIcon && b("div", { class: `${t}-alert__icon`, "aria-hidden": "true" }, vr(r.icon, () => [
          b(fr, { clsPrefix: t }, {
            default: () => {
              switch (this.type) {
                case "success":
                  return b(xb, null);
                case "info":
                  return b(vp, null);
                case "warning":
                  return b(wb, null);
                case "error":
                  return b(yb, null);
                default:
                  return null;
              }
            }
          })
        ])), b("div", { class: [
          `${t}-alert-body`,
          this.mergedBordered && `${t}-alert-body--bordered`
        ] }, Fr(r.header, (i) => {
          const o = i || this.title;
          return o ? b("div", { class: `${t}-alert-body__title` }, o) : null;
        }), r.default && b("div", { class: `${t}-alert-body__content` }, r))) : null;
      }
    });
  }
});
function ix(e) {
  return e.type === "group";
}
function bH(e) {
  return e.type === "ignored";
}
function FI(e, t) {
  try {
    return !!(1 + t.toString().toLowerCase().indexOf(e.trim().toLowerCase()));
  } catch {
    return !1;
  }
}
function yH(e, t) {
  return {
    getIsGroup: ix,
    getIgnored: bH,
    getKey(n) {
      return ix(n) ? n.name || n.key || "key-required" : n[e];
    },
    getChildren(n) {
      return n[t];
    }
  };
}
function ope(e, t, r, n) {
  if (!t)
    return e;
  function i(o) {
    if (!Array.isArray(o))
      return [];
    const a = [];
    for (const s of o)
      if (ix(s)) {
        const u = i(s[n]);
        u.length && a.push(Object.assign({}, s, {
          [n]: u
        }));
      } else {
        if (bH(s))
          continue;
        t(r, s) && a.push(s);
      }
    return a;
  }
  return i(e);
}
function ape(e, t, r) {
  const n = /* @__PURE__ */ new Map();
  return e.forEach((i) => {
    ix(i) ? i[r].forEach((o) => {
      n.set(o[t], o);
    }) : n.set(i[t], i);
  }), n;
}
const lpe = Is && "chrome" in window;
Is && navigator.userAgent.includes("Firefox");
const xH = Is && navigator.userAgent.includes("Safari") && !lpe;
var spe = {
  paddingTiny: "0 8px",
  paddingSmall: "0 10px",
  paddingMedium: "0 12px",
  paddingLarge: "0 14px",
  clearSize: "16px"
};
const upe = (e) => {
  const { textColor2: t, textColor3: r, textColorDisabled: n, primaryColor: i, primaryColorHover: o, inputColor: a, inputColorDisabled: s, borderColor: u, warningColor: d, warningColorHover: f, errorColor: h, errorColorHover: g, borderRadius: m, lineHeight: v, fontSizeTiny: w, fontSizeSmall: x, fontSizeMedium: y, fontSizeLarge: C, heightTiny: S, heightSmall: T, heightMedium: A, heightLarge: D, actionColor: E, clearColor: N, clearColorHover: I, clearColorPressed: $, placeholderColor: _, placeholderColorDisabled: R, iconColor: U, iconColorDisabled: Q, iconColorHover: Z, iconColorPressed: X } = e;
  return Object.assign(Object.assign({}, spe), {
    countTextColorDisabled: n,
    countTextColor: r,
    heightTiny: S,
    heightSmall: T,
    heightMedium: A,
    heightLarge: D,
    fontSizeTiny: w,
    fontSizeSmall: x,
    fontSizeMedium: y,
    fontSizeLarge: C,
    lineHeight: v,
    lineHeightTextarea: v,
    borderRadius: m,
    iconSize: "16px",
    groupLabelColor: E,
    groupLabelTextColor: t,
    textColor: t,
    textColorDisabled: n,
    textDecorationColor: t,
    caretColor: i,
    placeholderColor: _,
    placeholderColorDisabled: R,
    color: a,
    colorDisabled: s,
    colorFocus: a,
    groupLabelBorder: `1px solid ${u}`,
    border: `1px solid ${u}`,
    borderHover: `1px solid ${o}`,
    borderDisabled: `1px solid ${u}`,
    borderFocus: `1px solid ${o}`,
    boxShadowFocus: `0 0 0 2px ${nr(i, { alpha: 0.2 })}`,
    loadingColor: i,
    loadingColorWarning: d,
    borderWarning: `1px solid ${d}`,
    borderHoverWarning: `1px solid ${f}`,
    colorFocusWarning: a,
    borderFocusWarning: `1px solid ${f}`,
    boxShadowFocusWarning: `0 0 0 2px ${nr(d, {
      alpha: 0.2
    })}`,
    caretColorWarning: d,
    loadingColorError: h,
    borderError: `1px solid ${h}`,
    borderHoverError: `1px solid ${g}`,
    colorFocusError: a,
    borderFocusError: `1px solid ${g}`,
    boxShadowFocusError: `0 0 0 2px ${nr(h, {
      alpha: 0.2
    })}`,
    caretColorError: h,
    clearColor: N,
    clearColorHover: I,
    clearColorPressed: $,
    iconColor: U,
    iconColorDisabled: Q,
    iconColorHover: Z,
    iconColorPressed: X,
    suffixTextColor: t
  });
}, cpe = {
  name: "Input",
  common: Sr,
  self: upe
};
var Fc = cpe;
const wH = "n-input";
function dpe(e) {
  let t = 0;
  for (const r of e)
    t++;
  return t;
}
function ay(e) {
  return e === "" || e == null;
}
function fpe(e) {
  const t = G(null);
  function r() {
    const { value: o } = e;
    if (!(o != null && o.focus)) {
      i();
      return;
    }
    const { selectionStart: a, selectionEnd: s, value: u } = o;
    if (a == null || s == null) {
      i();
      return;
    }
    t.value = {
      start: a,
      end: s,
      beforeText: u.slice(0, a),
      afterText: u.slice(s)
    };
  }
  function n() {
    var o;
    const { value: a } = t, { value: s } = e;
    if (!a || !s)
      return;
    const { value: u } = s, { start: d, beforeText: f, afterText: h } = a;
    let g = u.length;
    if (u.endsWith(h))
      g = u.length - h.length;
    else if (u.startsWith(f))
      g = f.length;
    else {
      const m = f[d - 1], v = u.indexOf(m, d - 1);
      v !== -1 && (g = v + 1);
    }
    (o = s.setSelectionRange) === null || o === void 0 || o.call(s, g, g);
  }
  function i() {
    t.value = null;
  }
  return Gt(e, i), {
    recordCursor: r,
    restoreCursor: n
  };
}
var FP = oe({
  name: "InputWordCount",
  setup(e, { slots: t }) {
    const { mergedValueRef: r, maxlengthRef: n, mergedClsPrefixRef: i, countGraphemesRef: o } = lt(wH), a = j(() => {
      const { value: s } = r;
      return s === null || Array.isArray(s) ? 0 : (o.value || dpe)(s);
    });
    return () => {
      const { value: s } = n, { value: u } = r;
      return b("span", { class: `${i.value}-input-word-count` }, v0(t.default, {
        value: u === null || Array.isArray(u) ? "" : u
      }, () => [
        s === void 0 ? a.value : `${a.value} / ${s}`
      ]));
    };
  }
}), hpe = L("input", `
 max-width: 100%;
 cursor: text;
 line-height: 1.5;
 z-index: auto;
 outline: none;
 box-sizing: border-box;
 position: relative;
 display: inline-flex;
 border-radius: var(--n-border-radius);
 background-color: var(--n-color);
 transition: background-color .3s var(--n-bezier);
 font-size: var(--n-font-size);
 --n-padding-vertical: calc((var(--n-height) - 1.5 * var(--n-font-size)) / 2);
`, [
  q("input, textarea", `
 overflow: hidden;
 flex-grow: 1;
 position: relative;
 `),
  q("input-el, textarea-el, input-mirror, textarea-mirror, separator, placeholder", `
 box-sizing: border-box;
 font-size: inherit;
 line-height: 1.5;
 font-family: inherit;
 border: none;
 outline: none;
 background-color: #0000;
 text-align: inherit;
 transition:
 -webkit-text-fill-color .3s var(--n-bezier),
 caret-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 text-decoration-color .3s var(--n-bezier);
 `),
  q("input-el, textarea-el", `
 -webkit-appearance: none;
 scrollbar-width: none;
 width: 100%;
 min-width: 0;
 text-decoration-color: var(--n-text-decoration-color);
 color: var(--n-text-color);
 caret-color: var(--n-caret-color);
 background-color: transparent;
 `, [Y("&::-webkit-scrollbar, &::-webkit-scrollbar-track-piece, &::-webkit-scrollbar-thumb", `
 width: 0;
 height: 0;
 display: none;
 `), Y("&::placeholder", `
 color: #0000;
 -webkit-text-fill-color: transparent !important;
 `), Y("&:-webkit-autofill ~", [q("placeholder", "display: none;")])]),
  K("round", [wr("textarea", "border-radius: calc(var(--n-height) / 2);")]),
  q("placeholder", `
 pointer-events: none;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 overflow: hidden;
 color: var(--n-placeholder-color);
 `, [Y("span", `
 width: 100%;
 display: inline-block;
 `)]),
  K("textarea", [q("placeholder", "overflow: visible;")]),
  wr("autosize", "width: 100%;"),
  K("autosize", [q("textarea-el, input-el", `
 position: absolute;
 top: 0;
 left: 0;
 height: 100%;
 `)]),
  L("input-wrapper", `
 overflow: hidden;
 display: inline-flex;
 flex-grow: 1;
 position: relative;
 padding-left: var(--n-padding-left);
 padding-right: var(--n-padding-right);
 `),
  q("input-mirror", `
 padding: 0;
 height: var(--n-height);
 line-height: var(--n-height);
 overflow: hidden;
 visibility: hidden;
 position: static;
 white-space: pre;
 pointer-events: none;
 `),
  q("input-el", `
 padding: 0;
 height: var(--n-height);
 line-height: var(--n-height);
 `, [Y("+", [q("placeholder", `
 display: flex;
 align-items: center; 
 `)])]),
  wr("textarea", [q("placeholder", "white-space: nowrap;")]),
  q("eye", `
 display: flex;
 align-items: center;
 justify-content: center;
 transition: color .3s var(--n-bezier);
 `),
  K("textarea", "width: 100%;", [L("input-word-count", `
 position: absolute;
 right: var(--n-padding-right);
 bottom: var(--n-padding-vertical);
 `), K("resizable", [L("input-wrapper", `
 resize: vertical;
 min-height: var(--n-height);
 `)]), q("textarea-el, textarea-mirror, placeholder", `
 height: 100%;
 padding-left: 0;
 padding-right: 0;
 padding-top: var(--n-padding-vertical);
 padding-bottom: var(--n-padding-vertical);
 word-break: break-word;
 display: inline-block;
 vertical-align: bottom;
 box-sizing: border-box;
 line-height: var(--n-line-height-textarea);
 margin: 0;
 resize: none;
 white-space: pre-wrap;
 `), q("textarea-mirror", `
 width: 100%;
 pointer-events: none;
 overflow: hidden;
 visibility: hidden;
 position: static;
 white-space: pre-wrap;
 overflow-wrap: break-word;
 `)]),
  K("pair", [q("input-el, placeholder", "text-align: center;"), q("separator", `
 display: flex;
 align-items: center;
 transition: color .3s var(--n-bezier);
 color: var(--n-text-color);
 white-space: nowrap;
 `, [L("icon", `
 color: var(--n-icon-color);
 `), L("base-icon", `
 color: var(--n-icon-color);
 `)])]),
  K("disabled", `
 cursor: not-allowed;
 background-color: var(--n-color-disabled);
 `, [q("border", "border: var(--n-border-disabled);"), q("input-el, textarea-el", `
 cursor: not-allowed;
 color: var(--n-text-color-disabled);
 text-decoration-color: var(--n-text-color-disabled);
 `), q("placeholder", "color: var(--n-placeholder-color-disabled);"), q("separator", "color: var(--n-text-color-disabled);", [L("icon", `
 color: var(--n-icon-color-disabled);
 `), L("base-icon", `
 color: var(--n-icon-color-disabled);
 `)]), L("input-word-count", `
 color: var(--n-count-text-color-disabled);
 `), q("suffix, prefix", "color: var(--n-text-color-disabled);", [L("icon", `
 color: var(--n-icon-color-disabled);
 `), L("internal-icon", `
 color: var(--n-icon-color-disabled);
 `)])]),
  wr("disabled", [q("eye", `
 color: var(--n-icon-color);
 cursor: pointer;
 `, [Y("&:hover", `
 color: var(--n-icon-color-hover);
 `), Y("&:active", `
 color: var(--n-icon-color-pressed);
 `)]), Y("&:hover", [q("state-border", "border: var(--n-border-hover);")]), K("focus", "background-color: var(--n-color-focus);", [q("state-border", `
 border: var(--n-border-focus);
 box-shadow: var(--n-box-shadow-focus);
 `)])]),
  q("border, state-border", `
 box-sizing: border-box;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 pointer-events: none;
 border-radius: inherit;
 border: var(--n-border);
 transition:
 box-shadow .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `),
  q("state-border", `
 border-color: #0000;
 z-index: 1;
 `),
  q("prefix", "margin-right: 4px;"),
  q("suffix", `
 margin-left: 4px;
 `),
  q("suffix, prefix", `
 transition: color .3s var(--n-bezier);
 flex-wrap: nowrap;
 flex-shrink: 0;
 line-height: var(--n-height);
 white-space: nowrap;
 display: inline-flex;
 align-items: center;
 justify-content: center;
 color: var(--n-suffix-text-color);
 `, [L("base-loading", `
 font-size: var(--n-icon-size);
 margin: 0 2px;
 color: var(--n-loading-color);
 `), L("base-clear", `
 font-size: var(--n-icon-size);
 `, [q("placeholder", [L("base-icon", `
 transition: color .3s var(--n-bezier);
 color: var(--n-icon-color);
 font-size: var(--n-icon-size);
 `)])]), Y(">", [L("icon", `
 transition: color .3s var(--n-bezier);
 color: var(--n-icon-color);
 font-size: var(--n-icon-size);
 `)]), L("base-icon", `
 font-size: var(--n-icon-size);
 `)]),
  L("input-word-count", `
 pointer-events: none;
 line-height: 1.5;
 font-size: .85em;
 color: var(--n-count-text-color);
 transition: color .3s var(--n-bezier);
 margin-left: 4px;
 font-variant: tabular-nums;
 `),
  ["warning", "error"].map((e) => K(`${e}-status`, [wr("disabled", [L("base-loading", `
 color: var(--n-loading-color-${e})
 `), q("input-el, textarea-el", `
 caret-color: var(--n-caret-color-${e});
 `), q("state-border", `
 border: var(--n-border-${e});
 `), Y("&:hover", [q("state-border", `
 border: var(--n-border-hover-${e});
 `)]), Y("&:focus", `
 background-color: var(--n-color-focus-${e});
 `, [q("state-border", `
 box-shadow: var(--n-box-shadow-focus-${e});
 border: var(--n-border-focus-${e});
 `)]), K("focus", `
 background-color: var(--n-color-focus-${e});
 `, [q("state-border", `
 box-shadow: var(--n-box-shadow-focus-${e});
 border: var(--n-border-focus-${e});
 `)])])]))
]);
const ppe = L("input", [K("disabled", [q("input-el, textarea-el", `
 -webkit-text-fill-color: var(--n-text-color-disabled);
 `)])]), gpe = Object.assign(Object.assign({}, ft.props), {
  bordered: {
    type: Boolean,
    default: void 0
  },
  type: {
    type: String,
    default: "text"
  },
  placeholder: [Array, String],
  defaultValue: {
    type: [String, Array],
    default: null
  },
  value: [String, Array],
  disabled: {
    type: Boolean,
    default: void 0
  },
  size: String,
  rows: {
    type: [Number, String],
    default: 3
  },
  round: Boolean,
  minlength: [String, Number],
  maxlength: [String, Number],
  clearable: Boolean,
  autosize: {
    type: [Boolean, Object],
    default: !1
  },
  pair: Boolean,
  separator: String,
  readonly: {
    type: [String, Boolean],
    default: !1
  },
  passivelyActivated: Boolean,
  showPasswordOn: String,
  stateful: {
    type: Boolean,
    default: !0
  },
  autofocus: Boolean,
  inputProps: Object,
  resizable: {
    type: Boolean,
    default: !0
  },
  showCount: Boolean,
  loading: {
    type: Boolean,
    default: void 0
  },
  allowInput: Function,
  renderCount: Function,
  onMousedown: Function,
  onKeydown: Function,
  onKeyup: Function,
  onInput: [Function, Array],
  onFocus: [Function, Array],
  onBlur: [Function, Array],
  onClick: [Function, Array],
  onChange: [Function, Array],
  onClear: [Function, Array],
  countGraphemes: Function,
  status: String,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  textDecoration: [String, Array],
  attrSize: {
    type: Number,
    default: 20
  },
  onInputBlur: [Function, Array],
  onInputFocus: [Function, Array],
  onDeactivate: [Function, Array],
  onActivate: [Function, Array],
  onWrapperFocus: [Function, Array],
  onWrapperBlur: [Function, Array],
  internalDeactivateOnEnter: Boolean,
  internalForceFocus: Boolean,
  internalLoadingBeforeSuffix: Boolean,
  showPasswordToggle: Boolean
});
var pa = oe({
  name: "Input",
  props: gpe,
  setup(e) {
    const { mergedClsPrefixRef: t, mergedBorderedRef: r, inlineThemeDisabled: n, mergedRtlRef: i } = Yt(e), o = ft("Input", "-input", hpe, Fc, e, t);
    xH && Vu("-input-safari", ppe, t);
    const a = G(null), s = G(null), u = G(null), d = G(null), f = G(null), h = G(null), g = G(null), m = fpe(g), v = G(null), { localeRef: w } = Zl("Input"), x = G(e.defaultValue), y = tt(e, "value"), C = dn(y, x), S = ta(e), { mergedSizeRef: T, mergedDisabledRef: A, mergedStatusRef: D } = S, E = G(!1), N = G(!1), I = G(!1), $ = G(!1);
    let _ = null;
    const R = j(() => {
      const { placeholder: ge, pair: Fe } = e;
      return Fe ? Array.isArray(ge) ? ge : ge === void 0 ? ["", ""] : [ge, ge] : ge === void 0 ? [w.value.placeholder] : [ge];
    }), U = j(() => {
      const { value: ge } = I, { value: Fe } = C, { value: Tt } = R;
      return !ge && (ay(Fe) || Array.isArray(Fe) && ay(Fe[0])) && Tt[0];
    }), Q = j(() => {
      const { value: ge } = I, { value: Fe } = C, { value: Tt } = R;
      return !ge && Tt[1] && (ay(Fe) || Array.isArray(Fe) && ay(Fe[1]));
    }), Z = _r(() => e.internalForceFocus || E.value), X = _r(() => {
      if (A.value || e.readonly || !e.clearable || !Z.value && !N.value)
        return !1;
      const { value: ge } = C, { value: Fe } = Z;
      return e.pair ? !!(Array.isArray(ge) && (ge[0] || ge[1])) && (N.value || Fe) : !!ge && (N.value || Fe);
    }), re = j(() => {
      const { showPasswordOn: ge } = e;
      if (ge)
        return ge;
      if (e.showPasswordToggle)
        return "click";
    }), ue = G(!1), he = j(() => {
      const { textDecoration: ge } = e;
      return ge ? Array.isArray(ge) ? ge.map((Fe) => ({
        textDecoration: Fe
      })) : [
        {
          textDecoration: ge
        }
      ] : ["", ""];
    }), te = G(void 0), de = () => {
      var ge, Fe;
      if (e.type === "textarea") {
        const { autosize: Tt } = e;
        if (Tt && (te.value = (Fe = (ge = v.value) === null || ge === void 0 ? void 0 : ge.$el) === null || Fe === void 0 ? void 0 : Fe.offsetWidth), !s.value || typeof Tt == "boolean")
          return;
        const { paddingTop: lr, paddingBottom: gr, lineHeight: Or } = window.getComputedStyle(s.value), ri = Number(lr.slice(0, -2)), xi = Number(gr.slice(0, -2)), wi = Number(Or.slice(0, -2)), { value: Pi } = u;
        if (!Pi)
          return;
        if (Tt.minRows) {
          const Mi = Math.max(Tt.minRows, 1), ze = `${ri + xi + wi * Mi}px`;
          Pi.style.minHeight = ze;
        }
        if (Tt.maxRows) {
          const Mi = `${ri + xi + wi * Tt.maxRows}px`;
          Pi.style.maxHeight = Mi;
        }
      }
    }, De = j(() => {
      const { maxlength: ge } = e;
      return ge === void 0 ? void 0 : Number(ge);
    });
    br(() => {
      const { value: ge } = C;
      Array.isArray(ge) || Ze(ge);
    });
    const Oe = uh().proxy;
    function Qe(ge) {
      const { onUpdateValue: Fe, "onUpdate:value": Tt, onInput: lr } = e, { nTriggerFormInput: gr } = S;
      Fe && je(Fe, ge), Tt && je(Tt, ge), lr && je(lr, ge), x.value = ge, gr();
    }
    function Ae(ge) {
      const { onChange: Fe } = e, { nTriggerFormChange: Tt } = S;
      Fe && je(Fe, ge), x.value = ge, Tt();
    }
    function Ne(ge) {
      const { onBlur: Fe } = e, { nTriggerFormBlur: Tt } = S;
      Fe && je(Fe, ge), Tt();
    }
    function $e(ge) {
      const { onFocus: Fe } = e, { nTriggerFormFocus: Tt } = S;
      Fe && je(Fe, ge), Tt();
    }
    function et(ge) {
      const { onClear: Fe } = e;
      Fe && je(Fe, ge);
    }
    function Ge(ge) {
      const { onInputBlur: Fe } = e;
      Fe && je(Fe, ge);
    }
    function Ee(ge) {
      const { onInputFocus: Fe } = e;
      Fe && je(Fe, ge);
    }
    function qe() {
      const { onDeactivate: ge } = e;
      ge && je(ge);
    }
    function Ue() {
      const { onActivate: ge } = e;
      ge && je(ge);
    }
    function ot(ge) {
      const { onClick: Fe } = e;
      Fe && je(Fe, ge);
    }
    function Ie(ge) {
      const { onWrapperFocus: Fe } = e;
      Fe && je(Fe, ge);
    }
    function rt(ge) {
      const { onWrapperBlur: Fe } = e;
      Fe && je(Fe, ge);
    }
    function W() {
      I.value = !0;
    }
    function P(ge) {
      I.value = !1, ge.target === h.value ? H(ge, 1) : H(ge, 0);
    }
    function H(ge, Fe = 0, Tt = "input") {
      const lr = ge.target.value;
      if (Ze(lr), ge instanceof InputEvent && !ge.isComposing && (I.value = !1), e.type === "textarea") {
        const { value: Or } = v;
        Or && Or.syncUnifiedContainer();
      }
      if (_ = lr, I.value)
        return;
      m.recordCursor();
      const gr = se(lr);
      if (gr)
        if (!e.pair)
          Tt === "input" ? Qe(lr) : Ae(lr);
        else {
          let { value: Or } = C;
          Array.isArray(Or) ? Or = [Or[0], Or[1]] : Or = ["", ""], Or[Fe] = lr, Tt === "input" ? Qe(Or) : Ae(Or);
        }
      Oe.$forceUpdate(), gr || an(m.restoreCursor);
    }
    function se(ge) {
      const { countGraphemes: Fe, maxlength: Tt, minlength: lr } = e;
      if (Fe) {
        let Or;
        if (Tt !== void 0 && (Or === void 0 && (Or = Fe(ge)), Or > Number(Tt)) || lr !== void 0 && (Or === void 0 && (Or = Fe(ge)), Or < Number(Tt)))
          return !1;
      }
      const { allowInput: gr } = e;
      return typeof gr == "function" ? gr(ge) : !0;
    }
    function pe(ge) {
      Ge(ge), ge.relatedTarget === a.value && qe(), ge.relatedTarget !== null && (ge.relatedTarget === f.value || ge.relatedTarget === h.value || ge.relatedTarget === s.value) || ($.value = !1), ke(ge, "blur"), g.value = null;
    }
    function ae(ge, Fe) {
      Ee(ge), E.value = !0, $.value = !0, Ue(), ke(ge, "focus"), Fe === 0 ? g.value = f.value : Fe === 1 ? g.value = h.value : Fe === 2 && (g.value = s.value);
    }
    function Me(ge) {
      e.passivelyActivated && (rt(ge), ke(ge, "blur"));
    }
    function fe(ge) {
      e.passivelyActivated && (E.value = !0, Ie(ge), ke(ge, "focus"));
    }
    function ke(ge, Fe) {
      ge.relatedTarget !== null && (ge.relatedTarget === f.value || ge.relatedTarget === h.value || ge.relatedTarget === s.value || ge.relatedTarget === a.value) || (Fe === "focus" ? ($e(ge), E.value = !0) : Fe === "blur" && (Ne(ge), E.value = !1));
    }
    function Le(ge, Fe) {
      H(ge, Fe, "change");
    }
    function dt(ge) {
      ot(ge);
    }
    function Mt(ge) {
      et(ge), e.pair ? (Qe(["", ""]), Ae(["", ""])) : (Qe(""), Ae(""));
    }
    function Ct(ge) {
      const { onMousedown: Fe } = e;
      Fe && Fe(ge);
      const { tagName: Tt } = ge.target;
      if (Tt !== "INPUT" && Tt !== "TEXTAREA") {
        if (e.resizable) {
          const { value: lr } = a;
          if (lr) {
            const { left: gr, top: Or, width: ri, height: xi } = lr.getBoundingClientRect(), wi = 14;
            if (gr + ri - wi < ge.clientX && ge.clientX < gr + ri && Or + xi - wi < ge.clientY && ge.clientY < Or + xi)
              return;
          }
        }
        ge.preventDefault(), E.value || ne();
      }
    }
    function er() {
      var ge;
      N.value = !0, e.type === "textarea" && ((ge = v.value) === null || ge === void 0 || ge.handleMouseEnterWrapper());
    }
    function Vt() {
      var ge;
      N.value = !1, e.type === "textarea" && ((ge = v.value) === null || ge === void 0 || ge.handleMouseLeaveWrapper());
    }
    function jt() {
      A.value || re.value === "click" && (ue.value = !ue.value);
    }
    function at(ge) {
      if (A.value)
        return;
      ge.preventDefault();
      const Fe = (lr) => {
        lr.preventDefault(), hr("mouseup", document, Fe);
      };
      if (Mr("mouseup", document, Fe), re.value !== "mousedown")
        return;
      ue.value = !0;
      const Tt = () => {
        ue.value = !1, hr("mouseup", document, Tt);
      };
      Mr("mouseup", document, Tt);
    }
    function St(ge) {
      var Fe;
      switch ((Fe = e.onKeydown) === null || Fe === void 0 || Fe.call(e, ge), ge.key) {
        case "Escape":
          We();
          break;
        case "Enter":
          ve(ge);
          break;
      }
    }
    function ve(ge) {
      var Fe, Tt;
      if (e.passivelyActivated) {
        const { value: lr } = $;
        if (lr) {
          e.internalDeactivateOnEnter && We();
          return;
        }
        ge.preventDefault(), e.type === "textarea" ? (Fe = s.value) === null || Fe === void 0 || Fe.focus() : (Tt = f.value) === null || Tt === void 0 || Tt.focus();
      }
    }
    function We() {
      e.passivelyActivated && ($.value = !1, an(() => {
        var ge;
        (ge = a.value) === null || ge === void 0 || ge.focus();
      }));
    }
    function ne() {
      var ge, Fe, Tt;
      A.value || (e.passivelyActivated ? (ge = a.value) === null || ge === void 0 || ge.focus() : ((Fe = s.value) === null || Fe === void 0 || Fe.focus(), (Tt = f.value) === null || Tt === void 0 || Tt.focus()));
    }
    function Se() {
      var ge;
      !((ge = a.value) === null || ge === void 0) && ge.contains(document.activeElement) && document.activeElement.blur();
    }
    function _e() {
      var ge, Fe;
      (ge = s.value) === null || ge === void 0 || ge.select(), (Fe = f.value) === null || Fe === void 0 || Fe.select();
    }
    function ut() {
      A.value || (s.value ? s.value.focus() : f.value && f.value.focus());
    }
    function ht() {
      const { value: ge } = a;
      ge != null && ge.contains(document.activeElement) && ge !== document.activeElement && We();
    }
    function ye(ge) {
      if (e.type === "textarea") {
        const { value: Fe } = s;
        Fe == null || Fe.scrollTo(ge);
      } else {
        const { value: Fe } = f;
        Fe == null || Fe.scrollTo(ge);
      }
    }
    function Ze(ge) {
      const { type: Fe, pair: Tt, autosize: lr } = e;
      if (!Tt && lr)
        if (Fe === "textarea") {
          const { value: gr } = u;
          gr && (gr.textContent = (ge ?? "") + `\r
`);
        } else {
          const { value: gr } = d;
          gr && (ge ? gr.textContent = ge : gr.innerHTML = "&nbsp;");
        }
    }
    function st() {
      de();
    }
    const Nt = G({
      top: "0"
    });
    function Te(ge) {
      var Fe;
      const { scrollTop: Tt } = ge.target;
      Nt.value.top = `${-Tt}px`, (Fe = v.value) === null || Fe === void 0 || Fe.syncUnifiedContainer();
    }
    let Ke = null;
    On(() => {
      const { autosize: ge, type: Fe } = e;
      ge && Fe === "textarea" ? Ke = Gt(C, (Tt) => {
        !Array.isArray(Tt) && Tt !== _ && Ze(Tt);
      }) : Ke == null || Ke();
    });
    let xe = null;
    On(() => {
      e.type === "textarea" ? xe = Gt(C, (ge) => {
        var Fe;
        !Array.isArray(ge) && ge !== _ && ((Fe = v.value) === null || Fe === void 0 || Fe.syncUnifiedContainer());
      }) : xe == null || xe();
    }), tr(wH, {
      mergedValueRef: C,
      maxlengthRef: De,
      mergedClsPrefixRef: t,
      countGraphemesRef: tt(e, "countGraphemes")
    });
    const Xe = {
      wrapperElRef: a,
      inputElRef: f,
      textareaElRef: s,
      isCompositing: I,
      focus: ne,
      blur: Se,
      select: _e,
      deactivate: ht,
      activate: ut,
      scrollTo: ye
    }, At = Li("Input", i, t), Ht = j(() => {
      const { value: ge } = T, { common: { cubicBezierEaseInOut: Fe }, self: { color: Tt, borderRadius: lr, textColor: gr, caretColor: Or, caretColorError: ri, caretColorWarning: xi, textDecorationColor: wi, border: Pi, borderDisabled: Mi, borderHover: ze, borderFocus: wt, placeholderColor: Ut, placeholderColorDisabled: Wr, lineHeightTextarea: ct, colorDisabled: en, colorFocus: Ci, textColorDisabled: na, boxShadowFocus: kr, iconSize: Xi, colorFocusWarning: hi, boxShadowFocusWarning: gl, borderWarning: so, borderFocusWarning: ia, borderHoverWarning: Os, colorFocusError: Qc, boxShadowFocusError: qc, borderError: Gc, borderFocusError: Zc, borderHoverError: _s, clearSize: Ls, clearColor: Ps, clearColorHover: Rs, clearColorPressed: lg, iconColor: Kc, iconColorDisabled: ml, suffixTextColor: Xc, countTextColor: sg, countTextColorDisabled: Jc, iconColorHover: ed, iconColorPressed: js, loadingColor: ug, loadingColorError: td, loadingColorWarning: Fs, [Be("padding", ge)]: Bs, [Be("fontSize", ge)]: Po, [Be("height", ge)]: rd } } = o.value, { left: nd, right: cg } = Ll(Bs);
      return {
        "--n-bezier": Fe,
        "--n-count-text-color": sg,
        "--n-count-text-color-disabled": Jc,
        "--n-color": Tt,
        "--n-font-size": Po,
        "--n-border-radius": lr,
        "--n-height": rd,
        "--n-padding-left": nd,
        "--n-padding-right": cg,
        "--n-text-color": gr,
        "--n-caret-color": Or,
        "--n-text-decoration-color": wi,
        "--n-border": Pi,
        "--n-border-disabled": Mi,
        "--n-border-hover": ze,
        "--n-border-focus": wt,
        "--n-placeholder-color": Ut,
        "--n-placeholder-color-disabled": Wr,
        "--n-icon-size": Xi,
        "--n-line-height-textarea": ct,
        "--n-color-disabled": en,
        "--n-color-focus": Ci,
        "--n-text-color-disabled": na,
        "--n-box-shadow-focus": kr,
        "--n-loading-color": ug,
        "--n-caret-color-warning": xi,
        "--n-color-focus-warning": hi,
        "--n-box-shadow-focus-warning": gl,
        "--n-border-warning": so,
        "--n-border-focus-warning": ia,
        "--n-border-hover-warning": Os,
        "--n-loading-color-warning": Fs,
        "--n-caret-color-error": ri,
        "--n-color-focus-error": Qc,
        "--n-box-shadow-focus-error": qc,
        "--n-border-error": Gc,
        "--n-border-focus-error": Zc,
        "--n-border-hover-error": _s,
        "--n-loading-color-error": td,
        "--n-clear-color": Ps,
        "--n-clear-size": Ls,
        "--n-clear-color-hover": Rs,
        "--n-clear-color-pressed": lg,
        "--n-icon-color": Kc,
        "--n-icon-color-hover": ed,
        "--n-icon-color-pressed": js,
        "--n-icon-color-disabled": ml,
        "--n-suffix-text-color": Xc
      };
    }), zt = n ? Cr("input", j(() => {
      const { value: ge } = T;
      return ge[0];
    }), Ht, e) : void 0;
    return Object.assign(Object.assign({}, Xe), {
      wrapperElRef: a,
      inputElRef: f,
      inputMirrorElRef: d,
      inputEl2Ref: h,
      textareaElRef: s,
      textareaMirrorElRef: u,
      textareaScrollbarInstRef: v,
      rtlEnabled: At,
      uncontrolledValue: x,
      mergedValue: C,
      passwordVisible: ue,
      mergedPlaceholder: R,
      showPlaceholder1: U,
      showPlaceholder2: Q,
      mergedFocus: Z,
      isComposing: I,
      activated: $,
      showClearButton: X,
      mergedSize: T,
      mergedDisabled: A,
      textDecorationStyle: he,
      mergedClsPrefix: t,
      mergedBordered: r,
      mergedShowPasswordOn: re,
      placeholderStyle: Nt,
      mergedStatus: D,
      textAreaScrollContainerWidth: te,
      handleTextAreaScroll: Te,
      handleCompositionStart: W,
      handleCompositionEnd: P,
      handleInput: H,
      handleInputBlur: pe,
      handleInputFocus: ae,
      handleWrapperBlur: Me,
      handleWrapperFocus: fe,
      handleMouseEnter: er,
      handleMouseLeave: Vt,
      handleMouseDown: Ct,
      handleChange: Le,
      handleClick: dt,
      handleClear: Mt,
      handlePasswordToggleClick: jt,
      handlePasswordToggleMousedown: at,
      handleWrapperKeydown: St,
      handleTextAreaMirrorResize: st,
      getTextareaScrollContainer: () => s.value,
      mergedTheme: o,
      cssVars: n ? void 0 : Ht,
      themeClass: zt == null ? void 0 : zt.themeClass,
      onRender: zt == null ? void 0 : zt.onRender
    });
  },
  render() {
    var e, t;
    const { mergedClsPrefix: r, mergedStatus: n, themeClass: i, type: o, countGraphemes: a, onRender: s } = this, u = this.$slots;
    return s == null || s(), b("div", { ref: "wrapperElRef", class: [
      `${r}-input`,
      i,
      n && `${r}-input--${n}-status`,
      {
        [`${r}-input--rtl`]: this.rtlEnabled,
        [`${r}-input--disabled`]: this.mergedDisabled,
        [`${r}-input--textarea`]: o === "textarea",
        [`${r}-input--resizable`]: this.resizable && !this.autosize,
        [`${r}-input--autosize`]: this.autosize,
        [`${r}-input--round`]: this.round && o !== "textarea",
        [`${r}-input--pair`]: this.pair,
        [`${r}-input--focus`]: this.mergedFocus,
        [`${r}-input--stateful`]: this.stateful
      }
    ], style: this.cssVars, tabindex: !this.mergedDisabled && this.passivelyActivated && !this.activated ? 0 : void 0, onFocus: this.handleWrapperFocus, onBlur: this.handleWrapperBlur, onClick: this.handleClick, onMousedown: this.handleMouseDown, onMouseenter: this.handleMouseEnter, onMouseleave: this.handleMouseLeave, onCompositionstart: this.handleCompositionStart, onCompositionend: this.handleCompositionEnd, onKeyup: this.onKeyup, onKeydown: this.handleWrapperKeydown }, b("div", { class: `${r}-input-wrapper` }, Fr(u.prefix, (d) => d && b("div", { class: `${r}-input__prefix` }, d)), o === "textarea" ? b(no, { ref: "textareaScrollbarInstRef", class: `${r}-input__textarea`, container: this.getTextareaScrollContainer, triggerDisplayManually: !0, useUnifiedContainer: !0, internalHoistYRail: !0 }, {
      default: () => {
        var d, f;
        const { textAreaScrollContainerWidth: h } = this, g = {
          width: this.autosize && h && `${h}px`
        };
        return b(Lr, null, b("textarea", Object.assign({}, this.inputProps, { ref: "textareaElRef", class: [
          `${r}-input__textarea-el`,
          (d = this.inputProps) === null || d === void 0 ? void 0 : d.class
        ], autofocus: this.autofocus, rows: Number(this.rows), placeholder: this.placeholder, value: this.mergedValue, disabled: this.mergedDisabled, maxlength: a ? void 0 : this.maxlength, minlength: a ? void 0 : this.minlength, readonly: this.readonly, tabindex: this.passivelyActivated && !this.activated ? -1 : void 0, style: [
          this.textDecorationStyle[0],
          (f = this.inputProps) === null || f === void 0 ? void 0 : f.style,
          g
        ], onBlur: this.handleInputBlur, onFocus: (m) => {
          this.handleInputFocus(m, 2);
        }, onInput: this.handleInput, onChange: this.handleChange, onScroll: this.handleTextAreaScroll })), this.showPlaceholder1 ? b("div", { class: `${r}-input__placeholder`, style: [
          this.placeholderStyle,
          g
        ], key: "placeholder" }, this.mergedPlaceholder[0]) : null, this.autosize ? b(Hl, { onResize: this.handleTextAreaMirrorResize }, {
          default: () => b("div", { ref: "textareaMirrorElRef", class: `${r}-input__textarea-mirror`, key: "mirror" })
        }) : null);
      }
    }) : b("div", { class: `${r}-input__input` }, b("input", Object.assign({ type: o === "password" && this.mergedShowPasswordOn && this.passwordVisible ? "text" : o }, this.inputProps, { ref: "inputElRef", class: [
      `${r}-input__input-el`,
      (e = this.inputProps) === null || e === void 0 ? void 0 : e.class
    ], style: [
      this.textDecorationStyle[0],
      (t = this.inputProps) === null || t === void 0 ? void 0 : t.style
    ], tabindex: this.passivelyActivated && !this.activated ? -1 : void 0, placeholder: this.mergedPlaceholder[0], disabled: this.mergedDisabled, maxlength: a ? void 0 : this.maxlength, minlength: a ? void 0 : this.minlength, value: Array.isArray(this.mergedValue) ? this.mergedValue[0] : this.mergedValue, readonly: this.readonly, autofocus: this.autofocus, size: this.attrSize, onBlur: this.handleInputBlur, onFocus: (d) => {
      this.handleInputFocus(d, 0);
    }, onInput: (d) => {
      this.handleInput(d, 0);
    }, onChange: (d) => {
      this.handleChange(d, 0);
    } })), this.showPlaceholder1 ? b("div", { class: `${r}-input__placeholder` }, b("span", null, this.mergedPlaceholder[0])) : null, this.autosize ? b("div", { class: `${r}-input__input-mirror`, key: "mirror", ref: "inputMirrorElRef" }, " ") : null), !this.pair && Fr(u.suffix, (d) => d || this.clearable || this.showCount || this.mergedShowPasswordOn || this.loading !== void 0 ? b("div", { class: `${r}-input__suffix` }, [
      Fr(u["clear-icon-placeholder"], (f) => (this.clearable || f) && b(Mz, { clsPrefix: r, show: this.showClearButton, onClear: this.handleClear }, {
        placeholder: () => f,
        icon: () => {
          var h, g;
          return (g = (h = this.$slots)["clear-icon"]) === null || g === void 0 ? void 0 : g.call(h);
        }
      })),
      this.internalLoadingBeforeSuffix ? null : d,
      this.loading !== void 0 ? b(gH, { clsPrefix: r, loading: this.loading, showArrow: !1, showClear: !1, style: this.cssVars }) : null,
      this.internalLoadingBeforeSuffix ? d : null,
      this.showCount && this.type !== "textarea" ? b(FP, null, {
        default: (f) => {
          var h;
          return (h = u.count) === null || h === void 0 ? void 0 : h.call(u, f);
        }
      }) : null,
      this.mergedShowPasswordOn && this.type === "password" ? b("div", { class: `${r}-input__eye`, onMousedown: this.handlePasswordToggleMousedown, onClick: this.handlePasswordToggleClick }, this.passwordVisible ? vr(u["password-visible-icon"], () => [
        b(fr, { clsPrefix: r }, { default: () => b(eH, null) })
      ]) : vr(u["password-invisible-icon"], () => [
        b(fr, { clsPrefix: r }, { default: () => b(vfe, null) })
      ])) : null
    ]) : null)), this.pair ? b("span", { class: `${r}-input__separator` }, vr(u.separator, () => [this.separator])) : null, this.pair ? b("div", { class: `${r}-input-wrapper` }, b("div", { class: `${r}-input__input` }, b("input", { ref: "inputEl2Ref", type: this.type, class: `${r}-input__input-el`, tabindex: this.passivelyActivated && !this.activated ? -1 : void 0, placeholder: this.mergedPlaceholder[1], disabled: this.mergedDisabled, maxlength: a ? void 0 : this.maxlength, minlength: a ? void 0 : this.minlength, value: Array.isArray(this.mergedValue) ? this.mergedValue[1] : void 0, readonly: this.readonly, style: this.textDecorationStyle[1], onBlur: this.handleInputBlur, onFocus: (d) => {
      this.handleInputFocus(d, 1);
    }, onInput: (d) => {
      this.handleInput(d, 1);
    }, onChange: (d) => {
      this.handleChange(d, 1);
    } }), this.showPlaceholder2 ? b("div", { class: `${r}-input__placeholder` }, b("span", null, this.mergedPlaceholder[1])) : null), Fr(u.suffix, (d) => (this.clearable || d) && b("div", { class: `${r}-input__suffix` }, [
      this.clearable && b(Mz, { clsPrefix: r, show: this.showClearButton, onClear: this.handleClear }, {
        icon: () => {
          var f;
          return (f = u["clear-icon"]) === null || f === void 0 ? void 0 : f.call(u);
        },
        placeholder: () => {
          var f;
          return (f = u["clear-icon-placeholder"]) === null || f === void 0 ? void 0 : f.call(u);
        }
      }),
      d
    ]))) : null, this.mergedBordered ? b("div", { class: `${r}-input__border` }) : null, this.mergedBordered ? b("div", { class: `${r}-input__state-border` }) : null, this.showCount && o === "textarea" ? b(FP, null, {
      default: (d) => {
        var f;
        const { renderCount: h } = this;
        return h ? h(d) : (f = u.count) === null || f === void 0 ? void 0 : f.call(u, d);
      }
    }) : null);
  }
}), mpe = L("input-group", `
 display: inline-flex;
 width: 100%;
 flex-wrap: nowrap;
 vertical-align: bottom;
`, [Y(">", [L("input", [Y("&:not(:last-child)", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `), Y("&:not(:first-child)", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 margin-left: -1px!important;
 `)]), L("button", [Y("&:not(:last-child)", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `, [q("state-border, border", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `)]), Y("&:not(:first-child)", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `, [q("state-border, border", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `)])]), Y("*", [Y("&:not(:last-child)", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `, [Y(">", [L("input", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `), L("base-selection", [L("base-selection-label", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `), L("base-selection-tags", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `), q("box-shadow, border, state-border", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `)])])]), Y("&:not(:first-child)", `
 margin-left: -1px!important;
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `, [Y(">", [L("input", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `), L("base-selection", [L("base-selection-label", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `), L("base-selection-tags", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `), q("box-shadow, border, state-border", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `)])])])])])]);
const vpe = {};
var T4 = oe({
  name: "InputGroup",
  props: vpe,
  setup(e) {
    const { mergedClsPrefixRef: t } = Yt(e);
    return Vu("-input-group", mpe, t), {
      mergedClsPrefix: t
    };
  },
  render() {
    const { mergedClsPrefix: e } = this;
    return b("div", { class: `${e}-input-group` }, this.$slots);
  }
}), bpe = L("input-group-label", `
 position: relative;
 user-select: none;
 -webkit-user-select: none;
 box-sizing: border-box;
 padding: 0 12px;
 display: inline-block;
 border-radius: var(--n-border-radius);
 background-color: var(--n-group-label-color);
 color: var(--n-group-label-text-color);
 font-size: var(--n-font-size);
 line-height: var(--n-height);
 height: var(--n-height);
 flex-shrink: 0;
 white-space: nowrap;
 transition: 
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
`, [q("border", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border-radius: inherit;
 border: var(--n-group-label-border);
 transition: border-color .3s var(--n-bezier);
 `)]);
const ype = Object.assign(Object.assign({}, ft.props), { size: {
  type: String,
  default: "medium"
}, bordered: {
  type: Boolean,
  default: void 0
} });
var xpe = oe({
  name: "InputGroupLabel",
  props: ype,
  setup(e) {
    const { mergedBorderedRef: t, mergedClsPrefixRef: r, inlineThemeDisabled: n } = Yt(e), i = ft("Input", "-input-group-label", bpe, Fc, e, r), o = j(() => {
      const { size: s } = e, { common: { cubicBezierEaseInOut: u }, self: { groupLabelColor: d, borderRadius: f, groupLabelTextColor: h, lineHeight: g, groupLabelBorder: m, [Be("fontSize", s)]: v, [Be("height", s)]: w } } = i.value;
      return {
        "--n-bezier": u,
        "--n-group-label-color": d,
        "--n-group-label-border": m,
        "--n-border-radius": f,
        "--n-group-label-text-color": h,
        "--n-font-size": v,
        "--n-line-height": g,
        "--n-height": w
      };
    }), a = n ? Cr("input-group-label", j(() => e.size[0]), o, e) : void 0;
    return {
      mergedClsPrefix: r,
      mergedBordered: t,
      cssVars: n ? void 0 : o,
      themeClass: a == null ? void 0 : a.themeClass,
      onRender: a == null ? void 0 : a.onRender
    };
  },
  render() {
    var e, t, r;
    const { mergedClsPrefix: n } = this;
    return (e = this.onRender) === null || e === void 0 || e.call(this), b("div", { class: [`${n}-input-group-label`, this.themeClass], style: this.cssVars }, (r = (t = this.$slots).default) === null || r === void 0 ? void 0 : r.call(t), this.mergedBordered ? b("div", { class: `${n}-input-group-label__border` }) : null);
  }
});
const Gy = Is && "loading" in document.createElement("img"), wpe = (e = {}) => {
  var t;
  const { root: r = null } = e;
  return {
    hash: `${e.rootMargin || "0px 0px 0px 0px"}-${Array.isArray(e.threshold) ? e.threshold.join(",") : (t = e.threshold) !== null && t !== void 0 ? t : "0"}`,
    options: Object.assign(Object.assign({}, e), { root: (typeof r == "string" ? document.querySelector(r) : r) || document.documentElement })
  };
}, BI = /* @__PURE__ */ new WeakMap(), UI = /* @__PURE__ */ new WeakMap(), HI = /* @__PURE__ */ new WeakMap(), MH = (e, t, r) => {
  if (!e)
    return () => {
    };
  const n = wpe(t), { root: i } = n.options;
  let o;
  const a = BI.get(i);
  a ? o = a : (o = /* @__PURE__ */ new Map(), BI.set(i, o));
  let s, u;
  o.has(n.hash) ? (u = o.get(n.hash), u[1].has(e) || (s = u[0], u[1].add(e), s.observe(e))) : (s = new IntersectionObserver((h) => {
    h.forEach((g) => {
      if (g.isIntersecting) {
        const m = UI.get(g.target), v = HI.get(g.target);
        m && m(), v && (v.value = !0);
      }
    });
  }, n.options), s.observe(e), u = [s, /* @__PURE__ */ new Set([e])], o.set(n.hash, u));
  let d = !1;
  const f = () => {
    d || (UI.delete(e), HI.delete(e), d = !0, u[1].has(e) && (u[0].unobserve(e), u[1].delete(e)), u[1].size <= 0 && o.delete(n.hash), o.size || BI.delete(i));
  };
  return UI.set(e, f), HI.set(e, r), f;
}, Mpe = (e) => {
  const { borderRadius: t, avatarColor: r, cardColor: n, fontSize: i, heightTiny: o, heightSmall: a, heightMedium: s, heightLarge: u, heightHuge: d, modalColor: f, popoverColor: h } = e;
  return {
    borderRadius: t,
    fontSize: i,
    border: `2px solid ${n}`,
    heightTiny: o,
    heightSmall: a,
    heightMedium: s,
    heightLarge: u,
    heightHuge: d,
    color: nn(n, r),
    colorModal: nn(f, r),
    colorPopover: nn(h, r)
  };
}, Cpe = {
  name: "Avatar",
  common: Sr,
  self: Mpe
};
var CH = Cpe;
const SH = "n-avatar-group";
var Spe = L("avatar", `
 width: var(--n-merged-size);
 height: var(--n-merged-size);
 color: #FFF;
 font-size: var(--n-font-size);
 display: inline-flex;
 position: relative;
 overflow: hidden;
 text-align: center;
 border: var(--n-border);
 border-radius: var(--n-border-radius);
 --n-merged-color: var(--n-color);
 background-color: var(--n-merged-color);
 transition:
 border-color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
`, [Bp(Y("&", "--n-merged-color: var(--n-color-modal);")), hb(Y("&", "--n-merged-color: var(--n-color-popover);")), Y("img", `
 width: 100%;
 height: 100%;
 `), q("text", `
 white-space: nowrap;
 display: inline-block;
 position: absolute;
 left: 50%;
 top: 50%;
 `), L("icon", `
 vertical-align: bottom;
 font-size: calc(var(--n-merged-size) - 6px);
 `), q("text", "line-height: 1.25")]);
const Tpe = Object.assign(Object.assign({}, ft.props), {
  size: [String, Number],
  src: String,
  circle: {
    type: Boolean,
    default: void 0
  },
  objectFit: String,
  round: {
    type: Boolean,
    default: void 0
  },
  bordered: {
    type: Boolean,
    default: void 0
  },
  onError: Function,
  fallbackSrc: String,
  intersectionObserverOptions: Object,
  lazy: Boolean,
  onLoad: Function,
  renderPlaceholder: Function,
  renderFallback: Function,
  imgProps: Object,
  color: String
});
var A0 = oe({
  name: "Avatar",
  props: Tpe,
  setup(e) {
    const { mergedClsPrefixRef: t, inlineThemeDisabled: r } = Yt(e), n = G(!1);
    let i = null;
    const o = G(null), a = G(null), s = () => {
      const { value: S } = o;
      if (S && (i === null || i !== S.innerHTML)) {
        i = S.innerHTML;
        const { value: T } = a;
        if (T) {
          const { offsetWidth: A, offsetHeight: D } = T, { offsetWidth: E, offsetHeight: N } = S, I = 0.9, $ = Math.min(A / E * I, D / N * I, 1);
          S.style.transform = `translateX(-50%) translateY(-50%) scale(${$})`;
        }
      }
    }, u = lt(SH, null), d = j(() => {
      const { size: S } = e;
      if (S)
        return S;
      const { size: T } = u || {};
      return T || "medium";
    }), f = ft("Avatar", "-avatar", Spe, CH, e, t), h = lt(pH, null), g = j(() => {
      if (u)
        return !0;
      const { round: S, circle: T } = e;
      return S !== void 0 || T !== void 0 ? S || T : h ? h.roundRef.value : !1;
    }), m = j(() => u ? !0 : e.bordered || !1), v = (S) => {
      var T;
      if (!y.value)
        return;
      n.value = !0;
      const { onError: A, imgProps: D } = e;
      (T = D == null ? void 0 : D.onError) === null || T === void 0 || T.call(D, S), A && A(S);
    };
    Gt(() => e.src, () => n.value = !1);
    const w = j(() => {
      const S = d.value, T = g.value, A = m.value, { color: D } = e, { self: { borderRadius: E, fontSize: N, color: I, border: $, colorModal: _, colorPopover: R }, common: { cubicBezierEaseInOut: U } } = f.value;
      let Q;
      return typeof S == "number" ? Q = `${S}px` : Q = f.value.self[Be("height", S)], {
        "--n-font-size": N,
        "--n-border": A ? $ : "none",
        "--n-border-radius": T ? "50%" : E,
        "--n-color": D || I,
        "--n-color-modal": D || _,
        "--n-color-popover": D || R,
        "--n-bezier": U,
        "--n-merged-size": `var(--n-avatar-size-override, ${Q})`
      };
    }), x = r ? Cr("avatar", j(() => {
      const S = d.value, T = g.value, A = m.value, { color: D } = e;
      let E = "";
      return S && (typeof S == "number" ? E += `a${S}` : E += S[0]), T && (E += "b"), A && (E += "c"), D && (E += hp(D)), E;
    }), w, e) : void 0, y = G(!e.lazy);
    br(() => {
      if (Gy)
        return;
      let S;
      const T = On(() => {
        S == null || S(), S = void 0, e.lazy && (S = MH(a.value, e.intersectionObserverOptions, y));
      });
      Gr(() => {
        T(), S == null || S();
      });
    });
    const C = G(!e.lazy);
    return {
      textRef: o,
      selfRef: a,
      mergedRoundRef: g,
      mergedClsPrefix: t,
      fitTextTransform: s,
      cssVars: r ? void 0 : w,
      themeClass: x == null ? void 0 : x.themeClass,
      onRender: x == null ? void 0 : x.onRender,
      hasLoadError: n,
      handleError: v,
      shouldStartLoading: y,
      loaded: C,
      mergedOnLoad: (S) => {
        var T;
        const { onLoad: A, imgProps: D } = e;
        A == null || A(S), (T = D == null ? void 0 : D.onLoad) === null || T === void 0 || T.call(D, S), C.value = !0;
      }
    };
  },
  render() {
    var e, t;
    const { $slots: r, src: n, mergedClsPrefix: i, lazy: o, onRender: a, mergedOnLoad: s, shouldStartLoading: u, loaded: d, hasLoadError: f } = this;
    a == null || a();
    let h;
    const g = !d && !f && (this.renderPlaceholder ? this.renderPlaceholder() : (t = (e = this.$slots).placeholder) === null || t === void 0 ? void 0 : t.call(e));
    return this.hasLoadError ? h = this.renderFallback ? this.renderFallback() : vr(r.fallback, () => [
      b("img", { src: this.fallbackSrc, style: { objectFit: this.objectFit } })
    ]) : h = Fr(r.default, (m) => {
      if (m)
        return b(Hl, { onResize: this.fitTextTransform }, {
          default: () => b("span", { ref: "textRef", class: `${i}-avatar__text` }, m)
        });
      if (n) {
        const { imgProps: v } = this;
        return b("img", Object.assign(Object.assign({}, v), { loading: Gy && !this.intersectionObserverOptions && o ? "lazy" : "eager", src: Gy || u || d ? n : void 0, onLoad: s, "data-image-src": n, onError: this.handleError, style: [
          v == null ? void 0 : v.style,
          { objectFit: this.objectFit },
          g ? {
            height: "0",
            width: "0",
            visibility: "hidden",
            position: "absolute"
          } : ""
        ] }));
      }
    }), b("span", { ref: "selfRef", class: [`${i}-avatar`, this.themeClass], style: this.cssVars }, h, o && g);
  }
}), kpe = L("avatar-group", `
 flex-wrap: nowrap;
 display: inline-flex;
 position: relative;
`, [wr("vertical", {
  flexDirection: "row"
}, [L("avatar", [Y("&:not(:first-child)", `
 margin-left: var(--n-gap);
 `)])]), K("vertical", {
  flexDirection: "column"
}, [L("avatar", [Y("&:not(:first-child)", `
 margin-top: var(--n-gap);
 `)])])]);
const Dpe = () => ({
  gap: "-12px"
}), Ape = {
  name: "AvatarGroup",
  common: Sr,
  peers: {
    Avatar: CH
  },
  self: Dpe
};
var Epe = Ape;
const Ipe = Object.assign(Object.assign({}, ft.props), { max: Number, maxStyle: [Object, String], options: {
  type: Array,
  default: () => []
}, vertical: Boolean, size: [String, Number] });
var Npe = oe({
  name: "AvatarGroup",
  props: Ipe,
  setup(e) {
    const { mergedClsPrefixRef: t, mergedRtlRef: r } = Yt(e), n = ft("AvatarGroup", "-avatar-group", kpe, Epe, e, t);
    tr(SH, e);
    const i = Li("AvatarGroup", r, t), o = j(() => {
      const { max: s } = e;
      if (s === void 0)
        return;
      const { options: u } = e;
      return u.length > s ? u.slice(s - 1, u.length) : [];
    }), a = j(() => {
      const { options: s, max: u } = e;
      return u === void 0 ? s : s.length > u ? s.slice(0, u - 1) : s.length === u ? s.slice(0, u) : s;
    });
    return {
      mergedTheme: n,
      rtlEnabled: i,
      mergedClsPrefix: t,
      restOptions: o,
      displayedOptions: a,
      cssVars: j(() => ({
        "--n-gap": n.value.self.gap
      }))
    };
  },
  render() {
    const { mergedClsPrefix: e, displayedOptions: t, restOptions: r, mergedTheme: n, $slots: i } = this;
    return b("div", { class: [
      `${e}-avatar-group`,
      this.rtlEnabled && `${e}-avatar-group--rtl`,
      this.vertical && `${e}-avatar-group--vertical`
    ], style: this.cssVars, role: "group" }, t.map((o) => i.avatar ? i.avatar({ option: o }) : b(A0, { src: o.src, theme: n.peers.Avatar, themeOverrides: n.peerOverrides.Avatar })), r !== void 0 && r.length > 0 && (i.rest ? i.rest({ options: r, rest: r.length }) : b(A0, { style: this.maxStyle, theme: n.peers.Avatar, themeOverrides: n.peerOverrides.Avatar }, {
      default: () => `+${r.length}`
    })));
  }
});
const zpe = (e) => {
  const { errorColor: t, infoColor: r, successColor: n, warningColor: i, fontFamily: o } = e;
  return {
    color: t,
    colorInfo: r,
    colorSuccess: n,
    colorError: t,
    colorWarning: i,
    fontSize: "12px",
    fontFamily: o
  };
}, $pe = {
  name: "Badge",
  common: Sr,
  self: zpe
};
var Ope = $pe, _pe = Y([Y("@keyframes badge-wave-spread", {
  from: {
    boxShadow: "0 0 0.5px 0px var(--n-ripple-color)",
    opacity: 0.6
  },
  to: {
    boxShadow: "0 0 0.5px 4.5px var(--n-ripple-color)",
    opacity: 0
  }
}), L("badge", `
 display: inline-flex;
 position: relative;
 vertical-align: middle;
 color: var(--n-color);
 font-family: var(--n-font-family);
 `, [K("as-is", [L("badge-sup", {
  position: "static",
  transform: "translateX(0)"
}, [Fa({
  transformOrigin: "left bottom",
  originalTransform: "translateX(0)"
})])]), K("dot", [L("badge-sup", `
 height: 8px;
 width: 8px;
 padding: 0;
 min-width: 8px;
 left: 100%;
 bottom: calc(100% - 4px);
 `, [Y("::before", "border-radius: 4px;")])]), L("badge-sup", `
 background: var(--n-color);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 color: #FFF;
 position: absolute;
 height: 18px;
 line-height: 18px;
 border-radius: 9px;
 padding: 0 6px;
 text-align: center;
 font-size: var(--n-font-size);
 transform: translateX(-50%);
 left: 100%;
 bottom: calc(100% - 9px);
 font-variant-numeric: tabular-nums;
 z-index: 1;
 display: flex;
 align-items: center;
 `, [Fa({
  transformOrigin: "left bottom",
  originalTransform: "translateX(-50%)"
}), L("base-wave", {
  zIndex: 1,
  animationDuration: "2s",
  animationIterationCount: "infinite",
  animationDelay: "1s",
  animationTimingFunction: "var(--n-ripple-bezier)",
  animationName: "badge-wave-spread"
}), Y("&::before", `
 opacity: 0;
 transform: scale(1);
 border-radius: 9px;
 content: "";
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `)])])]);
const Lpe = Object.assign(Object.assign({}, ft.props), { value: [String, Number], max: Number, dot: Boolean, type: {
  type: String,
  default: "default"
}, show: {
  type: Boolean,
  default: !0
}, showZero: Boolean, processing: Boolean, color: String, offset: Array });
var TH = oe({
  name: "Badge",
  props: Lpe,
  setup(e, { slots: t }) {
    const { mergedClsPrefixRef: r, inlineThemeDisabled: n, mergedRtlRef: i } = Yt(e), o = ft("Badge", "-badge", _pe, Ope, e, r), a = G(!1), s = () => {
      a.value = !0;
    }, u = () => {
      a.value = !1;
    }, d = j(() => e.show && (e.dot || e.value !== void 0 && !(!e.showZero && Number(e.value) <= 0) || !Bf(t.value)));
    br(() => {
      d.value && (a.value = !0);
    });
    const f = Li("Badge", i, r), h = j(() => {
      const { type: v, color: w } = e, { common: { cubicBezierEaseInOut: x, cubicBezierEaseOut: y }, self: { [Be("color", v)]: C, fontFamily: S, fontSize: T } } = o.value;
      return {
        "--n-font-size": T,
        "--n-font-family": S,
        "--n-color": w || C,
        "--n-ripple-color": w || C,
        "--n-bezier": x,
        "--n-ripple-bezier": y
      };
    }), g = n ? Cr("badge", j(() => {
      let v = "";
      const { type: w, color: x } = e;
      return w && (v += w[0]), x && (v += hp(x)), v;
    }), h, e) : void 0, m = j(() => {
      const { offset: v } = e;
      if (!v)
        return;
      const [w, x] = v, y = typeof w == "number" ? `${w}px` : w, C = typeof x == "number" ? `${x}px` : x;
      return {
        transform: `translate(calc(${f != null && f.value ? "50%" : "-50%"} + ${y}), ${C})`
      };
    });
    return {
      rtlEnabled: f,
      mergedClsPrefix: r,
      appeared: a,
      showBadge: d,
      handleAfterEnter: s,
      handleAfterLeave: u,
      cssVars: n ? void 0 : h,
      themeClass: g == null ? void 0 : g.themeClass,
      onRender: g == null ? void 0 : g.onRender,
      offsetStyle: m
    };
  },
  render() {
    var e;
    const { mergedClsPrefix: t, onRender: r, themeClass: n, $slots: i } = this;
    r == null || r();
    const o = (e = i.default) === null || e === void 0 ? void 0 : e.call(i);
    return b("div", { class: [
      `${t}-badge`,
      this.rtlEnabled && `${t}-badge--rtl`,
      n,
      {
        [`${t}-badge--dot`]: this.dot,
        [`${t}-badge--as-is`]: !o
      }
    ], style: this.cssVars }, o, b(jn, { name: "fade-in-scale-up-transition", onAfterEnter: this.handleAfterEnter, onAfterLeave: this.handleAfterLeave }, {
      default: () => this.showBadge ? b("sup", { class: `${t}-badge-sup`, title: cU(this.value), style: this.offsetStyle }, vr(i.value, () => [
        this.dot ? null : b(Ghe, { clsPrefix: t, appeared: this.appeared, max: this.max, value: this.value })
      ]), this.processing ? b(uH, { clsPrefix: t }) : null) : null
    }));
  }
}), Ppe = {
  fontWeightActive: "400"
};
const Rpe = (e) => {
  const { fontSize: t, textColor3: r, textColor2: n, borderRadius: i, buttonColor2Hover: o, buttonColor2Pressed: a } = e;
  return Object.assign(Object.assign({}, Ppe), { fontSize: t, itemLineHeight: "1.25", itemTextColor: r, itemTextColorHover: n, itemTextColorPressed: n, itemTextColorActive: n, itemBorderRadius: i, itemColorHover: o, itemColorPressed: a, separatorColor: r });
}, jpe = {
  name: "Breadcrumb",
  common: Sr,
  self: Rpe
};
var Fpe = jpe, Bpe = L("breadcrumb", `
 white-space: nowrap;
 cursor: default;
 line-height: var(--n-item-line-height);
`, [Y("ul", `
 list-style: none;
 padding: 0;
 margin: 0;
 `), Y("a", `
 color: inherit;
 text-decoration: inherit;
 `), L("breadcrumb-item", `
 font-size: var(--n-font-size);
 transition: color .3s var(--n-bezier);
 display: inline-flex;
 align-items: center;
 `, [L("icon", `
 font-size: 18px;
 vertical-align: -.2em;
 transition: color .3s var(--n-bezier);
 color: var(--n-item-text-color);
 `), Y("&:not(:last-child)", [K("clickable", [q("link", `
 cursor: pointer;
 `, [Y("&:hover", `
 background-color: var(--n-item-color-hover);
 `), Y("&:active", `
 background-color: var(--n-item-color-pressed); 
 `)])])]), q("link", `
 padding: 4px;
 border-radius: var(--n-item-border-radius);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 color: var(--n-item-text-color);
 position: relative;
 `, [Y("&:hover", `
 color: var(--n-item-text-color-hover);
 `, [L("icon", `
 color: var(--n-item-text-color-hover);
 `)]), Y("&:active", `
 color: var(--n-item-text-color-pressed);
 `, [L("icon", `
 color: var(--n-item-text-color-pressed);
 `)])]), q("separator", `
 margin: 0 8px;
 color: var(--n-separator-color);
 transition: color .3s var(--n-bezier);
 user-select: none;
 -webkit-user-select: none;
 `), Y("&:last-child", [q("link", `
 font-weight: var(--n-font-weight-active);
 cursor: unset;
 color: var(--n-item-text-color-active);
 `, [L("icon", `
 color: var(--n-item-text-color-active);
 `)]), q("separator", `
 display: none;
 `)])])]);
const kH = "n-breadcrumb", Upe = Object.assign(Object.assign({}, ft.props), { separator: {
  type: String,
  default: "/"
} });
var Hpe = oe({
  name: "Breadcrumb",
  props: Upe,
  setup(e) {
    const { mergedClsPrefixRef: t, inlineThemeDisabled: r } = Yt(e), n = ft("Breadcrumb", "-breadcrumb", Bpe, Fpe, e, t);
    tr(kH, {
      separatorRef: tt(e, "separator"),
      mergedClsPrefixRef: t
    });
    const i = j(() => {
      const { common: { cubicBezierEaseInOut: a }, self: { separatorColor: s, itemTextColor: u, itemTextColorHover: d, itemTextColorPressed: f, itemTextColorActive: h, fontSize: g, fontWeightActive: m, itemBorderRadius: v, itemColorHover: w, itemColorPressed: x, itemLineHeight: y } } = n.value;
      return {
        "--n-font-size": g,
        "--n-bezier": a,
        "--n-item-text-color": u,
        "--n-item-text-color-hover": d,
        "--n-item-text-color-pressed": f,
        "--n-item-text-color-active": h,
        "--n-separator-color": s,
        "--n-item-color-hover": w,
        "--n-item-color-pressed": x,
        "--n-item-border-radius": v,
        "--n-font-weight-active": m,
        "--n-item-line-height": y
      };
    }), o = r ? Cr("breadcrumb", void 0, i, e) : void 0;
    return {
      mergedClsPrefix: t,
      cssVars: r ? void 0 : i,
      themeClass: o == null ? void 0 : o.themeClass,
      onRender: o == null ? void 0 : o.onRender
    };
  },
  render() {
    var e;
    return (e = this.onRender) === null || e === void 0 || e.call(this), b("nav", { class: [`${this.mergedClsPrefix}-breadcrumb`, this.themeClass], style: this.cssVars, "aria-label": "Breadcrumb" }, b("ul", null, this.$slots));
  }
});
const Wpe = (e = Is ? window : null) => {
  const t = () => {
    const { hash: i, host: o, hostname: a, href: s, origin: u, pathname: d, port: f, protocol: h, search: g } = (e == null ? void 0 : e.location) || {};
    return {
      hash: i,
      host: o,
      hostname: a,
      href: s,
      origin: u,
      pathname: d,
      port: f,
      protocol: h,
      search: g
    };
  }, r = () => {
    n.value = t();
  }, n = G(t());
  return br(() => {
    e && (e.addEventListener("popstate", r), e.addEventListener("hashchange", r));
  }), FO(() => {
    e && (e.removeEventListener("popstate", r), e.removeEventListener("hashchange", r));
  }), n;
}, Vpe = {
  separator: String,
  href: String,
  clickable: {
    type: Boolean,
    default: !0
  },
  onClick: Function
};
var Ype = oe({
  name: "BreadcrumbItem",
  props: Vpe,
  setup(e, { slots: t }) {
    const r = lt(kH, null);
    if (!r)
      return () => null;
    const { separatorRef: n, mergedClsPrefixRef: i } = r, o = Wpe(), a = j(() => e.href ? "a" : "span"), s = j(() => o.value.href === e.href ? "location" : null);
    return () => {
      const { value: u } = i;
      return b("li", { class: [
        `${u}-breadcrumb-item`,
        e.clickable && `${u}-breadcrumb-item--clickable`
      ] }, b(a.value, {
        class: `${u}-breadcrumb-item__link`,
        "aria-current": s.value,
        href: e.href,
        onClick: e.onClick
      }, t), b("span", { class: `${u}-breadcrumb-item__separator`, "aria-hidden": "true" }, vr(t.separator, () => {
        var d;
        return [
          (d = e.separator) !== null && d !== void 0 ? d : n.value
        ];
      })));
    };
  }
});
function gf(e) {
  return nn(e, [255, 255, 255, 0.16]);
}
function ly(e) {
  return nn(e, [0, 0, 0, 0.12]);
}
const DH = "n-button-group";
var Qpe = {
  paddingTiny: "0 6px",
  paddingSmall: "0 10px",
  paddingMedium: "0 14px",
  paddingLarge: "0 18px",
  paddingRoundTiny: "0 10px",
  paddingRoundSmall: "0 14px",
  paddingRoundMedium: "0 18px",
  paddingRoundLarge: "0 22px",
  iconMarginTiny: "6px",
  iconMarginSmall: "6px",
  iconMarginMedium: "6px",
  iconMarginLarge: "6px",
  iconSizeTiny: "14px",
  iconSizeSmall: "18px",
  iconSizeMedium: "18px",
  iconSizeLarge: "20px",
  rippleDuration: ".6s"
};
const qpe = (e) => {
  const { heightTiny: t, heightSmall: r, heightMedium: n, heightLarge: i, borderRadius: o, fontSizeTiny: a, fontSizeSmall: s, fontSizeMedium: u, fontSizeLarge: d, opacityDisabled: f, textColor2: h, textColor3: g, primaryColorHover: m, primaryColorPressed: v, borderColor: w, primaryColor: x, baseColor: y, infoColor: C, infoColorHover: S, infoColorPressed: T, successColor: A, successColorHover: D, successColorPressed: E, warningColor: N, warningColorHover: I, warningColorPressed: $, errorColor: _, errorColorHover: R, errorColorPressed: U, fontWeight: Q, buttonColor2: Z, buttonColor2Hover: X, buttonColor2Pressed: re, fontWeightStrong: ue } = e;
  return Object.assign(Object.assign({}, Qpe), {
    heightTiny: t,
    heightSmall: r,
    heightMedium: n,
    heightLarge: i,
    borderRadiusTiny: o,
    borderRadiusSmall: o,
    borderRadiusMedium: o,
    borderRadiusLarge: o,
    fontSizeTiny: a,
    fontSizeSmall: s,
    fontSizeMedium: u,
    fontSizeLarge: d,
    opacityDisabled: f,
    colorOpacitySecondary: "0.16",
    colorOpacitySecondaryHover: "0.22",
    colorOpacitySecondaryPressed: "0.28",
    colorSecondary: Z,
    colorSecondaryHover: X,
    colorSecondaryPressed: re,
    colorTertiary: Z,
    colorTertiaryHover: X,
    colorTertiaryPressed: re,
    colorQuaternary: "#0000",
    colorQuaternaryHover: X,
    colorQuaternaryPressed: re,
    color: "#0000",
    colorHover: "#0000",
    colorPressed: "#0000",
    colorFocus: "#0000",
    colorDisabled: "#0000",
    textColor: h,
    textColorTertiary: g,
    textColorHover: m,
    textColorPressed: v,
    textColorFocus: m,
    textColorDisabled: h,
    textColorText: h,
    textColorTextHover: m,
    textColorTextPressed: v,
    textColorTextFocus: m,
    textColorTextDisabled: h,
    textColorGhost: h,
    textColorGhostHover: m,
    textColorGhostPressed: v,
    textColorGhostFocus: m,
    textColorGhostDisabled: h,
    border: `1px solid ${w}`,
    borderHover: `1px solid ${m}`,
    borderPressed: `1px solid ${v}`,
    borderFocus: `1px solid ${m}`,
    borderDisabled: `1px solid ${w}`,
    rippleColor: x,
    colorPrimary: x,
    colorHoverPrimary: m,
    colorPressedPrimary: v,
    colorFocusPrimary: m,
    colorDisabledPrimary: x,
    textColorPrimary: y,
    textColorHoverPrimary: y,
    textColorPressedPrimary: y,
    textColorFocusPrimary: y,
    textColorDisabledPrimary: y,
    textColorTextPrimary: x,
    textColorTextHoverPrimary: m,
    textColorTextPressedPrimary: v,
    textColorTextFocusPrimary: m,
    textColorTextDisabledPrimary: h,
    textColorGhostPrimary: x,
    textColorGhostHoverPrimary: m,
    textColorGhostPressedPrimary: v,
    textColorGhostFocusPrimary: m,
    textColorGhostDisabledPrimary: x,
    borderPrimary: `1px solid ${x}`,
    borderHoverPrimary: `1px solid ${m}`,
    borderPressedPrimary: `1px solid ${v}`,
    borderFocusPrimary: `1px solid ${m}`,
    borderDisabledPrimary: `1px solid ${x}`,
    rippleColorPrimary: x,
    colorInfo: C,
    colorHoverInfo: S,
    colorPressedInfo: T,
    colorFocusInfo: S,
    colorDisabledInfo: C,
    textColorInfo: y,
    textColorHoverInfo: y,
    textColorPressedInfo: y,
    textColorFocusInfo: y,
    textColorDisabledInfo: y,
    textColorTextInfo: C,
    textColorTextHoverInfo: S,
    textColorTextPressedInfo: T,
    textColorTextFocusInfo: S,
    textColorTextDisabledInfo: h,
    textColorGhostInfo: C,
    textColorGhostHoverInfo: S,
    textColorGhostPressedInfo: T,
    textColorGhostFocusInfo: S,
    textColorGhostDisabledInfo: C,
    borderInfo: `1px solid ${C}`,
    borderHoverInfo: `1px solid ${S}`,
    borderPressedInfo: `1px solid ${T}`,
    borderFocusInfo: `1px solid ${S}`,
    borderDisabledInfo: `1px solid ${C}`,
    rippleColorInfo: C,
    colorSuccess: A,
    colorHoverSuccess: D,
    colorPressedSuccess: E,
    colorFocusSuccess: D,
    colorDisabledSuccess: A,
    textColorSuccess: y,
    textColorHoverSuccess: y,
    textColorPressedSuccess: y,
    textColorFocusSuccess: y,
    textColorDisabledSuccess: y,
    textColorTextSuccess: A,
    textColorTextHoverSuccess: D,
    textColorTextPressedSuccess: E,
    textColorTextFocusSuccess: D,
    textColorTextDisabledSuccess: h,
    textColorGhostSuccess: A,
    textColorGhostHoverSuccess: D,
    textColorGhostPressedSuccess: E,
    textColorGhostFocusSuccess: D,
    textColorGhostDisabledSuccess: A,
    borderSuccess: `1px solid ${A}`,
    borderHoverSuccess: `1px solid ${D}`,
    borderPressedSuccess: `1px solid ${E}`,
    borderFocusSuccess: `1px solid ${D}`,
    borderDisabledSuccess: `1px solid ${A}`,
    rippleColorSuccess: A,
    colorWarning: N,
    colorHoverWarning: I,
    colorPressedWarning: $,
    colorFocusWarning: I,
    colorDisabledWarning: N,
    textColorWarning: y,
    textColorHoverWarning: y,
    textColorPressedWarning: y,
    textColorFocusWarning: y,
    textColorDisabledWarning: y,
    textColorTextWarning: N,
    textColorTextHoverWarning: I,
    textColorTextPressedWarning: $,
    textColorTextFocusWarning: I,
    textColorTextDisabledWarning: h,
    textColorGhostWarning: N,
    textColorGhostHoverWarning: I,
    textColorGhostPressedWarning: $,
    textColorGhostFocusWarning: I,
    textColorGhostDisabledWarning: N,
    borderWarning: `1px solid ${N}`,
    borderHoverWarning: `1px solid ${I}`,
    borderPressedWarning: `1px solid ${$}`,
    borderFocusWarning: `1px solid ${I}`,
    borderDisabledWarning: `1px solid ${N}`,
    rippleColorWarning: N,
    colorError: _,
    colorHoverError: R,
    colorPressedError: U,
    colorFocusError: R,
    colorDisabledError: _,
    textColorError: y,
    textColorHoverError: y,
    textColorPressedError: y,
    textColorFocusError: y,
    textColorDisabledError: y,
    textColorTextError: _,
    textColorTextHoverError: R,
    textColorTextPressedError: U,
    textColorTextFocusError: R,
    textColorTextDisabledError: h,
    textColorGhostError: _,
    textColorGhostHoverError: R,
    textColorGhostPressedError: U,
    textColorGhostFocusError: R,
    textColorGhostDisabledError: _,
    borderError: `1px solid ${_}`,
    borderHoverError: `1px solid ${R}`,
    borderPressedError: `1px solid ${U}`,
    borderFocusError: `1px solid ${R}`,
    borderDisabledError: `1px solid ${_}`,
    rippleColorError: _,
    waveOpacity: "0.6",
    fontWeight: Q,
    fontWeightStrong: ue
  });
}, Gpe = {
  name: "Button",
  common: Sr,
  self: qpe
};
var Yu = Gpe, Zpe = Y([L("button", `
 margin: 0;
 font-weight: var(--n-font-weight);
 line-height: 1;
 font-family: inherit;
 padding: var(--n-padding);
 height: var(--n-height);
 font-size: var(--n-font-size);
 border-radius: var(--n-border-radius);
 color: var(--n-text-color);
 background-color: var(--n-color);
 width: var(--n-width);
 white-space: nowrap;
 outline: none;
 position: relative;
 z-index: auto;
 border: none;
 display: inline-flex;
 flex-wrap: nowrap;
 flex-shrink: 0;
 align-items: center;
 justify-content: center;
 user-select: none;
 -webkit-user-select: none;
 text-align: center;
 cursor: pointer;
 text-decoration: none;
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `, [K("color", [q("border", {
  borderColor: "var(--n-border-color)"
}), K("disabled", [q("border", {
  borderColor: "var(--n-border-color-disabled)"
})]), wr("disabled", [Y("&:focus", [q("state-border", {
  borderColor: "var(--n-border-color-focus)"
})]), Y("&:hover", [q("state-border", {
  borderColor: "var(--n-border-color-hover)"
})]), Y("&:active", [q("state-border", {
  borderColor: "var(--n-border-color-pressed)"
})]), K("pressed", [q("state-border", {
  borderColor: "var(--n-border-color-pressed)"
})])])]), K("disabled", {
  backgroundColor: "var(--n-color-disabled)",
  color: "var(--n-text-color-disabled)"
}, [q("border", {
  border: "var(--n-border-disabled)"
})]), wr("disabled", [Y("&:focus", {
  backgroundColor: "var(--n-color-focus)",
  color: "var(--n-text-color-focus)"
}, [q("state-border", {
  border: "var(--n-border-focus)"
})]), Y("&:hover", {
  backgroundColor: "var(--n-color-hover)",
  color: "var(--n-text-color-hover)"
}, [q("state-border", {
  border: "var(--n-border-hover)"
})]), Y("&:active", {
  backgroundColor: "var(--n-color-pressed)",
  color: "var(--n-text-color-pressed)"
}, [q("state-border", {
  border: "var(--n-border-pressed)"
})]), K("pressed", {
  backgroundColor: "var(--n-color-pressed)",
  color: "var(--n-text-color-pressed)"
}, [q("state-border", {
  border: "var(--n-border-pressed)"
})])]), K("loading", "cursor: wait;"), L("base-wave", `
 pointer-events: none;
 top: 0;
 right: 0;
 bottom: 0;
 left: 0;
 animation-iteration-count: 1;
 animation-duration: var(--n-ripple-duration);
 animation-timing-function: var(--n-bezier-ease-out), var(--n-bezier-ease-out);
 `, [K("active", {
  zIndex: 1,
  animationName: "button-wave-spread, button-wave-opacity"
})]), Is && "MozBoxSizing" in document.createElement("div").style ? Y("&::moz-focus-inner", {
  border: 0
}) : null, q("border, state-border", `
 position: absolute;
 left: 0;
 top: 0;
 right: 0;
 bottom: 0;
 border-radius: inherit;
 transition: border-color .3s var(--n-bezier);
 pointer-events: none;
 `), q("border", {
  border: "var(--n-border)"
}), q("state-border", {
  border: "var(--n-border)",
  borderColor: "#0000",
  zIndex: 1
}), q("icon", `
 margin: var(--n-icon-margin);
 margin-left: 0;
 height: var(--n-icon-size);
 width: var(--n-icon-size);
 max-width: var(--n-icon-size);
 font-size: var(--n-icon-size);
 position: relative;
 flex-shrink: 0;
 `, [L("icon-slot", `
 height: var(--n-icon-size);
 width: var(--n-icon-size);
 position: absolute;
 left: 0;
 top: 50%;
 transform: translateY(-50%);
 display: flex;
 align-items: center;
 justify-content: center;
 `, [Io({
  top: "50%",
  originalTransform: "translateY(-50%)"
})]), vH()]), q("content", `
 display: flex;
 align-items: center;
 flex-wrap: nowrap;
 min-width: 0;
 `, [Y("~", [q("icon", {
  margin: "var(--n-icon-margin)",
  marginRight: 0
})])]), K("block", `
 display: flex;
 width: 100%;
 `), K("dashed", [q("border, state-border", {
  borderStyle: "dashed !important"
})]), K("disabled", {
  cursor: "not-allowed",
  opacity: "var(--n-opacity-disabled)"
})]), Y("@keyframes button-wave-spread", {
  from: {
    boxShadow: "0 0 0.5px 0 var(--n-ripple-color)"
  },
  to: {
    boxShadow: "0 0 0.5px 4.5px var(--n-ripple-color)"
  }
}), Y("@keyframes button-wave-opacity", {
  from: {
    opacity: "var(--n-wave-opacity)"
  },
  to: {
    opacity: 0
  }
})]);
const Kpe = Object.assign(Object.assign({}, ft.props), { color: String, textColor: String, text: Boolean, block: Boolean, loading: Boolean, disabled: Boolean, circle: Boolean, size: String, ghost: Boolean, round: Boolean, secondary: Boolean, tertiary: Boolean, quaternary: Boolean, strong: Boolean, focusable: {
  type: Boolean,
  default: !0
}, keyboard: {
  type: Boolean,
  default: !0
}, tag: {
  type: String,
  default: "button"
}, type: {
  type: String,
  default: "default"
}, dashed: Boolean, renderIcon: Function, iconPlacement: {
  type: String,
  default: "left"
}, attrType: {
  type: String,
  default: "button"
}, bordered: {
  type: Boolean,
  default: !0
}, onClick: [Function, Array], nativeFocusBehavior: {
  type: Boolean,
  default: !xH
} }), AH = oe({
  name: "Button",
  props: Kpe,
  setup(e) {
    const t = G(null), r = G(null), n = G(!1), i = _r(() => !e.quaternary && !e.tertiary && !e.secondary && !e.text && (!e.color || e.ghost || e.dashed) && e.bordered), o = lt(DH, {}), { mergedSizeRef: a } = ta({}, {
      defaultSize: "medium",
      mergedSize: (T) => {
        const { size: A } = e;
        if (A)
          return A;
        const { size: D } = o;
        if (D)
          return D;
        const { mergedSize: E } = T || {};
        return E ? E.value : "medium";
      }
    }), s = j(() => e.focusable && !e.disabled), u = (T) => {
      var A;
      s.value || T.preventDefault(), !e.nativeFocusBehavior && (T.preventDefault(), !e.disabled && s.value && ((A = t.value) === null || A === void 0 || A.focus({ preventScroll: !0 })));
    }, d = (T) => {
      var A;
      if (!e.disabled && !e.loading) {
        const { onClick: D } = e;
        D && je(D, T), e.text || (A = r.value) === null || A === void 0 || A.play();
      }
    }, f = (T) => {
      switch (T.key) {
        case "Enter":
          if (!e.keyboard)
            return;
          n.value = !1;
      }
    }, h = (T) => {
      switch (T.key) {
        case "Enter":
          if (!e.keyboard || e.loading) {
            T.preventDefault();
            return;
          }
          n.value = !0;
      }
    }, g = () => {
      n.value = !1;
    }, { inlineThemeDisabled: m, mergedClsPrefixRef: v, mergedRtlRef: w } = Yt(e), x = ft("Button", "-button", Zpe, Yu, e, v), y = Li("Button", w, v), C = j(() => {
      const T = x.value, { common: { cubicBezierEaseInOut: A, cubicBezierEaseOut: D }, self: E } = T, { rippleDuration: N, opacityDisabled: I, fontWeight: $, fontWeightStrong: _ } = E, R = a.value, { dashed: U, type: Q, ghost: Z, text: X, color: re, round: ue, circle: he, textColor: te, secondary: de, tertiary: De, quaternary: Oe, strong: Qe } = e, Ae = {
        "font-weight": Qe ? _ : $
      };
      let Ne = {
        "--n-color": "initial",
        "--n-color-hover": "initial",
        "--n-color-pressed": "initial",
        "--n-color-focus": "initial",
        "--n-color-disabled": "initial",
        "--n-ripple-color": "initial",
        "--n-text-color": "initial",
        "--n-text-color-hover": "initial",
        "--n-text-color-pressed": "initial",
        "--n-text-color-focus": "initial",
        "--n-text-color-disabled": "initial"
      };
      const $e = Q === "tertiary", et = Q === "default", Ge = $e ? "default" : Q;
      if (X) {
        const pe = te || re;
        Ne = {
          "--n-color": "#0000",
          "--n-color-hover": "#0000",
          "--n-color-pressed": "#0000",
          "--n-color-focus": "#0000",
          "--n-color-disabled": "#0000",
          "--n-ripple-color": "#0000",
          "--n-text-color": pe || E[Be("textColorText", Ge)],
          "--n-text-color-hover": pe ? gf(pe) : E[Be("textColorTextHover", Ge)],
          "--n-text-color-pressed": pe ? ly(pe) : E[Be("textColorTextPressed", Ge)],
          "--n-text-color-focus": pe ? gf(pe) : E[Be("textColorTextHover", Ge)],
          "--n-text-color-disabled": pe || E[Be("textColorTextDisabled", Ge)]
        };
      } else if (Z || U) {
        const pe = te || re;
        Ne = {
          "--n-color": "#0000",
          "--n-color-hover": "#0000",
          "--n-color-pressed": "#0000",
          "--n-color-focus": "#0000",
          "--n-color-disabled": "#0000",
          "--n-ripple-color": re || E[Be("rippleColor", Ge)],
          "--n-text-color": pe || E[Be("textColorGhost", Ge)],
          "--n-text-color-hover": pe ? gf(pe) : E[Be("textColorGhostHover", Ge)],
          "--n-text-color-pressed": pe ? ly(pe) : E[Be("textColorGhostPressed", Ge)],
          "--n-text-color-focus": pe ? gf(pe) : E[Be("textColorGhostHover", Ge)],
          "--n-text-color-disabled": pe || E[Be("textColorGhostDisabled", Ge)]
        };
      } else if (de) {
        const pe = et ? E.textColor : $e ? E.textColorTertiary : E[Be("color", Ge)], ae = re || pe, Me = Q !== "default" && Q !== "tertiary";
        Ne = {
          "--n-color": Me ? nr(ae, {
            alpha: Number(E.colorOpacitySecondary)
          }) : E.colorSecondary,
          "--n-color-hover": Me ? nr(ae, {
            alpha: Number(E.colorOpacitySecondaryHover)
          }) : E.colorSecondaryHover,
          "--n-color-pressed": Me ? nr(ae, {
            alpha: Number(E.colorOpacitySecondaryPressed)
          }) : E.colorSecondaryPressed,
          "--n-color-focus": Me ? nr(ae, {
            alpha: Number(E.colorOpacitySecondaryHover)
          }) : E.colorSecondaryHover,
          "--n-color-disabled": E.colorSecondary,
          "--n-ripple-color": "#0000",
          "--n-text-color": ae,
          "--n-text-color-hover": ae,
          "--n-text-color-pressed": ae,
          "--n-text-color-focus": ae,
          "--n-text-color-disabled": ae
        };
      } else if (De || Oe) {
        const pe = et ? E.textColor : $e ? E.textColorTertiary : E[Be("color", Ge)], ae = re || pe;
        De ? (Ne["--n-color"] = E.colorTertiary, Ne["--n-color-hover"] = E.colorTertiaryHover, Ne["--n-color-pressed"] = E.colorTertiaryPressed, Ne["--n-color-focus"] = E.colorSecondaryHover, Ne["--n-color-disabled"] = E.colorTertiary) : (Ne["--n-color"] = E.colorQuaternary, Ne["--n-color-hover"] = E.colorQuaternaryHover, Ne["--n-color-pressed"] = E.colorQuaternaryPressed, Ne["--n-color-focus"] = E.colorQuaternaryHover, Ne["--n-color-disabled"] = E.colorQuaternary), Ne["--n-ripple-color"] = "#0000", Ne["--n-text-color"] = ae, Ne["--n-text-color-hover"] = ae, Ne["--n-text-color-pressed"] = ae, Ne["--n-text-color-focus"] = ae, Ne["--n-text-color-disabled"] = ae;
      } else
        Ne = {
          "--n-color": re || E[Be("color", Ge)],
          "--n-color-hover": re ? gf(re) : E[Be("colorHover", Ge)],
          "--n-color-pressed": re ? ly(re) : E[Be("colorPressed", Ge)],
          "--n-color-focus": re ? gf(re) : E[Be("colorFocus", Ge)],
          "--n-color-disabled": re || E[Be("colorDisabled", Ge)],
          "--n-ripple-color": re || E[Be("rippleColor", Ge)],
          "--n-text-color": te || (re ? E.textColorPrimary : $e ? E.textColorTertiary : E[Be("textColor", Ge)]),
          "--n-text-color-hover": te || (re ? E.textColorHoverPrimary : E[Be("textColorHover", Ge)]),
          "--n-text-color-pressed": te || (re ? E.textColorPressedPrimary : E[Be("textColorPressed", Ge)]),
          "--n-text-color-focus": te || (re ? E.textColorFocusPrimary : E[Be("textColorFocus", Ge)]),
          "--n-text-color-disabled": te || (re ? E.textColorDisabledPrimary : E[Be("textColorDisabled", Ge)])
        };
      let Ee = {
        "--n-border": "initial",
        "--n-border-hover": "initial",
        "--n-border-pressed": "initial",
        "--n-border-focus": "initial",
        "--n-border-disabled": "initial"
      };
      X ? Ee = {
        "--n-border": "none",
        "--n-border-hover": "none",
        "--n-border-pressed": "none",
        "--n-border-focus": "none",
        "--n-border-disabled": "none"
      } : Ee = {
        "--n-border": E[Be("border", Ge)],
        "--n-border-hover": E[Be("borderHover", Ge)],
        "--n-border-pressed": E[Be("borderPressed", Ge)],
        "--n-border-focus": E[Be("borderFocus", Ge)],
        "--n-border-disabled": E[Be("borderDisabled", Ge)]
      };
      const { [Be("height", R)]: qe, [Be("fontSize", R)]: Ue, [Be("padding", R)]: ot, [Be("paddingRound", R)]: Ie, [Be("iconSize", R)]: rt, [Be("borderRadius", R)]: W, [Be("iconMargin", R)]: P, waveOpacity: H } = E, se = {
        "--n-width": he && !X ? qe : "initial",
        "--n-height": X ? "initial" : qe,
        "--n-font-size": Ue,
        "--n-padding": he || X ? "initial" : ue ? Ie : ot,
        "--n-icon-size": rt,
        "--n-icon-margin": P,
        "--n-border-radius": X ? "initial" : he || ue ? qe : W
      };
      return Object.assign(Object.assign(Object.assign(Object.assign({ "--n-bezier": A, "--n-bezier-ease-out": D, "--n-ripple-duration": N, "--n-opacity-disabled": I, "--n-wave-opacity": H }, Ae), Ne), Ee), se);
    }), S = m ? Cr("button", j(() => {
      let T = "";
      const { dashed: A, type: D, ghost: E, text: N, color: I, round: $, circle: _, textColor: R, secondary: U, tertiary: Q, quaternary: Z, strong: X } = e;
      A && (T += "a"), E && (T += "b"), N && (T += "c"), $ && (T += "d"), _ && (T += "e"), U && (T += "f"), Q && (T += "g"), Z && (T += "h"), X && (T += "i"), I && (T += "j" + hp(I)), R && (T += "k" + hp(R));
      const { value: re } = a;
      return T += "l" + re[0], T += "m" + D[0], T;
    }), C, e) : void 0;
    return {
      selfElRef: t,
      waveElRef: r,
      mergedClsPrefix: v,
      mergedFocusable: s,
      mergedSize: a,
      showBorder: i,
      enterPressed: n,
      rtlEnabled: y,
      handleMousedown: u,
      handleKeydown: h,
      handleBlur: g,
      handleKeyup: f,
      handleClick: d,
      customColorCssVars: j(() => {
        const { color: T } = e;
        if (!T)
          return null;
        const A = gf(T);
        return {
          "--n-border-color": T,
          "--n-border-color-hover": A,
          "--n-border-color-pressed": ly(T),
          "--n-border-color-focus": A,
          "--n-border-color-disabled": T
        };
      }),
      cssVars: m ? void 0 : C,
      themeClass: S == null ? void 0 : S.themeClass,
      onRender: S == null ? void 0 : S.onRender
    };
  },
  render() {
    const { mergedClsPrefix: e, tag: t, onRender: r } = this;
    r == null || r();
    const n = Fr(this.$slots.default, (i) => i && b("span", { class: `${e}-button__content` }, i));
    return b(t, { ref: "selfElRef", class: [
      this.themeClass,
      `${e}-button`,
      `${e}-button--${this.type}-type`,
      `${e}-button--${this.mergedSize}-type`,
      this.rtlEnabled && `${e}-button--rtl`,
      this.disabled && `${e}-button--disabled`,
      this.block && `${e}-button--block`,
      this.enterPressed && `${e}-button--pressed`,
      !this.text && this.dashed && `${e}-button--dashed`,
      this.color && `${e}-button--color`,
      this.secondary && `${e}-button--secondary`,
      this.loading && `${e}-button--loading`,
      this.ghost && `${e}-button--ghost`
    ], tabindex: this.mergedFocusable ? 0 : -1, type: this.attrType, style: this.cssVars, disabled: this.disabled, onClick: this.handleClick, onBlur: this.handleBlur, onMousedown: this.handleMousedown, onKeyup: this.handleKeyup, onKeydown: this.handleKeydown }, this.iconPlacement === "right" && n, b(ph, { width: !0 }, {
      default: () => Fr(this.$slots.icon, (i) => (this.loading || this.renderIcon || i) && b("span", { class: `${e}-button__icon`, style: {
        margin: Bf(this.$slots.default) ? "0" : ""
      } }, b(Lc, null, {
        default: () => this.loading ? b(mh, { clsPrefix: e, key: "loading", class: `${e}-icon-slot`, strokeWidth: 20 }) : b("div", { key: "icon", class: `${e}-icon-slot`, role: "none" }, this.renderIcon ? this.renderIcon() : i)
      })))
    }), this.iconPlacement === "left" && n, this.text ? null : b(uH, { ref: "waveElRef", clsPrefix: e }), this.showBorder ? b("div", { "aria-hidden": !0, class: `${e}-button__border`, style: this.customColorCssVars }) : null, this.showBorder ? b("div", { "aria-hidden": !0, class: `${e}-button__state-border`, style: this.customColorCssVars }) : null);
  }
});
var Mn = AH;
const bs = AH, li = "0!important", EH = "-1px!important";
function Eh(e) {
  return K(e + "-type", [Y("& +", [L("button", {}, [K(e + "-type", [q("border", {
    borderLeftWidth: li
  }), q("state-border", {
    left: EH
  })])])])]);
}
function Ih(e) {
  return K(e + "-type", [Y("& +", [L("button", [K(e + "-type", [q("border", {
    borderTopWidth: li
  }), q("state-border", {
    top: EH
  })])])])]);
}
var Xpe = L("button-group", `
 flex-wrap: nowrap;
 display: inline-flex;
 position: relative;
`, [wr("vertical", {
  flexDirection: "row"
}, [wr("rtl", [L("button", [Y("&:first-child:not(:last-child)", `
 margin-right: ${li};
 border-top-right-radius: ${li};
 border-bottom-right-radius: ${li};
 `), Y("&:last-child:not(:first-child)", `
 margin-left: ${li};
 border-top-left-radius: ${li};
 border-bottom-left-radius: ${li};
 `), Y("&:not(:first-child):not(:last-child)", `
 margin-left: ${li};
 margin-right: ${li};
 border-radius: ${li};
 `), Eh("default"), K("ghost", [Eh("primary"), Eh("info"), Eh("success"), Eh("warning"), Eh("error")])])])]), K("vertical", {
  flexDirection: "column"
}, [L("button", [Y("&:first-child:not(:last-child)", `
 margin-bottom: ${li};
 margin-left: ${li};
 margin-right: ${li};
 border-bottom-left-radius: ${li};
 border-bottom-right-radius: ${li};
 `), Y("&:last-child:not(:first-child)", `
 margin-top: ${li};
 margin-left: ${li};
 margin-right: ${li};
 border-top-left-radius: ${li};
 border-top-right-radius: ${li};
 `), Y("&:not(:first-child):not(:last-child)", `
 margin: ${li};
 border-radius: ${li};
 `), Ih("default"), K("ghost", [Ih("primary"), Ih("info"), Ih("success"), Ih("warning"), Ih("error")])])])]);
const Jpe = {
  size: {
    type: String,
    default: void 0
  },
  vertical: Boolean
};
var ege = oe({
  name: "ButtonGroup",
  props: Jpe,
  setup(e) {
    const { mergedClsPrefixRef: t, mergedRtlRef: r } = Yt(e);
    return Vu("-button-group", Xpe, t), tr(DH, e), {
      rtlEnabled: Li("ButtonGroup", r, t),
      mergedClsPrefix: t
    };
  },
  render() {
    const { mergedClsPrefix: e } = this;
    return b("div", { class: [
      `${e}-button-group`,
      this.rtlEnabled && `${e}-button-group--rtl`,
      this.vertical && `${e}-button-group--vertical`
    ], role: "group" }, this.$slots);
  }
});
const ox = 1901, th = 40, tge = {
  date: gae,
  month: jM,
  year: Q7,
  quarter: Y7
};
function $u(e, t, r) {
  const n = tge[r];
  return Array.isArray(e) ? e.some((i) => n(i, t)) : n(e, t);
}
function WI(e, t, r, n) {
  let i = !1, o = !1, a = !1;
  Array.isArray(r) && (r[0] < e && e < r[1] && (i = !0), $u(r[0], e, "date") && (o = !0), $u(r[1], e, "date") && (a = !0));
  const s = r !== null && (Array.isArray(r) ? $u(r[0], e, "date") || $u(r[1], e, "date") : $u(r, e, "date"));
  return {
    type: "date",
    dateObject: {
      date: $l(e),
      month: Gn(e),
      year: si(e)
    },
    inCurrentMonth: jM(e, t),
    isCurrentDate: $u(n, e, "date"),
    inSpan: i,
    startOfSpan: o,
    endOfSpan: a,
    selected: s,
    ts: Lt(e)
  };
}
function rge(e, t, r) {
  return {
    type: "month",
    dateObject: {
      month: Gn(e),
      year: si(e)
    },
    isCurrent: jM(r, e),
    selected: t !== null && $u(t, e, "month"),
    ts: Lt(e)
  };
}
function nge(e, t, r) {
  return {
    type: "year",
    dateObject: {
      year: si(e)
    },
    isCurrent: Q7(r, e),
    selected: t !== null && $u(t, e, "year"),
    ts: Lt(e)
  };
}
function ige(e, t, r) {
  return {
    type: "quarter",
    dateObject: {
      quarter: vae(e),
      year: si(e)
    },
    isCurrent: Y7(r, e),
    selected: t !== null && $u(t, e, "quarter"),
    ts: Lt(e)
  };
}
function Cz(e, t, r, n, i = !1) {
  const o = Gn(e);
  let a = Lt(Iu(e)), s = Lt(oy(a, -1));
  const u = [];
  let d = !i;
  for (; jae(s) !== n || d; )
    u.unshift(WI(s, e, t, r)), s = Lt(oy(s, -1)), d = !1;
  for (; Gn(a) === o; )
    u.push(WI(a, e, t, r)), a = Lt(oy(a, 1));
  const f = i ? u.length <= 28 ? 28 : u.length <= 35 ? 35 : 42 : 42;
  for (; u.length < f; )
    u.push(WI(a, e, t, r)), a = Lt(oy(a, 1));
  return u;
}
function Sz(e, t, r) {
  const n = [], i = p4(e);
  for (let o = 0; o < 12; o++)
    n.push(rge(Lt(yo(i, o)), t, r));
  return n;
}
function Tz(e, t, r) {
  const n = [], i = p4(e);
  for (let o = 0; o < 4; o++)
    n.push(ige(Lt(dae(i, o)), t, r));
  return n;
}
function kz(e, t) {
  const r = [], n = new Date(ox, 0, 1);
  for (let i = 0; i < 200; i++)
    r.push(nge(Lt(bz(n, i)), e, t));
  return r;
}
function ua(e, t, r, n) {
  const i = $le(e, t, r, n);
  return rl(i) ? Xn(i, t, n) === e ? i : new Date(NaN) : i;
}
function Zy(e) {
  if (e === void 0)
    return;
  if (typeof e == "number")
    return e;
  const [t, r, n] = e.split(":");
  return {
    hours: Number(t),
    minutes: Number(r),
    seconds: Number(n)
  };
}
function Nh(e, t) {
  return Array.isArray(e) ? e[t === "start" ? 0 : 1] : null;
}
const oge = (e) => {
  const { fontSize: t, boxShadow2: r, popoverColor: n, textColor2: i, borderRadius: o, borderColor: a, heightSmall: s, heightMedium: u, heightLarge: d, fontSizeSmall: f, fontSizeMedium: h, fontSizeLarge: g, dividerColor: m } = e;
  return {
    panelFontSize: t,
    boxShadow: r,
    color: n,
    textColor: i,
    borderRadius: o,
    border: `1px solid ${a}`,
    heightSmall: s,
    heightMedium: u,
    heightLarge: d,
    fontSizeSmall: f,
    fontSizeMedium: h,
    fontSizeLarge: g,
    dividerColor: m
  };
}, age = {
  name: "ColorPicker",
  common: Sr,
  peers: {
    Input: Fc,
    Button: Yu
  },
  self: oge
};
var lge = age;
function sge(e, t) {
  switch (e[0]) {
    case "hex":
      return t ? "#000000FF" : "#000000";
    case "rgb":
      return t ? "rgba(0, 0, 0, 1)" : "rgb(0, 0, 0)";
    case "hsl":
      return t ? "hsla(0, 0%, 0%, 1)" : "hsl(0, 0%, 0%)";
    case "hsv":
      return t ? "hsva(0, 0%, 0%, 1)" : "hsv(0, 0%, 0%)";
  }
  return "#000000";
}
function E0(e) {
  return e === null ? null : /^ *#/.test(e) ? "hex" : e.includes("rgb") ? "rgb" : e.includes("hsl") ? "hsl" : e.includes("hsv") ? "hsv" : null;
}
function uge(e) {
  return e = Math.round(e), e >= 360 ? 359 : e < 0 ? 0 : e;
}
function cge(e) {
  return e = Math.round(e * 100) / 100, e > 1 ? 1 : e < 0 ? 0 : e;
}
const dge = {
  rgb: {
    hex(e) {
      return pc(ro(e));
    },
    hsl(e) {
      const [t, r, n, i] = ro(e);
      return hc([...ZN(t, r, n), i]);
    },
    hsv(e) {
      const [t, r, n, i] = ro(e);
      return Ff([...GN(t, r, n), i]);
    }
  },
  hex: {
    rgb(e) {
      return gs(ro(e));
    },
    hsl(e) {
      const [t, r, n, i] = ro(e);
      return hc([...ZN(t, r, n), i]);
    },
    hsv(e) {
      const [t, r, n, i] = ro(e);
      return Ff([...GN(t, r, n), i]);
    }
  },
  hsl: {
    hex(e) {
      const [t, r, n, i] = ep(e);
      return pc([...KN(t, r, n), i]);
    },
    rgb(e) {
      const [t, r, n, i] = ep(e);
      return gs([...KN(t, r, n), i]);
    },
    hsv(e) {
      const [t, r, n, i] = ep(e);
      return Ff([...uU(t, r, n), i]);
    }
  },
  hsv: {
    hex(e) {
      const [t, r, n, i] = jf(e);
      return pc([...oc(t, r, n), i]);
    },
    rgb(e) {
      const [t, r, n, i] = jf(e);
      return gs([...oc(t, r, n), i]);
    },
    hsl(e) {
      const [t, r, n, i] = jf(e);
      return hc([...Yy(t, r, n), i]);
    }
  }
};
function IH(e, t, r) {
  return r = r || E0(e), r ? r === t ? e : dge[r][t](e) : null;
}
const zh = "12px", fge = 12, mf = "6px", hge = 6, pge = "linear-gradient(90deg,red,#ff0 16.66%,#0f0 33.33%,#0ff 50%,#00f 66.66%,#f0f 83.33%,red)";
var gge = oe({
  name: "HueSlider",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    hue: {
      type: Number,
      required: !0
    },
    onUpdateHue: {
      type: Function,
      required: !0
    },
    onComplete: Function
  },
  setup(e) {
    const t = G(null);
    function r(o) {
      t.value && (Mr("mousemove", document, n), Mr("mouseup", document, i), n(o));
    }
    function n(o) {
      const { value: a } = t;
      if (!a)
        return;
      const { width: s, left: u } = a.getBoundingClientRect(), d = uge((o.clientX - u - hge) / (s - fge) * 360);
      e.onUpdateHue(d);
    }
    function i() {
      var o;
      hr("mousemove", document, n), hr("mouseup", document, i), (o = e.onComplete) === null || o === void 0 || o.call(e);
    }
    return {
      railRef: t,
      handleMouseDown: r
    };
  },
  render() {
    const { clsPrefix: e } = this;
    return b("div", { class: `${e}-color-picker-slider`, style: {
      height: zh,
      borderRadius: mf
    } }, b("div", { ref: "railRef", style: {
      boxShadow: "inset 0 0 2px 0 rgba(0, 0, 0, .24)",
      boxSizing: "border-box",
      backgroundImage: pge,
      height: zh,
      borderRadius: mf,
      position: "relative"
    }, onMousedown: this.handleMouseDown }, b("div", { style: {
      position: "absolute",
      left: mf,
      right: mf,
      top: 0,
      bottom: 0
    } }, b("div", { class: `${e}-color-picker-handle`, style: {
      left: `calc((${this.hue}%) / 359 * 100 - ${mf})`,
      borderRadius: mf,
      width: zh,
      height: zh
    } }, b("div", { class: `${e}-color-picker-handle__fill`, style: {
      backgroundColor: `hsl(${this.hue}, 100%, 50%)`,
      borderRadius: mf,
      width: zh,
      height: zh
    } })))));
  }
});
const kv = "12px", mge = 12, vf = "6px";
var vge = oe({
  name: "AlphaSlider",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    rgba: {
      type: Array,
      default: null
    },
    alpha: {
      type: Number,
      default: 0
    },
    onUpdateAlpha: {
      type: Function,
      required: !0
    },
    onComplete: Function
  },
  setup(e) {
    const t = G(null);
    function r(o) {
      !t.value || !e.rgba || (Mr("mousemove", document, n), Mr("mouseup", document, i), n(o));
    }
    function n(o) {
      const { value: a } = t;
      if (!a)
        return;
      const { width: s, left: u } = a.getBoundingClientRect(), d = (o.clientX - u) / (s - mge);
      e.onUpdateAlpha(cge(d));
    }
    function i() {
      var o;
      hr("mousemove", document, n), hr("mouseup", document, i), (o = e.onComplete) === null || o === void 0 || o.call(e);
    }
    return {
      railRef: t,
      railBackgroundImage: j(() => {
        const { rgba: o } = e;
        return o ? `linear-gradient(to right, rgba(${o[0]}, ${o[1]}, ${o[2]}, 0) 0%, rgba(${o[0]}, ${o[1]}, ${o[2]}, 1) 100%)` : "";
      }),
      handleMouseDown: r
    };
  },
  render() {
    const { clsPrefix: e } = this;
    return b("div", { class: `${e}-color-picker-slider`, ref: "railRef", style: {
      height: kv,
      borderRadius: vf
    }, onMousedown: this.handleMouseDown }, b("div", { style: {
      borderRadius: vf,
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      overflow: "hidden"
    } }, b("div", { class: `${e}-color-picker-checkboard` }), b("div", { class: `${e}-color-picker-slider__image`, style: {
      backgroundImage: this.railBackgroundImage
    } })), this.rgba && b("div", { style: {
      position: "absolute",
      left: vf,
      right: vf,
      top: 0,
      bottom: 0
    } }, b("div", { class: `${e}-color-picker-handle`, style: {
      left: `calc(${this.alpha * 100}% - ${vf})`,
      borderRadius: vf,
      width: kv,
      height: kv
    } }, b("div", { class: `${e}-color-picker-handle__fill`, style: {
      backgroundColor: gs(this.rgba),
      borderRadius: vf,
      width: kv,
      height: kv
    } }))));
  }
});
const sy = "12px", uy = "6px";
var bge = oe({
  name: "Pallete",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    rgba: {
      type: Array,
      default: null
    },
    displayedHue: {
      type: Number,
      required: !0
    },
    displayedSv: {
      type: Array,
      required: !0
    },
    onUpdateSV: {
      type: Function,
      required: !0
    },
    onComplete: Function
  },
  setup(e) {
    const t = G(null);
    function r(o) {
      t.value && (Mr("mousemove", document, n), Mr("mouseup", document, i), n(o));
    }
    function n(o) {
      const { value: a } = t;
      if (!a)
        return;
      const { width: s, height: u, left: d, bottom: f } = a.getBoundingClientRect(), h = (f - o.clientY) / u, g = (o.clientX - d) / s, m = 100 * (g > 1 ? 1 : g < 0 ? 0 : g), v = 100 * (h > 1 ? 1 : h < 0 ? 0 : h);
      e.onUpdateSV(m, v);
    }
    function i() {
      var o;
      hr("mousemove", document, n), hr("mouseup", document, i), (o = e.onComplete) === null || o === void 0 || o.call(e);
    }
    return {
      palleteRef: t,
      handleColor: j(() => {
        const { rgba: o } = e;
        return o ? `rgb(${o[0]}, ${o[1]}, ${o[2]})` : "";
      }),
      handleMouseDown: r
    };
  },
  render() {
    const { clsPrefix: e } = this;
    return b("div", { class: `${e}-color-picker-pallete`, onMousedown: this.handleMouseDown, ref: "palleteRef" }, b("div", { class: `${e}-color-picker-pallete__layer`, style: {
      backgroundImage: `linear-gradient(90deg, white, hsl(${this.displayedHue}, 100%, 50%))`
    } }), b("div", { class: `${e}-color-picker-pallete__layer ${e}-color-picker-pallete__layer--shadowed`, style: {
      backgroundImage: "linear-gradient(180deg, rgba(0, 0, 0, 0%), rgba(0, 0, 0, 100%))"
    } }), this.rgba && b("div", { class: `${e}-color-picker-handle`, style: {
      width: sy,
      height: sy,
      borderRadius: uy,
      left: `calc(${this.displayedSv[0]}% - ${uy})`,
      bottom: `calc(${this.displayedSv[1]}% - ${uy})`
    } }, b("div", { class: `${e}-color-picker-handle__fill`, style: {
      backgroundColor: this.handleColor,
      borderRadius: uy,
      width: sy,
      height: sy
    } })));
  }
});
const k4 = "n-color-picker";
function yge(e) {
  return /^\d{1,3}\.?\d*$/.test(e.trim()) ? Math.max(0, Math.min(parseInt(e), 255)) : !1;
}
function xge(e) {
  return /^\d{1,3}\.?\d*$/.test(e.trim()) ? Math.max(0, Math.min(parseInt(e), 360)) : !1;
}
function wge(e) {
  return /^\d{1,3}\.?\d*$/.test(e.trim()) ? Math.max(0, Math.min(parseInt(e), 100)) : !1;
}
function Mge(e) {
  const t = e.trim();
  return /^#[0-9a-fA-F]+$/.test(t) ? [4, 5, 7, 9].includes(t.length) : !1;
}
function Cge(e) {
  return /^\d{1,3}\.?\d*%$/.test(e.trim()) ? Math.max(0, Math.min(parseInt(e) / 100, 100)) : !1;
}
const Sge = {
  paddingSmall: "0 4px"
};
var BP = oe({
  name: "ColorInputUnit",
  props: {
    label: {
      type: String,
      required: !0
    },
    value: {
      type: [Number, String],
      default: null
    },
    showAlpha: Boolean,
    onUpdateValue: {
      type: Function,
      required: !0
    }
  },
  setup(e) {
    const t = G(""), { themeRef: r } = lt(k4, null);
    On(() => {
      t.value = n();
    });
    function n() {
      const { value: a } = e;
      if (a === null)
        return "";
      const { label: s } = e;
      return s === "HEX" ? a : s === "A" ? `${Math.floor(a * 100)}%` : String(Math.floor(a));
    }
    function i(a) {
      t.value = a;
    }
    function o(a) {
      let s, u;
      switch (e.label) {
        case "HEX":
          u = Mge(a), u && e.onUpdateValue(a), t.value = n();
          break;
        case "H":
          s = xge(a), s === !1 ? t.value = n() : e.onUpdateValue(s);
          break;
        case "S":
        case "L":
        case "V":
          s = wge(a), s === !1 ? t.value = n() : e.onUpdateValue(s);
          break;
        case "A":
          s = Cge(a), s === !1 ? t.value = n() : e.onUpdateValue(s);
          break;
        case "R":
        case "G":
        case "B":
          s = yge(a), s === !1 ? t.value = n() : e.onUpdateValue(s);
          break;
      }
    }
    return {
      mergedTheme: r,
      inputValue: t,
      handleInputChange: o,
      handleInputUpdateValue: i
    };
  },
  render() {
    const { mergedTheme: e } = this;
    return b(pa, {
      size: "small",
      placeholder: this.label,
      theme: e.peers.Input,
      themeOverrides: e.peerOverrides.Input,
      builtinThemeOverrides: Sge,
      value: this.inputValue,
      onUpdateValue: this.handleInputUpdateValue,
      onChange: this.handleInputChange,
      style: this.label === "A" ? "flex-grow: 1.25;" : ""
    });
  }
}), Tge = oe({
  name: "ColorInput",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    mode: {
      type: String,
      required: !0
    },
    modes: {
      type: Array,
      required: !0
    },
    showAlpha: {
      type: Boolean,
      required: !0
    },
    value: {
      type: String,
      default: null
    },
    valueArr: {
      type: Array,
      default: null
    },
    onUpdateValue: {
      type: Function,
      required: !0
    },
    onUpdateMode: {
      type: Function,
      required: !0
    }
  },
  setup(e) {
    return {
      handleUnitUpdateValue(t, r) {
        const { showAlpha: n } = e;
        if (e.mode === "hex") {
          e.onUpdateValue((n ? pc : qv)(r));
          return;
        }
        let i;
        switch (e.valueArr === null ? i = [0, 0, 0, 0] : i = Array.from(e.valueArr), e.mode) {
          case "hsv":
            i[t] = r, e.onUpdateValue((n ? Ff : ez)(i));
            break;
          case "rgb":
            i[t] = r, e.onUpdateValue((n ? gs : JN)(i));
            break;
          case "hsl":
            i[t] = r, e.onUpdateValue((n ? hc : tz)(i));
            break;
        }
      }
    };
  },
  render() {
    const { clsPrefix: e, modes: t } = this;
    return b("div", { class: `${e}-color-picker-input` }, b("div", { class: `${e}-color-picker-input__mode`, onClick: this.onUpdateMode, style: {
      cursor: t.length === 1 ? "" : "pointer"
    } }, this.mode.toUpperCase() + (this.showAlpha ? "A" : "")), b(T4, null, {
      default: () => {
        const { mode: r, valueArr: n, showAlpha: i } = this;
        if (r === "hex") {
          let o = null;
          try {
            o = n === null ? null : (i ? pc : qv)(n);
          } catch {
          }
          return b(BP, { label: "HEX", showAlpha: i, value: o, onUpdateValue: (a) => {
            this.handleUnitUpdateValue(0, a);
          } });
        }
        return (r + (i ? "a" : "")).split("").map((o, a) => b(BP, { label: o.toUpperCase(), value: n === null ? null : n[a], onUpdateValue: (s) => {
          this.handleUnitUpdateValue(a, s);
        } }));
      }
    }));
  }
}), kge = oe({
  name: "ColorPickerTrigger",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    value: {
      type: String,
      default: null
    },
    hsla: {
      type: Array,
      default: null
    },
    disabled: Boolean,
    onClick: Function
  },
  setup(e) {
    const { colorPickerSlots: t, renderLabelRef: r } = lt(k4, null);
    return () => {
      const { hsla: n, value: i, clsPrefix: o, onClick: a, disabled: s } = e, u = t.label || r.value;
      return b("div", { class: [
        `${o}-color-picker-trigger`,
        s && `${o}-color-picker-trigger--disabled`
      ], onClick: s ? void 0 : a }, b("div", { class: `${o}-color-picker-trigger__fill` }, b("div", { class: `${o}-color-picker-checkboard` }), b("div", { style: {
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        backgroundColor: n ? hc(n) : ""
      } }), i && n ? b("div", { class: `${o}-color-picker-trigger__value`, style: {
        color: n[2] > 50 || n[3] < 0.5 ? "black" : "white"
      } }, u ? u(i) : i) : null));
    };
  }
});
function Dge(e, t) {
  if (t === "hsv") {
    const [r, n, i, o] = jf(e);
    return gs([...oc(r, n, i), o]);
  }
  return e;
}
function Age(e) {
  const t = document.createElement("canvas").getContext("2d");
  return t.fillStyle = e, t.fillStyle;
}
var Ege = oe({
  name: "ColorPickerSwatches",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    mode: {
      type: String,
      required: !0
    },
    swatches: {
      type: Array,
      required: !0
    },
    onUpdateColor: {
      type: Function,
      required: !0
    }
  },
  setup(e) {
    const t = j(() => e.swatches.map((o) => {
      const a = E0(o);
      return {
        value: o,
        mode: a,
        legalValue: Dge(o, a)
      };
    }));
    function r(o) {
      const { mode: a } = e;
      let { value: s, mode: u } = o;
      return u || (u = "hex", /^[a-zA-Z]+$/.test(s) ? s = Age(s) : (ja("color-picker", `color ${s} in swatches is invalid.`), s = "#000000")), u === a ? s : IH(s, a, u);
    }
    function n(o) {
      e.onUpdateColor(r(o));
    }
    function i(o, a) {
      o.key === "Enter" && n(a);
    }
    return {
      parsedSwatchesRef: t,
      handleSwatchSelect: n,
      handleSwatchKeyDown: i
    };
  },
  render() {
    const { clsPrefix: e } = this;
    return b("div", { class: `${e}-color-picker-swatches` }, this.parsedSwatchesRef.map((t) => b("div", { class: `${e}-color-picker-swatch`, tabindex: 0, onClick: () => {
      this.handleSwatchSelect(t);
    }, onKeydown: (r) => {
      this.handleSwatchKeyDown(r, t);
    } }, b("div", { class: `${e}-color-picker-swatch__fill`, style: { background: t.legalValue } }))));
  }
}), Ige = oe({
  name: "ColorPreview",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    mode: {
      type: String,
      required: !0
    },
    color: {
      type: String,
      default: null,
      validator: (e) => {
        const t = E0(e);
        return Boolean(!e || t && t !== "hsv");
      }
    },
    onUpdateColor: {
      type: Function,
      required: !0
    }
  },
  setup(e) {
    function t(r) {
      var n;
      const i = r.target.value;
      (n = e.onUpdateColor) === null || n === void 0 || n.call(e, IH(i.toUpperCase(), e.mode, "hex")), r.stopPropagation();
    }
    return {
      handleChange: t
    };
  },
  render() {
    const { clsPrefix: e } = this;
    return b("div", { class: `${e}-color-picker-preview__preview` }, b("span", { class: `${e}-color-picker-preview__fill`, style: {
      background: this.color || "#000000"
    } }), b("input", { class: `${e}-color-picker-preview__input`, type: "color", value: this.color, onChange: this.handleChange }));
  }
}), Nge = Y([L("color-picker", `
 display: inline-block;
 box-sizing: border-box;
 height: var(--n-height);
 font-size: var(--n-font-size);
 width: 100%;
 position: relative;
 `), L("color-picker-panel", `
 margin: 4px 0;
 width: 240px;
 font-size: var(--n-panel-font-size);
 color: var(--n-text-color);
 background-color: var(--n-color);
 transition:
 box-shadow .3s var(--n-bezier),
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 border-radius: var(--n-border-radius);
 box-shadow: var(--n-box-shadow);
 `, [Fa(), L("input", `
 text-align: center;
 `)]), L("color-picker-checkboard", `
 background: white; 
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `, [Y("&::after", `
 background-image: linear-gradient(45deg, #DDD 25%, #0000 25%), linear-gradient(-45deg, #DDD 25%, #0000 25%), linear-gradient(45deg, #0000 75%, #DDD 75%), linear-gradient(-45deg, #0000 75%, #DDD 75%);
 background-size: 12px 12px;
 background-position: 0 0, 0 6px, 6px -6px, -6px 0px;
 background-repeat: repeat;
 content: "";
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `)]), L("color-picker-slider", `
 margin-bottom: 8px;
 position: relative;
 box-sizing: border-box;
 `, [q("image", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `), Y("&::after", `
 content: "";
 position: absolute;
 border-radius: inherit;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 box-shadow: inset 0 0 2px 0 rgba(0, 0, 0, .24);
 pointer-events: none;
 `)]), L("color-picker-handle", `
 z-index: 1;
 box-shadow: 0 0 2px 0 rgba(0, 0, 0, .45);
 position: absolute;
 background-color: white;
 overflow: hidden;
 `, [q("fill", `
 box-sizing: border-box;
 border: 2px solid white;
 `)]), L("color-picker-pallete", `
 height: 180px;
 position: relative;
 margin-bottom: 8px;
 cursor: crosshair;
 `, [q("layer", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `, [K("shadowed", `
 box-shadow: inset 0 0 2px 0 rgba(0, 0, 0, .24);
 `)])]), L("color-picker-preview", `
 display: flex;
 `, [q("sliders", `
 flex: 1 0 auto;
 `), q("preview", `
 position: relative;
 height: 30px;
 width: 30px;
 margin: 0 0 8px 6px;
 border-radius: 50%;
 box-shadow: rgba(0, 0, 0, .15) 0px 0px 0px 1px inset;
 overflow: hidden;
 `), q("fill", `
 display: block;
 width: 30px;
 height: 30px;
 `), q("input", `
 position: absolute;
 top: 0;
 left: 0;
 width: 30px;
 height: 30px;
 opacity: 0;
 z-index: 1;
 `)]), L("color-picker-input", `
 display: flex;
 align-items: center;
 `, [L("input", `
 flex-grow: 1;
 flex-basis: 0;
 `), q("mode", `
 width: 72px;
 text-align: center;
 `)]), L("color-picker-control", `
 padding: 12px;
 `), L("color-picker-action", `
 display: flex;
 margin-top: -4px;
 border-top: 1px solid var(--n-divider-color);
 padding: 8px 12px;
 justify-content: flex-end;
 `, [L("button", "margin-left: 8px;")]), L("color-picker-trigger", `
 border: var(--n-border);
 height: 100%;
 box-sizing: border-box;
 border-radius: var(--n-border-radius);
 transition: border-color .3s var(--n-bezier);
 cursor: pointer;
 `, [q("value", `
 white-space: nowrap;
 position: relative;
 `), q("fill", `
 border-radius: var(--n-border-radius);
 position: absolute;
 display: flex;
 align-items: center;
 justify-content: center;
 left: 4px;
 right: 4px;
 top: 4px;
 bottom: 4px;
 `), K("disabled", "cursor: not-allowed"), L("color-picker-checkboard", `
 border-radius: var(--n-border-radius);
 `, [Y("&::after", `
 --n-block-size: calc((var(--n-height) - 8px) / 3);
 background-size: calc(var(--n-block-size) * 2) calc(var(--n-block-size) * 2);
 background-position: 0 0, 0 var(--n-block-size), var(--n-block-size) calc(-1 * var(--n-block-size)), calc(-1 * var(--n-block-size)) 0px; 
 `)])]), L("color-picker-swatches", `
 display: grid;
 grid-gap: 8px;
 flex-wrap: wrap;
 position: relative;
 grid-template-columns: repeat(auto-fill, 18px);
 margin-top: 10px;
 `, [L("color-picker-swatch", `
 width: 18px;
 height: 18px;
 background-image: linear-gradient(45deg, #DDD 25%, #0000 25%), linear-gradient(-45deg, #DDD 25%, #0000 25%), linear-gradient(45deg, #0000 75%, #DDD 75%), linear-gradient(-45deg, #0000 75%, #DDD 75%);
 background-size: 8px 8px;
 background-position: 0px 0, 0px 4px, 4px -4px, -4px 0px;
 background-repeat: repeat;
 `, [q("fill", `
 position: relative;
 width: 100%;
 height: 100%;
 border-radius: 3px;
 box-shadow: rgba(0, 0, 0, .15) 0px 0px 0px 1px inset;
 cursor: pointer;
 `), Y("&:focus", `
 outline: none;
 `, [q("fill", [Y("&::after", `
 position: absolute;
 top: 0;
 right: 0;
 bottom: 0;
 left: 0;
 background: inherit;
 filter: blur(2px);
 content: "";
 `)])])])])]);
const zge = Object.assign(Object.assign({}, ft.props), { value: String, show: {
  type: Boolean,
  default: void 0
}, defaultShow: Boolean, defaultValue: String, modes: {
  type: Array,
  default: () => ["rgb", "hex", "hsl"]
}, placement: {
  type: String,
  default: "bottom-start"
}, to: vi.propTo, showAlpha: {
  type: Boolean,
  default: !0
}, showPreview: Boolean, swatches: Array, disabled: {
  type: Boolean,
  default: void 0
}, actions: {
  type: Array,
  default: null
}, internalActions: Array, size: String, renderLabel: Function, onComplete: Function, onConfirm: Function, "onUpdate:show": [Function, Array], onUpdateShow: [Function, Array], "onUpdate:value": [Function, Array], onUpdateValue: [Function, Array] });
var NH = oe({
  name: "ColorPicker",
  props: zge,
  setup(e, { slots: t }) {
    const r = G(null);
    let n = null;
    const i = ta(e), { mergedSizeRef: o, mergedDisabledRef: a } = i, { localeRef: s } = Zl("global"), { mergedClsPrefixRef: u, namespaceRef: d, inlineThemeDisabled: f } = Yt(e), h = ft("ColorPicker", "-color-picker", Nge, lge, e, u);
    tr(k4, {
      themeRef: h,
      renderLabelRef: tt(e, "renderLabel"),
      colorPickerSlots: t
    });
    const g = G(e.defaultShow), m = dn(tt(e, "show"), g);
    function v(H) {
      const { onUpdateShow: se, "onUpdate:show": pe } = e;
      se && je(se, H), pe && je(pe, H), g.value = H;
    }
    const { defaultValue: w } = e, x = G(w === void 0 ? sge(e.modes, e.showAlpha) : w), y = dn(tt(e, "value"), x), C = G([y.value]), S = G(0), T = j(() => E0(y.value)), { modes: A } = e, D = G(E0(y.value) || A[0] || "rgb");
    function E() {
      const { modes: H } = e, { value: se } = D, pe = H.findIndex((ae) => ae === se);
      ~pe ? D.value = H[(pe + 1) % H.length] : D.value = "rgb";
    }
    let N, I, $, _, R, U, Q, Z;
    const X = j(() => {
      const { value: H } = y;
      if (!H)
        return null;
      switch (T.value) {
        case "hsv":
          return jf(H);
        case "hsl":
          return [N, I, $, Z] = ep(H), [...uU(N, I, $), Z];
        case "rgb":
        case "hex":
          return [R, U, Q, Z] = ro(H), [...GN(R, U, Q), Z];
      }
    }), re = j(() => {
      const { value: H } = y;
      if (!H)
        return null;
      switch (T.value) {
        case "rgb":
        case "hex":
          return ro(H);
        case "hsv":
          return [N, I, _, Z] = jf(H), [...oc(N, I, _), Z];
        case "hsl":
          return [N, I, $, Z] = ep(H), [...KN(N, I, $), Z];
      }
    }), ue = j(() => {
      const { value: H } = y;
      if (!H)
        return null;
      switch (T.value) {
        case "hsl":
          return ep(H);
        case "hsv":
          return [N, I, _, Z] = jf(H), [...Yy(N, I, _), Z];
        case "rgb":
        case "hex":
          return [R, U, Q, Z] = ro(H), [...ZN(R, U, Q), Z];
      }
    }), he = j(() => {
      switch (D.value) {
        case "rgb":
        case "hex":
          return re.value;
        case "hsv":
          return X.value;
        case "hsl":
          return ue.value;
      }
    }), te = G(0), de = G(1), De = G([0, 0]);
    function Oe(H, se) {
      const { value: pe } = X, ae = te.value, Me = pe ? pe[3] : 1;
      De.value = [H, se];
      const { showAlpha: fe } = e;
      switch (D.value) {
        case "hsv":
          Ne((fe ? Ff : ez)([ae, H, se, Me]), "cursor");
          break;
        case "hsl":
          Ne((fe ? hc : tz)([
            ...Yy(ae, H, se),
            Me
          ]), "cursor");
          break;
        case "rgb":
          Ne((fe ? gs : JN)([
            ...oc(ae, H, se),
            Me
          ]), "cursor");
          break;
        case "hex":
          Ne((fe ? pc : qv)([
            ...oc(ae, H, se),
            Me
          ]), "cursor");
          break;
      }
    }
    function Qe(H) {
      te.value = H;
      const { value: se } = X;
      if (!se)
        return;
      const [, pe, ae, Me] = se, { showAlpha: fe } = e;
      switch (D.value) {
        case "hsv":
          Ne((fe ? Ff : ez)([H, pe, ae, Me]), "cursor");
          break;
        case "rgb":
          Ne((fe ? gs : JN)([
            ...oc(H, pe, ae),
            Me
          ]), "cursor");
          break;
        case "hex":
          Ne((fe ? pc : qv)([
            ...oc(H, pe, ae),
            Me
          ]), "cursor");
          break;
        case "hsl":
          Ne((fe ? hc : tz)([
            ...Yy(H, pe, ae),
            Me
          ]), "cursor");
          break;
      }
    }
    function Ae(H) {
      switch (D.value) {
        case "hsv":
          [N, I, _] = X.value, Ne(Ff([N, I, _, H]), "cursor");
          break;
        case "rgb":
          [R, U, Q] = re.value, Ne(gs([R, U, Q, H]), "cursor");
          break;
        case "hex":
          [R, U, Q] = re.value, Ne(pc([R, U, Q, H]), "cursor");
          break;
        case "hsl":
          [N, I, $] = ue.value, Ne(hc([N, I, $, H]), "cursor");
          break;
      }
      de.value = H;
    }
    function Ne(H, se) {
      se === "cursor" ? n = H : n = null;
      const { nTriggerFormChange: pe, nTriggerFormInput: ae } = i, { onUpdateValue: Me, "onUpdate:value": fe } = e;
      Me && je(Me, H), fe && je(fe, H), pe(), ae(), x.value = H;
    }
    function $e(H) {
      Ne(H, "input"), an(et);
    }
    function et(H = !0) {
      const { value: se } = y;
      if (se) {
        const { nTriggerFormChange: pe, nTriggerFormInput: ae } = i, { onComplete: Me } = e;
        Me && Me(se);
        const { value: fe } = C, { value: ke } = S;
        H && (fe.splice(ke + 1, fe.length, se), S.value = ke + 1), pe(), ae();
      }
    }
    function Ge() {
      const { value: H } = S;
      H - 1 < 0 || (Ne(C.value[H - 1], "input"), et(!1), S.value = H - 1);
    }
    function Ee() {
      const { value: H } = S;
      H < 0 || H + 1 >= C.value.length || (Ne(C.value[H + 1], "input"), et(!1), S.value = H + 1);
    }
    function qe() {
      Ne(null, "input"), v(!1);
    }
    function Ue() {
      const { value: H } = y, { onConfirm: se } = e;
      se && se(H), v(!1);
    }
    const ot = j(() => S.value >= 1), Ie = j(() => {
      const { value: H } = C;
      return H.length > 1 && S.value < H.length - 1;
    });
    Gt(m, (H) => {
      H || (C.value = [y.value], S.value = 0);
    }), On(() => {
      if (!(n && n === y.value)) {
        const { value: H } = X;
        H && (te.value = H[0], de.value = H[3], De.value = [H[1], H[2]]);
      }
      n = null;
    });
    const rt = j(() => {
      const { value: H } = o, { common: { cubicBezierEaseInOut: se }, self: { textColor: pe, color: ae, panelFontSize: Me, boxShadow: fe, border: ke, borderRadius: Le, dividerColor: dt, [Be("height", H)]: Mt, [Be("fontSize", H)]: Ct } } = h.value;
      return {
        "--n-bezier": se,
        "--n-text-color": pe,
        "--n-color": ae,
        "--n-panel-font-size": Me,
        "--n-font-size": Ct,
        "--n-box-shadow": fe,
        "--n-border": ke,
        "--n-border-radius": Le,
        "--n-height": Mt,
        "--n-divider-color": dt
      };
    }), W = f ? Cr("color-picker", j(() => o.value[0]), rt, e) : void 0;
    function P() {
      var H;
      const { value: se } = re, { value: pe } = te, { internalActions: ae, modes: Me, actions: fe } = e, { value: ke } = h, { value: Le } = u;
      return b("div", { class: [
        `${Le}-color-picker-panel`,
        W == null ? void 0 : W.themeClass.value
      ], onDragstart: (dt) => {
        dt.preventDefault();
      }, style: f ? void 0 : rt.value }, b("div", { class: `${Le}-color-picker-control` }, b(bge, { clsPrefix: Le, rgba: se, displayedHue: pe, displayedSv: De.value, onUpdateSV: Oe, onComplete: et }), b("div", { class: `${Le}-color-picker-preview` }, b("div", { class: `${Le}-color-picker-preview__sliders` }, b(gge, { clsPrefix: Le, hue: pe, onUpdateHue: Qe, onComplete: et }), e.showAlpha ? b(vge, { clsPrefix: Le, rgba: se, alpha: de.value, onUpdateAlpha: Ae, onComplete: et }) : null), e.showPreview ? b(Ige, { clsPrefix: Le, mode: D.value, color: re.value && qv(re.value), onUpdateColor: (dt) => {
        Ne(dt, "input");
      } }) : null), b(Tge, { clsPrefix: Le, showAlpha: e.showAlpha, mode: D.value, modes: Me, onUpdateMode: E, value: y.value, valueArr: he.value, onUpdateValue: $e }), ((H = e.swatches) === null || H === void 0 ? void 0 : H.length) && b(Ege, { clsPrefix: Le, mode: D.value, swatches: e.swatches, onUpdateColor: (dt) => {
        Ne(dt, "input");
      } })), fe != null && fe.length ? b("div", { class: `${Le}-color-picker-action` }, fe.includes("confirm") && b(Mn, { size: "small", onClick: Ue, theme: ke.peers.Button, themeOverrides: ke.peerOverrides.Button }, { default: () => s.value.confirm }), fe.includes("clear") && b(Mn, { size: "small", onClick: qe, disabled: !y.value, theme: ke.peers.Button, themeOverrides: ke.peerOverrides.Button }, { default: () => s.value.clear })) : null, t.action ? b("div", { class: `${Le}-color-picker-action` }, { default: t.action }) : ae ? b("div", { class: `${Le}-color-picker-action` }, ae.includes("undo") && b(Mn, { size: "small", onClick: Ge, disabled: !ot.value, theme: ke.peers.Button, themeOverrides: ke.peerOverrides.Button }, { default: () => s.value.undo }), ae.includes("redo") && b(Mn, { size: "small", onClick: Ee, disabled: !Ie.value, theme: ke.peers.Button, themeOverrides: ke.peerOverrides.Button }, { default: () => s.value.redo })) : null);
    }
    return {
      mergedClsPrefix: u,
      namespace: d,
      selfRef: r,
      hsla: ue,
      rgba: re,
      mergedShow: m,
      mergedDisabled: a,
      isMounted: ql(),
      adjustedTo: vi(e),
      mergedValue: y,
      handleTriggerClick() {
        v(!0);
      },
      handleClickOutside(H) {
        var se;
        !((se = r.value) === null || se === void 0) && se.contains(Ul(H)) || v(!1);
      },
      renderPanel: P,
      cssVars: f ? void 0 : rt,
      themeClass: W == null ? void 0 : W.themeClass,
      onRender: W == null ? void 0 : W.onRender
    };
  },
  render() {
    const { $slots: e, mergedClsPrefix: t, onRender: r } = this;
    return r == null || r(), b("div", { class: [this.themeClass, `${t}-color-picker`], ref: "selfRef", style: this.cssVars }, b(zc, null, {
      default: () => [
        b($c, null, {
          default: () => b(kge, { clsPrefix: t, value: this.mergedValue, hsla: this.hsla, disabled: this.mergedDisabled, onClick: this.handleTriggerClick }, {
            label: e.label
          })
        }),
        b(_c, { placement: this.placement, show: this.mergedShow, containerClass: this.namespace, teleportDisabled: this.adjustedTo === vi.tdkey, to: this.adjustedTo }, {
          default: () => b(jn, { name: "fade-in-scale-up-transition", appear: this.isMounted }, {
            default: () => this.mergedShow ? Jn(this.renderPanel(), [
              [
                ks,
                this.handleClickOutside,
                void 0,
                { capture: !0 }
              ]
            ]) : null
          })
        })
      ]
    }));
  }
}), $ge = {
  paddingSmall: "12px 16px 12px",
  paddingMedium: "19px 24px 20px",
  paddingLarge: "23px 32px 24px",
  paddingHuge: "27px 40px 28px",
  titleFontSizeSmall: "16px",
  titleFontSizeMedium: "18px",
  titleFontSizeLarge: "18px",
  titleFontSizeHuge: "18px",
  closeIconSize: "18px",
  closeSize: "22px"
};
const Oge = (e) => {
  const { primaryColor: t, borderRadius: r, lineHeight: n, fontSize: i, cardColor: o, textColor2: a, textColor1: s, dividerColor: u, fontWeightStrong: d, closeIconColor: f, closeIconColorHover: h, closeIconColorPressed: g, closeColorHover: m, closeColorPressed: v, modalColor: w, boxShadow1: x, popoverColor: y, actionColor: C } = e;
  return Object.assign(Object.assign({}, $ge), {
    lineHeight: n,
    color: o,
    colorModal: w,
    colorPopover: y,
    colorTarget: t,
    colorEmbedded: C,
    colorEmbeddedModal: C,
    colorEmbeddedPopover: C,
    textColor: a,
    titleTextColor: s,
    borderColor: u,
    actionColor: C,
    titleFontWeight: d,
    closeColorHover: m,
    closeColorPressed: v,
    closeBorderRadius: r,
    closeIconColor: f,
    closeIconColorHover: h,
    closeIconColorPressed: g,
    fontSizeSmall: i,
    fontSizeMedium: i,
    fontSizeLarge: i,
    fontSizeHuge: i,
    boxShadow: x,
    borderRadius: r
  });
}, _ge = {
  name: "Card",
  common: Sr,
  self: Oge
};
var zH = _ge, Lge = Y([L("card", `
 font-size: var(--n-font-size);
 line-height: var(--n-line-height);
 display: flex;
 flex-direction: column;
 width: 100%;
 box-sizing: border-box;
 position: relative;
 border-radius: var(--n-border-radius);
 background-color: var(--n-color);
 color: var(--n-text-color);
 word-break: break-word;
 transition: 
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `, [yU({
  background: "var(--n-color-modal)"
}), K("hoverable", [Y("&:hover", "box-shadow: var(--n-box-shadow);")]), K("content-segmented", [Y(">", [q("content", {
  paddingTop: "var(--n-padding-bottom)"
})])]), K("content-soft-segmented", [Y(">", [q("content", `
 margin: 0 var(--n-padding-left);
 padding: var(--n-padding-bottom) 0;
 `)])]), K("footer-segmented", [Y(">", [q("footer", {
  paddingTop: "var(--n-padding-bottom)"
})])]), K("footer-soft-segmented", [Y(">", [q("footer", `
 padding: var(--n-padding-bottom) 0;
 margin: 0 var(--n-padding-left);
 `)])]), Y(">", [L("card-header", `
 box-sizing: border-box;
 display: flex;
 align-items: center;
 font-size: var(--n-title-font-size);
 padding:
 var(--n-padding-top)
 var(--n-padding-left)
 var(--n-padding-bottom)
 var(--n-padding-left);
 `, [q("main", `
 font-weight: var(--n-title-font-weight);
 transition: color .3s var(--n-bezier);
 flex: 1;
 min-width: 0;
 color: var(--n-title-text-color);
 `), q("extra", `
 display: flex;
 align-items: center;
 font-size: var(--n-font-size);
 font-weight: 400;
 transition: color .3s var(--n-bezier);
 color: var(--n-text-color);
 `), q("close", `
 margin: 0 0 0 8px;
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `)]), q("action", `
 box-sizing: border-box;
 transition:
 background-color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 background-clip: padding-box;
 background-color: var(--n-action-color);
 `), q("content", "flex: 1; min-width: 0;"), q("content, footer", `
 box-sizing: border-box;
 padding: 0 var(--n-padding-left) var(--n-padding-bottom) var(--n-padding-left);
 font-size: var(--n-font-size);
 `, [Y("&:first-child", {
  paddingTop: "var(--n-padding-bottom)"
})]), q("action", `
 background-color: var(--n-action-color);
 padding: var(--n-padding-bottom) var(--n-padding-left);
 border-bottom-left-radius: var(--n-border-radius);
 border-bottom-right-radius: var(--n-border-radius);
 `)]), L("card-cover", `
 overflow: hidden;
 width: 100%;
 border-radius: var(--n-border-radius) var(--n-border-radius) 0 0;
 `, [Y("img", `
 display: block;
 width: 100%;
 `)]), K("bordered", `
 border: 1px solid var(--n-border-color);
 `, [Y("&:target", "border-color: var(--n-color-target);")]), K("action-segmented", [Y(">", [q("action", [Y("&:not(:first-child)", {
  borderTop: "1px solid var(--n-border-color)"
})])])]), K("content-segmented, content-soft-segmented", [Y(">", [q("content", {
  transition: "border-color 0.3s var(--n-bezier)"
}, [Y("&:not(:first-child)", {
  borderTop: "1px solid var(--n-border-color)"
})])])]), K("footer-segmented, footer-soft-segmented", [Y(">", [q("footer", {
  transition: "border-color 0.3s var(--n-bezier)"
}, [Y("&:not(:first-child)", {
  borderTop: "1px solid var(--n-border-color)"
})])])]), K("embedded", `
 background-color: var(--n-color-embedded);
 `)]), Bp(L("card", `
 background: var(--n-color-modal);
 `, [K("embedded", `
 background-color: var(--n-color-embedded-modal);
 `)])), hb(L("card", `
 background: var(--n-color-popover);
 `, [K("embedded", `
 background-color: var(--n-color-embedded-popover);
 `)]))]);
const D4 = {
  title: String,
  contentStyle: [Object, String],
  headerStyle: [Object, String],
  headerExtraStyle: [Object, String],
  footerStyle: [Object, String],
  embedded: Boolean,
  segmented: {
    type: [Boolean, Object],
    default: !1
  },
  size: {
    type: String,
    default: "medium"
  },
  bordered: {
    type: Boolean,
    default: !0
  },
  closable: Boolean,
  hoverable: Boolean,
  role: String,
  onClose: [Function, Array],
  tag: {
    type: String,
    default: "div"
  }
}, Pge = Ts(D4), Rge = Object.assign(Object.assign({}, ft.props), D4);
var $H = oe({
  name: "Card",
  props: Rge,
  setup(e) {
    const t = () => {
      const { onClose: d } = e;
      d && je(d);
    }, { inlineThemeDisabled: r, mergedClsPrefixRef: n, mergedRtlRef: i } = Yt(e), o = ft("Card", "-card", Lge, zH, e, n), a = Li("Card", i, n), s = j(() => {
      const { size: d } = e, { self: { color: f, colorModal: h, colorTarget: g, textColor: m, titleTextColor: v, titleFontWeight: w, borderColor: x, actionColor: y, borderRadius: C, lineHeight: S, closeIconColor: T, closeIconColorHover: A, closeIconColorPressed: D, closeColorHover: E, closeColorPressed: N, closeBorderRadius: I, closeIconSize: $, closeSize: _, boxShadow: R, colorPopover: U, colorEmbedded: Q, colorEmbeddedModal: Z, colorEmbeddedPopover: X, [Be("padding", d)]: re, [Be("fontSize", d)]: ue, [Be("titleFontSize", d)]: he }, common: { cubicBezierEaseInOut: te } } = o.value, { top: de, left: De, bottom: Oe } = Ll(re);
      return {
        "--n-bezier": te,
        "--n-border-radius": C,
        "--n-color": f,
        "--n-color-modal": h,
        "--n-color-popover": U,
        "--n-color-embedded": Q,
        "--n-color-embedded-modal": Z,
        "--n-color-embedded-popover": X,
        "--n-color-target": g,
        "--n-text-color": m,
        "--n-line-height": S,
        "--n-action-color": y,
        "--n-title-text-color": v,
        "--n-title-font-weight": w,
        "--n-close-icon-color": T,
        "--n-close-icon-color-hover": A,
        "--n-close-icon-color-pressed": D,
        "--n-close-color-hover": E,
        "--n-close-color-pressed": N,
        "--n-border-color": x,
        "--n-box-shadow": R,
        "--n-padding-top": de,
        "--n-padding-bottom": Oe,
        "--n-padding-left": De,
        "--n-font-size": ue,
        "--n-title-font-size": he,
        "--n-close-size": _,
        "--n-close-icon-size": $,
        "--n-close-border-radius": I
      };
    }), u = r ? Cr("card", j(() => e.size[0]), s, e) : void 0;
    return {
      rtlEnabled: a,
      mergedClsPrefix: n,
      mergedTheme: o,
      handleCloseClick: t,
      cssVars: r ? void 0 : s,
      themeClass: u == null ? void 0 : u.themeClass,
      onRender: u == null ? void 0 : u.onRender
    };
  },
  render() {
    const { segmented: e, bordered: t, hoverable: r, mergedClsPrefix: n, rtlEnabled: i, onRender: o, embedded: a, tag: s, $slots: u } = this;
    return o == null || o(), b(s, { class: [
      `${n}-card`,
      this.themeClass,
      a && `${n}-card--embedded`,
      {
        [`${n}-card--rtl`]: i,
        [`${n}-card--content${typeof e != "boolean" && e.content === "soft" ? "-soft" : ""}-segmented`]: e === !0 || e !== !1 && e.content,
        [`${n}-card--footer${typeof e != "boolean" && e.footer === "soft" ? "-soft" : ""}-segmented`]: e === !0 || e !== !1 && e.footer,
        [`${n}-card--action-segmented`]: e === !0 || e !== !1 && e.action,
        [`${n}-card--bordered`]: t,
        [`${n}-card--hoverable`]: r
      }
    ], style: this.cssVars, role: this.role }, Fr(u.cover, (d) => d && b("div", { class: `${n}-card-cover`, role: "none" }, d)), Fr(u.header, (d) => d || this.title || this.closable ? b("div", { class: `${n}-card-header`, style: this.headerStyle }, b("div", { class: `${n}-card-header__main`, role: "heading" }, d || this.title), Fr(u["header-extra"], (f) => f && b("div", { class: `${n}-card-header__extra`, style: this.headerExtraStyle }, f)), this.closable ? b(gh, { clsPrefix: n, class: `${n}-card-header__close`, onClick: this.handleCloseClick, absolute: !0 }) : null) : null), Fr(u.default, (d) => d && b("div", { class: `${n}-card__content`, style: this.contentStyle, role: "none" }, d)), Fr(u.footer, (d) => d && [
      b("div", { class: `${n}-card__footer`, style: this.footerStyle, role: "none" }, d)
    ]), Fr(u.action, (d) => d && b("div", { class: `${n}-card__action`, role: "none" }, d)));
  }
});
const jge = (e) => ({
  dotSize: "8px",
  dotColor: "rgba(255, 255, 255, .3)",
  dotColorActive: "rgba(255, 255, 255, 1)",
  dotColorFocus: "rgba(255, 255, 255, .5)",
  dotLineWidth: "16px",
  dotLineWidthActive: "24px",
  arrowColor: "#eee"
}), Fge = {
  name: "Carousel",
  common: Sr,
  self: jge
};
var Bge = Fge;
function Uge(e) {
  const { length: t } = e;
  return t > 1 && (e.push(UP(e[0], 0, "append")), e.unshift(UP(e[t - 1], t - 1, "prepend"))), e;
}
function UP(e, t, r) {
  return db(e, {
    key: `carousel-item-duplicate-${t}-${r}`
  });
}
function HP(e, t, r) {
  return r ? e === 0 ? t - 3 : e === t - 1 ? 0 : e - 1 : e;
}
function VI(e, t) {
  return t ? e + 1 : e;
}
function Hge(e, t, r) {
  return e < 0 ? null : e === 0 ? r ? t - 1 : null : e - 1;
}
function Wge(e, t, r) {
  return e > t - 1 ? null : e === t - 1 ? r ? 0 : null : e + 1;
}
function Vge(e, t) {
  return t && e > 3 ? e - 2 : e;
}
function WP(e) {
  return window.TouchEvent && e instanceof window.TouchEvent;
}
function VP(e, t) {
  let { offsetWidth: r, offsetHeight: n } = e;
  if (t) {
    const i = getComputedStyle(e);
    r = r - parseFloat(i.getPropertyValue("padding-left")) - parseFloat(i.getPropertyValue("padding-right")), n = n - parseFloat(i.getPropertyValue("padding-top")) - parseFloat(i.getPropertyValue("padding-bottom"));
  }
  return { width: r, height: n };
}
function cy(e, t, r) {
  return e < t ? t : e > r ? r : e;
}
function Yge(e) {
  if (e === void 0)
    return 0;
  if (typeof e == "number")
    return e;
  const t = /^((\d+)?\.?\d+?)(ms|s)?$/, r = e.match(t);
  if (r) {
    const [, n, , i = "ms"] = r;
    return Number(n) * (i === "ms" ? 1 : 1e3);
  }
  return 0;
}
const OH = "n-carousel-methods", Qge = (e) => {
  tr(OH, e);
}, A4 = (e = "unknown", t = "component") => {
  const r = lt(OH);
  return r || Ql(e, `\`${t}\` must be placed inside \`n-carousel\`.`), r;
}, qge = {
  total: {
    type: Number,
    default: 0
  },
  currentIndex: {
    type: Number,
    default: 0
  },
  dotType: {
    type: String,
    default: "dot"
  },
  trigger: {
    type: String,
    default: "click"
  },
  keyboard: Boolean
};
var Gge = oe({
  name: "CarouselDots",
  props: qge,
  setup(e) {
    const { mergedClsPrefixRef: t } = Yt(e), r = G([]), n = A4();
    function i(d, f) {
      switch (d.key) {
        case "Enter":
        case " ":
          d.preventDefault(), n.to(f);
          return;
      }
      e.keyboard && s(d);
    }
    function o(d) {
      e.trigger === "hover" && n.to(d);
    }
    function a(d) {
      e.trigger === "click" && n.to(d);
    }
    function s(d) {
      var f;
      if (d.shiftKey || d.altKey || d.ctrlKey || d.metaKey)
        return;
      const h = (f = document.activeElement) === null || f === void 0 ? void 0 : f.nodeName.toLowerCase();
      if (h === "input" || h === "textarea")
        return;
      const { code: g } = d, m = g === "PageUp" || g === "ArrowUp", v = g === "PageDown" || g === "ArrowDown", w = g === "PageUp" || g === "ArrowRight", x = g === "PageDown" || g === "ArrowLeft", y = n.isVertical(), C = y ? m : w, S = y ? v : x;
      !C && !S || (d.preventDefault(), C && !n.isNextDisabled() ? (n.next(), u(n.currentIndexRef.value)) : S && !n.isPrevDisabled() && (n.prev(), u(n.currentIndexRef.value)));
    }
    function u(d) {
      var f;
      (f = r.value[d]) === null || f === void 0 || f.focus();
    }
    return Nc(() => r.value.length = 0), {
      mergedClsPrefix: t,
      dotEls: r,
      handleKeydown: i,
      handleMouseenter: o,
      handleClick: a
    };
  },
  render() {
    const { mergedClsPrefix: e, dotEls: t } = this;
    return b("div", { class: [
      `${e}-carousel__dots`,
      `${e}-carousel__dots--${this.dotType}`
    ], role: "tablist" }, RK(this.total, (r) => {
      const n = r === this.currentIndex;
      return b("div", { "aria-selected": n, ref: (i) => t.push(i), role: "button", tabindex: "0", class: [
        `${e}-carousel__dot`,
        n && `${e}-carousel__dot--active`
      ], key: r, onClick: () => {
        this.handleClick(r);
      }, onMouseenter: () => {
        this.handleMouseenter(r);
      }, onKeydown: (i) => {
        this.handleKeydown(i, r);
      } });
    }));
  }
});
const Zge = b("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" }, b("g", { fill: "none" }, b("path", { d: "M10.26 3.2a.75.75 0 0 1 .04 1.06L6.773 8l3.527 3.74a.75.75 0 1 1-1.1 1.02l-4-4.25a.75.75 0 0 1 0-1.02l4-4.25a.75.75 0 0 1 1.06-.04z", fill: "currentColor" }))), Kge = b("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" }, b("g", { fill: "none" }, b("path", { d: "M5.74 3.2a.75.75 0 0 0-.04 1.06L9.227 8L5.7 11.74a.75.75 0 1 0 1.1 1.02l4-4.25a.75.75 0 0 0 0-1.02l-4-4.25a.75.75 0 0 0-1.06-.04z", fill: "currentColor" })));
var Xge = oe({
  name: "CarouselArrow",
  setup(e) {
    const { mergedClsPrefixRef: t } = Yt(e), { isVertical: r, isPrevDisabled: n, isNextDisabled: i, prev: o, next: a } = A4();
    return {
      mergedClsPrefix: t,
      isVertical: r,
      isPrevDisabled: n,
      isNextDisabled: i,
      prev: o,
      next: a
    };
  },
  render() {
    const { mergedClsPrefix: e } = this;
    return b("div", { class: `${e}-carousel__arrow-group` }, b("div", { class: [
      `${e}-carousel__arrow`,
      this.isPrevDisabled() && `${e}-carousel__arrow--disabled`
    ], role: "button", onClick: this.prev }, Zge), b("div", { class: [
      `${e}-carousel__arrow`,
      this.isNextDisabled() && `${e}-carousel__arrow--disabled`
    ], role: "button", onClick: this.next }, Kge));
  }
});
const Ky = "CarouselItem", Jge = (e) => {
  var t;
  return ((t = e.type) === null || t === void 0 ? void 0 : t.name) === Ky;
};
var E4 = oe({
  name: Ky,
  setup(e) {
    const { mergedClsPrefixRef: t } = Yt(e), r = A4(N3(Ky), `n-${N3(Ky)}`), n = G(), i = j(() => {
      const { value: f } = n;
      return f ? r.getSlideIndex(f) : -1;
    }), o = j(() => r.isPrev(i.value)), a = j(() => r.isNext(i.value)), s = j(() => r.isActive(i.value)), u = j(() => r.getSlideStyle(i.value));
    br(() => {
      r.addSlide(n.value);
    }), Gr(() => {
      r.removeSlide(n.value);
    });
    function d(f) {
      const { value: h } = i;
      h !== void 0 && (r == null || r.onCarouselItemClick(h, f));
    }
    return {
      mergedClsPrefix: t,
      selfElRef: n,
      isPrev: o,
      isNext: a,
      isActive: s,
      index: i,
      style: u,
      handleClick: d
    };
  },
  render() {
    var e;
    const { $slots: t, mergedClsPrefix: r, isPrev: n, isNext: i, isActive: o, index: a, style: s } = this, u = [
      `${r}-carousel__slide`,
      {
        [`${r}-carousel__slide--current`]: o,
        [`${r}-carousel__slide--prev`]: n,
        [`${r}-carousel__slide--next`]: i
      }
    ];
    return b("div", {
      ref: "selfElRef",
      class: u,
      role: "option",
      tabindex: "-1",
      "data-index": a,
      "aria-hidden": !o,
      style: s,
      onClickCapture: this.handleClick
    }, (e = t.default) === null || e === void 0 ? void 0 : e.call(t, {
      isPrev: n,
      isNext: i,
      isActive: o,
      index: a
    }));
  }
}), eme = L("carousel", `
 position: relative;
 width: 100%;
 height: 100%;
 touch-action: pan-y;
 overflow: hidden;
`, [q("slides", `
 display: flex;
 width: 100%;
 height: 100%;
 transition-timing-function: var(--n-bezier);
 transition-property: transform;
 `, [q("slide", `
 flex-shrink: 0;
 position: relative;
 width: 100%;
 height: 100%;
 outline: none;
 overflow: hidden;
 `, [Y("> img", `
 display: block;
 `)])]), q("dots", `
 position: absolute;
 display: flex;
 flex-wrap: nowrap;
 `, [K("dot", [q("dot", `
 height: var(--n-dot-size);
 width: var(--n-dot-size);
 background-color: var(--n-dot-color);
 border-radius: 50%;
 cursor: pointer;
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 outline: none;
 `, [Y("&:focus", `
 background-color: var(--n-dot-color-focus);
 `), K("active", `
 background-color: var(--n-dot-color-active);
 `)])]), K("line", [q("dot", `
 border-radius: 9999px;
 width: var(--n-dot-line-width);
 height: 4px;
 background-color: var(--n-dot-color);
 cursor: pointer;
 transition:
 width .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 outline: none;
 `, [Y("&:focus", `
 background-color: var(--n-dot-color-focus);
 `), K("active", `
 width: var(--n-dot-line-width-active);
 background-color: var(--n-dot-color-active);
 `)])])]), q("arrow", `
 transition: background-color .3s var(--n-bezier);
 cursor: pointer;
 height: 28px;
 width: 28px;
 display: flex;
 align-items: center;
 justify-content: center;
 background-color: rgba(255, 255, 255, .2);
 color: var(--n-arrow-color);
 border-radius: 8px;
 user-select: none;
 -webkit-user-select: none;
 font-size: 18px;
 `, [Y("svg", `
 height: 1em;
 width: 1em;
 `), Y("&:hover", `
 background-color: rgba(255, 255, 255, .3);
 `)]), K("vertical", `
 touch-action: pan-x;
 `, [q("slides", `
 flex-direction: column;
 `), K("fade", [q("slide", `
 top: 50%;
 left: unset;
 transform: translateY(-50%);
 `)]), K("card", [q("slide", `
 top: 50%;
 left: unset;
 transform: translateY(-50%) translateZ(-400px);
 `, [K("current", `
 transform: translateY(-50%) translateZ(0);
 `), K("prev", `
 transform: translateY(-100%) translateZ(-200px);
 `), K("next", `
 transform: translateY(0%) translateZ(-200px);
 `)])])]), K("usercontrol", [q("slides", [Y(">", [Y("div", `
 position: absolute;
 top: 50%;
 left: 50%;
 width: 100%;
 height: 100%;
 transform: translate(-50%, -50%);
 `)])])]), K("left", [q("dots", `
 transform: translateY(-50%);
 top: 50%;
 left: 12px;
 flex-direction: column;
 `, [K("line", [q("dot", `
 width: 4px;
 height: var(--n-dot-line-width);
 margin: 4px 0;
 transition:
 height .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 outline: none;
 `, [K("active", `
 height: var(--n-dot-line-width-active);
 `)])])]), q("dot", `
 margin: 4px 0;
 `)]), q("arrow-group", `
 position: absolute;
 display: flex;
 flex-wrap: nowrap;
 `), K("vertical", [q("arrow", `
 transform: rotate(90deg);
 `)]), K("show-arrow", [K("bottom", [q("dots", `
 transform: translateX(0);
 bottom: 18px;
 left: 18px;
 `)]), K("top", [q("dots", `
 transform: translateX(0);
 top: 18px;
 left: 18px;
 `)]), K("left", [q("dots", `
 transform: translateX(0);
 top: 18px;
 left: 18px;
 `)]), K("right", [q("dots", `
 transform: translateX(0);
 top: 18px;
 right: 18px;
 `)])]), K("left", [q("arrow-group", `
 bottom: 12px;
 left: 12px;
 flex-direction: column;
 `, [Y("> *:first-child", `
 margin-bottom: 12px;
 `)])]), K("right", [q("dots", `
 transform: translateY(-50%);
 top: 50%;
 right: 12px;
 flex-direction: column;
 `, [K("line", [q("dot", `
 width: 4px;
 height: var(--n-dot-line-width);
 margin: 4px 0;
 transition:
 height .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 outline: none;
 `, [K("active", `
 height: var(--n-dot-line-width-active);
 `)])])]), q("dot", `
 margin: 4px 0;
 `), q("arrow-group", `
 bottom: 12px;
 right: 12px;
 flex-direction: column;
 `, [Y("> *:first-child", `
 margin-bottom: 12px;
 `)])]), K("top", [q("dots", `
 transform: translateX(-50%);
 top: 12px;
 left: 50%;
 `, [K("line", [q("dot", `
 margin: 0 4px;
 `)])]), q("dot", `
 margin: 0 4px;
 `), q("arrow-group", `
 top: 12px;
 right: 12px;
 `, [Y("> *:first-child", `
 margin-right: 12px;
 `)])]), K("bottom", [q("dots", `
 transform: translateX(-50%);
 bottom: 12px;
 left: 50%;
 `, [K("line", [q("dot", `
 margin: 0 4px;
 `)])]), q("dot", `
 margin: 0 4px;
 `), q("arrow-group", `
 bottom: 12px;
 right: 12px;
 `, [Y("> *:first-child", `
 margin-right: 12px;
 `)])]), K("fade", [q("slide", `
 position: absolute;
 opacity: 0;
 transition-property: opacity;
 pointer-events: none;
 `, [K("current", `
 opacity: 1;
 pointer-events: auto;
 `)])]), K("card", [q("slides", `
 perspective: 1000px;
 `), q("slide", `
 position: absolute;
 left: 50%;
 opacity: 0;
 transform: translateX(-50%) translateZ(-400px);
 transition-property: opacity, transform;
 `, [K("current", `
 opacity: 1;
 transform: translateX(-50%) translateZ(0);
 z-index: 1;
 `), K("prev", `
 opacity: 0.4;
 transform: translateX(-100%) translateZ(-200px);
 `), K("next", `
 opacity: 0.4;
 transform: translateX(0%) translateZ(-200px);
 `)])])]);
const tme = [
  "transitionDuration",
  "transitionTimingFunction"
], rme = Object.assign(Object.assign({}, ft.props), { defaultIndex: {
  type: Number,
  default: 0
}, currentIndex: Number, showArrow: Boolean, dotType: {
  type: String,
  default: "dot"
}, dotPlacement: {
  type: String,
  default: "bottom"
}, slidesPerView: {
  type: [Number, String],
  default: 1
}, spaceBetween: {
  type: Number,
  default: 0
}, centeredSlides: Boolean, direction: {
  type: String,
  default: "horizontal"
}, autoplay: Boolean, interval: {
  type: Number,
  default: 5e3
}, loop: {
  type: Boolean,
  default: !0
}, effect: {
  type: String,
  default: "slide"
}, showDots: {
  type: Boolean,
  default: !0
}, trigger: {
  type: String,
  default: "click"
}, transitionStyle: {
  type: Object,
  default: () => ({
    transitionDuration: "300ms"
  })
}, transitionProps: Object, draggable: Boolean, prevSlideStyle: [Object, String], nextSlideStyle: [Object, String], touchable: {
  type: Boolean,
  default: !0
}, mousewheel: Boolean, keyboard: Boolean, "onUpdate:currentIndex": Function, onUpdateCurrentIndex: Function });
let YI = !1;
var _H = oe({
  name: "Carousel",
  props: rme,
  setup(e) {
    const { mergedClsPrefixRef: t, inlineThemeDisabled: r } = Yt(e), n = G(null), i = G(null), o = G([]), a = { value: [] }, s = j(() => e.direction === "vertical"), u = j(() => s.value ? "height" : "width"), d = j(() => s.value ? "bottom" : "right"), f = j(() => e.effect === "slide"), h = j(() => e.loop && e.slidesPerView === 1 && f.value), g = j(() => e.effect === "custom"), m = j(() => !f.value || e.centeredSlides ? 1 : e.slidesPerView), v = j(() => g.value ? 1 : e.slidesPerView), w = j(() => m.value === "auto" || e.slidesPerView === "auto" && e.centeredSlides), x = G({ width: 0, height: 0 }), y = j(() => {
      const { value: xe } = o;
      if (!xe.length)
        return [];
      const { value: Xe } = w;
      if (Xe)
        return xe.map((Tt) => VP(Tt));
      const { value: At } = v, { value: Ht } = x, { value: zt } = u;
      let ge = Ht[zt];
      if (At !== "auto") {
        const { spaceBetween: Tt } = e, lr = ge - (At - 1) * Tt, gr = 1 / Math.max(1, At);
        ge = lr * gr;
      }
      const Fe = Object.assign(Object.assign({}, Ht), { [zt]: ge });
      return xe.map(() => Fe);
    }), C = j(() => {
      const { value: xe } = y;
      if (!xe.length)
        return [];
      const { centeredSlides: Xe, spaceBetween: At } = e, { value: Ht } = u, { [Ht]: zt } = x.value;
      let ge = 0;
      return xe.map(({ [Ht]: Fe }) => {
        let Tt = ge;
        return Xe && (Tt += (Fe - zt) / 2), ge += Fe + At, Tt;
      });
    }), S = G(!1), T = j(() => {
      const { transitionStyle: xe } = e;
      return xe ? il(xe, tme) : {};
    }), A = j(() => g.value ? 0 : Yge(T.value.transitionDuration)), D = j(() => {
      const { value: xe } = o;
      if (!xe.length)
        return [];
      const Xe = !(w.value || v.value === 1), At = (Fe) => {
        if (Xe) {
          const { value: Tt } = u;
          return {
            [Tt]: `${y.value[Fe][Tt]}px`
          };
        }
      };
      if (g.value)
        return xe.map((Fe, Tt) => At(Tt));
      const { effect: Ht, spaceBetween: zt } = e, { value: ge } = d;
      return xe.reduce((Fe, Tt, lr) => {
        const gr = Object.assign(Object.assign({}, At(lr)), { [`margin-${ge}`]: `${zt}px` });
        return Fe.push(gr), S.value && (Ht === "fade" || Ht === "card") && Object.assign(gr, T.value), Fe;
      }, []);
    }), E = j(() => {
      const { value: xe } = m, { length: Xe } = o.value;
      if (xe !== "auto")
        return Math.max(Xe - xe, 0) + 1;
      {
        const { value: At } = y, { length: Ht } = At;
        if (!Ht)
          return Xe;
        const { value: zt } = C, { value: ge } = u, Fe = x.value[ge];
        let Tt = At[At.length - 1][ge], lr = Ht;
        for (; lr > 1 && Tt < Fe; )
          lr--, Tt += zt[lr] - zt[lr - 1];
        return cy(lr + 1, 1, Ht);
      }
    }), N = j(() => Vge(E.value, h.value)), I = VI(e.defaultIndex, h.value), $ = G(HP(I, E.value, h.value)), _ = dn(tt(e, "currentIndex"), $), R = j(() => VI(_.value, h.value));
    function U(xe) {
      var Xe, At;
      xe = cy(xe, 0, E.value - 1);
      const Ht = HP(xe, E.value, h.value), { value: zt } = _;
      Ht !== _.value && ($.value = Ht, (Xe = e["onUpdate:currentIndex"]) === null || Xe === void 0 || Xe.call(e, Ht, zt), (At = e.onUpdateCurrentIndex) === null || At === void 0 || At.call(e, Ht, zt));
    }
    function Q(xe = R.value) {
      return Hge(xe, E.value, e.loop);
    }
    function Z(xe = R.value) {
      return Wge(xe, E.value, e.loop);
    }
    function X(xe) {
      const Xe = H(xe);
      return Xe !== null && Q() === Xe;
    }
    function re(xe) {
      const Xe = H(xe);
      return Xe !== null && Z() === Xe;
    }
    function ue(xe) {
      return R.value === H(xe);
    }
    function he(xe) {
      return _.value === xe;
    }
    function te() {
      return Q() === null;
    }
    function de() {
      return Z() === null;
    }
    function De(xe) {
      const Xe = cy(VI(xe, h.value), 0, E.value);
      (xe !== _.value || Xe !== R.value) && U(Xe);
    }
    function Oe() {
      const xe = Q();
      xe !== null && U(xe);
    }
    function Qe() {
      const xe = Z();
      xe !== null && U(xe);
    }
    function Ae() {
      (!$e || !h.value) && Oe();
    }
    function Ne() {
      (!$e || !h.value) && Qe();
    }
    let $e = !1, et = 0;
    const Ge = G({});
    function Ee(xe, Xe = 0) {
      Ge.value = Object.assign({}, T.value, {
        transform: s.value ? `translateY(${-xe}px)` : `translateX(${-xe}px)`,
        transitionDuration: `${Xe}ms`
      });
    }
    function qe(xe = 0) {
      f.value ? Ue(R.value, xe) : et !== 0 && (!$e && xe > 0 && ($e = !0), Ee(et = 0, xe));
    }
    function Ue(xe, Xe) {
      const At = ot(xe);
      At !== et && Xe > 0 && ($e = !0), et = ot(R.value), Ee(At, Xe);
    }
    function ot(xe) {
      let Xe;
      return xe >= E.value - 1 ? Xe = Ie() : Xe = C.value[xe] || 0, Xe;
    }
    function Ie() {
      if (m.value === "auto") {
        const { value: xe } = u, { [xe]: Xe } = x.value, { value: At } = C, Ht = At[At.length - 1];
        let zt;
        if (Ht === void 0)
          zt = Xe;
        else {
          const { value: ge } = y;
          zt = Ht + ge[ge.length - 1][xe];
        }
        return zt - Xe;
      } else {
        const { value: xe } = C;
        return xe[E.value - 1] || 0;
      }
    }
    const rt = {
      currentIndexRef: _,
      to: De,
      prev: Ae,
      next: Ne,
      isVertical: () => s.value,
      isHorizontal: () => !s.value,
      isPrev: X,
      isNext: re,
      isActive: ue,
      isPrevDisabled: te,
      isNextDisabled: de,
      getSlideIndex: H,
      getSlideStyle: se,
      addSlide: W,
      removeSlide: P,
      onCarouselItemClick: pe
    };
    Qge(rt);
    function W(xe) {
      xe && o.value.push(xe);
    }
    function P(xe) {
      if (!xe)
        return;
      const Xe = H(xe);
      Xe !== -1 && o.value.splice(Xe, 1);
    }
    function H(xe) {
      return typeof xe == "number" ? xe : xe ? o.value.indexOf(xe) : -1;
    }
    function se(xe) {
      const Xe = H(xe);
      if (Xe !== -1) {
        const At = [D.value[Xe]], Ht = rt.isPrev(Xe), zt = rt.isNext(Xe);
        return Ht && At.push(e.prevSlideStyle || ""), zt && At.push(e.nextSlideStyle || ""), Jf(At);
      }
    }
    function pe(xe, Xe) {
      let At = !$e && !Ct && !er;
      e.effect === "card" && At && !ue(xe) && (De(xe), At = !1), At || (Xe.preventDefault(), Xe.stopPropagation());
    }
    let ae = null;
    function Me() {
      ae && (clearInterval(ae), ae = null);
    }
    function fe() {
      Me(), !e.autoplay || N.value < 2 || (ae = window.setInterval(Qe, e.interval));
    }
    let ke = 0, Le = 0, dt = 0, Mt = 0, Ct = !1, er = !1;
    function Vt(xe) {
      var Xe;
      if (YI || !(!((Xe = i.value) === null || Xe === void 0) && Xe.contains(Ul(xe))))
        return;
      YI = !0, Ct = !0, er = !1, Mt = Date.now(), Me(), xe.type !== "touchstart" && !xe.target.isContentEditable && xe.preventDefault();
      const At = WP(xe) ? xe.touches[0] : xe;
      s.value ? Le = At.clientY : ke = At.clientX, e.touchable && (Mr("touchmove", document, jt, { passive: !0 }), Mr("touchend", document, at), Mr("touchcancel", document, at)), e.draggable && (Mr("mousemove", document, jt), Mr("mouseup", document, at));
    }
    function jt(xe) {
      const { value: Xe } = s, { value: At } = u, Ht = WP(xe) ? xe.touches[0] : xe, zt = Xe ? Ht.clientY - Le : Ht.clientX - ke, ge = x.value[At];
      dt = cy(zt, -ge, ge), xe.cancelable && xe.preventDefault(), f.value && Ee(et - dt, 0);
    }
    function at() {
      const { value: xe } = R;
      let Xe = xe;
      if (!$e && dt !== 0 && f.value) {
        const At = et - dt, Ht = [
          ...C.value.slice(0, E.value - 1),
          Ie()
        ];
        let zt = null;
        for (let ge = 0; ge < Ht.length; ge++) {
          const Fe = Math.abs(Ht[ge] - At);
          if (zt !== null && zt < Fe)
            break;
          zt = Fe, Xe = ge;
        }
      }
      if (Xe === xe) {
        const At = Date.now() - Mt, { value: Ht } = u, zt = x.value[Ht];
        dt > zt / 2 || dt / At > 0.4 ? Xe = Q(xe) : (dt < -zt / 2 || dt / At < -0.4) && (Xe = Z(xe));
      }
      Xe !== null && Xe !== xe ? (er = !0, U(Xe), an(() => {
        (!h.value || $.value !== _.value) && qe(A.value);
      })) : qe(A.value), St(), fe();
    }
    function St() {
      Ct && (YI = !1), Ct = !1, ke = 0, Le = 0, dt = 0, Mt = 0, hr("touchmove", document, jt), hr("touchend", document, at), hr("touchcancel", document, at), hr("mousemove", document, jt), hr("mouseup", document, at);
    }
    function ve() {
      if (f.value && $e) {
        const { value: xe } = R;
        Ue(xe, 0);
      } else
        fe();
      f.value && (Ge.value.transitionDuration = "0ms"), $e = !1;
    }
    function We(xe) {
      if (xe.preventDefault(), $e)
        return;
      let { deltaX: Xe, deltaY: At } = xe;
      xe.shiftKey && !Xe && (Xe = At);
      const Ht = -1, zt = 1, ge = (Xe || At) > 0 ? zt : Ht;
      let Fe = 0, Tt = 0;
      s.value ? Tt = ge : Fe = ge;
      const lr = 10;
      (Tt * At >= lr || Fe * Xe >= lr) && (ge === zt && !de() ? Qe() : ge === Ht && !te() && Oe());
    }
    function ne() {
      x.value = VP(n.value, !0), fe();
    }
    function Se() {
      var xe, Xe;
      w.value && ((Xe = (xe = y.effect).scheduler) === null || Xe === void 0 || Xe.call(xe), y.effect.run());
    }
    function _e() {
      e.autoplay && Me();
    }
    function ut() {
      e.autoplay && fe();
    }
    br(() => {
      On(fe), requestAnimationFrame(() => S.value = !0);
    }), Gr(() => {
      St(), Me();
    }), fi(() => {
      const { value: xe } = o, { value: Xe } = a, At = /* @__PURE__ */ new Map(), Ht = (ge) => At.has(ge) ? At.get(ge) : -1;
      let zt = !1;
      for (let ge = 0; ge < xe.length; ge++) {
        const Fe = Xe.findIndex((Tt) => Tt.el === xe[ge]);
        Fe !== ge && (zt = !0), At.set(xe[ge], Fe);
      }
      zt && xe.sort((ge, Fe) => Ht(ge) - Ht(Fe));
    }), Gt(R, (xe, Xe) => {
      if (xe !== Xe)
        if (fe(), f.value) {
          if (h.value && N.value > 2) {
            const { value: At } = E;
            xe === At - 2 && Xe === 1 ? xe = 0 : xe === 1 && Xe === At - 2 && (xe = At - 1);
          }
          Ue(xe, A.value);
        } else
          qe();
    }, { immediate: !0 }), Gt([h, m], () => void an(() => {
      U(R.value);
    })), Gt(C, () => {
      f.value && qe();
    }, {
      deep: !0
    }), Gt(f, (xe) => {
      xe ? qe() : ($e = !1, Ee(et = 0));
    });
    const ht = j(() => ({
      onTouchstartPassive: e.touchable ? Vt : void 0,
      onMousedown: e.draggable ? Vt : void 0,
      onWheel: e.mousewheel ? We : void 0
    })), ye = j(() => Object.assign(Object.assign({}, il(rt, [
      "to",
      "prev",
      "next",
      "isPrevDisabled",
      "isNextDisabled"
    ])), { total: N.value, currentIndex: _.value })), Ze = j(() => ({
      total: N.value,
      currentIndex: _.value,
      to: rt.to
    })), st = {
      getCurrentIndex: () => _.value,
      to: De,
      prev: Oe,
      next: Qe
    }, Nt = ft("Carousel", "-carousel", eme, Bge, e, t), Te = j(() => {
      const { common: { cubicBezierEaseInOut: xe }, self: { dotSize: Xe, dotColor: At, dotColorActive: Ht, dotColorFocus: zt, dotLineWidth: ge, dotLineWidthActive: Fe, arrowColor: Tt } } = Nt.value;
      return {
        "--n-bezier": xe,
        "--n-dot-color": At,
        "--n-dot-color-focus": zt,
        "--n-dot-color-active": Ht,
        "--n-dot-size": Xe,
        "--n-dot-line-width": ge,
        "--n-dot-line-width-active": Fe,
        "--n-arrow-color": Tt
      };
    }), Ke = r ? Cr("carousel", void 0, Te, e) : void 0;
    return Object.assign(Object.assign({
      mergedClsPrefix: t,
      selfElRef: n,
      slidesElRef: i,
      slideVNodes: a,
      duplicatedable: h,
      userWantsControl: g,
      autoSlideSize: w,
      displayIndex: _,
      realIndex: R,
      slideStyles: D,
      translateStyle: Ge,
      slidesControlListeners: ht,
      handleTransitionEnd: ve,
      handleResize: ne,
      handleSlideResize: Se,
      handleMouseenter: _e,
      handleMouseleave: ut,
      isActive: he,
      arrowSlotProps: ye,
      dotSlotProps: Ze
    }, st), { cssVars: r ? void 0 : Te, themeClass: Ke == null ? void 0 : Ke.themeClass, onRender: Ke == null ? void 0 : Ke.onRender });
  },
  render() {
    var e;
    const { mergedClsPrefix: t, showArrow: r, userWantsControl: n, slideStyles: i, dotType: o, dotPlacement: a, slidesControlListeners: s, transitionProps: u = {}, arrowSlotProps: d, dotSlotProps: f, $slots: { default: h, dots: g, arrow: m } } = this, v = h && ms(h()) || [];
    let w = nme(v);
    return w.length || (w = v.map((x) => b(E4, null, {
      default: () => db(x)
    }))), this.duplicatedable && (w = Uge(w)), this.slideVNodes.value = w, this.autoSlideSize && (w = w.map((x) => b(Hl, { onResize: this.handleSlideResize }, {
      default: () => x
    }))), (e = this.onRender) === null || e === void 0 || e.call(this), b("div", Object.assign({ ref: "selfElRef", class: [
      this.themeClass,
      `${t}-carousel`,
      this.direction === "vertical" && `${t}-carousel--vertical`,
      this.showArrow && `${t}-carousel--show-arrow`,
      `${t}-carousel--${a}`,
      `${t}-carousel--${this.direction}`,
      `${t}-carousel--${this.effect}`,
      n && `${t}-carousel--usercontrol`
    ], style: this.cssVars }, s, { onMouseenter: this.handleMouseenter, onMouseleave: this.handleMouseleave }), b(Hl, { onResize: this.handleResize }, {
      default: () => b("div", { ref: "slidesElRef", class: `${t}-carousel__slides`, role: "listbox", style: this.translateStyle, onTransitionend: this.handleTransitionEnd }, n ? w.map((x, y) => b("div", { style: i[y], key: y }, Jn(b(jn, Object.assign({}, u), {
        default: () => x
      }), [[Ra, this.isActive(y)]]))) : w)
    }), this.showDots && f.total > 1 && v0(g, f, () => [
      b(Gge, { key: o + a, total: f.total, currentIndex: f.currentIndex, dotType: o, trigger: this.trigger, keyboard: this.keyboard })
    ]), r && v0(m, d, () => [
      b(Xge, null)
    ]));
  }
});
function nme(e) {
  return e.reduce((t, r) => (Jge(r) && t.push(r), t), []);
}
var ime = {
  sizeSmall: "14px",
  sizeMedium: "16px",
  sizeLarge: "18px",
  labelPadding: "0 8px",
  labelFontWeight: "400"
};
const ome = (e) => {
  const { baseColor: t, inputColorDisabled: r, cardColor: n, modalColor: i, popoverColor: o, textColorDisabled: a, borderColor: s, primaryColor: u, textColor2: d, fontSizeSmall: f, fontSizeMedium: h, fontSizeLarge: g, borderRadiusSmall: m, lineHeight: v } = e;
  return Object.assign(Object.assign({}, ime), {
    labelLineHeight: v,
    fontSizeSmall: f,
    fontSizeMedium: h,
    fontSizeLarge: g,
    borderRadius: m,
    color: t,
    colorChecked: u,
    colorDisabled: r,
    colorDisabledChecked: r,
    colorTableHeader: n,
    colorTableHeaderModal: i,
    colorTableHeaderPopover: o,
    checkMarkColor: t,
    checkMarkColorDisabled: a,
    checkMarkColorDisabledChecked: a,
    border: `1px solid ${s}`,
    borderDisabled: `1px solid ${s}`,
    borderDisabledChecked: `1px solid ${s}`,
    borderChecked: `1px solid ${u}`,
    borderFocus: `1px solid ${u}`,
    boxShadowFocus: `0 0 0 2px ${nr(u, { alpha: 0.3 })}`,
    textColor: d,
    textColorDisabled: a
  });
}, ame = {
  name: "Checkbox",
  common: Sr,
  self: ome
};
var LH = ame, lme = b("svg", { viewBox: "0 0 64 64", class: "check-icon" }, b("path", { d: "M50.42,16.76L22.34,39.45l-8.1-11.46c-1.12-1.58-3.3-1.96-4.88-0.84c-1.58,1.12-1.95,3.3-0.84,4.88l10.26,14.51  c0.56,0.79,1.42,1.31,2.38,1.45c0.16,0.02,0.32,0.03,0.48,0.03c0.8,0,1.57-0.27,2.2-0.78l30.99-25.03c1.5-1.21,1.74-3.42,0.52-4.92  C54.13,15.78,51.93,15.55,50.42,16.76z" })), sme = b("svg", { viewBox: "0 0 100 100", class: "line-icon" }, b("path", { d: "M80.2,55.5H21.4c-2.8,0-5.1-2.5-5.1-5.5l0,0c0-3,2.3-5.5,5.1-5.5h58.7c2.8,0,5.1,2.5,5.1,5.5l0,0C85.2,53.1,82.9,55.5,80.2,55.5z" }));
const PH = "n-checkbox-group", ume = {
  min: Number,
  max: Number,
  size: String,
  value: Array,
  defaultValue: {
    type: Array,
    default: null
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onChange: [Function, Array]
};
var cme = oe({
  name: "CheckboxGroup",
  props: ume,
  setup(e) {
    const { mergedClsPrefixRef: t } = Yt(e), r = ta(e), { mergedSizeRef: n, mergedDisabledRef: i } = r, o = G(e.defaultValue), a = j(() => e.value), s = dn(a, o), u = j(() => {
      var h;
      return ((h = s.value) === null || h === void 0 ? void 0 : h.length) || 0;
    }), d = j(() => Array.isArray(s.value) ? new Set(s.value) : /* @__PURE__ */ new Set());
    function f(h, g) {
      const { nTriggerFormInput: m, nTriggerFormChange: v } = r, { onChange: w, "onUpdate:value": x, onUpdateValue: y } = e;
      if (Array.isArray(s.value)) {
        const C = Array.from(s.value), S = C.findIndex((T) => T === g);
        h ? ~S || (C.push(g), y && je(y, C, {
          actionType: "check",
          value: g
        }), x && je(x, C, {
          actionType: "check",
          value: g
        }), m(), v(), o.value = C, w && je(w, C)) : ~S && (C.splice(S, 1), y && je(y, C, {
          actionType: "uncheck",
          value: g
        }), x && je(x, C, {
          actionType: "uncheck",
          value: g
        }), w && je(w, C), o.value = C, m(), v());
      } else
        h ? (y && je(y, [g], {
          actionType: "check",
          value: g
        }), x && je(x, [g], {
          actionType: "check",
          value: g
        }), w && je(w, [g]), o.value = [g], m(), v()) : (y && je(y, [], {
          actionType: "uncheck",
          value: g
        }), x && je(x, [], {
          actionType: "uncheck",
          value: g
        }), w && je(w, []), o.value = [], m(), v());
    }
    return tr(PH, {
      checkedCountRef: u,
      maxRef: tt(e, "max"),
      minRef: tt(e, "min"),
      valueSetRef: d,
      disabledRef: i,
      mergedSizeRef: n,
      toggleCheckbox: f
    }), {
      mergedClsPrefix: t
    };
  },
  render() {
    return b("div", { class: `${this.mergedClsPrefix}-checkbox-group`, role: "group" }, this.$slots);
  }
}), dme = Y([
  L("checkbox", `
 line-height: var(--n-label-line-height);
 font-size: var(--n-font-size);
 outline: none;
 cursor: pointer;
 display: inline-flex;
 flex-wrap: nowrap;
 align-items: flex-start;
 word-break: break-word;
 --n-merged-color-table: var(--n-color-table);
 `, [Y("&:hover", [L("checkbox-box", [q("border", {
    border: "var(--n-border-checked)"
  })])]), Y("&:focus:not(:active)", [L("checkbox-box", [q("border", `
 border: var(--n-border-focus);
 box-shadow: var(--n-box-shadow-focus);
 `)])]), K("inside-table", [L("checkbox-box", `
 background-color: var(--n-merged-color-table);
 `)]), K("checked", [L("checkbox-box", `
 background-color: var(--n-color-checked);
 `, [L("checkbox-icon", [
    Y(".check-icon", `
 opacity: 1;
 transform: scale(1);
 `)
  ])])]), K("indeterminate", [L("checkbox-box", [L("checkbox-icon", [Y(".check-icon", `
 opacity: 0;
 transform: scale(.5);
 `), Y(".line-icon", `
 opacity: 1;
 transform: scale(1);
 `)])])]), K("checked, indeterminate", [Y("&:focus:not(:active)", [L("checkbox-box", [q("border", `
 border: var(--n-border-checked);
 box-shadow: var(--n-box-shadow-focus);
 `)])]), L("checkbox-box", `
 background-color: var(--n-color-checked);
 border-left: 0;
 border-top: 0;
 `, [q("border", {
    border: "var(--n-border-checked)"
  })])]), K("disabled", {
    cursor: "not-allowed"
  }, [K("checked", [L("checkbox-box", `
 background-color: var(--n-color-disabled-checked);
 `, [q("border", {
    border: "var(--n-border-disabled-checked)"
  }), L("checkbox-icon", [Y(".check-icon, .line-icon", {
    fill: "var(--n-check-mark-color-disabled-checked)"
  })])])]), L("checkbox-box", `
 background-color: var(--n-color-disabled);
 `, [q("border", {
    border: "var(--n-border-disabled)"
  }), L("checkbox-icon", [Y(".check-icon, .line-icon", {
    fill: "var(--n-check-mark-color-disabled)"
  })])]), q("label", {
    color: "var(--n-text-color-disabled)"
  })]), L("checkbox-box-wrapper", `
 position: relative;
 width: var(--n-size);
 flex-shrink: 0;
 flex-grow: 0;
 user-select: none;
 -webkit-user-select: none;
 `), L("checkbox-box", `
 position: absolute;
 left: 0;
 top: 50%;
 transform: translateY(-50%);
 height: var(--n-size);
 width: var(--n-size);
 display: inline-block;
 box-sizing: border-box;
 border-radius: var(--n-border-radius);
 background-color: var(--n-color);
 transition: background-color 0.3s var(--n-bezier);
 `, [q("border", `
 transition:
 border-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 border-radius: inherit;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border: var(--n-border);
 `), L("checkbox-icon", `
 display: flex;
 align-items: center;
 justify-content: center;
 position: absolute;
 left: 1px;
 right: 1px;
 top: 1px;
 bottom: 1px;
 `, [Y(".check-icon, .line-icon", `
 width: 100%;
 fill: var(--n-check-mark-color);
 opacity: 0;
 transform: scale(0.5);
 transform-origin: center;
 transition:
 fill 0.3s var(--n-bezier),
 transform 0.3s var(--n-bezier),
 opacity 0.3s var(--n-bezier),
 border-color 0.3s var(--n-bezier);
 `), Io({
    left: "1px",
    top: "1px"
  })])]), q("label", `
 color: var(--n-text-color);
 transition: color .3s var(--n-bezier);
 user-select: none;
 -webkit-user-select: none;
 padding: var(--n-label-padding);
 font-weight: var(--n-label-font-weight);
 `, [Y("&:empty", {
    display: "none"
  })])]),
  Bp(L("checkbox", `
 --n-merged-color-table: var(--n-color-table-modal);
 `)),
  hb(L("checkbox", `
 --n-merged-color-table: var(--n-color-table-popover);
 `))
]);
const fme = Object.assign(Object.assign({}, ft.props), {
  size: String,
  checked: {
    type: [Boolean, String, Number],
    default: void 0
  },
  defaultChecked: {
    type: [Boolean, String, Number],
    default: !1
  },
  value: [String, Number],
  disabled: {
    type: Boolean,
    default: void 0
  },
  indeterminate: Boolean,
  label: String,
  focusable: {
    type: Boolean,
    default: !0
  },
  checkedValue: {
    type: [Boolean, String, Number],
    default: !0
  },
  uncheckedValue: {
    type: [Boolean, String, Number],
    default: !1
  },
  "onUpdate:checked": [Function, Array],
  onUpdateChecked: [Function, Array],
  privateInsideTable: Boolean,
  onChange: [Function, Array]
});
var BM = oe({
  name: "Checkbox",
  props: fme,
  setup(e) {
    const t = G(null), { mergedClsPrefixRef: r, inlineThemeDisabled: n, mergedRtlRef: i } = Yt(e), o = ta(e, {
      mergedSize(D) {
        const { size: E } = e;
        if (E !== void 0)
          return E;
        if (u) {
          const { value: N } = u.mergedSizeRef;
          if (N !== void 0)
            return N;
        }
        if (D) {
          const { mergedSize: N } = D;
          if (N !== void 0)
            return N.value;
        }
        return "medium";
      },
      mergedDisabled(D) {
        const { disabled: E } = e;
        if (E !== void 0)
          return E;
        if (u) {
          if (u.disabledRef.value)
            return !0;
          const { maxRef: { value: N }, checkedCountRef: I } = u;
          if (N !== void 0 && I.value >= N && !g.value)
            return !0;
          const { minRef: { value: $ } } = u;
          if ($ !== void 0 && I.value <= $ && g.value)
            return !0;
        }
        return D ? D.disabled.value : !1;
      }
    }), { mergedDisabledRef: a, mergedSizeRef: s } = o, u = lt(PH, null), d = G(e.defaultChecked), f = tt(e, "checked"), h = dn(f, d), g = _r(() => {
      if (u) {
        const D = u.valueSetRef.value;
        return D && e.value !== void 0 ? D.has(e.value) : !1;
      } else
        return h.value === e.checkedValue;
    }), m = ft("Checkbox", "-checkbox", dme, LH, e, r);
    function v(D) {
      if (u && e.value !== void 0)
        u.toggleCheckbox(!g.value, e.value);
      else {
        const { onChange: E, "onUpdate:checked": N, onUpdateChecked: I } = e, { nTriggerFormInput: $, nTriggerFormChange: _ } = o, R = g.value ? e.uncheckedValue : e.checkedValue;
        N && je(N, R, D), I && je(I, R, D), E && je(E, R, D), $(), _(), d.value = R;
      }
    }
    function w(D) {
      a.value || v(D);
    }
    function x(D) {
      if (!a.value)
        switch (D.key) {
          case " ":
          case "Enter":
            v(D);
        }
    }
    function y(D) {
      switch (D.key) {
        case " ":
          D.preventDefault();
      }
    }
    const C = {
      focus: () => {
        var D;
        (D = t.value) === null || D === void 0 || D.focus();
      },
      blur: () => {
        var D;
        (D = t.value) === null || D === void 0 || D.blur();
      }
    }, S = Li("Checkbox", i, r), T = j(() => {
      const { value: D } = s, { common: { cubicBezierEaseInOut: E }, self: { borderRadius: N, color: I, colorChecked: $, colorDisabled: _, colorTableHeader: R, colorTableHeaderModal: U, colorTableHeaderPopover: Q, checkMarkColor: Z, checkMarkColorDisabled: X, border: re, borderFocus: ue, borderDisabled: he, borderChecked: te, boxShadowFocus: de, textColor: De, textColorDisabled: Oe, checkMarkColorDisabledChecked: Qe, colorDisabledChecked: Ae, borderDisabledChecked: Ne, labelPadding: $e, labelLineHeight: et, labelFontWeight: Ge, [Be("fontSize", D)]: Ee, [Be("size", D)]: qe } } = m.value;
      return {
        "--n-label-line-height": et,
        "--n-label-font-weight": Ge,
        "--n-size": qe,
        "--n-bezier": E,
        "--n-border-radius": N,
        "--n-border": re,
        "--n-border-checked": te,
        "--n-border-focus": ue,
        "--n-border-disabled": he,
        "--n-border-disabled-checked": Ne,
        "--n-box-shadow-focus": de,
        "--n-color": I,
        "--n-color-checked": $,
        "--n-color-table": R,
        "--n-color-table-modal": U,
        "--n-color-table-popover": Q,
        "--n-color-disabled": _,
        "--n-color-disabled-checked": Ae,
        "--n-text-color": De,
        "--n-text-color-disabled": Oe,
        "--n-check-mark-color": Z,
        "--n-check-mark-color-disabled": X,
        "--n-check-mark-color-disabled-checked": Qe,
        "--n-font-size": Ee,
        "--n-label-padding": $e
      };
    }), A = n ? Cr("checkbox", j(() => s.value[0]), T, e) : void 0;
    return Object.assign(o, C, {
      rtlEnabled: S,
      selfRef: t,
      mergedClsPrefix: r,
      mergedDisabled: a,
      renderedChecked: g,
      mergedTheme: m,
      labelId: Ss(),
      handleClick: w,
      handleKeyUp: x,
      handleKeyDown: y,
      cssVars: n ? void 0 : T,
      themeClass: A == null ? void 0 : A.themeClass,
      onRender: A == null ? void 0 : A.onRender
    });
  },
  render() {
    var e;
    const { $slots: t, renderedChecked: r, mergedDisabled: n, indeterminate: i, privateInsideTable: o, cssVars: a, labelId: s, label: u, mergedClsPrefix: d, focusable: f, handleKeyUp: h, handleKeyDown: g, handleClick: m } = this;
    return (e = this.onRender) === null || e === void 0 || e.call(this), b("div", { ref: "selfRef", class: [
      `${d}-checkbox`,
      this.themeClass,
      this.rtlEnabled && `${d}-checkbox--rtl`,
      r && `${d}-checkbox--checked`,
      n && `${d}-checkbox--disabled`,
      i && `${d}-checkbox--indeterminate`,
      o && `${d}-checkbox--inside-table`
    ], tabindex: n || !f ? void 0 : 0, role: "checkbox", "aria-checked": i ? "mixed" : r, "aria-labelledby": s, style: a, onKeyup: h, onKeydown: g, onClick: m, onMousedown: () => {
      Mr("selectstart", window, (v) => {
        v.preventDefault();
      }, {
        once: !0
      });
    } }, b("div", { class: `${d}-checkbox-box-wrapper` }, " ", b("div", { class: `${d}-checkbox-box` }, b(Lc, null, {
      default: () => this.indeterminate ? b("div", { key: "indeterminate", class: `${d}-checkbox-icon` }, sme) : b("div", { key: "check", class: `${d}-checkbox-icon` }, lme)
    }), b("div", { class: `${d}-checkbox-box__border` }))), u !== null || t.default ? b("span", { class: `${d}-checkbox__label`, id: s }, t.default ? t.default() : u) : null);
  }
});
const hme = (e) => {
  const { fontWeight: t, textColor1: r, textColor2: n, textColorDisabled: i, dividerColor: o, fontSize: a } = e;
  return {
    titleFontSize: a,
    titleFontWeight: t,
    dividerColor: o,
    titleTextColor: r,
    titleTextColorDisabled: i,
    fontSize: a,
    textColor: n,
    arrowColor: n,
    arrowColorDisabled: i,
    itemMargin: "16px 0 0 0",
    titlePadding: "16px 0 0 0"
  };
}, pme = {
  name: "Collapse",
  common: Sr,
  self: hme
};
var gme = pme, mme = L("collapse", "width: 100%;", [L("collapse-item", `
 font-size: var(--n-font-size);
 color: var(--n-text-color);
 transition:
 color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 margin: var(--n-item-margin);
 `, [K("disabled", [q("header", "cursor: not-allowed;", [q("header-main", `
 color: var(--n-title-text-color-disabled);
 `), L("collapse-item-arrow", `
 color: var(--n-arrow-color-disabled);
 `)])]), L("collapse-item", "margin-left: 32px;"), Y("&:first-child", "margin-top: 0;"), Y("&:first-child >", [q("header", "padding-top: 0;")]), K("left-arrow-placement", [q("header", [L("collapse-item-arrow", "margin-right: 4px;")])]), K("right-arrow-placement", [q("header", [L("collapse-item-arrow", "margin-left: 4px;")])]), q("content-wrapper", [q("content-inner", "padding-top: 16px;"), D0({
  duration: "0.15s"
})]), K("active", [q("header", [K("active", [L("collapse-item-arrow", "transform: rotate(90deg);")])])]), Y("&:not(:first-child)", "border-top: 1px solid var(--n-divider-color);"), q("header", `
 font-size: var(--n-title-font-size);
 display: flex;
 flex-wrap: nowrap;
 align-items: center;
 transition: color .3s var(--n-bezier);
 position: relative;
 padding: var(--n-title-padding);
 color: var(--n-title-text-color);
 cursor: pointer;
 `, [q("header-main", `
 display: flex;
 flex-wrap: nowrap;
 align-items: center;
 font-weight: var(--n-title-font-weight);
 transition: color .3s var(--n-bezier);
 flex: 1;
 color: var(--n-title-text-color);
 `), q("header-extra", `
 display: flex;
 align-items: center;
 transition: color .3s var(--n-bezier);
 color: var(--n-text-color);
 `), L("collapse-item-arrow", `
 display: flex;
 transition:
 transform .15s var(--n-bezier),
 color .3s var(--n-bezier);
 font-size: 18px;
 color: var(--n-arrow-color);
 `)])])]);
const vme = Object.assign(Object.assign({}, ft.props), {
  defaultExpandedNames: {
    type: [Array, String],
    default: null
  },
  expandedNames: [Array, String],
  arrowPlacement: {
    type: String,
    default: "left"
  },
  accordion: {
    type: Boolean,
    default: !1
  },
  displayDirective: {
    type: String,
    default: "if"
  },
  onItemHeaderClick: [Function, Array],
  "onUpdate:expandedNames": [Function, Array],
  onUpdateExpandedNames: [Function, Array],
  onExpandedNamesChange: {
    type: [Function, Array],
    validator: () => !0,
    default: void 0
  }
}), RH = "n-collapse";
var jH = oe({
  name: "Collapse",
  props: vme,
  setup(e, { slots: t }) {
    const { mergedClsPrefixRef: r, inlineThemeDisabled: n, mergedRtlRef: i } = Yt(e), o = G(e.defaultExpandedNames), a = j(() => e.expandedNames), s = dn(a, o), u = ft("Collapse", "-collapse", mme, gme, e, r);
    function d(w) {
      const { "onUpdate:expandedNames": x, onUpdateExpandedNames: y, onExpandedNamesChange: C } = e;
      y && je(y, w), x && je(x, w), C && je(C, w), o.value = w;
    }
    function f(w) {
      const { onItemHeaderClick: x } = e;
      x && je(x, w);
    }
    function h(w, x, y) {
      const { accordion: C } = e, { value: S } = s;
      if (C)
        w ? (d([x]), f({ name: x, expanded: !0, event: y })) : (d([]), f({ name: x, expanded: !1, event: y }));
      else if (!Array.isArray(S))
        d([x]), f({ name: x, expanded: !0, event: y });
      else {
        const T = S.slice(), A = T.findIndex((D) => x === D);
        ~A ? (T.splice(A, 1), d(T), f({ name: x, expanded: !1, event: y })) : (T.push(x), d(T), f({ name: x, expanded: !0, event: y }));
      }
    }
    tr(RH, {
      props: e,
      mergedClsPrefixRef: r,
      expandedNamesRef: s,
      slots: t,
      toggleItem: h
    });
    const g = Li("Collapse", i, r), m = j(() => {
      const { common: { cubicBezierEaseInOut: w }, self: { titleFontWeight: x, dividerColor: y, titlePadding: C, titleTextColor: S, titleTextColorDisabled: T, textColor: A, arrowColor: D, fontSize: E, titleFontSize: N, arrowColorDisabled: I, itemMargin: $ } } = u.value;
      return {
        "--n-font-size": E,
        "--n-bezier": w,
        "--n-text-color": A,
        "--n-divider-color": y,
        "--n-title-padding": C,
        "--n-title-font-size": N,
        "--n-title-text-color": S,
        "--n-title-text-color-disabled": T,
        "--n-title-font-weight": x,
        "--n-arrow-color": D,
        "--n-arrow-color-disabled": I,
        "--n-item-margin": $
      };
    }), v = n ? Cr("collapse", void 0, m, e) : void 0;
    return {
      rtlEnabled: g,
      mergedTheme: u,
      mergedClsPrefix: r,
      cssVars: n ? void 0 : m,
      themeClass: v == null ? void 0 : v.themeClass,
      onRender: v == null ? void 0 : v.onRender
    };
  },
  render() {
    var e;
    return (e = this.onRender) === null || e === void 0 || e.call(this), b("div", { class: [
      `${this.mergedClsPrefix}-collapse`,
      this.rtlEnabled && `${this.mergedClsPrefix}-collapse--rtl`,
      this.themeClass
    ], style: this.cssVars }, this.$slots);
  }
}), bme = oe({
  name: "CollapseItemContent",
  props: {
    displayDirective: {
      type: String,
      required: !0
    },
    show: Boolean,
    clsPrefix: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return {
      onceTrue: MU(tt(e, "show"))
    };
  },
  render() {
    return b(ph, null, {
      default: () => {
        const { show: e, displayDirective: t, onceTrue: r, clsPrefix: n } = this, i = t === "show" && r, o = b("div", { class: `${n}-collapse-item__content-wrapper` }, b("div", { class: `${n}-collapse-item__content-inner` }, this.$slots));
        return i ? Jn(o, [[Ra, e]]) : e ? o : null;
      }
    });
  }
});
const yme = {
  title: String,
  name: [String, Number],
  disabled: Boolean,
  displayDirective: String
};
var FH = oe({
  name: "CollapseItem",
  props: yme,
  setup(e) {
    const { mergedRtlRef: t } = Yt(e), r = Ss(), n = _r(() => {
      var h;
      return (h = e.name) !== null && h !== void 0 ? h : r;
    }), i = lt(RH);
    i || Ql("collapse-item", "`n-collapse-item` must be placed inside `n-collapse`.");
    const { expandedNamesRef: o, props: a, mergedClsPrefixRef: s, slots: u } = i, d = j(() => {
      const { value: h } = o;
      if (Array.isArray(h)) {
        const { value: g } = n;
        return !~h.findIndex((m) => m === g);
      } else if (h) {
        const { value: g } = n;
        return g !== h;
      }
      return !0;
    });
    return {
      rtlEnabled: Li("Collapse", t, s),
      collapseSlots: u,
      randomName: r,
      mergedClsPrefix: s,
      collapsed: d,
      mergedDisplayDirective: j(() => {
        const { displayDirective: h } = e;
        return h || a.displayDirective;
      }),
      arrowPlacement: j(() => a.arrowPlacement),
      handleClick(h) {
        i && !e.disabled && i.toggleItem(d.value, n.value, h);
      }
    };
  },
  render() {
    const { collapseSlots: e, $slots: t, arrowPlacement: r, collapsed: n, mergedDisplayDirective: i, mergedClsPrefix: o, disabled: a } = this, s = v0(t.header, { collapsed: n }, () => [this.title]), u = t["header-extra"] || e["header-extra"], d = t.arrow || e.arrow;
    return b("div", { class: [
      `${o}-collapse-item`,
      `${o}-collapse-item--${r}-arrow-placement`,
      a && `${o}-collapse-item--disabled`,
      !n && `${o}-collapse-item--active`
    ] }, b("div", { class: [
      `${o}-collapse-item__header`,
      !n && `${o}-collapse-item__header--active`
    ] }, b("div", { class: `${o}-collapse-item__header-main`, onClick: this.handleClick }, r === "right" && s, b("div", { class: `${o}-collapse-item-arrow`, key: this.rtlEnabled ? 0 : 1 }, v0(d, { collapsed: n }, () => {
      var f;
      return [
        b(fr, { clsPrefix: o }, {
          default: (f = e.expandIcon) !== null && f !== void 0 ? f : () => this.rtlEnabled ? b(mfe, null) : b(w4, null)
        })
      ];
    })), r === "left" && s), jK(u, { collapsed: n }, (f) => b("div", { class: `${o}-collapse-item__header-extra`, onClick: this.handleClick }, f))), b(bme, { clsPrefix: o, displayDirective: i, show: !n }, t));
  }
});
const xme = {
  abstract: Boolean,
  bordered: {
    type: Boolean,
    default: void 0
  },
  clsPrefix: String,
  locale: Object,
  dateLocale: Object,
  namespace: String,
  rtl: Array,
  tag: {
    type: String,
    default: "div"
  },
  hljs: Object,
  katex: Object,
  theme: Object,
  themeOverrides: Object,
  componentOptions: Object,
  icons: Object,
  breakpoints: Object,
  preflightStyleDisabled: Boolean,
  inlineThemeDisabled: {
    type: Boolean,
    default: void 0
  },
  as: {
    type: String,
    validator: () => (ja("config-provider", "`as` is deprecated, please use `tag` instead."), !0),
    default: void 0
  }
};
var wme = oe({
  name: "ConfigProvider",
  alias: ["App"],
  props: xme,
  setup(e) {
    const t = lt(ju, null), r = j(() => {
      const { theme: v } = e;
      if (v === null)
        return;
      const w = t == null ? void 0 : t.mergedThemeRef.value;
      return v === void 0 ? w : w === void 0 ? v : Object.assign({}, w, v);
    }), n = j(() => {
      const { themeOverrides: v } = e;
      if (v !== null) {
        if (v === void 0)
          return t == null ? void 0 : t.mergedThemeOverridesRef.value;
        {
          const w = t == null ? void 0 : t.mergedThemeOverridesRef.value;
          return w === void 0 ? v : _v({}, w, v);
        }
      }
    }), i = _r(() => {
      const { namespace: v } = e;
      return v === void 0 ? t == null ? void 0 : t.mergedNamespaceRef.value : v;
    }), o = _r(() => {
      const { bordered: v } = e;
      return v === void 0 ? t == null ? void 0 : t.mergedBorderedRef.value : v;
    }), a = j(() => {
      const { icons: v } = e;
      return v === void 0 ? t == null ? void 0 : t.mergedIconsRef.value : v;
    }), s = j(() => {
      const { componentOptions: v } = e;
      return v !== void 0 ? v : t == null ? void 0 : t.mergedComponentPropsRef.value;
    }), u = j(() => {
      const { clsPrefix: v } = e;
      return v !== void 0 ? v : t == null ? void 0 : t.mergedClsPrefixRef.value;
    }), d = j(() => {
      var v;
      const { rtl: w } = e;
      if (w === void 0)
        return t == null ? void 0 : t.mergedRtlRef.value;
      const x = {};
      for (const y of w)
        x[y.name] = qN(y), (v = y.peers) === null || v === void 0 || v.forEach((C) => {
          C.name in x || (x[C.name] = qN(C));
        });
      return x;
    }), f = j(() => e.breakpoints || (t == null ? void 0 : t.mergedBreakpointsRef.value)), h = e.inlineThemeDisabled || (t == null ? void 0 : t.inlineThemeDisabled), g = e.preflightStyleDisabled || (t == null ? void 0 : t.preflightStyleDisabled), m = j(() => {
      const { value: v } = r, { value: w } = n, x = w && Object.keys(w).length !== 0, y = v == null ? void 0 : v.name;
      return y ? x ? `${y}-${b0(JSON.stringify(n.value))}` : y : x ? b0(JSON.stringify(n.value)) : "";
    });
    return tr(ju, {
      mergedThemeHashRef: m,
      mergedBreakpointsRef: f,
      mergedRtlRef: d,
      mergedIconsRef: a,
      mergedComponentPropsRef: s,
      mergedBorderedRef: o,
      mergedNamespaceRef: i,
      mergedClsPrefixRef: u,
      mergedLocaleRef: j(() => {
        const { locale: v } = e;
        if (v !== null)
          return v === void 0 ? t == null ? void 0 : t.mergedLocaleRef.value : v;
      }),
      mergedDateLocaleRef: j(() => {
        const { dateLocale: v } = e;
        if (v !== null)
          return v === void 0 ? t == null ? void 0 : t.mergedDateLocaleRef.value : v;
      }),
      mergedHljsRef: j(() => {
        const { hljs: v } = e;
        return v === void 0 ? t == null ? void 0 : t.mergedHljsRef.value : v;
      }),
      mergedKatexRef: j(() => {
        const { katex: v } = e;
        return v === void 0 ? t == null ? void 0 : t.mergedKatexRef.value : v;
      }),
      mergedThemeRef: r,
      mergedThemeOverridesRef: n,
      inlineThemeDisabled: h || !1,
      preflightStyleDisabled: g || !1
    }), {
      mergedClsPrefix: u,
      mergedBordered: o,
      mergedNamespace: i,
      mergedTheme: r,
      mergedThemeOverrides: n
    };
  },
  render() {
    var e, t, r, n;
    return this.abstract ? (n = (r = this.$slots).default) === null || n === void 0 ? void 0 : n.call(r) : b(this.as || this.tag, {
      class: `${this.mergedClsPrefix || $7}-config-provider`
    }, (t = (e = this.$slots).default) === null || t === void 0 ? void 0 : t.call(e));
  }
});
function Mme(e) {
  const { boxShadow2: t } = e;
  return {
    menuBoxShadow: t
  };
}
const Cme = {
  name: "Popselect",
  common: Sr,
  peers: {
    Popover: Vp,
    InternalSelectMenu: S4
  },
  self: Mme
};
var I4 = Cme;
const BH = "n-popselect";
var Sme = L("popselect-menu", `
 box-shadow: var(--n-menu-box-shadow);
`);
const N4 = {
  multiple: Boolean,
  value: {
    type: [String, Number, Array],
    default: null
  },
  cancelable: Boolean,
  options: {
    type: Array,
    default: () => []
  },
  size: {
    type: String,
    default: "medium"
  },
  scrollable: Boolean,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onMouseenter: Function,
  onMouseleave: Function,
  renderLabel: Function,
  showCheckmark: {
    type: Boolean,
    default: void 0
  },
  nodeProps: Function,
  virtualScroll: Boolean,
  onChange: [Function, Array]
}, YP = Ts(N4);
var Tme = oe({
  name: "PopselectPanel",
  props: N4,
  setup(e) {
    const t = lt(BH), { mergedClsPrefixRef: r, inlineThemeDisabled: n } = Yt(e), i = ft("Popselect", "-pop-select", Sme, I4, t.props, r), o = j(() => Mb(e.options, yH("value", "children")));
    function a(g, m) {
      const { onUpdateValue: v, "onUpdate:value": w, onChange: x } = e;
      v && je(v, g, m), w && je(w, g, m), x && je(x, g, m);
    }
    function s(g) {
      d(g.key);
    }
    function u(g) {
      Bl(g, "action") || g.preventDefault();
    }
    function d(g) {
      const { value: { getNode: m } } = o;
      if (e.multiple)
        if (Array.isArray(e.value)) {
          const v = [], w = [];
          let x = !0;
          e.value.forEach((y) => {
            if (y === g) {
              x = !1;
              return;
            }
            const C = m(y);
            C && (v.push(C.key), w.push(C.rawNode));
          }), x && (v.push(g), w.push(m(g).rawNode)), a(v, w);
        } else {
          const v = m(g);
          v && a([g], [v.rawNode]);
        }
      else if (e.value === g && e.cancelable)
        a(null, null);
      else {
        const v = m(g);
        v && a(g, v.rawNode);
        const { "onUpdate:show": w, onUpdateShow: x } = t.props;
        w && je(w, !1), x && je(x, !1), t.setShow(!1);
      }
      an(() => {
        t.syncPosition();
      });
    }
    Gt(tt(e, "options"), () => {
      an(() => {
        t.syncPosition();
      });
    });
    const f = j(() => {
      const { self: { menuBoxShadow: g } } = i.value;
      return {
        "--n-menu-box-shadow": g
      };
    }), h = n ? Cr("select", void 0, f, t.props) : void 0;
    return {
      mergedTheme: t.mergedThemeRef,
      mergedClsPrefix: r,
      treeMate: o,
      handleToggle: s,
      handleMenuMousedown: u,
      cssVars: n ? void 0 : f,
      themeClass: h == null ? void 0 : h.themeClass,
      onRender: h == null ? void 0 : h.onRender
    };
  },
  render() {
    var e;
    return (e = this.onRender) === null || e === void 0 || e.call(this), b(sH, { clsPrefix: this.mergedClsPrefix, focusable: !0, nodeProps: this.nodeProps, class: [`${this.mergedClsPrefix}-popselect-menu`, this.themeClass], style: this.cssVars, theme: this.mergedTheme.peers.InternalSelectMenu, themeOverrides: this.mergedTheme.peerOverrides.InternalSelectMenu, multiple: this.multiple, treeMate: this.treeMate, size: this.size, value: this.value, virtualScroll: this.virtualScroll, scrollable: this.scrollable, renderLabel: this.renderLabel, onToggle: this.handleToggle, onMouseenter: this.onMouseenter, onMouseleave: this.onMouseenter, onMousedown: this.handleMenuMousedown, showCheckmark: this.showCheckmark }, {
      action: () => {
        var t, r;
        return ((r = (t = this.$slots).action) === null || r === void 0 ? void 0 : r.call(t)) || [];
      },
      empty: () => {
        var t, r;
        return ((r = (t = this.$slots).empty) === null || r === void 0 ? void 0 : r.call(t)) || [];
      }
    });
  }
});
const kme = Object.assign(Object.assign(Object.assign(Object.assign({}, ft.props), IM(yp, ["showArrow", "arrow"])), { placement: Object.assign(Object.assign({}, yp.placement), { default: "bottom" }), trigger: {
  type: String,
  default: "hover"
} }), N4);
var Dme = oe({
  name: "Popselect",
  props: kme,
  inheritAttrs: !1,
  __popover__: !0,
  setup(e) {
    const { mergedClsPrefixRef: t } = Yt(e), r = ft("Popselect", "-popselect", void 0, I4, e, t), n = G(null);
    function i() {
      var s;
      (s = n.value) === null || s === void 0 || s.syncPosition();
    }
    function o(s) {
      var u;
      (u = n.value) === null || u === void 0 || u.setShow(s);
    }
    return tr(BH, {
      props: e,
      mergedThemeRef: r,
      syncPosition: i,
      setShow: o
    }), Object.assign(Object.assign({}, {
      syncPosition: i,
      setShow: o
    }), { popoverInstRef: n, mergedTheme: r });
  },
  render() {
    const { mergedTheme: e } = this, t = {
      theme: e.peers.Popover,
      themeOverrides: e.peerOverrides.Popover,
      builtinThemeOverrides: {
        padding: "0"
      },
      ref: "popoverInstRef",
      internalRenderBody: (r, n, i, o, a) => {
        const { $attrs: s } = this;
        return b(Tme, Object.assign({}, s, { class: [s.class, r], style: [s.style, i] }, il(this.$props, YP), { ref: dU(n), onMouseenter: Gv([
          o,
          s.onMouseenter
        ]), onMouseleave: Gv([
          a,
          s.onMouseleave
        ]) }), {
          action: () => {
            var u, d;
            return (d = (u = this.$slots).action) === null || d === void 0 ? void 0 : d.call(u);
          },
          empty: () => {
            var u, d;
            return (d = (u = this.$slots).empty) === null || d === void 0 ? void 0 : d.call(u);
          }
        });
      }
    };
    return b(jc, Object.assign({}, IM(this.$props, YP), t, { internalDeactivateImmediately: !0 }), {
      trigger: () => {
        var r, n;
        return (n = (r = this.$slots).default) === null || n === void 0 ? void 0 : n.call(r);
      }
    });
  }
});
function Ame(e) {
  const { boxShadow2: t } = e;
  return {
    menuBoxShadow: t
  };
}
const Eme = {
  name: "Select",
  common: Sr,
  peers: {
    InternalSelection: mH,
    InternalSelectMenu: S4
  },
  self: Ame
};
var UH = Eme, Ime = Y([L("select", `
 z-index: auto;
 outline: none;
 width: 100%;
 position: relative;
 `), L("select-menu", `
 margin: 4px 0;
 box-shadow: var(--n-menu-box-shadow);
 `, [Fa({
  originalTransition: "background-color .3s var(--n-bezier), box-shadow .3s var(--n-bezier)"
})])]);
const Nme = Object.assign(Object.assign({}, ft.props), {
  to: vi.propTo,
  bordered: {
    type: Boolean,
    default: void 0
  },
  clearable: Boolean,
  clearFilterAfterSelect: {
    type: Boolean,
    default: !0
  },
  options: {
    type: Array,
    default: () => []
  },
  defaultValue: {
    type: [String, Number, Array],
    default: null
  },
  keyboard: {
    type: Boolean,
    default: !0
  },
  value: [String, Number, Array],
  placeholder: String,
  menuProps: Object,
  multiple: Boolean,
  size: String,
  filterable: Boolean,
  disabled: {
    type: Boolean,
    default: void 0
  },
  remote: Boolean,
  loading: Boolean,
  filter: Function,
  placement: {
    type: String,
    default: "bottom-start"
  },
  widthMode: {
    type: String,
    default: "trigger"
  },
  tag: Boolean,
  onCreate: Function,
  fallbackOption: {
    type: [Function, Boolean],
    default: void 0
  },
  show: {
    type: Boolean,
    default: void 0
  },
  showArrow: {
    type: Boolean,
    default: !0
  },
  maxTagCount: [Number, String],
  consistentMenuWidth: {
    type: Boolean,
    default: !0
  },
  virtualScroll: {
    type: Boolean,
    default: !0
  },
  labelField: {
    type: String,
    default: "label"
  },
  valueField: {
    type: String,
    default: "value"
  },
  childrenField: {
    type: String,
    default: "children"
  },
  renderLabel: Function,
  renderOption: Function,
  renderTag: Function,
  "onUpdate:value": [Function, Array],
  inputProps: Object,
  nodeProps: Function,
  ignoreComposition: { type: Boolean, default: !0 },
  showOnFocus: Boolean,
  onUpdateValue: [Function, Array],
  onBlur: [Function, Array],
  onClear: [Function, Array],
  onFocus: [Function, Array],
  onScroll: [Function, Array],
  onSearch: [Function, Array],
  onUpdateShow: [Function, Array],
  "onUpdate:show": [Function, Array],
  displayDirective: {
    type: String,
    default: "show"
  },
  resetMenuOnOptionsChange: {
    type: Boolean,
    default: !0
  },
  status: String,
  showCheckmark: {
    type: Boolean,
    default: !0
  },
  onChange: [Function, Array],
  items: Array
});
var HH = oe({
  name: "Select",
  props: Nme,
  setup(e) {
    const { mergedClsPrefixRef: t, mergedBorderedRef: r, namespaceRef: n, inlineThemeDisabled: i } = Yt(e), o = ft("Select", "-select", Ime, UH, e, t), a = G(e.defaultValue), s = tt(e, "value"), u = dn(s, a), d = G(!1), f = G(""), h = j(() => {
      const { valueField: ne, childrenField: Se } = e, _e = yH(ne, Se);
      return Mb(R.value, _e);
    }), g = j(() => ape($.value, e.valueField, e.childrenField)), m = G(!1), v = dn(tt(e, "show"), m), w = G(null), x = G(null), y = G(null), { localeRef: C } = Zl("Select"), S = j(() => {
      var ne;
      return (ne = e.placeholder) !== null && ne !== void 0 ? ne : C.value.placeholder;
    }), T = pp(e, ["items", "options"]), A = [], D = G([]), E = G([]), N = G(/* @__PURE__ */ new Map()), I = j(() => {
      const { fallbackOption: ne } = e;
      if (ne === void 0) {
        const { labelField: Se, valueField: _e } = e;
        return (ut) => ({
          [Se]: String(ut),
          [_e]: ut
        });
      }
      return ne === !1 ? !1 : (Se) => Object.assign(ne(Se), {
        value: Se
      });
    }), $ = j(() => E.value.concat(D.value).concat(T.value)), _ = j(() => {
      const { filter: ne } = e;
      if (ne)
        return ne;
      const { labelField: Se, valueField: _e } = e;
      return (ut, ht) => {
        if (!ht)
          return !1;
        const ye = ht[Se];
        if (typeof ye == "string")
          return FI(ut, ye);
        const Ze = ht[_e];
        return typeof Ze == "string" ? FI(ut, Ze) : typeof Ze == "number" ? FI(ut, String(Ze)) : !1;
      };
    }), R = j(() => {
      if (e.remote)
        return T.value;
      {
        const { value: ne } = $, { value: Se } = f;
        return !Se.length || !e.filterable ? ne : ope(ne, _.value, Se, e.childrenField);
      }
    });
    function U(ne) {
      const Se = e.remote, { value: _e } = N, { value: ut } = g, { value: ht } = I, ye = [];
      return ne.forEach((Ze) => {
        if (ut.has(Ze))
          ye.push(ut.get(Ze));
        else if (Se && _e.has(Ze))
          ye.push(_e.get(Ze));
        else if (ht) {
          const st = ht(Ze);
          st && ye.push(st);
        }
      }), ye;
    }
    const Q = j(() => {
      if (e.multiple) {
        const { value: ne } = u;
        return Array.isArray(ne) ? U(ne) : [];
      }
      return null;
    }), Z = j(() => {
      const { value: ne } = u;
      return !e.multiple && !Array.isArray(ne) ? ne === null ? null : U([ne])[0] || null : null;
    }), X = ta(e), { mergedSizeRef: re, mergedDisabledRef: ue, mergedStatusRef: he } = X;
    function te(ne, Se) {
      const { onChange: _e, "onUpdate:value": ut, onUpdateValue: ht } = e, { nTriggerFormChange: ye, nTriggerFormInput: Ze } = X;
      _e && je(_e, ne, Se), ht && je(ht, ne, Se), ut && je(ut, ne, Se), a.value = ne, ye(), Ze();
    }
    function de(ne) {
      const { onBlur: Se } = e, { nTriggerFormBlur: _e } = X;
      Se && je(Se, ne), _e();
    }
    function De() {
      const { onClear: ne } = e;
      ne && je(ne);
    }
    function Oe(ne) {
      const { onFocus: Se, showOnFocus: _e } = e, { nTriggerFormFocus: ut } = X;
      Se && je(Se, ne), ut(), _e && et();
    }
    function Qe(ne) {
      const { onSearch: Se } = e;
      Se && je(Se, ne);
    }
    function Ae(ne) {
      const { onScroll: Se } = e;
      Se && je(Se, ne);
    }
    function Ne() {
      var ne;
      const { remote: Se, multiple: _e } = e;
      if (Se) {
        const { value: ut } = N;
        if (_e) {
          const { valueField: ht } = e;
          (ne = Q.value) === null || ne === void 0 || ne.forEach((ye) => {
            ut.set(ye[ht], ye);
          });
        } else {
          const ht = Z.value;
          ht && ut.set(ht[e.valueField], ht);
        }
      }
    }
    function $e(ne) {
      const { onUpdateShow: Se, "onUpdate:show": _e } = e;
      Se && je(Se, ne), _e && je(_e, ne), m.value = ne;
    }
    function et() {
      ue.value || ($e(!0), m.value = !0, e.filterable && jt());
    }
    function Ge() {
      $e(!1);
    }
    function Ee() {
      f.value = "", E.value = A;
    }
    const qe = G(!1);
    function Ue() {
      e.filterable && (qe.value = !0);
    }
    function ot() {
      e.filterable && (qe.value = !1, v.value || Ee());
    }
    function Ie() {
      ue.value || (v.value ? e.filterable ? jt() : Ge() : et());
    }
    function rt(ne) {
      var Se, _e;
      !((_e = (Se = y.value) === null || Se === void 0 ? void 0 : Se.selfRef) === null || _e === void 0) && _e.contains(ne.relatedTarget) || (d.value = !1, de(ne), Ge());
    }
    function W(ne) {
      Oe(ne), d.value = !0;
    }
    function P(ne) {
      d.value = !0;
    }
    function H(ne) {
      var Se;
      !((Se = w.value) === null || Se === void 0) && Se.$el.contains(ne.relatedTarget) || (d.value = !1, de(ne), Ge());
    }
    function se() {
      var ne;
      (ne = w.value) === null || ne === void 0 || ne.focus(), Ge();
    }
    function pe(ne) {
      var Se;
      v.value && (!((Se = w.value) === null || Se === void 0) && Se.$el.contains(Ul(ne)) || Ge());
    }
    function ae(ne) {
      if (!Array.isArray(ne))
        return [];
      if (I.value)
        return Array.from(ne);
      {
        const { remote: Se } = e, { value: _e } = g;
        if (Se) {
          const { value: ut } = N;
          return ne.filter((ht) => _e.has(ht) || ut.has(ht));
        } else
          return ne.filter((ut) => _e.has(ut));
      }
    }
    function Me(ne) {
      fe(ne.rawNode);
    }
    function fe(ne) {
      if (ue.value)
        return;
      const { tag: Se, remote: _e, clearFilterAfterSelect: ut, valueField: ht } = e;
      if (Se && !_e) {
        const { value: ye } = E, Ze = ye[0] || null;
        if (Ze) {
          const st = D.value;
          st.length ? st.push(Ze) : D.value = [Ze], E.value = A;
        }
      }
      if (_e && N.value.set(ne[ht], ne), e.multiple) {
        const ye = ae(u.value), Ze = ye.findIndex((st) => st === ne[ht]);
        if (~Ze) {
          if (ye.splice(Ze, 1), Se && !_e) {
            const st = ke(ne[ht]);
            ~st && (D.value.splice(st, 1), ut && (f.value = ""));
          }
        } else
          ye.push(ne[ht]), ut && (f.value = "");
        te(ye, U(ye));
      } else {
        if (Se && !_e) {
          const ye = ke(ne[ht]);
          ~ye ? D.value = [
            D.value[ye]
          ] : D.value = A;
        }
        Vt(), Ge(), te(ne[ht], ne);
      }
    }
    function ke(ne) {
      return D.value.findIndex((_e) => _e[e.valueField] === ne);
    }
    function Le(ne) {
      v.value || et();
      const { value: Se } = ne.target;
      f.value = Se;
      const { tag: _e, remote: ut } = e;
      if (Qe(Se), _e && !ut) {
        if (!Se) {
          E.value = A;
          return;
        }
        const { onCreate: ht } = e, ye = ht ? ht(Se) : { [e.labelField]: Se, [e.valueField]: Se }, { valueField: Ze } = e;
        T.value.some((st) => st[Ze] === ye[Ze]) || D.value.some((st) => st[Ze] === ye[Ze]) ? E.value = A : E.value = [ye];
      }
    }
    function dt(ne) {
      ne.stopPropagation();
      const { multiple: Se } = e;
      !Se && e.filterable && Ge(), De(), Se ? te([], []) : te(null, null);
    }
    function Mt(ne) {
      !Bl(ne, "action") && !Bl(ne, "empty") && ne.preventDefault();
    }
    function Ct(ne) {
      Ae(ne);
    }
    function er(ne) {
      var Se, _e, ut, ht, ye;
      if (!e.keyboard) {
        ne.preventDefault();
        return;
      }
      switch (ne.key) {
        case " ":
          if (e.filterable)
            break;
          ne.preventDefault();
        case "Enter":
          if (!(!((Se = w.value) === null || Se === void 0) && Se.isComposing)) {
            if (v.value) {
              const Ze = (_e = y.value) === null || _e === void 0 ? void 0 : _e.getPendingTmNode();
              Ze ? Me(Ze) : e.filterable || (Ge(), Vt());
            } else if (et(), e.tag && qe.value) {
              const Ze = E.value[0];
              if (Ze) {
                const st = Ze[e.valueField], { value: Nt } = u;
                e.multiple && Array.isArray(Nt) && Nt.some((Te) => Te === st) || fe(Ze);
              }
            }
          }
          ne.preventDefault();
          break;
        case "ArrowUp":
          if (ne.preventDefault(), e.loading)
            return;
          v.value && ((ut = y.value) === null || ut === void 0 || ut.prev());
          break;
        case "ArrowDown":
          if (ne.preventDefault(), e.loading)
            return;
          v.value ? (ht = y.value) === null || ht === void 0 || ht.next() : et();
          break;
        case "Escape":
          v.value && (x0(ne), Ge()), (ye = w.value) === null || ye === void 0 || ye.focus();
          break;
      }
    }
    function Vt() {
      var ne;
      (ne = w.value) === null || ne === void 0 || ne.focus();
    }
    function jt() {
      var ne;
      (ne = w.value) === null || ne === void 0 || ne.focusInput();
    }
    function at() {
      var ne;
      v.value && ((ne = x.value) === null || ne === void 0 || ne.syncPosition());
    }
    Ne(), Gt(tt(e, "options"), Ne);
    const St = {
      focus: () => {
        var ne;
        (ne = w.value) === null || ne === void 0 || ne.focus();
      },
      blur: () => {
        var ne;
        (ne = w.value) === null || ne === void 0 || ne.blur();
      }
    }, ve = j(() => {
      const { self: { menuBoxShadow: ne } } = o.value;
      return {
        "--n-menu-box-shadow": ne
      };
    }), We = i ? Cr("select", void 0, ve, e) : void 0;
    return Object.assign(Object.assign({}, St), {
      mergedStatus: he,
      mergedClsPrefix: t,
      mergedBordered: r,
      namespace: n,
      treeMate: h,
      isMounted: ql(),
      triggerRef: w,
      menuRef: y,
      pattern: f,
      uncontrolledShow: m,
      mergedShow: v,
      adjustedTo: vi(e),
      uncontrolledValue: a,
      mergedValue: u,
      followerRef: x,
      localizedPlaceholder: S,
      selectedOption: Z,
      selectedOptions: Q,
      mergedSize: re,
      mergedDisabled: ue,
      focused: d,
      activeWithoutMenuOpen: qe,
      inlineThemeDisabled: i,
      onTriggerInputFocus: Ue,
      onTriggerInputBlur: ot,
      handleTriggerOrMenuResize: at,
      handleMenuFocus: P,
      handleMenuBlur: H,
      handleMenuTabOut: se,
      handleTriggerClick: Ie,
      handleToggle: Me,
      handleDeleteOption: fe,
      handlePatternInput: Le,
      handleClear: dt,
      handleTriggerBlur: rt,
      handleTriggerFocus: W,
      handleKeydown: er,
      handleMenuAfterLeave: Ee,
      handleMenuClickOutside: pe,
      handleMenuScroll: Ct,
      handleMenuKeydown: er,
      handleMenuMousedown: Mt,
      mergedTheme: o,
      cssVars: i ? void 0 : ve,
      themeClass: We == null ? void 0 : We.themeClass,
      onRender: We == null ? void 0 : We.onRender
    });
  },
  render() {
    return b("div", { class: `${this.mergedClsPrefix}-select` }, b(zc, null, {
      default: () => [
        b($c, null, {
          default: () => b(Yhe, { ref: "triggerRef", inlineThemeDisabled: this.inlineThemeDisabled, status: this.mergedStatus, inputProps: this.inputProps, clsPrefix: this.mergedClsPrefix, showArrow: this.showArrow, maxTagCount: this.maxTagCount, bordered: this.mergedBordered, active: this.activeWithoutMenuOpen || this.mergedShow, pattern: this.pattern, placeholder: this.localizedPlaceholder, selectedOption: this.selectedOption, selectedOptions: this.selectedOptions, multiple: this.multiple, renderTag: this.renderTag, renderLabel: this.renderLabel, filterable: this.filterable, clearable: this.clearable, disabled: this.mergedDisabled, size: this.mergedSize, theme: this.mergedTheme.peers.InternalSelection, labelField: this.labelField, valueField: this.valueField, themeOverrides: this.mergedTheme.peerOverrides.InternalSelection, loading: this.loading, focused: this.focused, onClick: this.handleTriggerClick, onDeleteOption: this.handleDeleteOption, onPatternInput: this.handlePatternInput, onClear: this.handleClear, onBlur: this.handleTriggerBlur, onFocus: this.handleTriggerFocus, onKeydown: this.handleKeydown, onPatternBlur: this.onTriggerInputBlur, onPatternFocus: this.onTriggerInputFocus, onResize: this.handleTriggerOrMenuResize, ignoreComposition: this.ignoreComposition }, {
            arrow: () => {
              var e, t;
              return [(t = (e = this.$slots).arrow) === null || t === void 0 ? void 0 : t.call(e)];
            }
          })
        }),
        b(_c, { ref: "followerRef", show: this.mergedShow, to: this.adjustedTo, teleportDisabled: this.adjustedTo === vi.tdkey, containerClass: this.namespace, width: this.consistentMenuWidth ? "target" : void 0, minWidth: "target", placement: this.placement }, {
          default: () => b(jn, { name: "fade-in-scale-up-transition", appear: this.isMounted, onAfterLeave: this.handleMenuAfterLeave }, {
            default: () => {
              var e, t, r;
              return this.mergedShow || this.displayDirective === "show" ? ((e = this.onRender) === null || e === void 0 || e.call(this), Jn(b(sH, Object.assign({}, this.menuProps, { ref: "menuRef", onResize: this.handleTriggerOrMenuResize, inlineThemeDisabled: this.inlineThemeDisabled, virtualScroll: this.consistentMenuWidth && this.virtualScroll, class: [
                `${this.mergedClsPrefix}-select-menu`,
                this.themeClass,
                (t = this.menuProps) === null || t === void 0 ? void 0 : t.class
              ], clsPrefix: this.mergedClsPrefix, focusable: !0, labelField: this.labelField, valueField: this.valueField, autoPending: !0, nodeProps: this.nodeProps, theme: this.mergedTheme.peers.InternalSelectMenu, themeOverrides: this.mergedTheme.peerOverrides.InternalSelectMenu, treeMate: this.treeMate, multiple: this.multiple, size: "medium", renderOption: this.renderOption, renderLabel: this.renderLabel, value: this.mergedValue, style: [(r = this.menuProps) === null || r === void 0 ? void 0 : r.style, this.cssVars], onToggle: this.handleToggle, onScroll: this.handleMenuScroll, onFocus: this.handleMenuFocus, onBlur: this.handleMenuBlur, onKeydown: this.handleMenuKeydown, onTabOut: this.handleMenuTabOut, onMousedown: this.handleMenuMousedown, show: this.mergedShow, showCheckmark: this.showCheckmark, resetMenuOnOptionsChange: this.resetMenuOnOptionsChange }), {
                empty: () => {
                  var n, i;
                  return [(i = (n = this.$slots).empty) === null || i === void 0 ? void 0 : i.call(n)];
                },
                action: () => {
                  var n, i;
                  return [(i = (n = this.$slots).action) === null || i === void 0 ? void 0 : i.call(n)];
                }
              }), this.displayDirective === "show" ? [
                [Ra, this.mergedShow],
                [
                  ks,
                  this.handleMenuClickOutside,
                  void 0,
                  { capture: !0 }
                ]
              ] : [
                [
                  ks,
                  this.handleMenuClickOutside,
                  void 0,
                  { capture: !0 }
                ]
              ])) : null;
            }
          })
        })
      ]
    }));
  }
}), zme = {
  itemPaddingSmall: "0 4px",
  itemMarginSmall: "0 0 0 8px",
  itemMarginSmallRtl: "0 8px 0 0",
  itemPaddingMedium: "0 4px",
  itemMarginMedium: "0 0 0 8px",
  itemMarginMediumRtl: "0 8px 0 0",
  itemPaddingLarge: "0 4px",
  itemMarginLarge: "0 0 0 8px",
  itemMarginLargeRtl: "0 8px 0 0",
  buttonIconSizeSmall: "14px",
  buttonIconSizeMedium: "16px",
  buttonIconSizeLarge: "18px",
  inputWidthSmall: "60px",
  selectWidthSmall: "unset",
  inputMarginSmall: "0 0 0 8px",
  inputMarginSmallRtl: "0 8px 0 0",
  selectMarginSmall: "0 0 0 8px",
  prefixMarginSmall: "0 8px 0 0",
  suffixMarginSmall: "0 0 0 8px",
  inputWidthMedium: "60px",
  selectWidthMedium: "unset",
  inputMarginMedium: "0 0 0 8px",
  inputMarginMediumRtl: "0 8px 0 0",
  selectMarginMedium: "0 0 0 8px",
  prefixMarginMedium: "0 8px 0 0",
  suffixMarginMedium: "0 0 0 8px",
  inputWidthLarge: "60px",
  selectWidthLarge: "unset",
  inputMarginLarge: "0 0 0 8px",
  inputMarginLargeRtl: "0 8px 0 0",
  selectMarginLarge: "0 0 0 8px",
  prefixMarginLarge: "0 8px 0 0",
  suffixMarginLarge: "0 0 0 8px"
};
const $me = (e) => {
  const {
    textColor2: t,
    primaryColor: r,
    primaryColorHover: n,
    primaryColorPressed: i,
    inputColorDisabled: o,
    textColorDisabled: a,
    borderColor: s,
    borderRadius: u,
    fontSizeTiny: d,
    fontSizeSmall: f,
    fontSizeMedium: h,
    heightTiny: g,
    heightSmall: m,
    heightMedium: v
  } = e;
  return Object.assign(Object.assign({}, zme), { buttonColor: "#0000", buttonColorHover: "#0000", buttonColorPressed: "#0000", buttonBorder: `1px solid ${s}`, buttonBorderHover: `1px solid ${s}`, buttonBorderPressed: `1px solid ${s}`, buttonIconColor: t, buttonIconColorHover: t, buttonIconColorPressed: t, itemTextColor: t, itemTextColorHover: n, itemTextColorPressed: i, itemTextColorActive: r, itemTextColorDisabled: a, itemColor: "#0000", itemColorHover: "#0000", itemColorPressed: "#0000", itemColorActive: "#0000", itemColorActiveHover: "#0000", itemColorDisabled: o, itemBorder: "1px solid #0000", itemBorderHover: "1px solid #0000", itemBorderPressed: "1px solid #0000", itemBorderActive: `1px solid ${r}`, itemBorderDisabled: `1px solid ${s}`, itemBorderRadius: u, itemSizeSmall: g, itemSizeMedium: m, itemSizeLarge: v, itemFontSizeSmall: d, itemFontSizeMedium: f, itemFontSizeLarge: h, jumperFontSizeSmall: d, jumperFontSizeMedium: f, jumperFontSizeLarge: h, jumperTextColor: t, jumperTextColorDisabled: a });
}, Ome = {
  name: "Pagination",
  common: Sr,
  peers: {
    Select: UH,
    Input: Fc,
    Popselect: I4
  },
  self: $me
};
var WH = Ome;
function _me(e, t, r) {
  let n = !1, i = !1, o = 1, a = t;
  if (t === 1)
    return {
      hasFastBackward: !1,
      hasFastForward: !1,
      fastForwardTo: a,
      fastBackwardTo: o,
      items: [
        {
          type: "page",
          label: 1,
          active: e === 1,
          mayBeFastBackward: !1,
          mayBeFastForward: !1
        }
      ]
    };
  if (t === 2)
    return {
      hasFastBackward: !1,
      hasFastForward: !1,
      fastForwardTo: a,
      fastBackwardTo: o,
      items: [
        {
          type: "page",
          label: 1,
          active: e === 1,
          mayBeFastBackward: !1,
          mayBeFastForward: !1
        },
        {
          type: "page",
          label: 2,
          active: e === 2,
          mayBeFastBackward: !0,
          mayBeFastForward: !1
        }
      ]
    };
  const s = 1, u = t;
  let d = e, f = e;
  const h = (r - 5) / 2;
  f += Math.ceil(h), f = Math.min(Math.max(f, s + r - 3), u - 2), d -= Math.floor(h), d = Math.max(Math.min(d, u - r + 3), s + 2);
  let g = !1, m = !1;
  d > s + 2 && (g = !0), f < u - 2 && (m = !0);
  const v = [];
  v.push({
    type: "page",
    label: 1,
    active: e === 1,
    mayBeFastBackward: !1,
    mayBeFastForward: !1
  }), g ? (n = !0, o = d - 1, v.push({
    type: "fast-backward",
    active: !1,
    label: void 0,
    options: QP(s + 1, d - 1)
  })) : u >= s + 1 && v.push({
    type: "page",
    label: s + 1,
    mayBeFastBackward: !0,
    mayBeFastForward: !1,
    active: e === s + 1
  });
  for (let w = d; w <= f; ++w)
    v.push({
      type: "page",
      label: w,
      mayBeFastBackward: !1,
      mayBeFastForward: !1,
      active: e === w
    });
  return m ? (i = !0, a = f + 1, v.push({
    type: "fast-forward",
    active: !1,
    label: void 0,
    options: QP(f + 1, u - 1)
  })) : f === u - 2 && v[v.length - 1].label !== u - 1 && v.push({
    type: "page",
    mayBeFastForward: !0,
    mayBeFastBackward: !1,
    label: u - 1,
    active: e === u - 1
  }), v[v.length - 1].label !== u && v.push({
    type: "page",
    mayBeFastForward: !1,
    mayBeFastBackward: !1,
    label: u,
    active: e === u
  }), {
    hasFastBackward: n,
    hasFastForward: i,
    fastBackwardTo: o,
    fastForwardTo: a,
    items: v
  };
}
function QP(e, t) {
  const r = [];
  for (let n = e; n <= t; ++n)
    r.push({
      label: `${n}`,
      value: n
    });
  return r;
}
const qP = `
 background: var(--n-item-color-hover);
 color: var(--n-item-text-color-hover);
 border: var(--n-item-border-hover);
`, GP = [K("button", `
 background: var(--n-button-color-hover);
 border: var(--n-button-border-hover);
 color: var(--n-button-icon-color-hover);
 `)];
var Lme = L("pagination", `
 display: flex;
 vertical-align: middle;
 font-size: var(--n-item-font-size);
 flex-wrap: nowrap;
`, [L("pagination-prefix", `
 display: flex;
 align-items: center;
 margin: var(--n-prefix-margin);
 `), L("pagination-suffix", `
 display: flex;
 align-items: center;
 margin: var(--n-suffix-margin);
 `), Y("> *:not(:first-child)", `
 margin: var(--n-item-margin);
 `), L("select", `
 width: var(--n-select-width);
 `), Y("&.transition-disabled", [L("pagination-item", "transition: none!important;")]), L("pagination-quick-jumper", `
 white-space: nowrap;
 display: flex;
 color: var(--n-jumper-text-color);
 transition: color .3s var(--n-bezier);
 align-items: center;
 font-size: var(--n-jumper-font-size);
 `, [L("input", `
 margin: var(--n-input-margin);
 width: var(--n-input-width);
 `)]), L("pagination-item", `
 position: relative;
 cursor: pointer;
 user-select: none;
 -webkit-user-select: none;
 display: flex;
 align-items: center;
 justify-content: center;
 box-sizing: border-box;
 min-width: var(--n-item-size);
 height: var(--n-item-size);
 padding: var(--n-item-padding);
 background-color: var(--n-item-color);
 color: var(--n-item-text-color);
 border-radius: var(--n-item-border-radius);
 border: var(--n-item-border);
 fill: var(--n-button-icon-color);
 transition:
 color .3s var(--n-bezier),
 border-color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 fill .3s var(--n-bezier);
 `, [K("button", `
 background: var(--n-button-color);
 color: var(--n-button-icon-color);
 border: var(--n-button-border);
 padding: 0;
 `, [L("base-icon", `
 font-size: var(--n-button-icon-size);
 `)]), wr("disabled", [K("hover", qP, GP), Y("&:hover", qP, GP), Y("&:active", `
 background: var(--n-item-color-pressed);
 color: var(--n-item-text-color-pressed);
 border: var(--n-item-border-pressed);
 `, [K("button", `
 background: var(--n-button-color-pressed);
 border: var(--n-button-border-pressed);
 color: var(--n-button-icon-color-pressed);
 `)]), K("active", `
 background: var(--n-item-color-active);
 color: var(--n-item-text-color-active);
 border: var(--n-item-border-active);
 `, [Y("&:hover", `
 background: var(--n-item-color-active-hover);
 `)])]), K("disabled", `
 cursor: not-allowed;
 color: var(--n-item-text-color-disabled);
 `, [K("active, button", `
 background-color: var(--n-item-color-disabled);
 border: var(--n-item-border-disabled);
 `)])]), K("disabled", `
 cursor: not-allowed;
 `, [L("pagination-quick-jumper", `
 color: var(--n-jumper-text-color-disabled);
 `)]), K("simple", `
 display: flex;
 align-items: center;
 flex-wrap: nowrap;
 `, [L("pagination-quick-jumper", [L("input", `
 margin: 0;
 `)])])]);
const Pme = Object.assign(Object.assign({}, ft.props), {
  simple: Boolean,
  page: Number,
  defaultPage: {
    type: Number,
    default: 1
  },
  itemCount: Number,
  pageCount: Number,
  defaultPageCount: {
    type: Number,
    default: 1
  },
  showSizePicker: Boolean,
  pageSize: Number,
  defaultPageSize: Number,
  pageSizes: {
    type: Array,
    default() {
      return [10];
    }
  },
  showQuickJumper: Boolean,
  size: {
    type: String,
    default: "medium"
  },
  disabled: Boolean,
  pageSlot: {
    type: Number,
    default: 9
  },
  selectProps: Object,
  prev: Function,
  next: Function,
  goto: Function,
  prefix: Function,
  suffix: Function,
  label: Function,
  displayOrder: {
    type: Array,
    default: ["pages", "size-picker", "quick-jumper"]
  },
  to: vi.propTo,
  "onUpdate:page": [Function, Array],
  onUpdatePage: [Function, Array],
  "onUpdate:pageSize": [Function, Array],
  onUpdatePageSize: [Function, Array],
  onPageSizeChange: [Function, Array],
  onChange: [Function, Array]
});
var VH = oe({
  name: "Pagination",
  props: Pme,
  setup(e) {
    const { mergedComponentPropsRef: t, mergedClsPrefixRef: r, inlineThemeDisabled: n, mergedRtlRef: i } = Yt(e), o = ft("Pagination", "-pagination", Lme, WH, e, r), { localeRef: a } = Zl("Pagination"), s = G(null), u = G(e.defaultPage), f = G((() => {
      const { defaultPageSize: Ee } = e;
      if (Ee !== void 0)
        return Ee;
      const qe = e.pageSizes[0];
      return typeof qe == "number" ? qe : qe.value || 10;
    })()), h = dn(tt(e, "page"), u), g = dn(tt(e, "pageSize"), f), m = j(() => {
      const { itemCount: Ee } = e;
      if (Ee !== void 0)
        return Math.max(1, Math.ceil(Ee / g.value));
      const { pageCount: qe } = e;
      return qe !== void 0 ? Math.max(qe, 1) : 1;
    }), v = G("");
    On(() => {
      e.simple, v.value = String(h.value);
    });
    const w = G(!1), x = G(!1), y = G(!1), C = G(!1), S = () => {
      e.disabled || (w.value = !0, X());
    }, T = () => {
      e.disabled || (w.value = !1, X());
    }, A = () => {
      x.value = !0, X();
    }, D = () => {
      x.value = !1, X();
    }, E = (Ee) => {
      re(Ee);
    }, N = j(() => _me(h.value, m.value, e.pageSlot));
    On(() => {
      N.value.hasFastBackward ? N.value.hasFastForward || (w.value = !1, y.value = !1) : (x.value = !1, C.value = !1);
    });
    const I = j(() => {
      const Ee = a.value.selectionSuffix;
      return e.pageSizes.map((qe) => typeof qe == "number" ? {
        label: `${qe} / ${Ee}`,
        value: qe
      } : qe);
    }), $ = j(() => {
      var Ee, qe;
      return ((qe = (Ee = t == null ? void 0 : t.value) === null || Ee === void 0 ? void 0 : Ee.Pagination) === null || qe === void 0 ? void 0 : qe.inputSize) || rz(e.size);
    }), _ = j(() => {
      var Ee, qe;
      return ((qe = (Ee = t == null ? void 0 : t.value) === null || Ee === void 0 ? void 0 : Ee.Pagination) === null || qe === void 0 ? void 0 : qe.selectSize) || rz(e.size);
    }), R = j(() => (h.value - 1) * g.value), U = j(() => {
      const Ee = h.value * g.value - 1, { itemCount: qe } = e;
      return qe !== void 0 && Ee > qe - 1 ? qe - 1 : Ee;
    }), Q = j(() => {
      const { itemCount: Ee } = e;
      return Ee !== void 0 ? Ee : (e.pageCount || 1) * g.value;
    }), Z = Li("Pagination", i, r), X = () => {
      an(() => {
        var Ee;
        const { value: qe } = s;
        qe && (qe.classList.add("transition-disabled"), (Ee = s.value) === null || Ee === void 0 || Ee.offsetWidth, qe.classList.remove("transition-disabled"));
      });
    };
    function re(Ee) {
      if (Ee === h.value)
        return;
      const { "onUpdate:page": qe, onUpdatePage: Ue, onChange: ot, simple: Ie } = e;
      qe && je(qe, Ee), Ue && je(Ue, Ee), ot && je(ot, Ee), u.value = Ee, Ie && (v.value = String(Ee));
    }
    function ue(Ee) {
      if (Ee === g.value)
        return;
      const { "onUpdate:pageSize": qe, onUpdatePageSize: Ue, onPageSizeChange: ot } = e;
      qe && je(qe, Ee), Ue && je(Ue, Ee), ot && je(ot, Ee), f.value = Ee, m.value < h.value && re(m.value);
    }
    function he() {
      if (e.disabled)
        return;
      const Ee = Math.min(h.value + 1, m.value);
      re(Ee);
    }
    function te() {
      if (e.disabled)
        return;
      const Ee = Math.max(h.value - 1, 1);
      re(Ee);
    }
    function de() {
      if (e.disabled)
        return;
      const Ee = Math.min(N.value.fastForwardTo, m.value);
      re(Ee);
    }
    function De() {
      if (e.disabled)
        return;
      const Ee = Math.max(N.value.fastBackwardTo, 1);
      re(Ee);
    }
    function Oe(Ee) {
      ue(Ee);
    }
    function Qe() {
      const Ee = parseInt(v.value);
      Number.isNaN(Ee) || (re(Math.max(1, Math.min(Ee, m.value))), e.simple || (v.value = ""));
    }
    function Ae() {
      Qe();
    }
    function Ne(Ee) {
      if (!e.disabled)
        switch (Ee.type) {
          case "page":
            re(Ee.label);
            break;
          case "fast-backward":
            De();
            break;
          case "fast-forward":
            de();
            break;
        }
    }
    function $e(Ee) {
      v.value = Ee.replace(/\D+/g, "");
    }
    On(() => {
      h.value, g.value, X();
    });
    const et = j(() => {
      const { size: Ee } = e, { self: { buttonBorder: qe, buttonBorderHover: Ue, buttonBorderPressed: ot, buttonIconColor: Ie, buttonIconColorHover: rt, buttonIconColorPressed: W, itemTextColor: P, itemTextColorHover: H, itemTextColorPressed: se, itemTextColorActive: pe, itemTextColorDisabled: ae, itemColor: Me, itemColorHover: fe, itemColorPressed: ke, itemColorActive: Le, itemColorActiveHover: dt, itemColorDisabled: Mt, itemBorder: Ct, itemBorderHover: er, itemBorderPressed: Vt, itemBorderActive: jt, itemBorderDisabled: at, itemBorderRadius: St, jumperTextColor: ve, jumperTextColorDisabled: We, buttonColor: ne, buttonColorHover: Se, buttonColorPressed: _e, [Be("itemPadding", Ee)]: ut, [Be("itemMargin", Ee)]: ht, [Be("inputWidth", Ee)]: ye, [Be("selectWidth", Ee)]: Ze, [Be("inputMargin", Ee)]: st, [Be("selectMargin", Ee)]: Nt, [Be("jumperFontSize", Ee)]: Te, [Be("prefixMargin", Ee)]: Ke, [Be("suffixMargin", Ee)]: xe, [Be("itemSize", Ee)]: Xe, [Be("buttonIconSize", Ee)]: At, [Be("itemFontSize", Ee)]: Ht, [`${Be("itemMargin", Ee)}Rtl`]: zt, [`${Be("inputMargin", Ee)}Rtl`]: ge }, common: { cubicBezierEaseInOut: Fe } } = o.value;
      return {
        "--n-prefix-margin": Ke,
        "--n-suffix-margin": xe,
        "--n-item-font-size": Ht,
        "--n-select-width": Ze,
        "--n-select-margin": Nt,
        "--n-input-width": ye,
        "--n-input-margin": st,
        "--n-input-margin-rtl": ge,
        "--n-item-size": Xe,
        "--n-item-text-color": P,
        "--n-item-text-color-disabled": ae,
        "--n-item-text-color-hover": H,
        "--n-item-text-color-active": pe,
        "--n-item-text-color-pressed": se,
        "--n-item-color": Me,
        "--n-item-color-hover": fe,
        "--n-item-color-disabled": Mt,
        "--n-item-color-active": Le,
        "--n-item-color-active-hover": dt,
        "--n-item-color-pressed": ke,
        "--n-item-border": Ct,
        "--n-item-border-hover": er,
        "--n-item-border-disabled": at,
        "--n-item-border-active": jt,
        "--n-item-border-pressed": Vt,
        "--n-item-padding": ut,
        "--n-item-border-radius": St,
        "--n-bezier": Fe,
        "--n-jumper-font-size": Te,
        "--n-jumper-text-color": ve,
        "--n-jumper-text-color-disabled": We,
        "--n-item-margin": ht,
        "--n-item-margin-rtl": zt,
        "--n-button-icon-size": At,
        "--n-button-icon-color": Ie,
        "--n-button-icon-color-hover": rt,
        "--n-button-icon-color-pressed": W,
        "--n-button-color-hover": Se,
        "--n-button-color": ne,
        "--n-button-color-pressed": _e,
        "--n-button-border": qe,
        "--n-button-border-hover": Ue,
        "--n-button-border-pressed": ot
      };
    }), Ge = n ? Cr("pagination", j(() => {
      let Ee = "";
      const { size: qe } = e;
      return Ee += qe[0], Ee;
    }), et, e) : void 0;
    return {
      rtlEnabled: Z,
      mergedClsPrefix: r,
      locale: a,
      selfRef: s,
      mergedPage: h,
      pageItems: j(() => N.value.items),
      mergedItemCount: Q,
      jumperValue: v,
      pageSizeOptions: I,
      mergedPageSize: g,
      inputSize: $,
      selectSize: _,
      mergedTheme: o,
      mergedPageCount: m,
      startIndex: R,
      endIndex: U,
      showFastForwardMenu: y,
      showFastBackwardMenu: C,
      fastForwardActive: w,
      fastBackwardActive: x,
      handleMenuSelect: E,
      handleFastForwardMouseenter: S,
      handleFastForwardMouseleave: T,
      handleFastBackwardMouseenter: A,
      handleFastBackwardMouseleave: D,
      handleJumperInput: $e,
      handleBackwardClick: te,
      handleForwardClick: he,
      handlePageItemClick: Ne,
      handleSizePickerChange: Oe,
      handleQuickJumperChange: Ae,
      cssVars: n ? void 0 : et,
      themeClass: Ge == null ? void 0 : Ge.themeClass,
      onRender: Ge == null ? void 0 : Ge.onRender
    };
  },
  render() {
    const { $slots: e, mergedClsPrefix: t, disabled: r, cssVars: n, mergedPage: i, mergedPageCount: o, pageItems: a, showSizePicker: s, showQuickJumper: u, mergedTheme: d, locale: f, inputSize: h, selectSize: g, mergedPageSize: m, pageSizeOptions: v, jumperValue: w, simple: x, prev: y, next: C, prefix: S, suffix: T, label: A, goto: D, handleJumperInput: E, handleSizePickerChange: N, handleBackwardClick: I, handlePageItemClick: $, handleForwardClick: _, handleQuickJumperChange: R, onRender: U } = this;
    U == null || U();
    const Q = e.prefix || S, Z = e.suffix || T, X = y || e.prev, re = C || e.next, ue = A || e.label;
    return b("div", { ref: "selfRef", class: [
      `${t}-pagination`,
      this.themeClass,
      this.rtlEnabled && `${t}-pagination--rtl`,
      r && `${t}-pagination--disabled`,
      x && `${t}-pagination--simple`
    ], style: n }, Q ? b("div", { class: `${t}-pagination-prefix` }, Q({
      page: i,
      pageSize: m,
      pageCount: o,
      startIndex: this.startIndex,
      endIndex: this.endIndex,
      itemCount: this.mergedItemCount
    })) : null, this.displayOrder.map((he) => {
      switch (he) {
        case "pages":
          return b(Lr, null, b("div", { class: [
            `${t}-pagination-item`,
            !X && `${t}-pagination-item--button`,
            (i <= 1 || i > o || r) && `${t}-pagination-item--disabled`
          ], onClick: I }, X ? X({
            page: i,
            pageSize: m,
            pageCount: o,
            startIndex: this.startIndex,
            endIndex: this.endIndex,
            itemCount: this.mergedItemCount
          }) : b(fr, { clsPrefix: t }, {
            default: () => this.rtlEnabled ? b(Sc, null) : b(wc, null)
          })), x ? b(Lr, null, b("div", { class: `${t}-pagination-quick-jumper` }, b(pa, { value: w, onUpdateValue: E, size: h, placeholder: "", disabled: r, theme: d.peers.Input, themeOverrides: d.peerOverrides.Input, onChange: R })), " / ", o) : a.map((te, de) => {
            let De, Oe, Qe;
            const { type: Ae } = te;
            switch (Ae) {
              case "page":
                const $e = te.label;
                ue ? De = ue({
                  type: "page",
                  node: $e,
                  active: te.active
                }) : De = $e;
                break;
              case "fast-forward":
                const et = this.fastForwardActive ? b(fr, { clsPrefix: t }, {
                  default: () => this.rtlEnabled ? b(Mc, null) : b(Cc, null)
                }) : b(fr, { clsPrefix: t }, { default: () => b(IP, null) });
                ue ? De = ue({
                  type: "fast-forward",
                  node: et,
                  active: this.fastForwardActive || this.showFastForwardMenu
                }) : De = et, Oe = this.handleFastForwardMouseenter, Qe = this.handleFastForwardMouseleave;
                break;
              case "fast-backward":
                const Ge = this.fastBackwardActive ? b(fr, { clsPrefix: t }, {
                  default: () => this.rtlEnabled ? b(Cc, null) : b(Mc, null)
                }) : b(fr, { clsPrefix: t }, { default: () => b(IP, null) });
                ue ? De = ue({
                  type: "fast-backward",
                  node: Ge,
                  active: this.fastBackwardActive || this.showFastBackwardMenu
                }) : De = Ge, Oe = this.handleFastBackwardMouseenter, Qe = this.handleFastBackwardMouseleave;
                break;
            }
            const Ne = b("div", { key: de, class: [
              `${t}-pagination-item`,
              te.active && `${t}-pagination-item--active`,
              Ae !== "page" && (Ae === "fast-backward" && this.showFastBackwardMenu || Ae === "fast-forward" && this.showFastForwardMenu) && `${t}-pagination-item--hover`,
              r && `${t}-pagination-item--disabled`,
              Ae === "page" && `${t}-pagination-item--clickable`
            ], onClick: () => {
              $(te);
            }, onMouseenter: Oe, onMouseleave: Qe }, De);
            if (Ae === "page" && !te.mayBeFastBackward && !te.mayBeFastForward)
              return Ne;
            {
              const $e = te.type === "page" ? te.mayBeFastBackward ? "fast-backward" : "fast-forward" : te.type;
              return b(Dme, { to: this.to, key: $e, disabled: r, trigger: "hover", virtualScroll: !0, style: { width: "60px" }, theme: d.peers.Popselect, themeOverrides: d.peerOverrides.Popselect, builtinThemeOverrides: {
                peers: {
                  InternalSelectMenu: {
                    height: "calc(var(--n-option-height) * 4.6)"
                  }
                }
              }, nodeProps: () => ({
                style: {
                  justifyContent: "center"
                }
              }), show: Ae === "page" ? !1 : Ae === "fast-backward" ? this.showFastBackwardMenu : this.showFastForwardMenu, onUpdateShow: (et) => {
                Ae !== "page" && (et ? Ae === "fast-backward" ? this.showFastBackwardMenu = et : this.showFastForwardMenu = et : (this.showFastBackwardMenu = !1, this.showFastForwardMenu = !1));
              }, options: te.type !== "page" ? te.options : [], onUpdateValue: this.handleMenuSelect, scrollable: !0, showCheckmark: !1 }, { default: () => Ne });
            }
          }), b("div", { class: [
            `${t}-pagination-item`,
            !re && `${t}-pagination-item--button`,
            {
              [`${t}-pagination-item--disabled`]: i < 1 || i >= o || r
            }
          ], onClick: _ }, re ? re({
            page: i,
            pageSize: m,
            pageCount: o,
            itemCount: this.mergedItemCount,
            startIndex: this.startIndex,
            endIndex: this.endIndex
          }) : b(fr, { clsPrefix: t }, {
            default: () => this.rtlEnabled ? b(wc, null) : b(Sc, null)
          })));
        case "size-picker":
          return !x && s ? b(HH, Object.assign({ consistentMenuWidth: !1, placeholder: "", showCheckmark: !1, to: this.to }, this.selectProps, { size: g, options: v, value: m, disabled: r, theme: d.peers.Select, themeOverrides: d.peerOverrides.Select, onUpdateValue: N })) : null;
        case "quick-jumper":
          return !x && u ? b("div", { class: `${t}-pagination-quick-jumper` }, D ? D() : vr(this.$slots.goto, () => [f.goto]), b(pa, { value: w, onUpdateValue: E, size: h, placeholder: "", disabled: r, theme: d.peers.Input, themeOverrides: d.peerOverrides.Input, onChange: R })) : null;
        default:
          return null;
      }
    }), Z ? b("div", { class: `${t}-pagination-suffix` }, Z({
      page: i,
      pageSize: m,
      pageCount: o,
      startIndex: this.startIndex,
      endIndex: this.endIndex,
      itemCount: this.mergedItemCount
    })) : null);
  }
}), Rme = {
  padding: "8px 14px"
};
const jme = (e) => {
  const { borderRadius: t, boxShadow2: r, baseColor: n } = e;
  return Object.assign(Object.assign({}, Rme), { borderRadius: t, boxShadow: r, color: nn(n, "rgba(0, 0, 0, .85)"), textColor: n });
}, Fme = {
  name: "Tooltip",
  common: Sr,
  peers: {
    Popover: Vp
  },
  self: jme
};
var UM = Fme;
const Bme = {
  name: "Ellipsis",
  common: Sr,
  peers: {
    Tooltip: UM
  }
};
var YH = Bme, Ume = {
  radioSizeSmall: "14px",
  radioSizeMedium: "16px",
  radioSizeLarge: "18px",
  labelPadding: "0 8px",
  labelFontWeight: "400"
};
const Hme = (e) => {
  const { borderColor: t, primaryColor: r, baseColor: n, textColorDisabled: i, inputColorDisabled: o, textColor2: a, opacityDisabled: s, borderRadius: u, fontSizeSmall: d, fontSizeMedium: f, fontSizeLarge: h, heightSmall: g, heightMedium: m, heightLarge: v, lineHeight: w } = e;
  return Object.assign(Object.assign({}, Ume), {
    labelLineHeight: w,
    buttonHeightSmall: g,
    buttonHeightMedium: m,
    buttonHeightLarge: v,
    fontSizeSmall: d,
    fontSizeMedium: f,
    fontSizeLarge: h,
    boxShadow: `inset 0 0 0 1px ${t}`,
    boxShadowActive: `inset 0 0 0 1px ${r}`,
    boxShadowFocus: `inset 0 0 0 1px ${r}, 0 0 0 2px ${nr(r, { alpha: 0.2 })}`,
    boxShadowHover: `inset 0 0 0 1px ${r}`,
    boxShadowDisabled: `inset 0 0 0 1px ${t}`,
    color: n,
    colorDisabled: o,
    colorActive: "#0000",
    textColor: a,
    textColorDisabled: i,
    dotColorActive: r,
    dotColorDisabled: t,
    buttonBorderColor: t,
    buttonBorderColorActive: r,
    buttonBorderColorHover: t,
    buttonColor: n,
    buttonColorActive: n,
    buttonTextColor: a,
    buttonTextColorActive: r,
    buttonTextColorHover: r,
    opacityDisabled: s,
    buttonBoxShadowFocus: `inset 0 0 0 1px ${r}, 0 0 0 2px ${nr(r, { alpha: 0.3 })}`,
    buttonBoxShadowHover: "inset 0 0 0 1px #0000",
    buttonBoxShadow: "inset 0 0 0 1px #0000",
    buttonBorderRadius: u
  });
}, Wme = {
  name: "Radio",
  common: Sr,
  self: Hme
};
var z4 = Wme, Vme = {
  padding: "4px 0",
  optionIconSizeSmall: "14px",
  optionIconSizeMedium: "16px",
  optionIconSizeLarge: "16px",
  optionIconSizeHuge: "18px",
  optionSuffixWidthSmall: "14px",
  optionSuffixWidthMedium: "14px",
  optionSuffixWidthLarge: "16px",
  optionSuffixWidthHuge: "16px",
  optionIconSuffixWidthSmall: "32px",
  optionIconSuffixWidthMedium: "32px",
  optionIconSuffixWidthLarge: "36px",
  optionIconSuffixWidthHuge: "36px",
  optionPrefixWidthSmall: "14px",
  optionPrefixWidthMedium: "14px",
  optionPrefixWidthLarge: "16px",
  optionPrefixWidthHuge: "16px",
  optionIconPrefixWidthSmall: "36px",
  optionIconPrefixWidthMedium: "36px",
  optionIconPrefixWidthLarge: "40px",
  optionIconPrefixWidthHuge: "40px"
};
const Yme = (e) => {
  const { primaryColor: t, textColor2: r, dividerColor: n, hoverColor: i, popoverColor: o, invertedColor: a, borderRadius: s, fontSizeSmall: u, fontSizeMedium: d, fontSizeLarge: f, fontSizeHuge: h, heightSmall: g, heightMedium: m, heightLarge: v, heightHuge: w, textColor3: x, opacityDisabled: y } = e;
  return Object.assign(Object.assign({}, Vme), {
    optionHeightSmall: g,
    optionHeightMedium: m,
    optionHeightLarge: v,
    optionHeightHuge: w,
    borderRadius: s,
    fontSizeSmall: u,
    fontSizeMedium: d,
    fontSizeLarge: f,
    fontSizeHuge: h,
    optionTextColor: r,
    optionTextColorHover: r,
    optionTextColorActive: t,
    optionTextColorChildActive: t,
    color: o,
    dividerColor: n,
    suffixColor: r,
    prefixColor: r,
    optionColorHover: i,
    optionColorActive: nr(t, { alpha: 0.1 }),
    groupHeaderTextColor: x,
    optionTextColorInverted: "#BBB",
    optionTextColorHoverInverted: "#FFF",
    optionTextColorActiveInverted: "#FFF",
    optionTextColorChildActiveInverted: "#FFF",
    colorInverted: a,
    dividerColorInverted: "#BBB",
    suffixColorInverted: "#BBB",
    prefixColorInverted: "#BBB",
    optionColorHoverInverted: t,
    optionColorActiveInverted: t,
    groupHeaderTextColorInverted: "#AAA",
    optionOpacityDisabled: y
  });
}, Qme = {
  name: "Dropdown",
  common: Sr,
  peers: {
    Popover: Vp
  },
  self: Yme
};
var $4 = Qme, qme = {
  thPaddingSmall: "8px",
  thPaddingMedium: "12px",
  thPaddingLarge: "12px",
  tdPaddingSmall: "8px",
  tdPaddingMedium: "12px",
  tdPaddingLarge: "12px",
  sorterSize: "15px",
  resizableContainerSize: "8px",
  resizableSize: "2px",
  filterSize: "15px",
  paginationMargin: "12px 0 0 0",
  emptyPadding: "48px 0",
  actionPadding: "8px 12px",
  actionButtonMargin: "0 8px 0 0"
};
const Gme = (e) => {
  const { cardColor: t, modalColor: r, popoverColor: n, textColor2: i, textColor1: o, tableHeaderColor: a, tableColorHover: s, iconColor: u, primaryColor: d, fontWeightStrong: f, borderRadius: h, lineHeight: g, fontSizeSmall: m, fontSizeMedium: v, fontSizeLarge: w, dividerColor: x, heightSmall: y, opacityDisabled: C, tableColorStriped: S } = e;
  return Object.assign(Object.assign({}, qme), {
    actionDividerColor: x,
    lineHeight: g,
    borderRadius: h,
    fontSizeSmall: m,
    fontSizeMedium: v,
    fontSizeLarge: w,
    borderColor: nn(t, x),
    tdColorHover: nn(t, s),
    tdColorStriped: nn(t, S),
    thColor: nn(t, a),
    thColorHover: nn(nn(t, a), s),
    tdColor: t,
    tdTextColor: i,
    thTextColor: o,
    thFontWeight: f,
    thButtonColorHover: s,
    thIconColor: u,
    thIconColorActive: d,
    borderColorModal: nn(r, x),
    tdColorHoverModal: nn(r, s),
    tdColorStripedModal: nn(r, S),
    thColorModal: nn(r, a),
    thColorHoverModal: nn(nn(r, a), s),
    tdColorModal: r,
    borderColorPopover: nn(n, x),
    tdColorHoverPopover: nn(n, s),
    tdColorStripedPopover: nn(n, S),
    thColorPopover: nn(n, a),
    thColorHoverPopover: nn(nn(n, a), s),
    tdColorPopover: n,
    boxShadowBefore: "inset -12px 0 8px -12px rgba(0, 0, 0, .18)",
    boxShadowAfter: "inset 12px 0 8px -12px rgba(0, 0, 0, .18)",
    loadingColor: d,
    loadingSize: y,
    opacityLoading: C
  });
}, Zme = {
  name: "DataTable",
  common: Sr,
  peers: {
    Button: Yu,
    Checkbox: LH,
    Radio: z4,
    Pagination: WH,
    Scrollbar: Rc,
    Empty: C4,
    Popover: Vp,
    Ellipsis: YH,
    Dropdown: $4
  },
  self: Gme
};
var Kme = Zme;
const Xme = Object.assign(Object.assign({}, yp), ft.props);
var HM = oe({
  name: "Tooltip",
  props: Xme,
  __popover__: !0,
  setup(e) {
    const { mergedClsPrefixRef: t } = Yt(e), r = ft("Tooltip", "-tooltip", void 0, UM, e, t), n = G(null);
    return Object.assign(Object.assign({}, {
      syncPosition() {
        n.value.syncPosition();
      },
      setShow(o) {
        n.value.setShow(o);
      }
    }), { popoverRef: n, mergedTheme: r, popoverThemeOverrides: j(() => r.value.self) });
  },
  render() {
    const { mergedTheme: e, internalExtraClass: t } = this;
    return b(jc, Object.assign(Object.assign({}, this.$props), { theme: e.peers.Popover, themeOverrides: e.peerOverrides.Popover, builtinThemeOverrides: this.popoverThemeOverrides, internalExtraClass: t.concat("tooltip"), ref: "popoverRef" }), this.$slots);
  }
}), Jme = L("ellipsis", {
  overflow: "hidden"
}, [wr("line-clamp", `
 white-space: nowrap;
 display: inline-block;
 vertical-align: bottom;
 max-width: 100%;
 `), K("line-clamp", `
 display: -webkit-inline-box;
 -webkit-box-orient: vertical;
 `), K("cursor-pointer", `
 cursor: pointer;
 `)]);
function ZP(e) {
  return `${e}-ellipsis--line-clamp`;
}
function KP(e, t) {
  return `${e}-ellipsis--cursor-${t}`;
}
const eve = Object.assign(Object.assign({}, ft.props), { expandTrigger: String, lineClamp: [Number, String], tooltip: {
  type: [Boolean, Object],
  default: !0
} });
var I0 = oe({
  name: "Ellipsis",
  inheritAttrs: !1,
  props: eve,
  setup(e, { slots: t, attrs: r }) {
    const { mergedClsPrefixRef: n } = Yt(e), i = ft("Ellipsis", "-ellipsis", Jme, YH, e, n), o = G(null), a = G(null), s = G(null), u = G(!1), d = j(() => {
      const { lineClamp: x } = e, { value: y } = u;
      return x !== void 0 ? {
        textOverflow: "",
        "-webkit-line-clamp": y ? "" : x
      } : {
        textOverflow: y ? "" : "ellipsis",
        "-webkit-line-clamp": ""
      };
    });
    function f() {
      let x = !1;
      const { value: y } = u;
      if (y)
        return !0;
      const { value: C } = o;
      if (C) {
        const { lineClamp: S } = e;
        if (m(C), S !== void 0)
          x = C.scrollHeight <= C.offsetHeight;
        else {
          const { value: T } = a;
          T && (x = T.getBoundingClientRect().width <= C.getBoundingClientRect().width);
        }
        v(C, x);
      }
      return x;
    }
    const h = j(() => e.expandTrigger === "click" ? () => {
      var x;
      const { value: y } = u;
      y && ((x = s.value) === null || x === void 0 || x.setShow(!1)), u.value = !y;
    } : void 0);
    EM(() => {
      var x;
      e.tooltip && ((x = s.value) === null || x === void 0 || x.setShow(!1));
    });
    const g = () => b("span", Object.assign({}, ir(r, {
      class: [
        `${n.value}-ellipsis`,
        e.lineClamp !== void 0 ? ZP(n.value) : void 0,
        e.expandTrigger === "click" ? KP(n.value, "pointer") : void 0
      ],
      style: d.value
    }), { ref: "triggerRef", onClick: h.value, onMouseenter: e.expandTrigger === "click" ? f : void 0 }), e.lineClamp ? t : b("span", { ref: "triggerInnerRef" }, t));
    function m(x) {
      if (!x)
        return;
      const y = d.value, C = ZP(n.value);
      e.lineClamp !== void 0 ? w(x, C, "add") : w(x, C, "remove");
      for (const S in y)
        x.style[S] !== y[S] && (x.style[S] = y[S]);
    }
    function v(x, y) {
      const C = KP(n.value, "pointer");
      e.expandTrigger === "click" && !y ? w(x, C, "add") : w(x, C, "remove");
    }
    function w(x, y, C) {
      C === "add" ? x.classList.contains(y) || x.classList.add(y) : x.classList.contains(y) && x.classList.remove(y);
    }
    return {
      mergedTheme: i,
      triggerRef: o,
      triggerInnerRef: a,
      tooltipRef: s,
      handleClick: h,
      renderTrigger: g,
      getTooltipDisabled: f
    };
  },
  render() {
    var e;
    const { tooltip: t, renderTrigger: r, $slots: n } = this;
    if (t) {
      const { mergedTheme: i } = this;
      return b(HM, Object.assign({ ref: "tooltipRef", placement: "top" }, t, { getDisabled: this.getTooltipDisabled, theme: i.peers.Tooltip, themeOverrides: i.peerOverrides.Tooltip }), {
        trigger: r,
        default: (e = n.tooltip) !== null && e !== void 0 ? e : n.default
      });
    } else
      return r();
  }
}), tve = oe({
  name: "DataTableRenderSorter",
  props: {
    render: {
      type: Function,
      required: !0
    },
    order: {
      type: [String, Boolean],
      default: !1
    }
  },
  render() {
    const { render: e, order: t } = this;
    return e({
      order: t
    });
  }
});
const rve = Object.assign(Object.assign({}, ft.props), {
  onUnstableColumnResize: Function,
  pagination: {
    type: [Object, Boolean],
    default: !1
  },
  paginateSinglePage: {
    type: Boolean,
    default: !0
  },
  minHeight: [Number, String],
  maxHeight: [Number, String],
  columns: {
    type: Array,
    default: () => []
  },
  rowClassName: [String, Function],
  rowProps: Function,
  rowKey: Function,
  summary: [Function],
  data: {
    type: Array,
    default: () => []
  },
  loading: Boolean,
  bordered: {
    type: Boolean,
    default: void 0
  },
  bottomBordered: {
    type: Boolean,
    default: void 0
  },
  striped: Boolean,
  scrollX: [Number, String],
  defaultCheckedRowKeys: {
    type: Array,
    default: () => []
  },
  checkedRowKeys: Array,
  singleLine: {
    type: Boolean,
    default: !0
  },
  singleColumn: Boolean,
  size: {
    type: String,
    default: "medium"
  },
  remote: Boolean,
  defaultExpandedRowKeys: {
    type: Array,
    default: []
  },
  defaultExpandAll: Boolean,
  expandedRowKeys: Array,
  stickyExpandedRows: Boolean,
  virtualScroll: Boolean,
  tableLayout: {
    type: String,
    default: "auto"
  },
  allowCheckingNotLoaded: Boolean,
  cascade: {
    type: Boolean,
    default: !0
  },
  childrenKey: {
    type: String,
    default: "children"
  },
  indent: {
    type: Number,
    default: 16
  },
  flexHeight: Boolean,
  summaryPlacement: {
    type: String,
    default: "bottom"
  },
  paginationBehaviorOnFilter: {
    type: String,
    default: "current"
  },
  scrollbarProps: Object,
  renderCell: Function,
  renderExpandIcon: Function,
  spinProps: { type: Object, default: {} },
  onLoad: Function,
  "onUpdate:page": [Function, Array],
  onUpdatePage: [Function, Array],
  "onUpdate:pageSize": [Function, Array],
  onUpdatePageSize: [Function, Array],
  "onUpdate:sorter": [Function, Array],
  onUpdateSorter: [Function, Array],
  "onUpdate:filters": [Function, Array],
  onUpdateFilters: [Function, Array],
  "onUpdate:checkedRowKeys": [Function, Array],
  onUpdateCheckedRowKeys: [Function, Array],
  "onUpdate:expandedRowKeys": [Function, Array],
  onUpdateExpandedRowKeys: [Function, Array],
  onScroll: Function,
  onPageChange: [Function, Array],
  onPageSizeChange: [Function, Array],
  onSorterChange: [Function, Array],
  onFiltersChange: [Function, Array],
  onCheckedRowKeysChange: [Function, Array]
}), Kl = "n-data-table";
var nve = oe({
  name: "SortIcon",
  props: {
    column: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { mergedComponentPropsRef: t } = Yt(), { mergedSortStateRef: r, mergedClsPrefixRef: n } = lt(Kl), i = j(() => r.value.find((u) => u.columnKey === e.column.key)), o = j(() => i.value !== void 0), a = j(() => {
      const { value: u } = i;
      return u && o.value ? u.order : !1;
    }), s = j(() => {
      var u, d;
      return ((d = (u = t == null ? void 0 : t.value) === null || u === void 0 ? void 0 : u.DataTable) === null || d === void 0 ? void 0 : d.renderSorter) || e.column.renderSorter;
    });
    return {
      mergedClsPrefix: n,
      active: o,
      mergedSortOrder: a,
      mergedRenderSorter: s
    };
  },
  render() {
    const { mergedRenderSorter: e, mergedSortOrder: t, mergedClsPrefix: r } = this, { renderSorterIcon: n } = this.column;
    return e ? b(tve, { render: e, order: t }) : b("span", { class: [
      `${r}-data-table-sorter`,
      t === "ascend" && `${r}-data-table-sorter--asc`,
      t === "descend" && `${r}-data-table-sorter--desc`
    ] }, n ? n({ order: t }) : b(fr, { clsPrefix: r }, { default: () => b(pfe, null) }));
  }
}), ive = oe({
  name: "DataTableRenderFilter",
  props: {
    render: {
      type: Function,
      required: !0
    },
    active: {
      type: Boolean,
      default: !1
    },
    show: {
      type: Boolean,
      default: !1
    }
  },
  render() {
    const { render: e, active: t, show: r } = this;
    return e({
      active: t,
      show: r
    });
  }
});
const QH = {
  name: String,
  value: {
    type: [String, Number, Boolean],
    default: "on"
  },
  checked: {
    type: Boolean,
    default: void 0
  },
  defaultChecked: Boolean,
  disabled: {
    type: Boolean,
    default: void 0
  },
  label: String,
  size: String,
  onUpdateChecked: [Function, Array],
  "onUpdate:checked": [Function, Array],
  checkedValue: {
    type: Boolean,
    default: void 0
  }
}, qH = "n-radio-group";
function GH(e) {
  const t = ta(e, {
    mergedSize(C) {
      const { size: S } = e;
      if (S !== void 0)
        return S;
      if (a) {
        const { mergedSizeRef: { value: T } } = a;
        if (T !== void 0)
          return T;
      }
      return C ? C.mergedSize.value : "medium";
    },
    mergedDisabled(C) {
      return !!(e.disabled || a != null && a.disabledRef.value || C != null && C.disabled.value);
    }
  }), { mergedSizeRef: r, mergedDisabledRef: n } = t, i = G(null), o = G(null), a = lt(qH, null), s = G(e.defaultChecked), u = tt(e, "checked"), d = dn(u, s), f = _r(() => a ? a.valueRef.value === e.value : d.value), h = _r(() => {
    const { name: C } = e;
    if (C !== void 0)
      return C;
    if (a)
      return a.nameRef.value;
  }), g = G(!1);
  function m() {
    if (a) {
      const { doUpdateValue: C } = a, { value: S } = e;
      je(C, S);
    } else {
      const { onUpdateChecked: C, "onUpdate:checked": S } = e, { nTriggerFormInput: T, nTriggerFormChange: A } = t;
      C && je(C, !0), S && je(S, !0), T(), A(), s.value = !0;
    }
  }
  function v() {
    n.value || f.value || m();
  }
  function w() {
    v();
  }
  function x() {
    g.value = !1;
  }
  function y() {
    g.value = !0;
  }
  return {
    mergedClsPrefix: a ? a.mergedClsPrefixRef : Yt(e).mergedClsPrefixRef,
    inputRef: i,
    labelRef: o,
    mergedName: h,
    mergedDisabled: n,
    uncontrolledChecked: s,
    renderSafeChecked: f,
    focus: g,
    mergedSize: r,
    handleRadioInputChange: w,
    handleRadioInputBlur: x,
    handleRadioInputFocus: y
  };
}
var ove = L("radio", `
 line-height: var(--n-label-line-height);
 outline: none;
 position: relative;
 user-select: none;
 -webkit-user-select: none;
 display: inline-flex;
 align-items: flex-start;
 flex-wrap: nowrap;
 font-size: var(--n-font-size);
 word-break: break-word;
`, [K("checked", [q("dot", `
 background-color: var(--n-color-active);
 `)]), q("dot-wrapper", `
 position: relative;
 flex-shrink: 0;
 flex-grow: 0;
 width: var(--n-radio-size);
 `), L("radio-input", `
 position: absolute;
 border: 0;
 border-radius: inherit;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 opacity: 0;
 z-index: 1;
 cursor: pointer;
 `), q("dot", `
 position: absolute;
 top: 50%;
 left: 0;
 transform: translateY(-50%);
 height: var(--n-radio-size);
 width: var(--n-radio-size);
 background: var(--n-color);
 box-shadow: var(--n-box-shadow);
 border-radius: 50%;
 transition:
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 `, [Y("&::before", `
 content: "";
 opacity: 0;
 position: absolute;
 left: 4px;
 top: 4px;
 height: calc(100% - 8px);
 width: calc(100% - 8px);
 border-radius: 50%;
 transform: scale(.8);
 background: var(--n-dot-color-active);
 transition: 
 opacity .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 transform .3s var(--n-bezier);
 `), K("checked", {
  boxShadow: "var(--n-box-shadow-active)"
}, [Y("&::before", `
 opacity: 1;
 transform: scale(1);
 `)])]), q("label", `
 color: var(--n-text-color);
 padding: var(--n-label-padding);
 font-weight: var(--n-label-font-weight);
 display: inline-block;
 transition: color .3s var(--n-bezier);
 `), wr("disabled", `
 cursor: pointer;
 `, [Y("&:hover", [q("dot", {
  boxShadow: "var(--n-box-shadow-hover)"
})]), K("focus", [Y("&:not(:active)", [q("dot", {
  boxShadow: "var(--n-box-shadow-focus)"
})])])]), K("disabled", `
 cursor: not-allowed;
 `, [q("dot", {
  boxShadow: "var(--n-box-shadow-disabled)",
  backgroundColor: "var(--n-color-disabled)"
}, [Y("&::before", {
  backgroundColor: "var(--n-dot-color-disabled)"
}), K("checked", `
 opacity: 1;
 `)]), q("label", {
  color: "var(--n-text-color-disabled)"
}), L("radio-input", `
 cursor: not-allowed;
 `)])]), WM = oe({
  name: "Radio",
  props: Object.assign(Object.assign({}, ft.props), QH),
  setup(e) {
    const t = GH(e), r = ft("Radio", "-radio", ove, z4, e, t.mergedClsPrefix), n = j(() => {
      const { mergedSize: { value: d } } = t, { common: { cubicBezierEaseInOut: f }, self: { boxShadow: h, boxShadowActive: g, boxShadowDisabled: m, boxShadowFocus: v, boxShadowHover: w, color: x, colorDisabled: y, colorActive: C, textColor: S, textColorDisabled: T, dotColorActive: A, dotColorDisabled: D, labelPadding: E, labelLineHeight: N, labelFontWeight: I, [Be("fontSize", d)]: $, [Be("radioSize", d)]: _ } } = r.value;
      return {
        "--n-bezier": f,
        "--n-label-line-height": N,
        "--n-label-font-weight": I,
        "--n-box-shadow": h,
        "--n-box-shadow-active": g,
        "--n-box-shadow-disabled": m,
        "--n-box-shadow-focus": v,
        "--n-box-shadow-hover": w,
        "--n-color": x,
        "--n-color-active": C,
        "--n-color-disabled": y,
        "--n-dot-color-active": A,
        "--n-dot-color-disabled": D,
        "--n-font-size": $,
        "--n-radio-size": _,
        "--n-text-color": S,
        "--n-text-color-disabled": T,
        "--n-label-padding": E
      };
    }), { inlineThemeDisabled: i, mergedClsPrefixRef: o, mergedRtlRef: a } = Yt(e), s = Li("Radio", a, o), u = i ? Cr("radio", j(() => t.mergedSize.value[0]), n, e) : void 0;
    return Object.assign(t, {
      rtlEnabled: s,
      cssVars: i ? void 0 : n,
      themeClass: u == null ? void 0 : u.themeClass,
      onRender: u == null ? void 0 : u.onRender
    });
  },
  render() {
    const { $slots: e, mergedClsPrefix: t, onRender: r, label: n } = this;
    return r == null || r(), b("label", { class: [
      `${t}-radio`,
      this.themeClass,
      {
        [`${t}-radio--rtl`]: this.rtlEnabled,
        [`${t}-radio--disabled`]: this.mergedDisabled,
        [`${t}-radio--checked`]: this.renderSafeChecked,
        [`${t}-radio--focus`]: this.focus
      }
    ], style: this.cssVars }, b("input", { ref: "inputRef", type: "radio", class: `${t}-radio-input`, value: this.value, name: this.mergedName, checked: this.renderSafeChecked, disabled: this.mergedDisabled, onChange: this.handleRadioInputChange, onFocus: this.handleRadioInputFocus, onBlur: this.handleRadioInputBlur }), b("div", { class: `${t}-radio__dot-wrapper` }, " ", b("div", { class: [
      `${t}-radio__dot`,
      this.renderSafeChecked && `${t}-radio__dot--checked`
    ] })), Fr(e.default, (i) => !i && !n ? null : b("div", { ref: "labelRef", class: `${t}-radio__label` }, i || n)));
  }
}), ave = L("radio-group", `
 display: inline-block;
 font-size: var(--n-font-size);
`, [q("splitor", `
 display: inline-block;
 vertical-align: bottom;
 width: 1px;
 transition:
 background-color .3s var(--n-bezier),
 opacity .3s var(--n-bezier);
 background: var(--n-button-border-color);
 `, [K("checked", {
  backgroundColor: "var(--n-button-border-color-active)"
}), K("disabled", {
  opacity: "var(--n-opacity-disabled)"
})]), K("button-group", `
 white-space: nowrap;
 height: var(--n-height);
 line-height: var(--n-height);
 `, [L("radio-button", {
  height: "var(--n-height)",
  lineHeight: "var(--n-height)"
}), q("splitor", {
  height: "var(--n-height)"
})]), L("radio-button", `
 vertical-align: bottom;
 outline: none;
 position: relative;
 user-select: none;
 -webkit-user-select: none;
 display: inline-block;
 box-sizing: border-box;
 padding-left: 14px;
 padding-right: 14px;
 white-space: nowrap;
 transition:
 background-color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 border-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 color: var(--n-button-text-color);
 border-top: 1px solid var(--n-button-border-color);
 border-bottom: 1px solid var(--n-button-border-color);
 `, [L("radio-input", `
 pointer-events: none;
 position: absolute;
 border: 0;
 border-radius: inherit;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 opacity: 0;
 z-index: 1;
 `), q("state-border", `
 z-index: 1;
 pointer-events: none;
 position: absolute;
 box-shadow: var(--n-button-box-shadow);
 transition: box-shadow .3s var(--n-bezier);
 left: -1px;
 bottom: -1px;
 right: -1px;
 top: -1px;
 `), Y("&:first-child", `
 border-top-left-radius: var(--n-button-border-radius);
 border-bottom-left-radius: var(--n-button-border-radius);
 border-left: 1px solid var(--n-button-border-color);
 `, [q("state-border", `
 border-top-left-radius: var(--n-button-border-radius);
 border-bottom-left-radius: var(--n-button-border-radius);
 `)]), Y("&:last-child", `
 border-top-right-radius: var(--n-button-border-radius);
 border-bottom-right-radius: var(--n-button-border-radius);
 border-right: 1px solid var(--n-button-border-color);
 `, [q("state-border", `
 border-top-right-radius: var(--n-button-border-radius);
 border-bottom-right-radius: var(--n-button-border-radius);
 `)]), wr("disabled", `
 cursor: pointer;
 `, [Y("&:hover", [q("state-border", `
 transition: box-shadow .3s var(--n-bezier);
 box-shadow: var(--n-button-box-shadow-hover);
 `), wr("checked", {
  color: "var(--n-button-text-color-hover)"
})]), K("focus", [Y("&:not(:active)", [q("state-border", {
  boxShadow: "var(--n-button-box-shadow-focus)"
})])])]), K("checked", `
 background: var(--n-button-color-active);
 color: var(--n-button-text-color-active);
 border-color: var(--n-button-border-color-active);
 `), K("disabled", `
 cursor: not-allowed;
 opacity: var(--n-opacity-disabled);
 `)])]);
function lve(e, t, r) {
  var n;
  const i = [];
  let o = !1;
  for (let a = 0; a < e.length; ++a) {
    const s = e[a], u = (n = s.type) === null || n === void 0 ? void 0 : n.name;
    u === "RadioButton" && (o = !0);
    const d = s.props;
    if (u !== "RadioButton") {
      i.push(s);
      continue;
    }
    if (a === 0)
      i.push(s);
    else {
      const f = i[i.length - 1].props, h = t === f.value, g = f.disabled, m = t === d.value, v = d.disabled, w = (h ? 2 : 0) + (g ? 0 : 1), x = (m ? 2 : 0) + (v ? 0 : 1), y = {
        [`${r}-radio-group__splitor--disabled`]: g,
        [`${r}-radio-group__splitor--checked`]: h
      }, C = {
        [`${r}-radio-group__splitor--disabled`]: v,
        [`${r}-radio-group__splitor--checked`]: m
      }, S = w < x ? C : y;
      i.push(b("div", { class: [`${r}-radio-group__splitor`, S] }), s);
    }
  }
  return {
    children: i,
    isButtonGroup: o
  };
}
const sve = Object.assign(Object.assign({}, ft.props), { name: String, value: [String, Number, Boolean], defaultValue: {
  type: [String, Number, Boolean],
  default: null
}, size: String, disabled: {
  type: Boolean,
  default: void 0
}, "onUpdate:value": [Function, Array], onUpdateValue: [Function, Array] });
var ZH = oe({
  name: "RadioGroup",
  props: sve,
  setup(e) {
    const t = G(null), { mergedSizeRef: r, mergedDisabledRef: n, nTriggerFormChange: i, nTriggerFormInput: o, nTriggerFormBlur: a, nTriggerFormFocus: s } = ta(e), { mergedClsPrefixRef: u, inlineThemeDisabled: d, mergedRtlRef: f } = Yt(e), h = ft("Radio", "-radio-group", ave, z4, e, u), g = G(e.defaultValue), m = tt(e, "value"), v = dn(m, g);
    function w(A) {
      const { onUpdateValue: D, "onUpdate:value": E } = e;
      D && je(D, A), E && je(E, A), g.value = A, i(), o();
    }
    function x(A) {
      const { value: D } = t;
      D && (D.contains(A.relatedTarget) || s());
    }
    function y(A) {
      const { value: D } = t;
      D && (D.contains(A.relatedTarget) || a());
    }
    tr(qH, {
      mergedClsPrefixRef: u,
      nameRef: tt(e, "name"),
      valueRef: v,
      disabledRef: n,
      mergedSizeRef: r,
      doUpdateValue: w
    });
    const C = Li("Radio", f, u), S = j(() => {
      const { value: A } = r, { common: { cubicBezierEaseInOut: D }, self: { buttonBorderColor: E, buttonBorderColorActive: N, buttonBorderRadius: I, buttonBoxShadow: $, buttonBoxShadowFocus: _, buttonBoxShadowHover: R, buttonColorActive: U, buttonTextColor: Q, buttonTextColorActive: Z, buttonTextColorHover: X, opacityDisabled: re, [Be("buttonHeight", A)]: ue, [Be("fontSize", A)]: he } } = h.value;
      return {
        "--n-font-size": he,
        "--n-bezier": D,
        "--n-button-border-color": E,
        "--n-button-border-color-active": N,
        "--n-button-border-radius": I,
        "--n-button-box-shadow": $,
        "--n-button-box-shadow-focus": _,
        "--n-button-box-shadow-hover": R,
        "--n-button-color-active": U,
        "--n-button-text-color": Q,
        "--n-button-text-color-hover": X,
        "--n-button-text-color-active": Z,
        "--n-height": ue,
        "--n-opacity-disabled": re
      };
    }), T = d ? Cr("radio-group", j(() => r.value[0]), S, e) : void 0;
    return {
      selfElRef: t,
      rtlEnabled: C,
      mergedClsPrefix: u,
      mergedValue: v,
      handleFocusout: y,
      handleFocusin: x,
      cssVars: d ? void 0 : S,
      themeClass: T == null ? void 0 : T.themeClass,
      onRender: T == null ? void 0 : T.onRender
    };
  },
  render() {
    var e;
    const { mergedValue: t, mergedClsPrefix: r, handleFocusin: n, handleFocusout: i } = this, { children: o, isButtonGroup: a } = lve(ms(qO(this)), t, r);
    return (e = this.onRender) === null || e === void 0 || e.call(this), b("div", { onFocusin: n, onFocusout: i, ref: "selfElRef", class: [
      `${r}-radio-group`,
      this.rtlEnabled && `${r}-radio-group--rtl`,
      this.themeClass,
      a && `${r}-radio-group--button-group`
    ], style: this.cssVars }, o);
  }
}), uve = oe({
  name: "RadioButton",
  props: QH,
  setup: GH,
  render() {
    const { mergedClsPrefix: e } = this;
    return b("label", { class: [
      `${e}-radio-button`,
      this.mergedDisabled && `${e}-radio-button--disabled`,
      this.renderSafeChecked && `${e}-radio-button--checked`,
      this.focus && [`${e}-radio-button--focus`]
    ] }, b("input", { ref: "inputRef", type: "radio", class: `${e}-radio-input`, value: this.value, name: this.mergedName, checked: this.renderSafeChecked, disabled: this.mergedDisabled, onChange: this.handleRadioInputChange, onFocus: this.handleRadioInputFocus, onBlur: this.handleRadioInputBlur }), b("div", { class: `${e}-radio-button__state-border` }), Fr(this.$slots.default, (t) => !t && !this.label ? null : b("div", { ref: "labelRef", class: `${e}-radio__label` }, t || this.label)));
  }
});
const KH = 40, XH = 40;
function XP(e) {
  if (e.type === "selection")
    return e.width === void 0 ? KH : wo(e.width);
  if (e.type === "expand")
    return e.width === void 0 ? XH : wo(e.width);
  if (!("children" in e))
    return typeof e.width == "string" ? wo(e.width) : e.width;
}
function cve(e) {
  var t, r;
  if (e.type === "selection")
    return Rn((t = e.width) !== null && t !== void 0 ? t : KH);
  if (e.type === "expand")
    return Rn((r = e.width) !== null && r !== void 0 ? r : XH);
  if (!("children" in e))
    return Rn(e.width);
}
function Ol(e) {
  return e.type === "selection" ? "__n_selection__" : e.type === "expand" ? "__n_expand__" : e.key;
}
function JP(e) {
  return e && (typeof e == "object" ? Object.assign({}, e) : e);
}
function dve(e) {
  return e === "ascend" ? 1 : e === "descend" ? -1 : 0;
}
function fve(e, t, r) {
  return r !== void 0 && (e = Math.min(e, typeof r == "number" ? r : parseFloat(r))), t !== void 0 && (e = Math.max(e, typeof t == "number" ? t : parseFloat(t))), e;
}
function hve(e, t) {
  if (t !== void 0)
    return {
      width: t,
      minWidth: t,
      maxWidth: t
    };
  const r = cve(e), { minWidth: n, maxWidth: i } = e;
  return {
    width: r,
    minWidth: Rn(n) || r,
    maxWidth: Rn(i)
  };
}
function pve(e, t, r) {
  return typeof r == "function" ? r(e, t) : r || "";
}
function QI(e) {
  return e.filterOptionValues !== void 0 || e.filterOptionValue === void 0 && e.defaultFilterOptionValues !== void 0;
}
function qI(e) {
  return "children" in e ? !1 : !!e.sorter;
}
function JH(e) {
  return "children" in e && e.children.length ? !1 : !!e.resizable;
}
function eR(e) {
  return "children" in e ? !1 : !!e.filter && (!!e.filterOptions || !!e.renderFilterMenu);
}
function tR(e) {
  if (e) {
    if (e === "descend")
      return "ascend";
  } else
    return "descend";
  return !1;
}
function gve(e, t) {
  return e.sorter === void 0 ? null : t === null || t.columnKey !== e.key ? {
    columnKey: e.key,
    sorter: e.sorter,
    order: tR(!1)
  } : Object.assign(Object.assign({}, t), { order: tR(t.order) });
}
function eW(e, t) {
  return t.find((r) => r.columnKey === e.key && r.order) !== void 0;
}
var mve = oe({
  name: "DataTableFilterMenu",
  props: {
    column: {
      type: Object,
      required: !0
    },
    radioGroupName: {
      type: String,
      required: !0
    },
    multiple: {
      type: Boolean,
      required: !0
    },
    value: {
      type: [Array, String, Number],
      default: null
    },
    options: {
      type: Array,
      required: !0
    },
    onConfirm: {
      type: Function,
      required: !0
    },
    onClear: {
      type: Function,
      required: !0
    },
    onChange: {
      type: Function,
      required: !0
    }
  },
  setup(e) {
    const {
      mergedClsPrefixRef: t,
      mergedThemeRef: r,
      localeRef: n
    } = lt(Kl), i = G(e.value), o = j(() => {
      const { value: h } = i;
      return Array.isArray(h) ? h : null;
    }), a = j(() => {
      const { value: h } = i;
      return QI(e.column) ? Array.isArray(h) && h.length && h[0] || null : Array.isArray(h) ? null : h;
    });
    function s(h) {
      e.onChange(h);
    }
    function u(h) {
      e.multiple && Array.isArray(h) ? i.value = h : QI(e.column) && !Array.isArray(h) ? i.value = [h] : i.value = h;
    }
    function d() {
      s(i.value), e.onConfirm();
    }
    function f() {
      e.multiple || QI(e.column) ? s([]) : s(null), e.onClear();
    }
    return {
      mergedClsPrefix: t,
      mergedTheme: r,
      locale: n,
      checkboxGroupValue: o,
      radioGroupValue: a,
      handleChange: u,
      handleConfirmClick: d,
      handleClearClick: f
    };
  },
  render() {
    const { mergedTheme: e, locale: t, mergedClsPrefix: r } = this;
    return b("div", { class: `${r}-data-table-filter-menu` }, b(no, null, {
      default: () => {
        const { checkboxGroupValue: n, handleChange: i } = this;
        return this.multiple ? b(cme, { value: n, class: `${r}-data-table-filter-menu__group`, onUpdateValue: i }, {
          default: () => this.options.map((o) => b(BM, { key: o.value, theme: e.peers.Checkbox, themeOverrides: e.peerOverrides.Checkbox, value: o.value }, { default: () => o.label }))
        }) : b(ZH, { name: this.radioGroupName, class: `${r}-data-table-filter-menu__group`, value: this.radioGroupValue, onUpdateValue: this.handleChange }, {
          default: () => this.options.map((o) => b(WM, { key: o.value, value: o.value, theme: e.peers.Radio, themeOverrides: e.peerOverrides.Radio }, { default: () => o.label }))
        });
      }
    }), b("div", { class: `${r}-data-table-filter-menu__action` }, b(Mn, { size: "tiny", theme: e.peers.Button, themeOverrides: e.peerOverrides.Button, onClick: this.handleClearClick }, { default: () => t.clear }), b(Mn, { theme: e.peers.Button, themeOverrides: e.peerOverrides.Button, type: "primary", size: "tiny", onClick: this.handleConfirmClick }, { default: () => t.confirm })));
  }
});
function vve(e, t, r) {
  const n = Object.assign({}, e);
  return n[t] = r, n;
}
var bve = oe({
  name: "DataTableFilterButton",
  props: {
    column: {
      type: Object,
      required: !0
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  setup(e) {
    const { mergedComponentPropsRef: t } = Yt(), {
      mergedThemeRef: r,
      mergedClsPrefixRef: n,
      mergedFilterStateRef: i,
      filterMenuCssVarsRef: o,
      paginationBehaviorOnFilterRef: a,
      doUpdatePage: s,
      doUpdateFilters: u
    } = lt(Kl), d = G(!1), f = i, h = j(() => e.column.filterMultiple !== !1), g = j(() => {
      const C = f.value[e.column.key];
      if (C === void 0) {
        const { value: S } = h;
        return S ? [] : null;
      }
      return C;
    }), m = j(() => {
      const { value: C } = g;
      return Array.isArray(C) ? C.length > 0 : C !== null;
    }), v = j(() => {
      var C, S;
      return ((S = (C = t == null ? void 0 : t.value) === null || C === void 0 ? void 0 : C.DataTable) === null || S === void 0 ? void 0 : S.renderFilter) || e.column.renderFilter;
    });
    function w(C) {
      const S = vve(f.value, e.column.key, C);
      u(S, e.column), a.value === "first" && s(1);
    }
    function x() {
      d.value = !1;
    }
    function y() {
      d.value = !1;
    }
    return {
      mergedTheme: r,
      mergedClsPrefix: n,
      active: m,
      showPopover: d,
      mergedRenderFilter: v,
      filterMultiple: h,
      mergedFilterValue: g,
      filterMenuCssVars: o,
      handleFilterChange: w,
      handleFilterMenuConfirm: y,
      handleFilterMenuCancel: x
    };
  },
  render() {
    const { mergedTheme: e, mergedClsPrefix: t, handleFilterMenuCancel: r } = this;
    return b(jc, { show: this.showPopover, onUpdateShow: (n) => this.showPopover = n, trigger: "click", theme: e.peers.Popover, themeOverrides: e.peerOverrides.Popover, placement: "bottom", style: { padding: 0 } }, {
      trigger: () => {
        const { mergedRenderFilter: n } = this;
        if (n)
          return b(ive, { "data-data-table-filter": !0, render: n, active: this.active, show: this.showPopover });
        const { renderFilterIcon: i } = this.column;
        return b("div", { "data-data-table-filter": !0, class: [
          `${t}-data-table-filter`,
          {
            [`${t}-data-table-filter--active`]: this.active,
            [`${t}-data-table-filter--show`]: this.showPopover
          }
        ] }, i ? i({
          active: this.active,
          show: this.showPopover
        }) : b(fr, { clsPrefix: t }, { default: () => b(wfe, null) }));
      },
      default: () => {
        const { renderFilterMenu: n } = this.column;
        return n ? n({ hide: r }) : b(mve, { style: this.filterMenuCssVars, radioGroupName: String(this.column.key), multiple: this.filterMultiple, value: this.mergedFilterValue, options: this.options, column: this.column, onChange: this.handleFilterChange, onClear: this.handleFilterMenuCancel, onConfirm: this.handleFilterMenuConfirm });
      }
    });
  }
}), yve = oe({
  name: "ColumnResizeButton",
  props: {
    onResizeStart: Function,
    onResize: Function,
    onResizeEnd: Function
  },
  setup(e) {
    const { mergedClsPrefixRef: t } = lt(Kl), r = G(!1);
    let n = 0;
    function i(u) {
      return u.clientX;
    }
    function o(u) {
      var d;
      const f = r.value;
      n = i(u), r.value = !0, f || (Mr("mousemove", window, a), Mr("mouseup", window, s), (d = e.onResizeStart) === null || d === void 0 || d.call(e));
    }
    function a(u) {
      var d;
      (d = e.onResize) === null || d === void 0 || d.call(e, i(u) - n);
    }
    function s() {
      var u;
      r.value = !1, (u = e.onResizeEnd) === null || u === void 0 || u.call(e), hr("mousemove", window, a), hr("mouseup", window, s);
    }
    return Gr(() => {
      hr("mousemove", window, a), hr("mouseup", window, s);
    }), {
      mergedClsPrefix: t,
      active: r,
      handleMousedown: o
    };
  },
  render() {
    const { mergedClsPrefix: e } = this;
    return b("span", { "data-data-table-resizable": !0, class: [
      `${e}-data-table-resize-button`,
      this.active && `${e}-data-table-resize-button--active`
    ], onMousedown: this.handleMousedown });
  }
}), tW = oe({
  name: "DropdownDivider",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    }
  },
  render() {
    return b("div", { class: `${this.clsPrefix}-dropdown-divider` });
  }
});
const xve = (e) => {
  const { textColorBase: t, opacity1: r, opacity2: n, opacity3: i, opacity4: o, opacity5: a } = e;
  return {
    color: t,
    opacity1Depth: r,
    opacity2Depth: n,
    opacity3Depth: i,
    opacity4Depth: o,
    opacity5Depth: a
  };
}, wve = {
  name: "Icon",
  common: Sr,
  self: xve
};
var Mve = wve, Cve = L("icon", `
 height: 1em;
 width: 1em;
 line-height: 1em;
 text-align: center;
 display: inline-block;
 position: relative;
 fill: currentColor;
 transform: translateZ(0);
`, [K("color-transition", {
  transition: "color .3s var(--n-bezier)"
}), K("depth", {
  color: "var(--n-color)"
}, [Y("svg", {
  opacity: "var(--n-opacity)",
  transition: "opacity .3s var(--n-bezier)"
})]), Y("svg", {
  height: "1em",
  width: "1em"
})]);
const Sve = Object.assign(Object.assign({}, ft.props), { depth: [String, Number], size: [Number, String], color: String, component: Object }), rW = oe({
  _n_icon__: !0,
  name: "Icon",
  inheritAttrs: !1,
  props: Sve,
  setup(e) {
    const { mergedClsPrefixRef: t, inlineThemeDisabled: r } = Yt(e), n = ft("Icon", "-icon", Cve, Mve, e, t), i = j(() => {
      const { depth: a } = e, { common: { cubicBezierEaseInOut: s }, self: u } = n.value;
      if (a !== void 0) {
        const { color: d, [`opacity${a}Depth`]: f } = u;
        return {
          "--n-bezier": s,
          "--n-color": d,
          "--n-opacity": f
        };
      }
      return {
        "--n-bezier": s,
        "--n-color": "",
        "--n-opacity": ""
      };
    }), o = r ? Cr("icon", j(() => `${e.depth || "d"}`), i, e) : void 0;
    return {
      mergedClsPrefix: t,
      mergedStyle: j(() => {
        const { size: a, color: s } = e;
        return {
          fontSize: Rn(a),
          color: s
        };
      }),
      cssVars: r ? void 0 : i,
      themeClass: o == null ? void 0 : o.themeClass,
      onRender: o == null ? void 0 : o.onRender
    };
  },
  render() {
    var e;
    const { $parent: t, depth: r, mergedClsPrefix: n, component: i, onRender: o, themeClass: a } = this;
    return !((e = t == null ? void 0 : t.$options) === null || e === void 0) && e._n_icon__ && ja("icon", "don't wrap `n-icon` inside `n-icon`"), o == null || o(), b("i", ir(this.$attrs, {
      role: "img",
      class: [
        `${n}-icon`,
        a,
        {
          [`${n}-icon--depth`]: r,
          [`${n}-icon--color-transition`]: r !== void 0
        }
      ],
      style: [this.cssVars, this.mergedStyle]
    }), i ? b(i) : this.$slots);
  }
}), O4 = "n-dropdown-menu", VM = "n-dropdown", rR = "n-dropdown-option";
function Dz(e, t) {
  return e.type === "submenu" || e.type === void 0 && e[t] !== void 0;
}
function Tve(e) {
  return e.type === "group";
}
function nW(e) {
  return e.type === "divider";
}
function kve(e) {
  return e.type === "render";
}
var iW = oe({
  name: "DropdownOption",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    tmNode: {
      type: Object,
      required: !0
    },
    parentKey: {
      type: [String, Number],
      default: null
    },
    placement: {
      type: String,
      default: "right-start"
    },
    props: Object,
    scrollable: Boolean
  },
  setup(e) {
    const t = lt(VM), { hoverKeyRef: r, keyboardKeyRef: n, lastToggledSubmenuKeyRef: i, pendingKeyPathRef: o, activeKeyPathRef: a, animatedRef: s, mergedShowRef: u, renderLabelRef: d, renderIconRef: f, labelFieldRef: h, childrenFieldRef: g, renderOptionRef: m, nodePropsRef: v, menuPropsRef: w } = t, x = lt(rR, null), y = lt(O4), C = lt(Up), S = j(() => e.tmNode.rawNode), T = j(() => {
      const { value: re } = g;
      return Dz(e.tmNode.rawNode, re);
    }), A = j(() => {
      const { disabled: re } = e.tmNode;
      return re;
    }), D = j(() => {
      if (!T.value)
        return !1;
      const { key: re, disabled: ue } = e.tmNode;
      if (ue)
        return !1;
      const { value: he } = r, { value: te } = n, { value: de } = i, { value: De } = o;
      return he !== null ? De.includes(re) : te !== null ? De.includes(re) && De[De.length - 1] !== re : de !== null ? De.includes(re) : !1;
    }), E = j(() => n.value === null && !s.value), N = cX(D, 300, E), I = j(() => !!(x != null && x.enteringSubmenuRef.value)), $ = G(!1);
    tr(rR, {
      enteringSubmenuRef: $
    });
    function _() {
      $.value = !0;
    }
    function R() {
      $.value = !1;
    }
    function U() {
      const { parentKey: re, tmNode: ue } = e;
      ue.disabled || u.value && (i.value = re, n.value = null, r.value = ue.key);
    }
    function Q() {
      const { tmNode: re } = e;
      re.disabled || u.value && r.value !== re.key && U();
    }
    function Z(re) {
      if (e.tmNode.disabled || !u.value)
        return;
      const { relatedTarget: ue } = re;
      ue && !Bl({ target: ue }, "dropdownOption") && !Bl({ target: ue }, "scrollbarRail") && (r.value = null);
    }
    function X() {
      const { value: re } = T, { tmNode: ue } = e;
      u.value && !re && !ue.disabled && (t.doSelect(ue.key, ue.rawNode), t.doUpdateShow(!1));
    }
    return {
      labelField: h,
      renderLabel: d,
      renderIcon: f,
      siblingHasIcon: y.showIconRef,
      siblingHasSubmenu: y.hasSubmenuRef,
      menuProps: w,
      popoverBody: C,
      animated: s,
      mergedShowSubmenu: j(() => N.value && !I.value),
      rawNode: S,
      hasSubmenu: T,
      pending: _r(() => {
        const { value: re } = o, { key: ue } = e.tmNode;
        return re.includes(ue);
      }),
      childActive: _r(() => {
        const { value: re } = a, { key: ue } = e.tmNode, he = re.findIndex((te) => ue === te);
        return he === -1 ? !1 : he < re.length - 1;
      }),
      active: _r(() => {
        const { value: re } = a, { key: ue } = e.tmNode, he = re.findIndex((te) => ue === te);
        return he === -1 ? !1 : he === re.length - 1;
      }),
      mergedDisabled: A,
      renderOption: m,
      nodeProps: v,
      handleClick: X,
      handleMouseMove: Q,
      handleMouseEnter: U,
      handleMouseLeave: Z,
      handleSubmenuBeforeEnter: _,
      handleSubmenuAfterEnter: R
    };
  },
  render() {
    var e, t;
    const { animated: r, rawNode: n, mergedShowSubmenu: i, clsPrefix: o, siblingHasIcon: a, siblingHasSubmenu: s, renderLabel: u, renderIcon: d, renderOption: f, nodeProps: h, props: g, scrollable: m } = this;
    let v = null;
    if (i) {
      const C = (e = this.menuProps) === null || e === void 0 ? void 0 : e.call(this, n, n.children);
      v = b(oW, Object.assign({}, C, { clsPrefix: o, scrollable: this.scrollable, tmNodes: this.tmNode.children, parentKey: this.tmNode.key }));
    }
    const w = {
      class: [
        `${o}-dropdown-option-body`,
        this.pending && `${o}-dropdown-option-body--pending`,
        this.active && `${o}-dropdown-option-body--active`,
        this.childActive && `${o}-dropdown-option-body--child-active`,
        this.mergedDisabled && `${o}-dropdown-option-body--disabled`
      ],
      onMousemove: this.handleMouseMove,
      onMouseenter: this.handleMouseEnter,
      onMouseleave: this.handleMouseLeave,
      onClick: this.handleClick
    }, x = h == null ? void 0 : h(n), y = b("div", Object.assign({ class: [`${o}-dropdown-option`, x == null ? void 0 : x.class], "data-dropdown-option": !0 }, x), b("div", ir(w, g), [
      b("div", { class: [
        `${o}-dropdown-option-body__prefix`,
        a && `${o}-dropdown-option-body__prefix--show-icon`
      ] }, [d ? d(n) : xn(n.icon)]),
      b("div", { "data-dropdown-option": !0, class: `${o}-dropdown-option-body__label` }, u ? u(n) : xn((t = n[this.labelField]) !== null && t !== void 0 ? t : n.title)),
      b("div", { "data-dropdown-option": !0, class: [
        `${o}-dropdown-option-body__suffix`,
        s && `${o}-dropdown-option-body__suffix--has-submenu`
      ] }, this.hasSubmenu ? b(rW, null, {
        default: () => b(w4, null)
      }) : null)
    ]), this.hasSubmenu ? b(zc, null, {
      default: () => [
        b($c, null, {
          default: () => b("div", { class: `${o}-dropdown-offset-container` }, b(_c, { show: this.mergedShowSubmenu, placement: this.placement, to: m && this.popoverBody || void 0, teleportDisabled: !m }, {
            default: () => b("div", { class: `${o}-dropdown-menu-wrapper` }, r ? b(jn, { onBeforeEnter: this.handleSubmenuBeforeEnter, onAfterEnter: this.handleSubmenuAfterEnter, name: "fade-in-scale-up-transition", appear: !0 }, {
              default: () => v
            }) : v)
          }))
        })
      ]
    }) : null);
    return f ? f({ node: y, option: n }) : y;
  }
}), Dve = oe({
  name: "DropdownGroupHeader",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    tmNode: {
      type: Object,
      required: !0
    }
  },
  setup() {
    const {
      showIconRef: e,
      hasSubmenuRef: t
    } = lt(O4), { renderLabelRef: r, labelFieldRef: n, nodePropsRef: i, renderOptionRef: o } = lt(VM);
    return {
      labelField: n,
      showIcon: e,
      hasSubmenu: t,
      renderLabel: r,
      nodeProps: i,
      renderOption: o
    };
  },
  render() {
    var e;
    const { clsPrefix: t, hasSubmenu: r, showIcon: n, nodeProps: i, renderLabel: o, renderOption: a } = this, { rawNode: s } = this.tmNode, u = b("div", Object.assign({ class: `${t}-dropdown-option` }, i == null ? void 0 : i(s)), b("div", { class: `${t}-dropdown-option-body ${t}-dropdown-option-body--group` }, b("div", { "data-dropdown-option": !0, class: [
      `${t}-dropdown-option-body__prefix`,
      n && `${t}-dropdown-option-body__prefix--show-icon`
    ] }, xn(s.icon)), b("div", { class: `${t}-dropdown-option-body__label`, "data-dropdown-option": !0 }, o ? o(s) : xn((e = s.title) !== null && e !== void 0 ? e : s[this.labelField])), b("div", { class: [
      `${t}-dropdown-option-body__suffix`,
      r && `${t}-dropdown-option-body__suffix--has-submenu`
    ], "data-dropdown-option": !0 })));
    return a ? a({ node: u, option: s }) : u;
  }
}), Ave = oe({
  name: "NDropdownGroup",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    tmNode: {
      type: Object,
      required: !0
    },
    parentKey: {
      type: [String, Number],
      default: null
    }
  },
  render() {
    const { tmNode: e, parentKey: t, clsPrefix: r } = this, { children: n } = e;
    return b(Lr, null, b(Dve, { clsPrefix: r, tmNode: e, key: e.key }), n == null ? void 0 : n.map((i) => {
      const { rawNode: o } = i;
      return o.show === !1 ? null : nW(o) ? b(tW, {
        clsPrefix: r,
        key: i.key
      }) : i.isGroup ? (ja("dropdown", "`group` node is not allowed to be put in `group` node."), null) : b(iW, { clsPrefix: r, tmNode: i, parentKey: t, key: i.key });
    }));
  }
}), Eve = oe({
  name: "DropdownRenderOption",
  props: {
    tmNode: {
      type: Object,
      required: !0
    }
  },
  render() {
    const { rawNode: { render: e, props: t } } = this.tmNode;
    return b("div", t, [e == null ? void 0 : e()]);
  }
}), oW = oe({
  name: "DropdownMenu",
  props: {
    scrollable: Boolean,
    showArrow: Boolean,
    arrowStyle: [String, Object],
    clsPrefix: {
      type: String,
      required: !0
    },
    tmNodes: {
      type: Array,
      default: () => []
    },
    parentKey: {
      type: [String, Number],
      default: null
    }
  },
  setup(e) {
    const { renderIconRef: t, childrenFieldRef: r } = lt(VM);
    tr(O4, {
      showIconRef: j(() => {
        const i = t.value;
        return e.tmNodes.some((o) => {
          var a;
          if (o.isGroup)
            return (a = o.children) === null || a === void 0 ? void 0 : a.some(({ rawNode: u }) => i ? i(u) : u.icon);
          const { rawNode: s } = o;
          return i ? i(s) : s.icon;
        });
      }),
      hasSubmenuRef: j(() => {
        const { value: i } = r;
        return e.tmNodes.some((o) => {
          var a;
          if (o.isGroup)
            return (a = o.children) === null || a === void 0 ? void 0 : a.some(({ rawNode: u }) => Dz(u, i));
          const { rawNode: s } = o;
          return Dz(s, i);
        });
      })
    });
    const n = G(null);
    return tr(pb, null), tr(gb, null), tr(Up, n), {
      bodyRef: n
    };
  },
  render() {
    const { parentKey: e, clsPrefix: t, scrollable: r } = this, n = this.tmNodes.map((i) => {
      const { rawNode: o } = i;
      return o.show === !1 ? null : kve(o) ? b(Eve, { tmNode: i, key: i.key }) : nW(o) ? b(tW, { clsPrefix: t, key: i.key }) : Tve(o) ? b(Ave, { clsPrefix: t, tmNode: i, parentKey: e, key: i.key }) : b(iW, { clsPrefix: t, tmNode: i, parentKey: e, key: i.key, props: o.props, scrollable: r });
    });
    return b("div", { class: [
      `${t}-dropdown-menu`,
      r && `${t}-dropdown-menu--scrollable`
    ], ref: "bodyRef" }, r ? b(lH, { contentClass: `${t}-dropdown-menu__content` }, {
      default: () => n
    }) : n, this.showArrow ? dH({
      clsPrefix: t,
      arrowStyle: this.arrowStyle
    }) : null);
  }
}), Ive = L("dropdown-menu", `
 transform-origin: var(--v-transform-origin);
 background-color: var(--n-color);
 border-radius: var(--n-border-radius);
 box-shadow: var(--n-box-shadow);
 position: relative;
 transition:
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
`, [Fa(), L("dropdown-option", `
 position: relative;
 `, [Y("a", `
 text-decoration: none;
 color: inherit;
 outline: none;
 `, [Y("&::before", `
 content: "";
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `)]), L("dropdown-option-body", `
 display: flex;
 cursor: pointer;
 position: relative;
 height: var(--n-option-height);
 line-height: var(--n-option-height);
 font-size: var(--n-font-size);
 color: var(--n-option-text-color);
 transition: color .3s var(--n-bezier);
 `, [Y("&::before", `
 content: "";
 position: absolute;
 top: 0;
 bottom: 0;
 left: 4px;
 right: 4px;
 transition: background-color .3s var(--n-bezier);
 border-radius: var(--n-border-radius);
 `), wr("disabled", [K("pending", `
 color: var(--n-option-text-color-hover);
 `, [q("prefix, suffix", `
 color: var(--n-option-text-color-hover);
 `), Y("&::before", "background-color: var(--n-option-color-hover);")]), K("active", `
 color: var(--n-option-text-color-active);
 `, [q("prefix, suffix", `
 color: var(--n-option-text-color-active);
 `), Y("&::before", "background-color: var(--n-option-color-active);")]), K("child-active", `
 color: var(--n-option-text-color-child-active);
 `, [q("prefix, suffix", `
 color: var(--n-option-text-color-child-active);
 `)])]), K("disabled", `
 cursor: not-allowed;
 opacity: var(--n-option-opacity-disabled);
 `), K("group", `
 font-size: calc(var(--n-font-size) - 1px);
 color: var(--n-group-header-text-color);
 `, [q("prefix", `
 width: calc(var(--n-option-prefix-width) / 2);
 `, [K("show-icon", `
 width: calc(var(--n-option-icon-prefix-width) / 2);
 `)])]), q("prefix", `
 width: var(--n-option-prefix-width);
 display: flex;
 justify-content: center;
 align-items: center;
 color: var(--n-prefix-color);
 transition: color .3s var(--n-bezier);
 z-index: 1;
 `, [K("show-icon", `
 width: var(--n-option-icon-prefix-width);
 `), L("icon", `
 font-size: var(--n-option-icon-size);
 `)]), q("label", `
 white-space: nowrap;
 flex: 1;
 z-index: 1;
 `), q("suffix", `
 box-sizing: border-box;
 flex-grow: 0;
 flex-shrink: 0;
 display: flex;
 justify-content: flex-end;
 align-items: center;
 min-width: var(--n-option-suffix-width);
 padding: 0 8px;
 transition: color .3s var(--n-bezier);
 color: var(--n-suffix-color);
 z-index: 1;
 `, [K("has-submenu", `
 width: var(--n-option-icon-suffix-width);
 `), L("icon", `
 font-size: var(--n-option-icon-size);
 `)]), L("dropdown-menu", "pointer-events: all;")]), L("dropdown-offset-container", `
 pointer-events: none;
 position: absolute;
 left: 0;
 right: 0;
 top: -4px;
 bottom: -4px;
 `)]), L("dropdown-divider", `
 transition: background-color .3s var(--n-bezier);
 background-color: var(--n-divider-color);
 height: 1px;
 margin: 4px 0;
 `), L("dropdown-menu-wrapper", `
 transform-origin: var(--v-transform-origin);
 width: fit-content;
 `), Y(">", [L("scrollbar", `
 height: inherit;
 max-height: inherit;
 `)]), wr("scrollable", `
 padding: var(--n-padding);
 `), K("scrollable", [q("content", `
 padding: var(--n-padding);
 `)])]);
const Nve = {
  animated: {
    type: Boolean,
    default: !0
  },
  keyboard: {
    type: Boolean,
    default: !0
  },
  size: {
    type: String,
    default: "medium"
  },
  inverted: Boolean,
  placement: {
    type: String,
    default: "bottom"
  },
  onSelect: [Function, Array],
  options: {
    type: Array,
    default: () => []
  },
  menuProps: Function,
  showArrow: Boolean,
  renderLabel: Function,
  renderIcon: Function,
  renderOption: Function,
  nodeProps: Function,
  labelField: {
    type: String,
    default: "label"
  },
  keyField: {
    type: String,
    default: "key"
  },
  childrenField: {
    type: String,
    default: "children"
  },
  value: [String, Number]
}, zve = Object.keys(yp), $ve = Object.assign(Object.assign(Object.assign({}, yp), Nve), ft.props);
var YM = oe({
  name: "Dropdown",
  inheritAttrs: !1,
  props: $ve,
  setup(e) {
    const t = G(!1), r = dn(tt(e, "show"), t), n = j(() => {
      const { keyField: R, childrenField: U } = e;
      return Mb(e.options, {
        getKey(Q) {
          return Q[R];
        },
        getDisabled(Q) {
          return Q.disabled === !0;
        },
        getIgnored(Q) {
          return Q.type === "divider" || Q.type === "render";
        },
        getChildren(Q) {
          return Q[U];
        }
      });
    }), i = j(() => n.value.treeNodes), o = G(null), a = G(null), s = G(null), u = j(() => {
      var R, U, Q;
      return (Q = (U = (R = o.value) !== null && R !== void 0 ? R : a.value) !== null && U !== void 0 ? U : s.value) !== null && Q !== void 0 ? Q : null;
    }), d = j(() => n.value.getPath(u.value).keyPath), f = j(() => n.value.getPath(e.value).keyPath), h = _r(() => e.keyboard && r.value);
    KO({
      keydown: {
        ArrowUp: {
          prevent: !0,
          handler: A
        },
        ArrowRight: {
          prevent: !0,
          handler: T
        },
        ArrowDown: {
          prevent: !0,
          handler: D
        },
        ArrowLeft: {
          prevent: !0,
          handler: S
        },
        Enter: {
          prevent: !0,
          handler: E
        },
        Escape: C
      }
    }, h);
    const { mergedClsPrefixRef: g, inlineThemeDisabled: m } = Yt(e), v = ft("Dropdown", "-dropdown", Ive, $4, e, g);
    tr(VM, {
      labelFieldRef: tt(e, "labelField"),
      childrenFieldRef: tt(e, "childrenField"),
      renderLabelRef: tt(e, "renderLabel"),
      renderIconRef: tt(e, "renderIcon"),
      hoverKeyRef: o,
      keyboardKeyRef: a,
      lastToggledSubmenuKeyRef: s,
      pendingKeyPathRef: d,
      activeKeyPathRef: f,
      animatedRef: tt(e, "animated"),
      mergedShowRef: r,
      nodePropsRef: tt(e, "nodeProps"),
      renderOptionRef: tt(e, "renderOption"),
      menuPropsRef: tt(e, "menuProps"),
      doSelect: w,
      doUpdateShow: x
    }), Gt(r, (R) => {
      !e.animated && !R && y();
    });
    function w(R, U) {
      const { onSelect: Q } = e;
      Q && je(Q, R, U);
    }
    function x(R) {
      const { "onUpdate:show": U, onUpdateShow: Q } = e;
      U && je(U, R), Q && je(Q, R), t.value = R;
    }
    function y() {
      o.value = null, a.value = null, s.value = null;
    }
    function C() {
      x(!1);
    }
    function S() {
      I("left");
    }
    function T() {
      I("right");
    }
    function A() {
      I("up");
    }
    function D() {
      I("down");
    }
    function E() {
      const R = N();
      R != null && R.isLeaf && r.value && (w(R.key, R.rawNode), x(!1));
    }
    function N() {
      var R;
      const { value: U } = n, { value: Q } = u;
      return !U || Q === null ? null : (R = U.getNode(Q)) !== null && R !== void 0 ? R : null;
    }
    function I(R) {
      const { value: U } = u, { value: { getFirstAvailableNode: Q } } = n;
      let Z = null;
      if (U === null) {
        const X = Q();
        X !== null && (Z = X.key);
      } else {
        const X = N();
        if (X) {
          let re;
          switch (R) {
            case "down":
              re = X.getNext();
              break;
            case "up":
              re = X.getPrev();
              break;
            case "right":
              re = X.getChild();
              break;
            case "left":
              re = X.getParent();
              break;
          }
          re && (Z = re.key);
        }
      }
      Z !== null && (o.value = null, a.value = Z);
    }
    const $ = j(() => {
      const { size: R, inverted: U } = e, { common: { cubicBezierEaseInOut: Q }, self: Z } = v.value, { padding: X, dividerColor: re, borderRadius: ue, optionOpacityDisabled: he, [Be("optionIconSuffixWidth", R)]: te, [Be("optionSuffixWidth", R)]: de, [Be("optionIconPrefixWidth", R)]: De, [Be("optionPrefixWidth", R)]: Oe, [Be("fontSize", R)]: Qe, [Be("optionHeight", R)]: Ae, [Be("optionIconSize", R)]: Ne } = Z, $e = {
        "--n-bezier": Q,
        "--n-font-size": Qe,
        "--n-padding": X,
        "--n-border-radius": ue,
        "--n-option-height": Ae,
        "--n-option-prefix-width": Oe,
        "--n-option-icon-prefix-width": De,
        "--n-option-suffix-width": de,
        "--n-option-icon-suffix-width": te,
        "--n-option-icon-size": Ne,
        "--n-divider-color": re,
        "--n-option-opacity-disabled": he
      };
      return U ? ($e["--n-color"] = Z.colorInverted, $e["--n-option-color-hover"] = Z.optionColorHoverInverted, $e["--n-option-color-active"] = Z.optionColorActiveInverted, $e["--n-option-text-color"] = Z.optionTextColorInverted, $e["--n-option-text-color-hover"] = Z.optionTextColorHoverInverted, $e["--n-option-text-color-active"] = Z.optionTextColorActiveInverted, $e["--n-option-text-color-child-active"] = Z.optionTextColorChildActiveInverted, $e["--n-prefix-color"] = Z.prefixColorInverted, $e["--n-suffix-color"] = Z.suffixColorInverted, $e["--n-group-header-text-color"] = Z.groupHeaderTextColorInverted) : ($e["--n-color"] = Z.color, $e["--n-option-color-hover"] = Z.optionColorHover, $e["--n-option-color-active"] = Z.optionColorActive, $e["--n-option-text-color"] = Z.optionTextColor, $e["--n-option-text-color-hover"] = Z.optionTextColorHover, $e["--n-option-text-color-active"] = Z.optionTextColorActive, $e["--n-option-text-color-child-active"] = Z.optionTextColorChildActive, $e["--n-prefix-color"] = Z.prefixColor, $e["--n-suffix-color"] = Z.suffixColor, $e["--n-group-header-text-color"] = Z.groupHeaderTextColor), $e;
    }), _ = m ? Cr("dropdown", j(() => `${e.size[0]}${e.inverted ? "i" : ""}`), $, e) : void 0;
    return {
      mergedClsPrefix: g,
      mergedTheme: v,
      tmNodes: i,
      mergedShow: r,
      handleAfterLeave: () => {
        e.animated && y();
      },
      doUpdateShow: x,
      cssVars: m ? void 0 : $,
      themeClass: _ == null ? void 0 : _.themeClass,
      onRender: _ == null ? void 0 : _.onRender
    };
  },
  render() {
    const e = (n, i, o, a, s) => {
      var u;
      const { mergedClsPrefix: d, menuProps: f } = this;
      (u = this.onRender) === null || u === void 0 || u.call(this);
      const h = (f == null ? void 0 : f(void 0, this.tmNodes.map((m) => m.rawNode))) || {}, g = {
        ref: dU(i),
        class: [n, `${d}-dropdown`, this.themeClass],
        clsPrefix: d,
        tmNodes: this.tmNodes,
        style: [o, this.cssVars],
        showArrow: this.showArrow,
        arrowStyle: this.arrowStyle,
        scrollable: this.scrollable,
        onMouseenter: a,
        onMouseleave: s
      };
      return b(oW, ir(this.$attrs, g, h));
    }, { mergedTheme: t } = this, r = {
      show: this.mergedShow,
      theme: t.peers.Popover,
      themeOverrides: t.peerOverrides.Popover,
      internalOnAfterLeave: this.handleAfterLeave,
      internalRenderBody: e,
      onUpdateShow: this.doUpdateShow,
      "onUpdate:show": void 0
    };
    return b(jc, Object.assign({}, il(this.$props, zve), r), {
      trigger: () => {
        var n, i;
        return (i = (n = this.$slots).default) === null || i === void 0 ? void 0 : i.call(n);
      }
    });
  }
});
const aW = "_n_all__", lW = "_n_none__";
function Ove(e, t, r, n) {
  return e ? (i) => {
    for (const o of e)
      switch (i) {
        case aW:
          r(!0);
          return;
        case lW:
          n(!0);
          return;
        default:
          if (typeof o == "object" && o.key === i) {
            o.onSelect(t.value);
            return;
          }
      }
  } : () => {
  };
}
function _ve(e, t) {
  return e ? e.map((r) => {
    switch (r) {
      case "all":
        return {
          label: t.checkTableAll,
          key: aW
        };
      case "none":
        return {
          label: t.uncheckTableAll,
          key: lW
        };
      default:
        return r;
    }
  }) : [];
}
var Lve = oe({
  name: "DataTableSelectionMenu",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const {
      props: t,
      localeRef: r,
      checkOptionsRef: n,
      rawPaginatedDataRef: i,
      doCheckAll: o,
      doUncheckAll: a
    } = lt(Kl), s = j(() => Ove(n.value, i, o, a)), u = j(() => _ve(n.value, r.value));
    return () => {
      var d, f, h, g;
      const { clsPrefix: m } = e;
      return b(YM, { theme: (f = (d = t.theme) === null || d === void 0 ? void 0 : d.peers) === null || f === void 0 ? void 0 : f.Dropdown, themeOverrides: (g = (h = t.themeOverrides) === null || h === void 0 ? void 0 : h.peers) === null || g === void 0 ? void 0 : g.Dropdown, options: u.value, onSelect: s.value }, {
        default: () => b(fr, { clsPrefix: m, class: `${m}-data-table-check-extra` }, {
          default: () => b(tH, null)
        })
      });
    };
  }
});
function GI(e) {
  return typeof e.title == "function" ? e.title(e) : e.title;
}
var sW = oe({
  name: "DataTableHeader",
  props: {
    discrete: {
      type: Boolean,
      default: !0
    }
  },
  setup() {
    const {
      mergedClsPrefixRef: e,
      scrollXRef: t,
      fixedColumnLeftMapRef: r,
      fixedColumnRightMapRef: n,
      mergedCurrentPageRef: i,
      allRowsCheckedRef: o,
      someRowsCheckedRef: a,
      rowsRef: s,
      colsRef: u,
      mergedThemeRef: d,
      checkOptionsRef: f,
      mergedSortStateRef: h,
      componentId: g,
      scrollPartRef: m,
      mergedTableLayoutRef: v,
      headerCheckboxDisabledRef: w,
      onUnstableColumnResize: x,
      doUpdateResizableWidth: y,
      handleTableHeaderScroll: C,
      deriveNextSorter: S,
      doUncheckAll: T,
      doCheckAll: A
    } = lt(Kl), D = G({});
    function E(Z) {
      const X = D.value[Z];
      return X == null ? void 0 : X.getBoundingClientRect().width;
    }
    function N() {
      o.value ? T() : A();
    }
    function I(Z, X) {
      if (Bl(Z, "dataTableFilter") || Bl(Z, "dataTableResizable") || !qI(X))
        return;
      const re = h.value.find((he) => he.columnKey === X.key) || null, ue = gve(X, re);
      S(ue);
    }
    function $() {
      m.value = "head";
    }
    function _() {
      m.value = "body";
    }
    const R = /* @__PURE__ */ new Map();
    function U(Z) {
      R.set(Z.key, E(Z.key));
    }
    function Q(Z, X) {
      const re = R.get(Z.key);
      if (re === void 0)
        return;
      const ue = re + X, he = fve(ue, Z.minWidth, Z.maxWidth);
      x(ue, he, Z, E), y(Z, he);
    }
    return {
      cellElsRef: D,
      componentId: g,
      mergedSortState: h,
      mergedClsPrefix: e,
      scrollX: t,
      fixedColumnLeftMap: r,
      fixedColumnRightMap: n,
      currentPage: i,
      allRowsChecked: o,
      someRowsChecked: a,
      rows: s,
      cols: u,
      mergedTheme: d,
      checkOptions: f,
      mergedTableLayout: v,
      headerCheckboxDisabled: w,
      handleMouseenter: $,
      handleMouseleave: _,
      handleCheckboxUpdateChecked: N,
      handleColHeaderClick: I,
      handleTableHeaderScroll: C,
      handleColumnResizeStart: U,
      handleColumnResize: Q
    };
  },
  render() {
    const { cellElsRef: e, mergedClsPrefix: t, fixedColumnLeftMap: r, fixedColumnRightMap: n, currentPage: i, allRowsChecked: o, someRowsChecked: a, rows: s, cols: u, mergedTheme: d, checkOptions: f, componentId: h, discrete: g, mergedTableLayout: m, headerCheckboxDisabled: v, mergedSortState: w, handleColHeaderClick: x, handleCheckboxUpdateChecked: y, handleColumnResizeStart: C, handleColumnResize: S } = this, T = b("thead", { class: `${t}-data-table-thead`, "data-n-id": h }, s.map((I) => b("tr", { class: `${t}-data-table-tr` }, I.map(({ column: $, colSpan: _, rowSpan: R, isLast: U }) => {
      var Q, Z;
      const X = Ol($), { ellipsis: re } = $, ue = () => $.type === "selection" ? $.multiple !== !1 ? b(Lr, null, b(BM, { key: i, privateInsideTable: !0, checked: o, indeterminate: a, disabled: v, onUpdateChecked: y }), f ? b(Lve, { clsPrefix: t }) : null) : null : b(Lr, null, b("div", { class: `${t}-data-table-th__title-wrapper` }, b("div", { class: `${t}-data-table-th__title` }, re === !0 || re && !re.tooltip ? b("div", { class: `${t}-data-table-th__ellipsis` }, GI($)) : re && typeof re == "object" ? b(I0, Object.assign({}, re, { theme: d.peers.Ellipsis, themeOverrides: d.peerOverrides.Ellipsis }), {
        default: () => GI($)
      }) : GI($)), qI($) ? b(nve, { column: $ }) : null), eR($) ? b(bve, { column: $, options: $.filterOptions }) : null, JH($) ? b(yve, { onResizeStart: () => {
        C($);
      }, onResize: (de) => {
        S($, de);
      } }) : null), he = X in r, te = X in n;
      return b("th", { ref: (de) => e[X] = de, key: X, style: {
        textAlign: $.titleAlign || $.align,
        left: Ko((Q = r[X]) === null || Q === void 0 ? void 0 : Q.start),
        right: Ko((Z = n[X]) === null || Z === void 0 ? void 0 : Z.start)
      }, colspan: _, rowspan: R, "data-col-key": X, class: [
        `${t}-data-table-th`,
        (he || te) && `${t}-data-table-th--fixed-${he ? "left" : "right"}`,
        {
          [`${t}-data-table-th--hover`]: eW($, w),
          [`${t}-data-table-th--filterable`]: eR($),
          [`${t}-data-table-th--sortable`]: qI($),
          [`${t}-data-table-th--selection`]: $.type === "selection",
          [`${t}-data-table-th--last`]: U
        },
        $.className
      ], onClick: $.type !== "selection" && $.type !== "expand" && !("children" in $) ? (de) => {
        x(de, $);
      } : void 0 }, ue());
    }))));
    if (!g)
      return T;
    const { handleTableHeaderScroll: A, handleMouseenter: D, handleMouseleave: E, scrollX: N } = this;
    return b("div", { class: `${t}-data-table-base-table-header`, onScroll: A, onMouseenter: D, onMouseleave: E }, b("table", { ref: "body", class: `${t}-data-table-table`, style: {
      minWidth: Rn(N),
      tableLayout: m
    } }, b("colgroup", null, u.map((I) => b("col", { key: I.key, style: I.style }))), T));
  }
}), Pve = oe({
  name: "DataTableCell",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    row: {
      type: Object,
      required: !0
    },
    index: {
      type: Number,
      required: !0
    },
    column: {
      type: Object,
      required: !0
    },
    isSummary: Boolean,
    mergedTheme: {
      type: Object,
      required: !0
    },
    renderCell: Function
  },
  render() {
    const { isSummary: e, column: t, row: r, renderCell: n } = this;
    let i;
    const { render: o, key: a, ellipsis: s } = t;
    if (o && !e ? i = o(r, this.index) : e ? i = r[a].value : i = n ? n(T0(r, a), r, t) : T0(r, a), s)
      if (typeof s == "object") {
        const { mergedTheme: u } = this;
        return b(I0, Object.assign({}, s, { theme: u.peers.Ellipsis, themeOverrides: u.peerOverrides.Ellipsis }), { default: () => i });
      } else
        return b("span", { class: `${this.clsPrefix}-data-table-td__ellipsis` }, i);
    return i;
  }
}), nR = oe({
  name: "DataTableExpandTrigger",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    expanded: Boolean,
    loading: Boolean,
    onClick: {
      type: Function,
      required: !0
    },
    renderExpandIcon: {
      type: Function
    }
  },
  render() {
    const { clsPrefix: e } = this;
    return b("div", { class: [
      `${e}-data-table-expand-trigger`,
      this.expanded && `${e}-data-table-expand-trigger--expanded`
    ], onClick: this.onClick }, b(Lc, null, {
      default: () => this.loading ? b(mh, { key: "loading", clsPrefix: this.clsPrefix, radius: 85, strokeWidth: 15, scale: 0.88 }) : this.renderExpandIcon ? this.renderExpandIcon({
        expanded: this.expanded
      }) : b(fr, { clsPrefix: e, key: "base-icon" }, {
        default: () => b(w4, null)
      })
    }));
  }
}), Rve = oe({
  name: "DataTableBodyCheckbox",
  props: {
    rowKey: {
      type: [String, Number],
      required: !0
    },
    disabled: {
      type: Boolean,
      required: !0
    },
    onUpdateChecked: {
      type: Function,
      required: !0
    }
  },
  setup(e) {
    const {
      mergedCheckedRowKeySetRef: t,
      mergedInderminateRowKeySetRef: r
    } = lt(Kl);
    return () => {
      const { rowKey: n } = e;
      return b(BM, { privateInsideTable: !0, disabled: e.disabled, indeterminate: r.value.has(n), checked: t.value.has(n), onUpdateChecked: e.onUpdateChecked });
    };
  }
}), jve = oe({
  name: "DataTableBodyRadio",
  props: {
    rowKey: {
      type: [String, Number],
      required: !0
    },
    disabled: {
      type: Boolean,
      required: !0
    },
    onUpdateChecked: {
      type: Function,
      required: !0
    }
  },
  setup(e) {
    const {
      mergedCheckedRowKeySetRef: t,
      componentId: r
    } = lt(Kl);
    return () => {
      const { rowKey: n } = e;
      return b(WM, { name: r, disabled: e.disabled, checked: t.value.has(n), onUpdateChecked: e.onUpdateChecked });
    };
  }
});
function Fve(e, t) {
  const r = [];
  function n(i, o) {
    i.forEach((a) => {
      a.children && t.has(a.key) ? (r.push({
        tmNode: a,
        striped: !1,
        key: a.key,
        index: o
      }), n(a.children, o)) : r.push({
        key: a.key,
        tmNode: a,
        striped: !1,
        index: o
      });
    });
  }
  return e.forEach((i) => {
    r.push(i);
    const { children: o } = i.tmNode;
    o && t.has(i.key) && n(o, i.index);
  }), r;
}
const Bve = oe({
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    id: {
      type: String,
      required: !0
    },
    cols: {
      type: Array,
      required: !0
    },
    onMouseenter: Function,
    onMouseleave: Function
  },
  render() {
    const { clsPrefix: e, id: t, cols: r, onMouseenter: n, onMouseleave: i } = this;
    return b("table", { style: { tableLayout: "fixed" }, class: `${e}-data-table-table`, onMouseenter: n, onMouseleave: i }, b("colgroup", null, r.map((o) => b("col", { key: o.key, style: o.style }))), b("tbody", { "data-n-id": t, class: `${e}-data-table-tbody` }, this.$slots));
  }
});
var Uve = oe({
  name: "DataTableBody",
  props: {
    onResize: Function,
    showHeader: Boolean,
    flexHeight: Boolean,
    bodyStyle: Object
  },
  setup(e) {
    const {
      slots: t,
      bodyWidthRef: r,
      mergedExpandedRowKeysRef: n,
      mergedClsPrefixRef: i,
      mergedThemeRef: o,
      scrollXRef: a,
      colsRef: s,
      paginatedDataRef: u,
      rawPaginatedDataRef: d,
      fixedColumnLeftMapRef: f,
      fixedColumnRightMapRef: h,
      mergedCurrentPageRef: g,
      rowClassNameRef: m,
      leftActiveFixedColKeyRef: v,
      leftActiveFixedChildrenColKeysRef: w,
      rightActiveFixedColKeyRef: x,
      rightActiveFixedChildrenColKeysRef: y,
      renderExpandRef: C,
      hoverKeyRef: S,
      summaryRef: T,
      mergedSortStateRef: A,
      virtualScrollRef: D,
      componentId: E,
      scrollPartRef: N,
      mergedTableLayoutRef: I,
      childTriggerColIndexRef: $,
      indentRef: _,
      rowPropsRef: R,
      maxHeightRef: U,
      stripedRef: Q,
      loadingRef: Z,
      onLoadRef: X,
      loadingKeySetRef: re,
      expandableRef: ue,
      stickyExpandedRowsRef: he,
      renderExpandIconRef: te,
      summaryPlacementRef: de,
      treeMateRef: De,
      scrollbarPropsRef: Oe,
      setHeaderScrollLeft: Qe,
      doUpdateExpandedRowKeys: Ae,
      handleTableBodyScroll: Ne,
      doCheck: $e,
      doUncheck: et,
      renderCell: Ge
    } = lt(Kl), Ee = G(null), qe = G(null), Ue = G(null), ot = _r(() => u.value.length === 0), Ie = _r(() => e.showHeader || !ot.value), rt = _r(() => e.showHeader || ot.value);
    let W = "";
    const P = j(() => new Set(n.value));
    function H(at) {
      var St;
      return (St = De.value.getNode(at)) === null || St === void 0 ? void 0 : St.rawNode;
    }
    function se(at, St, ve) {
      const We = H(at.key);
      if (!We) {
        ja("data-table", `fail to get row data with key ${at.key}`);
        return;
      }
      if (ve) {
        const ne = u.value.findIndex((Se) => Se.key === W);
        if (ne !== -1) {
          const Se = u.value.findIndex((ye) => ye.key === at.key), _e = Math.min(ne, Se), ut = Math.max(ne, Se), ht = [];
          u.value.slice(_e, ut + 1).forEach((ye) => {
            ye.disabled || ht.push(ye.key);
          }), St ? $e(ht, !1, We) : et(ht, We), W = at.key;
          return;
        }
      }
      St ? $e(at.key, !1, We) : et(at.key, We), W = at.key;
    }
    function pe(at) {
      const St = H(at.key);
      if (!St) {
        ja("data-table", `fail to get row data with key ${at.key}`);
        return;
      }
      $e(at.key, !0, St);
    }
    function ae() {
      if (!Ie.value) {
        const { value: St } = Ue;
        return St || null;
      }
      if (D.value)
        return Le();
      const { value: at } = Ee;
      return at ? at.containerRef : null;
    }
    function Me(at, St) {
      var ve;
      if (re.value.has(at))
        return;
      const { value: We } = n, ne = We.indexOf(at), Se = Array.from(We);
      ~ne ? (Se.splice(ne, 1), Ae(Se)) : St && !St.isLeaf && !St.shallowLoaded ? (re.value.add(at), (ve = X.value) === null || ve === void 0 || ve.call(X, St.rawNode).then(() => {
        const { value: _e } = n, ut = Array.from(_e);
        ~ut.indexOf(at) || ut.push(at), Ae(ut);
      }).finally(() => {
        re.value.delete(at);
      })) : (Se.push(at), Ae(Se));
    }
    function fe() {
      S.value = null;
    }
    function ke() {
      N.value = "body";
    }
    function Le() {
      const { value: at } = qe;
      return at == null ? void 0 : at.listElRef;
    }
    function dt() {
      const { value: at } = qe;
      return at == null ? void 0 : at.itemsElRef;
    }
    function Mt(at) {
      var St;
      Ne(at), (St = Ee.value) === null || St === void 0 || St.sync();
    }
    function Ct(at) {
      var St;
      const { onResize: ve } = e;
      ve && ve(at), (St = Ee.value) === null || St === void 0 || St.sync();
    }
    const er = {
      getScrollContainer: ae,
      scrollTo(at, St) {
        var ve, We;
        D.value ? (ve = qe.value) === null || ve === void 0 || ve.scrollTo(at, St) : (We = Ee.value) === null || We === void 0 || We.scrollTo(at, St);
      }
    }, Vt = Y([
      ({ props: at }) => {
        const St = (We) => We === null ? null : Y(`[data-n-id="${at.componentId}"] [data-col-key="${We}"]::after`, { boxShadow: "var(--n-box-shadow-after)" }), ve = (We) => We === null ? null : Y(`[data-n-id="${at.componentId}"] [data-col-key="${We}"]::before`, { boxShadow: "var(--n-box-shadow-before)" });
        return Y([
          St(at.leftActiveFixedColKey),
          ve(at.rightActiveFixedColKey),
          at.leftActiveFixedChildrenColKeys.map((We) => St(We)),
          at.rightActiveFixedChildrenColKeys.map((We) => ve(We))
        ]);
      }
    ]);
    let jt = !1;
    return On(() => {
      const { value: at } = v, { value: St } = w, { value: ve } = x, { value: We } = y;
      if (!jt && at === null && ve === null)
        return;
      const ne = {
        leftActiveFixedColKey: at,
        leftActiveFixedChildrenColKeys: St,
        rightActiveFixedColKey: ve,
        rightActiveFixedChildrenColKeys: We,
        componentId: E
      };
      Vt.mount({
        id: `n-${E}`,
        force: !0,
        props: ne,
        anchorMetaName: gp
      }), jt = !0;
    }), FO(() => {
      Vt.unmount({
        id: `n-${E}`
      });
    }), Object.assign({
      bodyWidth: r,
      summaryPlacement: de,
      dataTableSlots: t,
      componentId: E,
      scrollbarInstRef: Ee,
      virtualListRef: qe,
      emptyElRef: Ue,
      summary: T,
      mergedClsPrefix: i,
      mergedTheme: o,
      scrollX: a,
      cols: s,
      loading: Z,
      bodyShowHeaderOnly: rt,
      shouldDisplaySomeTablePart: Ie,
      empty: ot,
      paginatedDataAndInfo: j(() => {
        const { value: at } = Q;
        let St = !1;
        return {
          data: u.value.map(at ? (We, ne) => (We.isLeaf || (St = !0), {
            tmNode: We,
            key: We.key,
            striped: ne % 2 === 1,
            index: ne
          }) : (We, ne) => (We.isLeaf || (St = !0), {
            tmNode: We,
            key: We.key,
            striped: !1,
            index: ne
          })),
          hasChildren: St
        };
      }),
      rawPaginatedData: d,
      fixedColumnLeftMap: f,
      fixedColumnRightMap: h,
      currentPage: g,
      rowClassName: m,
      renderExpand: C,
      mergedExpandedRowKeySet: P,
      hoverKey: S,
      mergedSortState: A,
      virtualScroll: D,
      mergedTableLayout: I,
      childTriggerColIndex: $,
      indent: _,
      rowProps: R,
      maxHeight: U,
      loadingKeySet: re,
      expandable: ue,
      stickyExpandedRows: he,
      renderExpandIcon: te,
      scrollbarProps: Oe,
      setHeaderScrollLeft: Qe,
      handleMouseenterTable: ke,
      handleVirtualListScroll: Mt,
      handleVirtualListResize: Ct,
      handleMouseleaveTable: fe,
      virtualListContainer: Le,
      virtualListContent: dt,
      handleTableBodyScroll: Ne,
      handleCheckboxUpdateChecked: se,
      handleRadioUpdateChecked: pe,
      handleUpdateExpanded: Me,
      renderCell: Ge
    }, er);
  },
  render() {
    const { mergedTheme: e, scrollX: t, mergedClsPrefix: r, virtualScroll: n, maxHeight: i, mergedTableLayout: o, flexHeight: a, loadingKeySet: s, onResize: u, setHeaderScrollLeft: d } = this, f = t !== void 0 || i !== void 0 || a, h = !f && o === "auto", g = t !== void 0 || h, m = {
      minWidth: Rn(t) || "100%"
    };
    t && (m.width = "100%");
    const v = b(no, Object.assign({}, this.scrollbarProps, { ref: "scrollbarInstRef", scrollable: f || h, class: `${r}-data-table-base-table-body`, style: this.bodyStyle, theme: e.peers.Scrollbar, themeOverrides: e.peerOverrides.Scrollbar, contentStyle: m, container: n ? this.virtualListContainer : void 0, content: n ? this.virtualListContent : void 0, horizontalRailStyle: { zIndex: 3 }, verticalRailStyle: { zIndex: 3 }, xScrollable: g, onScroll: n ? void 0 : this.handleTableBodyScroll, internalOnUpdateScrollLeft: d, onResize: u }), {
      default: () => {
        const w = {}, x = {}, { cols: y, paginatedDataAndInfo: C, mergedTheme: S, fixedColumnLeftMap: T, fixedColumnRightMap: A, currentPage: D, rowClassName: E, mergedSortState: N, mergedExpandedRowKeySet: I, stickyExpandedRows: $, componentId: _, childTriggerColIndex: R, expandable: U, rowProps: Q, handleMouseenterTable: Z, handleMouseleaveTable: X, renderExpand: re, summary: ue, handleCheckboxUpdateChecked: he, handleRadioUpdateChecked: te, handleUpdateExpanded: de } = this, { length: De } = y;
        let Oe;
        const { data: Qe, hasChildren: Ae } = C, Ne = Ae ? Fve(Qe, I) : Qe;
        if (ue) {
          const Ie = ue(this.rawPaginatedData);
          if (Array.isArray(Ie)) {
            const rt = Ie.map((W, P) => ({
              isSummaryRow: !0,
              key: `__n_summary__${P}`,
              tmNode: {
                rawNode: W,
                disabled: !0
              },
              index: -1
            }));
            Oe = this.summaryPlacement === "top" ? [...rt, ...Ne] : [...Ne, ...rt];
          } else {
            const rt = {
              isSummaryRow: !0,
              key: "__n_summary__",
              tmNode: {
                rawNode: Ie,
                disabled: !0
              },
              index: -1
            };
            Oe = this.summaryPlacement === "top" ? [rt, ...Ne] : [...Ne, rt];
          }
        } else
          Oe = Ne;
        const $e = Ae ? { width: Ko(this.indent) } : void 0, et = [];
        Oe.forEach((Ie) => {
          re && I.has(Ie.key) && (!U || U(Ie.tmNode.rawNode)) ? et.push(Ie, {
            isExpandedRow: !0,
            key: `${Ie.key}-expand`,
            tmNode: Ie.tmNode,
            index: Ie.index
          }) : et.push(Ie);
        });
        const { length: Ge } = et, Ee = {};
        Qe.forEach(({ tmNode: Ie }, rt) => {
          Ee[rt] = Ie.key;
        });
        const qe = $ ? this.bodyWidth : null, Ue = qe === null ? void 0 : `${qe}px`, ot = (Ie, rt, W) => {
          const { index: P } = Ie;
          if ("isExpandedRow" in Ie) {
            const { tmNode: { key: Mt, rawNode: Ct } } = Ie;
            return b("tr", { class: `${r}-data-table-tr`, key: `${Mt}__expand` }, b("td", { class: [
              `${r}-data-table-td`,
              `${r}-data-table-td--last-col`,
              rt + 1 === Ge && `${r}-data-table-td--last-row`
            ], colspan: De }, $ ? b("div", { class: `${r}-data-table-expand`, style: {
              width: Ue
            } }, re(Ct, P)) : re(Ct, P)));
          }
          const H = "isSummaryRow" in Ie, se = !H && Ie.striped, { tmNode: pe, key: ae } = Ie, { rawNode: Me } = pe, fe = I.has(ae), ke = Q ? Q(Me, P) : void 0, Le = typeof E == "string" ? E : pve(Me, P, E);
          return b("tr", Object.assign({ onMouseenter: () => {
            this.hoverKey = ae;
          }, key: ae, class: [
            `${r}-data-table-tr`,
            H && `${r}-data-table-tr--summary`,
            se && `${r}-data-table-tr--striped`,
            Le
          ] }, ke), y.map((Mt, Ct) => {
            var er, Vt, jt, at, St;
            if (rt in w) {
              const Ke = w[rt], xe = Ke.indexOf(Ct);
              if (~xe)
                return Ke.splice(xe, 1), null;
            }
            const { column: ve } = Mt, We = Ol(Mt), { rowSpan: ne, colSpan: Se } = ve, _e = H ? ((er = Ie.tmNode.rawNode[We]) === null || er === void 0 ? void 0 : er.colSpan) || 1 : Se ? Se(Me, P) : 1, ut = H ? ((Vt = Ie.tmNode.rawNode[We]) === null || Vt === void 0 ? void 0 : Vt.rowSpan) || 1 : ne ? ne(Me, P) : 1, ht = Ct + _e === De, ye = rt + ut === Ge, Ze = ut > 1;
            if (Ze && (x[rt] = {
              [Ct]: []
            }), _e > 1 || Ze)
              for (let Ke = rt; Ke < rt + ut; ++Ke) {
                Ze && x[rt][Ct].push(Ee[Ke]);
                for (let xe = Ct; xe < Ct + _e; ++xe)
                  Ke === rt && xe === Ct || (Ke in w ? w[Ke].push(xe) : w[Ke] = [xe]);
              }
            const st = Ze ? this.hoverKey : null, { cellProps: Nt } = ve, Te = Nt == null ? void 0 : Nt(Me, P);
            return b("td", Object.assign({}, Te, { key: We, style: [
              {
                textAlign: ve.align || void 0,
                left: Ko((jt = T[We]) === null || jt === void 0 ? void 0 : jt.start),
                right: Ko((at = A[We]) === null || at === void 0 ? void 0 : at.start)
              },
              (Te == null ? void 0 : Te.style) || ""
            ], colspan: _e, rowspan: W ? void 0 : ut, "data-col-key": We, class: [
              `${r}-data-table-td`,
              ve.className,
              Te == null ? void 0 : Te.class,
              H && `${r}-data-table-td--summary`,
              (st !== null && x[rt][Ct].includes(st) || eW(ve, N)) && `${r}-data-table-td--hover`,
              ve.fixed && `${r}-data-table-td--fixed-${ve.fixed}`,
              ve.align && `${r}-data-table-td--${ve.align}-align`,
              ve.type === "selection" && `${r}-data-table-td--selection`,
              ve.type === "expand" && `${r}-data-table-td--expand`,
              ht && `${r}-data-table-td--last-col`,
              ye && `${r}-data-table-td--last-row`
            ] }), Ae && Ct === R ? [
              PK(H ? 0 : Ie.tmNode.level, b("div", { class: `${r}-data-table-indent`, style: $e })),
              H || Ie.tmNode.isLeaf ? b("div", { class: `${r}-data-table-expand-placeholder` }) : b(nR, { class: `${r}-data-table-expand-trigger`, clsPrefix: r, expanded: fe, renderExpandIcon: this.renderExpandIcon, loading: s.has(Ie.key), onClick: () => {
                de(ae, Ie.tmNode);
              } })
            ] : null, ve.type === "selection" ? H ? null : ve.multiple === !1 ? b(jve, { key: D, rowKey: ae, disabled: Ie.tmNode.disabled, onUpdateChecked: () => {
              te(Ie.tmNode);
            } }) : b(Rve, { key: D, rowKey: ae, disabled: Ie.tmNode.disabled, onUpdateChecked: (Ke, xe) => {
              he(Ie.tmNode, Ke, xe.shiftKey);
            } }) : ve.type === "expand" ? H ? null : !ve.expandable || !((St = ve.expandable) === null || St === void 0) && St.call(ve, Me) ? b(nR, { clsPrefix: r, expanded: fe, renderExpandIcon: this.renderExpandIcon, onClick: () => {
              de(ae, null);
            } }) : null : b(Pve, { clsPrefix: r, index: P, row: Me, column: ve, isSummary: H, mergedTheme: S, renderCell: this.renderCell }));
          }));
        };
        return n ? b(M0, { ref: "virtualListRef", items: et, itemSize: 28, visibleItemsTag: Bve, visibleItemsProps: {
          clsPrefix: r,
          id: _,
          cols: y,
          onMouseenter: Z,
          onMouseleave: X
        }, showScrollbar: !1, onResize: this.handleVirtualListResize, onScroll: this.handleVirtualListScroll, itemsStyle: m, itemResizable: !0 }, {
          default: ({ item: Ie, index: rt }) => ot(Ie, rt, !0)
        }) : b("table", { class: `${r}-data-table-table`, onMouseleave: X, onMouseenter: Z, style: {
          tableLayout: this.mergedTableLayout
        } }, b("colgroup", null, y.map((Ie) => b("col", { key: Ie.key, style: Ie.style }))), this.showHeader ? b(sW, { discrete: !1 }) : null, this.empty ? null : b("tbody", { "data-n-id": _, class: `${r}-data-table-tbody` }, et.map((Ie, rt) => ot(Ie, rt, !1))));
      }
    });
    if (this.empty) {
      const w = () => b("div", { class: [
        `${r}-data-table-empty`,
        this.loading && `${r}-data-table-empty--hide`
      ], style: this.bodyStyle, ref: "emptyElRef" }, vr(this.dataTableSlots.empty, () => [
        b(oH, { theme: this.mergedTheme.peers.Empty, themeOverrides: this.mergedTheme.peerOverrides.Empty })
      ]));
      return this.shouldDisplaySomeTablePart ? b(Lr, null, v, w()) : b(Hl, { onResize: this.onResize }, { default: w });
    }
    return v;
  }
}), Hve = oe({
  setup() {
    const {
      mergedClsPrefixRef: e,
      rightFixedColumnsRef: t,
      leftFixedColumnsRef: r,
      bodyWidthRef: n,
      maxHeightRef: i,
      minHeightRef: o,
      flexHeightRef: a,
      syncScrollState: s
    } = lt(Kl), u = G(null), d = G(null), f = G(null), h = G(!(r.value.length || t.value.length)), g = j(() => ({
      maxHeight: Rn(i.value),
      minHeight: Rn(o.value)
    }));
    function m(y) {
      n.value = y.contentRect.width, s(), h.value || (h.value = !0);
    }
    function v() {
      const { value: y } = u;
      return y ? y.$el : null;
    }
    function w() {
      const { value: y } = d;
      return y ? y.getScrollContainer() : null;
    }
    const x = {
      getBodyElement: w,
      getHeaderElement: v,
      scrollTo(y, C) {
        var S;
        (S = d.value) === null || S === void 0 || S.scrollTo(y, C);
      }
    };
    return On(() => {
      const { value: y } = f;
      if (!y)
        return;
      const C = `${e.value}-data-table-base-table--transition-disabled`;
      h.value ? setTimeout(() => {
        y.classList.remove(C);
      }, 0) : y.classList.add(C);
    }), Object.assign({
      maxHeight: i,
      mergedClsPrefix: e,
      selfElRef: f,
      headerInstRef: u,
      bodyInstRef: d,
      bodyStyle: g,
      flexHeight: a,
      handleBodyResize: m
    }, x);
  },
  render() {
    const { mergedClsPrefix: e, maxHeight: t, flexHeight: r } = this, n = t === void 0 && !r;
    return b("div", { class: `${e}-data-table-base-table`, ref: "selfElRef" }, n ? null : b(sW, { ref: "headerInstRef" }), b(Uve, { ref: "bodyInstRef", bodyStyle: this.bodyStyle, showHeader: n, flexHeight: r, onResize: this.handleBodyResize }));
  }
});
function Wve(e, t) {
  const { paginatedDataRef: r, treeMateRef: n, selectionColumnRef: i } = t, o = G(e.defaultCheckedRowKeys), a = j(() => {
    var A;
    const { checkedRowKeys: D } = e, E = D === void 0 ? o.value : D;
    return ((A = i.value) === null || A === void 0 ? void 0 : A.multiple) === !1 ? {
      checkedKeys: E.slice(0, 1),
      indeterminateKeys: []
    } : n.value.getCheckedKeys(E, {
      cascade: e.cascade,
      allowNotLoaded: e.allowCheckingNotLoaded
    });
  }), s = j(() => a.value.checkedKeys), u = j(() => a.value.indeterminateKeys), d = j(() => new Set(s.value)), f = j(() => new Set(u.value)), h = j(() => {
    const { value: A } = d;
    return r.value.reduce((D, E) => {
      const { key: N, disabled: I } = E;
      return D + (!I && A.has(N) ? 1 : 0);
    }, 0);
  }), g = j(() => r.value.filter((A) => A.disabled).length), m = j(() => {
    const { length: A } = r.value, { value: D } = f;
    return h.value > 0 && h.value < A - g.value || r.value.some((E) => D.has(E.key));
  }), v = j(() => {
    const { length: A } = r.value;
    return h.value !== 0 && h.value === A - g.value;
  }), w = j(() => r.value.length === 0);
  function x(A, D, E) {
    const { "onUpdate:checkedRowKeys": N, onUpdateCheckedRowKeys: I, onCheckedRowKeysChange: $ } = e, _ = [], { value: { getNode: R } } = n;
    A.forEach((U) => {
      var Q;
      const Z = (Q = R(U)) === null || Q === void 0 ? void 0 : Q.rawNode;
      _.push(Z);
    }), N && je(N, A, _, { row: D, action: E }), I && je(I, A, _, { row: D, action: E }), $ && je($, A, _, { row: D, action: E }), o.value = A;
  }
  function y(A, D = !1, E) {
    if (!e.loading) {
      if (D) {
        x(Array.isArray(A) ? A.slice(0, 1) : [A], E, "check");
        return;
      }
      x(n.value.check(A, s.value, {
        cascade: e.cascade,
        allowNotLoaded: e.allowCheckingNotLoaded
      }).checkedKeys, E, "check");
    }
  }
  function C(A, D) {
    e.loading || x(n.value.uncheck(A, s.value, {
      cascade: e.cascade,
      allowNotLoaded: e.allowCheckingNotLoaded
    }).checkedKeys, D, "uncheck");
  }
  function S(A = !1) {
    const { value: D } = i;
    if (!D || e.loading)
      return;
    const E = [];
    (A ? n.value.treeNodes : r.value).forEach((N) => {
      N.disabled || E.push(N.key);
    }), x(n.value.check(E, s.value, {
      cascade: !0,
      allowNotLoaded: e.allowCheckingNotLoaded
    }).checkedKeys, void 0, "checkAll");
  }
  function T(A = !1) {
    const { value: D } = i;
    if (!D || e.loading)
      return;
    const E = [];
    (A ? n.value.treeNodes : r.value).forEach((N) => {
      N.disabled || E.push(N.key);
    }), x(n.value.uncheck(E, s.value, {
      cascade: !0,
      allowNotLoaded: e.allowCheckingNotLoaded
    }).checkedKeys, void 0, "uncheckAll");
  }
  return {
    mergedCheckedRowKeySetRef: d,
    mergedCheckedRowKeysRef: s,
    mergedInderminateRowKeySetRef: f,
    someRowsCheckedRef: m,
    allRowsCheckedRef: v,
    headerCheckboxDisabledRef: w,
    doUpdateCheckedRowKeys: x,
    doCheckAll: S,
    doUncheckAll: T,
    doCheck: y,
    doUncheck: C
  };
}
function dy(e) {
  return typeof e == "object" && typeof e.multiple == "number" ? e.multiple : !1;
}
function Vve(e, t) {
  return t && (e === void 0 || e === "default" || typeof e == "object" && e.compare === "default") ? Yve(t) : typeof e == "function" ? e : e && typeof e == "object" && e.compare && e.compare !== "default" ? e.compare : !1;
}
function Yve(e) {
  return (t, r) => {
    const n = t[e], i = r[e];
    return typeof n == "number" && typeof i == "number" ? n - i : typeof n == "string" && typeof i == "string" ? n.localeCompare(i) : 0;
  };
}
function Qve(e, { dataRelatedColsRef: t, filteredDataRef: r }) {
  const n = [];
  t.value.forEach((m) => {
    var v;
    m.sorter !== void 0 && g(n, {
      columnKey: m.key,
      sorter: m.sorter,
      order: (v = m.defaultSortOrder) !== null && v !== void 0 ? v : !1
    });
  });
  const i = G(n), o = j(() => {
    const m = t.value.filter((x) => x.type !== "selection" && x.sorter !== void 0 && (x.sortOrder === "ascend" || x.sortOrder === "descend" || x.sortOrder === !1)), v = m.filter((x) => x.sortOrder !== !1);
    if (v.length)
      return v.map((x) => ({
        columnKey: x.key,
        order: x.sortOrder,
        sorter: x.sorter
      }));
    if (m.length)
      return [];
    const { value: w } = i;
    return Array.isArray(w) ? w : w ? [w] : [];
  }), a = j(() => {
    const m = o.value.slice().sort((v, w) => {
      const x = dy(v.sorter) || 0;
      return (dy(w.sorter) || 0) - x;
    });
    return m.length ? r.value.slice().sort((w, x) => {
      let y = 0;
      return m.some((C) => {
        const { columnKey: S, sorter: T, order: A } = C, D = Vve(T, S);
        return D && A && (y = D(w.rawNode, x.rawNode), y !== 0) ? (y = y * dve(A), !0) : !1;
      }), y;
    }) : r.value;
  });
  function s(m) {
    let v = o.value.slice();
    return m && dy(m.sorter) !== !1 ? (v = v.filter((w) => dy(w.sorter) !== !1), g(v, m), v) : m || null;
  }
  function u(m) {
    const v = s(m);
    d(v);
  }
  function d(m) {
    const { "onUpdate:sorter": v, onUpdateSorter: w, onSorterChange: x } = e;
    v && je(v, m), w && je(w, m), x && je(x, m), i.value = m;
  }
  function f(m, v = "ascend") {
    if (!m)
      h();
    else {
      const w = t.value.find((y) => y.type !== "selection" && y.type !== "expand" && y.key === m);
      if (!(w != null && w.sorter))
        return;
      const x = w.sorter;
      u({
        columnKey: m,
        sorter: x,
        order: v
      });
    }
  }
  function h() {
    d(null);
  }
  function g(m, v) {
    const w = m.findIndex((x) => (v == null ? void 0 : v.columnKey) && x.columnKey === v.columnKey);
    w !== void 0 && w >= 0 ? m[w] = v : m.push(v);
  }
  return {
    clearSorter: h,
    sort: f,
    sortedDataRef: a,
    mergedSortStateRef: o,
    deriveNextSorter: u
  };
}
function qve(e, { dataRelatedColsRef: t }) {
  const r = j(() => {
    const te = (de) => {
      for (let De = 0; De < de.length; ++De) {
        const Oe = de[De];
        if ("children" in Oe)
          return te(Oe.children);
        if (Oe.type === "selection")
          return Oe;
      }
      return null;
    };
    return te(e.columns);
  }), n = j(() => {
    const { childrenKey: te } = e;
    return Mb(e.data, {
      ignoreEmptyChildren: !0,
      getKey: e.rowKey,
      getChildren: (de) => de[te],
      getDisabled: (de) => {
        var De, Oe;
        return !!(!((Oe = (De = r.value) === null || De === void 0 ? void 0 : De.disabled) === null || Oe === void 0) && Oe.call(De, de));
      }
    });
  }), i = _r(() => {
    const { columns: te } = e, { length: de } = te;
    let De = null;
    for (let Oe = 0; Oe < de; ++Oe) {
      const Qe = te[Oe];
      if (!Qe.type && De === null && (De = Oe), "tree" in Qe && Qe.tree)
        return Oe;
    }
    return De || 0;
  }), o = G({}), a = G(1), s = G(10), u = j(() => {
    const te = t.value.filter((Oe) => Oe.filterOptionValues !== void 0 || Oe.filterOptionValue !== void 0), de = {};
    return te.forEach((Oe) => {
      var Qe;
      Oe.type === "selection" || Oe.type === "expand" || (Oe.filterOptionValues === void 0 ? de[Oe.key] = (Qe = Oe.filterOptionValue) !== null && Qe !== void 0 ? Qe : null : de[Oe.key] = Oe.filterOptionValues);
    }), Object.assign(JP(o.value), de);
  }), d = j(() => {
    const te = u.value, { columns: de } = e;
    function De(Ae) {
      return (Ne, $e) => !!~String($e[Ae]).indexOf(String(Ne));
    }
    const { value: { treeNodes: Oe } } = n, Qe = [];
    return de.forEach((Ae) => {
      Ae.type === "selection" || Ae.type === "expand" || "children" in Ae || Qe.push([Ae.key, Ae]);
    }), Oe ? Oe.filter((Ae) => {
      const { rawNode: Ne } = Ae;
      for (const [$e, et] of Qe) {
        let Ge = te[$e];
        if (Ge == null || (Array.isArray(Ge) || (Ge = [Ge]), !Ge.length))
          continue;
        const Ee = et.filter === "default" ? De($e) : et.filter;
        if (et && typeof Ee == "function")
          if (et.filterMode === "and") {
            if (Ge.some((qe) => !Ee(qe, Ne)))
              return !1;
          } else {
            if (Ge.some((qe) => Ee(qe, Ne)))
              continue;
            return !1;
          }
      }
      return !0;
    }) : [];
  }), { sortedDataRef: f, deriveNextSorter: h, mergedSortStateRef: g, sort: m, clearSorter: v } = Qve(e, {
    dataRelatedColsRef: t,
    filteredDataRef: d
  });
  t.value.forEach((te) => {
    var de;
    if (te.filter) {
      const De = te.defaultFilterOptionValues;
      te.filterMultiple ? o.value[te.key] = De || [] : De !== void 0 ? o.value[te.key] = De === null ? [] : De : o.value[te.key] = (de = te.defaultFilterOptionValue) !== null && de !== void 0 ? de : null;
    }
  });
  const w = j(() => {
    const { pagination: te } = e;
    if (te !== !1)
      return te.page;
  }), x = j(() => {
    const { pagination: te } = e;
    if (te !== !1)
      return te.pageSize;
  }), y = dn(w, a), C = dn(x, s), S = _r(() => {
    const te = y.value;
    return e.remote ? te : Math.max(1, Math.min(Math.ceil(d.value.length / C.value), te));
  }), T = j(() => {
    const { pagination: te } = e;
    if (te) {
      const { pageCount: de } = te;
      if (de !== void 0)
        return de;
    }
  }), A = j(() => {
    if (e.remote)
      return n.value.treeNodes;
    if (!e.pagination)
      return f.value;
    const te = C.value, de = (S.value - 1) * te;
    return f.value.slice(de, de + te);
  }), D = j(() => A.value.map((te) => te.rawNode));
  function E(te) {
    const { pagination: de } = e;
    if (de) {
      const { onChange: De, "onUpdate:page": Oe, onUpdatePage: Qe } = de;
      De && je(De, te), Qe && je(Qe, te), Oe && je(Oe, te), _(te);
    }
  }
  function N(te) {
    const { pagination: de } = e;
    if (de) {
      const { onPageSizeChange: De, "onUpdate:pageSize": Oe, onUpdatePageSize: Qe } = de;
      De && je(De, te), Qe && je(Qe, te), Oe && je(Oe, te), R(te);
    }
  }
  const I = j(() => {
    if (e.remote) {
      const { pagination: te } = e;
      if (te) {
        const { itemCount: de } = te;
        if (de !== void 0)
          return de;
      }
      return;
    }
    return d.value.length;
  }), $ = j(() => Object.assign(Object.assign({}, e.pagination), {
    onChange: void 0,
    onUpdatePage: void 0,
    onUpdatePageSize: void 0,
    onPageSizeChange: void 0,
    "onUpdate:page": E,
    "onUpdate:pageSize": N,
    page: S.value,
    pageSize: C.value,
    pageCount: I.value === void 0 ? T.value : void 0,
    itemCount: I.value
  }));
  function _(te) {
    const { "onUpdate:page": de, onPageChange: De, onUpdatePage: Oe } = e;
    Oe && je(Oe, te), de && je(de, te), De && je(De, te), a.value = te;
  }
  function R(te) {
    const { "onUpdate:pageSize": de, onPageSizeChange: De, onUpdatePageSize: Oe } = e;
    De && je(De, te), Oe && je(Oe, te), de && je(de, te), s.value = te;
  }
  function U(te, de) {
    const { onUpdateFilters: De, "onUpdate:filters": Oe, onFiltersChange: Qe } = e;
    De && je(De, te, de), Oe && je(Oe, te, de), Qe && je(Qe, te, de), o.value = te;
  }
  function Q(te, de, De, Oe) {
    var Qe;
    (Qe = e.onUnstableColumnResize) === null || Qe === void 0 || Qe.call(e, te, de, De, Oe);
  }
  function Z(te) {
    _(te);
  }
  function X() {
    re();
  }
  function re() {
    ue({});
  }
  function ue(te) {
    he(te);
  }
  function he(te) {
    te ? te && (o.value = JP(te)) : o.value = {};
  }
  return {
    treeMateRef: n,
    mergedCurrentPageRef: S,
    mergedPaginationRef: $,
    paginatedDataRef: A,
    rawPaginatedDataRef: D,
    mergedFilterStateRef: u,
    mergedSortStateRef: g,
    hoverKeyRef: G(null),
    selectionColumnRef: r,
    childTriggerColIndexRef: i,
    doUpdateFilters: U,
    deriveNextSorter: h,
    doUpdatePageSize: R,
    doUpdatePage: _,
    onUnstableColumnResize: Q,
    filter: he,
    filters: ue,
    clearFilter: X,
    clearFilters: re,
    clearSorter: v,
    page: Z,
    sort: m
  };
}
function Gve(e, { mainTableInstRef: t, mergedCurrentPageRef: r, bodyWidthRef: n, scrollPartRef: i }) {
  let o = 0;
  const a = G(null), s = G([]), u = G(null), d = G([]), f = j(() => Rn(e.scrollX)), h = j(() => e.columns.filter((I) => I.fixed === "left")), g = j(() => e.columns.filter((I) => I.fixed === "right")), m = j(() => {
    const I = {};
    let $ = 0;
    function _(R) {
      R.forEach((U) => {
        const Q = { start: $, end: 0 };
        I[Ol(U)] = Q, "children" in U ? (_(U.children), Q.end = $) : ($ += XP(U) || 0, Q.end = $);
      });
    }
    return _(h.value), I;
  }), v = j(() => {
    const I = {};
    let $ = 0;
    function _(R) {
      for (let U = R.length - 1; U >= 0; --U) {
        const Q = R[U], Z = { start: $, end: 0 };
        I[Ol(Q)] = Z, "children" in Q ? (_(Q.children), Z.end = $) : ($ += XP(Q) || 0, Z.end = $);
      }
    }
    return _(g.value), I;
  });
  function w() {
    var I, $;
    const { value: _ } = h;
    let R = 0;
    const { value: U } = m;
    let Q = null;
    for (let Z = 0; Z < _.length; ++Z) {
      const X = Ol(_[Z]);
      if (o > (((I = U[X]) === null || I === void 0 ? void 0 : I.start) || 0) - R)
        Q = X, R = (($ = U[X]) === null || $ === void 0 ? void 0 : $.end) || 0;
      else
        break;
    }
    a.value = Q;
  }
  function x() {
    s.value = [];
    let I = e.columns.find(($) => Ol($) === a.value);
    for (; I && "children" in I; ) {
      const $ = I.children.length;
      if ($ === 0)
        break;
      const _ = I.children[$ - 1];
      s.value.push(Ol(_)), I = _;
    }
  }
  function y() {
    var I, $;
    const { value: _ } = g, R = Number(e.scrollX), { value: U } = n;
    if (U === null)
      return;
    let Q = 0, Z = null;
    const { value: X } = v;
    for (let re = _.length - 1; re >= 0; --re) {
      const ue = Ol(_[re]);
      if (Math.round(o + (((I = X[ue]) === null || I === void 0 ? void 0 : I.start) || 0) + U - Q) < R)
        Z = ue, Q = (($ = X[ue]) === null || $ === void 0 ? void 0 : $.end) || 0;
      else
        break;
    }
    u.value = Z;
  }
  function C() {
    d.value = [];
    let I = e.columns.find(($) => Ol($) === u.value);
    for (; I && "children" in I && I.children.length; ) {
      const $ = I.children[0];
      d.value.push(Ol($)), I = $;
    }
  }
  function S() {
    const I = t.value ? t.value.getHeaderElement() : null, $ = t.value ? t.value.getBodyElement() : null;
    return {
      header: I,
      body: $
    };
  }
  function T() {
    const { body: I } = S();
    I && (I.scrollTop = 0);
  }
  function A() {
    i.value === "head" && m0(E);
  }
  function D(I) {
    var $;
    ($ = e.onScroll) === null || $ === void 0 || $.call(e, I), i.value === "body" && m0(E);
  }
  function E() {
    const { header: I, body: $ } = S();
    if (!$)
      return;
    const { value: _ } = n;
    if (_ === null)
      return;
    const { value: R } = i;
    if (e.maxHeight || e.flexHeight) {
      if (!I)
        return;
      R === "head" ? (o = I.scrollLeft, $.scrollLeft = o) : (o = $.scrollLeft, I.scrollLeft = o);
    } else
      o = $.scrollLeft;
    w(), x(), y(), C();
  }
  function N(I) {
    const { header: $ } = S();
    $ && ($.scrollLeft = I, E());
  }
  return Gt(r, () => {
    T();
  }), {
    styleScrollXRef: f,
    fixedColumnLeftMapRef: m,
    fixedColumnRightMapRef: v,
    leftFixedColumnsRef: h,
    rightFixedColumnsRef: g,
    leftActiveFixedColKeyRef: a,
    leftActiveFixedChildrenColKeysRef: s,
    rightActiveFixedColKeyRef: u,
    rightActiveFixedChildrenColKeysRef: d,
    syncScrollState: E,
    handleTableBodyScroll: D,
    handleTableHeaderScroll: A,
    setHeaderScrollLeft: N
  };
}
function Zve() {
  const e = G({});
  function t(i) {
    return e.value[i];
  }
  function r(i, o) {
    JH(i) && "key" in i && (e.value[i.key] = o);
  }
  function n() {
    e.value = {};
  }
  return {
    getResizableWidth: t,
    doUpdateResizableWidth: r,
    clearResizableWidth: n
  };
}
function Kve(e, t) {
  const r = [], n = [], i = [], o = /* @__PURE__ */ new WeakMap();
  let a = -1, s = 0, u = !1;
  function d(g, m) {
    m > a && (r[m] = [], a = m);
    for (const v of g)
      if ("children" in v)
        d(v.children, m + 1);
      else {
        const w = "key" in v ? v.key : void 0;
        n.push({
          key: Ol(v),
          style: hve(v, w !== void 0 ? Rn(t(w)) : void 0),
          column: v
        }), s += 1, u || (u = !!v.ellipsis), i.push(v);
      }
  }
  d(e, 0);
  let f = 0;
  function h(g, m) {
    let v = 0;
    g.forEach((w, x) => {
      var y;
      if ("children" in w) {
        const C = f, S = {
          column: w,
          colSpan: 0,
          rowSpan: 1,
          isLast: !1
        };
        h(w.children, m + 1), w.children.forEach((T) => {
          var A, D;
          S.colSpan += (D = (A = o.get(T)) === null || A === void 0 ? void 0 : A.colSpan) !== null && D !== void 0 ? D : 0;
        }), C + S.colSpan === s && (S.isLast = !0), o.set(w, S), r[m].push(S);
      } else {
        if (f < v) {
          f += 1;
          return;
        }
        let C = 1;
        "titleColSpan" in w && (C = (y = w.titleColSpan) !== null && y !== void 0 ? y : 1), C > 1 && (v = f + C);
        const S = f + C === s, T = {
          column: w,
          colSpan: C,
          rowSpan: a - m + 1,
          isLast: S
        };
        o.set(w, T), r[m].push(T), f += 1;
      }
    });
  }
  return h(e, 0), {
    hasEllipsis: u,
    rows: r,
    cols: n,
    dataRelatedCols: i
  };
}
function Xve(e, t) {
  const r = j(() => Kve(e.columns, t));
  return {
    rowsRef: j(() => r.value.rows),
    colsRef: j(() => r.value.cols),
    hasEllipsisRef: j(() => r.value.hasEllipsis),
    dataRelatedColsRef: j(() => r.value.dataRelatedCols)
  };
}
function Jve(e, t) {
  const r = _r(() => {
    for (const d of e.columns)
      if (d.type === "expand")
        return d.renderExpand;
  }), n = _r(() => {
    let d;
    for (const f of e.columns)
      if (f.type === "expand") {
        d = f.expandable;
        break;
      }
    return d;
  }), i = G(e.defaultExpandAll ? r != null && r.value ? (() => {
    const d = [];
    return t.value.treeNodes.forEach((f) => {
      var h;
      !((h = n.value) === null || h === void 0) && h.call(n, f.rawNode) && d.push(f.key);
    }), d;
  })() : t.value.getNonLeafKeys() : e.defaultExpandedRowKeys), o = tt(e, "expandedRowKeys"), a = tt(e, "stickyExpandedRows"), s = dn(o, i);
  function u(d) {
    const { onUpdateExpandedRowKeys: f, "onUpdate:expandedRowKeys": h } = e;
    f && je(f, d), h && je(h, d), i.value = d;
  }
  return {
    stickyExpandedRowsRef: a,
    mergedExpandedRowKeysRef: s,
    renderExpandRef: r,
    expandableRef: n,
    doUpdateExpandedRowKeys: u
  };
}
const iR = t0e();
var e0e = Y([L("data-table", `
 width: 100%;
 font-size: var(--n-font-size);
 display: flex;
 flex-direction: column;
 position: relative;
 --n-merged-th-color: var(--n-th-color);
 --n-merged-td-color: var(--n-td-color);
 --n-merged-border-color: var(--n-border-color);
 --n-merged-th-color-hover: var(--n-th-color-hover);
 --n-merged-td-color-hover: var(--n-td-color-hover);
 --n-merged-td-color-striped: var(--n-td-color-striped);
 `, [L("data-table-wrapper", `
 flex-grow: 1;
 display: flex;
 flex-direction: column;
 `), K("flex-height", [Y(">", [L("data-table-wrapper", [Y(">", [L("data-table-base-table", `
 display: flex;
 flex-direction: column;
 flex-grow: 1;
 `, [Y(">", [L("data-table-base-table-body", "flex-basis: 0;", [
  Y("&:last-child", "flex-grow: 1;")
])])])])])])]), Y(">", [L("data-table-loading-wrapper", `
 color: var(--n-loading-color);
 font-size: var(--n-loading-size);
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 transition: color .3s var(--n-bezier);
 display: flex;
 align-items: center;
 justify-content: center;
 `, [Fa({
  originalTransform: "translateX(-50%) translateY(-50%)"
})])]), L("data-table-expand-placeholder", `
 margin-right: 8px;
 display: inline-block;
 width: 16px;
 height: 1px;
 `), L("data-table-indent", `
 display: inline-block;
 height: 1px;
 `), L("data-table-expand-trigger", `
 display: inline-flex;
 margin-right: 8px;
 cursor: pointer;
 font-size: 16px;
 vertical-align: -0.2em;
 position: relative;
 width: 16px;
 height: 16px;
 color: var(--n-td-text-color);
 transition: color .3s var(--n-bezier);
 `, [K("expanded", [L("icon", "transform: rotate(90deg);", [Io({
  originalTransform: "rotate(90deg)"
})]), L("base-icon", "transform: rotate(90deg);", [Io({
  originalTransform: "rotate(90deg)"
})])]), L("base-loading", `
 color: var(--n-loading-color);
 transition: color .3s var(--n-bezier);
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `, [Io()]), L("icon", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `, [Io()]), L("base-icon", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `, [Io()])]), L("data-table-thead", `
 transition: background-color .3s var(--n-bezier);
 background-color: var(--n-merged-th-color);
 `), L("data-table-tr", `
 box-sizing: border-box;
 background-clip: padding-box;
 transition: background-color .3s var(--n-bezier);
 `, [L("data-table-expand", `
 position: sticky;
 left: 0;
 overflow: hidden;
 margin: calc(var(--n-th-padding) * -1);
 padding: var(--n-th-padding);
 box-sizing: border-box;
 `), K("striped", "background-color: var(--n-merged-td-color-striped);", [L("data-table-td", "background-color: var(--n-merged-td-color-striped);")]), wr("summary", [Y("&:hover", "background-color: var(--n-merged-td-color-hover);", [Y(">", [L("data-table-td", "background-color: var(--n-merged-td-color-hover);")])])])]), L("data-table-th", `
 padding: var(--n-th-padding);
 position: relative;
 text-align: start;
 box-sizing: border-box;
 background-color: var(--n-merged-th-color);
 border-color: var(--n-merged-border-color);
 border-bottom: 1px solid var(--n-merged-border-color);
 color: var(--n-th-text-color);
 transition:
 border-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 font-weight: var(--n-th-font-weight);
 `, [K("filterable", `
 padding-right: 36px;
 `, [K("sortable", `
 padding-right: calc(var(--n-th-padding) + 36px);
 `)]), iR, K("selection", `
 padding: 0;
 text-align: center;
 line-height: 0;
 z-index: 3;
 `), q("title-wrapper", `
 display: flex;
 align-items: center;
 flex-wrap: nowrap;
 max-width: 100%;
 `, [q("title", `
 flex: 1;
 min-width: 0;
 `)]), q("ellipsis", `
 display: inline-block;
 vertical-align: bottom;
 text-overflow: ellipsis;
 overflow: hidden;
 white-space: nowrap;
 max-width: 100%;
 `), K("hover", `
 background-color: var(--n-merged-th-color-hover);
 `), K("sortable", `
 cursor: pointer;
 `, [q("ellipsis", `
 max-width: calc(100% - 18px);
 `), Y("&:hover", `
 background-color: var(--n-merged-th-color-hover);
 `)]), L("data-table-sorter", `
 height: var(--n-sorter-size);
 width: var(--n-sorter-size);
 margin-left: 4px;
 position: relative;
 display: inline-flex;
 align-items: center;
 justify-content: center;
 vertical-align: -0.2em;
 color: var(--n-th-icon-color);
 transition: color .3s var(--n-bezier);
 `, [L("base-icon", "transition: transform .3s var(--n-bezier)"), K("desc", [L("base-icon", `
 transform: rotate(0deg);
 `)]), K("asc", [L("base-icon", `
 transform: rotate(-180deg);
 `)]), K("asc, desc", `
 color: var(--n-th-icon-color-active);
 `)]), L("data-table-resize-button", `
 width: var(--n-resizable-container-size);
 position: absolute;
 top: 0;
 right: calc(var(--n-resizable-container-size) / 2);
 bottom: 0;
 cursor: col-resize;
 user-select: none;
 `, [Y("&::after", `
 width: var(--n-resizable-size);
 height: 50%;
 position: absolute;
 top: 50%;
 left: calc(var(--n-resizable-container-size) / 2);
 bottom: 0;
 background-color: var(--n-merged-border-color);
 transform: translateY(-50%);
 transition: background-color .3s var(--n-bezier);
 z-index: 1;
 content: '';
 `), K("active", [Y("&::after", ` 
 background-color: var(--n-th-icon-color-active);
 `)]), Y("&:hover::after", `
 background-color: var(--n-th-icon-color-active);
 `)]), L("data-table-filter", `
 position: absolute;
 z-index: auto;
 right: 0;
 width: 36px;
 top: 0;
 bottom: 0;
 cursor: pointer;
 display: flex;
 justify-content: center;
 align-items: center;
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 font-size: var(--n-filter-size);
 color: var(--n-th-icon-color);
 `, [Y("&:hover", `
 background-color: var(--n-th-button-color-hover);
 `), K("show", `
 background-color: var(--n-th-button-color-hover);
 `), K("active", `
 background-color: var(--n-th-button-color-hover);
 color: var(--n-th-icon-color-active);
 `)])]), L("data-table-td", `
 padding: var(--n-td-padding);
 text-align: start;
 box-sizing: border-box;
 border: none;
 background-color: var(--n-merged-td-color);
 color: var(--n-td-text-color);
 border-bottom: 1px solid var(--n-merged-border-color);
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 border-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `, [K("expand", [L("data-table-expand-trigger", `
 margin-right: 0;
 `)]), K("last-row", `
 border-bottom: 0 solid var(--n-merged-border-color);
 `, [
  Y("&::after", `
 bottom: 0 !important;
 `),
  Y("&::before", `
 bottom: 0 !important;
 `)
]), K("summary", `
 background-color: var(--n-merged-th-color);
 `), K("hover", `
 background-color: var(--n-merged-td-color-hover);
 `), q("ellipsis", `
 display: inline-block;
 text-overflow: ellipsis;
 overflow: hidden;
 white-space: nowrap;
 max-width: 100%;
 vertical-align: bottom;
 `), K("selection, expand", `
 text-align: center;
 padding: 0;
 line-height: 0;
 `), iR]), L("data-table-empty", `
 box-sizing: border-box;
 padding: var(--n-empty-padding);
 flex-grow: 1;
 flex-shrink: 0;
 opacity: 1;
 display: flex;
 align-items: center;
 justify-content: center;
 transition: opacity .3s var(--n-bezier);
 `, [K("hide", `
 opacity: 0;
 `)]), q("pagination", `
 margin: var(--n-pagination-margin);
 display: flex;
 justify-content: flex-end;
 `), L("data-table-wrapper", `
 position: relative;
 opacity: 1;
 transition: opacity .3s var(--n-bezier), border-color .3s var(--n-bezier);
 border-top-left-radius: var(--n-border-radius);
 border-top-right-radius: var(--n-border-radius);
 line-height: var(--n-line-height);
 `), K("loading", [L("data-table-wrapper", `
 opacity: var(--n-opacity-loading);
 pointer-events: none;
 `)]), K("single-column", [L("data-table-td", `
 border-bottom: 0 solid var(--n-merged-border-color);
 `, [Y("&::after, &::before", `
 bottom: 0 !important;
 `)])]), wr("single-line", [L("data-table-th", `
 border-right: 1px solid var(--n-merged-border-color);
 `, [K("last", `
 border-right: 0 solid var(--n-merged-border-color);
 `)]), L("data-table-td", `
 border-right: 1px solid var(--n-merged-border-color);
 `, [K("last-col", `
 border-right: 0 solid var(--n-merged-border-color);
 `)])]), K("bordered", [L("data-table-wrapper", `
 border: 1px solid var(--n-merged-border-color);
 border-bottom-left-radius: var(--n-border-radius);
 border-bottom-right-radius: var(--n-border-radius);
 overflow: hidden;
 `)]), L("data-table-base-table", [K("transition-disabled", [L("data-table-th", [Y("&::after, &::before", "transition: none;")]), L("data-table-td", [Y("&::after, &::before", "transition: none;")])])]), K("bottom-bordered", [L("data-table-td", [K("last-row", `
 border-bottom: 1px solid var(--n-merged-border-color);
 `)])]), L("data-table-table", `
 font-variant-numeric: tabular-nums;
 width: 100%;
 word-break: break-word;
 transition: background-color .3s var(--n-bezier);
 border-collapse: separate;
 border-spacing: 0;
 background-color: var(--n-merged-td-color);
 `), L("data-table-base-table-header", `
 border-top-left-radius: calc(var(--n-border-radius) - 1px);
 border-top-right-radius: calc(var(--n-border-radius) - 1px);
 z-index: 3;
 overflow: scroll;
 flex-shrink: 0;
 transition: border-color .3s var(--n-bezier);
 scrollbar-width: none;
 `, [Y("&::-webkit-scrollbar", `
 width: 0;
 height: 0;
 `)]), L("data-table-check-extra", `
 transition: color .3s var(--n-bezier);
 color: var(--n-th-icon-color);
 position: absolute;
 font-size: 14px;
 right: -4px;
 top: 50%;
 transform: translateY(-50%);
 z-index: 1;
 `)]), L("data-table-filter-menu", [L("scrollbar", `
 max-height: 240px;
 `), q("group", `
 display: flex;
 flex-direction: column;
 padding: 12px 12px 0 12px;
 `, [L("checkbox", `
 margin-bottom: 12px;
 margin-right: 0;
 `), L("radio", `
 margin-bottom: 12px;
 margin-right: 0;
 `)]), q("action", `
 padding: var(--n-action-padding);
 display: flex;
 flex-wrap: nowrap;
 justify-content: space-evenly;
 border-top: 1px solid var(--n-action-divider-color);
 `, [L("button", [Y("&:not(:last-child)", `
 margin: var(--n-action-button-margin);
 `), Y("&:last-child", `
 margin-right: 0;
 `)])]), L("divider", `
 margin: 0 !important;
 `)]), Bp(L("data-table", `
 --n-merged-th-color: var(--n-th-color-modal);
 --n-merged-td-color: var(--n-td-color-modal);
 --n-merged-border-color: var(--n-border-color-modal);
 --n-merged-th-color-hover: var(--n-th-color-hover-modal);
 --n-merged-td-color-hover: var(--n-td-color-hover-modal);
 --n-merged-td-color-striped: var(--n-td-color-striped-modal);
 `)), hb(L("data-table", `
 --n-merged-th-color: var(--n-th-color-popover);
 --n-merged-td-color: var(--n-td-color-popover);
 --n-merged-border-color: var(--n-border-color-popover);
 --n-merged-th-color-hover: var(--n-th-color-hover-popover);
 --n-merged-td-color-hover: var(--n-td-color-hover-popover);
 --n-merged-td-color-striped: var(--n-td-color-striped-popover);
 `))]);
function t0e() {
  return [K("fixed-left", `
 left: 0;
 position: sticky;
 z-index: 2;
 `, [Y("&::after", `
 pointer-events: none;
 content: "";
 width: 36px;
 display: inline-block;
 position: absolute;
 top: 0;
 bottom: -1px;
 transition: box-shadow .2s var(--n-bezier);
 right: -36px;
 `)]), K("fixed-right", `
 right: 0;
 position: sticky;
 z-index: 1;
 `, [Y("&::before", `
 pointer-events: none;
 content: "";
 width: 36px;
 display: inline-block;
 position: absolute;
 top: 0;
 bottom: -1px;
 transition: box-shadow .2s var(--n-bezier);
 left: -36px;
 `)])];
}
var uW = oe({
  name: "DataTable",
  alias: ["AdvancedTable"],
  props: rve,
  setup(e, { slots: t }) {
    const { mergedBorderedRef: r, mergedClsPrefixRef: n, inlineThemeDisabled: i } = Yt(e), o = j(() => {
      const { bottomBordered: ve } = e;
      return r.value ? !1 : ve !== void 0 ? ve : !0;
    }), a = ft("DataTable", "-data-table", e0e, Kme, e, n), s = G(null), u = G("body");
    EM(() => {
      u.value = "body";
    });
    const d = G(null), { getResizableWidth: f, clearResizableWidth: h, doUpdateResizableWidth: g } = Zve(), { rowsRef: m, colsRef: v, dataRelatedColsRef: w, hasEllipsisRef: x } = Xve(e, f), { treeMateRef: y, mergedCurrentPageRef: C, paginatedDataRef: S, rawPaginatedDataRef: T, selectionColumnRef: A, hoverKeyRef: D, mergedPaginationRef: E, mergedFilterStateRef: N, mergedSortStateRef: I, childTriggerColIndexRef: $, doUpdatePage: _, doUpdateFilters: R, onUnstableColumnResize: U, deriveNextSorter: Q, filter: Z, filters: X, clearFilter: re, clearFilters: ue, clearSorter: he, page: te, sort: de } = qve(e, { dataRelatedColsRef: w }), { doCheckAll: De, doUncheckAll: Oe, doCheck: Qe, doUncheck: Ae, headerCheckboxDisabledRef: Ne, someRowsCheckedRef: $e, allRowsCheckedRef: et, mergedCheckedRowKeySetRef: Ge, mergedInderminateRowKeySetRef: Ee } = Wve(e, {
      selectionColumnRef: A,
      treeMateRef: y,
      paginatedDataRef: S
    }), { stickyExpandedRowsRef: qe, mergedExpandedRowKeysRef: Ue, renderExpandRef: ot, expandableRef: Ie, doUpdateExpandedRowKeys: rt } = Jve(e, y), { handleTableBodyScroll: W, handleTableHeaderScroll: P, syncScrollState: H, setHeaderScrollLeft: se, leftActiveFixedColKeyRef: pe, leftActiveFixedChildrenColKeysRef: ae, rightActiveFixedColKeyRef: Me, rightActiveFixedChildrenColKeysRef: fe, leftFixedColumnsRef: ke, rightFixedColumnsRef: Le, fixedColumnLeftMapRef: dt, fixedColumnRightMapRef: Mt } = Gve(e, {
      scrollPartRef: u,
      bodyWidthRef: s,
      mainTableInstRef: d,
      mergedCurrentPageRef: C
    }), { localeRef: Ct } = Zl("DataTable"), er = j(() => e.virtualScroll || e.flexHeight || e.maxHeight !== void 0 || x.value ? "fixed" : e.tableLayout);
    tr(Kl, {
      props: e,
      treeMateRef: y,
      renderExpandIconRef: tt(e, "renderExpandIcon"),
      loadingKeySetRef: G(/* @__PURE__ */ new Set()),
      slots: t,
      indentRef: tt(e, "indent"),
      childTriggerColIndexRef: $,
      bodyWidthRef: s,
      componentId: Ss(),
      hoverKeyRef: D,
      mergedClsPrefixRef: n,
      mergedThemeRef: a,
      scrollXRef: j(() => e.scrollX),
      rowsRef: m,
      colsRef: v,
      paginatedDataRef: S,
      leftActiveFixedColKeyRef: pe,
      leftActiveFixedChildrenColKeysRef: ae,
      rightActiveFixedColKeyRef: Me,
      rightActiveFixedChildrenColKeysRef: fe,
      leftFixedColumnsRef: ke,
      rightFixedColumnsRef: Le,
      fixedColumnLeftMapRef: dt,
      fixedColumnRightMapRef: Mt,
      mergedCurrentPageRef: C,
      someRowsCheckedRef: $e,
      allRowsCheckedRef: et,
      mergedSortStateRef: I,
      mergedFilterStateRef: N,
      loadingRef: tt(e, "loading"),
      rowClassNameRef: tt(e, "rowClassName"),
      mergedCheckedRowKeySetRef: Ge,
      mergedExpandedRowKeysRef: Ue,
      mergedInderminateRowKeySetRef: Ee,
      localeRef: Ct,
      scrollPartRef: u,
      expandableRef: Ie,
      stickyExpandedRowsRef: qe,
      rowKeyRef: tt(e, "rowKey"),
      renderExpandRef: ot,
      summaryRef: tt(e, "summary"),
      virtualScrollRef: tt(e, "virtualScroll"),
      rowPropsRef: tt(e, "rowProps"),
      stripedRef: tt(e, "striped"),
      checkOptionsRef: j(() => {
        const { value: ve } = A;
        return ve == null ? void 0 : ve.options;
      }),
      rawPaginatedDataRef: T,
      filterMenuCssVarsRef: j(() => {
        const { self: { actionDividerColor: ve, actionPadding: We, actionButtonMargin: ne } } = a.value;
        return {
          "--n-action-padding": We,
          "--n-action-button-margin": ne,
          "--n-action-divider-color": ve
        };
      }),
      onLoadRef: tt(e, "onLoad"),
      mergedTableLayoutRef: er,
      maxHeightRef: tt(e, "maxHeight"),
      minHeightRef: tt(e, "minHeight"),
      flexHeightRef: tt(e, "flexHeight"),
      headerCheckboxDisabledRef: Ne,
      paginationBehaviorOnFilterRef: tt(e, "paginationBehaviorOnFilter"),
      summaryPlacementRef: tt(e, "summaryPlacement"),
      scrollbarPropsRef: tt(e, "scrollbarProps"),
      syncScrollState: H,
      doUpdatePage: _,
      doUpdateFilters: R,
      getResizableWidth: f,
      onUnstableColumnResize: U,
      clearResizableWidth: h,
      doUpdateResizableWidth: g,
      deriveNextSorter: Q,
      doCheck: Qe,
      doUncheck: Ae,
      doCheckAll: De,
      doUncheckAll: Oe,
      doUpdateExpandedRowKeys: rt,
      handleTableHeaderScroll: P,
      handleTableBodyScroll: W,
      setHeaderScrollLeft: se,
      renderCell: tt(e, "renderCell")
    });
    const Vt = {
      filter: Z,
      filters: X,
      clearFilters: ue,
      clearSorter: he,
      page: te,
      sort: de,
      clearFilter: re,
      scrollTo: (ve, We) => {
        var ne;
        (ne = d.value) === null || ne === void 0 || ne.scrollTo(ve, We);
      }
    }, jt = j(() => {
      const { size: ve } = e, { common: { cubicBezierEaseInOut: We }, self: { borderColor: ne, tdColorHover: Se, thColor: _e, thColorHover: ut, tdColor: ht, tdTextColor: ye, thTextColor: Ze, thFontWeight: st, thButtonColorHover: Nt, thIconColor: Te, thIconColorActive: Ke, filterSize: xe, borderRadius: Xe, lineHeight: At, tdColorModal: Ht, thColorModal: zt, borderColorModal: ge, thColorHoverModal: Fe, tdColorHoverModal: Tt, borderColorPopover: lr, thColorPopover: gr, tdColorPopover: Or, tdColorHoverPopover: ri, thColorHoverPopover: xi, paginationMargin: wi, emptyPadding: Pi, boxShadowAfter: Mi, boxShadowBefore: ze, sorterSize: wt, resizableContainerSize: Ut, resizableSize: Wr, loadingColor: ct, loadingSize: en, opacityLoading: Ci, tdColorStriped: na, tdColorStripedModal: kr, tdColorStripedPopover: Xi, [Be("fontSize", ve)]: hi, [Be("thPadding", ve)]: gl, [Be("tdPadding", ve)]: so } } = a.value;
      return {
        "--n-font-size": hi,
        "--n-th-padding": gl,
        "--n-td-padding": so,
        "--n-bezier": We,
        "--n-border-radius": Xe,
        "--n-line-height": At,
        "--n-border-color": ne,
        "--n-border-color-modal": ge,
        "--n-border-color-popover": lr,
        "--n-th-color": _e,
        "--n-th-color-hover": ut,
        "--n-th-color-modal": zt,
        "--n-th-color-hover-modal": Fe,
        "--n-th-color-popover": gr,
        "--n-th-color-hover-popover": xi,
        "--n-td-color": ht,
        "--n-td-color-hover": Se,
        "--n-td-color-modal": Ht,
        "--n-td-color-hover-modal": Tt,
        "--n-td-color-popover": Or,
        "--n-td-color-hover-popover": ri,
        "--n-th-text-color": Ze,
        "--n-td-text-color": ye,
        "--n-th-font-weight": st,
        "--n-th-button-color-hover": Nt,
        "--n-th-icon-color": Te,
        "--n-th-icon-color-active": Ke,
        "--n-filter-size": xe,
        "--n-pagination-margin": wi,
        "--n-empty-padding": Pi,
        "--n-box-shadow-before": ze,
        "--n-box-shadow-after": Mi,
        "--n-sorter-size": wt,
        "--n-resizable-container-size": Ut,
        "--n-resizable-size": Wr,
        "--n-loading-size": en,
        "--n-loading-color": ct,
        "--n-opacity-loading": Ci,
        "--n-td-color-striped": na,
        "--n-td-color-striped-modal": kr,
        "--n-td-color-striped-popover": Xi
      };
    }), at = i ? Cr("data-table", j(() => e.size[0]), jt, e) : void 0, St = j(() => {
      if (!e.pagination)
        return !1;
      if (e.paginateSinglePage)
        return !0;
      const ve = E.value, { pageCount: We } = ve;
      return We !== void 0 ? We > 1 : ve.itemCount && ve.pageSize && ve.itemCount > ve.pageSize;
    });
    return Object.assign({ mainTableInstRef: d, mergedClsPrefix: n, mergedTheme: a, paginatedData: S, mergedBordered: r, mergedBottomBordered: o, mergedPagination: E, mergedShowPagination: St, cssVars: i ? void 0 : jt, themeClass: at == null ? void 0 : at.themeClass, onRender: at == null ? void 0 : at.onRender }, Vt);
  },
  render() {
    const { mergedClsPrefix: e, themeClass: t, onRender: r, $slots: n, spinProps: i } = this;
    return r == null || r(), b("div", { class: [
      `${e}-data-table`,
      t,
      {
        [`${e}-data-table--bordered`]: this.mergedBordered,
        [`${e}-data-table--bottom-bordered`]: this.mergedBottomBordered,
        [`${e}-data-table--single-line`]: this.singleLine,
        [`${e}-data-table--single-column`]: this.singleColumn,
        [`${e}-data-table--loading`]: this.loading,
        [`${e}-data-table--flex-height`]: this.flexHeight
      }
    ], style: this.cssVars }, b("div", { class: `${e}-data-table-wrapper` }, b(Hve, { ref: "mainTableInstRef" })), this.mergedShowPagination ? b("div", { class: `${e}-data-table__pagination` }, b(VH, Object.assign({ theme: this.mergedTheme.peers.Pagination, themeOverrides: this.mergedTheme.peerOverrides.Pagination, disabled: this.loading }, this.mergedPagination))) : null, b(jn, { name: "fade-in-scale-up-transition" }, {
      default: () => this.loading ? b("div", { class: `${e}-data-table-loading-wrapper` }, vr(n.loading, () => [
        b(mh, Object.assign({ clsPrefix: e, strokeWidth: 20 }, i))
      ])) : null
    }));
  }
}), r0e = {
  itemFontSize: "12px",
  itemHeight: "36px",
  itemWidth: "52px",
  panelActionPadding: "8px 0"
};
const n0e = (e) => {
  const { popoverColor: t, textColor2: r, primaryColor: n, hoverColor: i, dividerColor: o, opacityDisabled: a, boxShadow2: s, borderRadius: u, iconColor: d, iconColorDisabled: f } = e;
  return Object.assign(Object.assign({}, r0e), {
    panelColor: t,
    panelBoxShadow: s,
    panelDividerColor: o,
    itemTextColor: r,
    itemTextColorActive: n,
    itemColorHover: i,
    itemOpacityDisabled: a,
    itemBorderRadius: u,
    borderRadius: u,
    iconColor: d,
    iconColorDisabled: f
  });
}, i0e = {
  name: "TimePicker",
  common: Sr,
  peers: {
    Scrollbar: Rc,
    Button: Yu,
    Input: Fc
  },
  self: n0e
};
var cW = i0e, o0e = {
  itemSize: "24px",
  itemCellWidth: "38px",
  itemCellHeight: "32px",
  scrollItemWidth: "80px",
  scrollItemHeight: "40px",
  panelExtraFooterPadding: "8px 12px",
  panelActionPadding: "8px 12px",
  calendarTitlePadding: "0",
  calendarTitleHeight: "28px",
  arrowSize: "14px",
  panelHeaderPadding: "8px 12px",
  calendarDaysHeight: "32px",
  calendarTitleGridTempateColumns: "28px 28px 1fr 28px 28px",
  calendarLeftPaddingDate: "6px 12px 4px 12px",
  calendarLeftPaddingDatetime: "4px 12px",
  calendarLeftPaddingDaterange: "6px 12px 4px 12px",
  calendarLeftPaddingDatetimerange: "4px 12px",
  calendarLeftPaddingMonth: "0",
  calendarLeftPaddingYear: "0",
  calendarLeftPaddingQuarter: "0",
  calendarLeftPaddingMonthrange: "0",
  calendarLeftPaddingQuarterrange: "0",
  calendarLeftPaddingYearrange: "0",
  calendarRightPaddingDate: "6px 12px 4px 12px",
  calendarRightPaddingDatetime: "4px 12px",
  calendarRightPaddingDaterange: "6px 12px 4px 12px",
  calendarRightPaddingDatetimerange: "4px 12px",
  calendarRightPaddingMonth: "0",
  calendarRightPaddingYear: "0",
  calendarRightPaddingQuarter: "0",
  calendarRightPaddingMonthrange: "0",
  calendarRightPaddingQuarterrange: "0",
  calendarRightPaddingYearrange: "0"
};
const a0e = (e) => {
  const { hoverColor: t, fontSize: r, textColor2: n, textColorDisabled: i, popoverColor: o, primaryColor: a, borderRadiusSmall: s, iconColor: u, iconColorDisabled: d, textColor1: f, dividerColor: h, boxShadow2: g, borderRadius: m, fontWeightStrong: v } = e;
  return Object.assign(Object.assign({}, o0e), {
    itemFontSize: r,
    calendarDaysFontSize: r,
    calendarTitleFontSize: r,
    itemTextColor: n,
    itemTextColorDisabled: i,
    itemTextColorActive: o,
    itemTextColorCurrent: a,
    itemColorIncluded: nr(a, { alpha: 0.1 }),
    itemColorHover: t,
    itemColorDisabled: t,
    itemColorActive: a,
    itemBorderRadius: s,
    panelColor: o,
    panelTextColor: n,
    arrowColor: u,
    calendarTitleTextColor: f,
    calendarTitleColorHover: t,
    calendarDaysTextColor: n,
    panelHeaderDividerColor: h,
    calendarDaysDividerColor: h,
    calendarDividerColor: h,
    panelActionDividerColor: h,
    panelBoxShadow: g,
    panelBorderRadius: m,
    calendarTitleFontWeight: v,
    scrollItemBorderRadius: m,
    iconColor: u,
    iconColorDisabled: d
  });
}, l0e = {
  name: "DatePicker",
  common: Sr,
  peers: {
    Input: Fc,
    Button: Yu,
    TimePicker: cW,
    Scrollbar: Rc
  },
  self: a0e
};
var s0e = l0e;
function u0e(e, t) {
  const r = j(() => {
    const { isTimeDisabled: f } = e, { value: h } = t;
    if (!(h === null || Array.isArray(h)))
      return f == null ? void 0 : f(h);
  }), n = j(() => {
    var f;
    return (f = r.value) === null || f === void 0 ? void 0 : f.isHourDisabled;
  }), i = j(() => {
    var f;
    return (f = r.value) === null || f === void 0 ? void 0 : f.isMinuteDisabled;
  }), o = j(() => {
    var f;
    return (f = r.value) === null || f === void 0 ? void 0 : f.isSecondDisabled;
  }), a = j(() => {
    const { type: f, isDateDisabled: h } = e, { value: g } = t;
    return g === null || Array.isArray(g) || !["date", "datetime"].includes(f) || !h ? !1 : h(g);
  }), s = j(() => {
    const { type: f } = e, { value: h } = t;
    if (h === null || f === "datetime" || Array.isArray(h))
      return !1;
    const g = new Date(h), m = g.getHours(), v = g.getMinutes(), w = g.getMinutes();
    return (n.value ? n.value(m) : !1) || (i.value ? i.value(v, m) : !1) || (o.value ? o.value(w, v, m) : !1);
  }), u = j(() => a.value || s.value);
  return {
    isValueInvalidRef: j(() => {
      const { type: f } = e;
      return f === "date" ? a.value : f === "datetime" ? u.value : !1;
    }),
    isDateInvalidRef: a,
    isTimeInvalidRef: s,
    isDateTimeInvalidRef: u,
    isHourDisabledRef: n,
    isMinuteDisabledRef: i,
    isSecondDisabledRef: o
  };
}
function c0e(e, t) {
  const r = j(() => {
    const { isTimeDisabled: h } = e, { value: g } = t;
    return !Array.isArray(g) || !h ? [void 0, void 0] : [
      h == null ? void 0 : h(g[0], "start", g),
      h == null ? void 0 : h(g[1], "end", g)
    ];
  }), n = {
    isStartHourDisabledRef: j(() => {
      var h;
      return (h = r.value[0]) === null || h === void 0 ? void 0 : h.isHourDisabled;
    }),
    isEndHourDisabledRef: j(() => {
      var h;
      return (h = r.value[1]) === null || h === void 0 ? void 0 : h.isHourDisabled;
    }),
    isStartMinuteDisabledRef: j(() => {
      var h;
      return (h = r.value[0]) === null || h === void 0 ? void 0 : h.isMinuteDisabled;
    }),
    isEndMinuteDisabledRef: j(() => {
      var h;
      return (h = r.value[1]) === null || h === void 0 ? void 0 : h.isMinuteDisabled;
    }),
    isStartSecondDisabledRef: j(() => {
      var h;
      return (h = r.value[0]) === null || h === void 0 ? void 0 : h.isSecondDisabled;
    }),
    isEndSecondDisabledRef: j(() => {
      var h;
      return (h = r.value[1]) === null || h === void 0 ? void 0 : h.isSecondDisabled;
    })
  }, i = j(() => {
    const { type: h, isDateDisabled: g } = e, { value: m } = t;
    return m === null || !Array.isArray(m) || !["daterange", "datetimerange"].includes(h) || !g ? !1 : g(m[0], "start", m);
  }), o = j(() => {
    const { type: h, isDateDisabled: g } = e, { value: m } = t;
    return m === null || !Array.isArray(m) || !["daterange", "datetimerange"].includes(h) || !g ? !1 : g(m[1], "end", m);
  }), a = j(() => {
    const { type: h } = e, { value: g } = t;
    if (g === null || !Array.isArray(g) || h !== "datetimerange")
      return !1;
    const m = ac(g[0]), v = J1(g[0]), w = ex(g[0]), { isStartHourDisabledRef: x, isStartMinuteDisabledRef: y, isStartSecondDisabledRef: C } = n;
    return (x.value ? x.value(m) : !1) || (y.value ? y.value(v, m) : !1) || (C.value ? C.value(w, v, m) : !1);
  }), s = j(() => {
    const { type: h } = e, { value: g } = t;
    if (g === null || !Array.isArray(g) || h !== "datetimerange")
      return !1;
    const m = ac(g[1]), v = J1(g[1]), w = ex(g[1]), { isEndHourDisabledRef: x, isEndMinuteDisabledRef: y, isEndSecondDisabledRef: C } = n;
    return (x.value ? x.value(m) : !1) || (y.value ? y.value(v, m) : !1) || (C.value ? C.value(w, v, m) : !1);
  }), u = j(() => i.value || a.value), d = j(() => o.value || s.value), f = j(() => u.value || d.value);
  return Object.assign(Object.assign({}, n), {
    isStartDateInvalidRef: i,
    isEndDateInvalidRef: o,
    isStartTimeInvalidRef: a,
    isEndTimeInvalidRef: s,
    isStartValueInvalidRef: u,
    isEndValueInvalidRef: d,
    isRangeInvalidRef: f
  });
}
const QM = "n-date-picker";
var Dv = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function qM(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Az = { exports: {} }, Ez = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(n, i) {
    if (n == null)
      throw new TypeError("assign requires that input parameter not be null or undefined");
    for (var o in i)
      Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    return n;
  }
  e.exports = t.default;
})(Ez, Ez.exports);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Ez.exports);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o) {
    return (0, r.default)({}, o);
  }
  e.exports = t.default;
})(Az, Az.exports);
var d0e = /* @__PURE__ */ qM(Az.exports), Iz = { exports: {} }, Nz = { exports: {} }, zz = { exports: {} }, Co = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(n, i) {
    if (i.length < n)
      throw new TypeError(n + " argument" + (n > 1 ? "s" : "") + " required, but only " + i.length + " present");
  }
  e.exports = t.default;
})(Co, Co.exports);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Co.exports);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o) {
    return (0, r.default)(1, arguments), o instanceof Date || typeof o == "object" && Object.prototype.toString.call(o) === "[object Date]";
  }
  e.exports = t.default;
})(zz, zz.exports);
var sl = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Co.exports);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o) {
    (0, r.default)(1, arguments);
    var a = Object.prototype.toString.call(o);
    return o instanceof Date || typeof o == "object" && a === "[object Date]" ? new Date(o.getTime()) : typeof o == "number" || a === "[object Number]" ? new Date(o) : ((typeof o == "string" || a === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), new Date(NaN));
  }
  e.exports = t.default;
})(sl, sl.exports);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = o(zz.exports), n = o(sl.exports), i = o(Co.exports);
  function o(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function a(s) {
    if ((0, i.default)(1, arguments), !(0, r.default)(s) && typeof s != "number")
      return !1;
    var u = (0, n.default)(s);
    return !isNaN(Number(u));
  }
  e.exports = t.default;
})(Nz, Nz.exports);
var $z = { exports: {} }, Oz = { exports: {} }, Bu = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(n) {
    if (n === null || n === !0 || n === !1)
      return NaN;
    var i = Number(n);
    return isNaN(i) ? i : i < 0 ? Math.ceil(i) : Math.floor(i);
  }
  e.exports = t.default;
})(Bu, Bu.exports);
var f0e = /* @__PURE__ */ qM(Bu.exports);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = o(Bu.exports), n = o(sl.exports), i = o(Co.exports);
  function o(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function a(s, u) {
    (0, i.default)(2, arguments);
    var d = (0, n.default)(s).getTime(), f = (0, r.default)(u);
    return new Date(d + f);
  }
  e.exports = t.default;
})(Oz, Oz.exports);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = o(Oz.exports), n = o(Co.exports), i = o(Bu.exports);
  function o(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function a(s, u) {
    (0, n.default)(2, arguments);
    var d = (0, i.default)(u);
    return (0, r.default)(s, -d);
  }
  e.exports = t.default;
})($z, $z.exports);
var _z = { exports: {} }, Lz = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = i(sl.exports), n = i(Co.exports);
  function i(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var o = 864e5;
  function a(s) {
    (0, n.default)(1, arguments);
    var u = (0, r.default)(s), d = u.getTime();
    u.setUTCMonth(0, 1), u.setUTCHours(0, 0, 0, 0);
    var f = u.getTime(), h = d - f;
    return Math.floor(h / o) + 1;
  }
  e.exports = t.default;
})(Lz, Lz.exports);
var Pz = { exports: {} }, N0 = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = i(sl.exports), n = i(Co.exports);
  function i(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function o(a) {
    (0, n.default)(1, arguments);
    var s = 1, u = (0, r.default)(a), d = u.getUTCDay(), f = (d < s ? 7 : 0) + d - s;
    return u.setUTCDate(u.getUTCDate() - f), u.setUTCHours(0, 0, 0, 0), u;
  }
  e.exports = t.default;
})(N0, N0.exports);
var Rz = { exports: {} }, ax = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = o(sl.exports), n = o(Co.exports), i = o(N0.exports);
  function o(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function a(s) {
    (0, n.default)(1, arguments);
    var u = (0, r.default)(s), d = u.getUTCFullYear(), f = new Date(0);
    f.setUTCFullYear(d + 1, 0, 4), f.setUTCHours(0, 0, 0, 0);
    var h = (0, i.default)(f), g = new Date(0);
    g.setUTCFullYear(d, 0, 4), g.setUTCHours(0, 0, 0, 0);
    var m = (0, i.default)(g);
    return u.getTime() >= h.getTime() ? d + 1 : u.getTime() >= m.getTime() ? d : d - 1;
  }
  e.exports = t.default;
})(ax, ax.exports);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = o(ax.exports), n = o(N0.exports), i = o(Co.exports);
  function o(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function a(s) {
    (0, i.default)(1, arguments);
    var u = (0, r.default)(s), d = new Date(0);
    d.setUTCFullYear(u, 0, 4), d.setUTCHours(0, 0, 0, 0);
    var f = (0, n.default)(d);
    return f;
  }
  e.exports = t.default;
})(Rz, Rz.exports);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  var r = a(sl.exports), n = a(N0.exports), i = a(Rz.exports), o = a(Co.exports);
  function a(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var s = 6048e5;
  function u(d) {
    (0, o.default)(1, arguments);
    var f = (0, r.default)(d), h = (0, n.default)(f).getTime() - (0, i.default)(f).getTime();
    return Math.round(h / s) + 1;
  }
  e.exports = t.default;
})(Pz, Pz.exports);
var jz = { exports: {} }, z0 = { exports: {} }, vh = {};
Object.defineProperty(vh, "__esModule", {
  value: !0
});
vh.getDefaultOptions = h0e;
vh.setDefaultOptions = p0e;
var dW = {};
function h0e() {
  return dW;
}
function p0e(e) {
  dW = e;
}
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = a(sl.exports), n = a(Co.exports), i = a(Bu.exports), o = vh;
  function a(u) {
    return u && u.__esModule ? u : { default: u };
  }
  function s(u, d) {
    var f, h, g, m, v, w, x, y;
    (0, n.default)(1, arguments);
    var C = (0, o.getDefaultOptions)(), S = (0, i.default)((f = (h = (g = (m = d == null ? void 0 : d.weekStartsOn) !== null && m !== void 0 ? m : d == null || (v = d.locale) === null || v === void 0 || (w = v.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && g !== void 0 ? g : C.weekStartsOn) !== null && h !== void 0 ? h : (x = C.locale) === null || x === void 0 || (y = x.options) === null || y === void 0 ? void 0 : y.weekStartsOn) !== null && f !== void 0 ? f : 0);
    if (!(S >= 0 && S <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var T = (0, r.default)(u), A = T.getUTCDay(), D = (A < S ? 7 : 0) + A - S;
    return T.setUTCDate(T.getUTCDate() - D), T.setUTCHours(0, 0, 0, 0), T;
  }
  e.exports = t.default;
})(z0, z0.exports);
var Fz = { exports: {} }, lx = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  var r = s(sl.exports), n = s(Co.exports), i = s(z0.exports), o = s(Bu.exports), a = vh;
  function s(d) {
    return d && d.__esModule ? d : { default: d };
  }
  function u(d, f) {
    var h, g, m, v, w, x, y, C;
    (0, n.default)(1, arguments);
    var S = (0, r.default)(d), T = S.getUTCFullYear(), A = (0, a.getDefaultOptions)(), D = (0, o.default)((h = (g = (m = (v = f == null ? void 0 : f.firstWeekContainsDate) !== null && v !== void 0 ? v : f == null || (w = f.locale) === null || w === void 0 || (x = w.options) === null || x === void 0 ? void 0 : x.firstWeekContainsDate) !== null && m !== void 0 ? m : A.firstWeekContainsDate) !== null && g !== void 0 ? g : (y = A.locale) === null || y === void 0 || (C = y.options) === null || C === void 0 ? void 0 : C.firstWeekContainsDate) !== null && h !== void 0 ? h : 1);
    if (!(D >= 1 && D <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var E = new Date(0);
    E.setUTCFullYear(T + 1, 0, D), E.setUTCHours(0, 0, 0, 0);
    var N = (0, i.default)(E, f), I = new Date(0);
    I.setUTCFullYear(T, 0, D), I.setUTCHours(0, 0, 0, 0);
    var $ = (0, i.default)(I, f);
    return S.getTime() >= N.getTime() ? T + 1 : S.getTime() >= $.getTime() ? T : T - 1;
  }
  e.exports = t.default;
})(lx, lx.exports);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  var r = s(lx.exports), n = s(Co.exports), i = s(z0.exports), o = s(Bu.exports), a = vh;
  function s(d) {
    return d && d.__esModule ? d : { default: d };
  }
  function u(d, f) {
    var h, g, m, v, w, x, y, C;
    (0, n.default)(1, arguments);
    var S = (0, a.getDefaultOptions)(), T = (0, o.default)((h = (g = (m = (v = f == null ? void 0 : f.firstWeekContainsDate) !== null && v !== void 0 ? v : f == null || (w = f.locale) === null || w === void 0 || (x = w.options) === null || x === void 0 ? void 0 : x.firstWeekContainsDate) !== null && m !== void 0 ? m : S.firstWeekContainsDate) !== null && g !== void 0 ? g : (y = S.locale) === null || y === void 0 || (C = y.options) === null || C === void 0 ? void 0 : C.firstWeekContainsDate) !== null && h !== void 0 ? h : 1), A = (0, r.default)(d, f), D = new Date(0);
    D.setUTCFullYear(A, 0, T), D.setUTCHours(0, 0, 0, 0);
    var E = (0, i.default)(D, f);
    return E;
  }
  e.exports = t.default;
})(Fz, Fz.exports);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  var r = a(sl.exports), n = a(z0.exports), i = a(Fz.exports), o = a(Co.exports);
  function a(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var s = 6048e5;
  function u(d, f) {
    (0, o.default)(1, arguments);
    var h = (0, r.default)(d), g = (0, n.default)(h, f).getTime() - (0, i.default)(h, f).getTime();
    return Math.round(g / s) + 1;
  }
  e.exports = t.default;
})(jz, jz.exports);
var sx = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(n, i) {
    for (var o = n < 0 ? "-" : "", a = Math.abs(n).toString(); a.length < i; )
      a = "0" + a;
    return o + a;
  }
  e.exports = t.default;
})(sx, sx.exports);
var Bz = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(sx.exports);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var i = {
    y: function(a, s) {
      var u = a.getUTCFullYear(), d = u > 0 ? u : 1 - u;
      return (0, r.default)(s === "yy" ? d % 100 : d, s.length);
    },
    M: function(a, s) {
      var u = a.getUTCMonth();
      return s === "M" ? String(u + 1) : (0, r.default)(u + 1, 2);
    },
    d: function(a, s) {
      return (0, r.default)(a.getUTCDate(), s.length);
    },
    a: function(a, s) {
      var u = a.getUTCHours() / 12 >= 1 ? "pm" : "am";
      switch (s) {
        case "a":
        case "aa":
          return u.toUpperCase();
        case "aaa":
          return u;
        case "aaaaa":
          return u[0];
        case "aaaa":
        default:
          return u === "am" ? "a.m." : "p.m.";
      }
    },
    h: function(a, s) {
      return (0, r.default)(a.getUTCHours() % 12 || 12, s.length);
    },
    H: function(a, s) {
      return (0, r.default)(a.getUTCHours(), s.length);
    },
    m: function(a, s) {
      return (0, r.default)(a.getUTCMinutes(), s.length);
    },
    s: function(a, s) {
      return (0, r.default)(a.getUTCSeconds(), s.length);
    },
    S: function(a, s) {
      var u = s.length, d = a.getUTCMilliseconds(), f = Math.floor(d * Math.pow(10, u - 3));
      return (0, r.default)(f, s.length);
    }
  }, o = i;
  t.default = o, e.exports = t.default;
})(Bz, Bz.exports);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = d(Lz.exports), n = d(Pz.exports), i = d(ax.exports), o = d(jz.exports), a = d(lx.exports), s = d(sx.exports), u = d(Bz.exports);
  function d(x) {
    return x && x.__esModule ? x : { default: x };
  }
  var f = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }, h = {
    G: function(x, y, C) {
      var S = x.getUTCFullYear() > 0 ? 1 : 0;
      switch (y) {
        case "G":
        case "GG":
        case "GGG":
          return C.era(S, {
            width: "abbreviated"
          });
        case "GGGGG":
          return C.era(S, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return C.era(S, {
            width: "wide"
          });
      }
    },
    y: function(x, y, C) {
      if (y === "yo") {
        var S = x.getUTCFullYear(), T = S > 0 ? S : 1 - S;
        return C.ordinalNumber(T, {
          unit: "year"
        });
      }
      return u.default.y(x, y);
    },
    Y: function(x, y, C, S) {
      var T = (0, a.default)(x, S), A = T > 0 ? T : 1 - T;
      if (y === "YY") {
        var D = A % 100;
        return (0, s.default)(D, 2);
      }
      return y === "Yo" ? C.ordinalNumber(A, {
        unit: "year"
      }) : (0, s.default)(A, y.length);
    },
    R: function(x, y) {
      var C = (0, i.default)(x);
      return (0, s.default)(C, y.length);
    },
    u: function(x, y) {
      var C = x.getUTCFullYear();
      return (0, s.default)(C, y.length);
    },
    Q: function(x, y, C) {
      var S = Math.ceil((x.getUTCMonth() + 1) / 3);
      switch (y) {
        case "Q":
          return String(S);
        case "QQ":
          return (0, s.default)(S, 2);
        case "Qo":
          return C.ordinalNumber(S, {
            unit: "quarter"
          });
        case "QQQ":
          return C.quarter(S, {
            width: "abbreviated",
            context: "formatting"
          });
        case "QQQQQ":
          return C.quarter(S, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return C.quarter(S, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    q: function(x, y, C) {
      var S = Math.ceil((x.getUTCMonth() + 1) / 3);
      switch (y) {
        case "q":
          return String(S);
        case "qq":
          return (0, s.default)(S, 2);
        case "qo":
          return C.ordinalNumber(S, {
            unit: "quarter"
          });
        case "qqq":
          return C.quarter(S, {
            width: "abbreviated",
            context: "standalone"
          });
        case "qqqqq":
          return C.quarter(S, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return C.quarter(S, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    M: function(x, y, C) {
      var S = x.getUTCMonth();
      switch (y) {
        case "M":
        case "MM":
          return u.default.M(x, y);
        case "Mo":
          return C.ordinalNumber(S + 1, {
            unit: "month"
          });
        case "MMM":
          return C.month(S, {
            width: "abbreviated",
            context: "formatting"
          });
        case "MMMMM":
          return C.month(S, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return C.month(S, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    L: function(x, y, C) {
      var S = x.getUTCMonth();
      switch (y) {
        case "L":
          return String(S + 1);
        case "LL":
          return (0, s.default)(S + 1, 2);
        case "Lo":
          return C.ordinalNumber(S + 1, {
            unit: "month"
          });
        case "LLL":
          return C.month(S, {
            width: "abbreviated",
            context: "standalone"
          });
        case "LLLLL":
          return C.month(S, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return C.month(S, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    w: function(x, y, C, S) {
      var T = (0, o.default)(x, S);
      return y === "wo" ? C.ordinalNumber(T, {
        unit: "week"
      }) : (0, s.default)(T, y.length);
    },
    I: function(x, y, C) {
      var S = (0, n.default)(x);
      return y === "Io" ? C.ordinalNumber(S, {
        unit: "week"
      }) : (0, s.default)(S, y.length);
    },
    d: function(x, y, C) {
      return y === "do" ? C.ordinalNumber(x.getUTCDate(), {
        unit: "date"
      }) : u.default.d(x, y);
    },
    D: function(x, y, C) {
      var S = (0, r.default)(x);
      return y === "Do" ? C.ordinalNumber(S, {
        unit: "dayOfYear"
      }) : (0, s.default)(S, y.length);
    },
    E: function(x, y, C) {
      var S = x.getUTCDay();
      switch (y) {
        case "E":
        case "EE":
        case "EEE":
          return C.day(S, {
            width: "abbreviated",
            context: "formatting"
          });
        case "EEEEE":
          return C.day(S, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return C.day(S, {
            width: "short",
            context: "formatting"
          });
        case "EEEE":
        default:
          return C.day(S, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    e: function(x, y, C, S) {
      var T = x.getUTCDay(), A = (T - S.weekStartsOn + 8) % 7 || 7;
      switch (y) {
        case "e":
          return String(A);
        case "ee":
          return (0, s.default)(A, 2);
        case "eo":
          return C.ordinalNumber(A, {
            unit: "day"
          });
        case "eee":
          return C.day(T, {
            width: "abbreviated",
            context: "formatting"
          });
        case "eeeee":
          return C.day(T, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return C.day(T, {
            width: "short",
            context: "formatting"
          });
        case "eeee":
        default:
          return C.day(T, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    c: function(x, y, C, S) {
      var T = x.getUTCDay(), A = (T - S.weekStartsOn + 8) % 7 || 7;
      switch (y) {
        case "c":
          return String(A);
        case "cc":
          return (0, s.default)(A, y.length);
        case "co":
          return C.ordinalNumber(A, {
            unit: "day"
          });
        case "ccc":
          return C.day(T, {
            width: "abbreviated",
            context: "standalone"
          });
        case "ccccc":
          return C.day(T, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return C.day(T, {
            width: "short",
            context: "standalone"
          });
        case "cccc":
        default:
          return C.day(T, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    i: function(x, y, C) {
      var S = x.getUTCDay(), T = S === 0 ? 7 : S;
      switch (y) {
        case "i":
          return String(T);
        case "ii":
          return (0, s.default)(T, y.length);
        case "io":
          return C.ordinalNumber(T, {
            unit: "day"
          });
        case "iii":
          return C.day(S, {
            width: "abbreviated",
            context: "formatting"
          });
        case "iiiii":
          return C.day(S, {
            width: "narrow",
            context: "formatting"
          });
        case "iiiiii":
          return C.day(S, {
            width: "short",
            context: "formatting"
          });
        case "iiii":
        default:
          return C.day(S, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    a: function(x, y, C) {
      var S = x.getUTCHours(), T = S / 12 >= 1 ? "pm" : "am";
      switch (y) {
        case "a":
        case "aa":
          return C.dayPeriod(T, {
            width: "abbreviated",
            context: "formatting"
          });
        case "aaa":
          return C.dayPeriod(T, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "aaaaa":
          return C.dayPeriod(T, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return C.dayPeriod(T, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    b: function(x, y, C) {
      var S = x.getUTCHours(), T;
      switch (S === 12 ? T = f.noon : S === 0 ? T = f.midnight : T = S / 12 >= 1 ? "pm" : "am", y) {
        case "b":
        case "bb":
          return C.dayPeriod(T, {
            width: "abbreviated",
            context: "formatting"
          });
        case "bbb":
          return C.dayPeriod(T, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "bbbbb":
          return C.dayPeriod(T, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return C.dayPeriod(T, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    B: function(x, y, C) {
      var S = x.getUTCHours(), T;
      switch (S >= 17 ? T = f.evening : S >= 12 ? T = f.afternoon : S >= 4 ? T = f.morning : T = f.night, y) {
        case "B":
        case "BB":
        case "BBB":
          return C.dayPeriod(T, {
            width: "abbreviated",
            context: "formatting"
          });
        case "BBBBB":
          return C.dayPeriod(T, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return C.dayPeriod(T, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    h: function(x, y, C) {
      if (y === "ho") {
        var S = x.getUTCHours() % 12;
        return S === 0 && (S = 12), C.ordinalNumber(S, {
          unit: "hour"
        });
      }
      return u.default.h(x, y);
    },
    H: function(x, y, C) {
      return y === "Ho" ? C.ordinalNumber(x.getUTCHours(), {
        unit: "hour"
      }) : u.default.H(x, y);
    },
    K: function(x, y, C) {
      var S = x.getUTCHours() % 12;
      return y === "Ko" ? C.ordinalNumber(S, {
        unit: "hour"
      }) : (0, s.default)(S, y.length);
    },
    k: function(x, y, C) {
      var S = x.getUTCHours();
      return S === 0 && (S = 24), y === "ko" ? C.ordinalNumber(S, {
        unit: "hour"
      }) : (0, s.default)(S, y.length);
    },
    m: function(x, y, C) {
      return y === "mo" ? C.ordinalNumber(x.getUTCMinutes(), {
        unit: "minute"
      }) : u.default.m(x, y);
    },
    s: function(x, y, C) {
      return y === "so" ? C.ordinalNumber(x.getUTCSeconds(), {
        unit: "second"
      }) : u.default.s(x, y);
    },
    S: function(x, y) {
      return u.default.S(x, y);
    },
    X: function(x, y, C, S) {
      var T = S._originalDate || x, A = T.getTimezoneOffset();
      if (A === 0)
        return "Z";
      switch (y) {
        case "X":
          return m(A);
        case "XXXX":
        case "XX":
          return v(A);
        case "XXXXX":
        case "XXX":
        default:
          return v(A, ":");
      }
    },
    x: function(x, y, C, S) {
      var T = S._originalDate || x, A = T.getTimezoneOffset();
      switch (y) {
        case "x":
          return m(A);
        case "xxxx":
        case "xx":
          return v(A);
        case "xxxxx":
        case "xxx":
        default:
          return v(A, ":");
      }
    },
    O: function(x, y, C, S) {
      var T = S._originalDate || x, A = T.getTimezoneOffset();
      switch (y) {
        case "O":
        case "OO":
        case "OOO":
          return "GMT" + g(A, ":");
        case "OOOO":
        default:
          return "GMT" + v(A, ":");
      }
    },
    z: function(x, y, C, S) {
      var T = S._originalDate || x, A = T.getTimezoneOffset();
      switch (y) {
        case "z":
        case "zz":
        case "zzz":
          return "GMT" + g(A, ":");
        case "zzzz":
        default:
          return "GMT" + v(A, ":");
      }
    },
    t: function(x, y, C, S) {
      var T = S._originalDate || x, A = Math.floor(T.getTime() / 1e3);
      return (0, s.default)(A, y.length);
    },
    T: function(x, y, C, S) {
      var T = S._originalDate || x, A = T.getTime();
      return (0, s.default)(A, y.length);
    }
  };
  function g(x, y) {
    var C = x > 0 ? "-" : "+", S = Math.abs(x), T = Math.floor(S / 60), A = S % 60;
    if (A === 0)
      return C + String(T);
    var D = y || "";
    return C + String(T) + D + (0, s.default)(A, 2);
  }
  function m(x, y) {
    if (x % 60 === 0) {
      var C = x > 0 ? "-" : "+";
      return C + (0, s.default)(Math.abs(x) / 60, 2);
    }
    return v(x, y);
  }
  function v(x, y) {
    var C = y || "", S = x > 0 ? "-" : "+", T = Math.abs(x), A = (0, s.default)(Math.floor(T / 60), 2), D = (0, s.default)(T % 60, 2);
    return S + A + C + D;
  }
  var w = h;
  t.default = w, e.exports = t.default;
})(_z, _z.exports);
var Uz = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = function(s, u) {
    switch (s) {
      case "P":
        return u.date({
          width: "short"
        });
      case "PP":
        return u.date({
          width: "medium"
        });
      case "PPP":
        return u.date({
          width: "long"
        });
      case "PPPP":
      default:
        return u.date({
          width: "full"
        });
    }
  }, n = function(s, u) {
    switch (s) {
      case "p":
        return u.time({
          width: "short"
        });
      case "pp":
        return u.time({
          width: "medium"
        });
      case "ppp":
        return u.time({
          width: "long"
        });
      case "pppp":
      default:
        return u.time({
          width: "full"
        });
    }
  }, i = function(s, u) {
    var d = s.match(/(P+)(p+)?/) || [], f = d[1], h = d[2];
    if (!h)
      return r(s, u);
    var g;
    switch (f) {
      case "P":
        g = u.dateTime({
          width: "short"
        });
        break;
      case "PP":
        g = u.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        g = u.dateTime({
          width: "long"
        });
        break;
      case "PPPP":
      default:
        g = u.dateTime({
          width: "full"
        });
        break;
    }
    return g.replace("{{date}}", r(f, u)).replace("{{time}}", n(h, u));
  }, o = {
    p: n,
    P: i
  }, a = o;
  t.default = a, e.exports = t.default;
})(Uz, Uz.exports);
var ux = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(n) {
    var i = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), n.getHours(), n.getMinutes(), n.getSeconds(), n.getMilliseconds()));
    return i.setUTCFullYear(n.getFullYear()), n.getTime() - i.getTime();
  }
  e.exports = t.default;
})(ux, ux.exports);
var oR = /* @__PURE__ */ qM(ux.exports), Cb = {};
Object.defineProperty(Cb, "__esModule", {
  value: !0
});
Cb.isProtectedDayOfYearToken = v0e;
Cb.isProtectedWeekYearToken = b0e;
Cb.throwProtectedError = y0e;
var g0e = ["D", "DD"], m0e = ["YY", "YYYY"];
function v0e(e) {
  return g0e.indexOf(e) !== -1;
}
function b0e(e) {
  return m0e.indexOf(e) !== -1;
}
function y0e(e, t, r) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var Hz = { exports: {} }, Wz = { exports: {} }, Vz = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  }, n = function(o, a, s) {
    var u, d = r[o];
    return typeof d == "string" ? u = d : a === 1 ? u = d.one : u = d.other.replace("{{count}}", a.toString()), s != null && s.addSuffix ? s.comparison && s.comparison > 0 ? "in " + u : u + " ago" : u;
  }, i = n;
  t.default = i, e.exports = t.default;
})(Vz, Vz.exports);
var Yz = { exports: {} }, Qz = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(n) {
    return function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = i.width ? String(i.width) : n.defaultWidth, a = n.formats[o] || n.formats[n.defaultWidth];
      return a;
    };
  }
  e.exports = t.default;
})(Qz, Qz.exports);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(Qz.exports);
  function n(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var i = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, a = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, r.default)({
      formats: i,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: a,
      defaultWidth: "full"
    })
  }, u = s;
  t.default = u, e.exports = t.default;
})(Yz, Yz.exports);
var qz = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  }, n = function(o, a, s, u) {
    return r[o];
  }, i = n;
  t.default = i, e.exports = t.default;
})(qz, qz.exports);
var Gz = { exports: {} }, Zz = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(n) {
    return function(i, o) {
      var a = o != null && o.context ? String(o.context) : "standalone", s;
      if (a === "formatting" && n.formattingValues) {
        var u = n.defaultFormattingWidth || n.defaultWidth, d = o != null && o.width ? String(o.width) : u;
        s = n.formattingValues[d] || n.formattingValues[u];
      } else {
        var f = n.defaultWidth, h = o != null && o.width ? String(o.width) : n.defaultWidth;
        s = n.values[h] || n.values[f];
      }
      var g = n.argumentCallback ? n.argumentCallback(i) : i;
      return s[g];
    };
  }
  e.exports = t.default;
})(Zz, Zz.exports);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(Zz.exports);
  function n(m) {
    return m && m.__esModule ? m : { default: m };
  }
  var i = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  }, a = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  }, s = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  }, u = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  }, d = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  }, f = function(m, v) {
    var w = Number(m), x = w % 100;
    if (x > 20 || x < 10)
      switch (x % 10) {
        case 1:
          return w + "st";
        case 2:
          return w + "nd";
        case 3:
          return w + "rd";
      }
    return w + "th";
  }, h = {
    ordinalNumber: f,
    era: (0, r.default)({
      values: i,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(m) {
        return m - 1;
      }
    }),
    month: (0, r.default)({
      values: a,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: u,
      defaultWidth: "wide",
      formattingValues: d,
      defaultFormattingWidth: "wide"
    })
  }, g = h;
  t.default = g, e.exports = t.default;
})(Gz, Gz.exports);
var Kz = { exports: {} }, Xz = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(o) {
    return function(a) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, u = s.width, d = u && o.matchPatterns[u] || o.matchPatterns[o.defaultMatchWidth], f = a.match(d);
      if (!f)
        return null;
      var h = f[0], g = u && o.parsePatterns[u] || o.parsePatterns[o.defaultParseWidth], m = Array.isArray(g) ? i(g, function(x) {
        return x.test(h);
      }) : n(g, function(x) {
        return x.test(h);
      }), v;
      v = o.valueCallback ? o.valueCallback(m) : m, v = s.valueCallback ? s.valueCallback(v) : v;
      var w = a.slice(h.length);
      return {
        value: v,
        rest: w
      };
    };
  }
  function n(o, a) {
    for (var s in o)
      if (o.hasOwnProperty(s) && a(o[s]))
        return s;
  }
  function i(o, a) {
    for (var s = 0; s < o.length; s++)
      if (a(o[s]))
        return s;
  }
  e.exports = t.default;
})(Xz, Xz.exports);
var Jz = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(n) {
    return function(i) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = i.match(n.matchPattern);
      if (!a)
        return null;
      var s = a[0], u = i.match(n.parsePattern);
      if (!u)
        return null;
      var d = n.valueCallback ? n.valueCallback(u[0]) : u[0];
      d = o.valueCallback ? o.valueCallback(d) : d;
      var f = i.slice(s.length);
      return {
        value: d,
        rest: f
      };
    };
  }
  e.exports = t.default;
})(Jz, Jz.exports);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = i(Xz.exports), n = i(Jz.exports);
  function i(S) {
    return S && S.__esModule ? S : { default: S };
  }
  var o = /^(\d+)(th|st|nd|rd)?/i, a = /\d+/i, s = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  }, u = {
    any: [/^b/i, /^(a|c)/i]
  }, d = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  }, f = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, h = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  }, g = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, m = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  }, v = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  }, w = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  }, x = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  }, y = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: a,
      valueCallback: function(S) {
        return parseInt(S, 10);
      }
    }),
    era: (0, r.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any"
    }),
    quarter: (0, r.default)({
      matchPatterns: d,
      defaultMatchWidth: "wide",
      parsePatterns: f,
      defaultParseWidth: "any",
      valueCallback: function(S) {
        return S + 1;
      }
    }),
    month: (0, r.default)({
      matchPatterns: h,
      defaultMatchWidth: "wide",
      parsePatterns: g,
      defaultParseWidth: "any"
    }),
    day: (0, r.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: v,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, r.default)({
      matchPatterns: w,
      defaultMatchWidth: "any",
      parsePatterns: x,
      defaultParseWidth: "any"
    })
  }, C = y;
  t.default = C, e.exports = t.default;
})(Kz, Kz.exports);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = s(Vz.exports), n = s(Yz.exports), i = s(qz.exports), o = s(Gz.exports), a = s(Kz.exports);
  function s(f) {
    return f && f.__esModule ? f : { default: f };
  }
  var u = {
    code: "en-US",
    formatDistance: r.default,
    formatLong: n.default,
    formatRelative: i.default,
    localize: o.default,
    match: a.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, d = u;
  t.default = d, e.exports = t.default;
})(Wz, Wz.exports);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(Wz.exports);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var i = r.default;
  t.default = i, e.exports = t.default;
})(Hz, Hz.exports);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = S;
  var r = m(Nz.exports), n = m($z.exports), i = m(sl.exports), o = m(_z.exports), a = m(Uz.exports), s = m(ux.exports), u = Cb, d = m(Bu.exports), f = m(Co.exports), h = vh, g = m(Hz.exports);
  function m(A) {
    return A && A.__esModule ? A : { default: A };
  }
  var v = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, w = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, x = /^'([^]*?)'?$/, y = /''/g, C = /[a-zA-Z]/;
  function S(A, D, E) {
    var N, I, $, _, R, U, Q, Z, X, re, ue, he, te, de, De, Oe, Qe, Ae;
    (0, f.default)(2, arguments);
    var Ne = String(D), $e = (0, h.getDefaultOptions)(), et = (N = (I = E == null ? void 0 : E.locale) !== null && I !== void 0 ? I : $e.locale) !== null && N !== void 0 ? N : g.default, Ge = (0, d.default)(($ = (_ = (R = (U = E == null ? void 0 : E.firstWeekContainsDate) !== null && U !== void 0 ? U : E == null || (Q = E.locale) === null || Q === void 0 || (Z = Q.options) === null || Z === void 0 ? void 0 : Z.firstWeekContainsDate) !== null && R !== void 0 ? R : $e.firstWeekContainsDate) !== null && _ !== void 0 ? _ : (X = $e.locale) === null || X === void 0 || (re = X.options) === null || re === void 0 ? void 0 : re.firstWeekContainsDate) !== null && $ !== void 0 ? $ : 1);
    if (!(Ge >= 1 && Ge <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var Ee = (0, d.default)((ue = (he = (te = (de = E == null ? void 0 : E.weekStartsOn) !== null && de !== void 0 ? de : E == null || (De = E.locale) === null || De === void 0 || (Oe = De.options) === null || Oe === void 0 ? void 0 : Oe.weekStartsOn) !== null && te !== void 0 ? te : $e.weekStartsOn) !== null && he !== void 0 ? he : (Qe = $e.locale) === null || Qe === void 0 || (Ae = Qe.options) === null || Ae === void 0 ? void 0 : Ae.weekStartsOn) !== null && ue !== void 0 ? ue : 0);
    if (!(Ee >= 0 && Ee <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!et.localize)
      throw new RangeError("locale must contain localize property");
    if (!et.formatLong)
      throw new RangeError("locale must contain formatLong property");
    var qe = (0, i.default)(A);
    if (!(0, r.default)(qe))
      throw new RangeError("Invalid time value");
    var Ue = (0, s.default)(qe), ot = (0, n.default)(qe, Ue), Ie = {
      firstWeekContainsDate: Ge,
      weekStartsOn: Ee,
      locale: et,
      _originalDate: qe
    }, rt = Ne.match(w).map(function(W) {
      var P = W[0];
      if (P === "p" || P === "P") {
        var H = a.default[P];
        return H(W, et.formatLong);
      }
      return W;
    }).join("").match(v).map(function(W) {
      if (W === "''")
        return "'";
      var P = W[0];
      if (P === "'")
        return T(W);
      var H = o.default[P];
      if (H)
        return !(E != null && E.useAdditionalWeekYearTokens) && (0, u.isProtectedWeekYearToken)(W) && (0, u.throwProtectedError)(W, D, String(A)), !(E != null && E.useAdditionalDayOfYearTokens) && (0, u.isProtectedDayOfYearToken)(W) && (0, u.throwProtectedError)(W, D, String(A)), H(ot, W, et.localize, Ie);
      if (P.match(C))
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + P + "`");
      return W;
    }).join("");
    return rt;
  }
  function T(A) {
    var D = A.match(x);
    return D ? D[1].replace(y, "'") : A;
  }
  e.exports = t.default;
})(Iz, Iz.exports);
var x0e = /* @__PURE__ */ qM(Iz.exports);
function aR(e, t, r) {
  var n = C0e(e, r.timeZone, r.locale);
  return n.formatToParts ? w0e(n, t) : M0e(n, t);
}
function w0e(e, t) {
  var r = e.formatToParts(t);
  return r[r.length - 1].value;
}
function M0e(e, t) {
  var r = e.format(t).replace(/\u200E/g, ""), n = / [\w-+ ]+$/.exec(r);
  return n ? n[0].substr(1) : "";
}
function C0e(e, t, r) {
  if (r && !r.code)
    throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
  return new Intl.DateTimeFormat(r ? [r.code, "en-US"] : void 0, {
    timeZone: t,
    timeZoneName: e
  });
}
function S0e(e, t) {
  var r = A0e(t);
  return r.formatToParts ? k0e(r, e) : D0e(r, e);
}
var T0e = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function k0e(e, t) {
  try {
    for (var r = e.formatToParts(t), n = [], i = 0; i < r.length; i++) {
      var o = T0e[r[i].type];
      o >= 0 && (n[o] = parseInt(r[i].value, 10));
    }
    return n;
  } catch (a) {
    if (a instanceof RangeError)
      return [NaN];
    throw a;
  }
}
function D0e(e, t) {
  var r = e.format(t).replace(/\u200E/g, ""), n = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(r);
  return [n[3], n[1], n[2], n[4], n[5], n[6]];
}
var ZI = {};
function A0e(e) {
  if (!ZI[e]) {
    var t = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(new Date("2014-06-25T04:00:00.123Z")), r = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    ZI[e] = r ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return ZI[e];
}
function fW(e, t, r, n, i, o, a) {
  var s = new Date(0);
  return s.setUTCFullYear(e, t, r), s.setUTCHours(n, i, o, a), s;
}
var lR = 36e5, E0e = 6e4, KI = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function _4(e, t, r) {
  var n, i;
  if (e === "" || (n = KI.timezoneZ.exec(e), n))
    return 0;
  var o;
  if (n = KI.timezoneHH.exec(e), n)
    return o = parseInt(n[1], 10), sR(o) ? -(o * lR) : NaN;
  if (n = KI.timezoneHHMM.exec(e), n) {
    o = parseInt(n[1], 10);
    var a = parseInt(n[2], 10);
    return sR(o, a) ? (i = Math.abs(o) * lR + a * E0e, o > 0 ? -i : i) : NaN;
  }
  if (z0e(e)) {
    t = new Date(t || Date.now());
    var s = r ? t : I0e(t), u = e$(s, e), d = r ? u : N0e(t, u, e);
    return -d;
  }
  return NaN;
}
function I0e(e) {
  return fW(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds());
}
function e$(e, t) {
  var r = S0e(e, t), n = fW(r[0], r[1] - 1, r[2], r[3] % 24, r[4], r[5], 0).getTime(), i = e.getTime(), o = i % 1e3;
  return i -= o >= 0 ? o : 1e3 + o, n - i;
}
function N0e(e, t, r) {
  var n = e.getTime(), i = n - t, o = e$(new Date(i), r);
  if (t === o)
    return t;
  i -= o - t;
  var a = e$(new Date(i), r);
  return o === a ? o : Math.max(o, a);
}
function sR(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var uR = {};
function z0e(e) {
  if (uR[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), uR[e] = !0, !0;
  } catch {
    return !1;
  }
}
var $0e = 60 * 1e3, O0e = {
  X: function(e, t, r, n) {
    var i = XI(n.timeZone, n._originalDate || e);
    if (i === 0)
      return "Z";
    switch (t) {
      case "X":
        return cR(i);
      case "XXXX":
      case "XX":
        return Uh(i);
      case "XXXXX":
      case "XXX":
      default:
        return Uh(i, ":");
    }
  },
  x: function(e, t, r, n) {
    var i = XI(n.timeZone, n._originalDate || e);
    switch (t) {
      case "x":
        return cR(i);
      case "xxxx":
      case "xx":
        return Uh(i);
      case "xxxxx":
      case "xxx":
      default:
        return Uh(i, ":");
    }
  },
  O: function(e, t, r, n) {
    var i = XI(n.timeZone, n._originalDate || e);
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + _0e(i, ":");
      case "OOOO":
      default:
        return "GMT" + Uh(i, ":");
    }
  },
  z: function(e, t, r, n) {
    var i = n._originalDate || e;
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return aR("short", i, n);
      case "zzzz":
      default:
        return aR("long", i, n);
    }
  }
};
function XI(e, t) {
  var r = e ? _4(e, t, !0) / $0e : t.getTimezoneOffset();
  if (Number.isNaN(r))
    throw new RangeError("Invalid time zone specified: " + e);
  return r;
}
function cx(e, t) {
  for (var r = e < 0 ? "-" : "", n = Math.abs(e).toString(); n.length < t; )
    n = "0" + n;
  return r + n;
}
function Uh(e, t) {
  var r = t || "", n = e > 0 ? "-" : "+", i = Math.abs(e), o = cx(Math.floor(i / 60), 2), a = cx(Math.floor(i % 60), 2);
  return n + o + r + a;
}
function cR(e, t) {
  if (e % 60 === 0) {
    var r = e > 0 ? "-" : "+";
    return r + cx(Math.abs(e) / 60, 2);
  }
  return Uh(e, t);
}
function _0e(e, t) {
  var r = e > 0 ? "-" : "+", n = Math.abs(e), i = Math.floor(n / 60), o = n % 60;
  if (o === 0)
    return r + String(i);
  var a = t || "";
  return r + String(i) + a + cx(o, 2);
}
var L0e = O0e, P0e = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, R0e = P0e, JI = 36e5, dR = 6e4, j0e = 2, Zo = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    /^([+-]\d{3})$/,
    /^([+-]\d{4})$/
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    /^([+-]\d{5})/,
    /^([+-]\d{6})/
  ],
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  timeZone: R0e
};
function hW(e, t) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return new Date(NaN);
  var r = t || {}, n = r.additionalDigits == null ? j0e : f0e(r.additionalDigits);
  if (n !== 2 && n !== 1 && n !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return new Date(NaN);
  var i = F0e(e), o = B0e(i.date, n), a = o.year, s = o.restDateString, u = U0e(s, a);
  if (isNaN(u))
    return new Date(NaN);
  if (u) {
    var d = u.getTime(), f = 0, h;
    if (i.time && (f = H0e(i.time), isNaN(f)))
      return new Date(NaN);
    if (i.timeZone || r.timeZone) {
      if (h = _4(i.timeZone || r.timeZone, new Date(d + f)), isNaN(h))
        return new Date(NaN);
    } else
      h = oR(new Date(d + f)), h = oR(new Date(d + f + h));
    return new Date(d + f + h);
  } else
    return new Date(NaN);
}
function F0e(e) {
  var t = {}, r = Zo.dateTimePattern.exec(e), n;
  if (r ? (t.date = r[1], n = r[3]) : (r = Zo.datePattern.exec(e), r ? (t.date = r[1], n = r[2]) : (t.date = null, n = e)), n) {
    var i = Zo.timeZone.exec(n);
    i ? (t.time = n.replace(i[1], ""), t.timeZone = i[1].trim()) : t.time = n;
  }
  return t;
}
function B0e(e, t) {
  var r = Zo.YYY[t], n = Zo.YYYYY[t], i;
  if (i = Zo.YYYY.exec(e) || n.exec(e), i) {
    var o = i[1];
    return {
      year: parseInt(o, 10),
      restDateString: e.slice(o.length)
    };
  }
  if (i = Zo.YY.exec(e) || r.exec(e), i) {
    var a = i[1];
    return {
      year: parseInt(a, 10) * 100,
      restDateString: e.slice(a.length)
    };
  }
  return {
    year: null
  };
}
function U0e(e, t) {
  if (t === null)
    return null;
  var r, n, i, o;
  if (e.length === 0)
    return n = new Date(0), n.setUTCFullYear(t), n;
  if (r = Zo.MM.exec(e), r)
    return n = new Date(0), i = parseInt(r[1], 10) - 1, hR(t, i) ? (n.setUTCFullYear(t, i), n) : new Date(NaN);
  if (r = Zo.DDD.exec(e), r) {
    n = new Date(0);
    var a = parseInt(r[1], 10);
    return Y0e(t, a) ? (n.setUTCFullYear(t, 0, a), n) : new Date(NaN);
  }
  if (r = Zo.MMDD.exec(e), r) {
    n = new Date(0), i = parseInt(r[1], 10) - 1;
    var s = parseInt(r[2], 10);
    return hR(t, i, s) ? (n.setUTCFullYear(t, i, s), n) : new Date(NaN);
  }
  if (r = Zo.Www.exec(e), r)
    return o = parseInt(r[1], 10) - 1, pR(t, o) ? fR(t, o) : new Date(NaN);
  if (r = Zo.WwwD.exec(e), r) {
    o = parseInt(r[1], 10) - 1;
    var u = parseInt(r[2], 10) - 1;
    return pR(t, o, u) ? fR(t, o, u) : new Date(NaN);
  }
  return null;
}
function H0e(e) {
  var t, r, n;
  if (t = Zo.HH.exec(e), t)
    return r = parseFloat(t[1].replace(",", ".")), e2(r) ? r % 24 * JI : NaN;
  if (t = Zo.HHMM.exec(e), t)
    return r = parseInt(t[1], 10), n = parseFloat(t[2].replace(",", ".")), e2(r, n) ? r % 24 * JI + n * dR : NaN;
  if (t = Zo.HHMMSS.exec(e), t) {
    r = parseInt(t[1], 10), n = parseInt(t[2], 10);
    var i = parseFloat(t[3].replace(",", "."));
    return e2(r, n, i) ? r % 24 * JI + n * dR + i * 1e3 : NaN;
  }
  return null;
}
function fR(e, t, r) {
  t = t || 0, r = r || 0;
  var n = new Date(0);
  n.setUTCFullYear(e, 0, 4);
  var i = n.getUTCDay() || 7, o = t * 7 + r + 1 - i;
  return n.setUTCDate(n.getUTCDate() + o), n;
}
var W0e = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], V0e = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function pW(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function hR(e, t, r) {
  if (t < 0 || t > 11)
    return !1;
  if (r != null) {
    if (r < 1)
      return !1;
    var n = pW(e);
    if (n && r > V0e[t] || !n && r > W0e[t])
      return !1;
  }
  return !0;
}
function Y0e(e, t) {
  if (t < 1)
    return !1;
  var r = pW(e);
  return !(r && t > 366 || !r && t > 365);
}
function pR(e, t, r) {
  return !(t < 0 || t > 52 || r != null && (r < 0 || r > 6));
}
function e2(e, t, r) {
  return !(e != null && (e < 0 || e >= 25) || t != null && (t < 0 || t >= 60) || r != null && (r < 0 || r >= 60));
}
var Q0e = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function q0e(e, t, r) {
  var n = String(t), i = r || {}, o = n.match(Q0e);
  if (o) {
    var a = hW(e, i);
    n = o.reduce(function(s, u) {
      if (u[0] === "'")
        return s;
      var d = s.indexOf(u), f = s[d - 1] === "'", h = s.replace(u, "'" + L0e[u[0]](a, u, null, i) + "'");
      return f ? h.substring(0, d - 1) + h.substring(d + 1) : h;
    }, n);
  }
  return x0e(e, n, i);
}
function G0e(e, t, r) {
  var n = hW(e, r), i = _4(t, n, !0), o = new Date(n.getTime() - i), a = new Date(0);
  return a.setFullYear(o.getUTCFullYear(), o.getUTCMonth(), o.getUTCDate()), a.setHours(o.getUTCHours(), o.getUTCMinutes(), o.getUTCSeconds(), o.getUTCMilliseconds()), a;
}
function Z0e(e, t, r, n) {
  var i = d0e(n);
  return i.timeZone = t, q0e(G0e(e, t), r, i);
}
const Lv = {
  amHours: [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11"
  ],
  pmHours: [
    "12",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11"
  ],
  hours: [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23"
  ],
  minutes: [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59"
  ],
  seconds: [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59"
  ],
  period: ["AM", "PM"]
};
function t2(e) {
  return `00${e}`.slice(-2);
}
function Pv(e, t, r) {
  return Array.isArray(t) ? (r === "am" ? t.filter((n) => n < 12) : r === "pm" ? t.filter((n) => n >= 12).map((n) => n === 12 ? 12 : n - 12) : t).map((n) => t2(n)) : typeof t == "number" ? r === "am" ? e.filter((n) => {
    const i = Number(n);
    return i < 12 && i % t === 0;
  }) : r === "pm" ? e.filter((n) => {
    const i = Number(n);
    return i >= 12 && i % t === 0;
  }).map((n) => {
    const i = Number(n);
    return t2(i === 12 ? 12 : i - 12);
  }) : e.filter((n) => Number(n) % t === 0) : r === "am" ? e.filter((n) => Number(n) < 12) : r === "pm" ? e.map((n) => Number(n)).filter((n) => Number(n) >= 12).map((n) => t2(n === 12 ? 12 : n - 12)) : e;
}
function fy(e, t, r) {
  return r ? typeof r == "number" ? e % r === 0 : r.includes(e) : !0;
}
function K0e(e, t, r) {
  const n = Pv(Lv[t], r).map(Number);
  let i, o;
  for (let a = 0; a < n.length; ++a) {
    const s = n[a];
    if (s === e)
      return s;
    if (s > e) {
      o = s;
      break;
    }
    i = s;
  }
  return i === void 0 ? (o || Ql("time-picker", "Please set 'hours' or 'minutes' or 'seconds' props"), o) : o === void 0 || o - e > e - i ? i : o;
}
function X0e(e) {
  return ac(e) < 12 ? "am" : "pm";
}
const gW = "n-time-picker";
var hy = oe({
  name: "TimePickerPanelCol",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    data: {
      type: Array,
      required: !0
    },
    activeValue: {
      type: Number,
      default: null
    },
    onItemClick: Function
  },
  render() {
    const { activeValue: e, onItemClick: t, clsPrefix: r } = this;
    return this.data.map((n) => {
      const { label: i, disabled: o, value: a } = n, s = e === a;
      return b("div", { key: i, "data-active": s ? "" : null, class: [
        `${r}-time-picker-col__item`,
        s && `${r}-time-picker-col__item--active`,
        o && `${r}-time-picker-col__item--disabled`
      ], onClick: t && !o ? () => {
        t(a);
      } : void 0 }, i);
    });
  }
});
const J0e = {
  actions: {
    type: Array,
    default: () => ["now", "confirm"]
  },
  showHour: {
    type: Boolean,
    default: !0
  },
  showMinute: {
    type: Boolean,
    default: !0
  },
  showSecond: {
    type: Boolean,
    default: !0
  },
  showPeriod: {
    type: Boolean,
    default: !0
  },
  isHourInvalid: Boolean,
  isMinuteInvalid: Boolean,
  isSecondInvalid: Boolean,
  isAmPmInvalid: Boolean,
  isValueInvalid: Boolean,
  hourValue: {
    type: Number,
    default: null
  },
  minuteValue: {
    type: Number,
    default: null
  },
  secondValue: {
    type: Number,
    default: null
  },
  amPmValue: {
    type: String,
    default: null
  },
  isHourDisabled: Function,
  isMinuteDisabled: Function,
  isSecondDisabled: Function,
  onHourClick: {
    type: Function,
    required: !0
  },
  onMinuteClick: {
    type: Function,
    required: !0
  },
  onSecondClick: {
    type: Function,
    required: !0
  },
  onAmPmClick: {
    type: Function,
    required: !0
  },
  onNowClick: Function,
  nowText: String,
  confirmText: String,
  transitionDisabled: Boolean,
  onConfirmClick: Function,
  onFocusin: Function,
  onFocusout: Function,
  onFocusDetectorFocus: Function,
  onKeydown: Function,
  hours: [Number, Array],
  minutes: [Number, Array],
  seconds: [Number, Array],
  use12Hours: Boolean
};
var ebe = oe({
  name: "TimePickerPanel",
  props: J0e,
  setup(e) {
    const {
      mergedThemeRef: t,
      mergedClsPrefixRef: r
    } = lt(gW), n = j(() => {
      const { isHourDisabled: s, hours: u, use12Hours: d, amPmValue: f } = e;
      if (d) {
        const h = f ?? X0e(Date.now());
        return Pv(Lv.hours, u, h).map((g) => {
          const m = Number(g), v = h === "pm" && m !== 12 ? m + 12 : m;
          return {
            label: g,
            value: v,
            disabled: s ? s(v) : !1
          };
        });
      } else
        return Pv(Lv.hours, u).map((h) => ({
          label: h,
          value: Number(h),
          disabled: s ? s(Number(h)) : !1
        }));
    }), i = j(() => {
      const { isMinuteDisabled: s, minutes: u } = e;
      return Pv(Lv.minutes, u).map((d) => ({
        label: d,
        value: Number(d),
        disabled: s ? s(Number(d), e.hourValue) : !1
      }));
    }), o = j(() => {
      const { isSecondDisabled: s, seconds: u } = e;
      return Pv(Lv.seconds, u).map((d) => ({
        label: d,
        value: Number(d),
        disabled: s ? s(Number(d), e.minuteValue, e.hourValue) : !1
      }));
    }), a = j(() => {
      const { isHourDisabled: s } = e;
      let u = !0, d = !0;
      for (let f = 0; f < 12; ++f)
        if (!(s != null && s(f))) {
          u = !1;
          break;
        }
      for (let f = 12; f < 24; ++f)
        if (!(s != null && s(f))) {
          d = !1;
          break;
        }
      return [
        {
          label: "AM",
          value: "am",
          disabled: u
        },
        {
          label: "PM",
          value: "pm",
          disabled: d
        }
      ];
    });
    return {
      mergedTheme: t,
      mergedClsPrefix: r,
      hours: n,
      minutes: i,
      seconds: o,
      amPm: a,
      hourScrollRef: G(null),
      minuteScrollRef: G(null),
      secondScrollRef: G(null),
      amPmScrollRef: G(null)
    };
  },
  render() {
    var e, t, r;
    const { mergedClsPrefix: n, mergedTheme: i } = this;
    return b("div", { tabindex: 0, class: `${n}-time-picker-panel`, onFocusin: this.onFocusin, onFocusout: this.onFocusout, onKeydown: this.onKeydown }, b("div", { class: `${n}-time-picker-cols` }, this.showHour ? b("div", { class: [
      `${n}-time-picker-col`,
      this.isHourInvalid && `${n}-time-picker-col--invalid`,
      this.transitionDisabled && `${n}-time-picker-col--transition-disabled`
    ] }, b(no, { ref: "hourScrollRef", theme: i.peers.Scrollbar, themeOverrides: i.peerOverrides.Scrollbar }, {
      default: () => [
        b(hy, { clsPrefix: n, data: this.hours, activeValue: this.hourValue, onItemClick: this.onHourClick }),
        b("div", { class: `${n}-time-picker-col__padding` })
      ]
    })) : null, this.showMinute ? b("div", { class: [
      `${n}-time-picker-col`,
      this.transitionDisabled && `${n}-time-picker-col--transition-disabled`,
      this.isMinuteInvalid && `${n}-time-picker-col--invalid`
    ] }, b(no, { ref: "minuteScrollRef", theme: i.peers.Scrollbar, themeOverrides: i.peerOverrides.Scrollbar }, {
      default: () => [
        b(hy, { clsPrefix: n, data: this.minutes, activeValue: this.minuteValue, onItemClick: this.onMinuteClick }),
        b("div", { class: `${n}-time-picker-col__padding` })
      ]
    })) : null, this.showSecond ? b("div", { class: [
      `${n}-time-picker-col`,
      this.isSecondInvalid && `${n}-time-picker-col--invalid`,
      this.transitionDisabled && `${n}-time-picker-col--transition-disabled`
    ] }, b(no, { ref: "secondScrollRef", theme: i.peers.Scrollbar, themeOverrides: i.peerOverrides.Scrollbar }, {
      default: () => [
        b(hy, { clsPrefix: n, data: this.seconds, activeValue: this.secondValue, onItemClick: this.onSecondClick }),
        b("div", { class: `${n}-time-picker-col__padding` })
      ]
    })) : null, this.use12Hours ? b("div", { class: [
      `${n}-time-picker-col`,
      this.isAmPmInvalid && `${n}-time-picker-col--invalid`,
      this.transitionDisabled && `${n}-time-picker-col--transition-disabled`
    ] }, b(no, { ref: "amPmScrollRef", theme: i.peers.Scrollbar, themeOverrides: i.peerOverrides.Scrollbar }, {
      default: () => [
        b(hy, { clsPrefix: n, data: this.amPm, activeValue: this.amPmValue, onItemClick: this.onAmPmClick }),
        b("div", { class: `${n}-time-picker-col__padding` })
      ]
    })) : null), !((e = this.actions) === null || e === void 0) && e.length ? b("div", { class: `${n}-time-picker-actions` }, !((t = this.actions) === null || t === void 0) && t.includes("now") ? b(Mn, { size: "tiny", theme: i.peers.Button, themeOverrides: i.peerOverrides.Button, onClick: this.onNowClick }, { default: () => this.nowText }) : null, !((r = this.actions) === null || r === void 0) && r.includes("confirm") ? b(Mn, { size: "tiny", type: "primary", class: `${n}-time-picker-actions__confirm`, theme: i.peers.Button, themeOverrides: i.peerOverrides.Button, disabled: this.isValueInvalid, onClick: this.onConfirmClick }, { default: () => this.confirmText }) : null) : null, b(Pc, { onFocus: this.onFocusDetectorFocus }));
  }
}), tbe = Y([L("time-picker", `
 z-index: auto;
 position: relative;
 `, [L("time-picker-icon", `
 color: var(--n-icon-color-override);
 transition: color .3s var(--n-bezier);
 `), K("disabled", [L("time-picker-icon", `
 color: var(--n-icon-color-disabled-override);
 `)])]), L("time-picker-panel", `
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 outline: none;
 font-size: var(--n-item-font-size);
 border-radius: var(--n-border-radius);
 margin: 4px 0;
 min-width: 104px;
 overflow: hidden;
 background-color: var(--n-panel-color);
 box-shadow: var(--n-panel-box-shadow);
 `, [Fa(), L("time-picker-actions", `
 padding: var(--n-panel-action-padding);
 align-items: center;
 display: flex;
 justify-content: space-evenly;
 `), L("time-picker-cols", `
 height: calc(var(--n-item-height) * 6);
 display: flex;
 position: relative;
 transition: border-color .3s var(--n-bezier);
 border-bottom: 1px solid var(--n-panel-divider-color);
 `), L("time-picker-col", `
 flex-grow: 1;
 min-width: var(--n-item-width);
 height: calc(var(--n-item-height) * 6);
 flex-direction: column;
 transition: box-shadow .3s var(--n-bezier);
 `, [K("transition-disabled", [q("item", "transition: none;", [Y("&::before", "transition: none;")])]), q("padding", `
 height: calc(var(--n-item-height) * 5);
 `), Y("&:first-child", "min-width: calc(var(--n-item-width) + 4px);", [q("item", [Y("&::before", "left: 4px;")])]), q("item", `
 cursor: pointer;
 height: var(--n-item-height);
 display: flex;
 align-items: center;
 justify-content: center;
 transition: 
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 text-decoration-color .3s var(--n-bezier);
 background: #0000;
 text-decoration-color: #0000;
 color: var(--n-item-text-color);
 z-index: 0;
 box-sizing: border-box;
 padding-top: 4px;
 position: relative;
 `, [Y("&::before", `
 content: "";
 transition: background-color .3s var(--n-bezier);
 z-index: -1;
 position: absolute;
 left: 0;
 right: 4px;
 top: 4px;
 bottom: 0;
 border-radius: var(--n-item-border-radius);
 `), wr("disabled", [Y("&:hover::before", `
 background-color: var(--n-item-color-hover);
 `)]), K("active", `
 color: var(--n-item-text-color-active);
 `, [Y("&::before", `
 background-color: var(--n-item-color-hover);
 `)]), K("disabled", `
 opacity: var(--n-item-opacity-disabled);
 cursor: not-allowed;
 `)]), K("invalid", [q("item", [K("active", `
 text-decoration: line-through;
 text-decoration-color: var(--n-item-text-color-active);
 `)])])])])]);
function r2(e, t) {
  return e === void 0 ? !0 : Array.isArray(e) ? e.every((r) => r >= 0 && r <= t) : e >= 0 && e <= t;
}
const rbe = Object.assign(Object.assign({}, ft.props), {
  to: vi.propTo,
  bordered: {
    type: Boolean,
    default: void 0
  },
  actions: Array,
  defaultValue: {
    type: Number,
    default: null
  },
  defaultFormattedValue: String,
  placeholder: String,
  placement: {
    type: String,
    default: "bottom-start"
  },
  value: Number,
  format: {
    type: String,
    default: "HH:mm:ss"
  },
  valueFormat: String,
  formattedValue: String,
  isHourDisabled: Function,
  size: String,
  isMinuteDisabled: Function,
  isSecondDisabled: Function,
  inputReadonly: Boolean,
  clearable: Boolean,
  status: String,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  onUpdateFormattedValue: [Function, Array],
  "onUpdate:formattedValue": [Function, Array],
  onBlur: [Function, Array],
  onConfirm: [Function, Array],
  onClear: Function,
  onFocus: [Function, Array],
  timeZone: String,
  showIcon: {
    type: Boolean,
    default: !0
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  show: {
    type: Boolean,
    default: void 0
  },
  hours: {
    type: [Number, Array],
    validator: (e) => r2(e, 23)
  },
  minutes: {
    type: [Number, Array],
    validator: (e) => r2(e, 59)
  },
  seconds: {
    type: [Number, Array],
    validator: (e) => r2(e, 59)
  },
  use12Hours: Boolean,
  stateful: {
    type: Boolean,
    default: !0
  },
  onChange: [Function, Array]
});
var dx = oe({
  name: "TimePicker",
  props: rbe,
  setup(e) {
    const { mergedBorderedRef: t, mergedClsPrefixRef: r, namespaceRef: n, inlineThemeDisabled: i } = Yt(e), { localeRef: o, dateLocaleRef: a } = Zl("TimePicker"), s = ta(e), { mergedSizeRef: u, mergedDisabledRef: d, mergedStatusRef: f } = s, h = ft("TimePicker", "-time-picker", tbe, cW, e, r), g = KO(), m = G(null), v = G(null), w = j(() => ({
      locale: a.value.locale
    }));
    function x(Te) {
      return Te === null ? null : ua(Te, e.valueFormat || e.format, new Date(), w.value).getTime();
    }
    const { defaultValue: y, defaultFormattedValue: C } = e, S = G(C !== void 0 ? x(C) : y), T = j(() => {
      const { formattedValue: Te } = e;
      if (Te !== void 0)
        return x(Te);
      const { value: Ke } = e;
      return Ke !== void 0 ? Ke : S.value;
    }), A = j(() => {
      const { timeZone: Te } = e;
      return Te ? (Ke, xe, Xe) => Z0e(Ke, Te, xe, Xe) : (Ke, xe, Xe) => Xn(Ke, xe, Xe);
    }), D = G("");
    Gt(() => e.timeZone, () => {
      const Te = T.value;
      D.value = Te === null ? "" : A.value(Te, e.format, w.value);
    }, {
      immediate: !0
    });
    const E = G(!1), N = tt(e, "show"), I = dn(N, E), $ = G(T.value), _ = G(!1), R = j(() => o.value.now), U = j(() => e.placeholder !== void 0 ? e.placeholder : o.value.placeholder), Q = j(() => o.value.negativeText), Z = j(() => o.value.positiveText), X = j(() => /H|h|K|k/.test(e.format)), re = j(() => e.format.includes("m")), ue = j(() => e.format.includes("s")), he = j(() => {
      const { isHourDisabled: Te } = e;
      return Ae.value === null ? !1 : fy(Ae.value, "hours", e.hours) ? Te ? Te(Ae.value) : !1 : !0;
    }), te = j(() => {
      const { value: Te } = Ne, { value: Ke } = Ae;
      if (Te === null || Ke === null)
        return !1;
      if (!fy(Te, "minutes", e.minutes))
        return !0;
      const { isMinuteDisabled: xe } = e;
      return xe ? xe(Te, Ke) : !1;
    }), de = j(() => {
      const { value: Te } = Ne, { value: Ke } = Ae, { value: xe } = $e;
      if (xe === null || Te === null || Ke === null)
        return !1;
      if (!fy(xe, "seconds", e.seconds))
        return !0;
      const { isSecondDisabled: Xe } = e;
      return Xe ? Xe(xe, Te, Ke) : !1;
    }), De = j(() => he.value || te.value || de.value), Oe = j(() => e.format.length + 4), Qe = j(() => {
      const { value: Te } = T;
      return Te === null ? null : ac(Te) < 12 ? "am" : "pm";
    }), Ae = j(() => {
      const { value: Te } = T;
      return Te === null ? null : Number(A.value(Te, "HH", w.value));
    }), Ne = j(() => {
      const { value: Te } = T;
      return Te === null ? null : Number(A.value(Te, "mm", w.value));
    }), $e = j(() => {
      const { value: Te } = T;
      return Te === null ? null : Number(A.value(Te, "ss", w.value));
    });
    function et(Te, Ke) {
      const { onUpdateFormattedValue: xe, "onUpdate:formattedValue": Xe } = e;
      xe && je(xe, Te, Ke), Xe && je(Xe, Te, Ke);
    }
    function Ge(Te) {
      return Te === null ? null : A.value(Te, e.valueFormat || e.format);
    }
    function Ee(Te) {
      const { onUpdateValue: Ke, "onUpdate:value": xe, onChange: Xe } = e, { nTriggerFormChange: At, nTriggerFormInput: Ht } = s, zt = Ge(Te);
      Ke && je(Ke, Te, zt), xe && je(xe, Te, zt), Xe && je(Xe, Te, zt), et(zt, Te), S.value = Te, At(), Ht();
    }
    function qe(Te) {
      const { onFocus: Ke } = e, { nTriggerFormFocus: xe } = s;
      Ke && je(Ke, Te), xe();
    }
    function Ue(Te) {
      const { onBlur: Ke } = e, { nTriggerFormBlur: xe } = s;
      Ke && je(Ke, Te), xe();
    }
    function ot() {
      const { onConfirm: Te } = e;
      Te && je(Te, T.value, Ge(T.value));
    }
    function Ie(Te) {
      var Ke;
      Te.stopPropagation(), Ee(null), ke(null), (Ke = e.onClear) === null || Ke === void 0 || Ke.call(e);
    }
    function rt() {
      ve({
        returnFocus: !0
      });
    }
    function W(Te) {
      Te.key === "Escape" && I.value && x0(Te);
    }
    function P(Te) {
      var Ke;
      switch (Te.key) {
        case "Escape":
          I.value && (x0(Te), ve({
            returnFocus: !0
          }));
          break;
        case "Tab":
          g.shift && Te.target === ((Ke = v.value) === null || Ke === void 0 ? void 0 : Ke.$el) && (Te.preventDefault(), ve({
            returnFocus: !0
          }));
          break;
      }
    }
    function H() {
      _.value = !0, an(() => {
        _.value = !1;
      });
    }
    function se(Te) {
      d.value || Bl(Te, "clear") || I.value || at();
    }
    function pe(Te) {
      typeof Te != "string" && (T.value === null ? Ee(Lt(pf(_le(new Date()), Te))) : Ee(Lt(pf(T.value, Te))));
    }
    function ae(Te) {
      typeof Te != "string" && (T.value === null ? Ee(Lt(OI(bae(new Date()), Te))) : Ee(Lt(OI(T.value, Te))));
    }
    function Me(Te) {
      typeof Te != "string" && (T.value === null ? Ee(Lt(_I(b4(new Date()), Te))) : Ee(Lt(_I(T.value, Te))));
    }
    function fe(Te) {
      const { value: Ke } = T;
      if (Ke === null) {
        const xe = new Date(), Xe = ac(xe);
        Te === "pm" && Xe < 12 ? Ee(Lt(pf(xe, Xe + 12))) : Te === "am" && Xe >= 12 && Ee(Lt(pf(xe, Xe - 12))), Ee(Lt(xe));
      } else {
        const xe = ac(Ke);
        Te === "pm" && xe < 12 ? Ee(Lt(pf(Ke, xe + 12))) : Te === "am" && xe >= 12 && Ee(Lt(pf(Ke, xe - 12)));
      }
    }
    function ke(Te) {
      Te === void 0 && (Te = T.value), Te === null ? D.value = "" : D.value = A.value(Te, e.format, w.value);
    }
    function Le(Te) {
      jt(Te) || qe(Te);
    }
    function dt(Te) {
      var Ke;
      if (!jt(Te))
        if (I.value) {
          const xe = (Ke = v.value) === null || Ke === void 0 ? void 0 : Ke.$el;
          xe != null && xe.contains(Te.relatedTarget) || (ke(), Ue(Te), ve({
            returnFocus: !1
          }));
        } else
          ke(), Ue(Te);
    }
    function Mt() {
      d.value || I.value || at();
    }
    function Ct() {
      d.value || (ke(), ve({
        returnFocus: !1
      }));
    }
    function er() {
      if (!v.value)
        return;
      const { hourScrollRef: Te, minuteScrollRef: Ke, secondScrollRef: xe, amPmScrollRef: Xe } = v.value;
      [Te, Ke, xe, Xe].forEach((At) => {
        var Ht;
        if (!At)
          return;
        const zt = (Ht = At.contentRef) === null || Ht === void 0 ? void 0 : Ht.querySelector("[data-active]");
        zt && At.scrollTo({
          top: zt.offsetTop
        });
      });
    }
    function Vt(Te) {
      E.value = Te;
      const { onUpdateShow: Ke, "onUpdate:show": xe } = e;
      Ke && je(Ke, Te), xe && je(xe, Te);
    }
    function jt(Te) {
      var Ke, xe, Xe;
      return !!(!((xe = (Ke = m.value) === null || Ke === void 0 ? void 0 : Ke.wrapperElRef) === null || xe === void 0) && xe.contains(Te.relatedTarget) || !((Xe = v.value) === null || Xe === void 0) && Xe.$el.contains(Te.relatedTarget));
    }
    function at() {
      $.value = T.value, Vt(!0), an(er);
    }
    function St(Te) {
      var Ke, xe;
      I.value && !(!((xe = (Ke = m.value) === null || Ke === void 0 ? void 0 : Ke.wrapperElRef) === null || xe === void 0) && xe.contains(Ul(Te))) && ve({
        returnFocus: !1
      });
    }
    function ve({ returnFocus: Te }) {
      var Ke;
      I.value && (Vt(!1), Te && ((Ke = m.value) === null || Ke === void 0 || Ke.focus()));
    }
    function We(Te) {
      if (Te === "") {
        Ee(null);
        return;
      }
      const Ke = ua(Te, e.format, new Date(), w.value);
      if (D.value = Te, rl(Ke)) {
        const { value: xe } = T;
        if (xe !== null) {
          const Xe = xo(xe, {
            hours: ac(Ke),
            minutes: J1(Ke),
            seconds: ex(Ke)
          });
          Ee(Lt(Xe));
        } else
          Ee(Lt(Ke));
      }
    }
    function ne() {
      Ee($.value), Vt(!1);
    }
    function Se() {
      const Te = new Date(), Ke = {
        hours: ac,
        minutes: J1,
        seconds: ex
      }, [xe, Xe, At] = ["hours", "minutes", "seconds"].map((zt) => !e[zt] || fy(Ke[zt](Te), zt, e[zt]) ? Ke[zt](Te) : K0e(Ke[zt](Te), zt, e[zt])), Ht = _I(OI(pf(T.value ? T.value : Lt(Te), xe), Xe), At);
      Ee(Lt(Ht));
    }
    function _e() {
      ke(), ot(), ve({
        returnFocus: !0
      });
    }
    function ut(Te) {
      jt(Te) || (ke(), Ue(Te), ve({
        returnFocus: !1
      }));
    }
    Gt(T, (Te) => {
      ke(Te), H(), an(er);
    }), Gt(I, () => {
      De.value && Ee($.value);
    }), tr(gW, {
      mergedThemeRef: h,
      mergedClsPrefixRef: r
    });
    const ht = {
      focus: () => {
        var Te;
        (Te = m.value) === null || Te === void 0 || Te.focus();
      },
      blur: () => {
        var Te;
        (Te = m.value) === null || Te === void 0 || Te.blur();
      }
    }, ye = j(() => {
      const { common: { cubicBezierEaseInOut: Te }, self: { iconColor: Ke, iconColorDisabled: xe } } = h.value;
      return {
        "--n-icon-color-override": Ke,
        "--n-icon-color-disabled-override": xe,
        "--n-bezier": Te
      };
    }), Ze = i ? Cr("time-picker-trigger", void 0, ye, e) : void 0, st = j(() => {
      const { self: { panelColor: Te, itemTextColor: Ke, itemTextColorActive: xe, itemColorHover: Xe, panelDividerColor: At, panelBoxShadow: Ht, itemOpacityDisabled: zt, borderRadius: ge, itemFontSize: Fe, itemWidth: Tt, itemHeight: lr, panelActionPadding: gr, itemBorderRadius: Or }, common: { cubicBezierEaseInOut: ri } } = h.value;
      return {
        "--n-bezier": ri,
        "--n-border-radius": ge,
        "--n-item-color-hover": Xe,
        "--n-item-font-size": Fe,
        "--n-item-height": lr,
        "--n-item-opacity-disabled": zt,
        "--n-item-text-color": Ke,
        "--n-item-text-color-active": xe,
        "--n-item-width": Tt,
        "--n-panel-action-padding": gr,
        "--n-panel-box-shadow": Ht,
        "--n-panel-color": Te,
        "--n-panel-divider-color": At,
        "--n-item-border-radius": Or
      };
    }), Nt = i ? Cr("time-picker", void 0, st, e) : void 0;
    return {
      focus: ht.focus,
      blur: ht.blur,
      mergedStatus: f,
      mergedBordered: t,
      mergedClsPrefix: r,
      namespace: n,
      uncontrolledValue: S,
      mergedValue: T,
      isMounted: ql(),
      inputInstRef: m,
      panelInstRef: v,
      adjustedTo: vi(e),
      mergedShow: I,
      localizedNow: R,
      localizedPlaceholder: U,
      localizedNegativeText: Q,
      localizedPositiveText: Z,
      hourInFormat: X,
      minuteInFormat: re,
      secondInFormat: ue,
      mergedAttrSize: Oe,
      displayTimeString: D,
      mergedSize: u,
      mergedDisabled: d,
      isValueInvalid: De,
      isHourInvalid: he,
      isMinuteInvalid: te,
      isSecondInvalid: de,
      transitionDisabled: _,
      hourValue: Ae,
      minuteValue: Ne,
      secondValue: $e,
      amPmValue: Qe,
      handleInputKeydown: W,
      handleTimeInputFocus: Le,
      handleTimeInputBlur: dt,
      handleNowClick: Se,
      handleConfirmClick: _e,
      handleTimeInputUpdateValue: We,
      handleMenuFocusOut: ut,
      handleCancelClick: ne,
      handleClickOutside: St,
      handleTimeInputActivate: Mt,
      handleTimeInputDeactivate: Ct,
      handleHourClick: pe,
      handleMinuteClick: ae,
      handleSecondClick: Me,
      handleAmPmClick: fe,
      handleTimeInputClear: Ie,
      handleFocusDetectorFocus: rt,
      handleMenuKeydown: P,
      handleTriggerClick: se,
      mergedTheme: h,
      triggerCssVars: i ? void 0 : ye,
      triggerThemeClass: Ze == null ? void 0 : Ze.themeClass,
      triggerOnRender: Ze == null ? void 0 : Ze.onRender,
      cssVars: i ? void 0 : st,
      themeClass: Nt == null ? void 0 : Nt.themeClass,
      onRender: Nt == null ? void 0 : Nt.onRender
    };
  },
  render() {
    const { mergedClsPrefix: e, $slots: t, triggerOnRender: r } = this;
    return r == null || r(), b("div", { class: [`${e}-time-picker`, this.triggerThemeClass], style: this.triggerCssVars }, b(zc, null, {
      default: () => [
        b($c, null, {
          default: () => b(pa, { ref: "inputInstRef", status: this.mergedStatus, value: this.displayTimeString, bordered: this.mergedBordered, passivelyActivated: !0, attrSize: this.mergedAttrSize, theme: this.mergedTheme.peers.Input, themeOverrides: this.mergedTheme.peerOverrides.Input, stateful: this.stateful, size: this.mergedSize, placeholder: this.localizedPlaceholder, clearable: this.clearable, disabled: this.mergedDisabled, textDecoration: this.isValueInvalid ? "line-through" : void 0, onFocus: this.handleTimeInputFocus, onBlur: this.handleTimeInputBlur, onActivate: this.handleTimeInputActivate, onDeactivate: this.handleTimeInputDeactivate, onUpdateValue: this.handleTimeInputUpdateValue, onClear: this.handleTimeInputClear, internalDeactivateOnEnter: !0, internalForceFocus: this.mergedShow, readonly: this.inputReadonly || this.mergedDisabled, onClick: this.handleTriggerClick, onKeydown: this.handleInputKeydown }, this.showIcon ? {
            [this.clearable ? "clear-icon-placeholder" : "suffix"]: () => b(fr, { clsPrefix: e, class: `${e}-time-picker-icon` }, {
              default: () => t.icon ? t.icon() : b(Cfe, null)
            })
          } : null)
        }),
        b(_c, { teleportDisabled: this.adjustedTo === vi.tdkey, show: this.mergedShow, to: this.adjustedTo, containerClass: this.namespace, placement: this.placement }, {
          default: () => b(jn, { name: "fade-in-scale-up-transition", appear: this.isMounted }, {
            default: () => {
              var n;
              return this.mergedShow ? ((n = this.onRender) === null || n === void 0 || n.call(this), Jn(b(ebe, { ref: "panelInstRef", actions: this.actions, class: this.themeClass, style: this.cssVars, seconds: this.seconds, minutes: this.minutes, hours: this.hours, transitionDisabled: this.transitionDisabled, hourValue: this.hourValue, showHour: this.hourInFormat, isHourInvalid: this.isHourInvalid, isHourDisabled: this.isHourDisabled, minuteValue: this.minuteValue, showMinute: this.minuteInFormat, isMinuteInvalid: this.isMinuteInvalid, isMinuteDisabled: this.isMinuteDisabled, secondValue: this.secondValue, amPmValue: this.amPmValue, showSecond: this.secondInFormat, isSecondInvalid: this.isSecondInvalid, isSecondDisabled: this.isSecondDisabled, isValueInvalid: this.isValueInvalid, nowText: this.localizedNow, confirmText: this.localizedPositiveText, use12Hours: this.use12Hours, onFocusout: this.handleMenuFocusOut, onKeydown: this.handleMenuKeydown, onHourClick: this.handleHourClick, onMinuteClick: this.handleMinuteClick, onSecondClick: this.handleSecondClick, onAmPmClick: this.handleAmPmClick, onNowClick: this.handleNowClick, onConfirmClick: this.handleConfirmClick, onFocusDetectorFocus: this.handleFocusDetectorFocus }), [
                [
                  ks,
                  this.handleClickOutside,
                  void 0,
                  { capture: !0 }
                ]
              ])) : null;
            }
          })
        })
      ]
    }));
  }
});
const nbe = "HH:mm:ss", mW = {
  active: Boolean,
  dateFormat: String,
  timeFormat: {
    type: String,
    value: nbe
  },
  value: {
    type: [Array, Number],
    default: null
  },
  shortcuts: Object,
  defaultTime: [Number, String, Array],
  onClear: Function,
  onConfirm: Function,
  onClose: Function,
  onTabOut: Function,
  onUpdateValue: {
    type: Function,
    required: !0
  },
  themeClass: String,
  onRender: Function,
  panel: Boolean
};
function vW(e) {
  const {
    dateLocaleRef: t,
    timePickerSizeRef: r,
    timePickerPropsRef: n,
    localeRef: i,
    mergedClsPrefixRef: o,
    mergedThemeRef: a
  } = lt(QM), s = j(() => ({
    locale: t.value.locale
  })), u = G(null), d = KO();
  function f() {
    const { onClear: R } = e;
    R && R();
  }
  function h() {
    const { onConfirm: R, value: U } = e;
    R && R(U);
  }
  function g(R, U) {
    const { onUpdateValue: Q } = e;
    Q(R, U);
  }
  function m(R = !1) {
    const { onClose: U } = e;
    U && U(R);
  }
  function v() {
    const { onTabOut: R } = e;
    R && R();
  }
  function w() {
    g(null, !0), m(!0), f();
  }
  function x() {
    v();
  }
  function y() {
    (e.active || e.panel) && an(() => {
      const { value: R } = u;
      if (!R)
        return;
      const U = R.querySelectorAll("[data-n-date]");
      U.forEach((Q) => {
        Q.classList.add("transition-disabled");
      }), R.offsetWidth, U.forEach((Q) => {
        Q.classList.remove("transition-disabled");
      });
    });
  }
  function C(R) {
    R.key === "Tab" && R.target === u.value && d.shift && (R.preventDefault(), v());
  }
  function S(R) {
    const { value: U } = u;
    d.tab && R.target === U && (U != null && U.contains(R.relatedTarget)) && v();
  }
  let T = null, A = !1;
  function D() {
    T = e.value, A = !0;
  }
  function E() {
    A = !1;
  }
  function N() {
    A && (g(T, !1), A = !1);
  }
  function I(R) {
    return typeof R == "function" ? R() : R;
  }
  const $ = G(!1);
  function _() {
    $.value = !$.value;
  }
  return {
    mergedTheme: a,
    mergedClsPrefix: o,
    dateFnsOptions: s,
    timePickerSize: r,
    timePickerProps: n,
    selfRef: u,
    locale: i,
    doConfirm: h,
    doClose: m,
    doUpdateValue: g,
    doTabOut: v,
    handleClearClick: w,
    handleFocusDetectorFocus: x,
    disableTransitionOneTick: y,
    handlePanelKeyDown: C,
    handlePanelFocus: S,
    cachePendingValue: D,
    clearPendingValue: E,
    restorePendingValue: N,
    getShortcutValue: I,
    handleShortcutMouseleave: N,
    showMonthYearPanel: $,
    handleOpenQuickSelectMonthPanel: _
  };
}
const L4 = Object.assign(Object.assign({}, mW), { actions: {
  type: Array,
  default: () => ["now", "clear", "confirm"]
} });
function P4(e, t) {
  const r = vW(e), {
    isValueInvalidRef: n,
    isDateDisabledRef: i,
    isDateInvalidRef: o,
    isTimeInvalidRef: a,
    isDateTimeInvalidRef: s,
    isHourDisabledRef: u,
    isMinuteDisabledRef: d,
    isSecondDisabledRef: f,
    localeRef: h,
    firstDayOfWeekRef: g,
    datePickerSlots: m
  } = lt(QM), v = {
    isValueInvalid: n,
    isDateDisabled: i,
    isDateInvalid: o,
    isTimeInvalid: a,
    isDateTimeInvalid: s,
    isHourDisabled: u,
    isMinuteDisabled: d,
    isSecondDisabled: f
  }, w = j(() => e.dateFormat || h.value.dateFormat), x = G(e.value === null || Array.isArray(e.value) ? "" : Xn(e.value, w.value)), y = G(e.value === null || Array.isArray(e.value) ? Date.now() : e.value), C = G(null), S = G(null), T = G(null), A = G(Date.now()), D = j(() => {
    var P;
    return Cz(y.value, e.value, A.value, (P = g.value) !== null && P !== void 0 ? P : h.value.firstDayOfWeek);
  }), E = j(() => {
    const { value: P } = e;
    return Sz(y.value, Array.isArray(P) ? null : P, A.value);
  }), N = j(() => {
    const { value: P } = e;
    return kz(Array.isArray(P) ? null : P, A.value);
  }), I = j(() => {
    const { value: P } = e;
    return Tz(y.value, Array.isArray(P) ? null : P, A.value);
  }), $ = j(() => D.value.slice(0, 7).map((P) => {
    const { ts: H } = P;
    return Xn(H, h.value.dayFormat, r.dateFnsOptions.value);
  })), _ = j(() => Xn(y.value, h.value.monthFormat, r.dateFnsOptions.value)), R = j(() => Xn(y.value, h.value.yearFormat, r.dateFnsOptions.value));
  Gt(y, (P, H) => {
    (t === "date" || t === "datetime") && (jM(P, H) || r.disableTransitionOneTick());
  }), Gt(j(() => e.value), (P) => {
    P !== null && !Array.isArray(P) ? (x.value = Xn(P, w.value, r.dateFnsOptions.value), y.value = P) : x.value = "";
  });
  function U(P) {
    return Lt(t === "datetime" ? b4(P) : t === "month" ? Iu(P) : t === "year" ? p4(P) : t === "quarter" ? k0(P) : K1(P));
  }
  function Q(P) {
    const { isDateDisabled: { value: H } } = v;
    return H ? H(P) : !1;
  }
  function Z(P) {
    const H = ua(P, w.value, new Date(), r.dateFnsOptions.value);
    if (rl(H)) {
      if (e.value === null)
        r.doUpdateValue(Lt(U(Date.now())), e.panel);
      else if (!Array.isArray(e.value)) {
        const se = xo(e.value, {
          year: si(H),
          month: Gn(H),
          date: $l(H)
        });
        r.doUpdateValue(Lt(U(Lt(se))), e.panel);
      }
    } else
      x.value = P;
  }
  function X() {
    const P = ua(x.value, w.value, new Date(), r.dateFnsOptions.value);
    if (rl(P)) {
      if (e.value === null)
        r.doUpdateValue(Lt(U(Date.now())), !1);
      else if (!Array.isArray(e.value)) {
        const H = xo(e.value, {
          year: si(P),
          month: Gn(P),
          date: $l(P)
        });
        r.doUpdateValue(Lt(U(Lt(H))), !1);
      }
    } else
      De();
  }
  function re() {
    r.doUpdateValue(null, !0), x.value = "", r.doClose(!0), r.handleClearClick();
  }
  function ue() {
    r.doUpdateValue(Lt(U(Date.now())), !0);
    const P = Date.now();
    y.value = P, r.doClose(!0), e.panel && (t === "month" || t === "quarter" || t === "year") && (r.disableTransitionOneTick(), rt(P));
  }
  function he(P) {
    if (Q(P.ts))
      return;
    let H;
    if (e.value !== null && !Array.isArray(e.value) ? H = e.value : H = Date.now(), t === "datetime" && e.defaultTime !== null && !Array.isArray(e.defaultTime)) {
      const se = Zy(e.defaultTime);
      se && (H = Lt(xo(H, se)));
    }
    switch (H = Lt(P.type === "quarter" && P.dateObject.quarter ? Lle(kP(H, P.dateObject.year), P.dateObject.quarter) : xo(H, P.dateObject)), r.doUpdateValue(U(H), e.panel || t === "date" || t === "year"), t) {
      case "date":
        r.doClose();
        break;
      case "year":
        e.panel && r.disableTransitionOneTick(), r.doClose();
        break;
      case "month":
        r.disableTransitionOneTick(), rt(H);
        break;
      case "quarter":
        r.disableTransitionOneTick(), rt(H);
        break;
    }
  }
  function te(P, H) {
    let se;
    e.value !== null && !Array.isArray(e.value) ? se = e.value : se = Date.now(), se = Lt(P.type === "month" ? y4(se, P.dateObject.month) : kP(se, P.dateObject.year)), H(se), rt(se);
  }
  function de(P) {
    y.value = P;
  }
  function De(P) {
    if (e.value === null || Array.isArray(e.value)) {
      x.value = "";
      return;
    }
    P === void 0 && (P = e.value), x.value = Xn(P, w.value, r.dateFnsOptions.value);
  }
  function Oe() {
    v.isDateInvalid.value || v.isTimeInvalid.value || (r.doConfirm(), Qe());
  }
  function Qe() {
    e.active && r.doClose();
  }
  function Ae() {
    y.value = Lt(bz(y.value, 1));
  }
  function Ne() {
    y.value = Lt(bz(y.value, -1));
  }
  function $e() {
    y.value = Lt(yo(y.value, 1));
  }
  function et() {
    y.value = Lt(yo(y.value, -1));
  }
  function Ge() {
    const { value: P } = C;
    return P == null ? void 0 : P.listElRef;
  }
  function Ee() {
    const { value: P } = C;
    return P == null ? void 0 : P.itemsElRef;
  }
  function qe(P) {
    var H;
    (H = S.value) === null || H === void 0 || H.sync();
  }
  function Ue(P) {
    P !== null && r.doUpdateValue(P, e.panel);
  }
  function ot(P) {
    r.cachePendingValue();
    const H = r.getShortcutValue(P);
    typeof H == "number" && r.doUpdateValue(H, !1);
  }
  function Ie(P) {
    const H = r.getShortcutValue(P);
    typeof H == "number" && (r.doUpdateValue(H, e.panel), r.clearPendingValue(), Oe());
  }
  function rt(P) {
    const { value: H } = e;
    if (T.value) {
      const se = Gn(P === void 0 ? H === null ? Date.now() : H : P);
      T.value.scrollTo({ top: se * th });
    }
    if (C.value) {
      const se = si(P === void 0 ? H === null ? Date.now() : H : P) - ox;
      C.value.scrollTo({ top: se * th });
    }
  }
  const W = {
    monthScrollbarRef: T,
    yearScrollbarRef: S,
    yearVlRef: C
  };
  return Object.assign(Object.assign(Object.assign(Object.assign({
    dateArray: D,
    monthArray: E,
    yearArray: N,
    quarterArray: I,
    calendarYear: R,
    calendarMonth: _,
    weekdays: $,
    mergedIsDateDisabled: Q,
    nextYear: Ae,
    prevYear: Ne,
    nextMonth: $e,
    prevMonth: et,
    handleNowClick: ue,
    handleConfirmClick: Oe,
    handleSingleShortcutMouseenter: ot,
    handleSingleShortcutClick: Ie
  }, v), r), W), {
    handleDateClick: he,
    handleDateInputBlur: X,
    handleDateInput: Z,
    handleTimePickerChange: Ue,
    clearSelectedDateTime: re,
    virtualListContainer: Ge,
    virtualListContent: Ee,
    handleVirtualListScroll: qe,
    timePickerSize: r.timePickerSize,
    dateInputValue: x,
    datePickerSlots: m,
    handleQuickMonthClick: te,
    justifyColumnsScrollState: rt,
    calendarValue: y,
    onUpdateCalendarValue: de
  });
}
var bW = oe({
  name: "MonthPanel",
  props: Object.assign(Object.assign({}, L4), {
    type: {
      type: String,
      required: !0
    },
    useAsQuickJump: Boolean
  }),
  setup(e) {
    const t = P4(e, e.type), r = (o) => {
      switch (o.type) {
        case "year":
          return o.dateObject.year;
        case "month":
          return o.dateObject.month + 1;
        case "quarter":
          return `Q${o.dateObject.quarter}`;
      }
    }, { useAsQuickJump: n } = e, i = (o, a, s) => {
      const { mergedIsDateDisabled: u, handleDateClick: d, handleQuickMonthClick: f } = t;
      return b("div", { "data-n-date": !0, key: a, class: [
        `${s}-date-panel-month-calendar__picker-col-item`,
        {
          [`${s}-date-panel-month-calendar__picker-col-item--current`]: o.isCurrent,
          [`${s}-date-panel-month-calendar__picker-col-item--selected`]: o.selected,
          [`${s}-date-panel-month-calendar__picker-col-item--disabled`]: !n && u(o.ts)
        }
      ], onClick: () => {
        n ? f(o, (h) => {
          e.onUpdateValue(h, !1);
        }) : d(o);
      } }, r(o));
    };
    return br(() => {
      t.justifyColumnsScrollState();
    }), Object.assign(Object.assign({}, t), { renderItem: i });
  },
  render() {
    const { mergedClsPrefix: e, mergedTheme: t, shortcuts: r, actions: n, renderItem: i, type: o, onRender: a } = this;
    return a == null || a(), b("div", { ref: "selfRef", tabindex: 0, class: [
      `${e}-date-panel`,
      `${e}-date-panel--month`,
      !this.panel && `${e}-date-panel--shadow`,
      this.themeClass
    ], onFocus: this.handlePanelFocus, onKeydown: this.handlePanelKeyDown }, b("div", { class: `${e}-date-panel-month-calendar` }, b(no, { ref: "yearScrollbarRef", class: `${e}-date-panel-month-calendar__picker-col`, theme: t.peers.Scrollbar, themeOverrides: t.peerOverrides.Scrollbar, container: this.virtualListContainer, content: this.virtualListContent, horizontalRailStyle: { zIndex: 1 }, verticalRailStyle: { zIndex: 1 } }, {
      default: () => b(M0, { ref: "yearVlRef", items: this.yearArray, itemSize: th, showScrollbar: !1, keyField: "ts", onScroll: this.handleVirtualListScroll, paddingBottom: 4 }, {
        default: ({ item: s, index: u }) => i(s, u, e)
      })
    }), o === "month" || o === "quarter" ? b("div", { class: `${e}-date-panel-month-calendar__picker-col` }, b(no, { ref: "monthScrollbarRef", theme: t.peers.Scrollbar, themeOverrides: t.peerOverrides.Scrollbar }, {
      default: () => [
        (o === "month" ? this.monthArray : this.quarterArray).map((s, u) => i(s, u, e)),
        b("div", { class: `${e}-date-panel-${o}-calendar__padding` })
      ]
    })) : null), this.datePickerSlots.footer ? b("div", { class: `${e}-date-panel-footer` }, {
      default: this.datePickerSlots.footer
    }) : null, n != null && n.length || r ? b("div", { class: `${e}-date-panel-actions` }, b("div", { class: `${e}-date-panel-actions__prefix` }, r && Object.keys(r).map((s) => {
      const u = r[s];
      return Array.isArray(u) ? null : b(bs, { size: "tiny", onMouseenter: () => {
        this.handleSingleShortcutMouseenter(u);
      }, onClick: () => {
        this.handleSingleShortcutClick(u);
      }, onMouseleave: () => {
        this.handleShortcutMouseleave();
      } }, { default: () => s });
    })), b("div", { class: `${e}-date-panel-actions__suffix` }, n != null && n.includes("clear") ? b(Mn, { theme: t.peers.Button, themeOverrides: t.peerOverrides.Button, size: "tiny", onClick: this.handleClearClick }, { default: () => this.locale.clear }) : null, n != null && n.includes("now") ? b(Mn, { theme: t.peers.Button, themeOverrides: t.peerOverrides.Button, size: "tiny", onClick: this.handleNowClick }, { default: () => this.locale.now }) : null, n != null && n.includes("confirm") ? b(Mn, { theme: t.peers.Button, themeOverrides: t.peerOverrides.Button, size: "tiny", type: "primary", disabled: this.isDateInvalid, onClick: this.handleConfirmClick }, { default: () => this.locale.confirm }) : null)) : null, b(Pc, { onFocus: this.handleFocusDetectorFocus }));
  }
}), xp = oe({
  props: {
    mergedClsPrefix: {
      type: String,
      required: !0
    },
    value: Number,
    monthBeforeYear: {
      type: Boolean,
      required: !0
    },
    calendarMonth: {
      type: String,
      required: !0
    },
    calendarYear: {
      type: String,
      required: !0
    },
    onUpdateValue: {
      type: Function,
      required: !0
    }
  },
  setup() {
    const e = G(null), t = G(null), r = G(!1);
    function n(o) {
      var a;
      r.value && !(!((a = e.value) === null || a === void 0) && a.contains(Ul(o))) && (r.value = !1);
    }
    function i() {
      r.value = !r.value;
    }
    return {
      show: r,
      triggerRef: e,
      monthPanelRef: t,
      handleHeaderClick: i,
      handleClickOutside: n
    };
  },
  render() {
    const { handleClickOutside: e, mergedClsPrefix: t } = this;
    return b("div", { class: `${t}-date-panel-month__month-year`, ref: "triggerRef" }, b(zc, null, {
      default: () => [
        b($c, null, {
          default: () => b("div", { class: [
            `${t}-date-panel-month__text`,
            this.show && `${t}-date-panel-month__text--active`
          ], onClick: this.handleHeaderClick }, this.monthBeforeYear ? [this.calendarMonth, " ", this.calendarYear] : [this.calendarYear, " ", this.calendarMonth])
        }),
        b(_c, { show: this.show, teleportDisabled: !0 }, {
          default: () => b(jn, { name: "fade-in-scale-up-transition", appear: !0 }, {
            default: () => this.show ? Jn(b(bW, {
              ref: "monthPanelRef",
              onUpdateValue: this.onUpdateValue,
              actions: [],
              type: "month",
              key: "month",
              useAsQuickJump: !0,
              value: this.value
            }), [
              [
                ks,
                e,
                void 0,
                { capture: !0 }
              ]
            ]) : null
          })
        })
      ]
    }));
  }
}), ibe = oe({
  name: "DateTimePanel",
  props: L4,
  setup(e) {
    return P4(e, "datetime");
  },
  render() {
    var e, t, r, n;
    const { mergedClsPrefix: i, mergedTheme: o, shortcuts: a, timePickerProps: s, onRender: u, $slots: d } = this;
    return u == null || u(), b("div", { ref: "selfRef", tabindex: 0, class: [
      `${i}-date-panel`,
      `${i}-date-panel--datetime`,
      !this.panel && `${i}-date-panel--shadow`,
      this.themeClass
    ], onKeydown: this.handlePanelKeyDown, onFocus: this.handlePanelFocus }, b("div", { class: `${i}-date-panel-header` }, b(pa, { value: this.dateInputValue, theme: o.peers.Input, themeOverrides: o.peerOverrides.Input, stateful: !1, size: this.timePickerSize, class: `${i}-date-panel-date-input`, textDecoration: this.isDateInvalid ? "line-through" : "", placeholder: this.locale.selectDate, onBlur: this.handleDateInputBlur, onUpdateValue: this.handleDateInput }), b(dx, Object.assign({ size: this.timePickerSize, placeholder: this.locale.selectTime, format: this.timeFormat }, Array.isArray(s) ? void 0 : s, { showIcon: !1, to: !1, theme: o.peers.TimePicker, themeOverrides: o.peerOverrides.TimePicker, value: Array.isArray(this.value) ? null : this.value, isHourDisabled: this.isHourDisabled, isMinuteDisabled: this.isMinuteDisabled, isSecondDisabled: this.isSecondDisabled, onUpdateValue: this.handleTimePickerChange, stateful: !1 }))), b("div", { class: `${i}-date-panel-calendar` }, b("div", { class: `${i}-date-panel-month` }, b("div", { class: `${i}-date-panel-month__fast-prev`, onClick: this.prevYear }, vr(d["prev-year"], () => [b(Mc, null)])), b("div", { class: `${i}-date-panel-month__prev`, onClick: this.prevMonth }, vr(d["prev-month"], () => [b(wc, null)])), b(xp, { monthBeforeYear: this.locale.monthBeforeYear, value: this.calendarValue, onUpdateValue: this.onUpdateCalendarValue, mergedClsPrefix: i, calendarMonth: this.calendarMonth, calendarYear: this.calendarYear }), b("div", { class: `${i}-date-panel-month__next`, onClick: this.nextMonth }, vr(d["next-month"], () => [b(Sc, null)])), b("div", { class: `${i}-date-panel-month__fast-next`, onClick: this.nextYear }, vr(d["next-year"], () => [b(Cc, null)]))), b("div", { class: `${i}-date-panel-weekdays` }, this.weekdays.map((f) => b("div", { key: f, class: `${i}-date-panel-weekdays__day` }, f))), b("div", { class: `${i}-date-panel-dates` }, this.dateArray.map((f, h) => b("div", { "data-n-date": !0, key: h, class: [
      `${i}-date-panel-date`,
      {
        [`${i}-date-panel-date--current`]: f.isCurrentDate,
        [`${i}-date-panel-date--selected`]: f.selected,
        [`${i}-date-panel-date--excluded`]: !f.inCurrentMonth,
        [`${i}-date-panel-date--disabled`]: this.mergedIsDateDisabled(f.ts)
      }
    ], onClick: () => {
      this.handleDateClick(f);
    } }, b("div", { class: `${i}-date-panel-date__trigger` }), f.dateObject.date, f.isCurrentDate ? b("div", { class: `${i}-date-panel-date__sup` }) : null)))), this.datePickerSlots.footer ? b("div", { class: `${i}-date-panel-footer` }, this.datePickerSlots.footer()) : null, !((e = this.actions) === null || e === void 0) && e.length || a ? b("div", { class: `${i}-date-panel-actions` }, b("div", { class: `${i}-date-panel-actions__prefix` }, a && Object.keys(a).map((f) => {
      const h = a[f];
      return Array.isArray(h) ? null : b(bs, { size: "tiny", onMouseenter: () => {
        this.handleSingleShortcutMouseenter(h);
      }, onClick: () => {
        this.handleSingleShortcutClick(h);
      }, onMouseleave: () => {
        this.handleShortcutMouseleave();
      } }, { default: () => f });
    })), b("div", { class: `${i}-date-panel-actions__suffix` }, !((t = this.actions) === null || t === void 0) && t.includes("clear") ? b(Mn, { theme: o.peers.Button, themeOverrides: o.peerOverrides.Button, size: "tiny", onClick: this.clearSelectedDateTime }, { default: () => this.locale.clear }) : null, !((r = this.actions) === null || r === void 0) && r.includes("now") ? b(Mn, { theme: o.peers.Button, themeOverrides: o.peerOverrides.Button, size: "tiny", onClick: this.handleNowClick }, { default: () => this.locale.now }) : null, !((n = this.actions) === null || n === void 0) && n.includes("confirm") ? b(Mn, { theme: o.peers.Button, themeOverrides: o.peerOverrides.Button, size: "tiny", type: "primary", disabled: this.isDateInvalid, onClick: this.handleConfirmClick }, { default: () => this.locale.confirm }) : null)) : null, b(Pc, { onFocus: this.handleFocusDetectorFocus }));
  }
});
const R4 = Object.assign(Object.assign({}, mW), { defaultCalendarStartTime: Number, defaultCalendarEndTime: Number, bindCalendarMonths: Boolean, actions: {
  type: Array,
  default: () => ["clear", "confirm"]
} });
function j4(e, t) {
  var r, n;
  const {
    isDateDisabledRef: i,
    isStartHourDisabledRef: o,
    isEndHourDisabledRef: a,
    isStartMinuteDisabledRef: s,
    isEndMinuteDisabledRef: u,
    isStartSecondDisabledRef: d,
    isEndSecondDisabledRef: f,
    isStartDateInvalidRef: h,
    isEndDateInvalidRef: g,
    isStartTimeInvalidRef: m,
    isEndTimeInvalidRef: v,
    isStartValueInvalidRef: w,
    isEndValueInvalidRef: x,
    isRangeInvalidRef: y,
    localeRef: C,
    rangesRef: S,
    closeOnSelectRef: T,
    updateValueOnCloseRef: A,
    firstDayOfWeekRef: D,
    datePickerSlots: E
  } = lt(QM), N = {
    isDateDisabled: i,
    isStartHourDisabled: o,
    isEndHourDisabled: a,
    isStartMinuteDisabled: s,
    isEndMinuteDisabled: u,
    isStartSecondDisabled: d,
    isEndSecondDisabled: f,
    isStartDateInvalid: h,
    isEndDateInvalid: g,
    isStartTimeInvalid: m,
    isEndTimeInvalid: v,
    isStartValueInvalid: w,
    isEndValueInvalid: x,
    isRangeInvalid: y
  }, I = vW(e), $ = G(null), _ = G(null), R = G(null), U = G(null), Q = G(null), Z = G(null), X = G(null), re = G(null), { value: ue } = e, he = (r = e.defaultCalendarStartTime) !== null && r !== void 0 ? r : Array.isArray(ue) && typeof ue[0] == "number" ? ue[0] : Date.now(), te = G(he), de = G((n = e.defaultCalendarEndTime) !== null && n !== void 0 ? n : Array.isArray(ue) && typeof ue[1] == "number" ? ue[1] : Lt(yo(he, 1)));
  dt(!0);
  const De = G(Date.now()), Oe = G(!1), Qe = G(0), Ae = j(() => e.dateFormat || C.value.dateFormat), Ne = G(Array.isArray(ue) ? Xn(ue[0], Ae.value, I.dateFnsOptions.value) : ""), $e = G(Array.isArray(ue) ? Xn(ue[1], Ae.value, I.dateFnsOptions.value) : ""), et = j(() => Oe.value ? "end" : "start"), Ge = j(() => {
    var ze;
    return Cz(te.value, e.value, De.value, (ze = D.value) !== null && ze !== void 0 ? ze : C.value.firstDayOfWeek);
  }), Ee = j(() => {
    var ze;
    return Cz(de.value, e.value, De.value, (ze = D.value) !== null && ze !== void 0 ? ze : C.value.firstDayOfWeek);
  }), qe = j(() => Ge.value.slice(0, 7).map((ze) => {
    const { ts: wt } = ze;
    return Xn(wt, C.value.dayFormat, I.dateFnsOptions.value);
  })), Ue = j(() => Xn(te.value, C.value.monthFormat, I.dateFnsOptions.value)), ot = j(() => Xn(de.value, C.value.monthFormat, I.dateFnsOptions.value)), Ie = j(() => Xn(te.value, C.value.yearFormat, I.dateFnsOptions.value)), rt = j(() => Xn(de.value, C.value.yearFormat, I.dateFnsOptions.value)), W = j(() => {
    const { value: ze } = e;
    return Array.isArray(ze) ? ze[0] : null;
  }), P = j(() => {
    const { value: ze } = e;
    return Array.isArray(ze) ? ze[1] : null;
  }), H = j(() => {
    const { shortcuts: ze } = e;
    return ze || S.value;
  }), se = j(() => kz(Nh(e.value, "start"), De.value)), pe = j(() => kz(Nh(e.value, "end"), De.value)), ae = j(() => {
    const ze = Nh(e.value, "start");
    return Tz(ze ?? Date.now(), ze, De.value);
  }), Me = j(() => {
    const ze = Nh(e.value, "end");
    return Tz(ze ?? Date.now(), ze, De.value);
  }), fe = j(() => {
    const ze = Nh(e.value, "start");
    return Sz(ze ?? Date.now(), ze, De.value);
  }), ke = j(() => {
    const ze = Nh(e.value, "end");
    return Sz(ze ?? Date.now(), ze, De.value);
  });
  Gt(j(() => e.value), (ze) => {
    if (ze !== null && Array.isArray(ze)) {
      const [wt, Ut] = ze;
      Ne.value = Xn(wt, Ae.value, I.dateFnsOptions.value), $e.value = Xn(Ut, Ae.value, I.dateFnsOptions.value), Oe.value || _e(ze);
    } else
      Ne.value = "", $e.value = "";
  });
  function Le(ze, wt) {
    (t === "daterange" || t === "datetimerange") && (si(ze) !== si(wt) || Gn(ze) !== Gn(wt)) && I.disableTransitionOneTick();
  }
  Gt(te, Le), Gt(de, Le);
  function dt(ze) {
    const wt = Iu(te.value), Ut = Iu(de.value);
    (e.bindCalendarMonths || wt >= Ut) && (ze ? de.value = Lt(yo(wt, 1)) : te.value = Lt(yo(Ut, -1)));
  }
  function Mt() {
    te.value = Lt(yo(te.value, 12)), dt(!0);
  }
  function Ct() {
    te.value = Lt(yo(te.value, -12)), dt(!0);
  }
  function er() {
    te.value = Lt(yo(te.value, 1)), dt(!0);
  }
  function Vt() {
    te.value = Lt(yo(te.value, -1)), dt(!0);
  }
  function jt() {
    de.value = Lt(yo(de.value, 12)), dt(!1);
  }
  function at() {
    de.value = Lt(yo(de.value, -12)), dt(!1);
  }
  function St() {
    de.value = Lt(yo(de.value, 1)), dt(!1);
  }
  function ve() {
    de.value = Lt(yo(de.value, -1)), dt(!1);
  }
  function We(ze) {
    te.value = ze, dt(!0);
  }
  function ne(ze) {
    de.value = ze, dt(!1);
  }
  function Se(ze) {
    const wt = i.value;
    if (!wt)
      return !1;
    if (!Array.isArray(e.value) || et.value === "start")
      return wt(ze, "start", null);
    {
      const { value: Ut } = Qe;
      return ze < Qe.value ? wt(ze, "start", [
        Ut,
        Ut
      ]) : wt(ze, "end", [
        Ut,
        Ut
      ]);
    }
  }
  function _e(ze) {
    if (ze === null)
      return;
    const [wt, Ut] = ze;
    te.value = wt, Iu(Ut) <= Iu(wt) ? de.value = Lt(Iu(yo(wt, 1))) : de.value = Lt(Iu(Ut));
  }
  function ut(ze) {
    if (!Oe.value)
      Oe.value = !0, Qe.value = ze.ts, Te(ze.ts, ze.ts, "done");
    else {
      Oe.value = !1;
      const { value: wt } = e;
      e.panel && Array.isArray(wt) ? Te(wt[0], wt[1], "done") : T.value && t === "daterange" && (A.value ? Ze() : ye());
    }
  }
  function ht(ze) {
    if (Oe.value) {
      if (Se(ze.ts))
        return;
      ze.ts >= Qe.value ? Te(Qe.value, ze.ts, "wipPreview") : Te(ze.ts, Qe.value, "wipPreview");
    }
  }
  function ye() {
    y.value || (I.doConfirm(), Ze());
  }
  function Ze() {
    Oe.value = !1, e.active && I.doClose();
  }
  function st(ze) {
    typeof ze != "number" && (ze = Lt(ze)), e.value === null ? I.doUpdateValue([ze, ze], e.panel) : Array.isArray(e.value) && I.doUpdateValue([ze, Math.max(e.value[1], ze)], e.panel);
  }
  function Nt(ze) {
    typeof ze != "number" && (ze = Lt(ze)), e.value === null ? I.doUpdateValue([ze, ze], e.panel) : Array.isArray(e.value) && I.doUpdateValue([Math.min(e.value[0], ze), ze], e.panel);
  }
  function Te(ze, wt, Ut) {
    if (typeof ze != "number" && (ze = Lt(ze)), Ut !== "shortcutPreview") {
      let Wr, ct;
      if (t === "datetimerange") {
        const { defaultTime: en } = e;
        Array.isArray(en) ? (Wr = Zy(en[0]), ct = Zy(en[1])) : (Wr = Zy(en), ct = Wr);
      }
      Wr && (ze = Lt(xo(ze, Wr))), ct && (wt = Lt(xo(wt, ct)));
    }
    I.doUpdateValue([ze, wt], e.panel && Ut === "done");
  }
  function Ke(ze) {
    return Lt(t === "datetimerange" ? b4(ze) : t === "monthrange" ? Iu(ze) : K1(ze));
  }
  function xe(ze) {
    const wt = ua(ze, Ae.value, new Date(), I.dateFnsOptions.value);
    if (rl(wt))
      if (e.value) {
        if (Array.isArray(e.value)) {
          const Ut = xo(e.value[0], {
            year: si(wt),
            month: Gn(wt),
            date: $l(wt)
          });
          st(Ke(Lt(Ut)));
        }
      } else {
        const Ut = xo(new Date(), {
          year: si(wt),
          month: Gn(wt),
          date: $l(wt)
        });
        st(Ke(Lt(Ut)));
      }
    else
      Ne.value = ze;
  }
  function Xe(ze) {
    const wt = ua(ze, Ae.value, new Date(), I.dateFnsOptions.value);
    if (rl(wt)) {
      if (e.value === null) {
        const Ut = xo(new Date(), {
          year: si(wt),
          month: Gn(wt),
          date: $l(wt)
        });
        Nt(Ke(Lt(Ut)));
      } else if (Array.isArray(e.value)) {
        const Ut = xo(e.value[1], {
          year: si(wt),
          month: Gn(wt),
          date: $l(wt)
        });
        Nt(Ke(Lt(Ut)));
      }
    } else
      $e.value = ze;
  }
  function At() {
    const ze = ua(Ne.value, Ae.value, new Date(), I.dateFnsOptions.value), { value: wt } = e;
    if (rl(ze)) {
      if (wt === null) {
        const Ut = xo(new Date(), {
          year: si(ze),
          month: Gn(ze),
          date: $l(ze)
        });
        st(Ke(Lt(Ut)));
      } else if (Array.isArray(wt)) {
        const Ut = xo(wt[0], {
          year: si(ze),
          month: Gn(ze),
          date: $l(ze)
        });
        st(Ke(Lt(Ut)));
      }
    } else
      zt();
  }
  function Ht() {
    const ze = ua($e.value, Ae.value, new Date(), I.dateFnsOptions.value), { value: wt } = e;
    if (rl(ze)) {
      if (wt === null) {
        const Ut = xo(new Date(), {
          year: si(ze),
          month: Gn(ze),
          date: $l(ze)
        });
        Nt(Ke(Lt(Ut)));
      } else if (Array.isArray(wt)) {
        const Ut = xo(wt[1], {
          year: si(ze),
          month: Gn(ze),
          date: $l(ze)
        });
        Nt(Ke(Lt(Ut)));
      }
    } else
      zt();
  }
  function zt(ze) {
    const { value: wt } = e;
    if (wt === null || !Array.isArray(wt)) {
      Ne.value = "", $e.value = "";
      return;
    }
    ze === void 0 && (ze = wt), Ne.value = Xn(ze[0], Ae.value, I.dateFnsOptions.value), $e.value = Xn(ze[1], Ae.value, I.dateFnsOptions.value);
  }
  function ge(ze) {
    ze !== null && st(ze);
  }
  function Fe(ze) {
    ze !== null && Nt(ze);
  }
  function Tt(ze) {
    I.cachePendingValue();
    const wt = I.getShortcutValue(ze);
    Array.isArray(wt) && Te(wt[0], wt[1], "shortcutPreview");
  }
  function lr(ze) {
    const wt = I.getShortcutValue(ze);
    Array.isArray(wt) && (Te(wt[0], wt[1], "done"), I.clearPendingValue(), ye());
  }
  function gr(ze, wt) {
    const Ut = ze === void 0 ? e.value : ze;
    if (ze === void 0 || wt === "start") {
      if (X.value) {
        const Wr = Array.isArray(Ut) ? Gn(Ut[0]) : Gn(Date.now());
        X.value.scrollTo({
          debounce: !1,
          index: Wr,
          elSize: th
        });
      }
      if (Q.value) {
        const Wr = (Array.isArray(Ut) ? si(Ut[0]) : si(Date.now())) - ox;
        Q.value.scrollTo({ index: Wr, debounce: !1 });
      }
    }
    if (ze === void 0 || wt === "end") {
      if (re.value) {
        const Wr = Array.isArray(Ut) ? Gn(Ut[1]) : Gn(Date.now());
        re.value.scrollTo({
          debounce: !1,
          index: Wr,
          elSize: th
        });
      }
      if (Z.value) {
        const Wr = (Array.isArray(Ut) ? si(Ut[1]) : si(Date.now())) - ox;
        Z.value.scrollTo({ index: Wr, debounce: !1 });
      }
    }
  }
  function Or(ze, wt) {
    const { value: Ut } = e, Wr = !Array.isArray(Ut), ct = ze.type === "year" && t !== "yearrange" ? Wr ? xo(ze.ts, {
      month: Gn(t === "quarterrange" ? k0(new Date()) : new Date())
    }).valueOf() : xo(ze.ts, {
      month: Gn(t === "quarterrange" ? k0(Ut[wt === "start" ? 0 : 1]) : Ut[wt === "start" ? 0 : 1])
    }).valueOf() : ze.ts;
    if (Wr) {
      const na = Ke(ct), kr = [na, na];
      I.doUpdateValue(kr, e.panel), gr(kr, "start"), gr(kr, "end"), I.disableTransitionOneTick();
      return;
    }
    const en = [Ut[0], Ut[1]];
    let Ci = !1;
    switch (wt === "start" ? (en[0] = Ke(ct), en[0] > en[1] && (en[1] = en[0], Ci = !0)) : (en[1] = Ke(ct), en[0] > en[1] && (en[0] = en[1], Ci = !0)), I.doUpdateValue(en, e.panel), t) {
      case "monthrange":
      case "quarterrange":
        I.disableTransitionOneTick(), Ci ? (gr(en, "start"), gr(en, "end")) : gr(en, wt);
        break;
      case "yearrange":
        I.disableTransitionOneTick(), gr(en, "start"), gr(en, "end");
    }
  }
  function ri() {
    var ze;
    (ze = R.value) === null || ze === void 0 || ze.sync();
  }
  function xi() {
    var ze;
    (ze = U.value) === null || ze === void 0 || ze.sync();
  }
  function wi(ze) {
    var wt, Ut;
    return ze === "start" ? (wt = Q.value) === null || wt === void 0 ? void 0 : wt.listElRef : (Ut = Z.value) === null || Ut === void 0 ? void 0 : Ut.listElRef;
  }
  function Pi(ze) {
    var wt, Ut;
    return ze === "start" ? (wt = Q.value) === null || wt === void 0 ? void 0 : wt.itemsElRef : (Ut = Z.value) === null || Ut === void 0 ? void 0 : Ut.itemsElRef;
  }
  const Mi = {
    startYearVlRef: Q,
    endYearVlRef: Z,
    startMonthScrollbarRef: X,
    endMonthScrollbarRef: re,
    startYearScrollbarRef: R,
    endYearScrollbarRef: U
  };
  return Object.assign(Object.assign(Object.assign(Object.assign({
    startDatesElRef: $,
    endDatesElRef: _,
    handleDateClick: ut,
    handleColItemClick: Or,
    handleDateMouseEnter: ht,
    handleConfirmClick: ye,
    startCalendarPrevYear: Ct,
    startCalendarPrevMonth: Vt,
    startCalendarNextYear: Mt,
    startCalendarNextMonth: er,
    endCalendarPrevYear: at,
    endCalendarPrevMonth: ve,
    endCalendarNextMonth: St,
    endCalendarNextYear: jt,
    mergedIsDateDisabled: Se,
    changeStartEndTime: Te,
    ranges: S,
    startCalendarMonth: Ue,
    startCalendarYear: Ie,
    endCalendarMonth: ot,
    endCalendarYear: rt,
    weekdays: qe,
    startDateArray: Ge,
    endDateArray: Ee,
    startYearArray: se,
    startMonthArray: fe,
    startQuarterArray: ae,
    endYearArray: pe,
    endMonthArray: ke,
    endQuarterArray: Me,
    isSelecting: Oe,
    handleRangeShortcutMouseenter: Tt,
    handleRangeShortcutClick: lr
  }, I), N), Mi), {
    startDateDisplayString: Ne,
    endDateInput: $e,
    timePickerSize: I.timePickerSize,
    startTimeValue: W,
    endTimeValue: P,
    datePickerSlots: E,
    shortcuts: H,
    startCalendarDateTime: te,
    endCalendarDateTime: de,
    justifyColumnsScrollState: gr,
    handleFocusDetectorFocus: I.handleFocusDetectorFocus,
    handleStartTimePickerChange: ge,
    handleEndTimePickerChange: Fe,
    handleStartDateInput: xe,
    handleStartDateInputBlur: At,
    handleEndDateInput: Xe,
    handleEndDateInputBlur: Ht,
    handleStartYearVlScroll: ri,
    handleEndYearVlScroll: xi,
    virtualListContainer: wi,
    virtualListContent: Pi,
    onUpdateStartCalendarValue: We,
    onUpdateEndCalendarValue: ne
  });
}
var obe = oe({
  name: "DateTimeRangePanel",
  props: R4,
  setup(e) {
    return j4(e, "datetimerange");
  },
  render() {
    var e, t, r;
    const { mergedClsPrefix: n, mergedTheme: i, shortcuts: o, timePickerProps: a, onRender: s, $slots: u } = this;
    return s == null || s(), b("div", { ref: "selfRef", tabindex: 0, class: [
      `${n}-date-panel`,
      `${n}-date-panel--datetimerange`,
      !this.panel && `${n}-date-panel--shadow`,
      this.themeClass
    ], onKeydown: this.handlePanelKeyDown, onFocus: this.handlePanelFocus }, b("div", { class: `${n}-date-panel-header` }, b(pa, { value: this.startDateDisplayString, theme: i.peers.Input, themeOverrides: i.peerOverrides.Input, size: this.timePickerSize, stateful: !1, class: `${n}-date-panel-date-input`, textDecoration: this.isStartValueInvalid ? "line-through" : "", placeholder: this.locale.selectDate, onBlur: this.handleStartDateInputBlur, onUpdateValue: this.handleStartDateInput }), b(dx, Object.assign({ placeholder: this.locale.selectTime, format: this.timeFormat, size: this.timePickerSize }, Array.isArray(a) ? a[0] : a, { value: this.startTimeValue, to: !1, showIcon: !1, disabled: this.isSelecting, theme: i.peers.TimePicker, themeOverrides: i.peerOverrides.TimePicker, stateful: !1, isHourDisabled: this.isStartHourDisabled, isMinuteDisabled: this.isStartMinuteDisabled, isSecondDisabled: this.isStartSecondDisabled, onUpdateValue: this.handleStartTimePickerChange })), b(pa, { value: this.endDateInput, theme: i.peers.Input, themeOverrides: i.peerOverrides.Input, stateful: !1, size: this.timePickerSize, class: `${n}-date-panel-date-input`, textDecoration: this.isEndValueInvalid ? "line-through" : "", placeholder: this.locale.selectDate, onBlur: this.handleEndDateInputBlur, onUpdateValue: this.handleEndDateInput }), b(dx, Object.assign({ placeholder: this.locale.selectTime, format: this.timeFormat, size: this.timePickerSize }, Array.isArray(a) ? a[1] : a, { disabled: this.isSelecting, showIcon: !1, theme: i.peers.TimePicker, themeOverrides: i.peerOverrides.TimePicker, to: !1, stateful: !1, value: this.endTimeValue, isHourDisabled: this.isEndHourDisabled, isMinuteDisabled: this.isEndMinuteDisabled, isSecondDisabled: this.isEndSecondDisabled, onUpdateValue: this.handleEndTimePickerChange }))), b("div", { ref: "startDatesElRef", class: `${n}-date-panel-calendar ${n}-date-panel-calendar--start` }, b("div", { class: `${n}-date-panel-month` }, b("div", { class: `${n}-date-panel-month__fast-prev`, onClick: this.startCalendarPrevYear }, vr(u["prev-year"], () => [b(Mc, null)])), b("div", { class: `${n}-date-panel-month__prev`, onClick: this.startCalendarPrevMonth }, vr(u["prev-month"], () => [b(wc, null)])), b(xp, { monthBeforeYear: this.locale.monthBeforeYear, value: this.startCalendarDateTime, onUpdateValue: this.onUpdateStartCalendarValue, mergedClsPrefix: n, calendarMonth: this.startCalendarMonth, calendarYear: this.startCalendarYear }), b("div", { class: `${n}-date-panel-month__next`, onClick: this.startCalendarNextMonth }, vr(u["next-month"], () => [b(Sc, null)])), b("div", { class: `${n}-date-panel-month__fast-next`, onClick: this.startCalendarNextYear }, vr(u["next-year"], () => [b(Cc, null)]))), b("div", { class: `${n}-date-panel-weekdays` }, this.weekdays.map((d) => b("div", { key: d, class: `${n}-date-panel-weekdays__day` }, d))), b("div", { class: `${n}-date-panel__divider` }), b("div", { class: `${n}-date-panel-dates` }, this.startDateArray.map((d, f) => {
      const h = this.mergedIsDateDisabled(d.ts);
      return b("div", { "data-n-date": !0, key: f, class: [
        `${n}-date-panel-date`,
        {
          [`${n}-date-panel-date--excluded`]: !d.inCurrentMonth,
          [`${n}-date-panel-date--current`]: d.isCurrentDate,
          [`${n}-date-panel-date--selected`]: d.selected,
          [`${n}-date-panel-date--covered`]: d.inSpan,
          [`${n}-date-panel-date--start`]: d.startOfSpan,
          [`${n}-date-panel-date--end`]: d.endOfSpan,
          [`${n}-date-panel-date--disabled`]: h
        }
      ], onClick: h ? void 0 : () => {
        this.handleDateClick(d);
      }, onMouseenter: h ? void 0 : () => {
        this.handleDateMouseEnter(d);
      } }, b("div", { class: `${n}-date-panel-date__trigger` }), d.dateObject.date, d.isCurrentDate ? b("div", { class: `${n}-date-panel-date__sup` }) : null);
    }))), b("div", { class: `${n}-date-panel__vertical-divider` }), b("div", { ref: "endDatesElRef", class: `${n}-date-panel-calendar ${n}-date-panel-calendar--end` }, b("div", { class: `${n}-date-panel-month` }, b("div", { class: `${n}-date-panel-month__fast-prev`, onClick: this.endCalendarPrevYear }, vr(u["prev-year"], () => [b(Mc, null)])), b("div", { class: `${n}-date-panel-month__prev`, onClick: this.endCalendarPrevMonth }, vr(u["prev-month"], () => [b(wc, null)])), b(xp, { monthBeforeYear: this.locale.monthBeforeYear, value: this.endCalendarDateTime, onUpdateValue: this.onUpdateEndCalendarValue, mergedClsPrefix: n, calendarMonth: this.endCalendarMonth, calendarYear: this.endCalendarYear }), b("div", { class: `${n}-date-panel-month__next`, onClick: this.endCalendarNextMonth }, vr(u["next-month"], () => [b(Sc, null)])), b("div", { class: `${n}-date-panel-month__fast-next`, onClick: this.endCalendarNextYear }, vr(u["next-year"], () => [b(Cc, null)]))), b("div", { class: `${n}-date-panel-weekdays` }, this.weekdays.map((d) => b("div", { key: d, class: `${n}-date-panel-weekdays__day` }, d))), b("div", { class: `${n}-date-panel__divider` }), b("div", { class: `${n}-date-panel-dates` }, this.endDateArray.map((d, f) => {
      const h = this.mergedIsDateDisabled(d.ts);
      return b("div", { "data-n-date": !0, key: f, class: [
        `${n}-date-panel-date`,
        {
          [`${n}-date-panel-date--excluded`]: !d.inCurrentMonth,
          [`${n}-date-panel-date--current`]: d.isCurrentDate,
          [`${n}-date-panel-date--selected`]: d.selected,
          [`${n}-date-panel-date--covered`]: d.inSpan,
          [`${n}-date-panel-date--start`]: d.startOfSpan,
          [`${n}-date-panel-date--end`]: d.endOfSpan,
          [`${n}-date-panel-date--disabled`]: h
        }
      ], onClick: h ? void 0 : () => {
        this.handleDateClick(d);
      }, onMouseenter: h ? void 0 : () => {
        this.handleDateMouseEnter(d);
      } }, b("div", { class: `${n}-date-panel-date__trigger` }), d.dateObject.date, d.isCurrentDate ? b("div", { class: `${n}-date-panel-date__sup` }) : null);
    }))), this.datePickerSlots.footer ? b("div", { class: `${n}-date-panel-footer` }, this.datePickerSlots.footer()) : null, !((e = this.actions) === null || e === void 0) && e.length || o ? b("div", { class: `${n}-date-panel-actions` }, b("div", { class: `${n}-date-panel-actions__prefix` }, o && Object.keys(o).map((d) => {
      const f = o[d];
      return Array.isArray(f) || typeof f == "function" ? b(bs, { size: "tiny", onMouseenter: () => {
        this.handleRangeShortcutMouseenter(f);
      }, onClick: () => {
        this.handleRangeShortcutClick(f);
      }, onMouseleave: () => {
        this.handleShortcutMouseleave();
      } }, { default: () => d }) : null;
    })), b("div", { class: `${n}-date-panel-actions__suffix` }, !((t = this.actions) === null || t === void 0) && t.includes("clear") ? b(Mn, { theme: i.peers.Button, themeOverrides: i.peerOverrides.Button, size: "tiny", onClick: this.handleClearClick }, { default: () => this.locale.clear }) : null, !((r = this.actions) === null || r === void 0) && r.includes("confirm") ? b(Mn, { theme: i.peers.Button, themeOverrides: i.peerOverrides.Button, size: "tiny", type: "primary", disabled: this.isRangeInvalid || this.isSelecting, onClick: this.handleConfirmClick }, { default: () => this.locale.confirm }) : null)) : null, b(Pc, { onFocus: this.handleFocusDetectorFocus }));
  }
}), abe = oe({
  name: "DatePanel",
  props: L4,
  setup(e) {
    return P4(e, "date");
  },
  render() {
    var e, t, r;
    const { mergedClsPrefix: n, mergedTheme: i, shortcuts: o, onRender: a, $slots: s } = this;
    return a == null || a(), b("div", { ref: "selfRef", tabindex: 0, class: [
      `${n}-date-panel`,
      `${n}-date-panel--date`,
      !this.panel && `${n}-date-panel--shadow`,
      this.themeClass
    ], onFocus: this.handlePanelFocus, onKeydown: this.handlePanelKeyDown }, b("div", { class: `${n}-date-panel-calendar` }, b("div", { class: `${n}-date-panel-month` }, b("div", { class: `${n}-date-panel-month__fast-prev`, onClick: this.prevYear }, vr(s["prev-year"], () => [b(Mc, null)])), b("div", { class: `${n}-date-panel-month__prev`, onClick: this.prevMonth }, vr(s["prev-month"], () => [b(wc, null)])), b(xp, { monthBeforeYear: this.locale.monthBeforeYear, value: this.calendarValue, onUpdateValue: this.onUpdateCalendarValue, mergedClsPrefix: n, calendarMonth: this.calendarMonth, calendarYear: this.calendarYear }), b("div", { class: `${n}-date-panel-month__next`, onClick: this.nextMonth }, vr(s["next-month"], () => [b(Sc, null)])), b("div", { class: `${n}-date-panel-month__fast-next`, onClick: this.nextYear }, vr(s["next-year"], () => [b(Cc, null)]))), b("div", { class: `${n}-date-panel-weekdays` }, this.weekdays.map((u) => b("div", { key: u, class: `${n}-date-panel-weekdays__day` }, u))), b("div", { class: `${n}-date-panel-dates` }, this.dateArray.map((u, d) => b("div", { "data-n-date": !0, key: d, class: [
      `${n}-date-panel-date`,
      {
        [`${n}-date-panel-date--current`]: u.isCurrentDate,
        [`${n}-date-panel-date--selected`]: u.selected,
        [`${n}-date-panel-date--excluded`]: !u.inCurrentMonth,
        [`${n}-date-panel-date--disabled`]: this.mergedIsDateDisabled(u.ts)
      }
    ], onClick: () => {
      this.handleDateClick(u);
    } }, b("div", { class: `${n}-date-panel-date__trigger` }), u.dateObject.date, u.isCurrentDate ? b("div", { class: `${n}-date-panel-date__sup` }) : null)))), this.datePickerSlots.footer ? b("div", { class: `${n}-date-panel-footer` }, this.datePickerSlots.footer()) : null, !((e = this.actions) === null || e === void 0) && e.length || o ? b("div", { class: `${n}-date-panel-actions` }, b("div", { class: `${n}-date-panel-actions__prefix` }, o && Object.keys(o).map((u) => {
      const d = o[u];
      return Array.isArray(d) ? null : b(bs, { size: "tiny", onMouseenter: () => {
        this.handleSingleShortcutMouseenter(d);
      }, onClick: () => {
        this.handleSingleShortcutClick(d);
      }, onMouseleave: () => {
        this.handleShortcutMouseleave();
      } }, { default: () => u });
    })), b("div", { class: `${n}-date-panel-actions__suffix` }, !((t = this.actions) === null || t === void 0) && t.includes("clear") ? b(Mn, { theme: i.peers.Button, themeOverrides: i.peerOverrides.Button, size: "tiny", onClick: this.handleClearClick }, { default: () => this.locale.clear }) : null, !((r = this.actions) === null || r === void 0) && r.includes("now") ? b(Mn, { theme: i.peers.Button, themeOverrides: i.peerOverrides.Button, size: "tiny", onClick: this.handleNowClick }, { default: () => this.locale.now }) : null)) : null, b(Pc, { onFocus: this.handleFocusDetectorFocus }));
  }
}), lbe = oe({
  name: "DateRangePanel",
  props: R4,
  setup(e) {
    return j4(e, "daterange");
  },
  render() {
    var e, t, r;
    const { mergedClsPrefix: n, mergedTheme: i, shortcuts: o, onRender: a, $slots: s } = this;
    return a == null || a(), b("div", { ref: "selfRef", tabindex: 0, class: [
      `${n}-date-panel`,
      `${n}-date-panel--daterange`,
      !this.panel && `${n}-date-panel--shadow`,
      this.themeClass
    ], onKeydown: this.handlePanelKeyDown, onFocus: this.handlePanelFocus }, b("div", { ref: "startDatesElRef", class: `${n}-date-panel-calendar ${n}-date-panel-calendar--start` }, b("div", { class: `${n}-date-panel-month` }, b("div", { class: `${n}-date-panel-month__fast-prev`, onClick: this.startCalendarPrevYear }, vr(s["prev-year"], () => [b(Mc, null)])), b("div", { class: `${n}-date-panel-month__prev`, onClick: this.startCalendarPrevMonth }, vr(s["prev-month"], () => [b(wc, null)])), b(xp, { monthBeforeYear: this.locale.monthBeforeYear, value: this.startCalendarDateTime, onUpdateValue: this.onUpdateStartCalendarValue, mergedClsPrefix: n, calendarMonth: this.startCalendarMonth, calendarYear: this.startCalendarYear }), b("div", { class: `${n}-date-panel-month__next`, onClick: this.startCalendarNextMonth }, vr(s["next-month"], () => [b(Sc, null)])), b("div", { class: `${n}-date-panel-month__fast-next`, onClick: this.startCalendarNextYear }, vr(s["next-year"], () => [b(Cc, null)]))), b("div", { class: `${n}-date-panel-weekdays` }, this.weekdays.map((u) => b("div", { key: u, class: `${n}-date-panel-weekdays__day` }, u))), b("div", { class: `${n}-date-panel__divider` }), b("div", { class: `${n}-date-panel-dates` }, this.startDateArray.map((u, d) => b("div", { "data-n-date": !0, key: d, class: [
      `${n}-date-panel-date`,
      {
        [`${n}-date-panel-date--excluded`]: !u.inCurrentMonth,
        [`${n}-date-panel-date--current`]: u.isCurrentDate,
        [`${n}-date-panel-date--selected`]: u.selected,
        [`${n}-date-panel-date--covered`]: u.inSpan,
        [`${n}-date-panel-date--start`]: u.startOfSpan,
        [`${n}-date-panel-date--end`]: u.endOfSpan,
        [`${n}-date-panel-date--disabled`]: this.mergedIsDateDisabled(u.ts)
      }
    ], onClick: () => {
      this.handleDateClick(u);
    }, onMouseenter: () => {
      this.handleDateMouseEnter(u);
    } }, b("div", { class: `${n}-date-panel-date__trigger` }), u.dateObject.date, u.isCurrentDate ? b("div", { class: `${n}-date-panel-date__sup` }) : null)))), b("div", { class: `${n}-date-panel__vertical-divider` }), b("div", { ref: "endDatesElRef", class: `${n}-date-panel-calendar ${n}-date-panel-calendar--end` }, b("div", { class: `${n}-date-panel-month` }, b("div", { class: `${n}-date-panel-month__fast-prev`, onClick: this.endCalendarPrevYear }, vr(s["prev-year"], () => [b(Mc, null)])), b("div", { class: `${n}-date-panel-month__prev`, onClick: this.endCalendarPrevMonth }, vr(s["prev-month"], () => [b(wc, null)])), b(xp, { monthBeforeYear: this.locale.monthBeforeYear, value: this.endCalendarDateTime, onUpdateValue: this.onUpdateEndCalendarValue, mergedClsPrefix: n, calendarMonth: this.endCalendarMonth, calendarYear: this.endCalendarYear }), b("div", { class: `${n}-date-panel-month__next`, onClick: this.endCalendarNextMonth }, vr(s["next-month"], () => [b(Sc, null)])), b("div", { class: `${n}-date-panel-month__fast-next`, onClick: this.endCalendarNextYear }, vr(s["next-year"], () => [b(Cc, null)]))), b("div", { class: `${n}-date-panel-weekdays` }, this.weekdays.map((u) => b("div", { key: u, class: `${n}-date-panel-weekdays__day` }, u))), b("div", { class: `${n}-date-panel__divider` }), b("div", { class: `${n}-date-panel-dates` }, this.endDateArray.map((u, d) => b("div", { "data-n-date": !0, key: d, class: [
      `${n}-date-panel-date`,
      {
        [`${n}-date-panel-date--excluded`]: !u.inCurrentMonth,
        [`${n}-date-panel-date--current`]: u.isCurrentDate,
        [`${n}-date-panel-date--selected`]: u.selected,
        [`${n}-date-panel-date--covered`]: u.inSpan,
        [`${n}-date-panel-date--start`]: u.startOfSpan,
        [`${n}-date-panel-date--end`]: u.endOfSpan,
        [`${n}-date-panel-date--disabled`]: this.mergedIsDateDisabled(u.ts)
      }
    ], onClick: () => {
      this.handleDateClick(u);
    }, onMouseenter: () => {
      this.handleDateMouseEnter(u);
    } }, b("div", { class: `${n}-date-panel-date__trigger` }), u.dateObject.date, u.isCurrentDate ? b("div", { class: `${n}-date-panel-date__sup` }) : null)))), this.datePickerSlots.footer ? b("div", { class: `${n}-date-panel-footer` }, this.datePickerSlots.footer()) : null, !((e = this.actions) === null || e === void 0) && e.length || o ? b("div", { class: `${n}-date-panel-actions` }, b("div", { class: `${n}-date-panel-actions__prefix` }, o && Object.keys(o).map((u) => {
      const d = o[u];
      return Array.isArray(d) || typeof d == "function" ? b(bs, { size: "tiny", onMouseenter: () => {
        this.handleRangeShortcutMouseenter(d);
      }, onClick: () => {
        this.handleRangeShortcutClick(d);
      }, onMouseleave: () => {
        this.handleShortcutMouseleave();
      } }, { default: () => u }) : null;
    })), b("div", { class: `${n}-date-panel-actions__suffix` }, !((t = this.actions) === null || t === void 0) && t.includes("clear") ? b(Mn, { theme: i.peers.Button, themeOverrides: i.peerOverrides.Button, size: "tiny", onClick: this.handleClearClick }, { default: () => this.locale.clear }) : null, !((r = this.actions) === null || r === void 0) && r.includes("confirm") ? b(Mn, { theme: i.peers.Button, themeOverrides: i.peerOverrides.Button, size: "tiny", type: "primary", disabled: this.isRangeInvalid || this.isSelecting, onClick: this.handleConfirmClick }, { default: () => this.locale.confirm }) : null)) : null, b(Pc, { onFocus: this.handleFocusDetectorFocus }));
  }
}), sbe = oe({
  name: "MonthRangePanel",
  props: Object.assign(Object.assign({}, R4), { type: {
    type: String,
    required: !0
  } }),
  setup(e) {
    const t = j4(e, e.type), r = (n, i, o, a) => {
      const { handleColItemClick: s } = t, u = !1;
      return b("div", { "data-n-date": !0, key: i, class: [
        `${o}-date-panel-month-calendar__picker-col-item`,
        {
          [`${o}-date-panel-month-calendar__picker-col-item--current`]: n.isCurrent,
          [`${o}-date-panel-month-calendar__picker-col-item--selected`]: n.selected,
          [`${o}-date-panel-month-calendar__picker-col-item--disabled`]: u
        }
      ], onClick: () => {
        s(n, a);
      } }, n.type === "month" ? n.dateObject.month + 1 : n.type === "quarter" ? `Q${n.dateObject.quarter}` : n.dateObject.year);
    };
    return br(() => {
      t.justifyColumnsScrollState();
    }), Object.assign(Object.assign({}, t), { renderItem: r });
  },
  render() {
    var e, t, r;
    const { mergedClsPrefix: n, mergedTheme: i, shortcuts: o, type: a, renderItem: s, onRender: u } = this;
    return u == null || u(), b("div", { ref: "selfRef", tabindex: 0, class: [
      `${n}-date-panel`,
      `${n}-date-panel--daterange`,
      !this.panel && `${n}-date-panel--shadow`,
      this.themeClass
    ], onKeydown: this.handlePanelKeyDown, onFocus: this.handlePanelFocus }, b("div", { ref: "startDatesElRef", class: `${n}-date-panel-calendar ${n}-date-panel-calendar--start` }, b("div", { class: `${n}-date-panel-month-calendar` }, b(no, { ref: "startYearScrollbarRef", class: `${n}-date-panel-month-calendar__picker-col`, theme: i.peers.Scrollbar, themeOverrides: i.peerOverrides.Scrollbar, container: () => this.virtualListContainer("start"), content: () => this.virtualListContent("start"), horizontalRailStyle: { zIndex: 1 }, verticalRailStyle: { zIndex: 1 } }, {
      default: () => b(M0, { ref: "startYearVlRef", items: this.startYearArray, itemSize: th, showScrollbar: !1, keyField: "ts", onScroll: this.handleStartYearVlScroll, paddingBottom: 4 }, {
        default: ({ item: d, index: f }) => s(d, f, n, "start")
      })
    }), a === "monthrange" || a === "quarterrange" ? b("div", { class: `${n}-date-panel-month-calendar__picker-col` }, b(no, { ref: "startMonthScrollbarRef", theme: i.peers.Scrollbar, themeOverrides: i.peerOverrides.Scrollbar }, {
      default: () => [
        (a === "monthrange" ? this.startMonthArray : this.startQuarterArray).map((d, f) => s(d, f, n, "start")),
        a === "monthrange" && b("div", { class: `${n}-date-panel-month-calendar__padding` })
      ]
    })) : null)), b("div", { class: `${n}-date-panel__vertical-divider` }), b("div", { ref: "endDatesElRef", class: `${n}-date-panel-calendar ${n}-date-panel-calendar--end` }, b("div", { class: `${n}-date-panel-month-calendar` }, b(no, { ref: "endYearScrollbarRef", class: `${n}-date-panel-month-calendar__picker-col`, theme: i.peers.Scrollbar, themeOverrides: i.peerOverrides.Scrollbar, container: () => this.virtualListContainer("end"), content: () => this.virtualListContent("end"), horizontalRailStyle: { zIndex: 1 }, verticalRailStyle: { zIndex: 1 } }, {
      default: () => b(M0, { ref: "endYearVlRef", items: this.endYearArray, itemSize: th, showScrollbar: !1, keyField: "ts", onScroll: this.handleEndYearVlScroll, paddingBottom: 4 }, {
        default: ({ item: d, index: f }) => s(d, f, n, "end")
      })
    }), a === "monthrange" || a === "quarterrange" ? b("div", { class: `${n}-date-panel-month-calendar__picker-col` }, b(no, { ref: "endMonthScrollbarRef", theme: i.peers.Scrollbar, themeOverrides: i.peerOverrides.Scrollbar }, {
      default: () => [
        (a === "monthrange" ? this.endMonthArray : this.endQuarterArray).map((d, f) => s(d, f, n, "end")),
        a === "monthrange" && b("div", { class: `${n}-date-panel-month-calendar__padding` })
      ]
    })) : null)), this.datePickerSlots.footer ? b("div", { class: `${n}-date-panel-footer` }, nt(this.datePickerSlots, "footer")) : null, !((e = this.actions) === null || e === void 0) && e.length || o ? b("div", { class: `${n}-date-panel-actions` }, b("div", { class: `${n}-date-panel-actions__prefix` }, o && Object.keys(o).map((d) => {
      const f = o[d];
      return Array.isArray(f) || typeof f == "function" ? b(bs, { size: "tiny", onMouseenter: () => {
        this.handleRangeShortcutMouseenter(f);
      }, onClick: () => {
        this.handleRangeShortcutClick(f);
      }, onMouseleave: () => {
        this.handleShortcutMouseleave();
      } }, { default: () => d }) : null;
    })), b("div", { class: `${n}-date-panel-actions__suffix` }, !((t = this.actions) === null || t === void 0) && t.includes("clear") ? b(bs, { theme: i.peers.Button, themeOverrides: i.peerOverrides.Button, size: "tiny", onClick: this.handleClearClick }, { default: () => this.locale.clear }) : null, !((r = this.actions) === null || r === void 0) && r.includes("confirm") ? b(bs, { theme: i.peers.Button, themeOverrides: i.peerOverrides.Button, size: "tiny", type: "primary", disabled: this.isRangeInvalid, onClick: this.handleConfirmClick }, { default: () => this.locale.confirm }) : null)) : null, b(Pc, { onFocus: this.handleFocusDetectorFocus }));
  }
}), ube = Y([L("date-picker", `
 position: relative;
 z-index: auto;
 `, [L("date-picker-icon", `
 color: var(--n-icon-color-override);
 transition: color .3s var(--n-bezier);
 `), L("icon", `
 color: var(--n-icon-color-override);
 transition: color .3s var(--n-bezier);
 `), K("disabled", [L("date-picker-icon", `
 color: var(--n-icon-color-disabled-override);
 `), L("icon", `
 color: var(--n-icon-color-disabled-override);
 `)])]), L("date-panel", `
 width: fit-content;
 outline: none;
 margin: 4px 0;
 display: grid;
 grid-template-columns: 0fr;
 border-radius: var(--n-panel-border-radius);
 background-color: var(--n-panel-color);
 color: var(--n-panel-text-color);
 `, [Fa(), K("shadow", `
 box-shadow: var(--n-panel-box-shadow);
 `), L("date-panel-calendar", {
  padding: "var(--n-calendar-left-padding)",
  display: "grid",
  gridTemplateColumns: "1fr",
  gridArea: "left-calendar"
}, [K("end", {
  padding: "var(--n-calendar-right-padding)",
  gridArea: "right-calendar"
})]), L("date-panel-month-calendar", {
  display: "flex",
  gridArea: "left-calendar"
}, [q("picker-col", `
 min-width: var(--n-scroll-item-width);
 height: calc(var(--n-scroll-item-height) * 6);
 user-select: none;
 -webkit-user-select: none;
 `, [Y("&:first-child", `
 min-width: calc(var(--n-scroll-item-width) + 4px);
 `, [q("picker-col-item", [Y("&::before", "left: 4px;")])]), q("padding", `
 height: calc(var(--n-scroll-item-height) * 5)
 `)]), q("picker-col-item", `
 z-index: 0;
 cursor: pointer;
 height: var(--n-scroll-item-height);
 box-sizing: border-box;
 padding-top: 4px;
 display: flex;
 align-items: center;
 justify-content: center;
 position: relative;
 transition: 
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 background: #0000;
 color: var(--n-item-text-color);
 `, [Y("&::before", `
 z-index: -1;
 content: "";
 position: absolute;
 left: 0;
 right: 4px;
 top: 4px;
 bottom: 0;
 border-radius: var(--n-scroll-item-border-radius);
 transition: 
 background-color .3s var(--n-bezier);
 `), wr("disabled", [Y("&:hover::before", `
 background-color: var(--n-item-color-hover);
 `), K("selected", `
 color: var(--n-item-color-active);
 `, [Y("&::before", "background-color: var(--n-item-color-hover);")])]), K("disabled", `
 color: var(--n-item-text-color-disabled);
 cursor: not-allowed;
 `, [K("selected", [Y("&::before", `
 background-color: var(--n-item-color-disabled);
 `)])])])]), K("date", {
  gridTemplateAreas: `
 "left-calendar"
 "footer"
 "action"
 `
}), K("daterange", {
  gridTemplateAreas: `
 "left-calendar divider right-calendar"
 "footer footer footer"
 "action action action"
 `
}), K("datetime", {
  gridTemplateAreas: `
 "header"
 "left-calendar"
 "footer"
 "action"
 `
}), K("datetimerange", {
  gridTemplateAreas: `
 "header header header"
 "left-calendar divider right-calendar"
 "footer footer footer"
 "action action action"
 `
}), K("month", {
  gridTemplateAreas: `
 "left-calendar"
 "footer"
 "action"
 `
}), L("date-panel-footer", {
  gridArea: "footer"
}), L("date-panel-actions", {
  gridArea: "action"
}), L("date-panel-header", {
  gridArea: "header"
}), L("date-panel-header", `
 box-sizing: border-box;
 width: 100%;
 align-items: center;
 padding: var(--n-panel-header-padding);
 display: flex;
 justify-content: space-between;
 border-bottom: 1px solid var(--n-panel-header-divider-color);
 `, [Y(">", [Y("*:not(:last-child)", {
  marginRight: "10px"
}), Y("*", {
  flex: 1,
  width: 0
}), L("time-picker", {
  zIndex: 1
})])]), L("date-panel-month", `
 box-sizing: border-box;
 display: grid;
 grid-template-columns: var(--n-calendar-title-grid-template-columns);
 align-items: center;
 justify-items: center;
 padding: var(--n-calendar-title-padding);
 height: var(--n-calendar-title-height);
 `, [q("prev, next, fast-prev, fast-next", `
 line-height: 0;
 cursor: pointer;
 width: var(--n-arrow-size);
 height: var(--n-arrow-size);
 color: var(--n-arrow-color);
 `), q("month-year", `
 user-select: none;
 -webkit-user-select: none;
 flex-grow: 1;
 position: relative;
 `, [q("text", `
 font-size: var(--n-calendar-title-font-size);
 line-height: var(--n-calendar-title-font-size);
 font-weight: var(--n-calendar-title-font-weight);
 padding: 6px 8px;
 text-align: center;
 color: var(--n-calendar-title-text-color);
 cursor: pointer;
 transition: background-color .3s var(--n-bezier);
 border-radius: var(--n-panel-border-radius);
 `, [K("active", `
 background-color: var(--n-calendar-title-color-hover);
 `), Y("&:hover", `
 background-color: var(--n-calendar-title-color-hover);
 `)])])]), L("date-panel-weekdays", `
 display: grid;
 margin: auto;
 grid-template-columns: repeat(7, var(--n-item-cell-width));
 grid-template-rows: repeat(1, var(--n-item-cell-height));
 align-items: center;
 justify-items: center;
 margin-bottom: 4px;
 border-bottom: 1px solid var(--n-calendar-days-divider-color);
 `, [q("day", `
 user-select: none;
 -webkit-user-select: none;
 line-height: 15px;
 width: var(--n-item-size);
 text-align: center;
 font-size: var(--n-calendar-days-font-size);
 color: var(--n-item-text-color);
 `)]), L("date-panel-dates", `
 margin: auto;
 display: grid;
 grid-template-columns: repeat(7, var(--n-item-cell-width));
 grid-template-rows: repeat(6, var(--n-item-cell-height));
 align-items: center;
 justify-items: center;
 flex-wrap: wrap;
 `, [L("date-panel-date", `
 user-select: none;
 -webkit-user-select: none;
 position: relative;
 width: var(--n-item-size);
 height: var(--n-item-size);
 line-height: var(--n-item-size);
 text-align: center;
 font-size: var(--n-item-font-size);
 border-radius: var(--n-item-border-radius);
 z-index: 0;
 cursor: pointer;
 transition:
 background-color .2s var(--n-bezier),
 color .2s var(--n-bezier);
 `, [q("trigger", `
 position: absolute;
 left: calc(var(--n-item-size) / 2 - var(--n-item-cell-width) / 2);
 top: calc(var(--n-item-size) / 2 - var(--n-item-cell-height) / 2);
 width: var(--n-item-cell-width);
 height: var(--n-item-cell-height);
 `), wr("disabled", [wr("selected", [Y("&:hover", {
  backgroundColor: "var(--n-item-color-hover)"
})])]), K("current", [q("sup", `
 position: absolute;
 top: 2px;
 right: 2px;
 content: "";
 height: 4px;
 width: 4px;
 border-radius: 2px;
 background-color: var(--n-item-color-active);
 transition:
 background-color .2s var(--n-bezier);
 `)]), Y("&::after", `
 content: "";
 z-index: -1;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border-radius: inherit;
 transition: background-color .3s var(--n-bezier);
 `), K("covered, start, end", [wr("excluded", [Y("&::before", `
 content: "";
 z-index: -2;
 position: absolute;
 left: calc((var(--n-item-size) - var(--n-item-cell-width)) / 2);
 right: calc((var(--n-item-size) - var(--n-item-cell-width)) / 2);
 top: 0;
 bottom: 0;
 background-color: var(--n-item-color-included);
 `), Y("&:nth-child(7n + 1)::before", {
  borderTopLeftRadius: "var(--n-item-border-radius)",
  borderBottomLeftRadius: "var(--n-item-border-radius)"
}), Y("&:nth-child(7n + 7)::before", {
  borderTopRightRadius: "var(--n-item-border-radius)",
  borderBottomRightRadius: "var(--n-item-border-radius)"
})])]), K("selected", {
  color: "var(--n-item-text-color-active)"
}, [Y("&::after", {
  backgroundColor: "var(--n-item-color-active)"
}), K("start", [Y("&::before", {
  left: "50%"
})]), K("end", [Y("&::before", {
  right: "50%"
})]), q("sup", {
  backgroundColor: "var(--n-panel-color)"
})]), K("excluded", {
  color: "var(--n-item-text-color-disabled)"
}, [K("selected", [Y("&::after", {
  backgroundColor: "var(--n-item-color-disabled)"
})])]), K("disabled", {
  cursor: "not-allowed",
  color: "var(--n-item-text-color-disabled)"
}, [K("covered", [Y("&::before", {
  backgroundColor: "var(--n-item-color-disabled)"
})]), K("selected", [Y("&::before", {
  backgroundColor: "var(--n-item-color-disabled)"
}), Y("&::after", {
  backgroundColor: "var(--n-item-color-disabled)"
})])])])]), q("vertical-divider", `
 grid-area: divider;
 height: 100%;
 width: 1px;
 background-color: var(--n-calendar-divider-color);
 `), L("date-panel-footer", {
  borderTop: "1px solid var(--n-panel-action-divider-color)",
  padding: "var(--n-panel-extra-footer-padding)"
}), L("date-panel-actions", `
 flex: 1;
 padding: var(--n-panel-action-padding);
 display: flex;
 align-items: center;
 justify-content: space-between;
 border-top: 1px solid var(--n-panel-action-divider-color);
 `, [q("prefix, suffix", `
 display: flex;
 margin-bottom: -8px;
 `), q("suffix", `
 align-self: flex-end;
 `), q("prefix", `
 flex-wrap: wrap;
 `), L("button", `
 margin-bottom: 8px;
 `, [Y("&:not(:last-child)", `
 margin-right: 8px;
 `)])])]), Y("[data-n-date].transition-disabled", {
  transition: "none !important"
}, [Y("&::before, &::after", {
  transition: "none !important"
})])]);
const cbe = Object.assign(Object.assign({}, ft.props), {
  to: vi.propTo,
  bordered: {
    type: Boolean,
    default: void 0
  },
  clearable: Boolean,
  updateValueOnClose: Boolean,
  defaultValue: [Number, Array],
  defaultFormattedValue: [String, Array],
  defaultTime: [Number, String, Array],
  disabled: {
    type: Boolean,
    default: void 0
  },
  placement: {
    type: String,
    default: "bottom-start"
  },
  value: [Number, Array],
  formattedValue: [String, Array],
  size: String,
  type: {
    type: String,
    default: "date"
  },
  valueFormat: String,
  separator: String,
  placeholder: String,
  startPlaceholder: String,
  endPlaceholder: String,
  format: String,
  dateFormat: String,
  timeFormat: String,
  actions: Array,
  shortcuts: Object,
  isDateDisabled: Function,
  isTimeDisabled: Function,
  show: {
    type: Boolean,
    default: void 0
  },
  panel: Boolean,
  ranges: Object,
  firstDayOfWeek: Number,
  inputReadonly: Boolean,
  closeOnSelect: Boolean,
  status: String,
  timePickerProps: [Object, Array],
  onClear: Function,
  onConfirm: Function,
  defaultCalendarStartTime: Number,
  defaultCalendarEndTime: Number,
  bindCalendarMonths: Boolean,
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  "onUpdate:formattedValue": [Function, Array],
  onUpdateFormattedValue: [Function, Array],
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onFocus: [Function, Array],
  onBlur: [Function, Array],
  onChange: [Function, Array]
});
var dbe = oe({
  name: "DatePicker",
  props: cbe,
  setup(e, { slots: t }) {
    var r;
    const { localeRef: n, dateLocaleRef: i } = Zl("DatePicker"), o = ta(e), { mergedSizeRef: a, mergedDisabledRef: s, mergedStatusRef: u } = o, { mergedComponentPropsRef: d, mergedClsPrefixRef: f, mergedBorderedRef: h, namespaceRef: g, inlineThemeDisabled: m } = Yt(e), v = G(null), w = G(null), x = G(null), y = G(!1), C = tt(e, "show"), S = dn(C, y), T = j(() => ({
      locale: i.value.locale
    })), A = j(() => {
      const { format: ye } = e;
      if (ye)
        return ye;
      switch (e.type) {
        case "date":
        case "daterange":
          return n.value.dateFormat;
        case "datetime":
        case "datetimerange":
          return n.value.dateTimeFormat;
        case "year":
        case "yearrange":
          return n.value.yearTypeFormat;
        case "month":
        case "monthrange":
          return n.value.monthTypeFormat;
        case "quarter":
        case "quarterrange":
          return n.value.quarterFormat;
      }
    }), D = j(() => {
      var ye;
      return (ye = e.valueFormat) !== null && ye !== void 0 ? ye : A.value;
    });
    function E(ye) {
      if (ye === null)
        return null;
      const { value: Ze } = D, { value: st } = T;
      return Array.isArray(ye) ? [
        ua(ye[0], Ze, new Date(), st).getTime(),
        ua(ye[1], Ze, new Date(), st).getTime()
      ] : ua(ye, Ze, new Date(), st).getTime();
    }
    const { defaultFormattedValue: N, defaultValue: I } = e, $ = G((r = N !== void 0 ? E(N) : I) !== null && r !== void 0 ? r : null), _ = j(() => {
      const { formattedValue: ye } = e;
      return ye !== void 0 ? E(ye) : e.value;
    }), R = dn(_, $), U = G(null);
    On(() => {
      U.value = R.value;
    });
    const Q = G(""), Z = G(""), X = G(""), re = ft("DatePicker", "-date-picker", ube, s0e, e, f), ue = j(() => {
      var ye, Ze;
      return ((Ze = (ye = d == null ? void 0 : d.value) === null || ye === void 0 ? void 0 : ye.DatePicker) === null || Ze === void 0 ? void 0 : Ze.timePickerSize) || "small";
    }), he = j(() => [
      "daterange",
      "datetimerange",
      "monthrange",
      "quarterrange",
      "yearrange"
    ].includes(e.type)), te = j(() => {
      const { placeholder: ye } = e;
      if (ye === void 0) {
        const { type: Ze } = e;
        switch (Ze) {
          case "date":
            return n.value.datePlaceholder;
          case "datetime":
            return n.value.datetimePlaceholder;
          case "month":
            return n.value.monthPlaceholder;
          case "year":
            return n.value.yearPlaceholder;
          case "quarter":
            return n.value.quarterPlaceholder;
          default:
            return "";
        }
      } else
        return ye;
    }), de = j(() => e.startPlaceholder === void 0 ? e.type === "daterange" ? n.value.startDatePlaceholder : e.type === "datetimerange" ? n.value.startDatetimePlaceholder : e.type === "monthrange" ? n.value.startMonthPlaceholder : "" : e.startPlaceholder), De = j(() => e.endPlaceholder === void 0 ? e.type === "daterange" ? n.value.endDatePlaceholder : e.type === "datetimerange" ? n.value.endDatetimePlaceholder : e.type === "monthrange" ? n.value.endMonthPlaceholder : "" : e.endPlaceholder), Oe = j(() => {
      const { actions: ye, type: Ze, clearable: st } = e;
      if (ye === null)
        return [];
      if (ye !== void 0)
        return ye;
      const Nt = st ? ["clear"] : [];
      switch (Ze) {
        case "date":
          return Nt.push("now"), Nt;
        case "datetime":
          return Nt.push("now", "confirm"), Nt;
        case "daterange":
          return Nt.push("confirm"), Nt;
        case "datetimerange":
          return Nt.push("confirm"), Nt;
        case "month":
          return Nt.push("now", "confirm"), Nt;
        case "year":
          return Nt.push("now"), Nt;
        case "quarter":
          return Nt.push("now", "confirm"), Nt;
        case "monthrange":
        case "yearrange":
        case "quarterrange":
          return Nt.push("confirm"), Nt;
        default: {
          ja("date-picker", "The type is wrong, n-date-picker's type only supports `date`, `datetime`, `daterange` and `datetimerange`.");
          break;
        }
      }
    });
    function Qe(ye) {
      if (ye === null)
        return null;
      if (Array.isArray(ye)) {
        const { value: Ze } = D, { value: st } = T;
        return [
          Xn(ye[0], Ze, st),
          Xn(ye[1], Ze, T.value)
        ];
      } else
        return Xn(ye, D.value, T.value);
    }
    function Ae(ye) {
      U.value = ye;
    }
    function Ne(ye, Ze) {
      const { "onUpdate:formattedValue": st, onUpdateFormattedValue: Nt } = e;
      st && je(st, ye, Ze), Nt && je(Nt, ye, Ze);
    }
    function $e(ye, Ze) {
      const { "onUpdate:value": st, onUpdateValue: Nt, onChange: Te } = e, { nTriggerFormChange: Ke, nTriggerFormInput: xe } = o, Xe = Qe(ye);
      Ze.doConfirm && Ge(ye, Xe), Nt && je(Nt, ye, Xe), st && je(st, ye, Xe), Te && je(Te, ye, Xe), $.value = ye, Ne(Xe, ye), Ke(), xe();
    }
    function et() {
      const { onClear: ye } = e;
      ye == null || ye();
    }
    function Ge(ye, Ze) {
      const { onConfirm: st } = e;
      st && st(ye, Ze);
    }
    function Ee(ye) {
      const { onFocus: Ze } = e, { nTriggerFormFocus: st } = o;
      Ze && je(Ze, ye), st();
    }
    function qe(ye) {
      const { onBlur: Ze } = e, { nTriggerFormBlur: st } = o;
      Ze && je(Ze, ye), st();
    }
    function Ue(ye) {
      const { "onUpdate:show": Ze, onUpdateShow: st } = e;
      Ze && je(Ze, ye), st && je(st, ye), y.value = ye;
    }
    function ot(ye) {
      ye.key === "Escape" && S.value && (x0(ye), St({
        returnFocus: !0
      }));
    }
    function Ie(ye) {
      ye.key === "Escape" && S.value && x0(ye);
    }
    function rt() {
      var ye;
      Ue(!1), (ye = x.value) === null || ye === void 0 || ye.deactivate(), et();
    }
    function W() {
      var ye;
      (ye = x.value) === null || ye === void 0 || ye.deactivate(), et();
    }
    function P() {
      St({
        returnFocus: !0
      });
    }
    function H(ye) {
      var Ze;
      S.value && !(!((Ze = w.value) === null || Ze === void 0) && Ze.contains(Ul(ye))) && St({
        returnFocus: !1
      });
    }
    function se(ye) {
      St({
        returnFocus: !0,
        disableUpdateOnClose: ye
      });
    }
    function pe(ye, Ze) {
      Ze ? $e(ye, { doConfirm: !1 }) : Ae(ye);
    }
    function ae() {
      const ye = U.value;
      $e(Array.isArray(ye) ? [ye[0], ye[1]] : ye, { doConfirm: !0 });
    }
    function Me() {
      const { value: ye } = U;
      he.value ? (Array.isArray(ye) || ye === null) && ke(ye) : Array.isArray(ye) || fe(ye);
    }
    function fe(ye) {
      ye === null ? Q.value = "" : Q.value = Xn(ye, A.value, T.value);
    }
    function ke(ye) {
      if (ye === null)
        Z.value = "", X.value = "";
      else {
        const Ze = T.value;
        Z.value = Xn(ye[0], A.value, Ze), X.value = Xn(ye[1], A.value, Ze);
      }
    }
    function Le() {
      S.value || at();
    }
    function dt(ye) {
      var Ze;
      !((Ze = v.value) === null || Ze === void 0) && Ze.$el.contains(ye.relatedTarget) || (qe(ye), Me(), St({
        returnFocus: !1
      }));
    }
    function Mt() {
      s.value || (Me(), St({
        returnFocus: !1
      }));
    }
    function Ct(ye) {
      if (ye === "") {
        $e(null, { doConfirm: !1 }), U.value = null, Q.value = "";
        return;
      }
      const Ze = ua(ye, A.value, new Date(), T.value);
      rl(Ze) ? ($e(Lt(Ze), { doConfirm: !1 }), Me()) : Q.value = ye;
    }
    function er(ye) {
      if (ye[0] === "" && ye[1] === "") {
        $e(null, { doConfirm: !1 }), U.value = null, Z.value = "", X.value = "";
        return;
      }
      const [Ze, st] = ye, Nt = ua(Ze, A.value, new Date(), T.value), Te = ua(st, A.value, new Date(), T.value);
      rl(Nt) && rl(Te) ? ($e([Lt(Nt), Lt(Te)], {
        doConfirm: !1
      }), Me()) : [Z.value, X.value] = ye;
    }
    function Vt(ye) {
      s.value || Bl(ye, "clear") || S.value || at();
    }
    function jt(ye) {
      s.value || Ee(ye);
    }
    function at() {
      s.value || S.value || Ue(!0);
    }
    function St({ returnFocus: ye, disableUpdateOnClose: Ze }) {
      var st;
      S.value && (Ue(!1), e.type !== "date" && e.updateValueOnClose && !Ze && ae(), ye && ((st = x.value) === null || st === void 0 || st.focus()));
    }
    Gt(U, () => {
      Me();
    }), Me(), Gt(S, (ye) => {
      ye || (U.value = R.value);
    });
    const ve = u0e(e, U), We = c0e(e, U);
    tr(QM, Object.assign(Object.assign(Object.assign({
      mergedClsPrefixRef: f,
      mergedThemeRef: re,
      timePickerSizeRef: ue,
      localeRef: n,
      dateLocaleRef: i,
      firstDayOfWeekRef: tt(e, "firstDayOfWeek"),
      isDateDisabledRef: tt(e, "isDateDisabled"),
      rangesRef: tt(e, "ranges"),
      timePickerPropsRef: tt(e, "timePickerProps"),
      closeOnSelectRef: tt(e, "closeOnSelect"),
      updateValueOnCloseRef: tt(e, "updateValueOnClose")
    }, ve), We), { datePickerSlots: t }));
    const ne = {
      focus: () => {
        var ye;
        (ye = x.value) === null || ye === void 0 || ye.focus();
      },
      blur: () => {
        var ye;
        (ye = x.value) === null || ye === void 0 || ye.blur();
      }
    }, Se = j(() => {
      const { common: { cubicBezierEaseInOut: ye }, self: { iconColor: Ze, iconColorDisabled: st } } = re.value;
      return {
        "--n-bezier": ye,
        "--n-icon-color-override": Ze,
        "--n-icon-color-disabled-override": st
      };
    }), _e = m ? Cr("date-picker-trigger", void 0, Se, e) : void 0, ut = j(() => {
      const { type: ye } = e, { common: { cubicBezierEaseInOut: Ze }, self: { calendarTitleFontSize: st, calendarDaysFontSize: Nt, itemFontSize: Te, itemTextColor: Ke, itemColorDisabled: xe, itemColorIncluded: Xe, itemColorHover: At, itemColorActive: Ht, itemBorderRadius: zt, itemTextColorDisabled: ge, itemTextColorActive: Fe, panelColor: Tt, panelTextColor: lr, arrowColor: gr, calendarTitleTextColor: Or, panelActionDividerColor: ri, panelHeaderDividerColor: xi, calendarDaysDividerColor: wi, panelBoxShadow: Pi, panelBorderRadius: Mi, calendarTitleFontWeight: ze, panelExtraFooterPadding: wt, panelActionPadding: Ut, itemSize: Wr, itemCellWidth: ct, itemCellHeight: en, scrollItemWidth: Ci, scrollItemHeight: na, calendarTitlePadding: kr, calendarTitleHeight: Xi, calendarDaysHeight: hi, calendarDaysTextColor: gl, arrowSize: so, panelHeaderPadding: ia, calendarDividerColor: Os, calendarTitleGridTempateColumns: Qc, iconColor: qc, iconColorDisabled: Gc, scrollItemBorderRadius: Zc, calendarTitleColorHover: _s, [Be("calendarLeftPadding", ye)]: Ls, [Be("calendarRightPadding", ye)]: Ps } } = re.value;
      return {
        "--n-bezier": Ze,
        "--n-panel-border-radius": Mi,
        "--n-panel-color": Tt,
        "--n-panel-box-shadow": Pi,
        "--n-panel-text-color": lr,
        "--n-panel-header-padding": ia,
        "--n-panel-header-divider-color": xi,
        "--n-calendar-left-padding": Ls,
        "--n-calendar-right-padding": Ps,
        "--n-calendar-title-color-hover": _s,
        "--n-calendar-title-height": Xi,
        "--n-calendar-title-padding": kr,
        "--n-calendar-title-font-size": st,
        "--n-calendar-title-font-weight": ze,
        "--n-calendar-title-text-color": Or,
        "--n-calendar-title-grid-template-columns": Qc,
        "--n-calendar-days-height": hi,
        "--n-calendar-days-divider-color": wi,
        "--n-calendar-days-font-size": Nt,
        "--n-calendar-days-text-color": gl,
        "--n-calendar-divider-color": Os,
        "--n-panel-action-padding": Ut,
        "--n-panel-extra-footer-padding": wt,
        "--n-panel-action-divider-color": ri,
        "--n-item-font-size": Te,
        "--n-item-border-radius": zt,
        "--n-item-size": Wr,
        "--n-item-cell-width": ct,
        "--n-item-cell-height": en,
        "--n-item-text-color": Ke,
        "--n-item-color-included": Xe,
        "--n-item-color-disabled": xe,
        "--n-item-color-hover": At,
        "--n-item-color-active": Ht,
        "--n-item-text-color-disabled": ge,
        "--n-item-text-color-active": Fe,
        "--n-scroll-item-width": Ci,
        "--n-scroll-item-height": na,
        "--n-scroll-item-border-radius": Zc,
        "--n-arrow-size": so,
        "--n-arrow-color": gr,
        "--n-icon-color": qc,
        "--n-icon-color-disabled": Gc
      };
    }), ht = m ? Cr("date-picker", j(() => e.type), ut, e) : void 0;
    return Object.assign(Object.assign({}, ne), {
      mergedStatus: u,
      mergedClsPrefix: f,
      mergedBordered: h,
      namespace: g,
      uncontrolledValue: $,
      pendingValue: U,
      panelInstRef: v,
      triggerElRef: w,
      inputInstRef: x,
      isMounted: ql(),
      displayTime: Q,
      displayStartTime: Z,
      displayEndTime: X,
      mergedShow: S,
      adjustedTo: vi(e),
      isRange: he,
      localizedStartPlaceholder: de,
      localizedEndPlaceholder: De,
      mergedSize: a,
      mergedDisabled: s,
      localizedPlacehoder: te,
      isValueInvalid: ve.isValueInvalidRef,
      isStartValueInvalid: We.isStartValueInvalidRef,
      isEndValueInvalid: We.isEndValueInvalidRef,
      handleInputKeydown: Ie,
      handleClickOutside: H,
      handleKeydown: ot,
      handleClear: rt,
      handlePanelClear: W,
      handleTriggerClick: Vt,
      handleInputActivate: Le,
      handleInputDeactivate: Mt,
      handleInputFocus: jt,
      handleInputBlur: dt,
      handlePanelTabOut: P,
      handlePanelClose: se,
      handleRangeUpdateValue: er,
      handleSingleUpdateValue: Ct,
      handlePanelUpdateValue: pe,
      handlePanelConfirm: ae,
      mergedTheme: re,
      actions: Oe,
      triggerCssVars: m ? void 0 : Se,
      triggerThemeClass: _e == null ? void 0 : _e.themeClass,
      triggerOnRender: _e == null ? void 0 : _e.onRender,
      cssVars: m ? void 0 : ut,
      themeClass: ht == null ? void 0 : ht.themeClass,
      onRender: ht == null ? void 0 : ht.onRender
    });
  },
  render() {
    const { clearable: e, triggerOnRender: t, mergedClsPrefix: r, $slots: n } = this, i = {
      onUpdateValue: this.handlePanelUpdateValue,
      onTabOut: this.handlePanelTabOut,
      onClose: this.handlePanelClose,
      onClear: this.handlePanelClear,
      onKeydown: this.handleKeydown,
      onConfirm: this.handlePanelConfirm,
      ref: "panelInstRef",
      value: this.pendingValue,
      active: this.mergedShow,
      actions: this.actions,
      shortcuts: this.shortcuts,
      style: this.cssVars,
      defaultTime: this.defaultTime,
      themeClass: this.themeClass,
      panel: this.panel,
      onRender: this.onRender
    }, o = () => {
      const { type: s } = this;
      return s === "datetime" ? b(ibe, Object.assign({}, i), n) : s === "daterange" ? b(lbe, Object.assign({}, i, { defaultCalendarStartTime: this.defaultCalendarStartTime, defaultCalendarEndTime: this.defaultCalendarEndTime, bindCalendarMonths: this.bindCalendarMonths }), n) : s === "datetimerange" ? b(obe, Object.assign({}, i, { defaultCalendarStartTime: this.defaultCalendarStartTime, defaultCalendarEndTime: this.defaultCalendarEndTime, bindCalendarMonths: this.bindCalendarMonths }), n) : s === "month" || s === "year" || s === "quarter" ? b(bW, Object.assign({}, i, { type: s, key: s })) : s === "monthrange" || s === "yearrange" || s === "quarterrange" ? b(sbe, Object.assign({}, i, { type: s })) : b(abe, Object.assign({}, i), n);
    };
    if (this.panel)
      return o();
    t == null || t();
    const a = {
      bordered: this.mergedBordered,
      size: this.mergedSize,
      passivelyActivated: !0,
      disabled: this.mergedDisabled,
      readonly: this.inputReadonly || this.mergedDisabled,
      clearable: e,
      onClear: this.handleClear,
      onClick: this.handleTriggerClick,
      onKeydown: this.handleInputKeydown,
      onActivate: this.handleInputActivate,
      onDeactivate: this.handleInputDeactivate,
      onFocus: this.handleInputFocus,
      onBlur: this.handleInputBlur
    };
    return b("div", { ref: "triggerElRef", class: [
      `${r}-date-picker`,
      this.mergedDisabled && `${r}-date-picker--disabled`,
      this.isRange && `${r}-date-picker--range`,
      this.triggerThemeClass
    ], style: this.triggerCssVars, onKeydown: this.handleKeydown }, b(zc, null, {
      default: () => [
        b($c, null, {
          default: () => this.isRange ? b(pa, Object.assign({ ref: "inputInstRef", status: this.mergedStatus, value: [this.displayStartTime, this.displayEndTime], placeholder: [
            this.localizedStartPlaceholder,
            this.localizedEndPlaceholder
          ], textDecoration: [
            this.isStartValueInvalid ? "line-through" : "",
            this.isEndValueInvalid ? "line-through" : ""
          ], pair: !0, onUpdateValue: this.handleRangeUpdateValue, theme: this.mergedTheme.peers.Input, themeOverrides: this.mergedTheme.peerOverrides.Input, internalForceFocus: this.mergedShow, internalDeactivateOnEnter: !0 }, a), {
            separator: () => this.separator === void 0 ? vr(n.separator, () => [
              b(fr, { clsPrefix: r, class: `${r}-date-picker-icon` }, {
                default: () => b(Dfe, null)
              })
            ]) : this.separator,
            [e ? "clear-icon-placeholder" : "suffix"]: () => vr(n["date-icon"], () => [
              b(fr, { clsPrefix: r, class: `${r}-date-picker-icon` }, {
                default: () => b(EP, null)
              })
            ])
          }) : b(pa, Object.assign({ ref: "inputInstRef", status: this.mergedStatus, value: this.displayTime, placeholder: this.localizedPlacehoder, textDecoration: this.isValueInvalid && !this.isRange ? "line-through" : "", onUpdateValue: this.handleSingleUpdateValue, theme: this.mergedTheme.peers.Input, themeOverrides: this.mergedTheme.peerOverrides.Input, internalForceFocus: this.mergedShow, internalDeactivateOnEnter: !0 }, a), {
            [e ? "clear-icon-placeholder" : "suffix"]: () => b(fr, { clsPrefix: r, class: `${r}-date-picker-icon` }, {
              default: () => vr(n["date-icon"], () => [
                b(EP, null)
              ])
            })
          })
        }),
        b(_c, { show: this.mergedShow, containerClass: this.namespace, to: this.adjustedTo, teleportDisabled: this.adjustedTo === vi.tdkey, placement: this.placement }, {
          default: () => b(jn, { name: "fade-in-scale-up-transition", appear: this.isMounted }, {
            default: () => this.mergedShow ? Jn(o(), [
              [
                ks,
                this.handleClickOutside,
                void 0,
                { capture: !0 }
              ]
            ]) : null
          })
        })
      ]
    }));
  }
}), fbe = {
  titleFontSize: "18px",
  padding: "16px 28px 20px 28px",
  iconSize: "28px",
  actionSpace: "12px",
  contentMargin: "8px 0 16px 0",
  iconMargin: "0 4px 0 0",
  iconMarginIconTop: "4px 0 8px 0",
  closeSize: "22px",
  closeIconSize: "18px",
  closeMargin: "20px 26px 0 0",
  closeMarginIconTop: "10px 16px 0 0"
};
const hbe = (e) => {
  const { textColor1: t, textColor2: r, modalColor: n, closeIconColor: i, closeIconColorHover: o, closeIconColorPressed: a, closeColorHover: s, closeColorPressed: u, infoColor: d, successColor: f, warningColor: h, errorColor: g, primaryColor: m, dividerColor: v, borderRadius: w, fontWeightStrong: x, lineHeight: y, fontSize: C } = e;
  return Object.assign(Object.assign({}, fbe), {
    fontSize: C,
    lineHeight: y,
    border: `1px solid ${v}`,
    titleTextColor: t,
    textColor: r,
    color: n,
    closeColorHover: s,
    closeColorPressed: u,
    closeIconColor: i,
    closeIconColorHover: o,
    closeIconColorPressed: a,
    closeBorderRadius: w,
    iconColor: m,
    iconColorInfo: d,
    iconColorSuccess: f,
    iconColorWarning: h,
    iconColorError: g,
    borderRadius: w,
    titleFontWeight: x
  });
}, pbe = {
  name: "Dialog",
  common: Sr,
  peers: {
    Button: Yu
  },
  self: hbe
};
var yW = pbe;
const F4 = {
  icon: Function,
  type: {
    type: String,
    default: "default"
  },
  title: [String, Function],
  closable: {
    type: Boolean,
    default: !0
  },
  negativeText: String,
  positiveText: String,
  positiveButtonProps: Object,
  negativeButtonProps: Object,
  content: [String, Function],
  action: Function,
  showIcon: {
    type: Boolean,
    default: !0
  },
  loading: Boolean,
  bordered: Boolean,
  iconPlacement: String,
  onPositiveClick: Function,
  onNegativeClick: Function,
  onClose: Function
}, gbe = Ts(F4);
var mbe = Y([L("dialog", `
 word-break: break-word;
 line-height: var(--n-line-height);
 position: relative;
 background: var(--n-color);
 color: var(--n-text-color);
 box-sizing: border-box;
 margin: auto;
 border-radius: var(--n-border-radius);
 padding: var(--n-padding);
 transition: 
 border-color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `, [q("icon", {
  color: "var(--n-icon-color)"
}), K("bordered", {
  border: "var(--n-border)"
}), K("icon-top", [q("close", {
  margin: "var(--n-close-margin)"
}), q("icon", {
  margin: "var(--n-icon-margin)"
}), q("content", {
  textAlign: "center"
}), q("title", {
  justifyContent: "center"
}), q("action", {
  justifyContent: "center"
})]), K("icon-left", [q("icon", {
  margin: "var(--n-icon-margin)"
}), K("closable", [q("title", `
 padding-right: calc(var(--n-close-size) + 6px);
 `)])]), q("close", `
 position: absolute;
 right: 0;
 top: 0;
 margin: var(--n-close-margin);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 z-index: 1;
 `), q("content", `
 font-size: var(--n-font-size);
 margin: var(--n-content-margin);
 position: relative;
 word-break: break-word;
 `, [K("last", "margin-bottom: 0;")]), q("action", `
 display: flex;
 justify-content: flex-end;
 `, [Y("> *:not(:last-child)", {
  marginRight: "var(--n-action-space)"
})]), q("icon", {
  fontSize: "var(--n-icon-size)",
  transition: "color .3s var(--n-bezier)"
}), q("title", `
 transition: color .3s var(--n-bezier);
 display: flex;
 align-items: center;
 font-size: var(--n-title-font-size);
 font-weight: var(--n-title-font-weight);
 color: var(--n-title-text-color);
 `), L("dialog-icon-container", {
  display: "flex",
  justifyContent: "center"
})]), Bp(L("dialog", `
 width: 446px;
 max-width: calc(100vw - 32px);
 `)), L("dialog", [yU(`
 width: 446px;
 max-width: calc(100vw - 32px);
 `)])]);
const vbe = {
  default: () => b(vp, null),
  info: () => b(vp, null),
  success: () => b(xb, null),
  warning: () => b(wb, null),
  error: () => b(yb, null)
}, bbe = oe({
  name: "Dialog",
  alias: [
    "NimbusConfirmCard",
    "Confirm"
  ],
  props: Object.assign(Object.assign({}, ft.props), F4),
  setup(e) {
    const { mergedComponentPropsRef: t, mergedClsPrefixRef: r, inlineThemeDisabled: n } = Yt(e), i = j(() => {
      var h, g;
      const { iconPlacement: m } = e;
      return m || ((g = (h = t == null ? void 0 : t.value) === null || h === void 0 ? void 0 : h.Dialog) === null || g === void 0 ? void 0 : g.iconPlacement) || "left";
    });
    function o(h) {
      const { onPositiveClick: g } = e;
      g && g(h);
    }
    function a(h) {
      const { onNegativeClick: g } = e;
      g && g(h);
    }
    function s() {
      const { onClose: h } = e;
      h && h();
    }
    const u = ft("Dialog", "-dialog", mbe, yW, e, r), d = j(() => {
      const { type: h } = e, g = i.value, { common: { cubicBezierEaseInOut: m }, self: { fontSize: v, lineHeight: w, border: x, titleTextColor: y, textColor: C, color: S, closeBorderRadius: T, closeColorHover: A, closeColorPressed: D, closeIconColor: E, closeIconColorHover: N, closeIconColorPressed: I, closeIconSize: $, borderRadius: _, titleFontWeight: R, titleFontSize: U, padding: Q, iconSize: Z, actionSpace: X, contentMargin: re, closeSize: ue, [g === "top" ? "iconMarginIconTop" : "iconMargin"]: he, [g === "top" ? "closeMarginIconTop" : "closeMargin"]: te, [Be("iconColor", h)]: de } } = u.value;
      return {
        "--n-font-size": v,
        "--n-icon-color": de,
        "--n-bezier": m,
        "--n-close-margin": te,
        "--n-icon-margin": he,
        "--n-icon-size": Z,
        "--n-close-size": ue,
        "--n-close-icon-size": $,
        "--n-close-border-radius": T,
        "--n-close-color-hover": A,
        "--n-close-color-pressed": D,
        "--n-close-icon-color": E,
        "--n-close-icon-color-hover": N,
        "--n-close-icon-color-pressed": I,
        "--n-color": S,
        "--n-text-color": C,
        "--n-border-radius": _,
        "--n-padding": Q,
        "--n-line-height": w,
        "--n-border": x,
        "--n-content-margin": re,
        "--n-title-font-size": U,
        "--n-title-font-weight": R,
        "--n-title-text-color": y,
        "--n-action-space": X
      };
    }), f = n ? Cr("dialog", j(() => `${e.type[0]}${i.value[0]}`), d, e) : void 0;
    return {
      mergedClsPrefix: r,
      mergedIconPlacement: i,
      mergedTheme: u,
      handlePositiveClick: o,
      handleNegativeClick: a,
      handleCloseClick: s,
      cssVars: n ? void 0 : d,
      themeClass: f == null ? void 0 : f.themeClass,
      onRender: f == null ? void 0 : f.onRender
    };
  },
  render() {
    var e;
    const { bordered: t, mergedIconPlacement: r, cssVars: n, closable: i, showIcon: o, title: a, content: s, action: u, negativeText: d, positiveText: f, positiveButtonProps: h, negativeButtonProps: g, handlePositiveClick: m, handleNegativeClick: v, mergedTheme: w, loading: x, type: y, mergedClsPrefix: C } = this;
    (e = this.onRender) === null || e === void 0 || e.call(this);
    const S = o ? b(fr, { clsPrefix: C, class: `${C}-dialog__icon` }, {
      default: () => Fr(this.$slots.icon, (A) => A || (this.icon ? xn(this.icon) : vbe[this.type]()))
    }) : null, T = Fr(this.$slots.action, (A) => A || f || d || u ? b("div", { class: `${C}-dialog__action` }, A || (u ? [xn(u)] : [
      this.negativeText && b(Mn, Object.assign({ theme: w.peers.Button, themeOverrides: w.peerOverrides.Button, ghost: !0, size: "small", onClick: v }, g), {
        default: () => xn(this.negativeText)
      }),
      this.positiveText && b(Mn, Object.assign({ theme: w.peers.Button, themeOverrides: w.peerOverrides.Button, size: "small", type: y === "default" ? "primary" : y, disabled: x, loading: x, onClick: m }, h), {
        default: () => xn(this.positiveText)
      })
    ])) : null);
    return b("div", { class: [
      `${C}-dialog`,
      this.themeClass,
      this.closable && `${C}-dialog--closable`,
      `${C}-dialog--icon-${r}`,
      t && `${C}-dialog--bordered`
    ], style: n, role: "dialog" }, i ? b(gh, { clsPrefix: C, class: `${C}-dialog__close`, onClick: this.handleCloseClick }) : null, o && r === "top" ? b("div", { class: `${C}-dialog-icon-container` }, S) : null, b("div", { class: `${C}-dialog__title` }, o && r === "left" ? S : null, vr(this.$slots.header, () => [xn(a)])), b("div", { class: [
      `${C}-dialog__content`,
      T ? "" : `${C}-dialog__content--last`
    ] }, vr(this.$slots.default, () => [xn(s)])), T);
  }
}), ybe = "n-dialog-provider", xbe = (e) => {
  const { modalColor: t, textColor2: r, boxShadow3: n } = e;
  return {
    color: t,
    textColor: r,
    boxShadow: n
  };
}, wbe = {
  name: "Modal",
  common: Sr,
  peers: {
    Scrollbar: Rc,
    Dialog: yW,
    Card: zH
  },
  self: xbe
};
var Mbe = wbe;
const B4 = Object.assign(Object.assign({}, D4), F4), Cbe = Ts(B4);
var Sbe = oe({
  name: "ModalBody",
  inheritAttrs: !1,
  props: Object.assign(Object.assign({ show: {
    type: Boolean,
    required: !0
  }, preset: String, displayDirective: {
    type: String,
    required: !0
  }, trapFocus: {
    type: Boolean,
    default: !0
  }, autoFocus: {
    type: Boolean,
    default: !0
  }, blockScroll: Boolean }, B4), {
    renderMask: Function,
    onClickoutside: Function,
    onBeforeLeave: {
      type: Function,
      required: !0
    },
    onAfterLeave: {
      type: Function,
      required: !0
    },
    onPositiveClick: {
      type: Function,
      required: !0
    },
    onNegativeClick: {
      type: Function,
      required: !0
    },
    onClose: {
      type: Function,
      required: !0
    },
    onAfterEnter: Function,
    onEsc: Function
  }),
  setup(e) {
    const t = G(null), r = G(null), n = G(e.show), i = G(null), o = G(null);
    Gt(tt(e, "show"), (x) => {
      x && (n.value = !0);
    }), UU(j(() => e.blockScroll && n.value));
    const a = lt(kU);
    function s() {
      if (a.transformOriginRef.value === "center")
        return "";
      const { value: x } = i, { value: y } = o;
      if (x === null || y === null)
        return "";
      if (r.value) {
        const C = r.value.containerScrollTop;
        return `${x}px ${y + C}px`;
      }
      return "";
    }
    function u(x) {
      if (a.transformOriginRef.value === "center")
        return;
      const y = a.getMousePosition();
      if (!y || !r.value)
        return;
      const C = r.value.containerScrollTop, { offsetLeft: S, offsetTop: T } = x;
      if (y) {
        const A = y.y, D = y.x;
        i.value = -(S - D), o.value = -(T - A - C);
      }
      x.style.transformOrigin = s();
    }
    function d(x) {
      an(() => {
        u(x);
      });
    }
    function f(x) {
      x.style.transformOrigin = s(), e.onBeforeLeave();
    }
    function h() {
      n.value = !1, i.value = null, o.value = null, e.onAfterLeave();
    }
    function g() {
      const { onClose: x } = e;
      x && x();
    }
    function m() {
      e.onNegativeClick();
    }
    function v() {
      e.onPositiveClick();
    }
    const w = G(null);
    return Gt(w, (x) => {
      x && an(() => {
        const y = x.el;
        y && t.value !== y && (t.value = y);
      });
    }), tr(pb, t), tr(gb, null), tr(Up, null), {
      mergedTheme: a.mergedThemeRef,
      appear: a.appearRef,
      isMounted: a.isMountedRef,
      mergedClsPrefix: a.mergedClsPrefixRef,
      bodyRef: t,
      scrollbarRef: r,
      displayed: n,
      childNodeRef: w,
      handlePositiveClick: v,
      handleNegativeClick: m,
      handleCloseClick: g,
      handleAfterLeave: h,
      handleBeforeLeave: f,
      handleEnter: d
    };
  },
  render() {
    const { $slots: e, $attrs: t, handleEnter: r, handleAfterLeave: n, handleBeforeLeave: i, preset: o, mergedClsPrefix: a } = this;
    let s = null;
    if (!o) {
      if (s = nz(e), !s) {
        ja("modal", "default slot is empty");
        return;
      }
      s = db(s), s.props = ir({
        class: `${a}-modal`
      }, t, s.props || {});
    }
    return this.displayDirective === "show" || this.displayed || this.show ? Jn(b("div", { role: "none", class: `${a}-modal-body-wrapper` }, b(no, { ref: "scrollbarRef", theme: this.mergedTheme.peers.Scrollbar, themeOverrides: this.mergedTheme.peerOverrides.Scrollbar, contentClass: `${a}-modal-scroll-content` }, {
      default: () => {
        var u;
        return [
          (u = this.renderMask) === null || u === void 0 ? void 0 : u.call(this),
          b(t4, { disabled: !this.trapFocus, active: this.show, onEsc: this.onEsc, autoFocus: this.autoFocus }, {
            default: () => {
              var d;
              return b(jn, { name: "fade-in-scale-up-transition", appear: (d = this.appear) !== null && d !== void 0 ? d : this.isMounted, onEnter: r, onAfterEnter: this.onAfterEnter, onAfterLeave: n, onBeforeLeave: i }, {
                default: () => {
                  const f = [
                    [Ra, this.show]
                  ], { onClickoutside: h } = this;
                  return h && f.push([
                    ks,
                    this.onClickoutside,
                    void 0,
                    { capture: !0 }
                  ]), Jn(this.preset === "confirm" || this.preset === "dialog" ? b(bbe, Object.assign({}, this.$attrs, { class: [
                    `${a}-modal`,
                    this.$attrs.class
                  ], ref: "bodyRef", theme: this.mergedTheme.peers.Dialog, themeOverrides: this.mergedTheme.peerOverrides.Dialog }, il(this.$props, gbe), { "aria-modal": "true" }), e) : this.preset === "card" ? b($H, Object.assign({}, this.$attrs, { ref: "bodyRef", class: [
                    `${a}-modal`,
                    this.$attrs.class
                  ], theme: this.mergedTheme.peers.Card, themeOverrides: this.mergedTheme.peerOverrides.Card }, il(this.$props, Pge), { "aria-modal": "true", role: "dialog" }), e) : this.childNodeRef = s, f);
                }
              });
            }
          })
        ];
      }
    })), [
      [
        Ra,
        this.displayDirective === "if" || this.displayed || this.show
      ]
    ]) : null;
  }
}), Tbe = Y([L("modal-container", `
 position: fixed;
 left: 0;
 top: 0;
 height: 0;
 width: 0;
 display: flex;
 `), L("modal-mask", `
 position: fixed;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 background-color: rgba(0, 0, 0, .4);
 `, [bp({
  enterDuration: ".25s",
  leaveDuration: ".25s",
  enterCubicBezier: "var(--n-bezier-ease-out)",
  leaveCubicBezier: "var(--n-bezier-ease-out)"
})]), L("modal-body-wrapper", `
 position: fixed;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 overflow: visible;
 `, [L("modal-scroll-content", `
 min-height: 100%;
 display: flex;
 position: relative;
 `)]), L("modal", `
 position: relative;
 align-self: center;
 color: var(--n-text-color);
 margin: auto;
 box-shadow: var(--n-box-shadow);
 `, [Fa({
  duration: ".25s",
  enterScale: ".5"
})])]);
const kbe = Object.assign(Object.assign(Object.assign(Object.assign({}, ft.props), { show: Boolean, unstableShowMask: {
  type: Boolean,
  default: !0
}, maskClosable: {
  type: Boolean,
  default: !0
}, preset: String, to: [String, Object], displayDirective: {
  type: String,
  default: "if"
}, transformOrigin: {
  type: String,
  default: "mouse"
}, zIndex: Number, autoFocus: {
  type: Boolean,
  default: !0
}, trapFocus: {
  type: Boolean,
  default: !0
}, closeOnEsc: {
  type: Boolean,
  default: !0
}, blockScroll: { type: Boolean, default: !0 } }), B4), {
  onEsc: Function,
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  onAfterEnter: Function,
  onBeforeLeave: Function,
  onAfterLeave: Function,
  onClose: Function,
  onPositiveClick: Function,
  onNegativeClick: Function,
  onMaskClick: Function,
  internalDialog: Boolean,
  internalAppear: {
    type: Boolean,
    default: void 0
  },
  overlayStyle: [String, Object],
  onBeforeHide: Function,
  onAfterHide: Function,
  onHide: Function
});
var Dbe = oe({
  name: "Modal",
  inheritAttrs: !1,
  props: kbe,
  setup(e) {
    const t = G(null), { mergedClsPrefixRef: r, namespaceRef: n, inlineThemeDisabled: i } = Yt(e), o = ft("Modal", "-modal", Tbe, Mbe, e, r), a = yX(64), s = vX(), u = ql(), d = e.internalDialog ? lt(ybe, null) : null, f = HU();
    function h(A) {
      const { onUpdateShow: D, "onUpdate:show": E, onHide: N } = e;
      D && je(D, A), E && je(E, A), N && !A && N(A);
    }
    function g() {
      const { onClose: A } = e;
      A ? Promise.resolve(A()).then((D) => {
        D !== !1 && h(!1);
      }) : h(!1);
    }
    function m() {
      const { onPositiveClick: A } = e;
      A ? Promise.resolve(A()).then((D) => {
        D !== !1 && h(!1);
      }) : h(!1);
    }
    function v() {
      const { onNegativeClick: A } = e;
      A ? Promise.resolve(A()).then((D) => {
        D !== !1 && h(!1);
      }) : h(!1);
    }
    function w() {
      const { onBeforeLeave: A, onBeforeHide: D } = e;
      A && je(A), D && D();
    }
    function x() {
      const { onAfterLeave: A, onAfterHide: D } = e;
      A && je(A), D && D();
    }
    function y(A) {
      var D;
      const { onMaskClick: E } = e;
      E && E(A), e.maskClosable && !((D = t.value) === null || D === void 0) && D.contains(Ul(A)) && h(!1);
    }
    function C(A) {
      var D;
      (D = e.onEsc) === null || D === void 0 || D.call(e), e.show && e.closeOnEsc && wU(A) && !f.value && h(!1);
    }
    tr(kU, {
      getMousePosition: () => {
        if (d) {
          const { clickedRef: A, clickPositionRef: D } = d;
          if (A.value && D.value)
            return D.value;
        }
        return a.value ? s.value : null;
      },
      mergedClsPrefixRef: r,
      mergedThemeRef: o,
      isMountedRef: u,
      appearRef: tt(e, "internalAppear"),
      transformOriginRef: tt(e, "transformOrigin")
    });
    const S = j(() => {
      const { common: { cubicBezierEaseOut: A }, self: { boxShadow: D, color: E, textColor: N } } = o.value;
      return {
        "--n-bezier-ease-out": A,
        "--n-box-shadow": D,
        "--n-color": E,
        "--n-text-color": N
      };
    }), T = i ? Cr("theme-class", void 0, S, e) : void 0;
    return {
      mergedClsPrefix: r,
      namespace: n,
      isMounted: u,
      containerRef: t,
      presetProps: j(() => il(e, Cbe)),
      handleEsc: C,
      handleAfterLeave: x,
      handleClickoutside: y,
      handleBeforeLeave: w,
      doUpdateShow: h,
      handleNegativeClick: v,
      handlePositiveClick: m,
      handleCloseClick: g,
      cssVars: i ? void 0 : S,
      themeClass: T == null ? void 0 : T.themeClass,
      onRender: T == null ? void 0 : T.onRender
    };
  },
  render() {
    const { mergedClsPrefix: e } = this;
    return b($M, { to: this.to, show: this.show }, {
      default: () => {
        var t;
        (t = this.onRender) === null || t === void 0 || t.call(this);
        const { unstableShowMask: r } = this;
        return Jn(b("div", { role: "none", ref: "containerRef", class: [
          `${e}-modal-container`,
          this.themeClass,
          this.namespace
        ], style: this.cssVars }, b(Sbe, Object.assign({ style: this.overlayStyle }, this.$attrs, { ref: "bodyWrapper", displayDirective: this.displayDirective, show: this.show, preset: this.preset, autoFocus: this.autoFocus, trapFocus: this.trapFocus, blockScroll: this.blockScroll }, this.presetProps, { onEsc: this.handleEsc, onClose: this.handleCloseClick, onNegativeClick: this.handleNegativeClick, onPositiveClick: this.handlePositiveClick, onBeforeLeave: this.handleBeforeLeave, onAfterEnter: this.onAfterEnter, onAfterLeave: this.handleAfterLeave, onClickoutside: r ? void 0 : this.handleClickoutside, renderMask: r ? () => {
          var n;
          return b(jn, { name: "fade-in-transition", key: "mask", appear: (n = this.internalAppear) !== null && n !== void 0 ? n : this.isMounted }, {
            default: () => this.show ? b("div", { "aria-hidden": !0, ref: "containerRef", class: `${e}-modal-mask`, onClick: this.handleClickoutside }) : null
          });
        } : void 0 }), this.$slots)), [
          [
            mb,
            {
              zIndex: this.zIndex,
              enabled: this.show
            }
          ]
        ]);
      }
    });
  }
});
const Abe = (e) => {
  const { textColor1: t, dividerColor: r, fontWeightStrong: n } = e;
  return {
    textColor: t,
    color: r,
    fontWeight: n
  };
}, Ebe = {
  name: "Divider",
  common: Sr,
  self: Abe
};
var Ibe = Ebe, Nbe = L("divider", `
 position: relative;
 display: flex;
 width: 100%;
 box-sizing: border-box;
 font-size: 16px;
 color: var(--n-text-color);
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
`, [wr("vertical", `
 margin-top: 24px;
 margin-bottom: 24px;
 `, [wr("no-title", `
 display: flex;
 align-items: center;
 `)]), q("title", `
 display: flex;
 align-items: center;
 margin-left: 12px;
 margin-right: 12px;
 white-space: nowrap;
 font-weight: var(--n-font-weight);
 `), K("title-position-left", [q("line", [K("left", {
  width: "28px"
})])]), K("title-position-right", [q("line", [K("right", {
  width: "28px"
})])]), K("dashed", [q("line", `
 background-color: #0000;
 height: 0px;
 width: 100%;
 border-style: dashed;
 border-width: 1px 0 0;
 `)]), K("vertical", `
 display: inline-block;
 height: 1em;
 margin: 0 8px;
 vertical-align: middle;
 width: 1px;
 `), q("line", `
 border: none;
 transition: background-color .3s var(--n-bezier), border-color .3s var(--n-bezier);
 height: 1px;
 width: 100%;
 margin: 0;
 `), wr("dashed", [q("line", {
  backgroundColor: "var(--n-color)"
})]), K("dashed", [q("line", {
  borderColor: "var(--n-color)"
})]), K("vertical", {
  backgroundColor: "var(--n-color)"
})]);
const zbe = Object.assign(Object.assign({}, ft.props), { titlePlacement: {
  type: String,
  default: "center"
}, dashed: Boolean, vertical: Boolean });
var gR = oe({
  name: "Divider",
  props: zbe,
  setup(e) {
    const { mergedClsPrefixRef: t, inlineThemeDisabled: r } = Yt(e), n = ft("Divider", "-divider", Nbe, Ibe, e, t), i = j(() => {
      const { common: { cubicBezierEaseInOut: a }, self: { color: s, textColor: u, fontWeight: d } } = n.value;
      return {
        "--n-bezier": a,
        "--n-color": s,
        "--n-text-color": u,
        "--n-font-weight": d
      };
    }), o = r ? Cr("divider", void 0, i, e) : void 0;
    return {
      mergedClsPrefix: t,
      cssVars: r ? void 0 : i,
      themeClass: o == null ? void 0 : o.themeClass,
      onRender: o == null ? void 0 : o.onRender
    };
  },
  render() {
    var e;
    const { $slots: t, titlePlacement: r, vertical: n, dashed: i, cssVars: o, mergedClsPrefix: a } = this;
    return (e = this.onRender) === null || e === void 0 || e.call(this), b("div", { role: "separator", class: [
      `${a}-divider`,
      this.themeClass,
      {
        [`${a}-divider--vertical`]: n,
        [`${a}-divider--no-title`]: !t.default,
        [`${a}-divider--dashed`]: i,
        [`${a}-divider--title-position-${r}`]: t.default && r
      }
    ], style: o }, n ? null : b("div", { class: `${a}-divider__line ${a}-divider__line--left` }), !n && t.default ? b(Lr, null, b("div", { class: `${a}-divider__title` }, this.$slots), b("div", { class: `${a}-divider__line ${a}-divider__line--right` })) : null);
  }
});
const $be = (e) => {
  const { modalColor: t, textColor1: r, textColor2: n, boxShadow3: i, lineHeight: o, fontWeightStrong: a, dividerColor: s, closeColorHover: u, closeColorPressed: d, closeIconColor: f, closeIconColorHover: h, closeIconColorPressed: g, borderRadius: m, primaryColorHover: v } = e;
  return {
    bodyPadding: "16px 24px",
    headerPadding: "16px 24px",
    footerPadding: "16px 24px",
    color: t,
    textColor: n,
    titleTextColor: r,
    titleFontSize: "18px",
    titleFontWeight: a,
    boxShadow: i,
    lineHeight: o,
    headerBorderBottom: `1px solid ${s}`,
    footerBorderTop: `1px solid ${s}`,
    closeIconColor: f,
    closeIconColorHover: h,
    closeIconColorPressed: g,
    closeSize: "22px",
    closeIconSize: "18px",
    closeColorHover: u,
    closeColorPressed: d,
    closeBorderRadius: m,
    resizableTriggerColorHover: v
  };
}, Obe = {
  name: "Drawer",
  common: Sr,
  peers: {
    Scrollbar: Rc
  },
  self: $be
};
var _be = Obe, Lbe = oe({
  name: "NDrawerContent",
  inheritAttrs: !1,
  props: {
    blockScroll: Boolean,
    show: {
      type: Boolean,
      default: void 0
    },
    displayDirective: {
      type: String,
      required: !0
    },
    placement: {
      type: String,
      required: !0
    },
    contentStyle: [Object, String],
    nativeScrollbar: {
      type: Boolean,
      required: !0
    },
    scrollbarProps: Object,
    trapFocus: {
      type: Boolean,
      default: !0
    },
    autoFocus: {
      type: Boolean,
      default: !0
    },
    showMask: {
      type: [Boolean, String],
      required: !0
    },
    resizable: Boolean,
    onClickoutside: Function,
    onAfterLeave: Function,
    onAfterEnter: Function,
    onEsc: Function
  },
  setup(e) {
    const t = G(!!e.show), r = G(null), n = lt(JO);
    let i = 0, o = "", a = null;
    const s = G(!1), u = G(!1), d = j(() => e.placement === "top" || e.placement === "bottom"), { mergedClsPrefixRef: f, mergedRtlRef: h } = Yt(e), g = Li("Drawer", h, f), m = (E) => {
      u.value = !0, i = d.value ? E.clientY : E.clientX, o = document.body.style.cursor, document.body.style.cursor = d.value ? "ns-resize" : "ew-resize", document.body.addEventListener("mousemove", C), document.body.addEventListener("mouseleave", T), document.body.addEventListener("mouseup", S);
    }, v = () => {
      a !== null && (window.clearTimeout(a), a = null), u.value ? s.value = !0 : a = window.setTimeout(() => {
        s.value = !0;
      }, 300);
    }, w = () => {
      a !== null && (window.clearTimeout(a), a = null), s.value = !1;
    }, { doUpdateHeight: x, doUpdateWidth: y } = n, C = (E) => {
      var N, I;
      if (u.value)
        if (d.value) {
          let $ = ((N = r.value) === null || N === void 0 ? void 0 : N.offsetHeight) || 0;
          const _ = i - E.clientY;
          $ += e.placement === "bottom" ? _ : -_, x($), i = E.clientY;
        } else {
          let $ = ((I = r.value) === null || I === void 0 ? void 0 : I.offsetWidth) || 0;
          const _ = i - E.clientX;
          $ += e.placement === "right" ? _ : -_, y($), i = E.clientX;
        }
    }, S = () => {
      u.value && (i = 0, u.value = !1, document.body.style.cursor = o, document.body.removeEventListener("mousemove", C), document.body.removeEventListener("mouseup", S), document.body.removeEventListener("mouseleave", T));
    }, T = S;
    On(() => {
      e.show && (t.value = !0);
    }), Gt(() => e.show, (E) => {
      E || S();
    }), Gr(() => {
      S();
    });
    const A = j(() => {
      const { show: E } = e, N = [[Ra, E]];
      return e.showMask || N.push([
        ks,
        e.onClickoutside,
        void 0,
        { capture: !0 }
      ]), N;
    });
    function D() {
      var E;
      t.value = !1, (E = e.onAfterLeave) === null || E === void 0 || E.call(e);
    }
    return UU(j(() => e.blockScroll && t.value)), tr(gb, r), tr(Up, null), tr(pb, null), {
      bodyRef: r,
      rtlEnabled: g,
      mergedClsPrefix: n.mergedClsPrefixRef,
      isMounted: n.isMountedRef,
      mergedTheme: n.mergedThemeRef,
      displayed: t,
      transitionName: j(() => ({
        right: "slide-in-from-right-transition",
        left: "slide-in-from-left-transition",
        top: "slide-in-from-top-transition",
        bottom: "slide-in-from-bottom-transition"
      })[e.placement]),
      handleAfterLeave: D,
      bodyDirectives: A,
      handleMousedownResizeTrigger: m,
      handleMouseenterResizeTrigger: v,
      handleMouseleaveResizeTrigger: w,
      isDragging: u,
      isHoverOnResizeTrigger: s
    };
  },
  render() {
    const { $slots: e, mergedClsPrefix: t } = this;
    return this.displayDirective === "show" || this.displayed || this.show ? Jn(b("div", { role: "none" }, b(t4, { disabled: !this.showMask || !this.trapFocus, active: this.show, autoFocus: this.autoFocus, onEsc: this.onEsc }, {
      default: () => b(jn, { name: this.transitionName, appear: this.isMounted, onAfterEnter: this.onAfterEnter, onAfterLeave: this.handleAfterLeave }, {
        default: () => Jn(b("div", ir(this.$attrs, {
          role: "dialog",
          ref: "bodyRef",
          "aria-modal": "true",
          class: [
            `${t}-drawer`,
            this.rtlEnabled && `${t}-drawer--rtl`,
            `${t}-drawer--${this.placement}-placement`,
            this.isDragging && `${t}-drawer--unselectable`,
            this.nativeScrollbar && `${t}-drawer--native-scrollbar`
          ]
        }), [
          this.resizable ? b("div", { class: [
            `${t}-drawer__resize-trigger`,
            (this.isDragging || this.isHoverOnResizeTrigger) && `${t}-drawer__resize-trigger--hover`
          ], onMouseenter: this.handleMouseenterResizeTrigger, onMouseleave: this.handleMouseleaveResizeTrigger, onMousedown: this.handleMousedownResizeTrigger }) : null,
          this.nativeScrollbar ? b("div", { class: `${t}-drawer-content-wrapper`, style: this.contentStyle, role: "none" }, e) : b(no, Object.assign({}, this.scrollbarProps, { contentStyle: this.contentStyle, contentClass: `${t}-drawer-content-wrapper`, theme: this.mergedTheme.peers.Scrollbar, themeOverrides: this.mergedTheme.peerOverrides.Scrollbar }), e)
        ]), this.bodyDirectives)
      })
    })), [
      [
        Ra,
        this.displayDirective === "if" || this.displayed || this.show
      ]
    ]) : null;
  }
});
const { cubicBezierEaseIn: Pbe, cubicBezierEaseOut: Rbe } = Wa;
function jbe({ duration: e = "0.3s", leaveDuration: t = "0.2s", name: r = "slide-in-from-right" } = {}) {
  return [
    Y(`&.${r}-transition-leave-active`, {
      transition: `transform ${t} ${Pbe}`
    }),
    Y(`&.${r}-transition-enter-active`, {
      transition: `transform ${e} ${Rbe}`
    }),
    Y(`&.${r}-transition-enter-to`, {
      transform: "translateX(0)"
    }),
    Y(`&.${r}-transition-enter-from`, {
      transform: "translateX(100%)"
    }),
    Y(`&.${r}-transition-leave-from`, {
      transform: "translateX(0)"
    }),
    Y(`&.${r}-transition-leave-to`, {
      transform: "translateX(100%)"
    })
  ];
}
const { cubicBezierEaseIn: Fbe, cubicBezierEaseOut: Bbe } = Wa;
function Ube({ duration: e = "0.3s", leaveDuration: t = "0.2s", name: r = "slide-in-from-left" } = {}) {
  return [
    Y(`&.${r}-transition-leave-active`, {
      transition: `transform ${t} ${Fbe}`
    }),
    Y(`&.${r}-transition-enter-active`, {
      transition: `transform ${e} ${Bbe}`
    }),
    Y(`&.${r}-transition-enter-to`, {
      transform: "translateX(0)"
    }),
    Y(`&.${r}-transition-enter-from`, {
      transform: "translateX(-100%)"
    }),
    Y(`&.${r}-transition-leave-from`, {
      transform: "translateX(0)"
    }),
    Y(`&.${r}-transition-leave-to`, {
      transform: "translateX(-100%)"
    })
  ];
}
const { cubicBezierEaseIn: Hbe, cubicBezierEaseOut: Wbe } = Wa;
function Vbe({ duration: e = "0.3s", leaveDuration: t = "0.2s", name: r = "slide-in-from-top" } = {}) {
  return [
    Y(`&.${r}-transition-leave-active`, {
      transition: `transform ${t} ${Hbe}`
    }),
    Y(`&.${r}-transition-enter-active`, {
      transition: `transform ${e} ${Wbe}`
    }),
    Y(`&.${r}-transition-enter-to`, {
      transform: "translateY(0)"
    }),
    Y(`&.${r}-transition-enter-from`, {
      transform: "translateY(-100%)"
    }),
    Y(`&.${r}-transition-leave-from`, {
      transform: "translateY(0)"
    }),
    Y(`&.${r}-transition-leave-to`, {
      transform: "translateY(-100%)"
    })
  ];
}
const { cubicBezierEaseIn: Ybe, cubicBezierEaseOut: Qbe } = Wa;
function qbe({ duration: e = "0.3s", leaveDuration: t = "0.2s", name: r = "slide-in-from-bottom" } = {}) {
  return [
    Y(`&.${r}-transition-leave-active`, {
      transition: `transform ${t} ${Ybe}`
    }),
    Y(`&.${r}-transition-enter-active`, {
      transition: `transform ${e} ${Qbe}`
    }),
    Y(`&.${r}-transition-enter-to`, {
      transform: "translateY(0)"
    }),
    Y(`&.${r}-transition-enter-from`, {
      transform: "translateY(100%)"
    }),
    Y(`&.${r}-transition-leave-from`, {
      transform: "translateY(0)"
    }),
    Y(`&.${r}-transition-leave-to`, {
      transform: "translateY(100%)"
    })
  ];
}
var Gbe = Y([L("drawer", `
 word-break: break-word;
 line-height: var(--n-line-height);
 position: absolute;
 pointer-events: all;
 box-shadow: var(--n-box-shadow);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 background-color: var(--n-color);
 color: var(--n-text-color);
 box-sizing: border-box;
 `, [jbe(), Ube(), Vbe(), qbe(), K("unselectable", `
 user-select: none; 
 -webkit-user-select: none;
 `), K("native-scrollbar", [L("drawer-content-wrapper", `
 overflow: auto;
 height: 100%;
 `)]), q("resize-trigger", `
 position: absolute;
 background-color: #0000;
 transition: background-color .3s var(--n-bezier);
 `, [K("hover", `
 background-color: var(--n-resize-trigger-color-hover);
 `)]), L("drawer-content-wrapper", `
 box-sizing: border-box;
 `), L("drawer-content", `
 height: 100%;
 display: flex;
 flex-direction: column;
 `, [K("native-scrollbar", [L("drawer-body-content-wrapper", `
 height: 100%;
 overflow: auto;
 `)]), L("drawer-body", `
 flex: 1 0 0;
 overflow: hidden;
 `), L("drawer-body-content-wrapper", `
 box-sizing: border-box;
 padding: var(--n-body-padding);
 `), L("drawer-header", `
 font-weight: var(--n-title-font-weight);
 line-height: 1;
 font-size: var(--n-title-font-size);
 color: var(--n-title-text-color);
 padding: var(--n-header-padding);
 transition: border .3s var(--n-bezier);
 border-bottom: 1px solid var(--n-divider-color);
 border-bottom: var(--n-header-border-bottom);
 display: flex;
 justify-content: space-between;
 align-items: center;
 `, [q("close", `
 margin-left: 6px;
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `)]), L("drawer-footer", `
 display: flex;
 justify-content: flex-end;
 border-top: var(--n-footer-border-top);
 transition: border .3s var(--n-bezier);
 padding: var(--n-footer-padding);
 `)]), K("right-placement", `
 top: 0;
 bottom: 0;
 right: 0;
 `, [q("resize-trigger", `
 width: 3px;
 height: 100%;
 top: 0;
 left: 0;
 transform: translateX(-1.5px);
 cursor: ew-resize;
 `)]), K("left-placement", `
 top: 0;
 bottom: 0;
 left: 0;
 `, [q("resize-trigger", `
 width: 3px;
 height: 100%;
 top: 0;
 right: 0;
 transform: translateX(1.5px);
 cursor: ew-resize;
 `)]), K("top-placement", `
 top: 0;
 left: 0;
 right: 0;
 `, [q("resize-trigger", `
 width: 100%;
 height: 3px;
 bottom: 0;
 left: 0;
 transform: translateY(1.5px);
 cursor: ns-resize;
 `)]), K("bottom-placement", `
 left: 0;
 bottom: 0;
 right: 0;
 `, [q("resize-trigger", `
 width: 100%;
 height: 3px;
 top: 0;
 left: 0;
 transform: translateY(-1.5px);
 cursor: ns-resize;
 `)])]), Y("body", [Y(">", [L("drawer-container", {
  position: "fixed"
})])]), L("drawer-container", `
 position: relative;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 pointer-events: none;
 `, [Y("> *", {
  pointerEvents: "all"
})]), L("drawer-mask", `
 background-color: rgba(0, 0, 0, .3);
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `, [K("invisible", `
 background-color: rgba(0, 0, 0, 0)
 `), bp({
  enterDuration: "0.2s",
  leaveDuration: "0.2s",
  enterCubicBezier: "var(--n-bezier-in)",
  leaveCubicBezier: "var(--n-bezier-out)"
})])]);
const Zbe = Object.assign(Object.assign({}, ft.props), {
  show: Boolean,
  width: [Number, String],
  height: [Number, String],
  placement: {
    type: String,
    default: "right"
  },
  maskClosable: {
    type: Boolean,
    default: !0
  },
  showMask: {
    type: [Boolean, String],
    default: !0
  },
  to: [String, Object],
  displayDirective: {
    type: String,
    default: "if"
  },
  nativeScrollbar: {
    type: Boolean,
    default: !0
  },
  zIndex: Number,
  onMaskClick: Function,
  scrollbarProps: Object,
  contentStyle: [Object, String],
  trapFocus: {
    type: Boolean,
    default: !0
  },
  onEsc: Function,
  autoFocus: {
    type: Boolean,
    default: !0
  },
  closeOnEsc: {
    type: Boolean,
    default: !0
  },
  blockScroll: {
    type: Boolean,
    default: !0
  },
  resizable: Boolean,
  defaultWidth: {
    type: [Number, String],
    default: 251
  },
  defaultHeight: {
    type: [Number, String],
    default: 251
  },
  onUpdateWidth: [Function, Array],
  onUpdateHeight: [Function, Array],
  "onUpdate:width": [Function, Array],
  "onUpdate:height": [Function, Array],
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  onAfterEnter: Function,
  onAfterLeave: Function,
  drawerStyle: [String, Object],
  drawerClass: String,
  target: null,
  onShow: Function,
  onHide: Function
});
var Kbe = oe({
  name: "Drawer",
  inheritAttrs: !1,
  props: Zbe,
  setup(e) {
    const { mergedClsPrefixRef: t, namespaceRef: r, inlineThemeDisabled: n } = Yt(e), i = ql(), o = ft("Drawer", "-drawer", Gbe, _be, e, t), a = G(e.defaultWidth), s = G(e.defaultHeight), u = dn(tt(e, "width"), a), d = dn(tt(e, "height"), s), f = j(() => {
      const { placement: A } = e;
      return A === "top" || A === "bottom" ? "" : Rn(u.value);
    }), h = j(() => {
      const { placement: A } = e;
      return A === "left" || A === "right" ? "" : Rn(d.value);
    }), g = (A) => {
      const { onUpdateWidth: D, "onUpdate:width": E } = e;
      D && je(D, A), E && je(E, A), a.value = A;
    }, m = (A) => {
      const { onUpdateHeight: D, "onUpdate:width": E } = e;
      D && je(D, A), E && je(E, A), s.value = A;
    }, v = j(() => [
      {
        width: f.value,
        height: h.value
      },
      e.drawerStyle || ""
    ]);
    function w(A) {
      const { onMaskClick: D, maskClosable: E } = e;
      E && C(!1), D && D(A);
    }
    const x = HU();
    function y(A) {
      var D;
      (D = e.onEsc) === null || D === void 0 || D.call(e), e.show && e.closeOnEsc && wU(A) && !x.value && C(!1);
    }
    function C(A) {
      const { onHide: D, onUpdateShow: E, "onUpdate:show": N } = e;
      E && je(E, A), N && je(N, A), D && !A && je(D, A);
    }
    tr(JO, {
      isMountedRef: i,
      mergedThemeRef: o,
      mergedClsPrefixRef: t,
      doUpdateShow: C,
      doUpdateHeight: m,
      doUpdateWidth: g
    });
    const S = j(() => {
      const { common: { cubicBezierEaseInOut: A, cubicBezierEaseIn: D, cubicBezierEaseOut: E }, self: { color: N, textColor: I, boxShadow: $, lineHeight: _, headerPadding: R, footerPadding: U, bodyPadding: Q, titleFontSize: Z, titleTextColor: X, titleFontWeight: re, headerBorderBottom: ue, footerBorderTop: he, closeIconColor: te, closeIconColorHover: de, closeIconColorPressed: De, closeColorHover: Oe, closeColorPressed: Qe, closeIconSize: Ae, closeSize: Ne, closeBorderRadius: $e, resizableTriggerColorHover: et } } = o.value;
      return {
        "--n-line-height": _,
        "--n-color": N,
        "--n-text-color": I,
        "--n-box-shadow": $,
        "--n-bezier": A,
        "--n-bezier-out": E,
        "--n-bezier-in": D,
        "--n-header-padding": R,
        "--n-body-padding": Q,
        "--n-footer-padding": U,
        "--n-title-text-color": X,
        "--n-title-font-size": Z,
        "--n-title-font-weight": re,
        "--n-header-border-bottom": ue,
        "--n-footer-border-top": he,
        "--n-close-icon-color": te,
        "--n-close-icon-color-hover": de,
        "--n-close-icon-color-pressed": De,
        "--n-close-size": Ne,
        "--n-close-color-hover": Oe,
        "--n-close-color-pressed": Qe,
        "--n-close-icon-size": Ae,
        "--n-close-border-radius": $e,
        "--n-resize-trigger-color-hover": et
      };
    }), T = n ? Cr("drawer", void 0, S, e) : void 0;
    return {
      mergedClsPrefix: t,
      namespace: r,
      mergedBodyStyle: v,
      handleMaskClick: w,
      handleEsc: y,
      mergedTheme: o,
      cssVars: n ? void 0 : S,
      themeClass: T == null ? void 0 : T.themeClass,
      onRender: T == null ? void 0 : T.onRender,
      isMounted: i
    };
  },
  render() {
    const { mergedClsPrefix: e } = this;
    return b($M, { to: this.to, show: this.show }, {
      default: () => {
        var t;
        return (t = this.onRender) === null || t === void 0 || t.call(this), Jn(b("div", { class: [
          `${e}-drawer-container`,
          this.namespace,
          this.themeClass
        ], style: this.cssVars, role: "none" }, this.showMask ? b(jn, { name: "fade-in-transition", appear: this.isMounted }, {
          default: () => this.show ? b("div", { "aria-hidden": !0, class: [
            `${e}-drawer-mask`,
            this.showMask === "transparent" && `${e}-drawer-mask--invisible`
          ], onClick: this.handleMaskClick }) : null
        }) : null, b(Lbe, Object.assign({}, this.$attrs, { class: [this.drawerClass, this.$attrs.class], style: [this.mergedBodyStyle, this.$attrs.style], blockScroll: this.blockScroll, contentStyle: this.contentStyle, placement: this.placement, scrollbarProps: this.scrollbarProps, show: this.show, displayDirective: this.displayDirective, nativeScrollbar: this.nativeScrollbar, onAfterEnter: this.onAfterEnter, onAfterLeave: this.onAfterLeave, trapFocus: this.trapFocus, autoFocus: this.autoFocus, resizable: this.resizable, showMask: this.showMask, onEsc: this.handleEsc, onClickoutside: this.handleMaskClick }), this.$slots)), [[mb, { zIndex: this.zIndex, enabled: this.show }]]);
      }
    });
  }
});
const Xbe = {
  title: {
    type: String
  },
  headerStyle: [Object, String],
  footerStyle: [Object, String],
  bodyStyle: [Object, String],
  bodyContentStyle: [Object, String],
  nativeScrollbar: { type: Boolean, default: !0 },
  scrollbarProps: Object,
  closable: Boolean
};
var Jbe = oe({
  name: "DrawerContent",
  props: Xbe,
  setup() {
    const e = lt(JO, null);
    e || Ql("drawer-content", "`n-drawer-content` must be placed inside `n-drawer`.");
    const { doUpdateShow: t } = e;
    function r() {
      t(!1);
    }
    return {
      handleCloseClick: r,
      mergedTheme: e.mergedThemeRef,
      mergedClsPrefix: e.mergedClsPrefixRef
    };
  },
  render() {
    const { title: e, mergedClsPrefix: t, nativeScrollbar: r, mergedTheme: n, bodyStyle: i, bodyContentStyle: o, headerStyle: a, footerStyle: s, scrollbarProps: u, closable: d, $slots: f } = this;
    return b("div", { role: "none", class: [
      `${t}-drawer-content`,
      r && `${t}-drawer-content--native-scrollbar`
    ] }, f.header || e || d ? b("div", { class: `${t}-drawer-header`, style: a, role: "none" }, b("div", { class: `${t}-drawer-header__main`, role: "heading", "aria-level": "1" }, f.header !== void 0 ? f.header() : e), d && b(gh, { onClick: this.handleCloseClick, clsPrefix: t, class: `${t}-drawer-header__close`, absolute: !0 })) : null, r ? b("div", { class: `${t}-drawer-body`, style: i, role: "none" }, b("div", { class: `${t}-drawer-body-content-wrapper`, style: o, role: "none" }, f)) : b(no, Object.assign({ themeOverrides: n.peerOverrides.Scrollbar, theme: n.peers.Scrollbar }, u, { class: `${t}-drawer-body`, contentClass: `${t}-drawer-body-content-wrapper`, contentStyle: o }), f), f.footer ? b("div", { class: `${t}-drawer-footer`, style: s, role: "none" }, f.footer()) : null);
  }
}), eye = {
  gapSmall: "4px 8px",
  gapMedium: "8px 12px",
  gapLarge: "12px 16px"
};
const tye = () => eye, rye = {
  name: "Space",
  self: tye
};
var xW = rye;
let n2;
const nye = () => {
  if (!Is)
    return !0;
  if (n2 === void 0) {
    const e = document.createElement("div");
    e.style.display = "flex", e.style.flexDirection = "column", e.style.rowGap = "1px", e.appendChild(document.createElement("div")), e.appendChild(document.createElement("div")), document.body.appendChild(e);
    const t = e.scrollHeight === 1;
    return document.body.removeChild(e), n2 = t;
  }
  return n2;
}, iye = Object.assign(Object.assign({}, ft.props), {
  align: String,
  justify: {
    type: String,
    default: "start"
  },
  inline: Boolean,
  vertical: Boolean,
  size: {
    type: [String, Number, Array],
    default: "medium"
  },
  wrapItem: {
    type: Boolean,
    default: !0
  },
  itemStyle: [String, Object],
  wrap: {
    type: Boolean,
    default: !0
  },
  internalUseGap: {
    type: Boolean,
    default: void 0
  }
});
var wW = oe({
  name: "Space",
  props: iye,
  setup(e) {
    const { mergedClsPrefixRef: t, mergedRtlRef: r } = Yt(e), n = ft("Space", "-space", void 0, xW, e, t), i = Li("Space", r, t);
    return {
      useGap: nye(),
      rtlEnabled: i,
      mergedClsPrefix: t,
      margin: j(() => {
        const { size: o } = e;
        if (Array.isArray(o))
          return {
            horizontal: o[0],
            vertical: o[1]
          };
        if (typeof o == "number")
          return {
            horizontal: o,
            vertical: o
          };
        const { self: { [Be("gap", o)]: a } } = n.value, { row: s, col: u } = AK(a);
        return {
          horizontal: wo(u),
          vertical: wo(s)
        };
      })
    };
  },
  render() {
    const { vertical: e, align: t, inline: r, justify: n, itemStyle: i, margin: o, wrap: a, mergedClsPrefix: s, rtlEnabled: u, useGap: d, wrapItem: f, internalUseGap: h } = this, g = ms(qO(this));
    if (!g.length)
      return null;
    const m = `${o.horizontal}px`, v = `${o.horizontal / 2}px`, w = `${o.vertical}px`, x = `${o.vertical / 2}px`, y = g.length - 1, C = n.startsWith("space-");
    return b("div", { role: "none", class: [
      `${s}-space`,
      u && `${s}-space--rtl`
    ], style: {
      display: r ? "inline-flex" : "flex",
      flexDirection: e ? "column" : "row",
      justifyContent: ["start", "end"].includes(n) ? "flex-" + n : n,
      flexWrap: !a || e ? "nowrap" : "wrap",
      marginTop: d || e ? "" : `-${x}`,
      marginBottom: d || e ? "" : `-${x}`,
      alignItems: t,
      gap: d ? `${o.vertical}px ${o.horizontal}px` : ""
    } }, !f && (d || h) ? g : g.map((S, T) => b("div", { role: "none", style: [
      i,
      {
        maxWidth: "100%"
      },
      d ? "" : e ? {
        marginBottom: T !== y ? w : ""
      } : u ? {
        marginLeft: C ? n === "space-between" && T === y ? "" : v : T !== y ? m : "",
        marginRight: C ? n === "space-between" && T === 0 ? "" : v : "",
        paddingTop: x,
        paddingBottom: x
      } : {
        marginRight: C ? n === "space-between" && T === y ? "" : v : T !== y ? m : "",
        marginLeft: C ? n === "space-between" && T === 0 ? "" : v : "",
        paddingTop: x,
        paddingBottom: x
      }
    ] }, S)));
  }
});
const oye = {
  name: "DynamicTags",
  common: Sr,
  peers: {
    Input: Fc,
    Button: Yu,
    Tag: fH,
    Space: xW
  },
  self() {
    return {
      inputWidth: "64px"
    };
  }
};
var aye = oye, lye = L("dynamic-tags", [L("input", {
  minWidth: "var(--n-input-width)"
})]);
const sye = Object.assign(Object.assign(Object.assign({}, ft.props), hH), {
  size: {
    type: String,
    default: "medium"
  },
  closable: {
    type: Boolean,
    default: !0
  },
  defaultValue: {
    type: Array,
    default: () => []
  },
  value: Array,
  inputStyle: [String, Object],
  inputProps: Object,
  max: Number,
  tagStyle: [String, Object],
  renderTag: Function,
  onCreate: {
    type: Function,
    default: (e) => e
  },
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onChange: [Function, Array]
});
var MW = oe({
  name: "DynamicTags",
  props: sye,
  setup(e) {
    const { mergedClsPrefixRef: t, inlineThemeDisabled: r } = Yt(e), { localeRef: n } = Zl("DynamicTags"), i = ta(e), { mergedDisabledRef: o } = i, a = G(""), s = G(!1), u = G(!0), d = G(null), f = ft("DynamicTags", "-dynamic-tags", lye, aye, e, t), h = G(e.defaultValue), g = tt(e, "value"), m = dn(g, h), v = j(() => n.value.add), w = j(() => rz(e.size)), x = j(() => o.value || !!e.max && m.value.length >= e.max);
    function y(I) {
      const { onChange: $, "onUpdate:value": _, onUpdateValue: R } = e, { nTriggerFormInput: U, nTriggerFormChange: Q } = i;
      $ && je($, I), R && je(R, I), _ && je(_, I), h.value = I, U(), Q();
    }
    function C(I) {
      const $ = m.value.slice(0);
      $.splice(I, 1), y($);
    }
    function S(I) {
      switch (I.key) {
        case "Enter":
          T();
      }
    }
    function T(I) {
      const $ = I ?? a.value;
      if ($) {
        const _ = m.value.slice(0);
        _.push(e.onCreate($)), y(_);
      }
      s.value = !1, u.value = !0, a.value = "";
    }
    function A() {
      T();
    }
    function D() {
      s.value = !0, an(() => {
        var I;
        (I = d.value) === null || I === void 0 || I.focus(), u.value = !1;
      });
    }
    const E = j(() => {
      const { self: { inputWidth: I } } = f.value;
      return {
        "--n-input-width": I
      };
    }), N = r ? Cr("dynamic-tags", void 0, E, e) : void 0;
    return {
      mergedClsPrefix: t,
      inputInstRef: d,
      localizedAdd: v,
      inputSize: w,
      inputValue: a,
      showInput: s,
      inputForceFocused: u,
      mergedValue: m,
      mergedDisabled: o,
      triggerDisabled: x,
      handleInputKeyUp: S,
      handleAddClick: D,
      handleInputBlur: A,
      handleCloseClick: C,
      handleInputConfirm: T,
      mergedTheme: f,
      cssVars: r ? void 0 : E,
      themeClass: N == null ? void 0 : N.themeClass,
      onRender: N == null ? void 0 : N.onRender
    };
  },
  render() {
    const { mergedTheme: e, cssVars: t, mergedClsPrefix: r, onRender: n, renderTag: i } = this;
    return n == null || n(), b(wW, { class: [`${r}-dynamic-tags`, this.themeClass], size: "small", style: t, theme: e.peers.Space, themeOverrides: e.peerOverrides.Space, itemStyle: "display: flex;" }, {
      default: () => {
        const { mergedTheme: o, tagStyle: a, type: s, round: u, size: d, color: f, closable: h, mergedDisabled: g, showInput: m, inputValue: v, inputStyle: w, inputSize: x, inputForceFocused: y, triggerDisabled: C, handleInputKeyUp: S, handleInputBlur: T, handleAddClick: A, handleCloseClick: D, handleInputConfirm: E, $slots: N } = this;
        return this.mergedValue.map((I, $) => i ? i(I, $) : b(Jv, { key: $, theme: o.peers.Tag, themeOverrides: o.peerOverrides.Tag, style: a, type: s, round: u, size: d, color: f, closable: h, disabled: g, onClose: () => {
          D($);
        } }, {
          default: () => typeof I == "string" ? I : I.label
        })).concat(m ? N.input ? N.input({
          submit: E,
          deactivate: T
        }) : b(pa, Object.assign({ placeholder: "", size: x, style: w, autosize: !0 }, this.inputProps, { ref: "inputInstRef", value: v, onUpdateValue: (I) => {
          this.inputValue = I;
        }, theme: o.peers.Input, themeOverrides: o.peerOverrides.Input, onKeyup: S, onBlur: T, internalForceFocus: y })) : N.trigger ? N.trigger({
          activate: A,
          disabled: C
        }) : b(Mn, { dashed: !0, disabled: C, theme: o.peers.Button, themeOverrides: o.peerOverrides.Button, size: x, onClick: A }, {
          icon: () => b(fr, { clsPrefix: r }, { default: () => b(FM, null) })
        }));
      }
    });
  }
}), uye = {
  feedbackPadding: "4px 0 0 2px",
  feedbackHeightSmall: "24px",
  feedbackHeightMedium: "24px",
  feedbackHeightLarge: "26px",
  feedbackFontSizeSmall: "13px",
  feedbackFontSizeMedium: "14px",
  feedbackFontSizeLarge: "14px",
  labelFontSizeLeftSmall: "14px",
  labelFontSizeLeftMedium: "14px",
  labelFontSizeLeftLarge: "15px",
  labelFontSizeTopSmall: "13px",
  labelFontSizeTopMedium: "14px",
  labelFontSizeTopLarge: "14px",
  labelHeightSmall: "24px",
  labelHeightMedium: "26px",
  labelHeightLarge: "28px",
  labelPaddingVertical: "0 0 6px 2px",
  labelPaddingHorizontal: "0 12px 0 0",
  labelTextAlignVertical: "left",
  labelTextAlignHorizontal: "right",
  labelFontWeight: "400"
};
const cye = (e) => {
  const { heightSmall: t, heightMedium: r, heightLarge: n, textColor1: i, errorColor: o, warningColor: a, lineHeight: s, textColor3: u } = e;
  return Object.assign(Object.assign({}, uye), { blankHeightSmall: t, blankHeightMedium: r, blankHeightLarge: n, lineHeight: s, labelTextColor: i, asteriskColor: o, feedbackTextColorError: o, feedbackTextColorWarning: a, feedbackTextColor: u });
}, dye = {
  name: "Form",
  common: Sr,
  self: cye
};
var CW = dye, fye = L("form", [K("inline", `
 width: 100%;
 display: inline-flex;
 align-items: flex-start;
 align-content: space-around;
 `, [L("form-item", {
  width: "auto",
  marginRight: "18px"
}, [Y("&:last-child", {
  marginRight: 0
})])])]);
const Sb = "n-form", SW = "n-form-item-insts";
var hye = globalThis && globalThis.__awaiter || function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function s(f) {
      try {
        d(n.next(f));
      } catch (h) {
        a(h);
      }
    }
    function u(f) {
      try {
        d(n.throw(f));
      } catch (h) {
        a(h);
      }
    }
    function d(f) {
      f.done ? o(f.value) : i(f.value).then(s, u);
    }
    d((n = n.apply(e, t || [])).next());
  });
};
const pye = Object.assign(Object.assign({}, ft.props), { inline: Boolean, labelWidth: [Number, String], labelAlign: String, labelPlacement: {
  type: String,
  default: "top"
}, model: {
  type: Object,
  default: () => {
  }
}, rules: Object, disabled: Boolean, size: String, showRequireMark: {
  type: Boolean,
  default: void 0
}, requireMarkPlacement: String, showFeedback: {
  type: Boolean,
  default: !0
}, onSubmit: {
  type: Function,
  default: (e) => {
    e.preventDefault();
  }
}, showLabel: {
  type: Boolean,
  default: void 0
}, validateMessages: Object });
var gye = oe({
  name: "Form",
  props: pye,
  setup(e) {
    const { mergedClsPrefixRef: t } = Yt(e);
    ft("Form", "-form", fye, CW, e, t);
    const r = {}, n = G(void 0), i = (u) => {
      const d = n.value;
      (d === void 0 || u >= d) && (n.value = u);
    };
    function o(u, d = () => !0) {
      return hye(this, void 0, void 0, function* () {
        yield new Promise((f, h) => {
          const g = [];
          for (const m of Ts(r)) {
            const v = r[m];
            for (const w of v)
              w.path && g.push(w.internalValidate(null, d));
          }
          Promise.all(g).then((m) => {
            if (m.some((v) => !v.valid)) {
              const v = m.filter((w) => w.errors).map((w) => w.errors);
              u && u(v), h(v);
            } else
              u && u(), f();
          });
        });
      });
    }
    function a() {
      for (const u of Ts(r)) {
        const d = r[u];
        for (const f of d)
          f.restoreValidation();
      }
    }
    return tr(Sb, {
      props: e,
      maxChildLabelWidthRef: n,
      deriveMaxChildLabelWidth: i
    }), tr(SW, { formItems: r }), Object.assign({
      validate: o,
      restoreValidation: a
    }, {
      mergedClsPrefix: t
    });
  },
  render() {
    const { mergedClsPrefix: e } = this;
    return b("form", { class: [
      `${e}-form`,
      this.inline && `${e}-form--inline`
    ], onSubmit: this.onSubmit }, this.$slots);
  }
});
function Lf() {
  return Lf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Lf.apply(this, arguments);
}
function mye(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, $0(e, t);
}
function t$(e) {
  return t$ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, t$(e);
}
function $0(e, t) {
  return $0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, $0(e, t);
}
function vye() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Xy(e, t, r) {
  return vye() ? Xy = Reflect.construct.bind() : Xy = function(i, o, a) {
    var s = [null];
    s.push.apply(s, o);
    var u = Function.bind.apply(i, s), d = new u();
    return a && $0(d, a.prototype), d;
  }, Xy.apply(null, arguments);
}
function bye(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function r$(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return r$ = function(n) {
    if (n === null || !bye(n))
      return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(n))
        return t.get(n);
      t.set(n, i);
    }
    function i() {
      return Xy(n, arguments, t$(this).constructor);
    }
    return i.prototype = Object.create(n.prototype, {
      constructor: {
        value: i,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), $0(i, n);
  }, r$(e);
}
var yye = /%[sdj%]/g, xye = function() {
};
typeof process < "u" && process.env;
function n$(e) {
  if (!e || !e.length)
    return null;
  var t = {};
  return e.forEach(function(r) {
    var n = r.field;
    t[n] = t[n] || [], t[n].push(r);
  }), t;
}
function La(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  var i = 0, o = r.length;
  if (typeof e == "function")
    return e.apply(null, r);
  if (typeof e == "string") {
    var a = e.replace(yye, function(s) {
      if (s === "%%")
        return "%";
      if (i >= o)
        return s;
      switch (s) {
        case "%s":
          return String(r[i++]);
        case "%d":
          return Number(r[i++]);
        case "%j":
          try {
            return JSON.stringify(r[i++]);
          } catch {
            return "[Circular]";
          }
          break;
        default:
          return s;
      }
    });
    return a;
  }
  return e;
}
function wye(e) {
  return e === "string" || e === "url" || e === "hex" || e === "email" || e === "date" || e === "pattern";
}
function Zi(e, t) {
  return !!(e == null || t === "array" && Array.isArray(e) && !e.length || wye(t) && typeof e == "string" && !e);
}
function Mye(e, t, r) {
  var n = [], i = 0, o = e.length;
  function a(s) {
    n.push.apply(n, s || []), i++, i === o && r(n);
  }
  e.forEach(function(s) {
    t(s, a);
  });
}
function mR(e, t, r) {
  var n = 0, i = e.length;
  function o(a) {
    if (a && a.length) {
      r(a);
      return;
    }
    var s = n;
    n = n + 1, s < i ? t(e[s], o) : r([]);
  }
  o([]);
}
function Cye(e) {
  var t = [];
  return Object.keys(e).forEach(function(r) {
    t.push.apply(t, e[r] || []);
  }), t;
}
var vR = /* @__PURE__ */ function(e) {
  mye(t, e);
  function t(r, n) {
    var i;
    return i = e.call(this, "Async Validation Error") || this, i.errors = r, i.fields = n, i;
  }
  return t;
}(/* @__PURE__ */ r$(Error));
function Sye(e, t, r, n, i) {
  if (t.first) {
    var o = new Promise(function(g, m) {
      var v = function(y) {
        return n(y), y.length ? m(new vR(y, n$(y))) : g(i);
      }, w = Cye(e);
      mR(w, r, v);
    });
    return o.catch(function(g) {
      return g;
    }), o;
  }
  var a = t.firstFields === !0 ? Object.keys(e) : t.firstFields || [], s = Object.keys(e), u = s.length, d = 0, f = [], h = new Promise(function(g, m) {
    var v = function(x) {
      if (f.push.apply(f, x), d++, d === u)
        return n(f), f.length ? m(new vR(f, n$(f))) : g(i);
    };
    s.length || (n(f), g(i)), s.forEach(function(w) {
      var x = e[w];
      a.indexOf(w) !== -1 ? mR(x, r, v) : Mye(x, r, v);
    });
  });
  return h.catch(function(g) {
    return g;
  }), h;
}
function Tye(e) {
  return !!(e && e.message !== void 0);
}
function kye(e, t) {
  for (var r = e, n = 0; n < t.length; n++) {
    if (r == null)
      return r;
    r = r[t[n]];
  }
  return r;
}
function bR(e, t) {
  return function(r) {
    var n;
    return e.fullFields ? n = kye(t, e.fullFields) : n = t[r.field || e.fullField], Tye(r) ? (r.field = r.field || e.fullField, r.fieldValue = n, r) : {
      message: typeof r == "function" ? r() : r,
      fieldValue: n,
      field: r.field || e.fullField
    };
  };
}
function yR(e, t) {
  if (t) {
    for (var r in t)
      if (t.hasOwnProperty(r)) {
        var n = t[r];
        typeof n == "object" && typeof e[r] == "object" ? e[r] = Lf({}, e[r], n) : e[r] = n;
      }
  }
  return e;
}
var TW = function(t, r, n, i, o, a) {
  t.required && (!n.hasOwnProperty(t.field) || Zi(r, a || t.type)) && i.push(La(o.messages.required, t.fullField));
}, Dye = function(t, r, n, i, o) {
  (/^\s+$/.test(r) || r === "") && i.push(La(o.messages.whitespace, t.fullField));
}, py, Aye = function() {
  if (py)
    return py;
  var e = "[a-fA-F\\d:]", t = function(T) {
    return T && T.includeBoundaries ? "(?:(?<=\\s|^)(?=" + e + ")|(?<=" + e + ")(?=\\s|$))" : "";
  }, r = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}", n = "[a-fA-F\\d]{1,4}", i = (`
(?:
(?:` + n + ":){7}(?:" + n + `|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
(?:` + n + ":){6}(?:" + r + "|:" + n + `|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4
(?:` + n + ":){5}(?::" + r + "|(?::" + n + `){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4
(?:` + n + ":){4}(?:(?::" + n + "){0,1}:" + r + "|(?::" + n + `){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4
(?:` + n + ":){3}(?:(?::" + n + "){0,2}:" + r + "|(?::" + n + `){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4
(?:` + n + ":){2}(?:(?::" + n + "){0,3}:" + r + "|(?::" + n + `){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4
(?:` + n + ":){1}(?:(?::" + n + "){0,4}:" + r + "|(?::" + n + `){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4
(?::(?:(?::` + n + "){0,5}:" + r + "|(?::" + n + `){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4
)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1
`).replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim(), o = new RegExp("(?:^" + r + "$)|(?:^" + i + "$)"), a = new RegExp("^" + r + "$"), s = new RegExp("^" + i + "$"), u = function(T) {
    return T && T.exact ? o : new RegExp("(?:" + t(T) + r + t(T) + ")|(?:" + t(T) + i + t(T) + ")", "g");
  };
  u.v4 = function(S) {
    return S && S.exact ? a : new RegExp("" + t(S) + r + t(S), "g");
  }, u.v6 = function(S) {
    return S && S.exact ? s : new RegExp("" + t(S) + i + t(S), "g");
  };
  var d = "(?:(?:[a-z]+:)?//)", f = "(?:\\S+(?::\\S*)?@)?", h = u.v4().source, g = u.v6().source, m = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)", v = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*", w = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))", x = "(?::\\d{2,5})?", y = '(?:[/?#][^\\s"]*)?', C = "(?:" + d + "|www\\.)" + f + "(?:localhost|" + h + "|" + g + "|" + m + v + w + ")" + x + y;
  return py = new RegExp("(?:^" + C + "$)", "i"), py;
}, xR = {
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
}, Rv = {
  integer: function(t) {
    return Rv.number(t) && parseInt(t, 10) === t;
  },
  float: function(t) {
    return Rv.number(t) && !Rv.integer(t);
  },
  array: function(t) {
    return Array.isArray(t);
  },
  regexp: function(t) {
    if (t instanceof RegExp)
      return !0;
    try {
      return !!new RegExp(t);
    } catch {
      return !1;
    }
  },
  date: function(t) {
    return typeof t.getTime == "function" && typeof t.getMonth == "function" && typeof t.getYear == "function" && !isNaN(t.getTime());
  },
  number: function(t) {
    return isNaN(t) ? !1 : typeof t == "number";
  },
  object: function(t) {
    return typeof t == "object" && !Rv.array(t);
  },
  method: function(t) {
    return typeof t == "function";
  },
  email: function(t) {
    return typeof t == "string" && t.length <= 320 && !!t.match(xR.email);
  },
  url: function(t) {
    return typeof t == "string" && t.length <= 2048 && !!t.match(Aye());
  },
  hex: function(t) {
    return typeof t == "string" && !!t.match(xR.hex);
  }
}, Eye = function(t, r, n, i, o) {
  if (t.required && r === void 0) {
    TW(t, r, n, i, o);
    return;
  }
  var a = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"], s = t.type;
  a.indexOf(s) > -1 ? Rv[s](r) || i.push(La(o.messages.types[s], t.fullField, t.type)) : s && typeof r !== t.type && i.push(La(o.messages.types[s], t.fullField, t.type));
}, Iye = function(t, r, n, i, o) {
  var a = typeof t.len == "number", s = typeof t.min == "number", u = typeof t.max == "number", d = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, f = r, h = null, g = typeof r == "number", m = typeof r == "string", v = Array.isArray(r);
  if (g ? h = "number" : m ? h = "string" : v && (h = "array"), !h)
    return !1;
  v && (f = r.length), m && (f = r.replace(d, "_").length), a ? f !== t.len && i.push(La(o.messages[h].len, t.fullField, t.len)) : s && !u && f < t.min ? i.push(La(o.messages[h].min, t.fullField, t.min)) : u && !s && f > t.max ? i.push(La(o.messages[h].max, t.fullField, t.max)) : s && u && (f < t.min || f > t.max) && i.push(La(o.messages[h].range, t.fullField, t.min, t.max));
}, $h = "enum", Nye = function(t, r, n, i, o) {
  t[$h] = Array.isArray(t[$h]) ? t[$h] : [], t[$h].indexOf(r) === -1 && i.push(La(o.messages[$h], t.fullField, t[$h].join(", ")));
}, zye = function(t, r, n, i, o) {
  if (t.pattern) {
    if (t.pattern instanceof RegExp)
      t.pattern.lastIndex = 0, t.pattern.test(r) || i.push(La(o.messages.pattern.mismatch, t.fullField, r, t.pattern));
    else if (typeof t.pattern == "string") {
      var a = new RegExp(t.pattern);
      a.test(r) || i.push(La(o.messages.pattern.mismatch, t.fullField, r, t.pattern));
    }
  }
}, Hr = {
  required: TW,
  whitespace: Dye,
  type: Eye,
  range: Iye,
  enum: Nye,
  pattern: zye
}, $ye = function(t, r, n, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Zi(r, "string") && !t.required)
      return n();
    Hr.required(t, r, i, a, o, "string"), Zi(r, "string") || (Hr.type(t, r, i, a, o), Hr.range(t, r, i, a, o), Hr.pattern(t, r, i, a, o), t.whitespace === !0 && Hr.whitespace(t, r, i, a, o));
  }
  n(a);
}, Oye = function(t, r, n, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Zi(r) && !t.required)
      return n();
    Hr.required(t, r, i, a, o), r !== void 0 && Hr.type(t, r, i, a, o);
  }
  n(a);
}, _ye = function(t, r, n, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (r === "" && (r = void 0), Zi(r) && !t.required)
      return n();
    Hr.required(t, r, i, a, o), r !== void 0 && (Hr.type(t, r, i, a, o), Hr.range(t, r, i, a, o));
  }
  n(a);
}, Lye = function(t, r, n, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Zi(r) && !t.required)
      return n();
    Hr.required(t, r, i, a, o), r !== void 0 && Hr.type(t, r, i, a, o);
  }
  n(a);
}, Pye = function(t, r, n, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Zi(r) && !t.required)
      return n();
    Hr.required(t, r, i, a, o), Zi(r) || Hr.type(t, r, i, a, o);
  }
  n(a);
}, Rye = function(t, r, n, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Zi(r) && !t.required)
      return n();
    Hr.required(t, r, i, a, o), r !== void 0 && (Hr.type(t, r, i, a, o), Hr.range(t, r, i, a, o));
  }
  n(a);
}, jye = function(t, r, n, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Zi(r) && !t.required)
      return n();
    Hr.required(t, r, i, a, o), r !== void 0 && (Hr.type(t, r, i, a, o), Hr.range(t, r, i, a, o));
  }
  n(a);
}, Fye = function(t, r, n, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (r == null && !t.required)
      return n();
    Hr.required(t, r, i, a, o, "array"), r != null && (Hr.type(t, r, i, a, o), Hr.range(t, r, i, a, o));
  }
  n(a);
}, Bye = function(t, r, n, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Zi(r) && !t.required)
      return n();
    Hr.required(t, r, i, a, o), r !== void 0 && Hr.type(t, r, i, a, o);
  }
  n(a);
}, Uye = "enum", Hye = function(t, r, n, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Zi(r) && !t.required)
      return n();
    Hr.required(t, r, i, a, o), r !== void 0 && Hr[Uye](t, r, i, a, o);
  }
  n(a);
}, Wye = function(t, r, n, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Zi(r, "string") && !t.required)
      return n();
    Hr.required(t, r, i, a, o), Zi(r, "string") || Hr.pattern(t, r, i, a, o);
  }
  n(a);
}, Vye = function(t, r, n, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Zi(r, "date") && !t.required)
      return n();
    if (Hr.required(t, r, i, a, o), !Zi(r, "date")) {
      var u;
      r instanceof Date ? u = r : u = new Date(r), Hr.type(t, u, i, a, o), u && Hr.range(t, u.getTime(), i, a, o);
    }
  }
  n(a);
}, Yye = function(t, r, n, i, o) {
  var a = [], s = Array.isArray(r) ? "array" : typeof r;
  Hr.required(t, r, i, a, o, s), n(a);
}, i2 = function(t, r, n, i, o) {
  var a = t.type, s = [], u = t.required || !t.required && i.hasOwnProperty(t.field);
  if (u) {
    if (Zi(r, a) && !t.required)
      return n();
    Hr.required(t, r, i, s, o, a), Zi(r, a) || Hr.type(t, r, i, s, o);
  }
  n(s);
}, Qye = function(t, r, n, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Zi(r) && !t.required)
      return n();
    Hr.required(t, r, i, a, o);
  }
  n(a);
}, e0 = {
  string: $ye,
  method: Oye,
  number: _ye,
  boolean: Lye,
  regexp: Pye,
  integer: Rye,
  float: jye,
  array: Fye,
  object: Bye,
  enum: Hye,
  pattern: Wye,
  date: Vye,
  url: i2,
  hex: i2,
  email: i2,
  required: Yye,
  any: Qye
};
function i$() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function() {
      var t = JSON.parse(JSON.stringify(this));
      return t.clone = this.clone, t;
    }
  };
}
var o$ = i$(), Tb = /* @__PURE__ */ function() {
  function e(r) {
    this.rules = null, this._messages = o$, this.define(r);
  }
  var t = e.prototype;
  return t.define = function(n) {
    var i = this;
    if (!n)
      throw new Error("Cannot configure a schema with no rules");
    if (typeof n != "object" || Array.isArray(n))
      throw new Error("Rules must be an object");
    this.rules = {}, Object.keys(n).forEach(function(o) {
      var a = n[o];
      i.rules[o] = Array.isArray(a) ? a : [a];
    });
  }, t.messages = function(n) {
    return n && (this._messages = yR(i$(), n)), this._messages;
  }, t.validate = function(n, i, o) {
    var a = this;
    i === void 0 && (i = {}), o === void 0 && (o = function() {
    });
    var s = n, u = i, d = o;
    if (typeof u == "function" && (d = u, u = {}), !this.rules || Object.keys(this.rules).length === 0)
      return d && d(null, s), Promise.resolve(s);
    function f(w) {
      var x = [], y = {};
      function C(T) {
        if (Array.isArray(T)) {
          var A;
          x = (A = x).concat.apply(A, T);
        } else
          x.push(T);
      }
      for (var S = 0; S < w.length; S++)
        C(w[S]);
      x.length ? (y = n$(x), d(x, y)) : d(null, s);
    }
    if (u.messages) {
      var h = this.messages();
      h === o$ && (h = i$()), yR(h, u.messages), u.messages = h;
    } else
      u.messages = this.messages();
    var g = {}, m = u.keys || Object.keys(this.rules);
    m.forEach(function(w) {
      var x = a.rules[w], y = s[w];
      x.forEach(function(C) {
        var S = C;
        typeof S.transform == "function" && (s === n && (s = Lf({}, s)), y = s[w] = S.transform(y)), typeof S == "function" ? S = {
          validator: S
        } : S = Lf({}, S), S.validator = a.getValidationMethod(S), S.validator && (S.field = w, S.fullField = S.fullField || w, S.type = a.getType(S), g[w] = g[w] || [], g[w].push({
          rule: S,
          value: y,
          source: s,
          field: w
        }));
      });
    });
    var v = {};
    return Sye(g, u, function(w, x) {
      var y = w.rule, C = (y.type === "object" || y.type === "array") && (typeof y.fields == "object" || typeof y.defaultField == "object");
      C = C && (y.required || !y.required && w.value), y.field = w.field;
      function S(D, E) {
        return Lf({}, E, {
          fullField: y.fullField + "." + D,
          fullFields: y.fullFields ? [].concat(y.fullFields, [D]) : [D]
        });
      }
      function T(D) {
        D === void 0 && (D = []);
        var E = Array.isArray(D) ? D : [D];
        !u.suppressWarning && E.length && e.warning("async-validator:", E), E.length && y.message !== void 0 && (E = [].concat(y.message));
        var N = E.map(bR(y, s));
        if (u.first && N.length)
          return v[y.field] = 1, x(N);
        if (!C)
          x(N);
        else {
          if (y.required && !w.value)
            return y.message !== void 0 ? N = [].concat(y.message).map(bR(y, s)) : u.error && (N = [u.error(y, La(u.messages.required, y.field))]), x(N);
          var I = {};
          y.defaultField && Object.keys(w.value).map(function(R) {
            I[R] = y.defaultField;
          }), I = Lf({}, I, w.rule.fields);
          var $ = {};
          Object.keys(I).forEach(function(R) {
            var U = I[R], Q = Array.isArray(U) ? U : [U];
            $[R] = Q.map(S.bind(null, R));
          });
          var _ = new e($);
          _.messages(u.messages), w.rule.options && (w.rule.options.messages = u.messages, w.rule.options.error = u.error), _.validate(w.value, w.rule.options || u, function(R) {
            var U = [];
            N && N.length && U.push.apply(U, N), R && R.length && U.push.apply(U, R), x(U.length ? U : null);
          });
        }
      }
      var A;
      if (y.asyncValidator)
        A = y.asyncValidator(y, w.value, T, w.source, u);
      else if (y.validator) {
        try {
          A = y.validator(y, w.value, T, w.source, u);
        } catch (D) {
          console.error == null || console.error(D), u.suppressValidatorError || setTimeout(function() {
            throw D;
          }, 0), T(D.message);
        }
        A === !0 ? T() : A === !1 ? T(typeof y.message == "function" ? y.message(y.fullField || y.field) : y.message || (y.fullField || y.field) + " fails") : A instanceof Array ? T(A) : A instanceof Error && T(A.message);
      }
      A && A.then && A.then(function() {
        return T();
      }, function(D) {
        return T(D);
      });
    }, function(w) {
      f(w);
    }, s);
  }, t.getType = function(n) {
    if (n.type === void 0 && n.pattern instanceof RegExp && (n.type = "pattern"), typeof n.validator != "function" && n.type && !e0.hasOwnProperty(n.type))
      throw new Error(La("Unknown rule type %s", n.type));
    return n.type || "string";
  }, t.getValidationMethod = function(n) {
    if (typeof n.validator == "function")
      return n.validator;
    var i = Object.keys(n), o = i.indexOf("message");
    return o !== -1 && i.splice(o, 1), i.length === 1 && i[0] === "required" ? e0.required : e0[this.getType(n)] || void 0;
  }, e;
}();
Tb.register = function(t, r) {
  if (typeof r != "function")
    throw new Error("Cannot register a validator by type, validator is not a function");
  e0[t] = r;
};
Tb.warning = xye;
Tb.messages = o$;
Tb.validators = e0;
function qye(e) {
  const t = lt(Sb, null);
  return {
    mergedSize: j(() => e.size !== void 0 ? e.size : (t == null ? void 0 : t.props.size) !== void 0 ? t.props.size : "medium")
  };
}
function Gye(e) {
  const t = lt(Sb, null), r = j(() => {
    const { labelPlacement: m } = e;
    return m !== void 0 ? m : t != null && t.props.labelPlacement ? t.props.labelPlacement : "top";
  }), n = j(() => r.value === "left" && (e.labelWidth === "auto" || (t == null ? void 0 : t.props.labelWidth) === "auto")), i = j(() => {
    if (r.value === "top")
      return;
    const { labelWidth: m } = e;
    if (m !== void 0 && m !== "auto")
      return Rn(m);
    if (n.value) {
      const v = t == null ? void 0 : t.maxChildLabelWidthRef.value;
      return v !== void 0 ? Rn(v) : void 0;
    }
    if ((t == null ? void 0 : t.props.labelWidth) !== void 0)
      return Rn(t.props.labelWidth);
  }), o = j(() => {
    const { labelAlign: m } = e;
    if (m)
      return m;
    if (t != null && t.props.labelAlign)
      return t.props.labelAlign;
  }), a = j(() => {
    var m;
    return [
      (m = e.labelProps) === null || m === void 0 ? void 0 : m.style,
      e.labelStyle,
      {
        width: i.value
      }
    ];
  }), s = j(() => {
    const { showRequireMark: m } = e;
    return m !== void 0 ? m : t == null ? void 0 : t.props.showRequireMark;
  }), u = j(() => {
    const { requireMarkPlacement: m } = e;
    return m !== void 0 ? m : (t == null ? void 0 : t.props.requireMarkPlacement) || "right";
  }), d = G(!1), f = j(() => {
    const { validationStatus: m } = e;
    if (m !== void 0)
      return m;
    if (d.value)
      return "error";
  }), h = j(() => {
    const { showFeedback: m } = e;
    return m !== void 0 ? m : (t == null ? void 0 : t.props.showFeedback) !== void 0 ? t.props.showFeedback : !0;
  }), g = j(() => {
    const { showLabel: m } = e;
    return m !== void 0 ? m : (t == null ? void 0 : t.props.showLabel) !== void 0 ? t.props.showLabel : !0;
  });
  return {
    validationErrored: d,
    mergedLabelStyle: a,
    mergedLabelPlacement: r,
    mergedLabelAlign: o,
    mergedShowRequireMark: s,
    mergedRequireMarkPlacement: u,
    mergedValidationStatus: f,
    mergedShowFeedback: h,
    mergedShowLabel: g,
    isAutoLabelWidth: n
  };
}
function Zye(e) {
  const t = lt(Sb, null), r = j(() => {
    const { rulePath: a } = e;
    if (a !== void 0)
      return a;
    const { path: s } = e;
    if (s !== void 0)
      return s;
  }), n = j(() => {
    const a = [], { rule: s } = e;
    if (s !== void 0 && (Array.isArray(s) ? a.push(...s) : a.push(s)), t) {
      const { rules: u } = t.props, { value: d } = r;
      if (u !== void 0 && d !== void 0) {
        const f = T0(u, d);
        f !== void 0 && (Array.isArray(f) ? a.push(...f) : a.push(f));
      }
    }
    return a;
  }), i = j(() => n.value.some((a) => a.required)), o = j(() => i.value || e.required);
  return {
    mergedRules: n,
    mergedRequired: o
  };
}
const {
  cubicBezierEaseInOut: wR
} = Wa;
function Kye({
  name: e = "fade-down",
  fromOffset: t = "-4px",
  enterDuration: r = ".3s",
  leaveDuration: n = ".3s",
  enterCubicBezier: i = wR,
  leaveCubicBezier: o = wR
} = {}) {
  return [Y(`&.${e}-transition-enter-from, &.${e}-transition-leave-to`, {
    opacity: 0,
    transform: `translateY(${t})`
  }), Y(`&.${e}-transition-enter-to, &.${e}-transition-leave-from`, {
    opacity: 1,
    transform: "translateY(0)"
  }), Y(`&.${e}-transition-leave-active`, {
    transition: `opacity ${n} ${o}, transform ${n} ${o}`
  }), Y(`&.${e}-transition-enter-active`, {
    transition: `opacity ${r} ${i}, transform ${r} ${i}`
  })];
}
var Xye = L("form-item", `
 display: grid;
 line-height: var(--n-line-height);
`, [L("form-item-label", `
 grid-area: label;
 align-items: center;
 line-height: 1.25;
 text-align: var(--n-label-text-align);
 font-size: var(--n-label-font-size);
 min-height: var(--n-label-height);
 padding: var(--n-label-padding);
 color: var(--n-label-text-color);
 transition: color .3s var(--n-bezier);
 box-sizing: border-box;
 font-weight: var(--n-label-font-weight);
 `, [q("asterisk", `
 white-space: nowrap;
 user-select: none;
 -webkit-user-select: none;
 color: var(--n-asterisk-color);
 transition: color .3s var(--n-bezier);
 `), q("asterisk-placeholder", `
 grid-area: mark;
 user-select: none;
 -webkit-user-select: none;
 visibility: hidden; 
 `)]), L("form-item-blank", `
 grid-area: blank;
 min-height: var(--n-blank-height);
 `), K("auto-label-width", [L("form-item-label", "white-space: nowrap;")]), K("left-labelled", `
 grid-template-areas:
 "label blank"
 "label feedback";
 grid-template-columns: auto minmax(0, 1fr);
 grid-template-rows: auto 1fr;
 align-items: start;
 `, [L("form-item-label", `
 display: grid;
 grid-template-columns: 1fr auto;
 min-height: var(--n-blank-height);
 height: auto;
 box-sizing: border-box;
 flex-shrink: 0;
 flex-grow: 0;
 `, [K("reverse-columns-space", `
 grid-template-columns: auto 1fr;
 `), K("left-mark", `
 grid-template-areas:
 "mark text"
 ". text";
 `), K("right-mark", `
 grid-template-areas: 
 "text mark"
 "text .";
 `), K("right-hanging-mark", `
 grid-template-areas: 
 "text mark"
 "text .";
 `), q("text", `
 grid-area: text; 
 `), q("asterisk", `
 grid-area: mark; 
 align-self: end;
 `)])]), K("top-labelled", `
 grid-template-areas:
 "label"
 "blank"
 "feedback";
 grid-template-rows: minmax(var(--n-label-height), auto) 1fr;
 grid-template-columns: minmax(0, 100%);
 `, [K("no-label", `
 grid-template-areas:
 "blank"
 "feedback";
 grid-template-rows: 1fr;
 `), L("form-item-label", `
 display: flex;
 align-items: flex-start;
 justify-content: var(--n-label-text-align);
 `)]), L("form-item-blank", `
 box-sizing: border-box;
 display: flex;
 align-items: center;
 position: relative;
 `), L("form-item-feedback-wrapper", `
 grid-area: feedback;
 box-sizing: border-box;
 min-height: var(--n-feedback-height);
 font-size: var(--n-feedback-font-size);
 line-height: 1.25;
 transform-origin: top left;
 `, [Y("&:not(:empty)", `
 padding: var(--n-feedback-padding);
 `), L("form-item-feedback", {
  transition: "color .3s var(--n-bezier)",
  color: "var(--n-feedback-text-color)"
}, [K("warning", {
  color: "var(--n-feedback-text-color-warning)"
}), K("error", {
  color: "var(--n-feedback-text-color-error)"
}), Kye({
  fromOffset: "-3px",
  enterDuration: ".3s",
  leaveDuration: ".2s"
})])])]), MR = globalThis && globalThis.__awaiter || function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function s(f) {
      try {
        d(n.next(f));
      } catch (h) {
        a(h);
      }
    }
    function u(f) {
      try {
        d(n.throw(f));
      } catch (h) {
        a(h);
      }
    }
    function d(f) {
      f.done ? o(f.value) : i(f.value).then(s, u);
    }
    d((n = n.apply(e, t || [])).next());
  });
};
const Jye = Object.assign(Object.assign({}, ft.props), { label: String, labelWidth: [Number, String], labelStyle: [String, Object], labelAlign: String, labelPlacement: String, path: String, first: Boolean, rulePath: String, required: Boolean, showRequireMark: {
  type: Boolean,
  default: void 0
}, requireMarkPlacement: String, showFeedback: {
  type: Boolean,
  default: void 0
}, rule: [Object, Array], size: String, ignorePathChange: Boolean, validationStatus: String, feedback: String, showLabel: {
  type: Boolean,
  default: void 0
}, labelProps: Object });
function CR(e, t) {
  return (...r) => {
    try {
      const n = e(...r);
      return !t && (typeof n == "boolean" || n instanceof Error || Array.isArray(n)) || n != null && n.then ? n : (n === void 0 || ja("form-item/validate", `You return a ${typeof n} typed value in the validator method, which is not recommended. Please use ` + (t ? "`Promise`" : "`boolean`, `Error` or `Promise`") + " typed value instead."), !0);
    } catch (n) {
      ja("form-item/validate", "An error is catched in the validation, so the validation won't be done. Your callback in `validate` method of `n-form` or `n-form-item` won't be called in this validation."), console.error(n);
      return;
    }
  };
}
var e1e = oe({
  name: "FormItem",
  props: Jye,
  setup(e) {
    uX(SW, "formItems", tt(e, "path"));
    const { mergedClsPrefixRef: t, inlineThemeDisabled: r } = Yt(e), n = lt(Sb, null), i = qye(e), o = Gye(e), { validationErrored: a } = o, { mergedRequired: s, mergedRules: u } = Zye(e), { mergedSize: d } = i, { mergedLabelPlacement: f, mergedLabelAlign: h, mergedRequireMarkPlacement: g } = o, m = G([]), v = G(Ss()), w = n ? tt(n.props, "disabled") : G(!1), x = ft("Form", "-form-item", Xye, CW, e, t);
    Gt(tt(e, "path"), () => {
      e.ignorePathChange || y();
    });
    function y() {
      m.value = [], a.value = !1, e.feedback && (v.value = Ss());
    }
    function C() {
      E("blur");
    }
    function S() {
      E("change");
    }
    function T() {
      E("focus");
    }
    function A() {
      E("input");
    }
    function D(U, Q) {
      return MR(this, void 0, void 0, function* () {
        let Z, X, re, ue;
        typeof U == "string" ? (Z = U, X = Q) : U !== null && typeof U == "object" && (Z = U.trigger, X = U.callback, re = U.shouldRuleBeApplied, ue = U.options), yield new Promise((he, te) => {
          E(Z, re, ue).then(({ valid: de, errors: De }) => {
            de ? (X && X(), he()) : (X && X(De), te(De));
          });
        });
      });
    }
    const E = (U = null, Q = () => !0, Z = {
      suppressWarning: !0
    }) => MR(this, void 0, void 0, function* () {
      const { path: X } = e;
      Z ? Z.first || (Z.first = e.first) : Z = {};
      const { value: re } = u, ue = n ? T0(n.props.model, X || "") : void 0, he = {}, te = {}, de = (U ? re.filter((Ae) => Array.isArray(Ae.trigger) ? Ae.trigger.includes(U) : Ae.trigger === U) : re).filter(Q).map((Ae, Ne) => {
        const $e = Object.assign({}, Ae);
        if ($e.validator && ($e.validator = CR($e.validator, !1)), $e.asyncValidator && ($e.asyncValidator = CR($e.asyncValidator, !0)), $e.renderMessage) {
          const et = `__renderMessage__${Ne}`;
          te[et] = $e.message, $e.message = et, he[et] = $e.renderMessage;
        }
        return $e;
      });
      if (!de.length)
        return {
          valid: !0
        };
      const De = X ?? "__n_no_path__", Oe = new Tb({ [De]: de }), { validateMessages: Qe } = (n == null ? void 0 : n.props) || {};
      return Qe && Oe.messages(Qe), yield new Promise((Ae) => {
        Oe.validate({ [De]: ue }, Z, (Ne) => {
          Ne != null && Ne.length ? (m.value = Ne.map(($e) => {
            const et = ($e == null ? void 0 : $e.message) || "";
            return {
              key: et,
              render: () => et.startsWith("__renderMessage__") ? he[et]() : et
            };
          }), Ne.forEach(($e) => {
            var et;
            !((et = $e.message) === null || et === void 0) && et.startsWith("__renderMessage__") && ($e.message = te[$e.message]);
          }), a.value = !0, Ae({
            valid: !1,
            errors: Ne
          })) : (y(), Ae({
            valid: !0
          }));
        });
      });
    });
    tr(uz, {
      path: tt(e, "path"),
      disabled: w,
      mergedSize: i.mergedSize,
      mergedValidationStatus: o.mergedValidationStatus,
      restoreValidation: y,
      handleContentBlur: C,
      handleContentChange: S,
      handleContentFocus: T,
      handleContentInput: A
    });
    const N = {
      validate: D,
      restoreValidation: y,
      internalValidate: E
    }, I = G(null);
    br(() => {
      if (!o.isAutoLabelWidth.value)
        return;
      const U = I.value;
      if (U !== null) {
        const Q = U.style.whiteSpace;
        U.style.whiteSpace = "nowrap", U.style.width = "", n == null || n.deriveMaxChildLabelWidth(Number(getComputedStyle(U).width.slice(0, -2))), U.style.whiteSpace = Q;
      }
    });
    const $ = j(() => {
      var U;
      const { value: Q } = d, { value: Z } = f, X = Z === "top" ? "vertical" : "horizontal", { common: { cubicBezierEaseInOut: re }, self: { labelTextColor: ue, asteriskColor: he, lineHeight: te, feedbackTextColor: de, feedbackTextColorWarning: De, feedbackTextColorError: Oe, feedbackPadding: Qe, labelFontWeight: Ae, [Be("labelHeight", Q)]: Ne, [Be("blankHeight", Q)]: $e, [Be("feedbackFontSize", Q)]: et, [Be("feedbackHeight", Q)]: Ge, [Be("labelPadding", X)]: Ee, [Be("labelTextAlign", X)]: qe, [Be(Be("labelFontSize", Z), Q)]: Ue } } = x.value;
      let ot = (U = h.value) !== null && U !== void 0 ? U : qe;
      return Z === "top" && (ot = ot === "right" ? "flex-end" : "flex-start"), {
        "--n-bezier": re,
        "--n-line-height": te,
        "--n-blank-height": $e,
        "--n-label-font-size": Ue,
        "--n-label-text-align": ot,
        "--n-label-height": Ne,
        "--n-label-padding": Ee,
        "--n-label-font-weight": Ae,
        "--n-asterisk-color": he,
        "--n-label-text-color": ue,
        "--n-feedback-padding": Qe,
        "--n-feedback-font-size": et,
        "--n-feedback-height": Ge,
        "--n-feedback-text-color": de,
        "--n-feedback-text-color-warning": De,
        "--n-feedback-text-color-error": Oe
      };
    }), _ = r ? Cr("form-item", j(() => {
      var U;
      return `${d.value[0]}${f.value[0]}${((U = h.value) === null || U === void 0 ? void 0 : U[0]) || ""}`;
    }), $, e) : void 0, R = j(() => f.value === "left" && g.value === "left" && h.value === "left");
    return Object.assign(Object.assign(Object.assign(Object.assign({ labelElementRef: I, mergedClsPrefix: t, mergedRequired: s, feedbackId: v, renderExplains: m, reverseColSpace: R }, o), i), N), { cssVars: r ? void 0 : $, themeClass: _ == null ? void 0 : _.themeClass, onRender: _ == null ? void 0 : _.onRender });
  },
  render() {
    const { $slots: e, mergedClsPrefix: t, mergedShowLabel: r, mergedShowRequireMark: n, mergedRequireMarkPlacement: i, onRender: o } = this, a = n !== void 0 ? n : this.mergedRequired;
    o == null || o();
    const s = () => {
      const u = this.$slots.label ? this.$slots.label() : this.label;
      if (!u)
        return null;
      const d = b("span", { class: `${t}-form-item-label__text` }, u), f = a ? b("span", { class: `${t}-form-item-label__asterisk` }, i !== "left" ? " *" : "* ") : i === "right-hanging" && b("span", { class: `${t}-form-item-label__asterisk-placeholder` }, " *"), { labelProps: h } = this;
      return b("label", Object.assign({}, h, { class: [
        h == null ? void 0 : h.class,
        `${t}-form-item-label`,
        `${t}-form-item-label--${i}-mark`,
        this.reverseColSpace && `${t}-form-item-label--reverse-columns-space`
      ], style: this.mergedLabelStyle, ref: "labelElementRef" }), i === "left" ? [f, d] : [d, f]);
    };
    return b("div", { class: [
      `${t}-form-item`,
      this.themeClass,
      `${t}-form-item--${this.mergedSize}-size`,
      `${t}-form-item--${this.mergedLabelPlacement}-labelled`,
      this.isAutoLabelWidth && `${t}-form-item--auto-label-width`,
      !r && `${t}-form-item--no-label`
    ], style: this.cssVars }, r && s(), b("div", { class: [
      `${t}-form-item-blank`,
      this.mergedValidationStatus && `${t}-form-item-blank--${this.mergedValidationStatus}`
    ] }, e), this.mergedShowFeedback ? b("div", { key: this.feedbackId, class: `${t}-form-item-feedback-wrapper` }, b(jn, { name: "fade-down-transition", mode: "out-in" }, {
      default: () => {
        const { mergedValidationStatus: u } = this;
        return Fr(e.feedback, (d) => {
          var f;
          const { feedback: h } = this, g = d || h ? b("div", { key: "__feedback__", class: `${t}-form-item-feedback__line` }, d || h) : this.renderExplains.length ? (f = this.renderExplains) === null || f === void 0 ? void 0 : f.map(({ key: m, render: v }) => b("div", { key: m, class: `${t}-form-item-feedback__line` }, v())) : null;
          return g ? u === "warning" ? b("div", { key: "controlled-warning", class: `${t}-form-item-feedback ${t}-form-item-feedback--warning` }, g) : u === "error" ? b("div", { key: "controlled-error", class: `${t}-form-item-feedback ${t}-form-item-feedback--error` }, g) : u === "success" ? b("div", { key: "controlled-success", class: `${t}-form-item-feedback ${t}-form-item-feedback--success` }, g) : b("div", { key: "controlled-default", class: `${t}-form-item-feedback` }, g) : null;
        });
      }
    })) : null);
  }
});
const U4 = Object.assign(Object.assign({}, ft.props), { showToolbar: { type: Boolean, default: !0 }, showToolbarTooltip: Boolean }), kW = "n-image";
function t1e() {
  return {
    toolbarIconColor: "rgba(255, 255, 255, .9)",
    toolbarColor: "rgba(0, 0, 0, .35)",
    toolbarBoxShadow: "none",
    toolbarBorderRadius: "24px"
  };
}
const r1e = {
  name: "Image",
  common: Sr,
  peers: {
    Tooltip: UM
  },
  self: t1e
};
var n1e = {
  closeMargin: "16px 12px",
  closeSize: "20px",
  closeIconSize: "16px",
  width: "365px",
  padding: "16px",
  titleFontSize: "16px",
  metaFontSize: "12px",
  descriptionFontSize: "12px"
};
const i1e = (e) => {
  const { textColor2: t, successColor: r, infoColor: n, warningColor: i, errorColor: o, popoverColor: a, closeIconColor: s, closeIconColorHover: u, closeIconColorPressed: d, closeColorHover: f, closeColorPressed: h, textColor1: g, textColor3: m, borderRadius: v, fontWeightStrong: w, boxShadow2: x, lineHeight: y, fontSize: C } = e;
  return Object.assign(Object.assign({}, n1e), {
    borderRadius: v,
    lineHeight: y,
    fontSize: C,
    headerFontWeight: w,
    iconColor: t,
    iconColorSuccess: r,
    iconColorInfo: n,
    iconColorWarning: i,
    iconColorError: o,
    color: a,
    textColor: t,
    closeIconColor: s,
    closeIconColorHover: u,
    closeIconColorPressed: d,
    closeBorderRadius: v,
    closeColorHover: f,
    closeColorPressed: h,
    headerTextColor: g,
    descriptionTextColor: m,
    actionTextColor: t,
    boxShadow: x
  });
}, o1e = {
  name: "Notification",
  common: Sr,
  peers: {
    Scrollbar: Rc
  },
  self: i1e
};
var a1e = o1e;
const l1e = (e) => {
  const { textColorDisabled: t } = e;
  return {
    iconColorDisabled: t
  };
}, s1e = {
  name: "InputNumber",
  common: Sr,
  peers: {
    Button: Yu,
    Input: Fc
  },
  self: l1e
};
var u1e = s1e;
function c1e(e, t, r, n) {
  return {
    itemColorHoverInverted: "#0000",
    itemColorActiveInverted: t,
    itemColorActiveHoverInverted: t,
    itemColorActiveCollapsedInverted: t,
    itemTextColorInverted: e,
    itemTextColorHoverInverted: r,
    itemTextColorChildActiveInverted: r,
    itemTextColorChildActiveHoverInverted: r,
    itemTextColorActiveInverted: r,
    itemTextColorActiveHoverInverted: r,
    itemTextColorHorizontalInverted: e,
    itemTextColorHoverHorizontalInverted: r,
    itemTextColorChildActiveHorizontalInverted: r,
    itemTextColorChildActiveHoverHorizontalInverted: r,
    itemTextColorActiveHorizontalInverted: r,
    itemTextColorActiveHoverHorizontalInverted: r,
    itemIconColorInverted: e,
    itemIconColorHoverInverted: r,
    itemIconColorActiveInverted: r,
    itemIconColorActiveHoverInverted: r,
    itemIconColorChildActiveInverted: r,
    itemIconColorChildActiveHoverInverted: r,
    itemIconColorCollapsedInverted: e,
    itemIconColorHorizontalInverted: e,
    itemIconColorHoverHorizontalInverted: r,
    itemIconColorActiveHorizontalInverted: r,
    itemIconColorActiveHoverHorizontalInverted: r,
    itemIconColorChildActiveHorizontalInverted: r,
    itemIconColorChildActiveHoverHorizontalInverted: r,
    arrowColorInverted: e,
    arrowColorHoverInverted: r,
    arrowColorActiveInverted: r,
    arrowColorActiveHoverInverted: r,
    arrowColorChildActiveInverted: r,
    arrowColorChildActiveHoverInverted: r,
    groupTextColorInverted: n
  };
}
const d1e = (e) => {
  const { borderRadius: t, textColor3: r, primaryColor: n, textColor2: i, textColor1: o, fontSize: a, dividerColor: s, hoverColor: u, primaryColorHover: d } = e;
  return Object.assign({
    borderRadius: t,
    color: "#0000",
    groupTextColor: r,
    itemColorHover: u,
    itemColorActive: nr(n, { alpha: 0.1 }),
    itemColorActiveHover: nr(n, { alpha: 0.1 }),
    itemColorActiveCollapsed: nr(n, { alpha: 0.1 }),
    itemTextColor: i,
    itemTextColorHover: i,
    itemTextColorActive: n,
    itemTextColorActiveHover: n,
    itemTextColorChildActive: n,
    itemTextColorChildActiveHover: n,
    itemTextColorHorizontal: i,
    itemTextColorHoverHorizontal: d,
    itemTextColorActiveHorizontal: n,
    itemTextColorActiveHoverHorizontal: n,
    itemTextColorChildActiveHorizontal: n,
    itemTextColorChildActiveHoverHorizontal: n,
    itemIconColor: o,
    itemIconColorHover: o,
    itemIconColorActive: n,
    itemIconColorActiveHover: n,
    itemIconColorChildActive: n,
    itemIconColorChildActiveHover: n,
    itemIconColorCollapsed: o,
    itemIconColorHorizontal: o,
    itemIconColorHoverHorizontal: d,
    itemIconColorActiveHorizontal: n,
    itemIconColorActiveHoverHorizontal: n,
    itemIconColorChildActiveHorizontal: n,
    itemIconColorChildActiveHoverHorizontal: n,
    itemHeight: "42px",
    arrowColor: i,
    arrowColorHover: i,
    arrowColorActive: n,
    arrowColorActiveHover: n,
    arrowColorChildActive: n,
    arrowColorChildActiveHover: n,
    colorInverted: "#0000",
    borderColorHorizontal: "#0000",
    fontSize: a,
    dividerColor: s
  }, c1e("#BBB", n, "#FFF", "#AAA"));
}, f1e = {
  name: "Menu",
  common: Sr,
  peers: {
    Tooltip: UM,
    Dropdown: $4
  },
  self: d1e
};
var h1e = f1e;
const p1e = (e) => {
  const { infoColor: t, successColor: r, warningColor: n, errorColor: i, textColor2: o, progressRailColor: a, fontSize: s, fontWeight: u } = e;
  return {
    fontSize: s,
    fontSizeCircle: "28px",
    fontWeightCircle: u,
    railColor: a,
    railHeight: "8px",
    iconSizeCircle: "36px",
    iconSizeLine: "18px",
    iconColor: t,
    iconColorInfo: t,
    iconColorSuccess: r,
    iconColorWarning: n,
    iconColorError: i,
    textColorCircle: o,
    textColorLineInner: "rgb(255, 255, 255)",
    textColorLineOuter: o,
    fillColor: t,
    fillColorInfo: t,
    fillColorSuccess: r,
    fillColorWarning: n,
    fillColorError: i,
    lineBgProcessing: "linear-gradient(90deg, rgba(255, 255, 255, .3) 0%, rgba(255, 255, 255, .5) 100%)"
  };
}, g1e = {
  name: "Progress",
  common: Sr,
  self: p1e
};
var DW = g1e, m1e = {
  railHeight: "4px",
  railWidthVertical: "4px",
  handleSize: "18px",
  dotHeight: "8px",
  dotWidth: "8px",
  dotBorderRadius: "4px"
};
const v1e = (e) => {
  const t = "rgba(0, 0, 0, .85)", r = "0 2px 8px 0 rgba(0, 0, 0, 0.12)", { railColor: n, primaryColor: i, baseColor: o, cardColor: a, modalColor: s, popoverColor: u, borderRadius: d, fontSize: f, opacityDisabled: h } = e;
  return Object.assign(Object.assign({}, m1e), { fontSize: f, markFontSize: f, railColor: n, railColorHover: n, fillColor: i, fillColorHover: i, opacityDisabled: h, handleColor: "#FFF", dotColor: a, dotColorModal: s, dotColorPopover: u, handleBoxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.3), inset 0 0 1px 0 rgba(0, 0, 0, 0.05)", handleBoxShadowHover: "0 1px 4px 0 rgba(0, 0, 0, 0.3), inset 0 0 1px 0 rgba(0, 0, 0, 0.05)", handleBoxShadowActive: "0 1px 4px 0 rgba(0, 0, 0, 0.3), inset 0 0 1px 0 rgba(0, 0, 0, 0.05)", handleBoxShadowFocus: "0 1px 4px 0 rgba(0, 0, 0, 0.3), inset 0 0 1px 0 rgba(0, 0, 0, 0.05)", indicatorColor: t, indicatorBoxShadow: r, indicatorTextColor: o, indicatorBorderRadius: d, dotBorder: `2px solid ${n}`, dotBorderActive: `2px solid ${i}`, dotBoxShadow: "" });
}, b1e = {
  name: "Slider",
  common: Sr,
  self: v1e
};
var y1e = b1e;
const x1e = (e) => {
  const { opacityDisabled: t, heightTiny: r, heightSmall: n, heightMedium: i, heightLarge: o, heightHuge: a, primaryColor: s, fontSize: u } = e;
  return {
    fontSize: u,
    textColor: s,
    sizeTiny: r,
    sizeSmall: n,
    sizeMedium: i,
    sizeLarge: o,
    sizeHuge: a,
    color: s,
    opacitySpinning: t
  };
}, w1e = {
  name: "Spin",
  common: Sr,
  self: x1e
};
var M1e = w1e, C1e = {
  stepHeaderFontSizeSmall: "14px",
  stepHeaderFontSizeMedium: "16px",
  indicatorIndexFontSizeSmall: "14px",
  indicatorIndexFontSizeMedium: "16px",
  indicatorSizeSmall: "22px",
  indicatorSizeMedium: "28px",
  indicatorIconSizeSmall: "14px",
  indicatorIconSizeMedium: "18px"
};
const S1e = (e) => {
  const { fontWeightStrong: t, baseColor: r, textColorDisabled: n, primaryColor: i, errorColor: o, textColor1: a, textColor2: s } = e;
  return Object.assign(Object.assign({}, C1e), { stepHeaderFontWeight: t, indicatorTextColorProcess: r, indicatorTextColorWait: n, indicatorTextColorFinish: i, indicatorTextColorError: o, indicatorBorderColorProcess: i, indicatorBorderColorWait: n, indicatorBorderColorFinish: i, indicatorBorderColorError: o, indicatorColorProcess: i, indicatorColorWait: "#0000", indicatorColorFinish: "#0000", indicatorColorError: "#0000", splitorColorProcess: n, splitorColorWait: n, splitorColorFinish: i, splitorColorError: n, headerTextColorProcess: a, headerTextColorWait: n, headerTextColorFinish: n, headerTextColorError: o, descriptionTextColorProcess: s, descriptionTextColorWait: n, descriptionTextColorFinish: n, descriptionTextColorError: o });
}, T1e = {
  name: "Steps",
  common: Sr,
  self: S1e
};
var k1e = T1e, D1e = {
  buttonHeightSmall: "14px",
  buttonHeightMedium: "18px",
  buttonHeightLarge: "22px",
  buttonWidthSmall: "14px",
  buttonWidthMedium: "18px",
  buttonWidthLarge: "22px",
  buttonWidthPressedSmall: "20px",
  buttonWidthPressedMedium: "24px",
  buttonWidthPressedLarge: "28px",
  railHeightSmall: "18px",
  railHeightMedium: "22px",
  railHeightLarge: "26px",
  railWidthSmall: "32px",
  railWidthMedium: "40px",
  railWidthLarge: "48px"
};
const A1e = (e) => {
  const { primaryColor: t, opacityDisabled: r, borderRadius: n, textColor3: i } = e, o = "rgba(0, 0, 0, .14)";
  return Object.assign(Object.assign({}, D1e), { iconColor: i, textColor: "white", loadingColor: t, opacityDisabled: r, railColor: o, railColorActive: t, buttonBoxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.3), inset 0 0 1px 0 rgba(0, 0, 0, 0.05)", buttonColor: "#FFF", railBorderRadiusSmall: n, railBorderRadiusMedium: n, railBorderRadiusLarge: n, buttonBorderRadiusSmall: n, buttonBorderRadiusMedium: n, buttonBorderRadiusLarge: n, boxShadowFocus: `0 0 0 2px ${nr(t, { alpha: 0.2 })}` });
}, E1e = {
  name: "Switch",
  common: Sr,
  self: A1e
};
var I1e = E1e, N1e = {
  tabFontSizeSmall: "14px",
  tabFontSizeMedium: "14px",
  tabFontSizeLarge: "16px",
  tabGapSmallLine: "36px",
  tabGapMediumLine: "36px",
  tabGapLargeLine: "36px",
  tabGapSmallLineVertical: "8px",
  tabGapMediumLineVertical: "8px",
  tabGapLargeLineVertical: "8px",
  tabPaddingSmallLine: "6px 0",
  tabPaddingMediumLine: "10px 0",
  tabPaddingLargeLine: "14px 0",
  tabPaddingVerticalSmallLine: "6px 12px",
  tabPaddingVerticalMediumLine: "8px 16px",
  tabPaddingVerticalLargeLine: "10px 20px",
  tabGapSmallBar: "36px",
  tabGapMediumBar: "36px",
  tabGapLargeBar: "36px",
  tabGapSmallBarVertical: "8px",
  tabGapMediumBarVertical: "8px",
  tabGapLargeBarVertical: "8px",
  tabPaddingSmallBar: "4px 0",
  tabPaddingMediumBar: "6px 0",
  tabPaddingLargeBar: "10px 0",
  tabPaddingVerticalSmallBar: "6px 12px",
  tabPaddingVerticalMediumBar: "8px 16px",
  tabPaddingVerticalLargeBar: "10px 20px",
  tabGapSmallCard: "4px",
  tabGapMediumCard: "4px",
  tabGapLargeCard: "4px",
  tabGapSmallCardVertical: "4px",
  tabGapMediumCardVertical: "4px",
  tabGapLargeCardVertical: "4px",
  tabPaddingSmallCard: "8px 16px",
  tabPaddingMediumCard: "10px 20px",
  tabPaddingLargeCard: "12px 24px",
  tabPaddingSmallSegment: "4px 0",
  tabPaddingMediumSegment: "6px 0",
  tabPaddingLargeSegment: "8px 0",
  tabPaddingVerticalLargeSegment: "0 8px",
  tabPaddingVerticalSmallCard: "8px 12px",
  tabPaddingVerticalMediumCard: "10px 16px",
  tabPaddingVerticalLargeCard: "12px 20px",
  tabPaddingVerticalSmallSegment: "0 4px",
  tabPaddingVerticalMediumSegment: "0 6px",
  tabGapSmallSegment: "0",
  tabGapMediumSegment: "0",
  tabGapLargeSegment: "0",
  tabGapSmallSegmentVertical: "0",
  tabGapMediumSegmentVertical: "0",
  tabGapLargeSegmentVertical: "0",
  panePaddingSmall: "8px 0 0 0",
  panePaddingMedium: "12px 0 0 0",
  panePaddingLarge: "16px 0 0 0",
  closeSize: "18px",
  closeIconSize: "14px"
};
const z1e = (e) => {
  const { textColor2: t, primaryColor: r, textColorDisabled: n, closeIconColor: i, closeIconColorHover: o, closeIconColorPressed: a, closeColorHover: s, closeColorPressed: u, tabColor: d, baseColor: f, dividerColor: h, fontWeight: g, textColor1: m, borderRadius: v, fontSize: w, fontWeightStrong: x } = e;
  return Object.assign(Object.assign({}, N1e), {
    colorSegment: d,
    tabFontSizeCard: w,
    tabTextColorLine: m,
    tabTextColorActiveLine: r,
    tabTextColorHoverLine: r,
    tabTextColorDisabledLine: n,
    tabTextColorSegment: m,
    tabTextColorActiveSegment: t,
    tabTextColorHoverSegment: t,
    tabTextColorDisabledSegment: n,
    tabTextColorBar: m,
    tabTextColorActiveBar: r,
    tabTextColorHoverBar: r,
    tabTextColorDisabledBar: n,
    tabTextColorCard: m,
    tabTextColorHoverCard: m,
    tabTextColorActiveCard: r,
    tabTextColorDisabledCard: n,
    barColor: r,
    closeIconColor: i,
    closeIconColorHover: o,
    closeIconColorPressed: a,
    closeColorHover: s,
    closeColorPressed: u,
    closeBorderRadius: v,
    tabColor: d,
    tabColorSegment: f,
    tabBorderColor: h,
    tabFontWeightActive: g,
    tabFontWeight: g,
    tabBorderRadius: v,
    paneTextColor: t,
    fontWeightStrong: x
  });
}, $1e = {
  name: "Tabs",
  common: Sr,
  self: z1e
};
var O1e = $1e;
const _1e = (e) => {
  const { iconColor: t, primaryColor: r, errorColor: n, textColor2: i, successColor: o, opacityDisabled: a, actionColor: s, borderColor: u, hoverColor: d, lineHeight: f, borderRadius: h, fontSize: g } = e;
  return {
    fontSize: g,
    lineHeight: f,
    borderRadius: h,
    draggerColor: s,
    draggerBorder: `1px dashed ${u}`,
    draggerBorderHover: `1px dashed ${r}`,
    itemColorHover: d,
    itemColorHoverError: nr(n, {
      alpha: 0.06
    }),
    itemTextColor: i,
    itemTextColorError: n,
    itemTextColorSuccess: o,
    itemIconColor: t,
    itemDisabledOpacity: a,
    itemBorderImageCardError: `1px solid ${n}`,
    itemBorderImageCard: `1px solid ${u}`
  };
}, L1e = {
  name: "Upload",
  common: Sr,
  peers: {
    Button: Yu,
    Progress: DW
  },
  self: _1e
};
var P1e = L1e;
const R1e = b("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, b("path", { d: "M6 5C5.75454 5 5.55039 5.17688 5.50806 5.41012L5.5 5.5V14.5C5.5 14.7761 5.72386 15 6 15C6.24546 15 6.44961 14.8231 6.49194 14.5899L6.5 14.5V5.5C6.5 5.22386 6.27614 5 6 5ZM13.8536 5.14645C13.68 4.97288 13.4106 4.9536 13.2157 5.08859L13.1464 5.14645L8.64645 9.64645C8.47288 9.82001 8.4536 10.0894 8.58859 10.2843L8.64645 10.3536L13.1464 14.8536C13.3417 15.0488 13.6583 15.0488 13.8536 14.8536C14.0271 14.68 14.0464 14.4106 13.9114 14.2157L13.8536 14.1464L9.70711 10L13.8536 5.85355C14.0488 5.65829 14.0488 5.34171 13.8536 5.14645Z", fill: "currentColor" })), j1e = b("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, b("path", { d: "M13.5 5C13.7455 5 13.9496 5.17688 13.9919 5.41012L14 5.5V14.5C14 14.7761 13.7761 15 13.5 15C13.2545 15 13.0504 14.8231 13.0081 14.5899L13 14.5V5.5C13 5.22386 13.2239 5 13.5 5ZM5.64645 5.14645C5.82001 4.97288 6.08944 4.9536 6.28431 5.08859L6.35355 5.14645L10.8536 9.64645C11.0271 9.82001 11.0464 10.0894 10.9114 10.2843L10.8536 10.3536L6.35355 14.8536C6.15829 15.0488 5.84171 15.0488 5.64645 14.8536C5.47288 14.68 5.4536 14.4106 5.58859 14.2157L5.64645 14.1464L9.79289 10L5.64645 5.85355C5.45118 5.65829 5.45118 5.34171 5.64645 5.14645Z", fill: "currentColor" })), F1e = b("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, b("path", { d: "M4.089 4.216l.057-.07a.5.5 0 0 1 .638-.057l.07.057L10 9.293l5.146-5.147a.5.5 0 0 1 .638-.057l.07.057a.5.5 0 0 1 .057.638l-.057.07L10.707 10l5.147 5.146a.5.5 0 0 1 .057.638l-.057.07a.5.5 0 0 1-.638.057l-.07-.057L10 10.707l-5.146 5.147a.5.5 0 0 1-.638.057l-.07-.057a.5.5 0 0 1-.057-.638l.057-.07L9.293 10L4.146 4.854a.5.5 0 0 1-.057-.638l.057-.07l-.057.07z", fill: "currentColor" }));
var B1e = Y([Y("body >", [L("image-container", "position: fixed;")]), L("image-preview-container", `
 position: fixed;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 display: flex;
 `), L("image-preview-overlay", `
 z-index: -1;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 background: rgba(0, 0, 0, .3);
 `, [bp()]), L("image-preview-toolbar", `
 z-index: 1;
 position: absolute;
 left: 50%;
 transform: translateX(-50%);
 border-radius: var(--n-toolbar-border-radius);
 height: 48px;
 bottom: 40px;
 padding: 0 12px;
 background: var(--n-toolbar-color);
 box-shadow: var(--n-toolbar-box-shadow);
 color: var(--n-toolbar-icon-color);
 transition: color .3s var(--n-bezier);
 display: flex;
 align-items: center;
 `, [L("base-icon", `
 padding: 0 8px;
 font-size: 28px;
 cursor: pointer;
 `), bp()]), L("image-preview-wrapper", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 display: flex;
 pointer-events: none;
 `, [Fa()]), L("image-preview", `
 user-select: none;
 -webkit-user-select: none;
 pointer-events: all;
 margin: auto;
 max-height: calc(100vh - 32px);
 max-width: calc(100vw - 32px);
 transition: transform .3s var(--n-bezier);
 `), L("image", `
 display: inline-flex;
 max-height: 100%;
 max-width: 100%;
 `, [wr("preview-disabled", `
 cursor: pointer;
 `), Y("img", `
 border-radius: inherit;
 `)])]);
const gy = 32;
var AW = oe({
  name: "ImagePreview",
  props: Object.assign(Object.assign({}, U4), { onNext: Function, onPrev: Function, clsPrefix: {
    type: String,
    required: !0
  } }),
  setup(e) {
    const t = ft("Image", "-image", B1e, r1e, e, tt(e, "clsPrefix"));
    let r = null;
    const n = G(null), i = G(null), o = G(void 0), a = G(!1), s = G(!1), { localeRef: u } = Zl("Image");
    function d() {
      const { value: Ue } = i;
      if (!r || !Ue)
        return;
      const { style: ot } = Ue, Ie = r.getBoundingClientRect(), rt = Ie.left + Ie.width / 2, W = Ie.top + Ie.height / 2;
      ot.transformOrigin = `${rt}px ${W}px`;
    }
    function f(Ue) {
      var ot, Ie;
      switch (Ue.key) {
        case " ":
          Ue.preventDefault();
          break;
        case "ArrowLeft":
          (ot = e.onPrev) === null || ot === void 0 || ot.call(e);
          break;
        case "ArrowRight":
          (Ie = e.onNext) === null || Ie === void 0 || Ie.call(e);
          break;
        case "Escape":
          Ae();
          break;
      }
    }
    Gt(a, (Ue) => {
      Ue ? Mr("keydown", document, f) : hr("keydown", document, f);
    }), Gr(() => {
      hr("keydown", document, f);
    });
    let h = 0, g = 0, m = 0, v = 0, w = 0, x = 0, y = 0, C = 0, S = !1;
    function T(Ue) {
      const { clientX: ot, clientY: Ie } = Ue;
      m = ot - h, v = Ie - g, m0(Qe);
    }
    function A(Ue) {
      const { mouseUpClientX: ot, mouseUpClientY: Ie, mouseDownClientX: rt, mouseDownClientY: W } = Ue, P = rt - ot, H = W - Ie, se = `vertical${H > 0 ? "Top" : "Bottom"}`, pe = `horizontal${P > 0 ? "Left" : "Right"}`;
      return {
        moveVerticalDirection: se,
        moveHorizontalDirection: pe,
        deltaHorizontal: P,
        deltaVertical: H
      };
    }
    function D(Ue) {
      const { value: ot } = n;
      if (!ot)
        return { offsetX: 0, offsetY: 0 };
      const Ie = ot.getBoundingClientRect(), { moveVerticalDirection: rt, moveHorizontalDirection: W, deltaHorizontal: P, deltaVertical: H } = Ue || {};
      let se = 0, pe = 0;
      return Ie.width <= window.innerWidth ? se = 0 : Ie.left > 0 ? se = (Ie.width - window.innerWidth) / 2 : Ie.right < window.innerWidth ? se = -(Ie.width - window.innerWidth) / 2 : W === "horizontalRight" ? se = Math.min((Ie.width - window.innerWidth) / 2, w - (P ?? 0)) : se = Math.max(-((Ie.width - window.innerWidth) / 2), w - (P ?? 0)), Ie.height <= window.innerHeight ? pe = 0 : Ie.top > 0 ? pe = (Ie.height - window.innerHeight) / 2 : Ie.bottom < window.innerHeight ? pe = -(Ie.height - window.innerHeight) / 2 : rt === "verticalBottom" ? pe = Math.min((Ie.height - window.innerHeight) / 2, x - (H ?? 0)) : pe = Math.max(-((Ie.height - window.innerHeight) / 2), x - (H ?? 0)), {
        offsetX: se,
        offsetY: pe
      };
    }
    function E(Ue) {
      hr("mousemove", document, T), hr("mouseup", document, E);
      const { clientX: ot, clientY: Ie } = Ue;
      S = !1;
      const rt = A({
        mouseUpClientX: ot,
        mouseUpClientY: Ie,
        mouseDownClientX: y,
        mouseDownClientY: C
      }), W = D(rt);
      m = W.offsetX, v = W.offsetY, Qe();
    }
    const N = lt(kW, null);
    function I(Ue) {
      var ot, Ie;
      if ((Ie = (ot = N == null ? void 0 : N.previewedImgPropsRef.value) === null || ot === void 0 ? void 0 : ot.onMousedown) === null || Ie === void 0 || Ie.call(ot, Ue), Ue.button !== 0)
        return;
      const { clientX: rt, clientY: W } = Ue;
      S = !0, h = rt - m, g = W - v, w = m, x = v, y = rt, C = W, Qe(), Mr("mousemove", document, T), Mr("mouseup", document, E);
    }
    function $(Ue) {
      var ot, Ie;
      (Ie = (ot = N == null ? void 0 : N.previewedImgPropsRef.value) === null || ot === void 0 ? void 0 : ot.onDblclick) === null || Ie === void 0 || Ie.call(ot, Ue);
      const rt = de();
      U = U === rt ? 1 : rt, Qe();
    }
    const _ = 1.5;
    let R = 0, U = 1, Q = 0;
    function Z() {
      U = 1, R = 0;
    }
    function X() {
      var Ue;
      Z(), Q = 0, (Ue = e.onPrev) === null || Ue === void 0 || Ue.call(e);
    }
    function re() {
      var Ue;
      Z(), Q = 0, (Ue = e.onNext) === null || Ue === void 0 || Ue.call(e);
    }
    function ue() {
      Q -= 90, Qe();
    }
    function he() {
      Q += 90, Qe();
    }
    function te() {
      const { value: Ue } = n;
      if (!Ue)
        return 1;
      const { innerWidth: ot, innerHeight: Ie } = window, rt = Math.max(1, Ue.naturalHeight / (Ie - gy)), W = Math.max(1, Ue.naturalWidth / (ot - gy));
      return Math.max(3, rt * 2, W * 2);
    }
    function de() {
      const { value: Ue } = n;
      if (!Ue)
        return 1;
      const { innerWidth: ot, innerHeight: Ie } = window, rt = Ue.naturalHeight / (Ie - gy), W = Ue.naturalWidth / (ot - gy);
      return rt < 1 && W < 1 ? 1 : Math.max(rt, W);
    }
    function De() {
      const Ue = te();
      U < Ue && (R += 1, U = Math.min(Ue, Math.pow(_, R)), Qe());
    }
    function Oe() {
      if (U > 0.5) {
        const Ue = U;
        R -= 1, U = Math.max(0.5, Math.pow(_, R));
        const ot = Ue - U;
        Qe(!1);
        const Ie = D();
        U += ot, Qe(!1), U -= ot, m = Ie.offsetX, v = Ie.offsetY, Qe();
      }
    }
    function Qe(Ue = !0) {
      var ot;
      const { value: Ie } = n;
      if (!Ie)
        return;
      const { style: rt } = Ie, W = Jf((ot = N == null ? void 0 : N.previewedImgPropsRef.value) === null || ot === void 0 ? void 0 : ot.style);
      let P = "";
      if (typeof W == "string")
        P = W + ";";
      else
        for (const se in W)
          P += `${moe(se)}: ${W[se]};`;
      const H = `transform-origin: center; transform: translateX(${m}px) translateY(${v}px) rotate(${Q}deg) scale(${U});`;
      S ? rt.cssText = P + "cursor: grabbing; transition: none;" + H : rt.cssText = P + "cursor: grab;" + H + (Ue ? "" : "transition: none;"), Ue || Ie.offsetHeight;
    }
    function Ae() {
      a.value = !a.value, s.value = !0;
    }
    function Ne() {
      U = de(), R = Math.ceil(Math.log(U) / Math.log(_)), m = 0, v = 0, Qe();
    }
    const $e = {
      setPreviewSrc: (Ue) => {
        o.value = Ue;
      },
      setThumbnailEl: (Ue) => {
        r = Ue;
      },
      toggleShow: Ae
    };
    function et(Ue, ot) {
      if (e.showToolbarTooltip) {
        const { value: Ie } = t;
        return b(HM, { to: !1, theme: Ie.peers.Tooltip, themeOverrides: Ie.peerOverrides.Tooltip, keepAliveOnHover: !1 }, {
          default: () => u.value[ot],
          trigger: () => Ue
        });
      } else
        return Ue;
    }
    const Ge = j(() => {
      const { common: { cubicBezierEaseInOut: Ue }, self: { toolbarIconColor: ot, toolbarBorderRadius: Ie, toolbarBoxShadow: rt, toolbarColor: W } } = t.value;
      return {
        "--n-bezier": Ue,
        "--n-toolbar-icon-color": ot,
        "--n-toolbar-color": W,
        "--n-toolbar-border-radius": Ie,
        "--n-toolbar-box-shadow": rt
      };
    }), { inlineThemeDisabled: Ee } = Yt(), qe = Ee ? Cr("image-preview", void 0, Ge, e) : void 0;
    return Object.assign({
      previewRef: n,
      previewWrapperRef: i,
      previewSrc: o,
      show: a,
      appear: ql(),
      displayed: s,
      previewedImgProps: N == null ? void 0 : N.previewedImgPropsRef,
      handleWheel(Ue) {
        Ue.preventDefault();
      },
      handlePreviewMousedown: I,
      handlePreviewDblclick: $,
      syncTransformOrigin: d,
      handleAfterLeave: () => {
        Z(), Q = 0, s.value = !1;
      },
      handleDragStart: (Ue) => {
        var ot, Ie;
        (Ie = (ot = N == null ? void 0 : N.previewedImgPropsRef.value) === null || ot === void 0 ? void 0 : ot.onDragstart) === null || Ie === void 0 || Ie.call(ot, Ue), Ue.preventDefault();
      },
      zoomIn: De,
      zoomOut: Oe,
      rotateCounterclockwise: ue,
      rotateClockwise: he,
      handleSwitchPrev: X,
      handleSwitchNext: re,
      withTooltip: et,
      resizeToOrignalImageSize: Ne,
      cssVars: Ee ? void 0 : Ge,
      themeClass: qe == null ? void 0 : qe.themeClass,
      onRender: qe == null ? void 0 : qe.onRender
    }, $e);
  },
  render() {
    var e, t;
    const { clsPrefix: r } = this;
    return b(Lr, null, (t = (e = this.$slots).default) === null || t === void 0 ? void 0 : t.call(e), b($M, { show: this.show }, {
      default: () => {
        var n;
        return this.show || this.displayed ? ((n = this.onRender) === null || n === void 0 || n.call(this), Jn(b("div", { class: [
          `${r}-image-preview-container`,
          this.themeClass
        ], style: this.cssVars, onWheel: this.handleWheel }, b(jn, { name: "fade-in-transition", appear: this.appear }, {
          default: () => this.show ? b("div", { class: `${r}-image-preview-overlay`, onClick: this.toggleShow }) : null
        }), this.showToolbar ? b(jn, { name: "fade-in-transition", appear: this.appear }, {
          default: () => {
            if (!this.show)
              return null;
            const { withTooltip: i } = this;
            return b("div", { class: `${r}-image-preview-toolbar` }, this.onPrev ? b(Lr, null, i(b(fr, { clsPrefix: r, onClick: this.handleSwitchPrev }, { default: () => R1e }), "tipPrevious"), i(b(fr, { clsPrefix: r, onClick: this.handleSwitchNext }, { default: () => j1e }), "tipNext")) : null, i(b(fr, { clsPrefix: r, onClick: this.rotateCounterclockwise }, {
              default: () => b(Ife, null)
            }), "tipCounterclockwise"), i(b(fr, { clsPrefix: r, onClick: this.rotateClockwise }, {
              default: () => b(Efe, null)
            }), "tipClockwise"), i(b(fr, { clsPrefix: r, onClick: this.resizeToOrignalImageSize }, {
              default: () => b($fe, null)
            }), "tipOriginalSize"), i(b(fr, { clsPrefix: r, onClick: this.zoomOut }, { default: () => b(zfe, null) }), "tipZoomOut"), i(b(fr, { clsPrefix: r, onClick: this.zoomIn }, { default: () => b(Nfe, null) }), "tipZoomIn"), i(b(fr, { clsPrefix: r, onClick: this.toggleShow }, { default: () => F1e }), "tipClose"));
          }
        }) : null, b(jn, {
          name: "fade-in-scale-up-transition",
          onAfterLeave: this.handleAfterLeave,
          appear: this.appear,
          onEnter: this.syncTransformOrigin,
          onBeforeLeave: this.syncTransformOrigin
        }, {
          default: () => {
            const { previewedImgProps: i = {} } = this;
            return Jn(b("div", { class: `${r}-image-preview-wrapper`, ref: "previewWrapperRef" }, b("img", Object.assign({}, i, { draggable: !1, onMousedown: this.handlePreviewMousedown, onDblclick: this.handlePreviewDblclick, class: [
              `${r}-image-preview`,
              i.class
            ], key: this.previewSrc, src: this.previewSrc, ref: "previewRef", onDragstart: this.handleDragStart }))), [[Ra, this.show]]);
          }
        })), [[mb, { enabled: this.show }]])) : null;
      }
    }));
  }
});
const EW = "n-image-group", U1e = U4;
var H1e = oe({
  name: "ImageGroup",
  props: U1e,
  setup(e) {
    let t;
    const { mergedClsPrefixRef: r } = Yt(e), n = `c${Ss()}`, i = uh(), o = (u) => {
      var d;
      t = u, (d = s.value) === null || d === void 0 || d.setPreviewSrc(u);
    };
    function a(u) {
      if (!(i != null && i.proxy))
        return;
      const f = i.proxy.$el.parentElement.querySelectorAll(`[data-group-id=${n}]:not([data-error=true])`);
      if (!f.length)
        return;
      const h = Array.from(f).findIndex((g) => g.dataset.previewSrc === t);
      ~h ? o(f[(h + u + f.length) % f.length].dataset.previewSrc) : o(f[0].dataset.previewSrc);
    }
    tr(EW, {
      mergedClsPrefixRef: r,
      setPreviewSrc: o,
      setThumbnailEl: (u) => {
        var d;
        (d = s.value) === null || d === void 0 || d.setThumbnailEl(u);
      },
      toggleShow: () => {
        var u;
        (u = s.value) === null || u === void 0 || u.toggleShow();
      },
      groupId: n
    });
    const s = G(null);
    return {
      mergedClsPrefix: r,
      previewInstRef: s,
      next: () => {
        a(1);
      },
      prev: () => {
        a(-1);
      }
    };
  },
  render() {
    return b(AW, { theme: this.theme, themeOverrides: this.themeOverrides, clsPrefix: this.mergedClsPrefix, ref: "previewInstRef", onPrev: this.prev, onNext: this.next, showToolbar: this.showToolbar, showToolbarTooltip: this.showToolbarTooltip }, this.$slots);
  }
});
const W1e = Object.assign({ alt: String, height: [String, Number], imgProps: Object, previewedImgProps: Object, lazy: Boolean, intersectionObserverOptions: Object, objectFit: {
  type: String,
  default: "fill"
}, previewSrc: String, fallbackSrc: String, width: [String, Number], src: String, previewDisabled: Boolean, loadDescription: String, onError: Function, onLoad: Function }, U4);
var V1e = oe({
  name: "Image",
  props: W1e,
  inheritAttrs: !1,
  setup(e) {
    const t = G(null), r = G(!1), n = G(null), i = lt(EW, null), { mergedClsPrefixRef: o } = i || Yt(e), a = {
      click: () => {
        if (e.previewDisabled || r.value)
          return;
        const d = e.previewSrc || e.src;
        if (i) {
          i.setPreviewSrc(d), i.setThumbnailEl(t.value), i.toggleShow();
          return;
        }
        const { value: f } = n;
        f && (f.setPreviewSrc(d), f.setThumbnailEl(t.value), f.toggleShow());
      }
    }, s = G(!e.lazy);
    br(() => {
      var d;
      (d = t.value) === null || d === void 0 || d.setAttribute("data-group-id", (i == null ? void 0 : i.groupId) || "");
    }), br(() => {
      if (e.lazy && e.intersectionObserverOptions) {
        let d;
        const f = On(() => {
          d == null || d(), d = void 0, d = MH(t.value, e.intersectionObserverOptions, s);
        });
        Gr(() => {
          f(), d == null || d();
        });
      }
    }), On(() => {
      var d;
      e.src, (d = e.imgProps) === null || d === void 0 || d.src, r.value = !1;
    });
    const u = G(!1);
    return tr(kW, {
      previewedImgPropsRef: tt(e, "previewedImgProps")
    }), Object.assign({
      mergedClsPrefix: o,
      groupId: i == null ? void 0 : i.groupId,
      previewInstRef: n,
      imageRef: t,
      showError: r,
      shouldStartLoading: s,
      loaded: u,
      mergedOnClick: (d) => {
        var f, h;
        a.click(), (h = (f = e.imgProps) === null || f === void 0 ? void 0 : f.onClick) === null || h === void 0 || h.call(f, d);
      },
      mergedOnError: (d) => {
        if (!s.value)
          return;
        r.value = !0;
        const { onError: f, imgProps: { onError: h } = {} } = e;
        f == null || f(d), h == null || h(d);
      },
      mergedOnLoad: (d) => {
        const { onLoad: f, imgProps: { onLoad: h } = {} } = e;
        f == null || f(d), h == null || h(d), u.value = !0;
      }
    }, a);
  },
  render() {
    var e, t;
    const { mergedClsPrefix: r, imgProps: n = {}, loaded: i, $attrs: o, lazy: a } = this, s = (t = (e = this.$slots).placeholder) === null || t === void 0 ? void 0 : t.call(e), u = this.src || n.src, d = b("img", Object.assign(Object.assign({}, n), {
      ref: "imageRef",
      width: this.width || n.width,
      height: this.height || n.height,
      src: this.showError ? this.fallbackSrc : a && this.intersectionObserverOptions ? this.shouldStartLoading ? u : void 0 : u,
      alt: this.alt || n.alt,
      "aria-label": this.alt || n.alt,
      onClick: this.mergedOnClick,
      onError: this.mergedOnError,
      onLoad: this.mergedOnLoad,
      loading: Gy && a && !this.intersectionObserverOptions ? "lazy" : "eager",
      style: [
        n.style || "",
        s && !i ? { height: "0", width: "0", visibility: "hidden" } : "",
        { objectFit: this.objectFit }
      ],
      "data-error": this.showError,
      "data-preview-src": this.previewSrc || this.src
    }));
    return b("div", Object.assign({}, o, { role: "none", class: [
      o.class,
      `${r}-image`,
      (this.previewDisabled || this.showError) && `${r}-image--preview-disabled`
    ] }), this.groupId ? d : b(AW, { theme: this.theme, themeOverrides: this.themeOverrides, clsPrefix: r, ref: "previewInstRef", showToolbar: this.showToolbar, showToolbarTooltip: this.showToolbarTooltip }, {
      default: () => d
    }), !i && s);
  }
});
function Y1e(e) {
  return e == null || typeof e == "string" && e.trim() === "" ? null : Number(e);
}
function Q1e(e) {
  return e.includes(".") && (/^(-)?\d+.*(\.|0)$/.test(e) || /^\.\d+$/.test(e));
}
function o2(e) {
  return e == null ? !0 : !Number.isNaN(e);
}
function SR(e, t) {
  return e == null ? "" : t === void 0 ? String(e) : e.toFixed(t);
}
function a2(e) {
  if (e === null)
    return null;
  if (typeof e == "number")
    return e;
  {
    const t = Number(e);
    return Number.isNaN(t) ? null : t;
  }
}
var q1e = Y([L("input-number-suffix", `
 display: inline-block;
 margin-right: 10px;
 `), L("input-number-prefix", `
 display: inline-block;
 margin-left: 10px;
 `)]);
const TR = 800, kR = 100, G1e = Object.assign(Object.assign({}, ft.props), {
  autofocus: Boolean,
  loading: {
    type: Boolean,
    default: void 0
  },
  placeholder: String,
  defaultValue: {
    type: Number,
    default: null
  },
  value: Number,
  step: {
    type: [Number, String],
    default: 1
  },
  min: [Number, String],
  max: [Number, String],
  size: String,
  disabled: {
    type: Boolean,
    default: void 0
  },
  validator: Function,
  bordered: {
    type: Boolean,
    default: void 0
  },
  showButton: {
    type: Boolean,
    default: !0
  },
  buttonPlacement: {
    type: String,
    default: "right"
  },
  readonly: Boolean,
  clearable: Boolean,
  keyboard: {
    type: Object,
    default: {}
  },
  updateValueOnInput: {
    type: Boolean,
    default: !0
  },
  parse: Function,
  format: Function,
  precision: Number,
  status: String,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onFocus: [Function, Array],
  onBlur: [Function, Array],
  onClear: [Function, Array],
  onChange: [Function, Array]
});
var Z1e = oe({
  name: "InputNumber",
  props: G1e,
  setup(e) {
    const { mergedBorderedRef: t, mergedClsPrefixRef: r, mergedRtlRef: n } = Yt(e), i = ft("InputNumber", "-input-number", q1e, u1e, e, r), { localeRef: o } = Zl("InputNumber"), a = ta(e), { mergedSizeRef: s, mergedDisabledRef: u, mergedStatusRef: d } = a, f = G(null), h = G(null), g = G(null), m = G(e.defaultValue), v = tt(e, "value"), w = dn(v, m), x = G(""), y = (P) => {
      const H = String(P).split(".")[1];
      return H ? H.length : 0;
    }, C = (P) => {
      const H = [e.min, e.max, e.step, P].map((se) => se === void 0 ? 0 : y(se));
      return Math.max(...H);
    }, S = _r(() => {
      const { placeholder: P } = e;
      return P !== void 0 ? P : o.value.placeholder;
    }), T = _r(() => {
      const P = a2(e.step);
      return P !== null ? P === 0 ? 1 : Math.abs(P) : 1;
    }), A = _r(() => {
      const P = a2(e.min);
      return P !== null ? P : null;
    }), D = _r(() => {
      const P = a2(e.max);
      return P !== null ? P : null;
    }), E = (P) => {
      const { value: H } = w;
      if (P === H) {
        I();
        return;
      }
      const { "onUpdate:value": se, onUpdateValue: pe, onChange: ae } = e, { nTriggerFormInput: Me, nTriggerFormChange: fe } = a;
      ae && je(ae, P), pe && je(pe, P), se && je(se, P), m.value = P, Me(), fe();
    }, N = ({ offset: P, doUpdateIfValid: H, fixPrecision: se, isInputing: pe }) => {
      const { value: ae } = x;
      if (pe && Q1e(ae))
        return !1;
      const Me = (e.parse || Y1e)(ae);
      if (Me === null)
        return H && E(null), null;
      if (o2(Me)) {
        const fe = y(Me), { precision: ke } = e;
        if (ke !== void 0 && ke < fe && !se)
          return !1;
        let Le = parseFloat((Me + P).toFixed(ke ?? C(Me)));
        if (o2(Le)) {
          const { value: dt } = D, { value: Mt } = A;
          if (dt !== null && Le > dt) {
            if (!H || pe)
              return !1;
            Le = dt;
          }
          if (Mt !== null && Le < Mt) {
            if (!H || pe)
              return !1;
            Le = Mt;
          }
          return e.validator && !e.validator(Le) ? !1 : (H && E(Le), Le);
        }
      }
      return !1;
    }, I = () => {
      const { value: P } = w;
      if (o2(P)) {
        const { format: H, precision: se } = e;
        H ? x.value = H(P) : P === null || se === void 0 || y(P) > se ? x.value = SR(P, void 0) : x.value = SR(P, se);
      } else
        x.value = String(P);
    };
    I();
    const $ = _r(() => N({
      offset: 0,
      doUpdateIfValid: !1,
      isInputing: !1,
      fixPrecision: !1
    }) === !1), _ = _r(() => {
      const { value: P } = w;
      if (e.validator && P === null)
        return !1;
      const { value: H } = T;
      return N({
        offset: -H,
        doUpdateIfValid: !1,
        isInputing: !1,
        fixPrecision: !1
      }) !== !1;
    }), R = _r(() => {
      const { value: P } = w;
      if (e.validator && P === null)
        return !1;
      const { value: H } = T;
      return N({
        offset: +H,
        doUpdateIfValid: !1,
        isInputing: !1,
        fixPrecision: !1
      }) !== !1;
    });
    function U(P) {
      const { onFocus: H } = e, { nTriggerFormFocus: se } = a;
      H && je(H, P), se();
    }
    function Q(P) {
      var H, se;
      if (P.target === ((H = f.value) === null || H === void 0 ? void 0 : H.wrapperElRef))
        return;
      const pe = N({
        offset: 0,
        doUpdateIfValid: !0,
        isInputing: !1,
        fixPrecision: !0
      });
      if (pe !== !1) {
        const fe = (se = f.value) === null || se === void 0 ? void 0 : se.inputElRef;
        fe && (fe.value = String(pe || "")), w.value === pe && I();
      } else
        I();
      const { onBlur: ae } = e, { nTriggerFormBlur: Me } = a;
      ae && je(ae, P), Me(), an(() => {
        I();
      });
    }
    function Z(P) {
      const { onClear: H } = e;
      H && je(H, P);
    }
    function X() {
      const { value: P } = R;
      if (!P) {
        $e();
        return;
      }
      const { value: H } = w;
      if (H === null)
        e.validator || E(te());
      else {
        const { value: se } = T;
        N({
          offset: se,
          doUpdateIfValid: !0,
          isInputing: !1,
          fixPrecision: !0
        });
      }
    }
    function re() {
      const { value: P } = _;
      if (!P) {
        Ne();
        return;
      }
      const { value: H } = w;
      if (H === null)
        e.validator || E(te());
      else {
        const { value: se } = T;
        N({
          offset: -se,
          doUpdateIfValid: !0,
          isInputing: !1,
          fixPrecision: !0
        });
      }
    }
    const ue = U, he = Q;
    function te() {
      if (e.validator)
        return null;
      const { value: P } = A, { value: H } = D;
      return P !== null ? Math.max(0, P) : H !== null ? Math.min(0, H) : 0;
    }
    function de(P) {
      Z(P), E(null);
    }
    function De(P) {
      var H, se, pe;
      !((H = g.value) === null || H === void 0) && H.$el.contains(P.target) && P.preventDefault(), !((se = h.value) === null || se === void 0) && se.$el.contains(P.target) && P.preventDefault(), (pe = f.value) === null || pe === void 0 || pe.activate();
    }
    let Oe = null, Qe = null, Ae = null;
    function Ne() {
      Ae && (window.clearTimeout(Ae), Ae = null), Oe && (window.clearInterval(Oe), Oe = null);
    }
    function $e() {
      Ge && (window.clearTimeout(Ge), Ge = null), Qe && (window.clearInterval(Qe), Qe = null);
    }
    function et() {
      Ne(), Ae = window.setTimeout(() => {
        Oe = window.setInterval(() => {
          re();
        }, kR);
      }, TR), Mr("mouseup", document, Ne, {
        once: !0
      });
    }
    let Ge = null;
    function Ee() {
      $e(), Ge = window.setTimeout(() => {
        Qe = window.setInterval(() => {
          X();
        }, kR);
      }, TR), Mr("mouseup", document, $e, {
        once: !0
      });
    }
    const qe = () => {
      Qe || X();
    }, Ue = () => {
      Oe || re();
    };
    function ot(P) {
      var H, se;
      if (P.key === "Enter") {
        if (P.target === ((H = f.value) === null || H === void 0 ? void 0 : H.wrapperElRef))
          return;
        N({
          offset: 0,
          doUpdateIfValid: !0,
          isInputing: !1,
          fixPrecision: !0
        }) !== !1 && ((se = f.value) === null || se === void 0 || se.deactivate());
      } else if (P.key === "ArrowUp") {
        if (!R.value || e.keyboard.ArrowUp === !1)
          return;
        P.preventDefault(), N({
          offset: 0,
          doUpdateIfValid: !0,
          isInputing: !1,
          fixPrecision: !0
        }) !== !1 && X();
      } else if (P.key === "ArrowDown") {
        if (!_.value || e.keyboard.ArrowDown === !1)
          return;
        P.preventDefault(), N({
          offset: 0,
          doUpdateIfValid: !0,
          isInputing: !1,
          fixPrecision: !0
        }) !== !1 && re();
      }
    }
    function Ie(P) {
      x.value = P, e.updateValueOnInput && !e.format && !e.parse && e.precision === void 0 && N({
        offset: 0,
        doUpdateIfValid: !0,
        isInputing: !0,
        fixPrecision: !1
      });
    }
    Gt(w, () => {
      I();
    });
    const rt = {
      focus: () => {
        var P;
        return (P = f.value) === null || P === void 0 ? void 0 : P.focus();
      },
      blur: () => {
        var P;
        return (P = f.value) === null || P === void 0 ? void 0 : P.blur();
      }
    }, W = Li("InputNumber", n, r);
    return Object.assign(Object.assign({}, rt), {
      rtlEnabled: W,
      inputInstRef: f,
      minusButtonInstRef: h,
      addButtonInstRef: g,
      mergedClsPrefix: r,
      mergedBordered: t,
      uncontrolledValue: m,
      mergedValue: w,
      mergedPlaceholder: S,
      displayedValueInvalid: $,
      mergedSize: s,
      mergedDisabled: u,
      displayedValue: x,
      addable: R,
      minusable: _,
      mergedStatus: d,
      handleFocus: ue,
      handleBlur: he,
      handleClear: de,
      handleMouseDown: De,
      handleAddClick: qe,
      handleMinusClick: Ue,
      handleAddMousedown: Ee,
      handleMinusMousedown: et,
      handleKeyDown: ot,
      handleUpdateDisplayedValue: Ie,
      mergedTheme: i,
      inputThemeOverrides: {
        paddingSmall: "0 8px 0 10px",
        paddingMedium: "0 8px 0 12px",
        paddingLarge: "0 8px 0 14px"
      },
      buttonThemeOverrides: j(() => {
        const { self: { iconColorDisabled: P } } = i.value, [H, se, pe, ae] = ro(P);
        return {
          textColorTextDisabled: `rgb(${H}, ${se}, ${pe})`,
          opacityDisabled: `${ae}`
        };
      })
    });
  },
  render() {
    const { mergedClsPrefix: e, $slots: t } = this, r = () => b(bs, { text: !0, disabled: !this.minusable || this.mergedDisabled || this.readonly, focusable: !1, theme: this.mergedTheme.peers.Button, themeOverrides: this.mergedTheme.peerOverrides.Button, builtinThemeOverrides: this.buttonThemeOverrides, onClick: this.handleMinusClick, onMousedown: this.handleMinusMousedown, ref: "minusButtonInstRef" }, {
      icon: () => vr(t["minus-icon"], () => [
        b(fr, { clsPrefix: e }, {
          default: () => b(Mfe, null)
        })
      ])
    }), n = () => b(bs, { text: !0, disabled: !this.addable || this.mergedDisabled || this.readonly, focusable: !1, theme: this.mergedTheme.peers.Button, themeOverrides: this.mergedTheme.peerOverrides.Button, builtinThemeOverrides: this.buttonThemeOverrides, onClick: this.handleAddClick, onMousedown: this.handleAddMousedown, ref: "addButtonInstRef" }, {
      icon: () => vr(t["add-icon"], () => [
        b(fr, { clsPrefix: e }, {
          default: () => b(FM, null)
        })
      ])
    });
    return b("div", { class: [
      `${e}-input-number`,
      this.rtlEnabled && `${e}-input-number--rtl`
    ] }, b(pa, { ref: "inputInstRef", autofocus: this.autofocus, status: this.mergedStatus, bordered: this.mergedBordered, loading: this.loading, value: this.displayedValue, onUpdateValue: this.handleUpdateDisplayedValue, theme: this.mergedTheme.peers.Input, themeOverrides: this.mergedTheme.peerOverrides.Input, builtinThemeOverrides: this.inputThemeOverrides, size: this.mergedSize, placeholder: this.mergedPlaceholder, disabled: this.mergedDisabled, readonly: this.readonly, textDecoration: this.displayedValueInvalid ? "line-through" : void 0, onFocus: this.handleFocus, onBlur: this.handleBlur, onKeydown: this.handleKeyDown, onMousedown: this.handleMouseDown, onClear: this.handleClear, clearable: this.clearable, internalLoadingBeforeSuffix: !0 }, {
      prefix: () => {
        var i;
        return this.showButton && this.buttonPlacement === "both" ? [
          r(),
          Fr(t.prefix, (o) => o ? b("span", { class: `${e}-input-number-prefix` }, o) : null)
        ] : (i = t.prefix) === null || i === void 0 ? void 0 : i.call(t);
      },
      suffix: () => {
        var i;
        return this.showButton ? [
          Fr(t.suffix, (o) => o ? b("span", { class: `${e}-input-number-suffix` }, o) : null),
          this.buttonPlacement === "right" ? r() : null,
          n()
        ] : (i = t.suffix) === null || i === void 0 ? void 0 : i.call(t);
      }
    }));
  }
});
const K1e = "n-layout-sider", kb = "n-menu", H4 = "n-submenu", W4 = "n-menu-item-group", my = 8;
function V4(e) {
  const t = lt(kb), { props: r, mergedCollapsedRef: n } = t, i = lt(H4, null), o = lt(W4, null), a = j(() => r.mode === "horizontal"), s = j(() => a.value ? r.dropdownPlacement : "tmNodes" in e ? "right-start" : "right"), u = j(() => {
    var g;
    return Math.max((g = r.collapsedIconSize) !== null && g !== void 0 ? g : r.iconSize, r.iconSize);
  }), d = j(() => {
    var g;
    return !a.value && e.root && n.value && (g = r.collapsedIconSize) !== null && g !== void 0 ? g : r.iconSize;
  }), f = j(() => {
    if (a.value)
      return;
    const { collapsedWidth: g, indent: m, rootIndent: v } = r, { root: w, isGroup: x } = e, y = v === void 0 ? m : v;
    if (w)
      return n.value ? g / 2 - u.value / 2 : y;
    if (o)
      return m / 2 + o.paddingLeftRef.value;
    if (i)
      return (x ? m / 2 : m) + i.paddingLeftRef.value;
  }), h = j(() => {
    const { collapsedWidth: g, indent: m, rootIndent: v } = r, { value: w } = u, { root: x } = e;
    return a.value || !x || !n.value ? my : (v === void 0 ? m : v) + w + my - (g + w) / 2;
  });
  return {
    dropdownPlacement: s,
    activeIconSize: d,
    maxIconSize: u,
    paddingLeft: f,
    iconMarginRight: h,
    NMenu: t,
    NSubmenu: i
  };
}
const Y4 = {
  internalKey: {
    type: [String, Number],
    required: !0
  },
  root: Boolean,
  isGroup: Boolean,
  level: {
    type: Number,
    required: !0
  },
  title: [String, Function],
  extra: [String, Function]
}, IW = Object.assign(Object.assign({}, Y4), { tmNode: {
  type: Object,
  required: !0
}, tmNodes: {
  type: Array,
  required: !0
} }), X1e = oe({
  name: "MenuOptionGroup",
  props: IW,
  setup(e) {
    tr(H4, null);
    const t = V4(e);
    tr(W4, {
      paddingLeftRef: t.paddingLeft
    });
    const { mergedClsPrefixRef: r, props: n } = lt(kb);
    return function() {
      const { value: i } = r, o = t.paddingLeft.value, { nodeProps: a } = n, s = a == null ? void 0 : a(e.tmNode.rawNode);
      return b("div", { class: `${i}-menu-item-group`, role: "group" }, b("div", Object.assign({}, s, { class: [`${i}-menu-item-group-title`, s == null ? void 0 : s.class], style: [
        (s == null ? void 0 : s.style) || "",
        o !== void 0 ? `padding-left: ${o}px;` : ""
      ] }), xn(e.title), e.extra ? b(Lr, null, " ", xn(e.extra)) : null), b("div", null, e.tmNodes.map((u) => Q4(u, n))));
    };
  }
});
var NW = oe({
  name: "MenuOptionContent",
  props: {
    collapsed: Boolean,
    disabled: Boolean,
    title: [String, Function],
    icon: Function,
    extra: [String, Function],
    showArrow: Boolean,
    childActive: Boolean,
    hover: Boolean,
    paddingLeft: Number,
    selected: Boolean,
    maxIconSize: {
      type: Number,
      required: !0
    },
    activeIconSize: {
      type: Number,
      required: !0
    },
    iconMarginRight: {
      type: Number,
      required: !0
    },
    clsPrefix: {
      type: String,
      required: !0
    },
    onClick: Function,
    tmNode: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { props: t } = lt(kb);
    return {
      menuProps: t,
      style: j(() => {
        const { paddingLeft: r } = e;
        return { paddingLeft: r && `${r}px` };
      }),
      iconStyle: j(() => {
        const { maxIconSize: r, activeIconSize: n, iconMarginRight: i } = e;
        return {
          width: `${r}px`,
          height: `${r}px`,
          fontSize: `${n}px`,
          marginRight: `${i}px`
        };
      })
    };
  },
  render() {
    const { clsPrefix: e, tmNode: t, menuProps: { renderIcon: r, renderLabel: n, renderExtra: i, expandIcon: o } } = this, a = r ? r(t.rawNode) : xn(this.icon);
    return b("div", { onClick: (s) => {
      var u;
      (u = this.onClick) === null || u === void 0 || u.call(this, s);
    }, role: "none", class: [
      `${e}-menu-item-content`,
      {
        [`${e}-menu-item-content--selected`]: this.selected,
        [`${e}-menu-item-content--collapsed`]: this.collapsed,
        [`${e}-menu-item-content--child-active`]: this.childActive,
        [`${e}-menu-item-content--disabled`]: this.disabled,
        [`${e}-menu-item-content--hover`]: this.hover
      }
    ], style: this.style }, a && b("div", { class: `${e}-menu-item-content__icon`, style: this.iconStyle, role: "none" }, [a]), b("div", { class: `${e}-menu-item-content-header`, role: "none" }, n ? n(t.rawNode) : xn(this.title), this.extra || i ? b("span", { class: `${e}-menu-item-content-header__extra` }, " ", i ? i(t.rawNode) : xn(this.extra)) : null), this.showArrow ? b(fr, { ariaHidden: !0, class: `${e}-menu-item-content__arrow`, clsPrefix: e }, {
      default: () => o ? o(t.rawNode) : b(kfe, null)
    }) : null);
  }
});
const zW = Object.assign(Object.assign({}, Y4), { rawNodes: {
  type: Array,
  default: () => []
}, tmNodes: {
  type: Array,
  default: () => []
}, tmNode: {
  type: Object,
  required: !0
}, disabled: {
  type: Boolean,
  default: !1
}, icon: Function, onClick: Function }), J1e = oe({
  name: "Submenu",
  props: zW,
  setup(e) {
    const t = V4(e), { NMenu: r, NSubmenu: n } = t, { props: i, mergedCollapsedRef: o, mergedThemeRef: a } = r, s = j(() => {
      const { disabled: g } = e;
      return n != null && n.mergedDisabledRef.value || i.disabled ? !0 : g;
    }), u = G(!1);
    tr(H4, {
      paddingLeftRef: t.paddingLeft,
      mergedDisabledRef: s
    }), tr(W4, null);
    function d() {
      const { onClick: g } = e;
      g && g();
    }
    function f() {
      s.value || (o.value || r.toggleExpand(e.internalKey), d());
    }
    function h(g) {
      u.value = g;
    }
    return {
      menuProps: i,
      mergedTheme: a,
      doSelect: r.doSelect,
      inverted: r.invertedRef,
      isHorizontal: r.isHorizontalRef,
      mergedClsPrefix: r.mergedClsPrefixRef,
      maxIconSize: t.maxIconSize,
      activeIconSize: t.activeIconSize,
      iconMarginRight: t.iconMarginRight,
      dropdownPlacement: t.dropdownPlacement,
      dropdownShow: u,
      paddingLeft: t.paddingLeft,
      mergedDisabled: s,
      mergedValue: r.mergedValueRef,
      childActive: _r(() => r.activePathRef.value.includes(e.internalKey)),
      collapsed: j(() => i.mode === "horizontal" ? !1 : o.value ? !0 : !r.mergedExpandedKeysRef.value.includes(e.internalKey)),
      dropdownEnabled: j(() => !s.value && (i.mode === "horizontal" || o.value)),
      handlePopoverShowChange: h,
      handleClick: f
    };
  },
  render() {
    var e;
    const { mergedClsPrefix: t, menuProps: { renderIcon: r, renderLabel: n } } = this, i = () => {
      const { isHorizontal: a, paddingLeft: s, collapsed: u, mergedDisabled: d, maxIconSize: f, activeIconSize: h, title: g, childActive: m, icon: v, handleClick: w, menuProps: { nodeProps: x }, dropdownShow: y, iconMarginRight: C, tmNode: S, mergedClsPrefix: T } = this, A = x == null ? void 0 : x(S.rawNode);
      return b("div", Object.assign({}, A, { class: [`${T}-menu-item`, A == null ? void 0 : A.class], role: "menuitem" }), b(NW, { tmNode: S, paddingLeft: s, collapsed: u, disabled: d, iconMarginRight: C, maxIconSize: f, activeIconSize: h, title: g, extra: this.extra, showArrow: !a, childActive: m, clsPrefix: T, icon: v, hover: y, onClick: w }));
    }, o = () => b(ph, null, {
      default: () => {
        const { tmNodes: a, collapsed: s } = this;
        return s ? null : b("div", { class: `${t}-submenu-children`, role: "menu" }, a.map((u) => Q4(u, this.menuProps)));
      }
    });
    return this.root ? b(YM, Object.assign({ size: "large", trigger: "hover" }, (e = this.menuProps) === null || e === void 0 ? void 0 : e.dropdownProps, { themeOverrides: this.mergedTheme.peerOverrides.Dropdown, theme: this.mergedTheme.peers.Dropdown, builtinThemeOverrides: {
      fontSizeLarge: "14px",
      optionIconSizeLarge: "18px"
    }, value: this.mergedValue, disabled: !this.dropdownEnabled, placement: this.dropdownPlacement, keyField: this.menuProps.keyField, labelField: this.menuProps.labelField, childrenField: this.menuProps.childrenField, onUpdateShow: this.handlePopoverShowChange, options: this.rawNodes, onSelect: this.doSelect, inverted: this.inverted, renderIcon: r, renderLabel: n }), {
      default: () => b("div", { class: `${t}-submenu`, role: "menuitem", "aria-expanded": !this.collapsed }, i(), this.isHorizontal ? null : o())
    }) : b("div", { class: `${t}-submenu`, role: "menuitem", "aria-expanded": !this.collapsed }, i(), o());
  }
}), $W = Object.assign(Object.assign({}, Y4), { tmNode: {
  type: Object,
  required: !0
}, disabled: Boolean, icon: Function, onClick: Function }), exe = oe({
  name: "MenuOption",
  props: $W,
  setup(e) {
    const t = V4(e), { NSubmenu: r, NMenu: n } = t, { props: i, mergedClsPrefixRef: o, mergedCollapsedRef: a } = n, s = r ? r.mergedDisabledRef : { value: !1 }, u = j(() => s.value || e.disabled);
    function d(h) {
      const { onClick: g } = e;
      g && g(h);
    }
    function f(h) {
      u.value || (n.doSelect(e.internalKey, e.tmNode.rawNode), d(h));
    }
    return {
      mergedClsPrefix: o,
      dropdownPlacement: t.dropdownPlacement,
      paddingLeft: t.paddingLeft,
      iconMarginRight: t.iconMarginRight,
      maxIconSize: t.maxIconSize,
      activeIconSize: t.activeIconSize,
      mergedTheme: n.mergedThemeRef,
      menuProps: i,
      dropdownEnabled: _r(() => e.root && a.value && i.mode !== "horizontal" && !u.value),
      selected: _r(() => n.mergedValueRef.value === e.internalKey),
      mergedDisabled: u,
      handleClick: f
    };
  },
  render() {
    const { mergedClsPrefix: e, mergedTheme: t, tmNode: r, menuProps: { renderLabel: n, nodeProps: i } } = this, o = i == null ? void 0 : i(r.rawNode);
    return b("div", Object.assign({}, o, { role: "menuitem", class: [`${e}-menu-item`, o == null ? void 0 : o.class] }), b(HM, { theme: t.peers.Tooltip, themeOverrides: t.peerOverrides.Tooltip, trigger: "hover", placement: this.dropdownPlacement, disabled: !this.dropdownEnabled || this.title === void 0, internalExtraClass: ["menu-tooltip"] }, {
      default: () => n ? n(r.rawNode) : xn(this.title),
      trigger: () => b(NW, { tmNode: r, clsPrefix: e, paddingLeft: this.paddingLeft, iconMarginRight: this.iconMarginRight, maxIconSize: this.maxIconSize, activeIconSize: this.activeIconSize, selected: this.selected, title: this.title, extra: this.extra, disabled: this.mergedDisabled, icon: this.icon, onClick: this.handleClick })
    }));
  }
});
var txe = oe({
  name: "MenuDivider",
  setup() {
    const e = lt(kb), { mergedClsPrefixRef: t, isHorizontalRef: r } = e;
    return () => r.value ? null : b("div", { class: `${t.value}-menu-divider` });
  }
});
const rxe = Ts(IW), nxe = Ts($W), ixe = Ts(zW);
function OW(e) {
  return e.type === "divider" || e.type === "render";
}
function oxe(e) {
  return e.type === "divider";
}
function Q4(e, t) {
  const { rawNode: r } = e, { show: n } = r;
  if (n === !1)
    return null;
  if (OW(r))
    return oxe(r) ? b(txe, Object.assign({ key: e.key }, r.props)) : null;
  const { labelField: i } = t, { key: o, level: a, isGroup: s } = e, u = Object.assign(Object.assign({}, r), {
    title: r.title || r[i],
    extra: r.titleExtra || r.extra,
    key: o,
    internalKey: o,
    level: a,
    root: a === 0,
    isGroup: s
  });
  return e.children ? e.isGroup ? b(X1e, il(u, rxe, { tmNode: e, tmNodes: e.children, key: o })) : b(J1e, il(u, ixe, {
    key: o,
    rawNodes: r[t.childrenField],
    tmNodes: e.children,
    tmNode: e
  })) : b(exe, il(u, nxe, {
    key: o,
    tmNode: e
  }));
}
const DR = [Y("&::before", "background-color: var(--n-item-color-hover);"), q("arrow", `
 color: var(--n-arrow-color-hover);
 `), q("icon", `
 color: var(--n-item-icon-color-hover);
 `), L("menu-item-content-header", `
 color: var(--n-item-text-color-hover);
 `, [Y("a", `
 color: var(--n-item-text-color-hover);
 `), q("extra", `
 color: var(--n-item-text-color-hover);
 `)])], AR = [q("icon", `
 color: var(--n-item-icon-color-hover-horizontal);
 `), L("menu-item-content-header", `
 color: var(--n-item-text-color-hover-horizontal);
 `, [Y("a", `
 color: var(--n-item-text-color-hover-horizontal);
 `), q("extra", `
 color: var(--n-item-text-color-hover-horizontal);
 `)])];
var axe = Y([L("menu", `
 background-color: var(--n-color);
 color: var(--n-item-text-color);
 overflow: hidden;
 transition: background-color .3s var(--n-bezier);
 box-sizing: border-box;
 font-size: var(--n-font-size);
 padding-bottom: 6px;
 `, [K("horizontal", `
 display: inline-flex;
 padding-bottom: 0;
 `, [L("submenu", "margin: 0;"), L("menu-item", "margin: 0;"), L("menu-item-content", `
 padding: 0 20px;
 border-bottom: 2px solid #0000;
 `, [Y("&::before", "display: none;"), K("selected", "border-bottom: 2px solid var(--n-border-color-horizontal)")]), L("menu-item-content", [K("selected", [q("icon", "color: var(--n-item-icon-color-active-horizontal);"), L("menu-item-content-header", `
 color: var(--n-item-text-color-active-horizontal);
 `, [Y("a", "color: var(--n-item-text-color-active-horizontal);"), q("extra", "color: var(--n-item-text-color-active-horizontal);")])]), K("child-active", `
 border-bottom: 2px solid var(--n-border-color-horizontal);
 `, [L("menu-item-content-header", `
 color: var(--n-item-text-color-child-active-horizontal);
 `, [Y("a", `
 color: var(--n-item-text-color-child-active-horizontal);
 `), q("extra", `
 color: var(--n-item-text-color-child-active-horizontal);
 `)]), q("icon", `
 color: var(--n-item-icon-color-child-active-horizontal);
 `)]), wr("disabled", [wr("selected, child-active", [Y("&:focus-within", AR)]), K("selected", [bf(null, [q("icon", "color: var(--n-item-icon-color-active-hover-horizontal);"), L("menu-item-content-header", `
 color: var(--n-item-text-color-active-hover-horizontal);
 `, [Y("a", "color: var(--n-item-text-color-active-hover-horizontal);"), q("extra", "color: var(--n-item-text-color-active-hover-horizontal);")])])]), K("child-active", [bf(null, [q("icon", "color: var(--n-item-icon-color-child-active-hover-horizontal);"), L("menu-item-content-header", `
 color: var(--n-item-text-color-child-active-hover-horizontal);
 `, [Y("a", "color: var(--n-item-text-color-child-active-hover-horizontal);"), q("extra", "color: var(--n-item-text-color-child-active-hover-horizontal);")])])]), bf("border-bottom: 2px solid var(--n-border-color-horizontal);", AR)]), L("menu-item-content-header", [Y("a", "color: var(--n-item-text-color-horizontal);")])])]), K("collapsed", [L("menu-item-content", [K("selected", [Y("&::before", `
 background-color: var(--n-item-color-active-collapsed) !important;
 `)]), L("menu-item-content-header", "opacity: 0;"), q("arrow", "opacity: 0;"), q("icon", "color: var(--n-item-icon-color-collapsed);")])]), L("menu-item", `
 height: var(--n-item-height);
 margin-top: 6px;
 position: relative;
 `), L("menu-item-content", `
 box-sizing: border-box;
 line-height: 1.75;
 height: 100%;
 display: grid;
 grid-template-areas: "icon content arrow";
 grid-template-columns: auto 1fr auto;
 align-items: center;
 cursor: pointer;
 position: relative;
 padding-right: 18px;
 transition:
 background-color .3s var(--n-bezier),
 padding-left .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `, [Y("> *", "z-index: 1;"), Y("&::before", `
 z-index: auto;
 content: "";
 background-color: #0000;
 position: absolute;
 left: 8px;
 right: 8px;
 top: 0;
 bottom: 0;
 pointer-events: none;
 border-radius: var(--n-border-radius);
 transition: background-color .3s var(--n-bezier);
 `), K("disabled", `
 opacity: .45;
 cursor: not-allowed;
 `), K("collapsed", [q("arrow", "transform: rotate(0);")]), K("selected", [Y("&::before", "background-color: var(--n-item-color-active);"), q("arrow", "color: var(--n-arrow-color-active);"), q("icon", "color: var(--n-item-icon-color-active);"), L("menu-item-content-header", `
 color: var(--n-item-text-color-active);
 `, [Y("a", "color: var(--n-item-text-color-active);"), q("extra", "color: var(--n-item-text-color-active);")])]), K("child-active", [L("menu-item-content-header", `
 color: var(--n-item-text-color-child-active);
 `, [Y("a", `
 color: var(--n-item-text-color-child-active);
 `), q("extra", `
 color: var(--n-item-text-color-child-active);
 `)]), q("arrow", `
 color: var(--n-arrow-color-child-active);
 `), q("icon", `
 color: var(--n-item-icon-color-child-active);
 `)]), wr("disabled", [wr("selected, child-active", [Y("&:focus-within", DR)]), K("selected", [bf(null, [q("arrow", "color: var(--n-arrow-color-active-hover);"), q("icon", "color: var(--n-item-icon-color-active-hover);"), L("menu-item-content-header", `
 color: var(--n-item-text-color-active-hover);
 `, [Y("a", "color: var(--n-item-text-color-active-hover);"), q("extra", "color: var(--n-item-text-color-active-hover);")])])]), K("child-active", [bf(null, [q("arrow", "color: var(--n-arrow-color-child-active-hover);"), q("icon", "color: var(--n-item-icon-color-child-active-hover);"), L("menu-item-content-header", `
 color: var(--n-item-text-color-child-active-hover);
 `, [Y("a", "color: var(--n-item-text-color-child-active-hover);"), q("extra", "color: var(--n-item-text-color-child-active-hover);")])])]), K("selected", [bf(null, [Y("&::before", "background-color: var(--n-item-color-active-hover);")])]), bf(null, DR)]), q("icon", `
 grid-area: icon;
 color: var(--n-item-icon-color);
 transition:
 color .3s var(--n-bezier),
 font-size .3s var(--n-bezier),
 margin-right .3s var(--n-bezier);
 box-sizing: content-box;
 display: inline-flex;
 align-items: center;
 justify-content: center;
 `), q("arrow", `
 grid-area: arrow;
 font-size: 16px;
 color: var(--n-arrow-color);
 transform: rotate(180deg);
 opacity: 1;
 transition:
 color .3s var(--n-bezier),
 transform 0.2s var(--n-bezier),
 opacity 0.2s var(--n-bezier);
 `), L("menu-item-content-header", `
 grid-area: content;
 transition:
 color .3s var(--n-bezier),
 opacity .3s var(--n-bezier);
 opacity: 1;
 white-space: nowrap;
 overflow: hidden;
 text-overflow: ellipsis;
 color: var(--n-item-text-color);
 `, [Y("a", `
 outline: none;
 text-decoration: none;
 transition: color .3s var(--n-bezier);
 color: var(--n-item-text-color);
 `, [Y("&::before", `
 content: "";
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `)]), q("extra", `
 font-size: .93em;
 color: var(--n-group-text-color);
 transition: color .3s var(--n-bezier);
 `)])]), L("submenu", `
 cursor: pointer;
 position: relative;
 margin-top: 6px;
 `, [L("menu-item-content", `
 height: var(--n-item-height);
 `), L("submenu-children", `
 overflow: hidden;
 padding: 0;
 `, [D0({
  duration: ".2s"
})])]), L("menu-item-group", [L("menu-item-group-title", `
 margin-top: 6px;
 color: var(--n-group-text-color);
 cursor: default;
 font-size: .93em;
 height: 36px;
 display: flex;
 align-items: center;
 transition:
 padding-left .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `)])]), L("menu-tooltip", [Y("a", `
 color: inherit;
 text-decoration: none;
 `)]), L("menu-divider", `
 transition: background-color .3s var(--n-bezier);
 background-color: var(--n-divider-color);
 height: 1px;
 margin: 6px 18px;
 `)]);
function bf(e, t) {
  return [K("hover", e, t), Y("&:hover", e, t)];
}
const lxe = Object.assign(Object.assign({}, ft.props), {
  options: {
    type: Array,
    default: () => []
  },
  collapsed: {
    type: Boolean,
    default: void 0
  },
  collapsedWidth: {
    type: Number,
    default: 48
  },
  iconSize: {
    type: Number,
    default: 20
  },
  collapsedIconSize: {
    type: Number,
    default: 24
  },
  rootIndent: Number,
  indent: {
    type: Number,
    default: 32
  },
  labelField: {
    type: String,
    default: "label"
  },
  keyField: {
    type: String,
    default: "key"
  },
  childrenField: {
    type: String,
    default: "children"
  },
  disabledField: {
    type: String,
    default: "disabled"
  },
  defaultExpandAll: Boolean,
  defaultExpandedKeys: Array,
  expandedKeys: Array,
  value: [String, Number],
  defaultValue: {
    type: [String, Number],
    default: null
  },
  mode: {
    type: String,
    default: "vertical"
  },
  watchProps: {
    type: Array,
    default: void 0
  },
  disabled: Boolean,
  show: {
    type: Boolean,
    default: !0
  },
  inverted: Boolean,
  "onUpdate:expandedKeys": [Function, Array],
  onUpdateExpandedKeys: [Function, Array],
  onUpdateValue: [Function, Array],
  "onUpdate:value": [Function, Array],
  expandIcon: Function,
  renderIcon: Function,
  renderLabel: Function,
  renderExtra: Function,
  dropdownProps: Object,
  accordion: Boolean,
  nodeProps: Function,
  items: Array,
  onOpenNamesChange: [Function, Array],
  onSelect: [Function, Array],
  onExpandedNamesChange: [Function, Array],
  expandedNames: Array,
  defaultExpandedNames: Array,
  dropdownPlacement: {
    type: String,
    default: "bottom"
  }
});
var sxe = oe({
  name: "Menu",
  props: lxe,
  setup(e) {
    const { mergedClsPrefixRef: t, inlineThemeDisabled: r } = Yt(e), n = ft("Menu", "-menu", axe, h1e, e, t), i = lt(K1e, null), o = j(() => {
      var N;
      const { collapsed: I } = e;
      if (I !== void 0)
        return I;
      if (i) {
        const { collapseModeRef: $, collapsedRef: _ } = i;
        if ($.value === "width")
          return (N = _.value) !== null && N !== void 0 ? N : !1;
      }
      return !1;
    }), a = j(() => {
      const { keyField: N, childrenField: I, disabledField: $ } = e;
      return Mb(e.items || e.options, {
        getIgnored(_) {
          return OW(_);
        },
        getChildren(_) {
          return _[I];
        },
        getDisabled(_) {
          return _[$];
        },
        getKey(_) {
          var R;
          return (R = _[N]) !== null && R !== void 0 ? R : _.name;
        }
      });
    }), s = j(() => new Set(a.value.treeNodes.map((N) => N.key))), { watchProps: u } = e, d = G(null);
    u != null && u.includes("defaultValue") ? On(() => {
      d.value = e.defaultValue;
    }) : d.value = e.defaultValue;
    const f = tt(e, "value"), h = dn(f, d), g = G([]), m = () => {
      g.value = e.defaultExpandAll ? a.value.getNonLeafKeys() : e.defaultExpandedNames || e.defaultExpandedKeys || a.value.getPath(h.value, {
        includeSelf: !1
      }).keyPath;
    };
    u != null && u.includes("defaultExpandedKeys") ? On(m) : m();
    const v = pp(e, [
      "expandedNames",
      "expandedKeys"
    ]), w = dn(v, g), x = j(() => a.value.treeNodes), y = j(() => a.value.getPath(h.value).keyPath);
    tr(kb, {
      props: e,
      mergedCollapsedRef: o,
      mergedThemeRef: n,
      mergedValueRef: h,
      mergedExpandedKeysRef: w,
      activePathRef: y,
      mergedClsPrefixRef: t,
      isHorizontalRef: j(() => e.mode === "horizontal"),
      invertedRef: tt(e, "inverted"),
      doSelect: C,
      toggleExpand: T
    });
    function C(N, I) {
      const { "onUpdate:value": $, onUpdateValue: _, onSelect: R } = e;
      _ && je(_, N, I), $ && je($, N, I), R && je(R, N, I), d.value = N;
    }
    function S(N) {
      const { "onUpdate:expandedKeys": I, onUpdateExpandedKeys: $, onExpandedNamesChange: _, onOpenNamesChange: R } = e;
      I && je(I, N), $ && je($, N), _ && je(_, N), R && je(R, N), g.value = N;
    }
    function T(N) {
      const I = Array.from(w.value), $ = I.findIndex((_) => _ === N);
      if (~$)
        I.splice($, 1);
      else {
        if (e.accordion && s.value.has(N)) {
          const _ = I.findIndex((R) => s.value.has(R));
          _ > -1 && I.splice(_, 1);
        }
        I.push(N);
      }
      S(I);
    }
    const A = (N) => {
      const I = a.value.getPath(N ?? h.value, {
        includeSelf: !1
      }).keyPath;
      if (!I.length)
        return;
      const $ = Array.from(w.value), _ = /* @__PURE__ */ new Set([
        ...$,
        ...I
      ]);
      e.accordion && s.value.forEach((R) => {
        _.has(R) && !I.includes(R) && _.delete(R);
      }), S(Array.from(_));
    }, D = j(() => {
      const { inverted: N } = e, { common: { cubicBezierEaseInOut: I }, self: $ } = n.value, { borderRadius: _, borderColorHorizontal: R, fontSize: U, itemHeight: Q, dividerColor: Z } = $, X = {
        "--n-divider-color": Z,
        "--n-bezier": I,
        "--n-font-size": U,
        "--n-border-color-horizontal": R,
        "--n-border-radius": _,
        "--n-item-height": Q
      };
      return N ? (X["--n-group-text-color"] = $.groupTextColorInverted, X["--n-color"] = $.colorInverted, X["--n-item-text-color"] = $.itemTextColorInverted, X["--n-item-text-color-hover"] = $.itemTextColorHoverInverted, X["--n-item-text-color-active"] = $.itemTextColorActiveInverted, X["--n-item-text-color-child-active"] = $.itemTextColorChildActiveInverted, X["--n-item-text-color-child-active-hover"] = $.itemTextColorChildActiveInverted, X["--n-item-text-color-active-hover"] = $.itemTextColorActiveHoverInverted, X["--n-item-icon-color"] = $.itemIconColorInverted, X["--n-item-icon-color-hover"] = $.itemIconColorHoverInverted, X["--n-item-icon-color-active"] = $.itemIconColorActiveInverted, X["--n-item-icon-color-active-hover"] = $.itemIconColorActiveHoverInverted, X["--n-item-icon-color-child-active"] = $.itemIconColorChildActiveInverted, X["--n-item-icon-color-child-active-hover"] = $.itemIconColorChildActiveHoverInverted, X["--n-item-icon-color-collapsed"] = $.itemIconColorCollapsedInverted, X["--n-item-text-color-horizontal"] = $.itemTextColorHorizontalInverted, X["--n-item-text-color-hover-horizontal"] = $.itemTextColorHoverHorizontalInverted, X["--n-item-text-color-active-horizontal"] = $.itemTextColorActiveHorizontalInverted, X["--n-item-text-color-child-active-horizontal"] = $.itemTextColorChildActiveHorizontalInverted, X["--n-item-text-color-child-active-hover-horizontal"] = $.itemTextColorChildActiveHoverHorizontalInverted, X["--n-item-text-color-active-hover-horizontal"] = $.itemTextColorActiveHoverHorizontalInverted, X["--n-item-icon-color-horizontal"] = $.itemIconColorHorizontalInverted, X["--n-item-icon-color-hover-horizontal"] = $.itemIconColorHoverHorizontalInverted, X["--n-item-icon-color-active-horizontal"] = $.itemIconColorActiveHorizontalInverted, X["--n-item-icon-color-active-hover-horizontal"] = $.itemIconColorActiveHoverHorizontalInverted, X["--n-item-icon-color-child-active-horizontal"] = $.itemIconColorChildActiveHorizontalInverted, X["--n-item-icon-color-child-active-hover-horizontal"] = $.itemIconColorChildActiveHoverHorizontalInverted, X["--n-arrow-color"] = $.arrowColorInverted, X["--n-arrow-color-hover"] = $.arrowColorHoverInverted, X["--n-arrow-color-active"] = $.arrowColorActiveInverted, X["--n-arrow-color-active-hover"] = $.arrowColorActiveHoverInverted, X["--n-arrow-color-child-active"] = $.arrowColorChildActiveInverted, X["--n-arrow-color-child-active-hover"] = $.arrowColorChildActiveHoverInverted, X["--n-item-color-hover"] = $.itemColorHoverInverted, X["--n-item-color-active"] = $.itemColorActiveInverted, X["--n-item-color-active-hover"] = $.itemColorActiveHoverInverted, X["--n-item-color-active-collapsed"] = $.itemColorActiveCollapsedInverted) : (X["--n-group-text-color"] = $.groupTextColor, X["--n-color"] = $.color, X["--n-item-text-color"] = $.itemTextColor, X["--n-item-text-color-hover"] = $.itemTextColorHover, X["--n-item-text-color-active"] = $.itemTextColorActive, X["--n-item-text-color-child-active"] = $.itemTextColorChildActive, X["--n-item-text-color-child-active-hover"] = $.itemTextColorChildActiveHover, X["--n-item-text-color-active-hover"] = $.itemTextColorActiveHover, X["--n-item-icon-color"] = $.itemIconColor, X["--n-item-icon-color-hover"] = $.itemIconColorHover, X["--n-item-icon-color-active"] = $.itemIconColorActive, X["--n-item-icon-color-active-hover"] = $.itemIconColorActiveHover, X["--n-item-icon-color-child-active"] = $.itemIconColorChildActive, X["--n-item-icon-color-child-active-hover"] = $.itemIconColorChildActiveHover, X["--n-item-icon-color-collapsed"] = $.itemIconColorCollapsed, X["--n-item-text-color-horizontal"] = $.itemTextColorHorizontal, X["--n-item-text-color-hover-horizontal"] = $.itemTextColorHoverHorizontal, X["--n-item-text-color-active-horizontal"] = $.itemTextColorActiveHorizontal, X["--n-item-text-color-child-active-horizontal"] = $.itemTextColorChildActiveHorizontal, X["--n-item-text-color-child-active-hover-horizontal"] = $.itemTextColorChildActiveHoverHorizontal, X["--n-item-text-color-active-hover-horizontal"] = $.itemTextColorActiveHoverHorizontal, X["--n-item-icon-color-horizontal"] = $.itemIconColorHorizontal, X["--n-item-icon-color-hover-horizontal"] = $.itemIconColorHoverHorizontal, X["--n-item-icon-color-active-horizontal"] = $.itemIconColorActiveHorizontal, X["--n-item-icon-color-active-hover-horizontal"] = $.itemIconColorActiveHoverHorizontal, X["--n-item-icon-color-child-active-horizontal"] = $.itemIconColorChildActiveHorizontal, X["--n-item-icon-color-child-active-hover-horizontal"] = $.itemIconColorChildActiveHoverHorizontal, X["--n-arrow-color"] = $.arrowColor, X["--n-arrow-color-hover"] = $.arrowColorHover, X["--n-arrow-color-active"] = $.arrowColorActive, X["--n-arrow-color-active-hover"] = $.arrowColorActiveHover, X["--n-arrow-color-child-active"] = $.arrowColorChildActive, X["--n-arrow-color-child-active-hover"] = $.arrowColorChildActiveHover, X["--n-item-color-hover"] = $.itemColorHover, X["--n-item-color-active"] = $.itemColorActive, X["--n-item-color-active-hover"] = $.itemColorActiveHover, X["--n-item-color-active-collapsed"] = $.itemColorActiveCollapsed), X;
    }), E = r ? Cr("menu", j(() => e.inverted ? "a" : "b"), D, e) : void 0;
    return {
      mergedClsPrefix: t,
      controlledExpandedKeys: v,
      uncontrolledExpanededKeys: g,
      mergedExpandedKeys: w,
      uncontrolledValue: d,
      mergedValue: h,
      activePath: y,
      tmNodes: x,
      mergedTheme: n,
      mergedCollapsed: o,
      cssVars: r ? void 0 : D,
      themeClass: E == null ? void 0 : E.themeClass,
      onRender: E == null ? void 0 : E.onRender,
      showOption: A
    };
  },
  render() {
    const { mergedClsPrefix: e, mode: t, themeClass: r, onRender: n } = this;
    return n == null || n(), b("div", { role: t === "horizontal" ? "menubar" : "menu", class: [
      `${e}-menu`,
      r,
      `${e}-menu--${t}`,
      this.mergedCollapsed && `${e}-menu--collapsed`
    ], style: this.cssVars }, this.tmNodes.map((i) => Q4(i, this.$props)));
  }
});
const GM = "n-notification-provider", uxe = oe({
  name: "NotificationContainer",
  props: {
    scrollable: {
      type: Boolean,
      required: !0
    },
    placement: {
      type: String,
      required: !0
    }
  },
  setup() {
    const { mergedThemeRef: e, mergedClsPrefixRef: t, wipTransitionCountRef: r } = lt(GM), n = G(null);
    return On(() => {
      var i, o;
      r.value > 0 ? (i = n == null ? void 0 : n.value) === null || i === void 0 || i.classList.add("transitioning") : (o = n == null ? void 0 : n.value) === null || o === void 0 || o.classList.remove("transitioning");
    }), {
      selfRef: n,
      mergedTheme: e,
      mergedClsPrefix: t,
      transitioning: r
    };
  },
  render() {
    const { $slots: e, scrollable: t, mergedClsPrefix: r, mergedTheme: n, placement: i } = this;
    return b("div", { ref: "selfRef", class: [
      `${r}-notification-container`,
      t && `${r}-notification-container--scrollable`,
      `${r}-notification-container--${i}`
    ] }, t ? b(no, { theme: n.peers.Scrollbar, themeOverrides: n.peerOverrides.Scrollbar, contentStyle: { overflow: "hidden" } }, e) : e);
  }
}), cxe = {
  info: () => b(vp, null),
  success: () => b(xb, null),
  warning: () => b(wb, null),
  error: () => b(yb, null),
  default: () => null
}, q4 = {
  closable: {
    type: Boolean,
    default: !0
  },
  type: {
    type: String,
    default: "default"
  },
  avatar: Function,
  title: [String, Function],
  description: [String, Function],
  content: [String, Function],
  meta: [String, Function],
  action: [String, Function],
  onClose: {
    type: Function,
    required: !0
  },
  keepAliveOnHover: Boolean,
  onMouseenter: Function,
  onMouseleave: Function
}, dxe = Ts(q4), fxe = oe({
  name: "Notification",
  props: q4,
  setup(e) {
    const {
      mergedClsPrefixRef: t,
      mergedThemeRef: r,
      props: n
    } = lt(GM), { inlineThemeDisabled: i, mergedRtlRef: o } = Yt(), a = Li("Notification", o, t), s = j(() => {
      const { type: d } = e, { self: { color: f, textColor: h, closeIconColor: g, closeIconColorHover: m, closeIconColorPressed: v, headerTextColor: w, descriptionTextColor: x, actionTextColor: y, borderRadius: C, headerFontWeight: S, boxShadow: T, lineHeight: A, fontSize: D, closeMargin: E, closeSize: N, width: I, padding: $, closeIconSize: _, closeBorderRadius: R, closeColorHover: U, closeColorPressed: Q, titleFontSize: Z, metaFontSize: X, descriptionFontSize: re, [Be("iconColor", d)]: ue }, common: { cubicBezierEaseOut: he, cubicBezierEaseIn: te, cubicBezierEaseInOut: de } } = r.value, { left: De, right: Oe, top: Qe, bottom: Ae } = Ll($);
      return {
        "--n-color": f,
        "--n-font-size": D,
        "--n-text-color": h,
        "--n-description-text-color": x,
        "--n-action-text-color": y,
        "--n-title-text-color": w,
        "--n-title-font-weight": S,
        "--n-bezier": de,
        "--n-bezier-ease-out": he,
        "--n-bezier-ease-in": te,
        "--n-border-radius": C,
        "--n-box-shadow": T,
        "--n-close-border-radius": R,
        "--n-close-color-hover": U,
        "--n-close-color-pressed": Q,
        "--n-close-icon-color": g,
        "--n-close-icon-color-hover": m,
        "--n-close-icon-color-pressed": v,
        "--n-line-height": A,
        "--n-icon-color": ue,
        "--n-close-margin": E,
        "--n-close-size": N,
        "--n-close-icon-size": _,
        "--n-width": I,
        "--n-padding-left": De,
        "--n-padding-right": Oe,
        "--n-padding-top": Qe,
        "--n-padding-bottom": Ae,
        "--n-title-font-size": Z,
        "--n-meta-font-size": X,
        "--n-description-font-size": re
      };
    }), u = i ? Cr("notification", j(() => e.type[0]), s, n) : void 0;
    return {
      mergedClsPrefix: t,
      showAvatar: j(() => e.avatar || e.type !== "default"),
      handleCloseClick() {
        e.onClose();
      },
      rtlEnabled: a,
      cssVars: i ? void 0 : s,
      themeClass: u == null ? void 0 : u.themeClass,
      onRender: u == null ? void 0 : u.onRender
    };
  },
  render() {
    var e;
    const { mergedClsPrefix: t } = this;
    return (e = this.onRender) === null || e === void 0 || e.call(this), b("div", { class: [`${t}-notification-wrapper`, this.themeClass], onMouseenter: this.onMouseenter, onMouseleave: this.onMouseleave, style: this.cssVars }, b("div", { class: [
      `${t}-notification`,
      this.rtlEnabled && `${t}-notification--rtl`,
      this.themeClass,
      {
        [`${t}-notification--closable`]: this.closable,
        [`${t}-notification--show-avatar`]: this.showAvatar
      }
    ], style: this.cssVars }, this.showAvatar ? b("div", { class: `${t}-notification__avatar` }, this.avatar ? xn(this.avatar) : this.type !== "default" ? b(fr, { clsPrefix: t }, { default: () => cxe[this.type]() }) : null) : null, this.closable ? b(gh, { clsPrefix: t, class: `${t}-notification__close`, onClick: this.handleCloseClick }) : null, b("div", { ref: "bodyRef", class: `${t}-notification-main` }, this.title ? b("div", { class: `${t}-notification-main__header` }, xn(this.title)) : null, this.description ? b("div", { class: `${t}-notification-main__description` }, xn(this.description)) : null, this.content ? b("pre", { class: `${t}-notification-main__content` }, xn(this.content)) : null, this.meta || this.action ? b("div", { class: `${t}-notification-main-footer` }, this.meta ? b("div", { class: `${t}-notification-main-footer__meta` }, xn(this.meta)) : null, this.action ? b("div", { class: `${t}-notification-main-footer__action` }, xn(this.action)) : null) : null)));
  }
}), hxe = Object.assign(Object.assign({}, q4), {
  duration: Number,
  onClose: Function,
  onLeave: Function,
  onAfterEnter: Function,
  onAfterLeave: Function,
  onHide: Function,
  onAfterShow: Function,
  onAfterHide: Function
}), pxe = oe({
  name: "NotificationEnvironment",
  props: Object.assign(Object.assign({}, hxe), {
    internalKey: {
      type: String,
      required: !0
    },
    onInternalAfterLeave: {
      type: Function,
      required: !0
    }
  }),
  setup(e) {
    const {
      wipTransitionCountRef: t
    } = lt(GM), r = G(!0);
    let n = null;
    function i() {
      r.value = !1, n && window.clearTimeout(n);
    }
    function o(v) {
      t.value++, an(() => {
        v.style.height = `${v.offsetHeight}px`, v.style.maxHeight = "0", v.style.transition = "none", v.offsetHeight, v.style.transition = "", v.style.maxHeight = v.style.height;
      });
    }
    function a(v) {
      t.value--, v.style.height = "", v.style.maxHeight = "";
      const { onAfterEnter: w, onAfterShow: x } = e;
      w && w(), x && x();
    }
    function s(v) {
      t.value++, v.style.maxHeight = `${v.offsetHeight}px`, v.style.height = `${v.offsetHeight}px`, v.offsetHeight;
    }
    function u(v) {
      const { onHide: w } = e;
      w && w(), v.style.maxHeight = "0", v.offsetHeight;
    }
    function d() {
      t.value--;
      const { onAfterLeave: v, onInternalAfterLeave: w, onAfterHide: x, internalKey: y } = e;
      v && v(), w(y), x && x();
    }
    function f() {
      const { duration: v } = e;
      v && (n = window.setTimeout(i, v));
    }
    function h(v) {
      v.currentTarget === v.target && n !== null && (window.clearTimeout(n), n = null);
    }
    function g(v) {
      v.currentTarget === v.target && f();
    }
    function m() {
      const { onClose: v } = e;
      v ? Promise.resolve(v()).then((w) => {
        w !== !1 && i();
      }) : i();
    }
    return br(() => {
      e.duration && (n = window.setTimeout(i, e.duration));
    }), {
      show: r,
      hide: i,
      handleClose: m,
      handleAfterLeave: d,
      handleLeave: u,
      handleBeforeLeave: s,
      handleAfterEnter: a,
      handleBeforeEnter: o,
      handleMouseenter: h,
      handleMouseleave: g
    };
  },
  render() {
    return b(jn, {
      name: "notification-transition",
      appear: !0,
      onBeforeEnter: this.handleBeforeEnter,
      onAfterEnter: this.handleAfterEnter,
      onBeforeLeave: this.handleBeforeLeave,
      onLeave: this.handleLeave,
      onAfterLeave: this.handleAfterLeave
    }, {
      default: () => this.show ? b(fxe, Object.assign({}, il(this.$props, dxe), { onClose: this.handleClose, onMouseenter: this.duration && this.keepAliveOnHover ? this.handleMouseenter : void 0, onMouseleave: this.duration && this.keepAliveOnHover ? this.handleMouseleave : void 0 })) : null
    });
  }
});
var gxe = Y([L("notification-container", `
 z-index: 4000;
 position: fixed;
 overflow: visible;
 display: flex;
 flex-direction: column;
 align-items: flex-end;
 `, [Y(">", [L("scrollbar", `
 width: initial;
 overflow: visible;
 height: -moz-fit-content !important;
 height: fit-content !important;
 max-height: 100vh !important;
 `, [Y(">", [L("scrollbar-container", `
 height: -moz-fit-content !important;
 height: fit-content !important;
 max-height: 100vh !important;
 `, [L("scrollbar-content", `
 padding-top: 12px;
 padding-bottom: 33px;
 `)])])])]), K("top, top-right, top-left", `
 top: 12px;
 `, [Y("&.transitioning >", [L("scrollbar", [Y(">", [L("scrollbar-container", `
 min-height: 100vh !important;
 `)])])])]), K("bottom, bottom-right, bottom-left", `
 bottom: 12px;
 `, [Y(">", [L("scrollbar", [Y(">", [L("scrollbar-container", [L("scrollbar-content", `
 padding-bottom: 12px;
 `)])])])]), L("notification-wrapper", `
 display: flex;
 align-items: flex-end;
 margin-bottom: 0;
 margin-top: 12px;
 `)]), K("top, bottom", `
 left: 50%;
 transform: translateX(-50%);
 `, [L("notification-wrapper", [Y("&.notification-transition-enter-from, &.notification-transition-leave-to", `
 transform: scale(0.85);
 `), Y("&.notification-transition-leave-from, &.notification-transition-enter-to", `
 transform: scale(1);
 `)])]), K("top", [L("notification-wrapper", `
 transform-origin: top center;
 `)]), K("bottom", [L("notification-wrapper", `
 transform-origin: bottom center;
 `)]), K("top-right, bottom-right", [L("notification", `
 margin-left: 28px;
 margin-right: 16px;
 `)]), K("top-left, bottom-left", [L("notification", `
 margin-left: 16px;
 margin-right: 28px;
 `)]), K("top-right", `
 right: 0;
 `, [vy("top-right")]), K("top-left", `
 left: 0;
 `, [vy("top-left")]), K("bottom-right", `
 right: 0;
 `, [vy("bottom-right")]), K("bottom-left", `
 left: 0;
 `, [vy("bottom-left")]), K("scrollable", [K("top-right", `
 top: 0;
 `), K("top-left", `
 top: 0;
 `), K("bottom-right", `
 bottom: 0;
 `), K("bottom-left", `
 bottom: 0;
 `)]), L("notification-wrapper", `
 margin-bottom: 12px;
 `, [Y("&.notification-transition-enter-from, &.notification-transition-leave-to", `
 opacity: 0;
 margin-top: 0 !important;
 margin-bottom: 0 !important;
 `), Y("&.notification-transition-leave-from, &.notification-transition-enter-to", `
 opacity: 1;
 `), Y("&.notification-transition-leave-active", `
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 transform .3s var(--n-bezier-ease-in),
 max-height .3s var(--n-bezier),
 margin-top .3s linear,
 margin-bottom .3s linear,
 box-shadow .3s var(--n-bezier);
 `), Y("&.notification-transition-enter-active", `
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 transform .3s var(--n-bezier-ease-out),
 max-height .3s var(--n-bezier),
 margin-top .3s linear,
 margin-bottom .3s linear,
 box-shadow .3s var(--n-bezier);
 `)]), L("notification", `
 background-color: var(--n-color);
 color: var(--n-text-color);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 font-family: inherit;
 font-size: var(--n-font-size);
 font-weight: 400;
 position: relative;
 display: flex;
 overflow: hidden;
 flex-shrink: 0;
 padding-left: var(--n-padding-left);
 padding-right: var(--n-padding-right);
 width: var(--n-width);
 border-radius: var(--n-border-radius);
 box-shadow: var(--n-box-shadow);
 box-sizing: border-box;
 opacity: 1;
 `, [q("avatar", [L("icon", {
  color: "var(--n-icon-color)"
}), L("base-icon", {
  color: "var(--n-icon-color)"
})]), K("show-avatar", [L("notification-main", `
 margin-left: 40px;
 width: calc(100% - 40px); 
 `)]), K("closable", [L("notification-main", [Y("> *:first-child", {
  paddingRight: "20px"
})]), q("close", `
 position: absolute;
 top: 0;
 right: 0;
 margin: var(--n-close-margin);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `)]), q("avatar", `
 position: absolute;
 top: var(--n-padding-top);
 left: var(--n-padding-left);
 width: 28px;
 height: 28px;
 font-size: 28px;
 display: flex;
 align-items: center;
 justify-content: center;
 `, [L("icon", "transition: color .3s var(--n-bezier);")]), L("notification-main", `
 padding-top: var(--n-padding-top);
 padding-bottom: var(--n-padding-bottom);
 box-sizing: border-box;
 display: flex;
 flex-direction: column;
 margin-left: 8px;
 width: calc(100% - 8px);
 `, [L("notification-main-footer", `
 display: flex;
 align-items: center;
 justify-content: space-between;
 margin-top: 12px;
 `, [q("meta", `
 font-size: var(--n-meta-font-size);
 transition: color .3s var(--n-bezier-ease-out);
 color: var(--n-description-text-color);
 `), q("action", `
 cursor: pointer;
 transition: color .3s var(--n-bezier-ease-out);
 color: var(--n-action-text-color);
 `)]), q("header", `
 font-weight: var(--n-title-font-weight);
 font-size: var(--n-title-font-size);
 transition: color .3s var(--n-bezier-ease-out);
 color: var(--n-title-text-color);
 `), q("description", `
 margin-top: 8px;
 font-size: var(--n-description-font-size);
 white-space: pre-wrap;
 word-wrap: break-word;
 transition: color .3s var(--n-bezier-ease-out);
 color: var(--n-description-text-color);
 `), q("content", `
 line-height: var(--n-line-height);
 margin: 12px 0 0 0;
 font-family: inherit;
 white-space: pre-wrap;
 word-wrap: break-word;
 transition: color .3s var(--n-bezier-ease-out);
 color: var(--n-text-color);
 `, [Y("&:first-child", {
  margin: 0
})])])])])]);
function vy(e) {
  const r = e.split("-")[1] === "left" ? "calc(-100%)" : "calc(100%)", n = "0";
  return L("notification-wrapper", [Y("&.notification-transition-enter-from, &.notification-transition-leave-to", `
 transform: translate(${r}, 0);
 `), Y("&.notification-transition-leave-from, &.notification-transition-enter-to", `
 transform: translate(${n}, 0);
 `)]);
}
const mxe = "n-notification-api", vxe = Object.assign(Object.assign({}, ft.props), { containerStyle: [String, Object], to: [String, Object], scrollable: {
  type: Boolean,
  default: !0
}, max: Number, placement: {
  type: String,
  default: "top-right"
}, keepAliveOnHover: Boolean });
var bxe = oe({
  name: "NotificationProvider",
  props: vxe,
  setup(e) {
    const { mergedClsPrefixRef: t } = Yt(e), r = G([]), n = {}, i = /* @__PURE__ */ new Set();
    function o(m) {
      const v = Ss(), w = () => {
        i.add(v), n[v] && n[v].hide();
      }, x = UO(Object.assign(Object.assign({}, m), {
        key: v,
        destroy: w,
        hide: w,
        deactivate: w
      })), { max: y } = e;
      if (y && r.value.length - i.size >= y) {
        let C = !1, S = 0;
        for (const T of r.value) {
          if (!i.has(T.key)) {
            n[T.key] && (T.destroy(), C = !0);
            break;
          }
          S++;
        }
        C || r.value.splice(S, 1);
      }
      return r.value.push(x), x;
    }
    const a = ["info", "success", "warning", "error"].map((m) => (v) => o(Object.assign(Object.assign({}, v), { type: m })));
    function s(m) {
      i.delete(m), r.value.splice(r.value.findIndex((v) => v.key === m), 1);
    }
    const u = ft("Notification", "-notification", gxe, a1e, e, t), d = {
      create: o,
      info: a[0],
      success: a[1],
      warning: a[2],
      error: a[3],
      open: h,
      destroyAll: g
    }, f = G(0);
    tr(mxe, d), tr(GM, {
      props: e,
      mergedClsPrefixRef: t,
      mergedThemeRef: u,
      wipTransitionCountRef: f
    });
    function h(m) {
      return o(m);
    }
    function g() {
      Object.values(r.value).forEach((m) => {
        m.hide();
      });
    }
    return Object.assign({
      mergedClsPrefix: t,
      notificationList: r,
      notificationRefs: n,
      handleAfterLeave: s
    }, d);
  },
  render() {
    var e, t, r;
    const { placement: n } = this;
    return b(Lr, null, (t = (e = this.$slots).default) === null || t === void 0 ? void 0 : t.call(e), this.notificationList.length ? b(AM, { to: (r = this.to) !== null && r !== void 0 ? r : "body" }, b(uxe, { style: this.containerStyle, scrollable: this.scrollable && n !== "top" && n !== "bottom", placement: n }, {
      default: () => this.notificationList.map((i) => b(pxe, Object.assign({ ref: (o) => {
        const a = i.key;
        o === null ? delete this.notificationRefs[a] : this.notificationRefs[a] = o;
      } }, IM(i, [
        "destroy",
        "hide",
        "deactivate"
      ]), { internalKey: i.key, onInternalAfterLeave: this.handleAfterLeave, keepAliveOnHover: i.keepAliveOnHover === void 0 ? this.keepAliveOnHover : i.keepAliveOnHover })))
    })) : null);
  }
}), yxe = Y([L("progress", {
  display: "inline-block"
}, [L("progress-icon", `
 color: var(--n-icon-color);
 transition: color .3s var(--n-bezier);
 `), K("line", `
 width: 100%;
 display: block;
 `, [L("progress-content", `
 display: flex;
 align-items: center;
 `, [L("progress-graph", {
  flex: 1
})]), L("progress-custom-content", {
  marginLeft: "14px"
}), L("progress-icon", `
 width: 30px;
 padding-left: 14px;
 height: var(--n-icon-size-line);
 line-height: var(--n-icon-size-line);
 font-size: var(--n-icon-size-line);
 `, [K("as-text", `
 color: var(--n-text-color-line-outer);
 text-align: center;
 width: 40px;
 font-size: var(--n-font-size);
 padding-left: 4px;
 transition: color .3s var(--n-bezier);
 `)])]), K("circle, dashboard", {
  width: "120px"
}, [L("progress-custom-content", `
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 display: flex;
 align-items: center;
 justify-content: center;
 `), L("progress-text", `
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 display: flex;
 align-items: center;
 color: inherit;
 font-size: var(--n-font-size-circle);
 color: var(--n-text-color-circle);
 font-weight: var(--n-font-weight-circle);
 transition: color .3s var(--n-bezier);
 white-space: nowrap;
 `), L("progress-icon", `
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 display: flex;
 align-items: center;
 color: var(--n-icon-color);
 font-size: var(--n-icon-size-circle);
 `)]), K("multiple-circle", `
 width: 200px;
 color: inherit;
 `, [L("progress-text", `
 font-weight: var(--n-font-weight-circle);
 color: var(--n-text-color-circle);
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 display: flex;
 align-items: center;
 justify-content: center;
 transition: color .3s var(--n-bezier);
 `)]), L("progress-content", {
  position: "relative"
}), L("progress-graph", {
  position: "relative"
}, [L("progress-graph-circle", [Y("svg", {
  verticalAlign: "bottom"
}), L("progress-graph-circle-fill", `
 stroke: var(--n-fill-color);
 transition:
 opacity .3s var(--n-bezier),
 stroke .3s var(--n-bezier),
 stroke-dasharray .3s var(--n-bezier);
 `, [K("empty", {
  opacity: 0
})]), L("progress-graph-circle-rail", `
 transition: stroke .3s var(--n-bezier);
 overflow: hidden;
 stroke: var(--n-rail-color);
 `)]), L("progress-graph-line", [K("indicator-inside", [L("progress-graph-line-rail", `
 height: 16px;
 line-height: 16px;
 border-radius: 10px;
 `, [L("progress-graph-line-fill", `
 height: inherit;
 border-radius: 10px;
 `), L("progress-graph-line-indicator", `
 background: #0000;
 white-space: nowrap;
 text-align: right;
 margin-left: 14px;
 margin-right: 14px;
 height: inherit;
 font-size: 12px;
 color: var(--n-text-color-line-inner);
 transition: color .3s var(--n-bezier);
 `)])]), K("indicator-inside-label", `
 height: 16px;
 display: flex;
 align-items: center;
 `, [L("progress-graph-line-rail", `
 flex: 1;
 transition: background-color .3s var(--n-bezier);
 `), L("progress-graph-line-indicator", `
 background: var(--n-fill-color);
 font-size: 12px;
 transform: translateZ(0);
 display: flex;
 vertical-align: middle;
 height: 16px;
 line-height: 16px;
 padding: 0 10px;
 border-radius: 10px;
 position: absolute;
 white-space: nowrap;
 color: var(--n-text-color-line-inner);
 transition:
 right .2s var(--n-bezier),
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 `)]), L("progress-graph-line-rail", `
 position: relative;
 overflow: hidden;
 height: var(--n-rail-height);
 border-radius: 5px;
 background-color: var(--n-rail-color);
 transition: background-color .3s var(--n-bezier);
 `, [L("progress-graph-line-fill", `
 background: var(--n-fill-color);
 position: relative;
 border-radius: 5px;
 height: inherit;
 width: 100%;
 max-width: 0%;
 transition:
 background-color .3s var(--n-bezier),
 max-width .2s var(--n-bezier);
 `, [K("processing", [Y("&::after", `
 content: "";
 background-image: var(--n-line-bg-processing);
 animation: progress-processing-animation 2s var(--n-bezier) infinite;
 `)])])])])])]), Y("@keyframes progress-processing-animation", `
 0% {
 position: absolute;
 left: 0;
 top: 0;
 bottom: 0;
 right: 100%;
 opacity: 1;
 }
 66% {
 position: absolute;
 left: 0;
 top: 0;
 bottom: 0;
 right: 0;
 opacity: 0;
 }
 100% {
 position: absolute;
 left: 0;
 top: 0;
 bottom: 0;
 right: 0;
 opacity: 0;
 }
 `)]);
const xxe = {
  success: b(xb, null),
  error: b(yb, null),
  warning: b(wb, null),
  info: b(vp, null)
};
var wxe = oe({
  name: "ProgressLine",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    percentage: {
      type: Number,
      default: 0
    },
    railColor: String,
    railStyle: [String, Object],
    fillColor: String,
    status: {
      type: String,
      required: !0
    },
    indicatorPlacement: {
      type: String,
      required: !0
    },
    indicatorTextColor: String,
    unit: {
      type: String,
      default: "%"
    },
    processing: {
      type: Boolean,
      required: !0
    },
    showIndicator: {
      type: Boolean,
      required: !0
    },
    height: [String, Number],
    railBorderRadius: [String, Number],
    fillBorderRadius: [String, Number]
  },
  setup(e, { slots: t }) {
    const r = j(() => Rn(e.height)), n = j(() => e.railBorderRadius !== void 0 ? Rn(e.railBorderRadius) : e.height !== void 0 ? Rn(e.height, { c: 0.5 }) : ""), i = j(() => e.fillBorderRadius !== void 0 ? Rn(e.fillBorderRadius) : e.railBorderRadius !== void 0 ? Rn(e.railBorderRadius) : e.height !== void 0 ? Rn(e.height, { c: 0.5 }) : "");
    return () => {
      const { indicatorPlacement: o, railColor: a, railStyle: s, percentage: u, unit: d, indicatorTextColor: f, status: h, showIndicator: g, fillColor: m, processing: v, clsPrefix: w } = e;
      return b("div", { class: `${w}-progress-content`, role: "none" }, b("div", { class: `${w}-progress-graph`, "aria-hidden": !0 }, b("div", { class: [
        `${w}-progress-graph-line`,
        {
          [`${w}-progress-graph-line--indicator-${o}`]: !0
        }
      ] }, b("div", { class: `${w}-progress-graph-line-rail`, style: [
        {
          backgroundColor: a,
          height: r.value,
          borderRadius: n.value
        },
        s
      ] }, b("div", { class: [
        `${w}-progress-graph-line-fill`,
        v && `${w}-progress-graph-line-fill--processing`
      ], style: {
        maxWidth: `${e.percentage}%`,
        backgroundColor: m,
        height: r.value,
        lineHeight: r.value,
        borderRadius: i.value
      } }, o === "inside" ? b("div", { class: `${w}-progress-graph-line-indicator`, style: {
        color: f
      } }, u, d) : null)))), g && o === "outside" ? b("div", null, t.default ? b("div", { class: `${w}-progress-custom-content`, style: {
        color: f
      }, role: "none" }, t.default()) : h === "default" ? b("div", { role: "none", class: `${w}-progress-icon ${w}-progress-icon--as-text`, style: {
        color: f
      } }, u, d) : b("div", { class: `${w}-progress-icon`, "aria-hidden": !0 }, b(fr, { clsPrefix: w }, { default: () => xxe[h] }))) : null);
    };
  }
});
const Mxe = {
  success: b(xb, null),
  error: b(yb, null),
  warning: b(wb, null),
  info: b(vp, null)
};
var Cxe = oe({
  name: "ProgressCircle",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    status: {
      type: String,
      required: !0
    },
    strokeWidth: {
      type: Number,
      required: !0
    },
    fillColor: String,
    railColor: String,
    railStyle: [String, Object],
    percentage: {
      type: Number,
      default: 0
    },
    offsetDegree: {
      type: Number,
      default: 0
    },
    showIndicator: {
      type: Boolean,
      required: !0
    },
    indicatorTextColor: String,
    unit: String,
    viewBoxWidth: {
      type: Number,
      required: !0
    },
    gapDegree: {
      type: Number,
      required: !0
    },
    gapOffsetDegree: {
      type: Number,
      default: 0
    }
  },
  setup(e, { slots: t }) {
    function r(n, i, o) {
      const { gapDegree: a, viewBoxWidth: s, strokeWidth: u } = e, d = 50, f = 0, h = d, g = 0, m = 2 * d, v = 50 + u / 2, w = `M ${v},${v} m ${f},${h}
      a ${d},${d} 0 1 1 ${g},${-m}
      a ${d},${d} 0 1 1 ${-g},${m}`, x = Math.PI * 2 * d, y = {
        stroke: o,
        strokeDasharray: `${n / 100 * (x - a)}px ${s * 8}px`,
        strokeDashoffset: `-${a / 2}px`,
        transformOrigin: i ? "center" : void 0,
        transform: i ? `rotate(${i}deg)` : void 0
      };
      return {
        pathString: w,
        pathStyle: y
      };
    }
    return () => {
      const { fillColor: n, railColor: i, strokeWidth: o, offsetDegree: a, status: s, percentage: u, showIndicator: d, indicatorTextColor: f, unit: h, gapOffsetDegree: g, clsPrefix: m } = e, { pathString: v, pathStyle: w } = r(100, 0, i), { pathString: x, pathStyle: y } = r(u, a, n), C = 100 + o;
      return b("div", { class: `${m}-progress-content`, role: "none" }, b("div", { class: `${m}-progress-graph`, "aria-hidden": !0 }, b("div", { class: `${m}-progress-graph-circle`, style: {
        transform: g ? `rotate(${g}deg)` : void 0
      } }, b("svg", { viewBox: `0 0 ${C} ${C}` }, b("g", null, b("path", { class: `${m}-progress-graph-circle-rail`, d: v, "stroke-width": o, "stroke-linecap": "round", fill: "none", style: w })), b("g", null, b("path", { class: [
        `${m}-progress-graph-circle-fill`,
        u === 0 && `${m}-progress-graph-circle-fill--empty`
      ], d: x, "stroke-width": o, "stroke-linecap": "round", fill: "none", style: y }))))), d ? b("div", null, t.default ? b("div", { class: `${m}-progress-custom-content`, role: "none" }, t.default()) : s !== "default" ? b("div", { class: `${m}-progress-icon`, "aria-hidden": !0 }, b(fr, { clsPrefix: m }, {
        default: () => Mxe[s]
      })) : b("div", { class: `${m}-progress-text`, style: {
        color: f
      }, role: "none" }, b("span", { class: `${m}-progress-text__percentage` }, u), b("span", { class: `${m}-progress-text__unit` }, h))) : null);
    };
  }
});
function ER(e, t, r = 100) {
  return `m ${r / 2} ${r / 2 - e} a ${e} ${e} 0 1 1 0 ${2 * e} a ${e} ${e} 0 1 1 0 -${2 * e}`;
}
var Sxe = oe({
  name: "ProgressMultipleCircle",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    viewBoxWidth: {
      type: Number,
      required: !0
    },
    percentage: {
      type: Array,
      default: [0]
    },
    strokeWidth: {
      type: Number,
      required: !0
    },
    circleGap: {
      type: Number,
      required: !0
    },
    showIndicator: {
      type: Boolean,
      required: !0
    },
    fillColor: {
      type: Array,
      default: () => []
    },
    railColor: {
      type: Array,
      default: () => []
    },
    railStyle: {
      type: Array,
      default: () => []
    }
  },
  setup(e, { slots: t }) {
    const r = j(() => e.percentage.map((i, o) => `${Math.PI * i / 100 * (e.viewBoxWidth / 2 - e.strokeWidth / 2 * (1 + 2 * o) - e.circleGap * o) * 2}, ${e.viewBoxWidth * 8}`));
    return () => {
      const { viewBoxWidth: n, strokeWidth: i, circleGap: o, showIndicator: a, fillColor: s, railColor: u, railStyle: d, percentage: f, clsPrefix: h } = e;
      return b("div", { class: `${h}-progress-content`, role: "none" }, b("div", { class: `${h}-progress-graph`, "aria-hidden": !0 }, b("div", { class: `${h}-progress-graph-circle` }, b("svg", { viewBox: `0 0 ${n} ${n}` }, f.map((g, m) => b("g", { key: m }, b("path", { class: `${h}-progress-graph-circle-rail`, d: ER(n / 2 - i / 2 * (1 + 2 * m) - o * m, i, n), "stroke-width": i, "stroke-linecap": "round", fill: "none", style: [
        {
          strokeDashoffset: 0,
          stroke: u[m]
        },
        d[m]
      ] }), b("path", { class: [
        `${h}-progress-graph-circle-fill`,
        g === 0 && `${h}-progress-graph-circle-fill--empty`
      ], d: ER(n / 2 - i / 2 * (1 + 2 * m) - o * m, i, n), "stroke-width": i, "stroke-linecap": "round", fill: "none", style: {
        strokeDasharray: r.value[m],
        strokeDashoffset: 0,
        stroke: s[m]
      } })))))), a && t.default ? b("div", null, b("div", { class: `${h}-progress-text` }, t.default())) : null);
    };
  }
});
const Txe = Object.assign(Object.assign({}, ft.props), { processing: Boolean, type: {
  type: String,
  default: "line"
}, gapDegree: Number, gapOffsetDegree: Number, status: {
  type: String,
  default: "default"
}, railColor: [String, Array], railStyle: [String, Array], color: [String, Array], viewBoxWidth: {
  type: Number,
  default: 100
}, strokeWidth: {
  type: Number,
  default: 7
}, percentage: [Number, Array], unit: {
  type: String,
  default: "%"
}, showIndicator: {
  type: Boolean,
  default: !0
}, indicatorPosition: {
  type: String,
  default: "outside"
}, indicatorPlacement: {
  type: String,
  default: "outside"
}, indicatorTextColor: String, circleGap: {
  type: Number,
  default: 1
}, height: Number, borderRadius: [String, Number], fillBorderRadius: [String, Number], offsetDegree: Number });
var _W = oe({
  name: "Progress",
  props: Txe,
  setup(e) {
    const t = j(() => e.indicatorPlacement || e.indicatorPosition), r = j(() => {
      if (e.gapDegree || e.gapDegree === 0)
        return e.gapDegree;
      if (e.type === "dashboard")
        return 75;
    }), { mergedClsPrefixRef: n, inlineThemeDisabled: i } = Yt(e), o = ft("Progress", "-progress", yxe, DW, e, n), a = j(() => {
      const { status: u } = e, { common: { cubicBezierEaseInOut: d }, self: { fontSize: f, fontSizeCircle: h, railColor: g, railHeight: m, iconSizeCircle: v, iconSizeLine: w, textColorCircle: x, textColorLineInner: y, textColorLineOuter: C, lineBgProcessing: S, fontWeightCircle: T, [Be("iconColor", u)]: A, [Be("fillColor", u)]: D } } = o.value;
      return {
        "--n-bezier": d,
        "--n-fill-color": D,
        "--n-font-size": f,
        "--n-font-size-circle": h,
        "--n-font-weight-circle": T,
        "--n-icon-color": A,
        "--n-icon-size-circle": v,
        "--n-icon-size-line": w,
        "--n-line-bg-processing": S,
        "--n-rail-color": g,
        "--n-rail-height": m,
        "--n-text-color-circle": x,
        "--n-text-color-line-inner": y,
        "--n-text-color-line-outer": C
      };
    }), s = i ? Cr("progress", j(() => e.status[0]), a, e) : void 0;
    return {
      mergedClsPrefix: n,
      mergedIndicatorPlacement: t,
      gapDeg: r,
      cssVars: i ? void 0 : a,
      themeClass: s == null ? void 0 : s.themeClass,
      onRender: s == null ? void 0 : s.onRender
    };
  },
  render() {
    const { type: e, cssVars: t, indicatorTextColor: r, showIndicator: n, status: i, railColor: o, railStyle: a, color: s, percentage: u, viewBoxWidth: d, strokeWidth: f, mergedIndicatorPlacement: h, unit: g, borderRadius: m, fillBorderRadius: v, height: w, processing: x, circleGap: y, mergedClsPrefix: C, gapDeg: S, gapOffsetDegree: T, themeClass: A, $slots: D, onRender: E } = this;
    return E == null || E(), b("div", { class: [
      A,
      `${C}-progress`,
      `${C}-progress--${e}`,
      `${C}-progress--${i}`
    ], style: t, "aria-valuemax": 100, "aria-valuemin": 0, "aria-valuenow": u, role: e === "circle" || e === "line" || e === "dashboard" ? "progressbar" : "none" }, e === "circle" || e === "dashboard" ? b(Cxe, { clsPrefix: C, status: i, showIndicator: n, indicatorTextColor: r, railColor: o, fillColor: s, railStyle: a, offsetDegree: this.offsetDegree, percentage: u, viewBoxWidth: d, strokeWidth: f, gapDegree: S === void 0 ? e === "dashboard" ? 75 : 0 : S, gapOffsetDegree: T, unit: g }, D) : e === "line" ? b(wxe, { clsPrefix: C, status: i, showIndicator: n, indicatorTextColor: r, railColor: o, fillColor: s, railStyle: a, percentage: u, processing: x, indicatorPlacement: h, unit: g, fillBorderRadius: v, railBorderRadius: m, height: w }, D) : e === "multiple-circle" ? b(Sxe, { clsPrefix: C, strokeWidth: f, railColor: o, fillColor: s, railStyle: a, viewBoxWidth: d, percentage: u, showIndicator: n, circleGap: y }, D) : null);
  }
});
const kxe = (e) => {
  const { heightSmall: t, heightMedium: r, heightLarge: n, borderRadius: i } = e;
  return {
    color: "#eee",
    colorEnd: "#ddd",
    borderRadius: i,
    heightSmall: t,
    heightMedium: r,
    heightLarge: n
  };
}, Dxe = {
  name: "Skeleton",
  common: Sr,
  self: kxe
};
var Axe = Y([L("skeleton", `
 height: 1em;
 width: 100%;
 transition: background-color .3s var(--n-bezier);
 transition:
 --n-color-start .3s var(--n-bezier),
 --n-color-end .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 animation: 2s skeleton-loading infinite cubic-bezier(0.36, 0, 0.64, 1);
 background-color: var(--n-color-start);
 `), Y("@keyframes skeleton-loading", `
 0% {
 background: var(--n-color-start);
 }
 40% {
 background: var(--n-color-end);
 }
 80% {
 background: var(--n-color-start);
 }
 100% {
 background: var(--n-color-start);
 }
 `)]);
const Exe = Object.assign(Object.assign({}, ft.props), { text: Boolean, round: Boolean, circle: Boolean, height: [String, Number], width: [String, Number], size: String, repeat: {
  type: Number,
  default: 1
}, animated: {
  type: Boolean,
  default: !0
}, sharp: {
  type: Boolean,
  default: !0
} });
var Ixe = oe({
  name: "Skeleton",
  inheritAttrs: !1,
  props: Exe,
  setup(e) {
    MX();
    const { mergedClsPrefixRef: t } = Yt(e), r = ft("Skeleton", "-skeleton", Axe, Dxe, e, t);
    return {
      mergedClsPrefix: t,
      style: j(() => {
        var n, i;
        const o = r.value, { common: { cubicBezierEaseInOut: a } } = o, s = o.self, { color: u, colorEnd: d, borderRadius: f } = s;
        let h;
        const { circle: g, sharp: m, round: v, width: w, height: x, size: y, text: C, animated: S } = e;
        y !== void 0 && (h = s[Be("height", y)]);
        const T = g ? (n = w ?? x) !== null && n !== void 0 ? n : h : w, A = (i = g ? w ?? x : x) !== null && i !== void 0 ? i : h;
        return {
          display: C ? "inline-block" : "",
          verticalAlign: C ? "-0.125em" : "",
          borderRadius: g ? "50%" : v ? "4096px" : m ? "" : f,
          width: typeof T == "number" ? Ko(T) : T,
          height: typeof A == "number" ? Ko(A) : A,
          animation: S ? "" : "none",
          "--n-bezier": a,
          "--n-color-start": u,
          "--n-color-end": d
        };
      })
    };
  },
  render() {
    const { repeat: e, style: t, mergedClsPrefix: r, $attrs: n } = this, i = b("div", ir({
      class: `${r}-skeleton`,
      style: t
    }, n));
    return e > 1 ? b(Lr, null, Array.apply(null, { length: e }).map((o) => [
      i,
      `
`
    ])) : i;
  }
});
function IR(e) {
  return window.TouchEvent && e instanceof window.TouchEvent;
}
function NR() {
  const e = G(/* @__PURE__ */ new Map()), t = (r) => (n) => {
    e.value.set(r, n);
  };
  return Nc(() => {
    e.value.clear();
  }), [e, t];
}
var Nxe = Y([L("slider", `
 display: block;
 padding: calc((var(--n-handle-size) - var(--n-rail-height)) / 2) 0;
 position: relative;
 z-index: 0;
 width: 100%;
 cursor: pointer;
 user-select: none;
 -webkit-user-select: none;
 `, [K("reverse", [L("slider-handles", [L("slider-handle-wrapper", `
 transform: translate(50%, -50%);
 `)]), L("slider-dots", [L("slider-dot", `
 transform: translateX(50%, -50%);
 `)]), K("vertical", [L("slider-handles", [L("slider-handle-wrapper", `
 transform: translate(-50%, -50%);
 `)]), L("slider-marks", [L("slider-mark", `
 transform: translateY(calc(-50% + var(--n-dot-height) / 2));
 `)]), L("slider-dots", [L("slider-dot", `
 transform: translateX(-50%) translateY(0);
 `)])])]), K("vertical", `
 padding: 0 calc((var(--n-handle-size) - var(--n-rail-height)) / 2);
 width: var(--n-rail-width-vertical);
 height: 100%;
 `, [L("slider-handles", `
 top: calc(var(--n-handle-size) / 2);
 right: 0;
 bottom: calc(var(--n-handle-size) / 2);
 left: 0;
 `, [L("slider-handle-wrapper", `
 top: unset;
 left: 50%;
 transform: translate(-50%, 50%);
 `)]), L("slider-rail", `
 height: 100%;
 `, [q("fill", `
 top: unset;
 right: 0;
 bottom: unset;
 left: 0;
 `)]), K("with-mark", `
 width: var(--n-rail-width-vertical);
 margin: 0 32px 0 8px;
 `), L("slider-marks", `
 top: calc(var(--n-handle-size) / 2);
 right: unset;
 bottom: calc(var(--n-handle-size) / 2);
 left: 22px;
 font-size: var(--n-mark-font-size);
 `, [L("slider-mark", `
 transform: translateY(50%);
 white-space: nowrap;
 `)]), L("slider-dots", `
 top: calc(var(--n-handle-size) / 2);
 right: unset;
 bottom: calc(var(--n-handle-size) / 2);
 left: 50%;
 `, [L("slider-dot", `
 transform: translateX(-50%) translateY(50%);
 `)])]), K("disabled", `
 cursor: not-allowed;
 opacity: var(--n-opacity-disabled);
 `, [L("slider-handle", `
 cursor: not-allowed;
 `)]), K("with-mark", `
 width: 100%;
 margin: 8px 0 32px 0;
 `), Y("&:hover", [L("slider-rail", {
  backgroundColor: "var(--n-rail-color-hover)"
}, [q("fill", {
  backgroundColor: "var(--n-fill-color-hover)"
})]), L("slider-handle", {
  boxShadow: "var(--n-handle-box-shadow-hover)"
})]), K("active", [L("slider-rail", {
  backgroundColor: "var(--n-rail-color-hover)"
}, [q("fill", {
  backgroundColor: "var(--n-fill-color-hover)"
})]), L("slider-handle", {
  boxShadow: "var(--n-handle-box-shadow-hover)"
})]), L("slider-marks", `
 position: absolute;
 top: 18px;
 left: calc(var(--n-handle-size) / 2);
 right: calc(var(--n-handle-size) / 2);
 `, [L("slider-mark", `
 position: absolute;
 transform: translateX(-50%);
 white-space: nowrap;
 `)]), L("slider-rail", `
 width: 100%;
 position: relative;
 height: var(--n-rail-height);
 background-color: var(--n-rail-color);
 transition: background-color .3s var(--n-bezier);
 border-radius: calc(var(--n-rail-height) / 2);
 `, [q("fill", `
 position: absolute;
 top: 0;
 bottom: 0;
 border-radius: calc(var(--n-rail-height) / 2);
 transition: background-color .3s var(--n-bezier);
 background-color: var(--n-fill-color);
 `)]), L("slider-handles", `
 position: absolute;
 top: 0;
 right: calc(var(--n-handle-size) / 2);
 bottom: 0;
 left: calc(var(--n-handle-size) / 2);
 `, [L("slider-handle-wrapper", `
 outline: none;
 position: absolute;
 top: 50%;
 transform: translate(-50%, -50%);
 cursor: pointer;
 display: flex;
 `, [L("slider-handle", `
 height: var(--n-handle-size);
 width: var(--n-handle-size);
 border-radius: 50%;
 overflow: hidden;
 transition: box-shadow .2s var(--n-bezier), background-color .3s var(--n-bezier);
 background-color: var(--n-handle-color);
 box-shadow: var(--n-handle-box-shadow);
 `, [Y("&:hover", `
 box-shadow: var(--n-handle-box-shadow-hover);
 `)]), Y("&:focus", [L("slider-handle", `
 box-shadow: var(--n-handle-box-shadow-focus);
 `, [Y("&:hover", `
 box-shadow: var(--n-handle-box-shadow-active);
 `)])])])]), L("slider-dots", `
 position: absolute;
 top: 50%;
 left: calc(var(--n-handle-size) / 2);
 right: calc(var(--n-handle-size) / 2);
 `, [K("transition-disabled", [L("slider-dot", "transition: none;")]), L("slider-dot", `
 transition:
 border-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 position: absolute;
 transform: translate(-50%, -50%);
 height: var(--n-dot-height);
 width: var(--n-dot-width);
 border-radius: var(--n-dot-border-radius);
 overflow: hidden;
 box-sizing: border-box;
 border: var(--n-dot-border);
 background-color: var(--n-dot-color);
 `, [K("active", "border: var(--n-dot-border-active);")])])]), L("slider-handle-indicator", `
 font-size: var(--n-font-size);
 padding: 6px 10px;
 border-radius: var(--n-indicator-border-radius);
 color: var(--n-indicator-text-color);
 background-color: var(--n-indicator-color);
 box-shadow: var(--n-indicator-box-shadow);
 `, [Fa()]), L("slider-handle-indicator", `
 font-size: var(--n-font-size);
 padding: 6px 10px;
 border-radius: var(--n-indicator-border-radius);
 color: var(--n-indicator-text-color);
 background-color: var(--n-indicator-color);
 box-shadow: var(--n-indicator-box-shadow);
 `, [K("top", `
 margin-bottom: 12px;
 `), K("right", `
 margin-left: 12px;
 `), K("bottom", `
 margin-top: 12px;
 `), K("left", `
 margin-right: 12px;
 `), Fa()]), Bp(L("slider", [L("slider-dot", "background-color: var(--n-dot-color-modal);")])), hb(L("slider", [L("slider-dot", "background-color: var(--n-dot-color-popover);")]))]);
const zxe = 0, $xe = Object.assign(Object.assign({}, ft.props), { to: vi.propTo, defaultValue: {
  type: [Number, Array],
  default: 0
}, marks: Object, disabled: {
  type: Boolean,
  default: void 0
}, formatTooltip: Function, keyboard: {
  type: Boolean,
  default: !0
}, min: {
  type: Number,
  default: 0
}, max: {
  type: Number,
  default: 100
}, step: {
  type: [Number, String],
  default: 1
}, range: Boolean, value: [Number, Array], placement: String, showTooltip: {
  type: Boolean,
  default: void 0
}, tooltip: {
  type: Boolean,
  default: !0
}, vertical: Boolean, reverse: Boolean, "onUpdate:value": [Function, Array], onUpdateValue: [Function, Array] });
var Oxe = oe({
  name: "Slider",
  props: $xe,
  setup(e) {
    const { mergedClsPrefixRef: t, namespaceRef: r, inlineThemeDisabled: n } = Yt(e), i = ft("Slider", "-slider", Nxe, y1e, e, t), o = G(null), [a, s] = NR(), [u, d] = NR(), f = G(/* @__PURE__ */ new Set()), h = ta(e), { mergedDisabledRef: g } = h, m = j(() => {
      const { step: fe } = e;
      if (Number(fe) <= 0 || fe === "mark")
        return 0;
      const ke = fe.toString();
      let Le = 0;
      return ke.includes(".") && (Le = ke.length - ke.indexOf(".") - 1), Le;
    }), v = G(e.defaultValue), w = tt(e, "value"), x = dn(w, v), y = j(() => {
      const { value: fe } = x;
      return (e.range ? fe : [fe]).map(De);
    }), C = j(() => y.value.length > 2), S = j(() => e.placement === void 0 ? e.vertical ? "right" : "top" : e.placement), T = j(() => {
      const { marks: fe } = e;
      return fe ? Object.keys(fe).map(parseFloat) : null;
    }), A = G(-1), D = G(-1), E = G(-1), N = G(!1), I = G(!1), $ = j(() => {
      const { vertical: fe, reverse: ke } = e;
      return fe ? ke ? "top" : "bottom" : ke ? "right" : "left";
    }), _ = j(() => {
      if (C.value)
        return;
      const fe = y.value, ke = Oe(e.range ? Math.min(...fe) : e.min), Le = Oe(e.range ? Math.max(...fe) : fe[0]), { value: dt } = $;
      return e.vertical ? {
        [dt]: `${ke}%`,
        height: `${Le - ke}%`
      } : {
        [dt]: `${ke}%`,
        width: `${Le - ke}%`
      };
    }), R = j(() => {
      const fe = [], { marks: ke } = e;
      if (ke) {
        const Le = y.value.slice();
        Le.sort((Vt, jt) => Vt - jt);
        const { value: dt } = $, { value: Mt } = C, { range: Ct } = e, er = Mt ? () => !1 : (Vt) => Ct ? Vt >= Le[0] && Vt <= Le[Le.length - 1] : Vt <= Le[0];
        for (const Vt of Object.keys(ke)) {
          const jt = Number(Vt);
          fe.push({
            active: er(jt),
            label: ke[Vt],
            style: {
              [dt]: `${Oe(jt)}%`
            }
          });
        }
      }
      return fe;
    });
    function U(fe, ke) {
      const Le = Oe(fe), { value: dt } = $;
      return {
        [dt]: `${Le}%`,
        zIndex: ke === A.value ? 1 : 0
      };
    }
    function Q(fe) {
      return e.showTooltip || E.value === fe || A.value === fe && N.value;
    }
    function Z(fe) {
      return N.value ? !(A.value === fe && D.value === fe) : !0;
    }
    function X(fe) {
      var ke;
      ~fe && (A.value = fe, (ke = a.value.get(fe)) === null || ke === void 0 || ke.focus());
    }
    function re() {
      u.value.forEach((fe, ke) => {
        Q(ke) && fe.syncPosition();
      });
    }
    function ue(fe) {
      const { "onUpdate:value": ke, onUpdateValue: Le } = e, { nTriggerFormInput: dt, nTriggerFormChange: Mt } = h;
      Le && je(Le, fe), ke && je(ke, fe), v.value = fe, dt(), Mt();
    }
    function he(fe) {
      const { range: ke } = e;
      if (ke) {
        if (Array.isArray(fe)) {
          const { value: Le } = y;
          fe.join() !== Le.join() && ue(fe);
        }
      } else
        Array.isArray(fe) || y.value[0] !== fe && ue(fe);
    }
    function te(fe, ke) {
      if (e.range) {
        const Le = y.value.slice();
        Le.splice(ke, 1, fe), he(Le);
      } else
        he(fe);
    }
    function de(fe, ke, Le) {
      const dt = Le !== void 0;
      Le || (Le = fe - ke > 0 ? 1 : -1);
      const Mt = T.value || [], { step: Ct } = e;
      if (Ct === "mark") {
        const jt = Ne(fe, Mt.concat(ke), dt ? Le : void 0);
        return jt ? jt.value : ke;
      }
      if (Ct <= 0)
        return ke;
      const { value: er } = m;
      let Vt;
      if (dt) {
        const jt = Number((ke / Ct).toFixed(er)), at = Math.floor(jt), St = jt > at ? at : at - 1, ve = jt < at ? at : at + 1;
        Vt = Ne(ke, [
          Number((St * Ct).toFixed(er)),
          Number((ve * Ct).toFixed(er)),
          ...Mt
        ], Le);
      } else {
        const jt = Ae(fe);
        Vt = Ne(fe, [...Mt, jt]);
      }
      return Vt ? De(Vt.value) : ke;
    }
    function De(fe) {
      return Math.min(e.max, Math.max(e.min, fe));
    }
    function Oe(fe) {
      const { max: ke, min: Le } = e;
      return (fe - Le) / (ke - Le) * 100;
    }
    function Qe(fe) {
      const { max: ke, min: Le } = e;
      return Le + (ke - Le) * fe;
    }
    function Ae(fe) {
      const { step: ke, min: Le } = e;
      if (Number(ke) <= 0 || ke === "mark")
        return fe;
      const dt = Math.round((fe - Le) / ke) * ke + Le;
      return Number(dt.toFixed(m.value));
    }
    function Ne(fe, ke = T.value, Le) {
      if (!(ke != null && ke.length))
        return null;
      let dt = null, Mt = -1;
      for (; ++Mt < ke.length; ) {
        const Ct = ke[Mt] - fe, er = Math.abs(Ct);
        (Le === void 0 || Ct * Le > 0) && (dt === null || er < dt.distance) && (dt = {
          index: Mt,
          distance: er,
          value: ke[Mt]
        });
      }
      return dt;
    }
    function $e(fe) {
      const ke = o.value;
      if (!ke)
        return;
      const Le = IR(fe) ? fe.touches[0] : fe, dt = ke.getBoundingClientRect();
      let Mt;
      return e.vertical ? Mt = (dt.bottom - Le.clientY) / dt.height : Mt = (Le.clientX - dt.left) / dt.width, e.reverse && (Mt = 1 - Mt), Qe(Mt);
    }
    function et(fe) {
      if (g.value || !e.keyboard)
        return;
      const { vertical: ke, reverse: Le } = e;
      switch (fe.key) {
        case "ArrowUp":
          fe.preventDefault(), Ge(ke && Le ? -1 : 1);
          break;
        case "ArrowRight":
          fe.preventDefault(), Ge(!ke && Le ? -1 : 1);
          break;
        case "ArrowDown":
          fe.preventDefault(), Ge(ke && Le ? 1 : -1);
          break;
        case "ArrowLeft":
          fe.preventDefault(), Ge(!ke && Le ? 1 : -1);
          break;
      }
    }
    function Ge(fe) {
      const ke = A.value;
      if (ke === -1)
        return;
      const { step: Le } = e, dt = y.value[ke], Mt = Number(Le) <= 0 || Le === "mark" ? dt : dt + Le * fe;
      te(de(Mt, dt, fe > 0 ? 1 : -1), ke);
    }
    function Ee(fe) {
      var ke, Le;
      if (g.value || !IR(fe) && fe.button !== zxe)
        return;
      const dt = $e(fe);
      if (dt === void 0)
        return;
      const Mt = y.value.slice(), Ct = e.range ? (Le = (ke = Ne(dt, Mt)) === null || ke === void 0 ? void 0 : ke.index) !== null && Le !== void 0 ? Le : -1 : 0;
      Ct !== -1 && (fe.preventDefault(), X(Ct), qe(), te(de(dt, y.value[Ct]), Ct));
    }
    function qe() {
      N.value || (N.value = !0, Mr("touchend", document, Ie), Mr("mouseup", document, Ie), Mr("touchmove", document, ot), Mr("mousemove", document, ot));
    }
    function Ue() {
      N.value && (N.value = !1, hr("touchend", document, Ie), hr("mouseup", document, Ie), hr("touchmove", document, ot), hr("mousemove", document, ot));
    }
    function ot(fe) {
      const { value: ke } = A;
      if (!N.value || ke === -1) {
        Ue();
        return;
      }
      const Le = $e(fe);
      te(de(Le, y.value[ke]), ke);
    }
    function Ie() {
      Ue();
    }
    function rt(fe) {
      A.value = fe, g.value || (E.value = fe);
    }
    function W(fe) {
      A.value === fe && (A.value = -1, Ue()), E.value === fe && (E.value = -1);
    }
    function P(fe) {
      E.value = fe;
    }
    function H(fe) {
      E.value === fe && (E.value = -1);
    }
    Gt(A, (fe, ke) => void an(() => D.value = ke)), Gt(x, () => {
      if (e.marks) {
        if (I.value)
          return;
        I.value = !0, an(() => {
          I.value = !1;
        });
      }
      an(re);
    }), Gr(() => {
      Ue();
    });
    const se = j(() => {
      const { self: { markFontSize: fe, railColor: ke, railColorHover: Le, fillColor: dt, fillColorHover: Mt, handleColor: Ct, opacityDisabled: er, dotColor: Vt, dotColorModal: jt, handleBoxShadow: at, handleBoxShadowHover: St, handleBoxShadowActive: ve, handleBoxShadowFocus: We, dotBorder: ne, dotBoxShadow: Se, railHeight: _e, railWidthVertical: ut, handleSize: ht, dotHeight: ye, dotWidth: Ze, dotBorderRadius: st, fontSize: Nt, dotBorderActive: Te, dotColorPopover: Ke }, common: { cubicBezierEaseInOut: xe } } = i.value;
      return {
        "--n-bezier": xe,
        "--n-dot-border": ne,
        "--n-dot-border-active": Te,
        "--n-dot-border-radius": st,
        "--n-dot-box-shadow": Se,
        "--n-dot-color": Vt,
        "--n-dot-color-modal": jt,
        "--n-dot-color-popover": Ke,
        "--n-dot-height": ye,
        "--n-dot-width": Ze,
        "--n-fill-color": dt,
        "--n-fill-color-hover": Mt,
        "--n-font-size": Nt,
        "--n-handle-box-shadow": at,
        "--n-handle-box-shadow-active": ve,
        "--n-handle-box-shadow-focus": We,
        "--n-handle-box-shadow-hover": St,
        "--n-handle-color": Ct,
        "--n-handle-size": ht,
        "--n-opacity-disabled": er,
        "--n-rail-color": ke,
        "--n-rail-color-hover": Le,
        "--n-rail-height": _e,
        "--n-rail-width-vertical": ut,
        "--n-mark-font-size": fe
      };
    }), pe = n ? Cr("slider", void 0, se, e) : void 0, ae = j(() => {
      const { self: { fontSize: fe, indicatorColor: ke, indicatorBoxShadow: Le, indicatorTextColor: dt, indicatorBorderRadius: Mt } } = i.value;
      return {
        "--n-font-size": fe,
        "--n-indicator-border-radius": Mt,
        "--n-indicator-box-shadow": Le,
        "--n-indicator-color": ke,
        "--n-indicator-text-color": dt
      };
    }), Me = n ? Cr("slider-indicator", void 0, ae, e) : void 0;
    return {
      mergedClsPrefix: t,
      namespace: r,
      uncontrolledValue: v,
      mergedValue: x,
      mergedDisabled: g,
      mergedPlacement: S,
      isMounted: ql(),
      adjustedTo: vi(e),
      dotTransitionDisabled: I,
      markInfos: R,
      isShowTooltip: Q,
      shouldKeepTooltipTransition: Z,
      handleRailRef: o,
      setHandleRefs: s,
      setFollowerRefs: d,
      fillStyle: _,
      getHandleStyle: U,
      activeIndex: A,
      arrifiedValues: y,
      followerEnabledIndexSet: f,
      handleRailMouseDown: Ee,
      handleHandleFocus: rt,
      handleHandleBlur: W,
      handleHandleMouseEnter: P,
      handleHandleMouseLeave: H,
      handleRailKeyDown: et,
      indicatorCssVars: n ? void 0 : ae,
      indicatorThemeClass: Me == null ? void 0 : Me.themeClass,
      indicatorOnRender: Me == null ? void 0 : Me.onRender,
      cssVars: n ? void 0 : se,
      themeClass: pe == null ? void 0 : pe.themeClass,
      onRender: pe == null ? void 0 : pe.onRender
    };
  },
  render() {
    var e;
    const { mergedClsPrefix: t, themeClass: r, formatTooltip: n } = this;
    return (e = this.onRender) === null || e === void 0 || e.call(this), b("div", { class: [
      `${t}-slider`,
      r,
      {
        [`${t}-slider--disabled`]: this.mergedDisabled,
        [`${t}-slider--active`]: this.activeIndex !== -1,
        [`${t}-slider--with-mark`]: this.marks,
        [`${t}-slider--vertical`]: this.vertical,
        [`${t}-slider--reverse`]: this.reverse
      }
    ], style: this.cssVars, onKeydown: this.handleRailKeyDown, onMousedown: this.handleRailMouseDown, onTouchstart: this.handleRailMouseDown }, b("div", { class: `${t}-slider-rail` }, b("div", { class: `${t}-slider-rail__fill`, style: this.fillStyle }), this.marks ? b("div", { class: [
      `${t}-slider-dots`,
      this.dotTransitionDisabled && `${t}-slider-dots--transition-disabled`
    ] }, this.markInfos.map((i) => b("div", { key: i.label, class: [
      `${t}-slider-dot`,
      {
        [`${t}-slider-dot--active`]: i.active
      }
    ], style: i.style }))) : null, b("div", { ref: "handleRailRef", class: `${t}-slider-handles` }, this.arrifiedValues.map((i, o) => {
      const a = this.isShowTooltip(o);
      return b(zc, null, {
        default: () => [
          b($c, null, {
            default: () => b("div", { ref: this.setHandleRefs(o), class: `${t}-slider-handle-wrapper`, tabindex: this.mergedDisabled ? -1 : 0, style: this.getHandleStyle(i, o), onFocus: () => {
              this.handleHandleFocus(o);
            }, onBlur: () => {
              this.handleHandleBlur(o);
            }, onMouseenter: () => {
              this.handleHandleMouseEnter(o);
            }, onMouseleave: () => {
              this.handleHandleMouseLeave(o);
            } }, vr(this.$slots.thumb, () => [
              b("div", { class: `${t}-slider-handle` })
            ]))
          }),
          this.tooltip && b(_c, { ref: this.setFollowerRefs(o), show: a, to: this.adjustedTo, enabled: this.showTooltip && !this.range || this.followerEnabledIndexSet.has(o), teleportDisabled: this.adjustedTo === vi.tdkey, placement: this.mergedPlacement, containerClass: this.namespace }, {
            default: () => b(jn, { name: "fade-in-scale-up-transition", appear: this.isMounted, css: this.shouldKeepTooltipTransition(o), onEnter: () => {
              this.followerEnabledIndexSet.add(o);
            }, onAfterLeave: () => {
              this.followerEnabledIndexSet.delete(o);
            } }, {
              default: () => {
                var s;
                return a ? ((s = this.indicatorOnRender) === null || s === void 0 || s.call(this), b("div", { class: [
                  `${t}-slider-handle-indicator`,
                  this.indicatorThemeClass,
                  `${t}-slider-handle-indicator--${this.mergedPlacement}`
                ], style: this.indicatorCssVars }, typeof n == "function" ? n(i) : i)) : null;
              }
            })
          })
        ]
      });
    })), this.marks ? b("div", { class: `${t}-slider-marks` }, this.markInfos.map((i) => b("div", { key: i.label, class: `${t}-slider-mark`, style: i.style }, i.label))) : null));
  }
}), _xe = Y([Y("@keyframes spin-rotate", `
 from {
 transform: rotate(0);
 }
 to {
 transform: rotate(360deg);
 }
 `), L("spin-container", {
  position: "relative"
}, [L("spin-body", `
 position: absolute;
 top: 50%;
 left: 50%;
 transform: translateX(-50%) translateY(-50%);
 `, [bp()])]), L("spin-body", `
 display: inline-flex;
 align-items: center;
 justify-content: center;
 flex-direction: column;
 `), L("spin", `
 display: inline-flex;
 height: var(--n-size);
 width: var(--n-size);
 font-size: var(--n-size);
 color: var(--n-color);
 `, [K("rotate", `
 animation: spin-rotate 2s linear infinite;
 `)]), L("spin-description", `
 display: inline-block;
 font-size: var(--n-font-size);
 color: var(--n-text-color);
 transition: color .3s var(--n-bezier);
 margin-top: 8px;
 `), L("spin-content", `
 opacity: 1;
 transition: opacity .3s var(--n-bezier);
 pointer-events: all;
 `, [K("spinning", `
 user-select: none;
 -webkit-user-select: none;
 pointer-events: none;
 opacity: var(--n-opacity-spinning);
 `)])]);
const Lxe = {
  small: 20,
  medium: 18,
  large: 16
}, Pxe = Object.assign(Object.assign({}, ft.props), { description: String, stroke: String, size: {
  type: [String, Number],
  default: "medium"
}, show: {
  type: Boolean,
  default: !0
}, strokeWidth: Number, rotate: {
  type: Boolean,
  default: !0
}, spinning: {
  type: Boolean,
  validator: () => !0,
  default: void 0
} });
var Rxe = oe({
  name: "Spin",
  props: Pxe,
  setup(e) {
    const { mergedClsPrefixRef: t, inlineThemeDisabled: r } = Yt(e), n = ft("Spin", "-spin", _xe, M1e, e, t), i = j(() => {
      const { size: a } = e, { common: { cubicBezierEaseInOut: s }, self: u } = n.value, { opacitySpinning: d, color: f, textColor: h } = u, g = typeof a == "number" ? Ko(a) : u[Be("size", a)];
      return {
        "--n-bezier": s,
        "--n-opacity-spinning": d,
        "--n-size": g,
        "--n-color": f,
        "--n-text-color": h
      };
    }), o = r ? Cr("spin", j(() => {
      const { size: a } = e;
      return typeof a == "number" ? String(a) : a[0];
    }), i, e) : void 0;
    return {
      mergedClsPrefix: t,
      compitableShow: pp(e, ["spinning", "show"]),
      mergedStrokeWidth: j(() => {
        const { strokeWidth: a } = e;
        if (a !== void 0)
          return a;
        const { size: s } = e;
        return Lxe[typeof s == "number" ? "medium" : s];
      }),
      cssVars: r ? void 0 : i,
      themeClass: o == null ? void 0 : o.themeClass,
      onRender: o == null ? void 0 : o.onRender
    };
  },
  render() {
    var e, t;
    const { $slots: r, mergedClsPrefix: n, description: i } = this, o = r.icon && this.rotate, a = (i || r.description) && b("div", { class: `${n}-spin-description` }, i || ((e = r.description) === null || e === void 0 ? void 0 : e.call(r))), s = r.icon ? b("div", { class: [`${n}-spin-body`, this.themeClass] }, b("div", { class: [
      `${n}-spin`,
      o && `${n}-spin--rotate`
    ], style: r.default ? "" : this.cssVars }, r.icon()), a) : b("div", { class: [`${n}-spin-body`, this.themeClass] }, b(mh, { clsPrefix: n, style: r.default ? "" : this.cssVars, stroke: this.stroke, "stroke-width": this.mergedStrokeWidth, class: `${n}-spin` }), a);
    return (t = this.onRender) === null || t === void 0 || t.call(this), r.default ? b("div", { class: [`${n}-spin-container`, this.themeClass], style: this.cssVars }, b("div", { class: [
      `${n}-spin-content`,
      this.compitableShow && `${n}-spin-content--spinning`
    ] }, r), b(jn, { name: "fade-in-transition" }, {
      default: () => this.compitableShow ? s : null
    })) : s;
  }
}), jxe = L("steps", `
 width: 100%;
 display: flex;
`, [L("step", `
 position: relative;
 display: flex;
 flex: 1;
 `, [K("disabled", "cursor: not-allowed"), K("clickable", `
 cursor: pointer;
 `), Y("&:last-child", [L("step-splitor", "display: none;")])]), L("step-splitor", `
 background-color: var(--n-splitor-color);
 margin-top: calc(var(--n-step-header-font-size) / 2);
 height: 1px;
 flex: 1;
 align-self: flex-start;
 margin-left: 12px;
 margin-right: 12px;
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 `), L("step-content", "flex: 1;", [L("step-content-header", `
 color: var(--n-header-text-color);
 margin-top: calc(var(--n-indicator-size) / 2 - var(--n-step-header-font-size) / 2);
 line-height: var(--n-step-header-font-size);
 font-size: var(--n-step-header-font-size);
 position: relative;
 display: flex;
 font-weight: var(--n-step-header-font-weight);
 margin-left: 9px;
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 `, [q("title", `
 white-space: nowrap;
 flex: 0;
 `)]), q("description", `
 color: var(--n-description-text-color);
 margin-top: 12px;
 margin-left: 9px;
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 `)]), L("step-indicator", `
 background-color: var(--n-indicator-color);
 box-shadow: 0 0 0 1px var(--n-indicator-border-color);
 height: var(--n-indicator-size);
 width: var(--n-indicator-size);
 border-radius: 50%;
 display: flex;
 align-items: center;
 justify-content: center;
 transition:
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 `, [L("step-indicator-slot", `
 position: relative;
 width: var(--n-indicator-icon-size);
 height: var(--n-indicator-icon-size);
 font-size: var(--n-indicator-icon-size);
 line-height: var(--n-indicator-icon-size);
 `, [q("index", `
 display: inline-block;
 text-align: center;
 position: absolute;
 left: 0;
 top: 0;
 font-size: var(--n-indicator-index-font-size);
 width: var(--n-indicator-icon-size);
 height: var(--n-indicator-icon-size);
 line-height: var(--n-indicator-icon-size);
 color: var(--n-indicator-text-color);
 transition: color .3s var(--n-bezier);
 `, [Io()]), L("icon", `
 color: var(--n-indicator-text-color);
 transition: color .3s var(--n-bezier);
 `, [Io()]), L("base-icon", `
 color: var(--n-indicator-text-color);
 transition: color .3s var(--n-bezier);
 `, [Io()])])]), K("vertical", "flex-direction: column;", [wr("show-description", [Y(">", [L("step", "padding-bottom: 8px;")])]), Y(">", [L("step", "margin-bottom: 16px;", [Y("&:last-child", "margin-bottom: 0;"), Y(">", [L("step-indicator", [Y(">", [L("step-splitor", `
 position: absolute;
 bottom: -8px;
 width: 1px;
 margin: 0 !important;
 left: calc(var(--n-indicator-size) / 2);
 height: calc(100% - var(--n-indicator-size));
 `)])]), L("step-content", [q("description", "margin-top: 8px;")])])])])])]);
function Fxe(e, t) {
  return typeof e != "object" || e === null || Array.isArray(e) ? null : (e.props || (e.props = {}), e.props.internalIndex = t + 1, e);
}
function Bxe(e) {
  return e.map((t, r) => Fxe(t, r));
}
const Uxe = Object.assign(Object.assign({}, ft.props), { current: Number, status: {
  type: String,
  default: "process"
}, size: {
  type: String,
  default: "medium"
}, vertical: Boolean, "onUpdate:current": [Function, Array], onUpdateCurrent: [Function, Array] }), LW = "n-steps";
var Hxe = oe({
  name: "Steps",
  props: Uxe,
  setup(e, { slots: t }) {
    const { mergedClsPrefixRef: r, mergedRtlRef: n } = Yt(e), i = Li("Steps", n, r), o = ft("Steps", "-steps", jxe, k1e, e, r);
    return tr(LW, {
      props: e,
      mergedThemeRef: o,
      mergedClsPrefixRef: r,
      stepsSlots: t
    }), {
      mergedClsPrefix: r,
      rtlEnabled: i
    };
  },
  render() {
    const { mergedClsPrefix: e } = this;
    return b("div", { class: [
      `${e}-steps`,
      this.rtlEnabled && `${e}-steps--rtl`,
      this.vertical && `${e}-steps--vertical`
    ] }, Bxe(ms(qO(this))));
  }
});
const Wxe = {
  status: String,
  title: String,
  description: String,
  disabled: Boolean,
  internalIndex: {
    type: Number,
    default: 0
  }
};
var Vxe = oe({
  name: "Step",
  props: Wxe,
  setup(e) {
    const t = lt(LW, null);
    t || Ql("step", "`n-step` must be placed inside `n-steps`.");
    const { inlineThemeDisabled: r } = Yt(), { props: n, mergedThemeRef: i, mergedClsPrefixRef: o, stepsSlots: a } = t, s = j(() => n.vertical), u = j(() => {
      const { status: g } = e;
      if (g)
        return g;
      {
        const { internalIndex: m } = e, { current: v } = n;
        if (v === void 0)
          return "process";
        if (m < v)
          return "finish";
        if (m === v)
          return n.status || "process";
        if (m > v)
          return "wait";
      }
      return "process";
    }), d = j(() => {
      const { value: g } = u, { size: m } = n, { common: { cubicBezierEaseInOut: v }, self: { stepHeaderFontWeight: w, [Be("stepHeaderFontSize", m)]: x, [Be("indicatorIndexFontSize", m)]: y, [Be("indicatorSize", m)]: C, [Be("indicatorIconSize", m)]: S, [Be("indicatorTextColor", g)]: T, [Be("indicatorBorderColor", g)]: A, [Be("headerTextColor", g)]: D, [Be("splitorColor", g)]: E, [Be("indicatorColor", g)]: N, [Be("descriptionTextColor", g)]: I } } = i.value;
      return {
        "--n-bezier": v,
        "--n-description-text-color": I,
        "--n-header-text-color": D,
        "--n-indicator-border-color": A,
        "--n-indicator-color": N,
        "--n-indicator-icon-size": S,
        "--n-indicator-index-font-size": y,
        "--n-indicator-size": C,
        "--n-indicator-text-color": T,
        "--n-splitor-color": E,
        "--n-step-header-font-size": x,
        "--n-step-header-font-weight": w
      };
    }), f = r ? Cr("step", j(() => {
      const { value: g } = u, { size: m } = n;
      return `${g[0]}${m[0]}`;
    }), d, n) : void 0, h = j(() => {
      if (e.disabled)
        return;
      const { onUpdateCurrent: g, "onUpdate:current": m } = n;
      return g || m ? () => {
        g && je(g, e.internalIndex), m && je(m, e.internalIndex);
      } : void 0;
    });
    return {
      stepsSlots: a,
      mergedClsPrefix: o,
      vertical: s,
      mergedStatus: u,
      handleStepClick: h,
      cssVars: r ? void 0 : d,
      themeClass: f == null ? void 0 : f.themeClass,
      onRender: f == null ? void 0 : f.onRender
    };
  },
  render() {
    const { mergedClsPrefix: e, onRender: t, handleStepClick: r, disabled: n } = this, i = Fr(this.$slots.default, (o) => {
      const a = o || this.description;
      return a ? b("div", { class: `${e}-step-content__description` }, a) : null;
    });
    return t == null || t(), b("div", { class: [
      `${e}-step`,
      n && `${e}-step--disabled`,
      !n && r && `${e}-step--clickable`,
      this.themeClass,
      i && `${e}-step--show-description`,
      `${e}-step--${this.mergedStatus}-status`
    ], style: this.cssVars, onClick: r }, b("div", { class: `${e}-step-indicator` }, b("div", { class: `${e}-step-indicator-slot` }, b(Lc, null, {
      default: () => Fr(this.$slots.icon, (o) => {
        const { mergedStatus: a, stepsSlots: s } = this;
        return a === "finish" || a === "error" ? a === "finish" ? b(fr, { clsPrefix: e, key: "finish" }, {
          default: () => vr(s["finish-icon"], () => [
            b(X7, null)
          ])
        }) : a === "error" ? b(fr, { clsPrefix: e, key: "error" }, {
          default: () => vr(s["error-icon"], () => [
            b(J7, null)
          ])
        }) : null : o || b("div", { key: this.internalIndex, class: `${e}-step-indicator-slot__index` }, this.internalIndex);
      })
    })), this.vertical ? b("div", { class: `${e}-step-splitor` }) : null), b("div", { class: `${e}-step-content` }, b("div", { class: `${e}-step-content-header` }, b("div", { class: `${e}-step-content-header__title` }, vr(this.$slots.title, () => [this.title])), this.vertical ? null : b("div", { class: `${e}-step-splitor` })), i));
  }
}), Yxe = L("switch", `
 height: var(--n-height);
 min-width: var(--n-width);
 vertical-align: middle;
 user-select: none;
 -webkit-user-select: none;
 display: inline-flex;
 outline: none;
 justify-content: center;
 align-items: center;
`, [q("children-placeholder", `
 height: var(--n-rail-height);
 display: flex;
 flex-direction: column;
 overflow: hidden;
 pointer-events: none;
 visibility: hidden;
 `), q("rail-placeholder", `
 display: flex;
 flex-wrap: none;
 `), q("button-placeholder", `
 width: calc(1.75 * var(--n-rail-height));
 height: var(--n-rail-height);
 `), L("base-loading", `
 position: absolute;
 top: 50%;
 left: 50%;
 transform: translateX(-50%) translateY(-50%);
 font-size: calc(var(--n-button-width) - 4px);
 color: var(--n-loading-color);
 transition: color .3s var(--n-bezier);
 `, [Io({
  left: "50%",
  top: "50%",
  originalTransform: "translateX(-50%) translateY(-50%)"
})]), q("checked, unchecked", `
 transition: color .3s var(--n-bezier);
 color: var(--n-text-color);
 box-sizing: border-box;
 position: absolute;
 white-space: nowrap;
 top: 0;
 bottom: 0;
 display: flex;
 align-items: center;
 line-height: 1;
 `), q("checked", `
 right: 0;
 padding-right: calc(1.25 * var(--n-rail-height) - var(--n-offset));
 `), q("unchecked", `
 left: 0;
 justify-content: flex-end;
 padding-left: calc(1.25 * var(--n-rail-height) - var(--n-offset));
 `), Y("&:focus", [q("rail", `
 box-shadow: var(--n-box-shadow-focus);
 `)]), K("round", [q("rail", "border-radius: calc(var(--n-rail-height) / 2);", [q("button", "border-radius: calc(var(--n-button-height) / 2);")])]), wr("disabled", [wr("icon", [K("rubber-band", [K("pressed", [q("rail", [q("button", "max-width: var(--n-button-width-pressed);")])]), q("rail", [Y("&:active", [q("button", "max-width: var(--n-button-width-pressed);")])]), K("active", [K("pressed", [q("rail", [q("button", "left: calc(100% - var(--n-offset) - var(--n-button-width-pressed));")])]), q("rail", [Y("&:active", [q("button", "left: calc(100% - var(--n-offset) - var(--n-button-width-pressed));")])])])])])]), K("active", [q("rail", [q("button", "left: calc(100% - var(--n-button-width) - var(--n-offset))")])]), q("rail", `
 overflow: hidden;
 height: var(--n-rail-height);
 min-width: var(--n-rail-width);
 border-radius: var(--n-rail-border-radius);
 cursor: pointer;
 position: relative;
 transition:
 opacity .3s var(--n-bezier),
 background .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 background-color: var(--n-rail-color);
 `, [q("button-icon", `
 color: var(--n-icon-color);
 transition: color .3s var(--n-bezier);
 font-size: calc(var(--n-button-height) - 4px);
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 display: flex;
 justify-content: center;
 align-items: center;
 line-height: 1;
 `, [Io()]), q("button", `
 align-items: center; 
 top: var(--n-offset);
 left: var(--n-offset);
 height: var(--n-button-height);
 width: var(--n-button-width-pressed);
 max-width: var(--n-button-width);
 border-radius: var(--n-button-border-radius);
 background-color: var(--n-button-color);
 box-shadow: var(--n-button-box-shadow);
 box-sizing: border-box;
 cursor: inherit;
 content: "";
 position: absolute;
 transition:
 background-color .3s var(--n-bezier),
 left .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 max-width .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 `)]), K("active", [q("rail", "background-color: var(--n-rail-color-active);")]), K("loading", [q("rail", `
 cursor: wait;
 `)]), K("disabled", [q("rail", `
 cursor: not-allowed;
 opacity: .5;
 `)])]);
const Qxe = Object.assign(Object.assign({}, ft.props), {
  size: {
    type: String,
    default: "medium"
  },
  value: {
    type: [String, Number, Boolean],
    default: void 0
  },
  loading: Boolean,
  defaultValue: {
    type: [String, Number, Boolean],
    default: !1
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  round: {
    type: Boolean,
    default: !0
  },
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  checkedValue: {
    type: [String, Number, Boolean],
    default: !0
  },
  uncheckedValue: {
    type: [String, Number, Boolean],
    default: !1
  },
  railStyle: Function,
  rubberBand: {
    type: Boolean,
    default: !0
  },
  onChange: [Function, Array]
});
let Av;
var qxe = oe({
  name: "Switch",
  props: Qxe,
  setup(e) {
    Av === void 0 && (typeof CSS < "u" ? typeof CSS.supports < "u" ? Av = CSS.supports("width", "max(1px)") : Av = !1 : Av = !0);
    const { mergedClsPrefixRef: t, inlineThemeDisabled: r } = Yt(e), n = ft("Switch", "-switch", Yxe, I1e, e, t), i = ta(e), { mergedSizeRef: o, mergedDisabledRef: a } = i, s = G(e.defaultValue), u = tt(e, "value"), d = dn(u, s), f = j(() => d.value === e.checkedValue), h = G(!1), g = G(!1), m = j(() => {
      const { railStyle: N } = e;
      if (N)
        return N({ focused: g.value, checked: f.value });
    });
    function v(N) {
      const { "onUpdate:value": I, onChange: $, onUpdateValue: _ } = e, { nTriggerFormInput: R, nTriggerFormChange: U } = i;
      I && je(I, N), _ && je(_, N), $ && je($, N), s.value = N, R(), U();
    }
    function w() {
      const { nTriggerFormFocus: N } = i;
      N();
    }
    function x() {
      const { nTriggerFormBlur: N } = i;
      N();
    }
    function y() {
      e.loading || a.value || (d.value !== e.checkedValue ? v(e.checkedValue) : v(e.uncheckedValue));
    }
    function C() {
      g.value = !0, w();
    }
    function S() {
      g.value = !1, x(), h.value = !1;
    }
    function T(N) {
      e.loading || a.value || N.key === " " && (d.value !== e.checkedValue ? v(e.checkedValue) : v(e.uncheckedValue), h.value = !1);
    }
    function A(N) {
      e.loading || a.value || N.key === " " && (N.preventDefault(), h.value = !0);
    }
    const D = j(() => {
      const { value: N } = o, { self: { opacityDisabled: I, railColor: $, railColorActive: _, buttonBoxShadow: R, buttonColor: U, boxShadowFocus: Q, loadingColor: Z, textColor: X, iconColor: re, [Be("buttonHeight", N)]: ue, [Be("buttonWidth", N)]: he, [Be("buttonWidthPressed", N)]: te, [Be("railHeight", N)]: de, [Be("railWidth", N)]: De, [Be("railBorderRadius", N)]: Oe, [Be("buttonBorderRadius", N)]: Qe }, common: { cubicBezierEaseInOut: Ae } } = n.value;
      let Ne, $e, et;
      return Av ? (Ne = `calc((${de} - ${ue}) / 2)`, $e = `max(${de}, ${ue})`, et = `max(${De}, calc(${De} + ${ue} - ${de}))`) : (Ne = Ko((wo(de) - wo(ue)) / 2), $e = Ko(Math.max(wo(de), wo(ue))), et = wo(de) > wo(ue) ? De : Ko(wo(De) + wo(ue) - wo(de))), {
        "--n-bezier": Ae,
        "--n-button-border-radius": Qe,
        "--n-button-box-shadow": R,
        "--n-button-color": U,
        "--n-button-width": he,
        "--n-button-width-pressed": te,
        "--n-button-height": ue,
        "--n-height": $e,
        "--n-offset": Ne,
        "--n-opacity-disabled": I,
        "--n-rail-border-radius": Oe,
        "--n-rail-color": $,
        "--n-rail-color-active": _,
        "--n-rail-height": de,
        "--n-rail-width": De,
        "--n-width": et,
        "--n-box-shadow-focus": Q,
        "--n-loading-color": Z,
        "--n-text-color": X,
        "--n-icon-color": re
      };
    }), E = r ? Cr("switch", j(() => o.value[0]), D, e) : void 0;
    return {
      handleClick: y,
      handleBlur: S,
      handleFocus: C,
      handleKeyup: T,
      handleKeydown: A,
      mergedRailStyle: m,
      pressed: h,
      mergedClsPrefix: t,
      mergedValue: d,
      checked: f,
      mergedDisabled: a,
      cssVars: r ? void 0 : D,
      themeClass: E == null ? void 0 : E.themeClass,
      onRender: E == null ? void 0 : E.onRender
    };
  },
  render() {
    const { mergedClsPrefix: e, mergedDisabled: t, checked: r, mergedRailStyle: n, onRender: i, $slots: o } = this;
    i == null || i();
    const { checked: a, unchecked: s, icon: u, "checked-icon": d, "unchecked-icon": f } = o, h = !(Bf(u) && Bf(d) && Bf(f));
    return b("div", { role: "switch", "aria-checked": r, class: [
      `${e}-switch`,
      this.themeClass,
      h && `${e}-switch--icon`,
      r && `${e}-switch--active`,
      t && `${e}-switch--disabled`,
      this.round && `${e}-switch--round`,
      this.loading && `${e}-switch--loading`,
      this.pressed && `${e}-switch--pressed`,
      this.rubberBand && `${e}-switch--rubber-band`
    ], tabindex: this.mergedDisabled ? void 0 : 0, style: this.cssVars, onClick: this.handleClick, onFocus: this.handleFocus, onBlur: this.handleBlur, onKeyup: this.handleKeyup, onKeydown: this.handleKeydown }, b("div", { class: `${e}-switch__rail`, "aria-hidden": "true", style: n }, Fr(a, (g) => Fr(s, (m) => g || m ? b("div", { "aria-hidden": !0, class: `${e}-switch__children-placeholder` }, b("div", { class: `${e}-switch__rail-placeholder` }, b("div", { class: `${e}-switch__button-placeholder` }), g), b("div", { class: `${e}-switch__rail-placeholder` }, b("div", { class: `${e}-switch__button-placeholder` }), m)) : null)), b("div", { class: `${e}-switch__button` }, Fr(u, (g) => Fr(d, (m) => Fr(f, (v) => b(Lc, null, {
      default: () => this.loading ? b(mh, { key: "loading", clsPrefix: e, strokeWidth: 20 }) : this.checked && (m || g) ? b("div", { class: `${e}-switch__button-icon`, key: m ? "checked-icon" : "icon" }, m || g) : !this.checked && (v || g) ? b("div", { class: `${e}-switch__button-icon`, key: v ? "unchecked-icon" : "icon" }, v || g) : null
    })))), Fr(a, (g) => g && b("div", { key: "checked", class: `${e}-switch__checked` }, g)), Fr(s, (g) => g && b("div", { key: "unchecked", class: `${e}-switch__unchecked` }, g)))));
  }
});
const G4 = "n-tabs", PW = {
  tab: [String, Number, Object, Function],
  name: {
    type: [String, Number],
    required: !0
  },
  disabled: Boolean,
  displayDirective: {
    type: String,
    default: "if"
  },
  closable: {
    type: Boolean,
    default: void 0
  },
  tabProps: Object,
  label: [String, Number, Object, Function]
};
var Gxe = oe({
  __TAB_PANE__: !0,
  name: "TabPane",
  alias: ["TabPanel"],
  props: PW,
  setup(e) {
    const t = lt(G4, null);
    return t || Ql("tab-pane", "`n-tab-pane` must be placed inside `n-tabs`."), {
      style: t.paneStyleRef,
      class: t.paneClassRef,
      mergedClsPrefix: t.mergedClsPrefixRef
    };
  },
  render() {
    return b("div", { class: [`${this.mergedClsPrefix}-tab-pane`, this.class], style: this.style }, this.$slots);
  }
});
const Zxe = Object.assign({ internalLeftPadded: Boolean, internalAddable: Boolean, internalCreatedByPane: Boolean }, IM(PW, ["displayDirective"]));
var fx = oe({
  __TAB__: !0,
  inheritAttrs: !1,
  name: "Tab",
  props: Zxe,
  setup(e) {
    const {
      mergedClsPrefixRef: t,
      valueRef: r,
      typeRef: n,
      closableRef: i,
      tabStyleRef: o,
      tabChangeIdRef: a,
      onBeforeLeaveRef: s,
      triggerRef: u,
      handleAdd: d,
      activateTab: f,
      handleClose: h
    } = lt(G4);
    return {
      trigger: u,
      mergedClosable: j(() => {
        if (e.internalAddable)
          return !1;
        const { closable: g } = e;
        return g === void 0 ? i.value : g;
      }),
      style: o,
      clsPrefix: t,
      value: r,
      type: n,
      handleClose(g) {
        g.stopPropagation(), !e.disabled && h(e.name);
      },
      activateTab() {
        if (e.disabled)
          return;
        if (e.internalAddable) {
          d();
          return;
        }
        const { name: g } = e, m = ++a.id;
        if (g !== r.value) {
          const { value: v } = s;
          v ? Promise.resolve(v(e.name, r.value)).then((w) => {
            w && a.id === m && f(g);
          }) : f(g);
        }
      }
    };
  },
  render() {
    const { internalAddable: e, clsPrefix: t, name: r, disabled: n, label: i, tab: o, value: a, mergedClosable: s, style: u, trigger: d, $slots: { default: f } } = this, h = i ?? o;
    return b("div", { class: `${t}-tabs-tab-wrapper` }, this.internalLeftPadded ? b("div", { class: `${t}-tabs-tab-pad` }) : null, b("div", Object.assign({ key: r, "data-name": r, "data-disabled": n ? !0 : void 0 }, ir({
      class: [
        `${t}-tabs-tab`,
        a === r && `${t}-tabs-tab--active`,
        n && `${t}-tabs-tab--disabled`,
        s && `${t}-tabs-tab--closable`,
        e && `${t}-tabs-tab--addable`
      ],
      onClick: d === "click" ? this.activateTab : void 0,
      onMouseenter: d === "hover" ? this.activateTab : void 0,
      style: e ? void 0 : u
    }, this.internalCreatedByPane ? this.tabProps || {} : this.$attrs)), b("span", { class: `${t}-tabs-tab__label` }, e ? b(Lr, null, b("div", { class: `${t}-tabs-tab__height-placeholder` }, " "), b(fr, { clsPrefix: t }, {
      default: () => b(FM, null)
    })) : f ? f() : typeof h == "object" ? h : xn(h ?? r)), s && this.type === "card" ? b(gh, { clsPrefix: t, class: `${t}-tabs-tab__close`, onClick: this.handleClose, disabled: n }) : null));
  }
}), Kxe = L("tabs", `
 box-sizing: border-box;
 width: 100%;
 display: flex;
 flex-direction: column;
 transition:
 background-color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
`, [K("segment-type", [L("tabs-rail", [Y("&.transition-disabled", "color: red;", [L("tabs-tab", `
 transition: none;
 `)])])]), K("top", [L("tab-pane", `
 padding: var(--n-pane-padding-top) var(--n-pane-padding-right) var(--n-pane-padding-bottom) var(--n-pane-padding-left);
 `)]), K("left", [L("tab-pane", `
 padding: var(--n-pane-padding-right) var(--n-pane-padding-bottom) var(--n-pane-padding-left) var(--n-pane-padding-top);
 `)]), K("left, right", `
 flex-direction: row;
 `, [L("tabs-bar", `
 width: 2px;
 right: 0;
 transition:
 top .2s var(--n-bezier),
 max-height .2s var(--n-bezier),
 background-color .3s var(--n-bezier);
 `), L("tabs-tab", `
 padding: var(--n-tab-padding-vertical); 
 `)]), K("right", `
 flex-direction: row-reverse;
 `, [L("tab-pane", `
 padding: var(--n-pane-padding-left) var(--n-pane-padding-top) var(--n-pane-padding-right) var(--n-pane-padding-bottom);
 `), L("tabs-bar", `
 left: 0;
 `)]), K("bottom", `
 flex-direction: column-reverse;
 justify-content: flex-end;
 `, [L("tab-pane", `
 padding: var(--n-pane-padding-bottom) var(--n-pane-padding-right) var(--n-pane-padding-top) var(--n-pane-padding-left);
 `), L("tabs-bar", `
 top: 0;
 `)]), L("tabs-rail", `
 padding: 3px;
 border-radius: var(--n-tab-border-radius);
 width: 100%;
 background-color: var(--n-color-segment);
 transition: background-color .3s var(--n-bezier);
 display: flex;
 align-items: center;
 `, [L("tabs-tab-wrapper", `
 flex-basis: 0;
 flex-grow: 1;
 display: flex;
 align-items: center;
 justify-content: center;
 `, [L("tabs-tab", `
 overflow: hidden;
 border-radius: var(--n-tab-border-radius);
 width: 100%;
 display: flex;
 align-items: center;
 justify-content: center;
 `, [K("active", `
 font-weight: var(--n-font-weight-strong);
 color: var(--n-tab-text-color-active);
 background-color: var(--n-tab-color-segment);
 box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .08);
 `), Y("&:hover", `
 color: var(--n-tab-text-color-hover);
 `)])])]), K("flex", [L("tabs-nav", {
  width: "100%"
}, [L("tabs-wrapper", {
  width: "100%"
}, [L("tabs-tab", {
  marginRight: 0
})])])]), L("tabs-nav", `
 box-sizing: border-box;
 line-height: 1.5;
 display: flex;
 transition: border-color .3s var(--n-bezier);
 `, [q("prefix, suffix", `
 display: flex;
 align-items: center;
 `), q("prefix", "padding-right: 16px;"), q("suffix", "padding-left: 16px;")]), K("top, bottom", [L("tabs-nav-scroll-wrapper", [Y("&::before", `
 top: 0;
 bottom: 0;
 left: 0;
 width: 20px;
 `), Y("&::after", `
 top: 0;
 bottom: 0;
 right: 0;
 width: 20px;
 `), K("shadow-start", [Y("&::before", `
 box-shadow: inset 10px 0 8px -8px rgba(0, 0, 0, .12);
 `)]), K("shadow-end", [Y("&::after", `
 box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, .12);
 `)])])]), K("left, right", [L("tabs-nav-scroll-wrapper", [Y("&::before", `
 top: 0;
 left: 0;
 right: 0;
 height: 20px;
 `), Y("&::after", `
 bottom: 0;
 left: 0;
 right: 0;
 height: 20px;
 `), K("shadow-start", [Y("&::before", `
 box-shadow: inset 0 10px 8px -8px rgba(0, 0, 0, .12);
 `)]), K("shadow-end", [Y("&::after", `
 box-shadow: inset 0 -10px 8px -8px rgba(0, 0, 0, .12);
 `)])])]), L("tabs-nav-scroll-wrapper", `
 flex: 1;
 position: relative;
 overflow: hidden;
 `, [L("tabs-nav-y-scroll", `
 height: 100%;
 width: 100%;
 overflow-y: auto; 
 scrollbar-width: none;
 `, [Y("&::-webkit-scrollbar", `
 width: 0;
 height: 0;
 `)]), Y("&::before, &::after", `
 transition: box-shadow .3s var(--n-bezier);
 pointer-events: none;
 content: "";
 position: absolute;
 z-index: 1;
 `)]), L("tabs-nav-scroll-content", `
 display: flex;
 position: relative;
 min-width: 100%;
 width: fit-content;
 box-sizing: border-box;
 `), L("tabs-wrapper", `
 display: inline-flex;
 flex-wrap: nowrap;
 position: relative;
 `), L("tabs-tab-wrapper", `
 display: flex;
 flex-wrap: nowrap;
 flex-shrink: 0;
 flex-grow: 0;
 `), L("tabs-tab", `
 cursor: pointer;
 white-space: nowrap;
 flex-wrap: nowrap;
 display: inline-flex;
 align-items: center;
 color: var(--n-tab-text-color);
 font-size: var(--n-tab-font-size);
 background-clip: padding-box;
 padding: var(--n-tab-padding);
 transition:
 box-shadow .3s var(--n-bezier),
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `, [K("disabled", {
  cursor: "not-allowed"
}), q("close", `
 margin-left: 6px;
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `), q("label", `
 display: flex;
 align-items: center;
 `)]), L("tabs-bar", `
 position: absolute;
 bottom: 0;
 height: 2px;
 border-radius: 1px;
 background-color: var(--n-bar-color);
 transition:
 left .2s var(--n-bezier),
 max-width .2s var(--n-bezier),
 background-color .3s var(--n-bezier);
 `, [Y("&.transition-disabled", `
 transition: none;
 `), K("disabled", `
 background-color: var(--n-tab-text-color-disabled)
 `)]), L("tabs-pane-wrapper", `
 position: relative;
 overflow: hidden;
 transition: max-height .2s var(--n-bezier);
 `), L("tab-pane", `
 color: var(--n-pane-text-color);
 width: 100%;
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 opacity .2s var(--n-bezier);
 left: 0;
 right: 0;
 top: 0;
 `, [Y("&.next-transition-leave-active, &.prev-transition-leave-active, &.next-transition-enter-active, &.prev-transition-enter-active", `
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 transform .2s var(--n-bezier),
 opacity .2s var(--n-bezier);
 `), Y("&.next-transition-leave-active, &.prev-transition-leave-active", `
 position: absolute;
 `), Y("&.next-transition-enter-from, &.prev-transition-leave-to", `
 transform: translateX(32px);
 opacity: 0;
 `), Y("&.next-transition-leave-to, &.prev-transition-enter-from", `
 transform: translateX(-32px);
 opacity: 0;
 `), Y("&.next-transition-leave-from, &.next-transition-enter-to, &.prev-transition-leave-from, &.prev-transition-enter-to", `
 transform: translateX(0);
 opacity: 1;
 `)]), L("tabs-tab-pad", `
 box-sizing: border-box;
 width: var(--n-tab-gap);
 flex-grow: 0;
 flex-shrink: 0;
 `), K("line-type, bar-type", [L("tabs-tab", `
 font-weight: var(--n-tab-font-weight);
 box-sizing: border-box;
 vertical-align: bottom;
 `, [Y("&:hover", {
  color: "var(--n-tab-text-color-hover)"
}), K("active", `
 color: var(--n-tab-text-color-active);
 font-weight: var(--n-tab-font-weight-active);
 `), K("disabled", {
  color: "var(--n-tab-text-color-disabled)"
})])]), L("tabs-nav", [K("line-type", [K("top", [q("prefix, suffix", `
 border-bottom: 1px solid var(--n-tab-border-color);
 `), L("tabs-nav-scroll-content", `
 border-bottom: 1px solid var(--n-tab-border-color);
 `), L("tabs-bar", `
 bottom: -1px;
 `)]), K("left", [q("prefix, suffix", `
 border-right: 1px solid var(--n-tab-border-color);
 `), L("tabs-nav-scroll-content", `
 border-right: 1px solid var(--n-tab-border-color);
 `), L("tabs-bar", `
 right: -1px;
 `)]), K("right", [q("prefix, suffix", `
 border-left: 1px solid var(--n-tab-border-color);
 `), L("tabs-nav-scroll-content", `
 border-left: 1px solid var(--n-tab-border-color);
 `), L("tabs-bar", `
 left: -1px;
 `)]), K("bottom", [q("prefix, suffix", `
 border-top: 1px solid var(--n-tab-border-color);
 `), L("tabs-nav-scroll-content", `
 border-top: 1px solid var(--n-tab-border-color);
 `), L("tabs-bar", `
 top: -1px;
 `)]), q("prefix, suffix", `
 transition: border-color .3s var(--n-bezier);
 `), L("tabs-nav-scroll-content", `
 transition: border-color .3s var(--n-bezier);
 `), L("tabs-bar", `
 border-radius: 0;
 `)]), K("card-type", [q("prefix, suffix", `
 transition: border-color .3s var(--n-bezier);
 border-bottom: 1px solid var(--n-tab-border-color);
 `), L("tabs-pad", `
 flex-grow: 1;
 transition: border-color .3s var(--n-bezier);
 border-bottom: 1px solid var(--n-tab-border-color);
 `), L("tabs-tab-pad", `
 transition: border-color .3s var(--n-bezier);
 `), L("tabs-tab", `
 font-weight: var(--n-tab-font-weight);
 border: 1px solid var(--n-tab-border-color);
 background-color: var(--n-tab-color);
 box-sizing: border-box;
 position: relative;
 vertical-align: bottom;
 display: flex;
 justify-content: space-between;
 font-size: var(--n-tab-font-size);
 color: var(--n-tab-text-color);
 `, [K("addable", `
 padding-left: 8px;
 padding-right: 8px;
 font-size: 16px;
 `, [q("height-placeholder", `
 width: 0;
 font-size: var(--n-tab-font-size);
 `), wr("disabled", [Y("&:hover", `
 color: var(--n-tab-text-color-hover);
 `)])]), K("closable", "padding-right: 8px;"), K("active", `
 background-color: #0000;
 font-weight: var(--n-tab-font-weight-active);
 color: var(--n-tab-text-color-active);
 `), K("disabled", "color: var(--n-tab-text-color-disabled);")]), L("tabs-scroll-padding", "border-bottom: 1px solid var(--n-tab-border-color);")]), K("left, right", [L("tabs-wrapper", `
 flex-direction: column;
 `, [L("tabs-tab-wrapper", `
 flex-direction: column;
 `, [L("tabs-tab-pad", `
 height: var(--n-tab-gap-vertical);
 width: 100%;
 `)])])]), K("top", [K("card-type", [L("tabs-tab", `
 border-top-left-radius: var(--n-tab-border-radius);
 border-top-right-radius: var(--n-tab-border-radius);
 `, [K("active", `
 border-bottom: 1px solid #0000;
 `)]), L("tabs-tab-pad", `
 border-bottom: 1px solid var(--n-tab-border-color);
 `)])]), K("left", [K("card-type", [L("tabs-tab", `
 border-top-left-radius: var(--n-tab-border-radius);
 border-bottom-left-radius: var(--n-tab-border-radius);
 `, [K("active", `
 border-right: 1px solid #0000;
 `)]), L("tabs-tab-pad", `
 border-right: 1px solid var(--n-tab-border-color);
 `)])]), K("right", [K("card-type", [L("tabs-tab", `
 border-top-right-radius: var(--n-tab-border-radius);
 border-bottom-right-radius: var(--n-tab-border-radius);
 `, [K("active", `
 border-left: 1px solid #0000;
 `)]), L("tabs-tab-pad", `
 border-left: 1px solid var(--n-tab-border-color);
 `)])]), K("bottom", [K("card-type", [L("tabs-tab", `
 border-bottom-left-radius: var(--n-tab-border-radius);
 border-bottom-right-radius: var(--n-tab-border-radius);
 `, [K("active", `
 border-top: 1px solid #0000;
 `)]), L("tabs-tab-pad", `
 border-top: 1px solid var(--n-tab-border-color);
 `)])])])]);
const Xxe = Object.assign(Object.assign({}, ft.props), {
  value: [String, Number],
  defaultValue: [String, Number],
  trigger: {
    type: String,
    default: "click"
  },
  type: {
    type: String,
    default: "bar"
  },
  closable: Boolean,
  justifyContent: String,
  size: {
    type: String,
    default: "medium"
  },
  placement: {
    type: String,
    default: "top"
  },
  tabStyle: [String, Object],
  barWidth: Number,
  paneClass: String,
  paneStyle: [String, Object],
  paneWrapperClass: String,
  paneWrapperStyle: [String, Object],
  addable: [Boolean, Object],
  tabsPadding: {
    type: Number,
    default: 0
  },
  animated: Boolean,
  onBeforeLeave: Function,
  onAdd: Function,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onClose: [Function, Array],
  labelSize: String,
  activeName: [String, Number],
  onActiveNameChange: [Function, Array]
});
var Jxe = oe({
  name: "Tabs",
  props: Xxe,
  setup(e, { slots: t }) {
    var r, n, i, o;
    const { mergedClsPrefixRef: a, inlineThemeDisabled: s } = Yt(e), u = ft("Tabs", "-tabs", Kxe, O1e, e, a), d = G(null), f = G(null), h = G(null), g = G(null), m = G(null), v = G(!0), w = G(!0), x = pp(e, ["labelSize", "size"]), y = pp(e, ["activeName", "value"]), C = G((n = (r = y.value) !== null && r !== void 0 ? r : e.defaultValue) !== null && n !== void 0 ? n : t.default ? (o = (i = ms(t.default())[0]) === null || i === void 0 ? void 0 : i.props) === null || o === void 0 ? void 0 : o.name : null), S = dn(y, C), T = { id: 0 }, A = j(() => {
      if (!(!e.justifyContent || e.type === "card"))
        return {
          display: "flex",
          justifyContent: e.justifyContent
        };
    });
    Gt(S, () => {
      T.id = 0, I(), $();
    });
    function D() {
      var W;
      const { value: P } = S;
      return P === null ? null : (W = d.value) === null || W === void 0 ? void 0 : W.querySelector(`[data-name="${P}"]`);
    }
    function E(W) {
      if (e.type === "card")
        return;
      const { value: P } = f;
      if (P && W) {
        const H = `${a.value}-tabs-bar--disabled`, { barWidth: se, placement: pe } = e;
        if (W.dataset.disabled === "true" ? P.classList.add(H) : P.classList.remove(H), ["top", "bottom"].includes(pe)) {
          if (N(["top", "maxHeight", "height"]), typeof se == "number" && W.offsetWidth >= se) {
            const ae = Math.floor((W.offsetWidth - se) / 2) + W.offsetLeft;
            P.style.left = `${ae}px`, P.style.maxWidth = `${se}px`;
          } else
            P.style.left = `${W.offsetLeft}px`, P.style.maxWidth = `${W.offsetWidth}px`;
          P.style.width = "8192px", P.offsetWidth;
        } else {
          if (N(["left", "maxWidth", "width"]), typeof se == "number" && W.offsetHeight >= se) {
            const ae = Math.floor((W.offsetHeight - se) / 2) + W.offsetTop;
            P.style.top = `${ae}px`, P.style.maxHeight = `${se}px`;
          } else
            P.style.top = `${W.offsetTop}px`, P.style.maxHeight = `${W.offsetHeight}px`;
          P.style.height = "8192px", P.offsetHeight;
        }
      }
    }
    function N(W) {
      const { value: P } = f;
      if (P)
        for (const H of W)
          P.style[H] = "";
    }
    function I() {
      if (e.type === "card")
        return;
      const W = D();
      W && E(W);
    }
    function $(W) {
      var P;
      const H = (P = m.value) === null || P === void 0 ? void 0 : P.$el;
      if (!H)
        return;
      const se = D();
      if (!se)
        return;
      const { scrollLeft: pe, offsetWidth: ae } = H, { offsetLeft: Me, offsetWidth: fe } = se;
      pe > Me ? H.scrollTo({
        top: 0,
        left: Me,
        behavior: "smooth"
      }) : Me + fe > pe + ae && H.scrollTo({
        top: 0,
        left: Me + fe - ae,
        behavior: "smooth"
      });
    }
    const _ = G(null);
    let R = 0, U = null;
    function Q(W) {
      const P = _.value;
      if (P) {
        R = W.getBoundingClientRect().height;
        const H = `${R}px`, se = () => {
          P.style.height = H, P.style.maxHeight = H;
        };
        U ? (se(), U(), U = null) : U = se;
      }
    }
    function Z(W) {
      const P = _.value;
      if (P) {
        const H = W.getBoundingClientRect().height, se = () => {
          document.body.offsetHeight, P.style.maxHeight = `${H}px`, P.style.height = `${Math.max(R, H)}px`;
        };
        U ? (U(), U = null, se()) : U = se;
      }
    }
    function X() {
      const W = _.value;
      W && (W.style.maxHeight = "", W.style.height = "");
    }
    const re = { value: [] }, ue = G("next");
    function he(W) {
      const P = S.value;
      let H = "next";
      for (const se of re.value) {
        if (se === P)
          break;
        if (se === W) {
          H = "prev";
          break;
        }
      }
      ue.value = H, te(W);
    }
    function te(W) {
      const { onActiveNameChange: P, onUpdateValue: H, "onUpdate:value": se } = e;
      P && je(P, W), H && je(H, W), se && je(se, W), C.value = W;
    }
    function de(W) {
      const { onClose: P } = e;
      P && je(P, W);
    }
    function De() {
      const { value: W } = f;
      if (!W)
        return;
      const P = "transition-disabled";
      W.classList.add(P), I(), W.classList.remove(P);
    }
    let Oe = 0;
    function Qe(W) {
      var P;
      if (W.contentRect.width === 0 && W.contentRect.height === 0 || Oe === W.contentRect.width)
        return;
      Oe = W.contentRect.width;
      const { type: H } = e;
      (H === "line" || H === "bar") && De(), H !== "segment" && Ee((P = m.value) === null || P === void 0 ? void 0 : P.$el);
    }
    const Ae = II(Qe, 64);
    Gt([() => e.justifyContent, () => e.size], () => {
      an(() => {
        const { type: W } = e;
        (W === "line" || W === "bar") && De();
      });
    });
    const Ne = G(!1);
    function $e(W) {
      var P;
      const { target: H, contentRect: { width: se } } = W, pe = H.parentElement.offsetWidth;
      if (!Ne.value)
        pe < se && (Ne.value = !0);
      else {
        const { value: ae } = g;
        if (!ae)
          return;
        pe - se > ae.$el.offsetWidth && (Ne.value = !1);
      }
      Ee((P = m.value) === null || P === void 0 ? void 0 : P.$el);
    }
    const et = II($e, 64);
    function Ge() {
      const { onAdd: W } = e;
      W && W(), an(() => {
        const P = D(), { value: H } = m;
        !P || !H || H.scrollTo({
          left: P.offsetLeft,
          top: 0,
          behavior: "smooth"
        });
      });
    }
    function Ee(W) {
      if (!W)
        return;
      const { placement: P } = e;
      if (P === "top" || P === "bottom") {
        const { scrollLeft: H, scrollWidth: se, offsetWidth: pe } = W;
        v.value = H <= 0, w.value = H + pe >= se;
      } else {
        const { scrollTop: H, scrollHeight: se, offsetHeight: pe } = W;
        v.value = H <= 0, w.value = H + pe >= se;
      }
    }
    const qe = II((W) => {
      Ee(W.target);
    }, 64);
    tr(G4, {
      triggerRef: tt(e, "trigger"),
      tabStyleRef: tt(e, "tabStyle"),
      paneClassRef: tt(e, "paneClass"),
      paneStyleRef: tt(e, "paneStyle"),
      mergedClsPrefixRef: a,
      typeRef: tt(e, "type"),
      closableRef: tt(e, "closable"),
      valueRef: S,
      tabChangeIdRef: T,
      onBeforeLeaveRef: tt(e, "onBeforeLeave"),
      activateTab: he,
      handleClose: de,
      handleAdd: Ge
    }), CU(() => {
      I(), $();
    }), On(() => {
      const { value: W } = h;
      if (!W)
        return;
      const { value: P } = a, H = `${P}-tabs-nav-scroll-wrapper--shadow-start`, se = `${P}-tabs-nav-scroll-wrapper--shadow-end`;
      v.value ? W.classList.remove(H) : W.classList.add(H), w.value ? W.classList.remove(se) : W.classList.add(se);
    });
    const Ue = G(null);
    Gt(S, () => {
      if (e.type === "segment") {
        const W = Ue.value;
        W && an(() => {
          W.classList.add("transition-disabled"), W.offsetWidth, W.classList.remove("transition-disabled");
        });
      }
    });
    const ot = {
      syncBarPosition: () => {
        I();
      }
    }, Ie = j(() => {
      const { value: W } = x, { type: P } = e, H = {
        card: "Card",
        bar: "Bar",
        line: "Line",
        segment: "Segment"
      }[P], se = `${W}${H}`, { self: { barColor: pe, closeIconColor: ae, closeIconColorHover: Me, closeIconColorPressed: fe, tabColor: ke, tabBorderColor: Le, paneTextColor: dt, tabFontWeight: Mt, tabBorderRadius: Ct, tabFontWeightActive: er, colorSegment: Vt, fontWeightStrong: jt, tabColorSegment: at, closeSize: St, closeIconSize: ve, closeColorHover: We, closeColorPressed: ne, closeBorderRadius: Se, [Be("panePadding", W)]: _e, [Be("tabPadding", se)]: ut, [Be("tabPaddingVertical", se)]: ht, [Be("tabGap", se)]: ye, [Be("tabGap", `${se}Vertical`)]: Ze, [Be("tabTextColor", P)]: st, [Be("tabTextColorActive", P)]: Nt, [Be("tabTextColorHover", P)]: Te, [Be("tabTextColorDisabled", P)]: Ke, [Be("tabFontSize", W)]: xe }, common: { cubicBezierEaseInOut: Xe } } = u.value;
      return {
        "--n-bezier": Xe,
        "--n-color-segment": Vt,
        "--n-bar-color": pe,
        "--n-tab-font-size": xe,
        "--n-tab-text-color": st,
        "--n-tab-text-color-active": Nt,
        "--n-tab-text-color-disabled": Ke,
        "--n-tab-text-color-hover": Te,
        "--n-pane-text-color": dt,
        "--n-tab-border-color": Le,
        "--n-tab-border-radius": Ct,
        "--n-close-size": St,
        "--n-close-icon-size": ve,
        "--n-close-color-hover": We,
        "--n-close-color-pressed": ne,
        "--n-close-border-radius": Se,
        "--n-close-icon-color": ae,
        "--n-close-icon-color-hover": Me,
        "--n-close-icon-color-pressed": fe,
        "--n-tab-color": ke,
        "--n-tab-font-weight": Mt,
        "--n-tab-font-weight-active": er,
        "--n-tab-padding": ut,
        "--n-tab-padding-vertical": ht,
        "--n-tab-gap": ye,
        "--n-tab-gap-vertical": Ze,
        "--n-pane-padding-left": Ll(_e, "left"),
        "--n-pane-padding-right": Ll(_e, "right"),
        "--n-pane-padding-top": Ll(_e, "top"),
        "--n-pane-padding-bottom": Ll(_e, "bottom"),
        "--n-font-weight-strong": jt,
        "--n-tab-color-segment": at
      };
    }), rt = s ? Cr("tabs", j(() => `${x.value[0]}${e.type[0]}`), Ie, e) : void 0;
    return Object.assign({
      mergedClsPrefix: a,
      mergedValue: S,
      renderedNames: /* @__PURE__ */ new Set(),
      tabsRailElRef: Ue,
      tabsPaneWrapperRef: _,
      tabsElRef: d,
      barElRef: f,
      addTabInstRef: g,
      xScrollInstRef: m,
      scrollWrapperElRef: h,
      addTabFixed: Ne,
      tabWrapperStyle: A,
      handleNavResize: Ae,
      mergedSize: x,
      handleScroll: qe,
      handleTabsResize: et,
      cssVars: s ? void 0 : Ie,
      themeClass: rt == null ? void 0 : rt.themeClass,
      animationDirection: ue,
      renderNameListRef: re,
      onAnimationBeforeLeave: Q,
      onAnimationEnter: Z,
      onAnimationAfterEnter: X,
      onRender: rt == null ? void 0 : rt.onRender
    }, ot);
  },
  render() {
    const { mergedClsPrefix: e, type: t, placement: r, addTabFixed: n, addable: i, mergedSize: o, renderNameListRef: a, onRender: s, paneWrapperClass: u, paneWrapperStyle: d, $slots: { default: f, prefix: h, suffix: g } } = this;
    s == null || s();
    const m = f ? ms(f()).filter((A) => A.type.__TAB_PANE__ === !0) : [], v = f ? ms(f()).filter((A) => A.type.__TAB__ === !0) : [], w = !v.length, x = t === "card", y = t === "segment", C = !x && !y && this.justifyContent;
    a.value = [];
    const S = () => {
      const A = b("div", { style: this.tabWrapperStyle, class: [`${e}-tabs-wrapper`] }, C ? null : b("div", { class: `${e}-tabs-scroll-padding`, style: { width: `${this.tabsPadding}px` } }), w ? m.map((D, E) => (a.value.push(D.props.name), l2(b(fx, Object.assign({}, D.props, { internalCreatedByPane: !0, internalLeftPadded: E !== 0 && (!C || C === "center" || C === "start" || C === "end") }), D.children ? {
        default: D.children.tab
      } : void 0)))) : v.map((D, E) => (a.value.push(D.props.name), l2(E !== 0 && !C ? OR(D) : D))), !n && i && x ? $R(i, (w ? m.length : v.length) !== 0) : null, C ? null : b("div", { class: `${e}-tabs-scroll-padding`, style: { width: `${this.tabsPadding}px` } }));
      return b("div", { ref: "tabsElRef", class: `${e}-tabs-nav-scroll-content` }, x && i ? b(Hl, { onResize: this.handleTabsResize }, {
        default: () => A
      }) : A, x ? b("div", { class: `${e}-tabs-pad` }) : null, x ? null : b("div", { ref: "barElRef", class: `${e}-tabs-bar` }));
    }, T = y ? "top" : r;
    return b("div", { class: [
      `${e}-tabs`,
      this.themeClass,
      `${e}-tabs--${t}-type`,
      `${e}-tabs--${o}-size`,
      C && `${e}-tabs--flex`,
      `${e}-tabs--${T}`
    ], style: this.cssVars }, b("div", { class: [
      `${e}-tabs-nav--${t}-type`,
      `${e}-tabs-nav--${T}`,
      `${e}-tabs-nav`
    ] }, Fr(h, (A) => A && b("div", { class: `${e}-tabs-nav__prefix` }, A)), y ? b("div", { class: `${e}-tabs-rail`, ref: "tabsRailElRef" }, w ? m.map((A, D) => (a.value.push(A.props.name), b(fx, Object.assign({}, A.props, { internalCreatedByPane: !0, internalLeftPadded: D !== 0 }), A.children ? {
      default: A.children.tab
    } : void 0))) : v.map((A, D) => (a.value.push(A.props.name), D === 0 ? A : OR(A)))) : b(Hl, { onResize: this.handleNavResize }, {
      default: () => b("div", { class: `${e}-tabs-nav-scroll-wrapper`, ref: "scrollWrapperElRef" }, ["top", "bottom"].includes(T) ? b(pJ, { ref: "xScrollInstRef", onScroll: this.handleScroll }, {
        default: S
      }) : b("div", { class: `${e}-tabs-nav-y-scroll`, onScroll: this.handleScroll }, S()))
    }), n && i && x ? $R(i, !0) : null, Fr(g, (A) => A && b("div", { class: `${e}-tabs-nav__suffix` }, A))), w && (this.animated && (T === "top" || T === "bottom") ? b("div", { ref: "tabsPaneWrapperRef", style: d, class: [`${e}-tabs-pane-wrapper`, u] }, zR(m, this.mergedValue, this.renderedNames, this.onAnimationBeforeLeave, this.onAnimationEnter, this.onAnimationAfterEnter, this.animationDirection)) : zR(m, this.mergedValue, this.renderedNames)));
  }
});
function zR(e, t, r, n, i, o, a) {
  const s = [];
  return e.forEach((u) => {
    const { name: d, displayDirective: f, "display-directive": h } = u.props, g = (v) => f === v || h === v, m = t === d;
    if (u.key !== void 0 && (u.key = d), m || g("show") || g("show:lazy") && r.has(d)) {
      r.has(d) || r.add(d);
      const v = !g("if");
      s.push(v ? Jn(u, [[Ra, m]]) : u);
    }
  }), a ? b(jO, { name: `${a}-transition`, onBeforeLeave: n, onEnter: i, onAfterEnter: o }, { default: () => s }) : s;
}
function $R(e, t) {
  return b(fx, { ref: "addTabInstRef", key: "__addable", name: "__addable", internalCreatedByPane: !0, internalAddable: !0, internalLeftPadded: t, disabled: typeof e == "object" && e.disabled });
}
function OR(e) {
  const t = db(e);
  return t.props ? t.props.internalLeftPadded = !0 : t.props = {
    internalLeftPadded: !0
  }, t;
}
function l2(e) {
  return Array.isArray(e.dynamicProps) ? e.dynamicProps.includes("internalLeftPadded") || e.dynamicProps.push("internalLeftPadded") : e.dynamicProps = ["internalLeftPadded"], e;
}
const Yp = "n-upload", RW = "__UPLOAD_DRAGGER__";
var jW = oe({
  name: "UploadDragger",
  [RW]: !0,
  setup(e, { slots: t }) {
    const r = lt(Yp, null);
    return r || Ql("upload-dragger", "`n-upload-dragger` must be placed inside `n-upload`."), () => {
      const { mergedClsPrefixRef: { value: n }, mergedDisabledRef: { value: i }, maxReachedRef: { value: o } } = r;
      return b("div", { class: [
        `${n}-upload-dragger`,
        (i || o) && `${n}-upload-dragger--disabled`
      ] }, t);
    };
  }
}), FW = globalThis && globalThis.__awaiter || function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function s(f) {
      try {
        d(n.next(f));
      } catch (h) {
        a(h);
      }
    }
    function u(f) {
      try {
        d(n.throw(f));
      } catch (h) {
        a(h);
      }
    }
    function d(f) {
      f.done ? o(f.value) : i(f.value).then(s, u);
    }
    d((n = n.apply(e, t || [])).next());
  });
};
const BW = (e) => e.includes("image/"), _R = (e = "") => {
  const t = e.split("/"), n = t[t.length - 1].split(/#|\?/)[0];
  return (/\.[^./\\]*$/.exec(n) || [""])[0];
}, LR = /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico)$/i, UW = (e) => {
  if (e.type)
    return BW(e.type);
  const t = _R(e.name || "");
  if (LR.test(t))
    return !0;
  const r = e.thumbnailUrl || e.url || "", n = _R(r);
  return !!(/^data:image\//.test(r) || LR.test(n));
};
function ewe(e) {
  return FW(this, void 0, void 0, function* () {
    return yield new Promise((t) => {
      if (!e.type || !BW(e.type)) {
        t("");
        return;
      }
      t(window.URL.createObjectURL(e));
    });
  });
}
const twe = Is && window.FileReader && window.File;
function rwe(e) {
  return e.isDirectory;
}
function nwe(e) {
  return e.isFile;
}
function iwe(e, t) {
  return FW(this, void 0, void 0, function* () {
    const r = [];
    let n, i = 0;
    function o() {
      i++;
    }
    function a() {
      i--, i || n(r);
    }
    function s(u) {
      u.forEach((d) => {
        if (d) {
          if (o(), t && rwe(d)) {
            const f = d.createReader();
            o(), f.readEntries((h) => {
              s(h), a();
            }, () => {
              a();
            });
          } else
            nwe(d) && (o(), d.file((f) => {
              r.push({ file: f, entry: d, source: "dnd" }), a();
            }, () => {
              a();
            }));
          a();
        }
      });
    }
    return yield new Promise((u) => {
      n = u, s(e);
    }), r;
  });
}
function O0(e) {
  const { id: t, name: r, percentage: n, status: i, url: o, file: a, thumbnailUrl: s, type: u, fullPath: d, batchId: f } = e;
  return {
    id: t,
    name: r,
    percentage: n ?? null,
    status: i,
    url: o ?? null,
    file: a ?? null,
    thumbnailUrl: s ?? null,
    type: u ?? null,
    fullPath: d ?? null,
    batchId: f ?? null
  };
}
function owe(e, t, r) {
  return e = e.toLowerCase(), t = t.toLocaleLowerCase(), r = r.toLocaleLowerCase(), r.split(",").map((i) => i.trim()).filter(Boolean).some((i) => {
    if (i.startsWith(".")) {
      if (e.endsWith(i))
        return !0;
    } else if (i.includes("/")) {
      const [o, a] = t.split("/"), [s, u] = i.split("/");
      if ((s === "*" || o && s && s === o) && (u === "*" || a && u && u === a))
        return !0;
    } else
      return !0;
    return !1;
  });
}
const awe = (e, t) => {
  if (!e)
    return;
  const r = document.createElement("a");
  r.href = e, t !== void 0 && (r.download = t), document.body.appendChild(r), r.click(), document.body.removeChild(r);
};
var HW = oe({
  name: "UploadTrigger",
  props: {
    abstract: Boolean
  },
  setup(e, { slots: t }) {
    const r = lt(Yp, null);
    r || Ql("upload-trigger", "`n-upload-trigger` must be placed inside `n-upload`.");
    const { mergedClsPrefixRef: n, mergedDisabledRef: i, maxReachedRef: o, listTypeRef: a, dragOverRef: s, openOpenFileDialog: u, draggerInsideRef: d, handleFileAddition: f, mergedDirectoryDndRef: h, triggerStyleRef: g } = r, m = j(() => a.value === "image-card");
    function v() {
      i.value || o.value || u();
    }
    function w(S) {
      S.preventDefault(), s.value = !0;
    }
    function x(S) {
      S.preventDefault(), s.value = !0;
    }
    function y(S) {
      S.preventDefault(), s.value = !1;
    }
    function C(S) {
      var T;
      if (S.preventDefault(), !d.value || i.value || o.value) {
        s.value = !1;
        return;
      }
      const A = (T = S.dataTransfer) === null || T === void 0 ? void 0 : T.items;
      A != null && A.length ? iwe(Array.from(A).map((D) => D.webkitGetAsEntry()), h.value).then((D) => {
        f(D);
      }).finally(() => {
        s.value = !1;
      }) : s.value = !1;
    }
    return () => {
      var S;
      const { value: T } = n;
      return e.abstract ? (S = t.default) === null || S === void 0 ? void 0 : S.call(t, {
        handleClick: v,
        handleDrop: C,
        handleDragOver: w,
        handleDragEnter: x,
        handleDragLeave: y
      }) : b("div", { class: [
        `${T}-upload-trigger`,
        (i.value || o.value) && `${T}-upload-trigger--disabled`,
        m.value && `${T}-upload-trigger--image-card`
      ], style: g.value, onClick: v, onDrop: C, onDragover: w, onDragenter: x, onDragleave: y }, m.value ? b(jW, null, {
        default: () => vr(t.default, () => [
          b(fr, { clsPrefix: T }, { default: () => b(FM, null) })
        ])
      }) : t);
    };
  }
}), lwe = oe({
  name: "UploadProgress",
  props: {
    show: Boolean,
    percentage: {
      type: Number,
      required: !0
    },
    status: {
      type: String,
      required: !0
    }
  },
  setup() {
    return {
      mergedTheme: lt(Yp).mergedThemeRef
    };
  },
  render() {
    return b(ph, null, {
      default: () => this.show ? b(_W, { type: "line", showIndicator: !1, percentage: this.percentage, status: this.status, height: 2, theme: this.mergedTheme.peers.Progress, themeOverrides: this.mergedTheme.peerOverrides.Progress }) : null
    });
  }
});
const swe = b("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 28" }, b("g", { fill: "none" }, b("path", { d: "M21.75 3A3.25 3.25 0 0 1 25 6.25v15.5A3.25 3.25 0 0 1 21.75 25H6.25A3.25 3.25 0 0 1 3 21.75V6.25A3.25 3.25 0 0 1 6.25 3h15.5zm.583 20.4l-7.807-7.68a.75.75 0 0 0-.968-.07l-.084.07l-7.808 7.68c.183.065.38.1.584.1h15.5c.204 0 .4-.035.583-.1l-7.807-7.68l7.807 7.68zM21.75 4.5H6.25A1.75 1.75 0 0 0 4.5 6.25v15.5c0 .208.036.408.103.593l7.82-7.692a2.25 2.25 0 0 1 3.026-.117l.129.117l7.82 7.692c.066-.185.102-.385.102-.593V6.25a1.75 1.75 0 0 0-1.75-1.75zm-3.25 3a2.5 2.5 0 1 1 0 5a2.5 2.5 0 0 1 0-5zm0 1.5a1 1 0 1 0 0 2a1 1 0 0 0 0-2z", fill: "currentColor" }))), uwe = b("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 28" }, b("g", { fill: "none" }, b("path", { d: "M6.4 2A2.4 2.4 0 0 0 4 4.4v19.2A2.4 2.4 0 0 0 6.4 26h15.2a2.4 2.4 0 0 0 2.4-2.4V11.578c0-.729-.29-1.428-.805-1.944l-6.931-6.931A2.4 2.4 0 0 0 14.567 2H6.4zm-.9 2.4a.9.9 0 0 1 .9-.9H14V10a2 2 0 0 0 2 2h6.5v11.6a.9.9 0 0 1-.9.9H6.4a.9.9 0 0 1-.9-.9V4.4zm16.44 6.1H16a.5.5 0 0 1-.5-.5V4.06l6.44 6.44z", fill: "currentColor" })));
var cwe = globalThis && globalThis.__awaiter || function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function s(f) {
      try {
        d(n.next(f));
      } catch (h) {
        a(h);
      }
    }
    function u(f) {
      try {
        d(n.throw(f));
      } catch (h) {
        a(h);
      }
    }
    function d(f) {
      f.done ? o(f.value) : i(f.value).then(s, u);
    }
    d((n = n.apply(e, t || [])).next());
  });
};
const by = {
  paddingMedium: "0 3px",
  heightMedium: "24px",
  iconSizeMedium: "18px"
};
var dwe = oe({
  name: "UploadFile",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    file: {
      type: Object,
      required: !0
    },
    listType: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = lt(Yp), r = G(null), n = G(""), i = j(() => {
      const { file: A } = e;
      return A.status === "finished" ? "success" : A.status === "error" ? "error" : "info";
    }), o = j(() => {
      const { file: A } = e;
      if (A.status === "error")
        return "error";
    }), a = j(() => {
      const { file: A } = e;
      return A.status === "uploading";
    }), s = j(() => {
      if (!t.showCancelButtonRef.value)
        return !1;
      const { file: A } = e;
      return ["uploading", "pending", "error"].includes(A.status);
    }), u = j(() => {
      if (!t.showRemoveButtonRef.value)
        return !1;
      const { file: A } = e;
      return ["finished"].includes(A.status);
    }), d = j(() => {
      if (!t.showDownloadButtonRef.value)
        return !1;
      const { file: A } = e;
      return ["finished"].includes(A.status);
    }), f = j(() => {
      if (!t.showRetryButtonRef.value)
        return !1;
      const { file: A } = e;
      return ["error"].includes(A.status);
    }), h = _r(() => n.value || e.file.thumbnailUrl || e.file.url), g = j(() => {
      if (!t.showPreviewButtonRef.value)
        return !1;
      const { file: { status: A }, listType: D } = e;
      return ["finished"].includes(A) && h.value && D === "image-card";
    });
    function m() {
      t.submit(e.file.id);
    }
    function v(A) {
      A.preventDefault();
      const { file: D } = e;
      ["finished", "pending", "error"].includes(D.status) ? x(D) : ["uploading"].includes(D.status) ? C(D) : ja("upload", "The button clicked type is unknown.");
    }
    function w(A) {
      A.preventDefault(), y(e.file);
    }
    function x(A) {
      const { xhrMap: D, doChange: E, onRemoveRef: { value: N }, mergedFileListRef: { value: I } } = t;
      Promise.resolve(N ? N({
        file: Object.assign({}, A),
        fileList: I
      }) : !0).then(($) => {
        if ($ === !1)
          return;
        const _ = Object.assign({}, A, {
          status: "removed"
        });
        D.delete(A.id), E(_, void 0, {
          remove: !0
        });
      });
    }
    function y(A) {
      const { onDownloadRef: { value: D } } = t;
      Promise.resolve(D ? D(Object.assign({}, A)) : !0).then((E) => {
        E !== !1 && awe(A.url, A.name);
      });
    }
    function C(A) {
      const { xhrMap: D } = t, E = D.get(A.id);
      E == null || E.abort(), x(Object.assign({}, A));
    }
    function S() {
      const { onPreviewRef: { value: A } } = t;
      if (A)
        A(e.file);
      else if (e.listType === "image-card") {
        const { value: D } = r;
        if (!D)
          return;
        D.click();
      }
    }
    const T = () => cwe(this, void 0, void 0, function* () {
      const { listType: A } = e;
      A !== "image" && A !== "image-card" || t.shouldUseThumbnailUrlRef.value(e.file) && (n.value = yield t.getFileThumbnailUrlResolver(e.file));
    });
    return On(() => {
      T();
    }), {
      mergedTheme: t.mergedThemeRef,
      progressStatus: i,
      buttonType: o,
      showProgress: a,
      disabled: t.mergedDisabledRef,
      showCancelButton: s,
      showRemoveButton: u,
      showDownloadButton: d,
      showRetryButton: f,
      showPreviewButton: g,
      mergedThumbnailUrl: h,
      shouldUseThumbnailUrl: t.shouldUseThumbnailUrlRef,
      renderIcon: t.renderIconRef,
      imageRef: r,
      handleRemoveOrCancelClick: v,
      handleDownloadClick: w,
      handleRetryClick: m,
      handlePreviewClick: S
    };
  },
  render() {
    const { clsPrefix: e, mergedTheme: t, listType: r, file: n, renderIcon: i } = this;
    let o;
    const a = r === "image";
    a || r === "image-card" ? o = !this.shouldUseThumbnailUrl(n) || !this.mergedThumbnailUrl ? b("span", { class: `${e}-upload-file-info__thumbnail` }, i ? i(n) : UW(n) ? b(fr, { clsPrefix: e }, { default: () => swe }) : b(fr, { clsPrefix: e }, { default: () => uwe })) : b("a", { rel: "noopener noreferer", target: "_blank", href: n.url || void 0, class: `${e}-upload-file-info__thumbnail`, onClick: this.handlePreviewClick }, r === "image-card" ? b(V1e, { src: this.mergedThumbnailUrl || void 0, previewSrc: n.url || void 0, alt: n.name, ref: "imageRef" }) : b("img", { src: this.mergedThumbnailUrl || void 0, alt: n.name })) : o = b("span", { class: `${e}-upload-file-info__thumbnail` }, i ? i(n) : b(fr, { clsPrefix: e }, { default: () => b(gfe, null) }));
    const u = b(lwe, { show: this.showProgress, percentage: n.percentage || 0, status: this.progressStatus }), d = r === "text" || r === "image";
    return b("div", { class: [
      `${e}-upload-file`,
      `${e}-upload-file--${this.progressStatus}-status`,
      n.url && n.status !== "error" && r !== "image-card" && `${e}-upload-file--with-url`,
      `${e}-upload-file--${r}-type`
    ] }, b("div", { class: `${e}-upload-file-info` }, o, b("div", { class: `${e}-upload-file-info__name` }, d && (n.url && n.status !== "error" ? b("a", { rel: "noopener noreferer", target: "_blank", href: n.url || void 0, onClick: this.handlePreviewClick }, n.name) : b("span", { onClick: this.handlePreviewClick }, n.name)), a && u), b("div", { class: [
      `${e}-upload-file-info__action`,
      `${e}-upload-file-info__action--${r}-type`
    ] }, this.showPreviewButton ? b(Mn, { key: "preview", quaternary: !0, type: this.buttonType, onClick: this.handlePreviewClick, theme: t.peers.Button, themeOverrides: t.peerOverrides.Button, builtinThemeOverrides: by }, {
      icon: () => b(fr, { clsPrefix: e }, { default: () => b(eH, null) })
    }) : null, (this.showRemoveButton || this.showCancelButton) && !this.disabled && b(Mn, { key: "cancelOrTrash", theme: t.peers.Button, themeOverrides: t.peerOverrides.Button, quaternary: !0, builtinThemeOverrides: by, type: this.buttonType, onClick: this.handleRemoveOrCancelClick }, {
      icon: () => b(Lc, null, {
        default: () => this.showRemoveButton ? b(fr, { clsPrefix: e, key: "trash" }, { default: () => b(bfe, null) }) : b(fr, { clsPrefix: e, key: "cancel" }, { default: () => b(Sfe, null) })
      })
    }), this.showRetryButton && !this.disabled && b(Mn, { key: "retry", quaternary: !0, type: this.buttonType, onClick: this.handleRetryClick, theme: t.peers.Button, themeOverrides: t.peerOverrides.Button, builtinThemeOverrides: by }, {
      icon: () => b(fr, { clsPrefix: e }, { default: () => b(Afe, null) })
    }), this.showDownloadButton ? b(Mn, { key: "download", quaternary: !0, type: this.buttonType, onClick: this.handleDownloadClick, theme: t.peers.Button, themeOverrides: t.peerOverrides.Button, builtinThemeOverrides: by }, {
      icon: () => b(fr, { clsPrefix: e }, { default: () => b(yfe, null) })
    }) : null)), !a && u);
  }
}), fwe = oe({
  name: "UploadFileList",
  setup(e, { slots: t }) {
    const r = lt(Yp, null);
    r || Ql("upload-file-list", "`n-upload-file-list` must be placed inside `n-upload`.");
    const { abstractRef: n, mergedClsPrefixRef: i, listTypeRef: o, mergedFileListRef: a, fileListStyleRef: s, cssVarsRef: u, themeClassRef: d, maxReachedRef: f, showTriggerRef: h, imageGroupPropsRef: g } = r, m = j(() => o.value === "image-card"), v = () => a.value.map((x) => b(dwe, { clsPrefix: i.value, key: x.id, file: x, listType: o.value })), w = () => m.value ? b(H1e, Object.assign({}, g.value), { default: v }) : b(ph, { group: !0 }, {
      default: v
    });
    return () => {
      const { value: x } = i, { value: y } = n;
      return b("div", { class: [
        `${x}-upload-file-list`,
        m.value && `${x}-upload-file-list--grid`,
        y ? d == null ? void 0 : d.value : void 0
      ], style: [
        y && u ? u.value : "",
        s.value
      ] }, w(), h.value && !f.value && m.value && b(HW, null, t));
    };
  }
}), hwe = Y([L("upload", "width: 100%;", [K("dragger-inside", [L("upload-trigger", `
 display: block;
 `)]), K("drag-over", [L("upload-dragger", `
 border: var(--n-dragger-border-hover);
 `)])]), L("upload-dragger", `
 cursor: pointer;
 box-sizing: border-box;
 width: 100%;
 text-align: center;
 border-radius: var(--n-border-radius);
 padding: 24px;
 opacity: 1;
 transition:
 opacity .3s var(--n-bezier),
 border-color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 background-color: var(--n-dragger-color);
 border: var(--n-dragger-border);
 `, [Y("&:hover", `
 border: var(--n-dragger-border-hover);
 `), K("disabled", `
 cursor: not-allowed;
 `)]), L("upload-trigger", `
 display: inline-block;
 box-sizing: border-box;
 opacity: 1;
 transition: opacity .3s var(--n-bezier);
 `, [Y("+", [L("upload-file-list", "margin-top: 8px;")]), K("disabled", `
 opacity: var(--n-item-disabled-opacity);
 cursor: not-allowed;
 `), K("image-card", `
 width: 96px;
 height: 96px;
 `, [L("base-icon", `
 font-size: 24px;
 `), L("upload-dragger", `
 padding: 0;
 height: 100%;
 width: 100%;
 display: flex;
 align-items: center;
 justify-content: center;
 `)])]), L("upload-file-list", `
 line-height: var(--n-line-height);
 opacity: 1;
 transition: opacity .3s var(--n-bezier);
 `, [Y("a, img", "outline: none;"), K("disabled", `
 opacity: var(--n-item-disabled-opacity);
 cursor: not-allowed;
 `, [L("upload-file", "cursor: not-allowed;")]), K("grid", `
 display: grid;
 grid-template-columns: repeat(auto-fill, 96px);
 grid-gap: 8px;
 margin-top: 0;
 `), L("upload-file", `
 display: block;
 box-sizing: border-box;
 cursor: default;
 padding: 0px 12px 0 6px;
 transition: background-color .3s var(--n-bezier);
 border-radius: var(--n-border-radius);
 `, [D0(), L("progress", [D0({
  foldPadding: !0
})]), Y("&:hover", `
 background-color: var(--n-item-color-hover);
 `, [L("upload-file-info", [q("action", `
 opacity: 1;
 `)])]), K("image-type", `
 border-radius: var(--n-border-radius);
 text-decoration: underline;
 text-decoration-color: #0000;
 `, [L("upload-file-info", `
 padding-top: 0px;
 padding-bottom: 0px;
 width: 100%;
 height: 100%;
 display: flex;
 justify-content: space-between;
 align-items: center;
 padding: 6px 0;
 `, [L("progress", `
 padding: 2px 0;
 margin-bottom: 0;
 `), q("name", `
 padding: 0 8px;
 `), q("thumbnail", `
 width: 32px;
 height: 32px;
 font-size: 28px;
 display: flex;
 justify-content: center;
 align-items: center;
 `, [Y("img", `
 width: 100%;
 `)])])]), K("text-type", [L("progress", `
 box-sizing: border-box;
 padding-bottom: 6px;
 margin-bottom: 6px;
 `)]), K("image-card-type", `
 position: relative;
 width: 96px;
 height: 96px;
 border: var(--n-item-border-image-card);
 border-radius: var(--n-border-radius);
 padding: 0;
 display: flex;
 align-items: center;
 justify-content: center;
 transition: border-color .3s var(--n-bezier), background-color .3s var(--n-bezier);
 border-radius: var(--n-border-radius);
 overflow: hidden;
 `, [L("progress", `
 position: absolute;
 left: 8px;
 bottom: 8px;
 right: 8px;
 width: unset;
 `), L("upload-file-info", `
 padding: 0;
 width: 100%;
 height: 100%;
 `, [q("thumbnail", `
 width: 100%;
 height: 100%;
 display: flex;
 flex-direction: column;
 align-items: center;
 justify-content: center;
 font-size: 36px;
 `, [Y("img", `
 width: 100%;
 `)])]), Y("&::before", `
 position: absolute;
 z-index: 1;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border-radius: inherit;
 opacity: 0;
 transition: opacity .2s var(--n-bezier);
 content: "";
 `), Y("&:hover", [Y("&::before", "opacity: 1;"), L("upload-file-info", [q("thumbnail", "opacity: .12;")])])]), K("error-status", [Y("&:hover", `
 background-color: var(--n-item-color-hover-error);
 `), L("upload-file-info", [q("name", "color: var(--n-item-text-color-error);"), q("thumbnail", "color: var(--n-item-text-color-error);")]), K("image-card-type", `
 border: var(--n-item-border-image-card-error);
 `)]), K("with-url", `
 cursor: pointer;
 `, [L("upload-file-info", [q("name", `
 color: var(--n-item-text-color-success);
 text-decoration-color: var(--n-item-text-color-success);
 `, [Y("a", `
 text-decoration: underline;
 `)])])]), L("upload-file-info", `
 position: relative;
 padding-top: 6px;
 padding-bottom: 6px;
 display: flex;
 flex-wrap: nowrap;
 `, [q("thumbnail", `
 font-size: 18px;
 opacity: 1;
 transition: opacity .2s var(--n-bezier);
 color: var(--n-item-icon-color);
 `, [L("base-icon", `
 margin-right: 2px;
 vertical-align: middle;
 transition: color .3s var(--n-bezier);
 `)]), q("action", `
 padding-top: inherit;
 padding-bottom: inherit;
 position: absolute;
 right: 0;
 top: 0;
 bottom: 0;
 width: 80px;
 display: flex;
 align-items: center;
 transition: opacity .2s var(--n-bezier);
 justify-content: flex-end;
 opacity: 0;
 `, [L("button", [Y("&:not(:last-child)", {
  marginRight: "4px"
}), L("base-icon", [Y("svg", [Io()])])]), K("image-type", `
 position: relative;
 max-width: 80px;
 width: auto;
 `), K("image-card-type", `
 z-index: 2;
 position: absolute;
 width: 100%;
 height: 100%;
 left: 0;
 right: 0;
 bottom: 0;
 top: 0;
 display: flex;
 justify-content: center;
 align-items: center;
 `)]), q("name", `
 color: var(--n-item-text-color);
 flex: 1;
 display: flex;
 justify-content: center;
 text-overflow: ellipsis;
 overflow: hidden;
 flex-direction: column;
 text-decoration-color: #0000;
 font-size: var(--n-font-size);
 transition:
 color .3s var(--n-bezier),
 text-decoration-color .3s var(--n-bezier); 
 `, [Y("a", `
 color: inherit;
 text-decoration: underline;
 `)])])])]), L("upload-file-input", `
 display: block;
 width: 0;
 height: 0;
 opacity: 0;
 `)]), PR = globalThis && globalThis.__awaiter || function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function s(f) {
      try {
        d(n.next(f));
      } catch (h) {
        a(h);
      }
    }
    function u(f) {
      try {
        d(n.throw(f));
      } catch (h) {
        a(h);
      }
    }
    function d(f) {
      f.done ? o(f.value) : i(f.value).then(s, u);
    }
    d((n = n.apply(e, t || [])).next());
  });
};
function pwe(e, t, r) {
  const { doChange: n, xhrMap: i } = e;
  let o = 0;
  function a(u) {
    var d;
    let f = Object.assign({}, t, {
      status: "error",
      percentage: o
    });
    i.delete(t.id), f = O0(((d = e.onError) === null || d === void 0 ? void 0 : d.call(e, { file: f, event: u })) || f), n(f, u);
  }
  function s(u) {
    var d;
    if (e.isErrorState) {
      if (e.isErrorState(r)) {
        a(u);
        return;
      }
    } else if (r.status < 200 || r.status >= 300) {
      a(u);
      return;
    }
    let f = Object.assign({}, t, {
      status: "finished",
      percentage: o
    });
    i.delete(t.id), f = O0(((d = e.onFinish) === null || d === void 0 ? void 0 : d.call(e, { file: f, event: u })) || f), n(f, u);
  }
  return {
    handleXHRLoad: s,
    handleXHRError: a,
    handleXHRAbort(u) {
      const d = Object.assign({}, t, {
        status: "removed",
        file: null,
        percentage: o
      });
      i.delete(t.id), n(d, u);
    },
    handleXHRProgress(u) {
      const d = Object.assign({}, t, {
        status: "uploading"
      });
      if (u.lengthComputable) {
        const f = Math.ceil(u.loaded / u.total * 100);
        d.percentage = f, o = f;
      }
      n(d, u);
    }
  };
}
function gwe(e) {
  const { inst: t, file: r, data: n, headers: i, withCredentials: o, action: a, customRequest: s } = e, { doChange: u } = e.inst;
  let d = 0;
  s({
    file: r,
    data: n,
    headers: i,
    withCredentials: o,
    action: a,
    onProgress(f) {
      const h = Object.assign({}, r, {
        status: "uploading"
      }), g = f.percent;
      h.percentage = g, d = g, u(h);
    },
    onFinish() {
      var f;
      let h = Object.assign({}, r, {
        status: "finished",
        percentage: d
      });
      h = O0(((f = t.onFinish) === null || f === void 0 ? void 0 : f.call(t, { file: h })) || h), u(h);
    },
    onError() {
      var f;
      let h = Object.assign({}, r, {
        status: "error",
        percentage: d
      });
      h = O0(((f = t.onError) === null || f === void 0 ? void 0 : f.call(t, { file: h })) || h), u(h);
    }
  });
}
function mwe(e, t, r) {
  const n = pwe(e, t, r);
  r.onabort = n.handleXHRAbort, r.onerror = n.handleXHRError, r.onload = n.handleXHRLoad, r.upload && (r.upload.onprogress = n.handleXHRProgress);
}
function WW(e, t) {
  return typeof e == "function" ? e({ file: t }) : e || {};
}
function vwe(e, t, r) {
  const n = WW(t, r);
  n && Object.keys(n).forEach((i) => {
    e.setRequestHeader(i, n[i]);
  });
}
function bwe(e, t, r) {
  const n = WW(t, r);
  n && Object.keys(n).forEach((i) => {
    e.append(i, n[i]);
  });
}
function ywe(e, t, r, { method: n, action: i, withCredentials: o, responseType: a, headers: s, data: u }) {
  const d = new XMLHttpRequest();
  d.responseType = a, e.xhrMap.set(r.id, d), d.withCredentials = o;
  const f = new FormData();
  if (bwe(f, u, r), f.append(t, r.file), mwe(e, r, d), i !== void 0) {
    d.open(n.toUpperCase(), i), vwe(d, s, r), d.send(f);
    const h = Object.assign({}, r, {
      status: "uploading"
    });
    e.doChange(h);
  }
}
const xwe = Object.assign(Object.assign({}, ft.props), {
  name: {
    type: String,
    default: "file"
  },
  accept: String,
  action: String,
  customRequest: Function,
  directory: Boolean,
  directoryDnd: { type: Boolean, default: void 0 },
  method: {
    type: String,
    default: "POST"
  },
  multiple: Boolean,
  showFileList: {
    type: Boolean,
    default: !0
  },
  data: [Object, Function],
  headers: [Object, Function],
  withCredentials: Boolean,
  responseType: {
    type: String,
    default: ""
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  onChange: Function,
  onRemove: Function,
  onFinish: Function,
  onError: Function,
  onBeforeUpload: Function,
  isErrorState: Function,
  onDownload: Function,
  defaultUpload: {
    type: Boolean,
    default: !0
  },
  fileList: Array,
  "onUpdate:fileList": [Function, Array],
  onUpdateFileList: [Function, Array],
  fileListStyle: [String, Object],
  defaultFileList: {
    type: Array,
    default: () => []
  },
  showCancelButton: {
    type: Boolean,
    default: !0
  },
  showRemoveButton: {
    type: Boolean,
    default: !0
  },
  showDownloadButton: Boolean,
  showRetryButton: {
    type: Boolean,
    default: !0
  },
  showPreviewButton: {
    type: Boolean,
    default: !0
  },
  listType: {
    type: String,
    default: "text"
  },
  onPreview: Function,
  shouldUseThumbnailUrl: {
    type: Function,
    default: (e) => twe ? UW(e) : !1
  },
  createThumbnailUrl: Function,
  abstract: Boolean,
  max: Number,
  showTrigger: {
    type: Boolean,
    default: !0
  },
  imageGroupProps: Object,
  inputProps: Object,
  triggerStyle: [String, Object],
  renderIcon: Object
});
var wwe = oe({
  name: "Upload",
  props: xwe,
  setup(e) {
    e.abstract && e.listType === "image-card" && Ql("upload", "when the list-type is image-card, abstract is not supported.");
    const { mergedClsPrefixRef: t, inlineThemeDisabled: r } = Yt(e), n = ft("Upload", "-upload", hwe, P1e, e, t), i = ta(e), o = j(() => {
      const { max: I } = e;
      return I !== void 0 ? m.value.length >= I : !1;
    }), a = G(e.defaultFileList), s = tt(e, "fileList"), u = G(null), d = {
      value: !1
    }, f = G(!1), h = /* @__PURE__ */ new Map(), g = dn(s, a), m = j(() => g.value.map(O0));
    function v() {
      var I;
      (I = u.value) === null || I === void 0 || I.click();
    }
    function w(I) {
      const $ = I.target;
      C($.files ? Array.from($.files).map((_) => ({
        file: _,
        entry: null,
        source: "input"
      })) : null, I), $.value = "";
    }
    function x(I) {
      const { "onUpdate:fileList": $, onUpdateFileList: _ } = e;
      $ && je($, I), _ && je(_, I), a.value = I;
    }
    const y = j(() => e.multiple || e.directory);
    function C(I, $) {
      if (!I || I.length === 0)
        return;
      const { onBeforeUpload: _ } = e;
      I = y.value ? I : [I[0]];
      const { max: R, accept: U } = e;
      I = I.filter(({ file: Z, source: X }) => X === "dnd" && (U != null && U.trim()) ? owe(Z.name, Z.type, U) : !0), R && (I = I.slice(0, R - m.value.length));
      const Q = Ss();
      Promise.all(I.map(({ file: Z, entry: X }) => PR(this, void 0, void 0, function* () {
        var re;
        const ue = {
          id: Ss(),
          batchId: Q,
          name: Z.name,
          status: "pending",
          percentage: 0,
          file: Z,
          url: null,
          type: Z.type,
          thumbnailUrl: null,
          fullPath: (re = X == null ? void 0 : X.fullPath) !== null && re !== void 0 ? re : `/${Z.webkitRelativePath || Z.name}`
        };
        return !_ || (yield _({
          file: ue,
          fileList: m.value
        })) !== !1 ? ue : null;
      }))).then((Z) => PR(this, void 0, void 0, function* () {
        let X = Promise.resolve();
        Z.forEach((re) => {
          X = X.then(an).then(() => {
            re && T(re, $, {
              append: !0
            });
          });
        }), yield X;
      })).then(() => {
        e.defaultUpload && S();
      });
    }
    function S(I) {
      const { method: $, action: _, withCredentials: R, headers: U, data: Q, name: Z } = e, X = I !== void 0 ? m.value.filter((ue) => ue.id === I) : m.value, re = I !== void 0;
      X.forEach((ue) => {
        const { status: he } = ue;
        (he === "pending" || he === "error" && re) && (e.customRequest ? gwe({
          inst: {
            doChange: T,
            xhrMap: h,
            onFinish: e.onFinish,
            onError: e.onError
          },
          file: ue,
          action: _,
          withCredentials: R,
          headers: U,
          data: Q,
          customRequest: e.customRequest
        }) : ywe({
          doChange: T,
          xhrMap: h,
          onFinish: e.onFinish,
          onError: e.onError,
          isErrorState: e.isErrorState
        }, Z, ue, {
          method: $,
          action: _,
          withCredentials: R,
          responseType: e.responseType,
          headers: U,
          data: Q
        }));
      });
    }
    const T = (I, $, _ = {
      append: !1,
      remove: !1
    }) => {
      const { append: R, remove: U } = _, Q = Array.from(m.value), Z = Q.findIndex((X) => X.id === I.id);
      if (R || U || ~Z) {
        R ? Q.push(I) : U ? Q.splice(Z, 1) : Q.splice(Z, 1, I);
        const { onChange: X } = e;
        X && X({
          file: I,
          fileList: Q,
          event: $
        }), x(Q);
      }
    };
    function A(I) {
      var $;
      if (I.thumbnailUrl)
        return I.thumbnailUrl;
      const { createThumbnailUrl: _ } = e;
      return _ ? ($ = _(I.file, I)) !== null && $ !== void 0 ? $ : I.url || "" : I.url ? I.url : I.file ? ewe(I.file) : "";
    }
    const D = j(() => {
      const { common: { cubicBezierEaseInOut: I }, self: { draggerColor: $, draggerBorder: _, draggerBorderHover: R, itemColorHover: U, itemColorHoverError: Q, itemTextColorError: Z, itemTextColorSuccess: X, itemTextColor: re, itemIconColor: ue, itemDisabledOpacity: he, lineHeight: te, borderRadius: de, fontSize: De, itemBorderImageCardError: Oe, itemBorderImageCard: Qe } } = n.value;
      return {
        "--n-bezier": I,
        "--n-border-radius": de,
        "--n-dragger-border": _,
        "--n-dragger-border-hover": R,
        "--n-dragger-color": $,
        "--n-font-size": De,
        "--n-item-color-hover": U,
        "--n-item-color-hover-error": Q,
        "--n-item-disabled-opacity": he,
        "--n-item-icon-color": ue,
        "--n-item-text-color": re,
        "--n-item-text-color-error": Z,
        "--n-item-text-color-success": X,
        "--n-line-height": te,
        "--n-item-border-image-card-error": Oe,
        "--n-item-border-image-card": Qe
      };
    }), E = r ? Cr("upload", void 0, D, e) : void 0;
    tr(Yp, {
      mergedClsPrefixRef: t,
      mergedThemeRef: n,
      showCancelButtonRef: tt(e, "showCancelButton"),
      showDownloadButtonRef: tt(e, "showDownloadButton"),
      showRemoveButtonRef: tt(e, "showRemoveButton"),
      showRetryButtonRef: tt(e, "showRetryButton"),
      onRemoveRef: tt(e, "onRemove"),
      onDownloadRef: tt(e, "onDownload"),
      mergedFileListRef: m,
      triggerStyleRef: tt(e, "triggerStyle"),
      shouldUseThumbnailUrlRef: tt(e, "shouldUseThumbnailUrl"),
      renderIconRef: tt(e, "renderIcon"),
      xhrMap: h,
      submit: S,
      doChange: T,
      showPreviewButtonRef: tt(e, "showPreviewButton"),
      onPreviewRef: tt(e, "onPreview"),
      getFileThumbnailUrlResolver: A,
      listTypeRef: tt(e, "listType"),
      dragOverRef: f,
      openOpenFileDialog: v,
      draggerInsideRef: d,
      handleFileAddition: C,
      mergedDisabledRef: i.mergedDisabledRef,
      maxReachedRef: o,
      fileListStyleRef: tt(e, "fileListStyle"),
      abstractRef: tt(e, "abstract"),
      acceptRef: tt(e, "accept"),
      cssVarsRef: r ? void 0 : D,
      themeClassRef: E == null ? void 0 : E.themeClass,
      onRender: E == null ? void 0 : E.onRender,
      showTriggerRef: tt(e, "showTrigger"),
      imageGroupPropsRef: tt(e, "imageGroupProps"),
      mergedDirectoryDndRef: j(() => {
        var I;
        return (I = e.directoryDnd) !== null && I !== void 0 ? I : e.directory;
      })
    });
    const N = {
      clear: () => {
        a.value = [];
      },
      submit: S,
      openOpenFileDialog: v
    };
    return Object.assign({
      mergedClsPrefix: t,
      draggerInsideRef: d,
      inputElRef: u,
      mergedTheme: n,
      dragOver: f,
      mergedMultiple: y,
      cssVars: r ? void 0 : D,
      themeClass: E == null ? void 0 : E.themeClass,
      onRender: E == null ? void 0 : E.onRender,
      handleFileInputChange: w
    }, N);
  },
  render() {
    var e, t;
    const { draggerInsideRef: r, mergedClsPrefix: n, $slots: i, directory: o, onRender: a } = this;
    if (i.default && !this.abstract) {
      const u = i.default()[0];
      !((e = u == null ? void 0 : u.type) === null || e === void 0) && e[RW] && (r.value = !0);
    }
    const s = b("input", Object.assign({}, this.inputProps, {
      ref: "inputElRef",
      type: "file",
      class: `${n}-upload-file-input`,
      accept: this.accept,
      multiple: this.mergedMultiple,
      onChange: this.handleFileInputChange,
      webkitdirectory: o || void 0,
      directory: o || void 0
    }));
    return this.abstract ? b(Lr, null, (t = i.default) === null || t === void 0 ? void 0 : t.call(i), b(AM, { to: "body" }, s)) : (a == null || a(), b("div", { class: [
      `${n}-upload`,
      r.value && `${n}-upload--dragger-inside`,
      this.dragOver && `${n}-upload--drag-over`,
      this.themeClass
    ], style: this.cssVars }, s, this.showTrigger && this.listType !== "image-card" && b(HW, null, i), this.showFileList && b(fwe, null, i)));
  }
});
const Mwe = {
  name: "UIBreadcrumb",
  inheritAttrs: !1
}, s2 = /* @__PURE__ */ oe(Qt(vt({}, Mwe), {
  props: {
    separator: {
      type: String,
      default: "/"
    }
  },
  setup(e) {
    return (t, r) => (ie(), Pe(B(Hpe), { separator: e.separator }, {
      default: we(() => [
        nt(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["separator"]));
  }
})), Cwe = {
  name: "UIBreadcrumbItem",
  inheritAttrs: !1
}, RR = /* @__PURE__ */ oe(Qt(vt({}, Cwe), {
  props: {
    clickable: {
      type: Boolean,
      default: !0
    },
    href: {
      type: String,
      default: void 0
    }
  },
  setup(e) {
    return (t, r) => (ie(), Pe(B(Ype), {
      clickable: e.clickable,
      href: e.href
    }, {
      default: we(() => [
        nt(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["clickable", "href"]));
  }
}));
s2.install = (e) => {
  e.component(s2.name, s2), e.component(RR.name, RR);
};
const Swe = {
  name: "UICollapse",
  inheritAttrs: !1
}, u2 = /* @__PURE__ */ oe(Qt(vt({}, Swe), {
  props: {
    arrowPlacement: {
      type: String,
      default: "left"
    },
    defaultExpandedNames: {
      type: [String, Number, Array],
      default: void 0
    }
  },
  emits: ["itemHeaderClick"],
  setup(e) {
    return (t, r) => (ie(), Pe(B(jH), {
      "arrow-placement": e.arrowPlacement,
      "default-expanded-names": e.defaultExpandedNames,
      onItemHeaderClick: r[0] || (r[0] = (n) => t.$emit("itemHeaderClick", n))
    }, {
      default: we(() => [
        nt(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["arrow-placement", "default-expanded-names"]));
  }
})), Twe = {
  name: "UICollapseItem",
  inheritAttrs: !1
}, jR = /* @__PURE__ */ oe(Qt(vt({}, Twe), {
  props: {
    title: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    arrowPlacement: {
      type: String,
      default: "left"
    },
    id: {
      type: String,
      required: !0
    }
  },
  emits: ["onItemHeaderClick"],
  setup(e) {
    return (t, r) => (ie(), Pe(B(FH), {
      id: e.id,
      title: e.title,
      name: e.name,
      onOnItemHeaderClick: r[0] || (r[0] = (n) => t.$emit("onItemHeaderClick", n))
    }, {
      "header-extra": we(() => [
        nt(t.$slots, "header-extra")
      ]),
      default: we(() => [
        nt(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "title", "name"]));
  }
}));
u2.install = (e) => {
  e.component(u2.name, u2), e.component(jR.name, jR);
};
const kwe = {
  name: "UIDrawer",
  inheritAttrs: !1
}, c2 = /* @__PURE__ */ oe(Qt(vt({}, kwe), {
  props: {
    show: {
      type: Boolean,
      default: !1
    },
    width: {
      type: Number,
      default: 502
    },
    placement: {
      type: String,
      default: "right"
    },
    id: {
      type: String,
      required: !0
    },
    displayDirective: {
      type: String,
      default: "if"
    }
  },
  emits: ["update:show"],
  setup(e) {
    return (t, r) => (ie(), Pe(B(Kbe), ir({ id: e.id }, t.$attrs, {
      show: e.show,
      width: e.width,
      placement: e.placement,
      "onUpdate:show": r[0] || (r[0] = (n) => t.$emit("update:show", n)),
      "display-directive": e.displayDirective
    }), {
      default: we(() => [
        nt(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "show", "width", "placement", "display-directive"]));
  }
})), Dwe = {
  key: 0,
  class: "hl-icon-container"
}, VW = /* @__PURE__ */ oe({
  __name: "IconContainer",
  props: {
    type: {
      type: String,
      default: "primary"
    }
  },
  setup(e) {
    const t = {
      success: "icon-success",
      error: "icon-error",
      warning: "icon-warning",
      primary: "icon-primary"
    }, r = pn();
    return (n, i) => B(r).default() ? (ie(), Ve("div", Dwe, [
      Ye("div", {
        class: Jr(["icon", t[e.type]])
      }, [
        nt(n.$slots, "default")
      ], 2)
    ])) : yt("", !0);
  }
}), Awe = {
  name: "UIButton"
}, on = /* @__PURE__ */ oe(Qt(vt({}, Awe), {
  props: {
    id: {
      type: String,
      required: !0
    },
    type: {
      type: String,
      default: "default"
    },
    size: {
      type: String,
      default: "medium"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    ghost: {
      type: Boolean,
      default: !1
    },
    quaternary: {
      type: Boolean,
      default: !1
    },
    circle: {
      type: Boolean,
      default: !1
    },
    text: {
      type: Boolean,
      default: !1
    },
    active: {
      type: Boolean,
      default: void 0
    }
  },
  emits: ["click"],
  setup(e) {
    const t = pn();
    return (r, n) => (ie(), Pe(B(Mn), ir({
      id: e.id,
      text: e.text,
      class: [
        e.quaternary ? "quaternary" : null,
        e.circle || e.text ? "icon-only" : null,
        e.active ? "hl-active-btn" : null,
        e.text ? "hl-text-btn" : null
      ],
      type: e.type,
      size: e.size
    }, r.$attrs, {
      disabled: e.disabled,
      loading: e.loading,
      onClick: n[0] || (n[0] = (i) => r.$emit("click", i)),
      quaternary: e.quaternary,
      circle: e.circle
    }), {
      default: we(() => [
        nt(r.$slots, "default"),
        B(t).icon ? nt(r.$slots, "icon", { key: 0 }) : yt("", !0)
      ]),
      _: 3
    }, 16, ["id", "text", "class", "type", "size", "disabled", "loading", "quaternary", "circle"]));
  }
}));
on.install = (e) => {
  e.component(on.name, on);
};
const Ewe = { class: "hl-drawer-header-container" }, Iwe = {
  key: 0,
  class: "hl-drawer-header-icon"
}, Nwe = { class: "hl-drawer-title" }, zwe = { class: "hl-drawer-description" }, $we = { class: "hl-drawer-actions" }, Owe = { class: "hl-drawer-action-left" }, _we = { class: "hl-drawer-action-right" }, Lwe = {
  name: "UIDrawerContent",
  inheritAttrs: !1
}, FR = /* @__PURE__ */ oe(Qt(vt({}, Lwe), {
  props: {
    id: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    icon: {
      type: Function,
      default: void 0
    },
    width: {
      type: Number,
      default: 502
    },
    positiveText: {
      type: String,
      default: ""
    },
    negativeText: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["negativeClick", "positiveClick"],
  setup(e) {
    const t = e, r = pn(), n = j(() => t.positiveText || t.negativeText || (r == null ? void 0 : r.actionLeft) || (r == null ? void 0 : r.actionRight));
    return (i, o) => (ie(), Pe(B(Jbe), ir(i.$attrs, {
      closable: "",
      class: "hl-drawer-content"
    }), fb({
      header: we(() => [
        Ye("div", Ewe, [
          e.icon ? (ie(), Ve("div", Iwe, [
            Re(VW, null, {
              default: we(() => [
                (ie(), Pe(mi(e.icon), { class: "w-5 h-5" }))
              ]),
              _: 1
            })
          ])) : yt("", !0),
          Ye("div", null, [
            Ye("div", Nwe, ar(e.title), 1),
            Ye("div", zwe, ar(e.description), 1)
          ])
        ])
      ]),
      default: we(() => [
        nt(i.$slots, "default")
      ]),
      _: 2
    }, [
      B(n) ? {
        name: "footer",
        fn: we(() => {
          var a, s;
          return [
            Ye("div", $we, [
              Ye("div", Owe, [
                (a = B(r)) != null && a.actionLeft ? nt(i.$slots, "actionLeft", { key: 0 }) : yt("", !0)
              ]),
              Ye("div", _we, [
                (s = B(r)) != null && s.actionRight ? nt(i.$slots, "actionRight", { key: 0 }) : (ie(), Ve(Lr, { key: 1 }, [
                  e.negativeText ? (ie(), Pe(B(on), {
                    key: 0,
                    id: `${e.id}-btn-negative-action`,
                    onClick: o[0] || (o[0] = (u) => i.$emit("negativeClick"))
                  }, {
                    default: we(() => [
                      zr(ar(e.negativeText), 1)
                    ]),
                    _: 1
                  }, 8, ["id"])) : yt("", !0),
                  e.positiveText ? (ie(), Pe(B(on), {
                    key: 1,
                    id: `${e.id}-btn-positive-action`,
                    loading: e.loading,
                    disabled: e.disabled,
                    type: "primary",
                    onClick: o[1] || (o[1] = (u) => i.$emit("positiveClick"))
                  }, {
                    default: we(() => [
                      zr(ar(e.positiveText), 1)
                    ]),
                    _: 1
                  }, 8, ["id", "loading", "disabled"])) : yt("", !0)
                ], 64))
              ])
            ])
          ];
        })
      } : void 0
    ]), 1040));
  }
}));
c2.install = (e) => {
  e.component(c2.name, c2), e.component(FR.name, FR);
};
function Pwe(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 9v4m0 4h.01M10.615 3.892L2.39 18.098c-.456.788-.684 1.182-.65 1.506a1 1 0 00.406.705c.263.191.718.191 1.629.191h16.45c.91 0 1.365 0 1.628-.191a1 1 0 00.407-.705c.034-.324-.195-.718-.65-1.506L13.383 3.892c-.454-.785-.681-1.178-.978-1.31a1 1 0 00-.813 0c-.296.132-.523.525-.978 1.31z"
    })
  ]);
}
function Rwe(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19 12H5m0 0l7 7m-7-7l7-7"
    })
  ]);
}
function jwe(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.5 12l3 3 6-6m5.5 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z"
    })
  ]);
}
function YW(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 9l6 6 6-6"
    })
  ]);
}
function Fwe(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 18l6-6-6-6"
    })
  ]);
}
function QW(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 13a1 1 0 100-2 1 1 0 000 2zM12 6a1 1 0 100-2 1 1 0 000 2zM12 20a1 1 0 100-2 1 1 0 000 2z"
    })
  ]);
}
function Bwe(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 12h12M3 6h18M9 18h6"
    })
  ]);
}
function qW(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 16v-4m0-4h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z"
    })
  ]);
}
function GW(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 21l-3.5-3.5m2.5-6a8.5 8.5 0 11-17 0 8.5 8.5 0 0117 0z"
    })
  ]);
}
function Uwe(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 21l-4.35-4.35M19 11a8 8 0 11-16 0 8 8 0 0116 0z"
    })
  ]);
}
function Hwe(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 15v1.2c0 1.68 0 2.52-.327 3.162a3 3 0 01-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 01-1.311-1.311C3 18.72 3 17.88 3 16.2V15m14-7l-5-5m0 0L7 8m5-5v12"
    })
  ]);
}
function BR(e, t) {
  return ie(), Ve("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    Ye("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M17 7L7 17M7 7l10 10"
    })
  ]);
}
const Wwe = {
  name: "UITooltip",
  inheritAttrs: !1
}, ys = /* @__PURE__ */ oe(Qt(vt({}, Wwe), {
  props: {
    trigger: {
      type: String,
      default: "hover"
    },
    placement: {
      type: String,
      default: void 0
    },
    show: {
      type: Boolean,
      default: void 0
    }
  },
  setup(e) {
    return (t, r) => (ie(), Pe(B(HM), ir(t.$attrs, {
      trigger: e.trigger,
      show: e.show,
      placement: e.placement,
      "onUpdate:show": r[0] || (r[0] = (n) => t.$emit("show", n))
    }), {
      trigger: we(() => [
        nt(t.$slots, "trigger")
      ]),
      default: we(() => [
        nt(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["trigger", "show", "placement"]));
  }
}));
ys.install = (e) => {
  e.component(ys.name, ys);
};
const Vwe = {
  name: "UIFormLabelTooltip",
  inheritAttrs: !1
}, hx = /* @__PURE__ */ oe(Qt(vt({}, Vwe), {
  props: {
    trigger: {
      type: String,
      default: "hover"
    },
    placement: {
      type: String,
      default: void 0
    },
    icon: {
      type: Function,
      default: qW
    },
    iconClass: String
  },
  setup(e) {
    return (t, r) => (ie(), Pe(B(ys), {
      placement: e.placement,
      trigger: e.trigger
    }, {
      trigger: we(() => [
        (ie(), Pe(mi(e.icon), {
          class: Jr(e.iconClass ? e.iconClass : "w-4 h-4 text-gray-500")
        }, null, 8, ["class"]))
      ]),
      default: we(() => [
        nt(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["placement", "trigger"]));
  }
})), Ywe = {
  name: "UIForm"
}, np = /* @__PURE__ */ oe(Qt(vt({}, Ywe), {
  props: {
    rules: {
      type: Object
    },
    inline: {
      type: Boolean,
      default: !1
    },
    model: {
      type: [String, Object]
    },
    id: {
      type: String,
      required: !0
    }
  },
  setup(e, { expose: t }) {
    const r = G();
    function n() {
      return r.value;
    }
    return t({ getForm: n }), (i, o) => (ie(), Pe(B(gye), ir({ id: e.id }, i.$attrs, {
      rules: e.rules,
      model: e.model,
      inline: e.inline,
      ref_key: "formRef",
      ref: r
    }), {
      default: we(() => [
        nt(i.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "rules", "model", "inline"]));
  }
})), Qwe = {
  name: "UIDivider",
  inheritAttrs: !1
}, Jy = /* @__PURE__ */ oe(Qt(vt({}, Qwe), {
  props: {
    titlePlacement: {
      type: String,
      default: "center"
    },
    dashed: {
      type: Boolean,
      default: !1
    },
    vertical: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = pn();
    return (r, n) => B(t).default ? (ie(), Pe(B(gR), {
      key: 0,
      "title-placement": e.titlePlacement,
      dashed: e.dashed,
      vertical: e.vertical
    }, {
      default: we(() => [
        nt(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["title-placement", "dashed", "vertical"])) : (ie(), Pe(B(gR), {
      key: 1,
      "title-placement": e.titlePlacement,
      dashed: e.dashed,
      vertical: e.vertical
    }, null, 8, ["title-placement", "dashed", "vertical"]));
  }
}));
Jy.install = (e) => {
  e.component(Jy.name, Jy);
};
var To = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, i] of t)
    r[n] = i;
  return r;
};
const qwe = {
  name: "UIDisplaySmMedium",
  inheritAttrs: !1
};
function Gwe(e, t, r, n, i, o) {
  return ie(), Ve("div", ir(e.$attrs, { class: "hl-display-sm-medium" }), [
    nt(e.$slots, "default")
  ], 16);
}
var e1 = /* @__PURE__ */ To(qwe, [["render", Gwe]]);
const Zwe = {
  name: "UITextLgMedium",
  inheritAttrs: !1
};
function Kwe(e, t, r, n, i, o) {
  return ie(), Ve("div", ir(e.$attrs, { class: "hl-text-lg-medium" }), [
    nt(e.$slots, "default")
  ], 16);
}
var a$ = /* @__PURE__ */ To(Zwe, [["render", Kwe]]);
const Xwe = {
  name: "UITextSmNormal",
  inheritAttrs: !1
};
function Jwe(e, t, r, n, i, o) {
  return ie(), Ve("div", ir(e.$attrs, { class: "hl-text-sm-normal" }), [
    nt(e.$slots, "default")
  ], 16);
}
var l$ = /* @__PURE__ */ To(Xwe, [["render", Jwe]]);
const eMe = {
  name: "UITextSmNormal",
  inheritAttrs: !1
};
function tMe(e, t, r, n, i, o) {
  return ie(), Ve("div", ir(e.$attrs, { class: "hl-text-sm-medium" }), [
    nt(e.$slots, "default")
  ], 16);
}
var wp = /* @__PURE__ */ To(eMe, [["render", tMe]]);
const rMe = {
  name: "UITextXsMedium",
  inheritAttrs: !1
};
function nMe(e, t, r, n, i, o) {
  return ie(), Ve("div", ir(e.$attrs, { class: "hl-text-xs-medium" }), [
    nt(e.$slots, "default")
  ], 16);
}
var px = /* @__PURE__ */ To(rMe, [["render", nMe]]);
const iMe = {
  name: "UITextXsRegular",
  inheritAttrs: !1
};
function oMe(e, t, r, n, i, o) {
  return ie(), Ve("div", ir(e.$attrs, { class: "hl-text-xs-regular" }), [
    nt(e.$slots, "default")
  ], 16);
}
var UR = /* @__PURE__ */ To(iMe, [["render", oMe]]);
const aMe = {
  name: "UITextMdMedium",
  inheritAttrs: !1
};
function lMe(e, t, r, n, i, o) {
  return ie(), Ve("div", ir(e.$attrs, { class: "hl-text-md-medium" }), [
    nt(e.$slots, "default")
  ], 16);
}
var HR = /* @__PURE__ */ To(aMe, [["render", lMe]]);
const sMe = {
  name: "UITextMdNormal",
  inheritAttrs: !1
};
function uMe(e, t, r, n, i, o) {
  return ie(), Ve("div", ir(e.$attrs, { class: "hl-text-md-normal" }), [
    nt(e.$slots, "default")
  ], 16);
}
var s$ = /* @__PURE__ */ To(sMe, [["render", uMe]]);
const cMe = {
  name: "UIDisplaySmSemibold",
  inheritAttrs: !1
};
function dMe(e, t, r, n, i, o) {
  return ie(), Ve("div", ir(e.$attrs, { class: "hl-display-sm-semibold" }), [
    nt(e.$slots, "default")
  ], 16);
}
var u$ = /* @__PURE__ */ To(cMe, [["render", dMe]]);
const fMe = {
  name: "UITextSmRegular",
  inheritAttrs: !1
};
function hMe(e, t, r, n, i, o) {
  return ie(), Ve("div", ir(e.$attrs, { class: "hl-text-sm-regular" }), [
    nt(e.$slots, "default")
  ], 16);
}
var c$ = /* @__PURE__ */ To(fMe, [["render", hMe]]);
e1.install = (e) => {
  e.component(e1.name, e1), e.component(a$.name, a$), e.component(l$.name, l$), e.component(wp.name, wp), e.component(px.name, px), e.component(HR.name, HR), e.component(s$.name, s$), e.component(u$.name, u$), e.component(c$.name, c$), e.component(UR.name, UR);
};
const pMe = { class: "hl-form-content-hz" }, gMe = { class: "col-left" }, mMe = { class: "n-form-custom-label" }, vMe = {
  key: 0,
  class: "asterisk"
}, bMe = { key: 0 }, yMe = {
  key: 0,
  class: "extra"
}, xMe = { class: "col-right" }, wMe = {
  name: "UIFormContentHorizontal",
  inheritAttrs: !1
}, WR = /* @__PURE__ */ oe(Qt(vt({}, wMe), {
  props: {
    label: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    tooltip: {
      type: Object,
      default: null
    }
  },
  setup(e) {
    const t = pn();
    return (r, n) => {
      var i, o, a, s;
      return ie(), Ve(Lr, null, [
        Re(B(Jy)),
        Ye("div", pMe, [
          Ye("div", gMe, [
            Ye("div", mMe, [
              Re(B(wp), { class: "title" }, {
                default: we(() => [
                  zr(ar(e.label) + " ", 1),
                  e.required ? (ie(), Ve("span", vMe, " *")) : yt("", !0)
                ]),
                _: 1
              }),
              e.tooltip ? (ie(), Pe(hx, {
                key: 0,
                placement: (i = e.tooltip) == null ? void 0 : i.placement,
                trigger: (o = e.tooltip) == null ? void 0 : o.trigger,
                icon: (a = e.tooltip) == null ? void 0 : a.icon,
                iconClass: (s = e.tooltip) == null ? void 0 : s.iconClass
              }, {
                default: we(() => [
                  typeof e.tooltip.text == "string" ? (ie(), Ve("span", bMe, ar(e.tooltip.text), 1)) : (ie(), Pe(mi(e.tooltip.text), { key: 1 }))
                ]),
                _: 1
              }, 8, ["placement", "trigger", "icon", "iconClass"])) : yt("", !0)
            ]),
            Re(B(c$), { class: "description" }, {
              default: we(() => [
                zr(ar(e.description), 1)
              ]),
              _: 1
            }),
            B(t).extra ? (ie(), Ve("div", yMe, [
              nt(r.$slots, "extra")
            ])) : yt("", !0)
          ]),
          Ye("div", xMe, [
            nt(r.$slots, "default")
          ])
        ])
      ], 64);
    };
  }
})), MMe = { class: "n-form-custom-label" }, CMe = {
  key: 0,
  class: "asterisk"
}, SMe = { key: 0 }, TMe = {
  name: "UIFormItem",
  inheritAttrs: !1
}, ca = oe(Qt(vt({}, TMe), {
  props: {
    label: {
      type: String
    },
    path: {
      type: String
    },
    showLabel: {
      type: Boolean,
      default: !0
    },
    showFeedback: {
      type: Boolean,
      default: !0
    },
    rule: {
      type: Object,
      default: void 0
    },
    tooltip: {
      type: Object,
      default: null
    },
    required: Boolean
  },
  setup(e) {
    return (t, r) => (ie(), Pe(B(e1e), ir(t.$attrs, {
      rule: e.rule,
      label: e.label,
      path: e.path,
      "show-label": e.showLabel,
      "show-feedback": e.showFeedback,
      class: { "n-form-has-custom-label": e.tooltip },
      required: e.required
    }), fb({
      default: we(() => [
        nt(t.$slots, "default")
      ]),
      _: 2
    }, [
      e.tooltip ? {
        name: "label",
        fn: we(() => {
          var n, i, o, a;
          return [
            Ye("div", MMe, [
              Ye("span", null, [
                Ye("span", null, ar(e.label), 1),
                e.required ? (ie(), Ve("span", CMe, " *")) : yt("", !0)
              ]),
              Re(hx, {
                placement: (n = e.tooltip) == null ? void 0 : n.placement,
                trigger: (i = e.tooltip) == null ? void 0 : i.trigger,
                icon: (o = e.tooltip) == null ? void 0 : o.icon,
                iconClass: (a = e.tooltip) == null ? void 0 : a.iconClass
              }, {
                default: we(() => [
                  typeof e.tooltip.text == "string" ? (ie(), Ve("span", SMe, ar(e.tooltip.text), 1)) : (ie(), Pe(mi(e.tooltip.text), { key: 1 }))
                ]),
                _: 1
              }, 8, ["placement", "trigger", "icon", "iconClass"])
            ])
          ];
        })
      } : void 0
    ]), 1040, ["rule", "label", "path", "show-label", "show-feedback", "class", "required"]));
  }
}));
np.install = (e) => {
  e.component(np.name, np), e.component(ca.name, ca), e.component(WR.name, WR), e.component(hx.name, hx);
};
const kMe = {
  name: "UIInput"
}, xs = /* @__PURE__ */ oe(Qt(vt({}, kMe), {
  props: {
    id: {
      type: String,
      required: !0
    },
    modelValue: {
      type: [String, Array],
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    placeholder: { type: String, default: void 0 },
    readonly: {
      type: Boolean,
      default: !1
    },
    rows: {
      type: Number,
      default: 3
    },
    maxlength: Number,
    minlength: Number,
    loading: {
      type: Boolean
    },
    autosize: {
      type: [Boolean, Object]
    },
    clearable: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "large"
    },
    showCount: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  emits: ["update:modelValue", "onBlur", "onChange"],
  setup(e, { emit: t }) {
    function r(n) {
      t("update:modelValue", n);
    }
    return (n, i) => (ie(), Pe(B(pa), ir(n.$attrs, {
      id: e.id,
      clearable: e.clearable,
      disabled: e.disabled,
      loading: e.loading,
      maxlength: e.maxlength,
      minlength: e.minlength,
      placeholder: e.placeholder,
      readonly: e.readonly,
      rows: e.rows,
      "show-count": e.showCount,
      size: e.size,
      type: e.type,
      value: e.modelValue,
      autosize: e.autosize,
      "onUpdate:value": r,
      onOnBlur: i[0] || (i[0] = (o) => n.$emit("onBlur", o)),
      onOnChange: i[1] || (i[1] = (o) => n.$emit("onChange", o)),
      class: "hl-input-text font-sans"
    }), {
      prefix: we(() => [
        nt(n.$slots, "prefix")
      ]),
      suffix: we(() => [
        nt(n.$slots, "suffix")
      ]),
      _: 3
    }, 16, ["id", "clearable", "disabled", "loading", "maxlength", "minlength", "placeholder", "readonly", "rows", "show-count", "size", "type", "value", "autosize"]));
  }
})), DMe = {
  name: "UIInputGroup",
  inheritAttrs: !1
}, gx = /* @__PURE__ */ oe(Qt(vt({}, DMe), {
  setup(e) {
    return (t, r) => (ie(), Pe(B(T4), null, {
      default: we(() => [
        nt(t.$slots, "default")
      ]),
      _: 3
    }));
  }
})), AMe = {
  name: "UIInputGroupLabel",
  inheritAttrs: !1
}, VR = /* @__PURE__ */ oe(Qt(vt({}, AMe), {
  props: {
    size: {
      type: String,
      default: "large"
    }
  },
  setup(e) {
    return (t, r) => (ie(), Pe(B(xpe), ir(t.$attrs, { size: e.size }), {
      default: we(() => [
        nt(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["size"]));
  }
}));
xs.install = (e) => {
  e.component(xs.name, xs), e.component(gx.name, gx), e.component(VR.name, VR);
};
const EMe = {
  name: "UIModal",
  inheritAttrs: !1
}, ip = /* @__PURE__ */ oe(Qt(vt({}, EMe), {
  props: {
    show: {
      type: Boolean,
      default: !1
    },
    width: {
      type: Number,
      default: 544
    },
    zIndex: {
      type: Number,
      default: void 0
    },
    to: {
      type: String,
      default: "body"
    },
    autoFocus: {
      type: Boolean,
      default: !1
    },
    className: {
      type: String,
      default: ""
    }
  },
  emits: ["update:show"],
  setup(e) {
    return (t, r) => (ie(), Pe(B(Dbe), {
      show: e.show,
      "onUpdate:show": r[0] || (r[0] = (n) => t.$emit("update:show", n)),
      "z-index": e.zIndex,
      "auto-focus": e.autoFocus,
      to: e.to
    }, {
      default: we(() => [
        Re(B($H), {
          style: Jf({ width: `${e.width}px` }),
          bordered: !1,
          size: "huge",
          role: "dialog",
          "aria-modal": "true",
          class: Jr(["hl-modal", e.className])
        }, {
          header: we(() => [
            nt(t.$slots, "header")
          ]),
          footer: we(() => [
            nt(t.$slots, "footer")
          ]),
          default: we(() => [
            nt(t.$slots, "default")
          ]),
          _: 3
        }, 8, ["style", "class"])
      ]),
      _: 3
    }, 8, ["show", "z-index", "auto-focus", "to"]));
  }
})), IMe = { class: "hl-modal-heading" }, NMe = { key: 0 }, zMe = { key: 1 }, $Me = {
  key: 0,
  class: "hl-icon-container"
}, OMe = { class: "action" }, _Me = { class: "title" }, LMe = {
  key: 0,
  class: "action"
}, PMe = {
  key: 1,
  class: "description"
}, _0 = /* @__PURE__ */ oe({
  __name: "ModalHeader",
  props: {
    id: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    icon: {
      type: Function,
      default: void 0
    },
    type: {
      type: String,
      default: "primary"
    }
  },
  emits: ["close"],
  setup(e) {
    const t = {
      custom: "icon-custom",
      success: "icon-success",
      error: "icon-error",
      warning: "icon-warning",
      primary: "icon-primary"
    }, r = pn();
    return (n, i) => (ie(), Ve("div", IMe, [
      B(r).customHeader ? (ie(), Ve("div", NMe, [
        nt(n.$slots, "customHeader")
      ])) : (ie(), Ve("div", zMe, [
        e.icon ? (ie(), Ve("div", $Me, [
          Ye("div", {
            class: Jr(["icon", t[e.type]])
          }, [
            (ie(), Pe(mi(e.icon)))
          ], 2),
          Ye("div", OMe, [
            Re(B(on), {
              circle: "",
              quaternary: "",
              onClick: i[0] || (i[0] = (o) => n.$emit("close")),
              id: `${e.id}-modal-close-btn`
            }, {
              default: we(() => [
                Re(B(BR), { class: "w-5 h-5" })
              ]),
              _: 1
            }, 8, ["id"])
          ])
        ])) : yt("", !0),
        Ye("div", _Me, [
          zr(ar(e.title) + " ", 1),
          e.icon ? yt("", !0) : (ie(), Ve("div", LMe, [
            Re(B(on), {
              circle: "",
              quaternary: "",
              onClick: i[1] || (i[1] = (o) => n.$emit("close")),
              id: `${e.id}-modal-close-btn`
            }, {
              default: we(() => [
                Re(B(BR), { class: "w-6 h-6" })
              ]),
              _: 1
            }, 8, ["id"])
          ]))
        ]),
        e.description ? (ie(), Ve("div", PMe, ar(e.description), 1)) : yt("", !0)
      ]))
    ]));
  }
}), RMe = { class: "hl-modal-footer-actions" }, jMe = { class: "action-left" }, FMe = { class: "action-right" };
oe({
  name: "UIModalFooter"
});
const L0 = /* @__PURE__ */ oe({
  __name: "ModalFooter",
  props: {
    id: {
      type: String,
      required: !0
    },
    positiveText: {
      type: String,
      default: ""
    },
    negativeText: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "primary"
    }
  },
  setup(e) {
    const t = pn(), r = j(() => !!t.actionRight);
    return (n, i) => (ie(), Ve("div", RMe, [
      Ye("div", jMe, [
        nt(n.$slots, "actionLeft")
      ]),
      Ye("div", FMe, [
        nt(n.$slots, "actionRight"),
        B(r) ? yt("", !0) : (ie(), Ve(Lr, { key: 0 }, [
          e.negativeText ? (ie(), Pe(B(on), {
            key: 0,
            onClick: i[0] || (i[0] = (o) => n.$emit("negativeClick")),
            id: `${e.id}-btn-negative-action`
          }, {
            default: we(() => [
              zr(ar(e.negativeText), 1)
            ]),
            _: 1
          }, 8, ["id"])) : yt("", !0),
          e.positiveText ? (ie(), Pe(B(on), {
            key: 1,
            loading: e.loading,
            disabled: e.disabled,
            type: e.type,
            id: `${e.id}-btn-positive-action`,
            onClick: i[1] || (i[1] = (o) => n.$emit("positiveClick"))
          }, {
            default: we(() => [
              zr(ar(e.positiveText), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled", "type", "id"])) : yt("", !0)
        ], 64))
      ])
    ]));
  }
}), BMe = { class: "hl-modal-content" };
oe({
  name: "UIModalContent"
});
const P0 = /* @__PURE__ */ oe({
  __name: "ModalContent",
  setup(e) {
    return (t, r) => (ie(), Ve("div", BMe, [
      nt(t.$slots, "default")
    ]));
  }
});
ip.install = (e) => {
  e.component(ip.name, ip), e.component(_0.name, _0), e.component(L0.name, L0), e.component(P0.name, P0);
};
const UMe = {
  name: "UIRadio",
  inheritAttrs: !1
}, t1 = /* @__PURE__ */ oe(Qt(vt({}, UMe), {
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    value: {
      type: [String, Number, Boolean]
    },
    name: {
      type: String
    },
    label: {
      type: String
    },
    checked: {
      type: Boolean
    },
    id: {
      type: String,
      required: !0
    }
  },
  emits: ["change", "checked", "value"],
  setup(e) {
    return (t, r) => (ie(), Pe(B(WM), ir({
      id: e.id,
      disabled: e.disabled,
      label: e.label,
      value: e.value,
      name: e.name
    }, t.$attrs, {
      checked: e.checked,
      onChange: r[0] || (r[0] = (n) => t.$emit("change", n)),
      onChecked: r[1] || (r[1] = (n) => t.$emit("checked", n)),
      "onUpdate:value": r[2] || (r[2] = (n) => t.$emit("value", n)),
      size: "large"
    }), {
      default: we(() => [
        nt(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "disabled", "label", "value", "name", "checked"]));
  }
})), HMe = {
  name: "UIRadioGroup",
  inheritAttrs: !1
}, d$ = /* @__PURE__ */ oe(Qt(vt({}, HMe), {
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    value: {
      type: [String, Number, Boolean]
    },
    name: {
      type: String
    },
    size: {
      type: String,
      default: "medium"
    },
    defaultValue: {
      type: [String, Number, Boolean, null]
    }
  },
  emits: ["update:value"],
  setup(e) {
    return (t, r) => (ie(), Pe(B(ZH), ir({
      disabled: e.disabled,
      "default-value": e.defaultValue,
      value: e.value,
      name: e.name
    }, t.$attrs, {
      size: e.size,
      "onUpdate:value": r[0] || (r[0] = (n) => t.$emit("update:value", n))
    }), {
      default: we(() => [
        nt(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["disabled", "default-value", "value", "name", "size"]));
  }
}));
t1.install = (e) => {
  e.component(t1.name, t1), e.component(d$.name, d$);
};
const WMe = {
  name: "UISteps",
  inheritAttrs: !1
}, d2 = /* @__PURE__ */ oe(Qt(vt({}, WMe), {
  props: {
    current: {
      type: Number
    },
    status: {
      type: String
    },
    vertical: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, r) => (ie(), Pe(B(Hxe), ir(t.$attrs, {
      current: e.current,
      status: e.status,
      vertical: e.vertical
    }), {
      default: we(() => [
        nt(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["current", "status", "vertical"]));
  }
})), VMe = {
  name: "UIStep",
  inheritAttrs: !1
}, YR = /* @__PURE__ */ oe(Qt(vt({}, VMe), {
  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    return (t, r) => (ie(), Pe(B(Vxe), ir(t.$attrs, {
      title: e.title,
      description: e.description
    }), {
      default: we(() => [
        nt(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["title", "description"]));
  }
}));
d2.install = (e) => {
  e.component(d2.name, d2), e.component(YR.name, YR);
};
function YMe({
  array: e,
  oldIndex: t,
  newIndex: r
}) {
  const n = [...e];
  if (r >= n.length) {
    let i = r - n.length + 1;
    for (; i--; )
      n.push(void 0);
  }
  return n.splice(r, 0, n.splice(t, 1)[0]), n;
}
const QMe = {
  name: "UIButtonGroup",
  inheritAttrs: !1
}, r1 = /* @__PURE__ */ oe(Qt(vt({}, QMe), {
  setup(e) {
    return (t, r) => (ie(), Pe(B(ege), OB(_B(t.$attrs)), {
      default: we(() => [
        nt(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}));
r1.install = (e) => {
  e.component(r1.name, r1);
};
const qMe = {
  name: "UIPagination",
  inheritAttrs: !1
}, n1 = /* @__PURE__ */ oe(Qt(vt({}, qMe), {
  props: {
    pageCount: {
      type: Number,
      default: 10
    },
    page: {
      type: Number
    },
    id: {
      type: String,
      required: !0
    },
    pageSize: {
      type: Number,
      default: void 0
    },
    pageSlot: {
      type: Number,
      default: 9
    },
    showSizePicker: {
      type: Boolean,
      default: !1
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 40]
    }
  },
  emits: ["update:page", "update:page-size"],
  setup(e, { emit: t }) {
    const r = lt("customLocale");
    return (n, i) => (ie(), Pe(B(VH), {
      "page-size": e.pageSize,
      "page-sizes": e.pageSizes,
      "show-size-picker": e.showSizePicker,
      "page-count": e.pageCount,
      page: e.page,
      "page-slot": e.pageSlot,
      "onUpdate:page": i[0] || (i[0] = (o) => t("update:page", o)),
      "onUpdate:pageSize": i[1] || (i[1] = (o) => t("update:page-size", o))
    }, {
      prev: we(() => [
        Re(B(on), {
          id: `${e.id}-previous`,
          size: "small"
        }, {
          default: we(() => {
            var o;
            return [
              zr(ar((o = B(r).Pagination.previous) != null ? o : "Previous"), 1)
            ];
          }),
          _: 1
        }, 8, ["id"])
      ]),
      next: we(() => [
        Re(B(on), {
          id: `${e.id}-next`,
          size: "small"
        }, {
          default: we(() => {
            var o;
            return [
              zr(ar((o = B(r).Pagination.next) != null ? o : "Next"), 1)
            ];
          }),
          _: 1
        }, 8, ["id"])
      ]),
      _: 1
    }, 8, ["page-size", "page-sizes", "show-size-picker", "page-count", "page", "page-slot"]));
  }
}));
n1.install = (e) => {
  e.component(n1.name, n1);
};
var ZW = { exports: {} };
(function(e, t) {
  (function(n, i) {
    e.exports = i();
  })(window, function() {
    return function(r) {
      var n = {};
      function i(o) {
        if (n[o])
          return n[o].exports;
        var a = n[o] = {
          i: o,
          l: !1,
          exports: {}
        };
        return r[o].call(a.exports, a, a.exports, i), a.l = !0, a.exports;
      }
      return i.m = r, i.c = n, i.d = function(o, a, s) {
        i.o(o, a) || Object.defineProperty(o, a, { enumerable: !0, get: s });
      }, i.r = function(o) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(o, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(o, "__esModule", { value: !0 });
      }, i.t = function(o, a) {
        if (a & 1 && (o = i(o)), a & 8 || a & 4 && typeof o == "object" && o && o.__esModule)
          return o;
        var s = /* @__PURE__ */ Object.create(null);
        if (i.r(s), Object.defineProperty(s, "default", { enumerable: !0, value: o }), a & 2 && typeof o != "string")
          for (var u in o)
            i.d(s, u, function(d) {
              return o[d];
            }.bind(null, u));
        return s;
      }, i.n = function(o) {
        var a = o && o.__esModule ? function() {
          return o.default;
        } : function() {
          return o;
        };
        return i.d(a, "a", a), a;
      }, i.o = function(o, a) {
        return Object.prototype.hasOwnProperty.call(o, a);
      }, i.p = "", i(i.s = 66);
    }([
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(64), a = s(o);
        function s(u) {
          return u && u.__esModule ? u : { default: u };
        }
        n.default = a.default;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(60), a = s(o);
        function s(u) {
          return u && u.__esModule ? u : { default: u };
        }
        n.default = a.default;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(51);
        Object.defineProperty(n, "closest", {
          enumerable: !0,
          get: function() {
            return s(o).default;
          }
        });
        var a = i(49);
        Object.defineProperty(n, "requestNextAnimationFrame", {
          enumerable: !0,
          get: function() {
            return s(a).default;
          }
        });
        function s(u) {
          return u && u.__esModule ? u : { default: u };
        }
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(44);
        Object.keys(o).forEach(function(a) {
          a === "default" || a === "__esModule" || Object.defineProperty(n, a, {
            enumerable: !0,
            get: function() {
              return o[a];
            }
          });
        });
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(47), a = s(o);
        function s(u) {
          return u && u.__esModule ? u : { default: u };
        }
        n.default = a.default;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(14);
        Object.keys(o).forEach(function(g) {
          g === "default" || g === "__esModule" || Object.defineProperty(n, g, {
            enumerable: !0,
            get: function() {
              return o[g];
            }
          });
        });
        var a = i(13);
        Object.keys(a).forEach(function(g) {
          g === "default" || g === "__esModule" || Object.defineProperty(n, g, {
            enumerable: !0,
            get: function() {
              return a[g];
            }
          });
        });
        var s = i(12);
        Object.keys(s).forEach(function(g) {
          g === "default" || g === "__esModule" || Object.defineProperty(n, g, {
            enumerable: !0,
            get: function() {
              return s[g];
            }
          });
        });
        var u = i(6);
        Object.keys(u).forEach(function(g) {
          g === "default" || g === "__esModule" || Object.defineProperty(n, g, {
            enumerable: !0,
            get: function() {
              return u[g];
            }
          });
        });
        var d = i(37), f = h(d);
        function h(g) {
          return g && g.__esModule ? g : { default: g };
        }
        n.default = f.default;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(4);
        Object.defineProperty(n, "Sensor", {
          enumerable: !0,
          get: function() {
            return h(o).default;
          }
        });
        var a = i(46);
        Object.defineProperty(n, "MouseSensor", {
          enumerable: !0,
          get: function() {
            return h(a).default;
          }
        });
        var s = i(43);
        Object.defineProperty(n, "TouchSensor", {
          enumerable: !0,
          get: function() {
            return h(s).default;
          }
        });
        var u = i(41);
        Object.defineProperty(n, "DragSensor", {
          enumerable: !0,
          get: function() {
            return h(u).default;
          }
        });
        var d = i(39);
        Object.defineProperty(n, "ForceTouchSensor", {
          enumerable: !0,
          get: function() {
            return h(d).default;
          }
        });
        var f = i(3);
        Object.keys(f).forEach(function(g) {
          g === "default" || g === "__esModule" || Object.defineProperty(n, g, {
            enumerable: !0,
            get: function() {
              return f[g];
            }
          });
        });
        function h(g) {
          return g && g.__esModule ? g : { default: g };
        }
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(18);
        Object.keys(o).forEach(function(a) {
          a === "default" || a === "__esModule" || Object.defineProperty(n, a, {
            enumerable: !0,
            get: function() {
              return o[a];
            }
          });
        });
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(23);
        Object.keys(o).forEach(function(a) {
          a === "default" || a === "__esModule" || Object.defineProperty(n, a, {
            enumerable: !0,
            get: function() {
              return o[a];
            }
          });
        });
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(27);
        Object.keys(o).forEach(function(a) {
          a === "default" || a === "__esModule" || Object.defineProperty(n, a, {
            enumerable: !0,
            get: function() {
              return o[a];
            }
          });
        });
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(30);
        Object.keys(o).forEach(function(a) {
          a === "default" || a === "__esModule" || Object.defineProperty(n, a, {
            enumerable: !0,
            get: function() {
              return o[a];
            }
          });
        });
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(33);
        Object.keys(o).forEach(function(a) {
          a === "default" || a === "__esModule" || Object.defineProperty(n, a, {
            enumerable: !0,
            get: function() {
              return o[a];
            }
          });
        });
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(62);
        Object.defineProperty(n, "Announcement", {
          enumerable: !0,
          get: function() {
            return d(o).default;
          }
        }), Object.defineProperty(n, "defaultAnnouncementOptions", {
          enumerable: !0,
          get: function() {
            return o.defaultOptions;
          }
        });
        var a = i(59);
        Object.defineProperty(n, "Focusable", {
          enumerable: !0,
          get: function() {
            return d(a).default;
          }
        });
        var s = i(57);
        Object.defineProperty(n, "Mirror", {
          enumerable: !0,
          get: function() {
            return d(s).default;
          }
        }), Object.defineProperty(n, "defaultMirrorOptions", {
          enumerable: !0,
          get: function() {
            return s.defaultOptions;
          }
        });
        var u = i(53);
        Object.defineProperty(n, "Scrollable", {
          enumerable: !0,
          get: function() {
            return d(u).default;
          }
        }), Object.defineProperty(n, "defaultScrollableOptions", {
          enumerable: !0,
          get: function() {
            return u.defaultOptions;
          }
        });
        function d(f) {
          return f && f.__esModule ? f : { default: f };
        }
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(63);
        Object.keys(o).forEach(function(a) {
          a === "default" || a === "__esModule" || Object.defineProperty(n, a, {
            enumerable: !0,
            get: function() {
              return o[a];
            }
          });
        });
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(65);
        Object.keys(o).forEach(function(a) {
          a === "default" || a === "__esModule" || Object.defineProperty(n, a, {
            enumerable: !0,
            get: function() {
              return o[a];
            }
          });
        });
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.defaultOptions = void 0;
        var o = Object.assign || function(v) {
          for (var w = 1; w < arguments.length; w++) {
            var x = arguments[w];
            for (var y in x)
              Object.prototype.hasOwnProperty.call(x, y) && (v[y] = x[y]);
          }
          return v;
        }, a = i(1), s = u(a);
        function u(v) {
          return v && v.__esModule ? v : { default: v };
        }
        const d = Symbol("onSortableSorted"), f = n.defaultOptions = {
          duration: 150,
          easingFunction: "ease-in-out",
          horizontal: !1
        };
        class h extends s.default {
          constructor(w) {
            super(w), this.options = o({}, f, this.getOptions()), this.lastAnimationFrame = null, this[d] = this[d].bind(this);
          }
          attach() {
            this.draggable.on("sortable:sorted", this[d]);
          }
          detach() {
            this.draggable.off("sortable:sorted", this[d]);
          }
          getOptions() {
            return this.draggable.options.swapAnimation || {};
          }
          [d]({ oldIndex: w, newIndex: x, dragEvent: y }) {
            const { source: C, over: S } = y;
            cancelAnimationFrame(this.lastAnimationFrame), this.lastAnimationFrame = requestAnimationFrame(() => {
              w >= x ? g(C, S, this.options) : g(S, C, this.options);
            });
          }
        }
        n.default = h;
        function g(v, w, { duration: x, easingFunction: y, horizontal: C }) {
          for (const S of [v, w])
            S.style.pointerEvents = "none";
          if (C) {
            const S = v.offsetWidth;
            v.style.transform = `translate3d(${S}px, 0, 0)`, w.style.transform = `translate3d(-${S}px, 0, 0)`;
          } else {
            const S = v.offsetHeight;
            v.style.transform = `translate3d(0, ${S}px, 0)`, w.style.transform = `translate3d(0, -${S}px, 0)`;
          }
          requestAnimationFrame(() => {
            for (const S of [v, w])
              S.addEventListener("transitionend", m), S.style.transition = `transform ${x}ms ${y}`, S.style.transform = "";
          });
        }
        function m(v) {
          v.target.style.transition = "", v.target.style.pointerEvents = "", v.target.removeEventListener("transitionend", m);
        }
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.defaultOptions = void 0;
        var o = i(15), a = s(o);
        function s(u) {
          return u && u.__esModule ? u : { default: u };
        }
        n.default = a.default, n.defaultOptions = o.defaultOptions;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(1), a = u(o), s = i(7);
        function u(x) {
          return x && x.__esModule ? x : { default: x };
        }
        const d = Symbol("onDragStart"), f = Symbol("onDragStop"), h = Symbol("onDragOver"), g = Symbol("onDragOut"), m = Symbol("onMirrorCreated"), v = Symbol("onMirrorDestroy");
        class w extends a.default {
          constructor(y) {
            super(y), this.firstSource = null, this.mirror = null, this[d] = this[d].bind(this), this[f] = this[f].bind(this), this[h] = this[h].bind(this), this[g] = this[g].bind(this), this[m] = this[m].bind(this), this[v] = this[v].bind(this);
          }
          attach() {
            this.draggable.on("drag:start", this[d]).on("drag:stop", this[f]).on("drag:over", this[h]).on("drag:out", this[g]).on("droppable:over", this[h]).on("droppable:out", this[g]).on("mirror:created", this[m]).on("mirror:destroy", this[v]);
          }
          detach() {
            this.draggable.off("drag:start", this[d]).off("drag:stop", this[f]).off("drag:over", this[h]).off("drag:out", this[g]).off("droppable:over", this[h]).off("droppable:out", this[g]).off("mirror:created", this[m]).off("mirror:destroy", this[v]);
          }
          [d](y) {
            y.canceled() || (this.firstSource = y.source);
          }
          [f]() {
            this.firstSource = null;
          }
          [h](y) {
            if (y.canceled())
              return;
            const C = y.source || y.dragEvent.source;
            if (C === this.firstSource) {
              this.firstSource = null;
              return;
            }
            const S = new s.SnapInEvent({
              dragEvent: y,
              snappable: y.over || y.droppable
            });
            this.draggable.trigger(S), !S.canceled() && (this.mirror && (this.mirror.style.display = "none"), C.classList.remove(this.draggable.getClassNameFor("source:dragging")), C.classList.add(this.draggable.getClassNameFor("source:placed")), setTimeout(() => {
              C.classList.remove(this.draggable.getClassNameFor("source:placed"));
            }, this.draggable.options.placedTimeout));
          }
          [g](y) {
            if (y.canceled())
              return;
            const C = y.source || y.dragEvent.source, S = new s.SnapOutEvent({
              dragEvent: y,
              snappable: y.over || y.droppable
            });
            this.draggable.trigger(S), !S.canceled() && (this.mirror && (this.mirror.style.display = ""), C.classList.add(this.draggable.getClassNameFor("source:dragging")));
          }
          [m]({ mirror: y }) {
            this.mirror = y;
          }
          [v]() {
            this.mirror = null;
          }
        }
        n.default = w;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.SnapOutEvent = n.SnapInEvent = n.SnapEvent = void 0;
        var o = i(0), a = s(o);
        function s(h) {
          return h && h.__esModule ? h : { default: h };
        }
        class u extends a.default {
          get dragEvent() {
            return this.data.dragEvent;
          }
          get snappable() {
            return this.data.snappable;
          }
        }
        n.SnapEvent = u, u.type = "snap";
        class d extends u {
        }
        n.SnapInEvent = d, d.type = "snap:in", d.cancelable = !0;
        class f extends u {
        }
        n.SnapOutEvent = f, f.type = "snap:out", f.cancelable = !0;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(7);
        Object.keys(o).forEach(function(d) {
          d === "default" || d === "__esModule" || Object.defineProperty(n, d, {
            enumerable: !0,
            get: function() {
              return o[d];
            }
          });
        });
        var a = i(17), s = u(a);
        function u(d) {
          return d && d.__esModule ? d : { default: d };
        }
        n.default = s.default;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.defaultOptions = void 0;
        var o = Object.assign || function(x) {
          for (var y = 1; y < arguments.length; y++) {
            var C = arguments[y];
            for (var S in C)
              Object.prototype.hasOwnProperty.call(C, S) && (x[S] = C[S]);
          }
          return x;
        }, a = i(1), s = d(a), u = i(2);
        function d(x) {
          return x && x.__esModule ? x : { default: x };
        }
        const f = Symbol("onMirrorCreated"), h = Symbol("onMirrorDestroy"), g = Symbol("onDragOver"), m = Symbol("resize"), v = n.defaultOptions = {};
        class w extends s.default {
          constructor(y) {
            super(y), this.options = o({}, v, this.getOptions()), this.lastWidth = 0, this.lastHeight = 0, this.mirror = null, this[f] = this[f].bind(this), this[h] = this[h].bind(this), this[g] = this[g].bind(this);
          }
          attach() {
            this.draggable.on("mirror:created", this[f]).on("drag:over", this[g]).on("drag:over:container", this[g]);
          }
          detach() {
            this.draggable.off("mirror:created", this[f]).off("mirror:destroy", this[h]).off("drag:over", this[g]).off("drag:over:container", this[g]);
          }
          getOptions() {
            return this.draggable.options.resizeMirror || {};
          }
          [f]({ mirror: y }) {
            this.mirror = y;
          }
          [h]() {
            this.mirror = null;
          }
          [g](y) {
            this[m](y);
          }
          [m]({ overContainer: y, over: C }) {
            requestAnimationFrame(() => {
              this.mirror.parentNode !== y && y.appendChild(this.mirror);
              const S = C || this.draggable.getDraggableElementsForContainer(y)[0];
              S && (0, u.requestNextAnimationFrame)(() => {
                const T = S.getBoundingClientRect();
                this.lastHeight === T.height && this.lastWidth === T.width || (this.mirror.style.width = `${T.width}px`, this.mirror.style.height = `${T.height}px`, this.lastWidth = T.width, this.lastHeight = T.height);
              });
            });
          }
        }
        n.default = w;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.defaultOptions = void 0;
        var o = i(20), a = s(o);
        function s(u) {
          return u && u.__esModule ? u : { default: u };
        }
        n.default = a.default, n.defaultOptions = o.defaultOptions;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(1), a = d(o), s = i(2), u = i(8);
        function d(v) {
          return v && v.__esModule ? v : { default: v };
        }
        const f = Symbol("onDragMove"), h = Symbol("onDragStop"), g = Symbol("onRequestAnimationFrame");
        class m extends a.default {
          constructor(w) {
            super(w), this.currentlyCollidingElement = null, this.lastCollidingElement = null, this.currentAnimationFrame = null, this[f] = this[f].bind(this), this[h] = this[h].bind(this), this[g] = this[g].bind(this);
          }
          attach() {
            this.draggable.on("drag:move", this[f]).on("drag:stop", this[h]);
          }
          detach() {
            this.draggable.off("drag:move", this[f]).off("drag:stop", this[h]);
          }
          getCollidables() {
            const w = this.draggable.options.collidables;
            return typeof w == "string" ? Array.prototype.slice.call(document.querySelectorAll(w)) : w instanceof NodeList || w instanceof Array ? Array.prototype.slice.call(w) : w instanceof HTMLElement ? [w] : typeof w == "function" ? w() : [];
          }
          [f](w) {
            const x = w.sensorEvent.target;
            this.currentAnimationFrame = requestAnimationFrame(this[g](x)), this.currentlyCollidingElement && w.cancel();
            const y = new u.CollidableInEvent({
              dragEvent: w,
              collidingElement: this.currentlyCollidingElement
            }), C = new u.CollidableOutEvent({
              dragEvent: w,
              collidingElement: this.lastCollidingElement
            }), S = Boolean(this.currentlyCollidingElement && this.lastCollidingElement !== this.currentlyCollidingElement), T = Boolean(!this.currentlyCollidingElement && this.lastCollidingElement);
            S ? (this.lastCollidingElement && this.draggable.trigger(C), this.draggable.trigger(y)) : T && this.draggable.trigger(C), this.lastCollidingElement = this.currentlyCollidingElement;
          }
          [h](w) {
            const x = this.currentlyCollidingElement || this.lastCollidingElement, y = new u.CollidableOutEvent({
              dragEvent: w,
              collidingElement: x
            });
            x && this.draggable.trigger(y), this.lastCollidingElement = null, this.currentlyCollidingElement = null;
          }
          [g](w) {
            return () => {
              const x = this.getCollidables();
              this.currentlyCollidingElement = (0, s.closest)(w, (y) => x.includes(y));
            };
          }
        }
        n.default = m;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.CollidableOutEvent = n.CollidableInEvent = n.CollidableEvent = void 0;
        var o = i(0), a = s(o);
        function s(h) {
          return h && h.__esModule ? h : { default: h };
        }
        class u extends a.default {
          get dragEvent() {
            return this.data.dragEvent;
          }
        }
        n.CollidableEvent = u, u.type = "collidable";
        class d extends u {
          get collidingElement() {
            return this.data.collidingElement;
          }
        }
        n.CollidableInEvent = d, d.type = "collidable:in";
        class f extends u {
          get collidingElement() {
            return this.data.collidingElement;
          }
        }
        n.CollidableOutEvent = f, f.type = "collidable:out";
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(8);
        Object.keys(o).forEach(function(d) {
          d === "default" || d === "__esModule" || Object.defineProperty(n, d, {
            enumerable: !0,
            get: function() {
              return o[d];
            }
          });
        });
        var a = i(22), s = u(a);
        function u(d) {
          return d && d.__esModule ? d : { default: d };
        }
        n.default = s.default;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(24);
        Object.defineProperty(n, "Collidable", {
          enumerable: !0,
          get: function() {
            return d(o).default;
          }
        });
        var a = i(21);
        Object.defineProperty(n, "ResizeMirror", {
          enumerable: !0,
          get: function() {
            return d(a).default;
          }
        }), Object.defineProperty(n, "defaultResizeMirrorOptions", {
          enumerable: !0,
          get: function() {
            return a.defaultOptions;
          }
        });
        var s = i(19);
        Object.defineProperty(n, "Snappable", {
          enumerable: !0,
          get: function() {
            return d(s).default;
          }
        });
        var u = i(16);
        Object.defineProperty(n, "SwapAnimation", {
          enumerable: !0,
          get: function() {
            return d(u).default;
          }
        }), Object.defineProperty(n, "defaultSwapAnimationOptions", {
          enumerable: !0,
          get: function() {
            return u.defaultOptions;
          }
        });
        function d(f) {
          return f && f.__esModule ? f : { default: f };
        }
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = Object.assign || function(D) {
          for (var E = 1; E < arguments.length; E++) {
            var N = arguments[E];
            for (var I in N)
              Object.prototype.hasOwnProperty.call(N, I) && (D[I] = N[I]);
          }
          return D;
        }, a = i(5), s = d(a), u = i(9);
        function d(D) {
          return D && D.__esModule ? D : { default: D };
        }
        const f = Symbol("onDragStart"), h = Symbol("onDragOverContainer"), g = Symbol("onDragOver"), m = Symbol("onDragStop");
        function v({ dragEvent: D }) {
          const E = D.source.textContent.trim() || D.source.id || "sortable element";
          if (D.over) {
            const N = D.over.textContent.trim() || D.over.id || "sortable element";
            return D.source.compareDocumentPosition(D.over) & Node.DOCUMENT_POSITION_FOLLOWING ? `Placed ${E} after ${N}` : `Placed ${E} before ${N}`;
          } else
            return `Placed ${E} into a different container`;
        }
        const w = {
          "sortable:sorted": v
        };
        class x extends s.default {
          constructor(E = [], N = {}) {
            super(E, o({}, N, {
              announcements: o({}, w, N.announcements || {})
            })), this.startIndex = null, this.startContainer = null, this[f] = this[f].bind(this), this[h] = this[h].bind(this), this[g] = this[g].bind(this), this[m] = this[m].bind(this), this.on("drag:start", this[f]).on("drag:over:container", this[h]).on("drag:over", this[g]).on("drag:stop", this[m]);
          }
          destroy() {
            super.destroy(), this.off("drag:start", this[f]).off("drag:over:container", this[h]).off("drag:over", this[g]).off("drag:stop", this[m]);
          }
          index(E) {
            return this.getDraggableElementsForContainer(E.parentNode).indexOf(E);
          }
          [f](E) {
            this.startContainer = E.source.parentNode, this.startIndex = this.index(E.source);
            const N = new u.SortableStartEvent({
              dragEvent: E,
              startIndex: this.startIndex,
              startContainer: this.startContainer
            });
            this.trigger(N), N.canceled() && E.cancel();
          }
          [h](E) {
            if (E.canceled())
              return;
            const { source: N, over: I, overContainer: $ } = E, _ = this.index(N), R = new u.SortableSortEvent({
              dragEvent: E,
              currentIndex: _,
              source: N,
              over: I
            });
            if (this.trigger(R), R.canceled())
              return;
            const U = this.getDraggableElementsForContainer($), Q = C({ source: N, over: I, overContainer: $, children: U });
            if (!Q)
              return;
            const { oldContainer: Z, newContainer: X } = Q, re = this.index(E.source), ue = new u.SortableSortedEvent({
              dragEvent: E,
              oldIndex: _,
              newIndex: re,
              oldContainer: Z,
              newContainer: X
            });
            this.trigger(ue);
          }
          [g](E) {
            if (E.over === E.originalSource || E.over === E.source)
              return;
            const { source: N, over: I, overContainer: $ } = E, _ = this.index(N), R = new u.SortableSortEvent({
              dragEvent: E,
              currentIndex: _,
              source: N,
              over: I
            });
            if (this.trigger(R), R.canceled())
              return;
            const U = this.getDraggableElementsForContainer($), Q = C({ source: N, over: I, overContainer: $, children: U });
            if (!Q)
              return;
            const { oldContainer: Z, newContainer: X } = Q, re = this.index(N), ue = new u.SortableSortedEvent({
              dragEvent: E,
              oldIndex: _,
              newIndex: re,
              oldContainer: Z,
              newContainer: X
            });
            this.trigger(ue);
          }
          [m](E) {
            const N = new u.SortableStopEvent({
              dragEvent: E,
              oldIndex: this.startIndex,
              newIndex: this.index(E.source),
              oldContainer: this.startContainer,
              newContainer: E.source.parentNode
            });
            this.trigger(N), this.startIndex = null, this.startContainer = null;
          }
        }
        n.default = x;
        function y(D) {
          return Array.prototype.indexOf.call(D.parentNode.children, D);
        }
        function C({ source: D, over: E, overContainer: N, children: I }) {
          const $ = !I.length, _ = D.parentNode !== N, R = E && !_;
          return $ ? S(D, N) : R ? T(D, E) : _ ? A(D, E, N) : null;
        }
        function S(D, E) {
          const N = D.parentNode;
          return E.appendChild(D), { oldContainer: N, newContainer: E };
        }
        function T(D, E) {
          const N = y(D), I = y(E);
          return N < I ? D.parentNode.insertBefore(D, E.nextElementSibling) : D.parentNode.insertBefore(D, E), { oldContainer: D.parentNode, newContainer: D.parentNode };
        }
        function A(D, E, N) {
          const I = D.parentNode;
          return E ? E.parentNode.insertBefore(D, E) : N.appendChild(D), { oldContainer: I, newContainer: D.parentNode };
        }
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.SortableStopEvent = n.SortableSortedEvent = n.SortableSortEvent = n.SortableStartEvent = n.SortableEvent = void 0;
        var o = i(0), a = s(o);
        function s(m) {
          return m && m.__esModule ? m : { default: m };
        }
        class u extends a.default {
          get dragEvent() {
            return this.data.dragEvent;
          }
        }
        n.SortableEvent = u, u.type = "sortable";
        class d extends u {
          get startIndex() {
            return this.data.startIndex;
          }
          get startContainer() {
            return this.data.startContainer;
          }
        }
        n.SortableStartEvent = d, d.type = "sortable:start", d.cancelable = !0;
        class f extends u {
          get currentIndex() {
            return this.data.currentIndex;
          }
          get over() {
            return this.data.oldIndex;
          }
          get overContainer() {
            return this.data.newIndex;
          }
        }
        n.SortableSortEvent = f, f.type = "sortable:sort", f.cancelable = !0;
        class h extends u {
          get oldIndex() {
            return this.data.oldIndex;
          }
          get newIndex() {
            return this.data.newIndex;
          }
          get oldContainer() {
            return this.data.oldContainer;
          }
          get newContainer() {
            return this.data.newContainer;
          }
        }
        n.SortableSortedEvent = h, h.type = "sortable:sorted";
        class g extends u {
          get oldIndex() {
            return this.data.oldIndex;
          }
          get newIndex() {
            return this.data.newIndex;
          }
          get oldContainer() {
            return this.data.oldContainer;
          }
          get newContainer() {
            return this.data.newContainer;
          }
        }
        n.SortableStopEvent = g, g.type = "sortable:stop";
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(9);
        Object.keys(o).forEach(function(d) {
          d === "default" || d === "__esModule" || Object.defineProperty(n, d, {
            enumerable: !0,
            get: function() {
              return o[d];
            }
          });
        });
        var a = i(26), s = u(a);
        function u(d) {
          return d && d.__esModule ? d : { default: d };
        }
        n.default = s.default;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = Object.assign || function(C) {
          for (var S = 1; S < arguments.length; S++) {
            var T = arguments[S];
            for (var A in T)
              Object.prototype.hasOwnProperty.call(T, A) && (C[A] = T[A]);
          }
          return C;
        }, a = i(5), s = d(a), u = i(10);
        function d(C) {
          return C && C.__esModule ? C : { default: C };
        }
        const f = Symbol("onDragStart"), h = Symbol("onDragOver"), g = Symbol("onDragStop");
        function m({ dragEvent: C, swappedElement: S }) {
          const T = C.source.textContent.trim() || C.source.id || "swappable element", A = S.textContent.trim() || S.id || "swappable element";
          return `Swapped ${T} with ${A}`;
        }
        const v = {
          "swappabled:swapped": m
        };
        class w extends s.default {
          constructor(S = [], T = {}) {
            super(S, o({}, T, {
              announcements: o({}, v, T.announcements || {})
            })), this.lastOver = null, this[f] = this[f].bind(this), this[h] = this[h].bind(this), this[g] = this[g].bind(this), this.on("drag:start", this[f]).on("drag:over", this[h]).on("drag:stop", this[g]);
          }
          destroy() {
            super.destroy(), this.off("drag:start", this._onDragStart).off("drag:over", this._onDragOver).off("drag:stop", this._onDragStop);
          }
          [f](S) {
            const T = new u.SwappableStartEvent({
              dragEvent: S
            });
            this.trigger(T), T.canceled() && S.cancel();
          }
          [h](S) {
            if (S.over === S.originalSource || S.over === S.source || S.canceled())
              return;
            const T = new u.SwappableSwapEvent({
              dragEvent: S,
              over: S.over,
              overContainer: S.overContainer
            });
            if (this.trigger(T), T.canceled())
              return;
            this.lastOver && this.lastOver !== S.over && y(this.lastOver, S.source), this.lastOver === S.over ? this.lastOver = null : this.lastOver = S.over, y(S.source, S.over);
            const A = new u.SwappableSwappedEvent({
              dragEvent: S,
              swappedElement: S.over
            });
            this.trigger(A);
          }
          [g](S) {
            const T = new u.SwappableStopEvent({
              dragEvent: S
            });
            this.trigger(T), this.lastOver = null;
          }
        }
        n.default = w;
        function x(C) {
          const S = document.createElement("div");
          C(S), S.parentNode.removeChild(S);
        }
        function y(C, S) {
          const T = S.parentNode, A = C.parentNode;
          x((D) => {
            A.insertBefore(D, C), T.insertBefore(C, S), A.insertBefore(S, D);
          });
        }
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.SwappableStopEvent = n.SwappableSwappedEvent = n.SwappableSwapEvent = n.SwappableStartEvent = n.SwappableEvent = void 0;
        var o = i(0), a = s(o);
        function s(m) {
          return m && m.__esModule ? m : { default: m };
        }
        class u extends a.default {
          get dragEvent() {
            return this.data.dragEvent;
          }
        }
        n.SwappableEvent = u, u.type = "swappable";
        class d extends u {
        }
        n.SwappableStartEvent = d, d.type = "swappable:start", d.cancelable = !0;
        class f extends u {
          get over() {
            return this.data.over;
          }
          get overContainer() {
            return this.data.overContainer;
          }
        }
        n.SwappableSwapEvent = f, f.type = "swappable:swap", f.cancelable = !0;
        class h extends u {
          get swappedElement() {
            return this.data.swappedElement;
          }
        }
        n.SwappableSwappedEvent = h, h.type = "swappable:swapped";
        class g extends u {
        }
        n.SwappableStopEvent = g, g.type = "swappable:stop";
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(10);
        Object.keys(o).forEach(function(d) {
          d === "default" || d === "__esModule" || Object.defineProperty(n, d, {
            enumerable: !0,
            get: function() {
              return o[d];
            }
          });
        });
        var a = i(29), s = u(a);
        function u(d) {
          return d && d.__esModule ? d : { default: d };
        }
        n.default = s.default;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = Object.assign || function(N) {
          for (var I = 1; I < arguments.length; I++) {
            var $ = arguments[I];
            for (var _ in $)
              Object.prototype.hasOwnProperty.call($, _) && (N[_] = $[_]);
          }
          return N;
        }, a = i(2), s = i(5), u = f(s), d = i(11);
        function f(N) {
          return N && N.__esModule ? N : { default: N };
        }
        const h = Symbol("onDragStart"), g = Symbol("onDragMove"), m = Symbol("onDragStop"), v = Symbol("dropInDropZone"), w = Symbol("returnToOriginalDropzone"), x = Symbol("closestDropzone"), y = Symbol("getDropzones");
        function C({ dragEvent: N, dropzone: I }) {
          const $ = N.source.textContent.trim() || N.source.id || "draggable element", _ = I.textContent.trim() || I.id || "droppable element";
          return `Dropped ${$} into ${_}`;
        }
        function S({ dragEvent: N, dropzone: I }) {
          const $ = N.source.textContent.trim() || N.source.id || "draggable element", _ = I.textContent.trim() || I.id || "droppable element";
          return `Returned ${$} from ${_}`;
        }
        const T = {
          "droppable:dropped": C,
          "droppable:returned": S
        }, A = {
          "droppable:active": "draggable-dropzone--active",
          "droppable:occupied": "draggable-dropzone--occupied"
        }, D = {
          dropzone: ".draggable-droppable"
        };
        class E extends u.default {
          constructor(I = [], $ = {}) {
            super(I, o({}, D, $, {
              classes: o({}, A, $.classes || {}),
              announcements: o({}, T, $.announcements || {})
            })), this.dropzones = null, this.lastDropzone = null, this.initialDropzone = null, this[h] = this[h].bind(this), this[g] = this[g].bind(this), this[m] = this[m].bind(this), this.on("drag:start", this[h]).on("drag:move", this[g]).on("drag:stop", this[m]);
          }
          destroy() {
            super.destroy(), this.off("drag:start", this[h]).off("drag:move", this[g]).off("drag:stop", this[m]);
          }
          [h](I) {
            if (I.canceled())
              return;
            this.dropzones = [...this[y]()];
            const $ = (0, a.closest)(I.sensorEvent.target, this.options.dropzone);
            if (!$) {
              I.cancel();
              return;
            }
            const _ = new d.DroppableStartEvent({
              dragEvent: I,
              dropzone: $
            });
            if (this.trigger(_), _.canceled()) {
              I.cancel();
              return;
            }
            this.initialDropzone = $;
            for (const R of this.dropzones)
              R.classList.contains(this.getClassNameFor("droppable:occupied")) || R.classList.add(this.getClassNameFor("droppable:active"));
          }
          [g](I) {
            if (I.canceled())
              return;
            const $ = this[x](I.sensorEvent.target);
            $ && !$.classList.contains(this.getClassNameFor("droppable:occupied")) && this[v](I, $) ? this.lastDropzone = $ : (!$ || $ === this.initialDropzone) && this.lastDropzone && (this[w](I), this.lastDropzone = null);
          }
          [m](I) {
            const $ = new d.DroppableStopEvent({
              dragEvent: I,
              dropzone: this.lastDropzone || this.initialDropzone
            });
            this.trigger($);
            const _ = this.getClassNameFor("droppable:occupied");
            for (const R of this.dropzones)
              R.classList.remove(this.getClassNameFor("droppable:active"));
            this.lastDropzone && this.lastDropzone !== this.initialDropzone && this.initialDropzone.classList.remove(_), this.dropzones = null, this.lastDropzone = null, this.initialDropzone = null;
          }
          [v](I, $) {
            const _ = new d.DroppableDroppedEvent({
              dragEvent: I,
              dropzone: $
            });
            if (this.trigger(_), _.canceled())
              return !1;
            const R = this.getClassNameFor("droppable:occupied");
            return this.lastDropzone && this.lastDropzone.classList.remove(R), $.appendChild(I.source), $.classList.add(R), !0;
          }
          [w](I) {
            const $ = new d.DroppableReturnedEvent({
              dragEvent: I,
              dropzone: this.lastDropzone
            });
            this.trigger($), !$.canceled() && (this.initialDropzone.appendChild(I.source), this.lastDropzone.classList.remove(this.getClassNameFor("droppable:occupied")));
          }
          [x](I) {
            return this.dropzones ? (0, a.closest)(I, this.dropzones) : null;
          }
          [y]() {
            const I = this.options.dropzone;
            return typeof I == "string" ? document.querySelectorAll(I) : I instanceof NodeList || I instanceof Array ? I : typeof I == "function" ? I() : [];
          }
        }
        n.default = E;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.DroppableStopEvent = n.DroppableReturnedEvent = n.DroppableDroppedEvent = n.DroppableStartEvent = n.DroppableEvent = void 0;
        var o = i(0), a = s(o);
        function s(m) {
          return m && m.__esModule ? m : { default: m };
        }
        class u extends a.default {
          get dragEvent() {
            return this.data.dragEvent;
          }
        }
        n.DroppableEvent = u, u.type = "droppable";
        class d extends u {
          get dropzone() {
            return this.data.dropzone;
          }
        }
        n.DroppableStartEvent = d, d.type = "droppable:start", d.cancelable = !0;
        class f extends u {
          get dropzone() {
            return this.data.dropzone;
          }
        }
        n.DroppableDroppedEvent = f, f.type = "droppable:dropped", f.cancelable = !0;
        class h extends u {
          get dropzone() {
            return this.data.dropzone;
          }
        }
        n.DroppableReturnedEvent = h, h.type = "droppable:returned", h.cancelable = !0;
        class g extends u {
          get dropzone() {
            return this.data.dropzone;
          }
        }
        n.DroppableStopEvent = g, g.type = "droppable:stop", g.cancelable = !0;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(11);
        Object.keys(o).forEach(function(d) {
          d === "default" || d === "__esModule" || Object.defineProperty(n, d, {
            enumerable: !0,
            get: function() {
              return o[d];
            }
          });
        });
        var a = i(32), s = u(a);
        function u(d) {
          return d && d.__esModule ? d : { default: d };
        }
        n.default = s.default;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        class o {
          constructor() {
            this.callbacks = {};
          }
          on(s, ...u) {
            return this.callbacks[s] || (this.callbacks[s] = []), this.callbacks[s].push(...u), this;
          }
          off(s, u) {
            if (!this.callbacks[s])
              return null;
            const d = this.callbacks[s].slice(0);
            for (let f = 0; f < d.length; f++)
              u === d[f] && this.callbacks[s].splice(f, 1);
            return this;
          }
          trigger(s) {
            if (!this.callbacks[s.type])
              return null;
            const u = [...this.callbacks[s.type]], d = [];
            for (let f = u.length - 1; f >= 0; f--) {
              const h = u[f];
              try {
                h(s);
              } catch (g) {
                d.push(g);
              }
            }
            return d.length && console.error(`Draggable caught errors while triggering '${s.type}'`, d), this;
          }
        }
        n.default = o;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(35), a = s(o);
        function s(u) {
          return u && u.__esModule ? u : { default: u };
        }
        n.default = a.default;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.defaultOptions = void 0;
        var o = Object.assign || function(N) {
          for (var I = 1; I < arguments.length; I++) {
            var $ = arguments[I];
            for (var _ in $)
              Object.prototype.hasOwnProperty.call($, _) && (N[_] = $[_]);
          }
          return N;
        }, a = i(2), s = i(12), u = i(36), d = m(u), f = i(6), h = i(13), g = i(14);
        function m(N) {
          return N && N.__esModule ? N : { default: N };
        }
        const v = Symbol("onDragStart"), w = Symbol("onDragMove"), x = Symbol("onDragStop"), y = Symbol("onDragPressure"), C = {
          "drag:start": (N) => `Picked up ${N.source.textContent.trim() || N.source.id || "draggable element"}`,
          "drag:stop": (N) => `Released ${N.source.textContent.trim() || N.source.id || "draggable element"}`
        }, S = {
          "container:dragging": "draggable-container--is-dragging",
          "source:dragging": "draggable-source--is-dragging",
          "source:placed": "draggable-source--placed",
          "container:placed": "draggable-container--placed",
          "body:dragging": "draggable--is-dragging",
          "draggable:over": "draggable--over",
          "container:over": "draggable-container--over",
          "source:original": "draggable--original",
          mirror: "draggable-mirror"
        }, T = n.defaultOptions = {
          draggable: ".draggable-source",
          handle: null,
          delay: 100,
          placedTimeout: 800,
          plugins: [],
          sensors: []
        };
        class A {
          constructor(I = [document.body], $ = {}) {
            if (I instanceof NodeList || I instanceof Array)
              this.containers = [...I];
            else if (I instanceof HTMLElement)
              this.containers = [I];
            else
              throw new Error("Draggable containers are expected to be of type `NodeList`, `HTMLElement[]` or `HTMLElement`");
            this.options = o({}, T, $, {
              classes: o({}, S, $.classes || {}),
              announcements: o({}, C, $.announcements || {})
            }), this.emitter = new d.default(), this.dragging = !1, this.plugins = [], this.sensors = [], this[v] = this[v].bind(this), this[w] = this[w].bind(this), this[x] = this[x].bind(this), this[y] = this[y].bind(this), document.addEventListener("drag:start", this[v], !0), document.addEventListener("drag:move", this[w], !0), document.addEventListener("drag:stop", this[x], !0), document.addEventListener("drag:pressure", this[y], !0);
            const _ = Object.values(A.Plugins).map((Q) => Q), R = [f.MouseSensor, f.TouchSensor];
            this.addPlugin(..._, ...this.options.plugins), this.addSensor(...R, ...this.options.sensors);
            const U = new h.DraggableInitializedEvent({
              draggable: this
            });
            this.on("mirror:created", ({ mirror: Q }) => this.mirror = Q), this.on("mirror:destroy", () => this.mirror = null), this.trigger(U);
          }
          destroy() {
            document.removeEventListener("drag:start", this[v], !0), document.removeEventListener("drag:move", this[w], !0), document.removeEventListener("drag:stop", this[x], !0), document.removeEventListener("drag:pressure", this[y], !0);
            const I = new h.DraggableDestroyEvent({
              draggable: this
            });
            this.trigger(I), this.removePlugin(...this.plugins.map(($) => $.constructor)), this.removeSensor(...this.sensors.map(($) => $.constructor));
          }
          addPlugin(...I) {
            const $ = I.map((_) => new _(this));
            return $.forEach((_) => _.attach()), this.plugins = [...this.plugins, ...$], this;
          }
          removePlugin(...I) {
            return this.plugins.filter((_) => I.includes(_.constructor)).forEach((_) => _.detach()), this.plugins = this.plugins.filter((_) => !I.includes(_.constructor)), this;
          }
          addSensor(...I) {
            const $ = I.map((_) => new _(this.containers, this.options));
            return $.forEach((_) => _.attach()), this.sensors = [...this.sensors, ...$], this;
          }
          removeSensor(...I) {
            return this.sensors.filter((_) => I.includes(_.constructor)).forEach((_) => _.detach()), this.sensors = this.sensors.filter((_) => !I.includes(_.constructor)), this;
          }
          addContainer(...I) {
            return this.containers = [...this.containers, ...I], this.sensors.forEach(($) => $.addContainer(...I)), this;
          }
          removeContainer(...I) {
            return this.containers = this.containers.filter(($) => !I.includes($)), this.sensors.forEach(($) => $.removeContainer(...I)), this;
          }
          on(I, ...$) {
            return this.emitter.on(I, ...$), this;
          }
          off(I, $) {
            return this.emitter.off(I, $), this;
          }
          trigger(I) {
            return this.emitter.trigger(I), this;
          }
          getClassNameFor(I) {
            return this.options.classes[I];
          }
          isDragging() {
            return Boolean(this.dragging);
          }
          getDraggableElements() {
            return this.containers.reduce((I, $) => [...I, ...this.getDraggableElementsForContainer($)], []);
          }
          getDraggableElementsForContainer(I) {
            return [...I.querySelectorAll(this.options.draggable)].filter((_) => _ !== this.originalSource && _ !== this.mirror);
          }
          [v](I) {
            const $ = D(I), { target: _, container: R } = $;
            if (!this.containers.includes(R))
              return;
            if (this.options.handle && _ && !(0, a.closest)(_, this.options.handle)) {
              $.cancel();
              return;
            }
            if (this.originalSource = (0, a.closest)(_, this.options.draggable), this.sourceContainer = R, !this.originalSource) {
              $.cancel();
              return;
            }
            this.lastPlacedSource && this.lastPlacedContainer && (clearTimeout(this.placedTimeoutID), this.lastPlacedSource.classList.remove(this.getClassNameFor("source:placed")), this.lastPlacedContainer.classList.remove(this.getClassNameFor("container:placed"))), this.source = this.originalSource.cloneNode(!0), this.originalSource.parentNode.insertBefore(this.source, this.originalSource), this.originalSource.style.display = "none";
            const U = new g.DragStartEvent({
              source: this.source,
              originalSource: this.originalSource,
              sourceContainer: R,
              sensorEvent: $
            });
            if (this.trigger(U), this.dragging = !U.canceled(), U.canceled()) {
              this.source.parentNode.removeChild(this.source), this.originalSource.style.display = null;
              return;
            }
            this.originalSource.classList.add(this.getClassNameFor("source:original")), this.source.classList.add(this.getClassNameFor("source:dragging")), this.sourceContainer.classList.add(this.getClassNameFor("container:dragging")), document.body.classList.add(this.getClassNameFor("body:dragging")), E(document.body, "none"), requestAnimationFrame(() => {
              const Z = D(I).clone({ target: this.source });
              this[w](o({}, I, {
                detail: Z
              }));
            });
          }
          [w](I) {
            if (!this.dragging)
              return;
            const $ = D(I), { container: _ } = $;
            let R = $.target;
            const U = new g.DragMoveEvent({
              source: this.source,
              originalSource: this.originalSource,
              sourceContainer: _,
              sensorEvent: $
            });
            this.trigger(U), U.canceled() && $.cancel(), R = (0, a.closest)(R, this.options.draggable);
            const Q = (0, a.closest)($.target, this.containers), Z = $.overContainer || Q, X = this.currentOverContainer && Z !== this.currentOverContainer, re = this.currentOver && R !== this.currentOver, ue = Z && this.currentOverContainer !== Z, he = Q && R && this.currentOver !== R;
            if (re) {
              const te = new g.DragOutEvent({
                source: this.source,
                originalSource: this.originalSource,
                sourceContainer: _,
                sensorEvent: $,
                over: this.currentOver
              });
              this.currentOver.classList.remove(this.getClassNameFor("draggable:over")), this.currentOver = null, this.trigger(te);
            }
            if (X) {
              const te = new g.DragOutContainerEvent({
                source: this.source,
                originalSource: this.originalSource,
                sourceContainer: _,
                sensorEvent: $,
                overContainer: this.currentOverContainer
              });
              this.currentOverContainer.classList.remove(this.getClassNameFor("container:over")), this.currentOverContainer = null, this.trigger(te);
            }
            if (ue) {
              Z.classList.add(this.getClassNameFor("container:over"));
              const te = new g.DragOverContainerEvent({
                source: this.source,
                originalSource: this.originalSource,
                sourceContainer: _,
                sensorEvent: $,
                overContainer: Z
              });
              this.currentOverContainer = Z, this.trigger(te);
            }
            if (he) {
              R.classList.add(this.getClassNameFor("draggable:over"));
              const te = new g.DragOverEvent({
                source: this.source,
                originalSource: this.originalSource,
                sourceContainer: _,
                sensorEvent: $,
                overContainer: Z,
                over: R
              });
              this.currentOver = R, this.trigger(te);
            }
          }
          [x](I) {
            if (!this.dragging)
              return;
            this.dragging = !1;
            const $ = new g.DragStopEvent({
              source: this.source,
              originalSource: this.originalSource,
              sensorEvent: I.sensorEvent,
              sourceContainer: this.sourceContainer
            });
            this.trigger($), this.source.parentNode.insertBefore(this.originalSource, this.source), this.source.parentNode.removeChild(this.source), this.originalSource.style.display = "", this.source.classList.remove(this.getClassNameFor("source:dragging")), this.originalSource.classList.remove(this.getClassNameFor("source:original")), this.originalSource.classList.add(this.getClassNameFor("source:placed")), this.sourceContainer.classList.add(this.getClassNameFor("container:placed")), this.sourceContainer.classList.remove(this.getClassNameFor("container:dragging")), document.body.classList.remove(this.getClassNameFor("body:dragging")), E(document.body, ""), this.currentOver && this.currentOver.classList.remove(this.getClassNameFor("draggable:over")), this.currentOverContainer && this.currentOverContainer.classList.remove(this.getClassNameFor("container:over")), this.lastPlacedSource = this.originalSource, this.lastPlacedContainer = this.sourceContainer, this.placedTimeoutID = setTimeout(() => {
              this.lastPlacedSource && this.lastPlacedSource.classList.remove(this.getClassNameFor("source:placed")), this.lastPlacedContainer && this.lastPlacedContainer.classList.remove(this.getClassNameFor("container:placed")), this.lastPlacedSource = null, this.lastPlacedContainer = null;
            }, this.options.placedTimeout), this.source = null, this.originalSource = null, this.currentOverContainer = null, this.currentOver = null, this.sourceContainer = null;
          }
          [y](I) {
            if (!this.dragging)
              return;
            const $ = D(I), _ = this.source || (0, a.closest)($.originalEvent.target, this.options.draggable), R = new g.DragPressureEvent({
              sensorEvent: $,
              source: _,
              pressure: $.pressure
            });
            this.trigger(R);
          }
        }
        n.default = A, A.Plugins = { Announcement: s.Announcement, Focusable: s.Focusable, Mirror: s.Mirror, Scrollable: s.Scrollable };
        function D(N) {
          return N.detail;
        }
        function E(N, I) {
          N.style.webkitUserSelect = I, N.style.mozUserSelect = I, N.style.msUserSelect = I, N.style.oUserSelect = I, N.style.userSelect = I;
        }
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(4), a = u(o), s = i(3);
        function u(y) {
          return y && y.__esModule ? y : { default: y };
        }
        const d = Symbol("onMouseForceWillBegin"), f = Symbol("onMouseForceDown"), h = Symbol("onMouseDown"), g = Symbol("onMouseForceChange"), m = Symbol("onMouseMove"), v = Symbol("onMouseUp"), w = Symbol("onMouseForceGlobalChange");
        class x extends a.default {
          constructor(C = [], S = {}) {
            super(C, S), this.mightDrag = !1, this[d] = this[d].bind(this), this[f] = this[f].bind(this), this[h] = this[h].bind(this), this[g] = this[g].bind(this), this[m] = this[m].bind(this), this[v] = this[v].bind(this);
          }
          attach() {
            for (const C of this.containers)
              C.addEventListener("webkitmouseforcewillbegin", this[d], !1), C.addEventListener("webkitmouseforcedown", this[f], !1), C.addEventListener("mousedown", this[h], !0), C.addEventListener("webkitmouseforcechanged", this[g], !1);
            document.addEventListener("mousemove", this[m]), document.addEventListener("mouseup", this[v]);
          }
          detach() {
            for (const C of this.containers)
              C.removeEventListener("webkitmouseforcewillbegin", this[d], !1), C.removeEventListener("webkitmouseforcedown", this[f], !1), C.removeEventListener("mousedown", this[h], !0), C.removeEventListener("webkitmouseforcechanged", this[g], !1);
            document.removeEventListener("mousemove", this[m]), document.removeEventListener("mouseup", this[v]);
          }
          [d](C) {
            C.preventDefault(), this.mightDrag = !0;
          }
          [f](C) {
            if (this.dragging)
              return;
            const S = document.elementFromPoint(C.clientX, C.clientY), T = C.currentTarget, A = new s.DragStartSensorEvent({
              clientX: C.clientX,
              clientY: C.clientY,
              target: S,
              container: T,
              originalEvent: C
            });
            this.trigger(T, A), this.currentContainer = T, this.dragging = !A.canceled(), this.mightDrag = !1;
          }
          [v](C) {
            if (!this.dragging)
              return;
            const S = new s.DragStopSensorEvent({
              clientX: C.clientX,
              clientY: C.clientY,
              target: null,
              container: this.currentContainer,
              originalEvent: C
            });
            this.trigger(this.currentContainer, S), this.currentContainer = null, this.dragging = !1, this.mightDrag = !1;
          }
          [h](C) {
            this.mightDrag && (C.stopPropagation(), C.stopImmediatePropagation(), C.preventDefault());
          }
          [m](C) {
            if (!this.dragging)
              return;
            const S = document.elementFromPoint(C.clientX, C.clientY), T = new s.DragMoveSensorEvent({
              clientX: C.clientX,
              clientY: C.clientY,
              target: S,
              container: this.currentContainer,
              originalEvent: C
            });
            this.trigger(this.currentContainer, T);
          }
          [g](C) {
            if (this.dragging)
              return;
            const S = C.target, T = C.currentTarget, A = new s.DragPressureSensorEvent({
              pressure: C.webkitForce,
              clientX: C.clientX,
              clientY: C.clientY,
              target: S,
              container: T,
              originalEvent: C
            });
            this.trigger(T, A);
          }
          [w](C) {
            if (!this.dragging)
              return;
            const S = C.target, T = new s.DragPressureSensorEvent({
              pressure: C.webkitForce,
              clientX: C.clientX,
              clientY: C.clientY,
              target: S,
              container: this.currentContainer,
              originalEvent: C
            });
            this.trigger(this.currentContainer, T);
          }
        }
        n.default = x;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(38), a = s(o);
        function s(u) {
          return u && u.__esModule ? u : { default: u };
        }
        n.default = a.default;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(2), a = i(4), s = d(a), u = i(3);
        function d(C) {
          return C && C.__esModule ? C : { default: C };
        }
        const f = Symbol("onMouseDown"), h = Symbol("onMouseUp"), g = Symbol("onDragStart"), m = Symbol("onDragOver"), v = Symbol("onDragEnd"), w = Symbol("onDrop"), x = Symbol("reset");
        class y extends s.default {
          constructor(S = [], T = {}) {
            super(S, T), this.mouseDownTimeout = null, this.draggableElement = null, this.nativeDraggableElement = null, this[f] = this[f].bind(this), this[h] = this[h].bind(this), this[g] = this[g].bind(this), this[m] = this[m].bind(this), this[v] = this[v].bind(this), this[w] = this[w].bind(this);
          }
          attach() {
            document.addEventListener("mousedown", this[f], !0);
          }
          detach() {
            document.removeEventListener("mousedown", this[f], !0);
          }
          [g](S) {
            S.dataTransfer.setData("text", ""), S.dataTransfer.effectAllowed = this.options.type;
            const T = document.elementFromPoint(S.clientX, S.clientY);
            if (this.currentContainer = (0, o.closest)(S.target, this.containers), !this.currentContainer)
              return;
            const A = new u.DragStartSensorEvent({
              clientX: S.clientX,
              clientY: S.clientY,
              target: T,
              container: this.currentContainer,
              originalEvent: S
            });
            setTimeout(() => {
              this.trigger(this.currentContainer, A), A.canceled() ? this.dragging = !1 : this.dragging = !0;
            }, 0);
          }
          [m](S) {
            if (!this.dragging)
              return;
            const T = document.elementFromPoint(S.clientX, S.clientY), A = this.currentContainer, D = new u.DragMoveSensorEvent({
              clientX: S.clientX,
              clientY: S.clientY,
              target: T,
              container: A,
              originalEvent: S
            });
            this.trigger(A, D), D.canceled() || (S.preventDefault(), S.dataTransfer.dropEffect = this.options.type);
          }
          [v](S) {
            if (!this.dragging)
              return;
            document.removeEventListener("mouseup", this[h], !0);
            const T = document.elementFromPoint(S.clientX, S.clientY), A = this.currentContainer, D = new u.DragStopSensorEvent({
              clientX: S.clientX,
              clientY: S.clientY,
              target: T,
              container: A,
              originalEvent: S
            });
            this.trigger(A, D), this.dragging = !1, this[x]();
          }
          [w](S) {
            S.preventDefault();
          }
          [f](S) {
            if (S.target && (S.target.form || S.target.contenteditable))
              return;
            const T = (0, o.closest)(S.target, (D) => D.draggable);
            T && (T.draggable = !1, this.nativeDraggableElement = T), document.addEventListener("mouseup", this[h], !0), document.addEventListener("dragstart", this[g], !1), document.addEventListener("dragover", this[m], !1), document.addEventListener("dragend", this[v], !1), document.addEventListener("drop", this[w], !1);
            const A = (0, o.closest)(S.target, this.options.draggable);
            A && (this.mouseDownTimeout = setTimeout(() => {
              A.draggable = !0, this.draggableElement = A;
            }, this.options.delay));
          }
          [h]() {
            this[x]();
          }
          [x]() {
            clearTimeout(this.mouseDownTimeout), document.removeEventListener("mouseup", this[h], !0), document.removeEventListener("dragstart", this[g], !1), document.removeEventListener("dragover", this[m], !1), document.removeEventListener("dragend", this[v], !1), document.removeEventListener("drop", this[w], !1), this.nativeDraggableElement && (this.nativeDraggableElement.draggable = !0, this.nativeDraggableElement = null), this.draggableElement && (this.draggableElement.draggable = !1, this.draggableElement = null);
          }
        }
        n.default = y;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(40), a = s(o);
        function s(u) {
          return u && u.__esModule ? u : { default: u };
        }
        n.default = a.default;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(2), a = i(4), s = d(a), u = i(3);
        function d(y) {
          return y && y.__esModule ? y : { default: y };
        }
        const f = Symbol("onTouchStart"), h = Symbol("onTouchHold"), g = Symbol("onTouchEnd"), m = Symbol("onTouchMove");
        let v = !1;
        window.addEventListener("touchmove", (y) => {
          v && y.preventDefault();
        }, { passive: !1 });
        class w extends s.default {
          constructor(C = [], S = {}) {
            super(C, S), this.currentScrollableParent = null, this.tapTimeout = null, this.touchMoved = !1, this[f] = this[f].bind(this), this[h] = this[h].bind(this), this[g] = this[g].bind(this), this[m] = this[m].bind(this);
          }
          attach() {
            document.addEventListener("touchstart", this[f]);
          }
          detach() {
            document.removeEventListener("touchstart", this[f]);
          }
          [f](C) {
            const S = (0, o.closest)(C.target, this.containers);
            S && (document.addEventListener("touchmove", this[m]), document.addEventListener("touchend", this[g]), document.addEventListener("touchcancel", this[g]), S.addEventListener("contextmenu", x), this.currentContainer = S, this.tapTimeout = setTimeout(this[h](C, S), this.options.delay));
          }
          [h](C, S) {
            return () => {
              if (this.touchMoved)
                return;
              const T = C.touches[0] || C.changedTouches[0], A = C.target, D = new u.DragStartSensorEvent({
                clientX: T.pageX,
                clientY: T.pageY,
                target: A,
                container: S,
                originalEvent: C
              });
              this.trigger(S, D), this.dragging = !D.canceled(), v = this.dragging;
            };
          }
          [m](C) {
            if (this.touchMoved = !0, !this.dragging)
              return;
            const S = C.touches[0] || C.changedTouches[0], T = document.elementFromPoint(S.pageX - window.scrollX, S.pageY - window.scrollY), A = new u.DragMoveSensorEvent({
              clientX: S.pageX,
              clientY: S.pageY,
              target: T,
              container: this.currentContainer,
              originalEvent: C
            });
            this.trigger(this.currentContainer, A);
          }
          [g](C) {
            if (this.touchMoved = !1, v = !1, document.removeEventListener("touchend", this[g]), document.removeEventListener("touchcancel", this[g]), document.removeEventListener("touchmove", this[m]), this.currentContainer && this.currentContainer.removeEventListener("contextmenu", x), clearTimeout(this.tapTimeout), !this.dragging)
              return;
            const S = C.touches[0] || C.changedTouches[0], T = document.elementFromPoint(S.pageX - window.scrollX, S.pageY - window.scrollY);
            C.preventDefault();
            const A = new u.DragStopSensorEvent({
              clientX: S.pageX,
              clientY: S.pageY,
              target: T,
              container: this.currentContainer,
              originalEvent: C
            });
            this.trigger(this.currentContainer, A), this.currentContainer = null, this.dragging = !1;
          }
        }
        n.default = w;
        function x(y) {
          y.preventDefault(), y.stopPropagation();
        }
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(42), a = s(o);
        function s(u) {
          return u && u.__esModule ? u : { default: u };
        }
        n.default = a.default;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.DragPressureSensorEvent = n.DragStopSensorEvent = n.DragMoveSensorEvent = n.DragStartSensorEvent = n.SensorEvent = void 0;
        var o = i(0), a = s(o);
        function s(m) {
          return m && m.__esModule ? m : { default: m };
        }
        class u extends a.default {
          get originalEvent() {
            return this.data.originalEvent;
          }
          get clientX() {
            return this.data.clientX;
          }
          get clientY() {
            return this.data.clientY;
          }
          get target() {
            return this.data.target;
          }
          get container() {
            return this.data.container;
          }
          get pressure() {
            return this.data.pressure;
          }
        }
        n.SensorEvent = u;
        class d extends u {
        }
        n.DragStartSensorEvent = d, d.type = "drag:start";
        class f extends u {
        }
        n.DragMoveSensorEvent = f, f.type = "drag:move";
        class h extends u {
        }
        n.DragStopSensorEvent = h, h.type = "drag:stop";
        class g extends u {
        }
        n.DragPressureSensorEvent = g, g.type = "drag:pressure";
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(2), a = i(4), s = d(a), u = i(3);
        function d(x) {
          return x && x.__esModule ? x : { default: x };
        }
        const f = Symbol("onContextMenuWhileDragging"), h = Symbol("onMouseDown"), g = Symbol("onMouseMove"), m = Symbol("onMouseUp");
        class v extends s.default {
          constructor(y = [], C = {}) {
            super(y, C), this.mouseDown = !1, this.mouseDownTimeout = null, this.openedContextMenu = !1, this[f] = this[f].bind(this), this[h] = this[h].bind(this), this[g] = this[g].bind(this), this[m] = this[m].bind(this);
          }
          attach() {
            document.addEventListener("mousedown", this[h], !0);
          }
          detach() {
            document.removeEventListener("mousedown", this[h], !0);
          }
          [h](y) {
            if (y.button !== 0 || y.ctrlKey || y.metaKey)
              return;
            document.addEventListener("mouseup", this[m]);
            const C = document.elementFromPoint(y.clientX, y.clientY), S = (0, o.closest)(C, this.containers);
            S && (document.addEventListener("dragstart", w), this.mouseDown = !0, clearTimeout(this.mouseDownTimeout), this.mouseDownTimeout = setTimeout(() => {
              if (!this.mouseDown)
                return;
              const T = new u.DragStartSensorEvent({
                clientX: y.clientX,
                clientY: y.clientY,
                target: C,
                container: S,
                originalEvent: y
              });
              this.trigger(S, T), this.currentContainer = S, this.dragging = !T.canceled(), this.dragging && (document.addEventListener("contextmenu", this[f]), document.addEventListener("mousemove", this[g]));
            }, this.options.delay));
          }
          [g](y) {
            if (!this.dragging)
              return;
            const C = document.elementFromPoint(y.clientX, y.clientY), S = new u.DragMoveSensorEvent({
              clientX: y.clientX,
              clientY: y.clientY,
              target: C,
              container: this.currentContainer,
              originalEvent: y
            });
            this.trigger(this.currentContainer, S);
          }
          [m](y) {
            if (this.mouseDown = Boolean(this.openedContextMenu), this.openedContextMenu) {
              this.openedContextMenu = !1;
              return;
            }
            if (document.removeEventListener("mouseup", this[m]), document.removeEventListener("dragstart", w), !this.dragging)
              return;
            const C = document.elementFromPoint(y.clientX, y.clientY), S = new u.DragStopSensorEvent({
              clientX: y.clientX,
              clientY: y.clientY,
              target: C,
              container: this.currentContainer,
              originalEvent: y
            });
            this.trigger(this.currentContainer, S), document.removeEventListener("contextmenu", this[f]), document.removeEventListener("mousemove", this[g]), this.currentContainer = null, this.dragging = !1;
          }
          [f](y) {
            y.preventDefault(), this.openedContextMenu = !0;
          }
        }
        n.default = v;
        function w(x) {
          x.preventDefault();
        }
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(45), a = s(o);
        function s(u) {
          return u && u.__esModule ? u : { default: u };
        }
        n.default = a.default;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = Object.assign || function(s) {
          for (var u = 1; u < arguments.length; u++) {
            var d = arguments[u];
            for (var f in d)
              Object.prototype.hasOwnProperty.call(d, f) && (s[f] = d[f]);
          }
          return s;
        };
        class a {
          constructor(u = [], d = {}) {
            this.containers = [...u], this.options = o({}, d), this.dragging = !1, this.currentContainer = null;
          }
          attach() {
            return this;
          }
          detach() {
            return this;
          }
          addContainer(...u) {
            this.containers = [...this.containers, ...u];
          }
          removeContainer(...u) {
            this.containers = this.containers.filter((d) => !u.includes(d));
          }
          trigger(u, d) {
            const f = document.createEvent("Event");
            return f.detail = d, f.initEvent(d.type, !0, !0), u.dispatchEvent(f), this.lastEvent = d, d;
          }
        }
        n.default = a;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.default = o;
        function o(a) {
          return requestAnimationFrame(() => {
            requestAnimationFrame(a);
          });
        }
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(48), a = s(o);
        function s(u) {
          return u && u.__esModule ? u : { default: u };
        }
        n.default = a.default;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.default = a;
        const o = Element.prototype.matches || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector;
        function a(s, u) {
          if (!s)
            return null;
          const d = u, f = u, h = u, g = u, m = Boolean(typeof u == "string"), v = Boolean(typeof u == "function"), w = Boolean(u instanceof NodeList || u instanceof Array), x = Boolean(u instanceof HTMLElement);
          function y(S) {
            return S && (m ? o.call(S, d) : w ? [...h].includes(S) : x ? g === S : v ? f(S) : null);
          }
          let C = s;
          do {
            if (C = C.correspondingUseElement || C.correspondingElement || C, y(C))
              return C;
            C = C.parentNode;
          } while (C && C !== document.body && C !== document);
          return null;
        }
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(50), a = s(o);
        function s(u) {
          return u && u.__esModule ? u : { default: u };
        }
        n.default = a.default;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.defaultOptions = n.scroll = n.onDragStop = n.onDragMove = n.onDragStart = void 0;
        var o = Object.assign || function(T) {
          for (var A = 1; A < arguments.length; A++) {
            var D = arguments[A];
            for (var E in D)
              Object.prototype.hasOwnProperty.call(D, E) && (T[E] = D[E]);
          }
          return T;
        }, a = i(1), s = d(a), u = i(2);
        function d(T) {
          return T && T.__esModule ? T : { default: T };
        }
        const f = n.onDragStart = Symbol("onDragStart"), h = n.onDragMove = Symbol("onDragMove"), g = n.onDragStop = Symbol("onDragStop"), m = n.scroll = Symbol("scroll"), v = n.defaultOptions = {
          speed: 6,
          sensitivity: 50,
          scrollableElements: []
        };
        class w extends s.default {
          constructor(A) {
            super(A), this.options = o({}, v, this.getOptions()), this.currentMousePosition = null, this.scrollAnimationFrame = null, this.scrollableElement = null, this.findScrollableElementFrame = null, this[f] = this[f].bind(this), this[h] = this[h].bind(this), this[g] = this[g].bind(this), this[m] = this[m].bind(this);
          }
          attach() {
            this.draggable.on("drag:start", this[f]).on("drag:move", this[h]).on("drag:stop", this[g]);
          }
          detach() {
            this.draggable.off("drag:start", this[f]).off("drag:move", this[h]).off("drag:stop", this[g]);
          }
          getOptions() {
            return this.draggable.options.scrollable || {};
          }
          getScrollableElement(A) {
            return this.hasDefinedScrollableElements() ? (0, u.closest)(A, this.options.scrollableElements) || document.documentElement : C(A);
          }
          hasDefinedScrollableElements() {
            return Boolean(this.options.scrollableElements.length !== 0);
          }
          [f](A) {
            this.findScrollableElementFrame = requestAnimationFrame(() => {
              this.scrollableElement = this.getScrollableElement(A.source);
            });
          }
          [h](A) {
            if (this.findScrollableElementFrame = requestAnimationFrame(() => {
              this.scrollableElement = this.getScrollableElement(A.sensorEvent.target);
            }), !this.scrollableElement)
              return;
            const D = A.sensorEvent, E = { x: 0, y: 0 };
            "ontouchstart" in window && (E.y = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0, E.x = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0), this.currentMousePosition = {
              clientX: D.clientX - E.x,
              clientY: D.clientY - E.y
            }, this.scrollAnimationFrame = requestAnimationFrame(this[m]);
          }
          [g]() {
            cancelAnimationFrame(this.scrollAnimationFrame), cancelAnimationFrame(this.findScrollableElementFrame), this.scrollableElement = null, this.scrollAnimationFrame = null, this.findScrollableElementFrame = null, this.currentMousePosition = null;
          }
          [m]() {
            if (!this.scrollableElement || !this.currentMousePosition)
              return;
            cancelAnimationFrame(this.scrollAnimationFrame);
            const { speed: A, sensitivity: D } = this.options, E = this.scrollableElement.getBoundingClientRect(), N = E.bottom > window.innerHeight, $ = E.top < 0 || N, _ = S(), R = this.scrollableElement, U = this.currentMousePosition.clientX, Q = this.currentMousePosition.clientY;
            if (R !== document.body && R !== document.documentElement && !$) {
              const { offsetHeight: Z, offsetWidth: X } = R;
              E.top + Z - Q < D ? R.scrollTop += A : Q - E.top < D && (R.scrollTop -= A), E.left + X - U < D ? R.scrollLeft += A : U - E.left < D && (R.scrollLeft -= A);
            } else {
              const { innerHeight: Z, innerWidth: X } = window;
              Q < D ? _.scrollTop -= A : Z - Q < D && (_.scrollTop += A), U < D ? _.scrollLeft -= A : X - U < D && (_.scrollLeft += A);
            }
            this.scrollAnimationFrame = requestAnimationFrame(this[m]);
          }
        }
        n.default = w;
        function x(T) {
          const A = /(auto|scroll)/, D = getComputedStyle(T, null), E = D.getPropertyValue("overflow") + D.getPropertyValue("overflow-y") + D.getPropertyValue("overflow-x");
          return A.test(E);
        }
        function y(T) {
          return getComputedStyle(T).getPropertyValue("position") === "static";
        }
        function C(T) {
          if (!T)
            return S();
          const A = getComputedStyle(T).getPropertyValue("position"), D = A === "absolute", E = (0, u.closest)(T, (N) => D && y(N) ? !1 : x(N));
          return A === "fixed" || !E ? S() : E;
        }
        function S() {
          return document.scrollingElement || document.documentElement;
        }
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.defaultOptions = void 0;
        var o = i(52), a = s(o);
        function s(u) {
          return u && u.__esModule ? u : { default: u };
        }
        n.default = a.default, n.defaultOptions = o.defaultOptions;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.MirrorDestroyEvent = n.MirrorMoveEvent = n.MirrorAttachedEvent = n.MirrorCreatedEvent = n.MirrorCreateEvent = n.MirrorEvent = void 0;
        var o = i(0), a = s(o);
        function s(v) {
          return v && v.__esModule ? v : { default: v };
        }
        class u extends a.default {
          get source() {
            return this.data.source;
          }
          get originalSource() {
            return this.data.originalSource;
          }
          get sourceContainer() {
            return this.data.sourceContainer;
          }
          get sensorEvent() {
            return this.data.sensorEvent;
          }
          get dragEvent() {
            return this.data.dragEvent;
          }
          get originalEvent() {
            return this.sensorEvent ? this.sensorEvent.originalEvent : null;
          }
        }
        n.MirrorEvent = u;
        class d extends u {
        }
        n.MirrorCreateEvent = d, d.type = "mirror:create";
        class f extends u {
          get mirror() {
            return this.data.mirror;
          }
        }
        n.MirrorCreatedEvent = f, f.type = "mirror:created";
        class h extends u {
          get mirror() {
            return this.data.mirror;
          }
        }
        n.MirrorAttachedEvent = h, h.type = "mirror:attached";
        class g extends u {
          get mirror() {
            return this.data.mirror;
          }
        }
        n.MirrorMoveEvent = g, g.type = "mirror:move", g.cancelable = !0;
        class m extends u {
          get mirror() {
            return this.data.mirror;
          }
        }
        n.MirrorDestroyEvent = m, m.type = "mirror:destroy", m.cancelable = !0;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(54);
        Object.keys(o).forEach(function(a) {
          a === "default" || a === "__esModule" || Object.defineProperty(n, a, {
            enumerable: !0,
            get: function() {
              return o[a];
            }
          });
        });
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.defaultOptions = n.getAppendableContainer = n.onScroll = n.onMirrorMove = n.onMirrorCreated = n.onDragStop = n.onDragMove = n.onDragStart = void 0;
        var o = Object.assign || function(R) {
          for (var U = 1; U < arguments.length; U++) {
            var Q = arguments[U];
            for (var Z in Q)
              Object.prototype.hasOwnProperty.call(Q, Z) && (R[Z] = Q[Z]);
          }
          return R;
        }, a = i(1), s = d(a), u = i(55);
        function d(R) {
          return R && R.__esModule ? R : { default: R };
        }
        function f(R, U) {
          var Q = {};
          for (var Z in R)
            U.indexOf(Z) >= 0 || Object.prototype.hasOwnProperty.call(R, Z) && (Q[Z] = R[Z]);
          return Q;
        }
        const h = n.onDragStart = Symbol("onDragStart"), g = n.onDragMove = Symbol("onDragMove"), m = n.onDragStop = Symbol("onDragStop"), v = n.onMirrorCreated = Symbol("onMirrorCreated"), w = n.onMirrorMove = Symbol("onMirrorMove"), x = n.onScroll = Symbol("onScroll"), y = n.getAppendableContainer = Symbol("getAppendableContainer"), C = n.defaultOptions = {
          constrainDimensions: !1,
          xAxis: !0,
          yAxis: !0,
          cursorOffsetX: null,
          cursorOffsetY: null
        };
        class S extends s.default {
          constructor(U) {
            super(U), this.options = o({}, C, this.getOptions()), this.scrollOffset = { x: 0, y: 0 }, this.initialScrollOffset = {
              x: window.scrollX,
              y: window.scrollY
            }, this[h] = this[h].bind(this), this[g] = this[g].bind(this), this[m] = this[m].bind(this), this[v] = this[v].bind(this), this[w] = this[w].bind(this), this[x] = this[x].bind(this);
          }
          attach() {
            this.draggable.on("drag:start", this[h]).on("drag:move", this[g]).on("drag:stop", this[m]).on("mirror:created", this[v]).on("mirror:move", this[w]);
          }
          detach() {
            this.draggable.off("drag:start", this[h]).off("drag:move", this[g]).off("drag:stop", this[m]).off("mirror:created", this[v]).off("mirror:move", this[w]);
          }
          getOptions() {
            return this.draggable.options.mirror || {};
          }
          [h](U) {
            if (U.canceled())
              return;
            "ontouchstart" in window && document.addEventListener("scroll", this[x], !0), this.initialScrollOffset = {
              x: window.scrollX,
              y: window.scrollY
            };
            const { source: Q, originalSource: Z, sourceContainer: X, sensorEvent: re } = U, ue = new u.MirrorCreateEvent({
              source: Q,
              originalSource: Z,
              sourceContainer: X,
              sensorEvent: re,
              dragEvent: U
            });
            if (this.draggable.trigger(ue), _(re) || ue.canceled())
              return;
            const he = this[y](Q) || X;
            this.mirror = Q.cloneNode(!0);
            const te = new u.MirrorCreatedEvent({
              source: Q,
              originalSource: Z,
              sourceContainer: X,
              sensorEvent: re,
              dragEvent: U,
              mirror: this.mirror
            }), de = new u.MirrorAttachedEvent({
              source: Q,
              originalSource: Z,
              sourceContainer: X,
              sensorEvent: re,
              dragEvent: U,
              mirror: this.mirror
            });
            this.draggable.trigger(te), he.appendChild(this.mirror), this.draggable.trigger(de);
          }
          [g](U) {
            if (!this.mirror || U.canceled())
              return;
            const { source: Q, originalSource: Z, sourceContainer: X, sensorEvent: re } = U, ue = new u.MirrorMoveEvent({
              source: Q,
              originalSource: Z,
              sourceContainer: X,
              sensorEvent: re,
              dragEvent: U,
              mirror: this.mirror
            });
            this.draggable.trigger(ue);
          }
          [m](U) {
            if ("ontouchstart" in window && document.removeEventListener("scroll", this[x], !0), this.initialScrollOffset = { x: 0, y: 0 }, this.scrollOffset = { x: 0, y: 0 }, !this.mirror)
              return;
            const { source: Q, sourceContainer: Z, sensorEvent: X } = U, re = new u.MirrorDestroyEvent({
              source: Q,
              mirror: this.mirror,
              sourceContainer: Z,
              sensorEvent: X,
              dragEvent: U
            });
            this.draggable.trigger(re), re.canceled() || this.mirror.parentNode.removeChild(this.mirror);
          }
          [x]() {
            this.scrollOffset = {
              x: window.scrollX - this.initialScrollOffset.x,
              y: window.scrollY - this.initialScrollOffset.y
            };
          }
          [v]({ mirror: U, source: Q, sensorEvent: Z }) {
            const X = this.draggable.getClassNameFor("mirror"), re = (he) => {
              let { mirrorOffset: te, initialX: de, initialY: De } = he, Oe = f(he, ["mirrorOffset", "initialX", "initialY"]);
              return this.mirrorOffset = te, this.initialX = de, this.initialY = De, o({ mirrorOffset: te, initialX: de, initialY: De }, Oe);
            }, ue = {
              mirror: U,
              source: Q,
              sensorEvent: Z,
              mirrorClass: X,
              scrollOffset: this.scrollOffset,
              options: this.options
            };
            return Promise.resolve(ue).then(T).then(A).then(D).then(E).then(I({ initial: !0 })).then(N).then(re);
          }
          [w](U) {
            if (U.canceled())
              return null;
            const Q = {
              mirror: U.mirror,
              sensorEvent: U.sensorEvent,
              mirrorOffset: this.mirrorOffset,
              options: this.options,
              initialX: this.initialX,
              initialY: this.initialY,
              scrollOffset: this.scrollOffset
            };
            return Promise.resolve(Q).then(I({ raf: !0 }));
          }
          [y](U) {
            const Q = this.options.appendTo;
            return typeof Q == "string" ? document.querySelector(Q) : Q instanceof HTMLElement ? Q : typeof Q == "function" ? Q(U) : U.parentNode;
          }
        }
        n.default = S;
        function T(R) {
          let { source: U } = R, Q = f(R, ["source"]);
          return $((Z) => {
            const X = U.getBoundingClientRect();
            Z(o({ source: U, sourceRect: X }, Q));
          });
        }
        function A(R) {
          let { sensorEvent: U, sourceRect: Q, options: Z } = R, X = f(R, ["sensorEvent", "sourceRect", "options"]);
          return $((re) => {
            const ue = Z.cursorOffsetY === null ? U.clientY - Q.top : Z.cursorOffsetY, he = Z.cursorOffsetX === null ? U.clientX - Q.left : Z.cursorOffsetX;
            re(o({ sensorEvent: U, sourceRect: Q, mirrorOffset: { top: ue, left: he }, options: Z }, X));
          });
        }
        function D(R) {
          let { mirror: U, source: Q, options: Z } = R, X = f(R, ["mirror", "source", "options"]);
          return $((re) => {
            let ue, he;
            if (Z.constrainDimensions) {
              const te = getComputedStyle(Q);
              ue = te.getPropertyValue("height"), he = te.getPropertyValue("width");
            }
            U.style.position = "fixed", U.style.pointerEvents = "none", U.style.top = 0, U.style.left = 0, U.style.margin = 0, Z.constrainDimensions && (U.style.height = ue, U.style.width = he), re(o({ mirror: U, source: Q, options: Z }, X));
          });
        }
        function E(R) {
          let { mirror: U, mirrorClass: Q } = R, Z = f(R, ["mirror", "mirrorClass"]);
          return $((X) => {
            U.classList.add(Q), X(o({ mirror: U, mirrorClass: Q }, Z));
          });
        }
        function N(R) {
          let { mirror: U } = R, Q = f(R, ["mirror"]);
          return $((Z) => {
            U.removeAttribute("id"), delete U.id, Z(o({ mirror: U }, Q));
          });
        }
        function I({ withFrame: R = !1, initial: U = !1 } = {}) {
          return (Q) => {
            let { mirror: Z, sensorEvent: X, mirrorOffset: re, initialY: ue, initialX: he, scrollOffset: te, options: de } = Q, De = f(Q, ["mirror", "sensorEvent", "mirrorOffset", "initialY", "initialX", "scrollOffset", "options"]);
            return $((Oe) => {
              const Qe = o({
                mirror: Z,
                sensorEvent: X,
                mirrorOffset: re,
                options: de
              }, De);
              if (re) {
                const Ae = X.clientX - re.left - te.x, Ne = X.clientY - re.top - te.y;
                de.xAxis && de.yAxis || U ? Z.style.transform = `translate3d(${Ae}px, ${Ne}px, 0)` : de.xAxis && !de.yAxis ? Z.style.transform = `translate3d(${Ae}px, ${ue}px, 0)` : de.yAxis && !de.xAxis && (Z.style.transform = `translate3d(${he}px, ${Ne}px, 0)`), U && (Qe.initialX = Ae, Qe.initialY = Ne);
              }
              Oe(Qe);
            }, { frame: R });
          };
        }
        function $(R, { raf: U = !1 } = {}) {
          return new Promise((Q, Z) => {
            U ? requestAnimationFrame(() => {
              R(Q, Z);
            }) : R(Q, Z);
          });
        }
        function _(R) {
          return /^drag/.test(R.originalEvent.type);
        }
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.defaultOptions = void 0;
        var o = i(56), a = s(o);
        function s(u) {
          return u && u.__esModule ? u : { default: u };
        }
        n.default = a.default, n.defaultOptions = o.defaultOptions;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = Object.assign || function(x) {
          for (var y = 1; y < arguments.length; y++) {
            var C = arguments[y];
            for (var S in C)
              Object.prototype.hasOwnProperty.call(C, S) && (x[S] = C[S]);
          }
          return x;
        }, a = i(1), s = u(a);
        function u(x) {
          return x && x.__esModule ? x : { default: x };
        }
        const d = Symbol("onInitialize"), f = Symbol("onDestroy"), h = {};
        class g extends s.default {
          constructor(y) {
            super(y), this.options = o({}, h, this.getOptions()), this[d] = this[d].bind(this), this[f] = this[f].bind(this);
          }
          attach() {
            this.draggable.on("draggable:initialize", this[d]).on("draggable:destroy", this[f]);
          }
          detach() {
            this.draggable.off("draggable:initialize", this[d]).off("draggable:destroy", this[f]);
          }
          getOptions() {
            return this.draggable.options.focusable || {};
          }
          getElements() {
            return [...this.draggable.containers, ...this.draggable.getDraggableElements()];
          }
          [d]() {
            requestAnimationFrame(() => {
              this.getElements().forEach((y) => v(y));
            });
          }
          [f]() {
            requestAnimationFrame(() => {
              this.getElements().forEach((y) => w(y));
            });
          }
        }
        n.default = g;
        const m = [];
        function v(x) {
          Boolean(!x.getAttribute("tabindex") && x.tabIndex === -1) && (m.push(x), x.tabIndex = 0);
        }
        function w(x) {
          const y = m.indexOf(x);
          y !== -1 && (x.tabIndex = -1, m.splice(y, 1));
        }
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = i(58), a = s(o);
        function s(u) {
          return u && u.__esModule ? u : { default: u };
        }
        n.default = a.default;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        class o {
          constructor(s) {
            this.draggable = s;
          }
          attach() {
            throw new Error("Not Implemented");
          }
          detach() {
            throw new Error("Not Implemented");
          }
        }
        n.default = o;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.defaultOptions = void 0;
        var o = Object.assign || function(D) {
          for (var E = 1; E < arguments.length; E++) {
            var N = arguments[E];
            for (var I in N)
              Object.prototype.hasOwnProperty.call(N, I) && (D[I] = N[I]);
          }
          return D;
        }, a = i(1), s = u(a);
        function u(D) {
          return D && D.__esModule ? D : { default: D };
        }
        const d = Symbol("onInitialize"), f = Symbol("onDestroy"), h = Symbol("announceEvent"), g = Symbol("announceMessage"), m = "aria-relevant", v = "aria-atomic", w = "aria-live", x = "role", y = n.defaultOptions = {
          expire: 7e3
        };
        class C extends s.default {
          constructor(E) {
            super(E), this.options = o({}, y, this.getOptions()), this.originalTriggerMethod = this.draggable.trigger, this[d] = this[d].bind(this), this[f] = this[f].bind(this);
          }
          attach() {
            this.draggable.on("draggable:initialize", this[d]);
          }
          detach() {
            this.draggable.off("draggable:destroy", this[f]);
          }
          getOptions() {
            return this.draggable.options.announcements || {};
          }
          [h](E) {
            const N = this.options[E.type];
            N && typeof N == "string" && this[g](N), N && typeof N == "function" && this[g](N(E));
          }
          [g](E) {
            T(E, { expire: this.options.expire });
          }
          [d]() {
            this.draggable.trigger = (E) => {
              try {
                this[h](E);
              } finally {
                this.originalTriggerMethod.call(this.draggable, E);
              }
            };
          }
          [f]() {
            this.draggable.trigger = this.originalTriggerMethod;
          }
        }
        n.default = C;
        const S = A();
        function T(D, { expire: E }) {
          const N = document.createElement("div");
          return N.textContent = D, S.appendChild(N), setTimeout(() => {
            S.removeChild(N);
          }, E);
        }
        function A() {
          const D = document.createElement("div");
          return D.setAttribute("id", "draggable-live-region"), D.setAttribute(m, "additions"), D.setAttribute(v, "true"), D.setAttribute(w, "assertive"), D.setAttribute(x, "log"), D.style.position = "fixed", D.style.width = "1px", D.style.height = "1px", D.style.top = "-1px", D.style.overflow = "hidden", D;
        }
        document.addEventListener("DOMContentLoaded", () => {
          document.body.appendChild(S);
        });
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.defaultOptions = void 0;
        var o = i(61), a = s(o);
        function s(u) {
          return u && u.__esModule ? u : { default: u };
        }
        n.default = a.default, n.defaultOptions = o.defaultOptions;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.DraggableDestroyEvent = n.DraggableInitializedEvent = n.DraggableEvent = void 0;
        var o = i(0), a = s(o);
        function s(h) {
          return h && h.__esModule ? h : { default: h };
        }
        class u extends a.default {
          get draggable() {
            return this.data.draggable;
          }
        }
        n.DraggableEvent = u, u.type = "draggable";
        class d extends u {
        }
        n.DraggableInitializedEvent = d, d.type = "draggable:initialize";
        class f extends u {
        }
        n.DraggableDestroyEvent = f, f.type = "draggable:destroy";
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        });
        var o = Object.assign || function(u) {
          for (var d = 1; d < arguments.length; d++) {
            var f = arguments[d];
            for (var h in f)
              Object.prototype.hasOwnProperty.call(f, h) && (u[h] = f[h]);
          }
          return u;
        };
        const a = Symbol("canceled");
        class s {
          constructor(d) {
            this[a] = !1, this.data = d;
          }
          get type() {
            return this.constructor.type;
          }
          get cancelable() {
            return this.constructor.cancelable;
          }
          cancel() {
            this[a] = !0;
          }
          canceled() {
            return Boolean(this[a]);
          }
          clone(d) {
            return new this.constructor(o({}, this.data, d));
          }
        }
        n.default = s, s.type = "event", s.cancelable = !1;
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.DragStopEvent = n.DragPressureEvent = n.DragOutContainerEvent = n.DragOverContainerEvent = n.DragOutEvent = n.DragOverEvent = n.DragMoveEvent = n.DragStartEvent = n.DragEvent = void 0;
        var o = i(0), a = s(o);
        function s(y) {
          return y && y.__esModule ? y : { default: y };
        }
        class u extends a.default {
          get source() {
            return this.data.source;
          }
          get originalSource() {
            return this.data.originalSource;
          }
          get mirror() {
            return this.data.mirror;
          }
          get sourceContainer() {
            return this.data.sourceContainer;
          }
          get sensorEvent() {
            return this.data.sensorEvent;
          }
          get originalEvent() {
            return this.sensorEvent ? this.sensorEvent.originalEvent : null;
          }
        }
        n.DragEvent = u, u.type = "drag";
        class d extends u {
        }
        n.DragStartEvent = d, d.type = "drag:start", d.cancelable = !0;
        class f extends u {
        }
        n.DragMoveEvent = f, f.type = "drag:move";
        class h extends u {
          get overContainer() {
            return this.data.overContainer;
          }
          get over() {
            return this.data.over;
          }
        }
        n.DragOverEvent = h, h.type = "drag:over", h.cancelable = !0;
        class g extends u {
          get overContainer() {
            return this.data.overContainer;
          }
          get over() {
            return this.data.over;
          }
        }
        n.DragOutEvent = g, g.type = "drag:out";
        class m extends u {
          get overContainer() {
            return this.data.overContainer;
          }
        }
        n.DragOverContainerEvent = m, m.type = "drag:over:container";
        class v extends u {
          get overContainer() {
            return this.data.overContainer;
          }
        }
        n.DragOutContainerEvent = v, v.type = "drag:out:container";
        class w extends u {
          get pressure() {
            return this.data.pressure;
          }
        }
        n.DragPressureEvent = w, w.type = "drag:pressure";
        class x extends u {
        }
        n.DragStopEvent = x, x.type = "drag:stop";
      },
      function(r, n, i) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.Plugins = n.Sensors = n.Sortable = n.Swappable = n.Droppable = n.Draggable = n.BasePlugin = n.BaseEvent = void 0;
        var o = i(5);
        Object.defineProperty(n, "Draggable", {
          enumerable: !0,
          get: function() {
            return C(o).default;
          }
        });
        var a = i(34);
        Object.defineProperty(n, "Droppable", {
          enumerable: !0,
          get: function() {
            return C(a).default;
          }
        });
        var s = i(31);
        Object.defineProperty(n, "Swappable", {
          enumerable: !0,
          get: function() {
            return C(s).default;
          }
        });
        var u = i(28);
        Object.defineProperty(n, "Sortable", {
          enumerable: !0,
          get: function() {
            return C(u).default;
          }
        });
        var d = i(0), f = C(d), h = i(1), g = C(h), m = i(6), v = y(m), w = i(25), x = y(w);
        function y(S) {
          if (S && S.__esModule)
            return S;
          var T = {};
          if (S != null)
            for (var A in S)
              Object.prototype.hasOwnProperty.call(S, A) && (T[A] = S[A]);
          return T.default = S, T;
        }
        function C(S) {
          return S && S.__esModule ? S : { default: S };
        }
        n.BaseEvent = f.default, n.BasePlugin = g.default, n.Sensors = v, n.Plugins = x;
      }
    ]);
  });
})(ZW);
function GMe(e) {
  const t = document.querySelectorAll(".n-data-table-tbody");
  if (t.length === 0)
    return !1;
  const r = {
    draggable: ".n-data-table-tr",
    mirror: {
      appendTo: t,
      constrainDimensions: !0
    },
    delay: 300,
    classes: {
      mirror: "draggable-mirror"
    }
  };
  return e && (r.handle = `.${e}`), new ZW.exports.Sortable(t, r);
}
const ZMe = { class: "ghl-table-custom-header" }, KMe = { class: "filter-bar--left" }, XMe = { class: "filter-bar--right" }, JMe = {
  key: 1,
  class: "hl-breadcrumb"
}, eCe = { class: "ghl-table-container" }, tCe = {
  key: 0,
  class: "ghl-table-footer"
}, rCe = { class: "ghl-table-footer-left" }, nCe = { class: "ghl-table-footer-right" }, iCe = {
  key: 1,
  class: "pagination"
}, oCe = {
  name: "UITable",
  inheritAttrs: !1
}, f2 = oe(Qt(vt({}, oCe), {
  props: {
    id: {
      type: String,
      required: !0
    },
    columns: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    page: {
      type: Number
    },
    pageCount: {
      type: Number
    },
    tabs: {
      type: Array,
      default: () => []
    },
    enableTextSearch: {
      type: Boolean,
      default: !0
    },
    enableFilter: {
      type: Boolean,
      default: !0
    },
    filterCollapseItems: {
      type: Array,
      default: () => []
    },
    filterOptions: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: !1
    },
    defaultTab: {
      type: String,
      default: ""
    },
    rowKey: Function,
    checkedRowKeys: Array,
    searchInputPlaceholder: {
      type: String,
      default: void 0
    },
    defaultExpandAll: {
      type: Boolean,
      default: !1
    },
    searchText: {
      type: String,
      default: ""
    },
    transparent: {
      type: Boolean,
      default: !1
    },
    showSizePicker: {
      type: Boolean,
      default: !1
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 40]
    },
    pageSize: {
      type: Number,
      default: void 0
    },
    pageSlot: {
      type: Number,
      default: 9
    },
    dragSort: {
      type: Boolean,
      default: !1
    },
    dragIconClass: {
      type: String,
      required: !1
    },
    scrollX: {
      type: [Number, void 0],
      required: !1,
      default: void 0
    },
    scrollbarProps: {
      type: Object,
      required: !1,
      default: void 0
    },
    virtualScroll: {
      type: Boolean,
      required: !1,
      default: !1
    },
    flexHeight: {
      type: Boolean,
      required: !1,
      default: !1
    },
    maxHeight: {
      type: Number,
      default: void 0
    },
    minHeight: {
      type: Number,
      default: void 0
    },
    tableLayout: {
      type: String,
      default: "auto"
    },
    rowClassName: {
      type: String,
      default: void 0
    },
    rowProps: {
      type: Function,
      default: void 0
    }
  },
  emits: [
    "update:page",
    "update:page-size",
    "update:searchText",
    "update:filter",
    "update:checkedRowKeys",
    "update:sorter",
    "update:defaultTab",
    "update:dragSort"
  ],
  setup(e, { emit: t }) {
    const r = e;
    function n(h) {
      t("update:defaultTab", h.key);
    }
    function i(h) {
      t("update:searchText", h);
    }
    const o = pn(), a = G(!1), s = G([]), u = (h) => {
      if (r.dragSort) {
        const {
          data: { oldIndex: g, newIndex: m }
        } = h, v = YMe({
          array: s.value.length ? s.value : r.data,
          oldIndex: g,
          newIndex: m
        });
        t("update:dragSort", {
          updatedList: v,
          sorted: s.value.length ? s.value[g] : r.data[g],
          oldIndex: g,
          newIndex: m
        }), s.value = v;
      }
    }, d = () => {
      if ((r == null ? void 0 : r.dragSort) === !0 && (r != null && r.data) && !a.value) {
        const h = GMe(r == null ? void 0 : r.dragIconClass);
        h ? (h.on("sortable:stop", u), a.value = !0) : console.warn(`ghl-ui:: Dragging is not initialized for table - ${r.id}`);
      }
    };
    br(() => {
      d();
    }), fi(() => d());
    const f = j(() => (r == null ? void 0 : r.tabs.length) || (r == null ? void 0 : r.enableTextSearch) || o["filter-right"] || o["filter-left"] || o["filter-left-start"] || o["filter-left-end"] || o["filter-right-start"] || o["filter-right-end"] || (r == null ? void 0 : r.filterCollapseItems.length));
    return (h, g) => {
      var m, v;
      return ie(), Ve("div", {
        class: Jr(["table-container", { "ghl-transparent-heading": e.transparent }])
      }, [
        Ye("div", ZMe, [
          B(f) ? (ie(), Ve("div", {
            key: 0,
            class: Jr(B(o).breadcrumb ? "filter-bar-breadcrumb" : "filter-bar")
          }, [
            Ye("div", KMe, [
              nt(h.$slots, "filter-left"),
              (m = B(o)) != null && m["filter-left"] ? yt("", !0) : nt(h.$slots, "filter-left-start", { key: 0 }),
              e.tabs.length ? (ie(), Pe(B(r1), { key: 1 }, {
                default: we(() => [
                  (ie(!0), Ve(Lr, null, Fl(e.tabs, (w) => (ie(), Pe(B(on), {
                    size: "large",
                    key: w.key,
                    onClick: (x) => n(w),
                    id: `hl-table-${e.id}-filter-tab-${w.key}`,
                    active: e.defaultTab === w.key
                  }, {
                    default: we(() => [
                      zr(ar(w == null ? void 0 : w.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick", "id", "active"]))), 128))
                ]),
                _: 1
              })) : yt("", !0),
              nt(h.$slots, "filter-left-end")
            ]),
            Ye("div", XMe, [
              nt(h.$slots, "filter-right"),
              (v = B(o)) != null && v["filter-right"] ? yt("", !0) : nt(h.$slots, "filter-right-start", { key: 0 }),
              e.enableTextSearch ? (ie(), Pe(B(xs), {
                key: 1,
                class: "filter-search",
                modelValue: e.searchText,
                "onUpdate:modelValue": i,
                clearable: "",
                size: "large",
                placeholder: e.searchInputPlaceholder,
                id: `hl-table-${e.id}-filter-text-search`
              }, {
                prefix: we(() => [
                  Re(B(GW), { class: "w-4 h-4" })
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder", "id"])) : yt("", !0),
              e.filterCollapseItems.length ? (ie(), Pe(B(f$), {
                key: 2,
                options: e.filterOptions,
                collapseItems: e.filterCollapseItems,
                id: e.id,
                "onUpdate:filter": g[0] || (g[0] = (w) => t("update:filter", w))
              }, null, 8, ["options", "collapseItems", "id"])) : yt("", !0),
              nt(h.$slots, "filter-right-end")
            ])
          ], 2)) : yt("", !0),
          B(o).breadcrumb ? (ie(), Ve("div", JMe, [
            nt(h.$slots, "breadcrumb")
          ])) : yt("", !0)
        ]),
        Ye("div", eCe, [
          Re(B(uW), {
            "default-expand-all": e.defaultExpandAll,
            "onUpdate:sorter": g[1] || (g[1] = (w) => h.$emit("update:sorter", w)),
            "checked-row-keys": e.checkedRowKeys,
            "onUpdate:checkedRowKeys": g[2] || (g[2] = (w) => h.$emit("update:checkedRowKeys", w)),
            "row-key": e.rowKey,
            columns: r.columns,
            data: e.data,
            pagination: !1,
            bordered: !1,
            loading: e.loading,
            "scroll-x": e.scrollX,
            "scrollbar-props": e.scrollbarProps,
            "virtual-scroll": e.virtualScroll,
            "flex-height": e.flexHeight,
            "max-height": e.maxHeight,
            "min-height": e.minHeight,
            "table-layout": e.tableLayout,
            "row-class-name": e.rowClassName,
            "row-props": e.rowProps
          }, {
            empty: we(() => [
              nt(h.$slots, "empty")
            ]),
            _: 3
          }, 8, ["default-expand-all", "checked-row-keys", "row-key", "columns", "data", "loading", "scroll-x", "scrollbar-props", "virtual-scroll", "flex-height", "max-height", "min-height", "table-layout", "row-class-name", "row-props"]),
          Ye("div", null, [
            e.data.length ? (ie(), Ve("div", tCe, [
              Ye("div", rCe, [
                B(o)["footer-left"] ? nt(h.$slots, "footer-left", { key: 0 }) : yt("", !0)
              ]),
              Ye("div", nCe, [
                B(o).pagination ? nt(h.$slots, "pagination", { key: 0 }) : (ie(), Ve("div", iCe, [
                  Re(B(n1), {
                    "show-size-picker": e.showSizePicker,
                    "page-sizes": e.pageSizes,
                    "page-size": e.pageSize,
                    "page-count": e.pageCount,
                    "onUpdate:page": g[3] || (g[3] = (w) => h.$emit("update:page", w)),
                    "onUpdate:pageSize": g[4] || (g[4] = (w) => h.$emit("update:page-size", w)),
                    page: e.page,
                    id: e.id,
                    "page-slot": e.pageSlot
                  }, null, 8, ["show-size-picker", "page-sizes", "page-size", "page-count", "page", "id", "page-slot"])
                ]))
              ])
            ])) : yt("", !0)
          ])
        ])
      ], 2);
    };
  }
})), aCe = {
  name: "UIDropdown",
  inheritAttrs: !1
}, gc = /* @__PURE__ */ oe(Qt(vt({}, aCe), {
  props: {
    trigger: {
      type: String,
      default: "click"
    },
    options: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      required: !0
    }
  },
  emits: ["select"],
  setup(e) {
    return (t, r) => (ie(), Pe(B(YM), {
      id: e.id,
      trigger: e.trigger,
      options: e.options,
      onSelect: r[0] || (r[0] = (n) => t.$emit("select", n))
    }, {
      default: we(() => [
        nt(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "trigger", "options"]));
  }
}));
gc.install = (e) => {
  e.component(gc.name, gc);
};
oe({
  name: "UIActionDropdown"
});
const QR = /* @__PURE__ */ oe({
  __name: "ActionDropdown",
  props: Qt(vt({}, gc.props), {
    id: {
      type: String,
      required: !0
    }
  }),
  emits: ["select"],
  setup(e, { emit: t }) {
    function r(n) {
      t("select", n);
    }
    return (n, i) => (ie(), Pe(B(gc), {
      options: n.options,
      onSelect: r,
      id: `${e.id}-action-dropdown`,
      "`": ""
    }, {
      default: we(() => [
        Re(B(on), {
          quaternary: "",
          circle: "",
          iconOnly: "",
          id: `${e.id}-action-dropdown-trigger`
        }, {
          default: we(() => [
            Re(B(QW), { class: "w-5 h-5" })
          ]),
          _: 1
        }, 8, ["id"])
      ]),
      _: 1
    }, 8, ["options", "id"]));
  }
}), lCe = { class: "flex space-x-1" };
oe({
  name: "UIActionButtons"
});
const qR = /* @__PURE__ */ oe({
  __name: "ActionButtons",
  props: {
    options: Array,
    id: {
      type: String,
      required: !0
    },
    placement: String
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const r = (n, i) => {
      i.preventDefault(), t("click", n);
    };
    return (n, i) => (ie(), Ve("div", lCe, [
      (ie(!0), Ve(Lr, null, Fl(e.options, (o) => (ie(), Pe(B(on), {
        id: `${e.id}-action-btn-${o.key}`,
        disabled: o == null ? void 0 : o.disabled,
        key: o.key,
        tooltip: "test",
        onClick: (a) => r(o, a),
        circle: "",
        quaternary: ""
      }, {
        default: we(() => [
          Re(B(ys), {
            placement: e.placement,
            disabled: !o.label
          }, {
            trigger: we(() => [
              (ie(), Pe(mi(o == null ? void 0 : o.icon)))
            ]),
            default: we(() => [
              zr(" " + ar(o.label), 1)
            ]),
            _: 2
          }, 1032, ["placement", "disabled"])
        ]),
        _: 2
      }, 1032, ["id", "disabled", "onClick"]))), 128))
    ]));
  }
});
var Tc = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
(function(e, t) {
  (function() {
    var r, n = "4.17.21", i = 200, o = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a = "Expected a function", s = "Invalid `variable` option passed into `_.template`", u = "__lodash_hash_undefined__", d = 500, f = "__lodash_placeholder__", h = 1, g = 2, m = 4, v = 1, w = 2, x = 1, y = 2, C = 4, S = 8, T = 16, A = 32, D = 64, E = 128, N = 256, I = 512, $ = 30, _ = "...", R = 800, U = 16, Q = 1, Z = 2, X = 3, re = 1 / 0, ue = 9007199254740991, he = 17976931348623157e292, te = 0 / 0, de = 4294967295, De = de - 1, Oe = de >>> 1, Qe = [
      ["ary", E],
      ["bind", x],
      ["bindKey", y],
      ["curry", S],
      ["curryRight", T],
      ["flip", I],
      ["partial", A],
      ["partialRight", D],
      ["rearg", N]
    ], Ae = "[object Arguments]", Ne = "[object Array]", $e = "[object AsyncFunction]", et = "[object Boolean]", Ge = "[object Date]", Ee = "[object DOMException]", qe = "[object Error]", Ue = "[object Function]", ot = "[object GeneratorFunction]", Ie = "[object Map]", rt = "[object Number]", W = "[object Null]", P = "[object Object]", H = "[object Promise]", se = "[object Proxy]", pe = "[object RegExp]", ae = "[object Set]", Me = "[object String]", fe = "[object Symbol]", ke = "[object Undefined]", Le = "[object WeakMap]", dt = "[object WeakSet]", Mt = "[object ArrayBuffer]", Ct = "[object DataView]", er = "[object Float32Array]", Vt = "[object Float64Array]", jt = "[object Int8Array]", at = "[object Int16Array]", St = "[object Int32Array]", ve = "[object Uint8Array]", We = "[object Uint8ClampedArray]", ne = "[object Uint16Array]", Se = "[object Uint32Array]", _e = /\b__p \+= '';/g, ut = /\b(__p \+=) '' \+/g, ht = /(__e\(.*?\)|\b__t\)) \+\n'';/g, ye = /&(?:amp|lt|gt|quot|#39);/g, Ze = /[&<>"']/g, st = RegExp(ye.source), Nt = RegExp(Ze.source), Te = /<%-([\s\S]+?)%>/g, Ke = /<%([\s\S]+?)%>/g, xe = /<%=([\s\S]+?)%>/g, Xe = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, At = /^\w*$/, Ht = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, zt = /[\\^$.*+?()[\]{}|]/g, ge = RegExp(zt.source), Fe = /^\s+/, Tt = /\s/, lr = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, gr = /\{\n\/\* \[wrapped with (.+)\] \*/, Or = /,? & /, ri = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, xi = /[()=,{}\[\]\/\s]/, wi = /\\(\\)?/g, Pi = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Mi = /\w*$/, ze = /^[-+]0x[0-9a-f]+$/i, wt = /^0b[01]+$/i, Ut = /^\[object .+?Constructor\]$/, Wr = /^0o[0-7]+$/i, ct = /^(?:0|[1-9]\d*)$/, en = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Ci = /($^)/, na = /['\n\r\u2028\u2029\\]/g, kr = "\\ud800-\\udfff", Xi = "\\u0300-\\u036f", hi = "\\ufe20-\\ufe2f", gl = "\\u20d0-\\u20ff", so = Xi + hi + gl, ia = "\\u2700-\\u27bf", Os = "a-z\\xdf-\\xf6\\xf8-\\xff", Qc = "\\xac\\xb1\\xd7\\xf7", qc = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Gc = "\\u2000-\\u206f", Zc = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", _s = "A-Z\\xc0-\\xd6\\xd8-\\xde", Ls = "\\ufe0e\\ufe0f", Ps = Qc + qc + Gc + Zc, Rs = "['’]", lg = "[" + kr + "]", Kc = "[" + Ps + "]", ml = "[" + so + "]", Xc = "\\d+", sg = "[" + ia + "]", Jc = "[" + Os + "]", ed = "[^" + kr + Ps + Xc + ia + Os + _s + "]", js = "\\ud83c[\\udffb-\\udfff]", ug = "(?:" + ml + "|" + js + ")", td = "[^" + kr + "]", Fs = "(?:\\ud83c[\\udde6-\\uddff]){2}", Bs = "[\\ud800-\\udbff][\\udc00-\\udfff]", Po = "[" + _s + "]", rd = "\\u200d", nd = "(?:" + Jc + "|" + ed + ")", cg = "(?:" + Po + "|" + ed + ")", dg = "(?:" + Rs + "(?:d|ll|m|re|s|t|ve))?", fg = "(?:" + Rs + "(?:D|LL|M|RE|S|T|VE))?", hg = ug + "?", pg = "[" + Ls + "]?", MC = "(?:" + rd + "(?:" + [td, Fs, Bs].join("|") + ")" + pg + hg + ")*", CC = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", SC = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", gg = pg + hg + MC, TC = "(?:" + [sg, Fs, Bs].join("|") + ")" + gg, kC = "(?:" + [td + ml + "?", ml, Fs, Bs, lg].join("|") + ")", DC = RegExp(Rs, "g"), AC = RegExp(ml, "g"), id = RegExp(js + "(?=" + js + ")|" + kC + gg, "g"), EC = RegExp([
      Po + "?" + Jc + "+" + dg + "(?=" + [Kc, Po, "$"].join("|") + ")",
      cg + "+" + fg + "(?=" + [Kc, Po + nd, "$"].join("|") + ")",
      Po + "?" + nd + "+" + dg,
      Po + "+" + fg,
      SC,
      CC,
      Xc,
      TC
    ].join("|"), "g"), IC = RegExp("[" + rd + kr + so + Ls + "]"), NC = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, zC = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], $C = -1, dr = {};
    dr[er] = dr[Vt] = dr[jt] = dr[at] = dr[St] = dr[ve] = dr[We] = dr[ne] = dr[Se] = !0, dr[Ae] = dr[Ne] = dr[Mt] = dr[et] = dr[Ct] = dr[Ge] = dr[qe] = dr[Ue] = dr[Ie] = dr[rt] = dr[P] = dr[pe] = dr[ae] = dr[Me] = dr[Le] = !1;
    var sr = {};
    sr[Ae] = sr[Ne] = sr[Mt] = sr[Ct] = sr[et] = sr[Ge] = sr[er] = sr[Vt] = sr[jt] = sr[at] = sr[St] = sr[Ie] = sr[rt] = sr[P] = sr[pe] = sr[ae] = sr[Me] = sr[fe] = sr[ve] = sr[We] = sr[ne] = sr[Se] = !0, sr[qe] = sr[Ue] = sr[Le] = !1;
    var OC = {
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, _C = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, LC = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, PC = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, RC = parseFloat, jC = parseInt, mg = typeof Dv == "object" && Dv && Dv.Object === Object && Dv, FC = typeof self == "object" && self && self.Object === Object && self, Vr = mg || FC || Function("return this")(), od = t && !t.nodeType && t, Ro = od && !0 && e && !e.nodeType && e, vg = Ro && Ro.exports === od, ad = vg && mg.process, Bn = function() {
      try {
        var J = Ro && Ro.require && Ro.require("util").types;
        return J || ad && ad.binding && ad.binding("util");
      } catch {
      }
    }(), bg = Bn && Bn.isArrayBuffer, yg = Bn && Bn.isDate, xg = Bn && Bn.isMap, wg = Bn && Bn.isRegExp, Mg = Bn && Bn.isSet, Cg = Bn && Bn.isTypedArray;
    function An(J, ce, le) {
      switch (le.length) {
        case 0:
          return J.call(ce);
        case 1:
          return J.call(ce, le[0]);
        case 2:
          return J.call(ce, le[0], le[1]);
        case 3:
          return J.call(ce, le[0], le[1], le[2]);
      }
      return J.apply(ce, le);
    }
    function BC(J, ce, le, Je) {
      for (var kt = -1, qt = J == null ? 0 : J.length; ++kt < qt; ) {
        var Pr = J[kt];
        ce(Je, Pr, le(Pr), J);
      }
      return Je;
    }
    function Un(J, ce) {
      for (var le = -1, Je = J == null ? 0 : J.length; ++le < Je && ce(J[le], le, J) !== !1; )
        ;
      return J;
    }
    function UC(J, ce) {
      for (var le = J == null ? 0 : J.length; le-- && ce(J[le], le, J) !== !1; )
        ;
      return J;
    }
    function Sg(J, ce) {
      for (var le = -1, Je = J == null ? 0 : J.length; ++le < Je; )
        if (!ce(J[le], le, J))
          return !1;
      return !0;
    }
    function uo(J, ce) {
      for (var le = -1, Je = J == null ? 0 : J.length, kt = 0, qt = []; ++le < Je; ) {
        var Pr = J[le];
        ce(Pr, le, J) && (qt[kt++] = Pr);
      }
      return qt;
    }
    function Us(J, ce) {
      var le = J == null ? 0 : J.length;
      return !!le && ba(J, ce, 0) > -1;
    }
    function ld(J, ce, le) {
      for (var Je = -1, kt = J == null ? 0 : J.length; ++Je < kt; )
        if (le(ce, J[Je]))
          return !0;
      return !1;
    }
    function mr(J, ce) {
      for (var le = -1, Je = J == null ? 0 : J.length, kt = Array(Je); ++le < Je; )
        kt[le] = ce(J[le], le, J);
      return kt;
    }
    function co(J, ce) {
      for (var le = -1, Je = ce.length, kt = J.length; ++le < Je; )
        J[kt + le] = ce[le];
      return J;
    }
    function sd(J, ce, le, Je) {
      var kt = -1, qt = J == null ? 0 : J.length;
      for (Je && qt && (le = J[++kt]); ++kt < qt; )
        le = ce(le, J[kt], kt, J);
      return le;
    }
    function HC(J, ce, le, Je) {
      var kt = J == null ? 0 : J.length;
      for (Je && kt && (le = J[--kt]); kt--; )
        le = ce(le, J[kt], kt, J);
      return le;
    }
    function ud(J, ce) {
      for (var le = -1, Je = J == null ? 0 : J.length; ++le < Je; )
        if (ce(J[le], le, J))
          return !0;
      return !1;
    }
    var WC = cd("length");
    function VC(J) {
      return J.split("");
    }
    function YC(J) {
      return J.match(ri) || [];
    }
    function Tg(J, ce, le) {
      var Je;
      return le(J, function(kt, qt, Pr) {
        if (ce(kt, qt, Pr))
          return Je = qt, !1;
      }), Je;
    }
    function Hs(J, ce, le, Je) {
      for (var kt = J.length, qt = le + (Je ? 1 : -1); Je ? qt-- : ++qt < kt; )
        if (ce(J[qt], qt, J))
          return qt;
      return -1;
    }
    function ba(J, ce, le) {
      return ce === ce ? iS(J, ce, le) : Hs(J, kg, le);
    }
    function QC(J, ce, le, Je) {
      for (var kt = le - 1, qt = J.length; ++kt < qt; )
        if (Je(J[kt], ce))
          return kt;
      return -1;
    }
    function kg(J) {
      return J !== J;
    }
    function Dg(J, ce) {
      var le = J == null ? 0 : J.length;
      return le ? fd(J, ce) / le : te;
    }
    function cd(J) {
      return function(ce) {
        return ce == null ? r : ce[J];
      };
    }
    function dd(J) {
      return function(ce) {
        return J == null ? r : J[ce];
      };
    }
    function Ag(J, ce, le, Je, kt) {
      return kt(J, function(qt, Pr, or) {
        le = Je ? (Je = !1, qt) : ce(le, qt, Pr, or);
      }), le;
    }
    function qC(J, ce) {
      var le = J.length;
      for (J.sort(ce); le--; )
        J[le] = J[le].value;
      return J;
    }
    function fd(J, ce) {
      for (var le, Je = -1, kt = J.length; ++Je < kt; ) {
        var qt = ce(J[Je]);
        qt !== r && (le = le === r ? qt : le + qt);
      }
      return le;
    }
    function hd(J, ce) {
      for (var le = -1, Je = Array(J); ++le < J; )
        Je[le] = ce(le);
      return Je;
    }
    function GC(J, ce) {
      return mr(ce, function(le) {
        return [le, J[le]];
      });
    }
    function Eg(J) {
      return J && J.slice(0, $g(J) + 1).replace(Fe, "");
    }
    function En(J) {
      return function(ce) {
        return J(ce);
      };
    }
    function pd(J, ce) {
      return mr(ce, function(le) {
        return J[le];
      });
    }
    function vl(J, ce) {
      return J.has(ce);
    }
    function Ig(J, ce) {
      for (var le = -1, Je = J.length; ++le < Je && ba(ce, J[le], 0) > -1; )
        ;
      return le;
    }
    function Ng(J, ce) {
      for (var le = J.length; le-- && ba(ce, J[le], 0) > -1; )
        ;
      return le;
    }
    function ZC(J, ce) {
      for (var le = J.length, Je = 0; le--; )
        J[le] === ce && ++Je;
      return Je;
    }
    var KC = dd(OC), XC = dd(_C);
    function JC(J) {
      return "\\" + PC[J];
    }
    function eS(J, ce) {
      return J == null ? r : J[ce];
    }
    function ya(J) {
      return IC.test(J);
    }
    function tS(J) {
      return NC.test(J);
    }
    function rS(J) {
      for (var ce, le = []; !(ce = J.next()).done; )
        le.push(ce.value);
      return le;
    }
    function gd(J) {
      var ce = -1, le = Array(J.size);
      return J.forEach(function(Je, kt) {
        le[++ce] = [kt, Je];
      }), le;
    }
    function zg(J, ce) {
      return function(le) {
        return J(ce(le));
      };
    }
    function fo(J, ce) {
      for (var le = -1, Je = J.length, kt = 0, qt = []; ++le < Je; ) {
        var Pr = J[le];
        (Pr === ce || Pr === f) && (J[le] = f, qt[kt++] = le);
      }
      return qt;
    }
    function Ws(J) {
      var ce = -1, le = Array(J.size);
      return J.forEach(function(Je) {
        le[++ce] = Je;
      }), le;
    }
    function nS(J) {
      var ce = -1, le = Array(J.size);
      return J.forEach(function(Je) {
        le[++ce] = [Je, Je];
      }), le;
    }
    function iS(J, ce, le) {
      for (var Je = le - 1, kt = J.length; ++Je < kt; )
        if (J[Je] === ce)
          return Je;
      return -1;
    }
    function oS(J, ce, le) {
      for (var Je = le + 1; Je--; )
        if (J[Je] === ce)
          return Je;
      return Je;
    }
    function xa(J) {
      return ya(J) ? lS(J) : WC(J);
    }
    function ni(J) {
      return ya(J) ? sS(J) : VC(J);
    }
    function $g(J) {
      for (var ce = J.length; ce-- && Tt.test(J.charAt(ce)); )
        ;
      return ce;
    }
    var aS = dd(LC);
    function lS(J) {
      for (var ce = id.lastIndex = 0; id.test(J); )
        ++ce;
      return ce;
    }
    function sS(J) {
      return J.match(id) || [];
    }
    function uS(J) {
      return J.match(EC) || [];
    }
    var cS = function J(ce) {
      ce = ce == null ? Vr : wa.defaults(Vr.Object(), ce, wa.pick(Vr, zC));
      var le = ce.Array, Je = ce.Date, kt = ce.Error, qt = ce.Function, Pr = ce.Math, or = ce.Object, md = ce.RegExp, dS = ce.String, Hn = ce.TypeError, Vs = le.prototype, fS = qt.prototype, Ma = or.prototype, Ys = ce["__core-js_shared__"], Qs = fS.toString, Jt = Ma.hasOwnProperty, hS = 0, Og = function() {
        var l = /[^.]+$/.exec(Ys && Ys.keys && Ys.keys.IE_PROTO || "");
        return l ? "Symbol(src)_1." + l : "";
      }(), qs = Ma.toString, pS = Qs.call(or), gS = Vr._, mS = md("^" + Qs.call(Jt).replace(zt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Gs = vg ? ce.Buffer : r, ho = ce.Symbol, Zs = ce.Uint8Array, _g = Gs ? Gs.allocUnsafe : r, Ks = zg(or.getPrototypeOf, or), Lg = or.create, Pg = Ma.propertyIsEnumerable, Xs = Vs.splice, Rg = ho ? ho.isConcatSpreadable : r, bl = ho ? ho.iterator : r, jo = ho ? ho.toStringTag : r, Js = function() {
        try {
          var l = Wo(or, "defineProperty");
          return l({}, "", {}), l;
        } catch {
        }
      }(), vS = ce.clearTimeout !== Vr.clearTimeout && ce.clearTimeout, bS = Je && Je.now !== Vr.Date.now && Je.now, yS = ce.setTimeout !== Vr.setTimeout && ce.setTimeout, eu = Pr.ceil, tu = Pr.floor, vd = or.getOwnPropertySymbols, xS = Gs ? Gs.isBuffer : r, jg = ce.isFinite, wS = Vs.join, MS = zg(or.keys, or), Rr = Pr.max, tn = Pr.min, CS = Je.now, SS = ce.parseInt, Fg = Pr.random, TS = Vs.reverse, bd = Wo(ce, "DataView"), yl = Wo(ce, "Map"), yd = Wo(ce, "Promise"), Ca = Wo(ce, "Set"), xl = Wo(ce, "WeakMap"), wl = Wo(or, "create"), ru = xl && new xl(), Sa = {}, kS = Vo(bd), DS = Vo(yl), AS = Vo(yd), ES = Vo(Ca), IS = Vo(xl), nu = ho ? ho.prototype : r, Ml = nu ? nu.valueOf : r, Bg = nu ? nu.toString : r;
      function z(l) {
        if (Dr(l) && !Et(l) && !(l instanceof Rt)) {
          if (l instanceof Wn)
            return l;
          if (Jt.call(l, "__wrapped__"))
            return Um(l);
        }
        return new Wn(l);
      }
      var Ta = function() {
        function l() {
        }
        return function(c) {
          if (!yr(c))
            return {};
          if (Lg)
            return Lg(c);
          l.prototype = c;
          var p = new l();
          return l.prototype = r, p;
        };
      }();
      function iu() {
      }
      function Wn(l, c) {
        this.__wrapped__ = l, this.__actions__ = [], this.__chain__ = !!c, this.__index__ = 0, this.__values__ = r;
      }
      z.templateSettings = {
        escape: Te,
        evaluate: Ke,
        interpolate: xe,
        variable: "",
        imports: {
          _: z
        }
      }, z.prototype = iu.prototype, z.prototype.constructor = z, Wn.prototype = Ta(iu.prototype), Wn.prototype.constructor = Wn;
      function Rt(l) {
        this.__wrapped__ = l, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = de, this.__views__ = [];
      }
      function NS() {
        var l = new Rt(this.__wrapped__);
        return l.__actions__ = gn(this.__actions__), l.__dir__ = this.__dir__, l.__filtered__ = this.__filtered__, l.__iteratees__ = gn(this.__iteratees__), l.__takeCount__ = this.__takeCount__, l.__views__ = gn(this.__views__), l;
      }
      function zS() {
        if (this.__filtered__) {
          var l = new Rt(this);
          l.__dir__ = -1, l.__filtered__ = !0;
        } else
          l = this.clone(), l.__dir__ *= -1;
        return l;
      }
      function $S() {
        var l = this.__wrapped__.value(), c = this.__dir__, p = Et(l), M = c < 0, k = p ? l.length : 0, O = VT(0, k, this.__views__), F = O.start, V = O.end, ee = V - F, me = M ? V : F - 1, be = this.__iteratees__, Ce = be.length, He = 0, it = tn(ee, this.__takeCount__);
        if (!p || !M && k == ee && it == ee)
          return dm(l, this.__actions__);
        var gt = [];
        e:
          for (; ee-- && He < it; ) {
            me += c;
            for (var $t = -1, mt = l[me]; ++$t < Ce; ) {
              var Pt = be[$t], Ft = Pt.iteratee, zn = Pt.type, un = Ft(mt);
              if (zn == Z)
                mt = un;
              else if (!un) {
                if (zn == Q)
                  continue e;
                break e;
              }
            }
            gt[He++] = mt;
          }
        return gt;
      }
      Rt.prototype = Ta(iu.prototype), Rt.prototype.constructor = Rt;
      function Fo(l) {
        var c = -1, p = l == null ? 0 : l.length;
        for (this.clear(); ++c < p; ) {
          var M = l[c];
          this.set(M[0], M[1]);
        }
      }
      function OS() {
        this.__data__ = wl ? wl(null) : {}, this.size = 0;
      }
      function _S(l) {
        var c = this.has(l) && delete this.__data__[l];
        return this.size -= c ? 1 : 0, c;
      }
      function LS(l) {
        var c = this.__data__;
        if (wl) {
          var p = c[l];
          return p === u ? r : p;
        }
        return Jt.call(c, l) ? c[l] : r;
      }
      function PS(l) {
        var c = this.__data__;
        return wl ? c[l] !== r : Jt.call(c, l);
      }
      function RS(l, c) {
        var p = this.__data__;
        return this.size += this.has(l) ? 0 : 1, p[l] = wl && c === r ? u : c, this;
      }
      Fo.prototype.clear = OS, Fo.prototype.delete = _S, Fo.prototype.get = LS, Fo.prototype.has = PS, Fo.prototype.set = RS;
      function Ri(l) {
        var c = -1, p = l == null ? 0 : l.length;
        for (this.clear(); ++c < p; ) {
          var M = l[c];
          this.set(M[0], M[1]);
        }
      }
      function jS() {
        this.__data__ = [], this.size = 0;
      }
      function FS(l) {
        var c = this.__data__, p = ou(c, l);
        if (p < 0)
          return !1;
        var M = c.length - 1;
        return p == M ? c.pop() : Xs.call(c, p, 1), --this.size, !0;
      }
      function BS(l) {
        var c = this.__data__, p = ou(c, l);
        return p < 0 ? r : c[p][1];
      }
      function US(l) {
        return ou(this.__data__, l) > -1;
      }
      function HS(l, c) {
        var p = this.__data__, M = ou(p, l);
        return M < 0 ? (++this.size, p.push([l, c])) : p[M][1] = c, this;
      }
      Ri.prototype.clear = jS, Ri.prototype.delete = FS, Ri.prototype.get = BS, Ri.prototype.has = US, Ri.prototype.set = HS;
      function ji(l) {
        var c = -1, p = l == null ? 0 : l.length;
        for (this.clear(); ++c < p; ) {
          var M = l[c];
          this.set(M[0], M[1]);
        }
      }
      function WS() {
        this.size = 0, this.__data__ = {
          hash: new Fo(),
          map: new (yl || Ri)(),
          string: new Fo()
        };
      }
      function VS(l) {
        var c = vu(this, l).delete(l);
        return this.size -= c ? 1 : 0, c;
      }
      function YS(l) {
        return vu(this, l).get(l);
      }
      function QS(l) {
        return vu(this, l).has(l);
      }
      function qS(l, c) {
        var p = vu(this, l), M = p.size;
        return p.set(l, c), this.size += p.size == M ? 0 : 1, this;
      }
      ji.prototype.clear = WS, ji.prototype.delete = VS, ji.prototype.get = YS, ji.prototype.has = QS, ji.prototype.set = qS;
      function Bo(l) {
        var c = -1, p = l == null ? 0 : l.length;
        for (this.__data__ = new ji(); ++c < p; )
          this.add(l[c]);
      }
      function GS(l) {
        return this.__data__.set(l, u), this;
      }
      function ZS(l) {
        return this.__data__.has(l);
      }
      Bo.prototype.add = Bo.prototype.push = GS, Bo.prototype.has = ZS;
      function ii(l) {
        var c = this.__data__ = new Ri(l);
        this.size = c.size;
      }
      function KS() {
        this.__data__ = new Ri(), this.size = 0;
      }
      function XS(l) {
        var c = this.__data__, p = c.delete(l);
        return this.size = c.size, p;
      }
      function JS(l) {
        return this.__data__.get(l);
      }
      function eT(l) {
        return this.__data__.has(l);
      }
      function tT(l, c) {
        var p = this.__data__;
        if (p instanceof Ri) {
          var M = p.__data__;
          if (!yl || M.length < i - 1)
            return M.push([l, c]), this.size = ++p.size, this;
          p = this.__data__ = new ji(M);
        }
        return p.set(l, c), this.size = p.size, this;
      }
      ii.prototype.clear = KS, ii.prototype.delete = XS, ii.prototype.get = JS, ii.prototype.has = eT, ii.prototype.set = tT;
      function Ug(l, c) {
        var p = Et(l), M = !p && Yo(l), k = !p && !M && bo(l), O = !p && !M && !k && Ea(l), F = p || M || k || O, V = F ? hd(l.length, dS) : [], ee = V.length;
        for (var me in l)
          (c || Jt.call(l, me)) && !(F && (me == "length" || k && (me == "offset" || me == "parent") || O && (me == "buffer" || me == "byteLength" || me == "byteOffset") || Hi(me, ee))) && V.push(me);
        return V;
      }
      function Hg(l) {
        var c = l.length;
        return c ? l[Id(0, c - 1)] : r;
      }
      function rT(l, c) {
        return bu(gn(l), Uo(c, 0, l.length));
      }
      function nT(l) {
        return bu(gn(l));
      }
      function xd(l, c, p) {
        (p !== r && !oi(l[c], p) || p === r && !(c in l)) && Fi(l, c, p);
      }
      function Cl(l, c, p) {
        var M = l[c];
        (!(Jt.call(l, c) && oi(M, p)) || p === r && !(c in l)) && Fi(l, c, p);
      }
      function ou(l, c) {
        for (var p = l.length; p--; )
          if (oi(l[p][0], c))
            return p;
        return -1;
      }
      function iT(l, c, p, M) {
        return po(l, function(k, O, F) {
          c(M, k, p(k), F);
        }), M;
      }
      function Wg(l, c) {
        return l && Ti(c, Ur(c), l);
      }
      function oT(l, c) {
        return l && Ti(c, vn(c), l);
      }
      function Fi(l, c, p) {
        c == "__proto__" && Js ? Js(l, c, {
          configurable: !0,
          enumerable: !0,
          value: p,
          writable: !0
        }) : l[c] = p;
      }
      function wd(l, c) {
        for (var p = -1, M = c.length, k = le(M), O = l == null; ++p < M; )
          k[p] = O ? r : tf(l, c[p]);
        return k;
      }
      function Uo(l, c, p) {
        return l === l && (p !== r && (l = l <= p ? l : p), c !== r && (l = l >= c ? l : c)), l;
      }
      function Vn(l, c, p, M, k, O) {
        var F, V = c & h, ee = c & g, me = c & m;
        if (p && (F = k ? p(l, M, k, O) : p(l)), F !== r)
          return F;
        if (!yr(l))
          return l;
        var be = Et(l);
        if (be) {
          if (F = QT(l), !V)
            return gn(l, F);
        } else {
          var Ce = rn(l), He = Ce == Ue || Ce == ot;
          if (bo(l))
            return pm(l, V);
          if (Ce == P || Ce == Ae || He && !k) {
            if (F = ee || He ? {} : $m(l), !V)
              return ee ? LT(l, oT(F, l)) : _T(l, Wg(F, l));
          } else {
            if (!sr[Ce])
              return k ? l : {};
            F = qT(l, Ce, V);
          }
        }
        O || (O = new ii());
        var it = O.get(l);
        if (it)
          return it;
        O.set(l, F), sv(l) ? l.forEach(function(mt) {
          F.add(Vn(mt, c, p, mt, l, O));
        }) : av(l) && l.forEach(function(mt, Pt) {
          F.set(Pt, Vn(mt, c, p, Pt, l, O));
        });
        var gt = me ? ee ? Bd : Fd : ee ? vn : Ur, $t = be ? r : gt(l);
        return Un($t || l, function(mt, Pt) {
          $t && (Pt = mt, mt = l[Pt]), Cl(F, Pt, Vn(mt, c, p, Pt, l, O));
        }), F;
      }
      function aT(l) {
        var c = Ur(l);
        return function(p) {
          return Vg(p, l, c);
        };
      }
      function Vg(l, c, p) {
        var M = p.length;
        if (l == null)
          return !M;
        for (l = or(l); M--; ) {
          var k = p[M], O = c[k], F = l[k];
          if (F === r && !(k in l) || !O(F))
            return !1;
        }
        return !0;
      }
      function Yg(l, c, p) {
        if (typeof l != "function")
          throw new Hn(a);
        return Il(function() {
          l.apply(r, p);
        }, c);
      }
      function Sl(l, c, p, M) {
        var k = -1, O = Us, F = !0, V = l.length, ee = [], me = c.length;
        if (!V)
          return ee;
        p && (c = mr(c, En(p))), M ? (O = ld, F = !1) : c.length >= i && (O = vl, F = !1, c = new Bo(c));
        e:
          for (; ++k < V; ) {
            var be = l[k], Ce = p == null ? be : p(be);
            if (be = M || be !== 0 ? be : 0, F && Ce === Ce) {
              for (var He = me; He--; )
                if (c[He] === Ce)
                  continue e;
              ee.push(be);
            } else
              O(c, Ce, M) || ee.push(be);
          }
        return ee;
      }
      var po = ym(Si), Qg = ym(Cd, !0);
      function lT(l, c) {
        var p = !0;
        return po(l, function(M, k, O) {
          return p = !!c(M, k, O), p;
        }), p;
      }
      function au(l, c, p) {
        for (var M = -1, k = l.length; ++M < k; ) {
          var O = l[M], F = c(O);
          if (F != null && (V === r ? F === F && !Nn(F) : p(F, V)))
            var V = F, ee = O;
        }
        return ee;
      }
      function sT(l, c, p, M) {
        var k = l.length;
        for (p = It(p), p < 0 && (p = -p > k ? 0 : k + p), M = M === r || M > k ? k : It(M), M < 0 && (M += k), M = p > M ? 0 : cv(M); p < M; )
          l[p++] = c;
        return l;
      }
      function qg(l, c) {
        var p = [];
        return po(l, function(M, k, O) {
          c(M, k, O) && p.push(M);
        }), p;
      }
      function Yr(l, c, p, M, k) {
        var O = -1, F = l.length;
        for (p || (p = ZT), k || (k = []); ++O < F; ) {
          var V = l[O];
          c > 0 && p(V) ? c > 1 ? Yr(V, c - 1, p, M, k) : co(k, V) : M || (k[k.length] = V);
        }
        return k;
      }
      var Md = xm(), Gg = xm(!0);
      function Si(l, c) {
        return l && Md(l, c, Ur);
      }
      function Cd(l, c) {
        return l && Gg(l, c, Ur);
      }
      function lu(l, c) {
        return uo(c, function(p) {
          return Wi(l[p]);
        });
      }
      function Ho(l, c) {
        c = mo(c, l);
        for (var p = 0, M = c.length; l != null && p < M; )
          l = l[ki(c[p++])];
        return p && p == M ? l : r;
      }
      function Zg(l, c, p) {
        var M = c(l);
        return Et(l) ? M : co(M, p(l));
      }
      function ln(l) {
        return l == null ? l === r ? ke : W : jo && jo in or(l) ? WT(l) : nk(l);
      }
      function Sd(l, c) {
        return l > c;
      }
      function uT(l, c) {
        return l != null && Jt.call(l, c);
      }
      function cT(l, c) {
        return l != null && c in or(l);
      }
      function dT(l, c, p) {
        return l >= tn(c, p) && l < Rr(c, p);
      }
      function Td(l, c, p) {
        for (var M = p ? ld : Us, k = l[0].length, O = l.length, F = O, V = le(O), ee = 1 / 0, me = []; F--; ) {
          var be = l[F];
          F && c && (be = mr(be, En(c))), ee = tn(be.length, ee), V[F] = !p && (c || k >= 120 && be.length >= 120) ? new Bo(F && be) : r;
        }
        be = l[0];
        var Ce = -1, He = V[0];
        e:
          for (; ++Ce < k && me.length < ee; ) {
            var it = be[Ce], gt = c ? c(it) : it;
            if (it = p || it !== 0 ? it : 0, !(He ? vl(He, gt) : M(me, gt, p))) {
              for (F = O; --F; ) {
                var $t = V[F];
                if (!($t ? vl($t, gt) : M(l[F], gt, p)))
                  continue e;
              }
              He && He.push(gt), me.push(it);
            }
          }
        return me;
      }
      function fT(l, c, p, M) {
        return Si(l, function(k, O, F) {
          c(M, p(k), O, F);
        }), M;
      }
      function Tl(l, c, p) {
        c = mo(c, l), l = Pm(l, c);
        var M = l == null ? l : l[ki(Qn(c))];
        return M == null ? r : An(M, l, p);
      }
      function Kg(l) {
        return Dr(l) && ln(l) == Ae;
      }
      function hT(l) {
        return Dr(l) && ln(l) == Mt;
      }
      function pT(l) {
        return Dr(l) && ln(l) == Ge;
      }
      function kl(l, c, p, M, k) {
        return l === c ? !0 : l == null || c == null || !Dr(l) && !Dr(c) ? l !== l && c !== c : gT(l, c, p, M, kl, k);
      }
      function gT(l, c, p, M, k, O) {
        var F = Et(l), V = Et(c), ee = F ? Ne : rn(l), me = V ? Ne : rn(c);
        ee = ee == Ae ? P : ee, me = me == Ae ? P : me;
        var be = ee == P, Ce = me == P, He = ee == me;
        if (He && bo(l)) {
          if (!bo(c))
            return !1;
          F = !0, be = !1;
        }
        if (He && !be)
          return O || (O = new ii()), F || Ea(l) ? Im(l, c, p, M, k, O) : UT(l, c, ee, p, M, k, O);
        if (!(p & v)) {
          var it = be && Jt.call(l, "__wrapped__"), gt = Ce && Jt.call(c, "__wrapped__");
          if (it || gt) {
            var $t = it ? l.value() : l, mt = gt ? c.value() : c;
            return O || (O = new ii()), k($t, mt, p, M, O);
          }
        }
        return He ? (O || (O = new ii()), HT(l, c, p, M, k, O)) : !1;
      }
      function mT(l) {
        return Dr(l) && rn(l) == Ie;
      }
      function kd(l, c, p, M) {
        var k = p.length, O = k, F = !M;
        if (l == null)
          return !O;
        for (l = or(l); k--; ) {
          var V = p[k];
          if (F && V[2] ? V[1] !== l[V[0]] : !(V[0] in l))
            return !1;
        }
        for (; ++k < O; ) {
          V = p[k];
          var ee = V[0], me = l[ee], be = V[1];
          if (F && V[2]) {
            if (me === r && !(ee in l))
              return !1;
          } else {
            var Ce = new ii();
            if (M)
              var He = M(me, be, ee, l, c, Ce);
            if (!(He === r ? kl(be, me, v | w, M, Ce) : He))
              return !1;
          }
        }
        return !0;
      }
      function Xg(l) {
        if (!yr(l) || XT(l))
          return !1;
        var c = Wi(l) ? mS : Ut;
        return c.test(Vo(l));
      }
      function vT(l) {
        return Dr(l) && ln(l) == pe;
      }
      function bT(l) {
        return Dr(l) && rn(l) == ae;
      }
      function yT(l) {
        return Dr(l) && Su(l.length) && !!dr[ln(l)];
      }
      function Jg(l) {
        return typeof l == "function" ? l : l == null ? bn : typeof l == "object" ? Et(l) ? rm(l[0], l[1]) : tm(l) : wv(l);
      }
      function Dd(l) {
        if (!El(l))
          return MS(l);
        var c = [];
        for (var p in or(l))
          Jt.call(l, p) && p != "constructor" && c.push(p);
        return c;
      }
      function xT(l) {
        if (!yr(l))
          return rk(l);
        var c = El(l), p = [];
        for (var M in l)
          M == "constructor" && (c || !Jt.call(l, M)) || p.push(M);
        return p;
      }
      function Ad(l, c) {
        return l < c;
      }
      function em(l, c) {
        var p = -1, M = mn(l) ? le(l.length) : [];
        return po(l, function(k, O, F) {
          M[++p] = c(k, O, F);
        }), M;
      }
      function tm(l) {
        var c = Hd(l);
        return c.length == 1 && c[0][2] ? _m(c[0][0], c[0][1]) : function(p) {
          return p === l || kd(p, l, c);
        };
      }
      function rm(l, c) {
        return Vd(l) && Om(c) ? _m(ki(l), c) : function(p) {
          var M = tf(p, l);
          return M === r && M === c ? rf(p, l) : kl(c, M, v | w);
        };
      }
      function su(l, c, p, M, k) {
        l !== c && Md(c, function(O, F) {
          if (k || (k = new ii()), yr(O))
            wT(l, c, F, p, su, M, k);
          else {
            var V = M ? M(Qd(l, F), O, F + "", l, c, k) : r;
            V === r && (V = O), xd(l, F, V);
          }
        }, vn);
      }
      function wT(l, c, p, M, k, O, F) {
        var V = Qd(l, p), ee = Qd(c, p), me = F.get(ee);
        if (me) {
          xd(l, p, me);
          return;
        }
        var be = O ? O(V, ee, p + "", l, c, F) : r, Ce = be === r;
        if (Ce) {
          var He = Et(ee), it = !He && bo(ee), gt = !He && !it && Ea(ee);
          be = ee, He || it || gt ? Et(V) ? be = V : Ir(V) ? be = gn(V) : it ? (Ce = !1, be = pm(ee, !0)) : gt ? (Ce = !1, be = gm(ee, !0)) : be = [] : Nl(ee) || Yo(ee) ? (be = V, Yo(V) ? be = dv(V) : (!yr(V) || Wi(V)) && (be = $m(ee))) : Ce = !1;
        }
        Ce && (F.set(ee, be), k(be, ee, M, O, F), F.delete(ee)), xd(l, p, be);
      }
      function nm(l, c) {
        var p = l.length;
        if (p)
          return c += c < 0 ? p : 0, Hi(c, p) ? l[c] : r;
      }
      function im(l, c, p) {
        c.length ? c = mr(c, function(O) {
          return Et(O) ? function(F) {
            return Ho(F, O.length === 1 ? O[0] : O);
          } : O;
        }) : c = [bn];
        var M = -1;
        c = mr(c, En(pt()));
        var k = em(l, function(O, F, V) {
          var ee = mr(c, function(me) {
            return me(O);
          });
          return { criteria: ee, index: ++M, value: O };
        });
        return qC(k, function(O, F) {
          return OT(O, F, p);
        });
      }
      function MT(l, c) {
        return om(l, c, function(p, M) {
          return rf(l, M);
        });
      }
      function om(l, c, p) {
        for (var M = -1, k = c.length, O = {}; ++M < k; ) {
          var F = c[M], V = Ho(l, F);
          p(V, F) && Dl(O, mo(F, l), V);
        }
        return O;
      }
      function CT(l) {
        return function(c) {
          return Ho(c, l);
        };
      }
      function Ed(l, c, p, M) {
        var k = M ? QC : ba, O = -1, F = c.length, V = l;
        for (l === c && (c = gn(c)), p && (V = mr(l, En(p))); ++O < F; )
          for (var ee = 0, me = c[O], be = p ? p(me) : me; (ee = k(V, be, ee, M)) > -1; )
            V !== l && Xs.call(V, ee, 1), Xs.call(l, ee, 1);
        return l;
      }
      function am(l, c) {
        for (var p = l ? c.length : 0, M = p - 1; p--; ) {
          var k = c[p];
          if (p == M || k !== O) {
            var O = k;
            Hi(k) ? Xs.call(l, k, 1) : $d(l, k);
          }
        }
        return l;
      }
      function Id(l, c) {
        return l + tu(Fg() * (c - l + 1));
      }
      function ST(l, c, p, M) {
        for (var k = -1, O = Rr(eu((c - l) / (p || 1)), 0), F = le(O); O--; )
          F[M ? O : ++k] = l, l += p;
        return F;
      }
      function Nd(l, c) {
        var p = "";
        if (!l || c < 1 || c > ue)
          return p;
        do
          c % 2 && (p += l), c = tu(c / 2), c && (l += l);
        while (c);
        return p;
      }
      function _t(l, c) {
        return qd(Lm(l, c, bn), l + "");
      }
      function TT(l) {
        return Hg(Ia(l));
      }
      function kT(l, c) {
        var p = Ia(l);
        return bu(p, Uo(c, 0, p.length));
      }
      function Dl(l, c, p, M) {
        if (!yr(l))
          return l;
        c = mo(c, l);
        for (var k = -1, O = c.length, F = O - 1, V = l; V != null && ++k < O; ) {
          var ee = ki(c[k]), me = p;
          if (ee === "__proto__" || ee === "constructor" || ee === "prototype")
            return l;
          if (k != F) {
            var be = V[ee];
            me = M ? M(be, ee, V) : r, me === r && (me = yr(be) ? be : Hi(c[k + 1]) ? [] : {});
          }
          Cl(V, ee, me), V = V[ee];
        }
        return l;
      }
      var lm = ru ? function(l, c) {
        return ru.set(l, c), l;
      } : bn, DT = Js ? function(l, c) {
        return Js(l, "toString", {
          configurable: !0,
          enumerable: !1,
          value: of(c),
          writable: !0
        });
      } : bn;
      function AT(l) {
        return bu(Ia(l));
      }
      function Yn(l, c, p) {
        var M = -1, k = l.length;
        c < 0 && (c = -c > k ? 0 : k + c), p = p > k ? k : p, p < 0 && (p += k), k = c > p ? 0 : p - c >>> 0, c >>>= 0;
        for (var O = le(k); ++M < k; )
          O[M] = l[M + c];
        return O;
      }
      function ET(l, c) {
        var p;
        return po(l, function(M, k, O) {
          return p = c(M, k, O), !p;
        }), !!p;
      }
      function uu(l, c, p) {
        var M = 0, k = l == null ? M : l.length;
        if (typeof c == "number" && c === c && k <= Oe) {
          for (; M < k; ) {
            var O = M + k >>> 1, F = l[O];
            F !== null && !Nn(F) && (p ? F <= c : F < c) ? M = O + 1 : k = O;
          }
          return k;
        }
        return zd(l, c, bn, p);
      }
      function zd(l, c, p, M) {
        var k = 0, O = l == null ? 0 : l.length;
        if (O === 0)
          return 0;
        c = p(c);
        for (var F = c !== c, V = c === null, ee = Nn(c), me = c === r; k < O; ) {
          var be = tu((k + O) / 2), Ce = p(l[be]), He = Ce !== r, it = Ce === null, gt = Ce === Ce, $t = Nn(Ce);
          if (F)
            var mt = M || gt;
          else
            me ? mt = gt && (M || He) : V ? mt = gt && He && (M || !it) : ee ? mt = gt && He && !it && (M || !$t) : it || $t ? mt = !1 : mt = M ? Ce <= c : Ce < c;
          mt ? k = be + 1 : O = be;
        }
        return tn(O, De);
      }
      function sm(l, c) {
        for (var p = -1, M = l.length, k = 0, O = []; ++p < M; ) {
          var F = l[p], V = c ? c(F) : F;
          if (!p || !oi(V, ee)) {
            var ee = V;
            O[k++] = F === 0 ? 0 : F;
          }
        }
        return O;
      }
      function um(l) {
        return typeof l == "number" ? l : Nn(l) ? te : +l;
      }
      function In(l) {
        if (typeof l == "string")
          return l;
        if (Et(l))
          return mr(l, In) + "";
        if (Nn(l))
          return Bg ? Bg.call(l) : "";
        var c = l + "";
        return c == "0" && 1 / l == -re ? "-0" : c;
      }
      function go(l, c, p) {
        var M = -1, k = Us, O = l.length, F = !0, V = [], ee = V;
        if (p)
          F = !1, k = ld;
        else if (O >= i) {
          var me = c ? null : FT(l);
          if (me)
            return Ws(me);
          F = !1, k = vl, ee = new Bo();
        } else
          ee = c ? [] : V;
        e:
          for (; ++M < O; ) {
            var be = l[M], Ce = c ? c(be) : be;
            if (be = p || be !== 0 ? be : 0, F && Ce === Ce) {
              for (var He = ee.length; He--; )
                if (ee[He] === Ce)
                  continue e;
              c && ee.push(Ce), V.push(be);
            } else
              k(ee, Ce, p) || (ee !== V && ee.push(Ce), V.push(be));
          }
        return V;
      }
      function $d(l, c) {
        return c = mo(c, l), l = Pm(l, c), l == null || delete l[ki(Qn(c))];
      }
      function cm(l, c, p, M) {
        return Dl(l, c, p(Ho(l, c)), M);
      }
      function cu(l, c, p, M) {
        for (var k = l.length, O = M ? k : -1; (M ? O-- : ++O < k) && c(l[O], O, l); )
          ;
        return p ? Yn(l, M ? 0 : O, M ? O + 1 : k) : Yn(l, M ? O + 1 : 0, M ? k : O);
      }
      function dm(l, c) {
        var p = l;
        return p instanceof Rt && (p = p.value()), sd(c, function(M, k) {
          return k.func.apply(k.thisArg, co([M], k.args));
        }, p);
      }
      function Od(l, c, p) {
        var M = l.length;
        if (M < 2)
          return M ? go(l[0]) : [];
        for (var k = -1, O = le(M); ++k < M; )
          for (var F = l[k], V = -1; ++V < M; )
            V != k && (O[k] = Sl(O[k] || F, l[V], c, p));
        return go(Yr(O, 1), c, p);
      }
      function fm(l, c, p) {
        for (var M = -1, k = l.length, O = c.length, F = {}; ++M < k; ) {
          var V = M < O ? c[M] : r;
          p(F, l[M], V);
        }
        return F;
      }
      function _d(l) {
        return Ir(l) ? l : [];
      }
      function Ld(l) {
        return typeof l == "function" ? l : bn;
      }
      function mo(l, c) {
        return Et(l) ? l : Vd(l, c) ? [l] : Bm(Zt(l));
      }
      var IT = _t;
      function vo(l, c, p) {
        var M = l.length;
        return p = p === r ? M : p, !c && p >= M ? l : Yn(l, c, p);
      }
      var hm = vS || function(l) {
        return Vr.clearTimeout(l);
      };
      function pm(l, c) {
        if (c)
          return l.slice();
        var p = l.length, M = _g ? _g(p) : new l.constructor(p);
        return l.copy(M), M;
      }
      function Pd(l) {
        var c = new l.constructor(l.byteLength);
        return new Zs(c).set(new Zs(l)), c;
      }
      function NT(l, c) {
        var p = c ? Pd(l.buffer) : l.buffer;
        return new l.constructor(p, l.byteOffset, l.byteLength);
      }
      function zT(l) {
        var c = new l.constructor(l.source, Mi.exec(l));
        return c.lastIndex = l.lastIndex, c;
      }
      function $T(l) {
        return Ml ? or(Ml.call(l)) : {};
      }
      function gm(l, c) {
        var p = c ? Pd(l.buffer) : l.buffer;
        return new l.constructor(p, l.byteOffset, l.length);
      }
      function mm(l, c) {
        if (l !== c) {
          var p = l !== r, M = l === null, k = l === l, O = Nn(l), F = c !== r, V = c === null, ee = c === c, me = Nn(c);
          if (!V && !me && !O && l > c || O && F && ee && !V && !me || M && F && ee || !p && ee || !k)
            return 1;
          if (!M && !O && !me && l < c || me && p && k && !M && !O || V && p && k || !F && k || !ee)
            return -1;
        }
        return 0;
      }
      function OT(l, c, p) {
        for (var M = -1, k = l.criteria, O = c.criteria, F = k.length, V = p.length; ++M < F; ) {
          var ee = mm(k[M], O[M]);
          if (ee) {
            if (M >= V)
              return ee;
            var me = p[M];
            return ee * (me == "desc" ? -1 : 1);
          }
        }
        return l.index - c.index;
      }
      function vm(l, c, p, M) {
        for (var k = -1, O = l.length, F = p.length, V = -1, ee = c.length, me = Rr(O - F, 0), be = le(ee + me), Ce = !M; ++V < ee; )
          be[V] = c[V];
        for (; ++k < F; )
          (Ce || k < O) && (be[p[k]] = l[k]);
        for (; me--; )
          be[V++] = l[k++];
        return be;
      }
      function bm(l, c, p, M) {
        for (var k = -1, O = l.length, F = -1, V = p.length, ee = -1, me = c.length, be = Rr(O - V, 0), Ce = le(be + me), He = !M; ++k < be; )
          Ce[k] = l[k];
        for (var it = k; ++ee < me; )
          Ce[it + ee] = c[ee];
        for (; ++F < V; )
          (He || k < O) && (Ce[it + p[F]] = l[k++]);
        return Ce;
      }
      function gn(l, c) {
        var p = -1, M = l.length;
        for (c || (c = le(M)); ++p < M; )
          c[p] = l[p];
        return c;
      }
      function Ti(l, c, p, M) {
        var k = !p;
        p || (p = {});
        for (var O = -1, F = c.length; ++O < F; ) {
          var V = c[O], ee = M ? M(p[V], l[V], V, p, l) : r;
          ee === r && (ee = l[V]), k ? Fi(p, V, ee) : Cl(p, V, ee);
        }
        return p;
      }
      function _T(l, c) {
        return Ti(l, Wd(l), c);
      }
      function LT(l, c) {
        return Ti(l, Nm(l), c);
      }
      function du(l, c) {
        return function(p, M) {
          var k = Et(p) ? BC : iT, O = c ? c() : {};
          return k(p, l, pt(M, 2), O);
        };
      }
      function ka(l) {
        return _t(function(c, p) {
          var M = -1, k = p.length, O = k > 1 ? p[k - 1] : r, F = k > 2 ? p[2] : r;
          for (O = l.length > 3 && typeof O == "function" ? (k--, O) : r, F && sn(p[0], p[1], F) && (O = k < 3 ? r : O, k = 1), c = or(c); ++M < k; ) {
            var V = p[M];
            V && l(c, V, M, O);
          }
          return c;
        });
      }
      function ym(l, c) {
        return function(p, M) {
          if (p == null)
            return p;
          if (!mn(p))
            return l(p, M);
          for (var k = p.length, O = c ? k : -1, F = or(p); (c ? O-- : ++O < k) && M(F[O], O, F) !== !1; )
            ;
          return p;
        };
      }
      function xm(l) {
        return function(c, p, M) {
          for (var k = -1, O = or(c), F = M(c), V = F.length; V--; ) {
            var ee = F[l ? V : ++k];
            if (p(O[ee], ee, O) === !1)
              break;
          }
          return c;
        };
      }
      function PT(l, c, p) {
        var M = c & x, k = Al(l);
        function O() {
          var F = this && this !== Vr && this instanceof O ? k : l;
          return F.apply(M ? p : this, arguments);
        }
        return O;
      }
      function wm(l) {
        return function(c) {
          c = Zt(c);
          var p = ya(c) ? ni(c) : r, M = p ? p[0] : c.charAt(0), k = p ? vo(p, 1).join("") : c.slice(1);
          return M[l]() + k;
        };
      }
      function Da(l) {
        return function(c) {
          return sd(yv(bv(c).replace(DC, "")), l, "");
        };
      }
      function Al(l) {
        return function() {
          var c = arguments;
          switch (c.length) {
            case 0:
              return new l();
            case 1:
              return new l(c[0]);
            case 2:
              return new l(c[0], c[1]);
            case 3:
              return new l(c[0], c[1], c[2]);
            case 4:
              return new l(c[0], c[1], c[2], c[3]);
            case 5:
              return new l(c[0], c[1], c[2], c[3], c[4]);
            case 6:
              return new l(c[0], c[1], c[2], c[3], c[4], c[5]);
            case 7:
              return new l(c[0], c[1], c[2], c[3], c[4], c[5], c[6]);
          }
          var p = Ta(l.prototype), M = l.apply(p, c);
          return yr(M) ? M : p;
        };
      }
      function RT(l, c, p) {
        var M = Al(l);
        function k() {
          for (var O = arguments.length, F = le(O), V = O, ee = Aa(k); V--; )
            F[V] = arguments[V];
          var me = O < 3 && F[0] !== ee && F[O - 1] !== ee ? [] : fo(F, ee);
          if (O -= me.length, O < p)
            return km(l, c, fu, k.placeholder, r, F, me, r, r, p - O);
          var be = this && this !== Vr && this instanceof k ? M : l;
          return An(be, this, F);
        }
        return k;
      }
      function Mm(l) {
        return function(c, p, M) {
          var k = or(c);
          if (!mn(c)) {
            var O = pt(p, 3);
            c = Ur(c), p = function(V) {
              return O(k[V], V, k);
            };
          }
          var F = l(c, p, M);
          return F > -1 ? k[O ? c[F] : F] : r;
        };
      }
      function Cm(l) {
        return Ui(function(c) {
          var p = c.length, M = p, k = Wn.prototype.thru;
          for (l && c.reverse(); M--; ) {
            var O = c[M];
            if (typeof O != "function")
              throw new Hn(a);
            if (k && !F && mu(O) == "wrapper")
              var F = new Wn([], !0);
          }
          for (M = F ? M : p; ++M < p; ) {
            O = c[M];
            var V = mu(O), ee = V == "wrapper" ? Ud(O) : r;
            ee && Yd(ee[0]) && ee[1] == (E | S | A | N) && !ee[4].length && ee[9] == 1 ? F = F[mu(ee[0])].apply(F, ee[3]) : F = O.length == 1 && Yd(O) ? F[V]() : F.thru(O);
          }
          return function() {
            var me = arguments, be = me[0];
            if (F && me.length == 1 && Et(be))
              return F.plant(be).value();
            for (var Ce = 0, He = p ? c[Ce].apply(this, me) : be; ++Ce < p; )
              He = c[Ce].call(this, He);
            return He;
          };
        });
      }
      function fu(l, c, p, M, k, O, F, V, ee, me) {
        var be = c & E, Ce = c & x, He = c & y, it = c & (S | T), gt = c & I, $t = He ? r : Al(l);
        function mt() {
          for (var Pt = arguments.length, Ft = le(Pt), zn = Pt; zn--; )
            Ft[zn] = arguments[zn];
          if (it)
            var un = Aa(mt), $n = ZC(Ft, un);
          if (M && (Ft = vm(Ft, M, k, it)), O && (Ft = bm(Ft, O, F, it)), Pt -= $n, it && Pt < me) {
            var Nr = fo(Ft, un);
            return km(l, c, fu, mt.placeholder, p, Ft, Nr, V, ee, me - Pt);
          }
          var ai = Ce ? p : this, Yi = He ? ai[l] : l;
          return Pt = Ft.length, V ? Ft = ik(Ft, V) : gt && Pt > 1 && Ft.reverse(), be && ee < Pt && (Ft.length = ee), this && this !== Vr && this instanceof mt && (Yi = $t || Al(Yi)), Yi.apply(ai, Ft);
        }
        return mt;
      }
      function Sm(l, c) {
        return function(p, M) {
          return fT(p, l, c(M), {});
        };
      }
      function hu(l, c) {
        return function(p, M) {
          var k;
          if (p === r && M === r)
            return c;
          if (p !== r && (k = p), M !== r) {
            if (k === r)
              return M;
            typeof p == "string" || typeof M == "string" ? (p = In(p), M = In(M)) : (p = um(p), M = um(M)), k = l(p, M);
          }
          return k;
        };
      }
      function Rd(l) {
        return Ui(function(c) {
          return c = mr(c, En(pt())), _t(function(p) {
            var M = this;
            return l(c, function(k) {
              return An(k, M, p);
            });
          });
        });
      }
      function pu(l, c) {
        c = c === r ? " " : In(c);
        var p = c.length;
        if (p < 2)
          return p ? Nd(c, l) : c;
        var M = Nd(c, eu(l / xa(c)));
        return ya(c) ? vo(ni(M), 0, l).join("") : M.slice(0, l);
      }
      function jT(l, c, p, M) {
        var k = c & x, O = Al(l);
        function F() {
          for (var V = -1, ee = arguments.length, me = -1, be = M.length, Ce = le(be + ee), He = this && this !== Vr && this instanceof F ? O : l; ++me < be; )
            Ce[me] = M[me];
          for (; ee--; )
            Ce[me++] = arguments[++V];
          return An(He, k ? p : this, Ce);
        }
        return F;
      }
      function Tm(l) {
        return function(c, p, M) {
          return M && typeof M != "number" && sn(c, p, M) && (p = M = r), c = Vi(c), p === r ? (p = c, c = 0) : p = Vi(p), M = M === r ? c < p ? 1 : -1 : Vi(M), ST(c, p, M, l);
        };
      }
      function gu(l) {
        return function(c, p) {
          return typeof c == "string" && typeof p == "string" || (c = qn(c), p = qn(p)), l(c, p);
        };
      }
      function km(l, c, p, M, k, O, F, V, ee, me) {
        var be = c & S, Ce = be ? F : r, He = be ? r : F, it = be ? O : r, gt = be ? r : O;
        c |= be ? A : D, c &= ~(be ? D : A), c & C || (c &= ~(x | y));
        var $t = [
          l,
          c,
          k,
          it,
          Ce,
          gt,
          He,
          V,
          ee,
          me
        ], mt = p.apply(r, $t);
        return Yd(l) && Rm(mt, $t), mt.placeholder = M, jm(mt, l, c);
      }
      function jd(l) {
        var c = Pr[l];
        return function(p, M) {
          if (p = qn(p), M = M == null ? 0 : tn(It(M), 292), M && jg(p)) {
            var k = (Zt(p) + "e").split("e"), O = c(k[0] + "e" + (+k[1] + M));
            return k = (Zt(O) + "e").split("e"), +(k[0] + "e" + (+k[1] - M));
          }
          return c(p);
        };
      }
      var FT = Ca && 1 / Ws(new Ca([, -0]))[1] == re ? function(l) {
        return new Ca(l);
      } : sf;
      function Dm(l) {
        return function(c) {
          var p = rn(c);
          return p == Ie ? gd(c) : p == ae ? nS(c) : GC(c, l(c));
        };
      }
      function Bi(l, c, p, M, k, O, F, V) {
        var ee = c & y;
        if (!ee && typeof l != "function")
          throw new Hn(a);
        var me = M ? M.length : 0;
        if (me || (c &= ~(A | D), M = k = r), F = F === r ? F : Rr(It(F), 0), V = V === r ? V : It(V), me -= k ? k.length : 0, c & D) {
          var be = M, Ce = k;
          M = k = r;
        }
        var He = ee ? r : Ud(l), it = [
          l,
          c,
          p,
          M,
          k,
          be,
          Ce,
          O,
          F,
          V
        ];
        if (He && tk(it, He), l = it[0], c = it[1], p = it[2], M = it[3], k = it[4], V = it[9] = it[9] === r ? ee ? 0 : l.length : Rr(it[9] - me, 0), !V && c & (S | T) && (c &= ~(S | T)), !c || c == x)
          var gt = PT(l, c, p);
        else
          c == S || c == T ? gt = RT(l, c, V) : (c == A || c == (x | A)) && !k.length ? gt = jT(l, c, p, M) : gt = fu.apply(r, it);
        var $t = He ? lm : Rm;
        return jm($t(gt, it), l, c);
      }
      function Am(l, c, p, M) {
        return l === r || oi(l, Ma[p]) && !Jt.call(M, p) ? c : l;
      }
      function Em(l, c, p, M, k, O) {
        return yr(l) && yr(c) && (O.set(c, l), su(l, c, r, Em, O), O.delete(c)), l;
      }
      function BT(l) {
        return Nl(l) ? r : l;
      }
      function Im(l, c, p, M, k, O) {
        var F = p & v, V = l.length, ee = c.length;
        if (V != ee && !(F && ee > V))
          return !1;
        var me = O.get(l), be = O.get(c);
        if (me && be)
          return me == c && be == l;
        var Ce = -1, He = !0, it = p & w ? new Bo() : r;
        for (O.set(l, c), O.set(c, l); ++Ce < V; ) {
          var gt = l[Ce], $t = c[Ce];
          if (M)
            var mt = F ? M($t, gt, Ce, c, l, O) : M(gt, $t, Ce, l, c, O);
          if (mt !== r) {
            if (mt)
              continue;
            He = !1;
            break;
          }
          if (it) {
            if (!ud(c, function(Pt, Ft) {
              if (!vl(it, Ft) && (gt === Pt || k(gt, Pt, p, M, O)))
                return it.push(Ft);
            })) {
              He = !1;
              break;
            }
          } else if (!(gt === $t || k(gt, $t, p, M, O))) {
            He = !1;
            break;
          }
        }
        return O.delete(l), O.delete(c), He;
      }
      function UT(l, c, p, M, k, O, F) {
        switch (p) {
          case Ct:
            if (l.byteLength != c.byteLength || l.byteOffset != c.byteOffset)
              return !1;
            l = l.buffer, c = c.buffer;
          case Mt:
            return !(l.byteLength != c.byteLength || !O(new Zs(l), new Zs(c)));
          case et:
          case Ge:
          case rt:
            return oi(+l, +c);
          case qe:
            return l.name == c.name && l.message == c.message;
          case pe:
          case Me:
            return l == c + "";
          case Ie:
            var V = gd;
          case ae:
            var ee = M & v;
            if (V || (V = Ws), l.size != c.size && !ee)
              return !1;
            var me = F.get(l);
            if (me)
              return me == c;
            M |= w, F.set(l, c);
            var be = Im(V(l), V(c), M, k, O, F);
            return F.delete(l), be;
          case fe:
            if (Ml)
              return Ml.call(l) == Ml.call(c);
        }
        return !1;
      }
      function HT(l, c, p, M, k, O) {
        var F = p & v, V = Fd(l), ee = V.length, me = Fd(c), be = me.length;
        if (ee != be && !F)
          return !1;
        for (var Ce = ee; Ce--; ) {
          var He = V[Ce];
          if (!(F ? He in c : Jt.call(c, He)))
            return !1;
        }
        var it = O.get(l), gt = O.get(c);
        if (it && gt)
          return it == c && gt == l;
        var $t = !0;
        O.set(l, c), O.set(c, l);
        for (var mt = F; ++Ce < ee; ) {
          He = V[Ce];
          var Pt = l[He], Ft = c[He];
          if (M)
            var zn = F ? M(Ft, Pt, He, c, l, O) : M(Pt, Ft, He, l, c, O);
          if (!(zn === r ? Pt === Ft || k(Pt, Ft, p, M, O) : zn)) {
            $t = !1;
            break;
          }
          mt || (mt = He == "constructor");
        }
        if ($t && !mt) {
          var un = l.constructor, $n = c.constructor;
          un != $n && "constructor" in l && "constructor" in c && !(typeof un == "function" && un instanceof un && typeof $n == "function" && $n instanceof $n) && ($t = !1);
        }
        return O.delete(l), O.delete(c), $t;
      }
      function Ui(l) {
        return qd(Lm(l, r, Vm), l + "");
      }
      function Fd(l) {
        return Zg(l, Ur, Wd);
      }
      function Bd(l) {
        return Zg(l, vn, Nm);
      }
      var Ud = ru ? function(l) {
        return ru.get(l);
      } : sf;
      function mu(l) {
        for (var c = l.name + "", p = Sa[c], M = Jt.call(Sa, c) ? p.length : 0; M--; ) {
          var k = p[M], O = k.func;
          if (O == null || O == l)
            return k.name;
        }
        return c;
      }
      function Aa(l) {
        var c = Jt.call(z, "placeholder") ? z : l;
        return c.placeholder;
      }
      function pt() {
        var l = z.iteratee || af;
        return l = l === af ? Jg : l, arguments.length ? l(arguments[0], arguments[1]) : l;
      }
      function vu(l, c) {
        var p = l.__data__;
        return KT(c) ? p[typeof c == "string" ? "string" : "hash"] : p.map;
      }
      function Hd(l) {
        for (var c = Ur(l), p = c.length; p--; ) {
          var M = c[p], k = l[M];
          c[p] = [M, k, Om(k)];
        }
        return c;
      }
      function Wo(l, c) {
        var p = eS(l, c);
        return Xg(p) ? p : r;
      }
      function WT(l) {
        var c = Jt.call(l, jo), p = l[jo];
        try {
          l[jo] = r;
          var M = !0;
        } catch {
        }
        var k = qs.call(l);
        return M && (c ? l[jo] = p : delete l[jo]), k;
      }
      var Wd = vd ? function(l) {
        return l == null ? [] : (l = or(l), uo(vd(l), function(c) {
          return Pg.call(l, c);
        }));
      } : uf, Nm = vd ? function(l) {
        for (var c = []; l; )
          co(c, Wd(l)), l = Ks(l);
        return c;
      } : uf, rn = ln;
      (bd && rn(new bd(new ArrayBuffer(1))) != Ct || yl && rn(new yl()) != Ie || yd && rn(yd.resolve()) != H || Ca && rn(new Ca()) != ae || xl && rn(new xl()) != Le) && (rn = function(l) {
        var c = ln(l), p = c == P ? l.constructor : r, M = p ? Vo(p) : "";
        if (M)
          switch (M) {
            case kS:
              return Ct;
            case DS:
              return Ie;
            case AS:
              return H;
            case ES:
              return ae;
            case IS:
              return Le;
          }
        return c;
      });
      function VT(l, c, p) {
        for (var M = -1, k = p.length; ++M < k; ) {
          var O = p[M], F = O.size;
          switch (O.type) {
            case "drop":
              l += F;
              break;
            case "dropRight":
              c -= F;
              break;
            case "take":
              c = tn(c, l + F);
              break;
            case "takeRight":
              l = Rr(l, c - F);
              break;
          }
        }
        return { start: l, end: c };
      }
      function YT(l) {
        var c = l.match(gr);
        return c ? c[1].split(Or) : [];
      }
      function zm(l, c, p) {
        c = mo(c, l);
        for (var M = -1, k = c.length, O = !1; ++M < k; ) {
          var F = ki(c[M]);
          if (!(O = l != null && p(l, F)))
            break;
          l = l[F];
        }
        return O || ++M != k ? O : (k = l == null ? 0 : l.length, !!k && Su(k) && Hi(F, k) && (Et(l) || Yo(l)));
      }
      function QT(l) {
        var c = l.length, p = new l.constructor(c);
        return c && typeof l[0] == "string" && Jt.call(l, "index") && (p.index = l.index, p.input = l.input), p;
      }
      function $m(l) {
        return typeof l.constructor == "function" && !El(l) ? Ta(Ks(l)) : {};
      }
      function qT(l, c, p) {
        var M = l.constructor;
        switch (c) {
          case Mt:
            return Pd(l);
          case et:
          case Ge:
            return new M(+l);
          case Ct:
            return NT(l, p);
          case er:
          case Vt:
          case jt:
          case at:
          case St:
          case ve:
          case We:
          case ne:
          case Se:
            return gm(l, p);
          case Ie:
            return new M();
          case rt:
          case Me:
            return new M(l);
          case pe:
            return zT(l);
          case ae:
            return new M();
          case fe:
            return $T(l);
        }
      }
      function GT(l, c) {
        var p = c.length;
        if (!p)
          return l;
        var M = p - 1;
        return c[M] = (p > 1 ? "& " : "") + c[M], c = c.join(p > 2 ? ", " : " "), l.replace(lr, `{
/* [wrapped with ` + c + `] */
`);
      }
      function ZT(l) {
        return Et(l) || Yo(l) || !!(Rg && l && l[Rg]);
      }
      function Hi(l, c) {
        var p = typeof l;
        return c = c ?? ue, !!c && (p == "number" || p != "symbol" && ct.test(l)) && l > -1 && l % 1 == 0 && l < c;
      }
      function sn(l, c, p) {
        if (!yr(p))
          return !1;
        var M = typeof c;
        return (M == "number" ? mn(p) && Hi(c, p.length) : M == "string" && c in p) ? oi(p[c], l) : !1;
      }
      function Vd(l, c) {
        if (Et(l))
          return !1;
        var p = typeof l;
        return p == "number" || p == "symbol" || p == "boolean" || l == null || Nn(l) ? !0 : At.test(l) || !Xe.test(l) || c != null && l in or(c);
      }
      function KT(l) {
        var c = typeof l;
        return c == "string" || c == "number" || c == "symbol" || c == "boolean" ? l !== "__proto__" : l === null;
      }
      function Yd(l) {
        var c = mu(l), p = z[c];
        if (typeof p != "function" || !(c in Rt.prototype))
          return !1;
        if (l === p)
          return !0;
        var M = Ud(p);
        return !!M && l === M[0];
      }
      function XT(l) {
        return !!Og && Og in l;
      }
      var JT = Ys ? Wi : cf;
      function El(l) {
        var c = l && l.constructor, p = typeof c == "function" && c.prototype || Ma;
        return l === p;
      }
      function Om(l) {
        return l === l && !yr(l);
      }
      function _m(l, c) {
        return function(p) {
          return p == null ? !1 : p[l] === c && (c !== r || l in or(p));
        };
      }
      function ek(l) {
        var c = Mu(l, function(M) {
          return p.size === d && p.clear(), M;
        }), p = c.cache;
        return c;
      }
      function tk(l, c) {
        var p = l[1], M = c[1], k = p | M, O = k < (x | y | E), F = M == E && p == S || M == E && p == N && l[7].length <= c[8] || M == (E | N) && c[7].length <= c[8] && p == S;
        if (!(O || F))
          return l;
        M & x && (l[2] = c[2], k |= p & x ? 0 : C);
        var V = c[3];
        if (V) {
          var ee = l[3];
          l[3] = ee ? vm(ee, V, c[4]) : V, l[4] = ee ? fo(l[3], f) : c[4];
        }
        return V = c[5], V && (ee = l[5], l[5] = ee ? bm(ee, V, c[6]) : V, l[6] = ee ? fo(l[5], f) : c[6]), V = c[7], V && (l[7] = V), M & E && (l[8] = l[8] == null ? c[8] : tn(l[8], c[8])), l[9] == null && (l[9] = c[9]), l[0] = c[0], l[1] = k, l;
      }
      function rk(l) {
        var c = [];
        if (l != null)
          for (var p in or(l))
            c.push(p);
        return c;
      }
      function nk(l) {
        return qs.call(l);
      }
      function Lm(l, c, p) {
        return c = Rr(c === r ? l.length - 1 : c, 0), function() {
          for (var M = arguments, k = -1, O = Rr(M.length - c, 0), F = le(O); ++k < O; )
            F[k] = M[c + k];
          k = -1;
          for (var V = le(c + 1); ++k < c; )
            V[k] = M[k];
          return V[c] = p(F), An(l, this, V);
        };
      }
      function Pm(l, c) {
        return c.length < 2 ? l : Ho(l, Yn(c, 0, -1));
      }
      function ik(l, c) {
        for (var p = l.length, M = tn(c.length, p), k = gn(l); M--; ) {
          var O = c[M];
          l[M] = Hi(O, p) ? k[O] : r;
        }
        return l;
      }
      function Qd(l, c) {
        if (!(c === "constructor" && typeof l[c] == "function") && c != "__proto__")
          return l[c];
      }
      var Rm = Fm(lm), Il = yS || function(l, c) {
        return Vr.setTimeout(l, c);
      }, qd = Fm(DT);
      function jm(l, c, p) {
        var M = c + "";
        return qd(l, GT(M, ok(YT(M), p)));
      }
      function Fm(l) {
        var c = 0, p = 0;
        return function() {
          var M = CS(), k = U - (M - p);
          if (p = M, k > 0) {
            if (++c >= R)
              return arguments[0];
          } else
            c = 0;
          return l.apply(r, arguments);
        };
      }
      function bu(l, c) {
        var p = -1, M = l.length, k = M - 1;
        for (c = c === r ? M : c; ++p < c; ) {
          var O = Id(p, k), F = l[O];
          l[O] = l[p], l[p] = F;
        }
        return l.length = c, l;
      }
      var Bm = ek(function(l) {
        var c = [];
        return l.charCodeAt(0) === 46 && c.push(""), l.replace(Ht, function(p, M, k, O) {
          c.push(k ? O.replace(wi, "$1") : M || p);
        }), c;
      });
      function ki(l) {
        if (typeof l == "string" || Nn(l))
          return l;
        var c = l + "";
        return c == "0" && 1 / l == -re ? "-0" : c;
      }
      function Vo(l) {
        if (l != null) {
          try {
            return Qs.call(l);
          } catch {
          }
          try {
            return l + "";
          } catch {
          }
        }
        return "";
      }
      function ok(l, c) {
        return Un(Qe, function(p) {
          var M = "_." + p[0];
          c & p[1] && !Us(l, M) && l.push(M);
        }), l.sort();
      }
      function Um(l) {
        if (l instanceof Rt)
          return l.clone();
        var c = new Wn(l.__wrapped__, l.__chain__);
        return c.__actions__ = gn(l.__actions__), c.__index__ = l.__index__, c.__values__ = l.__values__, c;
      }
      function ak(l, c, p) {
        (p ? sn(l, c, p) : c === r) ? c = 1 : c = Rr(It(c), 0);
        var M = l == null ? 0 : l.length;
        if (!M || c < 1)
          return [];
        for (var k = 0, O = 0, F = le(eu(M / c)); k < M; )
          F[O++] = Yn(l, k, k += c);
        return F;
      }
      function lk(l) {
        for (var c = -1, p = l == null ? 0 : l.length, M = 0, k = []; ++c < p; ) {
          var O = l[c];
          O && (k[M++] = O);
        }
        return k;
      }
      function sk() {
        var l = arguments.length;
        if (!l)
          return [];
        for (var c = le(l - 1), p = arguments[0], M = l; M--; )
          c[M - 1] = arguments[M];
        return co(Et(p) ? gn(p) : [p], Yr(c, 1));
      }
      var uk = _t(function(l, c) {
        return Ir(l) ? Sl(l, Yr(c, 1, Ir, !0)) : [];
      }), ck = _t(function(l, c) {
        var p = Qn(c);
        return Ir(p) && (p = r), Ir(l) ? Sl(l, Yr(c, 1, Ir, !0), pt(p, 2)) : [];
      }), dk = _t(function(l, c) {
        var p = Qn(c);
        return Ir(p) && (p = r), Ir(l) ? Sl(l, Yr(c, 1, Ir, !0), r, p) : [];
      });
      function fk(l, c, p) {
        var M = l == null ? 0 : l.length;
        return M ? (c = p || c === r ? 1 : It(c), Yn(l, c < 0 ? 0 : c, M)) : [];
      }
      function hk(l, c, p) {
        var M = l == null ? 0 : l.length;
        return M ? (c = p || c === r ? 1 : It(c), c = M - c, Yn(l, 0, c < 0 ? 0 : c)) : [];
      }
      function pk(l, c) {
        return l && l.length ? cu(l, pt(c, 3), !0, !0) : [];
      }
      function gk(l, c) {
        return l && l.length ? cu(l, pt(c, 3), !0) : [];
      }
      function mk(l, c, p, M) {
        var k = l == null ? 0 : l.length;
        return k ? (p && typeof p != "number" && sn(l, c, p) && (p = 0, M = k), sT(l, c, p, M)) : [];
      }
      function Hm(l, c, p) {
        var M = l == null ? 0 : l.length;
        if (!M)
          return -1;
        var k = p == null ? 0 : It(p);
        return k < 0 && (k = Rr(M + k, 0)), Hs(l, pt(c, 3), k);
      }
      function Wm(l, c, p) {
        var M = l == null ? 0 : l.length;
        if (!M)
          return -1;
        var k = M - 1;
        return p !== r && (k = It(p), k = p < 0 ? Rr(M + k, 0) : tn(k, M - 1)), Hs(l, pt(c, 3), k, !0);
      }
      function Vm(l) {
        var c = l == null ? 0 : l.length;
        return c ? Yr(l, 1) : [];
      }
      function vk(l) {
        var c = l == null ? 0 : l.length;
        return c ? Yr(l, re) : [];
      }
      function bk(l, c) {
        var p = l == null ? 0 : l.length;
        return p ? (c = c === r ? 1 : It(c), Yr(l, c)) : [];
      }
      function yk(l) {
        for (var c = -1, p = l == null ? 0 : l.length, M = {}; ++c < p; ) {
          var k = l[c];
          M[k[0]] = k[1];
        }
        return M;
      }
      function Ym(l) {
        return l && l.length ? l[0] : r;
      }
      function xk(l, c, p) {
        var M = l == null ? 0 : l.length;
        if (!M)
          return -1;
        var k = p == null ? 0 : It(p);
        return k < 0 && (k = Rr(M + k, 0)), ba(l, c, k);
      }
      function wk(l) {
        var c = l == null ? 0 : l.length;
        return c ? Yn(l, 0, -1) : [];
      }
      var Mk = _t(function(l) {
        var c = mr(l, _d);
        return c.length && c[0] === l[0] ? Td(c) : [];
      }), Ck = _t(function(l) {
        var c = Qn(l), p = mr(l, _d);
        return c === Qn(p) ? c = r : p.pop(), p.length && p[0] === l[0] ? Td(p, pt(c, 2)) : [];
      }), Sk = _t(function(l) {
        var c = Qn(l), p = mr(l, _d);
        return c = typeof c == "function" ? c : r, c && p.pop(), p.length && p[0] === l[0] ? Td(p, r, c) : [];
      });
      function Tk(l, c) {
        return l == null ? "" : wS.call(l, c);
      }
      function Qn(l) {
        var c = l == null ? 0 : l.length;
        return c ? l[c - 1] : r;
      }
      function kk(l, c, p) {
        var M = l == null ? 0 : l.length;
        if (!M)
          return -1;
        var k = M;
        return p !== r && (k = It(p), k = k < 0 ? Rr(M + k, 0) : tn(k, M - 1)), c === c ? oS(l, c, k) : Hs(l, kg, k, !0);
      }
      function Dk(l, c) {
        return l && l.length ? nm(l, It(c)) : r;
      }
      var Ak = _t(Qm);
      function Qm(l, c) {
        return l && l.length && c && c.length ? Ed(l, c) : l;
      }
      function Ek(l, c, p) {
        return l && l.length && c && c.length ? Ed(l, c, pt(p, 2)) : l;
      }
      function Ik(l, c, p) {
        return l && l.length && c && c.length ? Ed(l, c, r, p) : l;
      }
      var Nk = Ui(function(l, c) {
        var p = l == null ? 0 : l.length, M = wd(l, c);
        return am(l, mr(c, function(k) {
          return Hi(k, p) ? +k : k;
        }).sort(mm)), M;
      });
      function zk(l, c) {
        var p = [];
        if (!(l && l.length))
          return p;
        var M = -1, k = [], O = l.length;
        for (c = pt(c, 3); ++M < O; ) {
          var F = l[M];
          c(F, M, l) && (p.push(F), k.push(M));
        }
        return am(l, k), p;
      }
      function Gd(l) {
        return l == null ? l : TS.call(l);
      }
      function $k(l, c, p) {
        var M = l == null ? 0 : l.length;
        return M ? (p && typeof p != "number" && sn(l, c, p) ? (c = 0, p = M) : (c = c == null ? 0 : It(c), p = p === r ? M : It(p)), Yn(l, c, p)) : [];
      }
      function Ok(l, c) {
        return uu(l, c);
      }
      function _k(l, c, p) {
        return zd(l, c, pt(p, 2));
      }
      function Lk(l, c) {
        var p = l == null ? 0 : l.length;
        if (p) {
          var M = uu(l, c);
          if (M < p && oi(l[M], c))
            return M;
        }
        return -1;
      }
      function Pk(l, c) {
        return uu(l, c, !0);
      }
      function Rk(l, c, p) {
        return zd(l, c, pt(p, 2), !0);
      }
      function jk(l, c) {
        var p = l == null ? 0 : l.length;
        if (p) {
          var M = uu(l, c, !0) - 1;
          if (oi(l[M], c))
            return M;
        }
        return -1;
      }
      function Fk(l) {
        return l && l.length ? sm(l) : [];
      }
      function Bk(l, c) {
        return l && l.length ? sm(l, pt(c, 2)) : [];
      }
      function Uk(l) {
        var c = l == null ? 0 : l.length;
        return c ? Yn(l, 1, c) : [];
      }
      function Hk(l, c, p) {
        return l && l.length ? (c = p || c === r ? 1 : It(c), Yn(l, 0, c < 0 ? 0 : c)) : [];
      }
      function Wk(l, c, p) {
        var M = l == null ? 0 : l.length;
        return M ? (c = p || c === r ? 1 : It(c), c = M - c, Yn(l, c < 0 ? 0 : c, M)) : [];
      }
      function Vk(l, c) {
        return l && l.length ? cu(l, pt(c, 3), !1, !0) : [];
      }
      function Yk(l, c) {
        return l && l.length ? cu(l, pt(c, 3)) : [];
      }
      var Qk = _t(function(l) {
        return go(Yr(l, 1, Ir, !0));
      }), qk = _t(function(l) {
        var c = Qn(l);
        return Ir(c) && (c = r), go(Yr(l, 1, Ir, !0), pt(c, 2));
      }), Gk = _t(function(l) {
        var c = Qn(l);
        return c = typeof c == "function" ? c : r, go(Yr(l, 1, Ir, !0), r, c);
      });
      function Zk(l) {
        return l && l.length ? go(l) : [];
      }
      function Kk(l, c) {
        return l && l.length ? go(l, pt(c, 2)) : [];
      }
      function Xk(l, c) {
        return c = typeof c == "function" ? c : r, l && l.length ? go(l, r, c) : [];
      }
      function Zd(l) {
        if (!(l && l.length))
          return [];
        var c = 0;
        return l = uo(l, function(p) {
          if (Ir(p))
            return c = Rr(p.length, c), !0;
        }), hd(c, function(p) {
          return mr(l, cd(p));
        });
      }
      function qm(l, c) {
        if (!(l && l.length))
          return [];
        var p = Zd(l);
        return c == null ? p : mr(p, function(M) {
          return An(c, r, M);
        });
      }
      var Jk = _t(function(l, c) {
        return Ir(l) ? Sl(l, c) : [];
      }), eD = _t(function(l) {
        return Od(uo(l, Ir));
      }), tD = _t(function(l) {
        var c = Qn(l);
        return Ir(c) && (c = r), Od(uo(l, Ir), pt(c, 2));
      }), rD = _t(function(l) {
        var c = Qn(l);
        return c = typeof c == "function" ? c : r, Od(uo(l, Ir), r, c);
      }), nD = _t(Zd);
      function iD(l, c) {
        return fm(l || [], c || [], Cl);
      }
      function oD(l, c) {
        return fm(l || [], c || [], Dl);
      }
      var aD = _t(function(l) {
        var c = l.length, p = c > 1 ? l[c - 1] : r;
        return p = typeof p == "function" ? (l.pop(), p) : r, qm(l, p);
      });
      function Gm(l) {
        var c = z(l);
        return c.__chain__ = !0, c;
      }
      function lD(l, c) {
        return c(l), l;
      }
      function yu(l, c) {
        return c(l);
      }
      var sD = Ui(function(l) {
        var c = l.length, p = c ? l[0] : 0, M = this.__wrapped__, k = function(O) {
          return wd(O, l);
        };
        return c > 1 || this.__actions__.length || !(M instanceof Rt) || !Hi(p) ? this.thru(k) : (M = M.slice(p, +p + (c ? 1 : 0)), M.__actions__.push({
          func: yu,
          args: [k],
          thisArg: r
        }), new Wn(M, this.__chain__).thru(function(O) {
          return c && !O.length && O.push(r), O;
        }));
      });
      function uD() {
        return Gm(this);
      }
      function cD() {
        return new Wn(this.value(), this.__chain__);
      }
      function dD() {
        this.__values__ === r && (this.__values__ = uv(this.value()));
        var l = this.__index__ >= this.__values__.length, c = l ? r : this.__values__[this.__index__++];
        return { done: l, value: c };
      }
      function fD() {
        return this;
      }
      function hD(l) {
        for (var c, p = this; p instanceof iu; ) {
          var M = Um(p);
          M.__index__ = 0, M.__values__ = r, c ? k.__wrapped__ = M : c = M;
          var k = M;
          p = p.__wrapped__;
        }
        return k.__wrapped__ = l, c;
      }
      function pD() {
        var l = this.__wrapped__;
        if (l instanceof Rt) {
          var c = l;
          return this.__actions__.length && (c = new Rt(this)), c = c.reverse(), c.__actions__.push({
            func: yu,
            args: [Gd],
            thisArg: r
          }), new Wn(c, this.__chain__);
        }
        return this.thru(Gd);
      }
      function gD() {
        return dm(this.__wrapped__, this.__actions__);
      }
      var mD = du(function(l, c, p) {
        Jt.call(l, p) ? ++l[p] : Fi(l, p, 1);
      });
      function vD(l, c, p) {
        var M = Et(l) ? Sg : lT;
        return p && sn(l, c, p) && (c = r), M(l, pt(c, 3));
      }
      function bD(l, c) {
        var p = Et(l) ? uo : qg;
        return p(l, pt(c, 3));
      }
      var yD = Mm(Hm), xD = Mm(Wm);
      function wD(l, c) {
        return Yr(xu(l, c), 1);
      }
      function MD(l, c) {
        return Yr(xu(l, c), re);
      }
      function CD(l, c, p) {
        return p = p === r ? 1 : It(p), Yr(xu(l, c), p);
      }
      function Zm(l, c) {
        var p = Et(l) ? Un : po;
        return p(l, pt(c, 3));
      }
      function Km(l, c) {
        var p = Et(l) ? UC : Qg;
        return p(l, pt(c, 3));
      }
      var SD = du(function(l, c, p) {
        Jt.call(l, p) ? l[p].push(c) : Fi(l, p, [c]);
      });
      function TD(l, c, p, M) {
        l = mn(l) ? l : Ia(l), p = p && !M ? It(p) : 0;
        var k = l.length;
        return p < 0 && (p = Rr(k + p, 0)), Tu(l) ? p <= k && l.indexOf(c, p) > -1 : !!k && ba(l, c, p) > -1;
      }
      var kD = _t(function(l, c, p) {
        var M = -1, k = typeof c == "function", O = mn(l) ? le(l.length) : [];
        return po(l, function(F) {
          O[++M] = k ? An(c, F, p) : Tl(F, c, p);
        }), O;
      }), DD = du(function(l, c, p) {
        Fi(l, p, c);
      });
      function xu(l, c) {
        var p = Et(l) ? mr : em;
        return p(l, pt(c, 3));
      }
      function AD(l, c, p, M) {
        return l == null ? [] : (Et(c) || (c = c == null ? [] : [c]), p = M ? r : p, Et(p) || (p = p == null ? [] : [p]), im(l, c, p));
      }
      var ED = du(function(l, c, p) {
        l[p ? 0 : 1].push(c);
      }, function() {
        return [[], []];
      });
      function ID(l, c, p) {
        var M = Et(l) ? sd : Ag, k = arguments.length < 3;
        return M(l, pt(c, 4), p, k, po);
      }
      function ND(l, c, p) {
        var M = Et(l) ? HC : Ag, k = arguments.length < 3;
        return M(l, pt(c, 4), p, k, Qg);
      }
      function zD(l, c) {
        var p = Et(l) ? uo : qg;
        return p(l, Cu(pt(c, 3)));
      }
      function $D(l) {
        var c = Et(l) ? Hg : TT;
        return c(l);
      }
      function OD(l, c, p) {
        (p ? sn(l, c, p) : c === r) ? c = 1 : c = It(c);
        var M = Et(l) ? rT : kT;
        return M(l, c);
      }
      function _D(l) {
        var c = Et(l) ? nT : AT;
        return c(l);
      }
      function LD(l) {
        if (l == null)
          return 0;
        if (mn(l))
          return Tu(l) ? xa(l) : l.length;
        var c = rn(l);
        return c == Ie || c == ae ? l.size : Dd(l).length;
      }
      function PD(l, c, p) {
        var M = Et(l) ? ud : ET;
        return p && sn(l, c, p) && (c = r), M(l, pt(c, 3));
      }
      var RD = _t(function(l, c) {
        if (l == null)
          return [];
        var p = c.length;
        return p > 1 && sn(l, c[0], c[1]) ? c = [] : p > 2 && sn(c[0], c[1], c[2]) && (c = [c[0]]), im(l, Yr(c, 1), []);
      }), wu = bS || function() {
        return Vr.Date.now();
      };
      function jD(l, c) {
        if (typeof c != "function")
          throw new Hn(a);
        return l = It(l), function() {
          if (--l < 1)
            return c.apply(this, arguments);
        };
      }
      function Xm(l, c, p) {
        return c = p ? r : c, c = l && c == null ? l.length : c, Bi(l, E, r, r, r, r, c);
      }
      function Jm(l, c) {
        var p;
        if (typeof c != "function")
          throw new Hn(a);
        return l = It(l), function() {
          return --l > 0 && (p = c.apply(this, arguments)), l <= 1 && (c = r), p;
        };
      }
      var Kd = _t(function(l, c, p) {
        var M = x;
        if (p.length) {
          var k = fo(p, Aa(Kd));
          M |= A;
        }
        return Bi(l, M, c, p, k);
      }), ev = _t(function(l, c, p) {
        var M = x | y;
        if (p.length) {
          var k = fo(p, Aa(ev));
          M |= A;
        }
        return Bi(c, M, l, p, k);
      });
      function tv(l, c, p) {
        c = p ? r : c;
        var M = Bi(l, S, r, r, r, r, r, c);
        return M.placeholder = tv.placeholder, M;
      }
      function rv(l, c, p) {
        c = p ? r : c;
        var M = Bi(l, T, r, r, r, r, r, c);
        return M.placeholder = rv.placeholder, M;
      }
      function nv(l, c, p) {
        var M, k, O, F, V, ee, me = 0, be = !1, Ce = !1, He = !0;
        if (typeof l != "function")
          throw new Hn(a);
        c = qn(c) || 0, yr(p) && (be = !!p.leading, Ce = "maxWait" in p, O = Ce ? Rr(qn(p.maxWait) || 0, c) : O, He = "trailing" in p ? !!p.trailing : He);
        function it(Nr) {
          var ai = M, Yi = k;
          return M = k = r, me = Nr, F = l.apply(Yi, ai), F;
        }
        function gt(Nr) {
          return me = Nr, V = Il(Pt, c), be ? it(Nr) : F;
        }
        function $t(Nr) {
          var ai = Nr - ee, Yi = Nr - me, Mv = c - ai;
          return Ce ? tn(Mv, O - Yi) : Mv;
        }
        function mt(Nr) {
          var ai = Nr - ee, Yi = Nr - me;
          return ee === r || ai >= c || ai < 0 || Ce && Yi >= O;
        }
        function Pt() {
          var Nr = wu();
          if (mt(Nr))
            return Ft(Nr);
          V = Il(Pt, $t(Nr));
        }
        function Ft(Nr) {
          return V = r, He && M ? it(Nr) : (M = k = r, F);
        }
        function zn() {
          V !== r && hm(V), me = 0, M = ee = k = V = r;
        }
        function un() {
          return V === r ? F : Ft(wu());
        }
        function $n() {
          var Nr = wu(), ai = mt(Nr);
          if (M = arguments, k = this, ee = Nr, ai) {
            if (V === r)
              return gt(ee);
            if (Ce)
              return hm(V), V = Il(Pt, c), it(ee);
          }
          return V === r && (V = Il(Pt, c)), F;
        }
        return $n.cancel = zn, $n.flush = un, $n;
      }
      var FD = _t(function(l, c) {
        return Yg(l, 1, c);
      }), BD = _t(function(l, c, p) {
        return Yg(l, qn(c) || 0, p);
      });
      function UD(l) {
        return Bi(l, I);
      }
      function Mu(l, c) {
        if (typeof l != "function" || c != null && typeof c != "function")
          throw new Hn(a);
        var p = function() {
          var M = arguments, k = c ? c.apply(this, M) : M[0], O = p.cache;
          if (O.has(k))
            return O.get(k);
          var F = l.apply(this, M);
          return p.cache = O.set(k, F) || O, F;
        };
        return p.cache = new (Mu.Cache || ji)(), p;
      }
      Mu.Cache = ji;
      function Cu(l) {
        if (typeof l != "function")
          throw new Hn(a);
        return function() {
          var c = arguments;
          switch (c.length) {
            case 0:
              return !l.call(this);
            case 1:
              return !l.call(this, c[0]);
            case 2:
              return !l.call(this, c[0], c[1]);
            case 3:
              return !l.call(this, c[0], c[1], c[2]);
          }
          return !l.apply(this, c);
        };
      }
      function HD(l) {
        return Jm(2, l);
      }
      var WD = IT(function(l, c) {
        c = c.length == 1 && Et(c[0]) ? mr(c[0], En(pt())) : mr(Yr(c, 1), En(pt()));
        var p = c.length;
        return _t(function(M) {
          for (var k = -1, O = tn(M.length, p); ++k < O; )
            M[k] = c[k].call(this, M[k]);
          return An(l, this, M);
        });
      }), Xd = _t(function(l, c) {
        var p = fo(c, Aa(Xd));
        return Bi(l, A, r, c, p);
      }), iv = _t(function(l, c) {
        var p = fo(c, Aa(iv));
        return Bi(l, D, r, c, p);
      }), VD = Ui(function(l, c) {
        return Bi(l, N, r, r, r, c);
      });
      function YD(l, c) {
        if (typeof l != "function")
          throw new Hn(a);
        return c = c === r ? c : It(c), _t(l, c);
      }
      function QD(l, c) {
        if (typeof l != "function")
          throw new Hn(a);
        return c = c == null ? 0 : Rr(It(c), 0), _t(function(p) {
          var M = p[c], k = vo(p, 0, c);
          return M && co(k, M), An(l, this, k);
        });
      }
      function qD(l, c, p) {
        var M = !0, k = !0;
        if (typeof l != "function")
          throw new Hn(a);
        return yr(p) && (M = "leading" in p ? !!p.leading : M, k = "trailing" in p ? !!p.trailing : k), nv(l, c, {
          leading: M,
          maxWait: c,
          trailing: k
        });
      }
      function GD(l) {
        return Xm(l, 1);
      }
      function ZD(l, c) {
        return Xd(Ld(c), l);
      }
      function KD() {
        if (!arguments.length)
          return [];
        var l = arguments[0];
        return Et(l) ? l : [l];
      }
      function XD(l) {
        return Vn(l, m);
      }
      function JD(l, c) {
        return c = typeof c == "function" ? c : r, Vn(l, m, c);
      }
      function eA(l) {
        return Vn(l, h | m);
      }
      function tA(l, c) {
        return c = typeof c == "function" ? c : r, Vn(l, h | m, c);
      }
      function rA(l, c) {
        return c == null || Vg(l, c, Ur(c));
      }
      function oi(l, c) {
        return l === c || l !== l && c !== c;
      }
      var nA = gu(Sd), iA = gu(function(l, c) {
        return l >= c;
      }), Yo = Kg(function() {
        return arguments;
      }()) ? Kg : function(l) {
        return Dr(l) && Jt.call(l, "callee") && !Pg.call(l, "callee");
      }, Et = le.isArray, oA = bg ? En(bg) : hT;
      function mn(l) {
        return l != null && Su(l.length) && !Wi(l);
      }
      function Ir(l) {
        return Dr(l) && mn(l);
      }
      function aA(l) {
        return l === !0 || l === !1 || Dr(l) && ln(l) == et;
      }
      var bo = xS || cf, lA = yg ? En(yg) : pT;
      function sA(l) {
        return Dr(l) && l.nodeType === 1 && !Nl(l);
      }
      function uA(l) {
        if (l == null)
          return !0;
        if (mn(l) && (Et(l) || typeof l == "string" || typeof l.splice == "function" || bo(l) || Ea(l) || Yo(l)))
          return !l.length;
        var c = rn(l);
        if (c == Ie || c == ae)
          return !l.size;
        if (El(l))
          return !Dd(l).length;
        for (var p in l)
          if (Jt.call(l, p))
            return !1;
        return !0;
      }
      function cA(l, c) {
        return kl(l, c);
      }
      function dA(l, c, p) {
        p = typeof p == "function" ? p : r;
        var M = p ? p(l, c) : r;
        return M === r ? kl(l, c, r, p) : !!M;
      }
      function Jd(l) {
        if (!Dr(l))
          return !1;
        var c = ln(l);
        return c == qe || c == Ee || typeof l.message == "string" && typeof l.name == "string" && !Nl(l);
      }
      function fA(l) {
        return typeof l == "number" && jg(l);
      }
      function Wi(l) {
        if (!yr(l))
          return !1;
        var c = ln(l);
        return c == Ue || c == ot || c == $e || c == se;
      }
      function ov(l) {
        return typeof l == "number" && l == It(l);
      }
      function Su(l) {
        return typeof l == "number" && l > -1 && l % 1 == 0 && l <= ue;
      }
      function yr(l) {
        var c = typeof l;
        return l != null && (c == "object" || c == "function");
      }
      function Dr(l) {
        return l != null && typeof l == "object";
      }
      var av = xg ? En(xg) : mT;
      function hA(l, c) {
        return l === c || kd(l, c, Hd(c));
      }
      function pA(l, c, p) {
        return p = typeof p == "function" ? p : r, kd(l, c, Hd(c), p);
      }
      function gA(l) {
        return lv(l) && l != +l;
      }
      function mA(l) {
        if (JT(l))
          throw new kt(o);
        return Xg(l);
      }
      function vA(l) {
        return l === null;
      }
      function bA(l) {
        return l == null;
      }
      function lv(l) {
        return typeof l == "number" || Dr(l) && ln(l) == rt;
      }
      function Nl(l) {
        if (!Dr(l) || ln(l) != P)
          return !1;
        var c = Ks(l);
        if (c === null)
          return !0;
        var p = Jt.call(c, "constructor") && c.constructor;
        return typeof p == "function" && p instanceof p && Qs.call(p) == pS;
      }
      var ef = wg ? En(wg) : vT;
      function yA(l) {
        return ov(l) && l >= -ue && l <= ue;
      }
      var sv = Mg ? En(Mg) : bT;
      function Tu(l) {
        return typeof l == "string" || !Et(l) && Dr(l) && ln(l) == Me;
      }
      function Nn(l) {
        return typeof l == "symbol" || Dr(l) && ln(l) == fe;
      }
      var Ea = Cg ? En(Cg) : yT;
      function xA(l) {
        return l === r;
      }
      function wA(l) {
        return Dr(l) && rn(l) == Le;
      }
      function MA(l) {
        return Dr(l) && ln(l) == dt;
      }
      var CA = gu(Ad), SA = gu(function(l, c) {
        return l <= c;
      });
      function uv(l) {
        if (!l)
          return [];
        if (mn(l))
          return Tu(l) ? ni(l) : gn(l);
        if (bl && l[bl])
          return rS(l[bl]());
        var c = rn(l), p = c == Ie ? gd : c == ae ? Ws : Ia;
        return p(l);
      }
      function Vi(l) {
        if (!l)
          return l === 0 ? l : 0;
        if (l = qn(l), l === re || l === -re) {
          var c = l < 0 ? -1 : 1;
          return c * he;
        }
        return l === l ? l : 0;
      }
      function It(l) {
        var c = Vi(l), p = c % 1;
        return c === c ? p ? c - p : c : 0;
      }
      function cv(l) {
        return l ? Uo(It(l), 0, de) : 0;
      }
      function qn(l) {
        if (typeof l == "number")
          return l;
        if (Nn(l))
          return te;
        if (yr(l)) {
          var c = typeof l.valueOf == "function" ? l.valueOf() : l;
          l = yr(c) ? c + "" : c;
        }
        if (typeof l != "string")
          return l === 0 ? l : +l;
        l = Eg(l);
        var p = wt.test(l);
        return p || Wr.test(l) ? jC(l.slice(2), p ? 2 : 8) : ze.test(l) ? te : +l;
      }
      function dv(l) {
        return Ti(l, vn(l));
      }
      function TA(l) {
        return l ? Uo(It(l), -ue, ue) : l === 0 ? l : 0;
      }
      function Zt(l) {
        return l == null ? "" : In(l);
      }
      var kA = ka(function(l, c) {
        if (El(c) || mn(c)) {
          Ti(c, Ur(c), l);
          return;
        }
        for (var p in c)
          Jt.call(c, p) && Cl(l, p, c[p]);
      }), fv = ka(function(l, c) {
        Ti(c, vn(c), l);
      }), ku = ka(function(l, c, p, M) {
        Ti(c, vn(c), l, M);
      }), DA = ka(function(l, c, p, M) {
        Ti(c, Ur(c), l, M);
      }), AA = Ui(wd);
      function EA(l, c) {
        var p = Ta(l);
        return c == null ? p : Wg(p, c);
      }
      var IA = _t(function(l, c) {
        l = or(l);
        var p = -1, M = c.length, k = M > 2 ? c[2] : r;
        for (k && sn(c[0], c[1], k) && (M = 1); ++p < M; )
          for (var O = c[p], F = vn(O), V = -1, ee = F.length; ++V < ee; ) {
            var me = F[V], be = l[me];
            (be === r || oi(be, Ma[me]) && !Jt.call(l, me)) && (l[me] = O[me]);
          }
        return l;
      }), NA = _t(function(l) {
        return l.push(r, Em), An(hv, r, l);
      });
      function zA(l, c) {
        return Tg(l, pt(c, 3), Si);
      }
      function $A(l, c) {
        return Tg(l, pt(c, 3), Cd);
      }
      function OA(l, c) {
        return l == null ? l : Md(l, pt(c, 3), vn);
      }
      function _A(l, c) {
        return l == null ? l : Gg(l, pt(c, 3), vn);
      }
      function LA(l, c) {
        return l && Si(l, pt(c, 3));
      }
      function PA(l, c) {
        return l && Cd(l, pt(c, 3));
      }
      function RA(l) {
        return l == null ? [] : lu(l, Ur(l));
      }
      function jA(l) {
        return l == null ? [] : lu(l, vn(l));
      }
      function tf(l, c, p) {
        var M = l == null ? r : Ho(l, c);
        return M === r ? p : M;
      }
      function FA(l, c) {
        return l != null && zm(l, c, uT);
      }
      function rf(l, c) {
        return l != null && zm(l, c, cT);
      }
      var BA = Sm(function(l, c, p) {
        c != null && typeof c.toString != "function" && (c = qs.call(c)), l[c] = p;
      }, of(bn)), UA = Sm(function(l, c, p) {
        c != null && typeof c.toString != "function" && (c = qs.call(c)), Jt.call(l, c) ? l[c].push(p) : l[c] = [p];
      }, pt), HA = _t(Tl);
      function Ur(l) {
        return mn(l) ? Ug(l) : Dd(l);
      }
      function vn(l) {
        return mn(l) ? Ug(l, !0) : xT(l);
      }
      function WA(l, c) {
        var p = {};
        return c = pt(c, 3), Si(l, function(M, k, O) {
          Fi(p, c(M, k, O), M);
        }), p;
      }
      function VA(l, c) {
        var p = {};
        return c = pt(c, 3), Si(l, function(M, k, O) {
          Fi(p, k, c(M, k, O));
        }), p;
      }
      var YA = ka(function(l, c, p) {
        su(l, c, p);
      }), hv = ka(function(l, c, p, M) {
        su(l, c, p, M);
      }), QA = Ui(function(l, c) {
        var p = {};
        if (l == null)
          return p;
        var M = !1;
        c = mr(c, function(O) {
          return O = mo(O, l), M || (M = O.length > 1), O;
        }), Ti(l, Bd(l), p), M && (p = Vn(p, h | g | m, BT));
        for (var k = c.length; k--; )
          $d(p, c[k]);
        return p;
      });
      function qA(l, c) {
        return pv(l, Cu(pt(c)));
      }
      var GA = Ui(function(l, c) {
        return l == null ? {} : MT(l, c);
      });
      function pv(l, c) {
        if (l == null)
          return {};
        var p = mr(Bd(l), function(M) {
          return [M];
        });
        return c = pt(c), om(l, p, function(M, k) {
          return c(M, k[0]);
        });
      }
      function ZA(l, c, p) {
        c = mo(c, l);
        var M = -1, k = c.length;
        for (k || (k = 1, l = r); ++M < k; ) {
          var O = l == null ? r : l[ki(c[M])];
          O === r && (M = k, O = p), l = Wi(O) ? O.call(l) : O;
        }
        return l;
      }
      function KA(l, c, p) {
        return l == null ? l : Dl(l, c, p);
      }
      function XA(l, c, p, M) {
        return M = typeof M == "function" ? M : r, l == null ? l : Dl(l, c, p, M);
      }
      var gv = Dm(Ur), mv = Dm(vn);
      function JA(l, c, p) {
        var M = Et(l), k = M || bo(l) || Ea(l);
        if (c = pt(c, 4), p == null) {
          var O = l && l.constructor;
          k ? p = M ? new O() : [] : yr(l) ? p = Wi(O) ? Ta(Ks(l)) : {} : p = {};
        }
        return (k ? Un : Si)(l, function(F, V, ee) {
          return c(p, F, V, ee);
        }), p;
      }
      function eE(l, c) {
        return l == null ? !0 : $d(l, c);
      }
      function tE(l, c, p) {
        return l == null ? l : cm(l, c, Ld(p));
      }
      function rE(l, c, p, M) {
        return M = typeof M == "function" ? M : r, l == null ? l : cm(l, c, Ld(p), M);
      }
      function Ia(l) {
        return l == null ? [] : pd(l, Ur(l));
      }
      function nE(l) {
        return l == null ? [] : pd(l, vn(l));
      }
      function iE(l, c, p) {
        return p === r && (p = c, c = r), p !== r && (p = qn(p), p = p === p ? p : 0), c !== r && (c = qn(c), c = c === c ? c : 0), Uo(qn(l), c, p);
      }
      function oE(l, c, p) {
        return c = Vi(c), p === r ? (p = c, c = 0) : p = Vi(p), l = qn(l), dT(l, c, p);
      }
      function aE(l, c, p) {
        if (p && typeof p != "boolean" && sn(l, c, p) && (c = p = r), p === r && (typeof c == "boolean" ? (p = c, c = r) : typeof l == "boolean" && (p = l, l = r)), l === r && c === r ? (l = 0, c = 1) : (l = Vi(l), c === r ? (c = l, l = 0) : c = Vi(c)), l > c) {
          var M = l;
          l = c, c = M;
        }
        if (p || l % 1 || c % 1) {
          var k = Fg();
          return tn(l + k * (c - l + RC("1e-" + ((k + "").length - 1))), c);
        }
        return Id(l, c);
      }
      var lE = Da(function(l, c, p) {
        return c = c.toLowerCase(), l + (p ? vv(c) : c);
      });
      function vv(l) {
        return nf(Zt(l).toLowerCase());
      }
      function bv(l) {
        return l = Zt(l), l && l.replace(en, KC).replace(AC, "");
      }
      function sE(l, c, p) {
        l = Zt(l), c = In(c);
        var M = l.length;
        p = p === r ? M : Uo(It(p), 0, M);
        var k = p;
        return p -= c.length, p >= 0 && l.slice(p, k) == c;
      }
      function uE(l) {
        return l = Zt(l), l && Nt.test(l) ? l.replace(Ze, XC) : l;
      }
      function cE(l) {
        return l = Zt(l), l && ge.test(l) ? l.replace(zt, "\\$&") : l;
      }
      var dE = Da(function(l, c, p) {
        return l + (p ? "-" : "") + c.toLowerCase();
      }), fE = Da(function(l, c, p) {
        return l + (p ? " " : "") + c.toLowerCase();
      }), hE = wm("toLowerCase");
      function pE(l, c, p) {
        l = Zt(l), c = It(c);
        var M = c ? xa(l) : 0;
        if (!c || M >= c)
          return l;
        var k = (c - M) / 2;
        return pu(tu(k), p) + l + pu(eu(k), p);
      }
      function gE(l, c, p) {
        l = Zt(l), c = It(c);
        var M = c ? xa(l) : 0;
        return c && M < c ? l + pu(c - M, p) : l;
      }
      function mE(l, c, p) {
        l = Zt(l), c = It(c);
        var M = c ? xa(l) : 0;
        return c && M < c ? pu(c - M, p) + l : l;
      }
      function vE(l, c, p) {
        return p || c == null ? c = 0 : c && (c = +c), SS(Zt(l).replace(Fe, ""), c || 0);
      }
      function bE(l, c, p) {
        return (p ? sn(l, c, p) : c === r) ? c = 1 : c = It(c), Nd(Zt(l), c);
      }
      function yE() {
        var l = arguments, c = Zt(l[0]);
        return l.length < 3 ? c : c.replace(l[1], l[2]);
      }
      var xE = Da(function(l, c, p) {
        return l + (p ? "_" : "") + c.toLowerCase();
      });
      function wE(l, c, p) {
        return p && typeof p != "number" && sn(l, c, p) && (c = p = r), p = p === r ? de : p >>> 0, p ? (l = Zt(l), l && (typeof c == "string" || c != null && !ef(c)) && (c = In(c), !c && ya(l)) ? vo(ni(l), 0, p) : l.split(c, p)) : [];
      }
      var ME = Da(function(l, c, p) {
        return l + (p ? " " : "") + nf(c);
      });
      function CE(l, c, p) {
        return l = Zt(l), p = p == null ? 0 : Uo(It(p), 0, l.length), c = In(c), l.slice(p, p + c.length) == c;
      }
      function SE(l, c, p) {
        var M = z.templateSettings;
        p && sn(l, c, p) && (c = r), l = Zt(l), c = ku({}, c, M, Am);
        var k = ku({}, c.imports, M.imports, Am), O = Ur(k), F = pd(k, O), V, ee, me = 0, be = c.interpolate || Ci, Ce = "__p += '", He = md((c.escape || Ci).source + "|" + be.source + "|" + (be === xe ? Pi : Ci).source + "|" + (c.evaluate || Ci).source + "|$", "g"), it = "//# sourceURL=" + (Jt.call(c, "sourceURL") ? (c.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++$C + "]") + `
`;
        l.replace(He, function(mt, Pt, Ft, zn, un, $n) {
          return Ft || (Ft = zn), Ce += l.slice(me, $n).replace(na, JC), Pt && (V = !0, Ce += `' +
__e(` + Pt + `) +
'`), un && (ee = !0, Ce += `';
` + un + `;
__p += '`), Ft && (Ce += `' +
((__t = (` + Ft + `)) == null ? '' : __t) +
'`), me = $n + mt.length, mt;
        }), Ce += `';
`;
        var gt = Jt.call(c, "variable") && c.variable;
        if (!gt)
          Ce = `with (obj) {
` + Ce + `
}
`;
        else if (xi.test(gt))
          throw new kt(s);
        Ce = (ee ? Ce.replace(_e, "") : Ce).replace(ut, "$1").replace(ht, "$1;"), Ce = "function(" + (gt || "obj") + `) {
` + (gt ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (V ? ", __e = _.escape" : "") + (ee ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Ce + `return __p
}`;
        var $t = xv(function() {
          return qt(O, it + "return " + Ce).apply(r, F);
        });
        if ($t.source = Ce, Jd($t))
          throw $t;
        return $t;
      }
      function TE(l) {
        return Zt(l).toLowerCase();
      }
      function kE(l) {
        return Zt(l).toUpperCase();
      }
      function DE(l, c, p) {
        if (l = Zt(l), l && (p || c === r))
          return Eg(l);
        if (!l || !(c = In(c)))
          return l;
        var M = ni(l), k = ni(c), O = Ig(M, k), F = Ng(M, k) + 1;
        return vo(M, O, F).join("");
      }
      function AE(l, c, p) {
        if (l = Zt(l), l && (p || c === r))
          return l.slice(0, $g(l) + 1);
        if (!l || !(c = In(c)))
          return l;
        var M = ni(l), k = Ng(M, ni(c)) + 1;
        return vo(M, 0, k).join("");
      }
      function EE(l, c, p) {
        if (l = Zt(l), l && (p || c === r))
          return l.replace(Fe, "");
        if (!l || !(c = In(c)))
          return l;
        var M = ni(l), k = Ig(M, ni(c));
        return vo(M, k).join("");
      }
      function IE(l, c) {
        var p = $, M = _;
        if (yr(c)) {
          var k = "separator" in c ? c.separator : k;
          p = "length" in c ? It(c.length) : p, M = "omission" in c ? In(c.omission) : M;
        }
        l = Zt(l);
        var O = l.length;
        if (ya(l)) {
          var F = ni(l);
          O = F.length;
        }
        if (p >= O)
          return l;
        var V = p - xa(M);
        if (V < 1)
          return M;
        var ee = F ? vo(F, 0, V).join("") : l.slice(0, V);
        if (k === r)
          return ee + M;
        if (F && (V += ee.length - V), ef(k)) {
          if (l.slice(V).search(k)) {
            var me, be = ee;
            for (k.global || (k = md(k.source, Zt(Mi.exec(k)) + "g")), k.lastIndex = 0; me = k.exec(be); )
              var Ce = me.index;
            ee = ee.slice(0, Ce === r ? V : Ce);
          }
        } else if (l.indexOf(In(k), V) != V) {
          var He = ee.lastIndexOf(k);
          He > -1 && (ee = ee.slice(0, He));
        }
        return ee + M;
      }
      function NE(l) {
        return l = Zt(l), l && st.test(l) ? l.replace(ye, aS) : l;
      }
      var zE = Da(function(l, c, p) {
        return l + (p ? " " : "") + c.toUpperCase();
      }), nf = wm("toUpperCase");
      function yv(l, c, p) {
        return l = Zt(l), c = p ? r : c, c === r ? tS(l) ? uS(l) : YC(l) : l.match(c) || [];
      }
      var xv = _t(function(l, c) {
        try {
          return An(l, r, c);
        } catch (p) {
          return Jd(p) ? p : new kt(p);
        }
      }), $E = Ui(function(l, c) {
        return Un(c, function(p) {
          p = ki(p), Fi(l, p, Kd(l[p], l));
        }), l;
      });
      function OE(l) {
        var c = l == null ? 0 : l.length, p = pt();
        return l = c ? mr(l, function(M) {
          if (typeof M[1] != "function")
            throw new Hn(a);
          return [p(M[0]), M[1]];
        }) : [], _t(function(M) {
          for (var k = -1; ++k < c; ) {
            var O = l[k];
            if (An(O[0], this, M))
              return An(O[1], this, M);
          }
        });
      }
      function _E(l) {
        return aT(Vn(l, h));
      }
      function of(l) {
        return function() {
          return l;
        };
      }
      function LE(l, c) {
        return l == null || l !== l ? c : l;
      }
      var PE = Cm(), RE = Cm(!0);
      function bn(l) {
        return l;
      }
      function af(l) {
        return Jg(typeof l == "function" ? l : Vn(l, h));
      }
      function jE(l) {
        return tm(Vn(l, h));
      }
      function FE(l, c) {
        return rm(l, Vn(c, h));
      }
      var BE = _t(function(l, c) {
        return function(p) {
          return Tl(p, l, c);
        };
      }), UE = _t(function(l, c) {
        return function(p) {
          return Tl(l, p, c);
        };
      });
      function lf(l, c, p) {
        var M = Ur(c), k = lu(c, M);
        p == null && !(yr(c) && (k.length || !M.length)) && (p = c, c = l, l = this, k = lu(c, Ur(c)));
        var O = !(yr(p) && "chain" in p) || !!p.chain, F = Wi(l);
        return Un(k, function(V) {
          var ee = c[V];
          l[V] = ee, F && (l.prototype[V] = function() {
            var me = this.__chain__;
            if (O || me) {
              var be = l(this.__wrapped__), Ce = be.__actions__ = gn(this.__actions__);
              return Ce.push({ func: ee, args: arguments, thisArg: l }), be.__chain__ = me, be;
            }
            return ee.apply(l, co([this.value()], arguments));
          });
        }), l;
      }
      function HE() {
        return Vr._ === this && (Vr._ = gS), this;
      }
      function sf() {
      }
      function WE(l) {
        return l = It(l), _t(function(c) {
          return nm(c, l);
        });
      }
      var VE = Rd(mr), YE = Rd(Sg), QE = Rd(ud);
      function wv(l) {
        return Vd(l) ? cd(ki(l)) : CT(l);
      }
      function qE(l) {
        return function(c) {
          return l == null ? r : Ho(l, c);
        };
      }
      var GE = Tm(), ZE = Tm(!0);
      function uf() {
        return [];
      }
      function cf() {
        return !1;
      }
      function KE() {
        return {};
      }
      function XE() {
        return "";
      }
      function JE() {
        return !0;
      }
      function eI(l, c) {
        if (l = It(l), l < 1 || l > ue)
          return [];
        var p = de, M = tn(l, de);
        c = pt(c), l -= de;
        for (var k = hd(M, c); ++p < l; )
          c(p);
        return k;
      }
      function tI(l) {
        return Et(l) ? mr(l, ki) : Nn(l) ? [l] : gn(Bm(Zt(l)));
      }
      function rI(l) {
        var c = ++hS;
        return Zt(l) + c;
      }
      var nI = hu(function(l, c) {
        return l + c;
      }, 0), iI = jd("ceil"), oI = hu(function(l, c) {
        return l / c;
      }, 1), aI = jd("floor");
      function lI(l) {
        return l && l.length ? au(l, bn, Sd) : r;
      }
      function sI(l, c) {
        return l && l.length ? au(l, pt(c, 2), Sd) : r;
      }
      function uI(l) {
        return Dg(l, bn);
      }
      function cI(l, c) {
        return Dg(l, pt(c, 2));
      }
      function dI(l) {
        return l && l.length ? au(l, bn, Ad) : r;
      }
      function fI(l, c) {
        return l && l.length ? au(l, pt(c, 2), Ad) : r;
      }
      var hI = hu(function(l, c) {
        return l * c;
      }, 1), pI = jd("round"), gI = hu(function(l, c) {
        return l - c;
      }, 0);
      function mI(l) {
        return l && l.length ? fd(l, bn) : 0;
      }
      function vI(l, c) {
        return l && l.length ? fd(l, pt(c, 2)) : 0;
      }
      return z.after = jD, z.ary = Xm, z.assign = kA, z.assignIn = fv, z.assignInWith = ku, z.assignWith = DA, z.at = AA, z.before = Jm, z.bind = Kd, z.bindAll = $E, z.bindKey = ev, z.castArray = KD, z.chain = Gm, z.chunk = ak, z.compact = lk, z.concat = sk, z.cond = OE, z.conforms = _E, z.constant = of, z.countBy = mD, z.create = EA, z.curry = tv, z.curryRight = rv, z.debounce = nv, z.defaults = IA, z.defaultsDeep = NA, z.defer = FD, z.delay = BD, z.difference = uk, z.differenceBy = ck, z.differenceWith = dk, z.drop = fk, z.dropRight = hk, z.dropRightWhile = pk, z.dropWhile = gk, z.fill = mk, z.filter = bD, z.flatMap = wD, z.flatMapDeep = MD, z.flatMapDepth = CD, z.flatten = Vm, z.flattenDeep = vk, z.flattenDepth = bk, z.flip = UD, z.flow = PE, z.flowRight = RE, z.fromPairs = yk, z.functions = RA, z.functionsIn = jA, z.groupBy = SD, z.initial = wk, z.intersection = Mk, z.intersectionBy = Ck, z.intersectionWith = Sk, z.invert = BA, z.invertBy = UA, z.invokeMap = kD, z.iteratee = af, z.keyBy = DD, z.keys = Ur, z.keysIn = vn, z.map = xu, z.mapKeys = WA, z.mapValues = VA, z.matches = jE, z.matchesProperty = FE, z.memoize = Mu, z.merge = YA, z.mergeWith = hv, z.method = BE, z.methodOf = UE, z.mixin = lf, z.negate = Cu, z.nthArg = WE, z.omit = QA, z.omitBy = qA, z.once = HD, z.orderBy = AD, z.over = VE, z.overArgs = WD, z.overEvery = YE, z.overSome = QE, z.partial = Xd, z.partialRight = iv, z.partition = ED, z.pick = GA, z.pickBy = pv, z.property = wv, z.propertyOf = qE, z.pull = Ak, z.pullAll = Qm, z.pullAllBy = Ek, z.pullAllWith = Ik, z.pullAt = Nk, z.range = GE, z.rangeRight = ZE, z.rearg = VD, z.reject = zD, z.remove = zk, z.rest = YD, z.reverse = Gd, z.sampleSize = OD, z.set = KA, z.setWith = XA, z.shuffle = _D, z.slice = $k, z.sortBy = RD, z.sortedUniq = Fk, z.sortedUniqBy = Bk, z.split = wE, z.spread = QD, z.tail = Uk, z.take = Hk, z.takeRight = Wk, z.takeRightWhile = Vk, z.takeWhile = Yk, z.tap = lD, z.throttle = qD, z.thru = yu, z.toArray = uv, z.toPairs = gv, z.toPairsIn = mv, z.toPath = tI, z.toPlainObject = dv, z.transform = JA, z.unary = GD, z.union = Qk, z.unionBy = qk, z.unionWith = Gk, z.uniq = Zk, z.uniqBy = Kk, z.uniqWith = Xk, z.unset = eE, z.unzip = Zd, z.unzipWith = qm, z.update = tE, z.updateWith = rE, z.values = Ia, z.valuesIn = nE, z.without = Jk, z.words = yv, z.wrap = ZD, z.xor = eD, z.xorBy = tD, z.xorWith = rD, z.zip = nD, z.zipObject = iD, z.zipObjectDeep = oD, z.zipWith = aD, z.entries = gv, z.entriesIn = mv, z.extend = fv, z.extendWith = ku, lf(z, z), z.add = nI, z.attempt = xv, z.camelCase = lE, z.capitalize = vv, z.ceil = iI, z.clamp = iE, z.clone = XD, z.cloneDeep = eA, z.cloneDeepWith = tA, z.cloneWith = JD, z.conformsTo = rA, z.deburr = bv, z.defaultTo = LE, z.divide = oI, z.endsWith = sE, z.eq = oi, z.escape = uE, z.escapeRegExp = cE, z.every = vD, z.find = yD, z.findIndex = Hm, z.findKey = zA, z.findLast = xD, z.findLastIndex = Wm, z.findLastKey = $A, z.floor = aI, z.forEach = Zm, z.forEachRight = Km, z.forIn = OA, z.forInRight = _A, z.forOwn = LA, z.forOwnRight = PA, z.get = tf, z.gt = nA, z.gte = iA, z.has = FA, z.hasIn = rf, z.head = Ym, z.identity = bn, z.includes = TD, z.indexOf = xk, z.inRange = oE, z.invoke = HA, z.isArguments = Yo, z.isArray = Et, z.isArrayBuffer = oA, z.isArrayLike = mn, z.isArrayLikeObject = Ir, z.isBoolean = aA, z.isBuffer = bo, z.isDate = lA, z.isElement = sA, z.isEmpty = uA, z.isEqual = cA, z.isEqualWith = dA, z.isError = Jd, z.isFinite = fA, z.isFunction = Wi, z.isInteger = ov, z.isLength = Su, z.isMap = av, z.isMatch = hA, z.isMatchWith = pA, z.isNaN = gA, z.isNative = mA, z.isNil = bA, z.isNull = vA, z.isNumber = lv, z.isObject = yr, z.isObjectLike = Dr, z.isPlainObject = Nl, z.isRegExp = ef, z.isSafeInteger = yA, z.isSet = sv, z.isString = Tu, z.isSymbol = Nn, z.isTypedArray = Ea, z.isUndefined = xA, z.isWeakMap = wA, z.isWeakSet = MA, z.join = Tk, z.kebabCase = dE, z.last = Qn, z.lastIndexOf = kk, z.lowerCase = fE, z.lowerFirst = hE, z.lt = CA, z.lte = SA, z.max = lI, z.maxBy = sI, z.mean = uI, z.meanBy = cI, z.min = dI, z.minBy = fI, z.stubArray = uf, z.stubFalse = cf, z.stubObject = KE, z.stubString = XE, z.stubTrue = JE, z.multiply = hI, z.nth = Dk, z.noConflict = HE, z.noop = sf, z.now = wu, z.pad = pE, z.padEnd = gE, z.padStart = mE, z.parseInt = vE, z.random = aE, z.reduce = ID, z.reduceRight = ND, z.repeat = bE, z.replace = yE, z.result = ZA, z.round = pI, z.runInContext = J, z.sample = $D, z.size = LD, z.snakeCase = xE, z.some = PD, z.sortedIndex = Ok, z.sortedIndexBy = _k, z.sortedIndexOf = Lk, z.sortedLastIndex = Pk, z.sortedLastIndexBy = Rk, z.sortedLastIndexOf = jk, z.startCase = ME, z.startsWith = CE, z.subtract = gI, z.sum = mI, z.sumBy = vI, z.template = SE, z.times = eI, z.toFinite = Vi, z.toInteger = It, z.toLength = cv, z.toLower = TE, z.toNumber = qn, z.toSafeInteger = TA, z.toString = Zt, z.toUpper = kE, z.trim = DE, z.trimEnd = AE, z.trimStart = EE, z.truncate = IE, z.unescape = NE, z.uniqueId = rI, z.upperCase = zE, z.upperFirst = nf, z.each = Zm, z.eachRight = Km, z.first = Ym, lf(z, function() {
        var l = {};
        return Si(z, function(c, p) {
          Jt.call(z.prototype, p) || (l[p] = c);
        }), l;
      }(), { chain: !1 }), z.VERSION = n, Un(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(l) {
        z[l].placeholder = z;
      }), Un(["drop", "take"], function(l, c) {
        Rt.prototype[l] = function(p) {
          p = p === r ? 1 : Rr(It(p), 0);
          var M = this.__filtered__ && !c ? new Rt(this) : this.clone();
          return M.__filtered__ ? M.__takeCount__ = tn(p, M.__takeCount__) : M.__views__.push({
            size: tn(p, de),
            type: l + (M.__dir__ < 0 ? "Right" : "")
          }), M;
        }, Rt.prototype[l + "Right"] = function(p) {
          return this.reverse()[l](p).reverse();
        };
      }), Un(["filter", "map", "takeWhile"], function(l, c) {
        var p = c + 1, M = p == Q || p == X;
        Rt.prototype[l] = function(k) {
          var O = this.clone();
          return O.__iteratees__.push({
            iteratee: pt(k, 3),
            type: p
          }), O.__filtered__ = O.__filtered__ || M, O;
        };
      }), Un(["head", "last"], function(l, c) {
        var p = "take" + (c ? "Right" : "");
        Rt.prototype[l] = function() {
          return this[p](1).value()[0];
        };
      }), Un(["initial", "tail"], function(l, c) {
        var p = "drop" + (c ? "" : "Right");
        Rt.prototype[l] = function() {
          return this.__filtered__ ? new Rt(this) : this[p](1);
        };
      }), Rt.prototype.compact = function() {
        return this.filter(bn);
      }, Rt.prototype.find = function(l) {
        return this.filter(l).head();
      }, Rt.prototype.findLast = function(l) {
        return this.reverse().find(l);
      }, Rt.prototype.invokeMap = _t(function(l, c) {
        return typeof l == "function" ? new Rt(this) : this.map(function(p) {
          return Tl(p, l, c);
        });
      }), Rt.prototype.reject = function(l) {
        return this.filter(Cu(pt(l)));
      }, Rt.prototype.slice = function(l, c) {
        l = It(l);
        var p = this;
        return p.__filtered__ && (l > 0 || c < 0) ? new Rt(p) : (l < 0 ? p = p.takeRight(-l) : l && (p = p.drop(l)), c !== r && (c = It(c), p = c < 0 ? p.dropRight(-c) : p.take(c - l)), p);
      }, Rt.prototype.takeRightWhile = function(l) {
        return this.reverse().takeWhile(l).reverse();
      }, Rt.prototype.toArray = function() {
        return this.take(de);
      }, Si(Rt.prototype, function(l, c) {
        var p = /^(?:filter|find|map|reject)|While$/.test(c), M = /^(?:head|last)$/.test(c), k = z[M ? "take" + (c == "last" ? "Right" : "") : c], O = M || /^find/.test(c);
        k && (z.prototype[c] = function() {
          var F = this.__wrapped__, V = M ? [1] : arguments, ee = F instanceof Rt, me = V[0], be = ee || Et(F), Ce = function(Pt) {
            var Ft = k.apply(z, co([Pt], V));
            return M && He ? Ft[0] : Ft;
          };
          be && p && typeof me == "function" && me.length != 1 && (ee = be = !1);
          var He = this.__chain__, it = !!this.__actions__.length, gt = O && !He, $t = ee && !it;
          if (!O && be) {
            F = $t ? F : new Rt(this);
            var mt = l.apply(F, V);
            return mt.__actions__.push({ func: yu, args: [Ce], thisArg: r }), new Wn(mt, He);
          }
          return gt && $t ? l.apply(this, V) : (mt = this.thru(Ce), gt ? M ? mt.value()[0] : mt.value() : mt);
        });
      }), Un(["pop", "push", "shift", "sort", "splice", "unshift"], function(l) {
        var c = Vs[l], p = /^(?:push|sort|unshift)$/.test(l) ? "tap" : "thru", M = /^(?:pop|shift)$/.test(l);
        z.prototype[l] = function() {
          var k = arguments;
          if (M && !this.__chain__) {
            var O = this.value();
            return c.apply(Et(O) ? O : [], k);
          }
          return this[p](function(F) {
            return c.apply(Et(F) ? F : [], k);
          });
        };
      }), Si(Rt.prototype, function(l, c) {
        var p = z[c];
        if (p) {
          var M = p.name + "";
          Jt.call(Sa, M) || (Sa[M] = []), Sa[M].push({ name: c, func: p });
        }
      }), Sa[fu(r, y).name] = [{
        name: "wrapper",
        func: r
      }], Rt.prototype.clone = NS, Rt.prototype.reverse = zS, Rt.prototype.value = $S, z.prototype.at = sD, z.prototype.chain = uD, z.prototype.commit = cD, z.prototype.next = dD, z.prototype.plant = hD, z.prototype.reverse = pD, z.prototype.toJSON = z.prototype.valueOf = z.prototype.value = gD, z.prototype.first = z.prototype.head, bl && (z.prototype[bl] = fD), z;
    }, wa = cS();
    Ro ? ((Ro.exports = wa)._ = wa, od._ = wa) : Vr._ = wa;
  }).call(Dv);
})(Tc, Tc.exports);
const sCe = (e) => {
  let t = 0;
  if (e.length == 0)
    return t.toString();
  for (let n = 0; n < e.length; n++)
    t = e.charCodeAt(n) + ((t << 5) - t), t = t & t;
  return "hsl(" + Math.abs(t) % 360 + ",35%, 60%)";
}, uCe = (e = "") => {
  if (e === null || !e.trim())
    return e;
  const t = (e ?? "").toLocaleUpperCase().split(" ").filter((r) => r.trim());
  return t.length > 1 ? t.splice(0, 2).reduce((r, n) => r + n[0], "") : t[0].slice(0, 2);
}, GR = (e = {}) => ({
  round: !0,
  size: 24,
  style: e
}), Z4 = (e) => e.imageUrl ? b(A0, vt({
  src: e.imageUrl
}, GR())) : b(A0, GR({
  backgroundColor: sCe(e.label),
  fontSize: "10px"
}), {
  default: () => uCe(e.label)
}), cCe = {
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  marginLeft: "8px"
}, dCe = (e) => b("div", {
  style: {
    display: "flex",
    alignItems: "center"
  }
}, [
  Z4(e),
  b("div", {
    style: cCe
  }, [
    b("p", { style: { margin: 0 } }, [e.label]),
    b("span", {
      style: {
        color: "var(--gray-500)"
      }
    }, {
      default: () => e == null ? void 0 : e.description
    })
  ])
]), fCe = (e) => b("div", {}, [b("span", {}, [e.label])]), hCe = { class: "flex items-center space-x-1" }, pCe = {
  key: 0,
  class: "flex items-center"
}, gCe = {
  name: "UITag",
  inheritAttrs: !1
}, i1 = /* @__PURE__ */ oe(Qt(vt({}, gCe), {
  props: {
    type: {
      type: String,
      default: "default"
    },
    closable: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "medium"
    },
    round: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const t = pn();
    return (r, n) => (ie(), Pe(B(Jv), ir({
      class: [`hl-${e.type}`]
    }, r.$attrs, {
      type: e.type,
      closable: e.closable,
      size: e.size,
      round: e.round,
      onClick: n[0] || (n[0] = (i) => r.$emit("click", i)),
      onClose: n[1] || (n[1] = (i) => r.$emit("close", i))
    }), {
      default: we(() => [
        Ye("div", hCe, [
          B(t).icon ? (ie(), Ve("div", pCe, [
            nt(r.$slots, "icon")
          ])) : yt("", !0),
          Ye("div", null, [
            nt(r.$slots, "default")
          ])
        ])
      ]),
      _: 3
    }, 16, ["class", "type", "closable", "size", "round"]));
  }
}));
i1.install = (e) => {
  e.component(i1.name, i1);
};
const KW = {
  display: "flex",
  alignItems: "center",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "24px"
}, mCe = ({ option: e }) => b("div", {
  style: KW
}, [
  Z4(e),
  b("p", { style: { marginLeft: "8px" } }, { default: () => e.label })
]), vCe = ({
  option: e,
  handleClose: t
}) => b(i1, {
  style: {
    padding: "0 6px 0 4px"
  },
  round: !0,
  closable: !0,
  onClose: (r) => {
    r.stopPropagation(), t();
  }
}, {
  default: () => b("div", {
    style: KW
  }, [
    Z4(e),
    b("p", { style: { marginLeft: "8px" } }, { default: () => e.label })
  ])
}), bCe = {
  name: "UISelect",
  inheritAttrs: !1
}, ws = oe(Qt(vt({}, bCe), {
  props: {
    id: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    show: {
      type: Boolean,
      default: void 0
    },
    multiple: {
      type: Boolean,
      default: void 0
    },
    filterable: {
      type: Boolean,
      default: void 0
    },
    loading: {
      type: Boolean,
      default: void 0
    },
    clearable: {
      type: Boolean,
      default: !1
    },
    remote: {
      type: Boolean,
      default: void 0
    },
    tag: {
      type: Boolean,
      default: void 0
    },
    type: {
      type: String,
      default: "default"
    },
    resetMenuOnOptionsChange: {
      type: Boolean,
      default: !0
    },
    size: {
      type: String,
      default: "large"
    },
    maxTagCount: {
      type: Number,
      default: void 0
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String
    },
    value: {
      type: [String, Array]
    }
  },
  emits: ["search", "update:value", "scroll"],
  setup(e) {
    const t = e, r = (i, o) => {
      var a;
      switch ((a = i.type) != null ? a : t.type) {
        case "avatar":
        default:
          return dCe(i);
        case "group":
          return fCe(i);
      }
    }, n = j(() => {
      switch (t.type) {
        case "avatar":
          return t.multiple ? vCe : mCe;
        case "default":
        default:
          return;
      }
    });
    return (i, o) => (ie(), Pe(B(HH), ir({
      "reset-menu-on-options-change": e.resetMenuOnOptionsChange,
      onScroll: o[0] || (o[0] = (a) => i.$emit("scroll", a)),
      "render-label": e.type === "avatar" ? r : void 0,
      "render-tag": B(n),
      id: e.id
    }, i.$attrs, {
      placeholder: e.placeholder,
      options: e.options,
      disabled: e.disabled,
      value: e.value,
      class: "hl-select",
      filterable: e.filterable,
      show: e.show,
      multiple: e.multiple,
      loading: e.loading,
      clearable: e.clearable,
      remote: e.remote,
      tag: e.tag,
      onSearch: o[1] || (o[1] = (a) => i.$emit("search", a)),
      "onUpdate:value": o[2] || (o[2] = (a, s) => i.$emit("update:value", a, s)),
      "max-tag-count": e.maxTagCount,
      size: e.size
    }), {
      action: we(() => [
        nt(i.$slots, "action")
      ]),
      arrow: we(() => [
        nt(i.$slots, "arrow")
      ]),
      empty: we(() => [
        nt(i.$slots, "empty")
      ]),
      _: 3
    }, 16, ["reset-menu-on-options-change", "render-label", "render-tag", "id", "placeholder", "options", "disabled", "value", "filterable", "show", "multiple", "loading", "clearable", "remote", "tag", "max-tag-count", "size"]));
  }
}));
ws.install = (e) => {
  e.component(ws.name, ws);
};
const yCe = { class: "mr-1" }, xCe = { class: "flex items-center justify-between w-60 filter-heading" }, wCe = { class: "flex items-center text-primary-600 space-x-2 actions" };
oe({
  name: "UITableFilter"
});
const MCe = /* @__PURE__ */ oe({
  __name: "TableFilter",
  props: {
    collapseItems: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      required: !0
    }
  },
  emits: ["update:filter"],
  setup(e, { emit: t }) {
    const r = e, n = G(), i = G([]), o = G(), a = G({}), s = G(0);
    Gt(() => r.options, (x) => {
      i.value = x;
    }, {
      immediate: !0
    });
    function u(x) {
      const y = i.value.find((C) => x.key === C.key);
      return y ? (y == null ? void 0 : y.options) || [] : [];
    }
    function d(x) {
      const y = i.value.find((C) => x.key === C.key);
      return y ? (y == null ? void 0 : y.value) || "" : [];
    }
    function f(x, y) {
      const C = Tc.exports.cloneDeep(i.value);
      C.forEach((S) => (S.key === y.key && (S.value = x), S)), i.value = C, n.value = Tc.exports.cloneDeep(C).map((S) => (delete S.options, S)), a.value[y.key] = x;
    }
    function h() {
      i.value = r.options, n.value = {}, a.value = {}, g(), v();
    }
    function g() {
      s.value = 0;
      for (const x in a.value) {
        const y = a.value[x], C = r.options.find((S) => S.key === x);
        C.key === x && C.value !== y && (s.value += 1);
      }
      t("update:filter", {
        filters: n.value,
        options: i.value
      });
    }
    function m() {
      g(), v();
    }
    function v() {
      o.value.handleClick();
    }
    const w = lt("customLocale");
    return (x, y) => (ie(), Pe(B(jc), {
      trigger: "click",
      "show-arrow": !1,
      ref_key: "popoverRef",
      ref: o,
      placement: "bottom"
    }, {
      trigger: we(() => [
        Re(B(on), {
          size: "large",
          class: "hl-table-filter-btn",
          id: ""
        }, {
          default: we(() => {
            var C;
            return [
              Re(B(Bwe), { class: "w-5 h-5 mr-1" }),
              Ye("span", yCe, ar((C = B(w).DataTable.filters) != null ? C : "Filters"), 1),
              Re(B(TH), {
                class: "badge",
                value: s.value,
                color: "#F2F4F7"
              }, null, 8, ["value"])
            ];
          }),
          _: 1
        })
      ]),
      header: we(() => [
        Ye("div", xCe, [
          Re(B(wp), { class: "title text-gray-900" }, {
            default: we(() => {
              var C;
              return [
                zr(ar((C = B(w).DataTable.filters) != null ? C : "Filters"), 1)
              ];
            }),
            _: 1
          }),
          Ye("div", wCe, [
            Re(B(on), {
              text: "",
              onClick: h,
              id: `hl-table-${e.id}-filter-clear`
            }, {
              default: we(() => {
                var C;
                return [
                  zr(ar((C = B(w).DataTable.clear) != null ? C : "Clear"), 1)
                ];
              }),
              _: 1
            }, 8, ["id"]),
            Re(B(on), {
              text: "",
              onClick: m,
              id: `hl-table-${e.id}-filter-apply`
            }, {
              default: we(() => {
                var C;
                return [
                  zr(ar((C = B(w).DataTable.apply) != null ? C : "Apply"), 1)
                ];
              }),
              _: 1
            }, 8, ["id"])
          ])
        ])
      ]),
      default: we(() => [
        Re(B(jH), null, {
          default: we(() => [
            (ie(!0), Ve(Lr, null, Fl(e.collapseItems, (C) => (ie(), Pe(B(FH), {
              title: C.label,
              name: C.key,
              key: C.key
            }, {
              default: we(() => [
                Re(B(ws), {
                  options: u(C),
                  value: d(C),
                  id: e.id,
                  "onUpdate:value": (S) => f(S, C)
                }, null, 8, ["options", "value", "id", "onUpdate:value"])
              ]),
              _: 2
            }, 1032, ["title", "name"]))), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512));
  }
});
var f$ = MCe;
f2.install = (e) => {
  e.component(f2.name, f2), e.component(QR.name, QR), e.component(qR.name, qR), e.component(f$.name, f$);
};
const CCe = {
  name: "UITabs",
  inheritAttrs: !1
}, h2 = oe(Qt(vt({}, CCe), {
  props: {
    value: {
      type: [String, Number]
    },
    type: {
      type: String,
      default: "line"
    },
    defaultValue: {
      type: String,
      default: void 0
    },
    justifyContent: {
      type: String,
      default: ""
    },
    animated: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:value"],
  setup(e) {
    return (t, r) => (ie(), Pe(B(Jxe), {
      value: e.value,
      "onUpdate:value": r[0] || (r[0] = (n) => t.$emit("update:value", n)),
      type: e.type,
      animated: e.animated,
      "justify-content": e.justifyContent,
      "default-value": e.defaultValue
    }, {
      default: we(() => [
        nt(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["value", "type", "animated", "justify-content", "default-value"]));
  }
}));
var ZR = oe({
  __TAB_PANE__: !0,
  props: {
    name: {
      type: [String, Number]
    },
    tab: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  setup(e, { slots: t }) {
    return () => b(Gxe, {
      name: e.name,
      tab: e.tab,
      disabled: e.disabled
    }, () => t == null ? void 0 : t.default());
  }
}), KR = oe({
  __TAB__: !0,
  props: {
    name: {
      type: [String, Number]
    },
    key: {
      type: [String, Number]
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  setup(e, { slots: t }) {
    return () => b(fx, {
      name: e.name,
      key: e.key,
      disabled: e.disabled
    }, () => t.default());
  }
});
h2.install = (e) => {
  e.component(h2.name, h2), e.component(ZR.name, ZR), e.component(KR.name, KR);
};
const SCe = {
  name: "UIToolbar",
  inheritAttrs: !1
}, p2 = /* @__PURE__ */ oe(Qt(vt({}, SCe), {
  props: {
    theme: {
      type: String,
      default: "dark"
    }
  },
  setup(e) {
    return (t, r) => (ie(), Ve("div", ir(t.$attrs, {
      class: ["hl-toolbar", e.theme]
    }), [
      nt(t.$slots, "default")
    ], 16));
  }
})), TCe = {
  name: "UIToolbarGroup",
  inheritAttrs: !1
}, XR = /* @__PURE__ */ oe(Qt(vt({}, TCe), {
  props: {
    borderLeft: Boolean,
    borderRight: Boolean
  },
  setup(e) {
    return (t, r) => (ie(), Ve("div", ir(t.$attrs, {
      class: ["hl-toolbar-group", { "hl-br": e.borderRight, "hl-bl": e.borderLeft }]
    }), [
      nt(t.$slots, "default")
    ], 16));
  }
}));
p2.install = (e) => {
  e.component(p2.name, p2), e.component(XR.name, XR);
};
const kCe = { class: "body" }, DCe = {
  key: 2,
  class: "mt-3"
}, ACe = {
  name: "UIAlert",
  inheritAttrs: !1
}, ECe = /* @__PURE__ */ oe(Qt(vt({}, ACe), {
  props: {
    id: {
      type: String,
      required: !0
    },
    type: {
      type: String,
      default: "default"
    },
    closable: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["close"],
  setup(e) {
    const t = pn();
    return (r, n) => (ie(), Pe(B(ipe), {
      id: e.id,
      type: e.type,
      closable: e.closable,
      class: Jr(["rounded-[12px]", [`hl-${e.type}`]]),
      onClose: n[0] || (n[0] = () => r.$emit("close", e.id))
    }, {
      icon: we(() => [
        e.type === "warning" ? (ie(), Pe(B(Pwe), {
          key: 0,
          class: "w-5 h-5"
        })) : e.type === "success" ? (ie(), Pe(B(jwe), {
          key: 1,
          class: "w-5 h-5"
        })) : (ie(), Pe(B(qW), {
          key: 2,
          class: "w-5 h-5"
        }))
      ]),
      default: we(() => [
        Ye("div", kCe, [
          B(t).title ? (ie(), Ve("div", {
            key: 0,
            class: Jr(B(t).content || B(t).actions ? "title" : "")
          }, [
            Re(B(wp), null, {
              default: we(() => [
                nt(r.$slots, "title", {}, void 0, !0)
              ]),
              _: 3
            })
          ], 2)) : yt("", !0),
          B(t).content ? nt(r.$slots, "content", { key: 1 }, void 0, !0) : yt("", !0),
          B(t).actions ? (ie(), Ve("div", DCe, [
            nt(r.$slots, "actions", {}, void 0, !0)
          ])) : yt("", !0)
        ])
      ]),
      _: 3
    }, 8, ["id", "type", "closable", "class"]));
  }
}));
var g2 = /* @__PURE__ */ To(ECe, [["__scopeId", "data-v-6949bb8a"]]);
g2.install = (e) => {
  e.component(g2.name, g2);
};
const ICe = {
  name: "UIAvatar",
  inheritAttrs: !1
}, Pf = /* @__PURE__ */ oe(Qt(vt({}, ICe), {
  props: {
    size: {
      type: String,
      default: "medium"
    },
    objectFit: {
      type: String,
      default: "fill"
    },
    round: {
      type: Boolean,
      default: !0
    },
    src: {
      type: String
    },
    fallbackSrc: {
      type: String
    },
    style: {
      type: Object
    }
  },
  setup(e) {
    return (t, r) => (ie(), Pe(B(A0), ir(t.$attrs, {
      style: e.style,
      src: e.src,
      "fallback-src": e.fallbackSrc,
      round: e.round,
      "object-fit": e.objectFit,
      size: e.size
    }), {
      default: we(() => [
        nt(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["style", "src", "fallback-src", "round", "object-fit", "size"]));
  }
}));
Pf.install = (e) => {
  e.component(Pf.name, Pf);
};
const NCe = {
  name: "UIAvatarGroup",
  inheritAttrs: !1
}, m2 = /* @__PURE__ */ oe(Qt(vt({}, NCe), {
  props: {
    size: {
      type: String,
      default: "medium"
    },
    vertical: {
      type: Boolean,
      default: !1
    },
    max: {
      type: Number,
      default: 5
    },
    id: {
      type: String,
      required: !0
    },
    options: {
      type: Array
    },
    defaultClassName: {
      type: String
    },
    restClassName: {
      type: String
    },
    src: {
      type: String
    }
  },
  setup(e) {
    function t(r) {
      return r.map((n) => ({
        key: n.name,
        label: n.name
      }));
    }
    return (r, n) => (ie(), Pe(B(Npe), {
      options: e.options,
      max: e.max,
      vertical: e.vertical
    }, {
      avatar: we(({ option: { name: i, src: o, icon: a, text: s, className: u } }) => [
        Re(B(ys), null, {
          trigger: we(() => [
            o ? (ie(), Pe(mi(B(Pf)), {
              key: 0,
              src: o,
              size: e.size,
              class: Jr(u || e.defaultClassName)
            }, null, 8, ["src", "size", "class"])) : s ? (ie(), Pe(mi(B(Pf)), {
              key: 1,
              size: e.size,
              class: Jr(u || e.defaultClassName)
            }, {
              default: we(() => [
                zr(ar(s), 1)
              ]),
              _: 2
            }, 1032, ["size", "class"])) : a ? (ie(), Pe(B(Pf), {
              key: 2,
              size: e.size,
              class: Jr(u || e.defaultClassName)
            }, {
              default: we(() => [
                (ie(), Pe(mi(a)))
              ]),
              _: 2
            }, 1032, ["size", "class"])) : yt("", !0)
          ]),
          default: we(() => [
            zr(" " + ar(i), 1)
          ]),
          _: 2
        }, 1024)
      ]),
      rest: we(({ options: i, rest: o }) => [
        Re(B(gc), {
          trigger: "hover",
          options: t(i),
          placement: "top",
          id: `${e.id}-dropdown`
        }, {
          default: we(() => [
            Re(B(Pf), {
              id: `${e.id}-dropdown-trigger`,
              class: Jr(e.restClassName || e.defaultClassName),
              size: e.size
            }, {
              default: we(() => [
                zr("+" + ar(o), 1)
              ]),
              _: 2
            }, 1032, ["id", "class", "size"])
          ]),
          _: 2
        }, 1032, ["options", "id"])
      ]),
      _: 1
    }, 8, ["options", "max", "vertical"]));
  }
}));
m2.install = (e) => {
  e.component(m2.name, m2);
};
const zCe = {
  name: "UIBadge",
  inheritAttrs: !1
}, v2 = /* @__PURE__ */ oe(Qt(vt({}, zCe), {
  props: {
    id: {
      type: String,
      required: !0
    },
    color: {
      type: String
    },
    dot: {
      type: Boolean
    },
    max: {
      type: Number
    },
    processing: {
      type: Boolean
    },
    showZero: {
      type: Boolean,
      default: !1
    },
    show: {
      type: Boolean,
      default: !0
    },
    type: {
      type: String,
      default: "default"
    },
    value: {
      type: Number,
      required: !0
    },
    offset: {
      type: Array
    }
  },
  setup(e) {
    const t = pn();
    return (r, n) => (ie(), Pe(B(TH), {
      color: e.color,
      dot: e.dot,
      max: e.max,
      processing: e.processing,
      "show-zero": e.showZero,
      show: e.show,
      type: e.type,
      value: e.value,
      offset: e.offset
    }, fb({
      default: we(() => [
        nt(r.$slots, "content")
      ]),
      _: 2
    }, [
      B(t).value ? {
        name: "value",
        fn: we(() => [
          nt(r.$slots, "value")
        ])
      } : void 0
    ]), 1032, ["color", "dot", "max", "processing", "show-zero", "show", "type", "value", "offset"]));
  }
}));
v2.install = (e) => {
  e.component(v2.name, v2);
};
const $Ce = {
  name: "UIDataTable"
}, b2 = /* @__PURE__ */ oe(Qt(vt({}, $Ce), {
  setup(e) {
    return (t, r) => (ie(), Pe(B(uW), OB(_B(t.$attrs)), null, 16));
  }
}));
b2.install = (e) => {
  e.component(b2.name, b2);
};
var OCe = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxOSAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuMzUwOTEgMi45MTY2N0MxLjgxMTE1IDIuOTE2NjcgMi4xODQyNCAyLjU0MzU3IDIuMTg0MjQgMi4wODMzM0MyLjE4NDI0IDEuNjIzMSAxLjgxMTE1IDEuMjUgMS4zNTA5MSAxLjI1QzAuODkwNjc0IDEuMjUgMC41MTc1NzggMS42MjMxIDAuNTE3NTc4IDIuMDgzMzNDMC41MTc1NzggMi41NDM1NyAwLjg5MDY3NCAyLjkxNjY3IDEuMzUwOTEgMi45MTY2N1oiIHN0cm9rZT0iIzk4QTJCMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xLjM1MDkxIDguNzVDMS44MTExNSA4Ljc1IDIuMTg0MjQgOC4zNzY5IDIuMTg0MjQgNy45MTY2N0MyLjE4NDI0IDcuNDU2NDMgMS44MTExNSA3LjA4MzMzIDEuMzUwOTEgNy4wODMzM0MwLjg5MDY3NCA3LjA4MzMzIDAuNTE3NTc4IDcuNDU2NDMgMC41MTc1NzggNy45MTY2N0MwLjUxNzU3OCA4LjM3NjkgMC44OTA2NzQgOC43NSAxLjM1MDkxIDguNzVaIiBzdHJva2U9IiM5OEEyQjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNi42NzIyIDIuOTE2NjdDNy4xMzI0NCAyLjkxNjY3IDcuNTA1NTMgMi41NDM1NyA3LjUwNTUzIDIuMDgzMzNDNy41MDU1MyAxLjYyMzEgNy4xMzI0NCAxLjI1IDYuNjcyMiAxLjI1QzYuMjExOTYgMS4yNSA1LjgzODg3IDEuNjIzMSA1LjgzODg3IDIuMDgzMzNDNS44Mzg4NyAyLjU0MzU3IDYuMjExOTYgMi45MTY2NyA2LjY3MjIgMi45MTY2N1oiIHN0cm9rZT0iIzk4QTJCMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik02LjY3MjIgOC43NUM3LjEzMjQ0IDguNzUgNy41MDU1MyA4LjM3NjkgNy41MDU1MyA3LjkxNjY3QzcuNTA1NTMgNy40NTY0MyA3LjEzMjQ0IDcuMDgzMzMgNi42NzIyIDcuMDgzMzNDNi4yMTE5NiA3LjA4MzMzIDUuODM4ODcgNy40NTY0MyA1LjgzODg3IDcuOTE2NjdDNS44Mzg4NyA4LjM3NjkgNi4yMTE5NiA4Ljc1IDYuNjcyMiA4Ljc1WiIgc3Ryb2tlPSIjOThBMkIzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTExLjk5MzUgMi45MTY2N0MxMi40NTM3IDIuOTE2NjcgMTIuODI2OCAyLjU0MzU3IDEyLjgyNjggMi4wODMzM0MxMi44MjY4IDEuNjIzMSAxMi40NTM3IDEuMjUgMTEuOTkzNSAxLjI1QzExLjUzMzMgMS4yNSAxMS4xNjAyIDEuNjIzMSAxMS4xNjAyIDIuMDgzMzNDMTEuMTYwMiAyLjU0MzU3IDExLjUzMzMgMi45MTY2NyAxMS45OTM1IDIuOTE2NjdaIiBzdHJva2U9IiM5OEEyQjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTEuOTkzNSA4Ljc1QzEyLjQ1MzcgOC43NSAxMi44MjY4IDguMzc2OSAxMi44MjY4IDcuOTE2NjdDMTIuODI2OCA3LjQ1NjQzIDEyLjQ1MzcgNy4wODMzMyAxMS45OTM1IDcuMDgzMzNDMTEuNTMzMyA3LjA4MzMzIDExLjE2MDIgNy40NTY0MyAxMS4xNjAyIDcuOTE2NjdDMTEuMTYwMiA4LjM3NjkgMTEuNTMzMyA4Ljc1IDExLjk5MzUgOC43NVoiIHN0cm9rZT0iIzk4QTJCMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNy4zMTQ4IDIuOTE2NjdDMTcuNzc1IDIuOTE2NjcgMTguMTQ4MSAyLjU0MzU3IDE4LjE0ODEgMi4wODMzM0MxOC4xNDgxIDEuNjIzMSAxNy43NzUgMS4yNSAxNy4zMTQ4IDEuMjVDMTYuODU0NSAxLjI1IDE2LjQ4MTQgMS42MjMxIDE2LjQ4MTQgMi4wODMzM0MxNi40ODE0IDIuNTQzNTcgMTYuODU0NSAyLjkxNjY3IDE3LjMxNDggMi45MTY2N1oiIHN0cm9rZT0iIzk4QTJCMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNy4zMTQ4IDguNzVDMTcuNzc1IDguNzUgMTguMTQ4MSA4LjM3NjkgMTguMTQ4MSA3LjkxNjY3QzE4LjE0ODEgNy40NTY0MyAxNy43NzUgNy4wODMzMyAxNy4zMTQ4IDcuMDgzMzNDMTYuODU0NSA3LjA4MzMzIDE2LjQ4MTQgNy40NTY0MyAxNi40ODE0IDcuOTE2NjdDMTYuNDgxNCA4LjM3NjkgMTYuODU0NSA4Ljc1IDE3LjMxNDggOC43NVoiIHN0cm9rZT0iIzk4QTJCMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
const _Ce = ["id"], LCe = ["src"], PCe = { class: "gui__builder-card--icon" }, RCe = {
  name: "UIDraggableElement",
  inheritAttrs: !1,
  components: { UITextXsMedium: px }
}, y2 = /* @__PURE__ */ oe(Qt(vt({}, RCe), {
  props: {
    id: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      default: null
    },
    icon: {
      type: Function,
      default: null
    },
    disabled: Boolean
  },
  setup(e) {
    const t = pn();
    return (r, n) => (ie(), Ve("div", {
      class: Jr(["gui__builder-card", e.disabled ? "disabled" : ""]),
      id: e.id,
      tabindex: "0"
    }, [
      Ye("img", {
        src: B(OCe),
        class: "gui__builder-card--handler",
        draggable: "false"
      }, null, 8, LCe),
      Ye("div", PCe, [
        B(t).icon ? nt(r.$slots, "icon", { key: 0 }) : (ie(), Pe(mi(e.icon), {
          key: 1,
          class: "w-8 h-8 p-2 text-gray-600"
        }))
      ]),
      Re(B(px), { class: "gui__builder-card--label" }, {
        default: we(() => [
          zr(ar(e.label), 1)
        ]),
        _: 1
      })
    ], 10, _Ce));
  }
}));
y2.install = (e) => {
  e.component(y2.name, y2);
};
const x2 = 0, Wt = 1, Kr = 2, zi = 3, Pn = 4, Ns = 5, ZM = 6, Ao = 7, la = 8, Zr = 9, xr = 10, ui = 11, qr = 12, yi = 13, Db = 14, sa = 15, No = 16, ga = 17, zs = 18, Va = 19, Wl = 20, Ki = 21, kn = 22, zo = 23, ul = 24, Xo = 25, jCe = 0;
function io(e) {
  return e >= 48 && e <= 57;
}
function kc(e) {
  return io(e) || e >= 65 && e <= 70 || e >= 97 && e <= 102;
}
function K4(e) {
  return e >= 65 && e <= 90;
}
function FCe(e) {
  return e >= 97 && e <= 122;
}
function BCe(e) {
  return K4(e) || FCe(e);
}
function UCe(e) {
  return e >= 128;
}
function mx(e) {
  return BCe(e) || UCe(e) || e === 95;
}
function XW(e) {
  return mx(e) || io(e) || e === 45;
}
function HCe(e) {
  return e >= 0 && e <= 8 || e === 11 || e >= 14 && e <= 31 || e === 127;
}
function vx(e) {
  return e === 10 || e === 13 || e === 12;
}
function rh(e) {
  return vx(e) || e === 32 || e === 9;
}
function hs(e, t) {
  return !(e !== 92 || vx(t) || t === jCe);
}
function o1(e, t, r) {
  return e === 45 ? mx(t) || t === 45 || hs(t, r) : mx(e) ? !0 : e === 92 ? hs(e, t) : !1;
}
function w2(e, t, r) {
  return e === 43 || e === 45 ? io(t) ? 2 : t === 46 && io(r) ? 3 : 0 : e === 46 ? io(t) ? 2 : 0 : io(e) ? 1 : 0;
}
function JW(e) {
  return e === 65279 || e === 65534 ? 1 : 0;
}
const h$ = new Array(128), WCe = 128, a1 = 130, eV = 131, X4 = 132, tV = 133;
for (let e = 0; e < h$.length; e++)
  h$[e] = rh(e) && a1 || io(e) && eV || mx(e) && X4 || HCe(e) && tV || e || WCe;
function M2(e) {
  return e < 128 ? h$[e] : X4;
}
function op(e, t) {
  return t < e.length ? e.charCodeAt(t) : 0;
}
function p$(e, t, r) {
  return r === 13 && op(e, t + 1) === 10 ? 2 : 1;
}
function ap(e, t, r) {
  let n = e.charCodeAt(t);
  return K4(n) && (n = n | 32), n === r;
}
function R0(e, t, r, n) {
  if (r - t !== n.length || t < 0 || r > e.length)
    return !1;
  for (let i = t; i < r; i++) {
    const o = n.charCodeAt(i - t);
    let a = e.charCodeAt(i);
    if (K4(a) && (a = a | 32), a !== o)
      return !1;
  }
  return !0;
}
function VCe(e, t) {
  for (; t >= 0 && rh(e.charCodeAt(t)); t--)
    ;
  return t + 1;
}
function yy(e, t) {
  for (; t < e.length && rh(e.charCodeAt(t)); t++)
    ;
  return t;
}
function C2(e, t) {
  for (; t < e.length && io(e.charCodeAt(t)); t++)
    ;
  return t;
}
function Mp(e, t) {
  if (t += 2, kc(op(e, t - 1))) {
    for (const n = Math.min(e.length, t + 5); t < n && kc(op(e, t)); t++)
      ;
    const r = op(e, t);
    rh(r) && (t += p$(e, t, r));
  }
  return t;
}
function xy(e, t) {
  for (; t < e.length; t++) {
    const r = e.charCodeAt(t);
    if (!XW(r)) {
      if (hs(r, op(e, t + 1))) {
        t = Mp(e, t) - 1;
        continue;
      }
      break;
    }
  }
  return t;
}
function KM(e, t) {
  let r = e.charCodeAt(t);
  if ((r === 43 || r === 45) && (r = e.charCodeAt(t += 1)), io(r) && (t = C2(e, t + 1), r = e.charCodeAt(t)), r === 46 && io(e.charCodeAt(t + 1)) && (t += 2, t = C2(e, t)), ap(e, t, 101)) {
    let n = 0;
    r = e.charCodeAt(t + 1), (r === 45 || r === 43) && (n = 1, r = e.charCodeAt(t + 2)), io(r) && (t = C2(e, t + 1 + n + 1));
  }
  return t;
}
function S2(e, t) {
  for (; t < e.length; t++) {
    const r = e.charCodeAt(t);
    if (r === 41) {
      t++;
      break;
    }
    hs(r, op(e, t + 1)) && (t = Mp(e, t));
  }
  return t;
}
function rV(e) {
  if (e.length === 1 && !kc(e.charCodeAt(0)))
    return e[0];
  let t = parseInt(e, 16);
  return (t === 0 || t >= 55296 && t <= 57343 || t > 1114111) && (t = 65533), String.fromCodePoint(t);
}
var nV = [
  "EOF-token",
  "ident-token",
  "function-token",
  "at-keyword-token",
  "hash-token",
  "string-token",
  "bad-string-token",
  "url-token",
  "bad-url-token",
  "delim-token",
  "number-token",
  "percentage-token",
  "dimension-token",
  "whitespace-token",
  "CDO-token",
  "CDC-token",
  "colon-token",
  "semicolon-token",
  "comma-token",
  "[-token",
  "]-token",
  "(-token",
  ")-token",
  "{-token",
  "}-token"
];
const YCe = 16 * 1024;
function bx(e = null, t) {
  return e === null || e.length < t ? new Uint32Array(Math.max(t + 1024, YCe)) : e;
}
const JR = 10, QCe = 12, e5 = 13;
function t5(e) {
  const t = e.source, r = t.length, n = t.length > 0 ? JW(t.charCodeAt(0)) : 0, i = bx(e.lines, r), o = bx(e.columns, r);
  let a = e.startLine, s = e.startColumn;
  for (let u = n; u < r; u++) {
    const d = t.charCodeAt(u);
    i[u] = a, o[u] = s++, (d === JR || d === e5 || d === QCe) && (d === e5 && u + 1 < r && t.charCodeAt(u + 1) === JR && (u++, i[u] = a, o[u] = s), a++, s = 1);
  }
  i[r] = a, o[r] = s, e.lines = i, e.columns = o, e.computed = !0;
}
class qCe {
  constructor() {
    this.lines = null, this.columns = null, this.computed = !1;
  }
  setSource(t, r = 0, n = 1, i = 1) {
    this.source = t, this.startOffset = r, this.startLine = n, this.startColumn = i, this.computed = !1;
  }
  getLocation(t, r) {
    return this.computed || t5(this), {
      source: r,
      offset: this.startOffset + t,
      line: this.lines[t],
      column: this.columns[t]
    };
  }
  getLocationRange(t, r, n) {
    return this.computed || t5(this), {
      source: n,
      start: {
        offset: this.startOffset + t,
        line: this.lines[t],
        column: this.columns[t]
      },
      end: {
        offset: this.startOffset + r,
        line: this.lines[r],
        column: this.columns[r]
      }
    };
  }
}
const qa = 16777215, Ku = 24, GCe = /* @__PURE__ */ new Map([
  [Kr, kn],
  [Ki, kn],
  [Va, Wl],
  [zo, ul]
]);
class ZCe {
  constructor(t, r) {
    this.setSource(t, r);
  }
  reset() {
    this.eof = !1, this.tokenIndex = -1, this.tokenType = 0, this.tokenStart = this.firstCharOffset, this.tokenEnd = this.firstCharOffset;
  }
  setSource(t = "", r = () => {
  }) {
    t = String(t || "");
    const n = t.length, i = bx(this.offsetAndType, t.length + 1), o = bx(this.balance, t.length + 1);
    let a = 0, s = 0, u = 0, d = -1;
    for (this.offsetAndType = null, this.balance = null, r(t, (f, h, g) => {
      switch (f) {
        default:
          o[a] = n;
          break;
        case s: {
          let m = u & qa;
          for (u = o[m], s = u >> Ku, o[a] = m, o[m++] = a; m < a; m++)
            o[m] === n && (o[m] = a);
          break;
        }
        case Ki:
        case Kr:
        case Va:
        case zo:
          o[a] = u, s = GCe.get(f), u = s << Ku | a;
          break;
      }
      i[a++] = f << Ku | g, d === -1 && (d = h);
    }), i[a] = x2 << Ku | n, o[a] = n, o[n] = n; u !== 0; ) {
      const f = u & qa;
      u = o[f], o[f] = n;
    }
    this.source = t, this.firstCharOffset = d === -1 ? 0 : d, this.tokenCount = a, this.offsetAndType = i, this.balance = o, this.reset(), this.next();
  }
  lookupType(t) {
    return t += this.tokenIndex, t < this.tokenCount ? this.offsetAndType[t] >> Ku : x2;
  }
  lookupOffset(t) {
    return t += this.tokenIndex, t < this.tokenCount ? this.offsetAndType[t - 1] & qa : this.source.length;
  }
  lookupValue(t, r) {
    return t += this.tokenIndex, t < this.tokenCount ? R0(this.source, this.offsetAndType[t - 1] & qa, this.offsetAndType[t] & qa, r) : !1;
  }
  getTokenStart(t) {
    return t === this.tokenIndex ? this.tokenStart : t > 0 ? t < this.tokenCount ? this.offsetAndType[t - 1] & qa : this.offsetAndType[this.tokenCount] & qa : this.firstCharOffset;
  }
  substrToCursor(t) {
    return this.source.substring(t, this.tokenStart);
  }
  isBalanceEdge(t) {
    return this.balance[this.tokenIndex] < t;
  }
  isDelim(t, r) {
    return r ? this.lookupType(r) === Zr && this.source.charCodeAt(this.lookupOffset(r)) === t : this.tokenType === Zr && this.source.charCodeAt(this.tokenStart) === t;
  }
  skip(t) {
    let r = this.tokenIndex + t;
    r < this.tokenCount ? (this.tokenIndex = r, this.tokenStart = this.offsetAndType[r - 1] & qa, r = this.offsetAndType[r], this.tokenType = r >> Ku, this.tokenEnd = r & qa) : (this.tokenIndex = this.tokenCount, this.next());
  }
  next() {
    let t = this.tokenIndex + 1;
    t < this.tokenCount ? (this.tokenIndex = t, this.tokenStart = this.tokenEnd, t = this.offsetAndType[t], this.tokenType = t >> Ku, this.tokenEnd = t & qa) : (this.eof = !0, this.tokenIndex = this.tokenCount, this.tokenType = x2, this.tokenStart = this.tokenEnd = this.source.length);
  }
  skipSC() {
    for (; this.tokenType === yi || this.tokenType === Xo; )
      this.next();
  }
  skipUntilBalanced(t, r) {
    let n = t, i, o;
    e:
      for (; n < this.tokenCount; n++) {
        if (i = this.balance[n], i < t)
          break e;
        switch (o = n > 0 ? this.offsetAndType[n - 1] & qa : this.firstCharOffset, r(this.source.charCodeAt(o))) {
          case 1:
            break e;
          case 2:
            n++;
            break e;
          default:
            this.balance[i] === n && (n = i);
        }
      }
    this.skip(n - this.tokenIndex);
  }
  forEachToken(t) {
    for (let r = 0, n = this.firstCharOffset; r < this.tokenCount; r++) {
      const i = n, o = this.offsetAndType[r], a = o & qa, s = o >> Ku;
      n = a, t(s, i, a, r);
    }
  }
  dump() {
    const t = new Array(this.tokenCount);
    return this.forEachToken((r, n, i, o) => {
      t[o] = {
        idx: o,
        type: nV[r],
        chunk: this.source.substring(n, i),
        balance: this.balance[o]
      };
    }), t;
  }
}
function XM(e, t) {
  function r(h) {
    return h < s ? e.charCodeAt(h) : 0;
  }
  function n() {
    if (d = KM(e, d), o1(r(d), r(d + 1), r(d + 2))) {
      f = qr, d = xy(e, d);
      return;
    }
    if (r(d) === 37) {
      f = ui, d++;
      return;
    }
    f = xr;
  }
  function i() {
    const h = d;
    if (d = xy(e, d), R0(e, h, d, "url") && r(d) === 40) {
      if (d = yy(e, d + 1), r(d) === 34 || r(d) === 39) {
        f = Kr, d = h + 4;
        return;
      }
      a();
      return;
    }
    if (r(d) === 40) {
      f = Kr, d++;
      return;
    }
    f = Wt;
  }
  function o(h) {
    for (h || (h = r(d++)), f = Ns; d < e.length; d++) {
      const g = e.charCodeAt(d);
      switch (M2(g)) {
        case h:
          d++;
          return;
        case a1:
          if (vx(g)) {
            d += p$(e, d, g), f = ZM;
            return;
          }
          break;
        case 92:
          if (d === e.length - 1)
            break;
          const m = r(d + 1);
          vx(m) ? d += p$(e, d + 1, m) : hs(g, m) && (d = Mp(e, d) - 1);
          break;
      }
    }
  }
  function a() {
    for (f = Ao, d = yy(e, d); d < e.length; d++) {
      const h = e.charCodeAt(d);
      switch (M2(h)) {
        case 41:
          d++;
          return;
        case a1:
          if (d = yy(e, d), r(d) === 41 || d >= e.length) {
            d < e.length && d++;
            return;
          }
          d = S2(e, d), f = la;
          return;
        case 34:
        case 39:
        case 40:
        case tV:
          d = S2(e, d), f = la;
          return;
        case 92:
          if (hs(h, r(d + 1))) {
            d = Mp(e, d) - 1;
            break;
          }
          d = S2(e, d), f = la;
          return;
      }
    }
  }
  e = String(e || "");
  const s = e.length;
  let u = JW(r(0)), d = u, f;
  for (; d < s; ) {
    const h = e.charCodeAt(d);
    switch (M2(h)) {
      case a1:
        f = yi, d = yy(e, d + 1);
        break;
      case 34:
        o();
        break;
      case 35:
        XW(r(d + 1)) || hs(r(d + 1), r(d + 2)) ? (f = Pn, d = xy(e, d + 1)) : (f = Zr, d++);
        break;
      case 39:
        o();
        break;
      case 40:
        f = Ki, d++;
        break;
      case 41:
        f = kn, d++;
        break;
      case 43:
        w2(h, r(d + 1), r(d + 2)) ? n() : (f = Zr, d++);
        break;
      case 44:
        f = zs, d++;
        break;
      case 45:
        w2(h, r(d + 1), r(d + 2)) ? n() : r(d + 1) === 45 && r(d + 2) === 62 ? (f = sa, d = d + 3) : o1(h, r(d + 1), r(d + 2)) ? i() : (f = Zr, d++);
        break;
      case 46:
        w2(h, r(d + 1), r(d + 2)) ? n() : (f = Zr, d++);
        break;
      case 47:
        r(d + 1) === 42 ? (f = Xo, d = e.indexOf("*/", d + 2), d = d === -1 ? e.length : d + 2) : (f = Zr, d++);
        break;
      case 58:
        f = No, d++;
        break;
      case 59:
        f = ga, d++;
        break;
      case 60:
        r(d + 1) === 33 && r(d + 2) === 45 && r(d + 3) === 45 ? (f = Db, d = d + 4) : (f = Zr, d++);
        break;
      case 64:
        o1(r(d + 1), r(d + 2), r(d + 3)) ? (f = zi, d = xy(e, d + 1)) : (f = Zr, d++);
        break;
      case 91:
        f = Va, d++;
        break;
      case 92:
        hs(h, r(d + 1)) ? i() : (f = Zr, d++);
        break;
      case 93:
        f = Wl, d++;
        break;
      case 123:
        f = zo, d++;
        break;
      case 125:
        f = ul, d++;
        break;
      case eV:
        n();
        break;
      case X4:
        i();
        break;
      default:
        f = Zr, d++;
    }
    t(f, u, u = d);
  }
}
let Oh = null;
class eo {
  static createItem(t) {
    return {
      prev: null,
      next: null,
      data: t
    };
  }
  constructor() {
    this.head = null, this.tail = null, this.cursor = null;
  }
  createItem(t) {
    return eo.createItem(t);
  }
  allocateCursor(t, r) {
    let n;
    return Oh !== null ? (n = Oh, Oh = Oh.cursor, n.prev = t, n.next = r, n.cursor = this.cursor) : n = {
      prev: t,
      next: r,
      cursor: this.cursor
    }, this.cursor = n, n;
  }
  releaseCursor() {
    const { cursor: t } = this;
    this.cursor = t.cursor, t.prev = null, t.next = null, t.cursor = Oh, Oh = t;
  }
  updateCursors(t, r, n, i) {
    let { cursor: o } = this;
    for (; o !== null; )
      o.prev === t && (o.prev = r), o.next === n && (o.next = i), o = o.cursor;
  }
  *[Symbol.iterator]() {
    for (let t = this.head; t !== null; t = t.next)
      yield t.data;
  }
  get size() {
    let t = 0;
    for (let r = this.head; r !== null; r = r.next)
      t++;
    return t;
  }
  get isEmpty() {
    return this.head === null;
  }
  get first() {
    return this.head && this.head.data;
  }
  get last() {
    return this.tail && this.tail.data;
  }
  fromArray(t) {
    let r = null;
    this.head = null;
    for (let n of t) {
      const i = eo.createItem(n);
      r !== null ? r.next = i : this.head = i, i.prev = r, r = i;
    }
    return this.tail = r, this;
  }
  toArray() {
    return [...this];
  }
  toJSON() {
    return [...this];
  }
  forEach(t, r = this) {
    const n = this.allocateCursor(null, this.head);
    for (; n.next !== null; ) {
      const i = n.next;
      n.next = i.next, t.call(r, i.data, i, this);
    }
    this.releaseCursor();
  }
  forEachRight(t, r = this) {
    const n = this.allocateCursor(this.tail, null);
    for (; n.prev !== null; ) {
      const i = n.prev;
      n.prev = i.prev, t.call(r, i.data, i, this);
    }
    this.releaseCursor();
  }
  reduce(t, r, n = this) {
    let i = this.allocateCursor(null, this.head), o = r, a;
    for (; i.next !== null; )
      a = i.next, i.next = a.next, o = t.call(n, o, a.data, a, this);
    return this.releaseCursor(), o;
  }
  reduceRight(t, r, n = this) {
    let i = this.allocateCursor(this.tail, null), o = r, a;
    for (; i.prev !== null; )
      a = i.prev, i.prev = a.prev, o = t.call(n, o, a.data, a, this);
    return this.releaseCursor(), o;
  }
  some(t, r = this) {
    for (let n = this.head; n !== null; n = n.next)
      if (t.call(r, n.data, n, this))
        return !0;
    return !1;
  }
  map(t, r = this) {
    const n = new eo();
    for (let i = this.head; i !== null; i = i.next)
      n.appendData(t.call(r, i.data, i, this));
    return n;
  }
  filter(t, r = this) {
    const n = new eo();
    for (let i = this.head; i !== null; i = i.next)
      t.call(r, i.data, i, this) && n.appendData(i.data);
    return n;
  }
  nextUntil(t, r, n = this) {
    if (t === null)
      return;
    const i = this.allocateCursor(null, t);
    for (; i.next !== null; ) {
      const o = i.next;
      if (i.next = o.next, r.call(n, o.data, o, this))
        break;
    }
    this.releaseCursor();
  }
  prevUntil(t, r, n = this) {
    if (t === null)
      return;
    const i = this.allocateCursor(t, null);
    for (; i.prev !== null; ) {
      const o = i.prev;
      if (i.prev = o.prev, r.call(n, o.data, o, this))
        break;
    }
    this.releaseCursor();
  }
  clear() {
    this.head = null, this.tail = null;
  }
  copy() {
    const t = new eo();
    for (let r of this)
      t.appendData(r);
    return t;
  }
  prepend(t) {
    return this.updateCursors(null, t, this.head, t), this.head !== null ? (this.head.prev = t, t.next = this.head) : this.tail = t, this.head = t, this;
  }
  prependData(t) {
    return this.prepend(eo.createItem(t));
  }
  append(t) {
    return this.insert(t);
  }
  appendData(t) {
    return this.insert(eo.createItem(t));
  }
  insert(t, r = null) {
    if (r !== null)
      if (this.updateCursors(r.prev, t, r, t), r.prev === null) {
        if (this.head !== r)
          throw new Error("before doesn't belong to list");
        this.head = t, r.prev = t, t.next = r, this.updateCursors(null, t);
      } else
        r.prev.next = t, t.prev = r.prev, r.prev = t, t.next = r;
    else
      this.updateCursors(this.tail, t, null, t), this.tail !== null ? (this.tail.next = t, t.prev = this.tail) : this.head = t, this.tail = t;
    return this;
  }
  insertData(t, r) {
    return this.insert(eo.createItem(t), r);
  }
  remove(t) {
    if (this.updateCursors(t, t.prev, t, t.next), t.prev !== null)
      t.prev.next = t.next;
    else {
      if (this.head !== t)
        throw new Error("item doesn't belong to list");
      this.head = t.next;
    }
    if (t.next !== null)
      t.next.prev = t.prev;
    else {
      if (this.tail !== t)
        throw new Error("item doesn't belong to list");
      this.tail = t.prev;
    }
    return t.prev = null, t.next = null, t;
  }
  push(t) {
    this.insert(eo.createItem(t));
  }
  pop() {
    return this.tail !== null ? this.remove(this.tail) : null;
  }
  unshift(t) {
    this.prepend(eo.createItem(t));
  }
  shift() {
    return this.head !== null ? this.remove(this.head) : null;
  }
  prependList(t) {
    return this.insertList(t, this.head);
  }
  appendList(t) {
    return this.insertList(t);
  }
  insertList(t, r) {
    return t.head === null ? this : (r != null ? (this.updateCursors(r.prev, t.tail, r, t.head), r.prev !== null ? (r.prev.next = t.head, t.head.prev = r.prev) : this.head = t.head, r.prev = t.tail, t.tail.next = r) : (this.updateCursors(this.tail, t.tail, null, t.head), this.tail !== null ? (this.tail.next = t.head, t.head.prev = this.tail) : this.head = t.head, this.tail = t.tail), t.head = null, t.tail = null, this);
  }
  replace(t, r) {
    "head" in r ? this.insertList(r, t) : this.insert(r, t), this.remove(t);
  }
}
function JM(e, t) {
  const r = Object.create(SyntaxError.prototype), n = new Error();
  return Object.assign(r, {
    name: e,
    message: t,
    get stack() {
      return (n.stack || "").replace(/^(.+\n){1,3}/, `${e}: ${t}
`);
    }
  });
}
const T2 = 100, r5 = 60, n5 = "    ";
function i5({ source: e, line: t, column: r }, n) {
  function i(f, h) {
    return o.slice(f, h).map((g, m) => String(f + m + 1).padStart(u) + " |" + g).join(`
`);
  }
  const o = e.split(/\r\n?|\n|\f/), a = Math.max(1, t - n) - 1, s = Math.min(t + n, o.length + 1), u = Math.max(4, String(s).length) + 1;
  let d = 0;
  r += (n5.length - 1) * (o[t - 1].substr(0, r - 1).match(/\t/g) || []).length, r > T2 && (d = r - r5 + 3, r = r5 - 2);
  for (let f = a; f <= s; f++)
    f >= 0 && f < o.length && (o[f] = o[f].replace(/\t/g, n5), o[f] = (d > 0 && o[f].length > d ? "…" : "") + o[f].substr(d, T2 - 2) + (o[f].length > d + T2 - 1 ? "…" : ""));
  return [
    i(a, t),
    new Array(r + u + 2).join("-") + "^",
    i(t, s)
  ].filter(Boolean).join(`
`);
}
function o5(e, t, r, n, i) {
  return Object.assign(JM("SyntaxError", e), {
    source: t,
    offset: r,
    line: n,
    column: i,
    sourceFragment(a) {
      return i5({ source: t, line: n, column: i }, isNaN(a) ? 0 : a);
    },
    get formattedMessage() {
      return `Parse error: ${e}
` + i5({ source: t, line: n, column: i }, 2);
    }
  });
}
function KCe(e) {
  const t = this.createList();
  let r = !1;
  const n = {
    recognizer: e
  };
  for (; !this.eof; ) {
    switch (this.tokenType) {
      case Xo:
        this.next();
        continue;
      case yi:
        r = !0, this.next();
        continue;
    }
    let i = e.getNode.call(this, n);
    if (i === void 0)
      break;
    r && (e.onWhiteSpace && e.onWhiteSpace.call(this, i, t, n), r = !1), t.push(i);
  }
  return r && e.onWhiteSpace && e.onWhiteSpace.call(this, null, t, n), t;
}
const a5 = () => {
}, XCe = 33, JCe = 35, k2 = 59, l5 = 123, s5 = 0;
function eSe(e) {
  return function() {
    return this[e]();
  };
}
function D2(e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const r in e) {
    const n = e[r], i = n.parse || n;
    i && (t[r] = i);
  }
  return t;
}
function tSe(e) {
  const t = {
    context: /* @__PURE__ */ Object.create(null),
    scope: Object.assign(/* @__PURE__ */ Object.create(null), e.scope),
    atrule: D2(e.atrule),
    pseudo: D2(e.pseudo),
    node: D2(e.node)
  };
  for (const r in e.parseContext)
    switch (typeof e.parseContext[r]) {
      case "function":
        t.context[r] = e.parseContext[r];
        break;
      case "string":
        t.context[r] = eSe(e.parseContext[r]);
        break;
    }
  return vt(vt({
    config: t
  }, t), t.node);
}
function rSe(e) {
  let t = "", r = "<unknown>", n = !1, i = a5, o = !1;
  const a = new qCe(), s = Object.assign(new ZCe(), tSe(e || {}), {
    parseAtrulePrelude: !0,
    parseRulePrelude: !0,
    parseValue: !0,
    parseCustomProperty: !1,
    readSequence: KCe,
    consumeUntilBalanceEnd: () => 0,
    consumeUntilLeftCurlyBracket(d) {
      return d === l5 ? 1 : 0;
    },
    consumeUntilLeftCurlyBracketOrSemicolon(d) {
      return d === l5 || d === k2 ? 1 : 0;
    },
    consumeUntilExclamationMarkOrSemicolon(d) {
      return d === XCe || d === k2 ? 1 : 0;
    },
    consumeUntilSemicolonIncluded(d) {
      return d === k2 ? 2 : 0;
    },
    createList() {
      return new eo();
    },
    createSingleNodeList(d) {
      return new eo().appendData(d);
    },
    getFirstListNode(d) {
      return d && d.first;
    },
    getLastListNode(d) {
      return d && d.last;
    },
    parseWithFallback(d, f) {
      const h = this.tokenIndex;
      try {
        return d.call(this);
      } catch (g) {
        if (o)
          throw g;
        const m = f.call(this, h);
        return o = !0, i(g, m), o = !1, m;
      }
    },
    lookupNonWSType(d) {
      let f;
      do
        if (f = this.lookupType(d++), f !== yi)
          return f;
      while (f !== s5);
      return s5;
    },
    charCodeAt(d) {
      return d >= 0 && d < t.length ? t.charCodeAt(d) : 0;
    },
    substring(d, f) {
      return t.substring(d, f);
    },
    substrToCursor(d) {
      return this.source.substring(d, this.tokenStart);
    },
    cmpChar(d, f) {
      return ap(t, d, f);
    },
    cmpStr(d, f, h) {
      return R0(t, d, f, h);
    },
    consume(d) {
      const f = this.tokenStart;
      return this.eat(d), this.substrToCursor(f);
    },
    consumeFunctionName() {
      const d = t.substring(this.tokenStart, this.tokenEnd - 1);
      return this.eat(Kr), d;
    },
    consumeNumber(d) {
      const f = t.substring(this.tokenStart, KM(t, this.tokenStart));
      return this.eat(d), f;
    },
    eat(d) {
      if (this.tokenType !== d) {
        const f = nV[d].slice(0, -6).replace(/-/g, " ").replace(/^./, (m) => m.toUpperCase());
        let h = `${/[[\](){}]/.test(f) ? `"${f}"` : f} is expected`, g = this.tokenStart;
        switch (d) {
          case Wt:
            this.tokenType === Kr || this.tokenType === Ao ? (g = this.tokenEnd - 1, h = "Identifier is expected but function found") : h = "Identifier is expected";
            break;
          case Pn:
            this.isDelim(JCe) && (this.next(), g++, h = "Name is expected");
            break;
          case ui:
            this.tokenType === xr && (g = this.tokenEnd, h = "Percent sign is expected");
            break;
        }
        this.error(h, g);
      }
      this.next();
    },
    eatIdent(d) {
      (this.tokenType !== Wt || this.lookupValue(0, d) === !1) && this.error(`Identifier "${d}" is expected`), this.next();
    },
    eatDelim(d) {
      this.isDelim(d) || this.error(`Delim "${String.fromCharCode(d)}" is expected`), this.next();
    },
    getLocation(d, f) {
      return n ? a.getLocationRange(d, f, r) : null;
    },
    getLocationFromList(d) {
      if (n) {
        const f = this.getFirstListNode(d), h = this.getLastListNode(d);
        return a.getLocationRange(f !== null ? f.loc.start.offset - a.startOffset : this.tokenStart, h !== null ? h.loc.end.offset - a.startOffset : this.tokenStart, r);
      }
      return null;
    },
    error(d, f) {
      const h = typeof f < "u" && f < t.length ? a.getLocation(f) : this.eof ? a.getLocation(VCe(t, t.length - 1)) : a.getLocation(this.tokenStart);
      throw new o5(d || "Unexpected input", t, h.offset, h.line, h.column);
    }
  });
  return Object.assign(function(d, f) {
    t = d, f = f || {}, s.setSource(t, XM), a.setSource(t, f.offset, f.line, f.column), r = f.filename || "<unknown>", n = Boolean(f.positions), i = typeof f.onParseError == "function" ? f.onParseError : a5, o = !1, s.parseAtrulePrelude = "parseAtrulePrelude" in f ? Boolean(f.parseAtrulePrelude) : !0, s.parseRulePrelude = "parseRulePrelude" in f ? Boolean(f.parseRulePrelude) : !0, s.parseValue = "parseValue" in f ? Boolean(f.parseValue) : !0, s.parseCustomProperty = "parseCustomProperty" in f ? Boolean(f.parseCustomProperty) : !1;
    const { context: h = "default", onComment: g } = f;
    if (!(h in s.context))
      throw new Error("Unknown context `" + h + "`");
    typeof g == "function" && s.forEachToken((v, w, x) => {
      if (v === Xo) {
        const y = s.getLocation(w, x), C = R0(t, x - 2, x, "*/") ? t.slice(w + 2, x - 2) : t.slice(w + 2, x);
        g(C, y);
      }
    });
    const m = s.context[h].call(s, f);
    return s.eof || s.error(), m;
  }, {
    SyntaxError: o5,
    config: s.config
  });
}
var J4 = {}, e_ = {}, u5 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
e_.encode = function(e) {
  if (0 <= e && e < u5.length)
    return u5[e];
  throw new TypeError("Must be between 0 and 63: " + e);
};
e_.decode = function(e) {
  var t = 65, r = 90, n = 97, i = 122, o = 48, a = 57, s = 43, u = 47, d = 26, f = 52;
  return t <= e && e <= r ? e - t : n <= e && e <= i ? e - n + d : o <= e && e <= a ? e - o + f : e == s ? 62 : e == u ? 63 : -1;
};
var iV = e_, t_ = 5, oV = 1 << t_, aV = oV - 1, lV = oV;
function nSe(e) {
  return e < 0 ? (-e << 1) + 1 : (e << 1) + 0;
}
function iSe(e) {
  var t = (e & 1) === 1, r = e >> 1;
  return t ? -r : r;
}
J4.encode = function(t) {
  var r = "", n, i = nSe(t);
  do
    n = i & aV, i >>>= t_, i > 0 && (n |= lV), r += iV.encode(n);
  while (i > 0);
  return r;
};
J4.decode = function(t, r, n) {
  var i = t.length, o = 0, a = 0, s, u;
  do {
    if (r >= i)
      throw new Error("Expected more digits in base 64 VLQ value.");
    if (u = iV.decode(t.charCodeAt(r++)), u === -1)
      throw new Error("Invalid base64 digit: " + t.charAt(r - 1));
    s = !!(u & lV), u &= aV, o = o + (u << a), a += t_;
  } while (s);
  n.value = iSe(o), n.rest = r;
};
var eC = {};
(function(e) {
  function t(N, I, $) {
    if (I in N)
      return N[I];
    if (arguments.length === 3)
      return $;
    throw new Error('"' + I + '" is a required argument.');
  }
  e.getArg = t;
  var r = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/, n = /^data:.+\,.+$/;
  function i(N) {
    var I = N.match(r);
    return I ? {
      scheme: I[1],
      auth: I[2],
      host: I[3],
      port: I[4],
      path: I[5]
    } : null;
  }
  e.urlParse = i;
  function o(N) {
    var I = "";
    return N.scheme && (I += N.scheme + ":"), I += "//", N.auth && (I += N.auth + "@"), N.host && (I += N.host), N.port && (I += ":" + N.port), N.path && (I += N.path), I;
  }
  e.urlGenerate = o;
  var a = 32;
  function s(N) {
    var I = [];
    return function($) {
      for (var _ = 0; _ < I.length; _++)
        if (I[_].input === $) {
          var R = I[0];
          return I[0] = I[_], I[_] = R, I[0].result;
        }
      var U = N($);
      return I.unshift({
        input: $,
        result: U
      }), I.length > a && I.pop(), U;
    };
  }
  var u = s(function(I) {
    var $ = I, _ = i(I);
    if (_) {
      if (!_.path)
        return I;
      $ = _.path;
    }
    for (var R = e.isAbsolute($), U = [], Q = 0, Z = 0; ; )
      if (Q = Z, Z = $.indexOf("/", Q), Z === -1) {
        U.push($.slice(Q));
        break;
      } else
        for (U.push($.slice(Q, Z)); Z < $.length && $[Z] === "/"; )
          Z++;
    for (var X, re = 0, Z = U.length - 1; Z >= 0; Z--)
      X = U[Z], X === "." ? U.splice(Z, 1) : X === ".." ? re++ : re > 0 && (X === "" ? (U.splice(Z + 1, re), re = 0) : (U.splice(Z, 2), re--));
    return $ = U.join("/"), $ === "" && ($ = R ? "/" : "."), _ ? (_.path = $, o(_)) : $;
  });
  e.normalize = u;
  function d(N, I) {
    N === "" && (N = "."), I === "" && (I = ".");
    var $ = i(I), _ = i(N);
    if (_ && (N = _.path || "/"), $ && !$.scheme)
      return _ && ($.scheme = _.scheme), o($);
    if ($ || I.match(n))
      return I;
    if (_ && !_.host && !_.path)
      return _.host = I, o(_);
    var R = I.charAt(0) === "/" ? I : u(N.replace(/\/+$/, "") + "/" + I);
    return _ ? (_.path = R, o(_)) : R;
  }
  e.join = d, e.isAbsolute = function(N) {
    return N.charAt(0) === "/" || r.test(N);
  };
  function f(N, I) {
    N === "" && (N = "."), N = N.replace(/\/$/, "");
    for (var $ = 0; I.indexOf(N + "/") !== 0; ) {
      var _ = N.lastIndexOf("/");
      if (_ < 0 || (N = N.slice(0, _), N.match(/^([^\/]+:\/)?\/*$/)))
        return I;
      ++$;
    }
    return Array($ + 1).join("../") + I.substr(N.length + 1);
  }
  e.relative = f;
  var h = function() {
    var N = /* @__PURE__ */ Object.create(null);
    return !("__proto__" in N);
  }();
  function g(N) {
    return N;
  }
  function m(N) {
    return w(N) ? "$" + N : N;
  }
  e.toSetString = h ? g : m;
  function v(N) {
    return w(N) ? N.slice(1) : N;
  }
  e.fromSetString = h ? g : v;
  function w(N) {
    if (!N)
      return !1;
    var I = N.length;
    if (I < 9 || N.charCodeAt(I - 1) !== 95 || N.charCodeAt(I - 2) !== 95 || N.charCodeAt(I - 3) !== 111 || N.charCodeAt(I - 4) !== 116 || N.charCodeAt(I - 5) !== 111 || N.charCodeAt(I - 6) !== 114 || N.charCodeAt(I - 7) !== 112 || N.charCodeAt(I - 8) !== 95 || N.charCodeAt(I - 9) !== 95)
      return !1;
    for (var $ = I - 10; $ >= 0; $--)
      if (N.charCodeAt($) !== 36)
        return !1;
    return !0;
  }
  function x(N, I, $) {
    var _ = T(N.source, I.source);
    return _ !== 0 || (_ = N.originalLine - I.originalLine, _ !== 0) || (_ = N.originalColumn - I.originalColumn, _ !== 0 || $) || (_ = N.generatedColumn - I.generatedColumn, _ !== 0) || (_ = N.generatedLine - I.generatedLine, _ !== 0) ? _ : T(N.name, I.name);
  }
  e.compareByOriginalPositions = x;
  function y(N, I, $) {
    var _;
    return _ = N.originalLine - I.originalLine, _ !== 0 || (_ = N.originalColumn - I.originalColumn, _ !== 0 || $) || (_ = N.generatedColumn - I.generatedColumn, _ !== 0) || (_ = N.generatedLine - I.generatedLine, _ !== 0) ? _ : T(N.name, I.name);
  }
  e.compareByOriginalPositionsNoSource = y;
  function C(N, I, $) {
    var _ = N.generatedLine - I.generatedLine;
    return _ !== 0 || (_ = N.generatedColumn - I.generatedColumn, _ !== 0 || $) || (_ = T(N.source, I.source), _ !== 0) || (_ = N.originalLine - I.originalLine, _ !== 0) || (_ = N.originalColumn - I.originalColumn, _ !== 0) ? _ : T(N.name, I.name);
  }
  e.compareByGeneratedPositionsDeflated = C;
  function S(N, I, $) {
    var _ = N.generatedColumn - I.generatedColumn;
    return _ !== 0 || $ || (_ = T(N.source, I.source), _ !== 0) || (_ = N.originalLine - I.originalLine, _ !== 0) || (_ = N.originalColumn - I.originalColumn, _ !== 0) ? _ : T(N.name, I.name);
  }
  e.compareByGeneratedPositionsDeflatedNoLine = S;
  function T(N, I) {
    return N === I ? 0 : N === null ? 1 : I === null ? -1 : N > I ? 1 : -1;
  }
  function A(N, I) {
    var $ = N.generatedLine - I.generatedLine;
    return $ !== 0 || ($ = N.generatedColumn - I.generatedColumn, $ !== 0) || ($ = T(N.source, I.source), $ !== 0) || ($ = N.originalLine - I.originalLine, $ !== 0) || ($ = N.originalColumn - I.originalColumn, $ !== 0) ? $ : T(N.name, I.name);
  }
  e.compareByGeneratedPositionsInflated = A;
  function D(N) {
    return JSON.parse(N.replace(/^\)]}'[^\n]*\n/, ""));
  }
  e.parseSourceMapInput = D;
  function E(N, I, $) {
    if (I = I || "", N && (N[N.length - 1] !== "/" && I[0] !== "/" && (N += "/"), I = N + I), $) {
      var _ = i($);
      if (!_)
        throw new Error("sourceMapURL could not be parsed");
      if (_.path) {
        var R = _.path.lastIndexOf("/");
        R >= 0 && (_.path = _.path.substring(0, R + 1));
      }
      I = d(o(_), I);
    }
    return u(I);
  }
  e.computeSourceURL = E;
})(eC);
var sV = {}, r_ = eC, n_ = Object.prototype.hasOwnProperty, Wf = typeof Map < "u";
function Uu() {
  this._array = [], this._set = Wf ? /* @__PURE__ */ new Map() : /* @__PURE__ */ Object.create(null);
}
Uu.fromArray = function(t, r) {
  for (var n = new Uu(), i = 0, o = t.length; i < o; i++)
    n.add(t[i], r);
  return n;
};
Uu.prototype.size = function() {
  return Wf ? this._set.size : Object.getOwnPropertyNames(this._set).length;
};
Uu.prototype.add = function(t, r) {
  var n = Wf ? t : r_.toSetString(t), i = Wf ? this.has(t) : n_.call(this._set, n), o = this._array.length;
  (!i || r) && this._array.push(t), i || (Wf ? this._set.set(t, o) : this._set[n] = o);
};
Uu.prototype.has = function(t) {
  if (Wf)
    return this._set.has(t);
  var r = r_.toSetString(t);
  return n_.call(this._set, r);
};
Uu.prototype.indexOf = function(t) {
  if (Wf) {
    var r = this._set.get(t);
    if (r >= 0)
      return r;
  } else {
    var n = r_.toSetString(t);
    if (n_.call(this._set, n))
      return this._set[n];
  }
  throw new Error('"' + t + '" is not in the set.');
};
Uu.prototype.at = function(t) {
  if (t >= 0 && t < this._array.length)
    return this._array[t];
  throw new Error("No element indexed by " + t);
};
Uu.prototype.toArray = function() {
  return this._array.slice();
};
sV.ArraySet = Uu;
var uV = {}, cV = eC;
function oSe(e, t) {
  var r = e.generatedLine, n = t.generatedLine, i = e.generatedColumn, o = t.generatedColumn;
  return n > r || n == r && o >= i || cV.compareByGeneratedPositionsInflated(e, t) <= 0;
}
function tC() {
  this._array = [], this._sorted = !0, this._last = { generatedLine: -1, generatedColumn: 0 };
}
tC.prototype.unsortedForEach = function(t, r) {
  this._array.forEach(t, r);
};
tC.prototype.add = function(t) {
  oSe(this._last, t) ? (this._last = t, this._array.push(t)) : (this._sorted = !1, this._array.push(t));
};
tC.prototype.toArray = function() {
  return this._sorted || (this._array.sort(cV.compareByGeneratedPositionsInflated), this._sorted = !0), this._array;
};
uV.MappingList = tC;
var Ev = J4, Oi = eC, yx = sV.ArraySet, aSe = uV.MappingList;
function cl(e) {
  e || (e = {}), this._file = Oi.getArg(e, "file", null), this._sourceRoot = Oi.getArg(e, "sourceRoot", null), this._skipValidation = Oi.getArg(e, "skipValidation", !1), this._sources = new yx(), this._names = new yx(), this._mappings = new aSe(), this._sourcesContents = null;
}
cl.prototype._version = 3;
cl.fromSourceMap = function(t) {
  var r = t.sourceRoot, n = new cl({
    file: t.file,
    sourceRoot: r
  });
  return t.eachMapping(function(i) {
    var o = {
      generated: {
        line: i.generatedLine,
        column: i.generatedColumn
      }
    };
    i.source != null && (o.source = i.source, r != null && (o.source = Oi.relative(r, o.source)), o.original = {
      line: i.originalLine,
      column: i.originalColumn
    }, i.name != null && (o.name = i.name)), n.addMapping(o);
  }), t.sources.forEach(function(i) {
    var o = i;
    r !== null && (o = Oi.relative(r, i)), n._sources.has(o) || n._sources.add(o);
    var a = t.sourceContentFor(i);
    a != null && n.setSourceContent(i, a);
  }), n;
};
cl.prototype.addMapping = function(t) {
  var r = Oi.getArg(t, "generated"), n = Oi.getArg(t, "original", null), i = Oi.getArg(t, "source", null), o = Oi.getArg(t, "name", null);
  this._skipValidation || this._validateMapping(r, n, i, o), i != null && (i = String(i), this._sources.has(i) || this._sources.add(i)), o != null && (o = String(o), this._names.has(o) || this._names.add(o)), this._mappings.add({
    generatedLine: r.line,
    generatedColumn: r.column,
    originalLine: n != null && n.line,
    originalColumn: n != null && n.column,
    source: i,
    name: o
  });
};
cl.prototype.setSourceContent = function(t, r) {
  var n = t;
  this._sourceRoot != null && (n = Oi.relative(this._sourceRoot, n)), r != null ? (this._sourcesContents || (this._sourcesContents = /* @__PURE__ */ Object.create(null)), this._sourcesContents[Oi.toSetString(n)] = r) : this._sourcesContents && (delete this._sourcesContents[Oi.toSetString(n)], Object.keys(this._sourcesContents).length === 0 && (this._sourcesContents = null));
};
cl.prototype.applySourceMap = function(t, r, n) {
  var i = r;
  if (r == null) {
    if (t.file == null)
      throw new Error(`SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map's "file" property. Both were omitted.`);
    i = t.file;
  }
  var o = this._sourceRoot;
  o != null && (i = Oi.relative(o, i));
  var a = new yx(), s = new yx();
  this._mappings.unsortedForEach(function(u) {
    if (u.source === i && u.originalLine != null) {
      var d = t.originalPositionFor({
        line: u.originalLine,
        column: u.originalColumn
      });
      d.source != null && (u.source = d.source, n != null && (u.source = Oi.join(n, u.source)), o != null && (u.source = Oi.relative(o, u.source)), u.originalLine = d.line, u.originalColumn = d.column, d.name != null && (u.name = d.name));
    }
    var f = u.source;
    f != null && !a.has(f) && a.add(f);
    var h = u.name;
    h != null && !s.has(h) && s.add(h);
  }, this), this._sources = a, this._names = s, t.sources.forEach(function(u) {
    var d = t.sourceContentFor(u);
    d != null && (n != null && (u = Oi.join(n, u)), o != null && (u = Oi.relative(o, u)), this.setSourceContent(u, d));
  }, this);
};
cl.prototype._validateMapping = function(t, r, n, i) {
  if (r && typeof r.line != "number" && typeof r.column != "number")
    throw new Error("original.line and original.column are not numbers -- you probably meant to omit the original mapping entirely and only map the generated position. If so, pass null for the original mapping instead of an object with empty or null values.");
  if (!(t && "line" in t && "column" in t && t.line > 0 && t.column >= 0 && !r && !n && !i)) {
    if (t && "line" in t && "column" in t && r && "line" in r && "column" in r && t.line > 0 && t.column >= 0 && r.line > 0 && r.column >= 0 && n)
      return;
    throw new Error("Invalid mapping: " + JSON.stringify({
      generated: t,
      source: n,
      original: r,
      name: i
    }));
  }
};
cl.prototype._serializeMappings = function() {
  for (var t = 0, r = 1, n = 0, i = 0, o = 0, a = 0, s = "", u, d, f, h, g = this._mappings.toArray(), m = 0, v = g.length; m < v; m++) {
    if (d = g[m], u = "", d.generatedLine !== r)
      for (t = 0; d.generatedLine !== r; )
        u += ";", r++;
    else if (m > 0) {
      if (!Oi.compareByGeneratedPositionsInflated(d, g[m - 1]))
        continue;
      u += ",";
    }
    u += Ev.encode(d.generatedColumn - t), t = d.generatedColumn, d.source != null && (h = this._sources.indexOf(d.source), u += Ev.encode(h - a), a = h, u += Ev.encode(d.originalLine - 1 - i), i = d.originalLine - 1, u += Ev.encode(d.originalColumn - n), n = d.originalColumn, d.name != null && (f = this._names.indexOf(d.name), u += Ev.encode(f - o), o = f)), s += u;
  }
  return s;
};
cl.prototype._generateSourcesContent = function(t, r) {
  return t.map(function(n) {
    if (!this._sourcesContents)
      return null;
    r != null && (n = Oi.relative(r, n));
    var i = Oi.toSetString(n);
    return Object.prototype.hasOwnProperty.call(this._sourcesContents, i) ? this._sourcesContents[i] : null;
  }, this);
};
cl.prototype.toJSON = function() {
  var t = {
    version: this._version,
    sources: this._sources.toArray(),
    names: this._names.toArray(),
    mappings: this._serializeMappings()
  };
  return this._file != null && (t.file = this._file), this._sourceRoot != null && (t.sourceRoot = this._sourceRoot), this._sourcesContents && (t.sourcesContent = this._generateSourcesContent(t.sources, t.sourceRoot)), t;
};
cl.prototype.toString = function() {
  return JSON.stringify(this.toJSON());
};
var lSe = cl;
const c5 = /* @__PURE__ */ new Set(["Atrule", "Selector", "Declaration"]);
function sSe(e) {
  const t = new lSe(), r = {
    line: 1,
    column: 0
  }, n = {
    line: 0,
    column: 0
  }, i = {
    line: 1,
    column: 0
  }, o = {
    generated: i
  };
  let a = 1, s = 0, u = !1;
  const d = e.node;
  e.node = function(g) {
    if (g.loc && g.loc.start && c5.has(g.type)) {
      const m = g.loc.start.line, v = g.loc.start.column - 1;
      (n.line !== m || n.column !== v) && (n.line = m, n.column = v, r.line = a, r.column = s, u && (u = !1, (r.line !== i.line || r.column !== i.column) && t.addMapping(o)), u = !0, t.addMapping({
        source: g.loc.source,
        original: n,
        generated: r
      }));
    }
    d.call(this, g), u && c5.has(g.type) && (i.line = a, i.column = s);
  };
  const f = e.emit;
  e.emit = function(g, m, v) {
    for (let w = 0; w < g.length; w++)
      g.charCodeAt(w) === 10 ? (a++, s = 0) : s++;
    f(g, m, v);
  };
  const h = e.result;
  return e.result = function() {
    return u && t.addMapping(o), {
      css: h(),
      map: t
    };
  }, e;
}
const uSe = 43, cSe = 45, A2 = (e, t) => {
  if (e === Zr && (e = t), typeof e == "string") {
    const r = e.charCodeAt(0);
    return r > 127 ? 32768 : r << 8;
  }
  return e;
}, dV = [
  [Wt, Wt],
  [Wt, Kr],
  [Wt, Ao],
  [Wt, la],
  [Wt, "-"],
  [Wt, xr],
  [Wt, ui],
  [Wt, qr],
  [Wt, sa],
  [Wt, Ki],
  [zi, Wt],
  [zi, Kr],
  [zi, Ao],
  [zi, la],
  [zi, "-"],
  [zi, xr],
  [zi, ui],
  [zi, qr],
  [zi, sa],
  [Pn, Wt],
  [Pn, Kr],
  [Pn, Ao],
  [Pn, la],
  [Pn, "-"],
  [Pn, xr],
  [Pn, ui],
  [Pn, qr],
  [Pn, sa],
  [qr, Wt],
  [qr, Kr],
  [qr, Ao],
  [qr, la],
  [qr, "-"],
  [qr, xr],
  [qr, ui],
  [qr, qr],
  [qr, sa],
  ["#", Wt],
  ["#", Kr],
  ["#", Ao],
  ["#", la],
  ["#", "-"],
  ["#", xr],
  ["#", ui],
  ["#", qr],
  ["#", sa],
  ["-", Wt],
  ["-", Kr],
  ["-", Ao],
  ["-", la],
  ["-", "-"],
  ["-", xr],
  ["-", ui],
  ["-", qr],
  ["-", sa],
  [xr, Wt],
  [xr, Kr],
  [xr, Ao],
  [xr, la],
  [xr, xr],
  [xr, ui],
  [xr, qr],
  [xr, "%"],
  [xr, sa],
  ["@", Wt],
  ["@", Kr],
  ["@", Ao],
  ["@", la],
  ["@", "-"],
  ["@", sa],
  [".", xr],
  [".", ui],
  [".", qr],
  ["+", xr],
  ["+", ui],
  ["+", qr],
  ["/", "*"]
], dSe = dV.concat([
  [Wt, Pn],
  [qr, Pn],
  [Pn, Pn],
  [zi, Ki],
  [zi, Ns],
  [zi, No],
  [ui, ui],
  [ui, qr],
  [ui, Kr],
  [ui, "-"],
  [kn, Wt],
  [kn, Kr],
  [kn, ui],
  [kn, qr],
  [kn, Pn],
  [kn, "-"]
]);
function fV(e) {
  const t = new Set(e.map(([r, n]) => A2(r) << 16 | A2(n)));
  return function(r, n, i) {
    const o = A2(n, i), a = i.charCodeAt(0);
    return (a === cSe && n !== Wt && n !== Kr && n !== sa || a === uSe ? t.has(r << 16 | a << 8) : t.has(r << 16 | o)) && this.emit(" ", yi, !0), o;
  };
}
const fSe = fV(dV), hV = fV(dSe);
var d5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  spec: fSe,
  safe: hV
}, Symbol.toStringTag, { value: "Module" }));
const hSe = 92;
function pSe(e, t) {
  if (typeof t == "function") {
    let r = null;
    e.children.forEach((n) => {
      r !== null && t.call(this, r), this.node(n), r = n;
    });
    return;
  }
  e.children.forEach(this.node, this);
}
function gSe(e) {
  XM(e, (t, r, n) => {
    this.token(t, e.slice(r, n));
  });
}
function mSe(e) {
  const t = /* @__PURE__ */ new Map();
  for (let r in e.node) {
    const n = e.node[r];
    typeof (n.generate || n) == "function" && t.set(r, n.generate || n);
  }
  return function(r, n) {
    let i = "", o = 0, a = {
      node(u) {
        if (t.has(u.type))
          t.get(u.type).call(s, u);
        else
          throw new Error("Unknown node type: " + u.type);
      },
      tokenBefore: hV,
      token(u, d) {
        o = this.tokenBefore(o, u, d), this.emit(d, u, !1), u === Zr && d.charCodeAt(0) === hSe && this.emit(`
`, yi, !0);
      },
      emit(u) {
        i += u;
      },
      result() {
        return i;
      }
    };
    n && (typeof n.decorator == "function" && (a = n.decorator(a)), n.sourceMap && (a = sSe(a)), n.mode in d5 && (a.tokenBefore = d5[n.mode]));
    const s = {
      node: (u) => a.node(u),
      children: pSe,
      token: (u, d) => a.token(u, d),
      tokenize: gSe
    };
    return a.node(r), a.result();
  };
}
function vSe(e) {
  return {
    fromPlainObject(t) {
      return e(t, {
        enter(r) {
          r.children && !(r.children instanceof eo) && (r.children = new eo().fromArray(r.children));
        }
      }), t;
    },
    toPlainObject(t) {
      return e(t, {
        leave(r) {
          r.children && r.children instanceof eo && (r.children = r.children.toArray());
        }
      }), t;
    }
  };
}
const { hasOwnProperty: i_ } = Object.prototype, jv = function() {
};
function f5(e) {
  return typeof e == "function" ? e : jv;
}
function h5(e, t) {
  return function(r, n, i) {
    r.type === t && e.call(this, r, n, i);
  };
}
function bSe(e, t) {
  const r = t.structure, n = [];
  for (const i in r) {
    if (i_.call(r, i) === !1)
      continue;
    let o = r[i];
    const a = {
      name: i,
      type: !1,
      nullable: !1
    };
    Array.isArray(o) || (o = [o]);
    for (const s of o)
      s === null ? a.nullable = !0 : typeof s == "string" ? a.type = "node" : Array.isArray(s) && (a.type = "list");
    a.type && n.push(a);
  }
  return n.length ? {
    context: t.walkContext,
    fields: n
  } : null;
}
function ySe(e) {
  const t = {};
  for (const r in e.node)
    if (i_.call(e.node, r)) {
      const n = e.node[r];
      if (!n.structure)
        throw new Error("Missed `structure` field in `" + r + "` node type definition");
      t[r] = bSe(r, n);
    }
  return t;
}
function p5(e, t) {
  const r = e.fields.slice(), n = e.context, i = typeof n == "string";
  return t && r.reverse(), function(o, a, s, u) {
    let d;
    i && (d = a[n], a[n] = o);
    for (const f of r) {
      const h = o[f.name];
      if (!f.nullable || h) {
        if (f.type === "list") {
          if (t ? h.reduceRight(u, !1) : h.reduce(u, !1))
            return !0;
        } else if (s(h))
          return !0;
      }
    }
    i && (a[n] = d);
  };
}
function g5({
  StyleSheet: e,
  Atrule: t,
  Rule: r,
  Block: n,
  DeclarationList: i
}) {
  return {
    Atrule: {
      StyleSheet: e,
      Atrule: t,
      Rule: r,
      Block: n
    },
    Rule: {
      StyleSheet: e,
      Atrule: t,
      Rule: r,
      Block: n
    },
    Declaration: {
      StyleSheet: e,
      Atrule: t,
      Rule: r,
      Block: n,
      DeclarationList: i
    }
  };
}
function xSe(e) {
  const t = ySe(e), r = {}, n = {}, i = Symbol("break-walk"), o = Symbol("skip-node");
  for (const d in t)
    i_.call(t, d) && t[d] !== null && (r[d] = p5(t[d], !1), n[d] = p5(t[d], !0));
  const a = g5(r), s = g5(n), u = function(d, f) {
    function h(y, C, S) {
      const T = g.call(x, y, C, S);
      return T === i ? !0 : T === o ? !1 : !!(v.hasOwnProperty(y.type) && v[y.type](y, x, h, w) || m.call(x, y, C, S) === i);
    }
    let g = jv, m = jv, v = r, w = (y, C, S, T) => y || h(C, S, T);
    const x = {
      break: i,
      skip: o,
      root: d,
      stylesheet: null,
      atrule: null,
      atrulePrelude: null,
      rule: null,
      selector: null,
      block: null,
      declaration: null,
      function: null
    };
    if (typeof f == "function")
      g = f;
    else if (f && (g = f5(f.enter), m = f5(f.leave), f.reverse && (v = n), f.visit)) {
      if (a.hasOwnProperty(f.visit))
        v = f.reverse ? s[f.visit] : a[f.visit];
      else if (!t.hasOwnProperty(f.visit))
        throw new Error("Bad value `" + f.visit + "` for `visit` option (should be: " + Object.keys(t).sort().join(", ") + ")");
      g = h5(g, f.visit), m = h5(m, f.visit);
    }
    if (g === jv && m === jv)
      throw new Error("Neither `enter` nor `leave` walker handler is set or both aren't a function");
    h(d);
  };
  return u.break = i, u.skip = o, u.find = function(d, f) {
    let h = null;
    return u(d, function(g, m, v) {
      if (f.call(this, g, m, v))
        return h = g, i;
    }), h;
  }, u.findLast = function(d, f) {
    let h = null;
    return u(d, {
      reverse: !0,
      enter(g, m, v) {
        if (f.call(this, g, m, v))
          return h = g, i;
      }
    }), h;
  }, u.findAll = function(d, f) {
    const h = [];
    return u(d, function(g, m, v) {
      f.call(this, g, m, v) && h.push(g);
    }), h;
  }, u;
}
function wSe(e) {
  return e;
}
function MSe(e) {
  const { min: t, max: r, comma: n } = e;
  return t === 0 && r === 0 ? n ? "#?" : "*" : t === 0 && r === 1 ? "?" : t === 1 && r === 0 ? n ? "#" : "+" : t === 1 && r === 1 ? "" : (n ? "#" : "") + (t === r ? "{" + t + "}" : "{" + t + "," + (r !== 0 ? r : "") + "}");
}
function CSe(e) {
  switch (e.type) {
    case "Range":
      return " [" + (e.min === null ? "-∞" : e.min) + "," + (e.max === null ? "∞" : e.max) + "]";
    default:
      throw new Error("Unknown node type `" + e.type + "`");
  }
}
function SSe(e, t, r, n) {
  const i = e.combinator === " " || n ? e.combinator : " " + e.combinator + " ", o = e.terms.map((a) => o_(a, t, r, n)).join(i);
  return e.explicit || r ? (n || o[0] === "," ? "[" : "[ ") + o + (n ? "]" : " ]") : o;
}
function o_(e, t, r, n) {
  let i;
  switch (e.type) {
    case "Group":
      i = SSe(e, t, r, n) + (e.disallowEmpty ? "!" : "");
      break;
    case "Multiplier":
      return o_(e.term, t, r, n) + t(MSe(e), e);
    case "Type":
      i = "<" + e.name + (e.opts ? t(CSe(e.opts), e.opts) : "") + ">";
      break;
    case "Property":
      i = "<'" + e.name + "'>";
      break;
    case "Keyword":
      i = e.name;
      break;
    case "AtKeyword":
      i = "@" + e.name;
      break;
    case "Function":
      i = e.name + "(";
      break;
    case "String":
    case "Token":
      i = e.value;
      break;
    case "Comma":
      i = ",";
      break;
    default:
      throw new Error("Unknown node type `" + e.type + "`");
  }
  return t(i, e);
}
function a_(e, t) {
  let r = wSe, n = !1, i = !1;
  return typeof t == "function" ? r = t : t && (n = Boolean(t.forceBraces), i = Boolean(t.compact), typeof t.decorate == "function" && (r = t.decorate)), o_(e, r, n, i);
}
const m5 = { offset: 0, line: 1, column: 1 };
function TSe(e, t) {
  const r = e.tokens, n = e.longestMatch, i = n < r.length && r[n].node || null, o = i !== t ? i : null;
  let a = 0, s = 0, u = 0, d = "", f, h;
  for (let g = 0; g < r.length; g++) {
    const m = r[g].value;
    g === n && (s = m.length, a = d.length), o !== null && r[g].node === o && (g <= n ? u++ : u = 0), d += m;
  }
  return n === r.length || u > 1 ? (f = wy(o || t, "end") || Fv(m5, d), h = Fv(f)) : (f = wy(o, "start") || Fv(wy(t, "start") || m5, d.slice(0, a)), h = wy(o, "end") || Fv(f, d.substr(a, s))), {
    css: d,
    mismatchOffset: a,
    mismatchLength: s,
    start: f,
    end: h
  };
}
function wy(e, t) {
  const r = e && e.loc && e.loc[t];
  return r ? "line" in r ? Fv(r) : r : null;
}
function Fv({ offset: e, line: t, column: r }, n) {
  const i = {
    offset: e,
    line: t,
    column: r
  };
  if (n) {
    const o = n.split(/\n|\r\n?|\f/);
    i.offset += n.length, i.line += o.length - 1, i.column = o.length === 1 ? i.column + n.length : o.pop().length + 1;
  }
  return i;
}
const Iv = function(e, t) {
  const r = JM("SyntaxReferenceError", e + (t ? " `" + t + "`" : ""));
  return r.reference = t, r;
}, kSe = function(e, t, r, n) {
  const i = JM("SyntaxMatchError", e), {
    css: o,
    mismatchOffset: a,
    mismatchLength: s,
    start: u,
    end: d
  } = TSe(n, r);
  return i.rawMessage = e, i.syntax = t ? a_(t) : "<generic>", i.css = o, i.mismatchOffset = a, i.mismatchLength = s, i.message = e + `
  syntax: ` + i.syntax + `
   value: ` + (o || "<empty string>") + `
  --------` + new Array(i.mismatchOffset + 1).join("-") + "^", Object.assign(i, u), i.loc = {
    source: r && r.loc && r.loc.source || "<unknown>",
    start: u,
    end: d
  }, i;
}, My = /* @__PURE__ */ new Map(), _h = /* @__PURE__ */ new Map(), xx = 45, E2 = DSe, g$ = ASe;
function l_(e, t) {
  return t = t || 0, e.length - t >= 2 && e.charCodeAt(t) === xx && e.charCodeAt(t + 1) === xx;
}
function pV(e, t) {
  if (t = t || 0, e.length - t >= 3 && e.charCodeAt(t) === xx && e.charCodeAt(t + 1) !== xx) {
    const r = e.indexOf("-", t + 2);
    if (r !== -1)
      return e.substring(t, r + 1);
  }
  return "";
}
function DSe(e) {
  if (My.has(e))
    return My.get(e);
  const t = e.toLowerCase();
  let r = My.get(t);
  if (r === void 0) {
    const n = l_(t, 0), i = n ? "" : pV(t, 0);
    r = Object.freeze({
      basename: t.substr(i.length),
      name: t,
      prefix: i,
      vendor: i,
      custom: n
    });
  }
  return My.set(e, r), r;
}
function ASe(e) {
  if (_h.has(e))
    return _h.get(e);
  let t = e, r = e[0];
  r === "/" ? r = e[1] === "/" ? "//" : "/" : r !== "_" && r !== "*" && r !== "$" && r !== "#" && r !== "+" && r !== "&" && (r = "");
  const n = l_(t, r.length);
  if (!n && (t = t.toLowerCase(), _h.has(t))) {
    const s = _h.get(t);
    return _h.set(e, s), s;
  }
  const i = n ? "" : pV(t, r.length), o = t.substr(0, r.length + i.length), a = Object.freeze({
    basename: t.substr(o.length),
    name: t.substr(r.length),
    hack: r,
    vendor: i,
    prefix: o,
    custom: n
  });
  return _h.set(e, a), a;
}
const gV = [
  "initial",
  "inherit",
  "unset",
  "revert",
  "revert-layer"
], j0 = 43, ls = 45, I2 = 110, Lh = !0, ESe = !1;
function m$(e, t) {
  return e !== null && e.type === Zr && e.value.charCodeAt(0) === t;
}
function t0(e, t, r) {
  for (; e !== null && (e.type === yi || e.type === Xo); )
    e = r(++t);
  return t;
}
function tc(e, t, r, n) {
  if (!e)
    return 0;
  const i = e.value.charCodeAt(t);
  if (i === j0 || i === ls) {
    if (r)
      return 0;
    t++;
  }
  for (; t < e.value.length; t++)
    if (!io(e.value.charCodeAt(t)))
      return 0;
  return n + 1;
}
function N2(e, t, r) {
  let n = !1, i = t0(e, t, r);
  if (e = r(i), e === null)
    return t;
  if (e.type !== xr)
    if (m$(e, j0) || m$(e, ls)) {
      if (n = !0, i = t0(r(++i), i, r), e = r(i), e === null || e.type !== xr)
        return 0;
    } else
      return t;
  if (!n) {
    const o = e.value.charCodeAt(0);
    if (o !== j0 && o !== ls)
      return 0;
  }
  return tc(e, n ? 0 : 1, n, i);
}
function ISe(e, t) {
  let r = 0;
  if (!e)
    return 0;
  if (e.type === xr)
    return tc(e, 0, ESe, r);
  if (e.type === Wt && e.value.charCodeAt(0) === ls) {
    if (!ap(e.value, 1, I2))
      return 0;
    switch (e.value.length) {
      case 2:
        return N2(t(++r), r, t);
      case 3:
        return e.value.charCodeAt(2) !== ls ? 0 : (r = t0(t(++r), r, t), e = t(r), tc(e, 0, Lh, r));
      default:
        return e.value.charCodeAt(2) !== ls ? 0 : tc(e, 3, Lh, r);
    }
  } else if (e.type === Wt || m$(e, j0) && t(r + 1).type === Wt) {
    if (e.type !== Wt && (e = t(++r)), e === null || !ap(e.value, 0, I2))
      return 0;
    switch (e.value.length) {
      case 1:
        return N2(t(++r), r, t);
      case 2:
        return e.value.charCodeAt(1) !== ls ? 0 : (r = t0(t(++r), r, t), e = t(r), tc(e, 0, Lh, r));
      default:
        return e.value.charCodeAt(1) !== ls ? 0 : tc(e, 2, Lh, r);
    }
  } else if (e.type === qr) {
    let n = e.value.charCodeAt(0), i = n === j0 || n === ls ? 1 : 0, o = i;
    for (; o < e.value.length && io(e.value.charCodeAt(o)); o++)
      ;
    return o === i || !ap(e.value, o, I2) ? 0 : o + 1 === e.value.length ? N2(t(++r), r, t) : e.value.charCodeAt(o + 1) !== ls ? 0 : o + 2 === e.value.length ? (r = t0(t(++r), r, t), e = t(r), tc(e, 0, Lh, r)) : tc(e, o + 2, Lh, r);
  }
  return 0;
}
const NSe = 43, mV = 45, vV = 63, zSe = 117;
function v$(e, t) {
  return e !== null && e.type === Zr && e.value.charCodeAt(0) === t;
}
function $Se(e, t) {
  return e.value.charCodeAt(0) === t;
}
function Bv(e, t, r) {
  let n = 0;
  for (let i = t; i < e.value.length; i++) {
    const o = e.value.charCodeAt(i);
    if (o === mV && r && n !== 0)
      return Bv(e, t + n + 1, !1), 6;
    if (!kc(o) || ++n > 6)
      return 0;
  }
  return n;
}
function Cy(e, t, r) {
  if (!e)
    return 0;
  for (; v$(r(t), vV); ) {
    if (++e > 6)
      return 0;
    t++;
  }
  return t;
}
function OSe(e, t) {
  let r = 0;
  if (e === null || e.type !== Wt || !ap(e.value, 0, zSe) || (e = t(++r), e === null))
    return 0;
  if (v$(e, NSe))
    return e = t(++r), e === null ? 0 : e.type === Wt ? Cy(Bv(e, 0, !0), ++r, t) : v$(e, vV) ? Cy(1, ++r, t) : 0;
  if (e.type === xr) {
    const n = Bv(e, 1, !0);
    return n === 0 ? 0 : (e = t(++r), e === null ? r : e.type === qr || e.type === xr ? !$Se(e, mV) || !Bv(e, 1, !1) ? 0 : r + 1 : Cy(n, r, t));
  }
  return e.type === qr ? Cy(Bv(e, 1, !0), ++r, t) : 0;
}
const _Se = ["calc(", "-moz-calc(", "-webkit-calc("], s_ = /* @__PURE__ */ new Map([
  [Kr, kn],
  [Ki, kn],
  [Va, Wl],
  [zo, ul]
]);
function Rl(e, t) {
  return t < e.length ? e.charCodeAt(t) : 0;
}
function bV(e, t) {
  return R0(e, 0, e.length, t);
}
function yV(e, t) {
  for (let r = 0; r < t.length; r++)
    if (bV(e, t[r]))
      return !0;
  return !1;
}
function xV(e, t) {
  return t !== e.length - 2 ? !1 : Rl(e, t) === 92 && io(Rl(e, t + 1));
}
function rC(e, t, r) {
  if (e && e.type === "Range") {
    const n = Number(r !== void 0 && r !== t.length ? t.substr(0, r) : t);
    if (isNaN(n) || e.min !== null && n < e.min && typeof e.min != "string" || e.max !== null && n > e.max && typeof e.max != "string")
      return !0;
  }
  return !1;
}
function LSe(e, t) {
  let r = 0, n = [], i = 0;
  e:
    do {
      switch (e.type) {
        case ul:
        case kn:
        case Wl:
          if (e.type !== r)
            break e;
          if (r = n.pop(), n.length === 0) {
            i++;
            break e;
          }
          break;
        case Kr:
        case Ki:
        case Va:
        case zo:
          n.push(r), r = s_.get(e.type);
          break;
      }
      i++;
    } while (e = t(i));
  return i;
}
function Za(e) {
  return function(t, r, n) {
    return t === null ? 0 : t.type === Kr && yV(t.value, _Se) ? LSe(t, r) : e(t, r, n);
  };
}
function Ln(e) {
  return function(t) {
    return t === null || t.type !== e ? 0 : 1;
  };
}
function PSe(e) {
  if (e === null || e.type !== Wt)
    return 0;
  const t = e.value.toLowerCase();
  return yV(t, gV) || bV(t, "default") ? 0 : 1;
}
function RSe(e) {
  return e === null || e.type !== Wt || Rl(e.value, 0) !== 45 || Rl(e.value, 1) !== 45 ? 0 : 1;
}
function jSe(e) {
  if (e === null || e.type !== Pn)
    return 0;
  const t = e.value.length;
  if (t !== 4 && t !== 5 && t !== 7 && t !== 9)
    return 0;
  for (let r = 1; r < t; r++)
    if (!kc(Rl(e.value, r)))
      return 0;
  return 1;
}
function FSe(e) {
  return e === null || e.type !== Pn || !o1(Rl(e.value, 1), Rl(e.value, 2), Rl(e.value, 3)) ? 0 : 1;
}
function BSe(e, t) {
  if (!e)
    return 0;
  let r = 0, n = [], i = 0;
  e:
    do {
      switch (e.type) {
        case ZM:
        case la:
          break e;
        case ul:
        case kn:
        case Wl:
          if (e.type !== r)
            break e;
          r = n.pop();
          break;
        case ga:
          if (r === 0)
            break e;
          break;
        case Zr:
          if (r === 0 && e.value === "!")
            break e;
          break;
        case Kr:
        case Ki:
        case Va:
        case zo:
          n.push(r), r = s_.get(e.type);
          break;
      }
      i++;
    } while (e = t(i));
  return i;
}
function USe(e, t) {
  if (!e)
    return 0;
  let r = 0, n = [], i = 0;
  e:
    do {
      switch (e.type) {
        case ZM:
        case la:
          break e;
        case ul:
        case kn:
        case Wl:
          if (e.type !== r)
            break e;
          r = n.pop();
          break;
        case Kr:
        case Ki:
        case Va:
        case zo:
          n.push(r), r = s_.get(e.type);
          break;
      }
      i++;
    } while (e = t(i));
  return i;
}
function Au(e) {
  return e && (e = new Set(e)), function(t, r, n) {
    if (t === null || t.type !== qr)
      return 0;
    const i = KM(t.value, 0);
    if (e !== null) {
      const o = t.value.indexOf("\\", i), a = o === -1 || !xV(t.value, o) ? t.value.substr(i) : t.value.substring(i, o);
      if (e.has(a.toLowerCase()) === !1)
        return 0;
    }
    return rC(n, t.value, i) ? 0 : 1;
  };
}
function HSe(e, t, r) {
  return e === null || e.type !== ui || rC(r, e.value, e.value.length - 1) ? 0 : 1;
}
function wV(e) {
  return typeof e != "function" && (e = function() {
    return 0;
  }), function(t, r, n) {
    return t !== null && t.type === xr && Number(t.value) === 0 ? 1 : e(t, r, n);
  };
}
function WSe(e, t, r) {
  if (e === null)
    return 0;
  const n = KM(e.value, 0);
  return !(n === e.value.length) && !xV(e.value, n) || rC(r, e.value, n) ? 0 : 1;
}
function VSe(e, t, r) {
  if (e === null || e.type !== xr)
    return 0;
  let n = Rl(e.value, 0) === 43 || Rl(e.value, 0) === 45 ? 1 : 0;
  for (; n < e.value.length; n++)
    if (!io(Rl(e.value, n)))
      return 0;
  return rC(r, e.value, n) ? 0 : 1;
}
const YSe = {
  "ident-token": Ln(Wt),
  "function-token": Ln(Kr),
  "at-keyword-token": Ln(zi),
  "hash-token": Ln(Pn),
  "string-token": Ln(Ns),
  "bad-string-token": Ln(ZM),
  "url-token": Ln(Ao),
  "bad-url-token": Ln(la),
  "delim-token": Ln(Zr),
  "number-token": Ln(xr),
  "percentage-token": Ln(ui),
  "dimension-token": Ln(qr),
  "whitespace-token": Ln(yi),
  "CDO-token": Ln(Db),
  "CDC-token": Ln(sa),
  "colon-token": Ln(No),
  "semicolon-token": Ln(ga),
  "comma-token": Ln(zs),
  "[-token": Ln(Va),
  "]-token": Ln(Wl),
  "(-token": Ln(Ki),
  ")-token": Ln(kn),
  "{-token": Ln(zo),
  "}-token": Ln(ul)
}, QSe = {
  string: Ln(Ns),
  ident: Ln(Wt),
  percentage: Za(HSe),
  zero: wV(),
  number: Za(WSe),
  integer: Za(VSe),
  "custom-ident": PSe,
  "custom-property-name": RSe,
  "hex-color": jSe,
  "id-selector": FSe,
  "an-plus-b": ISe,
  urange: OSe,
  "declaration-value": BSe,
  "any-value": USe
};
function qSe(e) {
  const {
    angle: t,
    decibel: r,
    frequency: n,
    flex: i,
    length: o,
    resolution: a,
    semitones: s,
    time: u
  } = e || {};
  return {
    dimension: Za(Au(null)),
    angle: Za(Au(t)),
    decibel: Za(Au(r)),
    frequency: Za(Au(n)),
    flex: Za(Au(i)),
    length: Za(wV(Au(o))),
    resolution: Za(Au(a)),
    semitones: Za(Au(s)),
    time: Za(Au(u))
  };
}
function GSe(e) {
  return vt(vt(vt({}, YSe), QSe), qSe(e));
}
const ZSe = [
  "cm",
  "mm",
  "q",
  "in",
  "pt",
  "pc",
  "px",
  "em",
  "rem",
  "ex",
  "rex",
  "cap",
  "rcap",
  "ch",
  "rch",
  "ic",
  "ric",
  "lh",
  "rlh",
  "vw",
  "svw",
  "lvw",
  "dvw",
  "vh",
  "svh",
  "lvh",
  "dvh",
  "vi",
  "svi",
  "lvi",
  "dvi",
  "vb",
  "svb",
  "lvb",
  "dvb",
  "vmin",
  "svmin",
  "lvmin",
  "dvmin",
  "vmax",
  "svmax",
  "lvmax",
  "dvmax",
  "cqw",
  "cqh",
  "cqi",
  "cqb",
  "cqmin",
  "cqmax"
], KSe = ["deg", "grad", "rad", "turn"], XSe = ["s", "ms"], JSe = ["hz", "khz"], eTe = ["dpi", "dpcm", "dppx", "x"], tTe = ["fr"], rTe = ["db"], nTe = ["st"];
var v5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  length: ZSe,
  angle: KSe,
  time: XSe,
  frequency: JSe,
  resolution: eTe,
  flex: tTe,
  decibel: rTe,
  semitones: nTe
}, Symbol.toStringTag, { value: "Module" }));
function iTe(e, t, r) {
  return Object.assign(JM("SyntaxError", e), {
    input: t,
    offset: r,
    rawMessage: e,
    message: e + `
  ` + t + `
--` + new Array((r || t.length) + 1).join("-") + "^"
  });
}
const oTe = 9, aTe = 10, lTe = 12, sTe = 13, uTe = 32;
class cTe {
  constructor(t) {
    this.str = t, this.pos = 0;
  }
  charCodeAt(t) {
    return t < this.str.length ? this.str.charCodeAt(t) : 0;
  }
  charCode() {
    return this.charCodeAt(this.pos);
  }
  nextCharCode() {
    return this.charCodeAt(this.pos + 1);
  }
  nextNonWsCode(t) {
    return this.charCodeAt(this.findWsEnd(t));
  }
  findWsEnd(t) {
    for (; t < this.str.length; t++) {
      const r = this.str.charCodeAt(t);
      if (r !== sTe && r !== aTe && r !== lTe && r !== uTe && r !== oTe)
        break;
    }
    return t;
  }
  substringToPos(t) {
    return this.str.substring(this.pos, this.pos = t);
  }
  eat(t) {
    this.charCode() !== t && this.error("Expect `" + String.fromCharCode(t) + "`"), this.pos++;
  }
  peek() {
    return this.pos < this.str.length ? this.str.charAt(this.pos++) : "";
  }
  error(t) {
    throw new iTe(t, this.str, this.pos);
  }
}
const dTe = 9, fTe = 10, hTe = 12, pTe = 13, gTe = 32, MV = 33, u_ = 35, b5 = 38, wx = 39, CV = 40, mTe = 41, SV = 42, c_ = 43, d_ = 44, y5 = 45, f_ = 60, TV = 62, b$ = 63, vTe = 64, nC = 91, h_ = 93, Mx = 123, x5 = 124, w5 = 125, M5 = 8734, F0 = new Uint8Array(128).map((e, t) => /[a-zA-Z0-9\-]/.test(String.fromCharCode(t)) ? 1 : 0), C5 = {
  " ": 1,
  "&&": 2,
  "||": 3,
  "|": 4
};
function Cx(e) {
  return e.substringToPos(e.findWsEnd(e.pos));
}
function Cp(e) {
  let t = e.pos;
  for (; t < e.str.length; t++) {
    const r = e.str.charCodeAt(t);
    if (r >= 128 || F0[r] === 0)
      break;
  }
  return e.pos === t && e.error("Expect a keyword"), e.substringToPos(t);
}
function Sx(e) {
  let t = e.pos;
  for (; t < e.str.length; t++) {
    const r = e.str.charCodeAt(t);
    if (r < 48 || r > 57)
      break;
  }
  return e.pos === t && e.error("Expect a number"), e.substringToPos(t);
}
function bTe(e) {
  const t = e.str.indexOf("'", e.pos + 1);
  return t === -1 && (e.pos = e.str.length, e.error("Expect an apostrophe")), e.substringToPos(t + 1);
}
function S5(e) {
  let t = null, r = null;
  return e.eat(Mx), t = Sx(e), e.charCode() === d_ ? (e.pos++, e.charCode() !== w5 && (r = Sx(e))) : r = t, e.eat(w5), {
    min: Number(t),
    max: r ? Number(r) : 0
  };
}
function yTe(e) {
  let t = null, r = !1;
  switch (e.charCode()) {
    case SV:
      e.pos++, t = {
        min: 0,
        max: 0
      };
      break;
    case c_:
      e.pos++, t = {
        min: 1,
        max: 0
      };
      break;
    case b$:
      e.pos++, t = {
        min: 0,
        max: 1
      };
      break;
    case u_:
      e.pos++, r = !0, e.charCode() === Mx ? t = S5(e) : e.charCode() === b$ ? (e.pos++, t = {
        min: 0,
        max: 0
      }) : t = {
        min: 1,
        max: 0
      };
      break;
    case Mx:
      t = S5(e);
      break;
    default:
      return null;
  }
  return {
    type: "Multiplier",
    comma: r,
    min: t.min,
    max: t.max,
    term: null
  };
}
function Sp(e, t) {
  const r = yTe(e);
  return r !== null ? (r.term = t, e.charCode() === u_ && e.charCodeAt(e.pos - 1) === c_ ? Sp(e, r) : r) : t;
}
function z2(e) {
  const t = e.peek();
  return t === "" ? null : {
    type: "Token",
    value: t
  };
}
function xTe(e) {
  let t;
  return e.eat(f_), e.eat(wx), t = Cp(e), e.eat(wx), e.eat(TV), Sp(e, {
    type: "Property",
    name: t
  });
}
function wTe(e) {
  let t = null, r = null, n = 1;
  return e.eat(nC), e.charCode() === y5 && (e.peek(), n = -1), n == -1 && e.charCode() === M5 ? e.peek() : (t = n * Number(Sx(e)), F0[e.charCode()] !== 0 && (t += Cp(e))), Cx(e), e.eat(d_), Cx(e), e.charCode() === M5 ? e.peek() : (n = 1, e.charCode() === y5 && (e.peek(), n = -1), r = n * Number(Sx(e)), F0[e.charCode()] !== 0 && (r += Cp(e))), e.eat(h_), {
    type: "Range",
    min: t,
    max: r
  };
}
function MTe(e) {
  let t, r = null;
  return e.eat(f_), t = Cp(e), e.charCode() === CV && e.nextCharCode() === mTe && (e.pos += 2, t += "()"), e.charCodeAt(e.findWsEnd(e.pos)) === nC && (Cx(e), r = wTe(e)), e.eat(TV), Sp(e, {
    type: "Type",
    name: t,
    opts: r
  });
}
function CTe(e) {
  const t = Cp(e);
  return e.charCode() === CV ? (e.pos++, {
    type: "Function",
    name: t
  }) : Sp(e, {
    type: "Keyword",
    name: t
  });
}
function STe(e, t) {
  function r(i, o) {
    return {
      type: "Group",
      terms: i,
      combinator: o,
      disallowEmpty: !1,
      explicit: !1
    };
  }
  let n;
  for (t = Object.keys(t).sort((i, o) => C5[i] - C5[o]); t.length > 0; ) {
    n = t.shift();
    let i = 0, o = 0;
    for (; i < e.length; i++) {
      const a = e[i];
      a.type === "Combinator" && (a.value === n ? (o === -1 && (o = i - 1), e.splice(i, 1), i--) : (o !== -1 && i - o > 1 && (e.splice(o, i - o, r(e.slice(o, i), n)), i = o + 1), o = -1));
    }
    o !== -1 && t.length && e.splice(o, i - o, r(e.slice(o, i), n));
  }
  return n;
}
function kV(e) {
  const t = [], r = {};
  let n, i = null, o = e.pos;
  for (; n = kTe(e); )
    n.type !== "Spaces" && (n.type === "Combinator" ? ((i === null || i.type === "Combinator") && (e.pos = o, e.error("Unexpected combinator")), r[n.value] = !0) : i !== null && i.type !== "Combinator" && (r[" "] = !0, t.push({
      type: "Combinator",
      value: " "
    })), t.push(n), i = n, o = e.pos);
  return i !== null && i.type === "Combinator" && (e.pos -= o, e.error("Unexpected combinator")), {
    type: "Group",
    terms: t,
    combinator: STe(t, r) || " ",
    disallowEmpty: !1,
    explicit: !1
  };
}
function TTe(e) {
  let t;
  return e.eat(nC), t = kV(e), e.eat(h_), t.explicit = !0, e.charCode() === MV && (e.pos++, t.disallowEmpty = !0), t;
}
function kTe(e) {
  let t = e.charCode();
  if (t < 128 && F0[t] === 1)
    return CTe(e);
  switch (t) {
    case h_:
      break;
    case nC:
      return Sp(e, TTe(e));
    case f_:
      return e.nextCharCode() === wx ? xTe(e) : MTe(e);
    case x5:
      return {
        type: "Combinator",
        value: e.substringToPos(e.pos + (e.nextCharCode() === x5 ? 2 : 1))
      };
    case b5:
      return e.pos++, e.eat(b5), {
        type: "Combinator",
        value: "&&"
      };
    case d_:
      return e.pos++, {
        type: "Comma"
      };
    case wx:
      return Sp(e, {
        type: "String",
        value: bTe(e)
      });
    case gTe:
    case dTe:
    case fTe:
    case pTe:
    case hTe:
      return {
        type: "Spaces",
        value: Cx(e)
      };
    case vTe:
      return t = e.nextCharCode(), t < 128 && F0[t] === 1 ? (e.pos++, {
        type: "AtKeyword",
        name: Cp(e)
      }) : z2(e);
    case SV:
    case c_:
    case b$:
    case u_:
    case MV:
      break;
    case Mx:
      if (t = e.nextCharCode(), t < 48 || t > 57)
        return z2(e);
      break;
    default:
      return z2(e);
  }
}
function DV(e) {
  const t = new cTe(e), r = kV(t);
  return t.pos !== e.length && t.error("Unexpected input"), r.terms.length === 1 && r.terms[0].type === "Group" ? r.terms[0] : r;
}
const Uv = function() {
};
function T5(e) {
  return typeof e == "function" ? e : Uv;
}
function DTe(e, t, r) {
  function n(a) {
    switch (i.call(r, a), a.type) {
      case "Group":
        a.terms.forEach(n);
        break;
      case "Multiplier":
        n(a.term);
        break;
      case "Type":
      case "Property":
      case "Keyword":
      case "AtKeyword":
      case "Function":
      case "String":
      case "Token":
      case "Comma":
        break;
      default:
        throw new Error("Unknown type: " + a.type);
    }
    o.call(r, a);
  }
  let i = Uv, o = Uv;
  if (typeof t == "function" ? i = t : t && (i = T5(t.enter), o = T5(t.leave)), i === Uv && o === Uv)
    throw new Error("Neither `enter` nor `leave` walker handler is set or both aren't a function");
  n(e);
}
const ATe = {
  decorator(e) {
    const t = [];
    let r = null;
    return Qt(vt({}, e), {
      node(n) {
        const i = r;
        r = n, e.node.call(this, n), r = i;
      },
      emit(n, i, o) {
        t.push({
          type: i,
          value: n,
          node: o ? null : r
        });
      },
      result() {
        return t;
      }
    });
  }
};
function ETe(e) {
  const t = [];
  return XM(e, (r, n, i) => t.push({
    type: r,
    value: e.slice(n, i),
    node: null
  })), t;
}
function ITe(e, t) {
  return typeof e == "string" ? ETe(e) : t.generate(e, ATe);
}
const cn = { type: "Match" }, Tn = { type: "Mismatch" }, p_ = { type: "DisallowEmpty" }, NTe = 40, zTe = 41;
function Do(e, t, r) {
  return t === cn && r === Tn || e === cn && t === cn && r === cn ? e : (e.type === "If" && e.else === Tn && t === cn && (t = e.then, e = e.match), {
    type: "If",
    match: e,
    then: t,
    else: r
  });
}
function AV(e) {
  return e.length > 2 && e.charCodeAt(e.length - 2) === NTe && e.charCodeAt(e.length - 1) === zTe;
}
function k5(e) {
  return e.type === "Keyword" || e.type === "AtKeyword" || e.type === "Function" || e.type === "Type" && AV(e.name);
}
function y$(e, t, r) {
  switch (e) {
    case " ": {
      let n = cn;
      for (let i = t.length - 1; i >= 0; i--) {
        const o = t[i];
        n = Do(o, n, Tn);
      }
      return n;
    }
    case "|": {
      let n = Tn, i = null;
      for (let o = t.length - 1; o >= 0; o--) {
        let a = t[o];
        if (k5(a) && (i === null && o > 0 && k5(t[o - 1]) && (i = /* @__PURE__ */ Object.create(null), n = Do({
          type: "Enum",
          map: i
        }, cn, n)), i !== null)) {
          const s = (AV(a.name) ? a.name.slice(0, -1) : a.name).toLowerCase();
          if (!(s in i)) {
            i[s] = a;
            continue;
          }
        }
        i = null, n = Do(a, cn, n);
      }
      return n;
    }
    case "&&": {
      if (t.length > 5)
        return {
          type: "MatchOnce",
          terms: t,
          all: !0
        };
      let n = Tn;
      for (let i = t.length - 1; i >= 0; i--) {
        const o = t[i];
        let a;
        t.length > 1 ? a = y$(e, t.filter(function(s) {
          return s !== o;
        }), !1) : a = cn, n = Do(o, a, n);
      }
      return n;
    }
    case "||": {
      if (t.length > 5)
        return {
          type: "MatchOnce",
          terms: t,
          all: !1
        };
      let n = r ? cn : Tn;
      for (let i = t.length - 1; i >= 0; i--) {
        const o = t[i];
        let a;
        t.length > 1 ? a = y$(e, t.filter(function(s) {
          return s !== o;
        }), !0) : a = cn, n = Do(o, a, n);
      }
      return n;
    }
  }
}
function $Te(e) {
  let t = cn, r = g_(e.term);
  if (e.max === 0)
    r = Do(r, p_, Tn), t = Do(r, null, Tn), t.then = Do(cn, cn, t), e.comma && (t.then.else = Do({ type: "Comma", syntax: e }, t, Tn));
  else
    for (let n = e.min || 1; n <= e.max; n++)
      e.comma && t !== cn && (t = Do({ type: "Comma", syntax: e }, t, Tn)), t = Do(r, Do(cn, cn, t), Tn);
  if (e.min === 0)
    t = Do(cn, cn, t);
  else
    for (let n = 0; n < e.min - 1; n++)
      e.comma && t !== cn && (t = Do({ type: "Comma", syntax: e }, t, Tn)), t = Do(r, t, Tn);
  return t;
}
function g_(e) {
  if (typeof e == "function")
    return {
      type: "Generic",
      fn: e
    };
  switch (e.type) {
    case "Group": {
      let t = y$(e.combinator, e.terms.map(g_), !1);
      return e.disallowEmpty && (t = Do(t, p_, Tn)), t;
    }
    case "Multiplier":
      return $Te(e);
    case "Type":
    case "Property":
      return {
        type: e.type,
        name: e.name,
        syntax: e
      };
    case "Keyword":
      return {
        type: e.type,
        name: e.name.toLowerCase(),
        syntax: e
      };
    case "AtKeyword":
      return {
        type: e.type,
        name: "@" + e.name.toLowerCase(),
        syntax: e
      };
    case "Function":
      return {
        type: e.type,
        name: e.name.toLowerCase() + "(",
        syntax: e
      };
    case "String":
      return e.value.length === 3 ? {
        type: "Token",
        value: e.value.charAt(1),
        syntax: e
      } : {
        type: e.type,
        value: e.value.substr(1, e.value.length - 2).replace(/\\'/g, "'"),
        syntax: e
      };
    case "Token":
      return {
        type: e.type,
        value: e.value,
        syntax: e
      };
    case "Comma":
      return {
        type: e.type,
        syntax: e
      };
    default:
      throw new Error("Unknown node type:", e.type);
  }
}
function x$(e, t) {
  return typeof e == "string" && (e = DV(e)), {
    type: "MatchGraph",
    match: g_(e),
    syntax: t || null,
    source: e
  };
}
const { hasOwnProperty: D5 } = Object.prototype, OTe = 0, _Te = 1, w$ = 2, EV = 3, A5 = "Match", LTe = "Mismatch", PTe = "Maximum iteration number exceeded (please fill an issue on https://github.com/csstree/csstree/issues)", E5 = 15e3;
function RTe(e) {
  let t = null, r = null, n = e;
  for (; n !== null; )
    r = n.prev, n.prev = t, t = n, n = r;
  return t;
}
function $2(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let r = 0; r < e.length; r++) {
    const n = t.charCodeAt(r);
    let i = e.charCodeAt(r);
    if (i >= 65 && i <= 90 && (i = i | 32), i !== n)
      return !1;
  }
  return !0;
}
function jTe(e) {
  return e.type !== Zr ? !1 : e.value !== "?";
}
function I5(e) {
  return e === null ? !0 : e.type === zs || e.type === Kr || e.type === Ki || e.type === Va || e.type === zo || jTe(e);
}
function N5(e) {
  return e === null ? !0 : e.type === kn || e.type === Wl || e.type === ul || e.type === Zr && e.value === "/";
}
function FTe(e, t, r) {
  function n() {
    do
      C++, y = C < e.length ? e[C] : null;
    while (y !== null && (y.type === yi || y.type === Xo));
  }
  function i(A) {
    const D = C + A;
    return D < e.length ? e[D] : null;
  }
  function o(A, D) {
    return {
      nextState: A,
      matchStack: T,
      syntaxStack: h,
      thenStack: g,
      tokenIndex: C,
      prev: D
    };
  }
  function a(A) {
    g = {
      nextState: A,
      matchStack: T,
      syntaxStack: h,
      prev: g
    };
  }
  function s(A) {
    m = o(A, m);
  }
  function u() {
    T = {
      type: _Te,
      syntax: t.syntax,
      token: y,
      prev: T
    }, n(), v = null, C > S && (S = C);
  }
  function d() {
    h = {
      syntax: t.syntax,
      opts: t.syntax.opts || h !== null && h.opts || null,
      prev: h
    }, T = {
      type: w$,
      syntax: t.syntax,
      token: T.token,
      prev: T
    };
  }
  function f() {
    T.type === w$ ? T = T.prev : T = {
      type: EV,
      syntax: h.syntax,
      token: T.token,
      prev: T
    }, h = h.prev;
  }
  let h = null, g = null, m = null, v = null, w = 0, x = null, y = null, C = -1, S = 0, T = {
    type: OTe,
    syntax: null,
    token: null,
    prev: null
  };
  for (n(); x === null && ++w < E5; )
    switch (t.type) {
      case "Match":
        if (g === null) {
          if (y !== null && (C !== e.length - 1 || y.value !== "\\0" && y.value !== "\\9")) {
            t = Tn;
            break;
          }
          x = A5;
          break;
        }
        if (t = g.nextState, t === p_)
          if (g.matchStack === T) {
            t = Tn;
            break;
          } else
            t = cn;
        for (; g.syntaxStack !== h; )
          f();
        g = g.prev;
        break;
      case "Mismatch":
        if (v !== null && v !== !1)
          (m === null || C > m.tokenIndex) && (m = v, v = !1);
        else if (m === null) {
          x = LTe;
          break;
        }
        t = m.nextState, g = m.thenStack, h = m.syntaxStack, T = m.matchStack, C = m.tokenIndex, y = C < e.length ? e[C] : null, m = m.prev;
        break;
      case "MatchGraph":
        t = t.match;
        break;
      case "If":
        t.else !== Tn && s(t.else), t.then !== cn && a(t.then), t = t.match;
        break;
      case "MatchOnce":
        t = {
          type: "MatchOnceBuffer",
          syntax: t,
          index: 0,
          mask: 0
        };
        break;
      case "MatchOnceBuffer": {
        const E = t.syntax.terms;
        if (t.index === E.length) {
          if (t.mask === 0 || t.syntax.all) {
            t = Tn;
            break;
          }
          t = cn;
          break;
        }
        if (t.mask === (1 << E.length) - 1) {
          t = cn;
          break;
        }
        for (; t.index < E.length; t.index++) {
          const N = 1 << t.index;
          if (!(t.mask & N)) {
            s(t), a({
              type: "AddMatchOnce",
              syntax: t.syntax,
              mask: t.mask | N
            }), t = E[t.index++];
            break;
          }
        }
        break;
      }
      case "AddMatchOnce":
        t = {
          type: "MatchOnceBuffer",
          syntax: t.syntax,
          index: 0,
          mask: t.mask
        };
        break;
      case "Enum":
        if (y !== null) {
          let E = y.value.toLowerCase();
          if (E.indexOf("\\") !== -1 && (E = E.replace(/\\[09].*$/, "")), D5.call(t.map, E)) {
            t = t.map[E];
            break;
          }
        }
        t = Tn;
        break;
      case "Generic": {
        const E = h !== null ? h.opts : null, N = C + Math.floor(t.fn(y, i, E));
        if (!isNaN(N) && N > C) {
          for (; C < N; )
            u();
          t = cn;
        } else
          t = Tn;
        break;
      }
      case "Type":
      case "Property": {
        const E = t.type === "Type" ? "types" : "properties", N = D5.call(r, E) ? r[E][t.name] : null;
        if (!N || !N.match)
          throw new Error("Bad syntax reference: " + (t.type === "Type" ? "<" + t.name + ">" : "<'" + t.name + "'>"));
        if (v !== !1 && y !== null && t.type === "Type" && (t.name === "custom-ident" && y.type === Wt || t.name === "length" && y.value === "0")) {
          v === null && (v = o(t, m)), t = Tn;
          break;
        }
        d(), t = N.match;
        break;
      }
      case "Keyword": {
        const E = t.name;
        if (y !== null) {
          let N = y.value;
          if (N.indexOf("\\") !== -1 && (N = N.replace(/\\[09].*$/, "")), $2(N, E)) {
            u(), t = cn;
            break;
          }
        }
        t = Tn;
        break;
      }
      case "AtKeyword":
      case "Function":
        if (y !== null && $2(y.value, t.name)) {
          u(), t = cn;
          break;
        }
        t = Tn;
        break;
      case "Token":
        if (y !== null && y.value === t.value) {
          u(), t = cn;
          break;
        }
        t = Tn;
        break;
      case "Comma":
        y !== null && y.type === zs ? I5(T.token) ? t = Tn : (u(), t = N5(y) ? Tn : cn) : t = I5(T.token) || N5(y) ? cn : Tn;
        break;
      case "String":
        let A = "", D = C;
        for (; D < e.length && A.length < t.value.length; D++)
          A += e[D].value;
        if ($2(A, t.value)) {
          for (; C < D; )
            u();
          t = cn;
        } else
          t = Tn;
        break;
      default:
        throw new Error("Unknown node type: " + t.type);
    }
  switch (x) {
    case null:
      console.warn("[csstree-match] BREAK after " + E5 + " iterations"), x = PTe, T = null;
      break;
    case A5:
      for (; h !== null; )
        f();
      break;
    default:
      T = null;
  }
  return {
    tokens: e,
    reason: x,
    iterations: w,
    match: T,
    longestMatch: S
  };
}
function z5(e, t, r) {
  const n = FTe(e, t, r || {});
  if (n.match === null)
    return n;
  let i = n.match, o = n.match = {
    syntax: t.syntax || null,
    match: []
  };
  const a = [o];
  for (i = RTe(i).prev; i !== null; ) {
    switch (i.type) {
      case w$:
        o.match.push(o = {
          syntax: i.syntax,
          match: []
        }), a.push(o);
        break;
      case EV:
        a.pop(), o = a[a.length - 1];
        break;
      default:
        o.match.push({
          syntax: i.syntax || null,
          token: i.token.value,
          node: i.token.node
        });
    }
    i = i.prev;
  }
  return n;
}
function IV(e) {
  function t(i) {
    return i === null ? !1 : i.type === "Type" || i.type === "Property" || i.type === "Keyword";
  }
  function r(i) {
    if (Array.isArray(i.match)) {
      for (let o = 0; o < i.match.length; o++)
        if (r(i.match[o]))
          return t(i.syntax) && n.unshift(i.syntax), !0;
    } else if (i.node === e)
      return n = t(i.syntax) ? [i.syntax] : [], !0;
    return !1;
  }
  let n = null;
  return this.matched !== null && r(this.matched), n;
}
function BTe(e, t) {
  return m_(this, e, (r) => r.type === "Type" && r.name === t);
}
function UTe(e, t) {
  return m_(this, e, (r) => r.type === "Property" && r.name === t);
}
function HTe(e) {
  return m_(this, e, (t) => t.type === "Keyword");
}
function m_(e, t, r) {
  const n = IV.call(e, t);
  return n === null ? !1 : n.some(r);
}
var WTe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getTrace: IV,
  isType: BTe,
  isProperty: UTe,
  isKeyword: HTe
}, Symbol.toStringTag, { value: "Module" }));
function NV(e) {
  return "node" in e ? e.node : NV(e.match[0]);
}
function zV(e) {
  return "node" in e ? e.node : zV(e.match[e.match.length - 1]);
}
function $5(e, t, r, n, i) {
  function o(s) {
    if (s.syntax !== null && s.syntax.type === n && s.syntax.name === i) {
      const u = NV(s), d = zV(s);
      e.syntax.walk(t, function(f, h, g) {
        if (f === u) {
          const m = new eo();
          do {
            if (m.appendData(h.data), h.data === d)
              break;
            h = h.next;
          } while (h !== null);
          a.push({
            parent: g,
            nodes: m
          });
        }
      });
    }
    Array.isArray(s.match) && s.match.forEach(o);
  }
  const a = [];
  return r.matched !== null && o(r.matched), a;
}
const { hasOwnProperty: r0 } = Object.prototype;
function O2(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e && e >= 0;
}
function O5(e) {
  return Boolean(e) && O2(e.offset) && O2(e.line) && O2(e.column);
}
function VTe(e, t) {
  return function(n, i) {
    if (!n || n.constructor !== Object)
      return i(n, "Type of node should be an Object");
    for (let o in n) {
      let a = !0;
      if (r0.call(n, o) !== !1) {
        if (o === "type")
          n.type !== e && i(n, "Wrong node type `" + n.type + "`, expected `" + e + "`");
        else if (o === "loc") {
          if (n.loc === null)
            continue;
          if (n.loc && n.loc.constructor === Object)
            if (typeof n.loc.source != "string")
              o += ".source";
            else if (!O5(n.loc.start))
              o += ".start";
            else if (!O5(n.loc.end))
              o += ".end";
            else
              continue;
          a = !1;
        } else if (t.hasOwnProperty(o)) {
          a = !1;
          for (let s = 0; !a && s < t[o].length; s++) {
            const u = t[o][s];
            switch (u) {
              case String:
                a = typeof n[o] == "string";
                break;
              case Boolean:
                a = typeof n[o] == "boolean";
                break;
              case null:
                a = n[o] === null;
                break;
              default:
                typeof u == "string" ? a = n[o] && n[o].type === u : Array.isArray(u) && (a = n[o] instanceof eo);
            }
          }
        } else
          i(n, "Unknown field `" + o + "` for " + e + " node type");
        a || i(n, "Bad value for `" + e + "." + o + "`");
      }
    }
    for (const o in t)
      r0.call(t, o) && r0.call(n, o) === !1 && i(n, "Field `" + e + "." + o + "` is missed");
  };
}
function YTe(e, t) {
  const r = t.structure, n = {
    type: String,
    loc: !0
  }, i = {
    type: '"' + e + '"'
  };
  for (const o in r) {
    if (r0.call(r, o) === !1)
      continue;
    const a = [], s = n[o] = Array.isArray(r[o]) ? r[o].slice() : [r[o]];
    for (let u = 0; u < s.length; u++) {
      const d = s[u];
      if (d === String || d === Boolean)
        a.push(d.name);
      else if (d === null)
        a.push("null");
      else if (typeof d == "string")
        a.push("<" + d + ">");
      else if (Array.isArray(d))
        a.push("List");
      else
        throw new Error("Wrong value `" + d + "` in `" + e + "." + o + "` structure definition");
    }
    i[o] = a.join(" | ");
  }
  return {
    docs: i,
    check: VTe(e, n)
  };
}
function QTe(e) {
  const t = {};
  if (e.node) {
    for (const r in e.node)
      if (r0.call(e.node, r)) {
        const n = e.node[r];
        if (n.structure)
          t[r] = YTe(r, n);
        else
          throw new Error("Missed `structure` field in `" + r + "` node type definition");
      }
  }
  return t;
}
const qTe = x$(gV.join(" | "));
function M$(e, t, r) {
  const n = {};
  for (const i in e)
    e[i].syntax && (n[i] = r ? e[i].syntax : a_(e[i].syntax, { compact: t }));
  return n;
}
function GTe(e, t, r) {
  const n = {};
  for (const [i, o] of Object.entries(e))
    n[i] = {
      prelude: o.prelude && (r ? o.prelude.syntax : a_(o.prelude.syntax, { compact: t })),
      descriptors: o.descriptors && M$(o.descriptors, t, r)
    };
  return n;
}
function ZTe(e) {
  for (let t = 0; t < e.length; t++)
    if (e[t].value.toLowerCase() === "var(")
      return !0;
  return !1;
}
function _l(e, t, r) {
  return vt({
    matched: e,
    iterations: r,
    error: t
  }, WTe);
}
function Ph(e, t, r, n) {
  const i = ITe(r, e.syntax);
  let o;
  return ZTe(i) ? _l(null, new Error("Matching for a tree with var() is not supported")) : (n && (o = z5(i, e.cssWideKeywordsSyntax, e)), (!n || !o.match) && (o = z5(i, t.match, e), !o.match) ? _l(null, new kSe(o.reason, t.syntax, r, o), o.iterations) : _l(o.match, null, o.iterations));
}
class _5 {
  constructor(t, r, n) {
    if (this.cssWideKeywordsSyntax = qTe, this.syntax = r, this.generic = !1, this.units = vt({}, v5), this.atrules = /* @__PURE__ */ Object.create(null), this.properties = /* @__PURE__ */ Object.create(null), this.types = /* @__PURE__ */ Object.create(null), this.structure = n || QTe(t), t) {
      if (t.units)
        for (const i of Object.keys(v5))
          Array.isArray(t.units[i]) && (this.units[i] = t.units[i]);
      if (t.types)
        for (const i in t.types)
          this.addType_(i, t.types[i]);
      if (t.generic) {
        this.generic = !0;
        for (const [i, o] of Object.entries(GSe(this.units)))
          this.addType_(i, o);
      }
      if (t.atrules)
        for (const i in t.atrules)
          this.addAtrule_(i, t.atrules[i]);
      if (t.properties)
        for (const i in t.properties)
          this.addProperty_(i, t.properties[i]);
    }
  }
  checkStructure(t) {
    function r(o, a) {
      i.push({ node: o, message: a });
    }
    const n = this.structure, i = [];
    return this.syntax.walk(t, function(o) {
      n.hasOwnProperty(o.type) ? n[o.type].check(o, r) : r(o, "Unknown node type `" + o.type + "`");
    }), i.length ? i : !1;
  }
  createDescriptor(t, r, n, i = null) {
    const o = {
      type: r,
      name: n
    }, a = {
      type: r,
      name: n,
      parent: i,
      serializable: typeof t == "string" || t && typeof t.type == "string",
      syntax: null,
      match: null
    };
    return typeof t == "function" ? a.match = x$(t, o) : (typeof t == "string" ? Object.defineProperty(a, "syntax", {
      get() {
        return Object.defineProperty(a, "syntax", {
          value: DV(t)
        }), a.syntax;
      }
    }) : a.syntax = t, Object.defineProperty(a, "match", {
      get() {
        return Object.defineProperty(a, "match", {
          value: x$(a.syntax, o)
        }), a.match;
      }
    })), a;
  }
  addAtrule_(t, r) {
    r && (this.atrules[t] = {
      type: "Atrule",
      name: t,
      prelude: r.prelude ? this.createDescriptor(r.prelude, "AtrulePrelude", t) : null,
      descriptors: r.descriptors ? Object.keys(r.descriptors).reduce((n, i) => (n[i] = this.createDescriptor(r.descriptors[i], "AtruleDescriptor", i, t), n), /* @__PURE__ */ Object.create(null)) : null
    });
  }
  addProperty_(t, r) {
    r && (this.properties[t] = this.createDescriptor(r, "Property", t));
  }
  addType_(t, r) {
    r && (this.types[t] = this.createDescriptor(r, "Type", t));
  }
  checkAtruleName(t) {
    if (!this.getAtrule(t))
      return new Iv("Unknown at-rule", "@" + t);
  }
  checkAtrulePrelude(t, r) {
    const n = this.checkAtruleName(t);
    if (n)
      return n;
    const i = this.getAtrule(t);
    if (!i.prelude && r)
      return new SyntaxError("At-rule `@" + t + "` should not contain a prelude");
    if (i.prelude && !r && !Ph(this, i.prelude, "", !1).matched)
      return new SyntaxError("At-rule `@" + t + "` should contain a prelude");
  }
  checkAtruleDescriptorName(t, r) {
    const n = this.checkAtruleName(t);
    if (n)
      return n;
    const i = this.getAtrule(t), o = E2(r);
    if (!i.descriptors)
      return new SyntaxError("At-rule `@" + t + "` has no known descriptors");
    if (!i.descriptors[o.name] && !i.descriptors[o.basename])
      return new Iv("Unknown at-rule descriptor", r);
  }
  checkPropertyName(t) {
    if (!this.getProperty(t))
      return new Iv("Unknown property", t);
  }
  matchAtrulePrelude(t, r) {
    const n = this.checkAtrulePrelude(t, r);
    if (n)
      return _l(null, n);
    const i = this.getAtrule(t);
    return i.prelude ? Ph(this, i.prelude, r || "", !1) : _l(null, null);
  }
  matchAtruleDescriptor(t, r, n) {
    const i = this.checkAtruleDescriptorName(t, r);
    if (i)
      return _l(null, i);
    const o = this.getAtrule(t), a = E2(r);
    return Ph(this, o.descriptors[a.name] || o.descriptors[a.basename], n, !1);
  }
  matchDeclaration(t) {
    return t.type !== "Declaration" ? _l(null, new Error("Not a Declaration node")) : this.matchProperty(t.property, t.value);
  }
  matchProperty(t, r) {
    if (g$(t).custom)
      return _l(null, new Error("Lexer matching doesn't applicable for custom properties"));
    const n = this.checkPropertyName(t);
    return n ? _l(null, n) : Ph(this, this.getProperty(t), r, !0);
  }
  matchType(t, r) {
    const n = this.getType(t);
    return n ? Ph(this, n, r, !1) : _l(null, new Iv("Unknown type", t));
  }
  match(t, r) {
    return typeof t != "string" && (!t || !t.type) ? _l(null, new Iv("Bad syntax")) : ((typeof t == "string" || !t.match) && (t = this.createDescriptor(t, "Type", "anonymous")), Ph(this, t, r, !1));
  }
  findValueFragments(t, r, n, i) {
    return $5(this, r, this.matchProperty(t, r), n, i);
  }
  findDeclarationValueFragments(t, r, n) {
    return $5(this, t.value, this.matchDeclaration(t), r, n);
  }
  findAllFragments(t, r, n) {
    const i = [];
    return this.syntax.walk(t, {
      visit: "Declaration",
      enter: (o) => {
        i.push.apply(i, this.findDeclarationValueFragments(o, r, n));
      }
    }), i;
  }
  getAtrule(t, r = !0) {
    const n = E2(t);
    return (n.vendor && r ? this.atrules[n.name] || this.atrules[n.basename] : this.atrules[n.name]) || null;
  }
  getAtrulePrelude(t, r = !0) {
    const n = this.getAtrule(t, r);
    return n && n.prelude || null;
  }
  getAtruleDescriptor(t, r) {
    return this.atrules.hasOwnProperty(t) && this.atrules.declarators && this.atrules[t].declarators[r] || null;
  }
  getProperty(t, r = !0) {
    const n = g$(t);
    return (n.vendor && r ? this.properties[n.name] || this.properties[n.basename] : this.properties[n.name]) || null;
  }
  getType(t) {
    return hasOwnProperty.call(this.types, t) ? this.types[t] : null;
  }
  validate() {
    function t(i, o, a, s) {
      if (a.has(o))
        return a.get(o);
      a.set(o, !1), s.syntax !== null && DTe(s.syntax, function(u) {
        if (u.type !== "Type" && u.type !== "Property")
          return;
        const d = u.type === "Type" ? i.types : i.properties, f = u.type === "Type" ? r : n;
        (!hasOwnProperty.call(d, u.name) || t(i, u.name, f, d[u.name])) && a.set(o, !0);
      }, this);
    }
    let r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
    for (const i in this.types)
      t(this, i, r, this.types[i]);
    for (const i in this.properties)
      t(this, i, n, this.properties[i]);
    return r = [...r.keys()].filter((i) => r.get(i)), n = [...n.keys()].filter((i) => n.get(i)), r.length || n.length ? {
      types: r,
      properties: n
    } : null;
  }
  dump(t, r) {
    return {
      generic: this.generic,
      units: this.units,
      types: M$(this.types, !r, t),
      properties: M$(this.properties, !r, t),
      atrules: GTe(this.atrules, !r, t)
    };
  }
  toString() {
    return JSON.stringify(this.dump());
  }
}
function _2(e, t) {
  return typeof t == "string" && /^\s*\|/.test(t) ? typeof e == "string" ? e + t : t.replace(/^\s*\|\s*/, "") : t || null;
}
function L5(e, t) {
  const r = /* @__PURE__ */ Object.create(null);
  for (const [n, i] of Object.entries(e))
    if (i) {
      r[n] = {};
      for (const o of Object.keys(i))
        t.includes(o) && (r[n][o] = i[o]);
    }
  return r;
}
function C$(e, t) {
  const r = vt({}, e);
  for (const [n, i] of Object.entries(t))
    switch (n) {
      case "generic":
        r[n] = Boolean(i);
        break;
      case "units":
        r[n] = vt({}, e[n]);
        for (const [o, a] of Object.entries(i))
          r[n][o] = Array.isArray(a) ? a : [];
        break;
      case "atrules":
        r[n] = vt({}, e[n]);
        for (const [o, a] of Object.entries(i)) {
          const s = r[n][o] || {}, u = r[n][o] = {
            prelude: s.prelude || null,
            descriptors: vt({}, s.descriptors)
          };
          if (a) {
            u.prelude = a.prelude ? _2(u.prelude, a.prelude) : u.prelude || null;
            for (const [d, f] of Object.entries(a.descriptors || {}))
              u.descriptors[d] = f ? _2(u.descriptors[d], f) : null;
            Object.keys(u.descriptors).length || (u.descriptors = null);
          }
        }
        break;
      case "types":
      case "properties":
        r[n] = vt({}, e[n]);
        for (const [o, a] of Object.entries(i))
          r[n][o] = _2(r[n][o], a);
        break;
      case "scope":
        r[n] = vt({}, e[n]);
        for (const [o, a] of Object.entries(i))
          r[n][o] = vt(vt({}, r[n][o]), a);
        break;
      case "parseContext":
        r[n] = vt(vt({}, e[n]), i);
        break;
      case "atrule":
      case "pseudo":
        r[n] = vt(vt({}, e[n]), L5(i, ["parse"]));
        break;
      case "node":
        r[n] = vt(vt({}, e[n]), L5(i, ["name", "structure", "parse", "generate", "walkContext"]));
        break;
    }
  return r;
}
function $V(e) {
  const t = rSe(e), r = xSe(e), n = mSe(e), { fromPlainObject: i, toPlainObject: o } = vSe(r), a = {
    lexer: null,
    createLexer: (s) => new _5(s, a, a.lexer.structure),
    tokenize: XM,
    parse: t,
    generate: n,
    walk: r,
    find: r.find,
    findLast: r.findLast,
    findAll: r.findAll,
    fromPlainObject: i,
    toPlainObject: o,
    fork(s) {
      const u = C$({}, e);
      return $V(typeof s == "function" ? s(u, Object.assign) : C$(u, s));
    }
  };
  return a.lexer = new _5({
    generic: !0,
    units: e.units,
    types: e.types,
    atrules: e.atrules,
    properties: e.properties,
    node: e.node
  }, a), a;
}
var KTe = (e) => $V(C$({}, e)), XTe = {
  generic: !0,
  units: {
    angle: [
      "deg",
      "grad",
      "rad",
      "turn"
    ],
    decibel: [
      "db"
    ],
    flex: [
      "fr"
    ],
    frequency: [
      "hz",
      "khz"
    ],
    length: [
      "cm",
      "mm",
      "q",
      "in",
      "pt",
      "pc",
      "px",
      "em",
      "rem",
      "ex",
      "rex",
      "cap",
      "rcap",
      "ch",
      "rch",
      "ic",
      "ric",
      "lh",
      "rlh",
      "vw",
      "svw",
      "lvw",
      "dvw",
      "vh",
      "svh",
      "lvh",
      "dvh",
      "vi",
      "svi",
      "lvi",
      "dvi",
      "vb",
      "svb",
      "lvb",
      "dvb",
      "vmin",
      "svmin",
      "lvmin",
      "dvmin",
      "vmax",
      "svmax",
      "lvmax",
      "dvmax",
      "cqw",
      "cqh",
      "cqi",
      "cqb",
      "cqmin",
      "cqmax"
    ],
    resolution: [
      "dpi",
      "dpcm",
      "dppx",
      "x"
    ],
    semitones: [
      "st"
    ],
    time: [
      "s",
      "ms"
    ]
  },
  types: {
    "abs()": "abs( <calc-sum> )",
    "absolute-size": "xx-small|x-small|small|medium|large|x-large|xx-large|xxx-large",
    "acos()": "acos( <calc-sum> )",
    "alpha-value": "<number>|<percentage>",
    "angle-percentage": "<angle>|<percentage>",
    "angular-color-hint": "<angle-percentage>",
    "angular-color-stop": "<color>&&<color-stop-angle>?",
    "angular-color-stop-list": "[<angular-color-stop> [, <angular-color-hint>]?]# , <angular-color-stop>",
    "animateable-feature": "scroll-position|contents|<custom-ident>",
    "asin()": "asin( <calc-sum> )",
    "atan()": "atan( <calc-sum> )",
    "atan2()": "atan2( <calc-sum> , <calc-sum> )",
    attachment: "scroll|fixed|local",
    "attr()": "attr( <attr-name> <type-or-unit>? [, <attr-fallback>]? )",
    "attr-matcher": "['~'|'|'|'^'|'$'|'*']? '='",
    "attr-modifier": "i|s",
    "attribute-selector": "'[' <wq-name> ']'|'[' <wq-name> <attr-matcher> [<string-token>|<ident-token>] <attr-modifier>? ']'",
    "auto-repeat": "repeat( [auto-fill|auto-fit] , [<line-names>? <fixed-size>]+ <line-names>? )",
    "auto-track-list": "[<line-names>? [<fixed-size>|<fixed-repeat>]]* <line-names>? <auto-repeat> [<line-names>? [<fixed-size>|<fixed-repeat>]]* <line-names>?",
    axis: "block|inline|vertical|horizontal",
    "baseline-position": "[first|last]? baseline",
    "basic-shape": "<inset()>|<circle()>|<ellipse()>|<polygon()>|<path()>",
    "bg-image": "none|<image>",
    "bg-layer": "<bg-image>||<bg-position> [/ <bg-size>]?||<repeat-style>||<attachment>||<box>||<box>",
    "bg-position": "[[left|center|right|top|bottom|<length-percentage>]|[left|center|right|<length-percentage>] [top|center|bottom|<length-percentage>]|[center|[left|right] <length-percentage>?]&&[center|[top|bottom] <length-percentage>?]]",
    "bg-size": "[<length-percentage>|auto]{1,2}|cover|contain",
    "blur()": "blur( <length> )",
    "blend-mode": "normal|multiply|screen|overlay|darken|lighten|color-dodge|color-burn|hard-light|soft-light|difference|exclusion|hue|saturation|color|luminosity",
    box: "border-box|padding-box|content-box",
    "brightness()": "brightness( <number-percentage> )",
    "calc()": "calc( <calc-sum> )",
    "calc-sum": "<calc-product> [['+'|'-'] <calc-product>]*",
    "calc-product": "<calc-value> ['*' <calc-value>|'/' <number>]*",
    "calc-value": "<number>|<dimension>|<percentage>|<calc-constant>|( <calc-sum> )",
    "calc-constant": "e|pi|infinity|-infinity|NaN",
    "cf-final-image": "<image>|<color>",
    "cf-mixing-image": "<percentage>?&&<image>",
    "circle()": "circle( [<shape-radius>]? [at <position>]? )",
    "clamp()": "clamp( <calc-sum>#{3} )",
    "class-selector": "'.' <ident-token>",
    "clip-source": "<url>",
    color: "<rgb()>|<rgba()>|<hsl()>|<hsla()>|<hwb()>|<lab()>|<lch()>|<hex-color>|<named-color>|currentcolor|<deprecated-system-color>",
    "color-stop": "<color-stop-length>|<color-stop-angle>",
    "color-stop-angle": "<angle-percentage>{1,2}",
    "color-stop-length": "<length-percentage>{1,2}",
    "color-stop-list": "[<linear-color-stop> [, <linear-color-hint>]?]# , <linear-color-stop>",
    combinator: "'>'|'+'|'~'|['||']",
    "common-lig-values": "[common-ligatures|no-common-ligatures]",
    "compat-auto": "searchfield|textarea|push-button|slider-horizontal|checkbox|radio|square-button|menulist|listbox|meter|progress-bar|button",
    "composite-style": "clear|copy|source-over|source-in|source-out|source-atop|destination-over|destination-in|destination-out|destination-atop|xor",
    "compositing-operator": "add|subtract|intersect|exclude",
    "compound-selector": "[<type-selector>? <subclass-selector>* [<pseudo-element-selector> <pseudo-class-selector>*]*]!",
    "compound-selector-list": "<compound-selector>#",
    "complex-selector": "<compound-selector> [<combinator>? <compound-selector>]*",
    "complex-selector-list": "<complex-selector>#",
    "conic-gradient()": "conic-gradient( [from <angle>]? [at <position>]? , <angular-color-stop-list> )",
    "contextual-alt-values": "[contextual|no-contextual]",
    "content-distribution": "space-between|space-around|space-evenly|stretch",
    "content-list": "[<string>|contents|<image>|<counter>|<quote>|<target>|<leader()>|<attr()>]+",
    "content-position": "center|start|end|flex-start|flex-end",
    "content-replacement": "<image>",
    "contrast()": "contrast( [<number-percentage>] )",
    "cos()": "cos( <calc-sum> )",
    counter: "<counter()>|<counters()>",
    "counter()": "counter( <counter-name> , <counter-style>? )",
    "counter-name": "<custom-ident>",
    "counter-style": "<counter-style-name>|symbols( )",
    "counter-style-name": "<custom-ident>",
    "counters()": "counters( <counter-name> , <string> , <counter-style>? )",
    "cross-fade()": "cross-fade( <cf-mixing-image> , <cf-final-image>? )",
    "cubic-bezier-timing-function": "ease|ease-in|ease-out|ease-in-out|cubic-bezier( <number [0,1]> , <number> , <number [0,1]> , <number> )",
    "deprecated-system-color": "ActiveBorder|ActiveCaption|AppWorkspace|Background|ButtonFace|ButtonHighlight|ButtonShadow|ButtonText|CaptionText|GrayText|Highlight|HighlightText|InactiveBorder|InactiveCaption|InactiveCaptionText|InfoBackground|InfoText|Menu|MenuText|Scrollbar|ThreeDDarkShadow|ThreeDFace|ThreeDHighlight|ThreeDLightShadow|ThreeDShadow|Window|WindowFrame|WindowText",
    "discretionary-lig-values": "[discretionary-ligatures|no-discretionary-ligatures]",
    "display-box": "contents|none",
    "display-inside": "flow|flow-root|table|flex|grid|ruby",
    "display-internal": "table-row-group|table-header-group|table-footer-group|table-row|table-cell|table-column-group|table-column|table-caption|ruby-base|ruby-text|ruby-base-container|ruby-text-container",
    "display-legacy": "inline-block|inline-list-item|inline-table|inline-flex|inline-grid",
    "display-listitem": "<display-outside>?&&[flow|flow-root]?&&list-item",
    "display-outside": "block|inline|run-in",
    "drop-shadow()": "drop-shadow( <length>{2,3} <color>? )",
    "east-asian-variant-values": "[jis78|jis83|jis90|jis04|simplified|traditional]",
    "east-asian-width-values": "[full-width|proportional-width]",
    "element()": "element( <custom-ident> , [first|start|last|first-except]? )|element( <id-selector> )",
    "ellipse()": "ellipse( [<shape-radius>{2}]? [at <position>]? )",
    "ending-shape": "circle|ellipse",
    "env()": "env( <custom-ident> , <declaration-value>? )",
    "exp()": "exp( <calc-sum> )",
    "explicit-track-list": "[<line-names>? <track-size>]+ <line-names>?",
    "family-name": "<string>|<custom-ident>+",
    "feature-tag-value": "<string> [<integer>|on|off]?",
    "feature-type": "@stylistic|@historical-forms|@styleset|@character-variant|@swash|@ornaments|@annotation",
    "feature-value-block": "<feature-type> '{' <feature-value-declaration-list> '}'",
    "feature-value-block-list": "<feature-value-block>+",
    "feature-value-declaration": "<custom-ident> : <integer>+ ;",
    "feature-value-declaration-list": "<feature-value-declaration>",
    "feature-value-name": "<custom-ident>",
    "fill-rule": "nonzero|evenodd",
    "filter-function": "<blur()>|<brightness()>|<contrast()>|<drop-shadow()>|<grayscale()>|<hue-rotate()>|<invert()>|<opacity()>|<saturate()>|<sepia()>",
    "filter-function-list": "[<filter-function>|<url>]+",
    "final-bg-layer": "<'background-color'>||<bg-image>||<bg-position> [/ <bg-size>]?||<repeat-style>||<attachment>||<box>||<box>",
    "fixed-breadth": "<length-percentage>",
    "fixed-repeat": "repeat( [<integer [1,∞]>] , [<line-names>? <fixed-size>]+ <line-names>? )",
    "fixed-size": "<fixed-breadth>|minmax( <fixed-breadth> , <track-breadth> )|minmax( <inflexible-breadth> , <fixed-breadth> )",
    "font-stretch-absolute": "normal|ultra-condensed|extra-condensed|condensed|semi-condensed|semi-expanded|expanded|extra-expanded|ultra-expanded|<percentage>",
    "font-variant-css21": "[normal|small-caps]",
    "font-weight-absolute": "normal|bold|<number [1,1000]>",
    "frequency-percentage": "<frequency>|<percentage>",
    "general-enclosed": "[<function-token> <any-value> )]|( <ident> <any-value> )",
    "generic-family": "serif|sans-serif|cursive|fantasy|monospace|-apple-system",
    "generic-name": "serif|sans-serif|cursive|fantasy|monospace",
    "geometry-box": "<shape-box>|fill-box|stroke-box|view-box",
    gradient: "<linear-gradient()>|<repeating-linear-gradient()>|<radial-gradient()>|<repeating-radial-gradient()>|<conic-gradient()>|<repeating-conic-gradient()>|<-legacy-gradient>",
    "grayscale()": "grayscale( <number-percentage> )",
    "grid-line": "auto|<custom-ident>|[<integer>&&<custom-ident>?]|[span&&[<integer>||<custom-ident>]]",
    "historical-lig-values": "[historical-ligatures|no-historical-ligatures]",
    "hsl()": "hsl( <hue> <percentage> <percentage> [/ <alpha-value>]? )|hsl( <hue> , <percentage> , <percentage> , <alpha-value>? )",
    "hsla()": "hsla( <hue> <percentage> <percentage> [/ <alpha-value>]? )|hsla( <hue> , <percentage> , <percentage> , <alpha-value>? )",
    hue: "<number>|<angle>",
    "hue-rotate()": "hue-rotate( <angle> )",
    "hwb()": "hwb( [<hue>|none] [<percentage>|none] [<percentage>|none] [/ [<alpha-value>|none]]? )",
    "hypot()": "hypot( <calc-sum># )",
    image: "<url>|<image()>|<image-set()>|<element()>|<paint()>|<cross-fade()>|<gradient>",
    "image()": "image( <image-tags>? [<image-src>? , <color>?]! )",
    "image-set()": "image-set( <image-set-option># )",
    "image-set-option": "[<image>|<string>] [<resolution>||type( <string> )]",
    "image-src": "<url>|<string>",
    "image-tags": "ltr|rtl",
    "inflexible-breadth": "<length-percentage>|min-content|max-content|auto",
    "inset()": "inset( <length-percentage>{1,4} [round <'border-radius'>]? )",
    "invert()": "invert( <number-percentage> )",
    "keyframes-name": "<custom-ident>|<string>",
    "keyframe-block": "<keyframe-selector># { <declaration-list> }",
    "keyframe-block-list": "<keyframe-block>+",
    "keyframe-selector": "from|to|<percentage>",
    "lab()": "lab( [<percentage>|<number>|none] [<percentage>|<number>|none] [<percentage>|<number>|none] [/ [<alpha-value>|none]]? )",
    "layer()": "layer( <layer-name> )",
    "layer-name": "<ident> ['.' <ident>]*",
    "lch()": "lch( [<percentage>|<number>|none] [<percentage>|<number>|none] [<hue>|none] [/ [<alpha-value>|none]]? )",
    "leader()": "leader( <leader-type> )",
    "leader-type": "dotted|solid|space|<string>",
    "length-percentage": "<length>|<percentage>",
    "line-names": "'[' <custom-ident>* ']'",
    "line-name-list": "[<line-names>|<name-repeat>]+",
    "line-style": "none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset",
    "line-width": "<length>|thin|medium|thick",
    "linear-color-hint": "<length-percentage>",
    "linear-color-stop": "<color> <color-stop-length>?",
    "linear-gradient()": "linear-gradient( [<angle>|to <side-or-corner>]? , <color-stop-list> )",
    "log()": "log( <calc-sum> , <calc-sum>? )",
    "mask-layer": "<mask-reference>||<position> [/ <bg-size>]?||<repeat-style>||<geometry-box>||[<geometry-box>|no-clip]||<compositing-operator>||<masking-mode>",
    "mask-position": "[<length-percentage>|left|center|right] [<length-percentage>|top|center|bottom]?",
    "mask-reference": "none|<image>|<mask-source>",
    "mask-source": "<url>",
    "masking-mode": "alpha|luminance|match-source",
    "matrix()": "matrix( <number>#{6} )",
    "matrix3d()": "matrix3d( <number>#{16} )",
    "max()": "max( <calc-sum># )",
    "media-and": "<media-in-parens> [and <media-in-parens>]+",
    "media-condition": "<media-not>|<media-and>|<media-or>|<media-in-parens>",
    "media-condition-without-or": "<media-not>|<media-and>|<media-in-parens>",
    "media-feature": "( [<mf-plain>|<mf-boolean>|<mf-range>] )",
    "media-in-parens": "( <media-condition> )|<media-feature>|<general-enclosed>",
    "media-not": "not <media-in-parens>",
    "media-or": "<media-in-parens> [or <media-in-parens>]+",
    "media-query": "<media-condition>|[not|only]? <media-type> [and <media-condition-without-or>]?",
    "media-query-list": "<media-query>#",
    "media-type": "<ident>",
    "mf-boolean": "<mf-name>",
    "mf-name": "<ident>",
    "mf-plain": "<mf-name> : <mf-value>",
    "mf-range": "<mf-name> ['<'|'>']? '='? <mf-value>|<mf-value> ['<'|'>']? '='? <mf-name>|<mf-value> '<' '='? <mf-name> '<' '='? <mf-value>|<mf-value> '>' '='? <mf-name> '>' '='? <mf-value>",
    "mf-value": "<number>|<dimension>|<ident>|<ratio>",
    "min()": "min( <calc-sum># )",
    "minmax()": "minmax( [<length-percentage>|min-content|max-content|auto] , [<length-percentage>|<flex>|min-content|max-content|auto] )",
    "mod()": "mod( <calc-sum> , <calc-sum> )",
    "name-repeat": "repeat( [<integer [1,∞]>|auto-fill] , <line-names>+ )",
    "named-color": "transparent|aliceblue|antiquewhite|aqua|aquamarine|azure|beige|bisque|black|blanchedalmond|blue|blueviolet|brown|burlywood|cadetblue|chartreuse|chocolate|coral|cornflowerblue|cornsilk|crimson|cyan|darkblue|darkcyan|darkgoldenrod|darkgray|darkgreen|darkgrey|darkkhaki|darkmagenta|darkolivegreen|darkorange|darkorchid|darkred|darksalmon|darkseagreen|darkslateblue|darkslategray|darkslategrey|darkturquoise|darkviolet|deeppink|deepskyblue|dimgray|dimgrey|dodgerblue|firebrick|floralwhite|forestgreen|fuchsia|gainsboro|ghostwhite|gold|goldenrod|gray|green|greenyellow|grey|honeydew|hotpink|indianred|indigo|ivory|khaki|lavender|lavenderblush|lawngreen|lemonchiffon|lightblue|lightcoral|lightcyan|lightgoldenrodyellow|lightgray|lightgreen|lightgrey|lightpink|lightsalmon|lightseagreen|lightskyblue|lightslategray|lightslategrey|lightsteelblue|lightyellow|lime|limegreen|linen|magenta|maroon|mediumaquamarine|mediumblue|mediumorchid|mediumpurple|mediumseagreen|mediumslateblue|mediumspringgreen|mediumturquoise|mediumvioletred|midnightblue|mintcream|mistyrose|moccasin|navajowhite|navy|oldlace|olive|olivedrab|orange|orangered|orchid|palegoldenrod|palegreen|paleturquoise|palevioletred|papayawhip|peachpuff|peru|pink|plum|powderblue|purple|rebeccapurple|red|rosybrown|royalblue|saddlebrown|salmon|sandybrown|seagreen|seashell|sienna|silver|skyblue|slateblue|slategray|slategrey|snow|springgreen|steelblue|tan|teal|thistle|tomato|turquoise|violet|wheat|white|whitesmoke|yellow|yellowgreen|<-non-standard-color>",
    "namespace-prefix": "<ident>",
    "ns-prefix": "[<ident-token>|'*']? '|'",
    "number-percentage": "<number>|<percentage>",
    "numeric-figure-values": "[lining-nums|oldstyle-nums]",
    "numeric-fraction-values": "[diagonal-fractions|stacked-fractions]",
    "numeric-spacing-values": "[proportional-nums|tabular-nums]",
    nth: "<an-plus-b>|even|odd",
    "opacity()": "opacity( [<number-percentage>] )",
    "overflow-position": "unsafe|safe",
    "outline-radius": "<length>|<percentage>",
    "page-body": "<declaration>? [; <page-body>]?|<page-margin-box> <page-body>",
    "page-margin-box": "<page-margin-box-type> '{' <declaration-list> '}'",
    "page-margin-box-type": "@top-left-corner|@top-left|@top-center|@top-right|@top-right-corner|@bottom-left-corner|@bottom-left|@bottom-center|@bottom-right|@bottom-right-corner|@left-top|@left-middle|@left-bottom|@right-top|@right-middle|@right-bottom",
    "page-selector-list": "[<page-selector>#]?",
    "page-selector": "<pseudo-page>+|<ident> <pseudo-page>*",
    "page-size": "A5|A4|A3|B5|B4|JIS-B5|JIS-B4|letter|legal|ledger",
    "path()": "path( [<fill-rule> ,]? <string> )",
    "paint()": "paint( <ident> , <declaration-value>? )",
    "perspective()": "perspective( [<length [0,∞]>|none] )",
    "polygon()": "polygon( <fill-rule>? , [<length-percentage> <length-percentage>]# )",
    position: "[[left|center|right]||[top|center|bottom]|[left|center|right|<length-percentage>] [top|center|bottom|<length-percentage>]?|[[left|right] <length-percentage>]&&[[top|bottom] <length-percentage>]]",
    "pow()": "pow( <calc-sum> , <calc-sum> )",
    "pseudo-class-selector": "':' <ident-token>|':' <function-token> <any-value> ')'",
    "pseudo-element-selector": "':' <pseudo-class-selector>",
    "pseudo-page": ": [left|right|first|blank]",
    quote: "open-quote|close-quote|no-open-quote|no-close-quote",
    "radial-gradient()": "radial-gradient( [<ending-shape>||<size>]? [at <position>]? , <color-stop-list> )",
    ratio: "<number [0,∞]> [/ <number [0,∞]>]?",
    "relative-selector": "<combinator>? <complex-selector>",
    "relative-selector-list": "<relative-selector>#",
    "relative-size": "larger|smaller",
    "rem()": "rem( <calc-sum> , <calc-sum> )",
    "repeat-style": "repeat-x|repeat-y|[repeat|space|round|no-repeat]{1,2}",
    "repeating-conic-gradient()": "repeating-conic-gradient( [from <angle>]? [at <position>]? , <angular-color-stop-list> )",
    "repeating-linear-gradient()": "repeating-linear-gradient( [<angle>|to <side-or-corner>]? , <color-stop-list> )",
    "repeating-radial-gradient()": "repeating-radial-gradient( [<ending-shape>||<size>]? [at <position>]? , <color-stop-list> )",
    "reversed-counter-name": "reversed( <counter-name> )",
    "rgb()": "rgb( <percentage>{3} [/ <alpha-value>]? )|rgb( <number>{3} [/ <alpha-value>]? )|rgb( <percentage>#{3} , <alpha-value>? )|rgb( <number>#{3} , <alpha-value>? )",
    "rgba()": "rgba( <percentage>{3} [/ <alpha-value>]? )|rgba( <number>{3} [/ <alpha-value>]? )|rgba( <percentage>#{3} , <alpha-value>? )|rgba( <number>#{3} , <alpha-value>? )",
    "rotate()": "rotate( [<angle>|<zero>] )",
    "rotate3d()": "rotate3d( <number> , <number> , <number> , [<angle>|<zero>] )",
    "rotateX()": "rotateX( [<angle>|<zero>] )",
    "rotateY()": "rotateY( [<angle>|<zero>] )",
    "rotateZ()": "rotateZ( [<angle>|<zero>] )",
    "round()": "round( <rounding-strategy>? , <calc-sum> , <calc-sum> )",
    "rounding-strategy": "nearest|up|down|to-zero",
    "saturate()": "saturate( <number-percentage> )",
    "scale()": "scale( [<number>|<percentage>]#{1,2} )",
    "scale3d()": "scale3d( [<number>|<percentage>]#{3} )",
    "scaleX()": "scaleX( [<number>|<percentage>] )",
    "scaleY()": "scaleY( [<number>|<percentage>] )",
    "scaleZ()": "scaleZ( [<number>|<percentage>] )",
    scroller: "root|nearest",
    "self-position": "center|start|end|self-start|self-end|flex-start|flex-end",
    "shape-radius": "<length-percentage>|closest-side|farthest-side",
    "sign()": "sign( <calc-sum> )",
    "skew()": "skew( [<angle>|<zero>] , [<angle>|<zero>]? )",
    "skewX()": "skewX( [<angle>|<zero>] )",
    "skewY()": "skewY( [<angle>|<zero>] )",
    "sepia()": "sepia( <number-percentage> )",
    shadow: "inset?&&<length>{2,4}&&<color>?",
    "shadow-t": "[<length>{2,3}&&<color>?]",
    shape: "rect( <top> , <right> , <bottom> , <left> )|rect( <top> <right> <bottom> <left> )",
    "shape-box": "<box>|margin-box",
    "side-or-corner": "[left|right]||[top|bottom]",
    "sin()": "sin( <calc-sum> )",
    "single-animation": "<time>||<easing-function>||<time>||<single-animation-iteration-count>||<single-animation-direction>||<single-animation-fill-mode>||<single-animation-play-state>||[none|<keyframes-name>]",
    "single-animation-direction": "normal|reverse|alternate|alternate-reverse",
    "single-animation-fill-mode": "none|forwards|backwards|both",
    "single-animation-iteration-count": "infinite|<number>",
    "single-animation-play-state": "running|paused",
    "single-animation-timeline": "auto|none|<timeline-name>|scroll( <axis>? <scroller>? )",
    "single-transition": "[none|<single-transition-property>]||<time>||<easing-function>||<time>",
    "single-transition-property": "all|<custom-ident>",
    size: "closest-side|farthest-side|closest-corner|farthest-corner|<length>|<length-percentage>{2}",
    "sqrt()": "sqrt( <calc-sum> )",
    "step-position": "jump-start|jump-end|jump-none|jump-both|start|end",
    "step-timing-function": "step-start|step-end|steps( <integer> [, <step-position>]? )",
    "subclass-selector": "<id-selector>|<class-selector>|<attribute-selector>|<pseudo-class-selector>",
    "supports-condition": "not <supports-in-parens>|<supports-in-parens> [and <supports-in-parens>]*|<supports-in-parens> [or <supports-in-parens>]*",
    "supports-in-parens": "( <supports-condition> )|<supports-feature>|<general-enclosed>",
    "supports-feature": "<supports-decl>|<supports-selector-fn>",
    "supports-decl": "( <declaration> )",
    "supports-selector-fn": "selector( <complex-selector> )",
    symbol: "<string>|<image>|<custom-ident>",
    "tan()": "tan( <calc-sum> )",
    target: "<target-counter()>|<target-counters()>|<target-text()>",
    "target-counter()": "target-counter( [<string>|<url>] , <custom-ident> , <counter-style>? )",
    "target-counters()": "target-counters( [<string>|<url>] , <custom-ident> , <string> , <counter-style>? )",
    "target-text()": "target-text( [<string>|<url>] , [content|before|after|first-letter]? )",
    "time-percentage": "<time>|<percentage>",
    "timeline-name": "<custom-ident>|<string>",
    "easing-function": "linear|<cubic-bezier-timing-function>|<step-timing-function>",
    "track-breadth": "<length-percentage>|<flex>|min-content|max-content|auto",
    "track-list": "[<line-names>? [<track-size>|<track-repeat>]]+ <line-names>?",
    "track-repeat": "repeat( [<integer [1,∞]>] , [<line-names>? <track-size>]+ <line-names>? )",
    "track-size": "<track-breadth>|minmax( <inflexible-breadth> , <track-breadth> )|fit-content( <length-percentage> )",
    "transform-function": "<matrix()>|<translate()>|<translateX()>|<translateY()>|<scale()>|<scaleX()>|<scaleY()>|<rotate()>|<skew()>|<skewX()>|<skewY()>|<matrix3d()>|<translate3d()>|<translateZ()>|<scale3d()>|<scaleZ()>|<rotate3d()>|<rotateX()>|<rotateY()>|<rotateZ()>|<perspective()>",
    "transform-list": "<transform-function>+",
    "translate()": "translate( <length-percentage> , <length-percentage>? )",
    "translate3d()": "translate3d( <length-percentage> , <length-percentage> , <length> )",
    "translateX()": "translateX( <length-percentage> )",
    "translateY()": "translateY( <length-percentage> )",
    "translateZ()": "translateZ( <length> )",
    "type-or-unit": "string|color|url|integer|number|length|angle|time|frequency|cap|ch|em|ex|ic|lh|rlh|rem|vb|vi|vw|vh|vmin|vmax|mm|Q|cm|in|pt|pc|px|deg|grad|rad|turn|ms|s|Hz|kHz|%",
    "type-selector": "<wq-name>|<ns-prefix>? '*'",
    "var()": "var( <custom-property-name> , <declaration-value>? )",
    "viewport-length": "auto|<length-percentage>",
    "visual-box": "content-box|padding-box|border-box",
    "wq-name": "<ns-prefix>? <ident-token>",
    "-legacy-gradient": "<-webkit-gradient()>|<-legacy-linear-gradient>|<-legacy-repeating-linear-gradient>|<-legacy-radial-gradient>|<-legacy-repeating-radial-gradient>",
    "-legacy-linear-gradient": "-moz-linear-gradient( <-legacy-linear-gradient-arguments> )|-webkit-linear-gradient( <-legacy-linear-gradient-arguments> )|-o-linear-gradient( <-legacy-linear-gradient-arguments> )",
    "-legacy-repeating-linear-gradient": "-moz-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )|-webkit-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )|-o-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )",
    "-legacy-linear-gradient-arguments": "[<angle>|<side-or-corner>]? , <color-stop-list>",
    "-legacy-radial-gradient": "-moz-radial-gradient( <-legacy-radial-gradient-arguments> )|-webkit-radial-gradient( <-legacy-radial-gradient-arguments> )|-o-radial-gradient( <-legacy-radial-gradient-arguments> )",
    "-legacy-repeating-radial-gradient": "-moz-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )|-webkit-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )|-o-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )",
    "-legacy-radial-gradient-arguments": "[<position> ,]? [[[<-legacy-radial-gradient-shape>||<-legacy-radial-gradient-size>]|[<length>|<percentage>]{2}] ,]? <color-stop-list>",
    "-legacy-radial-gradient-size": "closest-side|closest-corner|farthest-side|farthest-corner|contain|cover",
    "-legacy-radial-gradient-shape": "circle|ellipse",
    "-non-standard-font": "-apple-system-body|-apple-system-headline|-apple-system-subheadline|-apple-system-caption1|-apple-system-caption2|-apple-system-footnote|-apple-system-short-body|-apple-system-short-headline|-apple-system-short-subheadline|-apple-system-short-caption1|-apple-system-short-footnote|-apple-system-tall-body",
    "-non-standard-color": "-moz-ButtonDefault|-moz-ButtonHoverFace|-moz-ButtonHoverText|-moz-CellHighlight|-moz-CellHighlightText|-moz-Combobox|-moz-ComboboxText|-moz-Dialog|-moz-DialogText|-moz-dragtargetzone|-moz-EvenTreeRow|-moz-Field|-moz-FieldText|-moz-html-CellHighlight|-moz-html-CellHighlightText|-moz-mac-accentdarkestshadow|-moz-mac-accentdarkshadow|-moz-mac-accentface|-moz-mac-accentlightesthighlight|-moz-mac-accentlightshadow|-moz-mac-accentregularhighlight|-moz-mac-accentregularshadow|-moz-mac-chrome-active|-moz-mac-chrome-inactive|-moz-mac-focusring|-moz-mac-menuselect|-moz-mac-menushadow|-moz-mac-menutextselect|-moz-MenuHover|-moz-MenuHoverText|-moz-MenuBarText|-moz-MenuBarHoverText|-moz-nativehyperlinktext|-moz-OddTreeRow|-moz-win-communicationstext|-moz-win-mediatext|-moz-activehyperlinktext|-moz-default-background-color|-moz-default-color|-moz-hyperlinktext|-moz-visitedhyperlinktext|-webkit-activelink|-webkit-focus-ring-color|-webkit-link|-webkit-text",
    "-non-standard-image-rendering": "optimize-contrast|-moz-crisp-edges|-o-crisp-edges|-webkit-optimize-contrast",
    "-non-standard-overflow": "-moz-scrollbars-none|-moz-scrollbars-horizontal|-moz-scrollbars-vertical|-moz-hidden-unscrollable",
    "-non-standard-width": "fill-available|min-intrinsic|intrinsic|-moz-available|-moz-fit-content|-moz-min-content|-moz-max-content|-webkit-min-content|-webkit-max-content",
    "-webkit-gradient()": "-webkit-gradient( <-webkit-gradient-type> , <-webkit-gradient-point> [, <-webkit-gradient-point>|, <-webkit-gradient-radius> , <-webkit-gradient-point>] [, <-webkit-gradient-radius>]? [, <-webkit-gradient-color-stop>]* )",
    "-webkit-gradient-color-stop": "from( <color> )|color-stop( [<number-zero-one>|<percentage>] , <color> )|to( <color> )",
    "-webkit-gradient-point": "[left|center|right|<length-percentage>] [top|center|bottom|<length-percentage>]",
    "-webkit-gradient-radius": "<length>|<percentage>",
    "-webkit-gradient-type": "linear|radial",
    "-webkit-mask-box-repeat": "repeat|stretch|round",
    "-webkit-mask-clip-style": "border|border-box|padding|padding-box|content|content-box|text",
    "-ms-filter-function-list": "<-ms-filter-function>+",
    "-ms-filter-function": "<-ms-filter-function-progid>|<-ms-filter-function-legacy>",
    "-ms-filter-function-progid": "'progid:' [<ident-token> '.']* [<ident-token>|<function-token> <any-value>? )]",
    "-ms-filter-function-legacy": "<ident-token>|<function-token> <any-value>? )",
    "-ms-filter": "<string>",
    age: "child|young|old",
    "attr-name": "<wq-name>",
    "attr-fallback": "<any-value>",
    "bg-clip": "<box>|border|text",
    bottom: "<length>|auto",
    "generic-voice": "[<age>? <gender> <integer>?]",
    gender: "male|female|neutral",
    left: "<length>|auto",
    "mask-image": "<mask-reference>#",
    paint: "none|<color>|<url> [none|<color>]?|context-fill|context-stroke",
    right: "<length>|auto",
    "scroll-timeline-axis": "block|inline|vertical|horizontal",
    "scroll-timeline-name": "none|<custom-ident>",
    "single-animation-composition": "replace|add|accumulate",
    "svg-length": "<percentage>|<length>|<number>",
    "svg-writing-mode": "lr-tb|rl-tb|tb-rl|lr|rl|tb",
    top: "<length>|auto",
    x: "<number>",
    y: "<number>",
    declaration: "<ident-token> : <declaration-value>? ['!' important]?",
    "declaration-list": "[<declaration>? ';']* <declaration>?",
    url: "url( <string> <url-modifier>* )|<url-token>",
    "url-modifier": "<ident>|<function-token> <any-value> )",
    "number-zero-one": "<number [0,1]>",
    "number-one-or-greater": "<number [1,∞]>",
    "-non-standard-display": "-ms-inline-flexbox|-ms-grid|-ms-inline-grid|-webkit-flex|-webkit-inline-flex|-webkit-box|-webkit-inline-box|-moz-inline-stack|-moz-box|-moz-inline-box"
  },
  properties: {
    "--*": "<declaration-value>",
    "-ms-accelerator": "false|true",
    "-ms-block-progression": "tb|rl|bt|lr",
    "-ms-content-zoom-chaining": "none|chained",
    "-ms-content-zooming": "none|zoom",
    "-ms-content-zoom-limit": "<'-ms-content-zoom-limit-min'> <'-ms-content-zoom-limit-max'>",
    "-ms-content-zoom-limit-max": "<percentage>",
    "-ms-content-zoom-limit-min": "<percentage>",
    "-ms-content-zoom-snap": "<'-ms-content-zoom-snap-type'>||<'-ms-content-zoom-snap-points'>",
    "-ms-content-zoom-snap-points": "snapInterval( <percentage> , <percentage> )|snapList( <percentage># )",
    "-ms-content-zoom-snap-type": "none|proximity|mandatory",
    "-ms-filter": "<string>",
    "-ms-flow-from": "[none|<custom-ident>]#",
    "-ms-flow-into": "[none|<custom-ident>]#",
    "-ms-grid-columns": "none|<track-list>|<auto-track-list>",
    "-ms-grid-rows": "none|<track-list>|<auto-track-list>",
    "-ms-high-contrast-adjust": "auto|none",
    "-ms-hyphenate-limit-chars": "auto|<integer>{1,3}",
    "-ms-hyphenate-limit-lines": "no-limit|<integer>",
    "-ms-hyphenate-limit-zone": "<percentage>|<length>",
    "-ms-ime-align": "auto|after",
    "-ms-overflow-style": "auto|none|scrollbar|-ms-autohiding-scrollbar",
    "-ms-scrollbar-3dlight-color": "<color>",
    "-ms-scrollbar-arrow-color": "<color>",
    "-ms-scrollbar-base-color": "<color>",
    "-ms-scrollbar-darkshadow-color": "<color>",
    "-ms-scrollbar-face-color": "<color>",
    "-ms-scrollbar-highlight-color": "<color>",
    "-ms-scrollbar-shadow-color": "<color>",
    "-ms-scrollbar-track-color": "<color>",
    "-ms-scroll-chaining": "chained|none",
    "-ms-scroll-limit": "<'-ms-scroll-limit-x-min'> <'-ms-scroll-limit-y-min'> <'-ms-scroll-limit-x-max'> <'-ms-scroll-limit-y-max'>",
    "-ms-scroll-limit-x-max": "auto|<length>",
    "-ms-scroll-limit-x-min": "<length>",
    "-ms-scroll-limit-y-max": "auto|<length>",
    "-ms-scroll-limit-y-min": "<length>",
    "-ms-scroll-rails": "none|railed",
    "-ms-scroll-snap-points-x": "snapInterval( <length-percentage> , <length-percentage> )|snapList( <length-percentage># )",
    "-ms-scroll-snap-points-y": "snapInterval( <length-percentage> , <length-percentage> )|snapList( <length-percentage># )",
    "-ms-scroll-snap-type": "none|proximity|mandatory",
    "-ms-scroll-snap-x": "<'-ms-scroll-snap-type'> <'-ms-scroll-snap-points-x'>",
    "-ms-scroll-snap-y": "<'-ms-scroll-snap-type'> <'-ms-scroll-snap-points-y'>",
    "-ms-scroll-translation": "none|vertical-to-horizontal",
    "-ms-text-autospace": "none|ideograph-alpha|ideograph-numeric|ideograph-parenthesis|ideograph-space",
    "-ms-touch-select": "grippers|none",
    "-ms-user-select": "none|element|text",
    "-ms-wrap-flow": "auto|both|start|end|maximum|clear",
    "-ms-wrap-margin": "<length>",
    "-ms-wrap-through": "wrap|none",
    "-moz-appearance": "none|button|button-arrow-down|button-arrow-next|button-arrow-previous|button-arrow-up|button-bevel|button-focus|caret|checkbox|checkbox-container|checkbox-label|checkmenuitem|dualbutton|groupbox|listbox|listitem|menuarrow|menubar|menucheckbox|menuimage|menuitem|menuitemtext|menulist|menulist-button|menulist-text|menulist-textfield|menupopup|menuradio|menuseparator|meterbar|meterchunk|progressbar|progressbar-vertical|progresschunk|progresschunk-vertical|radio|radio-container|radio-label|radiomenuitem|range|range-thumb|resizer|resizerpanel|scale-horizontal|scalethumbend|scalethumb-horizontal|scalethumbstart|scalethumbtick|scalethumb-vertical|scale-vertical|scrollbarbutton-down|scrollbarbutton-left|scrollbarbutton-right|scrollbarbutton-up|scrollbarthumb-horizontal|scrollbarthumb-vertical|scrollbartrack-horizontal|scrollbartrack-vertical|searchfield|separator|sheet|spinner|spinner-downbutton|spinner-textfield|spinner-upbutton|splitter|statusbar|statusbarpanel|tab|tabpanel|tabpanels|tab-scroll-arrow-back|tab-scroll-arrow-forward|textfield|textfield-multiline|toolbar|toolbarbutton|toolbarbutton-dropdown|toolbargripper|toolbox|tooltip|treeheader|treeheadercell|treeheadersortarrow|treeitem|treeline|treetwisty|treetwistyopen|treeview|-moz-mac-unified-toolbar|-moz-win-borderless-glass|-moz-win-browsertabbar-toolbox|-moz-win-communicationstext|-moz-win-communications-toolbox|-moz-win-exclude-glass|-moz-win-glass|-moz-win-mediatext|-moz-win-media-toolbox|-moz-window-button-box|-moz-window-button-box-maximized|-moz-window-button-close|-moz-window-button-maximize|-moz-window-button-minimize|-moz-window-button-restore|-moz-window-frame-bottom|-moz-window-frame-left|-moz-window-frame-right|-moz-window-titlebar|-moz-window-titlebar-maximized",
    "-moz-binding": "<url>|none",
    "-moz-border-bottom-colors": "<color>+|none",
    "-moz-border-left-colors": "<color>+|none",
    "-moz-border-right-colors": "<color>+|none",
    "-moz-border-top-colors": "<color>+|none",
    "-moz-context-properties": "none|[fill|fill-opacity|stroke|stroke-opacity]#",
    "-moz-float-edge": "border-box|content-box|margin-box|padding-box",
    "-moz-force-broken-image-icon": "0|1",
    "-moz-image-region": "<shape>|auto",
    "-moz-orient": "inline|block|horizontal|vertical",
    "-moz-outline-radius": "<outline-radius>{1,4} [/ <outline-radius>{1,4}]?",
    "-moz-outline-radius-bottomleft": "<outline-radius>",
    "-moz-outline-radius-bottomright": "<outline-radius>",
    "-moz-outline-radius-topleft": "<outline-radius>",
    "-moz-outline-radius-topright": "<outline-radius>",
    "-moz-stack-sizing": "ignore|stretch-to-fit",
    "-moz-text-blink": "none|blink",
    "-moz-user-focus": "ignore|normal|select-after|select-before|select-menu|select-same|select-all|none",
    "-moz-user-input": "auto|none|enabled|disabled",
    "-moz-user-modify": "read-only|read-write|write-only",
    "-moz-window-dragging": "drag|no-drag",
    "-moz-window-shadow": "default|menu|tooltip|sheet|none",
    "-webkit-appearance": "none|button|button-bevel|caps-lock-indicator|caret|checkbox|default-button|inner-spin-button|listbox|listitem|media-controls-background|media-controls-fullscreen-background|media-current-time-display|media-enter-fullscreen-button|media-exit-fullscreen-button|media-fullscreen-button|media-mute-button|media-overlay-play-button|media-play-button|media-seek-back-button|media-seek-forward-button|media-slider|media-sliderthumb|media-time-remaining-display|media-toggle-closed-captions-button|media-volume-slider|media-volume-slider-container|media-volume-sliderthumb|menulist|menulist-button|menulist-text|menulist-textfield|meter|progress-bar|progress-bar-value|push-button|radio|scrollbarbutton-down|scrollbarbutton-left|scrollbarbutton-right|scrollbarbutton-up|scrollbargripper-horizontal|scrollbargripper-vertical|scrollbarthumb-horizontal|scrollbarthumb-vertical|scrollbartrack-horizontal|scrollbartrack-vertical|searchfield|searchfield-cancel-button|searchfield-decoration|searchfield-results-button|searchfield-results-decoration|slider-horizontal|slider-vertical|sliderthumb-horizontal|sliderthumb-vertical|square-button|textarea|textfield|-apple-pay-button",
    "-webkit-border-before": "<'border-width'>||<'border-style'>||<color>",
    "-webkit-border-before-color": "<color>",
    "-webkit-border-before-style": "<'border-style'>",
    "-webkit-border-before-width": "<'border-width'>",
    "-webkit-box-reflect": "[above|below|right|left]? <length>? <image>?",
    "-webkit-line-clamp": "none|<integer>",
    "-webkit-mask": "[<mask-reference>||<position> [/ <bg-size>]?||<repeat-style>||[<box>|border|padding|content|text]||[<box>|border|padding|content]]#",
    "-webkit-mask-attachment": "<attachment>#",
    "-webkit-mask-clip": "[<box>|border|padding|content|text]#",
    "-webkit-mask-composite": "<composite-style>#",
    "-webkit-mask-image": "<mask-reference>#",
    "-webkit-mask-origin": "[<box>|border|padding|content]#",
    "-webkit-mask-position": "<position>#",
    "-webkit-mask-position-x": "[<length-percentage>|left|center|right]#",
    "-webkit-mask-position-y": "[<length-percentage>|top|center|bottom]#",
    "-webkit-mask-repeat": "<repeat-style>#",
    "-webkit-mask-repeat-x": "repeat|no-repeat|space|round",
    "-webkit-mask-repeat-y": "repeat|no-repeat|space|round",
    "-webkit-mask-size": "<bg-size>#",
    "-webkit-overflow-scrolling": "auto|touch",
    "-webkit-tap-highlight-color": "<color>",
    "-webkit-text-fill-color": "<color>",
    "-webkit-text-stroke": "<length>||<color>",
    "-webkit-text-stroke-color": "<color>",
    "-webkit-text-stroke-width": "<length>",
    "-webkit-touch-callout": "default|none",
    "-webkit-user-modify": "read-only|read-write|read-write-plaintext-only",
    "accent-color": "auto|<color>",
    "align-content": "normal|<baseline-position>|<content-distribution>|<overflow-position>? <content-position>",
    "align-items": "normal|stretch|<baseline-position>|[<overflow-position>? <self-position>]",
    "align-self": "auto|normal|stretch|<baseline-position>|<overflow-position>? <self-position>",
    "align-tracks": "[normal|<baseline-position>|<content-distribution>|<overflow-position>? <content-position>]#",
    all: "initial|inherit|unset|revert|revert-layer",
    animation: "<single-animation>#",
    "animation-composition": "<single-animation-composition>#",
    "animation-delay": "<time>#",
    "animation-direction": "<single-animation-direction>#",
    "animation-duration": "<time>#",
    "animation-fill-mode": "<single-animation-fill-mode>#",
    "animation-iteration-count": "<single-animation-iteration-count>#",
    "animation-name": "[none|<keyframes-name>]#",
    "animation-play-state": "<single-animation-play-state>#",
    "animation-timing-function": "<easing-function>#",
    "animation-timeline": "<single-animation-timeline>#",
    appearance: "none|auto|textfield|menulist-button|<compat-auto>",
    "aspect-ratio": "auto|<ratio>",
    azimuth: "<angle>|[[left-side|far-left|left|center-left|center|center-right|right|far-right|right-side]||behind]|leftwards|rightwards",
    "backdrop-filter": "none|<filter-function-list>",
    "backface-visibility": "visible|hidden",
    background: "[<bg-layer> ,]* <final-bg-layer>",
    "background-attachment": "<attachment>#",
    "background-blend-mode": "<blend-mode>#",
    "background-clip": "<bg-clip>#",
    "background-color": "<color>",
    "background-image": "<bg-image>#",
    "background-origin": "<box>#",
    "background-position": "<bg-position>#",
    "background-position-x": "[center|[[left|right|x-start|x-end]? <length-percentage>?]!]#",
    "background-position-y": "[center|[[top|bottom|y-start|y-end]? <length-percentage>?]!]#",
    "background-repeat": "<repeat-style>#",
    "background-size": "<bg-size>#",
    "block-overflow": "clip|ellipsis|<string>",
    "block-size": "<'width'>",
    border: "<line-width>||<line-style>||<color>",
    "border-block": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-block-color": "<'border-top-color'>{1,2}",
    "border-block-style": "<'border-top-style'>",
    "border-block-width": "<'border-top-width'>",
    "border-block-end": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-block-end-color": "<'border-top-color'>",
    "border-block-end-style": "<'border-top-style'>",
    "border-block-end-width": "<'border-top-width'>",
    "border-block-start": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-block-start-color": "<'border-top-color'>",
    "border-block-start-style": "<'border-top-style'>",
    "border-block-start-width": "<'border-top-width'>",
    "border-bottom": "<line-width>||<line-style>||<color>",
    "border-bottom-color": "<'border-top-color'>",
    "border-bottom-left-radius": "<length-percentage>{1,2}",
    "border-bottom-right-radius": "<length-percentage>{1,2}",
    "border-bottom-style": "<line-style>",
    "border-bottom-width": "<line-width>",
    "border-collapse": "collapse|separate",
    "border-color": "<color>{1,4}",
    "border-end-end-radius": "<length-percentage>{1,2}",
    "border-end-start-radius": "<length-percentage>{1,2}",
    "border-image": "<'border-image-source'>||<'border-image-slice'> [/ <'border-image-width'>|/ <'border-image-width'>? / <'border-image-outset'>]?||<'border-image-repeat'>",
    "border-image-outset": "[<length>|<number>]{1,4}",
    "border-image-repeat": "[stretch|repeat|round|space]{1,2}",
    "border-image-slice": "<number-percentage>{1,4}&&fill?",
    "border-image-source": "none|<image>",
    "border-image-width": "[<length-percentage>|<number>|auto]{1,4}",
    "border-inline": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-inline-end": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-inline-color": "<'border-top-color'>{1,2}",
    "border-inline-style": "<'border-top-style'>",
    "border-inline-width": "<'border-top-width'>",
    "border-inline-end-color": "<'border-top-color'>",
    "border-inline-end-style": "<'border-top-style'>",
    "border-inline-end-width": "<'border-top-width'>",
    "border-inline-start": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-inline-start-color": "<'border-top-color'>",
    "border-inline-start-style": "<'border-top-style'>",
    "border-inline-start-width": "<'border-top-width'>",
    "border-left": "<line-width>||<line-style>||<color>",
    "border-left-color": "<color>",
    "border-left-style": "<line-style>",
    "border-left-width": "<line-width>",
    "border-radius": "<length-percentage>{1,4} [/ <length-percentage>{1,4}]?",
    "border-right": "<line-width>||<line-style>||<color>",
    "border-right-color": "<color>",
    "border-right-style": "<line-style>",
    "border-right-width": "<line-width>",
    "border-spacing": "<length> <length>?",
    "border-start-end-radius": "<length-percentage>{1,2}",
    "border-start-start-radius": "<length-percentage>{1,2}",
    "border-style": "<line-style>{1,4}",
    "border-top": "<line-width>||<line-style>||<color>",
    "border-top-color": "<color>",
    "border-top-left-radius": "<length-percentage>{1,2}",
    "border-top-right-radius": "<length-percentage>{1,2}",
    "border-top-style": "<line-style>",
    "border-top-width": "<line-width>",
    "border-width": "<line-width>{1,4}",
    bottom: "<length>|<percentage>|auto",
    "box-align": "start|center|end|baseline|stretch",
    "box-decoration-break": "slice|clone",
    "box-direction": "normal|reverse|inherit",
    "box-flex": "<number>",
    "box-flex-group": "<integer>",
    "box-lines": "single|multiple",
    "box-ordinal-group": "<integer>",
    "box-orient": "horizontal|vertical|inline-axis|block-axis|inherit",
    "box-pack": "start|center|end|justify",
    "box-shadow": "none|<shadow>#",
    "box-sizing": "content-box|border-box",
    "break-after": "auto|avoid|always|all|avoid-page|page|left|right|recto|verso|avoid-column|column|avoid-region|region",
    "break-before": "auto|avoid|always|all|avoid-page|page|left|right|recto|verso|avoid-column|column|avoid-region|region",
    "break-inside": "auto|avoid|avoid-page|avoid-column|avoid-region",
    "caption-side": "top|bottom|block-start|block-end|inline-start|inline-end",
    caret: "<'caret-color'>||<'caret-shape'>",
    "caret-color": "auto|<color>",
    "caret-shape": "auto|bar|block|underscore",
    clear: "none|left|right|both|inline-start|inline-end",
    clip: "<shape>|auto",
    "clip-path": "<clip-source>|[<basic-shape>||<geometry-box>]|none",
    color: "<color>",
    "print-color-adjust": "economy|exact",
    "color-scheme": "normal|[light|dark|<custom-ident>]+&&only?",
    "column-count": "<integer>|auto",
    "column-fill": "auto|balance|balance-all",
    "column-gap": "normal|<length-percentage>",
    "column-rule": "<'column-rule-width'>||<'column-rule-style'>||<'column-rule-color'>",
    "column-rule-color": "<color>",
    "column-rule-style": "<'border-style'>",
    "column-rule-width": "<'border-width'>",
    "column-span": "none|all",
    "column-width": "<length>|auto",
    columns: "<'column-width'>||<'column-count'>",
    contain: "none|strict|content|[[size||inline-size]||layout||style||paint]",
    "contain-intrinsic-size": "[none|<length>|auto <length>]{1,2}",
    "contain-intrinsic-block-size": "none|<length>|auto <length>",
    "contain-intrinsic-height": "none|<length>|auto <length>",
    "contain-intrinsic-inline-size": "none|<length>|auto <length>",
    "contain-intrinsic-width": "none|<length>|auto <length>",
    content: "normal|none|[<content-replacement>|<content-list>] [/ [<string>|<counter>]+]?",
    "content-visibility": "visible|auto|hidden",
    "counter-increment": "[<counter-name> <integer>?]+|none",
    "counter-reset": "[<counter-name> <integer>?|<reversed-counter-name> <integer>?]+|none",
    "counter-set": "[<counter-name> <integer>?]+|none",
    cursor: "[[<url> [<x> <y>]? ,]* [auto|default|none|context-menu|help|pointer|progress|wait|cell|crosshair|text|vertical-text|alias|copy|move|no-drop|not-allowed|e-resize|n-resize|ne-resize|nw-resize|s-resize|se-resize|sw-resize|w-resize|ew-resize|ns-resize|nesw-resize|nwse-resize|col-resize|row-resize|all-scroll|zoom-in|zoom-out|grab|grabbing|hand|-webkit-grab|-webkit-grabbing|-webkit-zoom-in|-webkit-zoom-out|-moz-grab|-moz-grabbing|-moz-zoom-in|-moz-zoom-out]]",
    direction: "ltr|rtl",
    display: "[<display-outside>||<display-inside>]|<display-listitem>|<display-internal>|<display-box>|<display-legacy>|<-non-standard-display>",
    "empty-cells": "show|hide",
    filter: "none|<filter-function-list>|<-ms-filter-function-list>",
    flex: "none|[<'flex-grow'> <'flex-shrink'>?||<'flex-basis'>]",
    "flex-basis": "content|<'width'>",
    "flex-direction": "row|row-reverse|column|column-reverse",
    "flex-flow": "<'flex-direction'>||<'flex-wrap'>",
    "flex-grow": "<number>",
    "flex-shrink": "<number>",
    "flex-wrap": "nowrap|wrap|wrap-reverse",
    float: "left|right|none|inline-start|inline-end",
    font: "[[<'font-style'>||<font-variant-css21>||<'font-weight'>||<'font-stretch'>]? <'font-size'> [/ <'line-height'>]? <'font-family'>]|caption|icon|menu|message-box|small-caption|status-bar",
    "font-family": "[<family-name>|<generic-family>]#",
    "font-feature-settings": "normal|<feature-tag-value>#",
    "font-kerning": "auto|normal|none",
    "font-language-override": "normal|<string>",
    "font-optical-sizing": "auto|none",
    "font-variation-settings": "normal|[<string> <number>]#",
    "font-size": "<absolute-size>|<relative-size>|<length-percentage>",
    "font-size-adjust": "none|[ex-height|cap-height|ch-width|ic-width|ic-height]? [from-font|<number>]",
    "font-smooth": "auto|never|always|<absolute-size>|<length>",
    "font-stretch": "<font-stretch-absolute>",
    "font-style": "normal|italic|oblique <angle>?",
    "font-synthesis": "none|[weight||style||small-caps]",
    "font-variant": "normal|none|[<common-lig-values>||<discretionary-lig-values>||<historical-lig-values>||<contextual-alt-values>||stylistic( <feature-value-name> )||historical-forms||styleset( <feature-value-name># )||character-variant( <feature-value-name># )||swash( <feature-value-name> )||ornaments( <feature-value-name> )||annotation( <feature-value-name> )||[small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps]||<numeric-figure-values>||<numeric-spacing-values>||<numeric-fraction-values>||ordinal||slashed-zero||<east-asian-variant-values>||<east-asian-width-values>||ruby]",
    "font-variant-alternates": "normal|[stylistic( <feature-value-name> )||historical-forms||styleset( <feature-value-name># )||character-variant( <feature-value-name># )||swash( <feature-value-name> )||ornaments( <feature-value-name> )||annotation( <feature-value-name> )]",
    "font-variant-caps": "normal|small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps",
    "font-variant-east-asian": "normal|[<east-asian-variant-values>||<east-asian-width-values>||ruby]",
    "font-variant-ligatures": "normal|none|[<common-lig-values>||<discretionary-lig-values>||<historical-lig-values>||<contextual-alt-values>]",
    "font-variant-numeric": "normal|[<numeric-figure-values>||<numeric-spacing-values>||<numeric-fraction-values>||ordinal||slashed-zero]",
    "font-variant-position": "normal|sub|super",
    "font-weight": "<font-weight-absolute>|bolder|lighter",
    "forced-color-adjust": "auto|none",
    gap: "<'row-gap'> <'column-gap'>?",
    grid: "<'grid-template'>|<'grid-template-rows'> / [auto-flow&&dense?] <'grid-auto-columns'>?|[auto-flow&&dense?] <'grid-auto-rows'>? / <'grid-template-columns'>",
    "grid-area": "<grid-line> [/ <grid-line>]{0,3}",
    "grid-auto-columns": "<track-size>+",
    "grid-auto-flow": "[row|column]||dense",
    "grid-auto-rows": "<track-size>+",
    "grid-column": "<grid-line> [/ <grid-line>]?",
    "grid-column-end": "<grid-line>",
    "grid-column-gap": "<length-percentage>",
    "grid-column-start": "<grid-line>",
    "grid-gap": "<'grid-row-gap'> <'grid-column-gap'>?",
    "grid-row": "<grid-line> [/ <grid-line>]?",
    "grid-row-end": "<grid-line>",
    "grid-row-gap": "<length-percentage>",
    "grid-row-start": "<grid-line>",
    "grid-template": "none|[<'grid-template-rows'> / <'grid-template-columns'>]|[<line-names>? <string> <track-size>? <line-names>?]+ [/ <explicit-track-list>]?",
    "grid-template-areas": "none|<string>+",
    "grid-template-columns": "none|<track-list>|<auto-track-list>|subgrid <line-name-list>?",
    "grid-template-rows": "none|<track-list>|<auto-track-list>|subgrid <line-name-list>?",
    "hanging-punctuation": "none|[first||[force-end|allow-end]||last]",
    height: "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )",
    "hyphenate-character": "auto|<string>",
    hyphens: "none|manual|auto",
    "image-orientation": "from-image|<angle>|[<angle>? flip]",
    "image-rendering": "auto|crisp-edges|pixelated|optimizeSpeed|optimizeQuality|<-non-standard-image-rendering>",
    "image-resolution": "[from-image||<resolution>]&&snap?",
    "ime-mode": "auto|normal|active|inactive|disabled",
    "initial-letter": "normal|[<number> <integer>?]",
    "initial-letter-align": "[auto|alphabetic|hanging|ideographic]",
    "inline-size": "<'width'>",
    "input-security": "auto|none",
    inset: "<'top'>{1,4}",
    "inset-block": "<'top'>{1,2}",
    "inset-block-end": "<'top'>",
    "inset-block-start": "<'top'>",
    "inset-inline": "<'top'>{1,2}",
    "inset-inline-end": "<'top'>",
    "inset-inline-start": "<'top'>",
    isolation: "auto|isolate",
    "justify-content": "normal|<content-distribution>|<overflow-position>? [<content-position>|left|right]",
    "justify-items": "normal|stretch|<baseline-position>|<overflow-position>? [<self-position>|left|right]|legacy|legacy&&[left|right|center]",
    "justify-self": "auto|normal|stretch|<baseline-position>|<overflow-position>? [<self-position>|left|right]",
    "justify-tracks": "[normal|<content-distribution>|<overflow-position>? [<content-position>|left|right]]#",
    left: "<length>|<percentage>|auto",
    "letter-spacing": "normal|<length-percentage>",
    "line-break": "auto|loose|normal|strict|anywhere",
    "line-clamp": "none|<integer>",
    "line-height": "normal|<number>|<length>|<percentage>",
    "line-height-step": "<length>",
    "list-style": "<'list-style-type'>||<'list-style-position'>||<'list-style-image'>",
    "list-style-image": "<image>|none",
    "list-style-position": "inside|outside",
    "list-style-type": "<counter-style>|<string>|none",
    margin: "[<length>|<percentage>|auto]{1,4}",
    "margin-block": "<'margin-left'>{1,2}",
    "margin-block-end": "<'margin-left'>",
    "margin-block-start": "<'margin-left'>",
    "margin-bottom": "<length>|<percentage>|auto",
    "margin-inline": "<'margin-left'>{1,2}",
    "margin-inline-end": "<'margin-left'>",
    "margin-inline-start": "<'margin-left'>",
    "margin-left": "<length>|<percentage>|auto",
    "margin-right": "<length>|<percentage>|auto",
    "margin-top": "<length>|<percentage>|auto",
    "margin-trim": "none|in-flow|all",
    mask: "<mask-layer>#",
    "mask-border": "<'mask-border-source'>||<'mask-border-slice'> [/ <'mask-border-width'>? [/ <'mask-border-outset'>]?]?||<'mask-border-repeat'>||<'mask-border-mode'>",
    "mask-border-mode": "luminance|alpha",
    "mask-border-outset": "[<length>|<number>]{1,4}",
    "mask-border-repeat": "[stretch|repeat|round|space]{1,2}",
    "mask-border-slice": "<number-percentage>{1,4} fill?",
    "mask-border-source": "none|<image>",
    "mask-border-width": "[<length-percentage>|<number>|auto]{1,4}",
    "mask-clip": "[<geometry-box>|no-clip]#",
    "mask-composite": "<compositing-operator>#",
    "mask-image": "<mask-reference>#",
    "mask-mode": "<masking-mode>#",
    "mask-origin": "<geometry-box>#",
    "mask-position": "<position>#",
    "mask-repeat": "<repeat-style>#",
    "mask-size": "<bg-size>#",
    "mask-type": "luminance|alpha",
    "masonry-auto-flow": "[pack|next]||[definite-first|ordered]",
    "math-depth": "auto-add|add( <integer> )|<integer>",
    "math-shift": "normal|compact",
    "math-style": "normal|compact",
    "max-block-size": "<'max-width'>",
    "max-height": "none|<length-percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )",
    "max-inline-size": "<'max-width'>",
    "max-lines": "none|<integer>",
    "max-width": "none|<length-percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )|<-non-standard-width>",
    "min-block-size": "<'min-width'>",
    "min-height": "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )",
    "min-inline-size": "<'min-width'>",
    "min-width": "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )|<-non-standard-width>",
    "mix-blend-mode": "<blend-mode>|plus-lighter",
    "object-fit": "fill|contain|cover|none|scale-down",
    "object-position": "<position>",
    offset: "[<'offset-position'>? [<'offset-path'> [<'offset-distance'>||<'offset-rotate'>]?]?]! [/ <'offset-anchor'>]?",
    "offset-anchor": "auto|<position>",
    "offset-distance": "<length-percentage>",
    "offset-path": "none|ray( [<angle>&&<size>&&contain?] )|<path()>|<url>|[<basic-shape>||<geometry-box>]",
    "offset-position": "auto|<position>",
    "offset-rotate": "[auto|reverse]||<angle>",
    opacity: "<alpha-value>",
    order: "<integer>",
    orphans: "<integer>",
    outline: "[<'outline-color'>||<'outline-style'>||<'outline-width'>]",
    "outline-color": "<color>|invert",
    "outline-offset": "<length>",
    "outline-style": "auto|<'border-style'>",
    "outline-width": "<line-width>",
    overflow: "[visible|hidden|clip|scroll|auto]{1,2}|<-non-standard-overflow>",
    "overflow-anchor": "auto|none",
    "overflow-block": "visible|hidden|clip|scroll|auto",
    "overflow-clip-box": "padding-box|content-box",
    "overflow-clip-margin": "<visual-box>||<length [0,∞]>",
    "overflow-inline": "visible|hidden|clip|scroll|auto",
    "overflow-wrap": "normal|break-word|anywhere",
    "overflow-x": "visible|hidden|clip|scroll|auto",
    "overflow-y": "visible|hidden|clip|scroll|auto",
    "overscroll-behavior": "[contain|none|auto]{1,2}",
    "overscroll-behavior-block": "contain|none|auto",
    "overscroll-behavior-inline": "contain|none|auto",
    "overscroll-behavior-x": "contain|none|auto",
    "overscroll-behavior-y": "contain|none|auto",
    padding: "[<length>|<percentage>]{1,4}",
    "padding-block": "<'padding-left'>{1,2}",
    "padding-block-end": "<'padding-left'>",
    "padding-block-start": "<'padding-left'>",
    "padding-bottom": "<length>|<percentage>",
    "padding-inline": "<'padding-left'>{1,2}",
    "padding-inline-end": "<'padding-left'>",
    "padding-inline-start": "<'padding-left'>",
    "padding-left": "<length>|<percentage>",
    "padding-right": "<length>|<percentage>",
    "padding-top": "<length>|<percentage>",
    "page-break-after": "auto|always|avoid|left|right|recto|verso",
    "page-break-before": "auto|always|avoid|left|right|recto|verso",
    "page-break-inside": "auto|avoid",
    "paint-order": "normal|[fill||stroke||markers]",
    perspective: "none|<length>",
    "perspective-origin": "<position>",
    "place-content": "<'align-content'> <'justify-content'>?",
    "place-items": "<'align-items'> <'justify-items'>?",
    "place-self": "<'align-self'> <'justify-self'>?",
    "pointer-events": "auto|none|visiblePainted|visibleFill|visibleStroke|visible|painted|fill|stroke|all|inherit",
    position: "static|relative|absolute|sticky|fixed|-webkit-sticky",
    quotes: "none|auto|[<string> <string>]+",
    resize: "none|both|horizontal|vertical|block|inline",
    right: "<length>|<percentage>|auto",
    rotate: "none|<angle>|[x|y|z|<number>{3}]&&<angle>",
    "row-gap": "normal|<length-percentage>",
    "ruby-align": "start|center|space-between|space-around",
    "ruby-merge": "separate|collapse|auto",
    "ruby-position": "[alternate||[over|under]]|inter-character",
    scale: "none|<number>{1,3}",
    "scrollbar-color": "auto|<color>{2}",
    "scrollbar-gutter": "auto|stable&&both-edges?",
    "scrollbar-width": "auto|thin|none",
    "scroll-behavior": "auto|smooth",
    "scroll-margin": "<length>{1,4}",
    "scroll-margin-block": "<length>{1,2}",
    "scroll-margin-block-start": "<length>",
    "scroll-margin-block-end": "<length>",
    "scroll-margin-bottom": "<length>",
    "scroll-margin-inline": "<length>{1,2}",
    "scroll-margin-inline-start": "<length>",
    "scroll-margin-inline-end": "<length>",
    "scroll-margin-left": "<length>",
    "scroll-margin-right": "<length>",
    "scroll-margin-top": "<length>",
    "scroll-padding": "[auto|<length-percentage>]{1,4}",
    "scroll-padding-block": "[auto|<length-percentage>]{1,2}",
    "scroll-padding-block-start": "auto|<length-percentage>",
    "scroll-padding-block-end": "auto|<length-percentage>",
    "scroll-padding-bottom": "auto|<length-percentage>",
    "scroll-padding-inline": "[auto|<length-percentage>]{1,2}",
    "scroll-padding-inline-start": "auto|<length-percentage>",
    "scroll-padding-inline-end": "auto|<length-percentage>",
    "scroll-padding-left": "auto|<length-percentage>",
    "scroll-padding-right": "auto|<length-percentage>",
    "scroll-padding-top": "auto|<length-percentage>",
    "scroll-snap-align": "[none|start|end|center]{1,2}",
    "scroll-snap-coordinate": "none|<position>#",
    "scroll-snap-destination": "<position>",
    "scroll-snap-points-x": "none|repeat( <length-percentage> )",
    "scroll-snap-points-y": "none|repeat( <length-percentage> )",
    "scroll-snap-stop": "normal|always",
    "scroll-snap-type": "none|[x|y|block|inline|both] [mandatory|proximity]?",
    "scroll-snap-type-x": "none|mandatory|proximity",
    "scroll-snap-type-y": "none|mandatory|proximity",
    "scroll-timeline": "<scroll-timeline-name>||<scroll-timeline-axis>",
    "scroll-timeline-axis": "block|inline|vertical|horizontal",
    "scroll-timeline-name": "none|<custom-ident>",
    "shape-image-threshold": "<alpha-value>",
    "shape-margin": "<length-percentage>",
    "shape-outside": "none|[<shape-box>||<basic-shape>]|<image>",
    "tab-size": "<integer>|<length>",
    "table-layout": "auto|fixed",
    "text-align": "start|end|left|right|center|justify|match-parent",
    "text-align-last": "auto|start|end|left|right|center|justify",
    "text-combine-upright": "none|all|[digits <integer>?]",
    "text-decoration": "<'text-decoration-line'>||<'text-decoration-style'>||<'text-decoration-color'>||<'text-decoration-thickness'>",
    "text-decoration-color": "<color>",
    "text-decoration-line": "none|[underline||overline||line-through||blink]|spelling-error|grammar-error",
    "text-decoration-skip": "none|[objects||[spaces|[leading-spaces||trailing-spaces]]||edges||box-decoration]",
    "text-decoration-skip-ink": "auto|all|none",
    "text-decoration-style": "solid|double|dotted|dashed|wavy",
    "text-decoration-thickness": "auto|from-font|<length>|<percentage>",
    "text-emphasis": "<'text-emphasis-style'>||<'text-emphasis-color'>",
    "text-emphasis-color": "<color>",
    "text-emphasis-position": "[over|under]&&[right|left]",
    "text-emphasis-style": "none|[[filled|open]||[dot|circle|double-circle|triangle|sesame]]|<string>",
    "text-indent": "<length-percentage>&&hanging?&&each-line?",
    "text-justify": "auto|inter-character|inter-word|none",
    "text-orientation": "mixed|upright|sideways",
    "text-overflow": "[clip|ellipsis|<string>]{1,2}",
    "text-rendering": "auto|optimizeSpeed|optimizeLegibility|geometricPrecision",
    "text-shadow": "none|<shadow-t>#",
    "text-size-adjust": "none|auto|<percentage>",
    "text-transform": "none|capitalize|uppercase|lowercase|full-width|full-size-kana",
    "text-underline-offset": "auto|<length>|<percentage>",
    "text-underline-position": "auto|from-font|[under||[left|right]]",
    top: "<length>|<percentage>|auto",
    "touch-action": "auto|none|[[pan-x|pan-left|pan-right]||[pan-y|pan-up|pan-down]||pinch-zoom]|manipulation",
    transform: "none|<transform-list>",
    "transform-box": "content-box|border-box|fill-box|stroke-box|view-box",
    "transform-origin": "[<length-percentage>|left|center|right|top|bottom]|[[<length-percentage>|left|center|right]&&[<length-percentage>|top|center|bottom]] <length>?",
    "transform-style": "flat|preserve-3d",
    transition: "<single-transition>#",
    "transition-delay": "<time>#",
    "transition-duration": "<time>#",
    "transition-property": "none|<single-transition-property>#",
    "transition-timing-function": "<easing-function>#",
    translate: "none|<length-percentage> [<length-percentage> <length>?]?",
    "unicode-bidi": "normal|embed|isolate|bidi-override|isolate-override|plaintext|-moz-isolate|-moz-isolate-override|-moz-plaintext|-webkit-isolate|-webkit-isolate-override|-webkit-plaintext",
    "user-select": "auto|text|none|contain|all",
    "vertical-align": "baseline|sub|super|text-top|text-bottom|middle|top|bottom|<percentage>|<length>",
    visibility: "visible|hidden|collapse",
    "white-space": "normal|pre|nowrap|pre-wrap|pre-line|break-spaces",
    widows: "<integer>",
    width: "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )|fill|stretch|intrinsic|-moz-max-content|-webkit-max-content|-moz-fit-content|-webkit-fit-content",
    "will-change": "auto|<animateable-feature>#",
    "word-break": "normal|break-all|keep-all|break-word",
    "word-spacing": "normal|<length>",
    "word-wrap": "normal|break-word",
    "writing-mode": "horizontal-tb|vertical-rl|vertical-lr|sideways-rl|sideways-lr|<svg-writing-mode>",
    "z-index": "auto|<integer>",
    zoom: "normal|reset|<number>|<percentage>",
    "-moz-background-clip": "padding|border",
    "-moz-border-radius-bottomleft": "<'border-bottom-left-radius'>",
    "-moz-border-radius-bottomright": "<'border-bottom-right-radius'>",
    "-moz-border-radius-topleft": "<'border-top-left-radius'>",
    "-moz-border-radius-topright": "<'border-bottom-right-radius'>",
    "-moz-control-character-visibility": "visible|hidden",
    "-moz-osx-font-smoothing": "auto|grayscale",
    "-moz-user-select": "none|text|all|-moz-none",
    "-ms-flex-align": "start|end|center|baseline|stretch",
    "-ms-flex-item-align": "auto|start|end|center|baseline|stretch",
    "-ms-flex-line-pack": "start|end|center|justify|distribute|stretch",
    "-ms-flex-negative": "<'flex-shrink'>",
    "-ms-flex-pack": "start|end|center|justify|distribute",
    "-ms-flex-order": "<integer>",
    "-ms-flex-positive": "<'flex-grow'>",
    "-ms-flex-preferred-size": "<'flex-basis'>",
    "-ms-interpolation-mode": "nearest-neighbor|bicubic",
    "-ms-grid-column-align": "start|end|center|stretch",
    "-ms-grid-row-align": "start|end|center|stretch",
    "-ms-hyphenate-limit-last": "none|always|column|page|spread",
    "-webkit-background-clip": "[<box>|border|padding|content|text]#",
    "-webkit-column-break-after": "always|auto|avoid",
    "-webkit-column-break-before": "always|auto|avoid",
    "-webkit-column-break-inside": "always|auto|avoid",
    "-webkit-font-smoothing": "auto|none|antialiased|subpixel-antialiased",
    "-webkit-mask-box-image": "[<url>|<gradient>|none] [<length-percentage>{4} <-webkit-mask-box-repeat>{2}]?",
    "-webkit-print-color-adjust": "economy|exact",
    "-webkit-text-security": "none|circle|disc|square",
    "-webkit-user-drag": "none|element|auto",
    "-webkit-user-select": "auto|none|text|all",
    "alignment-baseline": "auto|baseline|before-edge|text-before-edge|middle|central|after-edge|text-after-edge|ideographic|alphabetic|hanging|mathematical",
    "baseline-shift": "baseline|sub|super|<svg-length>",
    behavior: "<url>+",
    "clip-rule": "nonzero|evenodd",
    cue: "<'cue-before'> <'cue-after'>?",
    "cue-after": "<url> <decibel>?|none",
    "cue-before": "<url> <decibel>?|none",
    "dominant-baseline": "auto|use-script|no-change|reset-size|ideographic|alphabetic|hanging|mathematical|central|middle|text-after-edge|text-before-edge",
    fill: "<paint>",
    "fill-opacity": "<number-zero-one>",
    "fill-rule": "nonzero|evenodd",
    "glyph-orientation-horizontal": "<angle>",
    "glyph-orientation-vertical": "<angle>",
    kerning: "auto|<svg-length>",
    marker: "none|<url>",
    "marker-end": "none|<url>",
    "marker-mid": "none|<url>",
    "marker-start": "none|<url>",
    pause: "<'pause-before'> <'pause-after'>?",
    "pause-after": "<time>|none|x-weak|weak|medium|strong|x-strong",
    "pause-before": "<time>|none|x-weak|weak|medium|strong|x-strong",
    rest: "<'rest-before'> <'rest-after'>?",
    "rest-after": "<time>|none|x-weak|weak|medium|strong|x-strong",
    "rest-before": "<time>|none|x-weak|weak|medium|strong|x-strong",
    "shape-rendering": "auto|optimizeSpeed|crispEdges|geometricPrecision",
    src: "[<url> [format( <string># )]?|local( <family-name> )]#",
    speak: "auto|none|normal",
    "speak-as": "normal|spell-out||digits||[literal-punctuation|no-punctuation]",
    stroke: "<paint>",
    "stroke-dasharray": "none|[<svg-length>+]#",
    "stroke-dashoffset": "<svg-length>",
    "stroke-linecap": "butt|round|square",
    "stroke-linejoin": "miter|round|bevel",
    "stroke-miterlimit": "<number-one-or-greater>",
    "stroke-opacity": "<number-zero-one>",
    "stroke-width": "<svg-length>",
    "text-anchor": "start|middle|end",
    "unicode-range": "<urange>#",
    "voice-balance": "<number>|left|center|right|leftwards|rightwards",
    "voice-duration": "auto|<time>",
    "voice-family": "[[<family-name>|<generic-voice>] ,]* [<family-name>|<generic-voice>]|preserve",
    "voice-pitch": "<frequency>&&absolute|[[x-low|low|medium|high|x-high]||[<frequency>|<semitones>|<percentage>]]",
    "voice-range": "<frequency>&&absolute|[[x-low|low|medium|high|x-high]||[<frequency>|<semitones>|<percentage>]]",
    "voice-rate": "[normal|x-slow|slow|medium|fast|x-fast]||<percentage>",
    "voice-stress": "normal|strong|moderate|none|reduced",
    "voice-volume": "silent|[[x-soft|soft|medium|loud|x-loud]||<decibel>]"
  },
  atrules: {
    charset: {
      prelude: "<string>",
      descriptors: null
    },
    "counter-style": {
      prelude: "<counter-style-name>",
      descriptors: {
        "additive-symbols": "[<integer>&&<symbol>]#",
        fallback: "<counter-style-name>",
        negative: "<symbol> <symbol>?",
        pad: "<integer>&&<symbol>",
        prefix: "<symbol>",
        range: "[[<integer>|infinite]{2}]#|auto",
        "speak-as": "auto|bullets|numbers|words|spell-out|<counter-style-name>",
        suffix: "<symbol>",
        symbols: "<symbol>+",
        system: "cyclic|numeric|alphabetic|symbolic|additive|[fixed <integer>?]|[extends <counter-style-name>]"
      }
    },
    document: {
      prelude: "[<url>|url-prefix( <string> )|domain( <string> )|media-document( <string> )|regexp( <string> )]#",
      descriptors: null
    },
    "font-face": {
      prelude: null,
      descriptors: {
        "ascent-override": "normal|<percentage>",
        "descent-override": "normal|<percentage>",
        "font-display": "[auto|block|swap|fallback|optional]",
        "font-family": "<family-name>",
        "font-feature-settings": "normal|<feature-tag-value>#",
        "font-variation-settings": "normal|[<string> <number>]#",
        "font-stretch": "<font-stretch-absolute>{1,2}",
        "font-style": "normal|italic|oblique <angle>{0,2}",
        "font-weight": "<font-weight-absolute>{1,2}",
        "font-variant": "normal|none|[<common-lig-values>||<discretionary-lig-values>||<historical-lig-values>||<contextual-alt-values>||stylistic( <feature-value-name> )||historical-forms||styleset( <feature-value-name># )||character-variant( <feature-value-name># )||swash( <feature-value-name> )||ornaments( <feature-value-name> )||annotation( <feature-value-name> )||[small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps]||<numeric-figure-values>||<numeric-spacing-values>||<numeric-fraction-values>||ordinal||slashed-zero||<east-asian-variant-values>||<east-asian-width-values>||ruby]",
        "line-gap-override": "normal|<percentage>",
        "size-adjust": "<percentage>",
        src: "[<url> [format( <string># )]?|local( <family-name> )]#",
        "unicode-range": "<urange>#"
      }
    },
    "font-feature-values": {
      prelude: "<family-name>#",
      descriptors: null
    },
    import: {
      prelude: "[<string>|<url>] [layer|layer( <layer-name> )]? [supports( [<supports-condition>|<declaration>] )]? <media-query-list>?",
      descriptors: null
    },
    keyframes: {
      prelude: "<keyframes-name>",
      descriptors: null
    },
    layer: {
      prelude: "[<layer-name>#|<layer-name>?]",
      descriptors: null
    },
    media: {
      prelude: "<media-query-list>",
      descriptors: null
    },
    namespace: {
      prelude: "<namespace-prefix>? [<string>|<url>]",
      descriptors: null
    },
    page: {
      prelude: "<page-selector-list>",
      descriptors: {
        bleed: "auto|<length>",
        marks: "none|[crop||cross]",
        size: "<length>{1,2}|auto|[<page-size>||[portrait|landscape]]"
      }
    },
    property: {
      prelude: "<custom-property-name>",
      descriptors: {
        syntax: "<string>",
        inherits: "true|false",
        "initial-value": "<string>"
      }
    },
    "scroll-timeline": {
      prelude: "<timeline-name>",
      descriptors: null
    },
    supports: {
      prelude: "<supports-condition>",
      descriptors: null
    },
    viewport: {
      prelude: null,
      descriptors: {
        height: "<viewport-length>{1,2}",
        "max-height": "<viewport-length>",
        "max-width": "<viewport-length>",
        "max-zoom": "auto|<number>|<percentage>",
        "min-height": "<viewport-length>",
        "min-width": "<viewport-length>",
        "min-zoom": "auto|<number>|<percentage>",
        orientation: "auto|portrait|landscape",
        "user-zoom": "zoom|fixed",
        "viewport-fit": "auto|contain|cover",
        width: "<viewport-length>{1,2}",
        zoom: "auto|<number>|<percentage>"
      }
    },
    nest: {
      prelude: "<complex-selector-list>",
      descriptors: null
    }
  }
};
const ds = 43, $a = 45, l1 = 110, Tf = !0, JTe = !1;
function s1(e, t) {
  let r = this.tokenStart + e;
  const n = this.charCodeAt(r);
  for ((n === ds || n === $a) && (t && this.error("Number sign is not allowed"), r++); r < this.tokenEnd; r++)
    io(this.charCodeAt(r)) || this.error("Integer is expected", r);
}
function Zh(e) {
  return s1.call(this, 0, e);
}
function Xu(e, t) {
  if (!this.cmpChar(this.tokenStart + e, t)) {
    let r = "";
    switch (t) {
      case l1:
        r = "N is expected";
        break;
      case $a:
        r = "HyphenMinus is expected";
        break;
    }
    this.error(r, this.tokenStart + e);
  }
}
function L2() {
  let e = 0, t = 0, r = this.tokenType;
  for (; r === yi || r === Xo; )
    r = this.lookupType(++e);
  if (r !== xr)
    if (this.isDelim(ds, e) || this.isDelim($a, e)) {
      t = this.isDelim(ds, e) ? ds : $a;
      do
        r = this.lookupType(++e);
      while (r === yi || r === Xo);
      r !== xr && (this.skip(e), Zh.call(this, Tf));
    } else
      return null;
  return e > 0 && this.skip(e), t === 0 && (r = this.charCodeAt(this.tokenStart), r !== ds && r !== $a && this.error("Number sign is expected")), Zh.call(this, t !== 0), t === $a ? "-" + this.consume(xr) : this.consume(xr);
}
const eke = "AnPlusB", tke = {
  a: [String, null],
  b: [String, null]
};
function OV() {
  const e = this.tokenStart;
  let t = null, r = null;
  if (this.tokenType === xr)
    Zh.call(this, JTe), r = this.consume(xr);
  else if (this.tokenType === Wt && this.cmpChar(this.tokenStart, $a))
    switch (t = "-1", Xu.call(this, 1, l1), this.tokenEnd - this.tokenStart) {
      case 2:
        this.next(), r = L2.call(this);
        break;
      case 3:
        Xu.call(this, 2, $a), this.next(), this.skipSC(), Zh.call(this, Tf), r = "-" + this.consume(xr);
        break;
      default:
        Xu.call(this, 2, $a), s1.call(this, 3, Tf), this.next(), r = this.substrToCursor(e + 2);
    }
  else if (this.tokenType === Wt || this.isDelim(ds) && this.lookupType(1) === Wt) {
    let n = 0;
    switch (t = "1", this.isDelim(ds) && (n = 1, this.next()), Xu.call(this, 0, l1), this.tokenEnd - this.tokenStart) {
      case 1:
        this.next(), r = L2.call(this);
        break;
      case 2:
        Xu.call(this, 1, $a), this.next(), this.skipSC(), Zh.call(this, Tf), r = "-" + this.consume(xr);
        break;
      default:
        Xu.call(this, 1, $a), s1.call(this, 2, Tf), this.next(), r = this.substrToCursor(e + n + 1);
    }
  } else if (this.tokenType === qr) {
    const n = this.charCodeAt(this.tokenStart), i = n === ds || n === $a;
    let o = this.tokenStart + i;
    for (; o < this.tokenEnd && io(this.charCodeAt(o)); o++)
      ;
    o === this.tokenStart + i && this.error("Integer is expected", this.tokenStart + i), Xu.call(this, o - this.tokenStart, l1), t = this.substring(e, o), o + 1 === this.tokenEnd ? (this.next(), r = L2.call(this)) : (Xu.call(this, o - this.tokenStart + 1, $a), o + 2 === this.tokenEnd ? (this.next(), this.skipSC(), Zh.call(this, Tf), r = "-" + this.consume(xr)) : (s1.call(this, o - this.tokenStart + 2, Tf), this.next(), r = this.substrToCursor(o + 1)));
  } else
    this.error();
  return t !== null && t.charCodeAt(0) === ds && (t = t.substr(1)), r !== null && r.charCodeAt(0) === ds && (r = r.substr(1)), {
    type: "AnPlusB",
    loc: this.getLocation(e, this.tokenStart),
    a: t,
    b: r
  };
}
function rke(e) {
  if (e.a) {
    const t = e.a === "+1" && "n" || e.a === "1" && "n" || e.a === "-1" && "-n" || e.a + "n";
    if (e.b) {
      const r = e.b[0] === "-" || e.b[0] === "+" ? e.b : "+" + e.b;
      this.tokenize(t + r);
    } else
      this.tokenize(t);
  } else
    this.tokenize(e.b);
}
var nke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: eke,
  structure: tke,
  parse: OV,
  generate: rke
}, Symbol.toStringTag, { value: "Module" }));
function P5(e) {
  return this.Raw(e, this.consumeUntilLeftCurlyBracketOrSemicolon, !0);
}
function ike() {
  for (let e = 1, t; t = this.lookupType(e); e++) {
    if (t === ul)
      return !0;
    if (t === zo || t === zi)
      return !1;
  }
  return !1;
}
const oke = "Atrule", ake = "atrule", lke = {
  name: String,
  prelude: ["AtrulePrelude", "Raw", null],
  block: ["Block", null]
};
function _V(e = !1) {
  const t = this.tokenStart;
  let r, n, i = null, o = null;
  switch (this.eat(zi), r = this.substrToCursor(t + 1), n = r.toLowerCase(), this.skipSC(), this.eof === !1 && this.tokenType !== zo && this.tokenType !== ga && (this.parseAtrulePrelude ? i = this.parseWithFallback(this.AtrulePrelude.bind(this, r, e), P5) : i = P5.call(this, this.tokenIndex), this.skipSC()), this.tokenType) {
    case ga:
      this.next();
      break;
    case zo:
      hasOwnProperty.call(this.atrule, n) && typeof this.atrule[n].block == "function" ? o = this.atrule[n].block.call(this, e) : o = this.Block(ike.call(this));
      break;
  }
  return {
    type: "Atrule",
    loc: this.getLocation(t, this.tokenStart),
    name: r,
    prelude: i,
    block: o
  };
}
function ske(e) {
  this.token(zi, "@" + e.name), e.prelude !== null && this.node(e.prelude), e.block ? this.node(e.block) : this.token(ga, ";");
}
var uke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: oke,
  walkContext: ake,
  structure: lke,
  parse: _V,
  generate: ske
}, Symbol.toStringTag, { value: "Module" }));
const cke = "AtrulePrelude", dke = "atrulePrelude", fke = {
  children: [[]]
};
function LV(e) {
  let t = null;
  return e !== null && (e = e.toLowerCase()), this.skipSC(), hasOwnProperty.call(this.atrule, e) && typeof this.atrule[e].prelude == "function" ? t = this.atrule[e].prelude.call(this) : t = this.readSequence(this.scope.AtrulePrelude), this.skipSC(), this.eof !== !0 && this.tokenType !== zo && this.tokenType !== ga && this.error("Semicolon or block is expected"), {
    type: "AtrulePrelude",
    loc: this.getLocationFromList(t),
    children: t
  };
}
function hke(e) {
  this.children(e);
}
var pke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: cke,
  walkContext: dke,
  structure: fke,
  parse: LV,
  generate: hke
}, Symbol.toStringTag, { value: "Module" }));
const gke = 36, PV = 42, u1 = 61, mke = 94, S$ = 124, vke = 126;
function bke() {
  this.eof && this.error("Unexpected end of input");
  const e = this.tokenStart;
  let t = !1;
  return this.isDelim(PV) ? (t = !0, this.next()) : this.isDelim(S$) || this.eat(Wt), this.isDelim(S$) ? this.charCodeAt(this.tokenStart + 1) !== u1 ? (this.next(), this.eat(Wt)) : t && this.error("Identifier is expected", this.tokenEnd) : t && this.error("Vertical line is expected"), {
    type: "Identifier",
    loc: this.getLocation(e, this.tokenStart),
    name: this.substrToCursor(e)
  };
}
function yke() {
  const e = this.tokenStart, t = this.charCodeAt(e);
  return t !== u1 && t !== vke && t !== mke && t !== gke && t !== PV && t !== S$ && this.error("Attribute selector (=, ~=, ^=, $=, *=, |=) is expected"), this.next(), t !== u1 && (this.isDelim(u1) || this.error("Equal sign is expected"), this.next()), this.substrToCursor(e);
}
const xke = "AttributeSelector", wke = {
  name: "Identifier",
  matcher: [String, null],
  value: ["String", "Identifier", null],
  flags: [String, null]
};
function RV() {
  const e = this.tokenStart;
  let t, r = null, n = null, i = null;
  return this.eat(Va), this.skipSC(), t = bke.call(this), this.skipSC(), this.tokenType !== Wl && (this.tokenType !== Wt && (r = yke.call(this), this.skipSC(), n = this.tokenType === Ns ? this.String() : this.Identifier(), this.skipSC()), this.tokenType === Wt && (i = this.consume(Wt), this.skipSC())), this.eat(Wl), {
    type: "AttributeSelector",
    loc: this.getLocation(e, this.tokenStart),
    name: t,
    matcher: r,
    value: n,
    flags: i
  };
}
function Mke(e) {
  this.token(Zr, "["), this.node(e.name), e.matcher !== null && (this.tokenize(e.matcher), this.node(e.value)), e.flags !== null && this.token(Wt, e.flags), this.token(Zr, "]");
}
var Cke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: xke,
  structure: wke,
  parse: RV,
  generate: Mke
}, Symbol.toStringTag, { value: "Module" }));
const Ske = 38;
function jV(e) {
  return this.Raw(e, null, !0);
}
function R5() {
  return this.parseWithFallback(this.Rule, jV);
}
function j5(e) {
  return this.Raw(e, this.consumeUntilSemicolonIncluded, !0);
}
function Tke() {
  if (this.tokenType === ga)
    return j5.call(this, this.tokenIndex);
  const e = this.parseWithFallback(this.Declaration, j5);
  return this.tokenType === ga && this.next(), e;
}
const kke = "Block", Dke = "block", Ake = {
  children: [[
    "Atrule",
    "Rule",
    "Declaration"
  ]]
};
function FV(e) {
  const t = e ? Tke : R5, r = this.tokenStart;
  let n = this.createList();
  this.eat(zo);
  e:
    for (; !this.eof; )
      switch (this.tokenType) {
        case ul:
          break e;
        case yi:
        case Xo:
          this.next();
          break;
        case zi:
          n.push(this.parseWithFallback(this.Atrule.bind(this, e), jV));
          break;
        default:
          e && this.isDelim(Ske) ? n.push(R5.call(this)) : n.push(t.call(this));
      }
  return this.eof || this.eat(ul), {
    type: "Block",
    loc: this.getLocation(r, this.tokenStart),
    children: n
  };
}
function Eke(e) {
  this.token(zo, "{"), this.children(e, (t) => {
    t.type === "Declaration" && this.token(ga, ";");
  }), this.token(ul, "}");
}
var Ike = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: kke,
  walkContext: Dke,
  structure: Ake,
  parse: FV,
  generate: Eke
}, Symbol.toStringTag, { value: "Module" }));
const Nke = "Brackets", zke = {
  children: [[]]
};
function BV(e, t) {
  const r = this.tokenStart;
  let n = null;
  return this.eat(Va), n = e.call(this, t), this.eof || this.eat(Wl), {
    type: "Brackets",
    loc: this.getLocation(r, this.tokenStart),
    children: n
  };
}
function $ke(e) {
  this.token(Zr, "["), this.children(e), this.token(Zr, "]");
}
var Oke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: Nke,
  structure: zke,
  parse: BV,
  generate: $ke
}, Symbol.toStringTag, { value: "Module" }));
const _ke = "CDC", Lke = [];
function UV() {
  const e = this.tokenStart;
  return this.eat(sa), {
    type: "CDC",
    loc: this.getLocation(e, this.tokenStart)
  };
}
function Pke() {
  this.token(sa, "-->");
}
var Rke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: _ke,
  structure: Lke,
  parse: UV,
  generate: Pke
}, Symbol.toStringTag, { value: "Module" }));
const jke = "CDO", Fke = [];
function HV() {
  const e = this.tokenStart;
  return this.eat(Db), {
    type: "CDO",
    loc: this.getLocation(e, this.tokenStart)
  };
}
function Bke() {
  this.token(Db, "<!--");
}
var Uke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: jke,
  structure: Fke,
  parse: HV,
  generate: Bke
}, Symbol.toStringTag, { value: "Module" }));
const Hke = 46, Wke = "ClassSelector", Vke = {
  name: String
};
function WV() {
  return this.eatDelim(Hke), {
    type: "ClassSelector",
    loc: this.getLocation(this.tokenStart - 1, this.tokenEnd),
    name: this.consume(Wt)
  };
}
function Yke(e) {
  this.token(Zr, "."), this.token(Wt, e.name);
}
var Qke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: Wke,
  structure: Vke,
  parse: WV,
  generate: Yke
}, Symbol.toStringTag, { value: "Module" }));
const qke = 43, F5 = 47, Gke = 62, Zke = 126, Kke = "Combinator", Xke = {
  name: String
};
function VV() {
  const e = this.tokenStart;
  let t;
  switch (this.tokenType) {
    case yi:
      t = " ";
      break;
    case Zr:
      switch (this.charCodeAt(this.tokenStart)) {
        case Gke:
        case qke:
        case Zke:
          this.next();
          break;
        case F5:
          this.next(), this.eatIdent("deep"), this.eatDelim(F5);
          break;
        default:
          this.error("Combinator is expected");
      }
      t = this.substrToCursor(e);
      break;
  }
  return {
    type: "Combinator",
    loc: this.getLocation(e, this.tokenStart),
    name: t
  };
}
function Jke(e) {
  this.tokenize(e.name);
}
var eDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: Kke,
  structure: Xke,
  parse: VV,
  generate: Jke
}, Symbol.toStringTag, { value: "Module" }));
const tDe = 42, rDe = 47, nDe = "Comment", iDe = {
  value: String
};
function YV() {
  const e = this.tokenStart;
  let t = this.tokenEnd;
  return this.eat(Xo), t - e + 2 >= 2 && this.charCodeAt(t - 2) === tDe && this.charCodeAt(t - 1) === rDe && (t -= 2), {
    type: "Comment",
    loc: this.getLocation(e, this.tokenStart),
    value: this.substring(e + 2, t)
  };
}
function oDe(e) {
  this.token(Xo, "/*" + e.value + "*/");
}
var aDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: nDe,
  structure: iDe,
  parse: YV,
  generate: oDe
}, Symbol.toStringTag, { value: "Module" }));
const QV = 33, lDe = 35, sDe = 36, uDe = 38, cDe = 42, dDe = 43, B5 = 47;
function fDe(e) {
  return this.Raw(e, this.consumeUntilExclamationMarkOrSemicolon, !0);
}
function hDe(e) {
  return this.Raw(e, this.consumeUntilExclamationMarkOrSemicolon, !1);
}
function pDe() {
  const e = this.tokenIndex, t = this.Value();
  return t.type !== "Raw" && this.eof === !1 && this.tokenType !== ga && this.isDelim(QV) === !1 && this.isBalanceEdge(e) === !1 && this.error(), t;
}
const gDe = "Declaration", mDe = "declaration", vDe = {
  important: [Boolean, String],
  property: String,
  value: ["Value", "Raw"]
};
function qV() {
  const e = this.tokenStart, t = this.tokenIndex, r = yDe.call(this), n = l_(r), i = n ? this.parseCustomProperty : this.parseValue, o = n ? hDe : fDe;
  let a = !1, s;
  this.skipSC(), this.eat(No);
  const u = this.tokenIndex;
  if (n || this.skipSC(), i ? s = this.parseWithFallback(pDe, o) : s = o.call(this, this.tokenIndex), n && s.type === "Value" && s.children.isEmpty) {
    for (let d = u - this.tokenIndex; d <= 0; d++)
      if (this.lookupType(d) === yi) {
        s.children.appendData({
          type: "WhiteSpace",
          loc: null,
          value: " "
        });
        break;
      }
  }
  return this.isDelim(QV) && (a = xDe.call(this), this.skipSC()), this.eof === !1 && this.tokenType !== ga && this.isBalanceEdge(t) === !1 && this.error(), {
    type: "Declaration",
    loc: this.getLocation(e, this.tokenStart),
    important: a,
    property: r,
    value: s
  };
}
function bDe(e) {
  this.token(Wt, e.property), this.token(No, ":"), this.node(e.value), e.important && (this.token(Zr, "!"), this.token(Wt, e.important === !0 ? "important" : e.important));
}
function yDe() {
  const e = this.tokenStart;
  if (this.tokenType === Zr)
    switch (this.charCodeAt(this.tokenStart)) {
      case cDe:
      case sDe:
      case dDe:
      case lDe:
      case uDe:
        this.next();
        break;
      case B5:
        this.next(), this.isDelim(B5) && this.next();
        break;
    }
  return this.tokenType === Pn ? this.eat(Pn) : this.eat(Wt), this.substrToCursor(e);
}
function xDe() {
  this.eat(Zr), this.skipSC();
  const e = this.consume(Wt);
  return e === "important" ? !0 : e;
}
var wDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: gDe,
  walkContext: mDe,
  structure: vDe,
  parse: qV,
  generate: bDe
}, Symbol.toStringTag, { value: "Module" }));
const MDe = 38;
function P2(e) {
  return this.Raw(e, this.consumeUntilSemicolonIncluded, !0);
}
const CDe = "DeclarationList", SDe = {
  children: [[
    "Declaration",
    "Atrule",
    "Rule"
  ]]
};
function GV() {
  const e = this.createList();
  for (; !this.eof; )
    switch (this.tokenType) {
      case yi:
      case Xo:
      case ga:
        this.next();
        break;
      case zi:
        e.push(this.parseWithFallback(this.Atrule.bind(this, !0), P2));
        break;
      default:
        this.isDelim(MDe) ? e.push(this.parseWithFallback(this.Rule, P2)) : e.push(this.parseWithFallback(this.Declaration, P2));
    }
  return {
    type: "DeclarationList",
    loc: this.getLocationFromList(e),
    children: e
  };
}
function TDe(e) {
  this.children(e, (t) => {
    t.type === "Declaration" && this.token(ga, ";");
  });
}
var kDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: CDe,
  structure: SDe,
  parse: GV,
  generate: TDe
}, Symbol.toStringTag, { value: "Module" }));
const DDe = "Dimension", ADe = {
  value: String,
  unit: String
};
function ZV() {
  const e = this.tokenStart, t = this.consumeNumber(qr);
  return {
    type: "Dimension",
    loc: this.getLocation(e, this.tokenStart),
    value: t,
    unit: this.substring(e + t.length, this.tokenStart)
  };
}
function EDe(e) {
  this.token(qr, e.value + e.unit);
}
var IDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: DDe,
  structure: ADe,
  parse: ZV,
  generate: EDe
}, Symbol.toStringTag, { value: "Module" }));
const NDe = "Function", zDe = "function", $De = {
  name: String,
  children: [[]]
};
function KV(e, t) {
  const r = this.tokenStart, n = this.consumeFunctionName(), i = n.toLowerCase();
  let o;
  return o = t.hasOwnProperty(i) ? t[i].call(this, t) : e.call(this, t), this.eof || this.eat(kn), {
    type: "Function",
    loc: this.getLocation(r, this.tokenStart),
    name: n,
    children: o
  };
}
function ODe(e) {
  this.token(Kr, e.name + "("), this.children(e), this.token(kn, ")");
}
var _De = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: NDe,
  walkContext: zDe,
  structure: $De,
  parse: KV,
  generate: ODe
}, Symbol.toStringTag, { value: "Module" }));
const LDe = "XXX", PDe = "Hash", RDe = {
  value: String
};
function XV() {
  const e = this.tokenStart;
  return this.eat(Pn), {
    type: "Hash",
    loc: this.getLocation(e, this.tokenStart),
    value: this.substrToCursor(e + 1)
  };
}
function jDe(e) {
  this.token(Pn, "#" + e.value);
}
var FDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  xxx: LDe,
  name: PDe,
  structure: RDe,
  parse: XV,
  generate: jDe
}, Symbol.toStringTag, { value: "Module" }));
const BDe = "Identifier", UDe = {
  name: String
};
function JV() {
  return {
    type: "Identifier",
    loc: this.getLocation(this.tokenStart, this.tokenEnd),
    name: this.consume(Wt)
  };
}
function HDe(e) {
  this.token(Wt, e.name);
}
var WDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: BDe,
  structure: UDe,
  parse: JV,
  generate: HDe
}, Symbol.toStringTag, { value: "Module" }));
const VDe = "IdSelector", YDe = {
  name: String
};
function eY() {
  const e = this.tokenStart;
  return this.eat(Pn), {
    type: "IdSelector",
    loc: this.getLocation(e, this.tokenStart),
    name: this.substrToCursor(e + 1)
  };
}
function QDe(e) {
  this.token(Zr, "#" + e.name);
}
var qDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: VDe,
  structure: YDe,
  parse: eY,
  generate: QDe
}, Symbol.toStringTag, { value: "Module" }));
const GDe = "MediaFeature", ZDe = {
  name: String,
  value: ["Identifier", "Number", "Dimension", "Ratio", null]
};
function tY() {
  const e = this.tokenStart;
  let t, r = null;
  if (this.eat(Ki), this.skipSC(), t = this.consume(Wt), this.skipSC(), this.tokenType !== kn) {
    switch (this.eat(No), this.skipSC(), this.tokenType) {
      case xr:
        this.lookupNonWSType(1) === Zr ? r = this.Ratio() : r = this.Number();
        break;
      case qr:
        r = this.Dimension();
        break;
      case Wt:
        r = this.Identifier();
        break;
      default:
        this.error("Number, dimension, ratio or identifier is expected");
    }
    this.skipSC();
  }
  return this.eat(kn), {
    type: "MediaFeature",
    loc: this.getLocation(e, this.tokenStart),
    name: t,
    value: r
  };
}
function KDe(e) {
  this.token(Ki, "("), this.token(Wt, e.name), e.value !== null && (this.token(No, ":"), this.node(e.value)), this.token(kn, ")");
}
var XDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: GDe,
  structure: ZDe,
  parse: tY,
  generate: KDe
}, Symbol.toStringTag, { value: "Module" }));
const JDe = "MediaQuery", eAe = {
  children: [[
    "Identifier",
    "MediaFeature",
    "WhiteSpace"
  ]]
};
function rY() {
  const e = this.createList();
  let t = null;
  this.skipSC();
  e:
    for (; !this.eof; ) {
      switch (this.tokenType) {
        case Xo:
        case yi:
          this.next();
          continue;
        case Wt:
          t = this.Identifier();
          break;
        case Ki:
          t = this.MediaFeature();
          break;
        default:
          break e;
      }
      e.push(t);
    }
  return t === null && this.error("Identifier or parenthesis is expected"), {
    type: "MediaQuery",
    loc: this.getLocationFromList(e),
    children: e
  };
}
function tAe(e) {
  this.children(e);
}
var rAe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: JDe,
  structure: eAe,
  parse: rY,
  generate: tAe
}, Symbol.toStringTag, { value: "Module" }));
const nAe = "MediaQueryList", iAe = {
  children: [[
    "MediaQuery"
  ]]
};
function nY() {
  const e = this.createList();
  for (this.skipSC(); !this.eof && (e.push(this.MediaQuery()), this.tokenType === zs); )
    this.next();
  return {
    type: "MediaQueryList",
    loc: this.getLocationFromList(e),
    children: e
  };
}
function oAe(e) {
  this.children(e, () => this.token(zs, ","));
}
var aAe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: nAe,
  structure: iAe,
  parse: nY,
  generate: oAe
}, Symbol.toStringTag, { value: "Module" }));
const lAe = 38, sAe = "NestingSelector", uAe = {};
function iY() {
  const e = this.tokenStart;
  return this.eatDelim(lAe), {
    type: "NestingSelector",
    loc: this.getLocation(e, this.tokenStart)
  };
}
function cAe() {
  this.token(Zr, "&");
}
var dAe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: sAe,
  structure: uAe,
  parse: iY,
  generate: cAe
}, Symbol.toStringTag, { value: "Module" }));
const fAe = "Nth", hAe = {
  nth: ["AnPlusB", "Identifier"],
  selector: ["SelectorList", null]
};
function oY() {
  this.skipSC();
  const e = this.tokenStart;
  let t = e, r = null, n;
  return this.lookupValue(0, "odd") || this.lookupValue(0, "even") ? n = this.Identifier() : n = this.AnPlusB(), t = this.tokenStart, this.skipSC(), this.lookupValue(0, "of") && (this.next(), r = this.SelectorList(), t = this.tokenStart), {
    type: "Nth",
    loc: this.getLocation(e, t),
    nth: n,
    selector: r
  };
}
function pAe(e) {
  this.node(e.nth), e.selector !== null && (this.token(Wt, "of"), this.node(e.selector));
}
var gAe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: fAe,
  structure: hAe,
  parse: oY,
  generate: pAe
}, Symbol.toStringTag, { value: "Module" }));
const mAe = "Number", vAe = {
  value: String
};
function aY() {
  return {
    type: "Number",
    loc: this.getLocation(this.tokenStart, this.tokenEnd),
    value: this.consume(xr)
  };
}
function bAe(e) {
  this.token(xr, e.value);
}
var yAe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: mAe,
  structure: vAe,
  parse: aY,
  generate: bAe
}, Symbol.toStringTag, { value: "Module" }));
const xAe = "Operator", wAe = {
  value: String
};
function lY() {
  const e = this.tokenStart;
  return this.next(), {
    type: "Operator",
    loc: this.getLocation(e, this.tokenStart),
    value: this.substrToCursor(e)
  };
}
function MAe(e) {
  this.tokenize(e.value);
}
var CAe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: xAe,
  structure: wAe,
  parse: lY,
  generate: MAe
}, Symbol.toStringTag, { value: "Module" }));
const SAe = "Parentheses", TAe = {
  children: [[]]
};
function sY(e, t) {
  const r = this.tokenStart;
  let n = null;
  return this.eat(Ki), n = e.call(this, t), this.eof || this.eat(kn), {
    type: "Parentheses",
    loc: this.getLocation(r, this.tokenStart),
    children: n
  };
}
function kAe(e) {
  this.token(Ki, "("), this.children(e), this.token(kn, ")");
}
var DAe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: SAe,
  structure: TAe,
  parse: sY,
  generate: kAe
}, Symbol.toStringTag, { value: "Module" }));
const AAe = "Percentage", EAe = {
  value: String
};
function uY() {
  return {
    type: "Percentage",
    loc: this.getLocation(this.tokenStart, this.tokenEnd),
    value: this.consumeNumber(ui)
  };
}
function IAe(e) {
  this.token(ui, e.value + "%");
}
var NAe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: AAe,
  structure: EAe,
  parse: uY,
  generate: IAe
}, Symbol.toStringTag, { value: "Module" }));
const zAe = "PseudoClassSelector", $Ae = "function", OAe = {
  name: String,
  children: [["Raw"], null]
};
function cY() {
  const e = this.tokenStart;
  let t = null, r, n;
  return this.eat(No), this.tokenType === Kr ? (r = this.consumeFunctionName(), n = r.toLowerCase(), hasOwnProperty.call(this.pseudo, n) ? (this.skipSC(), t = this.pseudo[n].call(this), this.skipSC()) : (t = this.createList(), t.push(this.Raw(this.tokenIndex, null, !1))), this.eat(kn)) : r = this.consume(Wt), {
    type: "PseudoClassSelector",
    loc: this.getLocation(e, this.tokenStart),
    name: r,
    children: t
  };
}
function _Ae(e) {
  this.token(No, ":"), e.children === null ? this.token(Wt, e.name) : (this.token(Kr, e.name + "("), this.children(e), this.token(kn, ")"));
}
var LAe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: zAe,
  walkContext: $Ae,
  structure: OAe,
  parse: cY,
  generate: _Ae
}, Symbol.toStringTag, { value: "Module" }));
const PAe = "PseudoElementSelector", RAe = "function", jAe = {
  name: String,
  children: [["Raw"], null]
};
function dY() {
  const e = this.tokenStart;
  let t = null, r, n;
  return this.eat(No), this.eat(No), this.tokenType === Kr ? (r = this.consumeFunctionName(), n = r.toLowerCase(), hasOwnProperty.call(this.pseudo, n) ? (this.skipSC(), t = this.pseudo[n].call(this), this.skipSC()) : (t = this.createList(), t.push(this.Raw(this.tokenIndex, null, !1))), this.eat(kn)) : r = this.consume(Wt), {
    type: "PseudoElementSelector",
    loc: this.getLocation(e, this.tokenStart),
    name: r,
    children: t
  };
}
function FAe(e) {
  this.token(No, ":"), this.token(No, ":"), e.children === null ? this.token(Wt, e.name) : (this.token(Kr, e.name + "("), this.children(e), this.token(kn, ")"));
}
var BAe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: PAe,
  walkContext: RAe,
  structure: jAe,
  parse: dY,
  generate: FAe
}, Symbol.toStringTag, { value: "Module" }));
const UAe = 47, HAe = 46;
function U5() {
  this.skipSC();
  const e = this.consume(xr);
  for (let t = 0; t < e.length; t++) {
    const r = e.charCodeAt(t);
    !io(r) && r !== HAe && this.error("Unsigned number is expected", this.tokenStart - e.length + t);
  }
  return Number(e) === 0 && this.error("Zero number is not allowed", this.tokenStart - e.length), e;
}
const WAe = "Ratio", VAe = {
  left: String,
  right: String
};
function fY() {
  const e = this.tokenStart, t = U5.call(this);
  let r;
  return this.skipSC(), this.eatDelim(UAe), r = U5.call(this), {
    type: "Ratio",
    loc: this.getLocation(e, this.tokenStart),
    left: t,
    right: r
  };
}
function YAe(e) {
  this.token(xr, e.left), this.token(Zr, "/"), this.token(xr, e.right);
}
var QAe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: WAe,
  structure: VAe,
  parse: fY,
  generate: YAe
}, Symbol.toStringTag, { value: "Module" }));
function qAe() {
  return this.tokenIndex > 0 && this.lookupType(-1) === yi ? this.tokenIndex > 1 ? this.getTokenStart(this.tokenIndex - 1) : this.firstCharOffset : this.tokenStart;
}
const GAe = "Raw", ZAe = {
  value: String
};
function hY(e, t, r) {
  const n = this.getTokenStart(e);
  let i;
  return this.skipUntilBalanced(e, t || this.consumeUntilBalanceEnd), r && this.tokenStart > n ? i = qAe.call(this) : i = this.tokenStart, {
    type: "Raw",
    loc: this.getLocation(n, i),
    value: this.substring(n, i)
  };
}
function KAe(e) {
  this.tokenize(e.value);
}
var XAe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: GAe,
  structure: ZAe,
  parse: hY,
  generate: KAe
}, Symbol.toStringTag, { value: "Module" }));
function H5(e) {
  return this.Raw(e, this.consumeUntilLeftCurlyBracket, !0);
}
function JAe() {
  const e = this.SelectorList();
  return e.type !== "Raw" && this.eof === !1 && this.tokenType !== zo && this.error(), e;
}
const eEe = "Rule", tEe = "rule", rEe = {
  prelude: ["SelectorList", "Raw"],
  block: ["Block"]
};
function pY() {
  const e = this.tokenIndex, t = this.tokenStart;
  let r, n;
  return this.parseRulePrelude ? r = this.parseWithFallback(JAe, H5) : r = H5.call(this, e), n = this.Block(!0), {
    type: "Rule",
    loc: this.getLocation(t, this.tokenStart),
    prelude: r,
    block: n
  };
}
function nEe(e) {
  this.node(e.prelude), this.node(e.block);
}
var iEe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: eEe,
  walkContext: tEe,
  structure: rEe,
  parse: pY,
  generate: nEe
}, Symbol.toStringTag, { value: "Module" }));
const oEe = "Selector", aEe = {
  children: [[
    "TypeSelector",
    "IdSelector",
    "ClassSelector",
    "AttributeSelector",
    "PseudoClassSelector",
    "PseudoElementSelector",
    "Combinator",
    "WhiteSpace"
  ]]
};
function gY() {
  const e = this.readSequence(this.scope.Selector);
  return this.getFirstListNode(e) === null && this.error("Selector is expected"), {
    type: "Selector",
    loc: this.getLocationFromList(e),
    children: e
  };
}
function lEe(e) {
  this.children(e);
}
var sEe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: oEe,
  structure: aEe,
  parse: gY,
  generate: lEe
}, Symbol.toStringTag, { value: "Module" }));
const uEe = "SelectorList", cEe = "selector", dEe = {
  children: [[
    "Selector",
    "Raw"
  ]]
};
function mY() {
  const e = this.createList();
  for (; !this.eof; ) {
    if (e.push(this.Selector()), this.tokenType === zs) {
      this.next();
      continue;
    }
    break;
  }
  return {
    type: "SelectorList",
    loc: this.getLocationFromList(e),
    children: e
  };
}
function fEe(e) {
  this.children(e, () => this.token(zs, ","));
}
var hEe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: uEe,
  walkContext: cEe,
  structure: dEe,
  parse: mY,
  generate: fEe
}, Symbol.toStringTag, { value: "Module" }));
const T$ = 92, vY = 34, bY = 39;
function yY(e) {
  const t = e.length, r = e.charCodeAt(0), n = r === vY || r === bY ? 1 : 0, i = n === 1 && t > 1 && e.charCodeAt(t - 1) === r ? t - 2 : t - 1;
  let o = "";
  for (let a = n; a <= i; a++) {
    let s = e.charCodeAt(a);
    if (s === T$) {
      if (a === i) {
        a !== t - 1 && (o = e.substr(a + 1));
        break;
      }
      if (s = e.charCodeAt(++a), hs(T$, s)) {
        const u = a - 1, d = Mp(e, u);
        a = d - 1, o += rV(e.substring(u + 1, d));
      } else
        s === 13 && e.charCodeAt(a + 1) === 10 && a++;
    } else
      o += e[a];
  }
  return o;
}
function pEe(e, t) {
  const r = t ? "'" : '"', n = t ? bY : vY;
  let i = "", o = !1;
  for (let a = 0; a < e.length; a++) {
    const s = e.charCodeAt(a);
    if (s === 0) {
      i += "�";
      continue;
    }
    if (s <= 31 || s === 127) {
      i += "\\" + s.toString(16), o = !0;
      continue;
    }
    s === n || s === T$ ? (i += "\\" + e.charAt(a), o = !1) : (o && (kc(s) || rh(s)) && (i += " "), i += e.charAt(a), o = !1);
  }
  return r + i + r;
}
const gEe = "String", mEe = {
  value: String
};
function xY() {
  return {
    type: "String",
    loc: this.getLocation(this.tokenStart, this.tokenEnd),
    value: yY(this.consume(Ns))
  };
}
function vEe(e) {
  this.token(Ns, pEe(e.value));
}
var bEe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: gEe,
  structure: mEe,
  parse: xY,
  generate: vEe
}, Symbol.toStringTag, { value: "Module" }));
const yEe = 33;
function W5(e) {
  return this.Raw(e, null, !1);
}
const xEe = "StyleSheet", wEe = "stylesheet", MEe = {
  children: [[
    "Comment",
    "CDO",
    "CDC",
    "Atrule",
    "Rule",
    "Raw"
  ]]
};
function wY() {
  const e = this.tokenStart, t = this.createList();
  let r;
  for (; !this.eof; ) {
    switch (this.tokenType) {
      case yi:
        this.next();
        continue;
      case Xo:
        if (this.charCodeAt(this.tokenStart + 2) !== yEe) {
          this.next();
          continue;
        }
        r = this.Comment();
        break;
      case Db:
        r = this.CDO();
        break;
      case sa:
        r = this.CDC();
        break;
      case zi:
        r = this.parseWithFallback(this.Atrule, W5);
        break;
      default:
        r = this.parseWithFallback(this.Rule, W5);
    }
    t.push(r);
  }
  return {
    type: "StyleSheet",
    loc: this.getLocation(e, this.tokenStart),
    children: t
  };
}
function CEe(e) {
  this.children(e);
}
var SEe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: xEe,
  walkContext: wEe,
  structure: MEe,
  parse: wY,
  generate: CEe
}, Symbol.toStringTag, { value: "Module" }));
const TEe = 42, V5 = 124;
function R2() {
  this.tokenType !== Wt && this.isDelim(TEe) === !1 && this.error("Identifier or asterisk is expected"), this.next();
}
const kEe = "TypeSelector", DEe = {
  name: String
};
function MY() {
  const e = this.tokenStart;
  return this.isDelim(V5) ? (this.next(), R2.call(this)) : (R2.call(this), this.isDelim(V5) && (this.next(), R2.call(this))), {
    type: "TypeSelector",
    loc: this.getLocation(e, this.tokenStart),
    name: this.substrToCursor(e)
  };
}
function AEe(e) {
  this.tokenize(e.name);
}
var EEe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: kEe,
  structure: DEe,
  parse: MY,
  generate: AEe
}, Symbol.toStringTag, { value: "Module" }));
const CY = 43, SY = 45, k$ = 63;
function Hv(e, t) {
  let r = 0;
  for (let n = this.tokenStart + e; n < this.tokenEnd; n++) {
    const i = this.charCodeAt(n);
    if (i === SY && t && r !== 0)
      return Hv.call(this, e + r + 1, !1), -1;
    kc(i) || this.error(t && r !== 0 ? "Hyphen minus" + (r < 6 ? " or hex digit" : "") + " is expected" : r < 6 ? "Hex digit is expected" : "Unexpected input", n), ++r > 6 && this.error("Too many hex digits", n);
  }
  return this.next(), r;
}
function Sy(e) {
  let t = 0;
  for (; this.isDelim(k$); )
    ++t > e && this.error("Too many question marks"), this.next();
}
function IEe(e) {
  this.charCodeAt(this.tokenStart) !== e && this.error((e === CY ? "Plus sign" : "Hyphen minus") + " is expected");
}
function NEe() {
  let e = 0;
  switch (this.tokenType) {
    case xr:
      if (e = Hv.call(this, 1, !0), this.isDelim(k$)) {
        Sy.call(this, 6 - e);
        break;
      }
      if (this.tokenType === qr || this.tokenType === xr) {
        IEe.call(this, SY), Hv.call(this, 1, !1);
        break;
      }
      break;
    case qr:
      e = Hv.call(this, 1, !0), e > 0 && Sy.call(this, 6 - e);
      break;
    default:
      if (this.eatDelim(CY), this.tokenType === Wt) {
        e = Hv.call(this, 0, !0), e > 0 && Sy.call(this, 6 - e);
        break;
      }
      if (this.isDelim(k$)) {
        this.next(), Sy.call(this, 5);
        break;
      }
      this.error("Hex digit or question mark is expected");
  }
}
const zEe = "UnicodeRange", $Ee = {
  value: String
};
function TY() {
  const e = this.tokenStart;
  return this.eatIdent("u"), NEe.call(this), {
    type: "UnicodeRange",
    loc: this.getLocation(e, this.tokenStart),
    value: this.substrToCursor(e)
  };
}
function OEe(e) {
  this.tokenize(e.value);
}
var _Ee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: zEe,
  structure: $Ee,
  parse: TY,
  generate: OEe
}, Symbol.toStringTag, { value: "Module" }));
const LEe = 32, D$ = 92, PEe = 34, REe = 39, jEe = 40, kY = 41;
function FEe(e) {
  const t = e.length;
  let r = 4, n = e.charCodeAt(t - 1) === kY ? t - 2 : t - 1, i = "";
  for (; r < n && rh(e.charCodeAt(r)); )
    r++;
  for (; r < n && rh(e.charCodeAt(n)); )
    n--;
  for (let o = r; o <= n; o++) {
    let a = e.charCodeAt(o);
    if (a === D$) {
      if (o === n) {
        o !== t - 1 && (i = e.substr(o + 1));
        break;
      }
      if (a = e.charCodeAt(++o), hs(D$, a)) {
        const s = o - 1, u = Mp(e, s);
        o = u - 1, i += rV(e.substring(s + 1, u));
      } else
        a === 13 && e.charCodeAt(o + 1) === 10 && o++;
    } else
      i += e[o];
  }
  return i;
}
function BEe(e) {
  let t = "", r = !1;
  for (let n = 0; n < e.length; n++) {
    const i = e.charCodeAt(n);
    if (i === 0) {
      t += "�";
      continue;
    }
    if (i <= 31 || i === 127) {
      t += "\\" + i.toString(16), r = !0;
      continue;
    }
    i === LEe || i === D$ || i === PEe || i === REe || i === jEe || i === kY ? (t += "\\" + e.charAt(n), r = !1) : (r && kc(i) && (t += " "), t += e.charAt(n), r = !1);
  }
  return "url(" + t + ")";
}
const UEe = "Url", HEe = {
  value: String
};
function DY() {
  const e = this.tokenStart;
  let t;
  switch (this.tokenType) {
    case Ao:
      t = FEe(this.consume(Ao));
      break;
    case Kr:
      this.cmpStr(this.tokenStart, this.tokenEnd, "url(") || this.error("Function name must be `url`"), this.eat(Kr), this.skipSC(), t = yY(this.consume(Ns)), this.skipSC(), this.eof || this.eat(kn);
      break;
    default:
      this.error("Url or Function is expected");
  }
  return {
    type: "Url",
    loc: this.getLocation(e, this.tokenStart),
    value: t
  };
}
function WEe(e) {
  this.token(Ao, BEe(e.value));
}
var VEe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: UEe,
  structure: HEe,
  parse: DY,
  generate: WEe
}, Symbol.toStringTag, { value: "Module" }));
const YEe = "Value", QEe = {
  children: [[]]
};
function AY() {
  const e = this.tokenStart, t = this.readSequence(this.scope.Value);
  return {
    type: "Value",
    loc: this.getLocation(e, this.tokenStart),
    children: t
  };
}
function qEe(e) {
  this.children(e);
}
var GEe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: YEe,
  structure: QEe,
  parse: AY,
  generate: qEe
}, Symbol.toStringTag, { value: "Module" }));
const ZEe = Object.freeze({
  type: "WhiteSpace",
  loc: null,
  value: " "
}), KEe = "WhiteSpace", XEe = {
  value: String
};
function EY() {
  return this.eat(yi), ZEe;
}
function JEe(e) {
  this.token(yi, e.value);
}
var eIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: KEe,
  structure: XEe,
  parse: EY,
  generate: JEe
}, Symbol.toStringTag, { value: "Module" })), IY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AnPlusB: nke,
  Atrule: uke,
  AtrulePrelude: pke,
  AttributeSelector: Cke,
  Block: Ike,
  Brackets: Oke,
  CDC: Rke,
  CDO: Uke,
  ClassSelector: Qke,
  Combinator: eDe,
  Comment: aDe,
  Declaration: wDe,
  DeclarationList: kDe,
  Dimension: IDe,
  Function: _De,
  Hash: FDe,
  Identifier: WDe,
  IdSelector: qDe,
  MediaFeature: XDe,
  MediaQuery: rAe,
  MediaQueryList: aAe,
  NestingSelector: dAe,
  Nth: gAe,
  Number: yAe,
  Operator: CAe,
  Parentheses: DAe,
  Percentage: NAe,
  PseudoClassSelector: LAe,
  PseudoElementSelector: BAe,
  Ratio: QAe,
  Raw: XAe,
  Rule: iEe,
  Selector: sEe,
  SelectorList: hEe,
  String: bEe,
  StyleSheet: SEe,
  TypeSelector: EEe,
  UnicodeRange: _Ee,
  Url: VEe,
  Value: GEe,
  WhiteSpace: eIe
}, Symbol.toStringTag, { value: "Module" })), tIe = Qt(vt({
  generic: !0
}, XTe), {
  node: IY
});
const rIe = 35, nIe = 42, Y5 = 43, iIe = 45, oIe = 47, aIe = 117;
function NY(e) {
  switch (this.tokenType) {
    case Pn:
      return this.Hash();
    case zs:
      return this.Operator();
    case Ki:
      return this.Parentheses(this.readSequence, e.recognizer);
    case Va:
      return this.Brackets(this.readSequence, e.recognizer);
    case Ns:
      return this.String();
    case qr:
      return this.Dimension();
    case ui:
      return this.Percentage();
    case xr:
      return this.Number();
    case Kr:
      return this.cmpStr(this.tokenStart, this.tokenEnd, "url(") ? this.Url() : this.Function(this.readSequence, e.recognizer);
    case Ao:
      return this.Url();
    case Wt:
      return this.cmpChar(this.tokenStart, aIe) && this.cmpChar(this.tokenStart + 1, Y5) ? this.UnicodeRange() : this.Identifier();
    case Zr: {
      const t = this.charCodeAt(this.tokenStart);
      if (t === oIe || t === nIe || t === Y5 || t === iIe)
        return this.Operator();
      t === rIe && this.error("Hex or identifier is expected", this.tokenStart + 1);
      break;
    }
  }
}
var lIe = {
  getNode: NY
};
const sIe = 35, uIe = 38, cIe = 42, dIe = 43, fIe = 47, Q5 = 46, hIe = 62, pIe = 124, gIe = 126;
function mIe(e, t) {
  t.last !== null && t.last.type !== "Combinator" && e !== null && e.type !== "Combinator" && t.push({
    type: "Combinator",
    loc: null,
    name: " "
  });
}
function vIe() {
  switch (this.tokenType) {
    case Va:
      return this.AttributeSelector();
    case Pn:
      return this.IdSelector();
    case No:
      return this.lookupType(1) === No ? this.PseudoElementSelector() : this.PseudoClassSelector();
    case Wt:
      return this.TypeSelector();
    case xr:
    case ui:
      return this.Percentage();
    case qr:
      this.charCodeAt(this.tokenStart) === Q5 && this.error("Identifier is expected", this.tokenStart + 1);
      break;
    case Zr: {
      switch (this.charCodeAt(this.tokenStart)) {
        case dIe:
        case hIe:
        case gIe:
        case fIe:
          return this.Combinator();
        case Q5:
          return this.ClassSelector();
        case cIe:
        case pIe:
          return this.TypeSelector();
        case sIe:
          return this.IdSelector();
        case uIe:
          return this.NestingSelector();
      }
      break;
    }
  }
}
var bIe = {
  onWhiteSpace: mIe,
  getNode: vIe
};
function yIe() {
  return this.createSingleNodeList(this.Raw(this.tokenIndex, null, !1));
}
function xIe() {
  const e = this.createList();
  if (this.skipSC(), e.push(this.Identifier()), this.skipSC(), this.tokenType === zs) {
    e.push(this.Operator());
    const t = this.tokenIndex, r = this.parseCustomProperty ? this.Value(null) : this.Raw(this.tokenIndex, this.consumeUntilExclamationMarkOrSemicolon, !1);
    if (r.type === "Value" && r.children.isEmpty) {
      for (let n = t - this.tokenIndex; n <= 0; n++)
        if (this.lookupType(n) === yi) {
          r.children.appendData({
            type: "WhiteSpace",
            loc: null,
            value: " "
          });
          break;
        }
    }
    e.push(r);
  }
  return e;
}
function q5(e) {
  return e !== null && e.type === "Operator" && (e.value[e.value.length - 1] === "-" || e.value[e.value.length - 1] === "+");
}
var wIe = {
  getNode: NY,
  onWhiteSpace(e, t) {
    q5(e) && (e.value = " " + e.value), q5(t.last) && (t.last.value += " ");
  },
  expression: yIe,
  var: xIe
}, MIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AtrulePrelude: lIe,
  Selector: bIe,
  Value: wIe
}, Symbol.toStringTag, { value: "Module" })), CIe = {
  parse: {
    prelude: null,
    block() {
      return this.Block(!0);
    }
  }
}, SIe = {
  parse: {
    prelude() {
      const e = this.createList();
      switch (this.skipSC(), this.tokenType) {
        case Ns:
          e.push(this.String());
          break;
        case Ao:
        case Kr:
          e.push(this.Url());
          break;
        default:
          this.error("String or url() is expected");
      }
      return (this.lookupNonWSType(0) === Wt || this.lookupNonWSType(0) === Ki) && e.push(this.MediaQueryList()), e;
    },
    block: null
  }
}, TIe = {
  parse: {
    prelude() {
      return this.createSingleNodeList(this.MediaQueryList());
    },
    block(e = !1) {
      return this.Block(e);
    }
  }
}, kIe = {
  parse: {
    prelude() {
      return this.createSingleNodeList(this.SelectorList());
    },
    block() {
      return this.Block(!0);
    }
  }
}, DIe = {
  parse: {
    prelude() {
      return this.createSingleNodeList(this.SelectorList());
    },
    block() {
      return this.Block(!0);
    }
  }
};
function AIe() {
  return this.createSingleNodeList(this.Raw(this.tokenIndex, null, !1));
}
function EIe() {
  return this.skipSC(), this.tokenType === Wt && this.lookupNonWSType(1) === No ? this.createSingleNodeList(this.Declaration()) : zY.call(this);
}
function zY() {
  const e = this.createList();
  let t;
  this.skipSC();
  e:
    for (; !this.eof; ) {
      switch (this.tokenType) {
        case Xo:
        case yi:
          this.next();
          continue;
        case Kr:
          t = this.Function(AIe, this.scope.AtrulePrelude);
          break;
        case Wt:
          t = this.Identifier();
          break;
        case Ki:
          t = this.Parentheses(EIe, this.scope.AtrulePrelude);
          break;
        default:
          break e;
      }
      e.push(t);
    }
  return e;
}
var IIe = {
  parse: {
    prelude() {
      const e = zY.call(this);
      return this.getFirstListNode(e) === null && this.error("Condition is expected"), e;
    },
    block(e = !1) {
      return this.Block(e);
    }
  }
}, NIe = {
  "font-face": CIe,
  import: SIe,
  media: TIe,
  nest: kIe,
  page: DIe,
  supports: IIe
};
const yf = {
  parse() {
    return this.createSingleNodeList(this.SelectorList());
  }
}, j2 = {
  parse() {
    return this.createSingleNodeList(this.Selector());
  }
}, G5 = {
  parse() {
    return this.createSingleNodeList(this.Identifier());
  }
}, Ty = {
  parse() {
    return this.createSingleNodeList(this.Nth());
  }
};
var zIe = {
  dir: G5,
  has: yf,
  lang: G5,
  matches: yf,
  is: yf,
  "-moz-any": yf,
  "-webkit-any": yf,
  where: yf,
  not: yf,
  "nth-child": Ty,
  "nth-last-child": Ty,
  "nth-last-of-type": Ty,
  "nth-of-type": Ty,
  slotted: j2,
  host: j2,
  "host-context": j2
}, $Ie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AnPlusB: OV,
  Atrule: _V,
  AtrulePrelude: LV,
  AttributeSelector: RV,
  Block: FV,
  Brackets: BV,
  CDC: UV,
  CDO: HV,
  ClassSelector: WV,
  Combinator: VV,
  Comment: YV,
  Declaration: qV,
  DeclarationList: GV,
  Dimension: ZV,
  Function: KV,
  Hash: XV,
  Identifier: JV,
  IdSelector: eY,
  MediaFeature: tY,
  MediaQuery: rY,
  MediaQueryList: nY,
  NestingSelector: iY,
  Nth: oY,
  Number: aY,
  Operator: lY,
  Parentheses: sY,
  Percentage: uY,
  PseudoClassSelector: cY,
  PseudoElementSelector: dY,
  Ratio: fY,
  Raw: hY,
  Rule: pY,
  Selector: gY,
  SelectorList: mY,
  String: xY,
  StyleSheet: wY,
  TypeSelector: MY,
  UnicodeRange: TY,
  Url: DY,
  Value: AY,
  WhiteSpace: EY
}, Symbol.toStringTag, { value: "Module" })), OIe = {
  parseContext: {
    default: "StyleSheet",
    stylesheet: "StyleSheet",
    atrule: "Atrule",
    atrulePrelude(e) {
      return this.AtrulePrelude(e.atrule ? String(e.atrule) : null);
    },
    mediaQueryList: "MediaQueryList",
    mediaQuery: "MediaQuery",
    rule: "Rule",
    selectorList: "SelectorList",
    selector: "Selector",
    block() {
      return this.Block(!0);
    },
    declarationList: "DeclarationList",
    declaration: "Declaration",
    value: "Value"
  },
  scope: MIe,
  atrule: NIe,
  pseudo: zIe,
  node: $Ie
}, _Ie = {
  node: IY
}, LIe = KTe(vt(vt(vt({}, tIe), OIe), _Ie));
const {
  tokenize: aKe,
  parse: PIe,
  generate: lKe,
  lexer: RIe,
  createLexer: sKe,
  walk: Z5,
  find: uKe,
  findLast: cKe,
  findAll: dKe,
  toPlainObject: fKe,
  fromPlainObject: hKe,
  fork: pKe
} = LIe, nh = RIe;
function ih(e) {
  return !e || e.name !== "SyntaxError" && e.name !== "SyntaxMatchError" && e.name !== "SyntaxReferenceError" ? null : e;
}
function jIe(e) {
  const t = e.name, r = [];
  let n;
  return (n = ih(nh.checkAtruleName(t))) ? (r.push(Object.assign(n, vt({
    atrule: t
  }, e.loc && e.loc.start))), r) : (r.push(...FIe(t, e.prelude, e.prelude && e.prelude.loc && e.prelude.loc.start || e.loc && e.loc.start)), e.block && e.block.children && e.block.children.forEach((i) => {
    i.type === "Declaration" && r.push(...BIe(t, i.property, i.value, i.loc && i.loc.start));
  }), r);
}
function FIe(e, t, r) {
  const n = [];
  let i;
  return (i = ih(nh.checkAtrulePrelude(e, t))) ? n.push(Object.assign(i, vt({
    atrule: e
  }, r))) : (i = ih(nh.matchAtrulePrelude(e, t).error)) && n.push(Object.assign(i, vt({
    atrule: e
  }, i.rawMessage === "Mismatch" && {
    details: i.message,
    message: "Invalid value for `@" + e + "` prelude"
  }))), n;
}
function BIe(e, t, r, n) {
  const i = [];
  let o;
  return (o = ih(nh.checkAtruleDescriptorName(e, t))) ? i.push(Object.assign(o, vt({
    atrule: e,
    descriptor: t
  }, n))) : (o = ih(nh.matchAtruleDescriptor(e, t, r).error)) && i.push(Object.assign(o, vt({
    atrule: e,
    descriptor: t
  }, o.rawMessage === "Mismatch" && {
    details: o.message,
    message: "Invalid value for `" + t + "` descriptor"
  }))), i;
}
function UIe(e, t, r) {
  const n = [];
  let i;
  return g$(e).custom || ((i = ih(nh.checkPropertyName(e))) ? n.push(Object.assign(i, vt({
    property: e
  }, r))) : (i = ih(nh.matchProperty(e, t).error)) && n.push(Object.assign(i, vt({
    property: e
  }, i.rawMessage === "Mismatch" && {
    details: i.message,
    message: "Invalid value for `" + e + "` property"
  })))), n;
}
function HIe(e) {
  const t = [];
  return e.block && e.block.children && e.block.children.forEach((r) => {
    r.type === "Declaration" && t.push(...UIe(r.property, r.value, r.loc && r.loc.start));
  }), t;
}
function WIe(e, t) {
  const r = [], n = typeof e != "string" ? e : PIe(e, {
    filename: t,
    positions: !0,
    parseAtrulePrelude: !1,
    parseRulePrelude: !1,
    parseValue: !1,
    parseCustomProperty: !1,
    onParseError(i) {
      r.push(i);
    }
  });
  return Z5(n, {
    visit: "Atrule",
    enter(i) {
      r.push(...jIe(i));
    }
  }), Z5(n, {
    visit: "Rule",
    enter(i) {
      r.push(...HIe(i));
    }
  }), r;
}
var Ei;
(function(e) {
  e.setDefault = "setDefault", e.setCurrentToAll = "setCurrentToAll", e.setAuto = "setAuto", e.setAutoToAll = "setAutoToAll", e.removeCurrent = "removeCurrent", e.removeAll = "removeAll";
})(Ei || (Ei = {}));
const VIe = [
  {
    key: Ei.setDefault,
    label: "Set value to 20px"
  },
  {
    key: Ei.setCurrentToAll,
    label: "Set all values to this value"
  },
  {
    key: Ei.setAuto,
    label: "Set value to auto"
  },
  {
    key: Ei.setAutoToAll,
    label: "Set all values to auto"
  },
  {
    key: Ei.removeCurrent,
    label: "Remove current value"
  },
  {
    key: Ei.removeAll,
    label: "Remove all values"
  }
], YIe = ["id"], QIe = /* @__PURE__ */ oe({
  __name: "Input",
  props: {
    id: String,
    value: String,
    spaceType: {
      type: String,
      required: !0
    },
    positionType: {
      type: String,
      required: !0
    },
    defaultValue: {
      type: String,
      required: !0
    }
  },
  emits: ["update:value", "update:action"],
  setup(e, { emit: t }) {
    const r = e, n = G(r == null ? void 0 : r.value), i = (s) => {
      switch (s) {
        case Ei.setAuto:
        case Ei.setAutoToAll: {
          t("update:action", {
            spaceType: r.spaceType,
            position: r.positionType,
            actionType: s,
            value: "auto"
          });
          break;
        }
        case Ei.setCurrentToAll: {
          t("update:action", {
            spaceType: r.spaceType,
            position: r.positionType,
            actionType: s,
            value: r.value
          });
          break;
        }
        case Ei.setDefault: {
          t("update:action", {
            spaceType: r.spaceType,
            position: r.positionType,
            actionType: s,
            value: r.defaultValue
          });
          break;
        }
        case Ei.removeAll:
        case Ei.removeCurrent: {
          t("update:action", {
            spaceType: r.spaceType,
            position: r.positionType,
            actionType: s,
            value: null
          });
          break;
        }
        default: {
          t("update:action", {
            spaceType: r.spaceType,
            position: r.positionType,
            actionType: Ei.setAuto,
            value: "auto"
          });
          break;
        }
      }
    }, o = (s) => !WIe(s, null).length, a = (s) => {
      const u = s.target.value, d = `.some{${r.spaceType}-${r.positionType} : ${u}}`, f = o(d) ? u : "";
      n.value = f, t("update:value", {
        spaceType: r.spaceType,
        position: r.positionType,
        value: f
      });
    };
    return fi(() => {
      n.value = r.value;
    }), (s, u) => (ie(), Ve("div", { id: e.id }, [
      Re(B(T4), null, {
        default: we(() => [
          Jn(Ye("input", {
            placeholder: "0px",
            "onUpdate:modelValue": u[0] || (u[0] = (d) => n.value = d),
            onBlur: a
          }, null, 544), [
            [LB, n.value]
          ]),
          Re(B(YM), {
            trigger: "click",
            options: B(VIe),
            onSelect: i
          }, {
            default: we(() => [
              Re(B(Mn), {
                size: "small",
                quaternary: "",
                style: { padding: "0px" },
                text: ""
              }, {
                icon: we(() => [
                  Re(B(rW), {
                    depth: "3",
                    size: "12px"
                  }, {
                    default: we(() => [
                      Re(B(YW))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["options"])
        ]),
        _: 1
      })
    ], 8, YIe));
  }
});
var K5 = /* @__PURE__ */ To(QIe, [["__scopeId", "data-v-24b51896"]]);
const v_ = (e) => (PB("data-v-42964fc8"), e = e(), RB(), e), qIe = { class: "ghl-spacing margin" }, GIe = /* @__PURE__ */ v_(() => /* @__PURE__ */ Ye("div", { class: "ghl-spacing__title" }, "Margin", -1)), ZIe = { class: "ghl-spacing__children" }, KIe = { class: "ghl-spacing padding" }, XIe = /* @__PURE__ */ v_(() => /* @__PURE__ */ Ye("div", { class: "ghl-spacing__title" }, "padding", -1)), JIe = /* @__PURE__ */ v_(() => /* @__PURE__ */ Ye("div", { class: "padding--children empty" }, null, -1)), e2e = /* @__PURE__ */ oe({
  __name: "Spacing",
  props: {
    margin: {
      type: Object,
      default: () => ({
        top: null,
        bottom: null,
        left: null,
        right: null
      })
    },
    marginPositions: {
      type: Array,
      default: ["top", "bottom", "right", "left"]
    },
    padding: {
      type: Object,
      default: () => ({
        top: null,
        bottom: null,
        left: null,
        right: null
      })
    },
    paddingPositions: {
      type: Array,
      default: ["top", "bottom", "right", "left"]
    }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const r = e, n = G({ margin: r.margin, padding: r.padding });
    Gt(() => r.margin, (a) => {
      n.value.margin = a;
    }), Gt(() => r.padding, (a) => {
      n.value.padding = a;
    });
    const i = ({
      spaceType: a,
      position: s,
      value: u
    }) => {
      n.value[a][s] = u, t("update:value", {
        changed: { [a]: { [s]: u } },
        value: n.value
      });
    }, o = ({
      actionType: a,
      spaceType: s,
      position: u,
      value: d
    }) => {
      switch (a) {
        case Ei.setAuto:
        case Ei.setDefault:
        case Ei.removeCurrent:
        default: {
          n.value[s][u] = d, t("update:value", {
            changed: { [s]: { [u]: d } },
            value: n.value
          });
          break;
        }
        case Ei.setCurrentToAll:
        case Ei.setAutoToAll:
        case Ei.removeAll: {
          Object.keys(n.value[s]).forEach((h) => {
            n.value[s][h] = d;
          }), t("update:value", {
            changed: n.value,
            value: n.value
          });
          break;
        }
      }
    };
    return (a, s) => (ie(), Ve("div", qIe, [
      GIe,
      (ie(!0), Ve(Lr, null, Fl(e.marginPositions, (u) => (ie(), Ve("div", {
        class: Jr(["ghl-spacing__input", `margin--${u}`]),
        key: u
      }, [
        Re(K5, {
          positionType: u,
          spaceType: "margin",
          "onUpdate:value": i,
          "onUpdate:action": o,
          defaultValue: "20px",
          value: n.value.margin[u]
        }, null, 8, ["positionType", "value"])
      ], 2))), 128)),
      Ye("div", ZIe, [
        Ye("div", KIe, [
          XIe,
          (ie(!0), Ve(Lr, null, Fl(e.paddingPositions, (u) => (ie(), Ve("div", {
            class: Jr(["ghl-spacing__input", `padding--${u}`]),
            key: u
          }, [
            Re(K5, {
              positionType: u,
              spaceType: "padding",
              "onUpdate:value": i,
              "onUpdate:action": o,
              defaultValue: "20px",
              value: n.value.padding[u]
            }, null, 8, ["positionType", "value"])
          ], 2))), 128)),
          JIe
        ])
      ])
    ]));
  }
});
var F2 = /* @__PURE__ */ To(e2e, [["__scopeId", "data-v-42964fc8"]]);
F2.install = (e) => {
  e.component(F2.name, F2);
};
const t2e = {
  key: 0,
  class: "hl-card-header"
}, r2e = { class: "hl-card-content" }, n2e = {
  key: 1,
  class: "hl-card-footer"
}, i2e = {
  name: "UICard",
  inheritAttrs: !1
}, B2 = /* @__PURE__ */ oe(Qt(vt({}, i2e), {
  setup(e) {
    const t = pn();
    return (r, n) => (ie(), Ve("div", ir(r.$attrs, { class: "hl-card" }), [
      B(t).header ? (ie(), Ve("div", t2e, [
        nt(r.$slots, "header")
      ])) : yt("", !0),
      Ye("div", r2e, [
        nt(r.$slots, "default")
      ]),
      B(t).footer ? (ie(), Ve("div", n2e, [
        nt(r.$slots, "footer")
      ])) : yt("", !0)
    ], 16));
  }
}));
B2.install = (e) => {
  e.component(B2.name, B2);
};
const o2e = ["src"], a2e = {
  name: "UICarousel",
  inheritAttrs: !1,
  components: { NCarousel: _H, NCarouselItem: E4 }
}, l2e = /* @__PURE__ */ oe(Qt(vt({}, a2e), {
  props: {
    showArrow: Boolean,
    autoPlay: Boolean,
    direction: {
      type: String,
      default: "horizontal"
    },
    dotPlacement: {
      type: String,
      default: "bottom"
    },
    dotType: {
      type: String,
      default: "dot"
    },
    itemsPerView: {
      type: [Number, String],
      default: 1
    },
    spaceBetweenItems: {
      type: Number,
      default: 0
    },
    draggable: Boolean,
    loop: Boolean,
    centeredItems: Boolean,
    mousewheel: Boolean,
    showDots: Boolean,
    interval: {
      type: Number,
      default: 5e3
    },
    effect: {
      type: String,
      default: "slide"
    },
    touchable: {
      type: Boolean,
      default: !0
    },
    transitionProps: {
      type: Object,
      default: void 0
    },
    transitionStyle: {
      type: Object,
      default: () => ({
        transitionDuration: "300ms"
      })
    },
    carouselItems: {
      type: Array,
      default: void 0
    },
    classNames: String
  },
  setup(e) {
    const t = pn();
    return (r, n) => (ie(), Pe(B(_H), {
      "show-arrow": e.showArrow,
      autoplay: e.autoPlay,
      direction: e.direction,
      "dot-type": e.dotType,
      "dot-placement": e.dotPlacement,
      class: Jr(e.classNames),
      "slides-per-view": e.itemsPerView,
      "space-between": e.spaceBetweenItems,
      draggable: e.draggable,
      loop: e.loop,
      "centered-slides": e.centeredItems,
      mousewheel: e.mousewheel,
      "show-dots": e.showDots,
      touchable: e.touchable,
      interval: e.interval,
      effect: e.effect,
      "transition-props": e.transitionProps,
      "transition-style": e.transitionStyle
    }, fb({
      dots: we(({ total: i, currentIndex: o, to: a }) => [
        nt(r.$slots, "customDots", {
          total: i,
          currentIndex: o,
          changeTo: a
        }, void 0, !0)
      ]),
      default: we(() => [
        B(t).customRender ? nt(r.$slots, "customRender", { key: 0 }, void 0, !0) : (ie(!0), Ve(Lr, { key: 1 }, Fl(e.carouselItems, (i) => (ie(), Pe(B(E4), {
          key: i.key,
          class: Jr(i == null ? void 0 : i.class)
        }, {
          default: we(() => [
            Ye("img", {
              src: i.src,
              class: Jr(`ghl-carousel-image-${i.key}`)
            }, null, 10, o2e)
          ]),
          _: 2
        }, 1032, ["class"]))), 128))
      ]),
      _: 2
    }, [
      B(t).customArrows ? {
        name: "arrow",
        fn: we(({ prev: i, next: o }) => [
          nt(r.$slots, "customArrows", {
            prev: i,
            next: o
          }, void 0, !0)
        ])
      } : void 0
    ]), 1032, ["show-arrow", "autoplay", "direction", "dot-type", "dot-placement", "class", "slides-per-view", "space-between", "draggable", "loop", "centered-slides", "mousewheel", "show-dots", "touchable", "interval", "effect", "transition-props", "transition-style"]));
  }
}));
var U2 = /* @__PURE__ */ To(l2e, [["__scopeId", "data-v-61bf2e0e"]]);
U2.install = (e) => {
  e.component(U2.name, U2);
};
const s2e = {
  name: "UICheckbox",
  inheritAttrs: !1
}, H2 = /* @__PURE__ */ oe(Qt(vt({}, s2e), {
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    checked: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      required: !0
    }
  },
  emits: ["update:checked"],
  setup(e) {
    return (t, r) => (ie(), Pe(B(BM), ir({
      id: e.id,
      disabled: e.disabled
    }, t.$attrs, {
      checked: e.checked,
      size: "large",
      "onUpdate:checked": r[0] || (r[0] = (n) => t.$emit("update:checked", n))
    }), {
      default: we(() => [
        nt(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "disabled", "checked"]));
  }
}));
H2.install = (e) => {
  e.component(H2.name, H2);
};
const u2e = {
  name: "UIColorPicker",
  inheritAttrs: !1,
  components: { NColorPicker: NH }
}, W2 = oe(Qt(vt({}, u2e), {
  props: {
    placement: {
      type: String,
      default: "bottom"
    },
    compact: {
      type: Boolean,
      default: !1
    },
    show: {
      type: Boolean,
      default: void 0
    },
    defaultShow: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    modes: {
      type: Array,
      default: () => ["rgb", "hex", "hsl"]
    },
    customTrigger: {
      type: Function,
      default: void 0
    },
    defaultValue: {
      type: String,
      default: "#000"
    },
    value: {
      type: String,
      default: "#000"
    },
    swatches: {
      type: Array,
      default: void 0
    },
    to: {
      type: String,
      default: "body"
    }
  },
  emits: ["onComplete", "update:value"],
  setup(e, { emit: t }) {
    const r = e, n = (i) => {
      if (r.compact)
        return b("div", {
          class: "ghl-color-preview",
          style: {
            "background-color": i ?? "#000",
            width: "24px",
            height: "24px",
            "border-radius": "50%",
            outline: "#00000069 solid 1px",
            padding: "2px"
          }
        });
    };
    return (i, o) => {
      var a;
      return ie(), Pe(B(NH), {
        class: Jr(e.compact || e.customTrigger ? "compact-picker" : ""),
        placement: e.placement,
        "render-label": (a = e.customTrigger) != null ? a : n,
        value: e.value,
        "default-value": e.defaultValue,
        "default-show": e.defaultShow,
        show: e.show,
        to: e.to,
        disabled: e.disabled,
        swatches: e.swatches,
        modes: e.modes,
        onComplete: o[0] || (o[0] = (s) => t("onComplete", s)),
        "onUpdate:value": o[1] || (o[1] = (s) => t("update:value", s))
      }, null, 8, ["class", "placement", "render-label", "value", "default-value", "default-show", "show", "to", "disabled", "swatches", "modes"]);
    };
  }
}));
W2.install = (e) => {
  e.component(W2.name, W2);
};
var $r;
(function(e) {
  e.englishUS = "en-US", e.danish = "da", e.dutch = "nl", e.finnish = "fi", e.frenchFrance = "fr-FR", e.frenchCanada = "fr-CA", e.german = "de", e.italian = "it", e.norwegian = "no", e.portuguesePortugal = "pt-PT", e.portugueseBrazil = "pt-BR", e.spanish = "es", e.swedish = "sv";
})($r || ($r = {}));
var c2e = {
  lessThanXSeconds: {
    one: "mindre end ét sekund",
    other: "mindre end {{count}} sekunder"
  },
  xSeconds: {
    one: "1 sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "ét halvt minut",
  lessThanXMinutes: {
    one: "mindre end ét minut",
    other: "mindre end {{count}} minutter"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "cirka 1 time",
    other: "cirka {{count}} timer"
  },
  xHours: {
    one: "1 time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dage"
  },
  aboutXWeeks: {
    one: "cirka 1 uge",
    other: "cirka {{count}} uger"
  },
  xWeeks: {
    one: "1 uge",
    other: "{{count}} uger"
  },
  aboutXMonths: {
    one: "cirka 1 måned",
    other: "cirka {{count}} måneder"
  },
  xMonths: {
    one: "1 måned",
    other: "{{count}} måneder"
  },
  aboutXYears: {
    one: "cirka 1 år",
    other: "cirka {{count}} år"
  },
  xYears: {
    one: "1 år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over 1 år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "næsten 1 år",
    other: "næsten {{count}} år"
  }
}, d2e = function(e, t, r) {
  var n, i = c2e[e];
  return typeof i == "string" ? n = i : t === 1 ? n = i.one : n = i.other.replace("{{count}}", String(t)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "om " + n : n + " siden" : n;
}, f2e = d2e, h2e = {
  full: "EEEE 'den' d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd/MM/y"
}, p2e = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, g2e = {
  full: "{{date}} 'kl'. {{time}}",
  long: "{{date}} 'kl'. {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, m2e = {
  date: jr({
    formats: h2e,
    defaultWidth: "full"
  }),
  time: jr({
    formats: p2e,
    defaultWidth: "full"
  }),
  dateTime: jr({
    formats: g2e,
    defaultWidth: "full"
  })
}, v2e = m2e, b2e = {
  lastWeek: "'sidste' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "'på' eeee 'kl.' p",
  other: "P"
}, y2e = function(e, t, r, n) {
  return b2e[e];
}, x2e = y2e, w2e = {
  narrow: ["fvt", "vt"],
  abbreviated: ["f.v.t.", "v.t."],
  wide: ["før vesterlandsk tidsregning", "vesterlandsk tidsregning"]
}, M2e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, C2e = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mar.", "apr.", "maj", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"]
}, S2e = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn.", "man.", "tir.", "ons.", "tor.", "fre.", "lør."],
  wide: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"]
}, T2e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  }
}, k2e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  }
}, D2e = function(e, t) {
  var r = Number(e);
  return r + ".";
}, A2e = {
  ordinalNumber: D2e,
  era: Kt({
    values: w2e,
    defaultWidth: "wide"
  }),
  quarter: Kt({
    values: M2e,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: Kt({
    values: C2e,
    defaultWidth: "wide"
  }),
  day: Kt({
    values: S2e,
    defaultWidth: "wide"
  }),
  dayPeriod: Kt({
    values: T2e,
    defaultWidth: "wide",
    formattingValues: k2e,
    defaultFormattingWidth: "wide"
  })
}, E2e = A2e, I2e = /^(\d+)(\.)?/i, N2e = /\d+/i, z2e = {
  narrow: /^(fKr|fvt|eKr|vt)/i,
  abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
  wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
}, $2e = {
  any: [/^f/i, /^(v|e)/i]
}, O2e = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]. kvt\./i,
  wide: /^[1234]\.? kvartal/i
}, _2e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, L2e = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
}, P2e = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, R2e = {
  narrow: /^[smtofl]/i,
  short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, j2e = {
  narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, F2e = {
  narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
  any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
}, B2e = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /midnat/i,
    noon: /middag/i,
    morning: /morgen/i,
    afternoon: /eftermiddag/i,
    evening: /aften/i,
    night: /nat/i
  }
}, U2e = {
  ordinalNumber: hl({
    matchPattern: I2e,
    parsePattern: N2e,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Xt({
    matchPatterns: z2e,
    defaultMatchWidth: "wide",
    parsePatterns: $2e,
    defaultParseWidth: "any"
  }),
  quarter: Xt({
    matchPatterns: O2e,
    defaultMatchWidth: "wide",
    parsePatterns: _2e,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: Xt({
    matchPatterns: L2e,
    defaultMatchWidth: "wide",
    parsePatterns: P2e,
    defaultParseWidth: "any"
  }),
  day: Xt({
    matchPatterns: R2e,
    defaultMatchWidth: "wide",
    parsePatterns: j2e,
    defaultParseWidth: "any"
  }),
  dayPeriod: Xt({
    matchPatterns: F2e,
    defaultMatchWidth: "any",
    parsePatterns: B2e,
    defaultParseWidth: "any"
  })
}, H2e = U2e, W2e = {
  code: "da",
  formatDistance: f2e,
  formatLong: v2e,
  formatRelative: x2e,
  localize: E2e,
  match: H2e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, V2e = W2e;
const Y2e = {
  name: $r.danish,
  locale: V2e
}, Q2e = {
  name: $r.danish,
  global: {
    undo: "Fortryd",
    redo: "Gentag",
    confirm: "Bekræft",
    clear: "Ryd"
  },
  Popconfirm: {
    positiveText: "Bekræft",
    negativeText: "Annuller"
  },
  Cascader: {
    placeholder: "Vælg venligst",
    loading: "Indlæser",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Ryd",
    now: "Nu",
    confirm: "Bekræft",
    selectTime: "Vælg Tid",
    selectDate: "Vælg Dato",
    datePlaceholder: "Vælg Dato",
    datetimePlaceholder: "Vælg Dato og Tid",
    monthPlaceholder: "Vælg Måned",
    yearPlaceholder: "Vælg År",
    quarterPlaceholder: "Vælg Kvartal",
    startDatePlaceholder: "Start Dato",
    endDatePlaceholder: "Slut Dato",
    startDatetimePlaceholder: "Start Dato og Tid",
    endDatetimePlaceholder: "Slut Dato og Tid",
    startMonthPlaceholder: "Start Måned",
    endMonthPlaceholder: "Slut Måned",
    monthBeforeYear: !0,
    firstDayOfWeek: 6,
    today: "I dag"
  },
  DataTable: {
    checkTableAll: "Vælg alt i tabellen",
    uncheckTableAll: "Fravælg alt i tabellen",
    confirm: "Bekræft",
    clear: "Ryd",
    apply: "Anvend",
    filters: "Filtre"
  },
  LegacyTransfer: {
    sourceTitle: "Kilde",
    targetTitle: "Mål"
  },
  Transfer: {
    selectAll: "Vælg alle",
    unselectAll: "Fravælg alle",
    clearAll: "Ryd"
  },
  Empty: {
    description: "Ingen data"
  },
  Select: {
    placeholder: "Vælg venligst"
  },
  TimePicker: {
    placeholder: "Vælg tid",
    positiveText: "OK",
    negativeText: "Annuller",
    now: "Nu"
  },
  Pagination: {
    goto: "Gå til",
    selectionSuffix: "side",
    next: "Næste",
    previous: "Tidligere"
  },
  DynamicTags: {
    add: "Tilføj"
  },
  Log: {
    loading: "Indlæser"
  },
  Input: {
    placeholder: "Indtast venligst"
  },
  InputNumber: {
    placeholder: "Indtast venligst"
  },
  DynamicInput: {
    create: "Opret"
  },
  ThemeEditor: {
    title: "Tema Editor",
    clearAllVars: "Ryd alle variabler",
    clearSearch: "Ryd søgning",
    filterCompName: "Filterkomponentnavn",
    filterVarName: "Filtervariabelnavn",
    import: "Import",
    export: "Eksport",
    restore: "Nulstil til standard"
  },
  Image: {
    tipPrevious: "Forrige billede (←)",
    tipNext: "Næste billede (→)",
    tipCounterclockwise: "Mod uret",
    tipClockwise: "Med uret",
    tipZoomOut: "Zoom ud",
    tipZoomIn: "Zoom ind",
    tipClose: "Luk (ESC)",
    tipOriginalSize: "Zoom til original størrelse"
  }
}, q2e = {
  name: $r.dutch,
  locale: $ue
}, G2e = {
  name: $r.dutch,
  global: {
    undo: "Ongedaan maken",
    redo: "Opnieuw uitvoeren",
    confirm: "Bevestig",
    clear: "Duidelijk"
  },
  Popconfirm: {
    positiveText: "Bevestig",
    negativeText: "Annuleer"
  },
  Cascader: {
    placeholder: "Gelieve te selecteren",
    loading: "Bezig met laden",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "MM/yyyy",
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss",
    quarterFormat: "qqq yyyy",
    clear: "Duidelijk",
    now: "Nu",
    confirm: "Bevestig",
    selectTime: "Selecteer Tijd",
    selectDate: "Selecteer Datum",
    datePlaceholder: "Selecteer Datum",
    datetimePlaceholder: "Selecteer Tijd en Datum",
    monthPlaceholder: "Selecteer Maand",
    yearPlaceholder: "Selecteer Jaar",
    quarterPlaceholder: "Selecteer Kwartaal",
    startDatePlaceholder: "Start Datum",
    endDatePlaceholder: "Eind Datum",
    startDatetimePlaceholder: "Start Datum en Tijd",
    endDatetimePlaceholder: "Eind Datum en Tijd",
    startMonthPlaceholder: "Start Maand",
    endMonthPlaceholder: "Einde Maand",
    monthBeforeYear: !0,
    firstDayOfWeek: 0,
    today: "Vandaag"
  },
  DataTable: {
    checkTableAll: "Selecteer alles in de tabel",
    uncheckTableAll: "Deselecteer alles in de tabel",
    confirm: "Bevestig",
    clear: "Duidelijk",
    apply: "Toepassen",
    filters: "Filters"
  },
  LegacyTransfer: {
    sourceTitle: "Bron",
    targetTitle: "Target"
  },
  Transfer: {
    selectAll: "Selecteer Alle",
    unselectAll: "Deselecteer Alle",
    clearAll: "Duidelijk"
  },
  Empty: {
    description: "Geen Data"
  },
  Select: {
    placeholder: "Selecteer alstublieft"
  },
  TimePicker: {
    placeholder: "Selecteer Tijd",
    positiveText: "OK",
    negativeText: "Annuleer",
    now: "Nu"
  },
  Pagination: {
    goto: "Ga naar",
    selectionSuffix: "Pagina",
    next: "Volgende",
    previous: "Vorige"
  },
  DynamicTags: {
    add: "Toevoegen"
  },
  Log: {
    loading: "Bezig met laden"
  },
  Input: {
    placeholder: "Vul alsjeblieft in"
  },
  InputNumber: {
    placeholder: "Vul alsjeblieft in"
  },
  DynamicInput: {
    create: "Maak"
  },
  ThemeEditor: {
    title: "Thema Editor",
    clearAllVars: "Wis Alle Variabelen",
    clearSearch: "Zoekopdracht Wissen",
    filterCompName: "Naam van filter component",
    filterVarName: "Naam van filter variable",
    import: "Import",
    export: "Export",
    restore: "Resetten naar standaard"
  },
  Image: {
    tipPrevious: "Vorige Afbeelding (←)",
    tipNext: "Volgende afbeelding (→)",
    tipCounterclockwise: "Tegen de klok in",
    tipClockwise: "Met de klok mee",
    tipZoomOut: "Zoom uit",
    tipZoomIn: "Zoom in",
    tipClose: "Sluiten (Esc)",
    tipOriginalSize: "Zoom in op originele grootte"
  }
}, X5 = {
  name: $r.englishUS,
  locale: RM
}, J5 = {
  name: $r.englishUS,
  global: {
    undo: "Undo",
    redo: "Redo",
    confirm: "Confirm",
    clear: "Clear"
  },
  Popconfirm: {
    positiveText: "Confirm",
    negativeText: "Cancel"
  },
  Cascader: {
    placeholder: "Please Select",
    loading: "Loading",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Clear",
    now: "Now",
    confirm: "Confirm",
    selectTime: "Select Time",
    selectDate: "Select Date",
    datePlaceholder: "Select Date",
    datetimePlaceholder: "Select Date and Time",
    monthPlaceholder: "Select Month",
    yearPlaceholder: "Select Year",
    quarterPlaceholder: "Select Quarter",
    startDatePlaceholder: "Start Date",
    endDatePlaceholder: "End Date",
    startDatetimePlaceholder: "Start Date and Time",
    endDatetimePlaceholder: "End Date and Time",
    startMonthPlaceholder: "Start Month",
    endMonthPlaceholder: "End Month",
    monthBeforeYear: !0,
    firstDayOfWeek: 6,
    today: "Today"
  },
  DataTable: {
    checkTableAll: "Select all in the table",
    uncheckTableAll: "Unselect all in the table",
    confirm: "Confirm",
    clear: "Clear",
    apply: "Apply",
    filters: "Filters"
  },
  LegacyTransfer: {
    sourceTitle: "Source",
    targetTitle: "Target"
  },
  Transfer: {
    selectAll: "Select all",
    unselectAll: "Unselect all",
    clearAll: "Clear"
  },
  Empty: {
    description: "No Data"
  },
  Select: {
    placeholder: "Please Select"
  },
  TimePicker: {
    placeholder: "Select Time",
    positiveText: "OK",
    negativeText: "Cancel",
    now: "Now"
  },
  Pagination: {
    goto: "Goto",
    selectionSuffix: "page",
    next: "Next",
    previous: "Previous"
  },
  DynamicTags: {
    add: "Add"
  },
  Log: {
    loading: "Loading"
  },
  Input: {
    placeholder: "Please Input"
  },
  InputNumber: {
    placeholder: "Please Input"
  },
  DynamicInput: {
    create: "Create"
  },
  ThemeEditor: {
    title: "Theme Editor",
    clearAllVars: "Clear All Variables",
    clearSearch: "Clear Search",
    filterCompName: "Filter Component Name",
    filterVarName: "Filter Variable Name",
    import: "Import",
    export: "Export",
    restore: "Reset to Default"
  },
  Image: {
    tipPrevious: "Previous picture (←)",
    tipNext: "Next picture (→)",
    tipCounterclockwise: "Counterclockwise",
    tipClockwise: "Clockwise",
    tipZoomOut: "Zoom out",
    tipZoomIn: "Zoom in",
    tipClose: "Close (Esc)",
    tipOriginalSize: "Zoom to original size"
  }
};
function ej(e) {
  return e.replace(/sekuntia?/, "sekunnin");
}
function tj(e) {
  return e.replace(/minuuttia?/, "minuutin");
}
function rj(e) {
  return e.replace(/tuntia?/, "tunnin");
}
function Z2e(e) {
  return e.replace(/päivää?/, "päivän");
}
function nj(e) {
  return e.replace(/(viikko|viikkoa)/, "viikon");
}
function ij(e) {
  return e.replace(/(kuukausi|kuukautta)/, "kuukauden");
}
function ky(e) {
  return e.replace(/(vuosi|vuotta)/, "vuoden");
}
var K2e = {
  lessThanXSeconds: {
    one: "alle sekunti",
    other: "alle {{count}} sekuntia",
    futureTense: ej
  },
  xSeconds: {
    one: "sekunti",
    other: "{{count}} sekuntia",
    futureTense: ej
  },
  halfAMinute: {
    one: "puoli minuuttia",
    other: "puoli minuuttia",
    futureTense: function(e) {
      return "puolen minuutin";
    }
  },
  lessThanXMinutes: {
    one: "alle minuutti",
    other: "alle {{count}} minuuttia",
    futureTense: tj
  },
  xMinutes: {
    one: "minuutti",
    other: "{{count}} minuuttia",
    futureTense: tj
  },
  aboutXHours: {
    one: "noin tunti",
    other: "noin {{count}} tuntia",
    futureTense: rj
  },
  xHours: {
    one: "tunti",
    other: "{{count}} tuntia",
    futureTense: rj
  },
  xDays: {
    one: "päivä",
    other: "{{count}} päivää",
    futureTense: Z2e
  },
  aboutXWeeks: {
    one: "noin viikko",
    other: "noin {{count}} viikkoa",
    futureTense: nj
  },
  xWeeks: {
    one: "viikko",
    other: "{{count}} viikkoa",
    futureTense: nj
  },
  aboutXMonths: {
    one: "noin kuukausi",
    other: "noin {{count}} kuukautta",
    futureTense: ij
  },
  xMonths: {
    one: "kuukausi",
    other: "{{count}} kuukautta",
    futureTense: ij
  },
  aboutXYears: {
    one: "noin vuosi",
    other: "noin {{count}} vuotta",
    futureTense: ky
  },
  xYears: {
    one: "vuosi",
    other: "{{count}} vuotta",
    futureTense: ky
  },
  overXYears: {
    one: "yli vuosi",
    other: "yli {{count}} vuotta",
    futureTense: ky
  },
  almostXYears: {
    one: "lähes vuosi",
    other: "lähes {{count}} vuotta",
    futureTense: ky
  }
}, X2e = function(e, t, r) {
  var n = K2e[e], i = t === 1 ? n.one : n.other.replace("{{count}}", String(t));
  return r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? n.futureTense(i) + " kuluttua" : i + " sitten" : i;
}, J2e = X2e, eNe = {
  full: "eeee d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "d.M.y"
}, tNe = {
  full: "HH.mm.ss zzzz",
  long: "HH.mm.ss z",
  medium: "HH.mm.ss",
  short: "HH.mm"
}, rNe = {
  full: "{{date}} 'klo' {{time}}",
  long: "{{date}} 'klo' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, nNe = {
  date: jr({
    formats: eNe,
    defaultWidth: "full"
  }),
  time: jr({
    formats: tNe,
    defaultWidth: "full"
  }),
  dateTime: jr({
    formats: rNe,
    defaultWidth: "full"
  })
}, iNe = nNe, oNe = {
  lastWeek: "'viime' eeee 'klo' p",
  yesterday: "'eilen klo' p",
  today: "'tänään klo' p",
  tomorrow: "'huomenna klo' p",
  nextWeek: "'ensi' eeee 'klo' p",
  other: "P"
}, aNe = function(e, t, r, n) {
  return oNe[e];
}, lNe = aNe, sNe = {
  narrow: ["eaa.", "jaa."],
  abbreviated: ["eaa.", "jaa."],
  wide: ["ennen ajanlaskun alkua", "jälkeen ajanlaskun alun"]
}, uNe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartaali", "2. kvartaali", "3. kvartaali", "4. kvartaali"]
}, A$ = {
  narrow: ["T", "H", "M", "H", "T", "K", "H", "E", "S", "L", "M", "J"],
  abbreviated: ["tammi", "helmi", "maalis", "huhti", "touko", "kesä", "heinä", "elo", "syys", "loka", "marras", "joulu"],
  wide: ["tammikuu", "helmikuu", "maaliskuu", "huhtikuu", "toukokuu", "kesäkuu", "heinäkuu", "elokuu", "syyskuu", "lokakuu", "marraskuu", "joulukuu"]
}, cNe = {
  narrow: A$.narrow,
  abbreviated: A$.abbreviated,
  wide: ["tammikuuta", "helmikuuta", "maaliskuuta", "huhtikuuta", "toukokuuta", "kesäkuuta", "heinäkuuta", "elokuuta", "syyskuuta", "lokakuuta", "marraskuuta", "joulukuuta"]
}, c1 = {
  narrow: ["S", "M", "T", "K", "T", "P", "L"],
  short: ["su", "ma", "ti", "ke", "to", "pe", "la"],
  abbreviated: ["sunn.", "maan.", "tiis.", "kesk.", "torst.", "perj.", "la"],
  wide: ["sunnuntai", "maanantai", "tiistai", "keskiviikko", "torstai", "perjantai", "lauantai"]
}, dNe = {
  narrow: c1.narrow,
  short: c1.short,
  abbreviated: c1.abbreviated,
  wide: ["sunnuntaina", "maanantaina", "tiistaina", "keskiviikkona", "torstaina", "perjantaina", "lauantaina"]
}, fNe = {
  narrow: {
    am: "ap",
    pm: "ip",
    midnight: "keskiyö",
    noon: "keskipäivä",
    morning: "ap",
    afternoon: "ip",
    evening: "illalla",
    night: "yöllä"
  },
  abbreviated: {
    am: "ap",
    pm: "ip",
    midnight: "keskiyö",
    noon: "keskipäivä",
    morning: "ap",
    afternoon: "ip",
    evening: "illalla",
    night: "yöllä"
  },
  wide: {
    am: "ap",
    pm: "ip",
    midnight: "keskiyöllä",
    noon: "keskipäivällä",
    morning: "aamupäivällä",
    afternoon: "iltapäivällä",
    evening: "illalla",
    night: "yöllä"
  }
}, hNe = function(e, t) {
  var r = Number(e);
  return r + ".";
}, pNe = {
  ordinalNumber: hNe,
  era: Kt({
    values: sNe,
    defaultWidth: "wide"
  }),
  quarter: Kt({
    values: uNe,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: Kt({
    values: A$,
    defaultWidth: "wide",
    formattingValues: cNe,
    defaultFormattingWidth: "wide"
  }),
  day: Kt({
    values: c1,
    defaultWidth: "wide",
    formattingValues: dNe,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: Kt({
    values: fNe,
    defaultWidth: "wide"
  })
}, gNe = pNe, mNe = /^(\d+)(\.)/i, vNe = /\d+/i, bNe = {
  narrow: /^(e|j)/i,
  abbreviated: /^(eaa.|jaa.)/i,
  wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
}, yNe = {
  any: [/^e/i, /^j/i]
}, xNe = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\.? kvartaali/i
}, wNe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, MNe = {
  narrow: /^[thmkeslj]/i,
  abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
  wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
}, CNe = {
  narrow: [/^t/i, /^h/i, /^m/i, /^h/i, /^t/i, /^k/i, /^h/i, /^e/i, /^s/i, /^l/i, /^m/i, /^j/i],
  any: [/^ta/i, /^hel/i, /^maa/i, /^hu/i, /^to/i, /^k/i, /^hei/i, /^e/i, /^s/i, /^l/i, /^mar/i, /^j/i]
}, SNe = {
  narrow: /^[smtkpl]/i,
  short: /^(su|ma|ti|ke|to|pe|la)/i,
  abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
  wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
}, TNe = {
  narrow: [/^s/i, /^m/i, /^t/i, /^k/i, /^t/i, /^p/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^k/i, /^to/i, /^p/i, /^l/i]
}, kNe = {
  narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
  any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
}, DNe = {
  any: {
    am: /^ap/i,
    pm: /^ip/i,
    midnight: /^keskiyö/i,
    noon: /^keskipäivä/i,
    morning: /aamupäivällä/i,
    afternoon: /iltapäivällä/i,
    evening: /illalla/i,
    night: /yöllä/i
  }
}, ANe = {
  ordinalNumber: hl({
    matchPattern: mNe,
    parsePattern: vNe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Xt({
    matchPatterns: bNe,
    defaultMatchWidth: "wide",
    parsePatterns: yNe,
    defaultParseWidth: "any"
  }),
  quarter: Xt({
    matchPatterns: xNe,
    defaultMatchWidth: "wide",
    parsePatterns: wNe,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: Xt({
    matchPatterns: MNe,
    defaultMatchWidth: "wide",
    parsePatterns: CNe,
    defaultParseWidth: "any"
  }),
  day: Xt({
    matchPatterns: SNe,
    defaultMatchWidth: "wide",
    parsePatterns: TNe,
    defaultParseWidth: "any"
  }),
  dayPeriod: Xt({
    matchPatterns: kNe,
    defaultMatchWidth: "any",
    parsePatterns: DNe,
    defaultParseWidth: "any"
  })
}, ENe = ANe, INe = {
  code: "fi",
  formatDistance: J2e,
  formatLong: iNe,
  formatRelative: lNe,
  localize: gNe,
  match: ENe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, NNe = INe;
const zNe = {
  name: $r.finnish,
  locale: NNe
}, $Ne = {
  name: $r.finnish,
  global: {
    undo: "Kumoa",
    redo: "tehdä uudelleen",
    confirm: "Vahvista",
    clear: "Selvä"
  },
  Popconfirm: {
    positiveText: "vahvista",
    negativeText: "Peruuta"
  },
  Cascader: {
    placeholder: "Valitse, ole hyvä",
    loading: "Ladataan",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "selvä",
    now: "Nyt",
    confirm: "Vahvistaa",
    selectTime: "Valitse aika",
    selectDate: "Valitse päivämäärä",
    datePlaceholder: "Valitse päivämäärä",
    datetimePlaceholder: "Valitse päivämäärä ja aika",
    monthPlaceholder: "Valitse kuukausi",
    yearPlaceholder: "Valitse vuosi",
    quarterPlaceholder: "Valitse neljännes",
    startDatePlaceholder: "Aloitus päivämäärä",
    endDatePlaceholder: "Päättymispäivämäärä",
    startDatetimePlaceholder: "Aloitusajankohta ja -aika",
    endDatetimePlaceholder: "Päätöspäivä ja aika",
    startMonthPlaceholder: "Aloituskuukausi",
    endMonthPlaceholder: "Lopun kuukausi",
    monthBeforeYear: !0,
    firstDayOfWeek: 6,
    today: "Tänään"
  },
  DataTable: {
    checkTableAll: "Valitse kaikki taulukosta",
    uncheckTableAll: "Poista valinnat taulukosta",
    confirm: "Vahvista",
    clear: "Selvä",
    apply: "Ansøg",
    filters: "Suodattimet"
  },
  LegacyTransfer: {
    sourceTitle: "Lähde",
    targetTitle: "kohde"
  },
  Transfer: {
    selectAll: "Valitse kaikki",
    unselectAll: "Poista kaikki valinnat",
    clearAll: "Kirkas"
  },
  Empty: {
    description: "Ei dataa"
  },
  Select: {
    placeholder: "Valitse, kiitos"
  },
  TimePicker: {
    placeholder: "Valitse aika",
    positiveText: "OK",
    negativeText: "peruuttaa",
    now: "Nyt"
  },
  Pagination: {
    goto: "Siirry",
    selectionSuffix: "sivu",
    next: "Seuraava",
    previous: "Edellinen"
  },
  DynamicTags: {
    add: "Lisää"
  },
  Log: {
    loading: "Lataus"
  },
  Input: {
    placeholder: "Syötäthän tiedot"
  },
  InputNumber: {
    placeholder: "Syötä kiitos"
  },
  DynamicInput: {
    create: "Luoda"
  },
  ThemeEditor: {
    title: "Teeman muokkaaja",
    clearAllVars: "Poista kaikki muuttujat",
    clearSearch: "Tyhjennä haku",
    filterCompName: "Suodatin osan nimi",
    filterVarName: "Suodattimen muuttujan nimi",
    import: "Tuonti",
    export: "Vienti",
    restore: "Nollaa oletusarvoihin"
  },
  Image: {
    tipPrevious: "Edellinen kuva (←)",
    tipNext: "Seuraava kuva (→)",
    tipCounterclockwise: "Vastapäivään",
    tipClockwise: "Myötäpäivään",
    tipZoomOut: "Zoomaa ulos",
    tipZoomIn: "Lähennä",
    tipClose: "Sulje (Esc)",
    tipOriginalSize: "Zoomaa alkuperäiseen kokoon"
  }
};
var ONe = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "yy-MM-dd"
}, _Ne = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, LNe = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, PNe = {
  date: jr({
    formats: ONe,
    defaultWidth: "full"
  }),
  time: jr({
    formats: _Ne,
    defaultWidth: "full"
  }),
  dateTime: jr({
    formats: LNe,
    defaultWidth: "full"
  })
}, RNe = PNe, jNe = {
  code: "fr-CA",
  formatDistance: q7,
  formatLong: RNe,
  formatRelative: G7,
  localize: Z7,
  match: K7,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, FNe = jNe;
const BNe = {
  name: $r.frenchCanada,
  locale: FNe
}, UNe = {
  name: $r.frenchCanada,
  global: {
    undo: "Annuler",
    redo: "Rétablir",
    confirm: "Confirmer",
    clear: "Effacer"
  },
  Popconfirm: {
    positiveText: "Confirmer",
    negativeText: "Effacer"
  },
  Cascader: {
    placeholder: "Veuillez sélectionner",
    loading: "Chargement",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "MM/yyyy",
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss",
    quarterFormat: "qqq yyyy",
    clear: "Effacer",
    now: "Maintenant",
    confirm: "Confirmer",
    selectTime: "Sélectionner l'heure",
    selectDate: "Sélectionner la date",
    datePlaceholder: "Sélectionner une date",
    datetimePlaceholder: "Sélectionner la date et l'heure",
    monthPlaceholder: "Sélectionner le mois",
    yearPlaceholder: "Sélectionner l'année",
    quarterPlaceholder: "Sélectionner le trimestre",
    startDatePlaceholder: "Date de début",
    endDatePlaceholder: "Date de fin",
    startDatetimePlaceholder: "Date et heure de début",
    endDatetimePlaceholder: "Date et heure de fin",
    startMonthPlaceholder: "Mois de début",
    endMonthPlaceholder: "Mois de fin",
    monthBeforeYear: !0,
    firstDayOfWeek: 1,
    today: "Aujourd'hui"
  },
  DataTable: {
    checkTableAll: "Sélectionner tout dans le tableau",
    uncheckTableAll: "Déselectionner tout dans le tableau",
    confirm: "Confirmer",
    clear: "Effacer",
    apply: "Appliquer",
    filters: "Filtres"
  },
  LegacyTransfer: {
    sourceTitle: "Source",
    targetTitle: "Cible"
  },
  Transfer: {
    selectAll: "Tout sélectionner",
    unselectAll: "Tout désélectionner",
    clearAll: "Effacer"
  },
  Empty: {
    description: "Aucune donnée"
  },
  Select: {
    placeholder: "Veuillez sélectionner"
  },
  TimePicker: {
    placeholder: "Sélectionner l'heure",
    positiveText: "OK",
    negativeText: "Annuler",
    now: "Maintenant"
  },
  Pagination: {
    goto: "Aller à",
    selectionSuffix: "page",
    next: "Suivant",
    previous: "Précédent"
  },
  DynamicTags: {
    add: "Ajouter"
  },
  Log: {
    loading: "Chargement"
  },
  Input: {
    placeholder: "Veuillez entrer"
  },
  InputNumber: {
    placeholder: "Veuillez entrer"
  },
  DynamicInput: {
    create: "Créer"
  },
  ThemeEditor: {
    title: "Éditeur de thème",
    clearAllVars: "Effacer toutes les variables",
    clearSearch: "Effacer la recherche",
    filterCompName: "Filtrer le nom du composant",
    filterVarName: "Filtrer le nom de la variable",
    import: "Importer",
    export: "Exporter",
    restore: "Réinitialiser par défaut"
  },
  Image: {
    tipPrevious: "Image précédente (←)",
    tipNext: "Image suivante (→)",
    tipCounterclockwise: "Dans le sens antihoraire",
    tipClockwise: "Dans le sens horaire",
    tipZoomOut: "Zoom arrière",
    tipZoomIn: "Zoom avant",
    tipClose: "Fermer (Esc)",
    tipOriginalSize: "Zoom à la taille d'origine"
  }
}, HNe = {
  name: $r.frenchFrance,
  locale: cce
}, WNe = {
  name: $r.frenchFrance,
  global: {
    undo: "Annuler",
    redo: "Rétablir",
    confirm: "Confirmer",
    clear: "Effacer"
  },
  Popconfirm: {
    positiveText: "Confirmer",
    negativeText: "Annuler"
  },
  Cascader: {
    placeholder: "Veuillez sélectionner",
    loading: "Chargement",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "MM/yyyy",
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss",
    quarterFormat: "qqq yyyy",
    clear: "Effacer",
    now: "Maintenant",
    confirm: "Confirmer",
    selectTime: "Sélectionner l'heure",
    selectDate: "Sélectionner la date",
    datePlaceholder: "Sélectionner la date",
    datetimePlaceholder: "Sélectionner la date et l'heure",
    monthPlaceholder: "Sélectionner le mois",
    yearPlaceholder: "Sélectionner l'année",
    quarterPlaceholder: "Sélectionner le trimestre",
    startDatePlaceholder: "Date de début",
    endDatePlaceholder: "Date de fin",
    startDatetimePlaceholder: "Heure de début",
    endDatetimePlaceholder: "Heure de fin",
    startMonthPlaceholder: "Mois de début",
    endMonthPlaceholder: "Mois de fin",
    monthBeforeYear: !0,
    firstDayOfWeek: 1,
    today: "Aujourd'hui"
  },
  DataTable: {
    checkTableAll: "Sélectionner tout dans le tableau",
    uncheckTableAll: "Déselectionner tout dans le tableau",
    confirm: "Confirmer",
    clear: "Effacer",
    apply: "Appliquer",
    filters: "Filtres"
  },
  LegacyTransfer: {
    sourceTitle: "Source",
    targetTitle: "Cible"
  },
  Transfer: {
    selectAll: "Sélectionner tout",
    unselectAll: "Désélectionner tout",
    clearAll: "Effacer"
  },
  Empty: {
    description: "Pas de données"
  },
  Select: {
    placeholder: "Veuillez sélectionner"
  },
  TimePicker: {
    placeholder: "Sélectionner l'heure",
    positiveText: "OK",
    negativeText: "Annuler",
    now: "Maintenant"
  },
  Pagination: {
    goto: "Aller à",
    selectionSuffix: "page",
    next: "Suivant",
    previous: "Précédent"
  },
  DynamicTags: {
    add: "Ajouter"
  },
  Log: {
    loading: "Chargement"
  },
  Input: {
    placeholder: "Veuillez entrer"
  },
  InputNumber: {
    placeholder: "Veuillez entrer"
  },
  DynamicInput: {
    create: "Créer"
  },
  ThemeEditor: {
    title: "Éditeur de thème",
    clearAllVars: "Effacer toutes les variables",
    clearSearch: "Effacer la recherche",
    filterCompName: "Filtrer le nom de l'élément",
    filterVarName: "Filtrer le nom de la variable",
    import: "Importer",
    export: "Exporter",
    restore: "Remise à l'état initial"
  },
  Image: {
    tipPrevious: "Image précédente (←)",
    tipNext: "Image suivante (→)",
    tipCounterclockwise: "Sens antihoraire",
    tipClockwise: "Sens horaire",
    tipZoomOut: "Zoom arrière",
    tipZoomIn: "Zoom avant",
    tipClose: "Fermer (Esc)",
    tipOriginalSize: "Zoom sur la taille originale"
  }
}, VNe = {
  name: $r.german,
  locale: vse
}, YNe = {
  name: $r.german,
  global: {
    undo: "Rückgängig machen",
    redo: "Wiederholen",
    confirm: "Bestätigen Sie",
    clear: "Löschen"
  },
  Popconfirm: {
    positiveText: "Bestätigen",
    negativeText: "Abbrechen"
  },
  Cascader: {
    placeholder: "Bitte auswählen",
    loading: "Laden",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd.MM.yyyy",
    dateTimeFormat: "dd.MM.yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "MM-yyyy",
    dateFormat: "dd.MM.yyyy",
    dateTimeFormat: "dd.MM.yyyy HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Löschen",
    now: "Jetzt",
    confirm: "Bestätigen Sie",
    selectTime: "Zeit auswählen",
    selectDate: "Datum auswählen",
    datePlaceholder: "Datum auswählen",
    datetimePlaceholder: "Datum und Uhrzeit wählen",
    monthPlaceholder: "Monat wählen",
    yearPlaceholder: "Jahr wählen",
    quarterPlaceholder: "Quartal wählen",
    startDatePlaceholder: "Startdatum",
    endDatePlaceholder: "Enddatum",
    startDatetimePlaceholder: "Startdatum und Uhrzeit",
    endDatetimePlaceholder: "Enddatum und -uhrzeit",
    startMonthPlaceholder: "Monat beginnen",
    endMonthPlaceholder: "Ende Monat",
    monthBeforeYear: !0,
    firstDayOfWeek: 0,
    today: "Heute"
  },
  DataTable: {
    checkTableAll: "Alles in der Tabelle markieren",
    uncheckTableAll: "Alle in der Tabelle abwählen",
    confirm: "Bestätigen",
    clear: "Löschen",
    apply: "Anwenden",
    filters: "Filtern"
  },
  LegacyTransfer: {
    sourceTitle: "Quelle",
    targetTitle: "Ziel"
  },
  Transfer: {
    selectAll: "Alles auswählen",
    unselectAll: "Alle abwählen",
    clearAll: "Löschen"
  },
  Empty: {
    description: "Keine Daten"
  },
  Select: {
    placeholder: "Bitte auswählen"
  },
  TimePicker: {
    placeholder: "Zeit auswählen",
    positiveText: "OK",
    negativeText: "Abbrechen",
    now: "Jetzt"
  },
  Pagination: {
    goto: "Gehe zu",
    selectionSuffix: "Seite",
    next: "Nächste",
    previous: "Vorherige"
  },
  DynamicTags: {
    add: "hinzufügen"
  },
  Log: {
    loading: "Laden"
  },
  Input: {
    placeholder: "Bitte eingeben"
  },
  InputNumber: {
    placeholder: "Bitte eingeben"
  },
  DynamicInput: {
    create: "erstellen"
  },
  ThemeEditor: {
    title: "Themen-Editor",
    clearAllVars: "Alle Variablen löschen",
    clearSearch: "Suche löschen",
    filterCompName: "Komponentenname filtern",
    filterVarName: "Variablenname filtern",
    import: "Importieren",
    export: "Exportieren",
    restore: "Auf Standard zurücksetzen"
  },
  Image: {
    tipPrevious: "Vorheriges Bild (←)",
    tipNext: "Nächstes Bild (→)",
    tipCounterclockwise: "Gegen den Uhrzeigersinn",
    tipClockwise: "Im Uhrzeigersinn",
    tipZoomOut: "Verkleinern",
    tipZoomIn: "Einzoomen",
    tipClose: "Schließen (Esc)",
    tipOriginalSize: "Auf Originalgröße zoomen"
  }
}, QNe = {
  name: $r.italian,
  locale: Nde
}, qNe = {
  name: $r.italian,
  global: {
    undo: "Annulla",
    redo: "Rifare",
    confirm: "Confermare",
    clear: "Chiaro"
  },
  Popconfirm: {
    positiveText: "Confermare",
    negativeText: "Annulla"
  },
  Cascader: {
    placeholder: "Per favore seleziona.",
    loading: "Caricamento",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Chiaro",
    now: "Adesso",
    confirm: "Conferma",
    selectTime: "Seleziona l'orario",
    selectDate: "Seleziona data",
    datePlaceholder: "Seleziona la data",
    datetimePlaceholder: "Seleziona data e ora",
    monthPlaceholder: "Seleziona mese",
    yearPlaceholder: "Seleziona anno",
    quarterPlaceholder: "Seleziona il trimestre",
    startDatePlaceholder: "Data di inizio",
    endDatePlaceholder: "Data di fine",
    startDatetimePlaceholder: "Data e Ora di inizio",
    endDatetimePlaceholder: "Data e ora di fine",
    startMonthPlaceholder: "Mese di Inizio",
    endMonthPlaceholder: "Fine Mese",
    monthBeforeYear: !0,
    firstDayOfWeek: 0,
    today: "Oggi"
  },
  DataTable: {
    checkTableAll: "Selezionare tutto nella tabella.",
    uncheckTableAll: "Deseleziona tutto nella tabella.",
    confirm: "Confermare",
    clear: "Chiaro",
    apply: "Applica",
    filters: "Filtri"
  },
  LegacyTransfer: {
    sourceTitle: "Fonte",
    targetTitle: "Obiettivo"
  },
  Transfer: {
    selectAll: "Seleziona tutto",
    unselectAll: "Deseleziona tutto",
    clearAll: "Chiaro"
  },
  Empty: {
    description: "Nessun dato"
  },
  Select: {
    placeholder: "Per favore seleziona"
  },
  TimePicker: {
    placeholder: "Seleziona orario",
    positiveText: "OK",
    negativeText: "Annullare",
    now: "Ora"
  },
  Pagination: {
    goto: "Andare a",
    selectionSuffix: "pagina",
    next: "Prossimo",
    previous: "Precedente"
  },
  DynamicTags: {
    add: "Aggiungi"
  },
  Log: {
    loading: "Caricamento"
  },
  Input: {
    placeholder: "Per favore, inserisci"
  },
  InputNumber: {
    placeholder: "Inserisci per favore."
  },
  DynamicInput: {
    create: "Creare"
  },
  ThemeEditor: {
    title: "Editor di temi",
    clearAllVars: "Cancella tutte le variabili",
    clearSearch: "Cancella ricerca",
    filterCompName: "Nome del componente di filtro",
    filterVarName: "Nome variabile filtro",
    import: "importazione",
    export: "Esportazione",
    restore: "Ripristina impostazioni predefinite"
  },
  Image: {
    tipPrevious: "Immagine precedente (←)",
    tipNext: "Prossima immagine (→)",
    tipCounterclockwise: "Controverse",
    tipClockwise: "in senso orario",
    tipZoomOut: "Allontana l'immagine",
    tipZoomIn: "Ingrandisci",
    tipClose: "Chiudi (Esc)",
    tipOriginalSize: "Ingrandisci alla dimensione originale"
  }
}, GNe = {
  name: $r.norwegian,
  locale: Xse
}, ZNe = {
  name: $r.norwegian,
  global: {
    undo: "Angre",
    redo: "Gjør om",
    confirm: "Gjør om",
    clear: "Gjør om"
  },
  Popconfirm: {
    positiveText: "Bekreft",
    negativeText: "Avbryt"
  },
  Cascader: {
    placeholder: "Vennligst Velg",
    loading: "Laster",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd.MM.yyyy",
    dateTimeFormat: "dd.MM.yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "MM.yyyy",
    dateFormat: "dd.MM.yyyy",
    dateTimeFormat: "dd.MM.yyyy HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Tøm",
    now: "Nå",
    confirm: "Bekreft",
    selectTime: "Velg Tid",
    selectDate: "Velg Dato",
    datePlaceholder: "Velg Dato",
    datetimePlaceholder: "Velg Dato og Tid",
    monthPlaceholder: "Velg Måned",
    yearPlaceholder: "Velg År",
    quarterPlaceholder: "Velg Kvartal",
    startDatePlaceholder: "Start Dato",
    endDatePlaceholder: "Slutt Dato",
    startDatetimePlaceholder: "Start Dato og Tid",
    endDatetimePlaceholder: "Slutt Dato og Tid",
    startMonthPlaceholder: "Start Måned",
    endMonthPlaceholder: "Slutt Måned",
    monthBeforeYear: !0,
    firstDayOfWeek: 0,
    today: "I Dag"
  },
  DataTable: {
    checkTableAll: "Velg alle i tabellen",
    uncheckTableAll: "Fjern markeringen av alle i tabellen",
    confirm: "Bekreft",
    clear: "Tøm",
    apply: "Bruk",
    filters: "Filtere"
  },
  LegacyTransfer: {
    sourceTitle: "Kilde",
    targetTitle: "Mål"
  },
  Transfer: {
    selectAll: "Marker alle",
    unselectAll: "Fjern alle valg",
    clearAll: "Tøm"
  },
  Empty: {
    description: "Ingen Data"
  },
  Select: {
    placeholder: "Vennligst Velg"
  },
  TimePicker: {
    placeholder: "Velg Tid",
    positiveText: "OK",
    negativeText: "Avbryt",
    now: "Nå"
  },
  Pagination: {
    goto: "Gå til",
    selectionSuffix: "side",
    next: "Neste",
    previous: "Forrige"
  },
  DynamicTags: {
    add: "Legg tid"
  },
  Log: {
    loading: "Laster"
  },
  Input: {
    placeholder: "Vennligst Skriv Inn"
  },
  InputNumber: {
    placeholder: "Vennligst Skriv Inn"
  },
  DynamicInput: {
    create: "Opprett"
  },
  ThemeEditor: {
    title: "Tema Redigerer",
    clearAllVars: "Tøm Alle Variabler",
    clearSearch: "Tøm Søk",
    filterCompName: "Filtrer Komponentnavn",
    filterVarName: "Filtrer Variabelnavn",
    import: "Importer",
    export: "Eksporter",
    restore: "Tilbakestill til Standard"
  },
  Image: {
    tipPrevious: "Forrige bilde (←)",
    tipNext: "Neste bilde (→)",
    tipCounterclockwise: "Mot klokken",
    tipClockwise: "Med klokken",
    tipZoomOut: "Zoom ut",
    tipZoomIn: "Zoom inn",
    tipClose: "Lukk (Esc)",
    tipOriginalSize: "Zoom til original størrelse"
  }
}, KNe = {
  name: $r.portugueseBrazil,
  locale: hfe
}, XNe = {
  name: $r.portugueseBrazil,
  global: {
    undo: "Desfazer",
    redo: "Refazer",
    confirm: "Confirmar",
    clear: "Limpar"
  },
  Popconfirm: {
    positiveText: "Confirmar",
    negativeText: "Cancelar"
  },
  Cascader: {
    placeholder: "Por favor, selecione",
    loading: "Carregando",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy/MM",
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss",
    quarterFormat: "yyyy/qqq",
    clear: "Limpar",
    now: "Agora",
    confirm: "Confirmar",
    selectTime: "Selecionar Horário",
    selectDate: "Selecionar Data",
    datePlaceholder: "Selecionar Data",
    datetimePlaceholder: "Selecionar Data e Hora",
    monthPlaceholder: "Selecionar Mês",
    yearPlaceholder: "Selecionar Ano",
    quarterPlaceholder: "Selecionar Trimestre",
    startDatePlaceholder: "Data de Início",
    endDatePlaceholder: "Data Final",
    startDatetimePlaceholder: "Data e Hora Inicial",
    endDatetimePlaceholder: "Data e Hora Final",
    startMonthPlaceholder: "Mês de Início",
    endMonthPlaceholder: "Mês Final",
    monthBeforeYear: !0,
    firstDayOfWeek: 6,
    today: "Hoje"
  },
  DataTable: {
    checkTableAll: "Selecionar tudo na tabela",
    uncheckTableAll: "Desmarcar tudo na tabela",
    confirm: "Confirmar",
    clear: "Limpar",
    apply: "Aplicar",
    filters: "Filtros"
  },
  LegacyTransfer: {
    sourceTitle: "Origem",
    targetTitle: "Destino"
  },
  Transfer: {
    selectAll: "Selecionar tudo",
    unselectAll: "Desmarcar tudo",
    clearAll: "Limpar"
  },
  Empty: {
    description: "Sem Dados"
  },
  Select: {
    placeholder: "Por favor, selecione"
  },
  TimePicker: {
    placeholder: "Selecionar Horário",
    positiveText: "OK",
    negativeText: "Cancelar",
    now: "Agora"
  },
  Pagination: {
    goto: "Ir para",
    selectionSuffix: "página",
    next: "Próximo",
    previous: "Anterior"
  },
  DynamicTags: {
    add: "Adicionar"
  },
  Log: {
    loading: "Carregando"
  },
  Input: {
    placeholder: "Por favor, insira"
  },
  InputNumber: {
    placeholder: "Por favor, preencha"
  },
  DynamicInput: {
    create: "Criar"
  },
  ThemeEditor: {
    title: "Editor de Tema",
    clearAllVars: "Limpar todas as variáveis",
    clearSearch: "Limpar Busca",
    filterCompName: "Filtrar Nome do Componente",
    filterVarName: "Filtrar Nome da Variável",
    import: "Importar",
    export: "Exportar",
    restore: "Redefinir para o Padrão"
  },
  Image: {
    tipPrevious: "Imagem Anterior (←)",
    tipNext: "Próxima Imagem (→)",
    tipCounterclockwise: "Sentido Anti-horário",
    tipClockwise: "Sentido Horário",
    tipZoomOut: "Reduzir Zoom",
    tipZoomIn: "Aumentar Zoom",
    tipClose: "Fechar (Esc)",
    tipOriginalSize: "Zoom para Tamanho Original"
  }
};
var JNe = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "aproximadamente 1 hora",
    other: "aproximadamente {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "aproximadamente 1 semana",
    other: "aproximadamente {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "aproximadamente 1 mês",
    other: "aproximadamente {{count}} meses"
  },
  xMonths: {
    one: "1 mês",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "aproximadamente 1 ano",
    other: "aproximadamente {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
}, eze = function(e, t, r) {
  var n, i = JNe[e];
  return typeof i == "string" ? n = i : t === 1 ? n = i.one : n = i.other.replace("{{count}}", String(t)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "daqui a " + n : "há " + n : n;
}, tze = eze, rze = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d 'de' MMM 'de' y",
  short: "dd/MM/y"
}, nze = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, ize = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, oze = {
  date: jr({
    formats: rze,
    defaultWidth: "full"
  }),
  time: jr({
    formats: nze,
    defaultWidth: "full"
  }),
  dateTime: jr({
    formats: ize,
    defaultWidth: "full"
  })
}, aze = oze, lze = {
  lastWeek: function(e) {
    var t = e.getUTCDay(), r = t === 0 || t === 6 ? "último" : "última";
    return "'" + r + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P"
}, sze = function(e, t, r, n) {
  var i = lze[e];
  return typeof i == "function" ? i(t) : i;
}, uze = sze, cze = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["antes de Cristo", "depois de Cristo"]
}, dze = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, fze = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
  wide: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
}, hze = {
  narrow: ["d", "s", "t", "q", "q", "s", "s"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  abbreviated: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  wide: ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"]
}, pze = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  }
}, gze = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  }
}, mze = function(e, t) {
  var r = Number(e);
  return r + "º";
}, vze = {
  ordinalNumber: mze,
  era: Kt({
    values: cze,
    defaultWidth: "wide"
  }),
  quarter: Kt({
    values: dze,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: Kt({
    values: fze,
    defaultWidth: "wide"
  }),
  day: Kt({
    values: hze,
    defaultWidth: "wide"
  }),
  dayPeriod: Kt({
    values: pze,
    defaultWidth: "wide",
    formattingValues: gze,
    defaultFormattingWidth: "wide"
  })
}, bze = vze, yze = /^(\d+)(º|ª)?/i, xze = /\d+/i, wze = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
}, Mze = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
}, Cze = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º|ª)? trimestre/i
}, Sze = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Tze = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
}, kze = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ab/i, /^mai/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Dze = {
  narrow: /^[dstq]/i,
  short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
}, Aze = {
  narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
}, Eze = {
  narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
  any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
}, Ize = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^meia/i,
    noon: /^meio/i,
    morning: /manh[ãa]/i,
    afternoon: /tarde/i,
    evening: /noite/i,
    night: /madrugada/i
  }
}, Nze = {
  ordinalNumber: hl({
    matchPattern: yze,
    parsePattern: xze,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Xt({
    matchPatterns: wze,
    defaultMatchWidth: "wide",
    parsePatterns: Mze,
    defaultParseWidth: "any"
  }),
  quarter: Xt({
    matchPatterns: Cze,
    defaultMatchWidth: "wide",
    parsePatterns: Sze,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: Xt({
    matchPatterns: Tze,
    defaultMatchWidth: "wide",
    parsePatterns: kze,
    defaultParseWidth: "any"
  }),
  day: Xt({
    matchPatterns: Dze,
    defaultMatchWidth: "wide",
    parsePatterns: Aze,
    defaultParseWidth: "any"
  }),
  dayPeriod: Xt({
    matchPatterns: Eze,
    defaultMatchWidth: "any",
    parsePatterns: Ize,
    defaultParseWidth: "any"
  })
}, zze = Nze, $ze = {
  code: "pt",
  formatDistance: tze,
  formatLong: aze,
  formatRelative: uze,
  localize: bze,
  match: zze,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Oze = $ze;
const _ze = {
  name: $r.portuguesePortugal,
  locale: Oze
}, Lze = {
  name: $r.portuguesePortugal,
  global: {
    undo: "Desfazer",
    redo: "Refazer",
    confirm: "Confirmar",
    clear: "Claro"
  },
  Popconfirm: {
    positiveText: "Confirmar",
    negativeText: "Cancelar"
  },
  Cascader: {
    placeholder: "Por favor, selecione",
    loading: "A carregar",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy/MM",
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss",
    quarterFormat: "yyyy/qqq",
    clear: "Claro",
    now: "Agora",
    confirm: "Confirmar",
    selectTime: "Selecionar Tempo",
    selectDate: "Selecionar Data",
    datePlaceholder: "Selecionar Data",
    datetimePlaceholder: "Selecionar Data e Hora",
    monthPlaceholder: "Selecionar Mês",
    yearPlaceholder: "Selecionar Ano",
    quarterPlaceholder: "Selecionar Trimestre",
    startDatePlaceholder: "Data de Início",
    endDatePlaceholder: "Data de término",
    startDatetimePlaceholder: "Data e Hora de Início",
    endDatetimePlaceholder: "Data e Hora de Fim",
    startMonthPlaceholder: "Mês de Início",
    endMonthPlaceholder: "Fim do mês",
    monthBeforeYear: !0,
    firstDayOfWeek: 6,
    today: "Hoje"
  },
  DataTable: {
    checkTableAll: "Selecione tudo na tabela",
    uncheckTableAll: "Desmarcar tudo na tabela",
    confirm: "Confirmar",
    clear: "Claro",
    apply: "Aplicar",
    filters: "Filtros"
  },
  LegacyTransfer: {
    sourceTitle: "Fonte",
    targetTitle: "Alvo"
  },
  Transfer: {
    selectAll: "Selecionar tudo",
    unselectAll: "Desmarcar tudo",
    clearAll: "Claro"
  },
  Empty: {
    description: "Sem Dados"
  },
  Select: {
    placeholder: "Por favor, selecione"
  },
  TimePicker: {
    placeholder: "Selecionar Tempo",
    positiveText: "OK",
    negativeText: "Cancelar",
    now: "Agora"
  },
  Pagination: {
    goto: "Ir para",
    selectionSuffix: "página",
    next: "Seguinte",
    previous: "Anterior"
  },
  DynamicTags: {
    add: "Adicionar"
  },
  Log: {
    loading: "A carregar"
  },
  Input: {
    placeholder: "Por favor, introduza"
  },
  InputNumber: {
    placeholder: "Por favor, introduza"
  },
  DynamicInput: {
    create: "Criar"
  },
  ThemeEditor: {
    title: "Editor de Temas",
    clearAllVars: "Limpar todas as variáveis",
    clearSearch: "Limpar pesquisa",
    filterCompName: "Nome do Componente de Filtro",
    filterVarName: "Nome da Variável de Filtro",
    import: "Importar",
    export: "Exportar",
    restore: "Repor para o Padrão"
  },
  Image: {
    tipPrevious: "Imagem anterior (←)",
    tipNext: "Próxima Imagem (→)",
    tipCounterclockwise: "Anticlockwise",
    tipClockwise: "No sentido dos ponteiros do relógio",
    tipZoomOut: "Afastar o zoom",
    tipZoomIn: "Ampliar",
    tipClose: "Fechar (Esc)",
    tipOriginalSize: "Ampliar para o tamanho original"
  }
}, Pze = {
  name: $r.spanish,
  locale: Qce
}, Rze = {
  name: $r.spanish,
  global: {
    undo: "Deshacer",
    redo: "Rehacer",
    confirm: "Confirmar",
    clear: "Limpiar"
  },
  Popconfirm: {
    positiveText: "Confirmar",
    negativeText: "Cancelar"
  },
  Cascader: {
    placeholder: "Por favor Seleccionar",
    loading: "Cargando",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Limpiar",
    now: "Ahora",
    confirm: "Confirmar",
    selectTime: "Seleccionar Hora",
    selectDate: "Seleccionar Fecha",
    datePlaceholder: "Seleccionar Fecha",
    datetimePlaceholder: "Seleccionar Fecha y Hora",
    monthPlaceholder: "Seleccionar Mes",
    yearPlaceholder: "Seleccionar Año",
    quarterPlaceholder: "Seleccionar Trimestre",
    startDatePlaceholder: "Fecha de Inicio",
    endDatePlaceholder: "Fecha Final",
    startDatetimePlaceholder: "Fecha y Hora de Inicio",
    endDatetimePlaceholder: "Fecha Hora Final",
    monthBeforeYear: !0,
    startMonthPlaceholder: "Mes de Inicio",
    endMonthPlaceholder: "Mes final",
    firstDayOfWeek: 6,
    today: "Hoy"
  },
  DataTable: {
    checkTableAll: "Seleccionar todo en la tabla",
    uncheckTableAll: "Deseleccionar todo en la tabla",
    confirm: "Confirmar",
    clear: "Limpiar",
    apply: "Aplicar",
    filters: "Filtros"
  },
  LegacyTransfer: {
    sourceTitle: "Origen",
    targetTitle: "Objetivo"
  },
  Transfer: {
    selectAll: "Seleccionar Todos",
    unselectAll: "Deseleccionar todos",
    clearAll: "Limpiar"
  },
  Empty: {
    description: "Sin datos"
  },
  Select: {
    placeholder: "Por favor selecciona"
  },
  TimePicker: {
    placeholder: "Seleccionar hora",
    positiveText: "De acuerdo",
    negativeText: "Cancelar",
    now: "Ahora"
  },
  Pagination: {
    goto: "Ir a",
    selectionSuffix: "Pagina",
    next: "Siguiente",
    previous: "Anterior"
  },
  DynamicTags: {
    add: "Agregar"
  },
  Log: {
    loading: "Cargando"
  },
  Input: {
    placeholder: "Por favor, entrada"
  },
  InputNumber: {
    placeholder: "Por favor, entrada"
  },
  DynamicInput: {
    create: "Crear"
  },
  ThemeEditor: {
    title: "Editor de Tema",
    clearAllVars: "Limpiar todas las variables",
    clearSearch: "Limpiar búsqueda",
    filterCompName: "Filtrar nombre del componente",
    filterVarName: "Filtrar variable de nombre",
    import: "Importar",
    export: "Exportar",
    restore: "restablecer a predeterminado"
  },
  Image: {
    tipPrevious: "Foto anterior (←)",
    tipNext: "Siguiente foto (→)",
    tipCounterclockwise: "Sentido contrario a las agujas del reloj",
    tipClockwise: "Sentido de las agujas del reloj",
    tipZoomOut: "Zoom out",
    tipZoomIn: "Zoom in",
    tipClose: "Cerrar (Esc)",
    tipOriginalSize: "Zoom al tamaño original"
  }
};
var jze = {
  lessThanXSeconds: {
    one: "mindre än en sekund",
    other: "mindre än {{count}} sekunder"
  },
  xSeconds: {
    one: "en sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "en halv minut",
  lessThanXMinutes: {
    one: "mindre än en minut",
    other: "mindre än {{count}} minuter"
  },
  xMinutes: {
    one: "en minut",
    other: "{{count}} minuter"
  },
  aboutXHours: {
    one: "ungefär en timme",
    other: "ungefär {{count}} timmar"
  },
  xHours: {
    one: "en timme",
    other: "{{count}} timmar"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "ungefär en vecka",
    other: "ungefär {{count}} vecka"
  },
  xWeeks: {
    one: "en vecka",
    other: "{{count}} vecka"
  },
  aboutXMonths: {
    one: "ungefär en månad",
    other: "ungefär {{count}} månader"
  },
  xMonths: {
    one: "en månad",
    other: "{{count}} månader"
  },
  aboutXYears: {
    one: "ungefär ett år",
    other: "ungefär {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "över ett år",
    other: "över {{count}} år"
  },
  almostXYears: {
    one: "nästan ett år",
    other: "nästan {{count}} år"
  }
}, Fze = ["noll", "en", "två", "tre", "fyra", "fem", "sex", "sju", "åtta", "nio", "tio", "elva", "tolv"], Bze = function(e, t, r) {
  var n, i = jze[e];
  return typeof i == "string" ? n = i : t === 1 ? n = i.one : r && r.onlyNumeric ? n = i.other.replace("{{count}}", String(t)) : n = i.other.replace("{{count}}", t < 13 ? Fze[t] : String(t)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "om " + n : n + " sedan" : n;
}, Uze = Bze, Hze = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "y-MM-dd"
}, Wze = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Vze = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Yze = {
  date: jr({
    formats: Hze,
    defaultWidth: "full"
  }),
  time: jr({
    formats: Wze,
    defaultWidth: "full"
  }),
  dateTime: jr({
    formats: Vze,
    defaultWidth: "full"
  })
}, Qze = Yze, qze = {
  lastWeek: "'i' EEEE's kl.' p",
  yesterday: "'igår kl.' p",
  today: "'idag kl.' p",
  tomorrow: "'imorgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, Gze = function(e, t, r, n) {
  return qze[e];
}, Zze = Gze, Kze = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["före Kristus", "efter Kristus"]
}, Xze = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
}, Jze = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apr.", "maj", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"]
}, e$e = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sö", "må", "ti", "on", "to", "fr", "lö"],
  abbreviated: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
  wide: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"]
}, t$e = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "morg.",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  abbreviated: {
    am: "f.m.",
    pm: "e.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  wide: {
    am: "förmiddag",
    pm: "eftermiddag",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "eftermiddag",
    evening: "kväll",
    night: "natt"
  }
}, r$e = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  abbreviated: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  wide: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgonen",
    afternoon: "på eftermiddagen",
    evening: "på kvällen",
    night: "på natten"
  }
}, n$e = function(e, t) {
  var r = Number(e), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
      case 2:
        return r + ":a";
    }
  return r + ":e";
}, i$e = {
  ordinalNumber: n$e,
  era: Kt({
    values: Kze,
    defaultWidth: "wide"
  }),
  quarter: Kt({
    values: Xze,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: Kt({
    values: Jze,
    defaultWidth: "wide"
  }),
  day: Kt({
    values: e$e,
    defaultWidth: "wide"
  }),
  dayPeriod: Kt({
    values: t$e,
    defaultWidth: "wide",
    formattingValues: r$e,
    defaultFormattingWidth: "wide"
  })
}, o$e = i$e, a$e = /^(\d+)(:a|:e)?/i, l$e = /\d+/i, s$e = {
  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
}, u$e = {
  any: [/^f/i, /^[ev]/i]
}, c$e = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](:a|:e)? kvartalet/i
}, d$e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, f$e = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
}, h$e = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, p$e = {
  narrow: /^[smtofl]/i,
  short: /^(sö|må|ti|on|to|fr|lö)/i,
  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
}, g$e = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, m$e = {
  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
}, v$e = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /eftermiddag/i,
    evening: /kväll/i,
    night: /natt/i
  }
}, b$e = {
  ordinalNumber: hl({
    matchPattern: a$e,
    parsePattern: l$e,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Xt({
    matchPatterns: s$e,
    defaultMatchWidth: "wide",
    parsePatterns: u$e,
    defaultParseWidth: "any"
  }),
  quarter: Xt({
    matchPatterns: c$e,
    defaultMatchWidth: "wide",
    parsePatterns: d$e,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: Xt({
    matchPatterns: f$e,
    defaultMatchWidth: "wide",
    parsePatterns: h$e,
    defaultParseWidth: "any"
  }),
  day: Xt({
    matchPatterns: p$e,
    defaultMatchWidth: "wide",
    parsePatterns: g$e,
    defaultParseWidth: "any"
  }),
  dayPeriod: Xt({
    matchPatterns: m$e,
    defaultMatchWidth: "any",
    parsePatterns: v$e,
    defaultParseWidth: "any"
  })
}, y$e = b$e, x$e = {
  code: "sv",
  formatDistance: Uze,
  formatLong: Qze,
  formatRelative: Zze,
  localize: o$e,
  match: y$e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, w$e = x$e;
const M$e = {
  name: $r.swedish,
  locale: w$e
}, C$e = {
  name: $r.swedish,
  global: {
    undo: "Ångra",
    redo: "Klar",
    confirm: "Bekräfta",
    clear: "Klar"
  },
  Popconfirm: {
    positiveText: "Bekräfta",
    negativeText: "Avbryt"
  },
  Cascader: {
    placeholder: "Vänligen välj",
    loading: "Laddar",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Klar",
    now: "Nu",
    confirm: "Bekräfta",
    selectTime: "Välj tidpunkt",
    selectDate: "Välj datum",
    datePlaceholder: "Välj datum",
    datetimePlaceholder: "Välj datum och tid",
    monthPlaceholder: "Välj månad",
    yearPlaceholder: "Välj år",
    quarterPlaceholder: "Välj kvartal",
    startDatePlaceholder: "Startdatum",
    endDatePlaceholder: "Slutdatum",
    startDatetimePlaceholder: "Startdatum och tid",
    endDatetimePlaceholder: "Slutdatum och tidpunkt",
    startMonthPlaceholder: "Startmånad",
    endMonthPlaceholder: "Slutet av månaden",
    monthBeforeYear: !0,
    firstDayOfWeek: 6,
    today: "Idag"
  },
  DataTable: {
    checkTableAll: "Välj allt i tabellen",
    uncheckTableAll: "Avmarkera allt i tabellen",
    confirm: "Bekräfta",
    clear: "Klar",
    apply: "Ansök",
    filters: "Filter"
  },
  LegacyTransfer: {
    sourceTitle: "Källa",
    targetTitle: "Mål"
  },
  Transfer: {
    selectAll: "Markera alla",
    unselectAll: "Avmarkera alla",
    clearAll: "Tydlig"
  },
  Empty: {
    description: "Inget data"
  },
  Select: {
    placeholder: "Välj"
  },
  TimePicker: {
    placeholder: "Välj tid",
    positiveText: "OK",
    negativeText: "Avbryt",
    now: "Nu"
  },
  Pagination: {
    goto: "Gå till",
    selectionSuffix: "sida",
    next: "Nästa",
    previous: "Föregående"
  },
  DynamicTags: {
    add: "Lägg till"
  },
  Log: {
    loading: "Läser in"
  },
  Input: {
    placeholder: "Vänligen ange"
  },
  InputNumber: {
    placeholder: "Var vänlig ange"
  },
  DynamicInput: {
    create: "Skapa"
  },
  ThemeEditor: {
    title: "Teman Redigerare",
    clearAllVars: "Rensa alla variabler",
    clearSearch: "Rensa sökning",
    filterCompName: "Filterkomponentnamn",
    filterVarName: "Filter Variabelnamn",
    import: "Importera",
    export: "Export",
    restore: "Återställ till standardinställningar"
  },
  Image: {
    tipPrevious: "Föregående bild (←)",
    tipNext: "Nästa bild (→)",
    tipCounterclockwise: "Moturs",
    tipClockwise: "Medurs",
    tipZoomOut: "Zooma ut",
    tipZoomIn: "Zooma in",
    tipClose: "Stäng (Esc)",
    tipOriginalSize: "Zooma till originalstorlek"
  }
}, S$e = {
  name: "common",
  common: {
    name: "common",
    fontFamily: 'Inter var, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji""',
    fontFamilyMono: "v-mono, SFMono-Regular, Menlo, Consolas, Courier, monospace",
    fontWeight: "400",
    fontWeightStrong: "500",
    cubicBezierEaseInOut: "cubic-bezier(.4, 0, .2, 1)",
    cubicBezierEaseOut: "cubic-bezier(0, 0, .2, 1)",
    cubicBezierEaseIn: "cubic-bezier(.4, 0, 1, 1)",
    borderRadius: "3px",
    borderRadiusSmall: "2px",
    fontSize: "14px",
    fontSizeMini: "12px",
    fontSizeTiny: "12px",
    fontSizeSmall: "14px",
    fontSizeMedium: "14px",
    fontSizeLarge: "15px",
    fontSizeHuge: "16px",
    lineHeight: "1.6",
    heightMini: "16px",
    heightTiny: "22px",
    heightSmall: "28px",
    heightMedium: "34px",
    heightLarge: "40px",
    heightHuge: "46px",
    baseColor: "#FFF",
    primaryColor: "#155EEF",
    primaryColorHover: "#004EEB",
    primaryColorPressed: "#155EEF",
    primaryColorSuppl: "#155EEF",
    infoColor: "#2080f0",
    infoColorHover: "#4098fc",
    infoColorPressed: "#1060c9",
    infoColorSuppl: "#4098fc",
    successColor: "#155EEF",
    successColorHover: "#155EEF",
    successColorPressed: "#004EEB",
    successColorSuppl: "#155EEF",
    warningColor: "#f0a020",
    warningColorHover: "#fcb040",
    warningColorPressed: "#c97c10",
    warningColorSuppl: "#fcb040",
    errorColor: "#D92D20",
    errorColorHover: "#B42318",
    errorColorPressed: "#D92D20",
    errorColorSuppl: "#D92D20",
    textColorBase: "#000",
    textColor1: "rgba(16, 24, 40, 1)",
    textColor2: "rgba(52, 64, 84, 1)",
    textColor3: "rgb(118, 124, 130)",
    textColorDisabled: "rgba(194, 194, 194, 1)",
    placeholderColor: "rgba(102, 112, 133, 1)",
    placeholderColorDisabled: "rgba(209, 209, 209, 1)",
    iconColor: "rgba(194, 194, 194, 1)",
    iconColorHover: "rgba(146, 146, 146, 1)",
    iconColorPressed: "rgba(175, 175, 175, 1)",
    iconColorDisabled: "rgba(209, 209, 209, 1)",
    opacity1: "0.82",
    opacity2: "0.72",
    opacity3: "0.38",
    opacity4: "0.24",
    opacity5: "0.18",
    dividerColor: "rgb(239, 239, 245)",
    borderColor: "rgb(224, 224, 230)",
    closeIconColor: "rgba(102, 102, 102, 1)",
    closeIconColorHover: "rgba(102, 102, 102, 1)",
    closeIconColorPressed: "rgba(102, 102, 102, 1)",
    closeColorHover: "rgba(0, 0, 0, .09)",
    closeColorPressed: "rgba(0, 0, 0, .13)",
    clearColor: "rgba(194, 194, 194, 1)",
    clearColorHover: "rgba(146, 146, 146, 1)",
    clearColorPressed: "rgba(175, 175, 175, 1)",
    scrollbarColor: "rgba(0, 0, 0, 0.25)",
    scrollbarColorHover: "rgba(0, 0, 0, 0.4)",
    scrollbarWidth: "5px",
    scrollbarHeight: "5px",
    scrollbarBorderRadius: "5px",
    progressRailColor: "rgba(235, 235, 235, 1)",
    railColor: "rgb(219, 219, 223)",
    popoverColor: "#fff",
    tableColor: "#fff",
    cardColor: "#fff",
    modalColor: "#fff",
    bodyColor: "#fff",
    tagColor: "#eee",
    avatarColor: "rgba(204, 204, 204, 1)",
    invertedColor: "rgb(0, 20, 40)",
    inputColor: "rgba(255, 255, 255, 1)",
    codeColor: "rgb(244, 244, 248)",
    tabColor: "rgb(247, 247, 250)",
    actionColor: "rgb(250, 250, 252)",
    tableHeaderColor: "rgb(250, 250, 252)",
    hoverColor: "rgb(243, 243, 245)",
    tableColorHover: "rgba(0, 0, 100, 0.03)",
    tableColorStriped: "rgba(0, 0, 100, 0.02)",
    pressedColor: "rgb(237, 237, 239)",
    opacityDisabled: "0.5",
    inputColorDisabled: "rgb(250, 250, 252)",
    buttonColor2: "rgba(46, 51, 56, .05)",
    buttonColor2Hover: "rgba(46, 51, 56, .09)",
    buttonColor2Pressed: "rgba(46, 51, 56, .13)",
    boxShadow1: "0 1px 2px -2px rgba(0, 0, 0, .08), 0 3px 6px 0 rgba(0, 0, 0, .06), 0 5px 12px 4px rgba(0, 0, 0, .04)",
    boxShadow2: "0 3px 6px -4px rgba(0, 0, 0, .12), 0 6px 16px 0 rgba(0, 0, 0, .08), 0 9px 28px 8px rgba(0, 0, 0, .05)",
    boxShadow3: "0 6px 16px -9px rgba(0, 0, 0, .08), 0 9px 28px 0 rgba(0, 0, 0, .05), 0 12px 48px 16px rgba(0, 0, 0, .03)"
  }
}, T$e = {
  Notification: {
    common: {
      successColor: "#039855",
      infoColor: "#155EEF",
      warningColor: "#DC6803",
      errorColor: "#D92D20"
    }
  },
  Badge: {
    common: {
      successColor: "var(--success-600)",
      infoColor: "var(--primary-600)"
    }
  }
}, k$e = {
  name: "UIContentWrap",
  inheritAttrs: !0
}, V2 = oe(Qt(vt({}, k$e), {
  props: {
    fullScreen: {
      type: Boolean,
      default: !1
    },
    locale: {
      type: String,
      default: $r.englishUS
    }
  },
  setup(e) {
    const t = e, r = G(J5), n = G(X5), i = () => {
      switch (function() {
        return t.locale.includes("_") ? (console.warn(`Deprecated used of '_' in the language '${t.locale}', please change to use hyphen '-'.`), t.locale.replace("_", "-")) : t.locale;
      }()) {
        case $r.englishUS:
        default: {
          r.value = J5, n.value = X5;
          break;
        }
        case $r.danish: {
          r.value = Q2e, n.value = Y2e;
          break;
        }
        case $r.dutch: {
          r.value = G2e, n.value = q2e;
          break;
        }
        case $r.finnish: {
          r.value = $Ne, n.value = zNe;
          break;
        }
        case $r.frenchCanada: {
          r.value = UNe, n.value = BNe;
          break;
        }
        case $r.frenchFrance: {
          r.value = WNe, n.value = HNe;
          break;
        }
        case $r.german: {
          r.value = YNe, n.value = VNe;
          break;
        }
        case $r.italian: {
          r.value = qNe, n.value = QNe;
          break;
        }
        case $r.norwegian: {
          r.value = ZNe, n.value = GNe;
          break;
        }
        case $r.portuguesePortugal: {
          r.value = Lze, n.value = _ze;
          break;
        }
        case $r.portugueseBrazil: {
          r.value = XNe, n.value = KNe;
          break;
        }
        case $r.spanish: {
          r.value = Rze, n.value = Pze;
          break;
        }
        case $r.swedish: {
          r.value = C$e, n.value = M$e;
          break;
        }
      }
    };
    return br(() => {
      i();
    }), fi(() => {
      i();
    }), tr("customLocale", r), (o, a) => (ie(), Ve("div", {
      class: Jr(["font-sans hl-wrapper-container", { "full-screen": e.fullScreen }])
    }, [
      Re(B(wme), {
        theme: B(S$e),
        "theme-overrides": B(T$e),
        locale: r.value,
        "date-locale": n.value
      }, {
        default: we(() => [
          Re(B(bxe), null, {
            default: we(() => [
              nt(o.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["theme", "theme-overrides", "locale", "date-locale"])
    ], 2));
  }
}));
V2.install = (e) => {
  e.component(V2.name, V2);
};
const D$e = {
  name: "UIDatepicker"
}, Y2 = /* @__PURE__ */ oe(Qt(vt({}, D$e), {
  props: {
    type: {
      type: String,
      default: "date"
    },
    clearable: {
      type: Boolean,
      default: !1
    },
    panel: {
      type: Boolean,
      default: !1
    },
    isDateDisabled: {
      type: Function
    },
    isTimeDisabled: {
      type: Function
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      required: !0
    },
    shortcuts: {
      type: Object,
      default: void 0
    },
    value: {
      type: Number
    },
    defaultValue: {
      type: Number
    }
  },
  setup(e) {
    return (t, r) => (ie(), Pe(B(dbe), ir({ id: e.id }, t.$attrs, {
      disabled: e.disabled,
      "is-date-disabled": e.isDateDisabled,
      "is-time-disabled": e.isTimeDisabled,
      panel: e.panel,
      value: e.value,
      "default-value": e.defaultValue,
      "onUpdate:value": r[0] || (r[0] = (n) => t.$emit("update:value", n)),
      clearable: e.clearable,
      type: e.type,
      size: "large",
      shortcuts: e.shortcuts
    }), {
      default: we(() => [
        nt(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "disabled", "is-date-disabled", "is-time-disabled", "panel", "value", "default-value", "clearable", "type", "shortcuts"]));
  }
}));
Y2.install = (e) => {
  e.component(Y2.name, Y2);
};
const A$e = {
  name: "UIDynamicTags",
  inheritAttrs: !1,
  components: { NDynamicTags: MW }
}, Q2 = /* @__PURE__ */ oe(Qt(vt({}, A$e), {
  props: {
    id: {
      required: !0,
      type: String
    },
    defaultValue: {
      type: Array,
      default: null
    },
    type: {
      type: String,
      default: "default"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    max: {
      type: Number,
      default: 10
    },
    closable: {
      type: Boolean,
      default: !0
    },
    round: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["onUpdate"],
  setup(e, { emit: t }) {
    var r;
    const i = G((r = e.defaultValue) != null ? r : []), o = (a) => {
      i.value = Tc.exports.uniqWith(a, (s, u) => s.trim() === u.trim()), t("onUpdate", i.value);
    };
    return (a, s) => (ie(), Pe(B(MW), ir({
      value: i.value,
      type: e.type,
      disabled: e.disabled,
      max: e.max,
      closable: e.closable,
      round: e.round,
      class: [`hl-${e.type}`]
    }, a.$attrs, { "onUpdate:value": o }), null, 16, ["value", "type", "disabled", "max", "closable", "round", "class"]));
  }
}));
Q2.install = (e) => {
  e.component(Q2.name, Q2);
};
const E$e = { class: "hl-empty" }, I$e = {
  key: 1,
  class: "hl-empty-icon-container"
}, N$e = { class: "hl-empty-icon" }, z$e = {
  key: 2,
  class: "hl-empty-title"
}, $$e = {
  key: 3,
  class: "hl-empty-description"
}, O$e = { class: "hl-empty-actions" }, _$e = {
  name: "UIEmpty",
  inheritAttrs: !1
}, q2 = /* @__PURE__ */ oe(Qt(vt({}, _$e), {
  props: {
    id: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    positiveText: {
      type: String,
      default: ""
    },
    icon: {
      type: Function,
      default: GW
    },
    negativeText: {
      type: String,
      default: ""
    },
    positiveIcon: {
      type: Function,
      default: () => ""
    }
  },
  setup(e) {
    const t = pn();
    return (r, n) => (ie(), Ve("div", E$e, [
      Ye("div", null, [
        B(t).media ? nt(r.$slots, "media", { key: 0 }) : (ie(), Ve("div", I$e, [
          Ye("div", N$e, [
            (ie(), Pe(mi(e.icon), { class: "w-5 h-6" }))
          ])
        ])),
        e.title ? (ie(), Ve("div", z$e, ar(e.title), 1)) : yt("", !0),
        e.description ? (ie(), Ve("div", $$e, ar(e.description), 1)) : yt("", !0)
      ]),
      Ye("div", O$e, [
        e.negativeText ? (ie(), Pe(B(on), {
          key: 0,
          id: `${e.id}-btn-negative-action`,
          onClick: n[0] || (n[0] = (i) => r.$emit("negativeClick"))
        }, {
          default: we(() => [
            zr(ar(e.negativeText), 1)
          ]),
          _: 1
        }, 8, ["id"])) : yt("", !0),
        e.positiveText ? (ie(), Pe(B(on), {
          key: 1,
          id: `${e.id}-btn-positive-action`,
          type: "primary",
          onClick: n[1] || (n[1] = (i) => r.$emit("positiveClick"))
        }, {
          default: we(() => [
            e.positiveIcon ? (ie(), Pe(mi(e.positiveIcon), {
              key: 0,
              class: "w-5 h-6"
            })) : yt("", !0),
            zr(" " + ar(e.positiveText), 1)
          ]),
          _: 1
        }, 8, ["id"])) : yt("", !0)
      ])
    ]));
  }
}));
q2.install = (e) => {
  e.component(q2.name, q2);
};
const L$e = { class: "hl-header" }, P$e = {
  key: 0,
  class: "back"
}, R$e = {
  key: 1,
  class: "header"
}, j$e = { class: "hl-header-content" }, F$e = { class: "hl-title-container" }, B$e = { class: "flex" }, U$e = { class: "space-x-2 flex" }, H$e = { key: 3 }, W$e = {
  key: 2,
  class: "footer"
}, V$e = {
  name: "UIHeader",
  inheritAttrs: !1
}, G2 = /* @__PURE__ */ oe(Qt(vt({}, V$e), {
  props: {
    title: {
      type: String,
      default: ""
    },
    secondaryTitle: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    primaryText: {
      type: String,
      default: void 0
    },
    secondaryText: {
      type: String,
      default: void 0
    },
    primaryActionIcon: {
      type: Function
    },
    secondaryActionIcon: {
      type: Function
    },
    primaryOptions: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = pn();
    return (r, n) => (ie(), Ve("div", L$e, [
      B(t).back ? (ie(), Ve("div", P$e, [
        nt(r.$slots, "back")
      ])) : yt("", !0),
      B(t).header ? (ie(), Ve("div", R$e, [
        nt(r.$slots, "header")
      ])) : yt("", !0),
      Ye("div", j$e, [
        Ye("div", F$e, [
          e.title ? (ie(), Pe(B(e1), {
            key: 0,
            class: "title"
          }, {
            default: we(() => [
              zr(ar(e.title), 1)
            ]),
            _: 1
          })) : yt("", !0),
          e.secondaryTitle ? (ie(), Pe(B(a$), { key: 1 }, {
            default: we(() => [
              zr(ar(e.secondaryTitle), 1)
            ]),
            _: 1
          })) : yt("", !0),
          e.description ? (ie(), Pe(mi(e.secondaryTitle ? B(l$) : B(s$)), {
            key: 2,
            class: "description max-w-3xl"
          }, {
            default: we(() => [
              zr(ar(e.description), 1)
            ]),
            _: 1
          })) : yt("", !0)
        ]),
        Ye("div", B$e, [
          Ye("div", U$e, [
            e.secondaryText ? (ie(), Pe(B(on), {
              key: 0,
              onClick: n[0] || (n[0] = (i) => r.$emit("secondaryClick")),
              id: `${e.id}-btn-secondary`
            }, {
              default: we(() => [
                (ie(), Pe(mi(e.secondaryActionIcon), { class: "w-5 h-4 mr-1" })),
                zr(" " + ar(e.secondaryText), 1)
              ]),
              _: 1
            }, 8, ["id"])) : yt("", !0),
            e.primaryText && !e.primaryOptions.length ? (ie(), Pe(B(on), {
              key: 1,
              onClick: n[1] || (n[1] = (i) => r.$emit("primaryClick")),
              type: "primary",
              id: `${e.id}-btn-primary`
            }, {
              default: we(() => [
                (ie(), Pe(mi(e.primaryActionIcon), { class: "w-5 h-4 mr-1" })),
                zr(" " + ar(e.primaryText), 1)
              ]),
              _: 1
            }, 8, ["id"])) : yt("", !0),
            e.primaryOptions && e.primaryOptions.length ? (ie(), Pe(B(gc), {
              key: 2,
              options: e.primaryOptions,
              onSelect: n[2] || (n[2] = (i) => r.$emit("primaryClick", i)),
              id: `${e.id}-dropdown-primary`
            }, {
              default: we(() => [
                Re(B(on), {
                  type: "primary",
                  id: `${e.id}-dropdown-btn-primary`
                }, {
                  default: we(() => [
                    (ie(), Pe(mi(e.primaryActionIcon), { class: "w-5 h-4 mr-1" })),
                    zr(" " + ar(e.primaryText), 1)
                  ]),
                  _: 1
                }, 8, ["id"])
              ]),
              _: 1
            }, 8, ["options", "id"])) : yt("", !0),
            B(t).extra ? (ie(), Ve("div", H$e, [
              nt(r.$slots, "extra")
            ])) : yt("", !0)
          ])
        ])
      ]),
      B(t).footer ? (ie(), Ve("div", W$e, [
        nt(r.$slots, "footer")
      ])) : yt("", !0)
    ]));
  }
}));
G2.install = (e) => {
  e.component(G2.name, G2);
};
const Y$e = {
  name: "UIInput"
}, Vf = /* @__PURE__ */ oe(Qt(vt({}, Y$e), {
  props: {
    modelValue: {
      type: Number
    },
    placeholder: String,
    readonly: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    clearable: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    precision: {
      type: Number,
      default: void 0
    },
    size: {
      type: String,
      default: "medium"
    },
    buttonPlacement: {
      type: String,
      default: void 0
    },
    showButton: {
      type: Boolean,
      default: void 0
    },
    max: {
      type: Number,
      default: void 0
    },
    min: {
      type: Number,
      default: void 0
    },
    id: {
      type: String,
      required: !0
    }
  },
  emits: ["update:modelValue", "blur", "focus"],
  setup(e, { emit: t }) {
    function r(n) {
      t("update:modelValue", n);
    }
    return (n, i) => (ie(), Pe(B(Z1e), ir({
      id: e.id,
      max: e.max,
      min: e.min,
      "button-placement": e.buttonPlacement,
      "show-button": e.showButton,
      precision: e.precision,
      disabled: e.disabled,
      size: e.size,
      readonly: e.readonly,
      value: e.modelValue,
      "onUpdate:value": r,
      placeholder: e.placeholder,
      clearable: e.clearable,
      loading: e.loading
    }, n.$attrs, {
      class: [e.loading ? "" : "hide-loader", "hl-input-number font-sans"],
      onFocus: i[0] || (i[0] = (o) => n.$emit("focus", o)),
      onBlur: i[1] || (i[1] = (o) => n.$emit("blur", o))
    }), {
      prefix: we(() => [
        nt(n.$slots, "prefix")
      ]),
      suffix: we(() => [
        nt(n.$slots, "suffix")
      ]),
      _: 3
    }, 16, ["id", "max", "min", "button-placement", "show-button", "precision", "disabled", "size", "readonly", "value", "placeholder", "clearable", "loading", "class"]));
  }
}));
Vf.install = (e) => {
  e.component(Vf.name, Vf);
};
const Q$e = {
  name: "UIMenu",
  inheritAttrs: !1
}, Z2 = /* @__PURE__ */ oe(Qt(vt({}, Q$e), {
  props: {
    options: {
      type: Array
    },
    value: {
      type: Object
    }
  },
  emits: ["update:value"],
  setup(e) {
    return (t, r) => (ie(), Pe(B(sxe), ir({
      options: e.options,
      "onUpdate:value": r[0] || (r[0] = (n) => t.$emit("update:value", n)),
      value: e.value
    }, t.$attrs), null, 16, ["options", "value"]));
  }
}));
Z2.install = (e) => {
  e.component(Z2.name, Z2);
};
const q$e = {
  name: "UIPopover",
  inheritAttrs: !1
}, d1 = /* @__PURE__ */ oe(Qt(vt({}, q$e), {
  props: {
    trigger: {
      type: String,
      default: "hover"
    },
    delay: {
      type: Number
    },
    duration: {
      type: Number
    },
    placement: {
      type: String,
      default: "top"
    },
    show: {
      type: Boolean,
      default: void 0
    },
    showArrow: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    return (t, r) => (ie(), Pe(B(jc), ir(t.$attrs, {
      "show-arrow": e.showArrow,
      show: e.show,
      placement: e.placement,
      trigger: e.trigger,
      delay: e.delay,
      duration: e.duration
    }), {
      trigger: we(() => [
        nt(t.$slots, "trigger")
      ]),
      header: we(() => [
        nt(t.$slots, "header")
      ]),
      footer: we(() => [
        nt(t.$slots, "footer")
      ]),
      default: we(() => [
        nt(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["show-arrow", "show", "placement", "trigger", "delay", "duration"]));
  }
}));
d1.install = (e) => {
  e.component(d1.name, d1);
};
const G$e = {
  mobile: {
    device: {
      width: "280px",
      height: "564px"
    },
    page: {
      width: "248px",
      height: "473px"
    }
  }
}, Z$e = ["id"], K$e = ["src"], X$e = {
  key: 1,
  class: "ghl-ui-preview__page--html-code"
}, J$e = {
  name: "UIPreview",
  inheritAttrs: !1
}, eOe = oe(Qt(vt({}, J$e), {
  props: {
    id: {
      type: String,
      required: !0
    },
    href: {
      type: String,
      required: !1
    },
    deviceClasses: {
      type: String,
      default: "",
      required: !1
    },
    pageClasses: {
      type: String,
      default: "",
      required: !1
    }
  },
  setup(e) {
    const t = e, r = pn(), n = j(() => {
      const i = G$e.mobile;
      return {
        device: t.deviceClasses ? "" : i.device,
        page: t.pageClasses ? "" : i.page
      };
    });
    return (i, o) => (ie(), Ve("div", ir(i.$attrs, {
      class: "ghl-ui-preview",
      id: e.id
    }), [
      Ye("div", {
        class: Jr(["ghl-ui-preview__page", e.pageClasses]),
        style: Jf(B(n).page)
      }, [
        t.href ? (ie(), Ve("iframe", {
          key: 0,
          src: e.href,
          id: "iphone-preview",
          class: "ghl-ui-preview__page--iframe"
        }, null, 8, K$e)) : B(r).html ? (ie(), Ve("div", X$e, [
          nt(i.$slots, "html", {}, void 0, !0)
        ])) : yt("", !0)
      ], 6),
      Ye("div", {
        class: Jr(["ghl-ui-preview__device--mobile", e.deviceClasses]),
        style: Jf(B(n).device)
      }, null, 6)
    ], 16, Z$e));
  }
}));
var K2 = /* @__PURE__ */ To(eOe, [["__scopeId", "data-v-4f81e174"]]);
K2.install = (e) => {
  e.component(K2.name, K2);
};
const tOe = { key: 1 }, rOe = {
  class: "n-progress-text",
  role: "none"
}, nOe = { class: "n-progress-text__percentage" }, iOe = /* @__PURE__ */ Ye("span", { class: "n-progress-text__unit" }, "%", -1), oOe = {
  name: "UIProgress",
  inheritAttrs: !1
}, X2 = /* @__PURE__ */ oe(Qt(vt({}, oOe), {
  props: {
    percentage: {
      type: Number
    },
    type: {
      type: String,
      default: "line"
    },
    processing: {
      type: Boolean
    },
    indicatorPlacement: {
      type: String,
      default: "inside"
    },
    status: {
      type: String
    },
    showIndicator: {
      type: Boolean,
      default: void 0
    }
  },
  setup(e) {
    const t = pn();
    return (r, n) => (ie(), Pe(B(_W), ir({
      "indicator-placement": e.indicatorPlacement,
      percentage: e.percentage,
      processing: e.processing,
      "show-indicator": e.showIndicator,
      status: e.status,
      type: e.type,
      "gap-position": "bottom"
    }, r.$attrs), {
      default: we(() => [
        B(t).default ? nt(r.$slots, "default", { key: 0 }) : (ie(), Ve("div", tOe, [
          Ye("div", rOe, [
            Ye("span", nOe, ar(e.percentage), 1),
            iOe
          ])
        ]))
      ]),
      _: 3
    }, 16, ["indicator-placement", "percentage", "processing", "show-indicator", "status", "type"]));
  }
}));
X2.install = (e) => {
  e.component(X2.name, X2);
};
const aOe = { class: "hl-radio-group-item-container" }, lOe = {
  key: 0,
  class: "hl-radio-group-item-icon"
}, sOe = {
  key: 1,
  class: "hl-radio-group-item-content"
}, uOe = { class: "hl-radio-group-item-action" }, cOe = {
  name: "UIRadioButton",
  inheritAttrs: !1
}, J2 = /* @__PURE__ */ oe(Qt(vt({}, cOe), {
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    value: {
      type: [String, Number, Boolean]
    },
    compact: Boolean
  },
  setup(e) {
    const t = pn();
    return (r, n) => (ie(), Pe(B(uve), ir(r.$attrs, {
      value: e.value,
      disabled: e.disabled,
      class: ["hl-radio-group-item", e.compact ? "compact-radio-item" : null]
    }), {
      default: we(() => [
        Ye("div", aOe, [
          B(t).icon ? (ie(), Ve("div", lOe, [
            nt(r.$slots, "icon")
          ])) : yt("", !0),
          B(t).content ? (ie(), Ve("div", sOe, [
            nt(r.$slots, "content")
          ])) : yt("", !0),
          Ye("div", uOe, [
            Re(B(WM), { value: e.value }, null, 8, ["value"])
          ])
        ])
      ]),
      _: 3
    }, 16, ["value", "disabled", "class"]));
  }
}));
J2.install = (e) => {
  e.component(J2.name, J2);
};
const dOe = {
  name: "UISkeleton",
  inheritAttrs: !1
}, eN = /* @__PURE__ */ oe(Qt(vt({}, dOe), {
  props: {
    text: {
      type: Boolean,
      default: !0
    },
    repeat: {
      type: Number,
      default: 1
    },
    width: {
      type: [String, Number],
      default: void 0
    },
    height: {
      type: [String, Number],
      default: void 0
    },
    animated: {
      type: Boolean,
      default: !0
    },
    circle: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, r) => (ie(), Pe(B(Ixe), ir(t.$attrs, {
      text: e.text,
      repeat: e.repeat,
      width: e.width,
      height: e.height,
      animated: e.animated,
      circle: e.circle
    }), null, 16, ["text", "repeat", "width", "height", "animated", "circle"]));
  }
}));
eN.install = (e) => {
  e.component(eN.name, eN);
};
const fOe = {
  name: "UISlider",
  inheritAttrs: !1
}, tN = /* @__PURE__ */ oe(Qt(vt({}, fOe), {
  props: {
    value: {
      type: [Number, Array]
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
    marks: {
      type: Object,
      default: void 0
    },
    tooltip: {
      type: Boolean,
      default: !0
    },
    defaultValue: {
      type: Number,
      default: void 0
    },
    formatTooltip: {
      type: Function,
      default: void 0
    }
  },
  emits: ["update:value"],
  setup(e) {
    return (t, r) => (ie(), Pe(B(Oxe), {
      "default-value": e.defaultValue,
      "format-tooltip": e.formatTooltip,
      tooltip: e.tooltip,
      marks: e.marks,
      step: e.step,
      max: e.max,
      min: e.min,
      value: e.value,
      "onUpdate:value": r[0] || (r[0] = (n) => t.$emit("update:value", n))
    }, null, 8, ["default-value", "format-tooltip", "tooltip", "marks", "step", "max", "min", "value"]));
  }
}));
tN.install = (e) => {
  e.component(tN.name, tN);
};
const hOe = {
  name: "UISpace",
  inheritAttrs: !1
}, rN = /* @__PURE__ */ oe(Qt(vt({}, hOe), {
  props: {
    align: {
      type: String,
      default: void 0
    },
    inline: {
      type: Boolean,
      default: !1
    },
    wrapItem: {
      type: Boolean,
      default: !0
    },
    justify: {
      type: String,
      default: "start"
    },
    size: {
      type: String,
      default: "medium"
    },
    vertical: {
      type: Boolean,
      default: !1
    },
    wrap: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    return (t, r) => (ie(), Pe(B(wW), ir(t.$attrs, {
      align: e.align,
      inline: e.inline,
      "wrap-item": e.wrapItem,
      justify: e.justify,
      size: e.size,
      vertical: e.vertical,
      wrap: e.wrap
    }), {
      default: we(() => [
        nt(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["align", "inline", "wrap-item", "justify", "size", "vertical", "wrap"]));
  }
}));
rN.install = (e) => {
  e.component(rN.name, rN);
};
const pOe = {
  name: "UISpin",
  inheritAttrs: !1
}, nN = /* @__PURE__ */ oe(Qt(vt({}, pOe), {
  props: {
    size: {
      type: [String, Number],
      default: "medium"
    },
    show: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    return (t, r) => (ie(), Pe(B(Rxe), ir(t.$attrs, {
      show: e.show,
      size: e.size
    }), null, 16, ["show", "size"]));
  }
}));
nN.install = (e) => {
  e.component(nN.name, nN);
};
const gOe = { class: "hl-statistic" }, mOe = { class: "hl-statistic-header" }, vOe = {
  key: 0,
  class: "hl-statistic-action"
}, bOe = { class: "hl-content" }, yOe = { class: "hl-container" }, xOe = {
  key: 0,
  class: "trend trend-container"
}, wOe = { key: 1 }, MOe = { key: 0 }, COe = { key: 0 }, SOe = {
  key: 0,
  class: "badge badge--positive"
}, TOe = { key: 1 }, kOe = {
  key: 0,
  class: "badge badge--negative"
}, DOe = { key: 1 }, AOe = {
  name: "UIStatistic",
  inheritAttrs: !1
}, iN = /* @__PURE__ */ oe(Qt(vt({}, AOe), {
  props: {
    id: {
      type: String,
      required: !0
    },
    icon: {
      type: Function
    },
    title: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "success"
    },
    trendTitle: {
      type: String,
      default: ""
    },
    showGraph: {
      type: Boolean,
      default: !1,
      required: !1
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  emits: ["select"],
  setup(e) {
    const t = pn();
    return (r, n) => {
      var i;
      return ie(), Ve("div", gOe, [
        Ye("div", mOe, [
          Ye("div", null, [
            (i = B(t)) != null && i.icon ? (ie(), Pe(B(VW), {
              key: 0,
              type: "success"
            }, {
              default: we(() => [
                nt(r.$slots, "icon")
              ]),
              _: 3
            })) : yt("", !0),
            Re(B(wp), { class: "title" }, {
              default: we(() => [
                zr(ar(e.title), 1)
              ]),
              _: 1
            })
          ]),
          e.options.length ? (ie(), Ve("div", vOe, [
            Re(B(gc), {
              options: e.options,
              onSelect: n[0] || (n[0] = (o) => r.$emit("select", o)),
              id: `${e.id}-dropdown`
            }, {
              default: we(() => [
                Re(B(on), {
                  circle: "",
                  quaternary: "",
                  id: `${e.id}-dropdown-trigger`
                }, {
                  default: we(() => [
                    Re(B(QW), { class: "w-5 h-5" })
                  ]),
                  _: 1
                }, 8, ["id"])
              ]),
              _: 1
            }, 8, ["options", "id"])
          ])) : yt("", !0)
        ]),
        Ye("div", bOe, [
          Ye("div", yOe, [
            Re(B(u$), null, {
              default: we(() => [
                nt(r.$slots, "default")
              ]),
              _: 3
            }),
            e.showGraph ? (ie(), Ve("div", xOe, [
              B(t).badge ? (ie(), Ve("div", {
                key: 0,
                class: Jr({
                  "trend trend--success": e.type === "success",
                  "trend trend--error": e.type === "error"
                })
              }, [
                nt(r.$slots, "badge")
              ], 2)) : yt("", !0),
              e.trendTitle ? (ie(), Ve("div", wOe, ar(e.trendTitle), 1)) : yt("", !0)
            ])) : yt("", !0)
          ]),
          e.showGraph ? yt("", !0) : (ie(), Ve("div", MOe, [
            e.type === "success" ? (ie(), Ve("div", COe, [
              B(t).badge ? (ie(), Ve("div", SOe, [
                nt(r.$slots, "badge")
              ])) : yt("", !0)
            ])) : yt("", !0),
            e.type === "error" ? (ie(), Ve("div", TOe, [
              B(t).badge ? (ie(), Ve("div", kOe, [
                nt(r.$slots, "badge")
              ])) : yt("", !0)
            ])) : yt("", !0)
          ])),
          e.showGraph && B(t).graph ? (ie(), Ve("div", DOe, [
            nt(r.$slots, "graph")
          ])) : yt("", !0)
        ])
      ]);
    };
  }
}));
iN.install = (e) => {
  e.component(iN.name, iN);
};
const EOe = {
  name: "UISwitch",
  inheritAttrs: !1
}, oN = /* @__PURE__ */ oe(Qt(vt({}, EOe), {
  props: {
    checkedValue: {
      type: [String, Number, Boolean],
      default: !0
    },
    defaultValue: {
      type: [String, Number, Boolean]
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    rubberBand: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String
    },
    uncheckedValue: {
      type: [String, Number, Boolean],
      default: !1
    },
    value: {
      type: [String, Number, Boolean]
    }
  },
  setup(e) {
    return (t, r) => (ie(), Pe(B(qxe), {
      "checked-value": e.checkedValue,
      "default-value": e.defaultValue,
      disabled: e.disabled,
      loading: e.loading,
      "rubber-band": e.rubberBand,
      size: e.size,
      "unchecked-value": e.uncheckedValue,
      value: e.value,
      "onUpdate:value": r[0] || (r[0] = (n) => t.$emit("update:value", n))
    }, null, 8, ["checked-value", "default-value", "disabled", "loading", "rubber-band", "size", "unchecked-value", "value"]));
  }
}));
oN.install = (e) => {
  e.component(oN.name, oN);
};
const IOe = {
  name: "UITimePicker",
  inheritAttrs: !1
}, aN = /* @__PURE__ */ oe(Qt(vt({}, IOe), {
  props: {
    defaultValue: {
      type: Number
    },
    defaultFormattedValue: {
      type: String
    },
    size: {
      type: String,
      default: "large"
    },
    isHourDisabled: {
      type: Function
    },
    isMinuteDisabled: {
      type: Function
    },
    isSecondDisabled: {
      type: Function
    },
    format: {
      type: String
    },
    value: {
      type: Number
    },
    status: {
      type: String
    },
    placeholder: {
      type: String
    },
    actions: {
      type: Array
    }
  },
  emits: ["confirm", "update:value"],
  setup(e) {
    return (t, r) => (ie(), Pe(B(dx), ir(t.$attrs, {
      actions: e.actions,
      placeholder: e.placeholder,
      status: e.status,
      value: e.value,
      "onUpdate:value": r[0] || (r[0] = (n) => t.$emit("update:value", n)),
      size: e.size,
      "default-value": e.defaultValue,
      "default-formatted-value": e.defaultFormattedValue,
      onConfirm: r[1] || (r[1] = (n) => t.$emit("confirm", n)),
      format: e.format,
      "is-hour-disabled": e.isHourDisabled,
      "is-minute-disabled": e.isMinuteDisabled,
      "is-second-disabled": e.isSecondDisabled
    }), {
      default: we(() => [
        nt(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["actions", "placeholder", "status", "value", "size", "default-value", "default-formatted-value", "format", "is-hour-disabled", "is-minute-disabled", "is-second-disabled"]));
  }
}));
aN.install = (e) => {
  e.component(aN.name, aN);
};
const NOe = {
  key: 0,
  class: "dropdown-tree__breadcrumb"
}, zOe = { class: "dropdown-tree__breadcrumb-content" }, $Oe = { class: "dropdown-tree__breadcrumb-title" }, OOe = /* @__PURE__ */ oe({
  __name: "BreadCrumb",
  props: {
    disabled: Boolean,
    title: String,
    show: Boolean,
    icon: Function,
    iconClass: String
  },
  emits: ["onClick"],
  setup(e, { emit: t }) {
    return (r, n) => e.show ? (ie(), Ve("div", NOe, [
      Re(B(on), {
        id: "dropdown-backward-traversal",
        text: "",
        onClick: n[0] || (n[0] = (i) => t("onClick")),
        disabled: e.disabled
      }, {
        default: we(() => [
          Ye("div", zOe, [
            Re(B(Rwe), { class: "w-5 h-5" }),
            Ye("span", $Oe, [
              (ie(), Pe(mi(e.icon), {
                class: Jr(e.iconClass)
              }, null, 8, ["class"])),
              Re(B(I0), {
                style: { "max-width": "250px" },
                tooltip: !1
              }, {
                default: we(() => [
                  zr(ar(e.title), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["disabled"])
    ])) : yt("", !0);
  }
});
var $Y = /* @__PURE__ */ To(OOe, [["__scopeId", "data-v-565aecec"]]);
const _Oe = ["onClick"], LOe = { class: "flex gap-1" }, POe = { class: "dropdown-tree__item--path" }, ROe = /* @__PURE__ */ zr(" " + /* @__PURE__ */ ar("/")), jOe = { class: "dropdown-tree__item--label" }, FOe = {
  key: 0,
  class: "dropdown-tree__item--icon"
}, BOe = /* @__PURE__ */ oe({
  __name: "DropdownItem",
  props: {
    options: {
      type: Array,
      default: () => []
    },
    showPath: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["onForwardTraverse", "onSelect"],
  setup(e, { emit: t }) {
    const r = (i) => {
      var o;
      !i.disabled && ((o = i.children) != null && o.length) ? t("onForwardTraverse", i) : t("onSelect", i.value);
    }, n = (i) => i ? i == null ? void 0 : i.split("/").filter(Boolean).at(-1) : null;
    return (i, o) => (ie(!0), Ve(Lr, null, Fl(e.options, (a) => {
      var s;
      return ie(), Ve("a", {
        key: a.value.toString(),
        class: Jr(["dropdown-tree__item", [a == null ? void 0 : a.className, a.disabled ? "disabled" : ""]]),
        onClick: () => r(a)
      }, [
        Ye("span", LOe, [
          e.showPath && a._pathFromRoot !== "/" ? (ie(), Pe(B(ys), {
            key: 0,
            disabled: !e.showPath && a._pathFromRoot
          }, {
            trigger: we(() => [
              Ye("span", POe, [
                Re(B(I0), {
                  class: "dropdown-tree__item--path-label",
                  tooltip: !1
                }, {
                  default: we(() => [
                    zr(ar(n(a._pathFromRoot)), 1)
                  ]),
                  _: 2
                }, 1024),
                ROe
              ])
            ]),
            default: we(() => [
              zr(" " + ar(a == null ? void 0 : a._pathFromRoot), 1)
            ]),
            _: 2
          }, 1032, ["disabled"])) : yt("", !0),
          Ye("span", jOe, [
            (ie(), Pe(mi(a.icon), {
              class: Jr(a.iconClass)
            }, null, 8, ["class"])),
            Re(B(I0), {
              class: Jr(e.showPath ? "showPath" : ""),
              tooltip: !1
            }, {
              default: we(() => [
                zr(ar(a.label), 1)
              ]),
              _: 2
            }, 1032, ["class"])
          ])
        ]),
        (s = a.children) != null && s.length ? (ie(), Ve("span", FOe, [
          a.customArrow ? (ie(), Pe(mi(a == null ? void 0 : a.customArrow), {
            key: 0,
            class: Jr(a == null ? void 0 : a.arrowClass)
          }, null, 8, ["class"])) : (ie(), Pe(B(Fwe), {
            key: 1,
            class: "chevron"
          }))
        ])) : yt("", !0)
      ], 10, _Oe);
    }), 128));
  }
});
var OY = /* @__PURE__ */ To(BOe, [["__scopeId", "data-v-66d95a24"]]);
const oj = ({
  path: e,
  options: t,
  pathSeparator: r = "/"
}) => {
  const n = e.split(r).filter(Boolean);
  let i = t;
  for (const o of n) {
    const a = i.find((s) => s.value === o);
    if (!a)
      return null;
    i = a.children || [];
  }
  return Tc.exports.uniqBy(i, "value");
}, Rh = (e, t) => {
  console.log(e, t);
}, aj = (e) => {
  const t = [], r = (n, i = "/") => {
    const o = n, { label: a, value: s, children: u } = o, d = kK(o, ["label", "value", "children"]), f = vt({ label: a, value: s, _pathFromRoot: i }, d);
    u ? (t.push(Qt(vt({}, f), { type: "parent" })), u.forEach((h) => r(h, `${i}${a}/`))) : t.push(f);
  };
  return e.forEach((n) => r(n)), Tc.exports.uniqBy(t, "value");
}, UOe = { class: "dropdown-tree__container" }, HOe = { class: "dropdown-tree__search" }, WOe = { key: 0 }, VOe = {
  key: 1,
  class: "no-data"
}, YOe = { key: 1 }, QOe = {
  key: 1,
  class: "empty-search"
}, qOe = {
  name: "UIDropdownTree",
  inheritAttrs: !1,
  components: { UIInput: xs, UIButton: on, BreadCrumb: $Y, DropdownItem: OY, NInput: pa }
}, n0 = /* @__PURE__ */ oe(Qt(vt({}, qOe), {
  props: {
    options: {
      type: Array,
      default: () => []
    },
    pathSeparator: {
      type: String,
      default: "/"
    },
    disabled: Boolean,
    triggerLabel: String,
    debug: Boolean,
    placement: String,
    loading: Boolean,
    remote: Boolean,
    searchPlaceholder: {
      type: String,
      required: !1,
      default: "Search"
    },
    trigger: {
      type: String,
      default: "click"
    }
  },
  emits: ["onSelect", "onSearch"],
  setup(e, { emit: t }) {
    const r = e, n = j(() => {
      const y = aj(r.options).filter((C) => C.type !== "parent");
      return r.debug && Rh("flattenedOptions", y), y;
    }), i = j(() => {
      const y = aj(r.options).filter((C) => C.type === "parent");
      return r.debug && Rh("flattenedParents", y), y;
    }), o = G(r.options);
    Gt(() => r.options, (y) => {
      o.value = y;
    });
    const a = G(""), s = G(r.pathSeparator), u = G(!1), d = G(null), f = pn(), h = G(!1), g = (y) => {
      var C, S;
      (C = a.value) != null && C.includes(y) || (a.value ? a.value += `${y}${s.value}` : a.value += `${y}${s.value}`, o.value = (S = oj({ options: r.options, path: a.value })) != null ? S : [], r.debug && Rh(`handleForwardTraversal(${y})`, `${JSON.stringify(o.value)}   ${a.value}`));
    }, m = (y) => {
      var C;
      const S = y.split(s.value).filter(Boolean), T = S.slice(0, S.length - 1).join(s.value);
      a.value = T ? `${T}${s.value}` : "", o.value = (C = oj({ options: r.options, path: T })) != null ? C : [], r.debug && Rh(`handleBackwardTraversal(${y})`, o.value);
    }, v = j(() => {
      const y = a.value.split(s.value).filter(Boolean).at(-1), C = i.value.find((S) => S.value === y);
      return r.debug && Rh(`[Computed] currentViewTitle for ${y} is`, C), C;
    }), w = (y) => {
      if (a.value = "", h.value = !0, r.remote)
        t("onSearch", y);
      else if (y) {
        const C = n.value.filter((S) => S.label.toLowerCase().includes(y.toLowerCase()));
        o.value = C;
      } else
        o.value = r.options, h.value = !1;
      r.debug && Rh(`handleSearch with remote ${r.remote} and search string is ${y}`, o.value);
    };
    Gt(() => d, Tc.exports.debounce((y) => {
      w(y.value);
    }, 300), { deep: !0 });
    const x = () => {
      setTimeout(() => {
        u.value = !1, o.value = r.options, d.value = null, a.value = "";
      }, 300);
    };
    return (y, C) => (ie(), Pe(B(jc), {
      raw: "",
      class: "dropdown-tree",
      disabled: e.disabled,
      "show-arrow": !1,
      trigger: e.trigger,
      onClickoutside: x,
      placement: e.placement
    }, {
      trigger: we(() => [
        B(f).trigger ? nt(y.$slots, "trigger", {
          key: 0,
          disabled: e.disabled
        }) : (ie(), Pe(B(on), {
          key: 1,
          id: "dropdown-tree__trigger",
          class: "dropdown-tree__trigger",
          disabled: e.disabled,
          loading: e.loading
        }, {
          default: we(() => [
            Ye("span", null, [
              zr(ar(e.triggerLabel) + " ", 1),
              (ie(), Pe(mi(B(YW)), { class: "chevron" }))
            ])
          ]),
          _: 1
        }, 8, ["disabled", "loading"]))
      ]),
      default: we(() => {
        var S, T, A;
        return [
          Ye("div", UOe, [
            Ye("div", HOe, [
              Re(B(pa), {
                id: "dropdown-tree-search",
                placeholder: e.searchPlaceholder,
                value: d.value,
                "onUpdate:value": C[0] || (C[0] = (D) => d.value = D),
                loading: e.loading,
                size: "small"
              }, {
                prefix: we(() => [
                  B(f).searchIcon ? nt(y.$slots, "searchIcon", { key: 0 }) : (ie(), Pe(B(Uwe), {
                    key: 1,
                    class: "icon"
                  }))
                ]),
                _: 3
              }, 8, ["placeholder", "value", "loading"])
            ]),
            Re($Y, {
              show: Boolean(a.value.length),
              title: (S = B(v)) == null ? void 0 : S.label,
              disabled: !a.value,
              onOnClick: C[1] || (C[1] = (D) => m(a.value)),
              icon: (T = B(v)) == null ? void 0 : T.icon,
              "icon-class": (A = B(v)) == null ? void 0 : A.iconClass
            }, null, 8, ["show", "title", "disabled", "icon", "icon-class"]),
            Re(OY, {
              showPath: h.value,
              options: o.value,
              onOnForwardTraverse: C[2] || (C[2] = (D) => g(D.value)),
              onOnSelect: C[3] || (C[3] = (D) => t("onSelect", D))
            }, null, 8, ["showPath", "options"]),
            !h.value && !e.options.length ? (ie(), Ve("div", WOe, [
              B(f).empty ? nt(y.$slots, "empty", { key: 0 }) : (ie(), Ve("p", VOe, "No data"))
            ])) : yt("", !0),
            h.value && !o.value.length ? (ie(), Ve("div", YOe, [
              B(f).emptySearch ? nt(y.$slots, "emptySearch", { key: 0 }) : (ie(), Ve("p", QOe, "No matching results found"))
            ])) : yt("", !0)
          ])
        ];
      }),
      _: 3
    }, 8, ["disabled", "trigger", "placement"]));
  }
}));
n0.install = (e) => {
  e.component(n0.name, n0);
};
const GOe = (e) => {
  if (e) {
    const { url: t, name: r } = e;
    if (!t)
      return;
    const n = document.createElement("a");
    return n.href = t, n.target = "_blank", r !== void 0 && (n.download = r), document.body.appendChild(n), n.click(), document.body.removeChild(n), !0;
  }
  return null;
}, ZOe = { style: { "margin-bottom": "12px" } }, KOe = { key: 0 }, XOe = {
  name: "UIUpload"
}, lN = /* @__PURE__ */ oe(Qt(vt({}, XOe), {
  props: {
    multiple: {
      type: Boolean,
      default: !1
    },
    fileList: {
      type: Array,
      default: () => []
    },
    max: Number,
    showDownloadButton: Boolean,
    accept: String,
    onDownload: Function
  },
  emits: ["change", "remove", "update:file-list", "download"],
  setup(e, { emit: t }) {
    const r = e, n = pn(), i = (o) => o ? r.onDownload ? (t("download", o), !1) : (GOe(o), !1) : null;
    return (o, a) => (ie(), Pe(B(wwe), ir(o.$attrs, {
      "list-type": "image",
      onChange: a[0] || (a[0] = (s) => o.$emit("change", s)),
      multiple: e.multiple,
      "file-list": e.fileList,
      max: e.max,
      accept: e.accept,
      "show-download-button": e.showDownloadButton,
      onRemove: a[1] || (a[1] = (s) => o.$emit("remove", s)),
      "onUpdate:fileList": a[2] || (a[2] = (s) => o.$emit("update:file-list", s)),
      onDownload: i
    }), {
      default: we(() => [
        Re(B(jW), null, {
          default: we(() => [
            Ye("div", ZOe, [
              Re(B(Hwe), { class: "w-8 h-8" })
            ]),
            B(n).extra ? (ie(), Ve("div", KOe, [
              nt(o.$slots, "extra")
            ])) : yt("", !0)
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 16, ["multiple", "file-list", "max", "accept", "show-download-button"]));
  }
}));
lN.install = (e) => {
  e.component(lN.name, lN);
};
const JOe = ["id", "disabled"], e4e = {
  name: "RTEControl",
  inheritAttrs: !1
}, t4e = /* @__PURE__ */ oe({
  ...e4e,
  props: {
    id: {
      type: String,
      required: !0
    },
    tooltipLabel: {
      type: String,
      required: !0
    },
    tooltipPosition: {
      type: String
    },
    active: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    callbackData: {
      type: Object,
      required: !1,
      default: null
    }
  },
  emits: ["onClick"],
  setup(e, { emit: t }) {
    return (r, n) => (ie(), Pe(B(ys), { placement: e.tooltipPosition }, {
      trigger: we(() => [
        Ye("button", {
          id: e.id,
          class: Jr(["toolbar_button", { "active ": e.active }]),
          disabled: e.disabled,
          onClick: n[0] || (n[0] = () => t("onClick", e.callbackData))
        }, [
          nt(r.$slots, "default", {}, void 0, !0)
        ], 10, JOe)
      ]),
      default: we(() => [
        Ye("span", null, ar(e.tooltipLabel), 1)
      ]),
      _: 3
    }, 8, ["placement"]));
  }
});
const Xl = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, i] of t)
    r[n] = i;
  return r;
}, Br = /* @__PURE__ */ Xl(t4e, [["__scopeId", "data-v-22b8b5ce"]]), r4e = {
  name: "RTEControlCode",
  inheritAttrs: !1
}, f1 = /* @__PURE__ */ oe({
  ...r4e,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    type: {
      type: String,
      default: "inline"
    },
    tooltipLabel: String,
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  setup(e) {
    const t = e, r = pn(), n = lt("locale") ?? Dn[t.language], i = G(!0), o = () => {
      const u = t.type === "block" ? "codeBlock" : "inlineCode";
      t.editor && (i.value = !ma(t.editor, u));
    };
    br(() => {
      o();
    }), fi(() => {
      o();
    });
    const a = j(() => t.type === "block" ? {
      id: Er.toolbarButtonCodeBlock,
      name: "codeBlock",
      icon: $Z
    } : {
      id: Er.toolbarButtonInlineCode,
      name: "inlineCode",
      icon: zZ
    }), s = () => {
      var u, d;
      return t.type === "block" ? (u = t == null ? void 0 : t.editor) == null ? void 0 : u.chain().focus().toggleCodeBlock().run() : (d = t == null ? void 0 : t.editor) == null ? void 0 : d.chain().focus().toggleInlineCode().run();
    };
    return (u, d) => {
      var f;
      return ie(), Pe(Br, {
        id: B(a).id,
        active: (f = e.editor) == null ? void 0 : f.isActive(B(a).name),
        disabled: i.value,
        onOnClick: s,
        "tooltip-label": e.tooltipLabel ?? B(n).common.code,
        "tooltip-position": e.tooltipPosition
      }, {
        default: we(() => [
          B(r).icon ? nt(u.$slots, "icon", { key: 0 }) : (ie(), Pe(mi(B(a).icon), {
            key: 1,
            class: "toolbar-button__icon"
          }))
        ]),
        _: 3
      }, 8, ["id", "active", "disabled", "tooltip-label", "tooltip-position"]);
    };
  }
});
f1.install = (e) => {
  e.component(f1.name, f1);
};
function _Y(e, t, r) {
  for (let n = 0; ; n++) {
    if (n == e.childCount || n == t.childCount)
      return e.childCount == t.childCount ? null : r;
    let i = e.child(n), o = t.child(n);
    if (i == o) {
      r += i.nodeSize;
      continue;
    }
    if (!i.sameMarkup(o))
      return r;
    if (i.isText && i.text != o.text) {
      for (let a = 0; i.text[a] == o.text[a]; a++)
        r++;
      return r;
    }
    if (i.content.size || o.content.size) {
      let a = _Y(i.content, o.content, r + 1);
      if (a != null)
        return a;
    }
    r += i.nodeSize;
  }
}
function LY(e, t, r, n) {
  for (let i = e.childCount, o = t.childCount; ; ) {
    if (i == 0 || o == 0)
      return i == o ? null : { a: r, b: n };
    let a = e.child(--i), s = t.child(--o), u = a.nodeSize;
    if (a == s) {
      r -= u, n -= u;
      continue;
    }
    if (!a.sameMarkup(s))
      return { a: r, b: n };
    if (a.isText && a.text != s.text) {
      let d = 0, f = Math.min(a.text.length, s.text.length);
      for (; d < f && a.text[a.text.length - d - 1] == s.text[s.text.length - d - 1]; )
        d++, r--, n--;
      return { a: r, b: n };
    }
    if (a.content.size || s.content.size) {
      let d = LY(a.content, s.content, r - 1, n - 1);
      if (d)
        return d;
    }
    r -= u, n -= u;
  }
}
class bt {
  /**
  @internal
  */
  constructor(t, r) {
    if (this.content = t, this.size = r || 0, r == null)
      for (let n = 0; n < t.length; n++)
        this.size += t[n].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(t, r, n, i = 0, o) {
    for (let a = 0, s = 0; s < r; a++) {
      let u = this.content[a], d = s + u.nodeSize;
      if (d > t && n(u, i + s, o || null, a) !== !1 && u.content.size) {
        let f = s + 1;
        u.nodesBetween(Math.max(0, t - f), Math.min(u.content.size, r - f), n, i + f);
      }
      s = d;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(t) {
    this.nodesBetween(0, this.size, t);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(t, r, n, i) {
    let o = "", a = !0;
    return this.nodesBetween(t, r, (s, u) => {
      s.isText ? (o += s.text.slice(Math.max(t, u) - u, r - u), a = !n) : s.isLeaf ? (i ? o += typeof i == "function" ? i(s) : i : s.type.spec.leafText && (o += s.type.spec.leafText(s)), a = !n) : !a && s.isBlock && (o += n, a = !0);
    }, 0), o;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(t) {
    if (!t.size)
      return this;
    if (!this.size)
      return t;
    let r = this.lastChild, n = t.firstChild, i = this.content.slice(), o = 0;
    for (r.isText && r.sameMarkup(n) && (i[i.length - 1] = r.withText(r.text + n.text), o = 1); o < t.content.length; o++)
      i.push(t.content[o]);
    return new bt(i, this.size + t.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(t, r = this.size) {
    if (t == 0 && r == this.size)
      return this;
    let n = [], i = 0;
    if (r > t)
      for (let o = 0, a = 0; a < r; o++) {
        let s = this.content[o], u = a + s.nodeSize;
        u > t && ((a < t || u > r) && (s.isText ? s = s.cut(Math.max(0, t - a), Math.min(s.text.length, r - a)) : s = s.cut(Math.max(0, t - a - 1), Math.min(s.content.size, r - a - 1))), n.push(s), i += s.nodeSize), a = u;
      }
    return new bt(n, i);
  }
  /**
  @internal
  */
  cutByIndex(t, r) {
    return t == r ? bt.empty : t == 0 && r == this.content.length ? this : new bt(this.content.slice(t, r));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(t, r) {
    let n = this.content[t];
    if (n == r)
      return this;
    let i = this.content.slice(), o = this.size + r.nodeSize - n.nodeSize;
    return i[t] = r, new bt(i, o);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(t) {
    return new bt([t].concat(this.content), this.size + t.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(t) {
    return new bt(this.content.concat(t), this.size + t.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(t) {
    if (this.content.length != t.content.length)
      return !1;
    for (let r = 0; r < this.content.length; r++)
      if (!this.content[r].eq(t.content[r]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(t) {
    let r = this.content[t];
    if (!r)
      throw new RangeError("Index " + t + " out of range for " + this);
    return r;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(t) {
    return this.content[t] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(t) {
    for (let r = 0, n = 0; r < this.content.length; r++) {
      let i = this.content[r];
      t(i, n, r), n += i.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(t, r = 0) {
    return _Y(this, t, r);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(t, r = this.size, n = t.size) {
    return LY(this, t, r, n);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. (Not public.)
  */
  findIndex(t, r = -1) {
    if (t == 0)
      return Dy(0, t);
    if (t == this.size)
      return Dy(this.content.length, t);
    if (t > this.size || t < 0)
      throw new RangeError(`Position ${t} outside of fragment (${this})`);
    for (let n = 0, i = 0; ; n++) {
      let o = this.child(n), a = i + o.nodeSize;
      if (a >= t)
        return a == t || r > 0 ? Dy(n + 1, a) : Dy(n, i);
      i = a;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((t) => t.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(t, r) {
    if (!r)
      return bt.empty;
    if (!Array.isArray(r))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new bt(r.map(t.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(t) {
    if (!t.length)
      return bt.empty;
    let r, n = 0;
    for (let i = 0; i < t.length; i++) {
      let o = t[i];
      n += o.nodeSize, i && o.isText && t[i - 1].sameMarkup(o) ? (r || (r = t.slice(0, i)), r[r.length - 1] = o.withText(r[r.length - 1].text + o.text)) : r && r.push(o);
    }
    return new bt(r || t, n);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(t) {
    if (!t)
      return bt.empty;
    if (t instanceof bt)
      return t;
    if (Array.isArray(t))
      return this.fromArray(t);
    if (t.attrs)
      return new bt([t], t.nodeSize);
    throw new RangeError("Can not convert " + t + " to a Fragment" + (t.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
bt.empty = new bt([], 0);
const sN = { index: 0, offset: 0 };
function Dy(e, t) {
  return sN.index = e, sN.offset = t, sN;
}
function E$(e, t) {
  if (e === t)
    return !0;
  if (!(e && typeof e == "object") || !(t && typeof t == "object"))
    return !1;
  let r = Array.isArray(e);
  if (Array.isArray(t) != r)
    return !1;
  if (r) {
    if (e.length != t.length)
      return !1;
    for (let n = 0; n < e.length; n++)
      if (!E$(e[n], t[n]))
        return !1;
  } else {
    for (let n in e)
      if (!(n in t) || !E$(e[n], t[n]))
        return !1;
    for (let n in t)
      if (!(n in e))
        return !1;
  }
  return !0;
}
let za = class I$ {
  /**
  @internal
  */
  constructor(t, r) {
    this.type = t, this.attrs = r;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(t) {
    let r, n = !1;
    for (let i = 0; i < t.length; i++) {
      let o = t[i];
      if (this.eq(o))
        return t;
      if (this.type.excludes(o.type))
        r || (r = t.slice(0, i));
      else {
        if (o.type.excludes(this.type))
          return t;
        !n && o.type.rank > this.type.rank && (r || (r = t.slice(0, i)), r.push(this), n = !0), r && r.push(o);
      }
    }
    return r || (r = t.slice()), n || r.push(this), r;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(t) {
    for (let r = 0; r < t.length; r++)
      if (this.eq(t[r]))
        return t.slice(0, r).concat(t.slice(r + 1));
    return t;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(t) {
    for (let r = 0; r < t.length; r++)
      if (this.eq(t[r]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(t) {
    return this == t || this.type == t.type && E$(this.attrs, t.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let t = { type: this.type.name };
    for (let r in this.attrs) {
      t.attrs = this.attrs;
      break;
    }
    return t;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(t, r) {
    if (!r)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let n = t.marks[r.type];
    if (!n)
      throw new RangeError(`There is no mark type ${r.type} in this schema`);
    return n.create(r.attrs);
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(t, r) {
    if (t == r)
      return !0;
    if (t.length != r.length)
      return !1;
    for (let n = 0; n < t.length; n++)
      if (!t[n].eq(r[n]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(t) {
    if (!t || Array.isArray(t) && t.length == 0)
      return I$.none;
    if (t instanceof I$)
      return [t];
    let r = t.slice();
    return r.sort((n, i) => n.type.rank - i.type.rank), r;
  }
};
za.none = [];
class n4e extends Error {
}
class Ot {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(t, r, n) {
    this.content = t, this.openStart = r, this.openEnd = n;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(t, r) {
    let n = RY(this.content, t + this.openStart, r);
    return n && new Ot(n, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(t, r) {
    return new Ot(PY(this.content, t + this.openStart, r + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(t) {
    return this.content.eq(t.content) && this.openStart == t.openStart && this.openEnd == t.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let t = { content: this.content.toJSON() };
    return this.openStart > 0 && (t.openStart = this.openStart), this.openEnd > 0 && (t.openEnd = this.openEnd), t;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(t, r) {
    if (!r)
      return Ot.empty;
    let n = r.openStart || 0, i = r.openEnd || 0;
    if (typeof n != "number" || typeof i != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new Ot(bt.fromJSON(t, r.content), n, i);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(t, r = !0) {
    let n = 0, i = 0;
    for (let o = t.firstChild; o && !o.isLeaf && (r || !o.type.spec.isolating); o = o.firstChild)
      n++;
    for (let o = t.lastChild; o && !o.isLeaf && (r || !o.type.spec.isolating); o = o.lastChild)
      i++;
    return new Ot(t, n, i);
  }
}
Ot.empty = new Ot(bt.empty, 0, 0);
function PY(e, t, r) {
  let { index: n, offset: i } = e.findIndex(t), o = e.maybeChild(n), { index: a, offset: s } = e.findIndex(r);
  if (i == t || o.isText) {
    if (s != r && !e.child(a).isText)
      throw new RangeError("Removing non-flat range");
    return e.cut(0, t).append(e.cut(r));
  }
  if (n != a)
    throw new RangeError("Removing non-flat range");
  return e.replaceChild(n, o.copy(PY(o.content, t - i - 1, r - i - 1)));
}
function RY(e, t, r, n) {
  let { index: i, offset: o } = e.findIndex(t), a = e.maybeChild(i);
  if (o == t || a.isText)
    return n && !n.canReplace(i, i, r) ? null : e.cut(0, t).append(r).append(e.cut(t));
  let s = RY(a.content, t - o - 1, r);
  return s && e.replaceChild(i, a.copy(s));
}
class N$ {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(t, r, n) {
    this.$from = t, this.$to = r, this.depth = n;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
function i4e(e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let r in e) {
    let n = e[r];
    if (!n.hasDefault)
      return null;
    t[r] = n.default;
  }
  return t;
}
function o4e(e, t) {
  let r = /* @__PURE__ */ Object.create(null);
  for (let n in e) {
    let i = t && t[n];
    if (i === void 0) {
      let o = e[n];
      if (o.hasDefault)
        i = o.default;
      else
        throw new RangeError("No value supplied for attribute " + n);
    }
    r[n] = i;
  }
  return r;
}
function a4e(e) {
  let t = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let r in e)
      t[r] = new l4e(e[r]);
  return t;
}
class l4e {
  constructor(t) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(t, "default"), this.default = t.default;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class b_ {
  /**
  @internal
  */
  constructor(t, r, n, i) {
    this.name = t, this.rank = r, this.schema = n, this.spec = i, this.attrs = a4e(i.attrs), this.excluded = null;
    let o = i4e(this.attrs);
    this.instance = o ? new za(this, o) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(t = null) {
    return !t && this.instance ? this.instance : new za(this, o4e(this.attrs, t));
  }
  /**
  @internal
  */
  static compile(t, r) {
    let n = /* @__PURE__ */ Object.create(null), i = 0;
    return t.forEach((o, a) => n[o] = new b_(o, i++, r, a)), n;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(t) {
    for (var r = 0; r < t.length; r++)
      t[r].type == this && (t = t.slice(0, r).concat(t.slice(r + 1)), r--);
    return t;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(t) {
    for (let r = 0; r < t.length; r++)
      if (t[r].type == this)
        return t[r];
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(t) {
    return this.excluded.indexOf(t) > -1;
  }
}
class Tp {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(t, r) {
    this.schema = t, this.rules = r, this.tags = [], this.styles = [], r.forEach((n) => {
      n.tag ? this.tags.push(n) : n.style && this.styles.push(n);
    }), this.normalizeLists = !this.tags.some((n) => {
      if (!/^(ul|ol)\b/.test(n.tag) || !n.node)
        return !1;
      let i = t.nodes[n.node];
      return i.contentMatch.matchType(i);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(t, r = {}) {
    let n = new sj(this, r, !1);
    return n.addAll(t, r.from, r.to), n.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(t, r = {}) {
    let n = new sj(this, r, !0);
    return n.addAll(t, r.from, r.to), Ot.maxOpen(n.finish());
  }
  /**
  @internal
  */
  matchTag(t, r, n) {
    for (let i = n ? this.tags.indexOf(n) + 1 : 0; i < this.tags.length; i++) {
      let o = this.tags[i];
      if (c4e(t, o.tag) && (o.namespace === void 0 || t.namespaceURI == o.namespace) && (!o.context || r.matchesContext(o.context))) {
        if (o.getAttrs) {
          let a = o.getAttrs(t);
          if (a === !1)
            continue;
          o.attrs = a || void 0;
        }
        return o;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(t, r, n, i) {
    for (let o = i ? this.styles.indexOf(i) + 1 : 0; o < this.styles.length; o++) {
      let a = this.styles[o], s = a.style;
      if (!(s.indexOf(t) != 0 || a.context && !n.matchesContext(a.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      s.length > t.length && (s.charCodeAt(t.length) != 61 || s.slice(t.length + 1) != r))) {
        if (a.getAttrs) {
          let u = a.getAttrs(r);
          if (u === !1)
            continue;
          a.attrs = u || void 0;
        }
        return a;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(t) {
    let r = [];
    function n(i) {
      let o = i.priority == null ? 50 : i.priority, a = 0;
      for (; a < r.length; a++) {
        let s = r[a];
        if ((s.priority == null ? 50 : s.priority) < o)
          break;
      }
      r.splice(a, 0, i);
    }
    for (let i in t.marks) {
      let o = t.marks[i].spec.parseDOM;
      o && o.forEach((a) => {
        n(a = uj(a)), a.mark || a.ignore || a.clearMark || (a.mark = i);
      });
    }
    for (let i in t.nodes) {
      let o = t.nodes[i].spec.parseDOM;
      o && o.forEach((a) => {
        n(a = uj(a)), a.node || a.ignore || a.mark || (a.node = i);
      });
    }
    return r;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
  */
  static fromSchema(t) {
    return t.cached.domParser || (t.cached.domParser = new Tp(t, Tp.schemaRules(t)));
  }
}
const jY = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, s4e = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, FY = { ol: !0, ul: !0 }, Tx = 1, kx = 2, i0 = 4;
function lj(e, t, r) {
  return t != null ? (t ? Tx : 0) | (t === "full" ? kx : 0) : e && e.whitespace == "pre" ? Tx | kx : r & ~i0;
}
class Ay {
  constructor(t, r, n, i, o, a, s) {
    this.type = t, this.attrs = r, this.marks = n, this.pendingMarks = i, this.solid = o, this.options = s, this.content = [], this.activeMarks = za.none, this.stashMarks = [], this.match = a || (s & i0 ? null : t.contentMatch);
  }
  findWrapping(t) {
    if (!this.match) {
      if (!this.type)
        return [];
      let r = this.type.contentMatch.fillBefore(bt.from(t));
      if (r)
        this.match = this.type.contentMatch.matchFragment(r);
      else {
        let n = this.type.contentMatch, i;
        return (i = n.findWrapping(t.type)) ? (this.match = n, i) : null;
      }
    }
    return this.match.findWrapping(t.type);
  }
  finish(t) {
    if (!(this.options & Tx)) {
      let n = this.content[this.content.length - 1], i;
      if (n && n.isText && (i = /[ \t\r\n\u000c]+$/.exec(n.text))) {
        let o = n;
        n.text.length == i[0].length ? this.content.pop() : this.content[this.content.length - 1] = o.withText(o.text.slice(0, o.text.length - i[0].length));
      }
    }
    let r = bt.from(this.content);
    return !t && this.match && (r = r.append(this.match.fillBefore(bt.empty, !0))), this.type ? this.type.create(this.attrs, r, this.marks) : r;
  }
  popFromStashMark(t) {
    for (let r = this.stashMarks.length - 1; r >= 0; r--)
      if (t.eq(this.stashMarks[r]))
        return this.stashMarks.splice(r, 1)[0];
  }
  applyPending(t) {
    for (let r = 0, n = this.pendingMarks; r < n.length; r++) {
      let i = n[r];
      (this.type ? this.type.allowsMarkType(i.type) : f4e(i.type, t)) && !i.isInSet(this.activeMarks) && (this.activeMarks = i.addToSet(this.activeMarks), this.pendingMarks = i.removeFromSet(this.pendingMarks));
    }
  }
  inlineContext(t) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : t.parentNode && !jY.hasOwnProperty(t.parentNode.nodeName.toLowerCase());
  }
}
class sj {
  constructor(t, r, n) {
    this.parser = t, this.options = r, this.isOpen = n, this.open = 0;
    let i = r.topNode, o, a = lj(null, r.preserveWhitespace, 0) | (n ? i0 : 0);
    i ? o = new Ay(i.type, i.attrs, za.none, za.none, !0, r.topMatch || i.type.contentMatch, a) : n ? o = new Ay(null, null, za.none, za.none, !0, null, a) : o = new Ay(t.schema.topNodeType, null, za.none, za.none, !0, null, a), this.nodes = [o], this.find = r.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(t) {
    if (t.nodeType == 3)
      this.addTextNode(t);
    else if (t.nodeType == 1) {
      let r = t.getAttribute("style");
      if (!r)
        this.addElement(t);
      else {
        let n = this.readStyles(d4e(r));
        if (!n)
          return;
        let [i, o] = n, a = this.top;
        for (let s = 0; s < o.length; s++)
          this.removePendingMark(o[s], a);
        for (let s = 0; s < i.length; s++)
          this.addPendingMark(i[s]);
        this.addElement(t);
        for (let s = 0; s < i.length; s++)
          this.removePendingMark(i[s], a);
        for (let s = 0; s < o.length; s++)
          this.addPendingMark(o[s]);
      }
    }
  }
  addTextNode(t) {
    let r = t.nodeValue, n = this.top;
    if (n.options & kx || n.inlineContext(t) || /[^ \t\r\n\u000c]/.test(r)) {
      if (n.options & Tx)
        n.options & kx ? r = r.replace(/\r\n?/g, `
`) : r = r.replace(/\r?\n|\r/g, " ");
      else if (r = r.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(r) && this.open == this.nodes.length - 1) {
        let i = n.content[n.content.length - 1], o = t.previousSibling;
        (!i || o && o.nodeName == "BR" || i.isText && /[ \t\r\n\u000c]$/.test(i.text)) && (r = r.slice(1));
      }
      r && this.insertNode(this.parser.schema.text(r)), this.findInText(t);
    } else
      this.findInside(t);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(t, r) {
    let n = t.nodeName.toLowerCase(), i;
    FY.hasOwnProperty(n) && this.parser.normalizeLists && u4e(t);
    let o = this.options.ruleFromNode && this.options.ruleFromNode(t) || (i = this.parser.matchTag(t, this, r));
    if (o ? o.ignore : s4e.hasOwnProperty(n))
      this.findInside(t), this.ignoreFallback(t);
    else if (!o || o.skip || o.closeParent) {
      o && o.closeParent ? this.open = Math.max(0, this.open - 1) : o && o.skip.nodeType && (t = o.skip);
      let a, s = this.top, u = this.needsBlock;
      if (jY.hasOwnProperty(n))
        s.content.length && s.content[0].isInline && this.open && (this.open--, s = this.top), a = !0, s.type || (this.needsBlock = !0);
      else if (!t.firstChild) {
        this.leafFallback(t);
        return;
      }
      this.addAll(t), a && this.sync(s), this.needsBlock = u;
    } else
      this.addElementByRule(t, o, o.consuming === !1 ? i : void 0);
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(t) {
    t.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(t.ownerDocument.createTextNode(`
`));
  }
  // Called for ignored nodes
  ignoreFallback(t) {
    t.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"));
  }
  // Run any style parser associated with the node's styles. Either
  // return an array of marks, or null to indicate some of the styles
  // had a rule with `ignore` set.
  readStyles(t) {
    let r = za.none, n = za.none;
    e:
      for (let i = 0; i < t.length; i += 2)
        for (let o = void 0; ; ) {
          let a = this.parser.matchStyle(t[i], t[i + 1], this, o);
          if (!a)
            continue e;
          if (a.ignore)
            return null;
          if (a.clearMark ? this.top.pendingMarks.forEach((s) => {
            a.clearMark(s) && (n = s.addToSet(n));
          }) : r = this.parser.schema.marks[a.mark].create(a.attrs).addToSet(r), a.consuming === !1)
            o = a;
          else
            break;
        }
    return [r, n];
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(t, r, n) {
    let i, o, a;
    r.node ? (o = this.parser.schema.nodes[r.node], o.isLeaf ? this.insertNode(o.create(r.attrs)) || this.leafFallback(t) : i = this.enter(o, r.attrs || null, r.preserveWhitespace)) : (a = this.parser.schema.marks[r.mark].create(r.attrs), this.addPendingMark(a));
    let s = this.top;
    if (o && o.isLeaf)
      this.findInside(t);
    else if (n)
      this.addElement(t, n);
    else if (r.getContent)
      this.findInside(t), r.getContent(t, this.parser.schema).forEach((u) => this.insertNode(u));
    else {
      let u = t;
      typeof r.contentElement == "string" ? u = t.querySelector(r.contentElement) : typeof r.contentElement == "function" ? u = r.contentElement(t) : r.contentElement && (u = r.contentElement), this.findAround(t, u, !0), this.addAll(u);
    }
    i && this.sync(s) && this.open--, a && this.removePendingMark(a, s);
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(t, r, n) {
    let i = r || 0;
    for (let o = r ? t.childNodes[r] : t.firstChild, a = n == null ? null : t.childNodes[n]; o != a; o = o.nextSibling, ++i)
      this.findAtPoint(t, i), this.addDOM(o);
    this.findAtPoint(t, i);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(t) {
    let r, n;
    for (let i = this.open; i >= 0; i--) {
      let o = this.nodes[i], a = o.findWrapping(t);
      if (a && (!r || r.length > a.length) && (r = a, n = o, !a.length) || o.solid)
        break;
    }
    if (!r)
      return !1;
    this.sync(n);
    for (let i = 0; i < r.length; i++)
      this.enterInner(r[i], null, !1);
    return !0;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(t) {
    if (t.isInline && this.needsBlock && !this.top.type) {
      let r = this.textblockFromContext();
      r && this.enterInner(r);
    }
    if (this.findPlace(t)) {
      this.closeExtra();
      let r = this.top;
      r.applyPending(t.type), r.match && (r.match = r.match.matchType(t.type));
      let n = r.activeMarks;
      for (let i = 0; i < t.marks.length; i++)
        (!r.type || r.type.allowsMarkType(t.marks[i].type)) && (n = t.marks[i].addToSet(n));
      return r.content.push(t.mark(n)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(t, r, n) {
    let i = this.findPlace(t.create(r));
    return i && this.enterInner(t, r, !0, n), i;
  }
  // Open a node of the given type
  enterInner(t, r = null, n = !1, i) {
    this.closeExtra();
    let o = this.top;
    o.applyPending(t), o.match = o.match && o.match.matchType(t);
    let a = lj(t, i, o.options);
    o.options & i0 && o.content.length == 0 && (a |= i0), this.nodes.push(new Ay(t, r, o.activeMarks, o.pendingMarks, n, null, a)), this.open++;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(t = !1) {
    let r = this.nodes.length - 1;
    if (r > this.open) {
      for (; r > this.open; r--)
        this.nodes[r - 1].content.push(this.nodes[r].finish(t));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(this.isOpen || this.options.topOpen);
  }
  sync(t) {
    for (let r = this.open; r >= 0; r--)
      if (this.nodes[r] == t)
        return this.open = r, !0;
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let t = 0;
    for (let r = this.open; r >= 0; r--) {
      let n = this.nodes[r].content;
      for (let i = n.length - 1; i >= 0; i--)
        t += n[i].nodeSize;
      r && t++;
    }
    return t;
  }
  findAtPoint(t, r) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].node == t && this.find[n].offset == r && (this.find[n].pos = this.currentPos);
  }
  findInside(t) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].pos == null && t.nodeType == 1 && t.contains(this.find[r].node) && (this.find[r].pos = this.currentPos);
  }
  findAround(t, r, n) {
    if (t != r && this.find)
      for (let i = 0; i < this.find.length; i++)
        this.find[i].pos == null && t.nodeType == 1 && t.contains(this.find[i].node) && r.compareDocumentPosition(this.find[i].node) & (n ? 2 : 4) && (this.find[i].pos = this.currentPos);
  }
  findInText(t) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == t && (this.find[r].pos = this.currentPos - (t.nodeValue.length - this.find[r].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(t) {
    if (t.indexOf("|") > -1)
      return t.split(/\s*\|\s*/).some(this.matchesContext, this);
    let r = t.split("/"), n = this.options.context, i = !this.isOpen && (!n || n.parent.type == this.nodes[0].type), o = -(n ? n.depth + 1 : 0) + (i ? 0 : 1), a = (s, u) => {
      for (; s >= 0; s--) {
        let d = r[s];
        if (d == "") {
          if (s == r.length - 1 || s == 0)
            continue;
          for (; u >= o; u--)
            if (a(s - 1, u))
              return !0;
          return !1;
        } else {
          let f = u > 0 || u == 0 && i ? this.nodes[u].type : n && u >= o ? n.node(u - o).type : null;
          if (!f || f.name != d && f.groups.indexOf(d) == -1)
            return !1;
          u--;
        }
      }
      return !0;
    };
    return a(r.length - 1, this.open);
  }
  textblockFromContext() {
    let t = this.options.context;
    if (t)
      for (let r = t.depth; r >= 0; r--) {
        let n = t.node(r).contentMatchAt(t.indexAfter(r)).defaultType;
        if (n && n.isTextblock && n.defaultAttrs)
          return n;
      }
    for (let r in this.parser.schema.nodes) {
      let n = this.parser.schema.nodes[r];
      if (n.isTextblock && n.defaultAttrs)
        return n;
    }
  }
  addPendingMark(t) {
    let r = h4e(t, this.top.pendingMarks);
    r && this.top.stashMarks.push(r), this.top.pendingMarks = t.addToSet(this.top.pendingMarks);
  }
  removePendingMark(t, r) {
    for (let n = this.open; n >= 0; n--) {
      let i = this.nodes[n];
      if (i.pendingMarks.lastIndexOf(t) > -1)
        i.pendingMarks = t.removeFromSet(i.pendingMarks);
      else {
        i.activeMarks = t.removeFromSet(i.activeMarks);
        let a = i.popFromStashMark(t);
        a && i.type && i.type.allowsMarkType(a.type) && (i.activeMarks = a.addToSet(i.activeMarks));
      }
      if (i == r)
        break;
    }
  }
}
function u4e(e) {
  for (let t = e.firstChild, r = null; t; t = t.nextSibling) {
    let n = t.nodeType == 1 ? t.nodeName.toLowerCase() : null;
    n && FY.hasOwnProperty(n) && r ? (r.appendChild(t), t = r) : n == "li" ? r = t : n && (r = null);
  }
}
function c4e(e, t) {
  return (e.matches || e.msMatchesSelector || e.webkitMatchesSelector || e.mozMatchesSelector).call(e, t);
}
function d4e(e) {
  let t = /\s*([\w-]+)\s*:\s*([^;]+)/g, r, n = [];
  for (; r = t.exec(e); )
    n.push(r[1], r[2].trim());
  return n;
}
function uj(e) {
  let t = {};
  for (let r in e)
    t[r] = e[r];
  return t;
}
function f4e(e, t) {
  let r = t.schema.nodes;
  for (let n in r) {
    let i = r[n];
    if (!i.allowsMarkType(e))
      continue;
    let o = [], a = (s) => {
      o.push(s);
      for (let u = 0; u < s.edgeCount; u++) {
        let { type: d, next: f } = s.edge(u);
        if (d == t || o.indexOf(f) < 0 && a(f))
          return !0;
      }
    };
    if (a(i.contentMatch))
      return !0;
  }
}
function h4e(e, t) {
  for (let r = 0; r < t.length; r++)
    if (e.eq(t[r]))
      return t[r];
}
class _u {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(t, r) {
    this.nodes = t, this.marks = r;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(t, r = {}, n) {
    n || (n = uN(r).createDocumentFragment());
    let i = n, o = [];
    return t.forEach((a) => {
      if (o.length || a.marks.length) {
        let s = 0, u = 0;
        for (; s < o.length && u < a.marks.length; ) {
          let d = a.marks[u];
          if (!this.marks[d.type.name]) {
            u++;
            continue;
          }
          if (!d.eq(o[s][0]) || d.type.spec.spanning === !1)
            break;
          s++, u++;
        }
        for (; s < o.length; )
          i = o.pop()[1];
        for (; u < a.marks.length; ) {
          let d = a.marks[u++], f = this.serializeMark(d, a.isInline, r);
          f && (o.push([d, i]), i.appendChild(f.dom), i = f.contentDOM || f.dom);
        }
      }
      i.appendChild(this.serializeNodeInner(a, r));
    }), n;
  }
  /**
  @internal
  */
  serializeNodeInner(t, r) {
    let { dom: n, contentDOM: i } = _u.renderSpec(uN(r), this.nodes[t.type.name](t));
    if (i) {
      if (t.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(t.content, r, i);
    }
    return n;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(t, r = {}) {
    let n = this.serializeNodeInner(t, r);
    for (let i = t.marks.length - 1; i >= 0; i--) {
      let o = this.serializeMark(t.marks[i], t.isInline, r);
      o && ((o.contentDOM || o.dom).appendChild(n), n = o.dom);
    }
    return n;
  }
  /**
  @internal
  */
  serializeMark(t, r, n = {}) {
    let i = this.marks[t.type.name];
    return i && _u.renderSpec(uN(n), i(t, r));
  }
  /**
  Render an [output spec](https://prosemirror.net/docs/ref/#model.DOMOutputSpec) to a DOM node. If
  the spec has a hole (zero) in it, `contentDOM` will point at the
  node with the hole.
  */
  static renderSpec(t, r, n = null) {
    if (typeof r == "string")
      return { dom: t.createTextNode(r) };
    if (r.nodeType != null)
      return { dom: r };
    if (r.dom && r.dom.nodeType != null)
      return r;
    let i = r[0], o = i.indexOf(" ");
    o > 0 && (n = i.slice(0, o), i = i.slice(o + 1));
    let a, s = n ? t.createElementNS(n, i) : t.createElement(i), u = r[1], d = 1;
    if (u && typeof u == "object" && u.nodeType == null && !Array.isArray(u)) {
      d = 2;
      for (let f in u)
        if (u[f] != null) {
          let h = f.indexOf(" ");
          h > 0 ? s.setAttributeNS(f.slice(0, h), f.slice(h + 1), u[f]) : s.setAttribute(f, u[f]);
        }
    }
    for (let f = d; f < r.length; f++) {
      let h = r[f];
      if (h === 0) {
        if (f < r.length - 1 || f > d)
          throw new RangeError("Content hole must be the only child of its parent node");
        return { dom: s, contentDOM: s };
      } else {
        let { dom: g, contentDOM: m } = _u.renderSpec(t, h, n);
        if (s.appendChild(g), m) {
          if (a)
            throw new RangeError("Multiple content holes");
          a = m;
        }
      }
    }
    return { dom: s, contentDOM: a };
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(t) {
    return t.cached.domSerializer || (t.cached.domSerializer = new _u(this.nodesFromSchema(t), this.marksFromSchema(t)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(t) {
    let r = cj(t.nodes);
    return r.text || (r.text = (n) => n.text), r;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(t) {
    return cj(t.marks);
  }
}
function cj(e) {
  let t = {};
  for (let r in e) {
    let n = e[r].spec.toDOM;
    n && (t[r] = n);
  }
  return t;
}
function uN(e) {
  return e.document || window.document;
}
const BY = 65535, UY = Math.pow(2, 16);
function p4e(e, t) {
  return e + t * UY;
}
function dj(e) {
  return e & BY;
}
function g4e(e) {
  return (e - (e & BY)) / UY;
}
const HY = 1, WY = 2, h1 = 4, VY = 8;
class z$ {
  /**
  @internal
  */
  constructor(t, r, n) {
    this.pos = t, this.delInfo = r, this.recover = n;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & VY) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (HY | h1)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (WY | h1)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & h1) > 0;
  }
}
class el {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(t, r = !1) {
    if (this.ranges = t, this.inverted = r, !t.length && el.empty)
      return el.empty;
  }
  /**
  @internal
  */
  recover(t) {
    let r = 0, n = dj(t);
    if (!this.inverted)
      for (let i = 0; i < n; i++)
        r += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
    return this.ranges[n * 3] + r + g4e(t);
  }
  mapResult(t, r = 1) {
    return this._map(t, r, !1);
  }
  map(t, r = 1) {
    return this._map(t, r, !0);
  }
  /**
  @internal
  */
  _map(t, r, n) {
    let i = 0, o = this.inverted ? 2 : 1, a = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let u = this.ranges[s] - (this.inverted ? i : 0);
      if (u > t)
        break;
      let d = this.ranges[s + o], f = this.ranges[s + a], h = u + d;
      if (t <= h) {
        let g = d ? t == u ? -1 : t == h ? 1 : r : r, m = u + i + (g < 0 ? 0 : f);
        if (n)
          return m;
        let v = t == (r < 0 ? u : h) ? null : p4e(s / 3, t - u), w = t == u ? WY : t == h ? HY : h1;
        return (r < 0 ? t != u : t != h) && (w |= VY), new z$(m, w, v);
      }
      i += f - d;
    }
    return n ? t + i : new z$(t + i, 0, null);
  }
  /**
  @internal
  */
  touches(t, r) {
    let n = 0, i = dj(r), o = this.inverted ? 2 : 1, a = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let u = this.ranges[s] - (this.inverted ? n : 0);
      if (u > t)
        break;
      let d = this.ranges[s + o], f = u + d;
      if (t <= f && s == i * 3)
        return !0;
      n += this.ranges[s + a] - d;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(t) {
    let r = this.inverted ? 2 : 1, n = this.inverted ? 1 : 2;
    for (let i = 0, o = 0; i < this.ranges.length; i += 3) {
      let a = this.ranges[i], s = a - (this.inverted ? o : 0), u = a + (this.inverted ? 0 : o), d = this.ranges[i + r], f = this.ranges[i + n];
      t(s, s + d, u, u + f), o += f - d;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new el(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(t) {
    return t == 0 ? el.empty : new el(t < 0 ? [0, -t, 0] : [0, 0, t]);
  }
}
el.empty = new el([]);
class o0 {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(t = [], r, n = 0, i = t.length) {
    this.maps = t, this.mirror = r, this.from = n, this.to = i;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(t = 0, r = this.maps.length) {
    return new o0(this.maps, this.mirror, t, r);
  }
  /**
  @internal
  */
  copy() {
    return new o0(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(t, r) {
    this.to = this.maps.push(t), r != null && this.setMirror(this.maps.length - 1, r);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(t) {
    for (let r = 0, n = this.maps.length; r < t.maps.length; r++) {
      let i = t.getMirror(r);
      this.appendMap(t.maps[r], i != null && i < r ? n + i : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(t) {
    if (this.mirror) {
      for (let r = 0; r < this.mirror.length; r++)
        if (this.mirror[r] == t)
          return this.mirror[r + (r % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(t, r) {
    this.mirror || (this.mirror = []), this.mirror.push(t, r);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(t) {
    for (let r = t.maps.length - 1, n = this.maps.length + t.maps.length; r >= 0; r--) {
      let i = t.getMirror(r);
      this.appendMap(t.maps[r].invert(), i != null && i > r ? n - i - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let t = new o0();
    return t.appendMappingInverted(this), t;
  }
  /**
  Map a position through this mapping.
  */
  map(t, r = 1) {
    if (this.mirror)
      return this._map(t, r, !0);
    for (let n = this.from; n < this.to; n++)
      t = this.maps[n].map(t, r);
    return t;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(t, r = 1) {
    return this._map(t, r, !1);
  }
  /**
  @internal
  */
  _map(t, r, n) {
    let i = 0;
    for (let o = this.from; o < this.to; o++) {
      let a = this.maps[o], s = a.mapResult(t, r);
      if (s.recover != null) {
        let u = this.getMirror(o);
        if (u != null && u > o && u < this.to) {
          o = u, t = this.maps[u].recover(s.recover);
          continue;
        }
      }
      i |= s.delInfo, t = s.pos;
    }
    return n ? t : new z$(t, i, null);
  }
}
const cN = /* @__PURE__ */ Object.create(null);
class va {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return el.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(t) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(t, r) {
    if (!r || !r.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let n = cN[r.stepType];
    if (!n)
      throw new RangeError(`No step type ${r.stepType} defined`);
    return n.fromJSON(t, r);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(t, r) {
    if (t in cN)
      throw new RangeError("Duplicate use of step JSON ID " + t);
    return cN[t] = r, r.prototype.jsonID = t, r;
  }
}
class Gi {
  /**
  @internal
  */
  constructor(t, r) {
    this.doc = t, this.failed = r;
  }
  /**
  Create a successful step result.
  */
  static ok(t) {
    return new Gi(t, null);
  }
  /**
  Create a failed step result.
  */
  static fail(t) {
    return new Gi(null, t);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(t, r, n, i) {
    try {
      return Gi.ok(t.replace(r, n, i));
    } catch (o) {
      if (o instanceof n4e)
        return Gi.fail(o.message);
      throw o;
    }
  }
}
function y_(e, t, r) {
  let n = [];
  for (let i = 0; i < e.childCount; i++) {
    let o = e.child(i);
    o.content.size && (o = o.copy(y_(o.content, t, o))), o.isInline && (o = t(o, r, i)), n.push(o);
  }
  return bt.fromArray(n);
}
class uc extends va {
  /**
  Create a mark step.
  */
  constructor(t, r, n) {
    super(), this.from = t, this.to = r, this.mark = n;
  }
  apply(t) {
    let r = t.slice(this.from, this.to), n = t.resolve(this.from), i = n.node(n.sharedDepth(this.to)), o = new Ot(y_(r.content, (a, s) => !a.isAtom || !s.type.allowsMarkType(this.mark.type) ? a : a.mark(this.mark.addToSet(a.marks)), i), r.openStart, r.openEnd);
    return Gi.fromReplace(t, this.from, this.to, o);
  }
  invert() {
    return new ps(this.from, this.to, this.mark);
  }
  map(t) {
    let r = t.mapResult(this.from, 1), n = t.mapResult(this.to, -1);
    return r.deleted && n.deleted || r.pos >= n.pos ? null : new uc(r.pos, n.pos, this.mark);
  }
  merge(t) {
    return t instanceof uc && t.mark.eq(this.mark) && this.from <= t.to && this.to >= t.from ? new uc(Math.min(this.from, t.from), Math.max(this.to, t.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(t, r) {
    if (typeof r.from != "number" || typeof r.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new uc(r.from, r.to, t.markFromJSON(r.mark));
  }
}
va.jsonID("addMark", uc);
class ps extends va {
  /**
  Create a mark-removing step.
  */
  constructor(t, r, n) {
    super(), this.from = t, this.to = r, this.mark = n;
  }
  apply(t) {
    let r = t.slice(this.from, this.to), n = new Ot(y_(r.content, (i) => i.mark(this.mark.removeFromSet(i.marks)), t), r.openStart, r.openEnd);
    return Gi.fromReplace(t, this.from, this.to, n);
  }
  invert() {
    return new uc(this.from, this.to, this.mark);
  }
  map(t) {
    let r = t.mapResult(this.from, 1), n = t.mapResult(this.to, -1);
    return r.deleted && n.deleted || r.pos >= n.pos ? null : new ps(r.pos, n.pos, this.mark);
  }
  merge(t) {
    return t instanceof ps && t.mark.eq(this.mark) && this.from <= t.to && this.to >= t.from ? new ps(Math.min(this.from, t.from), Math.max(this.to, t.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(t, r) {
    if (typeof r.from != "number" || typeof r.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new ps(r.from, r.to, t.markFromJSON(r.mark));
  }
}
va.jsonID("removeMark", ps);
class cc extends va {
  /**
  Create a node mark step.
  */
  constructor(t, r) {
    super(), this.pos = t, this.mark = r;
  }
  apply(t) {
    let r = t.nodeAt(this.pos);
    if (!r)
      return Gi.fail("No node at mark step's position");
    let n = r.type.create(r.attrs, null, this.mark.addToSet(r.marks));
    return Gi.fromReplace(t, this.pos, this.pos + 1, new Ot(bt.from(n), 0, r.isLeaf ? 0 : 1));
  }
  invert(t) {
    let r = t.nodeAt(this.pos);
    if (r) {
      let n = this.mark.addToSet(r.marks);
      if (n.length == r.marks.length) {
        for (let i = 0; i < r.marks.length; i++)
          if (!r.marks[i].isInSet(n))
            return new cc(this.pos, r.marks[i]);
        return new cc(this.pos, this.mark);
      }
    }
    return new kp(this.pos, this.mark);
  }
  map(t) {
    let r = t.mapResult(this.pos, 1);
    return r.deletedAfter ? null : new cc(r.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(t, r) {
    if (typeof r.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new cc(r.pos, t.markFromJSON(r.mark));
  }
}
va.jsonID("addNodeMark", cc);
class kp extends va {
  /**
  Create a mark-removing step.
  */
  constructor(t, r) {
    super(), this.pos = t, this.mark = r;
  }
  apply(t) {
    let r = t.nodeAt(this.pos);
    if (!r)
      return Gi.fail("No node at mark step's position");
    let n = r.type.create(r.attrs, null, this.mark.removeFromSet(r.marks));
    return Gi.fromReplace(t, this.pos, this.pos + 1, new Ot(bt.from(n), 0, r.isLeaf ? 0 : 1));
  }
  invert(t) {
    let r = t.nodeAt(this.pos);
    return !r || !this.mark.isInSet(r.marks) ? this : new cc(this.pos, this.mark);
  }
  map(t) {
    let r = t.mapResult(this.pos, 1);
    return r.deletedAfter ? null : new kp(r.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(t, r) {
    if (typeof r.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new kp(r.pos, t.markFromJSON(r.mark));
  }
}
va.jsonID("removeNodeMark", kp);
class Eo extends va {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(t, r, n, i = !1) {
    super(), this.from = t, this.to = r, this.slice = n, this.structure = i;
  }
  apply(t) {
    return this.structure && $$(t, this.from, this.to) ? Gi.fail("Structure replace would overwrite content") : Gi.fromReplace(t, this.from, this.to, this.slice);
  }
  getMap() {
    return new el([this.from, this.to - this.from, this.slice.size]);
  }
  invert(t) {
    return new Eo(this.from, this.from + this.slice.size, t.slice(this.from, this.to));
  }
  map(t) {
    let r = t.mapResult(this.from, 1), n = t.mapResult(this.to, -1);
    return r.deletedAcross && n.deletedAcross ? null : new Eo(r.pos, Math.max(r.pos, n.pos), this.slice);
  }
  merge(t) {
    if (!(t instanceof Eo) || t.structure || this.structure)
      return null;
    if (this.from + this.slice.size == t.from && !this.slice.openEnd && !t.slice.openStart) {
      let r = this.slice.size + t.slice.size == 0 ? Ot.empty : new Ot(this.slice.content.append(t.slice.content), this.slice.openStart, t.slice.openEnd);
      return new Eo(this.from, this.to + (t.to - t.from), r, this.structure);
    } else if (t.to == this.from && !this.slice.openStart && !t.slice.openEnd) {
      let r = this.slice.size + t.slice.size == 0 ? Ot.empty : new Ot(t.slice.content.append(this.slice.content), t.slice.openStart, this.slice.openEnd);
      return new Eo(t.from, this.to, r, this.structure);
    } else
      return null;
  }
  toJSON() {
    let t = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (t.slice = this.slice.toJSON()), this.structure && (t.structure = !0), t;
  }
  /**
  @internal
  */
  static fromJSON(t, r) {
    if (typeof r.from != "number" || typeof r.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new Eo(r.from, r.to, Ot.fromJSON(t, r.slice), !!r.structure);
  }
}
va.jsonID("replace", Eo);
class oo extends va {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(t, r, n, i, o, a, s = !1) {
    super(), this.from = t, this.to = r, this.gapFrom = n, this.gapTo = i, this.slice = o, this.insert = a, this.structure = s;
  }
  apply(t) {
    if (this.structure && ($$(t, this.from, this.gapFrom) || $$(t, this.gapTo, this.to)))
      return Gi.fail("Structure gap-replace would overwrite content");
    let r = t.slice(this.gapFrom, this.gapTo);
    if (r.openStart || r.openEnd)
      return Gi.fail("Gap is not a flat range");
    let n = this.slice.insertAt(this.insert, r.content);
    return n ? Gi.fromReplace(t, this.from, this.to, n) : Gi.fail("Content does not fit in gap");
  }
  getMap() {
    return new el([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(t) {
    let r = this.gapTo - this.gapFrom;
    return new oo(this.from, this.from + this.slice.size + r, this.from + this.insert, this.from + this.insert + r, t.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(t) {
    let r = t.mapResult(this.from, 1), n = t.mapResult(this.to, -1), i = t.map(this.gapFrom, -1), o = t.map(this.gapTo, 1);
    return r.deletedAcross && n.deletedAcross || i < r.pos || o > n.pos ? null : new oo(r.pos, n.pos, i, o, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let t = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (t.slice = this.slice.toJSON()), this.structure && (t.structure = !0), t;
  }
  /**
  @internal
  */
  static fromJSON(t, r) {
    if (typeof r.from != "number" || typeof r.to != "number" || typeof r.gapFrom != "number" || typeof r.gapTo != "number" || typeof r.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new oo(r.from, r.to, r.gapFrom, r.gapTo, Ot.fromJSON(t, r.slice), r.insert, !!r.structure);
  }
}
va.jsonID("replaceAround", oo);
function $$(e, t, r) {
  let n = e.resolve(t), i = r - t, o = n.depth;
  for (; i > 0 && o > 0 && n.indexAfter(o) == n.node(o).childCount; )
    o--, i--;
  if (i > 0) {
    let a = n.node(o).maybeChild(n.indexAfter(o));
    for (; i > 0; ) {
      if (!a || a.isLeaf)
        return !0;
      a = a.firstChild, i--;
    }
  }
  return !1;
}
function m4e(e, t, r, n) {
  let i = [], o = [], a, s;
  e.doc.nodesBetween(t, r, (u, d, f) => {
    if (!u.isInline)
      return;
    let h = u.marks;
    if (!n.isInSet(h) && f.type.allowsMarkType(n.type)) {
      let g = Math.max(d, t), m = Math.min(d + u.nodeSize, r), v = n.addToSet(h);
      for (let w = 0; w < h.length; w++)
        h[w].isInSet(v) || (a && a.to == g && a.mark.eq(h[w]) ? a.to = m : i.push(a = new ps(g, m, h[w])));
      s && s.to == g ? s.to = m : o.push(s = new uc(g, m, n));
    }
  }), i.forEach((u) => e.step(u)), o.forEach((u) => e.step(u));
}
function v4e(e, t, r, n) {
  let i = [], o = 0;
  e.doc.nodesBetween(t, r, (a, s) => {
    if (!a.isInline)
      return;
    o++;
    let u = null;
    if (n instanceof b_) {
      let d = a.marks, f;
      for (; f = n.isInSet(d); )
        (u || (u = [])).push(f), d = f.removeFromSet(d);
    } else
      n ? n.isInSet(a.marks) && (u = [n]) : u = a.marks;
    if (u && u.length) {
      let d = Math.min(s + a.nodeSize, r);
      for (let f = 0; f < u.length; f++) {
        let h = u[f], g;
        for (let m = 0; m < i.length; m++) {
          let v = i[m];
          v.step == o - 1 && h.eq(i[m].style) && (g = v);
        }
        g ? (g.to = d, g.step = o) : i.push({ style: h, from: Math.max(s, t), to: d, step: o });
      }
    }
  }), i.forEach((a) => e.step(new ps(a.from, a.to, a.style)));
}
function b4e(e, t, r, n = r.contentMatch) {
  let i = e.doc.nodeAt(t), o = [], a = t + 1;
  for (let s = 0; s < i.childCount; s++) {
    let u = i.child(s), d = a + u.nodeSize, f = n.matchType(u.type);
    if (!f)
      o.push(new Eo(a, d, Ot.empty));
    else {
      n = f;
      for (let h = 0; h < u.marks.length; h++)
        r.allowsMarkType(u.marks[h].type) || e.step(new ps(a, d, u.marks[h]));
    }
    a = d;
  }
  if (!n.validEnd) {
    let s = n.fillBefore(bt.empty, !0);
    e.replace(a, a, new Ot(s, 0, 0));
  }
  for (let s = o.length - 1; s >= 0; s--)
    e.step(o[s]);
}
function y4e(e, t, r) {
  return (t == 0 || e.canReplace(t, e.childCount)) && (r == e.childCount || e.canReplace(0, r));
}
function Qp(e) {
  let r = e.parent.content.cutByIndex(e.startIndex, e.endIndex);
  for (let n = e.depth; ; --n) {
    let i = e.$from.node(n), o = e.$from.index(n), a = e.$to.indexAfter(n);
    if (n < e.depth && i.canReplace(o, a, r))
      return n;
    if (n == 0 || i.type.spec.isolating || !y4e(i, o, a))
      break;
  }
  return null;
}
function x4e(e, t, r) {
  let { $from: n, $to: i, depth: o } = t, a = n.before(o + 1), s = i.after(o + 1), u = a, d = s, f = bt.empty, h = 0;
  for (let v = o, w = !1; v > r; v--)
    w || n.index(v) > 0 ? (w = !0, f = bt.from(n.node(v).copy(f)), h++) : u--;
  let g = bt.empty, m = 0;
  for (let v = o, w = !1; v > r; v--)
    w || i.after(v + 1) < i.end(v) ? (w = !0, g = bt.from(i.node(v).copy(g)), m++) : d++;
  e.step(new oo(u, d, a, s, new Ot(f.append(g), h, m), f.size - h, !0));
}
function x_(e, t, r = null, n = e) {
  let i = w4e(e, t), o = i && M4e(n, t);
  return o ? i.map(fj).concat({ type: t, attrs: r }).concat(o.map(fj)) : null;
}
function fj(e) {
  return { type: e, attrs: null };
}
function w4e(e, t) {
  let { parent: r, startIndex: n, endIndex: i } = e, o = r.contentMatchAt(n).findWrapping(t);
  if (!o)
    return null;
  let a = o.length ? o[0] : t;
  return r.canReplaceWith(n, i, a) ? o : null;
}
function M4e(e, t) {
  let { parent: r, startIndex: n, endIndex: i } = e, o = r.child(n), a = t.contentMatch.findWrapping(o.type);
  if (!a)
    return null;
  let u = (a.length ? a[a.length - 1] : t).contentMatch;
  for (let d = n; u && d < i; d++)
    u = u.matchType(r.child(d).type);
  return !u || !u.validEnd ? null : a;
}
function C4e(e, t, r) {
  let n = bt.empty;
  for (let a = r.length - 1; a >= 0; a--) {
    if (n.size) {
      let s = r[a].type.contentMatch.matchFragment(n);
      if (!s || !s.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    n = bt.from(r[a].type.create(r[a].attrs, n));
  }
  let i = t.start, o = t.end;
  e.step(new oo(i, o, i, o, new Ot(n, 0, 0), r.length, !0));
}
function S4e(e, t, r, n, i) {
  if (!n.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let o = e.steps.length;
  e.doc.nodesBetween(t, r, (a, s) => {
    if (a.isTextblock && !a.hasMarkup(n, i) && T4e(e.doc, e.mapping.slice(o).map(s), n)) {
      e.clearIncompatible(e.mapping.slice(o).map(s, 1), n);
      let u = e.mapping.slice(o), d = u.map(s, 1), f = u.map(s + a.nodeSize, 1);
      return e.step(new oo(d, f, d + 1, f - 1, new Ot(bt.from(n.create(i, null, a.marks)), 0, 0), 1, !0)), !1;
    }
  });
}
function T4e(e, t, r) {
  let n = e.resolve(t), i = n.index();
  return n.parent.canReplaceWith(i, i + 1, r);
}
function k4e(e, t, r, n, i) {
  let o = e.doc.nodeAt(t);
  if (!o)
    throw new RangeError("No node at given position");
  r || (r = o.type);
  let a = r.create(n, null, i || o.marks);
  if (o.isLeaf)
    return e.replaceWith(t, t + o.nodeSize, a);
  if (!r.validContent(o.content))
    throw new RangeError("Invalid content for node type " + r.name);
  e.step(new oo(t, t + o.nodeSize, t + 1, t + o.nodeSize - 1, new Ot(bt.from(a), 0, 0), 1, !0));
}
function lp(e, t, r = 1, n) {
  let i = e.resolve(t), o = i.depth - r, a = n && n[n.length - 1] || i.parent;
  if (o < 0 || i.parent.type.spec.isolating || !i.parent.canReplace(i.index(), i.parent.childCount) || !a.type.validContent(i.parent.content.cutByIndex(i.index(), i.parent.childCount)))
    return !1;
  for (let d = i.depth - 1, f = r - 2; d > o; d--, f--) {
    let h = i.node(d), g = i.index(d);
    if (h.type.spec.isolating)
      return !1;
    let m = h.content.cutByIndex(g, h.childCount), v = n && n[f] || h;
    if (v != h && (m = m.replaceChild(0, v.type.create(v.attrs))), !h.canReplace(g + 1, h.childCount) || !v.type.validContent(m))
      return !1;
  }
  let s = i.indexAfter(o), u = n && n[0];
  return i.node(o).canReplaceWith(s, s, u ? u.type : i.node(o + 1).type);
}
function D4e(e, t, r = 1, n) {
  let i = e.doc.resolve(t), o = bt.empty, a = bt.empty;
  for (let s = i.depth, u = i.depth - r, d = r - 1; s > u; s--, d--) {
    o = bt.from(i.node(s).copy(o));
    let f = n && n[d];
    a = bt.from(f ? f.type.create(f.attrs, a) : i.node(s).copy(a));
  }
  e.step(new Eo(t, t, new Ot(o.append(a), r, r), !0));
}
function Bc(e, t) {
  let r = e.resolve(t), n = r.index();
  return YY(r.nodeBefore, r.nodeAfter) && r.parent.canReplace(n, n + 1);
}
function YY(e, t) {
  return !!(e && t && !e.isLeaf && e.canAppend(t));
}
function QY(e, t, r = -1) {
  let n = e.resolve(t);
  for (let i = n.depth; ; i--) {
    let o, a, s = n.index(i);
    if (i == n.depth ? (o = n.nodeBefore, a = n.nodeAfter) : r > 0 ? (o = n.node(i + 1), s++, a = n.node(i).maybeChild(s)) : (o = n.node(i).maybeChild(s - 1), a = n.node(i + 1)), o && !o.isTextblock && YY(o, a) && n.node(i).canReplace(s, s + 1))
      return t;
    if (i == 0)
      break;
    t = r < 0 ? n.before(i) : n.after(i);
  }
}
function A4e(e, t, r) {
  let n = new Eo(t - r, t + r, Ot.empty, !0);
  e.step(n);
}
function E4e(e, t, r) {
  let n = e.resolve(t);
  if (n.parent.canReplaceWith(n.index(), n.index(), r))
    return t;
  if (n.parentOffset == 0)
    for (let i = n.depth - 1; i >= 0; i--) {
      let o = n.index(i);
      if (n.node(i).canReplaceWith(o, o, r))
        return n.before(i + 1);
      if (o > 0)
        return null;
    }
  if (n.parentOffset == n.parent.content.size)
    for (let i = n.depth - 1; i >= 0; i--) {
      let o = n.indexAfter(i);
      if (n.node(i).canReplaceWith(o, o, r))
        return n.after(i + 1);
      if (o < n.node(i).childCount)
        return null;
    }
  return null;
}
function qY(e, t, r) {
  let n = e.resolve(t);
  if (!r.content.size)
    return t;
  let i = r.content;
  for (let o = 0; o < r.openStart; o++)
    i = i.firstChild.content;
  for (let o = 1; o <= (r.openStart == 0 && r.size ? 2 : 1); o++)
    for (let a = n.depth; a >= 0; a--) {
      let s = a == n.depth ? 0 : n.pos <= (n.start(a + 1) + n.end(a + 1)) / 2 ? -1 : 1, u = n.index(a) + (s > 0 ? 1 : 0), d = n.node(a), f = !1;
      if (o == 1)
        f = d.canReplace(u, u, i);
      else {
        let h = d.contentMatchAt(u).findWrapping(i.firstChild.type);
        f = h && d.canReplaceWith(u, u, h[0]);
      }
      if (f)
        return s == 0 ? n.pos : s < 0 ? n.before(a + 1) : n.after(a + 1);
    }
  return null;
}
function w_(e, t, r = t, n = Ot.empty) {
  if (t == r && !n.size)
    return null;
  let i = e.resolve(t), o = e.resolve(r);
  return GY(i, o, n) ? new Eo(t, r, n) : new I4e(i, o, n).fit();
}
function GY(e, t, r) {
  return !r.openStart && !r.openEnd && e.start() == t.start() && e.parent.canReplace(e.index(), t.index(), r.content);
}
class I4e {
  constructor(t, r, n) {
    this.$from = t, this.$to = r, this.unplaced = n, this.frontier = [], this.placed = bt.empty;
    for (let i = 0; i <= t.depth; i++) {
      let o = t.node(i);
      this.frontier.push({
        type: o.type,
        match: o.contentMatchAt(t.indexAfter(i))
      });
    }
    for (let i = t.depth; i > 0; i--)
      this.placed = bt.from(t.node(i).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let d = this.findFittable();
      d ? this.placeNodes(d) : this.openMore() || this.dropNode();
    }
    let t = this.mustMoveInline(), r = this.placed.size - this.depth - this.$from.depth, n = this.$from, i = this.close(t < 0 ? this.$to : n.doc.resolve(t));
    if (!i)
      return null;
    let o = this.placed, a = n.depth, s = i.depth;
    for (; a && s && o.childCount == 1; )
      o = o.firstChild.content, a--, s--;
    let u = new Ot(o, a, s);
    return t > -1 ? new oo(n.pos, t, this.$to.pos, this.$to.end(), u, r) : u.size || n.pos != this.$to.pos ? new Eo(n.pos, i.pos, u) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let t = this.unplaced.openStart;
    for (let r = this.unplaced.content, n = 0, i = this.unplaced.openEnd; n < t; n++) {
      let o = r.firstChild;
      if (r.childCount > 1 && (i = 0), o.type.spec.isolating && i <= n) {
        t = n;
        break;
      }
      r = o.content;
    }
    for (let r = 1; r <= 2; r++)
      for (let n = r == 1 ? t : this.unplaced.openStart; n >= 0; n--) {
        let i, o = null;
        n ? (o = dN(this.unplaced.content, n - 1).firstChild, i = o.content) : i = this.unplaced.content;
        let a = i.firstChild;
        for (let s = this.depth; s >= 0; s--) {
          let { type: u, match: d } = this.frontier[s], f, h = null;
          if (r == 1 && (a ? d.matchType(a.type) || (h = d.fillBefore(bt.from(a), !1)) : o && u.compatibleContent(o.type)))
            return { sliceDepth: n, frontierDepth: s, parent: o, inject: h };
          if (r == 2 && a && (f = d.findWrapping(a.type)))
            return { sliceDepth: n, frontierDepth: s, parent: o, wrap: f };
          if (o && d.matchType(o.type))
            break;
        }
      }
  }
  openMore() {
    let { content: t, openStart: r, openEnd: n } = this.unplaced, i = dN(t, r);
    return !i.childCount || i.firstChild.isLeaf ? !1 : (this.unplaced = new Ot(t, r + 1, Math.max(n, i.size + r >= t.size - n ? r + 1 : 0)), !0);
  }
  dropNode() {
    let { content: t, openStart: r, openEnd: n } = this.unplaced, i = dN(t, r);
    if (i.childCount <= 1 && r > 0) {
      let o = t.size - r <= r + i.size;
      this.unplaced = new Ot(Wv(t, r - 1, 1), r - 1, o ? r - 1 : n);
    } else
      this.unplaced = new Ot(Wv(t, r, 1), r, n);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: t, frontierDepth: r, parent: n, inject: i, wrap: o }) {
    for (; this.depth > r; )
      this.closeFrontierNode();
    if (o)
      for (let w = 0; w < o.length; w++)
        this.openFrontierNode(o[w]);
    let a = this.unplaced, s = n ? n.content : a.content, u = a.openStart - t, d = 0, f = [], { match: h, type: g } = this.frontier[r];
    if (i) {
      for (let w = 0; w < i.childCount; w++)
        f.push(i.child(w));
      h = h.matchFragment(i);
    }
    let m = s.size + t - (a.content.size - a.openEnd);
    for (; d < s.childCount; ) {
      let w = s.child(d), x = h.matchType(w.type);
      if (!x)
        break;
      d++, (d > 1 || u == 0 || w.content.size) && (h = x, f.push(ZY(w.mark(g.allowedMarks(w.marks)), d == 1 ? u : 0, d == s.childCount ? m : -1)));
    }
    let v = d == s.childCount;
    v || (m = -1), this.placed = Vv(this.placed, r, bt.from(f)), this.frontier[r].match = h, v && m < 0 && n && n.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let w = 0, x = s; w < m; w++) {
      let y = x.lastChild;
      this.frontier.push({ type: y.type, match: y.contentMatchAt(y.childCount) }), x = y.content;
    }
    this.unplaced = v ? t == 0 ? Ot.empty : new Ot(Wv(a.content, t - 1, 1), t - 1, m < 0 ? a.openEnd : t - 1) : new Ot(Wv(a.content, t, d), a.openStart, a.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let t = this.frontier[this.depth], r;
    if (!t.type.isTextblock || !fN(this.$to, this.$to.depth, t.type, t.match, !1) || this.$to.depth == this.depth && (r = this.findCloseLevel(this.$to)) && r.depth == this.depth)
      return -1;
    let { depth: n } = this.$to, i = this.$to.after(n);
    for (; n > 1 && i == this.$to.end(--n); )
      ++i;
    return i;
  }
  findCloseLevel(t) {
    e:
      for (let r = Math.min(this.depth, t.depth); r >= 0; r--) {
        let { match: n, type: i } = this.frontier[r], o = r < t.depth && t.end(r + 1) == t.pos + (t.depth - (r + 1)), a = fN(t, r, i, n, o);
        if (a) {
          for (let s = r - 1; s >= 0; s--) {
            let { match: u, type: d } = this.frontier[s], f = fN(t, s, d, u, !0);
            if (!f || f.childCount)
              continue e;
          }
          return { depth: r, fit: a, move: o ? t.doc.resolve(t.after(r + 1)) : t };
        }
      }
  }
  close(t) {
    let r = this.findCloseLevel(t);
    if (!r)
      return null;
    for (; this.depth > r.depth; )
      this.closeFrontierNode();
    r.fit.childCount && (this.placed = Vv(this.placed, r.depth, r.fit)), t = r.move;
    for (let n = r.depth + 1; n <= t.depth; n++) {
      let i = t.node(n), o = i.type.contentMatch.fillBefore(i.content, !0, t.index(n));
      this.openFrontierNode(i.type, i.attrs, o);
    }
    return t;
  }
  openFrontierNode(t, r = null, n) {
    let i = this.frontier[this.depth];
    i.match = i.match.matchType(t), this.placed = Vv(this.placed, this.depth, bt.from(t.create(r, n))), this.frontier.push({ type: t, match: t.contentMatch });
  }
  closeFrontierNode() {
    let r = this.frontier.pop().match.fillBefore(bt.empty, !0);
    r.childCount && (this.placed = Vv(this.placed, this.frontier.length, r));
  }
}
function Wv(e, t, r) {
  return t == 0 ? e.cutByIndex(r, e.childCount) : e.replaceChild(0, e.firstChild.copy(Wv(e.firstChild.content, t - 1, r)));
}
function Vv(e, t, r) {
  return t == 0 ? e.append(r) : e.replaceChild(e.childCount - 1, e.lastChild.copy(Vv(e.lastChild.content, t - 1, r)));
}
function dN(e, t) {
  for (let r = 0; r < t; r++)
    e = e.firstChild.content;
  return e;
}
function ZY(e, t, r) {
  if (t <= 0)
    return e;
  let n = e.content;
  return t > 1 && (n = n.replaceChild(0, ZY(n.firstChild, t - 1, n.childCount == 1 ? r - 1 : 0))), t > 0 && (n = e.type.contentMatch.fillBefore(n).append(n), r <= 0 && (n = n.append(e.type.contentMatch.matchFragment(n).fillBefore(bt.empty, !0)))), e.copy(n);
}
function fN(e, t, r, n, i) {
  let o = e.node(t), a = i ? e.indexAfter(t) : e.index(t);
  if (a == o.childCount && !r.compatibleContent(o.type))
    return null;
  let s = n.fillBefore(o.content, !0, a);
  return s && !N4e(r, o.content, a) ? s : null;
}
function N4e(e, t, r) {
  for (let n = r; n < t.childCount; n++)
    if (!e.allowsMarks(t.child(n).marks))
      return !0;
  return !1;
}
function z4e(e) {
  return e.spec.defining || e.spec.definingForContent;
}
function $4e(e, t, r, n) {
  if (!n.size)
    return e.deleteRange(t, r);
  let i = e.doc.resolve(t), o = e.doc.resolve(r);
  if (GY(i, o, n))
    return e.step(new Eo(t, r, n));
  let a = XY(i, e.doc.resolve(r));
  a[a.length - 1] == 0 && a.pop();
  let s = -(i.depth + 1);
  a.unshift(s);
  for (let g = i.depth, m = i.pos - 1; g > 0; g--, m--) {
    let v = i.node(g).type.spec;
    if (v.defining || v.definingAsContext || v.isolating)
      break;
    a.indexOf(g) > -1 ? s = g : i.before(g) == m && a.splice(1, 0, -g);
  }
  let u = a.indexOf(s), d = [], f = n.openStart;
  for (let g = n.content, m = 0; ; m++) {
    let v = g.firstChild;
    if (d.push(v), m == n.openStart)
      break;
    g = v.content;
  }
  for (let g = f - 1; g >= 0; g--) {
    let m = d[g].type, v = z4e(m);
    if (v && i.node(u).type != m)
      f = g;
    else if (v || !m.isTextblock)
      break;
  }
  for (let g = n.openStart; g >= 0; g--) {
    let m = (g + f + 1) % (n.openStart + 1), v = d[m];
    if (v)
      for (let w = 0; w < a.length; w++) {
        let x = a[(w + u) % a.length], y = !0;
        x < 0 && (y = !1, x = -x);
        let C = i.node(x - 1), S = i.index(x - 1);
        if (C.canReplaceWith(S, S, v.type, v.marks))
          return e.replace(i.before(x), y ? o.after(x) : r, new Ot(KY(n.content, 0, n.openStart, m), m, n.openEnd));
      }
  }
  let h = e.steps.length;
  for (let g = a.length - 1; g >= 0 && (e.replace(t, r, n), !(e.steps.length > h)); g--) {
    let m = a[g];
    m < 0 || (t = i.before(m), r = o.after(m));
  }
}
function KY(e, t, r, n, i) {
  if (t < r) {
    let o = e.firstChild;
    e = e.replaceChild(0, o.copy(KY(o.content, t + 1, r, n, o)));
  }
  if (t > n) {
    let o = i.contentMatchAt(0), a = o.fillBefore(e).append(e);
    e = a.append(o.matchFragment(a).fillBefore(bt.empty, !0));
  }
  return e;
}
function O4e(e, t, r, n) {
  if (!n.isInline && t == r && e.doc.resolve(t).parent.content.size) {
    let i = E4e(e.doc, t, n.type);
    i != null && (t = r = i);
  }
  e.replaceRange(t, r, new Ot(bt.from(n), 0, 0));
}
function _4e(e, t, r) {
  let n = e.doc.resolve(t), i = e.doc.resolve(r), o = XY(n, i);
  for (let a = 0; a < o.length; a++) {
    let s = o[a], u = a == o.length - 1;
    if (u && s == 0 || n.node(s).type.contentMatch.validEnd)
      return e.delete(n.start(s), i.end(s));
    if (s > 0 && (u || n.node(s - 1).canReplace(n.index(s - 1), i.indexAfter(s - 1))))
      return e.delete(n.before(s), i.after(s));
  }
  for (let a = 1; a <= n.depth && a <= i.depth; a++)
    if (t - n.start(a) == n.depth - a && r > n.end(a) && i.end(a) - r != i.depth - a)
      return e.delete(n.before(a), r);
  e.delete(t, r);
}
function XY(e, t) {
  let r = [], n = Math.min(e.depth, t.depth);
  for (let i = n; i >= 0; i--) {
    let o = e.start(i);
    if (o < e.pos - (e.depth - i) || t.end(i) > t.pos + (t.depth - i) || e.node(i).type.spec.isolating || t.node(i).type.spec.isolating)
      break;
    (o == t.start(i) || i == e.depth && i == t.depth && e.parent.inlineContent && t.parent.inlineContent && i && t.start(i - 1) == o - 1) && r.push(i);
  }
  return r;
}
class sp extends va {
  /**
  Construct an attribute step.
  */
  constructor(t, r, n) {
    super(), this.pos = t, this.attr = r, this.value = n;
  }
  apply(t) {
    let r = t.nodeAt(this.pos);
    if (!r)
      return Gi.fail("No node at attribute step's position");
    let n = /* @__PURE__ */ Object.create(null);
    for (let o in r.attrs)
      n[o] = r.attrs[o];
    n[this.attr] = this.value;
    let i = r.type.create(n, null, r.marks);
    return Gi.fromReplace(t, this.pos, this.pos + 1, new Ot(bt.from(i), 0, r.isLeaf ? 0 : 1));
  }
  getMap() {
    return el.empty;
  }
  invert(t) {
    return new sp(this.pos, this.attr, t.nodeAt(this.pos).attrs[this.attr]);
  }
  map(t) {
    let r = t.mapResult(this.pos, 1);
    return r.deletedAfter ? null : new sp(r.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(t, r) {
    if (typeof r.pos != "number" || typeof r.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new sp(r.pos, r.attr, r.value);
  }
}
va.jsonID("attr", sp);
let Dp = class extends Error {
};
Dp = function e(t) {
  let r = Error.call(this, t);
  return r.__proto__ = e.prototype, r;
};
Dp.prototype = Object.create(Error.prototype);
Dp.prototype.constructor = Dp;
Dp.prototype.name = "TransformError";
class JY {
  /**
  Create a transform that starts with the given document.
  */
  constructor(t) {
    this.doc = t, this.steps = [], this.docs = [], this.mapping = new o0();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(t) {
    let r = this.maybeStep(t);
    if (r.failed)
      throw new Dp(r.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(t) {
    let r = t.apply(this.doc);
    return r.failed || this.addStep(t, r.doc), r;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(t, r) {
    this.docs.push(this.doc), this.steps.push(t), this.mapping.appendMap(t.getMap()), this.doc = r;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(t, r = t, n = Ot.empty) {
    let i = w_(this.doc, t, r, n);
    return i && this.step(i), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(t, r, n) {
    return this.replace(t, r, new Ot(bt.from(n), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(t, r) {
    return this.replace(t, r, Ot.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(t, r) {
    return this.replaceWith(t, t, r);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(t, r, n) {
    return $4e(this, t, r, n), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(t, r, n) {
    return O4e(this, t, r, n), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(t, r) {
    return _4e(this, t, r), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(t, r) {
    return x4e(this, t, r), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(t, r = 1) {
    return A4e(this, t, r), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(t, r) {
    return C4e(this, t, r), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(t, r = t, n, i = null) {
    return S4e(this, t, r, n, i), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(t, r, n = null, i) {
    return k4e(this, t, r, n, i), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  */
  setNodeAttribute(t, r, n) {
    return this.step(new sp(t, r, n)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(t, r) {
    return this.step(new cc(t, r)), this;
  }
  /**
  Remove a mark (or a mark of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(t, r) {
    if (!(r instanceof za)) {
      let n = this.doc.nodeAt(t);
      if (!n)
        throw new RangeError("No node at position " + t);
      if (r = r.isInSet(n.marks), !r)
        return this;
    }
    return this.step(new kp(t, r)), this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split.
  */
  split(t, r = 1, n) {
    return D4e(this, t, r, n), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(t, r, n) {
    return m4e(this, t, r, n), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(t, r, n) {
    return v4e(this, t, r, n), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(t, r, n) {
    return b4e(this, t, r, n), this;
  }
}
const hN = /* @__PURE__ */ Object.create(null);
class Ar {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(t, r, n) {
    this.$anchor = t, this.$head = r, this.ranges = n || [new eQ(t.min(r), t.max(r))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let t = this.ranges;
    for (let r = 0; r < t.length; r++)
      if (t[r].$from.pos != t[r].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(t, r = Ot.empty) {
    let n = r.content.lastChild, i = null;
    for (let s = 0; s < r.openEnd; s++)
      i = n, n = n.lastChild;
    let o = t.steps.length, a = this.ranges;
    for (let s = 0; s < a.length; s++) {
      let { $from: u, $to: d } = a[s], f = t.mapping.slice(o);
      t.replaceRange(f.map(u.pos), f.map(d.pos), s ? Ot.empty : r), s == 0 && gj(t, o, (n ? n.isInline : i && i.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(t, r) {
    let n = t.steps.length, i = this.ranges;
    for (let o = 0; o < i.length; o++) {
      let { $from: a, $to: s } = i[o], u = t.mapping.slice(n), d = u.map(a.pos), f = u.map(s.pos);
      o ? t.deleteRange(d, f) : (t.replaceRangeWith(d, f, r), gj(t, n, r.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(t, r, n = !1) {
    let i = t.parent.inlineContent ? new pr(t) : Hh(t.node(0), t.parent, t.pos, t.index(), r, n);
    if (i)
      return i;
    for (let o = t.depth - 1; o >= 0; o--) {
      let a = r < 0 ? Hh(t.node(0), t.node(o), t.before(o + 1), t.index(o), r, n) : Hh(t.node(0), t.node(o), t.after(o + 1), t.index(o) + 1, r, n);
      if (a)
        return a;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(t, r = 1) {
    return this.findFrom(t, r) || this.findFrom(t, -r) || new ol(t.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(t) {
    return Hh(t, t, 0, 0, 1) || new ol(t);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(t) {
    return Hh(t, t, t.content.size, t.childCount, -1) || new ol(t);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(t, r) {
    if (!r || !r.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let n = hN[r.type];
    if (!n)
      throw new RangeError(`No selection type ${r.type} defined`);
    return n.fromJSON(t, r);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(t, r) {
    if (t in hN)
      throw new RangeError("Duplicate use of selection JSON ID " + t);
    return hN[t] = r, r.prototype.jsonID = t, r;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return pr.between(this.$anchor, this.$head).getBookmark();
  }
}
Ar.prototype.visible = !0;
class eQ {
  /**
  Create a range.
  */
  constructor(t, r) {
    this.$from = t, this.$to = r;
  }
}
let hj = !1;
function pj(e) {
  !hj && !e.parent.inlineContent && (hj = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + e.parent.type.name + ")"));
}
class pr extends Ar {
  /**
  Construct a text selection between the given points.
  */
  constructor(t, r = t) {
    pj(t), pj(r), super(t, r);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(t, r) {
    let n = t.resolve(r.map(this.head));
    if (!n.parent.inlineContent)
      return Ar.near(n);
    let i = t.resolve(r.map(this.anchor));
    return new pr(i.parent.inlineContent ? i : n, n);
  }
  replace(t, r = Ot.empty) {
    if (super.replace(t, r), r == Ot.empty) {
      let n = this.$from.marksAcross(this.$to);
      n && t.ensureMarks(n);
    }
  }
  eq(t) {
    return t instanceof pr && t.anchor == this.anchor && t.head == this.head;
  }
  getBookmark() {
    return new iC(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(t, r) {
    if (typeof r.anchor != "number" || typeof r.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new pr(t.resolve(r.anchor), t.resolve(r.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(t, r, n = r) {
    let i = t.resolve(r);
    return new this(i, n == r ? i : t.resolve(n));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(t, r, n) {
    let i = t.pos - r.pos;
    if ((!n || i) && (n = i >= 0 ? 1 : -1), !r.parent.inlineContent) {
      let o = Ar.findFrom(r, n, !0) || Ar.findFrom(r, -n, !0);
      if (o)
        r = o.$head;
      else
        return Ar.near(r, n);
    }
    return t.parent.inlineContent || (i == 0 ? t = r : (t = (Ar.findFrom(t, -n, !0) || Ar.findFrom(t, n, !0)).$anchor, t.pos < r.pos != i < 0 && (t = r))), new pr(t, r);
  }
}
Ar.jsonID("text", pr);
class iC {
  constructor(t, r) {
    this.anchor = t, this.head = r;
  }
  map(t) {
    return new iC(t.map(this.anchor), t.map(this.head));
  }
  resolve(t) {
    return pr.between(t.resolve(this.anchor), t.resolve(this.head));
  }
}
class Bt extends Ar {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(t) {
    let r = t.nodeAfter, n = t.node(0).resolve(t.pos + r.nodeSize);
    super(t, n), this.node = r;
  }
  map(t, r) {
    let { deleted: n, pos: i } = r.mapResult(this.anchor), o = t.resolve(i);
    return n ? Ar.near(o) : new Bt(o);
  }
  content() {
    return new Ot(bt.from(this.node), 0, 0);
  }
  eq(t) {
    return t instanceof Bt && t.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new M_(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(t, r) {
    if (typeof r.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new Bt(t.resolve(r.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(t, r) {
    return new Bt(t.resolve(r));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(t) {
    return !t.isText && t.type.spec.selectable !== !1;
  }
}
Bt.prototype.visible = !1;
Ar.jsonID("node", Bt);
class M_ {
  constructor(t) {
    this.anchor = t;
  }
  map(t) {
    let { deleted: r, pos: n } = t.mapResult(this.anchor);
    return r ? new iC(n, n) : new M_(n);
  }
  resolve(t) {
    let r = t.resolve(this.anchor), n = r.nodeAfter;
    return n && Bt.isSelectable(n) ? new Bt(r) : Ar.near(r);
  }
}
class ol extends Ar {
  /**
  Create an all-selection over the given document.
  */
  constructor(t) {
    super(t.resolve(0), t.resolve(t.content.size));
  }
  replace(t, r = Ot.empty) {
    if (r == Ot.empty) {
      t.delete(0, t.doc.content.size);
      let n = Ar.atStart(t.doc);
      n.eq(t.selection) || t.setSelection(n);
    } else
      super.replace(t, r);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(t) {
    return new ol(t);
  }
  map(t) {
    return new ol(t);
  }
  eq(t) {
    return t instanceof ol;
  }
  getBookmark() {
    return L4e;
  }
}
Ar.jsonID("all", ol);
const L4e = {
  map() {
    return this;
  },
  resolve(e) {
    return new ol(e);
  }
};
function Hh(e, t, r, n, i, o = !1) {
  if (t.inlineContent)
    return pr.create(e, r);
  for (let a = n - (i > 0 ? 0 : 1); i > 0 ? a < t.childCount : a >= 0; a += i) {
    let s = t.child(a);
    if (s.isAtom) {
      if (!o && Bt.isSelectable(s))
        return Bt.create(e, r - (i < 0 ? s.nodeSize : 0));
    } else {
      let u = Hh(e, s, r + i, i < 0 ? s.childCount : 0, i, o);
      if (u)
        return u;
    }
    r += s.nodeSize * i;
  }
  return null;
}
function gj(e, t, r) {
  let n = e.steps.length - 1;
  if (n < t)
    return;
  let i = e.steps[n];
  if (!(i instanceof Eo || i instanceof oo))
    return;
  let o = e.mapping.maps[n], a;
  o.forEach((s, u, d, f) => {
    a == null && (a = f);
  }), e.setSelection(Ar.near(e.doc.resolve(a), r));
}
function mj(e, t) {
  return !t || !e ? e : e.bind(t);
}
class Ey {
  constructor(t, r, n) {
    this.name = t, this.init = mj(r.init, n), this.apply = mj(r.apply, n);
  }
}
new Ey("doc", {
  init(e) {
    return e.doc || e.schema.topNodeType.createAndFill();
  },
  apply(e) {
    return e.doc;
  }
}), new Ey("selection", {
  init(e, t) {
    return e.selection || Ar.atStart(t.doc);
  },
  apply(e) {
    return e.selection;
  }
}), new Ey("storedMarks", {
  init(e) {
    return e.storedMarks || null;
  },
  apply(e, t, r, n) {
    return n.selection.$cursor ? e.storedMarks : null;
  }
}), new Ey("scrollToSelection", {
  init() {
    return 0;
  },
  apply(e, t) {
    return e.scrolledIntoView ? t + 1 : t;
  }
});
function tQ(e, t, r) {
  for (let n in e) {
    let i = e[n];
    i instanceof Function ? i = i.bind(t) : n == "handleDOMEvents" && (i = tQ(i, t, {})), r[n] = i;
  }
  return r;
}
class ra {
  /**
  Create a plugin.
  */
  constructor(t) {
    this.spec = t, this.props = {}, t.props && tQ(t.props, this, this.props), this.key = t.key ? t.key.key : rQ("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(t) {
    return t[this.key];
  }
}
const pN = /* @__PURE__ */ Object.create(null);
function rQ(e) {
  return e in pN ? e + "$" + ++pN[e] : (pN[e] = 0, e + "$");
}
class _o {
  /**
  Create a plugin key.
  */
  constructor(t = "key") {
    this.key = rQ(t);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(t) {
    return t.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(t) {
    return t[this.key];
  }
}
const Ab = function(e) {
  for (var t = 0; ; t++)
    if (e = e.previousSibling, !e)
      return t;
}, nQ = function(e, t, r, n) {
  return r && (vj(e, t, r, n, -1) || vj(e, t, r, n, 1));
}, P4e = /^(img|br|input|textarea|hr)$/i;
function vj(e, t, r, n, i) {
  for (; ; ) {
    if (e == r && t == n)
      return !0;
    if (t == (i < 0 ? 0 : Dx(e))) {
      let o = e.parentNode;
      if (!o || o.nodeType != 1 || j4e(e) || P4e.test(e.nodeName) || e.contentEditable == "false")
        return !1;
      t = Ab(e) + (i < 0 ? 0 : 1), e = o;
    } else if (e.nodeType == 1) {
      if (e = e.childNodes[t + (i < 0 ? -1 : 0)], e.contentEditable == "false")
        return !1;
      t = i < 0 ? Dx(e) : 0;
    } else
      return !1;
  }
}
function Dx(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function R4e(e, t, r) {
  for (let n = t == 0, i = t == Dx(e); n || i; ) {
    if (e == r)
      return !0;
    let o = Ab(e);
    if (e = e.parentNode, !e)
      return !1;
    n = n && o == 0, i = i && o == Dx(e);
  }
}
function j4e(e) {
  let t;
  for (let r = e; r && !(t = r.pmViewDesc); r = r.parentNode)
    ;
  return t && t.node && t.node.isBlock && (t.dom == e || t.contentDOM == e);
}
const iQ = function(e) {
  return e.focusNode && nQ(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset);
};
function oQ(e, t) {
  let r = document.createEvent("Event");
  return r.initEvent("keydown", !0, !0), r.keyCode = e, r.key = r.code = t, r;
}
const Dc = typeof navigator < "u" ? navigator : null, bj = typeof document < "u" ? document : null, Uc = Dc && Dc.userAgent || "", O$ = /Edge\/(\d+)/.exec(Uc), aQ = /MSIE \d/.exec(Uc), _$ = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Uc), Eb = !!(aQ || _$ || O$), lQ = aQ ? document.documentMode : _$ ? +_$[1] : O$ ? +O$[1] : 0, oC = !Eb && /gecko\/(\d+)/i.test(Uc);
oC && +(/Firefox\/(\d+)/.exec(Uc) || [0, 0])[1];
const L$ = !Eb && /Chrome\/(\d+)/.exec(Uc), qp = !!L$, F4e = L$ ? +L$[1] : 0, bh = !Eb && !!Dc && /Apple Computer/.test(Dc.vendor), C_ = bh && (/Mobile\/\w+/.test(Uc) || !!Dc && Dc.maxTouchPoints > 2), Xa = C_ || (Dc ? /Mac/.test(Dc.platform) : !1), Ib = /Android \d/.test(Uc), S_ = !!bj && "webkitFontSmoothing" in bj.documentElement.style, B4e = S_ ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function U4e(e, t = null) {
  let r = e.domSelectionRange(), n = e.state.doc;
  if (!r.focusNode)
    return null;
  let i = e.docView.nearestDesc(r.focusNode), o = i && i.size == 0, a = e.docView.posFromDOM(r.focusNode, r.focusOffset, 1);
  if (a < 0)
    return null;
  let s = n.resolve(a), u, d;
  if (iQ(r)) {
    for (u = s; i && !i.node; )
      i = i.parent;
    let f = i.node;
    if (i && f.isAtom && Bt.isSelectable(f) && i.parent && !(f.isInline && R4e(r.focusNode, r.focusOffset, i.dom))) {
      let h = i.posBefore;
      d = new Bt(a == h ? s : n.resolve(h));
    }
  } else {
    let f = e.docView.posFromDOM(r.anchorNode, r.anchorOffset, 1);
    if (f < 0)
      return null;
    u = n.resolve(f);
  }
  if (!d) {
    let f = t == "pointer" || e.state.selection.head < s.pos && !o ? 1 : -1;
    d = uQ(e, u, s, f);
  }
  return d;
}
function sQ(e) {
  return e.editable ? e.hasFocus() : Y4e(e) && document.activeElement && document.activeElement.contains(e.dom);
}
function T_(e, t = !1) {
  let r = e.state.selection;
  if (V4e(e, r), !!sQ(e)) {
    if (!t && e.input.mouseDown && e.input.mouseDown.allowDefault && qp) {
      let n = e.domSelectionRange(), i = e.domObserver.currentSelection;
      if (n.anchorNode && i.anchorNode && nQ(n.anchorNode, n.anchorOffset, i.anchorNode, i.anchorOffset)) {
        e.input.mouseDown.delayedSelectionSync = !0, e.domObserver.setCurSelection();
        return;
      }
    }
    if (e.domObserver.disconnectSelection(), e.cursorWrapper)
      W4e(e);
    else {
      let { anchor: n, head: i } = r, o, a;
      yj && !(r instanceof pr) && (r.$from.parent.inlineContent || (o = xj(e, r.from)), !r.empty && !r.$from.parent.inlineContent && (a = xj(e, r.to))), e.docView.setSelection(n, i, e.root, t), yj && (o && wj(o), a && wj(a)), r.visible ? e.dom.classList.remove("ProseMirror-hideselection") : (e.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && H4e(e));
    }
    e.domObserver.setCurSelection(), e.domObserver.connectSelection();
  }
}
const yj = bh || qp && F4e < 63;
function xj(e, t) {
  let { node: r, offset: n } = e.docView.domFromPos(t, 0), i = n < r.childNodes.length ? r.childNodes[n] : null, o = n ? r.childNodes[n - 1] : null;
  if (bh && i && i.contentEditable == "false")
    return gN(i);
  if ((!i || i.contentEditable == "false") && (!o || o.contentEditable == "false")) {
    if (i)
      return gN(i);
    if (o)
      return gN(o);
  }
}
function gN(e) {
  return e.contentEditable = "true", bh && e.draggable && (e.draggable = !1, e.wasDraggable = !0), e;
}
function wj(e) {
  e.contentEditable = "false", e.wasDraggable && (e.draggable = !0, e.wasDraggable = null);
}
function H4e(e) {
  let t = e.dom.ownerDocument;
  t.removeEventListener("selectionchange", e.input.hideSelectionGuard);
  let r = e.domSelectionRange(), n = r.anchorNode, i = r.anchorOffset;
  t.addEventListener("selectionchange", e.input.hideSelectionGuard = () => {
    (r.anchorNode != n || r.anchorOffset != i) && (t.removeEventListener("selectionchange", e.input.hideSelectionGuard), setTimeout(() => {
      (!sQ(e) || e.state.selection.visible) && e.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function W4e(e) {
  let t = e.domSelection(), r = document.createRange(), n = e.cursorWrapper.dom, i = n.nodeName == "IMG";
  i ? r.setEnd(n.parentNode, Ab(n) + 1) : r.setEnd(n, 0), r.collapse(!1), t.removeAllRanges(), t.addRange(r), !i && !e.state.selection.visible && Eb && lQ <= 11 && (n.disabled = !0, n.disabled = !1);
}
function V4e(e, t) {
  if (t instanceof Bt) {
    let r = e.docView.descAt(t.from);
    r != e.lastSelectedViewDesc && (Mj(e), r && r.selectNode(), e.lastSelectedViewDesc = r);
  } else
    Mj(e);
}
function Mj(e) {
  e.lastSelectedViewDesc && (e.lastSelectedViewDesc.parent && e.lastSelectedViewDesc.deselectNode(), e.lastSelectedViewDesc = void 0);
}
function uQ(e, t, r, n) {
  return e.someProp("createSelectionBetween", (i) => i(e, t, r)) || pr.between(t, r, n);
}
function Y4e(e) {
  let t = e.domSelectionRange();
  if (!t.anchorNode)
    return !1;
  try {
    return e.dom.contains(t.anchorNode.nodeType == 3 ? t.anchorNode.parentNode : t.anchorNode) && (e.editable || e.dom.contains(t.focusNode.nodeType == 3 ? t.focusNode.parentNode : t.focusNode));
  } catch {
    return !1;
  }
}
function P$(e, t) {
  let { $anchor: r, $head: n } = e.selection, i = t > 0 ? r.max(n) : r.min(n), o = i.parent.inlineContent ? i.depth ? e.doc.resolve(t > 0 ? i.after() : i.before()) : null : i;
  return o && Ar.findFrom(o, t);
}
function Ef(e, t) {
  return e.dispatch(e.state.tr.setSelection(t).scrollIntoView()), !0;
}
function Cj(e, t, r) {
  let n = e.state.selection;
  if (n instanceof pr) {
    if (!n.empty || r.indexOf("s") > -1)
      return !1;
    if (e.endOfTextblock(t > 0 ? "right" : "left")) {
      let i = P$(e.state, t);
      return i && i instanceof Bt ? Ef(e, i) : !1;
    } else if (!(Xa && r.indexOf("m") > -1)) {
      let i = n.$head, o = i.textOffset ? null : t < 0 ? i.nodeBefore : i.nodeAfter, a;
      if (!o || o.isText)
        return !1;
      let s = t < 0 ? i.pos - o.nodeSize : i.pos;
      return o.isAtom || (a = e.docView.descAt(s)) && !a.contentDOM ? Bt.isSelectable(o) ? Ef(e, new Bt(t < 0 ? e.state.doc.resolve(i.pos - o.nodeSize) : i)) : S_ ? Ef(e, new pr(e.state.doc.resolve(t < 0 ? s : s + o.nodeSize))) : !1 : !1;
    }
  } else {
    if (n instanceof Bt && n.node.isInline)
      return Ef(e, new pr(t > 0 ? n.$to : n.$from));
    {
      let i = P$(e.state, t);
      return i ? Ef(e, i) : !1;
    }
  }
}
function Ax(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function a0(e) {
  let t = e.pmViewDesc;
  return t && t.size == 0 && (e.nextSibling || e.nodeName != "BR");
}
function mN(e) {
  let t = e.domSelectionRange(), r = t.focusNode, n = t.focusOffset;
  if (!r)
    return;
  let i, o, a = !1;
  for (oC && r.nodeType == 1 && n < Ax(r) && a0(r.childNodes[n]) && (a = !0); ; )
    if (n > 0) {
      if (r.nodeType != 1)
        break;
      {
        let s = r.childNodes[n - 1];
        if (a0(s))
          i = r, o = --n;
        else if (s.nodeType == 3)
          r = s, n = r.nodeValue.length;
        else
          break;
      }
    } else {
      if (cQ(r))
        break;
      {
        let s = r.previousSibling;
        for (; s && a0(s); )
          i = r.parentNode, o = Ab(s), s = s.previousSibling;
        if (s)
          r = s, n = Ax(r);
        else {
          if (r = r.parentNode, r == e.dom)
            break;
          n = 0;
        }
      }
    }
  a ? R$(e, r, n) : i && R$(e, i, o);
}
function vN(e) {
  let t = e.domSelectionRange(), r = t.focusNode, n = t.focusOffset;
  if (!r)
    return;
  let i = Ax(r), o, a;
  for (; ; )
    if (n < i) {
      if (r.nodeType != 1)
        break;
      let s = r.childNodes[n];
      if (a0(s))
        o = r, a = ++n;
      else
        break;
    } else {
      if (cQ(r))
        break;
      {
        let s = r.nextSibling;
        for (; s && a0(s); )
          o = s.parentNode, a = Ab(s) + 1, s = s.nextSibling;
        if (s)
          r = s, n = 0, i = Ax(r);
        else {
          if (r = r.parentNode, r == e.dom)
            break;
          n = i = 0;
        }
      }
    }
  o && R$(e, o, a);
}
function cQ(e) {
  let t = e.pmViewDesc;
  return t && t.node && t.node.isBlock;
}
function R$(e, t, r) {
  let n = e.domSelection();
  if (iQ(n)) {
    let o = document.createRange();
    o.setEnd(t, r), o.setStart(t, r), n.removeAllRanges(), n.addRange(o);
  } else
    n.extend && n.extend(t, r);
  e.domObserver.setCurSelection();
  let { state: i } = e;
  setTimeout(() => {
    e.state == i && T_(e);
  }, 50);
}
function Sj(e, t, r) {
  let n = e.state.selection;
  if (n instanceof pr && !n.empty || r.indexOf("s") > -1 || Xa && r.indexOf("m") > -1)
    return !1;
  let { $from: i, $to: o } = n;
  if (!i.parent.inlineContent || e.endOfTextblock(t < 0 ? "up" : "down")) {
    let a = P$(e.state, t);
    if (a && a instanceof Bt)
      return Ef(e, a);
  }
  if (!i.parent.inlineContent) {
    let a = t < 0 ? i : o, s = n instanceof ol ? Ar.near(a, t) : Ar.findFrom(a, t);
    return s ? Ef(e, s) : !1;
  }
  return !1;
}
function Tj(e, t) {
  if (!(e.state.selection instanceof pr))
    return !0;
  let { $head: r, $anchor: n, empty: i } = e.state.selection;
  if (!r.sameParent(n))
    return !0;
  if (!i)
    return !1;
  if (e.endOfTextblock(t > 0 ? "forward" : "backward"))
    return !0;
  let o = !r.textOffset && (t < 0 ? r.nodeBefore : r.nodeAfter);
  if (o && !o.isText) {
    let a = e.state.tr;
    return t < 0 ? a.delete(r.pos - o.nodeSize, r.pos) : a.delete(r.pos, r.pos + o.nodeSize), e.dispatch(a), !0;
  }
  return !1;
}
function kj(e, t, r) {
  e.domObserver.stop(), t.contentEditable = r, e.domObserver.start();
}
function Q4e(e) {
  if (!bh || e.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: t, focusOffset: r } = e.domSelectionRange();
  if (t && t.nodeType == 1 && r == 0 && t.firstChild && t.firstChild.contentEditable == "false") {
    let n = t.firstChild;
    kj(e, n, "true"), setTimeout(() => kj(e, n, "false"), 20);
  }
  return !1;
}
function q4e(e) {
  let t = "";
  return e.ctrlKey && (t += "c"), e.metaKey && (t += "m"), e.altKey && (t += "a"), e.shiftKey && (t += "s"), t;
}
function G4e(e, t) {
  let r = t.keyCode, n = q4e(t);
  return r == 8 || Xa && r == 72 && n == "c" ? Tj(e, -1) || mN(e) : r == 46 || Xa && r == 68 && n == "c" ? Tj(e, 1) || vN(e) : r == 13 || r == 27 ? !0 : r == 37 || Xa && r == 66 && n == "c" ? Cj(e, -1, n) || mN(e) : r == 39 || Xa && r == 70 && n == "c" ? Cj(e, 1, n) || vN(e) : r == 38 || Xa && r == 80 && n == "c" ? Sj(e, -1, n) || mN(e) : r == 40 || Xa && r == 78 && n == "c" ? Q4e(e) || Sj(e, 1, n) || vN(e) : n == (Xa ? "m" : "c") && (r == 66 || r == 73 || r == 89 || r == 90);
}
function dQ(e, t) {
  e.someProp("transformCopied", (m) => {
    t = m(t, e);
  });
  let r = [], { content: n, openStart: i, openEnd: o } = t;
  for (; i > 1 && o > 1 && n.childCount == 1 && n.firstChild.childCount == 1; ) {
    i--, o--;
    let m = n.firstChild;
    r.push(m.type.name, m.attrs != m.type.defaultAttrs ? m.attrs : null), n = m.content;
  }
  let a = e.someProp("clipboardSerializer") || _u.fromSchema(e.state.schema), s = vQ(), u = s.createElement("div");
  u.appendChild(a.serializeFragment(n, { document: s }));
  let d = u.firstChild, f, h = 0;
  for (; d && d.nodeType == 1 && (f = mQ[d.nodeName.toLowerCase()]); ) {
    for (let m = f.length - 1; m >= 0; m--) {
      let v = s.createElement(f[m]);
      for (; u.firstChild; )
        v.appendChild(u.firstChild);
      u.appendChild(v), h++;
    }
    d = u.firstChild;
  }
  d && d.nodeType == 1 && d.setAttribute("data-pm-slice", `${i} ${o}${h ? ` -${h}` : ""} ${JSON.stringify(r)}`);
  let g = e.someProp("clipboardTextSerializer", (m) => m(t, e)) || t.content.textBetween(0, t.content.size, `

`);
  return { dom: u, text: g };
}
function fQ(e, t, r, n, i) {
  let o = i.parent.type.spec.code, a, s;
  if (!r && !t)
    return null;
  let u = t && (n || o || !r);
  if (u) {
    if (e.someProp("transformPastedText", (g) => {
      t = g(t, o || n, e);
    }), o)
      return t ? new Ot(bt.from(e.state.schema.text(t.replace(/\r\n?/g, `
`))), 0, 0) : Ot.empty;
    let h = e.someProp("clipboardTextParser", (g) => g(t, i, n, e));
    if (h)
      s = h;
    else {
      let g = i.marks(), { schema: m } = e.state, v = _u.fromSchema(m);
      a = document.createElement("div"), t.split(/(?:\r\n?|\n)+/).forEach((w) => {
        let x = a.appendChild(document.createElement("p"));
        w && x.appendChild(v.serializeNode(m.text(w, g)));
      });
    }
  } else
    e.someProp("transformPastedHTML", (h) => {
      r = h(r, e);
    }), a = X4e(r), S_ && J4e(a);
  let d = a && a.querySelector("[data-pm-slice]"), f = d && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(d.getAttribute("data-pm-slice") || "");
  if (f && f[3])
    for (let h = +f[3]; h > 0; h--) {
      let g = a.firstChild;
      for (; g && g.nodeType != 1; )
        g = g.nextSibling;
      if (!g)
        break;
      a = g;
    }
  if (s || (s = (e.someProp("clipboardParser") || e.someProp("domParser") || Tp.fromSchema(e.state.schema)).parseSlice(a, {
    preserveWhitespace: !!(u || f),
    context: i,
    ruleFromNode(g) {
      return g.nodeName == "BR" && !g.nextSibling && g.parentNode && !Z4e.test(g.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), f)
    s = e_e(Dj(s, +f[1], +f[2]), f[4]);
  else if (s = Ot.maxOpen(K4e(s.content, i), !0), s.openStart || s.openEnd) {
    let h = 0, g = 0;
    for (let m = s.content.firstChild; h < s.openStart && !m.type.spec.isolating; h++, m = m.firstChild)
      ;
    for (let m = s.content.lastChild; g < s.openEnd && !m.type.spec.isolating; g++, m = m.lastChild)
      ;
    s = Dj(s, h, g);
  }
  return e.someProp("transformPasted", (h) => {
    s = h(s, e);
  }), s;
}
const Z4e = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function K4e(e, t) {
  if (e.childCount < 2)
    return e;
  for (let r = t.depth; r >= 0; r--) {
    let i = t.node(r).contentMatchAt(t.index(r)), o, a = [];
    if (e.forEach((s) => {
      if (!a)
        return;
      let u = i.findWrapping(s.type), d;
      if (!u)
        return a = null;
      if (d = a.length && o.length && pQ(u, o, s, a[a.length - 1], 0))
        a[a.length - 1] = d;
      else {
        a.length && (a[a.length - 1] = gQ(a[a.length - 1], o.length));
        let f = hQ(s, u);
        a.push(f), i = i.matchType(f.type), o = u;
      }
    }), a)
      return bt.from(a);
  }
  return e;
}
function hQ(e, t, r = 0) {
  for (let n = t.length - 1; n >= r; n--)
    e = t[n].create(null, bt.from(e));
  return e;
}
function pQ(e, t, r, n, i) {
  if (i < e.length && i < t.length && e[i] == t[i]) {
    let o = pQ(e, t, r, n.lastChild, i + 1);
    if (o)
      return n.copy(n.content.replaceChild(n.childCount - 1, o));
    if (n.contentMatchAt(n.childCount).matchType(i == e.length - 1 ? r.type : e[i + 1]))
      return n.copy(n.content.append(bt.from(hQ(r, e, i + 1))));
  }
}
function gQ(e, t) {
  if (t == 0)
    return e;
  let r = e.content.replaceChild(e.childCount - 1, gQ(e.lastChild, t - 1)), n = e.contentMatchAt(e.childCount).fillBefore(bt.empty, !0);
  return e.copy(r.append(n));
}
function j$(e, t, r, n, i, o) {
  let a = t < 0 ? e.firstChild : e.lastChild, s = a.content;
  return i < n - 1 && (s = j$(s, t, r, n, i + 1, o)), i >= r && (s = t < 0 ? a.contentMatchAt(0).fillBefore(s, e.childCount > 1 || o <= i).append(s) : s.append(a.contentMatchAt(a.childCount).fillBefore(bt.empty, !0))), e.replaceChild(t < 0 ? 0 : e.childCount - 1, a.copy(s));
}
function Dj(e, t, r) {
  return t < e.openStart && (e = new Ot(j$(e.content, -1, t, e.openStart, 0, e.openEnd), t, e.openEnd)), r < e.openEnd && (e = new Ot(j$(e.content, 1, r, e.openEnd, 0, 0), e.openStart, r)), e;
}
const mQ = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let Aj = null;
function vQ() {
  return Aj || (Aj = document.implementation.createHTMLDocument("title"));
}
function X4e(e) {
  let t = /^(\s*<meta [^>]*>)*/.exec(e);
  t && (e = e.slice(t[0].length));
  let r = vQ().createElement("div"), n = /<([a-z][^>\s]+)/i.exec(e), i;
  if ((i = n && mQ[n[1].toLowerCase()]) && (e = i.map((o) => "<" + o + ">").join("") + e + i.map((o) => "</" + o + ">").reverse().join("")), r.innerHTML = e, i)
    for (let o = 0; o < i.length; o++)
      r = r.querySelector(i[o]) || r;
  return r;
}
function J4e(e) {
  let t = e.querySelectorAll(qp ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let r = 0; r < t.length; r++) {
    let n = t[r];
    n.childNodes.length == 1 && n.textContent == " " && n.parentNode && n.parentNode.replaceChild(e.ownerDocument.createTextNode(" "), n);
  }
}
function e_e(e, t) {
  if (!e.size)
    return e;
  let r = e.content.firstChild.type.schema, n;
  try {
    n = JSON.parse(t);
  } catch {
    return e;
  }
  let { content: i, openStart: o, openEnd: a } = e;
  for (let s = n.length - 2; s >= 0; s -= 2) {
    let u = r.nodes[n[s]];
    if (!u || u.hasRequiredAttrs())
      break;
    i = bt.from(u.create(n[s + 1], i)), o++, a++;
  }
  return new Ot(i, o, a);
}
const Jl = {}, Ba = {};
function dc(e, t) {
  e.input.lastSelectionOrigin = t, e.input.lastSelectionTime = Date.now();
}
Ba.keydown = (e, t) => {
  let r = t;
  if (e.input.shiftKey = r.keyCode == 16 || r.shiftKey, !yQ(e, r) && (e.input.lastKeyCode = r.keyCode, e.input.lastKeyCodeTime = Date.now(), !(Ib && qp && r.keyCode == 13)))
    if (r.keyCode != 229 && e.domObserver.forceFlush(), C_ && r.keyCode == 13 && !r.ctrlKey && !r.altKey && !r.metaKey) {
      let n = Date.now();
      e.input.lastIOSEnter = n, e.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        e.input.lastIOSEnter == n && (e.someProp("handleKeyDown", (i) => i(e, oQ(13, "Enter"))), e.input.lastIOSEnter = 0);
      }, 200);
    } else
      e.someProp("handleKeyDown", (n) => n(e, r)) || G4e(e, r) ? r.preventDefault() : dc(e, "key");
};
Ba.keyup = (e, t) => {
  t.keyCode == 16 && (e.input.shiftKey = !1);
};
Ba.keypress = (e, t) => {
  let r = t;
  if (yQ(e, r) || !r.charCode || r.ctrlKey && !r.altKey || Xa && r.metaKey)
    return;
  if (e.someProp("handleKeyPress", (i) => i(e, r))) {
    r.preventDefault();
    return;
  }
  let n = e.state.selection;
  if (!(n instanceof pr) || !n.$from.sameParent(n.$to)) {
    let i = String.fromCharCode(r.charCode);
    !/[\r\n]/.test(i) && !e.someProp("handleTextInput", (o) => o(e, n.$from.pos, n.$to.pos, i)) && e.dispatch(e.state.tr.insertText(i).scrollIntoView()), r.preventDefault();
  }
};
function aC(e) {
  return { left: e.clientX, top: e.clientY };
}
function t_e(e, t) {
  let r = t.x - e.clientX, n = t.y - e.clientY;
  return r * r + n * n < 100;
}
function k_(e, t, r, n, i) {
  if (n == -1)
    return !1;
  let o = e.state.doc.resolve(n);
  for (let a = o.depth + 1; a > 0; a--)
    if (e.someProp(t, (s) => a > o.depth ? s(e, r, o.nodeAfter, o.before(a), i, !0) : s(e, r, o.node(a), o.before(a), i, !1)))
      return !0;
  return !1;
}
function up(e, t, r) {
  e.focused || e.focus();
  let n = e.state.tr.setSelection(t);
  r == "pointer" && n.setMeta("pointer", !0), e.dispatch(n);
}
function r_e(e, t) {
  if (t == -1)
    return !1;
  let r = e.state.doc.resolve(t), n = r.nodeAfter;
  return n && n.isAtom && Bt.isSelectable(n) ? (up(e, new Bt(r), "pointer"), !0) : !1;
}
function n_e(e, t) {
  if (t == -1)
    return !1;
  let r = e.state.selection, n, i;
  r instanceof Bt && (n = r.node);
  let o = e.state.doc.resolve(t);
  for (let a = o.depth + 1; a > 0; a--) {
    let s = a > o.depth ? o.nodeAfter : o.node(a);
    if (Bt.isSelectable(s)) {
      n && r.$from.depth > 0 && a >= r.$from.depth && o.before(r.$from.depth + 1) == r.$from.pos ? i = o.before(r.$from.depth) : i = o.before(a);
      break;
    }
  }
  return i != null ? (up(e, Bt.create(e.state.doc, i), "pointer"), !0) : !1;
}
function i_e(e, t, r, n, i) {
  return k_(e, "handleClickOn", t, r, n) || e.someProp("handleClick", (o) => o(e, t, n)) || (i ? n_e(e, r) : r_e(e, r));
}
function o_e(e, t, r, n) {
  return k_(e, "handleDoubleClickOn", t, r, n) || e.someProp("handleDoubleClick", (i) => i(e, t, n));
}
function a_e(e, t, r, n) {
  return k_(e, "handleTripleClickOn", t, r, n) || e.someProp("handleTripleClick", (i) => i(e, t, n)) || l_e(e, r, n);
}
function l_e(e, t, r) {
  if (r.button != 0)
    return !1;
  let n = e.state.doc;
  if (t == -1)
    return n.inlineContent ? (up(e, pr.create(n, 0, n.content.size), "pointer"), !0) : !1;
  let i = n.resolve(t);
  for (let o = i.depth + 1; o > 0; o--) {
    let a = o > i.depth ? i.nodeAfter : i.node(o), s = i.before(o);
    if (a.inlineContent)
      up(e, pr.create(n, s + 1, s + 1 + a.content.size), "pointer");
    else if (Bt.isSelectable(a))
      up(e, Bt.create(n, s), "pointer");
    else
      continue;
    return !0;
  }
}
function D_(e) {
  return Ex(e);
}
const bQ = Xa ? "metaKey" : "ctrlKey";
Jl.mousedown = (e, t) => {
  let r = t;
  e.input.shiftKey = r.shiftKey;
  let n = D_(e), i = Date.now(), o = "singleClick";
  i - e.input.lastClick.time < 500 && t_e(r, e.input.lastClick) && !r[bQ] && (e.input.lastClick.type == "singleClick" ? o = "doubleClick" : e.input.lastClick.type == "doubleClick" && (o = "tripleClick")), e.input.lastClick = { time: i, x: r.clientX, y: r.clientY, type: o };
  let a = e.posAtCoords(aC(r));
  a && (o == "singleClick" ? (e.input.mouseDown && e.input.mouseDown.done(), e.input.mouseDown = new s_e(e, a, r, !!n)) : (o == "doubleClick" ? o_e : a_e)(e, a.pos, a.inside, r) ? r.preventDefault() : dc(e, "pointer"));
};
let s_e = class {
  constructor(t, r, n, i) {
    this.view = t, this.pos = r, this.event = n, this.flushed = i, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = t.state.doc, this.selectNode = !!n[bQ], this.allowDefault = n.shiftKey;
    let o, a;
    if (r.inside > -1)
      o = t.state.doc.nodeAt(r.inside), a = r.inside;
    else {
      let f = t.state.doc.resolve(r.pos);
      o = f.parent, a = f.depth ? f.before() : 0;
    }
    const s = i ? null : n.target, u = s ? t.docView.nearestDesc(s, !0) : null;
    this.target = u ? u.dom : null;
    let { selection: d } = t.state;
    (n.button == 0 && o.type.spec.draggable && o.type.spec.selectable !== !1 || d instanceof Bt && d.from <= a && d.to > a) && (this.mightDrag = {
      node: o,
      pos: a,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && oC && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), t.root.addEventListener("mouseup", this.up = this.up.bind(this)), t.root.addEventListener("mousemove", this.move = this.move.bind(this)), dc(t, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => T_(this.view)), this.view.input.mouseDown = null;
  }
  up(t) {
    if (this.done(), !this.view.dom.contains(t.target))
      return;
    let r = this.pos;
    this.view.state.doc != this.startDoc && (r = this.view.posAtCoords(aC(t))), this.updateAllowDefault(t), this.allowDefault || !r ? dc(this.view, "pointer") : i_e(this.view, r.pos, r.inside, t, this.selectNode) ? t.preventDefault() : t.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    bh && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    qp && !this.view.state.selection.visible && Math.min(Math.abs(r.pos - this.view.state.selection.from), Math.abs(r.pos - this.view.state.selection.to)) <= 2) ? (up(this.view, Ar.near(this.view.state.doc.resolve(r.pos)), "pointer"), t.preventDefault()) : dc(this.view, "pointer");
  }
  move(t) {
    this.updateAllowDefault(t), dc(this.view, "pointer"), t.buttons == 0 && this.done();
  }
  updateAllowDefault(t) {
    !this.allowDefault && (Math.abs(this.event.x - t.clientX) > 4 || Math.abs(this.event.y - t.clientY) > 4) && (this.allowDefault = !0);
  }
};
Jl.touchstart = (e) => {
  e.input.lastTouch = Date.now(), D_(e), dc(e, "pointer");
};
Jl.touchmove = (e) => {
  e.input.lastTouch = Date.now(), dc(e, "pointer");
};
Jl.contextmenu = (e) => D_(e);
function yQ(e, t) {
  return e.composing ? !0 : bh && Math.abs(t.timeStamp - e.input.compositionEndedAt) < 500 ? (e.input.compositionEndedAt = -2e8, !0) : !1;
}
const u_e = Ib ? 5e3 : -1;
Ba.compositionstart = Ba.compositionupdate = (e) => {
  if (!e.composing) {
    e.domObserver.flush();
    let { state: t } = e, r = t.selection.$from;
    if (t.selection.empty && (t.storedMarks || !r.textOffset && r.parentOffset && r.nodeBefore.marks.some((n) => n.type.spec.inclusive === !1)))
      e.markCursor = e.state.storedMarks || r.marks(), Ex(e, !0), e.markCursor = null;
    else if (Ex(e), oC && t.selection.empty && r.parentOffset && !r.textOffset && r.nodeBefore.marks.length) {
      let n = e.domSelectionRange();
      for (let i = n.focusNode, o = n.focusOffset; i && i.nodeType == 1 && o != 0; ) {
        let a = o < 0 ? i.lastChild : i.childNodes[o - 1];
        if (!a)
          break;
        if (a.nodeType == 3) {
          e.domSelection().collapse(a, a.nodeValue.length);
          break;
        } else
          i = a, o = -1;
      }
    }
    e.input.composing = !0;
  }
  xQ(e, u_e);
};
Ba.compositionend = (e, t) => {
  e.composing && (e.input.composing = !1, e.input.compositionEndedAt = t.timeStamp, xQ(e, 20));
};
function xQ(e, t) {
  clearTimeout(e.input.composingTimeout), t > -1 && (e.input.composingTimeout = setTimeout(() => Ex(e), t));
}
function c_e(e) {
  for (e.composing && (e.input.composing = !1, e.input.compositionEndedAt = d_e()); e.input.compositionNodes.length > 0; )
    e.input.compositionNodes.pop().markParentsDirty();
}
function d_e() {
  let e = document.createEvent("Event");
  return e.initEvent("event", !0, !0), e.timeStamp;
}
function Ex(e, t = !1) {
  if (!(Ib && e.domObserver.flushingSoon >= 0)) {
    if (e.domObserver.forceFlush(), c_e(e), t || e.docView && e.docView.dirty) {
      let r = U4e(e);
      return r && !r.eq(e.state.selection) ? e.dispatch(e.state.tr.setSelection(r)) : e.updateState(e.state), !0;
    }
    return !1;
  }
}
function f_e(e, t) {
  if (!e.dom.parentNode)
    return;
  let r = e.dom.parentNode.appendChild(document.createElement("div"));
  r.appendChild(t), r.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let n = getSelection(), i = document.createRange();
  i.selectNodeContents(t), e.dom.blur(), n.removeAllRanges(), n.addRange(i), setTimeout(() => {
    r.parentNode && r.parentNode.removeChild(r), e.focus();
  }, 50);
}
const Ap = Eb && lQ < 15 || C_ && B4e < 604;
Jl.copy = Ba.cut = (e, t) => {
  let r = t, n = e.state.selection, i = r.type == "cut";
  if (n.empty)
    return;
  let o = Ap ? null : r.clipboardData, a = n.content(), { dom: s, text: u } = dQ(e, a);
  o ? (r.preventDefault(), o.clearData(), o.setData("text/html", s.innerHTML), o.setData("text/plain", u)) : f_e(e, s), i && e.dispatch(e.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function h_e(e) {
  return e.openStart == 0 && e.openEnd == 0 && e.content.childCount == 1 ? e.content.firstChild : null;
}
function p_e(e, t) {
  if (!e.dom.parentNode)
    return;
  let r = e.input.shiftKey || e.state.selection.$from.parent.type.spec.code, n = e.dom.parentNode.appendChild(document.createElement(r ? "textarea" : "div"));
  r || (n.contentEditable = "true"), n.style.cssText = "position: fixed; left: -10000px; top: 10px", n.focus(), setTimeout(() => {
    e.focus(), n.parentNode && n.parentNode.removeChild(n), r ? F$(e, n.value, null, e.input.shiftKey, t) : F$(e, n.textContent, n.innerHTML, e.input.shiftKey, t);
  }, 50);
}
function F$(e, t, r, n, i) {
  let o = fQ(e, t, r, n, e.state.selection.$from);
  if (e.someProp("handlePaste", (u) => u(e, i, o || Ot.empty)))
    return !0;
  if (!o)
    return !1;
  let a = h_e(o), s = a ? e.state.tr.replaceSelectionWith(a, e.input.shiftKey) : e.state.tr.replaceSelection(o);
  return e.dispatch(s.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
Ba.paste = (e, t) => {
  let r = t;
  if (e.composing && !Ib)
    return;
  let n = Ap ? null : r.clipboardData;
  n && F$(e, n.getData("text/plain"), n.getData("text/html"), e.input.shiftKey, r) ? r.preventDefault() : p_e(e, r);
};
let g_e = class {
  constructor(t, r) {
    this.slice = t, this.move = r;
  }
};
const wQ = Xa ? "altKey" : "ctrlKey";
Jl.dragstart = (e, t) => {
  let r = t, n = e.input.mouseDown;
  if (n && n.done(), !r.dataTransfer)
    return;
  let i = e.state.selection, o = i.empty ? null : e.posAtCoords(aC(r));
  if (!(o && o.pos >= i.from && o.pos <= (i instanceof Bt ? i.to - 1 : i.to))) {
    if (n && n.mightDrag)
      e.dispatch(e.state.tr.setSelection(Bt.create(e.state.doc, n.mightDrag.pos)));
    else if (r.target && r.target.nodeType == 1) {
      let d = e.docView.nearestDesc(r.target, !0);
      d && d.node.type.spec.draggable && d != e.docView && e.dispatch(e.state.tr.setSelection(Bt.create(e.state.doc, d.posBefore)));
    }
  }
  let a = e.state.selection.content(), { dom: s, text: u } = dQ(e, a);
  r.dataTransfer.clearData(), r.dataTransfer.setData(Ap ? "Text" : "text/html", s.innerHTML), r.dataTransfer.effectAllowed = "copyMove", Ap || r.dataTransfer.setData("text/plain", u), e.dragging = new g_e(a, !r[wQ]);
};
Jl.dragend = (e) => {
  let t = e.dragging;
  window.setTimeout(() => {
    e.dragging == t && (e.dragging = null);
  }, 50);
};
Ba.dragover = Ba.dragenter = (e, t) => t.preventDefault();
Ba.drop = (e, t) => {
  let r = t, n = e.dragging;
  if (e.dragging = null, !r.dataTransfer)
    return;
  let i = e.posAtCoords(aC(r));
  if (!i)
    return;
  let o = e.state.doc.resolve(i.pos), a = n && n.slice;
  a ? e.someProp("transformPasted", (v) => {
    a = v(a, e);
  }) : a = fQ(e, r.dataTransfer.getData(Ap ? "Text" : "text/plain"), Ap ? null : r.dataTransfer.getData("text/html"), !1, o);
  let s = !!(n && !r[wQ]);
  if (e.someProp("handleDrop", (v) => v(e, r, a || Ot.empty, s))) {
    r.preventDefault();
    return;
  }
  if (!a)
    return;
  r.preventDefault();
  let u = a ? qY(e.state.doc, o.pos, a) : o.pos;
  u == null && (u = o.pos);
  let d = e.state.tr;
  s && d.deleteSelection();
  let f = d.mapping.map(u), h = a.openStart == 0 && a.openEnd == 0 && a.content.childCount == 1, g = d.doc;
  if (h ? d.replaceRangeWith(f, f, a.content.firstChild) : d.replaceRange(f, f, a), d.doc.eq(g))
    return;
  let m = d.doc.resolve(f);
  if (h && Bt.isSelectable(a.content.firstChild) && m.nodeAfter && m.nodeAfter.sameMarkup(a.content.firstChild))
    d.setSelection(new Bt(m));
  else {
    let v = d.mapping.map(u);
    d.mapping.maps[d.mapping.maps.length - 1].forEach((w, x, y, C) => v = C), d.setSelection(uQ(e, m, d.doc.resolve(v)));
  }
  e.focus(), e.dispatch(d.setMeta("uiEvent", "drop"));
};
Jl.focus = (e) => {
  e.input.lastFocus = Date.now(), e.focused || (e.domObserver.stop(), e.dom.classList.add("ProseMirror-focused"), e.domObserver.start(), e.focused = !0, setTimeout(() => {
    e.docView && e.hasFocus() && !e.domObserver.currentSelection.eq(e.domSelectionRange()) && T_(e);
  }, 20));
};
Jl.blur = (e, t) => {
  let r = t;
  e.focused && (e.domObserver.stop(), e.dom.classList.remove("ProseMirror-focused"), e.domObserver.start(), r.relatedTarget && e.dom.contains(r.relatedTarget) && e.domObserver.currentSelection.clear(), e.focused = !1);
};
Jl.beforeinput = (e, t) => {
  if (qp && Ib && t.inputType == "deleteContentBackward") {
    e.domObserver.flushSoon();
    let { domChangeCount: n } = e.input;
    setTimeout(() => {
      if (e.input.domChangeCount != n || (e.dom.blur(), e.focus(), e.someProp("handleKeyDown", (o) => o(e, oQ(8, "Backspace")))))
        return;
      let { $cursor: i } = e.state.selection;
      i && i.pos > 0 && e.dispatch(e.state.tr.delete(i.pos - 1, i.pos).scrollIntoView());
    }, 50);
  }
};
for (let e in Ba)
  Jl[e] = Ba[e];
function B0(e, t) {
  if (e == t)
    return !0;
  for (let r in e)
    if (e[r] !== t[r])
      return !1;
  for (let r in t)
    if (!(r in e))
      return !1;
  return !0;
}
let m_e = class MQ {
  constructor(t, r) {
    this.toDOM = t, this.spec = r || Yf, this.side = this.spec.side || 0;
  }
  map(t, r, n, i) {
    let { pos: o, deleted: a } = t.mapResult(r.from + i, this.side < 0 ? -1 : 1);
    return a ? null : new Nb(o - n, o - n, this);
  }
  valid() {
    return !0;
  }
  eq(t) {
    return this == t || t instanceof MQ && (this.spec.key && this.spec.key == t.spec.key || this.toDOM == t.toDOM && B0(this.spec, t.spec));
  }
  destroy(t) {
    this.spec.destroy && this.spec.destroy(t);
  }
}, l0 = class B$ {
  constructor(t, r) {
    this.attrs = t, this.spec = r || Yf;
  }
  map(t, r, n, i) {
    let o = t.map(r.from + i, this.spec.inclusiveStart ? -1 : 1) - n, a = t.map(r.to + i, this.spec.inclusiveEnd ? 1 : -1) - n;
    return o >= a ? null : new Nb(o, a, this);
  }
  valid(t, r) {
    return r.from < r.to;
  }
  eq(t) {
    return this == t || t instanceof B$ && B0(this.attrs, t.attrs) && B0(this.spec, t.spec);
  }
  static is(t) {
    return t.type instanceof B$;
  }
  destroy() {
  }
}, v_e = class CQ {
  constructor(t, r) {
    this.attrs = t, this.spec = r || Yf;
  }
  map(t, r, n, i) {
    let o = t.mapResult(r.from + i, 1);
    if (o.deleted)
      return null;
    let a = t.mapResult(r.to + i, -1);
    return a.deleted || a.pos <= o.pos ? null : new Nb(o.pos - n, a.pos - n, this);
  }
  valid(t, r) {
    let { index: n, offset: i } = t.content.findIndex(r.from), o;
    return i == r.from && !(o = t.child(n)).isText && i + o.nodeSize == r.to;
  }
  eq(t) {
    return this == t || t instanceof CQ && B0(this.attrs, t.attrs) && B0(this.spec, t.spec);
  }
  destroy() {
  }
}, Nb = class Yv {
  /**
  @internal
  */
  constructor(t, r, n) {
    this.from = t, this.to = r, this.type = n;
  }
  /**
  @internal
  */
  copy(t, r) {
    return new Yv(t, r, this.type);
  }
  /**
  @internal
  */
  eq(t, r = 0) {
    return this.type.eq(t.type) && this.from + r == t.from && this.to + r == t.to;
  }
  /**
  @internal
  */
  map(t, r, n) {
    return this.type.map(t, this, r, n);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(t, r, n) {
    return new Yv(t, t, new m_e(r, n));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(t, r, n, i) {
    return new Yv(t, r, new l0(n, i));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(t, r, n, i) {
    return new Yv(t, r, new v_e(n, i));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof l0;
  }
};
const Wh = [], Yf = {};
let Ms = class rc {
  /**
  @internal
  */
  constructor(t, r) {
    this.local = t.length ? t : Wh, this.children = r.length ? r : Wh;
  }
  /**
  Create a set of decorations, using the structure of the given
  document.
  */
  static create(t, r) {
    return r.length ? Ix(r, t, 0, Yf) : qo;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(t, r, n) {
    let i = [];
    return this.findInner(t ?? 0, r ?? 1e9, i, 0, n), i;
  }
  findInner(t, r, n, i, o) {
    for (let a = 0; a < this.local.length; a++) {
      let s = this.local[a];
      s.from <= r && s.to >= t && (!o || o(s.spec)) && n.push(s.copy(s.from + i, s.to + i));
    }
    for (let a = 0; a < this.children.length; a += 3)
      if (this.children[a] < r && this.children[a + 1] > t) {
        let s = this.children[a] + 1;
        this.children[a + 2].findInner(t - s, r - s, n, i + s, o);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(t, r, n) {
    return this == qo || t.maps.length == 0 ? this : this.mapInner(t, r, 0, 0, n || Yf);
  }
  /**
  @internal
  */
  mapInner(t, r, n, i, o) {
    let a;
    for (let s = 0; s < this.local.length; s++) {
      let u = this.local[s].map(t, n, i);
      u && u.type.valid(r, u) ? (a || (a = [])).push(u) : o.onRemove && o.onRemove(this.local[s].spec);
    }
    return this.children.length ? y_e(this.children, a || [], t, r, n, i, o) : a ? new rc(a.sort(Qf), Wh) : qo;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Needs access to the current document to
  create the appropriate tree structure.
  */
  add(t, r) {
    return r.length ? this == qo ? rc.create(t, r) : this.addInner(t, r, 0) : this;
  }
  addInner(t, r, n) {
    let i, o = 0;
    t.forEach((s, u) => {
      let d = u + n, f;
      if (f = TQ(r, s, d)) {
        for (i || (i = this.children.slice()); o < i.length && i[o] < u; )
          o += 3;
        i[o] == u ? i[o + 2] = i[o + 2].addInner(s, f, d + 1) : i.splice(o, 0, u, u + s.nodeSize, Ix(f, s, d + 1, Yf)), o += 3;
      }
    });
    let a = SQ(o ? kQ(r) : r, -n);
    for (let s = 0; s < a.length; s++)
      a[s].type.valid(t, a[s]) || a.splice(s--, 1);
    return new rc(a.length ? this.local.concat(a).sort(Qf) : this.local, i || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(t) {
    return t.length == 0 || this == qo ? this : this.removeInner(t, 0);
  }
  removeInner(t, r) {
    let n = this.children, i = this.local;
    for (let o = 0; o < n.length; o += 3) {
      let a, s = n[o] + r, u = n[o + 1] + r;
      for (let f = 0, h; f < t.length; f++)
        (h = t[f]) && h.from > s && h.to < u && (t[f] = null, (a || (a = [])).push(h));
      if (!a)
        continue;
      n == this.children && (n = this.children.slice());
      let d = n[o + 2].removeInner(a, s + 1);
      d != qo ? n[o + 2] = d : (n.splice(o, 3), o -= 3);
    }
    if (i.length) {
      for (let o = 0, a; o < t.length; o++)
        if (a = t[o])
          for (let s = 0; s < i.length; s++)
            i[s].eq(a, r) && (i == this.local && (i = this.local.slice()), i.splice(s--, 1));
    }
    return n == this.children && i == this.local ? this : i.length || n.length ? new rc(i, n) : qo;
  }
  /**
  @internal
  */
  forChild(t, r) {
    if (this == qo)
      return this;
    if (r.isLeaf)
      return rc.empty;
    let n, i;
    for (let s = 0; s < this.children.length; s += 3)
      if (this.children[s] >= t) {
        this.children[s] == t && (n = this.children[s + 2]);
        break;
      }
    let o = t + 1, a = o + r.content.size;
    for (let s = 0; s < this.local.length; s++) {
      let u = this.local[s];
      if (u.from < a && u.to > o && u.type instanceof l0) {
        let d = Math.max(o, u.from) - o, f = Math.min(a, u.to) - o;
        d < f && (i || (i = [])).push(u.copy(d, f));
      }
    }
    if (i) {
      let s = new rc(i.sort(Qf), Wh);
      return n ? new b_e([s, n]) : s;
    }
    return n || qo;
  }
  /**
  @internal
  */
  eq(t) {
    if (this == t)
      return !0;
    if (!(t instanceof rc) || this.local.length != t.local.length || this.children.length != t.children.length)
      return !1;
    for (let r = 0; r < this.local.length; r++)
      if (!this.local[r].eq(t.local[r]))
        return !1;
    for (let r = 0; r < this.children.length; r += 3)
      if (this.children[r] != t.children[r] || this.children[r + 1] != t.children[r + 1] || !this.children[r + 2].eq(t.children[r + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(t) {
    return A_(this.localsInner(t));
  }
  /**
  @internal
  */
  localsInner(t) {
    if (this == qo)
      return Wh;
    if (t.inlineContent || !this.local.some(l0.is))
      return this.local;
    let r = [];
    for (let n = 0; n < this.local.length; n++)
      this.local[n].type instanceof l0 || r.push(this.local[n]);
    return r;
  }
};
Ms.empty = new Ms([], []);
Ms.removeOverlap = A_;
const qo = Ms.empty;
let b_e = class Vh {
  constructor(t) {
    this.members = t;
  }
  map(t, r) {
    const n = this.members.map((i) => i.map(t, r, Yf));
    return Vh.from(n);
  }
  forChild(t, r) {
    if (r.isLeaf)
      return Ms.empty;
    let n = [];
    for (let i = 0; i < this.members.length; i++) {
      let o = this.members[i].forChild(t, r);
      o != qo && (o instanceof Vh ? n = n.concat(o.members) : n.push(o));
    }
    return Vh.from(n);
  }
  eq(t) {
    if (!(t instanceof Vh) || t.members.length != this.members.length)
      return !1;
    for (let r = 0; r < this.members.length; r++)
      if (!this.members[r].eq(t.members[r]))
        return !1;
    return !0;
  }
  locals(t) {
    let r, n = !0;
    for (let i = 0; i < this.members.length; i++) {
      let o = this.members[i].localsInner(t);
      if (o.length)
        if (!r)
          r = o;
        else {
          n && (r = r.slice(), n = !1);
          for (let a = 0; a < o.length; a++)
            r.push(o[a]);
        }
    }
    return r ? A_(n ? r : r.sort(Qf)) : Wh;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(t) {
    switch (t.length) {
      case 0:
        return qo;
      case 1:
        return t[0];
      default:
        return new Vh(t.every((r) => r instanceof Ms) ? t : t.reduce((r, n) => r.concat(n instanceof Ms ? n : n.members), []));
    }
  }
};
function y_e(e, t, r, n, i, o, a) {
  let s = e.slice();
  for (let d = 0, f = o; d < r.maps.length; d++) {
    let h = 0;
    r.maps[d].forEach((g, m, v, w) => {
      let x = w - v - (m - g);
      for (let y = 0; y < s.length; y += 3) {
        let C = s[y + 1];
        if (C < 0 || g > C + f - h)
          continue;
        let S = s[y] + f - h;
        m >= S ? s[y + 1] = g <= S ? -2 : -1 : v >= i && x && (s[y] += x, s[y + 1] += x);
      }
      h += x;
    }), f = r.maps[d].map(f, -1);
  }
  let u = !1;
  for (let d = 0; d < s.length; d += 3)
    if (s[d + 1] < 0) {
      if (s[d + 1] == -2) {
        u = !0, s[d + 1] = -1;
        continue;
      }
      let f = r.map(e[d] + o), h = f - i;
      if (h < 0 || h >= n.content.size) {
        u = !0;
        continue;
      }
      let g = r.map(e[d + 1] + o, -1), m = g - i, { index: v, offset: w } = n.content.findIndex(h), x = n.maybeChild(v);
      if (x && w == h && w + x.nodeSize == m) {
        let y = s[d + 2].mapInner(r, x, f + 1, e[d] + o + 1, a);
        y != qo ? (s[d] = h, s[d + 1] = m, s[d + 2] = y) : (s[d + 1] = -2, u = !0);
      } else
        u = !0;
    }
  if (u) {
    let d = x_e(s, e, t, r, i, o, a), f = Ix(d, n, 0, a);
    t = f.local;
    for (let h = 0; h < s.length; h += 3)
      s[h + 1] < 0 && (s.splice(h, 3), h -= 3);
    for (let h = 0, g = 0; h < f.children.length; h += 3) {
      let m = f.children[h];
      for (; g < s.length && s[g] < m; )
        g += 3;
      s.splice(g, 0, f.children[h], f.children[h + 1], f.children[h + 2]);
    }
  }
  return new Ms(t.sort(Qf), s);
}
function SQ(e, t) {
  if (!t || !e.length)
    return e;
  let r = [];
  for (let n = 0; n < e.length; n++) {
    let i = e[n];
    r.push(new Nb(i.from + t, i.to + t, i.type));
  }
  return r;
}
function x_e(e, t, r, n, i, o, a) {
  function s(u, d) {
    for (let f = 0; f < u.local.length; f++) {
      let h = u.local[f].map(n, i, d);
      h ? r.push(h) : a.onRemove && a.onRemove(u.local[f].spec);
    }
    for (let f = 0; f < u.children.length; f += 3)
      s(u.children[f + 2], u.children[f] + d + 1);
  }
  for (let u = 0; u < e.length; u += 3)
    e[u + 1] == -1 && s(e[u + 2], t[u] + o + 1);
  return r;
}
function TQ(e, t, r) {
  if (t.isLeaf)
    return null;
  let n = r + t.nodeSize, i = null;
  for (let o = 0, a; o < e.length; o++)
    (a = e[o]) && a.from > r && a.to < n && ((i || (i = [])).push(a), e[o] = null);
  return i;
}
function kQ(e) {
  let t = [];
  for (let r = 0; r < e.length; r++)
    e[r] != null && t.push(e[r]);
  return t;
}
function Ix(e, t, r, n) {
  let i = [], o = !1;
  t.forEach((s, u) => {
    let d = TQ(e, s, u + r);
    if (d) {
      o = !0;
      let f = Ix(d, s, r + u + 1, n);
      f != qo && i.push(u, u + s.nodeSize, f);
    }
  });
  let a = SQ(o ? kQ(e) : e, -r).sort(Qf);
  for (let s = 0; s < a.length; s++)
    a[s].type.valid(t, a[s]) || (n.onRemove && n.onRemove(a[s].spec), a.splice(s--, 1));
  return a.length || i.length ? new Ms(a, i) : qo;
}
function Qf(e, t) {
  return e.from - t.from || e.to - t.to;
}
function A_(e) {
  let t = e;
  for (let r = 0; r < t.length - 1; r++) {
    let n = t[r];
    if (n.from != n.to)
      for (let i = r + 1; i < t.length; i++) {
        let o = t[i];
        if (o.from == n.from) {
          o.to != n.to && (t == e && (t = e.slice()), t[i] = o.copy(o.from, n.to), Ej(t, i + 1, o.copy(n.to, o.to)));
          continue;
        } else {
          o.from < n.to && (t == e && (t = e.slice()), t[r] = n.copy(n.from, o.from), Ej(t, i, n.copy(o.from, n.to)));
          break;
        }
      }
  }
  return t;
}
function Ej(e, t, r) {
  for (; t < e.length && Qf(r, e[t]) > 0; )
    t++;
  e.splice(t, 0, r);
}
var Ac = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, Nx = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, Ij = typeof navigator < "u" && /Chrome\/(\d+)/.exec(navigator.userAgent), w_e = typeof navigator < "u" && /Mac/.test(navigator.platform), M_e = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent), C_e = w_e || Ij && +Ij[1] < 57;
for (var Mo = 0; Mo < 10; Mo++)
  Ac[48 + Mo] = Ac[96 + Mo] = String(Mo);
for (var Mo = 1; Mo <= 24; Mo++)
  Ac[Mo + 111] = "F" + Mo;
for (var Mo = 65; Mo <= 90; Mo++)
  Ac[Mo] = String.fromCharCode(Mo + 32), Nx[Mo] = String.fromCharCode(Mo);
for (var bN in Ac)
  Nx.hasOwnProperty(bN) || (Nx[bN] = Ac[bN]);
function S_e(e) {
  var t = C_e && (e.ctrlKey || e.altKey || e.metaKey) || M_e && e.shiftKey && e.key && e.key.length == 1 || e.key == "Unidentified", r = !t && e.key || (e.shiftKey ? Nx : Ac)[e.keyCode] || e.key || "Unidentified";
  return r == "Esc" && (r = "Escape"), r == "Del" && (r = "Delete"), r == "Left" && (r = "ArrowLeft"), r == "Up" && (r = "ArrowUp"), r == "Right" && (r = "ArrowRight"), r == "Down" && (r = "ArrowDown"), r;
}
const T_e = (e, t) => e.selection.empty ? !1 : (t && t(e.tr.deleteSelection().scrollIntoView()), !0);
function k_e(e, t) {
  let { $cursor: r } = e.selection;
  return !r || (t ? !t.endOfTextblock("backward", e) : r.parentOffset > 0) ? null : r;
}
const D_e = (e, t, r) => {
  let n = k_e(e, r);
  if (!n)
    return !1;
  let i = DQ(n);
  if (!i) {
    let a = n.blockRange(), s = a && Qp(a);
    return s == null ? !1 : (t && t(e.tr.lift(a, s).scrollIntoView()), !0);
  }
  let o = i.nodeBefore;
  if (!o.type.spec.isolating && IQ(e, i, t))
    return !0;
  if (n.parent.content.size == 0 && (Ep(o, "end") || Bt.isSelectable(o))) {
    let a = w_(e.doc, n.before(), n.after(), Ot.empty);
    if (a && a.slice.size < a.to - a.from) {
      if (t) {
        let s = e.tr.step(a);
        s.setSelection(Ep(o, "end") ? Ar.findFrom(s.doc.resolve(s.mapping.map(i.pos, -1)), -1) : Bt.create(s.doc, i.pos - o.nodeSize)), t(s.scrollIntoView());
      }
      return !0;
    }
  }
  return o.isAtom && i.depth == n.depth - 1 ? (t && t(e.tr.delete(i.pos - o.nodeSize, i.pos).scrollIntoView()), !0) : !1;
};
function Ep(e, t, r = !1) {
  for (let n = e; n; n = t == "start" ? n.firstChild : n.lastChild) {
    if (n.isTextblock)
      return !0;
    if (r && n.childCount != 1)
      return !1;
  }
  return !1;
}
const A_e = (e, t, r) => {
  let { $head: n, empty: i } = e.selection, o = n;
  if (!i)
    return !1;
  if (n.parent.isTextblock) {
    if (r ? !r.endOfTextblock("backward", e) : n.parentOffset > 0)
      return !1;
    o = DQ(n);
  }
  let a = o && o.nodeBefore;
  return !a || !Bt.isSelectable(a) ? !1 : (t && t(e.tr.setSelection(Bt.create(e.doc, o.pos - a.nodeSize)).scrollIntoView()), !0);
};
function DQ(e) {
  if (!e.parent.type.spec.isolating)
    for (let t = e.depth - 1; t >= 0; t--) {
      if (e.index(t) > 0)
        return e.doc.resolve(e.before(t + 1));
      if (e.node(t).type.spec.isolating)
        break;
    }
  return null;
}
function E_e(e, t) {
  let { $cursor: r } = e.selection;
  return !r || (t ? !t.endOfTextblock("forward", e) : r.parentOffset < r.parent.content.size) ? null : r;
}
const I_e = (e, t, r) => {
  let n = E_e(e, r);
  if (!n)
    return !1;
  let i = AQ(n);
  if (!i)
    return !1;
  let o = i.nodeAfter;
  if (IQ(e, i, t))
    return !0;
  if (n.parent.content.size == 0 && (Ep(o, "start") || Bt.isSelectable(o))) {
    let a = w_(e.doc, n.before(), n.after(), Ot.empty);
    if (a && a.slice.size < a.to - a.from) {
      if (t) {
        let s = e.tr.step(a);
        s.setSelection(Ep(o, "start") ? Ar.findFrom(s.doc.resolve(s.mapping.map(i.pos)), 1) : Bt.create(s.doc, s.mapping.map(i.pos))), t(s.scrollIntoView());
      }
      return !0;
    }
  }
  return o.isAtom && i.depth == n.depth - 1 ? (t && t(e.tr.delete(i.pos, i.pos + o.nodeSize).scrollIntoView()), !0) : !1;
}, N_e = (e, t, r) => {
  let { $head: n, empty: i } = e.selection, o = n;
  if (!i)
    return !1;
  if (n.parent.isTextblock) {
    if (r ? !r.endOfTextblock("forward", e) : n.parentOffset < n.parent.content.size)
      return !1;
    o = AQ(n);
  }
  let a = o && o.nodeAfter;
  return !a || !Bt.isSelectable(a) ? !1 : (t && t(e.tr.setSelection(Bt.create(e.doc, o.pos)).scrollIntoView()), !0);
};
function AQ(e) {
  if (!e.parent.type.spec.isolating)
    for (let t = e.depth - 1; t >= 0; t--) {
      let r = e.node(t);
      if (e.index(t) + 1 < r.childCount)
        return e.doc.resolve(e.after(t + 1));
      if (r.type.spec.isolating)
        break;
    }
  return null;
}
const z_e = (e, t) => {
  let r = e.selection, n = r instanceof Bt, i;
  if (n) {
    if (r.node.isTextblock || !Bc(e.doc, r.from))
      return !1;
    i = r.from;
  } else if (i = QY(e.doc, r.from, -1), i == null)
    return !1;
  if (t) {
    let o = e.tr.join(i);
    n && o.setSelection(Bt.create(o.doc, i - e.doc.resolve(i).nodeBefore.nodeSize)), t(o.scrollIntoView());
  }
  return !0;
}, $_e = (e, t) => {
  let r = e.selection, n;
  if (r instanceof Bt) {
    if (r.node.isTextblock || !Bc(e.doc, r.to))
      return !1;
    n = r.to;
  } else if (n = QY(e.doc, r.to, 1), n == null)
    return !1;
  return t && t(e.tr.join(n).scrollIntoView()), !0;
}, O_e = (e, t) => {
  let { $from: r, $to: n } = e.selection, i = r.blockRange(n), o = i && Qp(i);
  return o == null ? !1 : (t && t(e.tr.lift(i, o).scrollIntoView()), !0);
}, __e = (e, t) => {
  let { $head: r, $anchor: n } = e.selection;
  return !r.parent.type.spec.code || !r.sameParent(n) ? !1 : (t && t(e.tr.insertText(`
`).scrollIntoView()), !0);
};
function EQ(e) {
  for (let t = 0; t < e.edgeCount; t++) {
    let { type: r } = e.edge(t);
    if (r.isTextblock && !r.hasRequiredAttrs())
      return r;
  }
  return null;
}
const L_e = (e, t) => {
  let { $head: r, $anchor: n } = e.selection;
  if (!r.parent.type.spec.code || !r.sameParent(n))
    return !1;
  let i = r.node(-1), o = r.indexAfter(-1), a = EQ(i.contentMatchAt(o));
  if (!a || !i.canReplaceWith(o, o, a))
    return !1;
  if (t) {
    let s = r.after(), u = e.tr.replaceWith(s, s, a.createAndFill());
    u.setSelection(Ar.near(u.doc.resolve(s), 1)), t(u.scrollIntoView());
  }
  return !0;
}, P_e = (e, t) => {
  let r = e.selection, { $from: n, $to: i } = r;
  if (r instanceof ol || n.parent.inlineContent || i.parent.inlineContent)
    return !1;
  let o = EQ(i.parent.contentMatchAt(i.indexAfter()));
  if (!o || !o.isTextblock)
    return !1;
  if (t) {
    let a = (!n.parentOffset && i.index() < i.parent.childCount ? n : i).pos, s = e.tr.insert(a, o.createAndFill());
    s.setSelection(pr.create(s.doc, a + 1)), t(s.scrollIntoView());
  }
  return !0;
}, R_e = (e, t) => {
  let { $cursor: r } = e.selection;
  if (!r || r.parent.content.size)
    return !1;
  if (r.depth > 1 && r.after() != r.end(-1)) {
    let o = r.before();
    if (lp(e.doc, o))
      return t && t(e.tr.split(o).scrollIntoView()), !0;
  }
  let n = r.blockRange(), i = n && Qp(n);
  return i == null ? !1 : (t && t(e.tr.lift(n, i).scrollIntoView()), !0);
}, j_e = (e, t) => {
  let { $from: r, to: n } = e.selection, i, o = r.sharedDepth(n);
  return o == 0 ? !1 : (i = r.before(o), t && t(e.tr.setSelection(Bt.create(e.doc, i))), !0);
};
function F_e(e, t, r) {
  let n = t.nodeBefore, i = t.nodeAfter, o = t.index();
  return !n || !i || !n.type.compatibleContent(i.type) ? !1 : !n.content.size && t.parent.canReplace(o - 1, o) ? (r && r(e.tr.delete(t.pos - n.nodeSize, t.pos).scrollIntoView()), !0) : !t.parent.canReplace(o, o + 1) || !(i.isTextblock || Bc(e.doc, t.pos)) ? !1 : (r && r(e.tr.clearIncompatible(t.pos, n.type, n.contentMatchAt(n.childCount)).join(t.pos).scrollIntoView()), !0);
}
function IQ(e, t, r) {
  let n = t.nodeBefore, i = t.nodeAfter, o, a;
  if (n.type.spec.isolating || i.type.spec.isolating)
    return !1;
  if (F_e(e, t, r))
    return !0;
  let s = t.parent.canReplace(t.index(), t.index() + 1);
  if (s && (o = (a = n.contentMatchAt(n.childCount)).findWrapping(i.type)) && a.matchType(o[0] || i.type).validEnd) {
    if (r) {
      let h = t.pos + i.nodeSize, g = bt.empty;
      for (let w = o.length - 1; w >= 0; w--)
        g = bt.from(o[w].create(null, g));
      g = bt.from(n.copy(g));
      let m = e.tr.step(new oo(t.pos - 1, h, t.pos, h, new Ot(g, 1, 0), o.length, !0)), v = h + 2 * o.length;
      Bc(m.doc, v) && m.join(v), r(m.scrollIntoView());
    }
    return !0;
  }
  let u = Ar.findFrom(t, 1), d = u && u.$from.blockRange(u.$to), f = d && Qp(d);
  if (f != null && f >= t.depth)
    return r && r(e.tr.lift(d, f).scrollIntoView()), !0;
  if (s && Ep(i, "start", !0) && Ep(n, "end")) {
    let h = n, g = [];
    for (; g.push(h), !h.isTextblock; )
      h = h.lastChild;
    let m = i, v = 1;
    for (; !m.isTextblock; m = m.firstChild)
      v++;
    if (h.canReplace(h.childCount, h.childCount, m.content)) {
      if (r) {
        let w = bt.empty;
        for (let y = g.length - 1; y >= 0; y--)
          w = bt.from(g[y].copy(w));
        let x = e.tr.step(new oo(t.pos - g.length, t.pos + i.nodeSize, t.pos + v, t.pos + i.nodeSize - v, new Ot(w, g.length, 0), 0, !0));
        r(x.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function NQ(e) {
  return function(t, r) {
    let n = t.selection, i = e < 0 ? n.$from : n.$to, o = i.depth;
    for (; i.node(o).isInline; ) {
      if (!o)
        return !1;
      o--;
    }
    return i.node(o).isTextblock ? (r && r(t.tr.setSelection(pr.create(t.doc, e < 0 ? i.start(o) : i.end(o)))), !0) : !1;
  };
}
const B_e = NQ(-1), U_e = NQ(1);
function H_e(e, t = null) {
  return function(r, n) {
    let { $from: i, $to: o } = r.selection, a = i.blockRange(o), s = a && x_(a, e, t);
    return s ? (n && n(r.tr.wrap(a, s).scrollIntoView()), !0) : !1;
  };
}
function Nj(e, t = null) {
  return function(r, n) {
    let i = !1;
    for (let o = 0; o < r.selection.ranges.length && !i; o++) {
      let { $from: { pos: a }, $to: { pos: s } } = r.selection.ranges[o];
      r.doc.nodesBetween(a, s, (u, d) => {
        if (i)
          return !1;
        if (!(!u.isTextblock || u.hasMarkup(e, t)))
          if (u.type == e)
            i = !0;
          else {
            let f = r.doc.resolve(d), h = f.index();
            i = f.parent.canReplaceWith(h, h + 1, e);
          }
      });
    }
    if (!i)
      return !1;
    if (n) {
      let o = r.tr;
      for (let a = 0; a < r.selection.ranges.length; a++) {
        let { $from: { pos: s }, $to: { pos: u } } = r.selection.ranges[a];
        o.setBlockType(s, u, e, t);
      }
      n(o.scrollIntoView());
    }
    return !0;
  };
}
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function W_e(e, t = null) {
  return function(r, n) {
    let { $from: i, $to: o } = r.selection, a = i.blockRange(o), s = !1, u = a;
    if (!a)
      return !1;
    if (a.depth >= 2 && i.node(a.depth - 1).type.compatibleContent(e) && a.startIndex == 0) {
      if (i.index(a.depth - 1) == 0)
        return !1;
      let f = r.doc.resolve(a.start - 2);
      u = new N$(f, f, a.depth), a.endIndex < a.parent.childCount && (a = new N$(i, r.doc.resolve(o.end(a.depth)), a.depth)), s = !0;
    }
    let d = x_(u, e, t, a);
    return d ? (n && n(V_e(r.tr, a, d, s, e).scrollIntoView()), !0) : !1;
  };
}
function V_e(e, t, r, n, i) {
  let o = bt.empty;
  for (let f = r.length - 1; f >= 0; f--)
    o = bt.from(r[f].type.create(r[f].attrs, o));
  e.step(new oo(t.start - (n ? 2 : 0), t.end, t.start, t.end, new Ot(o, 0, 0), r.length, !0));
  let a = 0;
  for (let f = 0; f < r.length; f++)
    r[f].type == i && (a = f + 1);
  let s = r.length - a, u = t.start + r.length - (n ? 2 : 0), d = t.parent;
  for (let f = t.startIndex, h = t.endIndex, g = !0; f < h; f++, g = !1)
    !g && lp(e.doc, u, s) && (e.split(u, s), u += 2 * s), u += d.child(f).nodeSize;
  return e;
}
function Y_e(e) {
  return function(t, r) {
    let { $from: n, $to: i } = t.selection, o = n.blockRange(i, (a) => a.childCount > 0 && a.firstChild.type == e);
    return o ? r ? n.node(o.depth - 1).type == e ? Q_e(t, r, e, o) : q_e(t, r, o) : !0 : !1;
  };
}
function Q_e(e, t, r, n) {
  let i = e.tr, o = n.end, a = n.$to.end(n.depth);
  o < a && (i.step(new oo(o - 1, a, o, a, new Ot(bt.from(r.create(null, n.parent.copy())), 1, 0), 1, !0)), n = new N$(i.doc.resolve(n.$from.pos), i.doc.resolve(a), n.depth));
  const s = Qp(n);
  if (s == null)
    return !1;
  i.lift(n, s);
  let u = i.mapping.map(o, -1) - 1;
  return Bc(i.doc, u) && i.join(u), t(i.scrollIntoView()), !0;
}
function q_e(e, t, r) {
  let n = e.tr, i = r.parent;
  for (let m = r.end, v = r.endIndex - 1, w = r.startIndex; v > w; v--)
    m -= i.child(v).nodeSize, n.delete(m - 1, m + 1);
  let o = n.doc.resolve(r.start), a = o.nodeAfter;
  if (n.mapping.map(r.end) != r.start + o.nodeAfter.nodeSize)
    return !1;
  let s = r.startIndex == 0, u = r.endIndex == i.childCount, d = o.node(-1), f = o.index(-1);
  if (!d.canReplace(f + (s ? 0 : 1), f + 1, a.content.append(u ? bt.empty : bt.from(i))))
    return !1;
  let h = o.pos, g = h + a.nodeSize;
  return n.step(new oo(h - (s ? 1 : 0), g + (u ? 1 : 0), h + 1, g - 1, new Ot((s ? bt.empty : bt.from(i.copy(bt.empty))).append(u ? bt.empty : bt.from(i.copy(bt.empty))), s ? 0 : 1, u ? 0 : 1), s ? 0 : 1)), t(n.scrollIntoView()), !0;
}
function G_e(e) {
  return function(t, r) {
    let { $from: n, $to: i } = t.selection, o = n.blockRange(i, (d) => d.childCount > 0 && d.firstChild.type == e);
    if (!o)
      return !1;
    let a = o.startIndex;
    if (a == 0)
      return !1;
    let s = o.parent, u = s.child(a - 1);
    if (u.type != e)
      return !1;
    if (r) {
      let d = u.lastChild && u.lastChild.type == s.type, f = bt.from(d ? e.create() : null), h = new Ot(bt.from(e.create(null, bt.from(s.type.create(null, f)))), d ? 3 : 1, 0), g = o.start, m = o.end;
      r(t.tr.step(new oo(g - (d ? 3 : 1), m, g, m, h, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function zQ(e) {
  const { state: t, transaction: r } = e;
  let { selection: n } = r, { doc: i } = r, { storedMarks: o } = r;
  return {
    ...t,
    apply: t.apply.bind(t),
    applyTransaction: t.applyTransaction.bind(t),
    filterTransaction: t.filterTransaction,
    plugins: t.plugins,
    schema: t.schema,
    reconfigure: t.reconfigure.bind(t),
    toJSON: t.toJSON.bind(t),
    get storedMarks() {
      return o;
    },
    get selection() {
      return n;
    },
    get doc() {
      return i;
    },
    get tr() {
      return n = r.selection, i = r.doc, o = r.storedMarks, r;
    }
  };
}
class Z_e {
  constructor(t) {
    this.editor = t.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = t.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: t, editor: r, state: n } = this, { view: i } = r, { tr: o } = n, a = this.buildProps(o);
    return Object.fromEntries(Object.entries(t).map(([s, u]) => [s, (...f) => {
      const h = u(...f)(a);
      return !o.getMeta("preventDispatch") && !this.hasCustomState && i.dispatch(o), h;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(t, r = !0) {
    const { rawCommands: n, editor: i, state: o } = this, { view: a } = i, s = [], u = !!t, d = t || o.tr, f = () => (!u && r && !d.getMeta("preventDispatch") && !this.hasCustomState && a.dispatch(d), s.every((g) => g === !0)), h = {
      ...Object.fromEntries(Object.entries(n).map(([g, m]) => [g, (...w) => {
        const x = this.buildProps(d, r), y = m(...w)(x);
        return s.push(y), h;
      }])),
      run: f
    };
    return h;
  }
  createCan(t) {
    const { rawCommands: r, state: n } = this, i = !1, o = t || n.tr, a = this.buildProps(o, i);
    return {
      ...Object.fromEntries(Object.entries(r).map(([u, d]) => [u, (...f) => d(...f)({ ...a, dispatch: void 0 })])),
      chain: () => this.createChain(o, i)
    };
  }
  buildProps(t, r = !0) {
    const { rawCommands: n, editor: i, state: o } = this, { view: a } = i;
    o.storedMarks && t.setStoredMarks(o.storedMarks);
    const s = {
      tr: t,
      editor: i,
      view: a,
      state: zQ({
        state: o,
        transaction: t
      }),
      dispatch: r ? () => {
      } : void 0,
      chain: () => this.createChain(t),
      can: () => this.createCan(t),
      get commands() {
        return Object.fromEntries(Object.entries(n).map(([u, d]) => [u, (...f) => d(...f)(s)]));
      }
    };
    return s;
  }
}
function qi(e, t, r) {
  return e.config[t] === void 0 && e.parent ? qi(e.parent, t, r) : typeof e.config[t] == "function" ? e.config[t].bind({
    ...r,
    parent: e.parent ? qi(e.parent, t, r) : null
  }) : e.config[t];
}
function K_e(e) {
  const t = e.filter((i) => i.type === "extension"), r = e.filter((i) => i.type === "node"), n = e.filter((i) => i.type === "mark");
  return {
    baseExtensions: t,
    nodeExtensions: r,
    markExtensions: n
  };
}
function So(e, t) {
  if (typeof e == "string") {
    if (!t.nodes[e])
      throw Error(`There is no node type named '${e}'. Maybe you forgot to add the extension?`);
    return t.nodes[e];
  }
  return e;
}
function _n(...e) {
  return e.filter((t) => !!t).reduce((t, r) => {
    const n = { ...t };
    return Object.entries(r).forEach(([i, o]) => {
      if (!n[i]) {
        n[i] = o;
        return;
      }
      i === "class" ? n[i] = [n[i], o].join(" ") : i === "style" ? n[i] = [n[i], o].join("; ") : n[i] = o;
    }), n;
  }, {});
}
function X_e(e) {
  return typeof e == "function";
}
function di(e, t = void 0, ...r) {
  return X_e(e) ? t ? e.bind(t)(...r) : e(...r) : e;
}
function J_e(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}
class lC {
  constructor(t) {
    this.find = t.find, this.handler = t.handler;
  }
}
class $Q {
  constructor(t) {
    this.find = t.find, this.handler = t.handler;
  }
}
function eLe(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function yN(e) {
  return eLe(e) !== "Object" ? !1 : e.constructor === Object && Object.getPrototypeOf(e) === Object.prototype;
}
function sC(e, t) {
  const r = { ...e };
  return yN(e) && yN(t) && Object.keys(t).forEach((n) => {
    yN(t[n]) ? n in e ? r[n] = sC(e[n], t[n]) : Object.assign(r, { [n]: t[n] }) : Object.assign(r, { [n]: t[n] });
  }), r;
}
class Fn {
  constructor(t = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...t
    }, this.name = this.config.name, t.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = di(qi(this, "addOptions", {
      name: this.name
    }))), this.storage = di(qi(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(t = {}) {
    return new Fn(t);
  }
  configure(t = {}) {
    const r = this.extend();
    return r.options = sC(this.options, t), r.storage = di(qi(r, "addStorage", {
      name: r.name,
      options: r.options
    })), r;
  }
  extend(t = {}) {
    const r = new Fn(t);
    return r.parent = this, this.child = r, r.name = t.name ? t.name : r.parent.name, t.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${r.name}".`), r.options = di(qi(r, "addOptions", {
      name: r.name
    })), r.storage = di(qi(r, "addStorage", {
      name: r.name,
      options: r.options
    })), r;
  }
}
function tLe(e, t, r) {
  const { from: n, to: i } = t, { blockSeparator: o = `

`, textSerializers: a = {} } = r || {};
  let s = "", u = !0;
  return e.nodesBetween(n, i, (d, f, h, g) => {
    var m;
    const v = a == null ? void 0 : a[d.type.name];
    v ? (d.isBlock && !u && (s += o, u = !0), h && (s += v({
      node: d,
      pos: f,
      parent: h,
      index: g,
      range: t
    }))) : d.isText ? (s += (m = d == null ? void 0 : d.text) === null || m === void 0 ? void 0 : m.slice(Math.max(n, f) - f, i - f), u = !1) : d.isBlock && !u && (s += o, u = !0);
  }), s;
}
function rLe(e) {
  return Object.fromEntries(Object.entries(e.nodes).filter(([, t]) => t.spec.toText).map(([t, r]) => [t, r.spec.toText]));
}
Fn.create({
  name: "clipboardTextSerializer",
  addProseMirrorPlugins() {
    return [
      new ra({
        key: new _o("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: e } = this, { state: t, schema: r } = e, { doc: n, selection: i } = t, { ranges: o } = i, a = Math.min(...o.map((f) => f.$from.pos)), s = Math.max(...o.map((f) => f.$to.pos)), u = rLe(r);
            return tLe(n, { from: a, to: s }, {
              textSerializers: u
            });
          }
        }
      })
    ];
  }
});
const nLe = () => ({ editor: e, view: t }) => (requestAnimationFrame(() => {
  var r;
  e.isDestroyed || (t.dom.blur(), (r = window == null ? void 0 : window.getSelection()) === null || r === void 0 || r.removeAllRanges());
}), !0), iLe = (e = !1) => ({ commands: t }) => t.setContent("", e), oLe = () => ({ state: e, tr: t, dispatch: r }) => {
  const { selection: n } = t, { ranges: i } = n;
  return r && i.forEach(({ $from: o, $to: a }) => {
    e.doc.nodesBetween(o.pos, a.pos, (s, u) => {
      if (s.type.isText)
        return;
      const { doc: d, mapping: f } = t, h = d.resolve(f.map(u)), g = d.resolve(f.map(u + s.nodeSize)), m = h.blockRange(g);
      if (!m)
        return;
      const v = Qp(m);
      if (s.type.isTextblock) {
        const { defaultType: w } = h.parent.contentMatchAt(h.index());
        t.setNodeMarkup(m.start, w);
      }
      (v || v === 0) && t.lift(m, v);
    });
  }), !0;
}, aLe = (e) => (t) => e(t), lLe = () => ({ state: e, dispatch: t }) => P_e(e, t), sLe = () => ({ tr: e, dispatch: t }) => {
  const { selection: r } = e, n = r.$anchor.node();
  if (n.content.size > 0)
    return !1;
  const i = e.selection.$anchor;
  for (let o = i.depth; o > 0; o -= 1)
    if (i.node(o).type === n.type) {
      if (t) {
        const s = i.before(o), u = i.after(o);
        e.delete(s, u).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, uLe = (e) => ({ tr: t, state: r, dispatch: n }) => {
  const i = So(e, r.schema), o = t.selection.$anchor;
  for (let a = o.depth; a > 0; a -= 1)
    if (o.node(a).type === i) {
      if (n) {
        const u = o.before(a), d = o.after(a);
        t.delete(u, d).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, cLe = (e) => ({ tr: t, dispatch: r }) => {
  const { from: n, to: i } = e;
  return r && t.delete(n, i), !0;
}, dLe = () => ({ state: e, dispatch: t }) => T_e(e, t), fLe = () => ({ commands: e }) => e.keyboardShortcut("Enter"), hLe = () => ({ state: e, dispatch: t }) => L_e(e, t);
function zx(e, t, r = { strict: !0 }) {
  const n = Object.keys(t);
  return n.length ? n.every((i) => r.strict ? t[i] === e[i] : J_e(t[i]) ? t[i].test(e[i]) : t[i] === e[i]) : !0;
}
function U$(e, t, r = {}) {
  return e.find((n) => n.type === t && zx(n.attrs, r));
}
function pLe(e, t, r = {}) {
  return !!U$(e, t, r);
}
function E_(e, t, r = {}) {
  if (!e || !t)
    return;
  let n = e.parent.childAfter(e.parentOffset);
  if (e.parentOffset === n.offset && n.offset !== 0 && (n = e.parent.childBefore(e.parentOffset)), !n.node)
    return;
  const i = U$([...n.node.marks], t, r);
  if (!i)
    return;
  let o = n.index, a = e.start() + n.offset, s = o + 1, u = a + n.node.nodeSize;
  for (U$([...n.node.marks], t, r); o > 0 && i.isInSet(e.parent.child(o - 1).marks); )
    o -= 1, a -= e.parent.child(o).nodeSize;
  for (; s < e.parent.childCount && pLe([...e.parent.child(s).marks], t, r); )
    u += e.parent.child(s).nodeSize, s += 1;
  return {
    from: a,
    to: u
  };
}
function Hc(e, t) {
  if (typeof e == "string") {
    if (!t.marks[e])
      throw Error(`There is no mark type named '${e}'. Maybe you forgot to add the extension?`);
    return t.marks[e];
  }
  return e;
}
const gLe = (e, t = {}) => ({ tr: r, state: n, dispatch: i }) => {
  const o = Hc(e, n.schema), { doc: a, selection: s } = r, { $from: u, from: d, to: f } = s;
  if (i) {
    const h = E_(u, o, t);
    if (h && h.from <= d && h.to >= f) {
      const g = pr.create(a, h.from, h.to);
      r.setSelection(g);
    }
  }
  return !0;
}, mLe = (e) => (t) => {
  const r = typeof e == "function" ? e(t) : e;
  for (let n = 0; n < r.length; n += 1)
    if (r[n](t))
      return !0;
  return !1;
};
function I_(e) {
  return e instanceof pr;
}
function Lu(e = 0, t = 0, r = 0) {
  return Math.min(Math.max(e, t), r);
}
function vLe(e, t = null) {
  if (!t)
    return null;
  const r = Ar.atStart(e), n = Ar.atEnd(e);
  if (t === "start" || t === !0)
    return r;
  if (t === "end")
    return n;
  const i = r.from, o = n.to;
  return t === "all" ? pr.create(e, Lu(0, i, o), Lu(e.content.size, i, o)) : pr.create(e, Lu(t, i, o), Lu(t, i, o));
}
function uC() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const bLe = (e = null, t = {}) => ({ editor: r, view: n, tr: i, dispatch: o }) => {
  t = {
    scrollIntoView: !0,
    ...t
  };
  const a = () => {
    uC() && n.dom.focus(), requestAnimationFrame(() => {
      r.isDestroyed || (n.focus(), t != null && t.scrollIntoView && r.commands.scrollIntoView());
    });
  };
  if (n.hasFocus() && e === null || e === !1)
    return !0;
  if (o && e === null && !I_(r.state.selection))
    return a(), !0;
  const s = vLe(i.doc, e) || r.state.selection, u = r.state.selection.eq(s);
  return o && (u || i.setSelection(s), u && i.storedMarks && i.setStoredMarks(i.storedMarks), a()), !0;
}, yLe = (e, t) => (r) => e.every((n, i) => t(n, { ...r, index: i })), xLe = (e, t) => ({ tr: r, commands: n }) => n.insertContentAt({ from: r.selection.from, to: r.selection.to }, e, t);
function zj(e) {
  const t = `<body>${e}</body>`;
  return new window.DOMParser().parseFromString(t, "text/html").body;
}
function $x(e, t, r) {
  if (r = {
    slice: !0,
    parseOptions: {},
    ...r
  }, typeof e == "object" && e !== null)
    try {
      return Array.isArray(e) ? bt.fromArray(e.map((n) => t.nodeFromJSON(n))) : t.nodeFromJSON(e);
    } catch (n) {
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", e, "Error:", n), $x("", t, r);
    }
  if (typeof e == "string") {
    const n = Tp.fromSchema(t);
    return r.slice ? n.parseSlice(zj(e), r.parseOptions).content : n.parse(zj(e), r.parseOptions);
  }
  return $x("", t, r);
}
function wLe(e, t, r) {
  const n = e.steps.length - 1;
  if (n < t)
    return;
  const i = e.steps[n];
  if (!(i instanceof Eo || i instanceof oo))
    return;
  const o = e.mapping.maps[n];
  let a = 0;
  o.forEach((s, u, d, f) => {
    a === 0 && (a = f);
  }), e.setSelection(Ar.near(e.doc.resolve(a), r));
}
const MLe = (e) => e.toString().startsWith("<"), CLe = (e, t, r) => ({ tr: n, dispatch: i, editor: o }) => {
  if (i) {
    r = {
      parseOptions: {},
      updateSelection: !0,
      ...r
    };
    const a = $x(t, o.schema, {
      parseOptions: {
        preserveWhitespace: "full",
        ...r.parseOptions
      }
    });
    if (a.toString() === "<>")
      return !0;
    let { from: s, to: u } = typeof e == "number" ? { from: e, to: e } : e, d = !0, f = !0;
    if ((MLe(a) ? a : [a]).forEach((g) => {
      g.check(), d = d ? g.isText && g.marks.length === 0 : !1, f = f ? g.isBlock : !1;
    }), s === u && f) {
      const { parent: g } = n.doc.resolve(s);
      g.isTextblock && !g.type.spec.code && !g.childCount && (s -= 1, u += 1);
    }
    d ? n.insertText(t, s, u) : n.replaceWith(s, u, a), r.updateSelection && wLe(n, n.steps.length - 1, -1);
  }
  return !0;
}, SLe = () => ({ state: e, dispatch: t }) => z_e(e, t), TLe = () => ({ state: e, dispatch: t }) => $_e(e, t), kLe = () => ({ state: e, dispatch: t }) => D_e(e, t), DLe = () => ({ state: e, dispatch: t }) => I_e(e, t);
function OQ() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function ALe(e) {
  const t = e.split(/-(?!$)/);
  let r = t[t.length - 1];
  r === "Space" && (r = " ");
  let n, i, o, a;
  for (let s = 0; s < t.length - 1; s += 1) {
    const u = t[s];
    if (/^(cmd|meta|m)$/i.test(u))
      a = !0;
    else if (/^a(lt)?$/i.test(u))
      n = !0;
    else if (/^(c|ctrl|control)$/i.test(u))
      i = !0;
    else if (/^s(hift)?$/i.test(u))
      o = !0;
    else if (/^mod$/i.test(u))
      uC() || OQ() ? a = !0 : i = !0;
    else
      throw new Error(`Unrecognized modifier name: ${u}`);
  }
  return n && (r = `Alt-${r}`), i && (r = `Ctrl-${r}`), a && (r = `Meta-${r}`), o && (r = `Shift-${r}`), r;
}
const ELe = (e) => ({ editor: t, view: r, tr: n, dispatch: i }) => {
  const o = ALe(e).split(/-(?!$)/), a = o.find((d) => !["Alt", "Ctrl", "Meta", "Shift"].includes(d)), s = new KeyboardEvent("keydown", {
    key: a === "Space" ? " " : a,
    altKey: o.includes("Alt"),
    ctrlKey: o.includes("Ctrl"),
    metaKey: o.includes("Meta"),
    shiftKey: o.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), u = t.captureTransaction(() => {
    r.someProp("handleKeyDown", (d) => d(r, s));
  });
  return u == null || u.steps.forEach((d) => {
    const f = d.map(n.mapping);
    f && i && n.maybeStep(f);
  }), !0;
};
function N_(e, t, r = {}) {
  const { from: n, to: i, empty: o } = e.selection, a = t ? So(t, e.schema) : null, s = [];
  e.doc.nodesBetween(n, i, (h, g) => {
    if (h.isText)
      return;
    const m = Math.max(n, g), v = Math.min(i, g + h.nodeSize);
    s.push({
      node: h,
      from: m,
      to: v
    });
  });
  const u = i - n, d = s.filter((h) => a ? a.name === h.node.type.name : !0).filter((h) => zx(h.node.attrs, r, { strict: !1 }));
  return o ? !!d.length : d.reduce((h, g) => h + g.to - g.from, 0) >= u;
}
const ILe = (e, t = {}) => ({ state: r, dispatch: n }) => {
  const i = So(e, r.schema);
  return N_(r, i, t) ? O_e(r, n) : !1;
}, NLe = () => ({ state: e, dispatch: t }) => R_e(e, t), zLe = (e) => ({ state: t, dispatch: r }) => {
  const n = So(e, t.schema);
  return Y_e(n)(t, r);
}, $Le = () => ({ state: e, dispatch: t }) => __e(e, t);
function z_(e, t) {
  return t.nodes[e] ? "node" : t.marks[e] ? "mark" : null;
}
function $j(e, t) {
  const r = typeof t == "string" ? [t] : t;
  return Object.keys(e).reduce((n, i) => (r.includes(i) || (n[i] = e[i]), n), {});
}
const OLe = (e, t) => ({ tr: r, state: n, dispatch: i }) => {
  let o = null, a = null;
  const s = z_(typeof e == "string" ? e : e.name, n.schema);
  return s ? (s === "node" && (o = So(e, n.schema)), s === "mark" && (a = Hc(e, n.schema)), i && r.selection.ranges.forEach((u) => {
    n.doc.nodesBetween(u.$from.pos, u.$to.pos, (d, f) => {
      o && o === d.type && r.setNodeMarkup(f, void 0, $j(d.attrs, t)), a && d.marks.length && d.marks.forEach((h) => {
        a === h.type && r.addMark(f, f + d.nodeSize, a.create($j(h.attrs, t)));
      });
    });
  }), !0) : !1;
}, _Le = () => ({ tr: e, dispatch: t }) => (t && e.scrollIntoView(), !0), LLe = () => ({ tr: e, commands: t }) => t.setTextSelection({
  from: 0,
  to: e.doc.content.size
}), PLe = () => ({ state: e, dispatch: t }) => A_e(e, t), RLe = () => ({ state: e, dispatch: t }) => N_e(e, t), jLe = () => ({ state: e, dispatch: t }) => j_e(e, t), FLe = () => ({ state: e, dispatch: t }) => U_e(e, t), BLe = () => ({ state: e, dispatch: t }) => B_e(e, t);
function ULe(e, t, r = {}) {
  return $x(e, t, { slice: !1, parseOptions: r });
}
const HLe = (e, t = !1, r = {}) => ({ tr: n, editor: i, dispatch: o }) => {
  const { doc: a } = n, s = ULe(e, i.schema, r);
  return o && n.replaceWith(0, a.content.size, s).setMeta("preventUpdate", !t), !0;
};
function WLe(e, t) {
  const r = new JY(e);
  return t.forEach((n) => {
    n.steps.forEach((i) => {
      r.step(i);
    });
  }), r;
}
function VLe(e) {
  for (let t = 0; t < e.edgeCount; t += 1) {
    const { type: r } = e.edge(t);
    if (r.isTextblock && !r.hasRequiredAttrs())
      return r;
  }
  return null;
}
function YLe(e, t, r) {
  const n = [];
  return e.nodesBetween(t.from, t.to, (i, o) => {
    r(i) && n.push({
      node: i,
      pos: o
    });
  }), n;
}
function _Q(e, t) {
  for (let r = e.depth; r > 0; r -= 1) {
    const n = e.node(r);
    if (t(n))
      return {
        pos: r > 0 ? e.before(r) : 0,
        start: e.start(r),
        depth: r,
        node: n
      };
  }
}
function $_(e) {
  return (t) => _Q(t.$from, e);
}
function O_(e, t) {
  const r = Hc(t, e.schema), { from: n, to: i, empty: o } = e.selection, a = [];
  o ? (e.storedMarks && a.push(...e.storedMarks), a.push(...e.selection.$head.marks())) : e.doc.nodesBetween(n, i, (u) => {
    a.push(...u.marks);
  });
  const s = a.find((u) => u.type.name === r.name);
  return s ? { ...s.attrs } : {};
}
function QLe(e, t) {
  const r = So(t, e.schema), { from: n, to: i } = e.selection, o = [];
  e.doc.nodesBetween(n, i, (s) => {
    o.push(s);
  });
  const a = o.reverse().find((s) => s.type.name === r.name);
  return a ? { ...a.attrs } : {};
}
function qLe(e, t) {
  const r = z_(typeof t == "string" ? t : t.name, e.schema);
  return r === "node" ? QLe(e, t) : r === "mark" ? O_(e, t) : {};
}
function GLe(e, t = JSON.stringify) {
  const r = {};
  return e.filter((n) => {
    const i = t(n);
    return Object.prototype.hasOwnProperty.call(r, i) ? !1 : r[i] = !0;
  });
}
function ZLe(e) {
  const t = GLe(e);
  return t.length === 1 ? t : t.filter((r, n) => !t.filter((o, a) => a !== n).some((o) => r.oldRange.from >= o.oldRange.from && r.oldRange.to <= o.oldRange.to && r.newRange.from >= o.newRange.from && r.newRange.to <= o.newRange.to));
}
function KLe(e) {
  const { mapping: t, steps: r } = e, n = [];
  return t.maps.forEach((i, o) => {
    const a = [];
    if (i.ranges.length)
      i.forEach((s, u) => {
        a.push({ from: s, to: u });
      });
    else {
      const { from: s, to: u } = r[o];
      if (s === void 0 || u === void 0)
        return;
      a.push({ from: s, to: u });
    }
    a.forEach(({ from: s, to: u }) => {
      const d = t.slice(o).map(s, -1), f = t.slice(o).map(u), h = t.invert().map(d, -1), g = t.invert().map(f);
      n.push({
        oldRange: {
          from: h,
          to: g
        },
        newRange: {
          from: d,
          to: f
        }
      });
    });
  }), ZLe(n);
}
function Ox(e, t, r) {
  const n = [];
  return e === t ? r.resolve(e).marks().forEach((i) => {
    const o = r.resolve(e - 1), a = E_(o, i.type);
    a && n.push({
      mark: i,
      ...a
    });
  }) : r.nodesBetween(e, t, (i, o) => {
    n.push(...i.marks.map((a) => ({
      from: o,
      to: o + i.nodeSize,
      mark: a
    })));
  }), n;
}
function XLe(e, t, r = {}) {
  const { empty: n, ranges: i } = e.selection, o = t ? Hc(t, e.schema) : null;
  if (n)
    return !!(e.storedMarks || e.selection.$from.marks()).filter((h) => o ? o.name === h.type.name : !0).find((h) => zx(h.attrs, r, { strict: !1 }));
  let a = 0;
  const s = [];
  if (i.forEach(({ $from: h, $to: g }) => {
    const m = h.pos, v = g.pos;
    e.doc.nodesBetween(m, v, (w, x) => {
      if (!w.isText && !w.marks.length)
        return;
      const y = Math.max(m, x), C = Math.min(v, x + w.nodeSize), S = C - y;
      a += S, s.push(...w.marks.map((T) => ({
        mark: T,
        from: y,
        to: C
      })));
    });
  }), a === 0)
    return !1;
  const u = s.filter((h) => o ? o.name === h.mark.type.name : !0).filter((h) => zx(h.mark.attrs, r, { strict: !1 })).reduce((h, g) => h + g.to - g.from, 0), d = s.filter((h) => o ? h.mark.type !== o && h.mark.type.excludes(o) : !0).reduce((h, g) => h + g.to - g.from, 0);
  return (u > 0 ? u + d : u) >= a;
}
function Oj(e, t) {
  const { nodeExtensions: r } = K_e(t), n = r.find((a) => a.name === e);
  if (!n)
    return !1;
  const i = {
    name: n.name,
    options: n.options,
    storage: n.storage
  }, o = di(qi(n, "group", i));
  return typeof o != "string" ? !1 : o.split(" ").includes("list");
}
function JLe(e) {
  return e instanceof Bt;
}
function LQ(e, t, r) {
  const i = e.state.doc.content.size, o = Lu(t, 0, i), a = Lu(r, 0, i), s = e.coordsAtPos(o), u = e.coordsAtPos(a, -1), d = Math.min(s.top, u.top), f = Math.max(s.bottom, u.bottom), h = Math.min(s.left, u.left), g = Math.max(s.right, u.right), m = g - h, v = f - d, y = {
    top: d,
    bottom: f,
    left: h,
    right: g,
    width: m,
    height: v,
    x: h,
    y: d
  };
  return {
    ...y,
    toJSON: () => y
  };
}
function e3e(e, t, r) {
  var n;
  const { selection: i } = t;
  let o = null;
  if (I_(i) && (o = i.$cursor), o) {
    const s = (n = e.storedMarks) !== null && n !== void 0 ? n : o.marks();
    return !!r.isInSet(s) || !s.some((u) => u.type.excludes(r));
  }
  const { ranges: a } = i;
  return a.some(({ $from: s, $to: u }) => {
    let d = s.depth === 0 ? e.doc.inlineContent && e.doc.type.allowsMarkType(r) : !1;
    return e.doc.nodesBetween(s.pos, u.pos, (f, h, g) => {
      if (d)
        return !1;
      if (f.isInline) {
        const m = !g || g.type.allowsMarkType(r), v = !!r.isInSet(f.marks) || !f.marks.some((w) => w.type.excludes(r));
        d = m && v;
      }
      return !d;
    }), d;
  });
}
const t3e = (e, t = {}) => ({ tr: r, state: n, dispatch: i }) => {
  const { selection: o } = r, { empty: a, ranges: s } = o, u = Hc(e, n.schema);
  if (i)
    if (a) {
      const d = O_(n, u);
      r.addStoredMark(u.create({
        ...d,
        ...t
      }));
    } else
      s.forEach((d) => {
        const f = d.$from.pos, h = d.$to.pos;
        n.doc.nodesBetween(f, h, (g, m) => {
          const v = Math.max(m, f), w = Math.min(m + g.nodeSize, h);
          g.marks.find((y) => y.type === u) ? g.marks.forEach((y) => {
            u === y.type && r.addMark(v, w, u.create({
              ...y.attrs,
              ...t
            }));
          }) : r.addMark(v, w, u.create(t));
        });
      });
  return e3e(n, r, u);
}, r3e = (e, t) => ({ tr: r }) => (r.setMeta(e, t), !0), n3e = (e, t = {}) => ({ state: r, dispatch: n, chain: i }) => {
  const o = So(e, r.schema);
  return o.isTextblock ? i().command(({ commands: a }) => Nj(o, t)(r) ? !0 : a.clearNodes()).command(({ state: a }) => Nj(o, t)(a, n)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, i3e = (e) => ({ tr: t, dispatch: r }) => {
  if (r) {
    const { doc: n } = t, i = Lu(e, 0, n.content.size), o = Bt.create(n, i);
    t.setSelection(o);
  }
  return !0;
}, o3e = (e) => ({ tr: t, dispatch: r }) => {
  if (r) {
    const { doc: n } = t, { from: i, to: o } = typeof e == "number" ? { from: e, to: e } : e, a = pr.atStart(n).from, s = pr.atEnd(n).to, u = Lu(i, a, s), d = Lu(o, a, s), f = pr.create(n, u, d);
    t.setSelection(f);
  }
  return !0;
}, a3e = (e) => ({ state: t, dispatch: r }) => {
  const n = So(e, t.schema);
  return G_e(n)(t, r);
};
function p1(e, t, r) {
  return Object.fromEntries(Object.entries(r).filter(([n]) => {
    const i = e.find((o) => o.type === t && o.name === n);
    return i ? i.attribute.keepOnSplit : !1;
  }));
}
function _j(e, t) {
  const r = e.storedMarks || e.selection.$to.parentOffset && e.selection.$from.marks();
  if (r) {
    const n = r.filter((i) => t == null ? void 0 : t.includes(i.type.name));
    e.tr.ensureMarks(n);
  }
}
const l3e = ({ keepMarks: e = !0 } = {}) => ({ tr: t, state: r, dispatch: n, editor: i }) => {
  const { selection: o, doc: a } = t, { $from: s, $to: u } = o, d = i.extensionManager.attributes, f = p1(d, s.node().type.name, s.node().attrs);
  if (o instanceof Bt && o.node.isBlock)
    return !s.parentOffset || !lp(a, s.pos) ? !1 : (n && (e && _j(r, i.extensionManager.splittableMarks), t.split(s.pos).scrollIntoView()), !0);
  if (!s.parent.isBlock)
    return !1;
  if (n) {
    const h = u.parentOffset === u.parent.content.size;
    o instanceof pr && t.deleteSelection();
    const g = s.depth === 0 ? void 0 : VLe(s.node(-1).contentMatchAt(s.indexAfter(-1)));
    let m = h && g ? [{
      type: g,
      attrs: f
    }] : void 0, v = lp(t.doc, t.mapping.map(s.pos), 1, m);
    if (!m && !v && lp(t.doc, t.mapping.map(s.pos), 1, g ? [{ type: g }] : void 0) && (v = !0, m = g ? [{
      type: g,
      attrs: f
    }] : void 0), v && (t.split(t.mapping.map(s.pos), 1, m), g && !h && !s.parentOffset && s.parent.type !== g)) {
      const w = t.mapping.map(s.before()), x = t.doc.resolve(w);
      s.node(-1).canReplaceWith(x.index(), x.index() + 1, g) && t.setNodeMarkup(t.mapping.map(s.before()), g);
    }
    e && _j(r, i.extensionManager.splittableMarks), t.scrollIntoView();
  }
  return !0;
}, s3e = (e) => ({ tr: t, state: r, dispatch: n, editor: i }) => {
  var o;
  const a = So(e, r.schema), { $from: s, $to: u } = r.selection, d = r.selection.node;
  if (d && d.isBlock || s.depth < 2 || !s.sameParent(u))
    return !1;
  const f = s.node(-1);
  if (f.type !== a)
    return !1;
  const h = i.extensionManager.attributes;
  if (s.parent.content.size === 0 && s.node(-1).childCount === s.indexAfter(-1)) {
    if (s.depth === 2 || s.node(-3).type !== a || s.index(-2) !== s.node(-2).childCount - 1)
      return !1;
    if (n) {
      let x = bt.empty;
      const y = s.index(-1) ? 1 : s.index(-2) ? 2 : 3;
      for (let E = s.depth - y; E >= s.depth - 3; E -= 1)
        x = bt.from(s.node(E).copy(x));
      const C = s.indexAfter(-1) < s.node(-2).childCount ? 1 : s.indexAfter(-2) < s.node(-3).childCount ? 2 : 3, S = p1(h, s.node().type.name, s.node().attrs), T = ((o = a.contentMatch.defaultType) === null || o === void 0 ? void 0 : o.createAndFill(S)) || void 0;
      x = x.append(bt.from(a.createAndFill(null, T) || void 0));
      const A = s.before(s.depth - (y - 1));
      t.replace(A, s.after(-C), new Ot(x, 4 - y, 0));
      let D = -1;
      t.doc.nodesBetween(A, t.doc.content.size, (E, N) => {
        if (D > -1)
          return !1;
        E.isTextblock && E.content.size === 0 && (D = N + 1);
      }), D > -1 && t.setSelection(pr.near(t.doc.resolve(D))), t.scrollIntoView();
    }
    return !0;
  }
  const g = u.pos === s.end() ? f.contentMatchAt(0).defaultType : null, m = p1(h, f.type.name, f.attrs), v = p1(h, s.node().type.name, s.node().attrs);
  t.delete(s.pos, u.pos);
  const w = g ? [{ type: a, attrs: m }, { type: g, attrs: v }] : [{ type: a, attrs: m }];
  return lp(t.doc, s.pos, 2) ? (n && t.split(s.pos, 2, w).scrollIntoView(), !0) : !1;
}, Lj = (e, t) => {
  const r = $_((a) => a.type === t)(e.selection);
  if (!r)
    return !0;
  const n = e.doc.resolve(Math.max(0, r.pos - 1)).before(r.depth);
  if (n === void 0)
    return !0;
  const i = e.doc.nodeAt(n);
  return r.node.type === (i == null ? void 0 : i.type) && Bc(e.doc, r.pos) && e.join(r.pos), !0;
}, Pj = (e, t) => {
  const r = $_((a) => a.type === t)(e.selection);
  if (!r)
    return !0;
  const n = e.doc.resolve(r.start).after(r.depth);
  if (n === void 0)
    return !0;
  const i = e.doc.nodeAt(n);
  return r.node.type === (i == null ? void 0 : i.type) && Bc(e.doc, n) && e.join(n), !0;
}, u3e = (e, t) => ({ editor: r, tr: n, state: i, dispatch: o, chain: a, commands: s, can: u }) => {
  const { extensions: d } = r.extensionManager, f = So(e, i.schema), h = So(t, i.schema), { selection: g } = i, { $from: m, $to: v } = g, w = m.blockRange(v);
  if (!w)
    return !1;
  const x = $_((y) => Oj(y.type.name, d))(g);
  if (w.depth >= 1 && x && w.depth - x.depth <= 1) {
    if (x.node.type === f)
      return s.liftListItem(h);
    if (Oj(x.node.type.name, d) && f.validContent(x.node.content) && o)
      return a().command(() => (n.setNodeMarkup(x.pos, f), !0)).command(() => Lj(n, f)).command(() => Pj(n, f)).run();
  }
  return a().command(() => u().wrapInList(f) ? !0 : s.clearNodes()).wrapInList(f).command(() => Lj(n, f)).command(() => Pj(n, f)).run();
}, c3e = (e, t = {}, r = {}) => ({ state: n, commands: i }) => {
  const { extendEmptyMarkRange: o = !1 } = r, a = Hc(e, n.schema);
  return XLe(n, a, t) ? i.unsetMark(a, { extendEmptyMarkRange: o }) : i.setMark(a, t);
}, d3e = (e, t, r = {}) => ({ state: n, commands: i }) => {
  const o = So(e, n.schema), a = So(t, n.schema);
  return N_(n, o, r) ? i.setNode(a) : i.setNode(o, r);
}, f3e = (e, t = {}) => ({ state: r, commands: n }) => {
  const i = So(e, r.schema);
  return N_(r, i, t) ? n.lift(i) : n.wrapIn(i, t);
}, h3e = () => ({ state: e, dispatch: t }) => {
  const r = e.plugins;
  for (let n = 0; n < r.length; n += 1) {
    const i = r[n];
    let o;
    if (i.spec.isInputRules && (o = i.getState(e))) {
      if (t) {
        const a = e.tr, s = o.transform;
        for (let u = s.steps.length - 1; u >= 0; u -= 1)
          a.step(s.steps[u].invert(s.docs[u]));
        if (o.text) {
          const u = a.doc.resolve(o.from).marks();
          a.replaceWith(o.from, o.to, e.schema.text(o.text, u));
        } else
          a.delete(o.from, o.to);
      }
      return !0;
    }
  }
  return !1;
}, p3e = () => ({ tr: e, dispatch: t }) => {
  const { selection: r } = e, { empty: n, ranges: i } = r;
  return n || t && i.forEach((o) => {
    e.removeMark(o.$from.pos, o.$to.pos);
  }), !0;
}, g3e = (e, t = {}) => ({ tr: r, state: n, dispatch: i }) => {
  var o;
  const { extendEmptyMarkRange: a = !1 } = t, { selection: s } = r, u = Hc(e, n.schema), { $from: d, empty: f, ranges: h } = s;
  if (!i)
    return !0;
  if (f && a) {
    let { from: g, to: m } = s;
    const v = (o = d.marks().find((x) => x.type === u)) === null || o === void 0 ? void 0 : o.attrs, w = E_(d, u, v);
    w && (g = w.from, m = w.to), r.removeMark(g, m, u);
  } else
    h.forEach((g) => {
      r.removeMark(g.$from.pos, g.$to.pos, u);
    });
  return r.removeStoredMark(u), !0;
}, m3e = (e, t = {}) => ({ tr: r, state: n, dispatch: i }) => {
  let o = null, a = null;
  const s = z_(typeof e == "string" ? e : e.name, n.schema);
  return s ? (s === "node" && (o = So(e, n.schema)), s === "mark" && (a = Hc(e, n.schema)), i && r.selection.ranges.forEach((u) => {
    const d = u.$from.pos, f = u.$to.pos;
    n.doc.nodesBetween(d, f, (h, g) => {
      o && o === h.type && r.setNodeMarkup(g, void 0, {
        ...h.attrs,
        ...t
      }), a && h.marks.length && h.marks.forEach((m) => {
        if (a === m.type) {
          const v = Math.max(g, d), w = Math.min(g + h.nodeSize, f);
          r.addMark(v, w, a.create({
            ...m.attrs,
            ...t
          }));
        }
      });
    });
  }), !0) : !1;
}, v3e = (e, t = {}) => ({ state: r, dispatch: n }) => {
  const i = So(e, r.schema);
  return H_e(i, t)(r, n);
}, b3e = (e, t = {}) => ({ state: r, dispatch: n }) => {
  const i = So(e, r.schema);
  return W_e(i, t)(r, n);
};
var y3e = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: nLe,
  clearContent: iLe,
  clearNodes: oLe,
  command: aLe,
  createParagraphNear: lLe,
  deleteCurrentNode: sLe,
  deleteNode: uLe,
  deleteRange: cLe,
  deleteSelection: dLe,
  enter: fLe,
  exitCode: hLe,
  extendMarkRange: gLe,
  first: mLe,
  focus: bLe,
  forEach: yLe,
  insertContent: xLe,
  insertContentAt: CLe,
  joinUp: SLe,
  joinDown: TLe,
  joinBackward: kLe,
  joinForward: DLe,
  keyboardShortcut: ELe,
  lift: ILe,
  liftEmptyBlock: NLe,
  liftListItem: zLe,
  newlineInCode: $Le,
  resetAttributes: OLe,
  scrollIntoView: _Le,
  selectAll: LLe,
  selectNodeBackward: PLe,
  selectNodeForward: RLe,
  selectParentNode: jLe,
  selectTextblockEnd: FLe,
  selectTextblockStart: BLe,
  setContent: HLe,
  setMark: t3e,
  setMeta: r3e,
  setNode: n3e,
  setNodeSelection: i3e,
  setTextSelection: o3e,
  sinkListItem: a3e,
  splitBlock: l3e,
  splitListItem: s3e,
  toggleList: u3e,
  toggleMark: c3e,
  toggleNode: d3e,
  toggleWrap: f3e,
  undoInputRule: h3e,
  unsetAllMarks: p3e,
  unsetMark: g3e,
  updateAttributes: m3e,
  wrapIn: v3e,
  wrapInList: b3e
});
Fn.create({
  name: "commands",
  addCommands() {
    return {
      ...y3e
    };
  }
});
Fn.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new ra({
        key: new _o("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
});
Fn.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: e } = this;
    return [
      new ra({
        key: new _o("focusEvents"),
        props: {
          handleDOMEvents: {
            focus: (t, r) => {
              e.isFocused = !0;
              const n = e.state.tr.setMeta("focus", { event: r }).setMeta("addToHistory", !1);
              return t.dispatch(n), !1;
            },
            blur: (t, r) => {
              e.isFocused = !1;
              const n = e.state.tr.setMeta("blur", { event: r }).setMeta("addToHistory", !1);
              return t.dispatch(n), !1;
            }
          }
        }
      })
    ];
  }
});
Fn.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const e = () => this.editor.commands.first(({ commands: a }) => [
      () => a.undoInputRule(),
      // maybe convert first text block node to default node
      () => a.command(({ tr: s }) => {
        const { selection: u, doc: d } = s, { empty: f, $anchor: h } = u, { pos: g, parent: m } = h, v = Ar.atStart(d).from === g;
        return !f || !v || !m.type.isTextblock || m.textContent.length ? !1 : a.clearNodes();
      }),
      () => a.deleteSelection(),
      () => a.joinBackward(),
      () => a.selectNodeBackward()
    ]), t = () => this.editor.commands.first(({ commands: a }) => [
      () => a.deleteSelection(),
      () => a.deleteCurrentNode(),
      () => a.joinForward(),
      () => a.selectNodeForward()
    ]), n = {
      Enter: () => this.editor.commands.first(({ commands: a }) => [
        () => a.newlineInCode(),
        () => a.createParagraphNear(),
        () => a.liftEmptyBlock(),
        () => a.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: e,
      "Mod-Backspace": e,
      "Shift-Backspace": e,
      Delete: t,
      "Mod-Delete": t,
      "Mod-a": () => this.editor.commands.selectAll()
    }, i = {
      ...n
    }, o = {
      ...n,
      "Ctrl-h": e,
      "Alt-Backspace": e,
      "Ctrl-d": t,
      "Ctrl-Alt-Backspace": t,
      "Alt-Delete": t,
      "Alt-d": t,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return uC() || OQ() ? o : i;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new ra({
        key: new _o("clearDocument"),
        appendTransaction: (e, t, r) => {
          if (!(e.some((v) => v.docChanged) && !t.doc.eq(r.doc)))
            return;
          const { empty: i, from: o, to: a } = t.selection, s = Ar.atStart(t.doc).from, u = Ar.atEnd(t.doc).to, d = o === s && a === u, f = r.doc.textBetween(0, r.doc.content.size, " ", " ").length === 0;
          if (i || !d || !f)
            return;
          const h = r.tr, g = zQ({
            state: r,
            transaction: h
          }), { commands: m } = new Z_e({
            editor: this.editor,
            state: g
          });
          if (m.clearNodes(), !!h.steps.length)
            return h;
        }
      })
    ];
  }
});
Fn.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new ra({
        key: new _o("tabindex"),
        props: {
          attributes: this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
function oh(e) {
  return new lC({
    find: e.find,
    handler: ({ state: t, range: r, match: n }) => {
      const i = di(e.getAttributes, void 0, n);
      if (i === !1 || i === null)
        return null;
      const { tr: o } = t, a = n[n.length - 1], s = n[0];
      let u = r.to;
      if (a) {
        const d = s.search(/\S/), f = r.from + s.indexOf(a), h = f + a.length;
        if (Ox(r.from, r.to, t.doc).filter((m) => m.mark.type.excluded.find((w) => w === e.type && w !== m.mark.type)).filter((m) => m.to > f).length)
          return null;
        h < r.to && o.delete(h, r.to), f > r.from && o.delete(r.from + d, f), u = r.from + d + a.length, o.addMark(r.from + d, u, e.type.create(i || {})), o.removeStoredMark(e.type);
      }
    }
  });
}
function x3e(e) {
  return new lC({
    find: e.find,
    handler: ({ state: t, range: r, match: n }) => {
      const i = di(e.getAttributes, void 0, n) || {}, { tr: o } = t, a = r.from;
      let s = r.to;
      if (n[1]) {
        const u = n[0].lastIndexOf(n[1]);
        let d = a + u;
        d > s ? d = s : s = d + n[1].length;
        const f = n[0][n[0].length - 1];
        o.insertText(f, a + n[0].length - 1), o.replaceWith(d, s, e.type.create(i));
      } else
        n[0] && o.replaceWith(a, s, e.type.create(i));
    }
  });
}
function H$(e) {
  return new lC({
    find: e.find,
    handler: ({ state: t, range: r, match: n }) => {
      const i = t.doc.resolve(r.from), o = di(e.getAttributes, void 0, n) || {};
      if (!i.node(-1).canReplaceWith(i.index(-1), i.indexAfter(-1), e.type))
        return null;
      t.tr.delete(r.from, r.to).setBlockType(r.from, r.from, e.type, o);
    }
  });
}
function U0(e) {
  return new lC({
    find: e.find,
    handler: ({ state: t, range: r, match: n }) => {
      const i = di(e.getAttributes, void 0, n) || {}, o = t.tr.delete(r.from, r.to), s = o.doc.resolve(r.from).blockRange(), u = s && x_(s, e.type, i);
      if (!u)
        return null;
      o.wrap(s, u);
      const d = o.doc.resolve(r.from - 1).nodeBefore;
      d && d.type === e.type && Bc(o.doc, r.from - 1) && (!e.joinPredicate || e.joinPredicate(n, d)) && o.join(r.from - 1);
    }
  });
}
class Ua {
  constructor(t = {}) {
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...t
    }, this.name = this.config.name, t.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = di(qi(this, "addOptions", {
      name: this.name
    }))), this.storage = di(qi(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(t = {}) {
    return new Ua(t);
  }
  configure(t = {}) {
    const r = this.extend();
    return r.options = sC(this.options, t), r.storage = di(qi(r, "addStorage", {
      name: r.name,
      options: r.options
    })), r;
  }
  extend(t = {}) {
    const r = new Ua(t);
    return r.parent = this, this.child = r, r.name = t.name ? t.name : r.parent.name, t.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${r.name}".`), r.options = di(qi(r, "addOptions", {
      name: r.name
    })), r.storage = di(qi(r, "addStorage", {
      name: r.name,
      options: r.options
    })), r;
  }
  static handleExit({ editor: t, mark: r }) {
    const { tr: n } = t.state, i = t.state.selection.$from;
    if (i.pos === i.end()) {
      const a = i.marks();
      if (!!!a.find((d) => (d == null ? void 0 : d.type.name) === r.name))
        return !1;
      const u = a.find((d) => (d == null ? void 0 : d.type.name) === r.name);
      return u && n.removeStoredMark(u), n.insertText(" ", i.pos), t.view.dispatch(n), !0;
    }
    return !1;
  }
}
let Lo = class W$ {
  constructor(t = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...t
    }, this.name = this.config.name, t.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = di(qi(this, "addOptions", {
      name: this.name
    }))), this.storage = di(qi(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(t = {}) {
    return new W$(t);
  }
  configure(t = {}) {
    const r = this.extend();
    return r.options = sC(this.options, t), r.storage = di(qi(r, "addStorage", {
      name: r.name,
      options: r.options
    })), r;
  }
  extend(t = {}) {
    const r = new W$(t);
    return r.parent = this, this.child = r, r.name = t.name ? t.name : r.parent.name, t.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${r.name}".`), r.options = di(qi(r, "addOptions", {
      name: r.name
    })), r.storage = di(qi(r, "addStorage", {
      name: r.name,
      options: r.options
    })), r;
  }
};
class w3e {
  constructor(t, r, n) {
    this.isDragging = !1, this.component = t, this.editor = r.editor, this.options = {
      stopEvent: null,
      ignoreMutation: null,
      ...n
    }, this.extension = r.extension, this.node = r.node, this.decorations = r.decorations, this.getPos = r.getPos, this.mount();
  }
  mount() {
  }
  get dom() {
    return this.editor.view.dom;
  }
  get contentDOM() {
    return null;
  }
  onDragStart(t) {
    var r, n, i, o, a, s, u;
    const { view: d } = this.editor, f = t.target, h = f.nodeType === 3 ? (r = f.parentElement) === null || r === void 0 ? void 0 : r.closest("[data-drag-handle]") : f.closest("[data-drag-handle]");
    if (!this.dom || !((n = this.contentDOM) === null || n === void 0) && n.contains(f) || !h)
      return;
    let g = 0, m = 0;
    if (this.dom !== h) {
      const x = this.dom.getBoundingClientRect(), y = h.getBoundingClientRect(), C = (i = t.offsetX) !== null && i !== void 0 ? i : (o = t.nativeEvent) === null || o === void 0 ? void 0 : o.offsetX, S = (a = t.offsetY) !== null && a !== void 0 ? a : (s = t.nativeEvent) === null || s === void 0 ? void 0 : s.offsetY;
      g = y.x - x.x + C, m = y.y - x.y + S;
    }
    (u = t.dataTransfer) === null || u === void 0 || u.setDragImage(this.dom, g, m);
    const v = Bt.create(d.state.doc, this.getPos()), w = d.state.tr.setSelection(v);
    d.dispatch(w);
  }
  stopEvent(t) {
    var r;
    if (!this.dom)
      return !1;
    if (typeof this.options.stopEvent == "function")
      return this.options.stopEvent({ event: t });
    const n = t.target;
    if (!(this.dom.contains(n) && !(!((r = this.contentDOM) === null || r === void 0) && r.contains(n))))
      return !1;
    const o = t.type === "drop";
    if ((["INPUT", "BUTTON", "SELECT", "TEXTAREA"].includes(n.tagName) || n.isContentEditable) && !o)
      return !0;
    const { isEditable: s } = this.editor, { isDragging: u } = this, d = !!this.node.type.spec.draggable, f = Bt.isSelectable(this.node), h = t.type === "copy", g = t.type === "paste", m = t.type === "cut", v = t.type === "mousedown", w = t.type.startsWith("drag");
    if (!d && f && w && t.preventDefault(), d && w && !u)
      return t.preventDefault(), !1;
    if (d && s && !u && v) {
      const x = n.closest("[data-drag-handle]");
      x && (this.dom === x || this.dom.contains(x)) && (this.isDragging = !0, document.addEventListener("dragend", () => {
        this.isDragging = !1;
      }, { once: !0 }), document.addEventListener("mouseup", () => {
        this.isDragging = !1;
      }, { once: !0 }));
    }
    return !(u || o || h || g || m || v && f);
  }
  ignoreMutation(t) {
    return !this.dom || !this.contentDOM ? !0 : typeof this.options.ignoreMutation == "function" ? this.options.ignoreMutation({ mutation: t }) : this.node.isLeaf || this.node.isAtom ? !0 : t.type === "selection" || this.dom.contains(t.target) && t.type === "childList" && uC() && this.editor.isFocused && [
      ...Array.from(t.addedNodes),
      ...Array.from(t.removedNodes)
    ].every((n) => n.isContentEditable) ? !1 : this.contentDOM === t.target && t.type === "attributes" ? !0 : !this.contentDOM.contains(t.target);
  }
  updateAttributes(t) {
    this.editor.commands.command(({ tr: r }) => {
      const n = this.getPos();
      return r.setNodeMarkup(n, void 0, {
        ...this.node.attrs,
        ...t
      }), !0;
    });
  }
  deleteNode() {
    const t = this.getPos(), r = t + this.node.nodeSize;
    this.editor.commands.deleteRange({ from: t, to: r });
  }
}
function Ec(e) {
  return new $Q({
    find: e.find,
    handler: ({ state: t, range: r, match: n }) => {
      const i = di(e.getAttributes, void 0, n);
      if (i === !1 || i === null)
        return null;
      const { tr: o } = t, a = n[n.length - 1], s = n[0];
      let u = r.to;
      if (a) {
        const d = s.search(/\S/), f = r.from + s.indexOf(a), h = f + a.length;
        if (Ox(r.from, r.to, t.doc).filter((m) => m.mark.type.excluded.find((w) => w === e.type && w !== m.mark.type)).filter((m) => m.to > f).length)
          return null;
        h < r.to && o.delete(h, r.to), f > r.from && o.delete(r.from + d, f), u = r.from + d + a.length, o.addMark(r.from + d, u, e.type.create(i || {})), o.removeStoredMark(e.type);
      }
    }
  });
}
function M3e(e) {
  return new $Q({
    find: e.find,
    handler({ match: t, chain: r, range: n }) {
      const i = di(e.getAttributes, void 0, t);
      if (i === !1 || i === null)
        return null;
      t.input && r().deleteRange(n).insertContentAt(n.from, {
        type: e.type.name,
        attrs: i
      });
    }
  });
}
const g1 = Lo.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["li", _n(this.options.HTMLAttributes, e), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
});
/*!
  * vue-color-kit v1.0.6
  * (c) 2023 
  * @license MIT
  */
function xf(e) {
  let t = { r: 0, g: 0, b: 0, a: 1 };
  /#/.test(e) ? t = S3e(e) : /rgb/.test(e) ? t = Rj(e) : typeof e == "string" ? t = Rj(`rgba(${e})`) : Object.prototype.toString.call(e) === "[object Object]" && (t = e);
  const { r, g: n, b: i, a: o } = t, { h: a, s, v: u } = T3e(t);
  return { r, g: n, b: i, a: o === void 0 ? 1 : o, h: a, s, v: u };
}
function __(e) {
  const t = document.createElement("canvas"), r = t.getContext("2d"), n = e * 2;
  return t.width = n, t.height = n, r.fillStyle = "#ffffff", r.fillRect(0, 0, n, n), r.fillStyle = "#ccd5db", r.fillRect(0, 0, e, e), r.fillRect(e, e, e, e), t;
}
function V$(e, t, r, n, i, o) {
  const a = e === "l", s = t.createLinearGradient(0, 0, a ? r : 0, a ? 0 : n);
  s.addColorStop(0.01, i), s.addColorStop(0.99, o), t.fillStyle = s, t.fillRect(0, 0, r, n);
}
function C3e({ r: e, g: t, b: r }, n) {
  const i = (a) => ("0" + Number(a).toString(16)).slice(-2), o = `#${i(e)}${i(t)}${i(r)}`;
  return n ? o.toUpperCase() : o;
}
function S3e(e) {
  e = e.slice(1);
  const t = (r) => parseInt(r, 16) || 0;
  return {
    r: t(e.slice(0, 2)),
    g: t(e.slice(2, 4)),
    b: t(e.slice(4, 6))
  };
}
function Rj(e) {
  return typeof e == "string" ? (e = (/rgba?\((.*?)\)/.exec(e) || ["", "0,0,0,1"])[1].split(","), {
    r: Number(e[0]) || 0,
    g: Number(e[1]) || 0,
    b: Number(e[2]) || 0,
    a: Number(e[3] ? e[3] : 1)
  }) : e;
}
function T3e({ r: e, g: t, b: r }) {
  e = e / 255, t = t / 255, r = r / 255;
  const n = Math.max(e, t, r), i = Math.min(e, t, r), o = n - i;
  let a = 0;
  n === i ? a = 0 : n === e ? t >= r ? a = 60 * (t - r) / o : a = 60 * (t - r) / o + 360 : n === t ? a = 60 * (r - e) / o + 120 : n === r && (a = 60 * (e - t) / o + 240), a = Math.floor(a);
  let s = parseFloat((n === 0 ? 0 : 1 - i / n).toFixed(2)), u = parseFloat(n.toFixed(2));
  return { h: a, s, v: u };
}
var L_ = oe({
  props: {
    color: {
      type: String,
      default: "#000000"
    },
    hsv: {
      type: Object,
      default: null
    },
    size: {
      type: Number,
      default: 152
    }
  },
  emits: ["selectSaturation"],
  data() {
    return {
      slideSaturationStyle: {}
    };
  },
  // Can’t monitor, otherwise the color will change when you change yourself
  // watch: {
  //     color() {
  //         this.renderColor()
  //     }
  // },
  mounted() {
    this.renderColor(), this.renderSlide();
  },
  methods: {
    renderColor() {
      const e = this.$refs.canvasSaturation, t = this.size, r = e.getContext("2d");
      e.width = t, e.height = t, r.fillStyle = this.color, r.fillRect(0, 0, t, t), V$("l", r, t, t, "#FFFFFF", "rgba(255,255,255,0)"), V$("p", r, t, t, "rgba(0,0,0,0)", "#000000");
    },
    renderSlide() {
      this.slideSaturationStyle = {
        left: this.hsv.s * this.size - 5 + "px",
        top: (1 - this.hsv.v) * this.size - 5 + "px"
      };
    },
    selectSaturation(e) {
      const { top: t, left: r } = this.$el.getBoundingClientRect(), n = e.target.getContext("2d"), i = (a) => {
        let s = a.clientX - r, u = a.clientY - t;
        s < 0 && (s = 0), u < 0 && (u = 0), s > this.size && (s = this.size), u > this.size && (u = this.size), this.slideSaturationStyle = {
          left: s - 5 + "px",
          top: u - 5 + "px"
        };
        const d = n.getImageData(Math.min(s, this.size - 1), Math.min(u, this.size - 1), 1, 1), [f, h, g] = d.data;
        this.$emit("selectSaturation", { r: f, g: h, b: g });
      };
      i(e);
      const o = () => {
        document.removeEventListener("mousemove", i), document.removeEventListener("mouseup", o);
      };
      document.addEventListener("mousemove", i), document.addEventListener("mouseup", o);
    }
  }
});
const k3e = { ref: "canvasSaturation" };
function D3e(e, t, r, n, i, o) {
  return ie(), Pe(
    "div",
    {
      class: "saturation",
      onMousedown: t[1] || (t[1] = HO((...a) => e.selectSaturation && e.selectSaturation(...a), ["prevent", "stop"]))
    },
    [
      Re(
        "canvas",
        k3e,
        null,
        512
        /* NEED_PATCH */
      ),
      Re(
        "div",
        {
          style: e.slideSaturationStyle,
          class: "slide"
        },
        null,
        4
        /* STYLE */
      )
    ],
    32
    /* HYDRATE_EVENTS */
  );
}
L_.render = D3e;
L_.__file = "src/color/Saturation.vue";
var P_ = oe({
  props: {
    hsv: {
      type: Object,
      default: null
    },
    width: {
      type: Number,
      default: 15
    },
    height: {
      type: Number,
      default: 152
    }
  },
  emits: ["selectHue"],
  data() {
    return {
      slideHueStyle: {}
    };
  },
  mounted() {
    this.renderColor(), this.renderSlide();
  },
  methods: {
    renderColor() {
      const e = this.$refs.canvasHue, t = this.width, r = this.height, n = e.getContext("2d");
      e.width = t, e.height = r;
      const i = n.createLinearGradient(0, 0, 0, r);
      i.addColorStop(0, "#FF0000"), i.addColorStop(0.17 * 1, "#FF00FF"), i.addColorStop(0.17 * 2, "#0000FF"), i.addColorStop(0.17 * 3, "#00FFFF"), i.addColorStop(0.17 * 4, "#00FF00"), i.addColorStop(0.17 * 5, "#FFFF00"), i.addColorStop(1, "#FF0000"), n.fillStyle = i, n.fillRect(0, 0, t, r);
    },
    renderSlide() {
      this.slideHueStyle = {
        top: (1 - this.hsv.h / 360) * this.height - 2 + "px"
      };
    },
    selectHue(e) {
      const { top: t } = this.$el.getBoundingClientRect(), r = e.target.getContext("2d"), n = (o) => {
        let a = o.clientY - t;
        a < 0 && (a = 0), a > this.height && (a = this.height), this.slideHueStyle = {
          top: a - 2 + "px"
        };
        const s = r.getImageData(0, Math.min(a, this.height - 1), 1, 1), [u, d, f] = s.data;
        this.$emit("selectHue", { r: u, g: d, b: f });
      };
      n(e);
      const i = () => {
        document.removeEventListener("mousemove", n), document.removeEventListener("mouseup", i);
      };
      document.addEventListener("mousemove", n), document.addEventListener("mouseup", i);
    }
  }
});
const A3e = { ref: "canvasHue" };
function E3e(e, t, r, n, i, o) {
  return ie(), Pe(
    "div",
    {
      class: "hue",
      onMousedown: t[1] || (t[1] = HO((...a) => e.selectHue && e.selectHue(...a), ["prevent", "stop"]))
    },
    [
      Re(
        "canvas",
        A3e,
        null,
        512
        /* NEED_PATCH */
      ),
      Re(
        "div",
        {
          style: e.slideHueStyle,
          class: "slide"
        },
        null,
        4
        /* STYLE */
      )
    ],
    32
    /* HYDRATE_EVENTS */
  );
}
P_.render = E3e;
P_.__file = "src/color/Hue.vue";
var R_ = oe({
  props: {
    color: {
      type: String,
      default: "#000000"
    },
    rgba: {
      type: Object,
      default: null
    },
    width: {
      type: Number,
      default: 15
    },
    height: {
      type: Number,
      default: 152
    }
  },
  emits: ["selectAlpha"],
  data() {
    return {
      slideAlphaStyle: {},
      alphaSize: 5
    };
  },
  watch: {
    color() {
      this.renderColor();
    },
    "rgba.a"() {
      this.renderSlide();
    }
  },
  mounted() {
    this.renderColor(), this.renderSlide();
  },
  methods: {
    renderColor() {
      const e = this.$refs.canvasAlpha, t = this.width, r = this.height, n = this.alphaSize, i = __(n), o = e.getContext("2d");
      e.width = t, e.height = r, o.fillStyle = o.createPattern(i, "repeat"), o.fillRect(0, 0, t, r), V$("p", o, t, r, "rgba(255,255,255,0)", this.color);
    },
    renderSlide() {
      this.slideAlphaStyle = {
        top: this.rgba.a * this.height - 2 + "px"
      };
    },
    selectAlpha(e) {
      const { top: t } = this.$el.getBoundingClientRect(), r = (i) => {
        let o = i.clientY - t;
        o < 0 && (o = 0), o > this.height && (o = this.height);
        let a = parseFloat((o / this.height).toFixed(2));
        this.$emit("selectAlpha", a);
      };
      r(e);
      const n = () => {
        document.removeEventListener("mousemove", r), document.removeEventListener("mouseup", n);
      };
      document.addEventListener("mousemove", r), document.addEventListener("mouseup", n);
    }
  }
});
const I3e = { ref: "canvasAlpha" };
function N3e(e, t, r, n, i, o) {
  return ie(), Pe(
    "div",
    {
      class: "color-alpha",
      onMousedown: t[1] || (t[1] = HO((...a) => e.selectAlpha && e.selectAlpha(...a), ["prevent", "stop"]))
    },
    [
      Re(
        "canvas",
        I3e,
        null,
        512
        /* NEED_PATCH */
      ),
      Re(
        "div",
        {
          style: e.slideAlphaStyle,
          class: "slide"
        },
        null,
        4
        /* STYLE */
      )
    ],
    32
    /* HYDRATE_EVENTS */
  );
}
R_.render = N3e;
R_.__file = "src/color/Alpha.vue";
var j_ = oe({
  props: {
    color: {
      type: String,
      default: "#000000"
    },
    width: {
      type: Number,
      default: 100
    },
    height: {
      type: Number,
      default: 30
    }
  },
  data() {
    return {
      alphaSize: 5
    };
  },
  watch: {
    color() {
      this.renderColor();
    }
  },
  mounted() {
    this.renderColor();
  },
  methods: {
    renderColor() {
      const e = this.$el, t = this.width, r = this.height, n = this.alphaSize, i = __(n), o = e.getContext("2d");
      e.width = t, e.height = r, o.fillStyle = o.createPattern(i, "repeat"), o.fillRect(0, 0, t, r), o.fillStyle = this.color, o.fillRect(0, 0, t, r);
    }
  }
});
function z3e(e, t, r, n, i, o) {
  return ie(), Pe("canvas");
}
j_.render = z3e;
j_.__file = "src/color/Preview.vue";
var F_ = oe({
  props: {
    suckerCanvas: {
      type: Object,
      default: null
    },
    suckerArea: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isOpenSucker: !1,
      suckerPreview: null,
      isSucking: !1
    };
  },
  watch: {
    suckerCanvas(e) {
      this.isSucking = !1, this.suckColor(e);
    }
  },
  methods: {
    openSucker() {
      this.isOpenSucker ? this.keydownHandler({ keyCode: 27 }) : (this.isOpenSucker = !0, this.isSucking = !0, this.$emit("openSucker", !0), document.addEventListener("keydown", this.keydownHandler));
    },
    keydownHandler(e) {
      e.keyCode === 27 && (this.isOpenSucker = !1, this.isSucking = !1, this.$emit("openSucker", !1), document.removeEventListener("keydown", this.keydownHandler), document.removeEventListener("mousemove", this.mousemoveHandler), document.removeEventListener("mouseup", this.mousemoveHandler), this.suckerPreview && (document.body.removeChild(this.suckerPreview), this.suckerPreview = null));
    },
    mousemoveHandler(e) {
      const { clientX: t, clientY: r } = e, { top: n, left: i, width: o, height: a } = this.suckerCanvas.getBoundingClientRect(), s = t - i, u = r - n, f = this.suckerCanvas.getContext("2d").getImageData(Math.min(s, o - 1), Math.min(u, a - 1), 1, 1);
      let [h, g, m, v] = f.data;
      v = parseFloat((v / 255).toFixed(2));
      const w = this.suckerPreview.style;
      Object.assign(w, {
        position: "absolute",
        left: t + 20 + "px",
        top: r - 36 + "px",
        width: "24px",
        height: "24px",
        borderRadius: "50%",
        border: "2px solid #fff",
        boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.16)",
        background: `rgba(${h}, ${g}, ${m}, ${v})`,
        zIndex: 95
      }), this.suckerArea.length && // @ts-ignore
      t >= this.suckerArea[0] && // @ts-ignore
      r >= this.suckerArea[1] && // @ts-ignore
      t <= this.suckerArea[2] && // @ts-ignore
      r <= this.suckerArea[3] ? w.display = "" : w.display = "none";
    },
    suckColor(e) {
      e && e.tagName !== "CANVAS" || (this.suckerPreview = document.createElement("div"), this.suckerPreview && document.body.appendChild(this.suckerPreview), document.addEventListener("mousemove", this.mousemoveHandler), document.addEventListener("mouseup", this.mousemoveHandler), e.addEventListener("click", (t) => {
        const { clientX: r, clientY: n } = t, { top: i, left: o, width: a, height: s } = e.getBoundingClientRect(), u = r - o, d = n - i, h = e.getContext("2d").getImageData(Math.min(u, a - 1), Math.min(d, s - 1), 1, 1);
        let [g, m, v, w] = h.data;
        w = parseFloat((w / 255).toFixed(2)), this.$emit("selectSucker", { r: g, g: m, b: v, a: w });
      }));
    }
  }
});
const $3e = /* @__PURE__ */ Re(
  "path",
  { d: "M13.1,8.2l5.6,5.6c0.4,0.4,0.5,1.1,0.1,1.5s-1.1,0.5-1.5,0.1c0,0-0.1,0-0.1-0.1l-1.4-1.4l-7.7,7.7C7.9,21.9,7.6,22,7.3,22H3.1C2.5,22,2,21.5,2,20.9l0,0v-4.2c0-0.3,0.1-0.6,0.3-0.8l5.8-5.8C8.5,9.7,9.2,9.6,9.7,10s0.5,1.1,0.1,1.5c0,0,0,0.1-0.1,0.1l-5.5,5.5v2.7h2.7l7.4-7.4L8.7,6.8c-0.5-0.4-0.5-1-0.1-1.5s1.1-0.5,1.5-0.1c0,0,0.1,0,0.1,0.1l1.4,1.4l3.5-3.5c1.6-1.6,4.1-1.6,5.8-0.1c1.6,1.6,1.6,4.1,0.1,5.8L20.9,9l-3.6,3.6c-0.4,0.4-1.1,0.5-1.5,0.1" },
  null,
  -1
  /* HOISTED */
), O3e = {
  key: 1,
  class: "sucker",
  viewBox: "-16 -16 68 68",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "#9099a4"
}, _3e = /* @__PURE__ */ Re(
  "g",
  {
    fill: "none",
    "fill-rule": "evenodd"
  },
  [
    /* @__PURE__ */ Re("g", {
      transform: "translate(1 1)",
      "stroke-width": "4"
    }, [
      /* @__PURE__ */ Re("circle", {
        "stroke-opacity": ".5",
        cx: "18",
        cy: "18",
        r: "18"
      }),
      /* @__PURE__ */ Re("path", { d: "M36 18c0-9.94-8.06-18-18-18" }, [
        /* @__PURE__ */ Re("animateTransform", {
          attributeName: "transform",
          type: "rotate",
          from: "0 18 18",
          to: "360 18 18",
          dur: "1s",
          repeatCount: "indefinite"
        })
      ])
    ])
  ],
  -1
  /* HOISTED */
);
function L3e(e, t, r, n, i, o) {
  return ie(), Pe("div", null, [
    e.isSucking ? yt("v-if", !0) : (ie(), Pe(
      "svg",
      {
        key: 0,
        class: [{ active: e.isOpenSucker }, "sucker"],
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "-12 -12 48 48",
        onClick: t[1] || (t[1] = (...a) => e.openSucker && e.openSucker(...a))
      },
      [
        $3e
      ],
      2
      /* CLASS */
    )),
    e.isSucking ? (ie(), Pe("svg", O3e, [
      _3e
    ])) : yt("v-if", !0)
  ]);
}
F_.render = L3e;
F_.__file = "src/color/Sucker.vue";
var B_ = oe({
  props: {
    name: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
    }
  },
  emits: ["inputColor", "inputFocus", "inputBlur"],
  setup(e, { emit: t }) {
    return {
      modelColor: j({
        get() {
          return e.color || "";
        },
        set(o) {
          t("inputColor", o);
        }
      }),
      handleFocus: (o) => {
        t("inputFocus", o);
      },
      handleBlur: (o) => {
        t("inputBlur", o);
      }
    };
  }
});
const P3e = { class: "color-type" }, R3e = { class: "name" };
function j3e(e, t, r, n, i, o) {
  return ie(), Pe("div", P3e, [
    Re(
      "span",
      R3e,
      ar(e.name),
      1
      /* TEXT */
    ),
    Jn(Re(
      "input",
      {
        "onUpdate:modelValue": t[1] || (t[1] = (a) => e.modelColor = a),
        class: "value",
        onFocus: t[2] || (t[2] = (...a) => e.handleFocus && e.handleFocus(...a)),
        onBlur: t[3] || (t[3] = (...a) => e.handleBlur && e.handleBlur(...a))
      },
      null,
      544
      /* HYDRATE_EVENTS, NEED_PATCH */
    ), [
      [LB, e.modelColor]
    ])
  ]);
}
B_.render = j3e;
B_.__file = "src/color/Box.vue";
var U_ = oe({
  name: "ColorPicker",
  props: {
    color: {
      type: String,
      default: "#000000"
    },
    colorsDefault: {
      type: Array,
      default: () => []
    },
    colorsHistoryKey: {
      type: String,
      default: ""
    }
  },
  emits: ["selectColor"],
  setup(e, { emit: t }) {
    const r = G(), n = G([]), i = G();
    e.colorsHistoryKey && localStorage && (n.value = JSON.parse(localStorage.getItem(e.colorsHistoryKey)) || []), i.value = __(4).toDataURL(), FO(() => {
      o(r.value);
    });
    function o(s) {
      if (!s)
        return;
      const u = n.value || [], d = u.indexOf(s);
      d >= 0 && u.splice(d, 1), u.length >= 8 && (u.length = 7), u.unshift(s), n.value = u || [], localStorage && e.colorsHistoryKey && localStorage.setItem(e.colorsHistoryKey, JSON.stringify(u));
    }
    function a(s) {
      t("selectColor", s);
    }
    return {
      setColorsHistory: o,
      colorsHistory: n,
      color: r,
      imgAlphaBase64: i,
      selectColor: a
    };
  }
});
const F3e = { class: "colors" }, B3e = {
  key: 0,
  class: "colors history"
};
function U3e(e, t, r, n, i, o) {
  return ie(), Pe("div", null, [
    Re("ul", F3e, [
      (ie(!0), Pe(
        Lr,
        null,
        Fl(e.colorsDefault, (a) => (ie(), Pe("li", {
          key: a,
          class: "item",
          onClick: (s) => e.selectColor(a)
        }, [
          Re(
            "div",
            {
              style: { background: `url(${e.imgAlphaBase64})` },
              class: "alpha"
            },
            null,
            4
            /* STYLE */
          ),
          Re(
            "div",
            {
              style: { background: a },
              class: "color"
            },
            null,
            4
            /* STYLE */
          )
        ], 8, ["onClick"]))),
        128
        /* KEYED_FRAGMENT */
      ))
    ]),
    e.colorsHistory.length ? (ie(), Pe("ul", B3e, [
      (ie(!0), Pe(
        Lr,
        null,
        Fl(e.colorsHistory, (a) => (ie(), Pe("li", {
          key: a,
          class: "item",
          onClick: (s) => e.selectColor(a)
        }, [
          Re(
            "div",
            {
              style: { background: `url(${e.imgAlphaBase64})` },
              class: "alpha"
            },
            null,
            4
            /* STYLE */
          ),
          Re(
            "div",
            {
              style: { background: a },
              class: "color"
            },
            null,
            4
            /* STYLE */
          )
        ], 8, ["onClick"]))),
        128
        /* KEYED_FRAGMENT */
      ))
    ])) : yt("v-if", !0)
  ]);
}
U_.render = U3e;
U_.__file = "src/color/Colors.vue";
var cp = oe({
  components: {
    Saturation: L_,
    Hue: P_,
    Alpha: R_,
    Preview: j_,
    Sucker: F_,
    Box: B_,
    Colors: U_
  },
  emits: ["changeColor", "openSucker", "inputFocus", "inputBlur"],
  props: {
    color: {
      type: String,
      default: "#000000"
    },
    theme: {
      type: String,
      default: "dark"
    },
    suckerHide: {
      type: Boolean,
      default: !0
    },
    suckerCanvas: {
      type: null,
      default: null
    },
    suckerArea: {
      type: Array,
      default: () => []
    },
    colorsDefault: {
      type: Array,
      default: () => [
        "#000000",
        "#FFFFFF",
        "#FF1900",
        "#F47365",
        "#FFB243",
        "#FFE623",
        "#6EFF2A",
        "#1BC7B1",
        "#00BEFF",
        "#2E81FF",
        "#5D61FF",
        "#FF89CF",
        "#FC3CAD",
        "#BF3DCE",
        "#8E00A7",
        "rgba(0,0,0,0)"
      ]
    },
    colorsHistoryKey: {
      type: String,
      default: "vue-colorpicker-history"
    }
  },
  data() {
    return {
      hueWidth: 15,
      hueHeight: 152,
      previewHeight: 30,
      modelRgba: "",
      modelHex: "",
      r: 0,
      g: 0,
      b: 0,
      a: 1,
      h: 0,
      s: 0,
      v: 0
    };
  },
  computed: {
    isLightTheme() {
      return this.theme === "light";
    },
    totalWidth() {
      return this.hueHeight + (this.hueWidth + 8) * 2;
    },
    previewWidth() {
      return this.totalWidth - (this.suckerHide ? 0 : this.previewHeight);
    },
    rgba() {
      return {
        r: this.r,
        g: this.g,
        b: this.b,
        a: this.a
      };
    },
    hsv() {
      return {
        h: this.h,
        s: this.s,
        v: this.v
      };
    },
    rgbString() {
      return `rgb(${this.r}, ${this.g}, ${this.b})`;
    },
    rgbaStringShort() {
      return `${this.r}, ${this.g}, ${this.b}, ${this.a}`;
    },
    rgbaString() {
      return `rgba(${this.rgbaStringShort})`;
    },
    hexString() {
      return C3e(this.rgba, !0);
    }
  },
  created() {
    Object.assign(this, xf(this.color)), this.setText(), this.$watch("rgba", () => {
      this.$emit("changeColor", {
        rgba: this.rgba,
        hsv: this.hsv,
        hex: this.modelHex
      });
    });
  },
  methods: {
    selectSaturation(e) {
      const { r: t, g: r, b: n, h: i, s: o, v: a } = xf(e);
      Object.assign(this, { r: t, g: r, b: n, h: i, s: o, v: a }), this.setText();
    },
    handleFocus(e) {
      this.$emit("inputFocus", e);
    },
    handleBlur(e) {
      this.$emit("inputBlur", e);
    },
    selectHue(e) {
      const { r: t, g: r, b: n, h: i, s: o, v: a } = xf(e);
      Object.assign(this, { r: t, g: r, b: n, h: i, s: o, v: a }), this.setText(), this.$nextTick(() => {
        this.$refs.saturation.renderColor(), this.$refs.saturation.renderSlide();
      });
    },
    selectAlpha(e) {
      this.a = e, this.setText();
    },
    inputHex(e) {
      const { r: t, g: r, b: n, a: i, h: o, s: a, v: s } = xf(e);
      Object.assign(this, { r: t, g: r, b: n, a: i, h: o, s: a, v: s }), this.modelHex = e, this.modelRgba = this.rgbaStringShort, this.$nextTick(() => {
        this.$refs.saturation.renderColor(), this.$refs.saturation.renderSlide(), this.$refs.hue.renderSlide();
      });
    },
    inputRgba(e) {
      const { r: t, g: r, b: n, a: i, h: o, s: a, v: s } = xf(e);
      Object.assign(this, { r: t, g: r, b: n, a: i, h: o, s: a, v: s }), this.modelHex = this.hexString, this.modelRgba = e, this.$nextTick(() => {
        this.$refs.saturation.renderColor(), this.$refs.saturation.renderSlide(), this.$refs.hue.renderSlide();
      });
    },
    setText() {
      this.modelHex = this.hexString, this.modelRgba = this.rgbaStringShort;
    },
    openSucker(e) {
      this.$emit("openSucker", e);
    },
    selectSucker(e) {
      const { r: t, g: r, b: n, a: i, h: o, s: a, v: s } = xf(e);
      Object.assign(this, { r: t, g: r, b: n, a: i, h: o, s: a, v: s }), this.setText(), this.$nextTick(() => {
        this.$refs.saturation.renderColor(), this.$refs.saturation.renderSlide(), this.$refs.hue.renderSlide();
      });
    },
    selectColor(e) {
      const { r: t, g: r, b: n, a: i, h: o, s: a, v: s } = xf(e);
      Object.assign(this, { r: t, g: r, b: n, a: i, h: o, s: a, v: s }), this.setText(), this.$nextTick(() => {
        this.$refs.saturation.renderColor(), this.$refs.saturation.renderSlide(), this.$refs.hue.renderSlide();
      });
    }
  }
});
const H3e = { class: "color-set" };
function W3e(e, t, r, n, i, o) {
  const a = ff("Saturation"), s = ff("Hue"), u = ff("Alpha"), d = ff("Preview"), f = ff("Sucker"), h = ff("Box"), g = ff("Colors");
  return ie(), Pe(
    "div",
    {
      class: ["hu-color-picker", { light: e.isLightTheme }],
      style: { width: e.totalWidth + "px" }
    },
    [
      Re("div", H3e, [
        Re(a, {
          ref: "saturation",
          color: e.rgbString,
          hsv: e.hsv,
          size: e.hueHeight,
          onSelectSaturation: e.selectSaturation
        }, null, 8, ["color", "hsv", "size", "onSelectSaturation"]),
        Re(s, {
          ref: "hue",
          hsv: e.hsv,
          width: e.hueWidth,
          height: e.hueHeight,
          onSelectHue: e.selectHue
        }, null, 8, ["hsv", "width", "height", "onSelectHue"]),
        Re(u, {
          ref: "alpha",
          color: e.rgbString,
          rgba: e.rgba,
          width: e.hueWidth,
          height: e.hueHeight,
          onSelectAlpha: e.selectAlpha
        }, null, 8, ["color", "rgba", "width", "height", "onSelectAlpha"])
      ]),
      Re(
        "div",
        {
          style: { height: e.previewHeight + "px" },
          class: "color-show"
        },
        [
          Re(d, {
            color: e.rgbaString,
            width: e.previewWidth,
            height: e.previewHeight
          }, null, 8, ["color", "width", "height"]),
          e.suckerHide ? yt("v-if", !0) : (ie(), Pe(f, {
            key: 0,
            "sucker-canvas": e.suckerCanvas,
            "sucker-area": e.suckerArea,
            onOpenSucker: e.openSucker,
            onSelectSucker: e.selectSucker
          }, null, 8, ["sucker-canvas", "sucker-area", "onOpenSucker", "onSelectSucker"]))
        ],
        4
        /* STYLE */
      ),
      Re(h, {
        name: "HEX",
        color: e.modelHex,
        onInputColor: e.inputHex,
        onInputFocus: e.handleFocus,
        onInputBlur: e.handleBlur
      }, null, 8, ["color", "onInputColor", "onInputFocus", "onInputBlur"]),
      Re(h, {
        name: "RGBA",
        color: e.modelRgba,
        onInputColor: e.inputRgba,
        onInputFocus: e.handleFocus,
        onInputBlur: e.handleBlur
      }, null, 8, ["color", "onInputColor", "onInputFocus", "onInputBlur"]),
      Re(g, {
        color: e.rgbaString,
        "colors-default": e.colorsDefault,
        "colors-history-key": e.colorsHistoryKey,
        onSelectColor: e.selectColor
      }, null, 8, ["color", "colors-default", "colors-history-key", "onSelectColor"]),
      yt(" custom options "),
      nt(e.$slots, "default")
    ],
    6
    /* CLASS, STYLE */
  );
}
cp.render = W3e;
cp.__file = "src/color/ColorPicker.vue";
cp.install = (e) => {
  e.component(cp.name, cp);
};
const V3e = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48IS0tIFVwbG9hZGVkIHRvOiBTVkcgUmVwbywgd3d3LnN2Z3JlcG8uY29tLCBHZW5lcmF0b3I6IFNWRyBSZXBvIE1peGVyIFRvb2xzIC0tPg0KPHN2ZyB3aWR0aD0iODAwcHgiIGhlaWdodD0iODAwcHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xNy41IDE5TDEyLjUgNEgxMS41TDYuNSAxOU03LjgzMzMzIDE1SDE2LjE2NjciIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjwvc3ZnPg==", Y3e = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PgoNPCEtLSBVcGxvYWRlZCB0bzogU1ZHIFJlcG8sIHd3dy5zdmdyZXBvLmNvbSwgR2VuZXJhdG9yOiBTVkcgUmVwbyBNaXhlciBUb29scyAtLT4KPHN2ZyBmaWxsPSIjMDAwMDAwIiB3aWR0aD0iODAwcHgiIGhlaWdodD0iODAwcHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgoNPGcgaWQ9IkhpZ2hsaWdodGVyX3BlbiI+Cg08cGF0aCBkPSJNNDUxLjQ2OTIsMTI1LjQwNDEsMzgwLjU2NTYsNTQuNTAxNmExMy4xMDkzLDEzLjEwOTMsMCwwLDAtMTcuNzQ1Ny0uNzMyN0wxNjQuOTk4NSwyMjEuMzcyMiwyODQuNjAxOCwzNDAuOTc0NGwxNjcuNi0xOTcuODIyNUExMy4xMSwxMy4xMSwwLDAsMCw0NTEuNDY5MiwxMjUuNDA0MVoiLz4KDTxyZWN0IGhlaWdodD0iMTcyLjc2MDgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNjYuMDQxNiAyMjcuNjE0OCkgcm90YXRlKC00NSkiIHdpZHRoPSI0MS4wMTQzIiB4PSIxNzEuMjI3NCIgeT0iMjI3Ljg1NjkiLz4KDTxwYXRoIGQ9Ik05NC41NTIxLDM2My43MzA2LDE0Mi4yNDEzLDQxMS40MmMxOC41MjMyLTExLjAwOCw0MC42NS0xNS41OCw2My4xNjE5LTE3LjM5MTFsLTkzLjQ2LTkzLjQ2QzExMC4xMzE2LDMyMy4wOCwxMDUuNTYsMzQ1LjIwNzMsOTQuNTUyMSwzNjMuNzMwNloiLz4KDTxwYXRoIGQ9Ik01OC42MTQzLDQwMy42Mjc5YTYuNTc0Myw2LjU3NDMsMCwwLDAtMS4yNzMyLDcuNTAxM2wyMi4zNzQ4LDQ2LjQ4NjZhNi41NzQ2LDYuNTc0NiwwLDAsMCwxMC41NzIzLDEuNzk2NWwzMS40MTExLTMxLjQxMTFMNzcuOTcwNiwzODQuMjcyNloiLz4KDTwvZz4KDTwvc3ZnPg==", Q3e = { class: "ghl-color-picker__container" }, q3e = {
  key: 1,
  class: "ghl-color-picker__trigger"
}, G3e = ["src"], Z3e = {
  name: "RTEControlColorPicker",
  inheritAttrs: !1,
  components: { ToolbarButton: Br }
}, m1 = /* @__PURE__ */ oe({
  ...Z3e,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    swatches: {
      type: Array,
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    colorFor: {
      type: String,
      default: "text"
    },
    tooltipLabel: String,
    tooltipPosition: {
      type: String,
      default: "top"
    },
    pickerPosition: {
      type: String,
      default: "bottom"
    },
    language: {
      type: String,
      default: Cn.English_US
    },
    type: {
      type: String,
      default: "rgba"
    }
  },
  setup(e) {
    const t = e, r = lt("locale") ?? Dn[t.language], n = G(!0), i = G(), o = G(), a = G(), s = G(!1), u = pn(), d = (w) => {
      var C, S, T, A, D, E;
      const x = ["hex", "rgba"].includes(t.type) ? t.type : "rgba", y = t.type === "hex" ? w[x] : MK(w[x]);
      switch (t.colorFor) {
        case "highlight":
          return s.value ? (C = t == null ? void 0 : t.editor) == null ? void 0 : C.chain().setHighlight({ color: y }).run() : (S = t == null ? void 0 : t.editor) == null ? void 0 : S.chain().focus().setHighlight({ color: y }).run();
        case "text":
        default: {
          const { from: N, to: I } = t.editor.state.selection, $ = t.editor.state.doc.textBetween(N, I), _ = t.editor.state.selection.$from.node(
            t.editor.state.selection.$from.depth
          ).textContent;
          return t.editor.isActive(g1.name) && (_ === $ || $.length > _.length) ? s.value ? (T = t == null ? void 0 : t.editor) == null ? void 0 : T.chain().setColor(y).updateAttributes(g1.name, {
            listColor: y
          }).run() : (A = t == null ? void 0 : t.editor) == null ? void 0 : A.chain().focus().setColor(y).updateAttributes(g1.name, { listColor: y }).run() : s.value ? (D = t == null ? void 0 : t.editor) == null ? void 0 : D.chain().setColor(y).run() : (E = t == null ? void 0 : t.editor) == null ? void 0 : E.chain().focus().setColor(y).run();
        }
      }
    }, f = ({
      editor: w
    }) => {
      const x = w.getAttributes(
        "textStyle"
      ), y = w.getAttributes(
        "highlight"
      );
      i.value = void 0, o.value = void 0, x && (i.value = x == null ? void 0 : x.color), y && (o.value = y == null ? void 0 : y.color), t.colorFor === "highlight" ? a.value = y == null ? void 0 : y.color : a.value = x == null ? void 0 : x.color;
    }, h = () => {
      t.editor && (n.value = !ma(
        t.editor,
        t.colorFor === "text" ? "color" : "highlight"
      ));
    };
    br(() => {
      var w;
      h(), (w = t == null ? void 0 : t.editor) == null || w.on("transaction", f);
    }), Nc(() => {
      var w;
      (w = t == null ? void 0 : t.editor) == null || w.off("transaction", f);
    }), fi(() => {
      var w;
      h(), (w = t == null ? void 0 : t.editor) == null || w.on("transaction", f);
    }), Gr(() => {
      var w;
      (w = t == null ? void 0 : t.editor) == null || w.off("transaction", f);
    });
    const g = () => {
      s.value = !0;
    }, m = () => {
      s.value = !1;
    };
    Gt(
      () => s.value,
      hn.debounce(() => {
        var w, x;
        !s.value && !((w = t == null ? void 0 : t.editor) != null && w.isFocused) && ((x = t.editor) == null || x.chain().focus().run());
      }, 200)
    );
    const v = j(() => t.tooltipLabel ? t.tooltipLabel : t.colorFor === "highlight" ? r.color.textHighlight : r.color.textColor);
    return (w, x) => (ie(), Ve("div", Q3e, [
      Re(B(d1), {
        raw: "",
        trigger: "click",
        placement: e.pickerPosition
      }, {
        trigger: we(() => [
          Ye("div", null, [
            Re(Br, {
              id: B(Er).toolbarButtonColorPicker,
              "tooltip-label": B(v),
              tooltipPosition: e.tooltipPosition,
              disabled: e.disabled ?? n.value
            }, {
              default: we(() => [
                B(u).trigger ? nt(w.$slots, "trigger", {
                  key: 0,
                  color: a.value,
                  disabled: n.value
                }) : (ie(), Ve("div", q3e, [
                  Ye("img", {
                    src: t.colorFor === "highlight" ? B(Y3e) : B(V3e),
                    class: "toolbar-button__icon"
                  }, null, 8, G3e),
                  Ye("span", {
                    style: Jf({ "border-color": a.value || "#000" })
                  }, null, 4)
                ]))
              ]),
              _: 3
            }, 8, ["id", "tooltip-label", "tooltipPosition", "disabled"])
          ])
        ]),
        default: we(() => [
          Re(B(cp), {
            theme: "light",
            color: a.value,
            colorsDefault: e.swatches,
            "sucker-hide": !0,
            onChangeColor: d,
            onInputFocus: g,
            onInputBlur: m
          }, null, 8, ["color", "colorsDefault"])
        ]),
        _: 3
      }, 8, ["placement"])
    ]));
  }
});
m1.install = (e) => {
  e.component(m1.name, m1);
};
Br.install = (e) => {
  e.component(Br.name, Br);
};
const K3e = {
  name: "RTEControlCustomSelect",
  inheritAttrs: !1,
  components: {}
}, X3e = /* @__PURE__ */ oe({
  ...K3e,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    customMenus: {
      type: Array,
      default: () => []
    },
    trigger: {
      type: String,
      default: "click"
    },
    to: {
      type: String || Boolean,
      default: "body"
    }
  },
  setup(e) {
    const t = e, r = pn(), n = (o) => {
      var a;
      o && ((a = t == null ? void 0 : t.editor) == null || a.chain().focus().insertContent(o).run());
    }, i = [
      {
        label: "No options available",
        value: "",
        disabled: !0
      }
    ];
    return (o, a) => (ie(!0), Ve(Lr, null, Fl(e.customMenus, (s) => (ie(), Pe(B(n0), {
      key: s.menuId,
      id: s.menuId,
      options: s.items.length ? s.items : i,
      onOnSelect: n,
      to: e.to,
      size: "small"
    }, {
      trigger: we(() => [
        B(r).trigger ? nt(o.$slots, "trigger", {
          key: 0,
          title: s.menuTitle,
          icon: s.icon
        }, void 0, !0) : (ie(), Pe(B(on), {
          key: 1,
          id: s.menuId,
          size: "small",
          class: "custom-menu__button mx-1"
        }, {
          default: we(() => [
            Ye("span", null, ar(s.menuTitle), 1)
          ]),
          _: 2
        }, 1032, ["id"]))
      ]),
      _: 2
    }, 1032, ["id", "options", "to"]))), 128));
  }
});
const v1 = /* @__PURE__ */ Xl(X3e, [["__scopeId", "data-v-5cb1e482"]]);
v1.install = (e) => {
  e.component(v1.name, v1);
};
function PQ(e) {
  if (!e)
    throw new Error("Editor is not available!");
  const t = G(void 0), r = (a, s) => {
    if (!s.src)
      return !1;
    e == null || e.chain().focus().setImage({
      ...s,
      title: s.alt
    }).run(), a === "CREATE" && (e == null || e.chain().focus().createParagraphNear().run());
  }, n = (a, s) => {
    i(a === "WRAP" ? { "data-wrap": s, "data-alignment": void 0 } : { "data-alignment": s, "data-wrap": void 0 });
  }, i = (a) => {
    if (!t.value)
      return !1;
    e == null || e.chain().focus().setImage({
      ...t.value,
      ...a
    }).run();
  }, o = () => {
    e == null || e.commands.deleteSelection();
  };
  return e == null || e.on("transaction", ({ editor: a }) => {
    const s = a.getAttributes("image"), u = a.getAttributes(
      "paragraph"
    );
    t.value = void 0, !hn.isEmpty(s) && hn.isEmpty(u) && (t.value = {
      ...s
    });
  }), {
    imageValues: t,
    onImageAdd: r,
    handleImagePosition: n,
    onRemove: o
  };
}
var fa = "top", dl = "bottom", fl = "right", ha = "left", cC = "auto", zb = [fa, dl, fl, ha], Ip = "start", H0 = "end", J3e = "clippingParents", RQ = "viewport", Nv = "popper", ePe = "reference", jj = /* @__PURE__ */ zb.reduce(function(e, t) {
  return e.concat([t + "-" + Ip, t + "-" + H0]);
}, []), jQ = /* @__PURE__ */ [].concat(zb, [cC]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Ip, t + "-" + H0]);
}, []), tPe = "beforeRead", rPe = "read", nPe = "afterRead", iPe = "beforeMain", oPe = "main", aPe = "afterMain", lPe = "beforeWrite", sPe = "write", uPe = "afterWrite", Y$ = [tPe, rPe, nPe, iPe, oPe, aPe, lPe, sPe, uPe];
function Ds(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function pl(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function ah(e) {
  var t = pl(e).Element;
  return e instanceof t || e instanceof Element;
}
function Pa(e) {
  var t = pl(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function H_(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = pl(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function cPe(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var n = t.styles[r] || {}, i = t.attributes[r] || {}, o = t.elements[r];
    !Pa(o) || !Ds(o) || (Object.assign(o.style, n), Object.keys(i).forEach(function(a) {
      var s = i[a];
      s === !1 ? o.removeAttribute(a) : o.setAttribute(a, s === !0 ? "" : s);
    }));
  });
}
function dPe(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var i = t.elements[n], o = t.attributes[n] || {}, a = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : r[n]), s = a.reduce(function(u, d) {
        return u[d] = "", u;
      }, {});
      !Pa(i) || !Ds(i) || (Object.assign(i.style, s), Object.keys(o).forEach(function(u) {
        i.removeAttribute(u);
      }));
    });
  };
}
const FQ = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: cPe,
  effect: dPe,
  requires: ["computeStyles"]
};
function jl(e) {
  return e.split("-")[0];
}
var qf = Math.max, _x = Math.min, Np = Math.round;
function Q$() {
  var e = navigator.userAgentData;
  return e != null && e.brands ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function BQ() {
  return !/^((?!chrome|android).)*safari/i.test(Q$());
}
function zp(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var n = e.getBoundingClientRect(), i = 1, o = 1;
  t && Pa(e) && (i = e.offsetWidth > 0 && Np(n.width) / e.offsetWidth || 1, o = e.offsetHeight > 0 && Np(n.height) / e.offsetHeight || 1);
  var a = ah(e) ? pl(e) : window, s = a.visualViewport, u = !BQ() && r, d = (n.left + (u && s ? s.offsetLeft : 0)) / i, f = (n.top + (u && s ? s.offsetTop : 0)) / o, h = n.width / i, g = n.height / o;
  return {
    width: h,
    height: g,
    top: f,
    right: d + h,
    bottom: f + g,
    left: d,
    x: d,
    y: f
  };
}
function W_(e) {
  var t = zp(e), r = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: n
  };
}
function UQ(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && H_(r)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function Vl(e) {
  return pl(e).getComputedStyle(e);
}
function fPe(e) {
  return ["table", "td", "th"].indexOf(Ds(e)) >= 0;
}
function Wc(e) {
  return ((ah(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function dC(e) {
  return Ds(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (H_(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Wc(e)
  );
}
function Fj(e) {
  return !Pa(e) || // https://github.com/popperjs/popper-core/issues/837
  Vl(e).position === "fixed" ? null : e.offsetParent;
}
function hPe(e) {
  var t = /firefox/i.test(Q$()), r = /Trident/i.test(Q$());
  if (r && Pa(e)) {
    var n = Vl(e);
    if (n.position === "fixed")
      return null;
  }
  var i = dC(e);
  for (H_(i) && (i = i.host); Pa(i) && ["html", "body"].indexOf(Ds(i)) < 0; ) {
    var o = Vl(i);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || t && o.willChange === "filter" || t && o.filter && o.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function $b(e) {
  for (var t = pl(e), r = Fj(e); r && fPe(r) && Vl(r).position === "static"; )
    r = Fj(r);
  return r && (Ds(r) === "html" || Ds(r) === "body" && Vl(r).position === "static") ? t : r || hPe(e) || t;
}
function V_(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function s0(e, t, r) {
  return qf(e, _x(t, r));
}
function pPe(e, t, r) {
  var n = s0(e, t, r);
  return n > r ? r : n;
}
function HQ() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function WQ(e) {
  return Object.assign({}, HQ(), e);
}
function VQ(e, t) {
  return t.reduce(function(r, n) {
    return r[n] = e, r;
  }, {});
}
var gPe = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, WQ(typeof t != "number" ? t : VQ(t, zb));
};
function mPe(e) {
  var t, r = e.state, n = e.name, i = e.options, o = r.elements.arrow, a = r.modifiersData.popperOffsets, s = jl(r.placement), u = V_(s), d = [ha, fl].indexOf(s) >= 0, f = d ? "height" : "width";
  if (!(!o || !a)) {
    var h = gPe(i.padding, r), g = W_(o), m = u === "y" ? fa : ha, v = u === "y" ? dl : fl, w = r.rects.reference[f] + r.rects.reference[u] - a[u] - r.rects.popper[f], x = a[u] - r.rects.reference[u], y = $b(o), C = y ? u === "y" ? y.clientHeight || 0 : y.clientWidth || 0 : 0, S = w / 2 - x / 2, T = h[m], A = C - g[f] - h[v], D = C / 2 - g[f] / 2 + S, E = s0(T, D, A), N = u;
    r.modifiersData[n] = (t = {}, t[N] = E, t.centerOffset = E - D, t);
  }
}
function vPe(e) {
  var t = e.state, r = e.options, n = r.element, i = n === void 0 ? "[data-popper-arrow]" : n;
  if (i != null && !(typeof i == "string" && (i = t.elements.popper.querySelector(i), !i))) {
    if (process.env.NODE_ENV !== "production" && (Pa(i) || console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', "To use an SVG arrow, wrap it in an HTMLElement that will be used as", "the arrow."].join(" "))), !UQ(t.elements.popper, i)) {
      process.env.NODE_ENV !== "production" && console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', "element."].join(" "));
      return;
    }
    t.elements.arrow = i;
  }
}
const bPe = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: mPe,
  effect: vPe,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function $p(e) {
  return e.split("-")[1];
}
var yPe = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function xPe(e) {
  var t = e.x, r = e.y, n = window, i = n.devicePixelRatio || 1;
  return {
    x: Np(t * i) / i || 0,
    y: Np(r * i) / i || 0
  };
}
function Bj(e) {
  var t, r = e.popper, n = e.popperRect, i = e.placement, o = e.variation, a = e.offsets, s = e.position, u = e.gpuAcceleration, d = e.adaptive, f = e.roundOffsets, h = e.isFixed, g = a.x, m = g === void 0 ? 0 : g, v = a.y, w = v === void 0 ? 0 : v, x = typeof f == "function" ? f({
    x: m,
    y: w
  }) : {
    x: m,
    y: w
  };
  m = x.x, w = x.y;
  var y = a.hasOwnProperty("x"), C = a.hasOwnProperty("y"), S = ha, T = fa, A = window;
  if (d) {
    var D = $b(r), E = "clientHeight", N = "clientWidth";
    if (D === pl(r) && (D = Wc(r), Vl(D).position !== "static" && s === "absolute" && (E = "scrollHeight", N = "scrollWidth")), D = D, i === fa || (i === ha || i === fl) && o === H0) {
      T = dl;
      var I = h && D === A && A.visualViewport ? A.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        D[E]
      );
      w -= I - n.height, w *= u ? 1 : -1;
    }
    if (i === ha || (i === fa || i === dl) && o === H0) {
      S = fl;
      var $ = h && D === A && A.visualViewport ? A.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        D[N]
      );
      m -= $ - n.width, m *= u ? 1 : -1;
    }
  }
  var _ = Object.assign({
    position: s
  }, d && yPe), R = f === !0 ? xPe({
    x: m,
    y: w
  }) : {
    x: m,
    y: w
  };
  if (m = R.x, w = R.y, u) {
    var U;
    return Object.assign({}, _, (U = {}, U[T] = C ? "0" : "", U[S] = y ? "0" : "", U.transform = (A.devicePixelRatio || 1) <= 1 ? "translate(" + m + "px, " + w + "px)" : "translate3d(" + m + "px, " + w + "px, 0)", U));
  }
  return Object.assign({}, _, (t = {}, t[T] = C ? w + "px" : "", t[S] = y ? m + "px" : "", t.transform = "", t));
}
function wPe(e) {
  var t = e.state, r = e.options, n = r.gpuAcceleration, i = n === void 0 ? !0 : n, o = r.adaptive, a = o === void 0 ? !0 : o, s = r.roundOffsets, u = s === void 0 ? !0 : s;
  if (process.env.NODE_ENV !== "production") {
    var d = Vl(t.elements.popper).transitionProperty || "";
    a && ["transform", "top", "right", "bottom", "left"].some(function(h) {
      return d.indexOf(h) >= 0;
    }) && console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', `

`, 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", `

`, "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
  }
  var f = {
    placement: jl(t.placement),
    variation: $p(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: i,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Bj(Object.assign({}, f, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: a,
    roundOffsets: u
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Bj(Object.assign({}, f, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: u
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const MPe = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: wPe,
  data: {}
};
var Iy = {
  passive: !0
};
function CPe(e) {
  var t = e.state, r = e.instance, n = e.options, i = n.scroll, o = i === void 0 ? !0 : i, a = n.resize, s = a === void 0 ? !0 : a, u = pl(t.elements.popper), d = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return o && d.forEach(function(f) {
    f.addEventListener("scroll", r.update, Iy);
  }), s && u.addEventListener("resize", r.update, Iy), function() {
    o && d.forEach(function(f) {
      f.removeEventListener("scroll", r.update, Iy);
    }), s && u.removeEventListener("resize", r.update, Iy);
  };
}
const SPe = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: CPe,
  data: {}
};
var TPe = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function b1(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return TPe[t];
  });
}
var kPe = {
  start: "end",
  end: "start"
};
function Uj(e) {
  return e.replace(/start|end/g, function(t) {
    return kPe[t];
  });
}
function Y_(e) {
  var t = pl(e), r = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function Q_(e) {
  return zp(Wc(e)).left + Y_(e).scrollLeft;
}
function DPe(e, t) {
  var r = pl(e), n = Wc(e), i = r.visualViewport, o = n.clientWidth, a = n.clientHeight, s = 0, u = 0;
  if (i) {
    o = i.width, a = i.height;
    var d = BQ();
    (d || !d && t === "fixed") && (s = i.offsetLeft, u = i.offsetTop);
  }
  return {
    width: o,
    height: a,
    x: s + Q_(e),
    y: u
  };
}
function APe(e) {
  var t, r = Wc(e), n = Y_(e), i = (t = e.ownerDocument) == null ? void 0 : t.body, o = qf(r.scrollWidth, r.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), a = qf(r.scrollHeight, r.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), s = -n.scrollLeft + Q_(e), u = -n.scrollTop;
  return Vl(i || r).direction === "rtl" && (s += qf(r.clientWidth, i ? i.clientWidth : 0) - o), {
    width: o,
    height: a,
    x: s,
    y: u
  };
}
function q_(e) {
  var t = Vl(e), r = t.overflow, n = t.overflowX, i = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + i + n);
}
function YQ(e) {
  return ["html", "body", "#document"].indexOf(Ds(e)) >= 0 ? e.ownerDocument.body : Pa(e) && q_(e) ? e : YQ(dC(e));
}
function u0(e, t) {
  var r;
  t === void 0 && (t = []);
  var n = YQ(e), i = n === ((r = e.ownerDocument) == null ? void 0 : r.body), o = pl(n), a = i ? [o].concat(o.visualViewport || [], q_(n) ? n : []) : n, s = t.concat(a);
  return i ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(u0(dC(a)))
  );
}
function q$(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function EPe(e, t) {
  var r = zp(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function Hj(e, t, r) {
  return t === RQ ? q$(DPe(e, r)) : ah(t) ? EPe(t, r) : q$(APe(Wc(e)));
}
function IPe(e) {
  var t = u0(dC(e)), r = ["absolute", "fixed"].indexOf(Vl(e).position) >= 0, n = r && Pa(e) ? $b(e) : e;
  return ah(n) ? t.filter(function(i) {
    return ah(i) && UQ(i, n) && Ds(i) !== "body";
  }) : [];
}
function NPe(e, t, r, n) {
  var i = t === "clippingParents" ? IPe(e) : [].concat(t), o = [].concat(i, [r]), a = o[0], s = o.reduce(function(u, d) {
    var f = Hj(e, d, n);
    return u.top = qf(f.top, u.top), u.right = _x(f.right, u.right), u.bottom = _x(f.bottom, u.bottom), u.left = qf(f.left, u.left), u;
  }, Hj(e, a, n));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function QQ(e) {
  var t = e.reference, r = e.element, n = e.placement, i = n ? jl(n) : null, o = n ? $p(n) : null, a = t.x + t.width / 2 - r.width / 2, s = t.y + t.height / 2 - r.height / 2, u;
  switch (i) {
    case fa:
      u = {
        x: a,
        y: t.y - r.height
      };
      break;
    case dl:
      u = {
        x: a,
        y: t.y + t.height
      };
      break;
    case fl:
      u = {
        x: t.x + t.width,
        y: s
      };
      break;
    case ha:
      u = {
        x: t.x - r.width,
        y: s
      };
      break;
    default:
      u = {
        x: t.x,
        y: t.y
      };
  }
  var d = i ? V_(i) : null;
  if (d != null) {
    var f = d === "y" ? "height" : "width";
    switch (o) {
      case Ip:
        u[d] = u[d] - (t[f] / 2 - r[f] / 2);
        break;
      case H0:
        u[d] = u[d] + (t[f] / 2 - r[f] / 2);
        break;
    }
  }
  return u;
}
function W0(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, i = n === void 0 ? e.placement : n, o = r.strategy, a = o === void 0 ? e.strategy : o, s = r.boundary, u = s === void 0 ? J3e : s, d = r.rootBoundary, f = d === void 0 ? RQ : d, h = r.elementContext, g = h === void 0 ? Nv : h, m = r.altBoundary, v = m === void 0 ? !1 : m, w = r.padding, x = w === void 0 ? 0 : w, y = WQ(typeof x != "number" ? x : VQ(x, zb)), C = g === Nv ? ePe : Nv, S = e.rects.popper, T = e.elements[v ? C : g], A = NPe(ah(T) ? T : T.contextElement || Wc(e.elements.popper), u, f, a), D = zp(e.elements.reference), E = QQ({
    reference: D,
    element: S,
    strategy: "absolute",
    placement: i
  }), N = q$(Object.assign({}, S, E)), I = g === Nv ? N : D, $ = {
    top: A.top - I.top + y.top,
    bottom: I.bottom - A.bottom + y.bottom,
    left: A.left - I.left + y.left,
    right: I.right - A.right + y.right
  }, _ = e.modifiersData.offset;
  if (g === Nv && _) {
    var R = _[i];
    Object.keys($).forEach(function(U) {
      var Q = [fl, dl].indexOf(U) >= 0 ? 1 : -1, Z = [fa, dl].indexOf(U) >= 0 ? "y" : "x";
      $[U] += R[Z] * Q;
    });
  }
  return $;
}
function zPe(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, i = r.boundary, o = r.rootBoundary, a = r.padding, s = r.flipVariations, u = r.allowedAutoPlacements, d = u === void 0 ? jQ : u, f = $p(n), h = f ? s ? jj : jj.filter(function(v) {
    return $p(v) === f;
  }) : zb, g = h.filter(function(v) {
    return d.indexOf(v) >= 0;
  });
  g.length === 0 && (g = h, process.env.NODE_ENV !== "production" && console.error(["Popper: The `allowedAutoPlacements` option did not allow any", "placements. Ensure the `placement` option matches the variation", "of the allowed placements.", 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(" ")));
  var m = g.reduce(function(v, w) {
    return v[w] = W0(e, {
      placement: w,
      boundary: i,
      rootBoundary: o,
      padding: a
    })[jl(w)], v;
  }, {});
  return Object.keys(m).sort(function(v, w) {
    return m[v] - m[w];
  });
}
function $Pe(e) {
  if (jl(e) === cC)
    return [];
  var t = b1(e);
  return [Uj(e), t, Uj(t)];
}
function OPe(e) {
  var t = e.state, r = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var i = r.mainAxis, o = i === void 0 ? !0 : i, a = r.altAxis, s = a === void 0 ? !0 : a, u = r.fallbackPlacements, d = r.padding, f = r.boundary, h = r.rootBoundary, g = r.altBoundary, m = r.flipVariations, v = m === void 0 ? !0 : m, w = r.allowedAutoPlacements, x = t.options.placement, y = jl(x), C = y === x, S = u || (C || !v ? [b1(x)] : $Pe(x)), T = [x].concat(S).reduce(function(Qe, Ae) {
      return Qe.concat(jl(Ae) === cC ? zPe(t, {
        placement: Ae,
        boundary: f,
        rootBoundary: h,
        padding: d,
        flipVariations: v,
        allowedAutoPlacements: w
      }) : Ae);
    }, []), A = t.rects.reference, D = t.rects.popper, E = /* @__PURE__ */ new Map(), N = !0, I = T[0], $ = 0; $ < T.length; $++) {
      var _ = T[$], R = jl(_), U = $p(_) === Ip, Q = [fa, dl].indexOf(R) >= 0, Z = Q ? "width" : "height", X = W0(t, {
        placement: _,
        boundary: f,
        rootBoundary: h,
        altBoundary: g,
        padding: d
      }), re = Q ? U ? fl : ha : U ? dl : fa;
      A[Z] > D[Z] && (re = b1(re));
      var ue = b1(re), he = [];
      if (o && he.push(X[R] <= 0), s && he.push(X[re] <= 0, X[ue] <= 0), he.every(function(Qe) {
        return Qe;
      })) {
        I = _, N = !1;
        break;
      }
      E.set(_, he);
    }
    if (N)
      for (var te = v ? 3 : 1, de = function(Ae) {
        var Ne = T.find(function($e) {
          var et = E.get($e);
          if (et)
            return et.slice(0, Ae).every(function(Ge) {
              return Ge;
            });
        });
        if (Ne)
          return I = Ne, "break";
      }, De = te; De > 0; De--) {
        var Oe = de(De);
        if (Oe === "break")
          break;
      }
    t.placement !== I && (t.modifiersData[n]._skip = !0, t.placement = I, t.reset = !0);
  }
}
const _Pe = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: OPe,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Wj(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function Vj(e) {
  return [fa, fl, dl, ha].some(function(t) {
    return e[t] >= 0;
  });
}
function LPe(e) {
  var t = e.state, r = e.name, n = t.rects.reference, i = t.rects.popper, o = t.modifiersData.preventOverflow, a = W0(t, {
    elementContext: "reference"
  }), s = W0(t, {
    altBoundary: !0
  }), u = Wj(a, n), d = Wj(s, i, o), f = Vj(u), h = Vj(d);
  t.modifiersData[r] = {
    referenceClippingOffsets: u,
    popperEscapeOffsets: d,
    isReferenceHidden: f,
    hasPopperEscaped: h
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": f,
    "data-popper-escaped": h
  });
}
const PPe = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: LPe
};
function RPe(e, t, r) {
  var n = jl(e), i = [ha, fa].indexOf(n) >= 0 ? -1 : 1, o = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, a = o[0], s = o[1];
  return a = a || 0, s = (s || 0) * i, [ha, fl].indexOf(n) >= 0 ? {
    x: s,
    y: a
  } : {
    x: a,
    y: s
  };
}
function jPe(e) {
  var t = e.state, r = e.options, n = e.name, i = r.offset, o = i === void 0 ? [0, 0] : i, a = jQ.reduce(function(f, h) {
    return f[h] = RPe(h, t.rects, o), f;
  }, {}), s = a[t.placement], u = s.x, d = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += u, t.modifiersData.popperOffsets.y += d), t.modifiersData[n] = a;
}
const FPe = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: jPe
};
function BPe(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = QQ({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const UPe = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: BPe,
  data: {}
};
function HPe(e) {
  return e === "x" ? "y" : "x";
}
function WPe(e) {
  var t = e.state, r = e.options, n = e.name, i = r.mainAxis, o = i === void 0 ? !0 : i, a = r.altAxis, s = a === void 0 ? !1 : a, u = r.boundary, d = r.rootBoundary, f = r.altBoundary, h = r.padding, g = r.tether, m = g === void 0 ? !0 : g, v = r.tetherOffset, w = v === void 0 ? 0 : v, x = W0(t, {
    boundary: u,
    rootBoundary: d,
    padding: h,
    altBoundary: f
  }), y = jl(t.placement), C = $p(t.placement), S = !C, T = V_(y), A = HPe(T), D = t.modifiersData.popperOffsets, E = t.rects.reference, N = t.rects.popper, I = typeof w == "function" ? w(Object.assign({}, t.rects, {
    placement: t.placement
  })) : w, $ = typeof I == "number" ? {
    mainAxis: I,
    altAxis: I
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, I), _ = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, R = {
    x: 0,
    y: 0
  };
  if (D) {
    if (o) {
      var U, Q = T === "y" ? fa : ha, Z = T === "y" ? dl : fl, X = T === "y" ? "height" : "width", re = D[T], ue = re + x[Q], he = re - x[Z], te = m ? -N[X] / 2 : 0, de = C === Ip ? E[X] : N[X], De = C === Ip ? -N[X] : -E[X], Oe = t.elements.arrow, Qe = m && Oe ? W_(Oe) : {
        width: 0,
        height: 0
      }, Ae = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : HQ(), Ne = Ae[Q], $e = Ae[Z], et = s0(0, E[X], Qe[X]), Ge = S ? E[X] / 2 - te - et - Ne - $.mainAxis : de - et - Ne - $.mainAxis, Ee = S ? -E[X] / 2 + te + et + $e + $.mainAxis : De + et + $e + $.mainAxis, qe = t.elements.arrow && $b(t.elements.arrow), Ue = qe ? T === "y" ? qe.clientTop || 0 : qe.clientLeft || 0 : 0, ot = (U = _ == null ? void 0 : _[T]) != null ? U : 0, Ie = re + Ge - ot - Ue, rt = re + Ee - ot, W = s0(m ? _x(ue, Ie) : ue, re, m ? qf(he, rt) : he);
      D[T] = W, R[T] = W - re;
    }
    if (s) {
      var P, H = T === "x" ? fa : ha, se = T === "x" ? dl : fl, pe = D[A], ae = A === "y" ? "height" : "width", Me = pe + x[H], fe = pe - x[se], ke = [fa, ha].indexOf(y) !== -1, Le = (P = _ == null ? void 0 : _[A]) != null ? P : 0, dt = ke ? Me : pe - E[ae] - N[ae] - Le + $.altAxis, Mt = ke ? pe + E[ae] + N[ae] - Le - $.altAxis : fe, Ct = m && ke ? pPe(dt, pe, Mt) : s0(m ? dt : Me, pe, m ? Mt : fe);
      D[A] = Ct, R[A] = Ct - pe;
    }
    t.modifiersData[n] = R;
  }
}
const VPe = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: WPe,
  requiresIfExists: ["offset"]
};
function YPe(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function QPe(e) {
  return e === pl(e) || !Pa(e) ? Y_(e) : YPe(e);
}
function qPe(e) {
  var t = e.getBoundingClientRect(), r = Np(t.width) / e.offsetWidth || 1, n = Np(t.height) / e.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function GPe(e, t, r) {
  r === void 0 && (r = !1);
  var n = Pa(t), i = Pa(t) && qPe(t), o = Wc(t), a = zp(e, i, r), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((Ds(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  q_(o)) && (s = QPe(t)), Pa(t) ? (u = zp(t, !0), u.x += t.clientLeft, u.y += t.clientTop) : o && (u.x = Q_(o))), {
    x: a.left + s.scrollLeft - u.x,
    y: a.top + s.scrollTop - u.y,
    width: a.width,
    height: a.height
  };
}
function ZPe(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(o) {
    t.set(o.name, o);
  });
  function i(o) {
    r.add(o.name);
    var a = [].concat(o.requires || [], o.requiresIfExists || []);
    a.forEach(function(s) {
      if (!r.has(s)) {
        var u = t.get(s);
        u && i(u);
      }
    }), n.push(o);
  }
  return e.forEach(function(o) {
    r.has(o.name) || i(o);
  }), n;
}
function KPe(e) {
  var t = ZPe(e);
  return Y$.reduce(function(r, n) {
    return r.concat(t.filter(function(i) {
      return i.phase === n;
    }));
  }, []);
}
function XPe(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function Ju(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  return [].concat(r).reduce(function(i, o) {
    return i.replace(/%s/, o);
  }, e);
}
var wf = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s', JPe = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available', Yj = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
function eRe(e) {
  e.forEach(function(t) {
    [].concat(Object.keys(t), Yj).filter(function(r, n, i) {
      return i.indexOf(r) === n;
    }).forEach(function(r) {
      switch (r) {
        case "name":
          typeof t.name != "string" && console.error(Ju(wf, String(t.name), '"name"', '"string"', '"' + String(t.name) + '"'));
          break;
        case "enabled":
          typeof t.enabled != "boolean" && console.error(Ju(wf, t.name, '"enabled"', '"boolean"', '"' + String(t.enabled) + '"'));
          break;
        case "phase":
          Y$.indexOf(t.phase) < 0 && console.error(Ju(wf, t.name, '"phase"', "either " + Y$.join(", "), '"' + String(t.phase) + '"'));
          break;
        case "fn":
          typeof t.fn != "function" && console.error(Ju(wf, t.name, '"fn"', '"function"', '"' + String(t.fn) + '"'));
          break;
        case "effect":
          t.effect != null && typeof t.effect != "function" && console.error(Ju(wf, t.name, '"effect"', '"function"', '"' + String(t.fn) + '"'));
          break;
        case "requires":
          t.requires != null && !Array.isArray(t.requires) && console.error(Ju(wf, t.name, '"requires"', '"array"', '"' + String(t.requires) + '"'));
          break;
        case "requiresIfExists":
          Array.isArray(t.requiresIfExists) || console.error(Ju(wf, t.name, '"requiresIfExists"', '"array"', '"' + String(t.requiresIfExists) + '"'));
          break;
        case "options":
        case "data":
          break;
        default:
          console.error('PopperJS: an invalid property has been provided to the "' + t.name + '" modifier, valid properties are ' + Yj.map(function(n) {
            return '"' + n + '"';
          }).join(", ") + '; but "' + r + '" was provided.');
      }
      t.requires && t.requires.forEach(function(n) {
        e.find(function(i) {
          return i.name === n;
        }) == null && console.error(Ju(JPe, String(t.name), n, n));
      });
    });
  });
}
function tRe(e, t) {
  var r = /* @__PURE__ */ new Set();
  return e.filter(function(n) {
    var i = t(n);
    if (!r.has(i))
      return r.add(i), !0;
  });
}
function rRe(e) {
  var t = e.reduce(function(r, n) {
    var i = r[n.name];
    return r[n.name] = i ? Object.assign({}, i, n, {
      options: Object.assign({}, i.options, n.options),
      data: Object.assign({}, i.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var Qj = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.", nRe = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.", qj = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Gj() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function iRe(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, n = r === void 0 ? [] : r, i = t.defaultOptions, o = i === void 0 ? qj : i;
  return function(s, u, d) {
    d === void 0 && (d = o);
    var f = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, qj, o),
      modifiersData: {},
      elements: {
        reference: s,
        popper: u
      },
      attributes: {},
      styles: {}
    }, h = [], g = !1, m = {
      state: f,
      setOptions: function(y) {
        var C = typeof y == "function" ? y(f.options) : y;
        w(), f.options = Object.assign({}, o, f.options, C), f.scrollParents = {
          reference: ah(s) ? u0(s) : s.contextElement ? u0(s.contextElement) : [],
          popper: u0(u)
        };
        var S = KPe(rRe([].concat(n, f.options.modifiers)));
        if (f.orderedModifiers = S.filter(function(_) {
          return _.enabled;
        }), process.env.NODE_ENV !== "production") {
          var T = tRe([].concat(S, f.options.modifiers), function(_) {
            var R = _.name;
            return R;
          });
          if (eRe(T), jl(f.options.placement) === cC) {
            var A = f.orderedModifiers.find(function(_) {
              var R = _.name;
              return R === "flip";
            });
            A || console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
          }
          var D = Vl(u), E = D.marginTop, N = D.marginRight, I = D.marginBottom, $ = D.marginLeft;
          [E, N, I, $].some(function(_) {
            return parseFloat(_);
          }) && console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
        }
        return v(), m.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!g) {
          var y = f.elements, C = y.reference, S = y.popper;
          if (!Gj(C, S)) {
            process.env.NODE_ENV !== "production" && console.error(Qj);
            return;
          }
          f.rects = {
            reference: GPe(C, $b(S), f.options.strategy === "fixed"),
            popper: W_(S)
          }, f.reset = !1, f.placement = f.options.placement, f.orderedModifiers.forEach(function(_) {
            return f.modifiersData[_.name] = Object.assign({}, _.data);
          });
          for (var T = 0, A = 0; A < f.orderedModifiers.length; A++) {
            if (process.env.NODE_ENV !== "production" && (T += 1, T > 100)) {
              console.error(nRe);
              break;
            }
            if (f.reset === !0) {
              f.reset = !1, A = -1;
              continue;
            }
            var D = f.orderedModifiers[A], E = D.fn, N = D.options, I = N === void 0 ? {} : N, $ = D.name;
            typeof E == "function" && (f = E({
              state: f,
              options: I,
              name: $,
              instance: m
            }) || f);
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: XPe(function() {
        return new Promise(function(x) {
          m.forceUpdate(), x(f);
        });
      }),
      destroy: function() {
        w(), g = !0;
      }
    };
    if (!Gj(s, u))
      return process.env.NODE_ENV !== "production" && console.error(Qj), m;
    m.setOptions(d).then(function(x) {
      !g && d.onFirstUpdate && d.onFirstUpdate(x);
    });
    function v() {
      f.orderedModifiers.forEach(function(x) {
        var y = x.name, C = x.options, S = C === void 0 ? {} : C, T = x.effect;
        if (typeof T == "function") {
          var A = T({
            state: f,
            name: y,
            instance: m,
            options: S
          }), D = function() {
          };
          h.push(A || D);
        }
      });
    }
    function w() {
      h.forEach(function(x) {
        return x();
      }), h = [];
    }
    return m;
  };
}
var oRe = [SPe, UPe, MPe, FQ, FPe, _Pe, VPe, bPe, PPe], aRe = /* @__PURE__ */ iRe({
  defaultModifiers: oRe
}), lRe = "tippy-box", qQ = "tippy-content", sRe = "tippy-backdrop", GQ = "tippy-arrow", ZQ = "tippy-svg-arrow", kf = {
  passive: !0,
  capture: !0
}, KQ = function() {
  return document.body;
};
function uRe(e, t) {
  return {}.hasOwnProperty.call(e, t);
}
function xN(e, t, r) {
  if (Array.isArray(e)) {
    var n = e[t];
    return n ?? (Array.isArray(r) ? r[t] : r);
  }
  return e;
}
function G_(e, t) {
  var r = {}.toString.call(e);
  return r.indexOf("[object") === 0 && r.indexOf(t + "]") > -1;
}
function XQ(e, t) {
  return typeof e == "function" ? e.apply(void 0, t) : e;
}
function Zj(e, t) {
  if (t === 0)
    return e;
  var r;
  return function(n) {
    clearTimeout(r), r = setTimeout(function() {
      e(n);
    }, t);
  };
}
function cRe(e, t) {
  var r = Object.assign({}, e);
  return t.forEach(function(n) {
    delete r[n];
  }), r;
}
function dRe(e) {
  return e.split(/\s+/).filter(Boolean);
}
function Yh(e) {
  return [].concat(e);
}
function Kj(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function fRe(e) {
  return e.filter(function(t, r) {
    return e.indexOf(t) === r;
  });
}
function hRe(e) {
  return e.split("-")[0];
}
function Lx(e) {
  return [].slice.call(e);
}
function Xj(e) {
  return Object.keys(e).reduce(function(t, r) {
    return e[r] !== void 0 && (t[r] = e[r]), t;
  }, {});
}
function c0() {
  return document.createElement("div");
}
function V0(e) {
  return ["Element", "Fragment"].some(function(t) {
    return G_(e, t);
  });
}
function pRe(e) {
  return G_(e, "NodeList");
}
function gRe(e) {
  return G_(e, "MouseEvent");
}
function mRe(e) {
  return !!(e && e._tippy && e._tippy.reference === e);
}
function vRe(e) {
  return V0(e) ? [e] : pRe(e) ? Lx(e) : Array.isArray(e) ? e : Lx(document.querySelectorAll(e));
}
function wN(e, t) {
  e.forEach(function(r) {
    r && (r.style.transitionDuration = t + "ms");
  });
}
function Jj(e, t) {
  e.forEach(function(r) {
    r && r.setAttribute("data-state", t);
  });
}
function bRe(e) {
  var t, r = Yh(e), n = r[0];
  return n != null && (t = n.ownerDocument) != null && t.body ? n.ownerDocument : document;
}
function yRe(e, t) {
  var r = t.clientX, n = t.clientY;
  return e.every(function(i) {
    var o = i.popperRect, a = i.popperState, s = i.props, u = s.interactiveBorder, d = hRe(a.placement), f = a.modifiersData.offset;
    if (!f)
      return !0;
    var h = d === "bottom" ? f.top.y : 0, g = d === "top" ? f.bottom.y : 0, m = d === "right" ? f.left.x : 0, v = d === "left" ? f.right.x : 0, w = o.top - n + h > u, x = n - o.bottom - g > u, y = o.left - r + m > u, C = r - o.right - v > u;
    return w || x || y || C;
  });
}
function MN(e, t, r) {
  var n = t + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(i) {
    e[n](i, r);
  });
}
function eF(e, t) {
  for (var r = t; r; ) {
    var n;
    if (e.contains(r))
      return !0;
    r = r.getRootNode == null || (n = r.getRootNode()) == null ? void 0 : n.host;
  }
  return !1;
}
var ss = {
  isTouch: !1
}, tF = 0;
function xRe() {
  ss.isTouch || (ss.isTouch = !0, window.performance && document.addEventListener("mousemove", JQ));
}
function JQ() {
  var e = performance.now();
  e - tF < 20 && (ss.isTouch = !1, document.removeEventListener("mousemove", JQ)), tF = e;
}
function wRe() {
  var e = document.activeElement;
  if (mRe(e)) {
    var t = e._tippy;
    e.blur && !t.state.isVisible && e.blur();
  }
}
function MRe() {
  document.addEventListener("touchstart", xRe, kf), window.addEventListener("blur", wRe);
}
var CRe = typeof window < "u" && typeof document < "u", SRe = CRe ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function jh(e) {
  var t = e === "destroy" ? "n already-" : " ";
  return [e + "() was called on a" + t + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function rF(e) {
  var t = /[ \t]{2,}/g, r = /^[ \t]*/gm;
  return e.replace(t, " ").replace(r, "").trim();
}
function TRe(e) {
  return rF(`
  %ctippy.js

  %c` + rF(e) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function eq(e) {
  return [
    TRe(e),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var Y0;
process.env.NODE_ENV !== "production" && kRe();
function kRe() {
  Y0 = /* @__PURE__ */ new Set();
}
function Nu(e, t) {
  if (e && !Y0.has(t)) {
    var r;
    Y0.add(t), (r = console).warn.apply(r, eq(t));
  }
}
function G$(e, t) {
  if (e && !Y0.has(t)) {
    var r;
    Y0.add(t), (r = console).error.apply(r, eq(t));
  }
}
function DRe(e) {
  var t = !e, r = Object.prototype.toString.call(e) === "[object Object]" && !e.addEventListener;
  G$(t, ["tippy() was passed", "`" + String(e) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), G$(r, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var tq = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, ARe = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, Oa = Object.assign({
  appendTo: KQ,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, tq, ARe), ERe = Object.keys(Oa), IRe = function(t) {
  process.env.NODE_ENV !== "production" && nq(t, []);
  var r = Object.keys(t);
  r.forEach(function(n) {
    Oa[n] = t[n];
  });
};
function rq(e) {
  var t = e.plugins || [], r = t.reduce(function(n, i) {
    var o = i.name, a = i.defaultValue;
    if (o) {
      var s;
      n[o] = e[o] !== void 0 ? e[o] : (s = Oa[o]) != null ? s : a;
    }
    return n;
  }, {});
  return Object.assign({}, e, r);
}
function NRe(e, t) {
  var r = t ? Object.keys(rq(Object.assign({}, Oa, {
    plugins: t
  }))) : ERe, n = r.reduce(function(i, o) {
    var a = (e.getAttribute("data-tippy-" + o) || "").trim();
    if (!a)
      return i;
    if (o === "content")
      i[o] = a;
    else
      try {
        i[o] = JSON.parse(a);
      } catch {
        i[o] = a;
      }
    return i;
  }, {});
  return n;
}
function nF(e, t) {
  var r = Object.assign({}, t, {
    content: XQ(t.content, [e])
  }, t.ignoreAttributes ? {} : NRe(e, t.plugins));
  return r.aria = Object.assign({}, Oa.aria, r.aria), r.aria = {
    expanded: r.aria.expanded === "auto" ? t.interactive : r.aria.expanded,
    content: r.aria.content === "auto" ? t.interactive ? null : "describedby" : r.aria.content
  }, r;
}
function nq(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = []);
  var r = Object.keys(e);
  r.forEach(function(n) {
    var i = cRe(Oa, Object.keys(tq)), o = !uRe(i, n);
    o && (o = t.filter(function(a) {
      return a.name === n;
    }).length === 0), Nu(o, ["`" + n + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var zRe = function() {
  return "innerHTML";
};
function Z$(e, t) {
  e[zRe()] = t;
}
function iF(e) {
  var t = c0();
  return e === !0 ? t.className = GQ : (t.className = ZQ, V0(e) ? t.appendChild(e) : Z$(t, e)), t;
}
function oF(e, t) {
  V0(t.content) ? (Z$(e, ""), e.appendChild(t.content)) : typeof t.content != "function" && (t.allowHTML ? Z$(e, t.content) : e.textContent = t.content);
}
function K$(e) {
  var t = e.firstElementChild, r = Lx(t.children);
  return {
    box: t,
    content: r.find(function(n) {
      return n.classList.contains(qQ);
    }),
    arrow: r.find(function(n) {
      return n.classList.contains(GQ) || n.classList.contains(ZQ);
    }),
    backdrop: r.find(function(n) {
      return n.classList.contains(sRe);
    })
  };
}
function iq(e) {
  var t = c0(), r = c0();
  r.className = lRe, r.setAttribute("data-state", "hidden"), r.setAttribute("tabindex", "-1");
  var n = c0();
  n.className = qQ, n.setAttribute("data-state", "hidden"), oF(n, e.props), t.appendChild(r), r.appendChild(n), i(e.props, e.props);
  function i(o, a) {
    var s = K$(t), u = s.box, d = s.content, f = s.arrow;
    a.theme ? u.setAttribute("data-theme", a.theme) : u.removeAttribute("data-theme"), typeof a.animation == "string" ? u.setAttribute("data-animation", a.animation) : u.removeAttribute("data-animation"), a.inertia ? u.setAttribute("data-inertia", "") : u.removeAttribute("data-inertia"), u.style.maxWidth = typeof a.maxWidth == "number" ? a.maxWidth + "px" : a.maxWidth, a.role ? u.setAttribute("role", a.role) : u.removeAttribute("role"), (o.content !== a.content || o.allowHTML !== a.allowHTML) && oF(d, e.props), a.arrow ? f ? o.arrow !== a.arrow && (u.removeChild(f), u.appendChild(iF(a.arrow))) : u.appendChild(iF(a.arrow)) : f && u.removeChild(f);
  }
  return {
    popper: t,
    onUpdate: i
  };
}
iq.$$tippy = !0;
var $Re = 1, Ny = [], CN = [];
function ORe(e, t) {
  var r = nF(e, Object.assign({}, Oa, rq(Xj(t)))), n, i, o, a = !1, s = !1, u = !1, d = !1, f, h, g, m = [], v = Zj(Ie, r.interactiveDebounce), w, x = $Re++, y = null, C = fRe(r.plugins), S = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, T = {
    // properties
    id: x,
    reference: e,
    popper: c0(),
    popperInstance: y,
    props: r,
    state: S,
    plugins: C,
    // methods
    clearDelayTimeouts: dt,
    setProps: Mt,
    setContent: Ct,
    show: er,
    hide: Vt,
    hideWithInteractivity: jt,
    enable: ke,
    disable: Le,
    unmount: at,
    destroy: St
  };
  if (!r.render)
    return process.env.NODE_ENV !== "production" && G$(!0, "render() function has not been supplied."), T;
  var A = r.render(T), D = A.popper, E = A.onUpdate;
  D.setAttribute("data-tippy-root", ""), D.id = "tippy-" + T.id, T.popper = D, e._tippy = T, D._tippy = T;
  var N = C.map(function(ve) {
    return ve.fn(T);
  }), I = e.hasAttribute("aria-expanded");
  return qe(), te(), re(), ue("onCreate", [T]), r.showOnCreate && Me(), D.addEventListener("mouseenter", function() {
    T.props.interactive && T.state.isVisible && T.clearDelayTimeouts();
  }), D.addEventListener("mouseleave", function() {
    T.props.interactive && T.props.trigger.indexOf("mouseenter") >= 0 && Q().addEventListener("mousemove", v);
  }), T;
  function $() {
    var ve = T.props.touch;
    return Array.isArray(ve) ? ve : [ve, 0];
  }
  function _() {
    return $()[0] === "hold";
  }
  function R() {
    var ve;
    return !!((ve = T.props.render) != null && ve.$$tippy);
  }
  function U() {
    return w || e;
  }
  function Q() {
    var ve = U().parentNode;
    return ve ? bRe(ve) : document;
  }
  function Z() {
    return K$(D);
  }
  function X(ve) {
    return T.state.isMounted && !T.state.isVisible || ss.isTouch || f && f.type === "focus" ? 0 : xN(T.props.delay, ve ? 0 : 1, Oa.delay);
  }
  function re(ve) {
    ve === void 0 && (ve = !1), D.style.pointerEvents = T.props.interactive && !ve ? "" : "none", D.style.zIndex = "" + T.props.zIndex;
  }
  function ue(ve, We, ne) {
    if (ne === void 0 && (ne = !0), N.forEach(function(_e) {
      _e[ve] && _e[ve].apply(_e, We);
    }), ne) {
      var Se;
      (Se = T.props)[ve].apply(Se, We);
    }
  }
  function he() {
    var ve = T.props.aria;
    if (ve.content) {
      var We = "aria-" + ve.content, ne = D.id, Se = Yh(T.props.triggerTarget || e);
      Se.forEach(function(_e) {
        var ut = _e.getAttribute(We);
        if (T.state.isVisible)
          _e.setAttribute(We, ut ? ut + " " + ne : ne);
        else {
          var ht = ut && ut.replace(ne, "").trim();
          ht ? _e.setAttribute(We, ht) : _e.removeAttribute(We);
        }
      });
    }
  }
  function te() {
    if (!(I || !T.props.aria.expanded)) {
      var ve = Yh(T.props.triggerTarget || e);
      ve.forEach(function(We) {
        T.props.interactive ? We.setAttribute("aria-expanded", T.state.isVisible && We === U() ? "true" : "false") : We.removeAttribute("aria-expanded");
      });
    }
  }
  function de() {
    Q().removeEventListener("mousemove", v), Ny = Ny.filter(function(ve) {
      return ve !== v;
    });
  }
  function De(ve) {
    if (!(ss.isTouch && (u || ve.type === "mousedown"))) {
      var We = ve.composedPath && ve.composedPath()[0] || ve.target;
      if (!(T.props.interactive && eF(D, We))) {
        if (Yh(T.props.triggerTarget || e).some(function(ne) {
          return eF(ne, We);
        })) {
          if (ss.isTouch || T.state.isVisible && T.props.trigger.indexOf("click") >= 0)
            return;
        } else
          ue("onClickOutside", [T, ve]);
        T.props.hideOnClick === !0 && (T.clearDelayTimeouts(), T.hide(), s = !0, setTimeout(function() {
          s = !1;
        }), T.state.isMounted || Ne());
      }
    }
  }
  function Oe() {
    u = !0;
  }
  function Qe() {
    u = !1;
  }
  function Ae() {
    var ve = Q();
    ve.addEventListener("mousedown", De, !0), ve.addEventListener("touchend", De, kf), ve.addEventListener("touchstart", Qe, kf), ve.addEventListener("touchmove", Oe, kf);
  }
  function Ne() {
    var ve = Q();
    ve.removeEventListener("mousedown", De, !0), ve.removeEventListener("touchend", De, kf), ve.removeEventListener("touchstart", Qe, kf), ve.removeEventListener("touchmove", Oe, kf);
  }
  function $e(ve, We) {
    Ge(ve, function() {
      !T.state.isVisible && D.parentNode && D.parentNode.contains(D) && We();
    });
  }
  function et(ve, We) {
    Ge(ve, We);
  }
  function Ge(ve, We) {
    var ne = Z().box;
    function Se(_e) {
      _e.target === ne && (MN(ne, "remove", Se), We());
    }
    if (ve === 0)
      return We();
    MN(ne, "remove", h), MN(ne, "add", Se), h = Se;
  }
  function Ee(ve, We, ne) {
    ne === void 0 && (ne = !1);
    var Se = Yh(T.props.triggerTarget || e);
    Se.forEach(function(_e) {
      _e.addEventListener(ve, We, ne), m.push({
        node: _e,
        eventType: ve,
        handler: We,
        options: ne
      });
    });
  }
  function qe() {
    _() && (Ee("touchstart", ot, {
      passive: !0
    }), Ee("touchend", rt, {
      passive: !0
    })), dRe(T.props.trigger).forEach(function(ve) {
      if (ve !== "manual")
        switch (Ee(ve, ot), ve) {
          case "mouseenter":
            Ee("mouseleave", rt);
            break;
          case "focus":
            Ee(SRe ? "focusout" : "blur", W);
            break;
          case "focusin":
            Ee("focusout", W);
            break;
        }
    });
  }
  function Ue() {
    m.forEach(function(ve) {
      var We = ve.node, ne = ve.eventType, Se = ve.handler, _e = ve.options;
      We.removeEventListener(ne, Se, _e);
    }), m = [];
  }
  function ot(ve) {
    var We, ne = !1;
    if (!(!T.state.isEnabled || P(ve) || s)) {
      var Se = ((We = f) == null ? void 0 : We.type) === "focus";
      f = ve, w = ve.currentTarget, te(), !T.state.isVisible && gRe(ve) && Ny.forEach(function(_e) {
        return _e(ve);
      }), ve.type === "click" && (T.props.trigger.indexOf("mouseenter") < 0 || a) && T.props.hideOnClick !== !1 && T.state.isVisible ? ne = !0 : Me(ve), ve.type === "click" && (a = !ne), ne && !Se && fe(ve);
    }
  }
  function Ie(ve) {
    var We = ve.target, ne = U().contains(We) || D.contains(We);
    if (!(ve.type === "mousemove" && ne)) {
      var Se = ae().concat(D).map(function(_e) {
        var ut, ht = _e._tippy, ye = (ut = ht.popperInstance) == null ? void 0 : ut.state;
        return ye ? {
          popperRect: _e.getBoundingClientRect(),
          popperState: ye,
          props: r
        } : null;
      }).filter(Boolean);
      yRe(Se, ve) && (de(), fe(ve));
    }
  }
  function rt(ve) {
    var We = P(ve) || T.props.trigger.indexOf("click") >= 0 && a;
    if (!We) {
      if (T.props.interactive) {
        T.hideWithInteractivity(ve);
        return;
      }
      fe(ve);
    }
  }
  function W(ve) {
    T.props.trigger.indexOf("focusin") < 0 && ve.target !== U() || T.props.interactive && ve.relatedTarget && D.contains(ve.relatedTarget) || fe(ve);
  }
  function P(ve) {
    return ss.isTouch ? _() !== ve.type.indexOf("touch") >= 0 : !1;
  }
  function H() {
    se();
    var ve = T.props, We = ve.popperOptions, ne = ve.placement, Se = ve.offset, _e = ve.getReferenceClientRect, ut = ve.moveTransition, ht = R() ? K$(D).arrow : null, ye = _e ? {
      getBoundingClientRect: _e,
      contextElement: _e.contextElement || U()
    } : e, Ze = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(Te) {
        var Ke = Te.state;
        if (R()) {
          var xe = Z(), Xe = xe.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(At) {
            At === "placement" ? Xe.setAttribute("data-placement", Ke.placement) : Ke.attributes.popper["data-popper-" + At] ? Xe.setAttribute("data-" + At, "") : Xe.removeAttribute("data-" + At);
          }), Ke.attributes.popper = {};
        }
      }
    }, st = [{
      name: "offset",
      options: {
        offset: Se
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !ut
      }
    }, Ze];
    R() && ht && st.push({
      name: "arrow",
      options: {
        element: ht,
        padding: 3
      }
    }), st.push.apply(st, (We == null ? void 0 : We.modifiers) || []), T.popperInstance = aRe(ye, D, Object.assign({}, We, {
      placement: ne,
      onFirstUpdate: g,
      modifiers: st
    }));
  }
  function se() {
    T.popperInstance && (T.popperInstance.destroy(), T.popperInstance = null);
  }
  function pe() {
    var ve = T.props.appendTo, We, ne = U();
    T.props.interactive && ve === KQ || ve === "parent" ? We = ne.parentNode : We = XQ(ve, [ne]), We.contains(D) || We.appendChild(D), T.state.isMounted = !0, H(), process.env.NODE_ENV !== "production" && Nu(T.props.interactive && ve === Oa.appendTo && ne.nextElementSibling !== D, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function ae() {
    return Lx(D.querySelectorAll("[data-tippy-root]"));
  }
  function Me(ve) {
    T.clearDelayTimeouts(), ve && ue("onTrigger", [T, ve]), Ae();
    var We = X(!0), ne = $(), Se = ne[0], _e = ne[1];
    ss.isTouch && Se === "hold" && _e && (We = _e), We ? n = setTimeout(function() {
      T.show();
    }, We) : T.show();
  }
  function fe(ve) {
    if (T.clearDelayTimeouts(), ue("onUntrigger", [T, ve]), !T.state.isVisible) {
      Ne();
      return;
    }
    if (!(T.props.trigger.indexOf("mouseenter") >= 0 && T.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(ve.type) >= 0 && a)) {
      var We = X(!1);
      We ? i = setTimeout(function() {
        T.state.isVisible && T.hide();
      }, We) : o = requestAnimationFrame(function() {
        T.hide();
      });
    }
  }
  function ke() {
    T.state.isEnabled = !0;
  }
  function Le() {
    T.hide(), T.state.isEnabled = !1;
  }
  function dt() {
    clearTimeout(n), clearTimeout(i), cancelAnimationFrame(o);
  }
  function Mt(ve) {
    if (process.env.NODE_ENV !== "production" && Nu(T.state.isDestroyed, jh("setProps")), !T.state.isDestroyed) {
      ue("onBeforeUpdate", [T, ve]), Ue();
      var We = T.props, ne = nF(e, Object.assign({}, We, Xj(ve), {
        ignoreAttributes: !0
      }));
      T.props = ne, qe(), We.interactiveDebounce !== ne.interactiveDebounce && (de(), v = Zj(Ie, ne.interactiveDebounce)), We.triggerTarget && !ne.triggerTarget ? Yh(We.triggerTarget).forEach(function(Se) {
        Se.removeAttribute("aria-expanded");
      }) : ne.triggerTarget && e.removeAttribute("aria-expanded"), te(), re(), E && E(We, ne), T.popperInstance && (H(), ae().forEach(function(Se) {
        requestAnimationFrame(Se._tippy.popperInstance.forceUpdate);
      })), ue("onAfterUpdate", [T, ve]);
    }
  }
  function Ct(ve) {
    T.setProps({
      content: ve
    });
  }
  function er() {
    process.env.NODE_ENV !== "production" && Nu(T.state.isDestroyed, jh("show"));
    var ve = T.state.isVisible, We = T.state.isDestroyed, ne = !T.state.isEnabled, Se = ss.isTouch && !T.props.touch, _e = xN(T.props.duration, 0, Oa.duration);
    if (!(ve || We || ne || Se) && !U().hasAttribute("disabled") && (ue("onShow", [T], !1), T.props.onShow(T) !== !1)) {
      if (T.state.isVisible = !0, R() && (D.style.visibility = "visible"), re(), Ae(), T.state.isMounted || (D.style.transition = "none"), R()) {
        var ut = Z(), ht = ut.box, ye = ut.content;
        wN([ht, ye], 0);
      }
      g = function() {
        var st;
        if (!(!T.state.isVisible || d)) {
          if (d = !0, D.offsetHeight, D.style.transition = T.props.moveTransition, R() && T.props.animation) {
            var Nt = Z(), Te = Nt.box, Ke = Nt.content;
            wN([Te, Ke], _e), Jj([Te, Ke], "visible");
          }
          he(), te(), Kj(CN, T), (st = T.popperInstance) == null || st.forceUpdate(), ue("onMount", [T]), T.props.animation && R() && et(_e, function() {
            T.state.isShown = !0, ue("onShown", [T]);
          });
        }
      }, pe();
    }
  }
  function Vt() {
    process.env.NODE_ENV !== "production" && Nu(T.state.isDestroyed, jh("hide"));
    var ve = !T.state.isVisible, We = T.state.isDestroyed, ne = !T.state.isEnabled, Se = xN(T.props.duration, 1, Oa.duration);
    if (!(ve || We || ne) && (ue("onHide", [T], !1), T.props.onHide(T) !== !1)) {
      if (T.state.isVisible = !1, T.state.isShown = !1, d = !1, a = !1, R() && (D.style.visibility = "hidden"), de(), Ne(), re(!0), R()) {
        var _e = Z(), ut = _e.box, ht = _e.content;
        T.props.animation && (wN([ut, ht], Se), Jj([ut, ht], "hidden"));
      }
      he(), te(), T.props.animation ? R() && $e(Se, T.unmount) : T.unmount();
    }
  }
  function jt(ve) {
    process.env.NODE_ENV !== "production" && Nu(T.state.isDestroyed, jh("hideWithInteractivity")), Q().addEventListener("mousemove", v), Kj(Ny, v), v(ve);
  }
  function at() {
    process.env.NODE_ENV !== "production" && Nu(T.state.isDestroyed, jh("unmount")), T.state.isVisible && T.hide(), T.state.isMounted && (se(), ae().forEach(function(ve) {
      ve._tippy.unmount();
    }), D.parentNode && D.parentNode.removeChild(D), CN = CN.filter(function(ve) {
      return ve !== T;
    }), T.state.isMounted = !1, ue("onHidden", [T]));
  }
  function St() {
    process.env.NODE_ENV !== "production" && Nu(T.state.isDestroyed, jh("destroy")), !T.state.isDestroyed && (T.clearDelayTimeouts(), T.unmount(), Ue(), delete e._tippy, T.state.isDestroyed = !0, ue("onDestroy", [T]));
  }
}
function Gp(e, t) {
  t === void 0 && (t = {});
  var r = Oa.plugins.concat(t.plugins || []);
  process.env.NODE_ENV !== "production" && (DRe(e), nq(t, r)), MRe();
  var n = Object.assign({}, t, {
    plugins: r
  }), i = vRe(e);
  if (process.env.NODE_ENV !== "production") {
    var o = V0(n.content), a = i.length > 1;
    Nu(o && a, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var s = i.reduce(function(u, d) {
    var f = d && ORe(d, n);
    return f && u.push(f), u;
  }, []);
  return V0(e) ? s[0] : s;
}
Gp.defaultProps = Oa;
Gp.setDefaultProps = IRe;
Gp.currentInput = ss;
Object.assign({}, FQ, {
  effect: function(t) {
    var r = t.state, n = {
      popper: {
        position: r.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(r.elements.popper.style, n.popper), r.styles = n, r.elements.arrow && Object.assign(r.elements.arrow.style, n.arrow);
  }
});
Gp.setDefaultProps({
  render: iq
});
var zy = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function _Re(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var oq = _Re, LRe = typeof zy == "object" && zy && zy.Object === Object && zy, PRe = LRe, RRe = PRe, jRe = typeof self == "object" && self && self.Object === Object && self, FRe = RRe || jRe || Function("return this")(), aq = FRe, BRe = aq, URe = function() {
  return BRe.Date.now();
}, HRe = URe, WRe = /\s/;
function VRe(e) {
  for (var t = e.length; t-- && WRe.test(e.charAt(t)); )
    ;
  return t;
}
var YRe = VRe, QRe = YRe, qRe = /^\s+/;
function GRe(e) {
  return e && e.slice(0, QRe(e) + 1).replace(qRe, "");
}
var ZRe = GRe, KRe = aq, XRe = KRe.Symbol, lq = XRe, aF = lq, sq = Object.prototype, JRe = sq.hasOwnProperty, e5e = sq.toString, zv = aF ? aF.toStringTag : void 0;
function t5e(e) {
  var t = JRe.call(e, zv), r = e[zv];
  try {
    e[zv] = void 0;
    var n = !0;
  } catch {
  }
  var i = e5e.call(e);
  return n && (t ? e[zv] = r : delete e[zv]), i;
}
var r5e = t5e, n5e = Object.prototype, i5e = n5e.toString;
function o5e(e) {
  return i5e.call(e);
}
var a5e = o5e, lF = lq, l5e = r5e, s5e = a5e, u5e = "[object Null]", c5e = "[object Undefined]", sF = lF ? lF.toStringTag : void 0;
function d5e(e) {
  return e == null ? e === void 0 ? c5e : u5e : sF && sF in Object(e) ? l5e(e) : s5e(e);
}
var f5e = d5e;
function h5e(e) {
  return e != null && typeof e == "object";
}
var p5e = h5e, g5e = f5e, m5e = p5e, v5e = "[object Symbol]";
function b5e(e) {
  return typeof e == "symbol" || m5e(e) && g5e(e) == v5e;
}
var y5e = b5e, x5e = ZRe, uF = oq, w5e = y5e, cF = 0 / 0, M5e = /^[-+]0x[0-9a-f]+$/i, C5e = /^0b[01]+$/i, S5e = /^0o[0-7]+$/i, T5e = parseInt;
function k5e(e) {
  if (typeof e == "number")
    return e;
  if (w5e(e))
    return cF;
  if (uF(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = uF(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = x5e(e);
  var r = C5e.test(e);
  return r || S5e.test(e) ? T5e(e.slice(2), r ? 2 : 8) : M5e.test(e) ? cF : +e;
}
var D5e = k5e, A5e = oq, SN = HRe, dF = D5e, E5e = "Expected a function", I5e = Math.max, N5e = Math.min;
function z5e(e, t, r) {
  var n, i, o, a, s, u, d = 0, f = !1, h = !1, g = !0;
  if (typeof e != "function")
    throw new TypeError(E5e);
  t = dF(t) || 0, A5e(r) && (f = !!r.leading, h = "maxWait" in r, o = h ? I5e(dF(r.maxWait) || 0, t) : o, g = "trailing" in r ? !!r.trailing : g);
  function m(D) {
    var E = n, N = i;
    return n = i = void 0, d = D, a = e.apply(N, E), a;
  }
  function v(D) {
    return d = D, s = setTimeout(y, t), f ? m(D) : a;
  }
  function w(D) {
    var E = D - u, N = D - d, I = t - E;
    return h ? N5e(I, o - N) : I;
  }
  function x(D) {
    var E = D - u, N = D - d;
    return u === void 0 || E >= t || E < 0 || h && N >= o;
  }
  function y() {
    var D = SN();
    if (x(D))
      return C(D);
    s = setTimeout(y, w(D));
  }
  function C(D) {
    return s = void 0, g && n ? m(D) : (n = i = void 0, a);
  }
  function S() {
    s !== void 0 && clearTimeout(s), d = 0, n = u = i = s = void 0;
  }
  function T() {
    return s === void 0 ? a : C(SN());
  }
  function A() {
    var D = SN(), E = x(D);
    if (n = arguments, i = this, u = D, E) {
      if (s === void 0)
        return v(u);
      if (h)
        return clearTimeout(s), s = setTimeout(y, t), m(u);
    }
    return s === void 0 && (s = setTimeout(y, t)), a;
  }
  return A.cancel = S, A.flush = T, A;
}
var $5e = z5e;
class O5e {
  constructor({ editor: t, element: r, view: n, tippyOptions: i = {}, updateDelay: o = 250, shouldShow: a }) {
    this.preventHide = !1, this.shouldShow = ({ view: s, state: u, from: d, to: f }) => {
      const { doc: h, selection: g } = u, { empty: m } = g, v = !h.textBetween(d, f).length && I_(u.selection), w = this.element.contains(document.activeElement);
      return !(!(s.hasFocus() || w) || m || v || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.dragstartHandler = () => {
      this.hide();
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: s }) => {
      var u;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      s != null && s.relatedTarget && (!((u = this.element.parentNode) === null || u === void 0) && u.contains(s.relatedTarget)) || this.hide();
    }, this.tippyBlurHandler = (s) => {
      this.blurHandler({ event: s });
    }, this.updateHandler = (s, u) => {
      var d, f, h;
      const { state: g, composing: m } = s, { doc: v, selection: w } = g, x = u && u.doc.eq(v) && u.selection.eq(w);
      if (m || x)
        return;
      this.createTooltip();
      const { ranges: y } = w, C = Math.min(...y.map((A) => A.$from.pos)), S = Math.max(...y.map((A) => A.$to.pos));
      if (!((d = this.shouldShow) === null || d === void 0 ? void 0 : d.call(this, {
        editor: this.editor,
        view: s,
        state: g,
        oldState: u,
        from: C,
        to: S
      }))) {
        this.hide();
        return;
      }
      (f = this.tippy) === null || f === void 0 || f.setProps({
        getReferenceClientRect: ((h = this.tippyOptions) === null || h === void 0 ? void 0 : h.getReferenceClientRect) || (() => {
          if (JLe(g.selection)) {
            const A = s.nodeDOM(C);
            if (A)
              return A.getBoundingClientRect();
          }
          return LQ(s, C, S);
        })
      }), this.show();
    }, this.editor = t, this.element = r, this.view = n, this.updateDelay = o, a && (this.shouldShow = a), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = i, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: t } = this.editor.options, r = !!t.parentElement;
    this.tippy || !r || (this.tippy = Gp(t, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "top",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(t, r) {
    const { state: n } = t, i = n.selection.$from.pos !== n.selection.$to.pos;
    this.updateDelay > 0 && i ? $5e(this.updateHandler, this.updateDelay)(t, r) : this.updateHandler(t, r);
  }
  show() {
    var t;
    (t = this.tippy) === null || t === void 0 || t.show();
  }
  hide() {
    var t;
    (t = this.tippy) === null || t === void 0 || t.hide();
  }
  destroy() {
    var t, r;
    !((t = this.tippy) === null || t === void 0) && t.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (r = this.tippy) === null || r === void 0 || r.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const uq = (e) => new ra({
  key: typeof e.pluginKey == "string" ? new _o(e.pluginKey) : e.pluginKey,
  view: (t) => new O5e({ view: t, ...e })
});
Fn.create({
  name: "bubbleMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "bubbleMenu",
      updateDelay: void 0,
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      uq({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        updateDelay: this.options.updateDelay,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
class _5e {
  constructor({ editor: t, element: r, view: n, tippyOptions: i = {}, shouldShow: o }) {
    this.preventHide = !1, this.shouldShow = ({ view: a, state: s }) => {
      const { selection: u } = s, { $anchor: d, empty: f } = u, h = d.depth === 1, g = d.parent.isTextblock && !d.parent.type.spec.code && !d.parent.textContent;
      return !(!a.hasFocus() || !f || !h || !g || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: a }) => {
      var s;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      a != null && a.relatedTarget && (!((s = this.element.parentNode) === null || s === void 0) && s.contains(a.relatedTarget)) || this.hide();
    }, this.tippyBlurHandler = (a) => {
      this.blurHandler({ event: a });
    }, this.editor = t, this.element = r, this.view = n, o && (this.shouldShow = o), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = i, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: t } = this.editor.options, r = !!t.parentElement;
    this.tippy || !r || (this.tippy = Gp(t, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "right",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(t, r) {
    var n, i, o;
    const { state: a } = t, { doc: s, selection: u } = a, { from: d, to: f } = u;
    if (r && r.doc.eq(s) && r.selection.eq(u))
      return;
    if (this.createTooltip(), !((n = this.shouldShow) === null || n === void 0 ? void 0 : n.call(this, {
      editor: this.editor,
      view: t,
      state: a,
      oldState: r
    }))) {
      this.hide();
      return;
    }
    (i = this.tippy) === null || i === void 0 || i.setProps({
      getReferenceClientRect: ((o = this.tippyOptions) === null || o === void 0 ? void 0 : o.getReferenceClientRect) || (() => LQ(t, d, f))
    }), this.show();
  }
  show() {
    var t;
    (t = this.tippy) === null || t === void 0 || t.show();
  }
  hide() {
    var t;
    (t = this.tippy) === null || t === void 0 || t.hide();
  }
  destroy() {
    var t, r;
    !((t = this.tippy) === null || t === void 0) && t.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (r = this.tippy) === null || r === void 0 || r.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const cq = (e) => new ra({
  key: typeof e.pluginKey == "string" ? new _o(e.pluginKey) : e.pluginKey,
  view: (t) => new _5e({ view: t, ...e })
});
Fn.create({
  name: "floatingMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "floatingMenu",
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      cq({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
const dq = oe({
  name: "BubbleMenu",
  props: {
    pluginKey: {
      // TODO: TypeScript breaks :(
      // type: [String, Object as PropType<Exclude<BubbleMenuPluginProps['pluginKey'], string>>],
      type: null,
      default: "bubbleMenu"
    },
    editor: {
      type: Object,
      required: !0
    },
    updateDelay: {
      type: Number,
      default: void 0
    },
    tippyOptions: {
      type: Object,
      default: () => ({})
    },
    shouldShow: {
      type: Function,
      default: null
    }
  },
  setup(e, { slots: t }) {
    const r = G(null);
    return br(() => {
      const { updateDelay: n, editor: i, pluginKey: o, shouldShow: a, tippyOptions: s } = e;
      i.registerPlugin(uq({
        updateDelay: n,
        editor: i,
        element: r.value,
        pluginKey: o,
        shouldShow: a,
        tippyOptions: s
      }));
    }), Gr(() => {
      const { pluginKey: n, editor: i } = e;
      i.unregisterPlugin(n);
    }), () => {
      var n;
      return b("div", { ref: r }, (n = t.default) === null || n === void 0 ? void 0 : n.call(t));
    };
  }
}), L5e = oe({
  name: "EditorContent",
  props: {
    editor: {
      default: null,
      type: Object
    }
  },
  setup(e) {
    const t = G(), r = uh();
    return On(() => {
      const n = e.editor;
      n && n.options.element && t.value && an(() => {
        if (!t.value || !n.options.element.firstChild)
          return;
        const i = B(t.value);
        t.value.append(...n.options.element.childNodes), n.contentComponent = r.ctx._, n.setOptions({
          element: i
        }), n.createNodeViews();
      });
    }), Gr(() => {
      const n = e.editor;
      if (!n || (n.isDestroyed || n.view.setProps({
        nodeViews: {}
      }), n.contentComponent = null, !n.options.element.firstChild))
        return;
      const i = document.createElement("div");
      i.append(...n.options.element.childNodes), n.setOptions({
        element: i
      });
    }), { rootEl: t };
  },
  render() {
    const e = [];
    return this.editor && this.editor.vueRenderers.forEach((t) => {
      const r = b(AM, {
        to: t.teleportElement,
        key: t.id
      }, b(t.component, {
        ref: t.id,
        ...t.props
      }));
      e.push(r);
    }), b("div", {
      ref: (t) => {
        this.rootEl = t;
      }
    }, ...e);
  }
});
oe({
  name: "FloatingMenu",
  props: {
    pluginKey: {
      // TODO: TypeScript breaks :(
      // type: [String, Object as PropType<Exclude<FloatingMenuPluginProps['pluginKey'], string>>],
      type: null,
      default: "floatingMenu"
    },
    editor: {
      type: Object,
      required: !0
    },
    tippyOptions: {
      type: Object,
      default: () => ({})
    },
    shouldShow: {
      type: Function,
      default: null
    }
  },
  setup(e, { slots: t }) {
    const r = G(null);
    return br(() => {
      const { pluginKey: n, editor: i, tippyOptions: o, shouldShow: a } = e;
      i.registerPlugin(cq({
        pluginKey: n,
        editor: i,
        element: r.value,
        tippyOptions: o,
        shouldShow: a
      }));
    }), Gr(() => {
      const { pluginKey: n, editor: i } = e;
      i.unregisterPlugin(n);
    }), () => {
      var n;
      return b("div", { ref: r }, (n = t.default) === null || n === void 0 ? void 0 : n.call(t));
    };
  }
});
oe({
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  render() {
    return b(this.as, {
      style: {
        whiteSpace: "pre-wrap"
      },
      "data-node-view-content": ""
    });
  }
});
const P5e = oe({
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  inject: ["onDragStart", "decorationClasses"],
  render() {
    var e, t;
    return b(this.as, {
      // @ts-ignore
      class: this.decorationClasses,
      style: {
        whiteSpace: "normal"
      },
      "data-node-view-wrapper": "",
      // @ts-ignore (https://github.com/vuejs/vue-next/issues/3031)
      onDragstart: this.onDragStart
    }, (t = (e = this.$slots).default) === null || t === void 0 ? void 0 : t.call(e));
  }
});
class R5e {
  constructor(t, { props: r = {}, editor: n }) {
    if (this.id = Math.floor(Math.random() * 4294967295).toString(), this.editor = n, this.component = qN(t), this.teleportElement = document.createElement("div"), this.element = this.teleportElement, this.props = UO(r), this.editor.vueRenderers.set(this.id, this), this.editor.contentComponent) {
      if (this.editor.contentComponent.update(), this.teleportElement.children.length !== 1)
        throw Error("VueRenderer doesn’t support multiple child elements.");
      this.element = this.teleportElement.firstElementChild;
    }
  }
  get ref() {
    var t;
    return (t = this.editor.contentComponent) === null || t === void 0 ? void 0 : t.refs[this.id];
  }
  updateProps(t = {}) {
    Object.entries(t).forEach(([r, n]) => {
      this.props[r] = n;
    });
  }
  destroy() {
    this.editor.vueRenderers.delete(this.id);
  }
}
class j5e extends w3e {
  mount() {
    const t = {
      editor: this.editor,
      node: this.node,
      decorations: this.decorations,
      selected: !1,
      extension: this.extension,
      getPos: () => this.getPos(),
      updateAttributes: (i = {}) => this.updateAttributes(i),
      deleteNode: () => this.deleteNode()
    }, r = this.onDragStart.bind(this);
    this.decorationClasses = G(this.getDecorationClasses());
    const n = oe({
      extends: { ...this.component },
      props: Object.keys(t),
      template: this.component.template,
      setup: (i) => {
        var o, a;
        return tr("onDragStart", r), tr("decorationClasses", this.decorationClasses), (a = (o = this.component).setup) === null || a === void 0 ? void 0 : a.call(o, i, {
          expose: () => {
          }
        });
      },
      // add support for scoped styles
      // @ts-ignore
      // eslint-disable-next-line
      __scopeId: this.component.__scopeId,
      // add support for CSS Modules
      // @ts-ignore
      // eslint-disable-next-line
      __cssModules: this.component.__cssModules
    });
    this.renderer = new R5e(n, {
      editor: this.editor,
      props: t
    });
  }
  get dom() {
    if (!this.renderer.element.hasAttribute("data-node-view-wrapper"))
      throw Error("Please use the NodeViewWrapper component for your node view.");
    return this.renderer.element;
  }
  get contentDOM() {
    return this.node.isLeaf ? null : this.dom.querySelector("[data-node-view-content]") || this.dom;
  }
  update(t, r) {
    const n = (i) => {
      this.decorationClasses.value = this.getDecorationClasses(), this.renderer.updateProps(i);
    };
    if (typeof this.options.update == "function") {
      const i = this.node, o = this.decorations;
      return this.node = t, this.decorations = r, this.options.update({
        oldNode: i,
        oldDecorations: o,
        newNode: t,
        newDecorations: r,
        updateProps: () => n({ node: t, decorations: r })
      });
    }
    return t.type !== this.node.type ? !1 : (t === this.node && this.decorations === r || (this.node = t, this.decorations = r, n({ node: t, decorations: r })), !0);
  }
  selectNode() {
    this.renderer.updateProps({
      selected: !0
    });
  }
  deselectNode() {
    this.renderer.updateProps({
      selected: !1
    });
  }
  getDecorationClasses() {
    return this.decorations.map((t) => t.type.attrs.class).flat().join(" ");
  }
  destroy() {
    this.renderer.destroy();
  }
}
function F5e(e, t) {
  return (r) => r.editor.contentComponent ? new j5e(e, r, t) : {};
}
const fq = "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMTcuMDgzMyA3LjVIMy43NVYxMi41SDE3LjA4MzNWNy41WiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTcuNSAxNi4yNUgxMy4zMzMzIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNy41IDMuNzVIMTMuMzMzMyIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==", hq = "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMy4zMzM5OCAxNUg5LjE2NzMyTTMuMzMzOTggNUgxNi42NjczVjEwSDMuMzMzOThWNVoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=", pq = "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMTYuNjY2IDE1SDEwLjgzMjdNMTYuNjY2IDVIMy4zMzI2OFYxMEgxNi42NjZWNVoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=", gq = "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMTUxOV8xNTc5OSkiPgo8cGF0aCBkPSJNOC45NDQyIDguMTAxNTZDOS4wODIyNyA4LjEwMTU2IDkuMTk0MiA4LjIxMzQ5IDkuMTk0MiA4LjM1MTU2VjEyLjQ3NjJDOS4xOTQyIDEyLjYxNDMgOS4wODIyNyAxMi43MjYyIDguOTQ0MiAxMi43MjYySDYuMzQ3MUgzLjc1QzMuNjExOTMgMTIuNzI2MiAzLjUgMTIuNjE0MyAzLjUgMTIuNDc2MlY4LjM1MTU2QzMuNSA4LjIxMzQ5IDMuNjExOTMgOC4xMDE1NiAzLjc1IDguMTAxNTZIOC45NDQyWiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIuNSAxNi40OTQxSDE3LjQ5OTciIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0yLjUgNC4zMzU5NEgxNy40OTk3IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTIuMjcxNSA4LjA2NjQxTDE3LjQ5OTkgOC4wNjY0MSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTEyLjI3MTUgMTIuNzczNEgxNS4xMzI5IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzE1MTlfMTU3OTkiPgo8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=", mq = "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMTEuMDU2IDguMTAxNTRDMTAuOTE3OSA4LjEwMTU0IDEwLjgwNiA4LjIxMzQ2IDEwLjgwNiA4LjM1MTUzVjEyLjQ3NjFDMTAuODA2IDEyLjYxNDIgMTAuOTE3OSAxMi43MjYxIDExLjA1NiAxMi43MjYxSDEzLjY1M0gxNi4yNUMxNi4zODgxIDEyLjcyNjEgMTYuNSAxMi42MTQyIDE2LjUgMTIuNDc2MVY4LjM1MTUzQzE2LjUgOC4yMTM0NiAxNi4zODgxIDguMTAxNTQgMTYuMjUgOC4xMDE1NEgxMS4wNTZaIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTcuNSAxNi40OTQxSDIuNTAwNjMiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNy41IDQuMzM1OTRIMi41MDA2MyIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTcuNzI4NTIgOC4wNjY0MUwyLjUwMDIxIDguMDY2NDEiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik03LjcyODUyIDEyLjc3MzRINC44NjcyIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";
var X$;
try {
  X$ = Map;
} catch {
}
var J$;
try {
  J$ = Set;
} catch {
}
function vq(e, t, r) {
  if (!e || typeof e != "object" || typeof e == "function")
    return e;
  if (e.nodeType && "cloneNode" in e)
    return e.cloneNode(!0);
  if (e instanceof Date)
    return new Date(e.getTime());
  if (e instanceof RegExp)
    return new RegExp(e);
  if (Array.isArray(e))
    return e.map(eO);
  if (X$ && e instanceof X$)
    return new Map(Array.from(e.entries()));
  if (J$ && e instanceof J$)
    return new Set(Array.from(e.values()));
  if (e instanceof Object) {
    t.push(e);
    var n = Object.create(e);
    r.push(n);
    for (var i in e) {
      var o = t.findIndex(function(a) {
        return a === e[i];
      });
      n[i] = o > -1 ? r[o] : vq(e[i], t, r);
    }
    return n;
  }
  return e;
}
function eO(e) {
  return vq(e, [], []);
}
const B5e = Object.prototype.toString, U5e = Error.prototype.toString, H5e = RegExp.prototype.toString, W5e = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", V5e = /^Symbol\((.*)\)(.*)$/;
function Y5e(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function fF(e, t = !1) {
  if (e == null || e === !0 || e === !1)
    return "" + e;
  const r = typeof e;
  if (r === "number")
    return Y5e(e);
  if (r === "string")
    return t ? `"${e}"` : e;
  if (r === "function")
    return "[Function " + (e.name || "anonymous") + "]";
  if (r === "symbol")
    return W5e.call(e).replace(V5e, "Symbol($1)");
  const n = B5e.call(e).slice(8, -1);
  return n === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : n === "Error" || e instanceof Error ? "[" + U5e.call(e) + "]" : n === "RegExp" ? H5e.call(e) : null;
}
function Q0(e, t) {
  let r = fF(e, t);
  return r !== null ? r : JSON.stringify(e, function(n, i) {
    let o = fF(this[n], t);
    return o !== null ? o : i;
  }, 2);
}
let Df = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: t,
    value: r,
    originalValue: n
  }) => {
    let i = n != null && n !== r, o = `${e} must be a \`${t}\` type, but the final value was: \`${Q0(r, !0)}\`` + (i ? ` (cast from the value \`${Q0(n, !0)}\`).` : ".");
    return r === null && (o += '\n If "null" is intended as an empty value be sure to mark the schema as `.nullable()`'), o;
  },
  defined: "${path} must be defined"
}, zl = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, nc = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, tO = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, Q5e = {
  isValue: "${path} field must be ${value}"
}, q5e = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, G5e = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: Df,
  string: zl,
  number: nc,
  date: tO,
  object: q5e,
  array: G5e,
  boolean: Q5e
});
var Z5e = Object.prototype, K5e = Z5e.hasOwnProperty;
function X5e(e, t) {
  return e != null && K5e.call(e, t);
}
var J5e = X5e, eje = Array.isArray, Vc = eje, tje = typeof Ou == "object" && Ou && Ou.Object === Object && Ou, bq = tje, rje = bq, nje = typeof self == "object" && self && self.Object === Object && self, ije = rje || nje || Function("return this")(), Qu = ije, oje = Qu, aje = oje.Symbol, fC = aje, hF = fC, yq = Object.prototype, lje = yq.hasOwnProperty, sje = yq.toString, $v = hF ? hF.toStringTag : void 0;
function uje(e) {
  var t = lje.call(e, $v), r = e[$v];
  try {
    e[$v] = void 0;
    var n = !0;
  } catch {
  }
  var i = sje.call(e);
  return n && (t ? e[$v] = r : delete e[$v]), i;
}
var cje = uje, dje = Object.prototype, fje = dje.toString;
function hje(e) {
  return fje.call(e);
}
var pje = hje, pF = fC, gje = cje, mje = pje, vje = "[object Null]", bje = "[object Undefined]", gF = pF ? pF.toStringTag : void 0;
function yje(e) {
  return e == null ? e === void 0 ? bje : vje : gF && gF in Object(e) ? gje(e) : mje(e);
}
var Ob = yje;
function xje(e) {
  return e != null && typeof e == "object";
}
var _b = xje, wje = Ob, Mje = _b, Cje = "[object Symbol]";
function Sje(e) {
  return typeof e == "symbol" || Mje(e) && wje(e) == Cje;
}
var Z_ = Sje, Tje = Vc, kje = Z_, Dje = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Aje = /^\w*$/;
function Eje(e, t) {
  if (Tje(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || kje(e) ? !0 : Aje.test(e) || !Dje.test(e) || t != null && e in Object(t);
}
var K_ = Eje;
function Ije(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var X_ = Ije, Nje = Ob, zje = X_, $je = "[object AsyncFunction]", Oje = "[object Function]", _je = "[object GeneratorFunction]", Lje = "[object Proxy]";
function Pje(e) {
  if (!zje(e))
    return !1;
  var t = Nje(e);
  return t == Oje || t == _je || t == $je || t == Lje;
}
var xq = Pje, Rje = Qu, jje = Rje["__core-js_shared__"], Fje = jje, TN = Fje, mF = function() {
  var e = /[^.]+$/.exec(TN && TN.keys && TN.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Bje(e) {
  return !!mF && mF in e;
}
var Uje = Bje, Hje = Function.prototype, Wje = Hje.toString;
function Vje(e) {
  if (e != null) {
    try {
      return Wje.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var wq = Vje, Yje = xq, Qje = Uje, qje = X_, Gje = wq, Zje = /[\\^$.*+?()[\]{}|]/g, Kje = /^\[object .+?Constructor\]$/, Xje = Function.prototype, Jje = Object.prototype, eFe = Xje.toString, tFe = Jje.hasOwnProperty, rFe = RegExp(
  "^" + eFe.call(tFe).replace(Zje, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function nFe(e) {
  if (!qje(e) || Qje(e))
    return !1;
  var t = Yje(e) ? rFe : Kje;
  return t.test(Gje(e));
}
var iFe = nFe;
function oFe(e, t) {
  return e == null ? void 0 : e[t];
}
var aFe = oFe, lFe = iFe, sFe = aFe;
function uFe(e, t) {
  var r = sFe(e, t);
  return lFe(r) ? r : void 0;
}
var yh = uFe, cFe = yh, dFe = cFe(Object, "create"), hC = dFe, vF = hC;
function fFe() {
  this.__data__ = vF ? vF(null) : {}, this.size = 0;
}
var hFe = fFe;
function pFe(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var gFe = pFe, mFe = hC, vFe = "__lodash_hash_undefined__", bFe = Object.prototype, yFe = bFe.hasOwnProperty;
function xFe(e) {
  var t = this.__data__;
  if (mFe) {
    var r = t[e];
    return r === vFe ? void 0 : r;
  }
  return yFe.call(t, e) ? t[e] : void 0;
}
var wFe = xFe, MFe = hC, CFe = Object.prototype, SFe = CFe.hasOwnProperty;
function TFe(e) {
  var t = this.__data__;
  return MFe ? t[e] !== void 0 : SFe.call(t, e);
}
var kFe = TFe, DFe = hC, AFe = "__lodash_hash_undefined__";
function EFe(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = DFe && t === void 0 ? AFe : t, this;
}
var IFe = EFe, NFe = hFe, zFe = gFe, $Fe = wFe, OFe = kFe, _Fe = IFe;
function Zp(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Zp.prototype.clear = NFe;
Zp.prototype.delete = zFe;
Zp.prototype.get = $Fe;
Zp.prototype.has = OFe;
Zp.prototype.set = _Fe;
var LFe = Zp;
function PFe() {
  this.__data__ = [], this.size = 0;
}
var RFe = PFe;
function jFe(e, t) {
  return e === t || e !== e && t !== t;
}
var Mq = jFe, FFe = Mq;
function BFe(e, t) {
  for (var r = e.length; r--; )
    if (FFe(e[r][0], t))
      return r;
  return -1;
}
var pC = BFe, UFe = pC, HFe = Array.prototype, WFe = HFe.splice;
function VFe(e) {
  var t = this.__data__, r = UFe(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : WFe.call(t, r, 1), --this.size, !0;
}
var YFe = VFe, QFe = pC;
function qFe(e) {
  var t = this.__data__, r = QFe(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var GFe = qFe, ZFe = pC;
function KFe(e) {
  return ZFe(this.__data__, e) > -1;
}
var XFe = KFe, JFe = pC;
function eBe(e, t) {
  var r = this.__data__, n = JFe(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var tBe = eBe, rBe = RFe, nBe = YFe, iBe = GFe, oBe = XFe, aBe = tBe;
function Kp(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Kp.prototype.clear = rBe;
Kp.prototype.delete = nBe;
Kp.prototype.get = iBe;
Kp.prototype.has = oBe;
Kp.prototype.set = aBe;
var gC = Kp, lBe = yh, sBe = Qu, uBe = lBe(sBe, "Map"), J_ = uBe, bF = LFe, cBe = gC, dBe = J_;
function fBe() {
  this.size = 0, this.__data__ = {
    hash: new bF(),
    map: new (dBe || cBe)(),
    string: new bF()
  };
}
var hBe = fBe;
function pBe(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var gBe = pBe, mBe = gBe;
function vBe(e, t) {
  var r = e.__data__;
  return mBe(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var mC = vBe, bBe = mC;
function yBe(e) {
  var t = bBe(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var xBe = yBe, wBe = mC;
function MBe(e) {
  return wBe(this, e).get(e);
}
var CBe = MBe, SBe = mC;
function TBe(e) {
  return SBe(this, e).has(e);
}
var kBe = TBe, DBe = mC;
function ABe(e, t) {
  var r = DBe(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var EBe = ABe, IBe = hBe, NBe = xBe, zBe = CBe, $Be = kBe, OBe = EBe;
function Xp(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Xp.prototype.clear = IBe;
Xp.prototype.delete = NBe;
Xp.prototype.get = zBe;
Xp.prototype.has = $Be;
Xp.prototype.set = OBe;
var eL = Xp, Cq = eL, _Be = "Expected a function";
function tL(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(_Be);
  var r = function() {
    var n = arguments, i = t ? t.apply(this, n) : n[0], o = r.cache;
    if (o.has(i))
      return o.get(i);
    var a = e.apply(this, n);
    return r.cache = o.set(i, a) || o, a;
  };
  return r.cache = new (tL.Cache || Cq)(), r;
}
tL.Cache = Cq;
var LBe = tL, PBe = LBe, RBe = 500;
function jBe(e) {
  var t = PBe(e, function(n) {
    return r.size === RBe && r.clear(), n;
  }), r = t.cache;
  return t;
}
var FBe = jBe, BBe = FBe, UBe = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, HBe = /\\(\\)?/g, WBe = BBe(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(UBe, function(r, n, i, o) {
    t.push(i ? o.replace(HBe, "$1") : n || r);
  }), t;
}), VBe = WBe;
function YBe(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, i = Array(n); ++r < n; )
    i[r] = t(e[r], r, e);
  return i;
}
var QBe = YBe, yF = fC, qBe = QBe, GBe = Vc, ZBe = Z_, KBe = 1 / 0, xF = yF ? yF.prototype : void 0, wF = xF ? xF.toString : void 0;
function Sq(e) {
  if (typeof e == "string")
    return e;
  if (GBe(e))
    return qBe(e, Sq) + "";
  if (ZBe(e))
    return wF ? wF.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -KBe ? "-0" : t;
}
var XBe = Sq, JBe = XBe;
function e6e(e) {
  return e == null ? "" : JBe(e);
}
var t6e = e6e, r6e = Vc, n6e = K_, i6e = VBe, o6e = t6e;
function a6e(e, t) {
  return r6e(e) ? e : n6e(e, t) ? [e] : i6e(o6e(e));
}
var Tq = a6e, l6e = Ob, s6e = _b, u6e = "[object Arguments]";
function c6e(e) {
  return s6e(e) && l6e(e) == u6e;
}
var d6e = c6e, MF = d6e, f6e = _b, kq = Object.prototype, h6e = kq.hasOwnProperty, p6e = kq.propertyIsEnumerable, g6e = MF(function() {
  return arguments;
}()) ? MF : function(e) {
  return f6e(e) && h6e.call(e, "callee") && !p6e.call(e, "callee");
}, Dq = g6e, m6e = 9007199254740991, v6e = /^(?:0|[1-9]\d*)$/;
function b6e(e, t) {
  var r = typeof e;
  return t = t ?? m6e, !!t && (r == "number" || r != "symbol" && v6e.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Aq = b6e, y6e = 9007199254740991;
function x6e(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= y6e;
}
var rL = x6e, w6e = Z_, M6e = 1 / 0;
function C6e(e) {
  if (typeof e == "string" || w6e(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -M6e ? "-0" : t;
}
var vC = C6e, S6e = Tq, T6e = Dq, k6e = Vc, D6e = Aq, A6e = rL, E6e = vC;
function I6e(e, t, r) {
  t = S6e(t, e);
  for (var n = -1, i = t.length, o = !1; ++n < i; ) {
    var a = E6e(t[n]);
    if (!(o = e != null && r(e, a)))
      break;
    e = e[a];
  }
  return o || ++n != i ? o : (i = e == null ? 0 : e.length, !!i && A6e(i) && D6e(a, i) && (k6e(e) || T6e(e)));
}
var Eq = I6e, N6e = J5e, z6e = Eq;
function $6e(e, t) {
  return e != null && z6e(e, t, N6e);
}
var O6e = $6e;
const Iq = (e) => e && e.__isYupSchema__;
class _6e {
  constructor(t, r) {
    if (this.fn = void 0, this.refs = t, this.refs = t, typeof r == "function") {
      this.fn = r;
      return;
    }
    if (!O6e(r, "is"))
      throw new TypeError("`is:` is required for `when()` conditions");
    if (!r.then && !r.otherwise)
      throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: n,
      then: i,
      otherwise: o
    } = r, a = typeof n == "function" ? n : (...s) => s.every((u) => u === n);
    this.fn = function(...s) {
      let u = s.pop(), d = s.pop(), f = a(...s) ? i : o;
      if (f)
        return typeof f == "function" ? f(d) : d.concat(f.resolve(u));
    };
  }
  resolve(t, r) {
    let n = this.refs.map((o) => o.getValue(r == null ? void 0 : r.value, r == null ? void 0 : r.parent, r == null ? void 0 : r.context)), i = this.fn.apply(t, n.concat(t, r));
    if (i === void 0 || i === t)
      return t;
    if (!Iq(i))
      throw new TypeError("conditions must return a schema object");
    return i.resolve(r);
  }
}
function Nq(e) {
  return e == null ? [] : [].concat(e);
}
function rO() {
  return rO = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rO.apply(this, arguments);
}
let L6e = /\$\{\s*(\w+)\s*\}/g;
class nl extends Error {
  static formatError(t, r) {
    const n = r.label || r.path || "this";
    return n !== r.path && (r = rO({}, r, {
      path: n
    })), typeof t == "string" ? t.replace(L6e, (i, o) => Q0(r[o])) : typeof t == "function" ? t(r) : t;
  }
  static isError(t) {
    return t && t.name === "ValidationError";
  }
  constructor(t, r, n, i) {
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.errors = void 0, this.params = void 0, this.inner = void 0, this.name = "ValidationError", this.value = r, this.path = n, this.type = i, this.errors = [], this.inner = [], Nq(t).forEach((o) => {
      nl.isError(o) ? (this.errors.push(...o.errors), this.inner = this.inner.concat(o.inner.length ? o.inner : o)) : this.errors.push(o);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0], Error.captureStackTrace && Error.captureStackTrace(this, nl);
  }
}
const P6e = (e) => {
  let t = !1;
  return (...r) => {
    t || (t = !0, e(...r));
  };
};
function CF(e, t) {
  let {
    endEarly: r,
    tests: n,
    args: i,
    value: o,
    errors: a,
    sort: s,
    path: u
  } = e, d = P6e(t), f = n.length;
  const h = [];
  if (a = a || [], !f)
    return a.length ? d(new nl(a, o, u)) : d(null, o);
  for (let g = 0; g < n.length; g++) {
    const m = n[g];
    m(i, function(w) {
      if (w) {
        if (!nl.isError(w))
          return d(w, o);
        if (r)
          return w.value = o, d(w, o);
        h.push(w);
      }
      if (--f <= 0) {
        if (h.length && (s && h.sort(s), a.length && h.push(...a), a = h), a.length) {
          d(new nl(a, o, u), o);
          return;
        }
        d(null, o);
      }
    });
  }
}
var R6e = yh, j6e = function() {
  try {
    var e = R6e(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), F6e = j6e, SF = F6e;
function B6e(e, t, r) {
  t == "__proto__" && SF ? SF(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var U6e = B6e;
function H6e(e) {
  return function(t, r, n) {
    for (var i = -1, o = Object(t), a = n(t), s = a.length; s--; ) {
      var u = a[e ? s : ++i];
      if (r(o[u], u, o) === !1)
        break;
    }
    return t;
  };
}
var W6e = H6e, V6e = W6e, Y6e = V6e(), Q6e = Y6e;
function q6e(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var G6e = q6e, q0 = {}, Z6e = {
  get exports() {
    return q0;
  },
  set exports(e) {
    q0 = e;
  }
};
function K6e() {
  return !1;
}
var X6e = K6e;
(function(e, t) {
  var r = Qu, n = X6e, i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, a = o && o.exports === i, s = a ? r.Buffer : void 0, u = s ? s.isBuffer : void 0, d = u || n;
  e.exports = d;
})(Z6e, q0);
var J6e = Ob, e8e = rL, t8e = _b, r8e = "[object Arguments]", n8e = "[object Array]", i8e = "[object Boolean]", o8e = "[object Date]", a8e = "[object Error]", l8e = "[object Function]", s8e = "[object Map]", u8e = "[object Number]", c8e = "[object Object]", d8e = "[object RegExp]", f8e = "[object Set]", h8e = "[object String]", p8e = "[object WeakMap]", g8e = "[object ArrayBuffer]", m8e = "[object DataView]", v8e = "[object Float32Array]", b8e = "[object Float64Array]", y8e = "[object Int8Array]", x8e = "[object Int16Array]", w8e = "[object Int32Array]", M8e = "[object Uint8Array]", C8e = "[object Uint8ClampedArray]", S8e = "[object Uint16Array]", T8e = "[object Uint32Array]", Kn = {};
Kn[v8e] = Kn[b8e] = Kn[y8e] = Kn[x8e] = Kn[w8e] = Kn[M8e] = Kn[C8e] = Kn[S8e] = Kn[T8e] = !0;
Kn[r8e] = Kn[n8e] = Kn[g8e] = Kn[i8e] = Kn[m8e] = Kn[o8e] = Kn[a8e] = Kn[l8e] = Kn[s8e] = Kn[u8e] = Kn[c8e] = Kn[d8e] = Kn[f8e] = Kn[h8e] = Kn[p8e] = !1;
function k8e(e) {
  return t8e(e) && e8e(e.length) && !!Kn[J6e(e)];
}
var D8e = k8e;
function A8e(e) {
  return function(t) {
    return e(t);
  };
}
var E8e = A8e, Px = {}, I8e = {
  get exports() {
    return Px;
  },
  set exports(e) {
    Px = e;
  }
};
(function(e, t) {
  var r = bq, n = t && !t.nodeType && t, i = n && !0 && e && !e.nodeType && e, o = i && i.exports === n, a = o && r.process, s = function() {
    try {
      var u = i && i.require && i.require("util").types;
      return u || a && a.binding && a.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(I8e, Px);
var N8e = D8e, z8e = E8e, TF = Px, kF = TF && TF.isTypedArray, $8e = kF ? z8e(kF) : N8e, zq = $8e, O8e = G6e, _8e = Dq, L8e = Vc, P8e = q0, R8e = Aq, j8e = zq, F8e = Object.prototype, B8e = F8e.hasOwnProperty;
function U8e(e, t) {
  var r = L8e(e), n = !r && _8e(e), i = !r && !n && P8e(e), o = !r && !n && !i && j8e(e), a = r || n || i || o, s = a ? O8e(e.length, String) : [], u = s.length;
  for (var d in e)
    (t || B8e.call(e, d)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (d == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (d == "offset" || d == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (d == "buffer" || d == "byteLength" || d == "byteOffset") || // Skip index properties.
    R8e(d, u))) && s.push(d);
  return s;
}
var H8e = U8e, W8e = Object.prototype;
function V8e(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || W8e;
  return e === r;
}
var Y8e = V8e;
function Q8e(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var q8e = Q8e, G8e = q8e, Z8e = G8e(Object.keys, Object), K8e = Z8e, X8e = Y8e, J8e = K8e, e9e = Object.prototype, t9e = e9e.hasOwnProperty;
function r9e(e) {
  if (!X8e(e))
    return J8e(e);
  var t = [];
  for (var r in Object(e))
    t9e.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var n9e = r9e, i9e = xq, o9e = rL;
function a9e(e) {
  return e != null && o9e(e.length) && !i9e(e);
}
var l9e = a9e, s9e = H8e, u9e = n9e, c9e = l9e;
function d9e(e) {
  return c9e(e) ? s9e(e) : u9e(e);
}
var nL = d9e, f9e = Q6e, h9e = nL;
function p9e(e, t) {
  return e && f9e(e, t, h9e);
}
var g9e = p9e, m9e = gC;
function v9e() {
  this.__data__ = new m9e(), this.size = 0;
}
var b9e = v9e;
function y9e(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var x9e = y9e;
function w9e(e) {
  return this.__data__.get(e);
}
var M9e = w9e;
function C9e(e) {
  return this.__data__.has(e);
}
var S9e = C9e, T9e = gC, k9e = J_, D9e = eL, A9e = 200;
function E9e(e, t) {
  var r = this.__data__;
  if (r instanceof T9e) {
    var n = r.__data__;
    if (!k9e || n.length < A9e - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new D9e(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var I9e = E9e, N9e = gC, z9e = b9e, $9e = x9e, O9e = M9e, _9e = S9e, L9e = I9e;
function Jp(e) {
  var t = this.__data__ = new N9e(e);
  this.size = t.size;
}
Jp.prototype.clear = z9e;
Jp.prototype.delete = $9e;
Jp.prototype.get = O9e;
Jp.prototype.has = _9e;
Jp.prototype.set = L9e;
var $q = Jp, P9e = "__lodash_hash_undefined__";
function R9e(e) {
  return this.__data__.set(e, P9e), this;
}
var j9e = R9e;
function F9e(e) {
  return this.__data__.has(e);
}
var B9e = F9e, U9e = eL, H9e = j9e, W9e = B9e;
function Rx(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new U9e(); ++t < r; )
    this.add(e[t]);
}
Rx.prototype.add = Rx.prototype.push = H9e;
Rx.prototype.has = W9e;
var V9e = Rx;
function Y9e(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var Q9e = Y9e;
function q9e(e, t) {
  return e.has(t);
}
var G9e = q9e, Z9e = V9e, K9e = Q9e, X9e = G9e, J9e = 1, eUe = 2;
function tUe(e, t, r, n, i, o) {
  var a = r & J9e, s = e.length, u = t.length;
  if (s != u && !(a && u > s))
    return !1;
  var d = o.get(e), f = o.get(t);
  if (d && f)
    return d == t && f == e;
  var h = -1, g = !0, m = r & eUe ? new Z9e() : void 0;
  for (o.set(e, t), o.set(t, e); ++h < s; ) {
    var v = e[h], w = t[h];
    if (n)
      var x = a ? n(w, v, h, t, e, o) : n(v, w, h, e, t, o);
    if (x !== void 0) {
      if (x)
        continue;
      g = !1;
      break;
    }
    if (m) {
      if (!K9e(t, function(y, C) {
        if (!X9e(m, C) && (v === y || i(v, y, r, n, o)))
          return m.push(C);
      })) {
        g = !1;
        break;
      }
    } else if (!(v === w || i(v, w, r, n, o))) {
      g = !1;
      break;
    }
  }
  return o.delete(e), o.delete(t), g;
}
var Oq = tUe, rUe = Qu, nUe = rUe.Uint8Array, iUe = nUe;
function oUe(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, i) {
    r[++t] = [i, n];
  }), r;
}
var aUe = oUe;
function lUe(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var sUe = lUe, DF = fC, AF = iUe, uUe = Mq, cUe = Oq, dUe = aUe, fUe = sUe, hUe = 1, pUe = 2, gUe = "[object Boolean]", mUe = "[object Date]", vUe = "[object Error]", bUe = "[object Map]", yUe = "[object Number]", xUe = "[object RegExp]", wUe = "[object Set]", MUe = "[object String]", CUe = "[object Symbol]", SUe = "[object ArrayBuffer]", TUe = "[object DataView]", EF = DF ? DF.prototype : void 0, kN = EF ? EF.valueOf : void 0;
function kUe(e, t, r, n, i, o, a) {
  switch (r) {
    case TUe:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case SUe:
      return !(e.byteLength != t.byteLength || !o(new AF(e), new AF(t)));
    case gUe:
    case mUe:
    case yUe:
      return uUe(+e, +t);
    case vUe:
      return e.name == t.name && e.message == t.message;
    case xUe:
    case MUe:
      return e == t + "";
    case bUe:
      var s = dUe;
    case wUe:
      var u = n & hUe;
      if (s || (s = fUe), e.size != t.size && !u)
        return !1;
      var d = a.get(e);
      if (d)
        return d == t;
      n |= pUe, a.set(e, t);
      var f = cUe(s(e), s(t), n, i, o, a);
      return a.delete(e), f;
    case CUe:
      if (kN)
        return kN.call(e) == kN.call(t);
  }
  return !1;
}
var DUe = kUe;
function AUe(e, t) {
  for (var r = -1, n = t.length, i = e.length; ++r < n; )
    e[i + r] = t[r];
  return e;
}
var EUe = AUe, IUe = EUe, NUe = Vc;
function zUe(e, t, r) {
  var n = t(e);
  return NUe(e) ? n : IUe(n, r(e));
}
var $Ue = zUe;
function OUe(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, i = 0, o = []; ++r < n; ) {
    var a = e[r];
    t(a, r, e) && (o[i++] = a);
  }
  return o;
}
var _Ue = OUe;
function LUe() {
  return [];
}
var PUe = LUe, RUe = _Ue, jUe = PUe, FUe = Object.prototype, BUe = FUe.propertyIsEnumerable, IF = Object.getOwnPropertySymbols, UUe = IF ? function(e) {
  return e == null ? [] : (e = Object(e), RUe(IF(e), function(t) {
    return BUe.call(e, t);
  }));
} : jUe, HUe = UUe, WUe = $Ue, VUe = HUe, YUe = nL;
function QUe(e) {
  return WUe(e, YUe, VUe);
}
var qUe = QUe, NF = qUe, GUe = 1, ZUe = Object.prototype, KUe = ZUe.hasOwnProperty;
function XUe(e, t, r, n, i, o) {
  var a = r & GUe, s = NF(e), u = s.length, d = NF(t), f = d.length;
  if (u != f && !a)
    return !1;
  for (var h = u; h--; ) {
    var g = s[h];
    if (!(a ? g in t : KUe.call(t, g)))
      return !1;
  }
  var m = o.get(e), v = o.get(t);
  if (m && v)
    return m == t && v == e;
  var w = !0;
  o.set(e, t), o.set(t, e);
  for (var x = a; ++h < u; ) {
    g = s[h];
    var y = e[g], C = t[g];
    if (n)
      var S = a ? n(C, y, g, t, e, o) : n(y, C, g, e, t, o);
    if (!(S === void 0 ? y === C || i(y, C, r, n, o) : S)) {
      w = !1;
      break;
    }
    x || (x = g == "constructor");
  }
  if (w && !x) {
    var T = e.constructor, A = t.constructor;
    T != A && "constructor" in e && "constructor" in t && !(typeof T == "function" && T instanceof T && typeof A == "function" && A instanceof A) && (w = !1);
  }
  return o.delete(e), o.delete(t), w;
}
var JUe = XUe, e7e = yh, t7e = Qu, r7e = e7e(t7e, "DataView"), n7e = r7e, i7e = yh, o7e = Qu, a7e = i7e(o7e, "Promise"), l7e = a7e, s7e = yh, u7e = Qu, c7e = s7e(u7e, "Set"), d7e = c7e, f7e = yh, h7e = Qu, p7e = f7e(h7e, "WeakMap"), g7e = p7e, nO = n7e, iO = J_, oO = l7e, aO = d7e, lO = g7e, _q = Ob, eg = wq, zF = "[object Map]", m7e = "[object Object]", $F = "[object Promise]", OF = "[object Set]", _F = "[object WeakMap]", LF = "[object DataView]", v7e = eg(nO), b7e = eg(iO), y7e = eg(oO), x7e = eg(aO), w7e = eg(lO), Af = _q;
(nO && Af(new nO(new ArrayBuffer(1))) != LF || iO && Af(new iO()) != zF || oO && Af(oO.resolve()) != $F || aO && Af(new aO()) != OF || lO && Af(new lO()) != _F) && (Af = function(e) {
  var t = _q(e), r = t == m7e ? e.constructor : void 0, n = r ? eg(r) : "";
  if (n)
    switch (n) {
      case v7e:
        return LF;
      case b7e:
        return zF;
      case y7e:
        return $F;
      case x7e:
        return OF;
      case w7e:
        return _F;
    }
  return t;
});
var M7e = Af, DN = $q, C7e = Oq, S7e = DUe, T7e = JUe, PF = M7e, RF = Vc, jF = q0, k7e = zq, D7e = 1, FF = "[object Arguments]", BF = "[object Array]", $y = "[object Object]", A7e = Object.prototype, UF = A7e.hasOwnProperty;
function E7e(e, t, r, n, i, o) {
  var a = RF(e), s = RF(t), u = a ? BF : PF(e), d = s ? BF : PF(t);
  u = u == FF ? $y : u, d = d == FF ? $y : d;
  var f = u == $y, h = d == $y, g = u == d;
  if (g && jF(e)) {
    if (!jF(t))
      return !1;
    a = !0, f = !1;
  }
  if (g && !f)
    return o || (o = new DN()), a || k7e(e) ? C7e(e, t, r, n, i, o) : S7e(e, t, u, r, n, i, o);
  if (!(r & D7e)) {
    var m = f && UF.call(e, "__wrapped__"), v = h && UF.call(t, "__wrapped__");
    if (m || v) {
      var w = m ? e.value() : e, x = v ? t.value() : t;
      return o || (o = new DN()), i(w, x, r, n, o);
    }
  }
  return g ? (o || (o = new DN()), T7e(e, t, r, n, i, o)) : !1;
}
var I7e = E7e, N7e = I7e, HF = _b;
function Lq(e, t, r, n, i) {
  return e === t ? !0 : e == null || t == null || !HF(e) && !HF(t) ? e !== e && t !== t : N7e(e, t, r, n, Lq, i);
}
var Pq = Lq, z7e = $q, $7e = Pq, O7e = 1, _7e = 2;
function L7e(e, t, r, n) {
  var i = r.length, o = i, a = !n;
  if (e == null)
    return !o;
  for (e = Object(e); i--; ) {
    var s = r[i];
    if (a && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++i < o; ) {
    s = r[i];
    var u = s[0], d = e[u], f = s[1];
    if (a && s[2]) {
      if (d === void 0 && !(u in e))
        return !1;
    } else {
      var h = new z7e();
      if (n)
        var g = n(d, f, u, e, t, h);
      if (!(g === void 0 ? $7e(f, d, O7e | _7e, n, h) : g))
        return !1;
    }
  }
  return !0;
}
var P7e = L7e, R7e = X_;
function j7e(e) {
  return e === e && !R7e(e);
}
var Rq = j7e, F7e = Rq, B7e = nL;
function U7e(e) {
  for (var t = B7e(e), r = t.length; r--; ) {
    var n = t[r], i = e[n];
    t[r] = [n, i, F7e(i)];
  }
  return t;
}
var H7e = U7e;
function W7e(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
var jq = W7e, V7e = P7e, Y7e = H7e, Q7e = jq;
function q7e(e) {
  var t = Y7e(e);
  return t.length == 1 && t[0][2] ? Q7e(t[0][0], t[0][1]) : function(r) {
    return r === e || V7e(r, e, t);
  };
}
var G7e = q7e, Z7e = Tq, K7e = vC;
function X7e(e, t) {
  t = Z7e(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[K7e(t[r++])];
  return r && r == n ? e : void 0;
}
var Fq = X7e, J7e = Fq;
function eHe(e, t, r) {
  var n = e == null ? void 0 : J7e(e, t);
  return n === void 0 ? r : n;
}
var tHe = eHe;
function rHe(e, t) {
  return e != null && t in Object(e);
}
var nHe = rHe, iHe = nHe, oHe = Eq;
function aHe(e, t) {
  return e != null && oHe(e, t, iHe);
}
var lHe = aHe, sHe = Pq, uHe = tHe, cHe = lHe, dHe = K_, fHe = Rq, hHe = jq, pHe = vC, gHe = 1, mHe = 2;
function vHe(e, t) {
  return dHe(e) && fHe(t) ? hHe(pHe(e), t) : function(r) {
    var n = uHe(r, e);
    return n === void 0 && n === t ? cHe(r, e) : sHe(t, n, gHe | mHe);
  };
}
var bHe = vHe;
function yHe(e) {
  return e;
}
var xHe = yHe;
function wHe(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var MHe = wHe, CHe = Fq;
function SHe(e) {
  return function(t) {
    return CHe(t, e);
  };
}
var THe = SHe, kHe = MHe, DHe = THe, AHe = K_, EHe = vC;
function IHe(e) {
  return AHe(e) ? kHe(EHe(e)) : DHe(e);
}
var NHe = IHe, zHe = G7e, $He = bHe, OHe = xHe, _He = Vc, LHe = NHe;
function PHe(e) {
  return typeof e == "function" ? e : e == null ? OHe : typeof e == "object" ? _He(e) ? $He(e[0], e[1]) : zHe(e) : LHe(e);
}
var RHe = PHe, jHe = U6e, FHe = g9e, BHe = RHe;
function UHe(e, t) {
  var r = {};
  return t = BHe(t), FHe(e, function(n, i, o) {
    jHe(r, i, t(n, i, o));
  }), r;
}
var HHe = UHe;
function xh(e) {
  this._maxSize = e, this.clear();
}
xh.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
xh.prototype.get = function(e) {
  return this._values[e];
};
xh.prototype.set = function(e, t) {
  return this._size >= this._maxSize && this.clear(), e in this._values || this._size++, this._values[e] = t;
};
var WHe = /[^.^\]^[]+|(?=\[\]|\.\.)/g, Bq = /^\d+$/, VHe = /^\d/, YHe = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, QHe = /^\s*(['"]?)(.*?)(\1)\s*$/, iL = 512, WF = new xh(iL), VF = new xh(iL), YF = new xh(iL), Uq = {
  Cache: xh,
  split: sO,
  normalizePath: AN,
  setter: function(e) {
    var t = AN(e);
    return VF.get(e) || VF.set(e, function(n, i) {
      for (var o = 0, a = t.length, s = n; o < a - 1; ) {
        var u = t[o];
        if (u === "__proto__" || u === "constructor" || u === "prototype")
          return n;
        s = s[t[o++]];
      }
      s[t[o]] = i;
    });
  },
  getter: function(e, t) {
    var r = AN(e);
    return YF.get(e) || YF.set(e, function(i) {
      for (var o = 0, a = r.length; o < a; )
        if (i != null || !t)
          i = i[r[o++]];
        else
          return;
      return i;
    });
  },
  join: function(e) {
    return e.reduce(function(t, r) {
      return t + (oL(r) || Bq.test(r) ? "[" + r + "]" : (t ? "." : "") + r);
    }, "");
  },
  forEach: function(e, t, r) {
    qHe(Array.isArray(e) ? e : sO(e), t, r);
  }
};
function AN(e) {
  return WF.get(e) || WF.set(
    e,
    sO(e).map(function(t) {
      return t.replace(QHe, "$2");
    })
  );
}
function sO(e) {
  return e.match(WHe) || [""];
}
function qHe(e, t, r) {
  var n = e.length, i, o, a, s;
  for (o = 0; o < n; o++)
    i = e[o], i && (KHe(i) && (i = '"' + i + '"'), s = oL(i), a = !s && /^\d+$/.test(i), t.call(r, i, s, a, o, e));
}
function oL(e) {
  return typeof e == "string" && e && ["'", '"'].indexOf(e.charAt(0)) !== -1;
}
function GHe(e) {
  return e.match(VHe) && !e.match(Bq);
}
function ZHe(e) {
  return YHe.test(e);
}
function KHe(e) {
  return !oL(e) && (GHe(e) || ZHe(e));
}
const Oy = {
  context: "$",
  value: "."
};
class Gf {
  constructor(t, r = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof t != "string")
      throw new TypeError("ref must be a string, got: " + t);
    if (this.key = t.trim(), t === "")
      throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === Oy.context, this.isValue = this.key[0] === Oy.value, this.isSibling = !this.isContext && !this.isValue;
    let n = this.isContext ? Oy.context : this.isValue ? Oy.value : "";
    this.path = this.key.slice(n.length), this.getter = this.path && Uq.getter(this.path, !0), this.map = r.map;
  }
  getValue(t, r, n) {
    let i = this.isContext ? n : this.isValue ? t : r;
    return this.getter && (i = this.getter(i || {})), this.map && (i = this.map(i)), i;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(t, r) {
    return this.getValue(t, r == null ? void 0 : r.parent, r == null ? void 0 : r.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(t) {
    return t && t.__isYupRef;
  }
}
Gf.prototype.__isYupRef = !0;
function jx() {
  return jx = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, jx.apply(this, arguments);
}
function XHe(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), i, o;
  for (o = 0; o < n.length; o++)
    i = n[o], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
function _y(e) {
  function t(r, n) {
    let {
      value: i,
      path: o = "",
      label: a,
      options: s,
      originalValue: u,
      sync: d
    } = r, f = XHe(r, ["value", "path", "label", "options", "originalValue", "sync"]);
    const {
      name: h,
      test: g,
      params: m,
      message: v
    } = e;
    let {
      parent: w,
      context: x
    } = s;
    function y(D) {
      return Gf.isRef(D) ? D.getValue(i, w, x) : D;
    }
    function C(D = {}) {
      const E = HHe(jx({
        value: i,
        originalValue: u,
        label: a,
        path: D.path || o
      }, m, D.params), y), N = new nl(nl.formatError(D.message || v, E), i, E.path, D.type || h);
      return N.params = E, N;
    }
    let S = jx({
      path: o,
      parent: w,
      type: h,
      createError: C,
      resolve: y,
      options: s,
      originalValue: u
    }, f);
    if (!d) {
      try {
        Promise.resolve(g.call(S, i, S)).then((D) => {
          nl.isError(D) ? n(D) : D ? n(null, D) : n(C());
        }).catch(n);
      } catch (D) {
        n(D);
      }
      return;
    }
    let T;
    try {
      var A;
      if (T = g.call(S, i, S), typeof ((A = T) == null ? void 0 : A.then) == "function")
        throw new Error(`Validation test of type: "${S.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
    } catch (D) {
      n(D);
      return;
    }
    nl.isError(T) ? n(T) : T ? n(null, T) : n(C());
  }
  return t.OPTIONS = e, t;
}
let JHe = (e) => e.substr(0, e.length - 1).substr(1);
function eWe(e, t, r, n = r) {
  let i, o, a;
  return t ? (Uq.forEach(t, (s, u, d) => {
    let f = u ? JHe(s) : s;
    if (e = e.resolve({
      context: n,
      parent: i,
      value: r
    }), e.innerType) {
      let h = d ? parseInt(f, 10) : 0;
      if (r && h >= r.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${s}, in the path: ${t}. because there is no value at that index. `);
      i = r, r = r && r[h], e = e.innerType;
    }
    if (!d) {
      if (!e.fields || !e.fields[f])
        throw new Error(`The schema does not contain the path: ${t}. (failed at: ${a} which is a type: "${e._type}")`);
      i = r, r = r && r[f], e = e.fields[f];
    }
    o = f, a = u ? "[" + s + "]" : "." + s;
  }), {
    schema: e,
    parent: i,
    parentPath: o
  }) : {
    parent: i,
    parentPath: t,
    schema: e
  };
}
class Fx {
  constructor() {
    this.list = void 0, this.refs = void 0, this.list = /* @__PURE__ */ new Set(), this.refs = /* @__PURE__ */ new Map();
  }
  get size() {
    return this.list.size + this.refs.size;
  }
  describe() {
    const t = [];
    for (const r of this.list)
      t.push(r);
    for (const [, r] of this.refs)
      t.push(r.describe());
    return t;
  }
  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }
  resolveAll(t) {
    return this.toArray().reduce((r, n) => r.concat(Gf.isRef(n) ? t(n) : n), []);
  }
  add(t) {
    Gf.isRef(t) ? this.refs.set(t.key, t) : this.list.add(t);
  }
  delete(t) {
    Gf.isRef(t) ? this.refs.delete(t.key) : this.list.delete(t);
  }
  clone() {
    const t = new Fx();
    return t.list = new Set(this.list), t.refs = new Map(this.refs), t;
  }
  merge(t, r) {
    const n = this.clone();
    return t.list.forEach((i) => n.add(i)), t.refs.forEach((i) => n.add(i)), r.list.forEach((i) => n.delete(i)), r.refs.forEach((i) => n.delete(i)), n;
  }
}
function Ka() {
  return Ka = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ka.apply(this, arguments);
}
class Yl {
  constructor(t) {
    this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this._typeError = void 0, this._whitelist = new Fx(), this._blacklist = new Fx(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(Df.notType);
    }), this.type = (t == null ? void 0 : t.type) || "mixed", this.spec = Ka({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      nullable: !1,
      presence: "optional"
    }, t == null ? void 0 : t.spec);
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  _typeCheck(t) {
    return !0;
  }
  clone(t) {
    if (this._mutate)
      return t && Object.assign(this.spec, t), this;
    const r = Object.create(Object.getPrototypeOf(this));
    return r.type = this.type, r._typeError = this._typeError, r._whitelistError = this._whitelistError, r._blacklistError = this._blacklistError, r._whitelist = this._whitelist.clone(), r._blacklist = this._blacklist.clone(), r.exclusiveTests = Ka({}, this.exclusiveTests), r.deps = [...this.deps], r.conditions = [...this.conditions], r.tests = [...this.tests], r.transforms = [...this.transforms], r.spec = eO(Ka({}, this.spec, t)), r;
  }
  label(t) {
    let r = this.clone();
    return r.spec.label = t, r;
  }
  meta(...t) {
    if (t.length === 0)
      return this.spec.meta;
    let r = this.clone();
    return r.spec.meta = Object.assign(r.spec.meta || {}, t[0]), r;
  }
  // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }
  withMutation(t) {
    let r = this._mutate;
    this._mutate = !0;
    let n = t(this);
    return this._mutate = r, n;
  }
  concat(t) {
    if (!t || t === this)
      return this;
    if (t.type !== this.type && this.type !== "mixed")
      throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${t.type}`);
    let r = this, n = t.clone();
    const i = Ka({}, r.spec, n.spec);
    return n.spec = i, n._typeError || (n._typeError = r._typeError), n._whitelistError || (n._whitelistError = r._whitelistError), n._blacklistError || (n._blacklistError = r._blacklistError), n._whitelist = r._whitelist.merge(t._whitelist, t._blacklist), n._blacklist = r._blacklist.merge(t._blacklist, t._whitelist), n.tests = r.tests, n.exclusiveTests = r.exclusiveTests, n.withMutation((o) => {
      t.tests.forEach((a) => {
        o.test(a.OPTIONS);
      });
    }), n.transforms = [...r.transforms, ...n.transforms], n;
  }
  isType(t) {
    return this.spec.nullable && t === null ? !0 : this._typeCheck(t);
  }
  resolve(t) {
    let r = this;
    if (r.conditions.length) {
      let n = r.conditions;
      r = r.clone(), r.conditions = [], r = n.reduce((i, o) => o.resolve(i, t), r), r = r.resolve(t);
    }
    return r;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */
  cast(t, r = {}) {
    let n = this.resolve(Ka({
      value: t
    }, r)), i = n._cast(t, r);
    if (t !== void 0 && r.assert !== !1 && n.isType(i) !== !0) {
      let o = Q0(t), a = Q0(i);
      throw new TypeError(`The value of ${r.path || "field"} could not be cast to a value that satisfies the schema type: "${n._type}". 

attempted value: ${o} 
` + (a !== o ? `result of cast: ${a}` : ""));
    }
    return i;
  }
  _cast(t, r) {
    let n = t === void 0 ? t : this.transforms.reduce((i, o) => o.call(this, i, t, this), t);
    return n === void 0 && (n = this.getDefault()), n;
  }
  _validate(t, r = {}, n) {
    let {
      sync: i,
      path: o,
      from: a = [],
      originalValue: s = t,
      strict: u = this.spec.strict,
      abortEarly: d = this.spec.abortEarly
    } = r, f = t;
    u || (f = this._cast(f, Ka({
      assert: !1
    }, r)));
    let h = {
      value: f,
      path: o,
      options: r,
      originalValue: s,
      schema: this,
      label: this.spec.label,
      sync: i,
      from: a
    }, g = [];
    this._typeError && g.push(this._typeError);
    let m = [];
    this._whitelistError && m.push(this._whitelistError), this._blacklistError && m.push(this._blacklistError), CF({
      args: h,
      value: f,
      path: o,
      sync: i,
      tests: g,
      endEarly: d
    }, (v) => {
      if (v)
        return void n(v, f);
      CF({
        tests: this.tests.concat(m),
        args: h,
        path: o,
        sync: i,
        value: f,
        endEarly: d
      }, n);
    });
  }
  validate(t, r, n) {
    let i = this.resolve(Ka({}, r, {
      value: t
    }));
    return typeof n == "function" ? i._validate(t, r, n) : new Promise((o, a) => i._validate(t, r, (s, u) => {
      s ? a(s) : o(u);
    }));
  }
  validateSync(t, r) {
    let n = this.resolve(Ka({}, r, {
      value: t
    })), i;
    return n._validate(t, Ka({}, r, {
      sync: !0
    }), (o, a) => {
      if (o)
        throw o;
      i = a;
    }), i;
  }
  isValid(t, r) {
    return this.validate(t, r).then(() => !0, (n) => {
      if (nl.isError(n))
        return !1;
      throw n;
    });
  }
  isValidSync(t, r) {
    try {
      return this.validateSync(t, r), !0;
    } catch (n) {
      if (nl.isError(n))
        return !1;
      throw n;
    }
  }
  _getDefault() {
    let t = this.spec.default;
    return t == null ? t : typeof t == "function" ? t.call(this) : eO(t);
  }
  getDefault(t) {
    return this.resolve(t || {})._getDefault();
  }
  default(t) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: t
    });
  }
  strict(t = !0) {
    let r = this.clone();
    return r.spec.strict = t, r;
  }
  _isPresent(t) {
    return t != null;
  }
  defined(t = Df.defined) {
    return this.test({
      message: t,
      name: "defined",
      exclusive: !0,
      test(r) {
        return r !== void 0;
      }
    });
  }
  required(t = Df.required) {
    return this.clone({
      presence: "required"
    }).withMutation((r) => r.test({
      message: t,
      name: "required",
      exclusive: !0,
      test(n) {
        return this.schema._isPresent(n);
      }
    }));
  }
  notRequired() {
    let t = this.clone({
      presence: "optional"
    });
    return t.tests = t.tests.filter((r) => r.OPTIONS.name !== "required"), t;
  }
  nullable(t = !0) {
    return this.clone({
      nullable: t !== !1
    });
  }
  transform(t) {
    let r = this.clone();
    return r.transforms.push(t), r;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...t) {
    let r;
    if (t.length === 1 ? typeof t[0] == "function" ? r = {
      test: t[0]
    } : r = t[0] : t.length === 2 ? r = {
      name: t[0],
      test: t[1]
    } : r = {
      name: t[0],
      message: t[1],
      test: t[2]
    }, r.message === void 0 && (r.message = Df.default), typeof r.test != "function")
      throw new TypeError("`test` is a required parameters");
    let n = this.clone(), i = _y(r), o = r.exclusive || r.name && n.exclusiveTests[r.name] === !0;
    if (r.exclusive && !r.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return r.name && (n.exclusiveTests[r.name] = !!r.exclusive), n.tests = n.tests.filter((a) => !(a.OPTIONS.name === r.name && (o || a.OPTIONS.test === i.OPTIONS.test))), n.tests.push(i), n;
  }
  when(t, r) {
    !Array.isArray(t) && typeof t != "string" && (r = t, t = ".");
    let n = this.clone(), i = Nq(t).map((o) => new Gf(o));
    return i.forEach((o) => {
      o.isSibling && n.deps.push(o.key);
    }), n.conditions.push(new _6e(i, r)), n;
  }
  typeError(t) {
    let r = this.clone();
    return r._typeError = _y({
      message: t,
      name: "typeError",
      test(n) {
        return n !== void 0 && !this.schema.isType(n) ? this.createError({
          params: {
            type: this.schema._type
          }
        }) : !0;
      }
    }), r;
  }
  oneOf(t, r = Df.oneOf) {
    let n = this.clone();
    return t.forEach((i) => {
      n._whitelist.add(i), n._blacklist.delete(i);
    }), n._whitelistError = _y({
      message: r,
      name: "oneOf",
      test(i) {
        if (i === void 0)
          return !0;
        let o = this.schema._whitelist, a = o.resolveAll(this.resolve);
        return a.includes(i) ? !0 : this.createError({
          params: {
            values: o.toArray().join(", "),
            resolved: a
          }
        });
      }
    }), n;
  }
  notOneOf(t, r = Df.notOneOf) {
    let n = this.clone();
    return t.forEach((i) => {
      n._blacklist.add(i), n._whitelist.delete(i);
    }), n._blacklistError = _y({
      message: r,
      name: "notOneOf",
      test(i) {
        let o = this.schema._blacklist, a = o.resolveAll(this.resolve);
        return a.includes(i) ? this.createError({
          params: {
            values: o.toArray().join(", "),
            resolved: a
          }
        }) : !0;
      }
    }), n;
  }
  strip(t = !0) {
    let r = this.clone();
    return r.spec.strip = t, r;
  }
  describe() {
    const t = this.clone(), {
      label: r,
      meta: n
    } = t.spec;
    return {
      meta: n,
      label: r,
      type: t.type,
      oneOf: t._whitelist.describe(),
      notOneOf: t._blacklist.describe(),
      tests: t.tests.map((o) => ({
        name: o.OPTIONS.name,
        params: o.OPTIONS.params
      })).filter((o, a, s) => s.findIndex((u) => u.name === o.name) === a)
    };
  }
}
Yl.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"])
  Yl.prototype[`${e}At`] = function(t, r, n = {}) {
    const {
      parent: i,
      parentPath: o,
      schema: a
    } = eWe(this, t, r, n.context);
    return a[e](i && i[o], Ka({}, n, {
      parent: i,
      path: t
    }));
  };
for (const e of ["equals", "is"])
  Yl.prototype[e] = Yl.prototype.oneOf;
for (const e of ["not", "nope"])
  Yl.prototype[e] = Yl.prototype.notOneOf;
Yl.prototype.optional = Yl.prototype.notRequired;
const to = (e) => e == null;
let tWe = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i, rWe = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i, nWe = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, iWe = (e) => to(e) || e === e.trim(), oWe = {}.toString();
function Pu() {
  return new Hq();
}
class Hq extends Yl {
  constructor() {
    super({
      type: "string"
    }), this.withMutation(() => {
      this.transform(function(t) {
        if (this.isType(t) || Array.isArray(t))
          return t;
        const r = t != null && t.toString ? t.toString() : t;
        return r === oWe ? t : r;
      });
    });
  }
  _typeCheck(t) {
    return t instanceof String && (t = t.valueOf()), typeof t == "string";
  }
  _isPresent(t) {
    return super._isPresent(t) && !!t.length;
  }
  length(t, r = zl.length) {
    return this.test({
      message: r,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      test(n) {
        return to(n) || n.length === this.resolve(t);
      }
    });
  }
  min(t, r = zl.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(n) {
        return to(n) || n.length >= this.resolve(t);
      }
    });
  }
  max(t, r = zl.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: r,
      params: {
        max: t
      },
      test(n) {
        return to(n) || n.length <= this.resolve(t);
      }
    });
  }
  matches(t, r) {
    let n = !1, i, o;
    return r && (typeof r == "object" ? {
      excludeEmptyString: n = !1,
      message: i,
      name: o
    } = r : i = r), this.test({
      name: o || "matches",
      message: i || zl.matches,
      params: {
        regex: t
      },
      test: (a) => to(a) || a === "" && n || a.search(t) !== -1
    });
  }
  email(t = zl.email) {
    return this.matches(tWe, {
      name: "email",
      message: t,
      excludeEmptyString: !0
    });
  }
  url(t = zl.url) {
    return this.matches(rWe, {
      name: "url",
      message: t,
      excludeEmptyString: !0
    });
  }
  uuid(t = zl.uuid) {
    return this.matches(nWe, {
      name: "uuid",
      message: t,
      excludeEmptyString: !1
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((t) => t === null ? "" : t);
  }
  trim(t = zl.trim) {
    return this.transform((r) => r != null ? r.trim() : r).test({
      message: t,
      name: "trim",
      test: iWe
    });
  }
  lowercase(t = zl.lowercase) {
    return this.transform((r) => to(r) ? r : r.toLowerCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (r) => to(r) || r === r.toLowerCase()
    });
  }
  uppercase(t = zl.uppercase) {
    return this.transform((r) => to(r) ? r : r.toUpperCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (r) => to(r) || r === r.toUpperCase()
    });
  }
}
Pu.prototype = Hq.prototype;
let aWe = (e) => e != +e;
function Zf() {
  return new Wq();
}
class Wq extends Yl {
  constructor() {
    super({
      type: "number"
    }), this.withMutation(() => {
      this.transform(function(t) {
        let r = t;
        if (typeof r == "string") {
          if (r = r.replace(/\s/g, ""), r === "")
            return NaN;
          r = +r;
        }
        return this.isType(r) ? r : parseFloat(r);
      });
    });
  }
  _typeCheck(t) {
    return t instanceof Number && (t = t.valueOf()), typeof t == "number" && !aWe(t);
  }
  min(t, r = nc.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(n) {
        return to(n) || n >= this.resolve(t);
      }
    });
  }
  max(t, r = nc.max) {
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(n) {
        return to(n) || n <= this.resolve(t);
      }
    });
  }
  lessThan(t, r = nc.lessThan) {
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        less: t
      },
      test(n) {
        return to(n) || n < this.resolve(t);
      }
    });
  }
  moreThan(t, r = nc.moreThan) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        more: t
      },
      test(n) {
        return to(n) || n > this.resolve(t);
      }
    });
  }
  positive(t = nc.positive) {
    return this.moreThan(0, t);
  }
  negative(t = nc.negative) {
    return this.lessThan(0, t);
  }
  integer(t = nc.integer) {
    return this.test({
      name: "integer",
      message: t,
      test: (r) => to(r) || Number.isInteger(r)
    });
  }
  truncate() {
    return this.transform((t) => to(t) ? t : t | 0);
  }
  round(t) {
    var r;
    let n = ["ceil", "floor", "round", "trunc"];
    if (t = ((r = t) == null ? void 0 : r.toLowerCase()) || "round", t === "trunc")
      return this.truncate();
    if (n.indexOf(t.toLowerCase()) === -1)
      throw new TypeError("Only valid options for round() are: " + n.join(", "));
    return this.transform((i) => to(i) ? i : Math[t](i));
  }
}
Zf.prototype = Wq.prototype;
var lWe = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function sWe(e) {
  var t = [1, 4, 5, 6, 7, 10, 11], r = 0, n, i;
  if (i = lWe.exec(e)) {
    for (var o = 0, a; a = t[o]; ++o)
      i[a] = +i[a] || 0;
    i[2] = (+i[2] || 1) - 1, i[3] = +i[3] || 1, i[7] = i[7] ? String(i[7]).substr(0, 3) : 0, (i[8] === void 0 || i[8] === "") && (i[9] === void 0 || i[9] === "") ? n = +new Date(i[1], i[2], i[3], i[4], i[5], i[6], i[7]) : (i[8] !== "Z" && i[9] !== void 0 && (r = i[10] * 60 + i[11], i[9] === "+" && (r = 0 - r)), n = Date.UTC(i[1], i[2], i[3], i[4], i[5] + r, i[6], i[7]));
  } else
    n = Date.parse ? Date.parse(e) : NaN;
  return n;
}
let Vq = new Date(""), uWe = (e) => Object.prototype.toString.call(e) === "[object Date]";
class cWe extends Yl {
  constructor() {
    super({
      type: "date"
    }), this.withMutation(() => {
      this.transform(function(t) {
        return this.isType(t) ? t : (t = sWe(t), isNaN(t) ? Vq : new Date(t));
      });
    });
  }
  _typeCheck(t) {
    return uWe(t) && !isNaN(t.getTime());
  }
  prepareParam(t, r) {
    let n;
    if (Gf.isRef(t))
      n = t;
    else {
      let i = this.cast(t);
      if (!this._typeCheck(i))
        throw new TypeError(`\`${r}\` must be a Date or a value that can be \`cast()\` to a Date`);
      n = i;
    }
    return n;
  }
  min(t, r = tO.min) {
    let n = this.prepareParam(t, "min");
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(i) {
        return to(i) || i >= this.resolve(n);
      }
    });
  }
  max(t, r = tO.max) {
    let n = this.prepareParam(t, "max");
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(i) {
        return to(i) || i <= this.resolve(n);
      }
    });
  }
}
cWe.INVALID_DATE = Vq;
var uO = {}, dWe = {
  get exports() {
    return uO;
  },
  set exports(e) {
    uO = e;
  }
};
dWe.exports = function(e) {
  return Yq(fWe(e), e);
};
uO.array = Yq;
function Yq(e, t) {
  var r = e.length, n = new Array(r), i = {}, o = r, a = hWe(t), s = pWe(e);
  for (t.forEach(function(d) {
    if (!s.has(d[0]) || !s.has(d[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); o--; )
    i[o] || u(e[o], o, /* @__PURE__ */ new Set());
  return n;
  function u(d, f, h) {
    if (h.has(d)) {
      var g;
      try {
        g = ", node was:" + JSON.stringify(d);
      } catch {
        g = "";
      }
      throw new Error("Cyclic dependency" + g);
    }
    if (!s.has(d))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(d));
    if (!i[f]) {
      i[f] = !0;
      var m = a.get(d) || /* @__PURE__ */ new Set();
      if (m = Array.from(m), f = m.length) {
        h.add(d);
        do {
          var v = m[--f];
          u(v, s.get(v), h);
        } while (f);
        h.delete(d);
      }
      n[--r] = d;
    }
  }
}
function fWe(e) {
  for (var t = /* @__PURE__ */ new Set(), r = 0, n = e.length; r < n; r++) {
    var i = e[r];
    t.add(i[0]), t.add(i[1]);
  }
  return Array.from(t);
}
function hWe(e) {
  for (var t = /* @__PURE__ */ new Map(), r = 0, n = e.length; r < n; r++) {
    var i = e[r];
    t.has(i[0]) || t.set(i[0], /* @__PURE__ */ new Set()), t.has(i[1]) || t.set(i[1], /* @__PURE__ */ new Set()), t.get(i[0]).add(i[1]);
  }
  return t;
}
function pWe(e) {
  for (var t = /* @__PURE__ */ new Map(), r = 0, n = e.length; r < n; r++)
    t.set(e[r], r);
  return t;
}
function Qq(e, t, r) {
  if (!e || !Iq(e.prototype))
    throw new TypeError("You must provide a yup schema constructor function");
  if (typeof t != "string")
    throw new TypeError("A Method name must be provided");
  if (typeof r != "function")
    throw new TypeError("Method function must be provided");
  e.prototype[t] = r;
}
const qq = (e) => (PB("data-v-5fe98463"), e = e(), RB(), e), gWe = { class: "dimensions" }, mWe = /* @__PURE__ */ qq(() => /* @__PURE__ */ Ye("span", { class: "suffix" }, "px", -1)), vWe = /* @__PURE__ */ qq(() => /* @__PURE__ */ Ye("span", { class: "suffix" }, "px", -1)), bWe = /* @__PURE__ */ oe({
  __name: "ImagePicker",
  props: {
    modalType: String,
    showModal: Boolean,
    initialValues: Object,
    enableExternalEmbed: {
      type: Boolean,
      default: !0
    },
    externalEmbeddedImage: {
      type: String,
      default: null
    },
    modalContainer: {
      type: String,
      default: null
    },
    externalEmbedText: {
      type: String
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  emits: [
    "onSave",
    "onModalClose",
    "onRemove",
    "triggerExternalEmbed"
  ],
  setup(e, { emit: t }) {
    const r = e, n = lt("locale") ?? Dn[r.language], i = [
      {
        value: "_self",
        label: n.imageEmbed.labels.target_self
      },
      {
        value: "_blank",
        label: n.imageEmbed.labels.target_blank
      }
    ], o = {
      src: void 0,
      width: void 0,
      height: void 0,
      alt: void 0,
      "data-image-link": void 0,
      "data-image-link-target": "_self"
    }, a = G(null), s = G(
      r.initialValues ? r.initialValues : Object.create(o)
    ), u = {
      src: {
        required: !0,
        trigger: ["change"],
        message: n.imageEmbed.validations.url,
        validator: (m, v) => Pu().url().required().validate(v)
        // Conscious type casting to avoid complicated conversions
      },
      width: {
        type: "number",
        trigger: ["change"],
        message: n.imageEmbed.validations.width,
        validator: (m, v) => Zf().validate(v)
      },
      height: {
        type: "number",
        trigger: ["change"],
        message: n.imageEmbed.validations.height,
        validator: (m, v) => Zf().validate(v)
      },
      alt: {
        required: !0,
        message: n.imageEmbed.validations.alt,
        trigger: ["change"],
        validator: (m, v) => Pu().trim().required().validate(v)
      },
      "data-image-link": {
        required: !1,
        trigger: ["change"],
        message: n.imageEmbed.validations.imageLink,
        validator: (m, v) => v != null && v.trim() ? Pu().trim().url().optional().validate(v) : !0
      },
      "data-image-link-target": {
        required: !1,
        trigger: ["change"],
        message: n.common.invalidOption,
        validator: (m, v) => Pu().oneOf(["_self", "_blank"]).validate(v)
        // Conscious type casting to avoid complicated conversions
      }
    }, d = () => {
      s.value = Object.create(o);
    }, f = () => {
      var m;
      (m = a.value) == null || m.getForm().validate().then(() => {
        const v = {
          ...s.value,
          width: s.value.width ? Number(s.value.width) : null,
          height: s.value.width ? Number(s.value.height) : null
        };
        t("onSave", r.modalType, v), d();
      }).catch();
    }, h = () => {
      d(), t("onModalClose", r.modalType);
    }, g = () => {
      d(), t("onModalClose", r.modalType), t("onRemove");
    };
    return Gt(
      () => r.externalEmbeddedImage,
      (m) => {
        s.value.src = m;
      }
    ), (m, v) => (ie(), Pe(B(ip), {
      id: "editor_image-picker",
      show: e.showModal,
      to: e.modalContainer
    }, {
      header: we(() => [
        Re(B(_0), {
          id: "warning-confirmation",
          type: "warning",
          title: e.modalType === "EDIT" ? B(n).imageEmbed.editTitle : B(n).imageEmbed.embedTitle,
          onClose: h
        }, null, 8, ["title"])
      ]),
      footer: we(() => [
        Re(B(L0), {
          id: "editor__image-picker-footer",
          "positive-text": r.modalType === "EDIT" ? B(n).common.update : B(n).common.save,
          "negative-text": B(n).common.cancel,
          disabled: !s.value.src,
          onPositiveClick: f,
          onNegativeClick: h
        }, {
          actionLeft: we(() => [
            r.modalType === "EDIT" ? (ie(), Pe(B(on), {
              key: 0,
              id: "editor__image-picker--remove",
              type: "error",
              onClick: g,
              size: "small"
            }, {
              default: we(() => [
                zr(ar(B(n).common.remove), 1)
              ]),
              _: 1
            })) : yt("", !0)
          ]),
          _: 1
        }, 8, ["positive-text", "negative-text", "disabled"])
      ]),
      default: we(() => [
        Re(B(P0), null, {
          default: we(() => [
            Re(B(np), {
              id: "image-picker_form",
              ref_key: "formRef",
              ref: a,
              model: s.value,
              rules: u
            }, {
              default: we(() => [
                Re(B(ca), {
                  label: B(n).imageEmbed.labels.url,
                  path: "src"
                }, {
                  default: we(() => [
                    Re(B(gx), null, {
                      default: we(() => [
                        Re(B(xs), {
                          id: "editor_image-picker-url",
                          modelValue: s.value.src,
                          "onUpdate:modelValue": v[0] || (v[0] = (w) => s.value.src = w),
                          placeholder: B(n).imageEmbed.placeholders.url,
                          clearable: ""
                        }, null, 8, ["modelValue", "placeholder"]),
                        e.enableExternalEmbed ? (ie(), Pe(B(on), {
                          key: 0,
                          id: "editor_image-picker-url-trigger",
                          onClick: v[1] || (v[1] = (w) => t("triggerExternalEmbed", !0))
                        }, {
                          default: we(() => [
                            zr(ar(e.externalEmbedText ?? B(n).common.externalEmbed), 1)
                          ]),
                          _: 1
                        })) : yt("", !0)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["label"]),
                Ye("div", gWe, [
                  Re(B(ca), {
                    label: B(n).imageEmbed.labels.width,
                    path: "width"
                  }, {
                    default: we(() => [
                      Re(B(Vf), {
                        id: "editor_image-picker-width",
                        modelValue: s.value.width,
                        "onUpdate:modelValue": v[2] || (v[2] = (w) => s.value.width = w),
                        size: "large",
                        min: 0,
                        "show-button": !1,
                        style: { width: "250px" },
                        placeholder: "auto"
                      }, {
                        suffix: we(() => [
                          mWe
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  Re(B(ca), {
                    label: B(n).imageEmbed.labels.height,
                    path: "height"
                  }, {
                    default: we(() => [
                      Re(B(Vf), {
                        id: "editor_image-picker-height",
                        modelValue: s.value.height,
                        "onUpdate:modelValue": v[3] || (v[3] = (w) => s.value.height = w),
                        size: "large",
                        min: 0,
                        "show-button": !1,
                        style: { width: "250px" },
                        placeholder: "auto"
                      }, {
                        suffix: we(() => [
                          vWe
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                Re(B(ca), {
                  label: B(n).imageEmbed.labels.alt,
                  path: "alt"
                }, {
                  default: we(() => [
                    Re(B(xs), {
                      id: "editor_image-picker-alt",
                      modelValue: s.value.alt,
                      "onUpdate:modelValue": v[4] || (v[4] = (w) => s.value.alt = w),
                      placeholder: B(n).videoEmbed.alt,
                      clearable: ""
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                Re(B(ca), {
                  label: B(n).imageEmbed.labels.imageLink,
                  path: "data-image-link"
                }, {
                  default: we(() => [
                    Re(B(xs), {
                      id: "editor_image-picker-link",
                      value: s.value["data-image-link"],
                      "onUpdate:value": v[5] || (v[5] = (w) => s.value["data-image-link"] = w),
                      placeholder: B(n).videoEmbed.imageLink,
                      clearable: ""
                    }, null, 8, ["value", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                Re(B(ca), {
                  label: B(n).imageEmbed.labels.target,
                  path: "data-image-link-target"
                }, {
                  default: we(() => [
                    Re(B(ws), {
                      id: "editor_link-embed-target",
                      value: s.value["data-image-link-target"],
                      "onUpdate:value": v[6] || (v[6] = (w) => s.value["data-image-link-target"] = w),
                      disabled: !s.value["data-image-link"],
                      options: i,
                      size: "large"
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show", "to"]));
  }
});
const aL = /* @__PURE__ */ Xl(bWe, [["__scopeId", "data-v-5fe98463"]]), yWe = { key: 0 }, xWe = { class: "flex_container float-menu" }, wWe = ["src"], MWe = ["src"], CWe = ["src"], SWe = ["src"], TWe = ["src"], kWe = /* @__PURE__ */ oe({
  __name: "ImageMenu",
  props: {
    editor: { type: Object },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  setup(e) {
    const t = e, r = lt("locale") ?? Dn[t.language], n = G(!1), { onImageAdd: i, onRemove: o, imageValues: a } = PQ(t.editor), s = (f, h) => {
      d(f === "WRAP" ? { "data-wrap": h, "data-alignment": void 0 } : { "data-alignment": h, "data-wrap": void 0 });
    }, u = (f, h) => {
      n.value = !1, i(f, h);
    }, d = (f) => {
      var h;
      if (!a.value)
        return !1;
      (h = t == null ? void 0 : t.editor) == null || h.chain().focus().setImage({
        ...a.value,
        ...f
      }).run();
    };
    return (f, h) => (ie(), Ve(Lr, null, [
      e.editor ? (ie(), Ve("div", yWe, [
        e.editor ? Jn((ie(), Pe(B(dq), {
          key: 0,
          editor: e.editor,
          "tippy-options": { duration: 100 }
        }, {
          default: we(() => {
            var g, m, v, w, x, y;
            return [
              Ye("div", xWe, [
                Re(Br, {
                  id: B(Er).floatingMenuImageAlignLeft,
                  active: (g = e.editor) == null ? void 0 : g.isActive({ "data-alignment": "left" }),
                  onOnClick: h[0] || (h[0] = (C) => s("ALIGN", "left")),
                  "tooltip-label": B(r).imageEmbed.alignmentTooltip.replace(
                    "{align}",
                    B(r).common.left
                  )
                }, {
                  default: we(() => [
                    Ye("img", {
                      src: B(hq),
                      class: "toolbar-button__icon"
                    }, null, 8, wWe)
                  ]),
                  _: 1
                }, 8, ["id", "active", "tooltip-label"]),
                Re(Br, {
                  id: B(Er).floatingMenuImageAlignCenter,
                  active: (m = e.editor) == null ? void 0 : m.isActive({ "data-alignment": "center" }),
                  onOnClick: h[1] || (h[1] = (C) => s("ALIGN", "center")),
                  "tooltip-label": B(r).imageEmbed.alignmentTooltip.replace(
                    "{align}",
                    B(r).common.center
                  )
                }, {
                  default: we(() => [
                    Ye("img", {
                      src: B(fq),
                      class: "toolbar-button__icon"
                    }, null, 8, MWe)
                  ]),
                  _: 1
                }, 8, ["id", "active", "tooltip-label"]),
                Re(Br, {
                  id: B(Er).floatingMenuImageAlignRight,
                  active: (v = e.editor) == null ? void 0 : v.isActive({ "data-alignment": "right" }),
                  onOnClick: h[2] || (h[2] = (C) => s("ALIGN", "right")),
                  "tooltip-label": B(r).imageEmbed.alignmentTooltip.replace(
                    "{align}",
                    B(r).common.right
                  )
                }, {
                  default: we(() => [
                    Ye("img", {
                      src: B(pq),
                      class: "toolbar-button__icon"
                    }, null, 8, CWe)
                  ]),
                  _: 1
                }, 8, ["id", "active", "tooltip-label"]),
                Re(Br, {
                  id: B(Er).floatingMenuImageJustifyLeft,
                  active: (w = e.editor) == null ? void 0 : w.isActive({ "data-wrap": "left" }),
                  onOnClick: h[3] || (h[3] = (C) => s("WRAP", "left")),
                  "tooltip-label": B(r).imageEmbed.wrapTooltip.replace(
                    "{align}",
                    B(r).common.right
                  )
                }, {
                  default: we(() => [
                    Ye("img", {
                      src: B(gq),
                      class: "toolbar-button__icon"
                    }, null, 8, SWe)
                  ]),
                  _: 1
                }, 8, ["id", "active", "tooltip-label"]),
                Re(Br, {
                  id: B(Er).floatingMenuImageAlignRight,
                  active: (x = e.editor) == null ? void 0 : x.isActive({ "data-wrap": "right" }),
                  onOnClick: h[4] || (h[4] = (C) => s("WRAP", "right")),
                  "tooltip-label": B(r).imageEmbed.wrapTooltip.replace("{align}", B(r).common.left)
                }, {
                  default: we(() => [
                    Ye("img", {
                      src: B(mq),
                      class: "toolbar-button__icon"
                    }, null, 8, TWe)
                  ]),
                  _: 1
                }, 8, ["id", "active", "tooltip-label"]),
                Re(Br, {
                  id: B(Er).floatingMenuImageShowPicker,
                  active: (y = e.editor) == null ? void 0 : y.isActive("Image"),
                  onOnClick: h[5] || (h[5] = (C) => n.value = !0),
                  "tooltip-label": B(r).imageEmbed.editTitle
                }, {
                  default: we(() => [
                    Re(B(jB), { class: "toolbar-button__icon" })
                  ]),
                  _: 1
                }, 8, ["id", "active", "tooltip-label"])
              ])
            ];
          }),
          _: 1
        }, 8, ["editor"])), [
          [Ra, !B(hn.isEmpty)(B(a)) && !n.value]
        ]) : yt("", !0)
      ])) : yt("", !0),
      n.value ? (ie(), Pe(aL, {
        key: 1,
        "show-modal": n.value,
        "initial-values": B(a),
        "modal-type": "EDIT",
        onOnModalClose: h[6] || (h[6] = (g) => n.value = !1),
        onOnSave: u,
        onOnRemove: B(o)
      }, null, 8, ["show-modal", "initial-values", "onOnRemove"])) : yt("", !0)
    ], 64));
  }
});
const Gq = /* @__PURE__ */ Xl(kWe, [["__scopeId", "data-v-20704cc0"]]), DWe = {
  name: "RTEControlEmbedImage",
  inheritAttrs: !1,
  components: { ImagePicker: aL, ImageMenu: Gq, ToolbarButton: Br }
}, y1 = /* @__PURE__ */ oe({
  ...DWe,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    enableFloatingMenu: {
      type: Boolean,
      default: !0
    },
    enableExternalEmbed: {
      type: Boolean,
      default: !0
    },
    externalEmbeddedImage: {
      type: String,
      default: null
    },
    modalContainer: {
      type: String,
      default: null
    },
    externalEmbedText: {
      type: String,
      default: null
    },
    tooltipLabel: {
      type: String
    },
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  emits: ["triggerExternalEmbed"],
  setup(e, { emit: t }) {
    const r = e, n = lt("locale") ?? Dn[r.language], i = G(!1), { onImageAdd: o, onRemove: a, imageValues: s } = PQ(r.editor), u = (f, h) => {
      i.value = !1, o(f, h);
    }, d = (f) => {
      t("triggerExternalEmbed", f);
    };
    return (f, h) => {
      var g, m;
      return ie(), Ve(Lr, null, [
        e.enableFloatingMenu ? (ie(), Pe(Gq, {
          key: 0,
          editor: e.editor
        }, null, 8, ["editor"])) : yt("", !0),
        Re(Br, {
          id: B(Er).toolbarButtonShowLinkEmbed,
          disabled: (g = e.editor) == null ? void 0 : g.isActive("link"),
          active: (m = e.editor) == null ? void 0 : m.isActive("image"),
          onOnClick: h[0] || (h[0] = (v) => i.value = !0),
          "tooltip-label": e.tooltipLabel ?? B(n).imageEmbed.tooltip,
          "tooltip-position": e.tooltipPosition
        }, {
          default: we(() => [
            Re(B(jB), { class: "toolbar-button__icon" })
          ]),
          _: 1
        }, 8, ["id", "disabled", "active", "tooltip-label", "tooltip-position"]),
        i.value ? (ie(), Pe(aL, {
          key: 1,
          "show-modal": i.value,
          "initial-values": B(s),
          "enable-external-embed": e.enableExternalEmbed,
          "external-embedded-image": e.externalEmbeddedImage,
          "modal-container": e.modalContainer,
          "modal-type": B(hn.isEmpty)(B(s)) ? "CREATE" : "EDIT",
          "external-embed-text": e.externalEmbedText,
          onOnSave: u,
          onOnModalClose: h[1] || (h[1] = (v) => i.value = !1),
          onOnRemove: B(a),
          onTriggerExternalEmbed: d
        }, null, 8, ["show-modal", "initial-values", "enable-external-embed", "external-embedded-image", "modal-container", "modal-type", "external-embed-text", "onOnRemove"])) : yt("", !0)
      ], 64);
    };
  }
});
y1.install = (e) => {
  e.component(y1.name, y1);
};
const Zq = "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMTAgNi42NjY2N0wxMy4wMzUyIDUuMTQ5MDdDMTMuNDc4NSA0LjkyNzQ0IDE0IDUuMjQ5NzcgMTQgNS43NDUzNlYxMC4yNTQ2QzE0IDEwLjc1MDIgMTMuNDc4NSAxMS4wNzI2IDEzLjAzNTIgMTAuODUwOUwxMCA5LjMzMzMzTTMuMzMzMzMgMTJIOC42NjY2N0M5LjQwMzA1IDEyIDEwIDExLjQwMyAxMCAxMC42NjY3VjUuMzMzMzNDMTAgNC41OTY5NSA5LjQwMzA1IDQgOC42NjY2NyA0SDMuMzMzMzNDMi41OTY5NSA0IDIgNC41OTY5NSAyIDUuMzMzMzNWMTAuNjY2N0MyIDExLjQwMyAyLjU5Njk1IDEyIDMuMzMzMzMgMTJaIiAgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
var aa = /* @__PURE__ */ ((e) => (e.YOUTUBE = "YOUTUBE", e.NATIVE = "NATIVE", e))(aa || {});
const lL = (e) => {
  if (!(e == null || e === "100%"))
    return e.includes("px") ? Number(e.trim().replace("px", "")) : Number(e);
}, sL = (e) => {
  if (!(e == null || e === "auto"))
    return e.includes("px") ? Number(e.trim().replace("px", "")) : Number(e);
}, uL = (e) => {
  switch (e) {
    case "right":
      return "margin-right: 0; margin-left: auto; display:block;";
    case "center":
      return "margin: auto; display:block;";
    case "left":
    default:
      return "margin-left: 0; margin-right: auto; display:block;";
  }
}, cL = (e) => {
  switch (e) {
    case "right":
      return "float: right; margin-left: 1rem;";
    case "left":
      return "float: left; margin-right: 1rem;";
    default:
      return "";
  }
}, AWe = /^(https?:\/\/)?(www\.|music\.)?(youtube\.com|youtu\.be)(.+)?$/, EWe = /^(https?:\/\/)?(www\.|music\.)?(youtube\.com|youtu\.be)(.+)?$/g, cO = (e) => e.match(AWe), QF = (e) => e ? "https://www.youtube-nocookie.com/embed/" : "https://www.youtube.com/embed/", IWe = (e) => {
  const { url: t, controls: r, nocookie: n, startAt: i } = e;
  if (t.includes("/embed/"))
    return t;
  if (t.includes("youtu.be")) {
    const d = t.split("/").pop();
    return d ? `${QF(n)}${d}` : null;
  }
  const a = /v=([-\w]+)/gm.exec(t);
  if (!a || !a[1])
    return null;
  let s = `${QF(n)}${a[1]}`;
  const u = [];
  return r || u.push("controls=0"), i && u.push(`start=${i}`), u.length && (s += `?${u.join("&")}`), s;
}, NWe = () => {
  const e = document.querySelectorAll("[data-video-embed]");
  if (e.length)
    for (let t = 0; t < e.length; t++) {
      const r = e[t];
      r.addEventListener("play", () => {
        r.pause(), r.currentTime = 0;
      });
    }
}, Kq = /(?:^|\s)((?:\*)((?:[^*]+))(?:\*))$/, Xq = /(?:^|\s)((?:\*)((?:[^*]+))(?:\*))/g, Jq = /(?:^|\s)((?:_)((?:[^_]+))(?:_))$/, eG = /(?:^|\s)((?:_)((?:[^_]+))(?:_))/g, tG = (e) => {
  const t = e.trim();
  return t ? t.endsWith(";") ? t : `${t};` : "";
};
function rG(e, t) {
  return new ra({
    key: new _o("handleClickLink"),
    props: {
      handleClick: (r, n, i) => {
        var s;
        const o = qLe(r.state, e.type.name), a = (s = i.target) == null ? void 0 : s.closest(t);
        return t === "video" && NWe(), a && o, !1;
      }
    }
  });
}
const zWe = Lo.create({
  name: "video",
  addOptions() {
    return {
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {}
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      },
      style: {
        default: null
      },
      class: {
        default: null
      },
      controls: {
        default: !0
      },
      width: {
        default: "100%"
      },
      height: {
        default: "auto"
      },
      autoplay: {
        default: !1,
        renderHTML: (e) => e.autoplay === !1 ? {} : { autoplay: e.autoplay }
      },
      "data-width": {
        default: null
      },
      "data-height": {
        default: null
      },
      "data-video-embed": {
        default: ""
      },
      "data-alignment": {
        default: null,
        rendered: !1
      },
      "data-wrap": {
        default: null,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "video[src]" : 'video[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    var i, o;
    const r = lL((i = e.attrs.width) == null ? void 0 : i.toString()), n = sL((o = e.attrs.height) == null ? void 0 : o.toString());
    return t.style = tG(e.attrs.style), t.style += `width: ${r ? r + "px" : "100%"}; max-width: 100%;`, t.style += `height: ${n ? n + "px" : "auto"};`, t.style += "clear:both;", t.width = r, t.height = n, t.alt = e.attrs.alt, t.title = e.attrs.alt, e.attrs["data-wrap"] && (t.style += cL(e.attrs["data-wrap"]), t["data-wrap"] = e.attrs["data-wrap"]), e.attrs["data-alignment"] && (t.style += uL(e.attrs["data-alignment"]), t.style += "float: none;", t["data-alignment"] = e.attrs["data-alignment"]), [
      "video",
      _n(this.options.HTMLAttributes, t)
    ];
  },
  addCommands() {
    return {
      addVideo: (e) => ({ commands: t }) => t.insertContent({
        type: this.name,
        attrs: e
      })
    };
  },
  addProseMirrorPlugins() {
    const e = [];
    return e.push(
      rG(
        {
          type: this.type
        },
        "video"
      )
    ), e;
  }
}), $We = Lo.create({
  name: "youtube",
  addOptions() {
    return {
      addPasteHandler: !0,
      allowFullscreen: !1,
      controls: !0,
      height: 480,
      HTMLAttributes: {},
      inline: !1,
      nocookie: !1,
      width: 640
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      start: {
        default: 0
      },
      width: {
        default: this.options.width
      },
      height: {
        default: this.options.height
      },
      "data-youtube-video": {
        default: ""
      },
      "data-alignment": {
        default: null,
        rendered: !1
      },
      "data-wrap": {
        default: null,
        rendered: !1
      },
      style: {
        default: null
      },
      class: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "div[data-youtube-video] iframe"
      }
    ];
  },
  addCommands() {
    return {
      setYoutubeVideo: (e) => ({ commands: t }) => cO(e.src) ? t.insertContent({
        type: this.name,
        attrs: e
      }) : !1
    };
  },
  addPasteRules() {
    return this.options.addPasteHandler ? [
      M3e({
        find: EWe,
        type: this.type,
        getAttributes: (e) => ({ src: e.input })
      })
    ] : [];
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    var o, a;
    const r = IWe({
      url: t.src,
      controls: this.options.controls,
      nocookie: this.options.nocookie,
      startAt: t.start || 0
    }), n = lL((o = e.attrs.width) == null ? void 0 : o.toString()), i = sL((a = e.attrs.height) == null ? void 0 : a.toString());
    return t.style = `width: ${n ? n + "px" : "100%"}; max-width: 100%;`, t.style += `height: ${i ? i + "px" : "auto"};`, t.style += "clear:both;", t.width = n, t.height = i, t.src = r, e.attrs["data-wrap"] && (t.style += cL(e.attrs["data-wrap"]), t["data-wrap"] = e.attrs["data-wrap"]), e.attrs["data-alignment"] && (t.style += uL(e.attrs["data-alignment"]), t.style += "float: none; clear:both;", t["data-alignment"] = e.attrs["data-alignment"]), [
      "div",
      _n(this.options.HTMLAttributes, t),
      [
        "iframe",
        _n(
          this.options.HTMLAttributes,
          {
            width: this.options.width,
            height: this.options.height,
            allowfullscreen: this.options.allowFullscreen
          },
          t
        )
      ]
    ];
  }
});
function nG(e) {
  if (!e)
    throw new Error("Editor is not available!");
  const t = G(void 0), r = (a, s) => {
    if (!s.src)
      return !1;
    s.linkSource === aa.YOUTUBE ? e == null || e.commands.setYoutubeVideo({
      src: s.src,
      width: Math.max(320, (s == null ? void 0 : s.width) || 640),
      height: Math.max(180, (s == null ? void 0 : s.height) || 480)
    }) : e == null || e.chain().focus().addVideo(s).run(), a === "CREATE" && (e == null || e.chain().focus().createParagraphNear().run());
  }, n = (a) => {
    var s;
    if (!t.value)
      return !1;
    ((s = t.value) == null ? void 0 : s.linkSource) === aa.YOUTUBE || e == null || e.chain().focus().addVideo({
      ...t.value,
      ...a
    }).run();
  }, i = (a, s) => {
    n(a === "WRAP" ? { "data-wrap": s, "data-alignment": void 0 } : { "data-alignment": s, "data-wrap": void 0 });
  }, o = () => {
    e == null || e.commands.deleteSelection();
  };
  return e == null || e.on("transaction", ({ editor: a }) => {
    const s = a.getAttributes("video"), u = a.getAttributes("youtube"), d = a.getAttributes(
      "paragraph"
    );
    t.value = void 0, !hn.isEmpty(u) && hn.isEmpty(d) && (t.value = {
      ...u,
      linkSource: aa.YOUTUBE
    }), !hn.isEmpty(s) && hn.isEmpty(d) && (t.value = {
      ...s,
      linkSource: aa.NATIVE
    });
  }), {
    videoValues: t,
    onVideoAdd: r,
    handleVideoPosition: i,
    onRemove: o
  };
}
const OWe = { key: 0 }, _We = { class: "flex_container float-menu" }, LWe = ["src"], PWe = ["src"], RWe = ["src"], jWe = ["src"], FWe = ["src"], BWe = ["src"], UWe = /* @__PURE__ */ oe({
  __name: "VideoMenu",
  props: {
    editor: { type: Object },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  emits: ["showVideoPicker"],
  setup(e, { emit: t }) {
    const r = e, n = lt("locale") ?? Dn[r.language], i = G(!1), { videoValues: o, handleVideoPosition: a } = nG(r.editor);
    return (s, u) => e.editor ? (ie(), Ve("div", OWe, [
      e.editor ? Jn((ie(), Pe(B(dq), {
        key: 0,
        editor: e.editor,
        "tippy-options": { duration: 100 }
      }, {
        default: we(() => {
          var d, f, h, g, m;
          return [
            Ye("div", _We, [
              Re(Br, {
                id: B(Er).floatingMenuVideoAlignLeft,
                active: (d = e.editor) == null ? void 0 : d.isActive({ "data-alignment": "left" }),
                onOnClick: u[0] || (u[0] = (v) => B(a)("ALIGN", "left")),
                "tooltip-label": B(n).videoEmbed.alignmentTooltip.replace(
                  "{align}",
                  B(n).common.left
                )
              }, {
                default: we(() => [
                  Ye("img", {
                    src: B(hq),
                    class: "toolbar-button__icon"
                  }, null, 8, LWe)
                ]),
                _: 1
              }, 8, ["id", "active", "tooltip-label"]),
              Re(Br, {
                id: B(Er).floatingMenuVideoAlignCenter,
                active: (f = e.editor) == null ? void 0 : f.isActive({ "data-alignment": "center" }),
                onOnClick: u[1] || (u[1] = (v) => B(a)("ALIGN", "center")),
                "tooltip-label": B(n).videoEmbed.alignmentTooltip.replace(
                  "{align}",
                  B(n).common.center
                )
              }, {
                default: we(() => [
                  Ye("img", {
                    src: B(fq),
                    class: "toolbar-button__icon"
                  }, null, 8, PWe)
                ]),
                _: 1
              }, 8, ["id", "active", "tooltip-label"]),
              Re(Br, {
                id: B(Er).floatingMenuVideoAlignRight,
                active: (h = e.editor) == null ? void 0 : h.isActive({ "data-alignment": "right" }),
                onOnClick: u[2] || (u[2] = (v) => B(a)("ALIGN", "right")),
                "tooltip-label": B(n).videoEmbed.alignmentTooltip.replace(
                  "{align}",
                  B(n).common.right
                )
              }, {
                default: we(() => [
                  Ye("img", {
                    src: B(pq),
                    class: "toolbar-button__icon"
                  }, null, 8, RWe)
                ]),
                _: 1
              }, 8, ["id", "active", "tooltip-label"]),
              Re(Br, {
                id: B(Er).floatingMenuVideoJustifyLeft,
                active: (g = e.editor) == null ? void 0 : g.isActive({ "data-wrap": "left" }),
                onOnClick: u[3] || (u[3] = (v) => B(a)("WRAP", "left")),
                "tooltip-label": B(n).videoEmbed.wrapTooltip.replace(
                  "{align}",
                  B(n).common.right
                )
              }, {
                default: we(() => [
                  Ye("img", {
                    src: B(gq),
                    class: "toolbar-button__icon"
                  }, null, 8, jWe)
                ]),
                _: 1
              }, 8, ["id", "active", "tooltip-label"]),
              Re(Br, {
                id: B(Er).floatingMenuVideoAlignRight,
                active: (m = e.editor) == null ? void 0 : m.isActive({ "data-wrap": "right" }),
                onOnClick: u[4] || (u[4] = (v) => B(a)("WRAP", "right")),
                "tooltip-label": B(n).videoEmbed.wrapTooltip.replace("{align}", B(n).common.left)
              }, {
                default: we(() => [
                  Ye("img", {
                    src: B(mq),
                    class: "toolbar-button__icon"
                  }, null, 8, FWe)
                ]),
                _: 1
              }, 8, ["id", "active", "tooltip-label"]),
              Re(Br, {
                id: B(Er).floatingMenuVideoShowPicker,
                onOnClick: u[5] || (u[5] = (v) => t("showVideoPicker")),
                "tooltip-label": B(n).videoEmbed.editTitle
              }, {
                default: we(() => [
                  Ye("img", {
                    src: B(Zq),
                    class: "toolbar-button__icon"
                  }, null, 8, BWe)
                ]),
                _: 1
              }, 8, ["id", "tooltip-label"])
            ])
          ];
        }),
        _: 1
      }, 8, ["editor"])), [
        [Ra, !B(hn.isEmpty)(B(o)) && !i.value]
      ]) : yt("", !0)
    ])) : yt("", !0);
  }
});
const iG = /* @__PURE__ */ Xl(UWe, [["__scopeId", "data-v-067f8542"]]), HWe = { class: "ghl-editor_video--source" }, WWe = { class: "ghl-editor_video--dimensions" }, VWe = /* @__PURE__ */ oe({
  __name: "VideoPicker",
  props: {
    modalType: String,
    showModal: Boolean,
    initialValues: Object,
    fileLimitInBytes: Number,
    modalContainer: {
      type: String,
      default: null
    },
    externalEmbedText: {
      type: String
    },
    externalEmbeddedVideo: {
      type: String,
      default: null
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  emits: [
    "onSave",
    "onModalClose",
    "onRemove",
    "triggerExternalEmbed"
  ],
  setup(e, { emit: t }) {
    const r = e;
    Qq(Zf, "handleEmpty", function() {
      return this.transform((y) => isNaN(y) ? void 0 : y);
    });
    const n = lt("locale") ?? Dn[r.language], i = G(!1), o = G(void 0), a = [
      {
        value: aa.NATIVE,
        label: n.videoEmbed.labels.source_native
      },
      {
        value: aa.YOUTUBE,
        label: n.videoEmbed.labels.source_youtube
      }
    ], s = {
      linkSource: aa.NATIVE,
      src: "",
      width: void 0,
      height: void 0
    }, u = G(null), d = G(
      r.initialValues ? r.initialValues : Object.create(s)
    ), f = {
      linkSource: {
        required: !0,
        validator: (y, C) => Pu().oneOf([aa.NATIVE, aa.YOUTUBE]).validate(C)
      },
      src: {
        required: !0,
        trigger: ["change", "blur"],
        validator: (y, C) => h(C)
        // Conscious type casting to avoid complicated conversions
      },
      width: {
        type: "number",
        validator: (y, C) => Zf().handleEmpty().validate(C)
      },
      height: {
        type: "number",
        validator: (y, C) => Zf().handleEmpty().validate(C)
      }
    }, h = (y) => {
      if (Pu().url().validate(y)) {
        if (d.value.linkSource === aa.YOUTUBE && cO(y))
          return !0;
        if (d.value.linkSource === aa.NATIVE && !cO(y))
          return g(y);
      }
      return "Invalid URL provided";
    }, g = async (y) => new Promise((C, S) => {
      y && (o.value = void 0, Pu().url().validate(y).then(() => {
        if (d.value.linkSource === aa.NATIVE)
          try {
            wK(y).then(({ resourceDetails: T }) => {
              o.value = (T == null ? void 0 : T.size) ?? void 0, T.size > r.fileLimitInBytes ? S(
                `Allowed size is Approx. ${NL(
                  r.fileLimitInBytes
                )}MB and video size is ${NL(
                  o.value
                )}MB`
              ) : C(T == null ? void 0 : T.size);
            }).catch(() => {
              S("Invalid File type");
            });
          } catch {
            S("Invalid File type");
          }
      }).catch(() => {
        S("t('postEditor.videoModal.videoValidationUrlError')");
      }));
    }), m = () => {
      var y;
      (y = u.value) == null || y.getForm().validate().then(() => {
        const C = {
          ...d.value,
          width: d.value.width ? Number(d.value.width) : null,
          height: d.value.width ? Number(d.value.height) : null
        };
        t("onSave", r.modalType, C), w();
      }).catch();
    }, v = () => {
      d.value = Object.create(s);
    }, w = () => {
      v(), t("onModalClose", r.modalType);
    }, x = () => {
      v(), t("onModalClose", r.modalType), t("onRemove");
    };
    return fi(() => {
      r.initialValues && (d.value.width = r.initialValues.width, d.value.height = r.initialValues.height);
    }), Gt(
      () => r.externalEmbeddedVideo,
      (y) => {
        d.value.src = y;
      }
    ), (y, C) => (ie(), Pe(B(ip), {
      id: "blog-editor_video-picker",
      show: e.showModal,
      to: e.modalContainer
    }, {
      header: we(() => [
        Re(B(_0), {
          id: "warning-confirmation",
          type: "warning",
          title: e.modalType === "EDIT" ? B(n).videoEmbed.editTitle : B(n).videoEmbed.tooltip,
          onClose: w
        }, null, 8, ["title"])
      ]),
      footer: we(() => [
        Re(B(L0), {
          id: "editor__video-picker-footer",
          "positive-text": r.modalType === "EDIT" ? B(n).videoEmbed.updateVideo : B(n).videoEmbed.tooltip,
          "negative-text": B(n).common.cancel,
          loading: i.value,
          disabled: !d.value.src,
          onPositiveClick: m,
          onNegativeClick: w
        }, {
          actionLeft: we(() => [
            r.modalType === "EDIT" ? (ie(), Pe(B(on), {
              key: 0,
              id: "editor__video-picker--remove",
              type: "error",
              onClick: x
            }, {
              default: we(() => [
                zr(ar(B(n).common.remove), 1)
              ]),
              _: 1
            })) : yt("", !0)
          ]),
          _: 1
        }, 8, ["positive-text", "negative-text", "loading", "disabled"])
      ]),
      default: we(() => [
        Re(B(P0), null, {
          default: we(() => [
            Re(B(np), {
              id: "video-picker_form",
              ref_key: "formRef",
              ref: u,
              model: d.value,
              rules: f
            }, {
              default: we(() => [
                Re(B(ca), {
                  label: B(n).videoEmbed.labels.linkSource,
                  path: "linkSource"
                }, {
                  default: we(() => [
                    Re(B(d$), {
                      value: d.value.linkSource,
                      "onUpdate:value": C[0] || (C[0] = (S) => d.value.linkSource = S),
                      name: "linkSource"
                    }, {
                      default: we(() => [
                        Ye("div", HWe, [
                          (ie(), Ve(Lr, null, Fl(a, (S) => Ye("div", {
                            key: S.value
                          }, [
                            Re(B(t1), {
                              id: S.value,
                              value: S.value
                            }, {
                              default: we(() => [
                                zr(ar(S.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["id", "value"])
                          ])), 64))
                        ])
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                Re(B(ca), {
                  label: B(n).videoEmbed.labels.src,
                  path: "src"
                }, {
                  default: we(() => [
                    Re(B(gx), null, {
                      default: we(() => [
                        Re(B(xs), {
                          id: "editor_video-picker-url",
                          modelValue: d.value.src,
                          "onUpdate:modelValue": C[1] || (C[1] = (S) => d.value.src = S),
                          placeholder: ""
                        }, null, 8, ["modelValue"]),
                        d.value.linkSource === B(aa).NATIVE ? (ie(), Pe(B(on), {
                          key: 0,
                          id: "editor_video-picker-url-trigger",
                          onClick: C[2] || (C[2] = (S) => t("triggerExternalEmbed", !0)),
                          type: "primary"
                        }, {
                          default: we(() => [
                            zr(ar(e.externalEmbedText ?? B(n).common.externalEmbed), 1)
                          ]),
                          _: 1
                        })) : yt("", !0)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["label"]),
                Ye("div", WWe, [
                  Ye("div", null, [
                    Re(B(ca), {
                      label: B(n).videoEmbed.labels.width,
                      path: "width"
                    }, {
                      default: we(() => [
                        Re(B(Vf), {
                          id: "editor_video-picker-width",
                          modelValue: d.value.width,
                          "onUpdate:modelValue": C[3] || (C[3] = (S) => d.value.width = S),
                          size: "large",
                          min: 0,
                          placeholder: d.value.width ? void 0 : B(n).videoEmbed.placeholders.width,
                          "show-button": !1
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  Ye("div", null, [
                    Re(B(ca), {
                      label: B(n).videoEmbed.labels.height,
                      path: "height"
                    }, {
                      default: we(() => [
                        Re(B(Vf), {
                          id: "editor_video-picker-height",
                          modelValue: d.value.height,
                          "onUpdate:modelValue": C[4] || (C[4] = (S) => d.value.height = S),
                          size: "large",
                          min: 0,
                          placeholder: d.value.height ? void 0 : B(n).videoEmbed.placeholders.height,
                          "show-button": !1
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show", "to"]));
  }
});
const oG = /* @__PURE__ */ Xl(VWe, [["__scopeId", "data-v-33d88577"]]), YWe = ["src"], QWe = {
  name: "RTEControlEmbedVideo",
  inheritAttrs: !1,
  components: { VideoPicker: oG, ToolbarButton: Br, VideoMenu: iG }
}, x1 = /* @__PURE__ */ oe({
  ...QWe,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    enableFloatingMenu: {
      type: Boolean,
      default: !0
    },
    enableExternalEmbed: {
      type: Boolean,
      default: !0
    },
    externalEmbeddedVideo: {
      type: String,
      default: null
    },
    modalContainer: {
      type: String,
      default: null
    },
    externalEmbedText: {
      type: String,
      default: null
    },
    fileLimitInBytes: Number,
    tooltipLabel: {
      type: String
    },
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  emits: ["triggerExternalEmbed"],
  setup(e, { emit: t }) {
    const r = e, n = lt("locale") ?? Dn[r.language], i = G(!1), { onVideoAdd: o, onRemove: a, videoValues: s } = nG(r.editor), u = (f, h) => {
      i.value = !1, o(f, h);
    }, d = (f) => {
      t("triggerExternalEmbed", f);
    };
    return (f, h) => {
      var g, m;
      return ie(), Ve(Lr, null, [
        !i.value && e.enableFloatingMenu ? (ie(), Pe(iG, {
          key: 0,
          editor: e.editor,
          onShowVideoPicker: h[0] || (h[0] = (v) => i.value = !0)
        }, null, 8, ["editor"])) : yt("", !0),
        Re(Br, {
          id: B(Er).toolbarButtonShowLinkEmbed,
          disabled: (g = e.editor) == null ? void 0 : g.isActive("link"),
          active: (m = e.editor) == null ? void 0 : m.isActive("video"),
          "tooltip-label": e.tooltipLabel ?? B(n).videoEmbed.tooltip,
          "tooltip-position": e.tooltipPosition,
          onOnClick: h[1] || (h[1] = (v) => i.value = !0)
        }, {
          default: we(() => [
            Ye("img", {
              src: B(Zq),
              class: "toolbar-button__icon"
            }, null, 8, YWe)
          ]),
          _: 1
        }, 8, ["id", "disabled", "active", "tooltip-label", "tooltip-position"]),
        i.value ? (ie(), Pe(oG, {
          key: 1,
          "show-modal": i.value,
          "initial-values": B(s),
          "file-limit-in-bytes": e.fileLimitInBytes,
          "enable-external-embed": e.enableExternalEmbed,
          "external-embedded-Video": e.externalEmbeddedVideo,
          "external-embed-text": e.externalEmbedText,
          "modal-container": e.modalContainer,
          "modal-type": B(hn.isEmpty)(B(s)) ? "CREATE" : "EDIT",
          onOnSave: u,
          onOnModalClose: h[2] || (h[2] = (v) => i.value = !1),
          onOnRemove: B(a),
          onTriggerExternalEmbed: d
        }, null, 8, ["show-modal", "initial-values", "file-limit-in-bytes", "enable-external-embed", "external-embedded-Video", "external-embed-text", "modal-container", "modal-type", "onOnRemove"])) : yt("", !0)
      ], 64);
    };
  }
});
x1.install = (e) => {
  e.component(x1.name, x1);
};
const w1 = [
  "sans-serif",
  "Comic Sans",
  "serif",
  "monospace",
  "cursive",
  "Segoe UI",
  "Roboto",
  "Helvetica Neue",
  "Arial",
  "Noto Sans"
], aG = [10, 12, 14, 16, 18, 24, 36, 48], qWe = w1[0], GWe = aG[3], ZWe = {
  name: "RTEControlFontFamily",
  inheritAttrs: !1
}, KWe = /* @__PURE__ */ oe({
  ...ZWe,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    fallbackFont: { type: String, default: qWe },
    fontFamilyOptions: {
      type: Array
    },
    className: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  setup(e) {
    const t = e, r = lt("locale") ?? Dn[t.language], n = G(t.fallbackFont), i = G(!0), o = t.fontFamilyOptions ? t.fontFamilyOptions : hn.unionBy(
      [n.value, ...w1].filter(String).map((d) => ({
        label: d,
        value: d,
        style: {
          fontFamily: d
        }
      })),
      "label"
    ), a = (d) => {
      var f;
      return (f = t == null ? void 0 : t.editor.chain().focus()) == null ? void 0 : f.setFontFamily(d).run();
    }, s = ({
      editor: d
    }) => {
      var g;
      const f = d.getAttributes(
        "textStyle"
      );
      n.value = t.fallbackFont;
      const h = ((g = f == null ? void 0 : f.fontFamily) == null ? void 0 : g.trim()) ?? "";
      if (h)
        if (t.fontFamilyOptions)
          n.value = h;
        else if (h != null && h.includes(",")) {
          const v = h.split(",").map((w) => w.trim()).find(
            (w) => w1.includes(w)
          );
          v && (n.value = v);
        } else
          w1.includes(h) && (n.value = h);
    }, u = () => {
      t.editor && (i.value = !ma(t.editor, "fontFamily"));
    };
    return br(() => {
      var d;
      u(), (d = t == null ? void 0 : t.editor) == null || d.on("transaction", s);
    }), Nc(() => {
      var d;
      (d = t == null ? void 0 : t.editor) == null || d.off("transaction", s);
    }), fi(() => {
      var d;
      u(), (d = t == null ? void 0 : t.editor) == null || d.on("transaction", s);
    }), Gr(() => {
      var d;
      (d = t == null ? void 0 : t.editor) == null || d.off("transaction", s);
    }), (d, f) => (ie(), Pe(B(ws), {
      id: B(Er).toolbarSelectFontFamily,
      placeholder: B(r).placeholders.fontFamily,
      value: n.value,
      options: B(o),
      disabled: i.value,
      size: "small",
      class: Jr(["font-family", e.className]),
      "onUpdate:value": a
    }, null, 8, ["id", "placeholder", "value", "options", "disabled", "class"]));
  }
});
const M1 = /* @__PURE__ */ Xl(KWe, [["__scopeId", "data-v-d143137c"]]);
M1.install = (e) => {
  e.component(M1.name, M1);
};
const XWe = {
  name: "RTEControlFontSize",
  inheritAttrs: !1
}, JWe = /* @__PURE__ */ oe({
  ...XWe,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    fontSizes: Array,
    fallbackFontSize: {
      type: Number
    },
    fallbackTextBlockFontSize: Object,
    className: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  setup(e) {
    const t = e, r = lt("locale") ?? Dn[t.language], n = G(!0), i = j(() => {
      let f = t.fallbackFontSize ?? GWe;
      if (t.fallbackTextBlockFontSize && t.editor) {
        const h = t.editor.getAttributes(
          "heading"
        );
        t.fallbackTextBlockFontSize[h.level] && (f = t.fallbackTextBlockFontSize[h.level]);
      }
      return f;
    }), o = G(Number(i.value)), a = j(
      () => hn.unionBy(
        [o.value, ...t.fontSizes ?? aG].filter(Number).sort((f, h) => f - h).map((f) => {
          const h = Number(f).toString();
          return {
            label: `${h}px`,
            value: h
          };
        }),
        "value"
      )
    ), s = (f) => {
      t != null && t.editor && t.editor.chain().focus().setFontSize(`${f}px`).run();
    }, u = ({
      editor: f
    }) => {
      var m, v;
      const h = f.getAttributes(
        "textStyle"
      );
      o.value = i.value;
      const g = (m = h == null ? void 0 : h.fontSize) != null && m.trim() ? (v = h == null ? void 0 : h.fontSize) == null ? void 0 : v.replace("px", "") : i.value;
      g && (o.value = Number(g));
    }, d = () => {
      t.editor && (n.value = !ma(t.editor, "fontSize"));
    };
    return br(() => {
      var f;
      d(), (f = t == null ? void 0 : t.editor) == null || f.on("transaction", u);
    }), Nc(() => {
      var f;
      (f = t == null ? void 0 : t.editor) == null || f.off("transaction", u);
    }), fi(() => {
      var f;
      d(), (f = t == null ? void 0 : t.editor) == null || f.on("transaction", u);
    }), Gr(() => {
      var f;
      (f = t == null ? void 0 : t.editor) == null || f.off("transaction", u);
    }), (f, h) => (ie(), Pe(B(ws), {
      id: B(Er).toolbarSelectFontSize,
      placeholder: B(r).placeholders.fontSize,
      value: o.value.toString(),
      options: B(a),
      size: "small",
      class: Jr(["font-size", e.className]),
      disabled: n.value,
      "onUpdate:value": s
    }, null, 8, ["id", "placeholder", "value", "options", "class", "disabled"]));
  }
});
const C1 = /* @__PURE__ */ Xl(JWe, [["__scopeId", "data-v-b5e376fd"]]);
C1.install = (e) => {
  e.component(C1.name, C1);
};
const eVe = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxNCAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjgzNDgyIDEuMTM0OTNDMTAuMDE0NiAwLjk1NTAyMiAxMC4zMDYzIDAuOTU1MDIyIDEwLjQ4NjEgMS4xMzQ5M0wxMi41MzMxIDMuMTgxOTVMMTIuNTc0NCAzLjIyOTEzQzEyLjcxMTcgMy40MDk2NSAxMi42OTggMy42Njg0MiAxMi41MzMxIDMuODMzMjNMMTAuNDg2MSA1Ljg4MDI1TDEwLjQzODkgNS45MjE1NEMxMC4yNTg0IDYuMDU4ODcgOS45OTk2MyA2LjA0NTE4IDkuODM0ODIgNS44ODAyNUw5Ljc5MzU0IDUuODMzMDhDOS42NTYyMSA1LjY1MjU2IDkuNjY5OSA1LjM5Mzc5IDkuODM0ODIgNS4yMjg5N0wxMS4wOTQ5IDMuOTY3ODhMNC43ODcwMiAzLjk2ODE4QzMuMjA0MjkgMy45NjgxOCAxLjkyMTIgNS4yNTEyOCAxLjkyMTIgNi44MzQwMUMxLjkyMTIgOC4zNzkwOCAzLjE0MzkxIDkuNjM4NjggNC42NzQ0NCA5LjY5NzU0TDQuNzg2OTggOS42OTk3M0g2LjgzNEM3LjA4ODM4IDkuNjk5NzMgNy4yOTQ1OCA5LjkwNTk0IDcuMjk0NTggMTAuMTYwM0M3LjI5NDU4IDEwLjM5NTEgNy4xMTg4NyAxMC41ODg5IDYuODkxNzggMTAuNjE3M0w2LjgzNDAxIDEwLjYyMDlINC43ODY5OUMyLjY5NTUgMTAuNjIwOSAxIDguOTI1MzkgMSA2LjgzMzlDMSA0Ljc4NDI3IDIuNjI4MzMgMy4xMTQ5NyA0LjY2MTg2IDMuMDQ4OTZMNC43ODY5IDMuMDQ2OTZMMTEuMDkzOCAzLjA0NjM2TDkuODM0NTcgMS43ODYxNkw5Ljc5MzI5IDEuNzM4OThDOS42NTU5NiAxLjU1ODQ3IDkuNjY5NjUgMS4yOTk2OSA5LjgzNDU3IDEuMTM0ODhMOS44MzQ4MiAxLjEzNDkzWiIgZmlsbD0iIzExMTgyNyIgc3Ryb2tlPSIjMTExODI3Ii8+Cjwvc3ZnPgo=", tVe = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxNCAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjE2NTE4IDEuMTM0OTNDMy45ODUzNyAwLjk1NTAyMiAzLjY5MzcgMC45NTUwMjIgMy41MTM5IDEuMTM0OTNMMS40NjY4OCAzLjE4MTk1TDEuNDI1NiAzLjIyOTEzQzEuMjg4MjYgMy40MDk2NSAxLjMwMTk2IDMuNjY4NDIgMS40NjY4OCAzLjgzMzIzTDMuNTEzOSA1Ljg4MDI1TDMuNTYxMDggNS45MjE1NEMzLjc0MTU5IDYuMDU4ODcgNC4wMDAzNyA2LjA0NTE4IDQuMTY1MTggNS44ODAyNUw0LjIwNjQ2IDUuODMzMDhDNC4zNDM3OSA1LjY1MjU2IDQuMzMwMSA1LjM5Mzc5IDQuMTY1MTggNS4yMjg5N0wyLjkwNTA4IDMuOTY3ODhMOS4yMTI5OCAzLjk2ODE4QzEwLjc5NTcgMy45NjgxOCAxMi4wNzg4IDUuMjUxMjggMTIuMDc4OCA2LjgzNDAxQzEyLjA3ODggOC4zNzkwOCAxMC44NTYxIDkuNjM4NjggOS4zMjU1NiA5LjY5NzU0TDkuMjEzMDIgOS42OTk3M0g3LjE2NkM2LjkxMTYyIDkuNjk5NzMgNi43MDU0MiA5LjkwNTk0IDYuNzA1NDIgMTAuMTYwM0M2LjcwNTQyIDEwLjM5NTEgNi44ODExMyAxMC41ODg5IDcuMTA4MjIgMTAuNjE3M0w3LjE2NTk5IDEwLjYyMDlIOS4yMTMwMUMxMS4zMDQ1IDEwLjYyMDkgMTMgOC45MjUzOSAxMyA2LjgzMzlDMTMgNC43ODQyNyAxMS4zNzE3IDMuMTE0OTcgOS4zMzgxNCAzLjA0ODk2TDkuMjEzMSAzLjA0Njk2TDIuOTA2MjMgMy4wNDYzNkw0LjE2NTQzIDEuNzg2MTZMNC4yMDY3MSAxLjczODk4QzQuMzQ0MDQgMS41NTg0NyA0LjMzMDM1IDEuMjk5NjkgNC4xNjU0MyAxLjEzNDg4TDQuMTY1MTggMS4xMzQ5M1oiIGZpbGw9IiMxMTE4MjciIHN0cm9rZT0iIzExMTgyNyIvPgo8L3N2Zz4K", rVe = ["src"], nVe = {
  name: "RTEControlHistory",
  inheritAttrs: !1,
  components: { ToolbarButton: Br }
}, S1 = /* @__PURE__ */ oe({
  ...nVe,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    type: {
      string: String,
      required: !0,
      default: "undo"
    },
    tooltipLabel: String,
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  setup(e) {
    const t = e, r = pn(), n = lt("locale") ?? Dn[t.language], i = (u) => {
      var d, f;
      u === "undo" ? (d = t == null ? void 0 : t.editor) == null || d.commands.undo() : u === "redo" && ((f = t == null ? void 0 : t.editor) == null || f.commands.redo());
    }, o = G(!0), a = () => {
      t.editor && (o.value = !ma(t.editor, "history"));
    }, s = j(() => t.type === "redo" ? !(t != null && t.editor.can().redo()) : !(t != null && t.editor.can().undo()));
    return br(() => {
      a();
    }), fi(() => {
      a();
    }), (u, d) => (ie(), Pe(Br, {
      id: e.type === "undo" ? B(Er).toolbarButtonUndo : B(Er).toolbarButtonRedo,
      disabled: o.value || B(s),
      onOnClick: d[0] || (d[0] = (f) => i(e.type)),
      "tooltip-label": e.tooltipLabel ?? e.type === "undo" ? B(n).history.undo : B(n).history.redo,
      "tooltip-position": e.tooltipPosition
    }, {
      default: we(() => [
        B(r).icon ? nt(u.$slots, "icon", { key: 0 }) : (ie(), Ve("img", {
          key: 1,
          src: e.type === "undo" ? B(tVe) : B(eVe),
          class: "toolbar-button__icon"
        }, null, 8, rVe))
      ]),
      _: 3
    }, 8, ["id", "disabled", "tooltip-label", "tooltip-position"]));
  }
});
S1.install = (e) => {
  e.component(S1.name, S1);
};
const iVe = { key: 0 }, oVe = {
  name: "RTEControlLineHeight",
  inheritAttrs: !1
}, aVe = /* @__PURE__ */ oe({
  ...oVe,
  props: {
    editor: { type: Object },
    fallbackLineHeight: {
      type: String,
      default: "1.5"
    },
    lineHeightOptions: {
      type: Array
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  setup(e) {
    const t = e, r = lt("locale") ?? Dn[t.language], n = G(!0), i = G(t.fallbackLineHeight), o = ["1", "1.15", "1.5", "2"], a = j(() => t.lineHeightOptions || o.map((h) => ({ label: h, value: h }))), s = (f) => {
      var h, g;
      f ? (h = t == null ? void 0 : t.editor) == null || h.chain().focus().setLineHeight(f).run() : (g = t == null ? void 0 : t.editor) == null || g.chain().focus().setLineHeight("inherit").run();
    }, u = ({
      editor: f
    }) => {
      const h = f.getAttributes(
        "paragraph"
      ), g = f.getAttributes(
        "heading"
      ), m = f.getAttributes(
        "blockquote"
      ), v = f.getAttributes(
        "listItem"
      );
      if (i.value = void 0, hn.has(h, "lineHeight") || hn.has(g, "lineHeight") || hn.has(m, "lineHeight") || hn.has(v, "lineHeight")) {
        const w = (hn.get(h, "lineHeight") ?? hn.get(g, "lineHeight") ?? hn.get(m, "lineHeight") ?? hn.get(v, "lineHeight") ?? "inherit").toString();
        w === "inherit" ? (i.value = "Line height", t.fallbackLineHeight && (i.value = t.fallbackLineHeight)) : i.value = w;
      }
    }, d = () => {
      t.editor && (n.value = !ma(t.editor, "lineHeight"));
    };
    return br(() => {
      var f;
      d(), (f = t == null ? void 0 : t.editor) == null || f.on("transaction", u);
    }), Nc(() => {
      var f;
      (f = t == null ? void 0 : t.editor) == null || f.off("transaction", u);
    }), fi(() => {
      var f;
      d(), (f = t == null ? void 0 : t.editor) == null || f.on("transaction", u);
    }), Gr(() => {
      var f;
      (f = t == null ? void 0 : t.editor) == null || f.off("transaction", u);
    }), (f, h) => e.editor ? (ie(), Ve("div", iVe, [
      Re(B(ys), null, {
        trigger: we(() => [
          Ye("div", null, [
            Re(B(ws), {
              id: B(Er).toolbarSelectLineHeight,
              class: "editor__line-height",
              placeholder: "Line height",
              value: i.value,
              options: B(a),
              disabled: n.value,
              "onUpdate:value": s,
              size: "small"
            }, null, 8, ["id", "value", "options", "disabled"])
          ])
        ]),
        default: we(() => [
          Ye("span", null, ar(B(r).lineHeight.tooltip), 1)
        ]),
        _: 1
      })
    ])) : yt("", !0);
  }
});
const T1 = /* @__PURE__ */ Xl(aVe, [["__scopeId", "data-v-f06e736a"]]);
T1.install = (e) => {
  e.component(T1.name, T1);
};
const lVe = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNzEwNDUgMTMuMzE1MkgxMy42MjYyQzEzLjgzODYgMTMuMzE1MiAxNC4wMTIzIDEzLjE0MTUgMTQuMDEyMyAxMi45MjkxVjEyLjI1MzNDMTQuMDEyMyAxMi4wNDA5IDEzLjgzODUgMTEuODY3MiAxMy42MjYyIDExLjg2NzJINS43MTA0NUM1LjQ5ODA3IDExLjg2NzIgNS4zMjQzNSAxMi4wNDA5IDUuMzI0MzUgMTIuMjUzM0w1LjMyNDIyIDEyLjkyOTFDNS4zMjQyMiAxMy4xNDE1IDUuNDk4MDggMTMuMzE1MiA1LjcxMDQ2IDEzLjMxNTJINS43MTA0NVoiIGZpbGw9IiMwNDBFMTMiLz4KPHBhdGggZD0iTTUuNzE0MjIgOC4yNDQ4N0gxMy42Mjk5QzEzLjg0MjMgOC4yNDQ4NyAxNC4wMTYgOC4wNzExNCAxNC4wMTYgNy44NTg3N1Y3LjE4Mjk3QzE0LjAxNiA2Ljk3MDU5IDEzLjg0MjMgNi43OTY4OCAxMy42Mjk5IDYuNzk2ODhINS43MTQyMkM1LjUwMTg0IDYuNzk2ODggNS4zMjgxMyA2Ljk3MDYgNS4zMjgxMyA3LjE4Mjk3VjcuODU4NzdDNS4zMjc5OSA4LjA3MTE1IDUuNTAxODUgOC4yNDQ4NyA1LjcxNDIyIDguMjQ0ODdWOC4yNDQ4N1oiIGZpbGw9IiMwNDBFMTMiLz4KPHBhdGggZD0iTTUuNzEwNDUgMy4xODIzN0gxMy42MjYyQzEzLjgzODYgMy4xODIzNyAxNC4wMTIzIDMuMDA4NjQgMTQuMDEyMyAyLjc5NjI3TDE0LjAxMjEgMi4xMjA0N0MxNC4wMTIxIDEuOTA4MDkgMTMuODM4NCAxLjczNDM4IDEzLjYyNiAxLjczNDM4SDUuNzEwMzJDNS40OTc5NCAxLjczNDM4IDUuMzI0MjIgMS45MDgxIDUuMzI0MjIgMi4xMjA0N1YyLjc5NjI3QzUuMzI0MjIgMy4wMDg2NSA1LjQ5ODA4IDMuMTgyMzcgNS43MTA0NiAzLjE4MjM3SDUuNzEwNDVaIiBmaWxsPSIjMDQwRTEzIi8+CjxwYXRoIGQ9Ik0xIDJMMiAzTDQgMSIgc3Ryb2tlPSIjMDQwRTEzIi8+CjxwYXRoIGQ9Ik0xIDdMMiA4TDQgNiIgc3Ryb2tlPSIjMDQwRTEzIi8+CjxwYXRoIGQ9Ik0xIDEyTDIgMTNMNCAxMSIgc3Ryb2tlPSIjMDQwRTEzIi8+Cjwvc3ZnPgo=", sVe = "data:image/svg+xml;base64,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", uVe = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDhweCIgaGVpZ2h0PSI0OHB4IiB2aWV3Qm94PSIwIDAgNDggNDgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUxLjIgKDU3NTE5KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5pY29uLWxpc3QtYnVsbC1kZWZhdWx0PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBmaWxsPSIjMDAwMDAwIiBjeD0iMTEiIGN5PSIxNCIgcj0iMyI+PC9jaXJjbGU+CiAgICAgICAgPGNpcmNsZSBmaWxsPSIjMDAwMDAwIiBjeD0iMTEiIGN5PSIyNCIgcj0iMyI+PC9jaXJjbGU+CiAgICAgICAgPGNpcmNsZSBmaWxsPSIjMDAwMDAwIiBjeD0iMTEiIGN5PSIzNCIgcj0iMyI+PC9jaXJjbGU+CiAgICAgICAgPHJlY3QgZmlsbD0iIzAwMDAwMCIgb3BhY2l0eT0iMC43IiB4PSIxOCIgeT0iMTIiIHdpZHRoPSIyMiIgaGVpZ2h0PSI0Ij48L3JlY3Q+CiAgICAgICAgPHJlY3QgZmlsbD0iIzAwMDAwMCIgb3BhY2l0eT0iMC43IiB4PSIxOCIgeT0iMjIiIHdpZHRoPSIyMiIgaGVpZ2h0PSI0Ij48L3JlY3Q+CiAgICAgICAgPHJlY3QgZmlsbD0iIzAwMDAwMCIgb3BhY2l0eT0iMC43IiB4PSIxOCIgeT0iMzIiIHdpZHRoPSIyMiIgaGVpZ2h0PSI0Ij48L3JlY3Q+CiAgICA8L2c+Cjwvc3ZnPg==", cVe = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDhweCIgaGVpZ2h0PSI0OHB4IiB2aWV3Qm94PSIwIDAgNDggNDgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUxLjIgKDU3NTE5KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5pY29uLWxpc3QtYnVsbC1zcXVhcmU8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cmVjdCBmaWxsPSIjMDAwMDAwIiB4PSI4IiB5PSIxMSIgd2lkdGg9IjYiIGhlaWdodD0iNiI+PC9yZWN0PgogICAgICAgIDxyZWN0IGZpbGw9IiMwMDAwMDAiIHg9IjgiIHk9IjIxIiB3aWR0aD0iNiIgaGVpZ2h0PSI2Ij48L3JlY3Q+CiAgICAgICAgPHJlY3QgZmlsbD0iIzAwMDAwMCIgeD0iOCIgeT0iMzEiIHdpZHRoPSI2IiBoZWlnaHQ9IjYiPjwvcmVjdD4KICAgICAgICA8cmVjdCBmaWxsPSIjMDAwMDAwIiBvcGFjaXR5PSIwLjciIHg9IjE4IiB5PSIxMiIgd2lkdGg9IjIyIiBoZWlnaHQ9IjQiPjwvcmVjdD4KICAgICAgICA8cmVjdCBmaWxsPSIjMDAwMDAwIiBvcGFjaXR5PSIwLjciIHg9IjE4IiB5PSIyMiIgd2lkdGg9IjIyIiBoZWlnaHQ9IjQiPjwvcmVjdD4KICAgICAgICA8cmVjdCBmaWxsPSIjMDAwMDAwIiBvcGFjaXR5PSIwLjciIHg9IjE4IiB5PSIzMiIgd2lkdGg9IjIyIiBoZWlnaHQ9IjQiPjwvcmVjdD4KICAgIDwvZz4KPC9zdmc+", dVe = "data:image/svg+xml;base64,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", fVe = "data:image/svg+xml;base64,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", hVe = "data:image/svg+xml;base64,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", pVe = "data:image/svg+xml;base64,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", gVe = "data:image/svg+xml;base64,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", mVe = "data:image/svg+xml;base64,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";
var Di = /* @__PURE__ */ ((e) => (e.OrderedList = "orderedList", e.BulletList = "bulletList", e.TaskList = "taskList", e.CircleList = "circleList", e.SquareList = "squareList", e.LowerAlphaList = "lowerAlphaList", e.LowerGreekList = "lowerGreekList", e.LowerRomanList = "lowerRomanList", e.UpperAlphaList = "upperAlphaList", e.UpperRomanList = "upperRomanList", e))(Di || {});
const vVe = ["src"], bVe = {
  name: "RTEControlList",
  inheritAttrs: !1
}, k1 = /* @__PURE__ */ oe({
  ...bVe,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    listType: {
      type: String,
      default: Di.BulletList
    },
    tooltipLabel: String,
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  setup(e) {
    const t = e, r = lt("locale") ?? Dn[t.language], n = G(!0), i = j(() => {
      switch (t.listType) {
        case Di.BulletList:
          return Er.toolbarButtonUnOrderedList;
        case Di.OrderedList:
          return Er.toolbarButtonOrderedList;
        case Di.TaskList:
          return Er.toolbarButtonTaskList;
        case Di.CircleList:
          return Er.toolbarButtonCircleList;
        case Di.SquareList:
          return Er.toolbarButtonSquareList;
        case Di.LowerAlphaList:
          return Er.toolbarButtonLowerAlphaList;
        case Di.LowerGreekList:
          return Er.toolbarButtonLowerGreekList;
        case Di.LowerRomanList:
          return Er.toolbarButtonLowerRomanList;
        case Di.UpperAlphaList:
          return Er.toolbarButtonUpperAlphaList;
        case Di.UpperRomanList:
          return Er.toolbarButtonUpperRomanList;
        default:
          return Er.toolbarButtonUnOrderedList;
      }
    }), o = j(() => {
      switch (t.listType) {
        case Di.CircleList:
          return r.list.circleList;
        case Di.SquareList:
          return r.list.squareList;
        case Di.BulletList:
          return r.list.discList;
        case Di.OrderedList:
          return r.list.decimalList;
        case Di.LowerAlphaList:
          return r.list.lowerAlphaList;
        case Di.LowerGreekList:
          return r.list.lowerGreekList;
        case Di.LowerRomanList:
          return r.list.lowerRomanList;
        case Di.UpperAlphaList:
          return r.list.upperAlphaList;
        case Di.UpperRomanList:
          return r.list.upperRomanList;
        default:
          return r.list.list;
      }
    }), a = {
      bulletList: "disc",
      circleList: "circle",
      squareList: "square"
    }, s = {
      orderedList: "decimal",
      lowerAlphaList: "lower-alpha",
      lowerGreekList: "lower-greek",
      lowerRomanList: "lower-roman",
      upperAlphaList: "upper-alpha",
      upperRomanList: "upper-roman"
    }, u = {
      bulletList: uVe,
      circleList: sVe,
      squareList: cVe,
      orderedList: dVe,
      lowerAlphaList: fVe,
      lowerGreekList: hVe,
      lowerRomanList: pVe,
      upperAlphaList: gVe,
      upperRomanList: mVe,
      taskList: lVe
    }, d = () => {
      var g, m, v, w, x, y;
      if (t.listType === "taskList")
        return (m = (g = t == null ? void 0 : t.editor) == null ? void 0 : g.chain().focus()) == null ? void 0 : m.toggleTaskList().run();
      if (Object.keys(a).includes(t.listType))
        return (w = (v = t == null ? void 0 : t.editor) == null ? void 0 : v.chain().focus()) == null ? void 0 : w.toggleCustomBulletList({ type: a[t.listType] }).run();
      (y = (x = t == null ? void 0 : t.editor) == null ? void 0 : x.chain().focus()) == null || y.toggleCustomOrderedList({ type: s[t.listType] }).run();
    }, f = () => {
      var v;
      const g = (v = t == null ? void 0 : t.editor) == null ? void 0 : v.extensionManager.extensions.map(
        (w) => w.name
      );
      [t.listType].every(
        (w) => g.includes(w)
      ) || [
        "circleList",
        "squareList",
        "lowerAlphaList",
        "lowerGreekList",
        "lowerRomanList",
        "upperAlphaList",
        "upperRomanList"
      ].includes(t.listType) ? n.value = !1 : console.warn(
        `Unable to load the ${t.listType} extension, Please check if the extension is passed to the editor`
      );
    };
    br(() => {
      f();
    }), fi(() => {
      f();
    });
    const h = (g) => {
      var v, w;
      const m = { listStyle: "" };
      return g === "taskList" ? (v = t.editor) == null ? void 0 : v.isActive("taskList") : (m.listStyle = { ...a, ...s }[g], (w = t.editor) == null ? void 0 : w.isActive(m));
    };
    return (g, m) => (ie(), Pe(Br, {
      id: B(i),
      "tooltip-label": e.tooltipLabel ?? B(o),
      "tooltip-position": e.tooltipPosition,
      active: h(e.listType),
      disabled: n.value,
      onOnClick: d
    }, {
      default: we(() => [
        Ye("img", {
          src: u[e.listType],
          class: "toolbar-button__icon--medium"
        }, null, 8, vVe)
      ]),
      _: 1
    }, 8, ["id", "tooltip-label", "tooltip-position", "active", "disabled"]));
  }
});
k1.install = (e) => {
  e.component(k1.name, k1);
};
const yVe = "data:image/svg+xml;base64,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", xVe = ["src"], wVe = {
  name: "RTEControlResetStyles",
  inheritAttrs: !1
}, D1 = /* @__PURE__ */ oe({
  ...wVe,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    reset: {
      type: String,
      default: "selected"
    },
    tooltipLabel: String,
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  setup(e) {
    const t = e, r = lt("locale") ?? Dn[t.language], n = (i) => {
      var o, a, s, u;
      switch (i) {
        case "document": {
          (o = t == null ? void 0 : t.editor) == null || o.commands.selectAll(), (a = t == null ? void 0 : t.editor) == null || a.chain().focus().unsetAllMarks().run(), (s = t == null ? void 0 : t.editor) == null || s.commands.blur();
          break;
        }
        case "selected":
        default: {
          (u = t == null ? void 0 : t.editor) == null || u.chain().focus().unsetAllMarks().run();
          break;
        }
      }
    };
    return (i, o) => (ie(), Pe(Br, {
      id: B(Er).toolbarButtonFormatStyles,
      onOnClick: o[0] || (o[0] = (a) => n(e.reset)),
      "tooltip-label": e.tooltipLabel ?? e.reset === "document" ? B(r).resetStyles.formatAllTooltip : B(r).resetStyles.formatSelectedTooltip,
      "tooltip-position": e.tooltipPosition
    }, {
      default: we(() => [
        e.reset === "document" ? (ie(), Ve("img", {
          key: 0,
          src: B(yVe),
          class: "toolbar-button__icon"
        }, null, 8, xVe)) : (ie(), Pe(B(YZ), {
          key: 1,
          class: "toolbar-button__icon"
        }))
      ]),
      _: 1
    }, 8, ["id", "tooltip-label", "tooltip-position"]));
  }
});
D1.install = (e) => {
  e.component(D1.name, D1);
};
var Qr = /* @__PURE__ */ ((e) => (e.AddColumnAfter = "addColumnAfter", e.AddColumnBefore = "addColumnBefore", e.AddRowAfter = "addRowAfter", e.AddRowBefore = "addRowBefore", e.DeleteColumn = "deleteColumn", e.DeleteRow = "deleteRow", e.DeleteTable = "deleteTable", e.InsertTable = "insertTable", e.MergeCells = "mergeCells", e.SplitCell = "splitCell", e))(Qr || {});
const MVe = {
  name: "RTEControlTable",
  inheritAttrs: !1
}, A1 = /* @__PURE__ */ oe({
  ...MVe,
  props: {
    editor: { type: Object },
    tooltipLabel: String,
    tooltipPosition: {
      type: String,
      default: "top"
    },
    action: {
      type: String,
      required: !0,
      default: Qr.InsertTable
    },
    defaultRows: {
      type: Number,
      default: 3
    },
    defaultColumns: {
      type: Number,
      default: 3
    },
    withHeader: {
      type: Boolean,
      default: !0
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  setup(e) {
    const t = e, r = G(!0), n = () => {
      var f;
      const u = ((f = t == null ? void 0 : t.editor) == null ? void 0 : f.extensionManager.extensions.map((h) => h.name)) ?? [];
      [
        "tableRow",
        "tableHeader",
        "tableCell",
        "table",
        "requiredExtensions"
      ].every((h) => u.includes(h)) ? r.value = !1 : console.warn(
        "Unable to load the Table extension, Please check if the extension is passed to the editor"
      );
    };
    br(() => {
      n();
    }), fi(() => {
      n();
    });
    const i = (u) => {
      const d = t.editor.chain().focus(), f = {
        [Qr.InsertTable]: () => d.insertTable({
          rows: t.defaultRows,
          cols: t.defaultColumns,
          withHeaderRow: t.withHeader
        }).updateAttributes("table", { class: "rte-table" }).run(),
        [Qr.AddColumnBefore]: () => d.addColumnBefore().run(),
        [Qr.AddColumnAfter]: () => d.addColumnAfter().run(),
        [Qr.AddRowBefore]: () => d.addRowBefore().run(),
        [Qr.AddRowAfter]: () => d.addRowAfter().run(),
        [Qr.DeleteTable]: () => d.deleteTable().run(),
        [Qr.MergeCells]: () => d.mergeCells().run(),
        [Qr.SplitCell]: () => d.splitCell().run(),
        [Qr.DeleteRow]: () => d.deleteRow().run(),
        [Qr.DeleteColumn]: () => d.deleteColumn().run()
      };
      (f[u] || f[Qr.InsertTable])();
    }, o = (u) => {
      const d = {
        [Qr.InsertTable]: LZ,
        [Qr.AddColumnBefore]: CZ,
        [Qr.AddColumnAfter]: SZ,
        [Qr.AddRowBefore]: kZ,
        [Qr.AddRowAfter]: TZ,
        [Qr.DeleteTable]: WZ,
        [Qr.MergeCells]: FZ,
        [Qr.SplitCell]: UZ,
        [Qr.DeleteRow]: BZ,
        [Qr.DeleteColumn]: OZ
      };
      return d[u] ?? d[Qr.InsertTable];
    }, a = lt("locale") ?? Dn[t.language], s = (u) => {
      const d = {
        [Qr.InsertTable]: a.table.insertTable,
        [Qr.AddColumnBefore]: a.table.addColumnBefore,
        [Qr.AddColumnAfter]: a.table.addColumnAfter,
        [Qr.AddRowBefore]: a.table.addRowBefore,
        [Qr.AddRowAfter]: a.table.addRowAfter,
        [Qr.DeleteTable]: a.table.deleteTable,
        [Qr.MergeCells]: a.table.mergeCell,
        [Qr.SplitCell]: a.table.splitCell,
        [Qr.DeleteRow]: a.table.deleteRow,
        [Qr.DeleteColumn]: a.table.deleteColumn
      };
      return d[u] ?? d[Qr.InsertTable];
    };
    return (u, d) => (ie(), Pe(Br, {
      id: `table-${t.action}`,
      "tooltip-label": e.tooltipLabel ?? s(t.action),
      "tooltip-position": "top",
      onOnClick: d[0] || (d[0] = (f) => i(t.action))
    }, {
      default: we(() => [
        (ie(), Pe(mi(o(e.action)), { class: "toolbar-button__icon" }))
      ]),
      _: 1
    }, 8, ["id", "tooltip-label"]));
  }
});
A1.install = (e) => {
  e.component(A1.name, A1);
};
const CVe = {
  name: "RTEControlTextAlignment",
  inheritAttrs: !1
}, E1 = /* @__PURE__ */ oe({
  ...CVe,
  props: {
    editor: { type: Object },
    align: {
      type: String,
      default: "left"
    },
    tooltipLabel: String,
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  setup(e) {
    const t = e, r = lt("locale") ?? Dn[t.language], n = G(!0), i = function() {
      switch (t.align) {
        case "right":
          return r.common.right;
        case "left":
          return r.common.left;
        case "center":
          return r.common.center;
      }
    }(), o = j(() => t.tooltipLabel ? t.tooltipLabel : t.align !== "justify" ? r.textAlign.alignTooltip.replace("{align}", i) : r.common.justify), a = () => {
      var d;
      const s = ((d = t == null ? void 0 : t.editor) == null ? void 0 : d.extensionManager.extensions.map((f) => f.name)) ?? [];
      [
        "textBlocks",
        "requiredExtensions",
        "textAlign"
      ].every((f) => s.includes(f)) ? n.value = !1 : console.warn(
        "Unable to load the Text Align extension, Please check if the extension is passed to the editor"
      );
    };
    return br(() => {
      a();
    }), fi(() => {
      a();
    }), (s, u) => {
      var d;
      return ie(), Pe(Br, {
        id: B(Er).toolbarButtonTextAlignCenter,
        active: (d = e.editor) == null ? void 0 : d.isActive({ textAlign: s.$props.align }),
        "tooltip-label": B(o),
        "tooltip-position": e.tooltipPosition,
        disabled: n.value,
        onOnClick: u[0] || (u[0] = (f) => {
          var h, g;
          (g = (h = e.editor) == null ? void 0 : h.chain().focus()) == null || g.setTextAlign(s.$props.align).run();
        })
      }, {
        default: we(() => [
          e.align === "left" ? (ie(), Pe(B(EZ), {
            key: 0,
            class: "toolbar-button__icon"
          })) : yt("", !0),
          e.align === "center" ? (ie(), Pe(B(DZ), {
            key: 1,
            class: "toolbar-button__icon"
          })) : yt("", !0),
          e.align === "right" ? (ie(), Pe(B(IZ), {
            key: 2,
            class: "toolbar-button__icon"
          })) : yt("", !0),
          e.align === "justify" ? (ie(), Pe(B(AZ), {
            key: 3,
            class: "toolbar-button__icon"
          })) : yt("", !0)
        ]),
        _: 1
      }, 8, ["id", "active", "tooltip-label", "tooltip-position", "disabled"]);
    };
  }
});
E1.install = (e) => {
  e.component(E1.name, E1);
};
const SVe = {
  name: "RTEControlTextBlocks",
  inheritAttrs: !1
}, TVe = /* @__PURE__ */ oe({
  ...SVe,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  setup(e) {
    var h;
    const t = e, r = lt("locale") ?? Dn[t.language], n = {
      fontWeight: "bold",
      fontStyle: "normal"
    }, i = [
      {
        label: r.paragraph.heading1,
        value: "1",
        style: {
          fontSize: "32px",
          ...n
        }
      },
      {
        label: r.paragraph.heading2,
        value: "2",
        style: {
          fontSize: "24px",
          ...n
        }
      },
      {
        label: r.paragraph.heading3,
        value: "3",
        style: {
          fontSize: "18.72px",
          ...n
        }
      },
      {
        label: r.paragraph.heading4,
        value: "4",
        style: {
          fontSize: "16px",
          ...n
        }
      },
      {
        label: r.paragraph.heading5,
        value: "5",
        style: {
          fontSize: "13.28px",
          ...n
        }
      },
      {
        label: r.paragraph.paragraph,
        value: "0",
        style: {
          fontSize: "18px",
          fontWeight: 400,
          fontStyle: "normal"
        }
      }
    ], o = (h = hn.last(i)) == null ? void 0 : h.value, a = G(!0), s = G(o), u = ({
      editor: g
    }) => {
      const m = g.getAttributes(
        "heading"
      );
      s.value = o, hn.isEmpty(m) || (s.value = String(m.level) ?? o);
    }, d = (g) => {
      var w;
      const m = t.editor.getAttributes(
        s.value === "0" ? "paragraph" : "heading"
      ), v = (w = t.editor.getAttributes("textStyle")) == null ? void 0 : w.fontFamily;
      t != null && t.editor && (g === "0" ? t.editor.chain().focus().setCustomParagraph(m).run() : t.editor.chain().focus().unsetFontSize().toggleHeading({
        ...m,
        level: Number(g)
      }).run(), v && t.editor.chain().setFontFamily(v).run());
    }, f = () => {
      t.editor && (a.value = !ma(t.editor, "heading"));
    };
    return br(() => {
      var g;
      f(), (g = t == null ? void 0 : t.editor) == null || g.on("transaction", u);
    }), Nc(() => {
      var g;
      (g = t == null ? void 0 : t.editor) == null || g.off("transaction", u);
    }), fi(() => {
      var g;
      f(), (g = t == null ? void 0 : t.editor) == null || g.on("transaction", u);
    }), Gr(() => {
      var g;
      (g = t == null ? void 0 : t.editor) == null || g.off("transaction", u);
    }), (g, m) => (ie(), Pe(B(ws), {
      id: B(Er).toolbarSelectTextBlock,
      placeholder: "Paragraph",
      value: s.value,
      options: i,
      disabled: a.value,
      class: "text-blocks",
      size: "small",
      "onUpdate:value": d
    }, null, 8, ["id", "value", "disabled"]));
  }
});
const I1 = /* @__PURE__ */ Xl(TVe, [["__scopeId", "data-v-235611b2"]]);
I1.install = (e) => {
  e.component(I1.name, I1);
};
const kVe = "data:image/svg+xml;base64,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", DVe = ["src"], AVe = {
  name: "RTEControlBlockQuote",
  inheritAttrs: !1
}, N1 = /* @__PURE__ */ oe({
  ...AVe,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    tooltipLabel: {
      type: String
    },
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  setup(e) {
    const t = e, r = lt("locale") ?? Dn[t.language], n = pn(), i = G(!0), o = () => {
      t.editor && (i.value = !ma(t.editor, "blockquote"));
    };
    return br(() => {
      o();
    }), fi(() => {
      o();
    }), (a, s) => {
      var u;
      return ie(), Pe(Br, {
        id: B(Er).toolbarButtonQuote,
        active: (u = e.editor) == null ? void 0 : u.isActive("blockquote"),
        disabled: i.value,
        onOnClick: s[0] || (s[0] = (d) => {
          var f;
          return (f = e.editor) == null ? void 0 : f.chain().focus().toggleBlockquote().run();
        }),
        "tooltip-label": e.tooltipLabel ?? B(r).common.blockquote,
        "tooltip-position": e.tooltipPosition
      }, {
        default: we(() => [
          B(n).icon ? nt(a.$slots, "icon", { key: 0 }) : (ie(), Ve("img", {
            key: 1,
            src: B(kVe),
            class: "toolbar-button__icon"
          }, null, 8, DVe))
        ]),
        _: 3
      }, 8, ["id", "active", "disabled", "tooltip-label", "tooltip-position"]);
    };
  }
});
N1.install = (e) => {
  e.component(N1.name, N1);
};
const EVe = {
  name: "RTEControlBold",
  inheritAttrs: !1
}, z1 = /* @__PURE__ */ oe({
  ...EVe,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    tooltipLabel: {
      type: String
    },
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  setup(e) {
    const t = e, r = lt("locale") ?? Dn[t.language], n = G(!0), i = () => {
      t.editor && (n.value = !ma(t.editor, "bold"));
    };
    return br(() => {
      i();
    }), fi(() => {
      i();
    }), (o, a) => {
      var s;
      return ie(), Pe(Br, {
        id: B(Er).toolbarButtonBold,
        active: (s = e.editor) == null ? void 0 : s.isActive("bold"),
        disabled: n.value,
        onOnClick: a[0] || (a[0] = (u) => {
          var d;
          return (d = e.editor) == null ? void 0 : d.chain().focus().toggleBold().run();
        }),
        "tooltip-label": e.tooltipLabel ?? B(r).common.bold,
        "tooltip-position": e.tooltipPosition
      }, {
        default: we(() => [
          Re(B(NZ), { class: "toolbar-button__icon" })
        ]),
        _: 1
      }, 8, ["id", "active", "disabled", "tooltip-label", "tooltip-position"]);
    };
  }
});
z1.install = (e) => {
  e.component(z1.name, z1);
};
const IVe = {
  name: "RTEControlItalic",
  inheritAttrs: !1
}, $1 = /* @__PURE__ */ oe({
  ...IVe,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    tooltipLabel: {
      type: String
    },
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  setup(e) {
    const t = e, r = lt("locale") ?? Dn[t.language], n = G(!0), i = () => {
      t.editor && (n.value = !ma(t.editor, "italic"));
    };
    return br(() => {
      i();
    }), fi(() => {
      i();
    }), (o, a) => {
      var s;
      return ie(), Pe(Br, {
        id: B(Er).toolbarButtonItalic,
        active: (s = e.editor) == null ? void 0 : s.isActive("italic"),
        "tooltip-label": e.tooltipLabel ?? B(r).common.italic,
        "tooltip-position": e.tooltipPosition,
        disabled: n.value,
        onOnClick: a[0] || (a[0] = (u) => {
          var d;
          return (d = e.editor) == null ? void 0 : d.chain().focus().toggleItalic().run();
        })
      }, {
        default: we(() => [
          Re(B(_Z), { class: "toolbar-button__icon" })
        ]),
        _: 1
      }, 8, ["id", "active", "tooltip-label", "tooltip-position", "disabled"]);
    };
  }
});
$1.install = (e) => {
  e.component($1.name, $1);
};
const NVe = {
  name: "RTEControlStrike",
  inheritAttrs: !1
}, O1 = /* @__PURE__ */ oe({
  ...NVe,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    tooltipLabel: {
      type: String
    },
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  setup(e) {
    const t = e, r = lt("locale") ?? Dn[t.language], n = G(!0), i = () => {
      t.editor && (n.value = !ma(t.editor, "strike"));
    };
    return br(() => {
      i();
    }), fi(() => {
      i();
    }), (o, a) => {
      var s;
      return ie(), Pe(Br, {
        id: B(Er).toolbarButtonStrike,
        active: (s = e.editor) == null ? void 0 : s.isActive("strike"),
        disabled: n.value,
        onOnClick: a[0] || (a[0] = (u) => {
          var d;
          return (d = e.editor) == null ? void 0 : d.chain().focus().toggleStrike().run();
        }),
        "tooltip-label": e.tooltipLabel ?? B(r).common.strike,
        "tooltip-position": e.tooltipPosition
      }, {
        default: we(() => [
          Re(B(HZ), { class: "toolbar-button__icon" })
        ]),
        _: 1
      }, 8, ["id", "active", "disabled", "tooltip-label", "tooltip-position"]);
    };
  }
});
O1.install = (e) => {
  e.component(O1.name, O1);
};
const zVe = "data:image/svg+xml;base64,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", $Ve = ["src"], OVe = {
  name: "RTEControlSubscript",
  inheritAttrs: !1
}, _1 = /* @__PURE__ */ oe({
  ...OVe,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    tooltipLabel: {
      type: String
    },
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  setup(e) {
    const t = e, r = lt("locale") ?? Dn[t.language], n = pn(), i = G(!0), o = () => {
      t.editor && (i.value = !ma(t.editor, "subscript"));
    };
    return br(() => {
      o();
    }), fi(() => {
      o();
    }), (a, s) => {
      var u;
      return ie(), Pe(Br, {
        id: B(Er).toolbarButtonSub,
        active: (u = e.editor) == null ? void 0 : u.isActive("subscript"),
        disabled: i.value,
        onOnClick: s[0] || (s[0] = (d) => {
          var f;
          return (f = e.editor) == null ? void 0 : f.chain().focus().toggleSubscript().run();
        }),
        "tooltip-label": e.tooltipLabel ?? B(r).textAlign.subScript,
        "tooltip-position": e.tooltipPosition
      }, {
        default: we(() => [
          B(n).icon ? nt(a.$slots, "icon", { key: 0 }) : (ie(), Ve("img", {
            key: 1,
            src: B(zVe),
            class: "toolbar-button__icon"
          }, null, 8, $Ve))
        ]),
        _: 3
      }, 8, ["id", "active", "disabled", "tooltip-label", "tooltip-position"]);
    };
  }
});
_1.install = (e) => {
  e.component(_1.name, _1);
};
const _Ve = "data:image/svg+xml;base64,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", LVe = ["src"], PVe = {
  name: "RTEControlSuperscript",
  inheritAttrs: !1
}, L1 = /* @__PURE__ */ oe({
  ...PVe,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    tooltipLabel: {
      type: String
    },
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  setup(e) {
    const t = e, r = lt("locale") ?? Dn[t.language], n = pn(), i = G(!0), o = () => {
      t.editor && (i.value = !ma(t.editor, "superscript"));
    };
    return br(() => {
      o();
    }), fi(() => {
      o();
    }), (a, s) => {
      var u;
      return ie(), Pe(Br, {
        id: B(Er).toolbarButtonSuper,
        active: (u = e.editor) == null ? void 0 : u.isActive("superscript"),
        disabled: i.value,
        onOnClick: s[0] || (s[0] = (d) => {
          var f;
          return (f = e.editor) == null ? void 0 : f.chain().focus().toggleSuperscript().run();
        }),
        "tooltip-label": e.tooltipLabel ?? B(r).textAlign.superScript,
        "tooltip-position": e.tooltipPosition
      }, {
        default: we(() => [
          B(n).icon ? nt(a.$slots, "icon", { key: 0 }) : (ie(), Ve("img", {
            key: 1,
            src: B(_Ve),
            class: "toolbar-button__icon"
          }, null, 8, LVe))
        ]),
        _: 3
      }, 8, ["id", "active", "disabled", "tooltip-label", "tooltip-position"]);
    };
  }
});
L1.install = (e) => {
  e.component(L1.name, L1);
};
const RVe = {
  name: "RTEControlUnderline",
  inheritAttrs: !1
}, P1 = /* @__PURE__ */ oe({
  ...RVe,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    tooltipLabel: {
      type: String
    },
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  setup(e) {
    const t = e, r = lt("locale") ?? Dn[t.language], n = G(!0), i = () => {
      t.editor && (n.value = !ma(t.editor, "underline"));
    };
    return br(() => {
      i();
    }), fi(() => {
      i();
    }), (o, a) => {
      var s;
      return ie(), Pe(Br, {
        id: B(Er).toolbarButtonUnderline,
        active: (s = e.editor) == null ? void 0 : s.isActive("underline"),
        disabled: n.value,
        "tooltip-label": e.tooltipLabel ?? B(r).common.underline,
        "tooltip-position": e.tooltipPosition,
        onOnClick: a[0] || (a[0] = (u) => {
          var d;
          return (d = e.editor) == null ? void 0 : d.chain().focus().toggleUnderline().run();
        })
      }, {
        default: we(() => [
          Re(B(QZ), { class: "toolbar-button__icon" })
        ]),
        _: 1
      }, 8, ["id", "active", "disabled", "tooltip-label", "tooltip-position"]);
    };
  }
});
P1.install = (e) => {
  e.component(P1.name, P1);
};
const jVe = {
  key: 0,
  id: "editor-toolbar",
  class: "flex_container toolbar_container border_bottom"
}, FVe = {
  name: "UIRichTextEditor",
  inheritAttrs: !1
}, BVe = /* @__PURE__ */ oe({
  ...FVe,
  props: {
    editor: { type: Object },
    containerClass: {
      type: String,
      default: () => ""
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  setup(e) {
    const t = e, r = pn();
    return IL(t.language), Gt(
      () => t.language,
      (n) => {
        IL(n);
      }
    ), (n, i) => e.editor ? (ie(), Ve("div", {
      key: 0,
      class: Jr(["editor-container", e.containerClass])
    }, [
      B(r).toolbar ? (ie(), Ve("div", jVe, [
        nt(n.$slots, "toolbar", {}, void 0, !0)
      ])) : yt("", !0),
      Re(B(L5e), {
        editor: e.editor,
        class: "editor-wrapper"
      }, null, 8, ["editor"])
    ], 2)) : yt("", !0);
  }
});
const UVe = /* @__PURE__ */ Xl(BVe, [["__scopeId", "data-v-23eb497f"]]);
var Qv = /* @__PURE__ */ ((e) => (e.Image = "image", e.Link = "link", e))(Qv || {}), dp = {}, HVe = {
  get exports() {
    return dp;
  },
  set exports(e) {
    dp = e;
  }
}, Op = {}, WVe = {
  get exports() {
    return Op;
  },
  set exports(e) {
    Op = e;
  }
}, xt = {}, VVe = {
  get exports() {
    return xt;
  },
  set exports(e) {
    xt = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function r(i) {
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(a) {
      return typeof a;
    } : r = function(a) {
      return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
    }, r(i);
  }
  function n(i) {
    var o = typeof i == "string" || i instanceof String;
    if (!o) {
      var a = r(i);
      throw i === null ? a = "null" : a === "object" && (a = i.constructor.name), new TypeError("Expected a string but received a ".concat(a));
    }
  }
  e.exports = t.default, e.exports.default = t.default;
})(VVe, xt);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(xt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o) {
    return (0, r.default)(o), o = Date.parse(o), isNaN(o) ? null : new Date(o);
  }
  e.exports = t.default, e.exports.default = t.default;
})(WVe, Op);
var G0 = {}, YVe = {
  get exports() {
    return G0;
  },
  set exports(e) {
    G0 = e;
  }
}, tg = {}, ei = {};
Object.defineProperty(ei, "__esModule", {
  value: !0
});
ei.commaDecimal = ei.dotDecimal = ei.bengaliLocales = ei.farsiLocales = ei.arabicLocales = ei.englishLocales = ei.decimal = ei.alphanumeric = ei.alpha = void 0;
var Jo = {
  "en-US": /^[A-Z]+$/i,
  "az-AZ": /^[A-VXYZÇƏĞİıÖŞÜ]+$/i,
  "bg-BG": /^[А-Я]+$/i,
  "cs-CZ": /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  "da-DK": /^[A-ZÆØÅ]+$/i,
  "de-DE": /^[A-ZÄÖÜß]+$/i,
  "el-GR": /^[Α-ώ]+$/i,
  "es-ES": /^[A-ZÁÉÍÑÓÚÜ]+$/i,
  "fa-IR": /^[ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]+$/i,
  "fi-FI": /^[A-ZÅÄÖ]+$/i,
  "fr-FR": /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  "it-IT": /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
  "ja-JP": /^[ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
  "nb-NO": /^[A-ZÆØÅ]+$/i,
  "nl-NL": /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
  "nn-NO": /^[A-ZÆØÅ]+$/i,
  "hu-HU": /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  "pl-PL": /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  "pt-PT": /^[A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
  "ru-RU": /^[А-ЯЁ]+$/i,
  "kk-KZ": /^[А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]+$/i,
  "sl-SI": /^[A-ZČĆĐŠŽ]+$/i,
  "sk-SK": /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
  "sr-RS@latin": /^[A-ZČĆŽŠĐ]+$/i,
  "sr-RS": /^[А-ЯЂЈЉЊЋЏ]+$/i,
  "sv-SE": /^[A-ZÅÄÖ]+$/i,
  "th-TH": /^[ก-๐\s]+$/i,
  "tr-TR": /^[A-ZÇĞİıÖŞÜ]+$/i,
  "uk-UA": /^[А-ЩЬЮЯЄIЇҐі]+$/i,
  "vi-VN": /^[A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
  "ko-KR": /^[ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
  "ku-IQ": /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
  he: /^[א-ת]+$/,
  fa: /^['آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی']+$/i,
  bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
  "hi-IN": /^[\u0900-\u0961]+[\u0972-\u097F]*$/i,
  "si-LK": /^[\u0D80-\u0DFF]+$/
};
ei.alpha = Jo;
var ea = {
  "en-US": /^[0-9A-Z]+$/i,
  "az-AZ": /^[0-9A-VXYZÇƏĞİıÖŞÜ]+$/i,
  "bg-BG": /^[0-9А-Я]+$/i,
  "cs-CZ": /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  "da-DK": /^[0-9A-ZÆØÅ]+$/i,
  "de-DE": /^[0-9A-ZÄÖÜß]+$/i,
  "el-GR": /^[0-9Α-ω]+$/i,
  "es-ES": /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
  "fi-FI": /^[0-9A-ZÅÄÖ]+$/i,
  "fr-FR": /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  "it-IT": /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
  "ja-JP": /^[0-9０-９ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
  "hu-HU": /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  "nb-NO": /^[0-9A-ZÆØÅ]+$/i,
  "nl-NL": /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
  "nn-NO": /^[0-9A-ZÆØÅ]+$/i,
  "pl-PL": /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  "pt-PT": /^[0-9A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
  "ru-RU": /^[0-9А-ЯЁ]+$/i,
  "kk-KZ": /^[0-9А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]+$/i,
  "sl-SI": /^[0-9A-ZČĆĐŠŽ]+$/i,
  "sk-SK": /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
  "sr-RS@latin": /^[0-9A-ZČĆŽŠĐ]+$/i,
  "sr-RS": /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
  "sv-SE": /^[0-9A-ZÅÄÖ]+$/i,
  "th-TH": /^[ก-๙\s]+$/i,
  "tr-TR": /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
  "uk-UA": /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
  "ko-KR": /^[0-9ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
  "ku-IQ": /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
  "vi-VN": /^[0-9A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
  he: /^[0-9א-ת]+$/,
  fa: /^['0-9آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی۱۲۳۴۵۶۷۸۹۰']+$/i,
  bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣ০১২৩৪৫৬৭৮৯ৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
  "hi-IN": /^[\u0900-\u0963]+[\u0966-\u097F]*$/i,
  "si-LK": /^[0-9\u0D80-\u0DFF]+$/
};
ei.alphanumeric = ea;
var $o = {
  "en-US": ".",
  ar: "٫"
};
ei.decimal = $o;
var dO = ["AU", "GB", "HK", "IN", "NZ", "ZA", "ZM"];
ei.englishLocales = dO;
for (var Ly, EN = 0; EN < dO.length; EN++)
  Ly = "en-".concat(dO[EN]), Jo[Ly] = Jo["en-US"], ea[Ly] = ea["en-US"], $o[Ly] = $o["en-US"];
var fO = ["AE", "BH", "DZ", "EG", "IQ", "JO", "KW", "LB", "LY", "MA", "QM", "QA", "SA", "SD", "SY", "TN", "YE"];
ei.arabicLocales = fO;
for (var Py, IN = 0; IN < fO.length; IN++)
  Py = "ar-".concat(fO[IN]), Jo[Py] = Jo.ar, ea[Py] = ea.ar, $o[Py] = $o.ar;
var hO = ["IR", "AF"];
ei.farsiLocales = hO;
for (var NN, zN = 0; zN < hO.length; zN++)
  NN = "fa-".concat(hO[zN]), ea[NN] = ea.fa, $o[NN] = $o.ar;
var pO = ["BD", "IN"];
ei.bengaliLocales = pO;
for (var Ry, $N = 0; $N < pO.length; $N++)
  Ry = "bn-".concat(pO[$N]), Jo[Ry] = Jo.bn, ea[Ry] = ea.bn, $o[Ry] = $o["en-US"];
var gO = ["ar-EG", "ar-LB", "ar-LY"];
ei.dotDecimal = gO;
var mO = ["bg-BG", "cs-CZ", "da-DK", "de-DE", "el-GR", "en-ZM", "es-ES", "fr-CA", "fr-FR", "id-ID", "it-IT", "ku-IQ", "hi-IN", "hu-HU", "nb-NO", "nn-NO", "nl-NL", "pl-PL", "pt-PT", "ru-RU", "kk-KZ", "si-LK", "sl-SI", "sr-RS@latin", "sr-RS", "sv-SE", "tr-TR", "uk-UA", "vi-VN"];
ei.commaDecimal = mO;
for (var ON = 0; ON < gO.length; ON++)
  $o[gO[ON]] = $o["en-US"];
for (var _N = 0; _N < mO.length; _N++)
  $o[mO[_N]] = ",";
Jo["fr-CA"] = Jo["fr-FR"];
ea["fr-CA"] = ea["fr-FR"];
Jo["pt-BR"] = Jo["pt-PT"];
ea["pt-BR"] = ea["pt-PT"];
$o["pt-BR"] = $o["pt-PT"];
Jo["pl-Pl"] = Jo["pl-PL"];
ea["pl-Pl"] = ea["pl-PL"];
$o["pl-Pl"] = $o["pl-PL"];
Jo["fa-AF"] = Jo.fa;
Object.defineProperty(tg, "__esModule", {
  value: !0
});
tg.default = GVe;
tg.locales = void 0;
var QVe = qVe(xt), lG = ei;
function qVe(e) {
  return e && e.__esModule ? e : { default: e };
}
function GVe(e, t) {
  (0, QVe.default)(e), t = t || {};
  var r = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(t.locale ? lG.decimal[t.locale] : ".", "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));
  if (e === "" || e === "." || e === "," || e === "-" || e === "+")
    return !1;
  var n = parseFloat(e.replace(",", "."));
  return r.test(e) && (!t.hasOwnProperty("min") || n >= t.min) && (!t.hasOwnProperty("max") || n <= t.max) && (!t.hasOwnProperty("lt") || n < t.lt) && (!t.hasOwnProperty("gt") || n > t.gt);
}
var ZVe = Object.keys(lG.decimal);
tg.locales = ZVe;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(tg);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o) {
    return (0, r.default)(o) ? parseFloat(o) : NaN;
  }
  e.exports = t.default, e.exports.default = t.default;
})(YVe, G0);
var Bx = {}, KVe = {
  get exports() {
    return Bx;
  },
  set exports(e) {
    Bx = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(xt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o, a) {
    return (0, r.default)(o), parseInt(o, a || 10);
  }
  e.exports = t.default, e.exports.default = t.default;
})(KVe, Bx);
var Ux = {}, XVe = {
  get exports() {
    return Ux;
  },
  set exports(e) {
    Ux = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(xt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o, a) {
    return (0, r.default)(o), a ? o === "1" || /^true$/i.test(o) : o !== "0" && !/^false$/i.test(o) && o !== "";
  }
  e.exports = t.default, e.exports.default = t.default;
})(XVe, Ux);
var Hx = {}, JVe = {
  get exports() {
    return Hx;
  },
  set exports(e) {
    Hx = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(xt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o, a) {
    return (0, r.default)(o), o === a;
  }
  e.exports = t.default, e.exports.default = t.default;
})(JVe, Hx);
var Wx = {}, eYe = {
  get exports() {
    return Wx;
  },
  set exports(e) {
    Wx = e;
  }
}, Z0 = {}, tYe = {
  get exports() {
    return Z0;
  },
  set exports(e) {
    Z0 = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function r(i) {
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(a) {
      return typeof a;
    } : r = function(a) {
      return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
    }, r(i);
  }
  function n(i) {
    return r(i) === "object" && i !== null ? typeof i.toString == "function" ? i = i.toString() : i = "[object Object]" : (i === null || typeof i > "u" || isNaN(i) && !i.length) && (i = ""), String(i);
  }
  e.exports = t.default, e.exports.default = t.default;
})(tYe, Z0);
var ao = {}, rYe = {
  get exports() {
    return ao;
  },
  set exports(e) {
    ao = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = arguments.length > 1 ? arguments[1] : void 0;
    for (var o in i)
      typeof n[o] > "u" && (n[o] = i[o]);
    return n;
  }
  e.exports = t.default, e.exports.default = t.default;
})(rYe, ao);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = o(xt), n = o(Z0), i = o(ao);
  function o(u) {
    return u && u.__esModule ? u : { default: u };
  }
  var a = {
    ignoreCase: !1,
    minOccurrences: 1
  };
  function s(u, d, f) {
    return (0, r.default)(u), f = (0, i.default)(f, a), f.ignoreCase ? u.toLowerCase().split((0, n.default)(d).toLowerCase()).length > f.minOccurrences : u.split((0, n.default)(d)).length > f.minOccurrences;
  }
  e.exports = t.default, e.exports.default = t.default;
})(eYe, Wx);
var Vx = {}, nYe = {
  get exports() {
    return Vx;
  },
  set exports(e) {
    Vx = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(xt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o, a, s) {
    return (0, r.default)(o), Object.prototype.toString.call(a) !== "[object RegExp]" && (a = new RegExp(a, s)), !!o.match(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(nYe, Vx);
var K0 = {}, iYe = {
  get exports() {
    return K0;
  },
  set exports(e) {
    K0 = e;
  }
}, X0 = {}, oYe = {
  get exports() {
    return X0;
  },
  set exports(e) {
    X0 = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(xt);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function i(a) {
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? i = function(u) {
      return typeof u;
    } : i = function(u) {
      return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
    }, i(a);
  }
  function o(a, s) {
    (0, r.default)(a);
    var u, d;
    i(s) === "object" ? (u = s.min || 0, d = s.max) : (u = arguments[1], d = arguments[2]);
    var f = encodeURI(a).split(/%..|./).length - 1;
    return f >= u && (typeof d > "u" || f <= d);
  }
  e.exports = t.default, e.exports.default = t.default;
})(oYe, X0);
var _p = {}, aYe = {
  get exports() {
    return _p;
  },
  set exports(e) {
    _p = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = i(xt), n = i(ao);
  function i(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var o = {
    require_tld: !0,
    allow_underscores: !1,
    allow_trailing_dot: !1,
    allow_numeric_tld: !1,
    allow_wildcard: !1,
    ignore_max_length: !1
  };
  function a(s, u) {
    (0, r.default)(s), u = (0, n.default)(u, o), u.allow_trailing_dot && s[s.length - 1] === "." && (s = s.substring(0, s.length - 1)), u.allow_wildcard === !0 && s.indexOf("*.") === 0 && (s = s.substring(2));
    var d = s.split("."), f = d[d.length - 1];
    return u.require_tld && (d.length < 2 || !u.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(f) || /\s/.test(f)) || !u.allow_numeric_tld && /^\d+$/.test(f) ? !1 : d.every(function(h) {
      return !(h.length > 63 && !u.ignore_max_length || !/^[a-z_\u00a1-\uffff0-9-]+$/i.test(h) || /[\uff01-\uff5e]/.test(h) || /^-|-$/.test(h) || !u.allow_underscores && /_/.test(h));
    });
  }
  e.exports = t.default, e.exports.default = t.default;
})(aYe, _p);
var lh = {}, lYe = {
  get exports() {
    return lh;
  },
  set exports(e) {
    lh = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = d;
  var r = n(xt);
  function n(f) {
    return f && f.__esModule ? f : { default: f };
  }
  var i = "(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])", o = "(".concat(i, "[.]){3}").concat(i), a = new RegExp("^".concat(o, "$")), s = "(?:[0-9a-fA-F]{1,4})", u = new RegExp("^(" + "(?:".concat(s, ":){7}(?:").concat(s, "|:)|") + "(?:".concat(s, ":){6}(?:").concat(o, "|:").concat(s, "|:)|") + "(?:".concat(s, ":){5}(?::").concat(o, "|(:").concat(s, "){1,2}|:)|") + "(?:".concat(s, ":){4}(?:(:").concat(s, "){0,1}:").concat(o, "|(:").concat(s, "){1,3}|:)|") + "(?:".concat(s, ":){3}(?:(:").concat(s, "){0,2}:").concat(o, "|(:").concat(s, "){1,4}|:)|") + "(?:".concat(s, ":){2}(?:(:").concat(s, "){0,3}:").concat(o, "|(:").concat(s, "){1,5}|:)|") + "(?:".concat(s, ":){1}(?:(:").concat(s, "){0,4}:").concat(o, "|(:").concat(s, "){1,6}|:)|") + "(?::((?::".concat(s, "){0,5}:").concat(o, "|(?::").concat(s, "){1,7}|:))") + ")(%[0-9a-zA-Z-.:]{1,})?$");
  function d(f) {
    var h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return (0, r.default)(f), h = String(h), h ? h === "4" ? a.test(f) : h === "6" ? u.test(f) : !1 : d(f, 4) || d(f, 6);
  }
  e.exports = t.default, e.exports.default = t.default;
})(lYe, lh);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = y;
  var r = s(xt), n = s(X0), i = s(_p), o = s(lh), a = s(ao);
  function s(C) {
    return C && C.__esModule ? C : { default: C };
  }
  var u = {
    allow_display_name: !1,
    allow_underscores: !1,
    require_display_name: !1,
    allow_utf8_local_part: !0,
    require_tld: !0,
    blacklisted_chars: "",
    ignore_max_length: !1,
    host_blacklist: [],
    host_whitelist: []
  }, d = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i, f = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i, h = /^[a-z\d]+$/, g = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i, m = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i, v = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i, w = 254;
  function x(C) {
    var S = C.replace(/^"(.+)"$/, "$1");
    if (!S.trim())
      return !1;
    var T = /[\.";<>]/.test(S);
    if (T) {
      if (S === C)
        return !1;
      var A = S.split('"').length === S.split('\\"').length;
      if (!A)
        return !1;
    }
    return !0;
  }
  function y(C, S) {
    if ((0, r.default)(C), S = (0, a.default)(S, u), S.require_display_name || S.allow_display_name) {
      var T = C.match(d);
      if (T) {
        var A = T[1];
        if (C = C.replace(A, "").replace(/(^<|>$)/g, ""), A.endsWith(" ") && (A = A.slice(0, -1)), !x(A))
          return !1;
      } else if (S.require_display_name)
        return !1;
    }
    if (!S.ignore_max_length && C.length > w)
      return !1;
    var D = C.split("@"), E = D.pop(), N = E.toLowerCase();
    if (S.host_blacklist.includes(N) || S.host_whitelist.length > 0 && !S.host_whitelist.includes(N))
      return !1;
    var I = D.join("@");
    if (S.domain_specific_validation && (N === "gmail.com" || N === "googlemail.com")) {
      I = I.toLowerCase();
      var $ = I.split("+")[0];
      if (!(0, n.default)($.replace(/\./g, ""), {
        min: 6,
        max: 30
      }))
        return !1;
      for (var _ = $.split("."), R = 0; R < _.length; R++)
        if (!h.test(_[R]))
          return !1;
    }
    if (S.ignore_max_length === !1 && (!(0, n.default)(I, {
      max: 64
    }) || !(0, n.default)(E, {
      max: 254
    })))
      return !1;
    if (!(0, i.default)(E, {
      require_tld: S.require_tld,
      ignore_max_length: S.ignore_max_length,
      allow_underscores: S.allow_underscores
    })) {
      if (!S.allow_ip_domain)
        return !1;
      if (!(0, o.default)(E)) {
        if (!E.startsWith("[") || !E.endsWith("]"))
          return !1;
        var U = E.slice(1, -1);
        if (U.length === 0 || !(0, o.default)(U))
          return !1;
      }
    }
    if (I[0] === '"')
      return I = I.slice(1, I.length - 1), S.allow_utf8_local_part ? v.test(I) : g.test(I);
    for (var Q = S.allow_utf8_local_part ? m : f, Z = I.split("."), X = 0; X < Z.length; X++)
      if (!Q.test(Z[X]))
        return !1;
    return !(S.blacklisted_chars && I.search(new RegExp("[".concat(S.blacklisted_chars, "]+"), "g")) !== -1);
  }
  e.exports = t.default, e.exports.default = t.default;
})(iYe, K0);
var Yx = {}, sYe = {
  get exports() {
    return Yx;
  },
  set exports(e) {
    Yx = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = y;
  var r = a(xt), n = a(_p), i = a(lh), o = a(ao);
  function a(C) {
    return C && C.__esModule ? C : { default: C };
  }
  function s(C, S) {
    return g(C) || h(C, S) || d(C, S) || u();
  }
  function u() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function d(C, S) {
    if (C) {
      if (typeof C == "string")
        return f(C, S);
      var T = Object.prototype.toString.call(C).slice(8, -1);
      if (T === "Object" && C.constructor && (T = C.constructor.name), T === "Map" || T === "Set")
        return Array.from(C);
      if (T === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(T))
        return f(C, S);
    }
  }
  function f(C, S) {
    (S == null || S > C.length) && (S = C.length);
    for (var T = 0, A = new Array(S); T < S; T++)
      A[T] = C[T];
    return A;
  }
  function h(C, S) {
    if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(C)))) {
      var T = [], A = !0, D = !1, E = void 0;
      try {
        for (var N = C[Symbol.iterator](), I; !(A = (I = N.next()).done) && (T.push(I.value), !(S && T.length === S)); A = !0)
          ;
      } catch ($) {
        D = !0, E = $;
      } finally {
        try {
          !A && N.return != null && N.return();
        } finally {
          if (D)
            throw E;
        }
      }
      return T;
    }
  }
  function g(C) {
    if (Array.isArray(C))
      return C;
  }
  var m = {
    protocols: ["http", "https", "ftp"],
    require_tld: !0,
    require_protocol: !1,
    require_host: !0,
    require_port: !1,
    require_valid_protocol: !0,
    allow_underscores: !1,
    allow_trailing_dot: !1,
    allow_protocol_relative_urls: !1,
    allow_fragments: !0,
    allow_query_components: !0,
    validate_length: !0
  }, v = /^\[([^\]]+)\](?::([0-9]+))?$/;
  function w(C) {
    return Object.prototype.toString.call(C) === "[object RegExp]";
  }
  function x(C, S) {
    for (var T = 0; T < S.length; T++) {
      var A = S[T];
      if (C === A || w(A) && A.test(C))
        return !0;
    }
    return !1;
  }
  function y(C, S) {
    if ((0, r.default)(C), !C || /[\s<>]/.test(C) || C.indexOf("mailto:") === 0 || (S = (0, o.default)(S, m), S.validate_length && C.length >= 2083) || !S.allow_fragments && C.includes("#") || !S.allow_query_components && (C.includes("?") || C.includes("&")))
      return !1;
    var T, A, D, E, N, I, $, _;
    if ($ = C.split("#"), C = $.shift(), $ = C.split("?"), C = $.shift(), $ = C.split("://"), $.length > 1) {
      if (T = $.shift().toLowerCase(), S.require_valid_protocol && S.protocols.indexOf(T) === -1)
        return !1;
    } else {
      if (S.require_protocol)
        return !1;
      if (C.slice(0, 2) === "//") {
        if (!S.allow_protocol_relative_urls)
          return !1;
        $[0] = C.slice(2);
      }
    }
    if (C = $.join("://"), C === "")
      return !1;
    if ($ = C.split("/"), C = $.shift(), C === "" && !S.require_host)
      return !0;
    if ($ = C.split("@"), $.length > 1) {
      if (S.disallow_auth || $[0] === "" || (A = $.shift(), A.indexOf(":") >= 0 && A.split(":").length > 2))
        return !1;
      var R = A.split(":"), U = s(R, 2), Q = U[0], Z = U[1];
      if (Q === "" && Z === "")
        return !1;
    }
    E = $.join("@"), I = null, _ = null;
    var X = E.match(v);
    if (X ? (D = "", _ = X[1], I = X[2] || null) : ($ = E.split(":"), D = $.shift(), $.length && (I = $.join(":"))), I !== null && I.length > 0) {
      if (N = parseInt(I, 10), !/^[0-9]+$/.test(I) || N <= 0 || N > 65535)
        return !1;
    } else if (S.require_port)
      return !1;
    return S.host_whitelist ? x(D, S.host_whitelist) : D === "" && !S.require_host ? !0 : !(!(0, i.default)(D) && !(0, n.default)(D, S) && (!_ || !(0, i.default)(_, 6)) || (D = D || _, S.host_blacklist && x(D, S.host_blacklist)));
  }
  e.exports = t.default, e.exports.default = t.default;
})(sYe, Yx);
var Qx = {}, uYe = {
  get exports() {
    return Qx;
  },
  set exports(e) {
    Qx = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = f;
  var r = n(xt);
  function n(h) {
    return h && h.__esModule ? h : { default: h };
  }
  var i = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){4}([0-9a-fA-F]{2})$/, o = /^([0-9a-fA-F]){12}$/, a = /^([0-9a-fA-F]{4}\.){2}([0-9a-fA-F]{4})$/, s = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){6}([0-9a-fA-F]{2})$/, u = /^([0-9a-fA-F]){16}$/, d = /^([0-9a-fA-F]{4}\.){3}([0-9a-fA-F]{4})$/;
  function f(h, g) {
    return (0, r.default)(h), g != null && g.eui && (g.eui = String(g.eui)), g != null && g.no_colons || g != null && g.no_separators ? g.eui === "48" ? o.test(h) : g.eui === "64" ? u.test(h) : o.test(h) || u.test(h) : (g == null ? void 0 : g.eui) === "48" ? i.test(h) || a.test(h) : (g == null ? void 0 : g.eui) === "64" ? s.test(h) || d.test(h) : f(h, {
      eui: "48"
    }) || f(h, {
      eui: "64"
    });
  }
  e.exports = t.default, e.exports.default = t.default;
})(uYe, Qx);
var qx = {}, cYe = {
  get exports() {
    return qx;
  },
  set exports(e) {
    qx = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  var r = i(xt), n = i(lh);
  function i(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var o = /^\d{1,3}$/, a = 32, s = 128;
  function u(d) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    (0, r.default)(d);
    var h = d.split("/");
    if (h.length !== 2 || !o.test(h[1]) || h[1].length > 1 && h[1].startsWith("0"))
      return !1;
    var g = (0, n.default)(h[0], f);
    if (!g)
      return !1;
    var m = null;
    switch (String(f)) {
      case "4":
        m = a;
        break;
      case "6":
        m = s;
        break;
      default:
        m = (0, n.default)(h[0], "6") ? s : a;
    }
    return h[1] <= m && h[1] >= 0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(cYe, qx);
var J0 = {}, dYe = {
  get exports() {
    return J0;
  },
  set exports(e) {
    J0 = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = v;
  var r = n(ao);
  function n(w) {
    return w && w.__esModule ? w : { default: w };
  }
  function i(w, x) {
    return s(w) || a(w, x) || d(w, x) || o();
  }
  function o() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function a(w, x) {
    if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(w)))) {
      var y = [], C = !0, S = !1, T = void 0;
      try {
        for (var A = w[Symbol.iterator](), D; !(C = (D = A.next()).done) && (y.push(D.value), !(x && y.length === x)); C = !0)
          ;
      } catch (E) {
        S = !0, T = E;
      } finally {
        try {
          !C && A.return != null && A.return();
        } finally {
          if (S)
            throw T;
        }
      }
      return y;
    }
  }
  function s(w) {
    if (Array.isArray(w))
      return w;
  }
  function u(w, x) {
    var y;
    if (typeof Symbol > "u" || w[Symbol.iterator] == null) {
      if (Array.isArray(w) || (y = d(w)) || x && w && typeof w.length == "number") {
        y && (w = y);
        var C = 0, S = function() {
        };
        return { s: S, n: function() {
          return C >= w.length ? { done: !0 } : { done: !1, value: w[C++] };
        }, e: function(N) {
          throw N;
        }, f: S };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var T = !0, A = !1, D;
    return { s: function() {
      y = w[Symbol.iterator]();
    }, n: function() {
      var N = y.next();
      return T = N.done, N;
    }, e: function(N) {
      A = !0, D = N;
    }, f: function() {
      try {
        !T && y.return != null && y.return();
      } finally {
        if (A)
          throw D;
      }
    } };
  }
  function d(w, x) {
    if (w) {
      if (typeof w == "string")
        return f(w, x);
      var y = Object.prototype.toString.call(w).slice(8, -1);
      if (y === "Object" && w.constructor && (y = w.constructor.name), y === "Map" || y === "Set")
        return Array.from(w);
      if (y === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(y))
        return f(w, x);
    }
  }
  function f(w, x) {
    (x == null || x > w.length) && (x = w.length);
    for (var y = 0, C = new Array(x); y < x; y++)
      C[y] = w[y];
    return C;
  }
  var h = {
    format: "YYYY/MM/DD",
    delimiters: ["/", "-"],
    strictMode: !1
  };
  function g(w) {
    return /(^(y{4}|y{2})[.\/-](m{1,2})[.\/-](d{1,2})$)|(^(m{1,2})[.\/-](d{1,2})[.\/-]((y{4}|y{2})$))|(^(d{1,2})[.\/-](m{1,2})[.\/-]((y{4}|y{2})$))/gi.test(w);
  }
  function m(w, x) {
    for (var y = [], C = Math.min(w.length, x.length), S = 0; S < C; S++)
      y.push([w[S], x[S]]);
    return y;
  }
  function v(w, x) {
    if (typeof x == "string" ? x = (0, r.default)({
      format: x
    }, h) : x = (0, r.default)(x, h), typeof w == "string" && g(x.format)) {
      var y = x.delimiters.find(function(U) {
        return x.format.indexOf(U) !== -1;
      }), C = x.strictMode ? y : x.delimiters.find(function(U) {
        return w.indexOf(U) !== -1;
      }), S = m(w.split(C), x.format.toLowerCase().split(y)), T = {}, A = u(S), D;
      try {
        for (A.s(); !(D = A.n()).done; ) {
          var E = i(D.value, 2), N = E[0], I = E[1];
          if (N.length !== I.length)
            return !1;
          T[I.charAt(0)] = N;
        }
      } catch (U) {
        A.e(U);
      } finally {
        A.f();
      }
      var $ = T.y;
      if (T.y.length === 2) {
        var _ = parseInt(T.y, 10);
        if (isNaN(_))
          return !1;
        var R = new Date().getFullYear() % 100;
        _ < R ? $ = "20".concat(T.y) : $ = "19".concat(T.y);
      }
      return new Date("".concat($, "-").concat(T.m, "-").concat(T.d)).getDate() === +T.d;
    }
    return x.strictMode ? !1 : Object.prototype.toString.call(w) === "[object Date]" && isFinite(w);
  }
  e.exports = t.default, e.exports.default = t.default;
})(dYe, J0);
var Gx = {}, fYe = {
  get exports() {
    return Gx;
  },
  set exports(e) {
    Gx = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(ao);
  function n(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var i = {
    hourFormat: "hour24",
    mode: "default"
  }, o = {
    hour24: {
      default: /^([01]?[0-9]|2[0-3]):([0-5][0-9])$/,
      withSeconds: /^([01]?[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/
    },
    hour12: {
      default: /^(0?[1-9]|1[0-2]):([0-5][0-9]) (A|P)M$/,
      withSeconds: /^(0?[1-9]|1[0-2]):([0-5][0-9]):([0-5][0-9]) (A|P)M$/
    }
  };
  function a(s, u) {
    return u = (0, r.default)(u, i), typeof s != "string" ? !1 : o[u.hourFormat][u.mode].test(s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(fYe, Gx);
var Zx = {}, hYe = {
  get exports() {
    return Zx;
  },
  set exports(e) {
    Zx = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = n(xt);
  function n(u) {
    return u && u.__esModule ? u : { default: u };
  }
  var i = {
    loose: !1
  }, o = ["true", "false", "1", "0"], a = [].concat(o, ["yes", "no"]);
  function s(u) {
    var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : i;
    return (0, r.default)(u), d.loose ? a.includes(u.toLowerCase()) : o.includes(u);
  }
  e.exports = t.default, e.exports.default = t.default;
})(hYe, Zx);
var Kx = {}, pYe = {
  get exports() {
    return Kx;
  },
  set exports(e) {
    Kx = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = C;
  var r = n(xt);
  function n(S) {
    return S && S.__esModule ? S : { default: S };
  }
  var i = "([A-Za-z]{3}(-[A-Za-z]{3}){0,2})", o = "(([a-zA-Z]{2,3}(-".concat(i, ")?)|([a-zA-Z]{5,8}))"), a = "([A-Za-z]{4})", s = "([A-Za-z]{2}|\\d{3})", u = "([A-Za-z0-9]{5,8}|(\\d[A-Z-a-z0-9]{3}))", d = "(\\d|[A-W]|[Y-Z]|[a-w]|[y-z])", f = "(".concat(d, "(-[A-Za-z0-9]{2,8})+)"), h = "(x(-[A-Za-z0-9]{1,8})+)", g = "((en-GB-oed)|(i-ami)|(i-bnn)|(i-default)|(i-enochian)|(i-hak)|(i-klingon)|(i-lux)|(i-mingo)|(i-navajo)|(i-pwn)|(i-tao)|(i-tay)|(i-tsu)|(sgn-BE-FR)|(sgn-BE-NL)|(sgn-CH-DE))", m = "((art-lojban)|(cel-gaulish)|(no-bok)|(no-nyn)|(zh-guoyu)|(zh-hakka)|(zh-min)|(zh-min-nan)|(zh-xiang))", v = "(".concat(g, "|").concat(m, ")"), w = "(-|_)", x = "".concat(o, "(").concat(w).concat(a, ")?(").concat(w).concat(s, ")?(").concat(w).concat(u, ")*(").concat(w).concat(f, ")*(").concat(w).concat(h, ")?"), y = new RegExp("(^".concat(h, "$)|(^").concat(v, "$)|(^").concat(x, "$)"));
  function C(S) {
    return (0, r.default)(S), y.test(S);
  }
  e.exports = t.default, e.exports.default = t.default;
})(pYe, Kx);
var Lb = {};
Object.defineProperty(Lb, "__esModule", {
  value: !0
});
Lb.default = vYe;
Lb.locales = void 0;
var gYe = mYe(xt), vO = ei;
function mYe(e) {
  return e && e.__esModule ? e : { default: e };
}
function vYe(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US", r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  (0, gYe.default)(e);
  var n = e, i = r.ignore;
  if (i)
    if (i instanceof RegExp)
      n = n.replace(i, "");
    else if (typeof i == "string")
      n = n.replace(new RegExp("[".concat(i.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, "\\$&"), "]"), "g"), "");
    else
      throw new Error("ignore should be instance of a String or RegExp");
  if (t in vO.alpha)
    return vO.alpha[t].test(n);
  throw new Error("Invalid locale '".concat(t, "'"));
}
var bYe = Object.keys(vO.alpha);
Lb.locales = bYe;
var Pb = {};
Object.defineProperty(Pb, "__esModule", {
  value: !0
});
Pb.default = wYe;
Pb.locales = void 0;
var yYe = xYe(xt), bO = ei;
function xYe(e) {
  return e && e.__esModule ? e : { default: e };
}
function wYe(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US", r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  (0, yYe.default)(e);
  var n = e, i = r.ignore;
  if (i)
    if (i instanceof RegExp)
      n = n.replace(i, "");
    else if (typeof i == "string")
      n = n.replace(new RegExp("[".concat(i.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, "\\$&"), "]"), "g"), "");
    else
      throw new Error("ignore should be instance of a String or RegExp");
  if (t in bO.alphanumeric)
    return bO.alphanumeric[t].test(n);
  throw new Error("Invalid locale '".concat(t, "'"));
}
var MYe = Object.keys(bO.alphanumeric);
Pb.locales = MYe;
var Xx = {}, CYe = {
  get exports() {
    return Xx;
  },
  set exports(e) {
    Xx = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = i(xt), n = ei;
  function i(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var o = /^[0-9]+$/;
  function a(s, u) {
    return (0, r.default)(s), u && u.no_symbols ? o.test(s) : new RegExp("^[+-]?([0-9]*[".concat((u || {}).locale ? n.decimal[u.locale] : ".", "])?[0-9]+$")).test(s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(CYe, Xx);
var Jx = {}, SYe = {
  get exports() {
    return Jx;
  },
  set exports(e) {
    Jx = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(xt);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var i = {
    AM: /^[A-Z]{2}\d{7}$/,
    // ARMENIA
    AR: /^[A-Z]{3}\d{6}$/,
    // ARGENTINA
    AT: /^[A-Z]\d{7}$/,
    // AUSTRIA
    AU: /^[A-Z]\d{7}$/,
    // AUSTRALIA
    AZ: /^[A-Z]{2,3}\d{7,8}$/,
    // AZERBAIJAN
    BE: /^[A-Z]{2}\d{6}$/,
    // BELGIUM
    BG: /^\d{9}$/,
    // BULGARIA
    BR: /^[A-Z]{2}\d{6}$/,
    // BRAZIL
    BY: /^[A-Z]{2}\d{7}$/,
    // BELARUS
    CA: /^[A-Z]{2}\d{6}$/,
    // CANADA
    CH: /^[A-Z]\d{7}$/,
    // SWITZERLAND
    CN: /^G\d{8}$|^E(?![IO])[A-Z0-9]\d{7}$/,
    // CHINA [G=Ordinary, E=Electronic] followed by 8-digits, or E followed by any UPPERCASE letter (except I and O) followed by 7 digits
    CY: /^[A-Z](\d{6}|\d{8})$/,
    // CYPRUS
    CZ: /^\d{8}$/,
    // CZECH REPUBLIC
    DE: /^[CFGHJKLMNPRTVWXYZ0-9]{9}$/,
    // GERMANY
    DK: /^\d{9}$/,
    // DENMARK
    DZ: /^\d{9}$/,
    // ALGERIA
    EE: /^([A-Z]\d{7}|[A-Z]{2}\d{7})$/,
    // ESTONIA (K followed by 7-digits), e-passports have 2 UPPERCASE followed by 7 digits
    ES: /^[A-Z0-9]{2}([A-Z0-9]?)\d{6}$/,
    // SPAIN
    FI: /^[A-Z]{2}\d{7}$/,
    // FINLAND
    FR: /^\d{2}[A-Z]{2}\d{5}$/,
    // FRANCE
    GB: /^\d{9}$/,
    // UNITED KINGDOM
    GR: /^[A-Z]{2}\d{7}$/,
    // GREECE
    HR: /^\d{9}$/,
    // CROATIA
    HU: /^[A-Z]{2}(\d{6}|\d{7})$/,
    // HUNGARY
    IE: /^[A-Z0-9]{2}\d{7}$/,
    // IRELAND
    IN: /^[A-Z]{1}-?\d{7}$/,
    // INDIA
    ID: /^[A-C]\d{7}$/,
    // INDONESIA
    IR: /^[A-Z]\d{8}$/,
    // IRAN
    IS: /^(A)\d{7}$/,
    // ICELAND
    IT: /^[A-Z0-9]{2}\d{7}$/,
    // ITALY
    JM: /^[Aa]\d{7}$/,
    // JAMAICA
    JP: /^[A-Z]{2}\d{7}$/,
    // JAPAN
    KR: /^[MS]\d{8}$/,
    // SOUTH KOREA, REPUBLIC OF KOREA, [S=PS Passports, M=PM Passports]
    KZ: /^[a-zA-Z]\d{7}$/,
    // KAZAKHSTAN
    LI: /^[a-zA-Z]\d{5}$/,
    // LIECHTENSTEIN
    LT: /^[A-Z0-9]{8}$/,
    // LITHUANIA
    LU: /^[A-Z0-9]{8}$/,
    // LUXEMBURG
    LV: /^[A-Z0-9]{2}\d{7}$/,
    // LATVIA
    LY: /^[A-Z0-9]{8}$/,
    // LIBYA
    MT: /^\d{7}$/,
    // MALTA
    MZ: /^([A-Z]{2}\d{7})|(\d{2}[A-Z]{2}\d{5})$/,
    // MOZAMBIQUE
    MY: /^[AHK]\d{8}$/,
    // MALAYSIA
    MX: /^\d{10,11}$/,
    // MEXICO
    NL: /^[A-Z]{2}[A-Z0-9]{6}\d$/,
    // NETHERLANDS
    NZ: /^([Ll]([Aa]|[Dd]|[Ff]|[Hh])|[Ee]([Aa]|[Pp])|[Nn])\d{6}$/,
    // NEW ZEALAND
    PH: /^([A-Z](\d{6}|\d{7}[A-Z]))|([A-Z]{2}(\d{6}|\d{7}))$/,
    // PHILIPPINES
    PK: /^[A-Z]{2}\d{7}$/,
    // PAKISTAN
    PL: /^[A-Z]{2}\d{7}$/,
    // POLAND
    PT: /^[A-Z]\d{6}$/,
    // PORTUGAL
    RO: /^\d{8,9}$/,
    // ROMANIA
    RU: /^\d{9}$/,
    // RUSSIAN FEDERATION
    SE: /^\d{8}$/,
    // SWEDEN
    SL: /^(P)[A-Z]\d{7}$/,
    // SLOVENIA
    SK: /^[0-9A-Z]\d{7}$/,
    // SLOVAKIA
    TH: /^[A-Z]{1,2}\d{6,7}$/,
    // THAILAND
    TR: /^[A-Z]\d{8}$/,
    // TURKEY
    UA: /^[A-Z]{2}\d{6}$/,
    // UKRAINE
    US: /^\d{9}$/
    // UNITED STATES
  };
  function o(a, s) {
    (0, r.default)(a);
    var u = a.replace(/\s/g, "").toUpperCase();
    return s.toUpperCase() in i && i[s].test(u);
  }
  e.exports = t.default, e.exports.default = t.default;
})(SYe, Jx);
var ew = {}, TYe = {
  get exports() {
    return ew;
  },
  set exports(e) {
    ew = e;
  }
}, Lp = {}, kYe = {
  get exports() {
    return Lp;
  },
  set exports(e) {
    Lp = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(xt);
  function n(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var i = /^(?:[-+]?(?:0|[1-9][0-9]*))$/, o = /^[-+]?[0-9]+$/;
  function a(s, u) {
    (0, r.default)(s), u = u || {};
    var d = u.hasOwnProperty("allow_leading_zeroes") && !u.allow_leading_zeroes ? i : o, f = !u.hasOwnProperty("min") || s >= u.min, h = !u.hasOwnProperty("max") || s <= u.max, g = !u.hasOwnProperty("lt") || s < u.lt, m = !u.hasOwnProperty("gt") || s > u.gt;
    return d.test(s) && f && h && g && m;
  }
  e.exports = t.default, e.exports.default = t.default;
})(kYe, Lp);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Lp);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o) {
    return (0, r.default)(o, {
      min: 0,
      max: 65535
    });
  }
  e.exports = t.default, e.exports.default = t.default;
})(TYe, ew);
var tw = {}, DYe = {
  get exports() {
    return tw;
  },
  set exports(e) {
    tw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(xt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o) {
    return (0, r.default)(o), o === o.toLowerCase();
  }
  e.exports = t.default, e.exports.default = t.default;
})(DYe, tw);
var rw = {}, AYe = {
  get exports() {
    return rw;
  },
  set exports(e) {
    rw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(xt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o) {
    return (0, r.default)(o), o === o.toUpperCase();
  }
  e.exports = t.default, e.exports.default = t.default;
})(AYe, rw);
var nw = {}, EYe = {
  get exports() {
    return nw;
  },
  set exports(e) {
    nw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(xt);
  function n(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var i = /^[0-9]{15}$/, o = /^\d{2}-\d{6}-\d{6}-\d{1}$/;
  function a(s, u) {
    (0, r.default)(s), u = u || {};
    var d = i;
    if (u.allow_hyphens && (d = o), !d.test(s))
      return !1;
    s = s.replace(/-/g, "");
    for (var f = 0, h = 2, g = 14, m = 0; m < g; m++) {
      var v = s.substring(g - m - 1, g - m), w = parseInt(v, 10) * h;
      w >= 10 ? f += w % 10 + 1 : f += w, h === 1 ? h += 1 : h -= 1;
    }
    var x = (10 - f % 10) % 10;
    return x === parseInt(s.substring(14, 15), 10);
  }
  e.exports = t.default, e.exports.default = t.default;
})(EYe, nw);
var iw = {}, IYe = {
  get exports() {
    return iw;
  },
  set exports(e) {
    iw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(xt);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var i = /^[\x00-\x7F]+$/;
  function o(a) {
    return (0, r.default)(a), i.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(IYe, iw);
var rg = {};
Object.defineProperty(rg, "__esModule", {
  value: !0
});
rg.default = $Ye;
rg.fullWidth = void 0;
var NYe = zYe(xt);
function zYe(e) {
  return e && e.__esModule ? e : { default: e };
}
var sG = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
rg.fullWidth = sG;
function $Ye(e) {
  return (0, NYe.default)(e), sG.test(e);
}
var ng = {};
Object.defineProperty(ng, "__esModule", {
  value: !0
});
ng.default = LYe;
ng.halfWidth = void 0;
var OYe = _Ye(xt);
function _Ye(e) {
  return e && e.__esModule ? e : { default: e };
}
var uG = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
ng.halfWidth = uG;
function LYe(e) {
  return (0, OYe.default)(e), uG.test(e);
}
var ow = {}, PYe = {
  get exports() {
    return ow;
  },
  set exports(e) {
    ow = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = o(xt), n = rg, i = ng;
  function o(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function a(s) {
    return (0, r.default)(s), n.fullWidth.test(s) && i.halfWidth.test(s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(PYe, ow);
var aw = {}, RYe = {
  get exports() {
    return aw;
  },
  set exports(e) {
    aw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(xt);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var i = /[^\x00-\x7F]/;
  function o(a) {
    return (0, r.default)(a), i.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(RYe, aw);
var lw = {}, jYe = {
  get exports() {
    return lw;
  },
  set exports(e) {
    lw = e;
  }
}, sw = {}, FYe = {
  get exports() {
    return sw;
  },
  set exports(e) {
    sw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(n, i) {
    var o = n.join("");
    return new RegExp(o, i);
  }
  e.exports = t.default, e.exports.default = t.default;
})(FYe, sw);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = i(xt), n = i(sw);
  function i(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var o = (0, n.default)(["^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)", "(?:-((?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*))*))", "?(?:\\+([0-9a-z-]+(?:\\.[0-9a-z-]+)*))?$"], "i");
  function a(s) {
    return (0, r.default)(s), o.test(s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(jYe, lw);
var uw = {}, BYe = {
  get exports() {
    return uw;
  },
  set exports(e) {
    uw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(xt);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var i = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
  function o(a) {
    return (0, r.default)(a), i.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(BYe, uw);
var cw = {}, UYe = {
  get exports() {
    return cw;
  },
  set exports(e) {
    cw = e;
  }
}, dw = {}, HYe = {
  get exports() {
    return dw;
  },
  set exports(e) {
    dw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = function(o, a) {
    return o.some(function(s) {
      return a === s;
    });
  }, n = r;
  t.default = n, e.exports = t.default, e.exports.default = t.default;
})(HYe, dw);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = f;
  var r = a(ao), n = a(xt), i = a(dw), o = ei;
  function a(h) {
    return h && h.__esModule ? h : { default: h };
  }
  function s(h) {
    var g = new RegExp("^[-+]?([0-9]+)?(\\".concat(o.decimal[h.locale], "[0-9]{").concat(h.decimal_digits, "})").concat(h.force_decimal ? "" : "?", "$"));
    return g;
  }
  var u = {
    force_decimal: !1,
    decimal_digits: "1,",
    locale: "en-US"
  }, d = ["", "-", "+"];
  function f(h, g) {
    if ((0, n.default)(h), g = (0, r.default)(g, u), g.locale in o.decimal)
      return !(0, i.default)(d, h.replace(/ /g, "")) && s(g).test(h);
    throw new Error("Invalid locale '".concat(g.locale, "'"));
  }
  e.exports = t.default, e.exports.default = t.default;
})(UYe, cw);
var eb = {}, WYe = {
  get exports() {
    return eb;
  },
  set exports(e) {
    eb = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(xt);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var i = /^(0x|0h)?[0-9A-F]+$/i;
  function o(a) {
    return (0, r.default)(a), i.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(WYe, eb);
var fw = {}, VYe = {
  get exports() {
    return fw;
  },
  set exports(e) {
    fw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(xt);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var i = /^(0o)?[0-7]+$/i;
  function o(a) {
    return (0, r.default)(a), i.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(VYe, fw);
var hw = {}, YYe = {
  get exports() {
    return hw;
  },
  set exports(e) {
    hw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = i(xt), n = i(G0);
  function i(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function o(a, s) {
    return (0, r.default)(a), (0, n.default)(a) % parseInt(s, 10) === 0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(YYe, hw);
var pw = {}, QYe = {
  get exports() {
    return pw;
  },
  set exports(e) {
    pw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(xt);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var i = /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;
  function o(a) {
    return (0, r.default)(a), i.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(QYe, pw);
var gw = {}, qYe = {
  get exports() {
    return gw;
  },
  set exports(e) {
    gw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  var r = n(xt);
  function n(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var i = /^rgb\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){2}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\)$/, o = /^rgba\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/, a = /^rgb\((([0-9]%|[1-9][0-9]%|100%),){2}([0-9]%|[1-9][0-9]%|100%)\)$/, s = /^rgba\((([0-9]%|[1-9][0-9]%|100%),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/;
  function u(d) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    return (0, r.default)(d), f ? i.test(d) || o.test(d) || a.test(d) || s.test(d) : i.test(d) || o.test(d);
  }
  e.exports = t.default, e.exports.default = t.default;
})(qYe, gw);
var mw = {}, GYe = {
  get exports() {
    return mw;
  },
  set exports(e) {
    mw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(xt);
  function n(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var i = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(,(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}(,((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?))?\)$/i, o = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(\s(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}\s?(\/\s((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?)\s?)?\)$/i;
  function a(s) {
    (0, r.default)(s);
    var u = s.replace(/\s+/g, " ").replace(/\s?(hsla?\(|\)|,)\s?/ig, "$1");
    return u.indexOf(",") !== -1 ? i.test(u) : o.test(u);
  }
  e.exports = t.default, e.exports.default = t.default;
})(GYe, mw);
var vw = {}, ZYe = {
  get exports() {
    return vw;
  },
  set exports(e) {
    vw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(xt);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var i = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;
  function o(a) {
    return (0, r.default)(a), i.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(ZYe, vw);
var Rb = {};
Object.defineProperty(Rb, "__esModule", {
  value: !0
});
Rb.default = rQe;
Rb.locales = void 0;
var KYe = XYe(xt);
function XYe(e) {
  return e && e.__esModule ? e : { default: e };
}
var bw = {
  AD: /^(AD[0-9]{2})\d{8}[A-Z0-9]{12}$/,
  AE: /^(AE[0-9]{2})\d{3}\d{16}$/,
  AL: /^(AL[0-9]{2})\d{8}[A-Z0-9]{16}$/,
  AT: /^(AT[0-9]{2})\d{16}$/,
  AZ: /^(AZ[0-9]{2})[A-Z0-9]{4}\d{20}$/,
  BA: /^(BA[0-9]{2})\d{16}$/,
  BE: /^(BE[0-9]{2})\d{12}$/,
  BG: /^(BG[0-9]{2})[A-Z]{4}\d{6}[A-Z0-9]{8}$/,
  BH: /^(BH[0-9]{2})[A-Z]{4}[A-Z0-9]{14}$/,
  BR: /^(BR[0-9]{2})\d{23}[A-Z]{1}[A-Z0-9]{1}$/,
  BY: /^(BY[0-9]{2})[A-Z0-9]{4}\d{20}$/,
  CH: /^(CH[0-9]{2})\d{5}[A-Z0-9]{12}$/,
  CR: /^(CR[0-9]{2})\d{18}$/,
  CY: /^(CY[0-9]{2})\d{8}[A-Z0-9]{16}$/,
  CZ: /^(CZ[0-9]{2})\d{20}$/,
  DE: /^(DE[0-9]{2})\d{18}$/,
  DK: /^(DK[0-9]{2})\d{14}$/,
  DO: /^(DO[0-9]{2})[A-Z]{4}\d{20}$/,
  EE: /^(EE[0-9]{2})\d{16}$/,
  EG: /^(EG[0-9]{2})\d{25}$/,
  ES: /^(ES[0-9]{2})\d{20}$/,
  FI: /^(FI[0-9]{2})\d{14}$/,
  FO: /^(FO[0-9]{2})\d{14}$/,
  FR: /^(FR[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
  GB: /^(GB[0-9]{2})[A-Z]{4}\d{14}$/,
  GE: /^(GE[0-9]{2})[A-Z0-9]{2}\d{16}$/,
  GI: /^(GI[0-9]{2})[A-Z]{4}[A-Z0-9]{15}$/,
  GL: /^(GL[0-9]{2})\d{14}$/,
  GR: /^(GR[0-9]{2})\d{7}[A-Z0-9]{16}$/,
  GT: /^(GT[0-9]{2})[A-Z0-9]{4}[A-Z0-9]{20}$/,
  HR: /^(HR[0-9]{2})\d{17}$/,
  HU: /^(HU[0-9]{2})\d{24}$/,
  IE: /^(IE[0-9]{2})[A-Z0-9]{4}\d{14}$/,
  IL: /^(IL[0-9]{2})\d{19}$/,
  IQ: /^(IQ[0-9]{2})[A-Z]{4}\d{15}$/,
  IR: /^(IR[0-9]{2})0\d{2}0\d{18}$/,
  IS: /^(IS[0-9]{2})\d{22}$/,
  IT: /^(IT[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
  JO: /^(JO[0-9]{2})[A-Z]{4}\d{22}$/,
  KW: /^(KW[0-9]{2})[A-Z]{4}[A-Z0-9]{22}$/,
  KZ: /^(KZ[0-9]{2})\d{3}[A-Z0-9]{13}$/,
  LB: /^(LB[0-9]{2})\d{4}[A-Z0-9]{20}$/,
  LC: /^(LC[0-9]{2})[A-Z]{4}[A-Z0-9]{24}$/,
  LI: /^(LI[0-9]{2})\d{5}[A-Z0-9]{12}$/,
  LT: /^(LT[0-9]{2})\d{16}$/,
  LU: /^(LU[0-9]{2})\d{3}[A-Z0-9]{13}$/,
  LV: /^(LV[0-9]{2})[A-Z]{4}[A-Z0-9]{13}$/,
  MA: /^(MA[0-9]{26})$/,
  MC: /^(MC[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
  MD: /^(MD[0-9]{2})[A-Z0-9]{20}$/,
  ME: /^(ME[0-9]{2})\d{18}$/,
  MK: /^(MK[0-9]{2})\d{3}[A-Z0-9]{10}\d{2}$/,
  MR: /^(MR[0-9]{2})\d{23}$/,
  MT: /^(MT[0-9]{2})[A-Z]{4}\d{5}[A-Z0-9]{18}$/,
  MU: /^(MU[0-9]{2})[A-Z]{4}\d{19}[A-Z]{3}$/,
  MZ: /^(MZ[0-9]{2})\d{21}$/,
  NL: /^(NL[0-9]{2})[A-Z]{4}\d{10}$/,
  NO: /^(NO[0-9]{2})\d{11}$/,
  PK: /^(PK[0-9]{2})[A-Z0-9]{4}\d{16}$/,
  PL: /^(PL[0-9]{2})\d{24}$/,
  PS: /^(PS[0-9]{2})[A-Z0-9]{4}\d{21}$/,
  PT: /^(PT[0-9]{2})\d{21}$/,
  QA: /^(QA[0-9]{2})[A-Z]{4}[A-Z0-9]{21}$/,
  RO: /^(RO[0-9]{2})[A-Z]{4}[A-Z0-9]{16}$/,
  RS: /^(RS[0-9]{2})\d{18}$/,
  SA: /^(SA[0-9]{2})\d{2}[A-Z0-9]{18}$/,
  SC: /^(SC[0-9]{2})[A-Z]{4}\d{20}[A-Z]{3}$/,
  SE: /^(SE[0-9]{2})\d{20}$/,
  SI: /^(SI[0-9]{2})\d{15}$/,
  SK: /^(SK[0-9]{2})\d{20}$/,
  SM: /^(SM[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
  SV: /^(SV[0-9]{2})[A-Z0-9]{4}\d{20}$/,
  TL: /^(TL[0-9]{2})\d{19}$/,
  TN: /^(TN[0-9]{2})\d{20}$/,
  TR: /^(TR[0-9]{2})\d{5}[A-Z0-9]{17}$/,
  UA: /^(UA[0-9]{2})\d{6}[A-Z0-9]{19}$/,
  VA: /^(VA[0-9]{2})\d{18}$/,
  VG: /^(VG[0-9]{2})[A-Z0-9]{4}\d{16}$/,
  XK: /^(XK[0-9]{2})\d{16}$/
};
function JYe(e) {
  var t = e.filter(function(r) {
    return !(r in bw);
  });
  return !(t.length > 0);
}
function eQe(e, t) {
  var r = e.replace(/[\s\-]+/gi, "").toUpperCase(), n = r.slice(0, 2).toUpperCase(), i = n in bw;
  if (t.whitelist) {
    if (!JYe(t.whitelist))
      return !1;
    var o = t.whitelist.includes(n);
    if (!o)
      return !1;
  }
  if (t.blacklist) {
    var a = t.blacklist.includes(n);
    if (a)
      return !1;
  }
  return i && bw[n].test(r);
}
function tQe(e) {
  var t = e.replace(/[^A-Z0-9]+/gi, "").toUpperCase(), r = t.slice(4) + t.slice(0, 4), n = r.replace(/[A-Z]/g, function(o) {
    return o.charCodeAt(0) - 55;
  }), i = n.match(/\d{1,7}/g).reduce(function(o, a) {
    return Number(o + a) % 97;
  }, "");
  return i === 1;
}
function rQe(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return (0, KYe.default)(e), eQe(e, t) && tQe(e);
}
var nQe = Object.keys(bw);
Rb.locales = nQe;
var yw = {}, iQe = {
  get exports() {
    return yw;
  },
  set exports(e) {
    yw = e;
  }
}, ig = {};
Object.defineProperty(ig, "__esModule", {
  value: !0
});
ig.default = lQe;
ig.CountryCodes = void 0;
var oQe = aQe(xt);
function aQe(e) {
  return e && e.__esModule ? e : { default: e };
}
var cG = /* @__PURE__ */ new Set(["AD", "AE", "AF", "AG", "AI", "AL", "AM", "AO", "AQ", "AR", "AS", "AT", "AU", "AW", "AX", "AZ", "BA", "BB", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BL", "BM", "BN", "BO", "BQ", "BR", "BS", "BT", "BV", "BW", "BY", "BZ", "CA", "CC", "CD", "CF", "CG", "CH", "CI", "CK", "CL", "CM", "CN", "CO", "CR", "CU", "CV", "CW", "CX", "CY", "CZ", "DE", "DJ", "DK", "DM", "DO", "DZ", "EC", "EE", "EG", "EH", "ER", "ES", "ET", "FI", "FJ", "FK", "FM", "FO", "FR", "GA", "GB", "GD", "GE", "GF", "GG", "GH", "GI", "GL", "GM", "GN", "GP", "GQ", "GR", "GS", "GT", "GU", "GW", "GY", "HK", "HM", "HN", "HR", "HT", "HU", "ID", "IE", "IL", "IM", "IN", "IO", "IQ", "IR", "IS", "IT", "JE", "JM", "JO", "JP", "KE", "KG", "KH", "KI", "KM", "KN", "KP", "KR", "KW", "KY", "KZ", "LA", "LB", "LC", "LI", "LK", "LR", "LS", "LT", "LU", "LV", "LY", "MA", "MC", "MD", "ME", "MF", "MG", "MH", "MK", "ML", "MM", "MN", "MO", "MP", "MQ", "MR", "MS", "MT", "MU", "MV", "MW", "MX", "MY", "MZ", "NA", "NC", "NE", "NF", "NG", "NI", "NL", "NO", "NP", "NR", "NU", "NZ", "OM", "PA", "PE", "PF", "PG", "PH", "PK", "PL", "PM", "PN", "PR", "PS", "PT", "PW", "PY", "QA", "RE", "RO", "RS", "RU", "RW", "SA", "SB", "SC", "SD", "SE", "SG", "SH", "SI", "SJ", "SK", "SL", "SM", "SN", "SO", "SR", "SS", "ST", "SV", "SX", "SY", "SZ", "TC", "TD", "TF", "TG", "TH", "TJ", "TK", "TL", "TM", "TN", "TO", "TR", "TT", "TV", "TW", "TZ", "UA", "UG", "UM", "US", "UY", "UZ", "VA", "VC", "VE", "VG", "VI", "VN", "VU", "WF", "WS", "YE", "YT", "ZA", "ZM", "ZW"]);
function lQe(e) {
  return (0, oQe.default)(e), cG.has(e.toUpperCase());
}
var sQe = cG;
ig.CountryCodes = sQe;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = i(xt), n = ig;
  function i(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var o = /^[A-Za-z]{6}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;
  function a(s) {
    (0, r.default)(s);
    var u = s.slice(4, 6).toUpperCase();
    return !n.CountryCodes.has(u) && u !== "XK" ? !1 : o.test(s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(iQe, yw);
var xw = {}, uQe = {
  get exports() {
    return xw;
  },
  set exports(e) {
    xw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(xt);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var i = /^[a-f0-9]{32}$/;
  function o(a) {
    return (0, r.default)(a), i.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(uQe, xw);
var ww = {}, cQe = {
  get exports() {
    return ww;
  },
  set exports(e) {
    ww = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(xt);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var i = {
    md5: 32,
    md4: 32,
    sha1: 40,
    sha256: 64,
    sha384: 96,
    sha512: 128,
    ripemd128: 32,
    ripemd160: 40,
    tiger128: 32,
    tiger160: 40,
    tiger192: 48,
    crc32: 8,
    crc32b: 8
  };
  function o(a, s) {
    (0, r.default)(a);
    var u = new RegExp("^[a-fA-F0-9]{".concat(i[s], "}$"));
    return u.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(cQe, ww);
var Mw = {}, dQe = {
  get exports() {
    return Mw;
  },
  set exports(e) {
    Mw = e;
  }
}, tb = {}, fQe = {
  get exports() {
    return tb;
  },
  set exports(e) {
    tb = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  var r = i(xt), n = i(ao);
  function i(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var o = /[^A-Z0-9+\/=]/i, a = /^[A-Z0-9_\-]*$/i, s = {
    urlSafe: !1
  };
  function u(d, f) {
    (0, r.default)(d), f = (0, n.default)(f, s);
    var h = d.length;
    if (f.urlSafe)
      return a.test(d);
    if (h % 4 !== 0 || o.test(d))
      return !1;
    var g = d.indexOf("=");
    return g === -1 || g === h - 1 || g === h - 2 && d[h - 1] === "=";
  }
  e.exports = t.default, e.exports.default = t.default;
})(fQe, tb);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = i(xt), n = i(tb);
  function i(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function o(a) {
    (0, r.default)(a);
    var s = a.split("."), u = s.length;
    return u !== 3 ? !1 : s.reduce(function(d, f) {
      return d && (0, n.default)(f, {
        urlSafe: !0
      });
    }, !0);
  }
  e.exports = t.default, e.exports.default = t.default;
})(dQe, Mw);
var Cw = {}, hQe = {
  get exports() {
    return Cw;
  },
  set exports(e) {
    Cw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = i(xt), n = i(ao);
  function i(u) {
    return u && u.__esModule ? u : { default: u };
  }
  function o(u) {
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? o = function(f) {
      return typeof f;
    } : o = function(f) {
      return f && typeof Symbol == "function" && f.constructor === Symbol && f !== Symbol.prototype ? "symbol" : typeof f;
    }, o(u);
  }
  var a = {
    allow_primitives: !1
  };
  function s(u, d) {
    (0, r.default)(u);
    try {
      d = (0, n.default)(d, a);
      var f = [];
      d.allow_primitives && (f = [null, !1, !0]);
      var h = JSON.parse(u);
      return f.includes(h) || !!h && o(h) === "object";
    } catch {
    }
    return !1;
  }
  e.exports = t.default, e.exports.default = t.default;
})(hQe, Cw);
var Sw = {}, pQe = {
  get exports() {
    return Sw;
  },
  set exports(e) {
    Sw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = i(xt), n = i(ao);
  function i(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var o = {
    ignore_whitespace: !1
  };
  function a(s, u) {
    return (0, r.default)(s), u = (0, n.default)(u, o), (u.ignore_whitespace ? s.trim().length : s.length) === 0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(pQe, Sw);
var Tw = {}, gQe = {
  get exports() {
    return Tw;
  },
  set exports(e) {
    Tw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(xt);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function i(a) {
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? i = function(u) {
      return typeof u;
    } : i = function(u) {
      return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
    }, i(a);
  }
  function o(a, s) {
    (0, r.default)(a);
    var u, d;
    i(s) === "object" ? (u = s.min || 0, d = s.max) : (u = arguments[1] || 0, d = arguments[2]);
    var f = a.match(/(\uFE0F|\uFE0E)/g) || [], h = a.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [], g = a.length - f.length - h.length;
    return g >= u && (typeof d > "u" || g <= d);
  }
  e.exports = t.default, e.exports.default = t.default;
})(gQe, Tw);
var kw = {}, mQe = {
  get exports() {
    return kw;
  },
  set exports(e) {
    kw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(xt);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var i = {
    1: /^[0-9A-F]{8}-[0-9A-F]{4}-1[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    2: /^[0-9A-F]{8}-[0-9A-F]{4}-2[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
  };
  function o(a, s) {
    (0, r.default)(a);
    var u = i[[void 0, null].includes(s) ? "all" : s];
    return !!u && u.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(mQe, kw);
var Dw = {}, vQe = {
  get exports() {
    return Dw;
  },
  set exports(e) {
    Dw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = i(xt), n = i(eb);
  function i(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function o(a) {
    return (0, r.default)(a), (0, n.default)(a) && a.length === 24;
  }
  e.exports = t.default, e.exports.default = t.default;
})(vQe, Dw);
var Aw = {}, bQe = {
  get exports() {
    return Aw;
  },
  set exports(e) {
    Aw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(Op);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o, a) {
    var s = (a == null ? void 0 : a.comparisonDate) || a || Date().toString(), u = (0, r.default)(s), d = (0, r.default)(o);
    return !!(d && u && d > u);
  }
  e.exports = t.default, e.exports.default = t.default;
})(bQe, Aw);
var Ew = {}, yQe = {
  get exports() {
    return Ew;
  },
  set exports(e) {
    Ew = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = i(xt), n = i(Op);
  function i(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function o(a) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : String(new Date());
    (0, r.default)(a);
    var u = (0, n.default)(s), d = (0, n.default)(a);
    return !!(d && u && d < u);
  }
  e.exports = t.default, e.exports.default = t.default;
})(yQe, Ew);
var Iw = {}, xQe = {
  get exports() {
    return Iw;
  },
  set exports(e) {
    Iw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = i(xt), n = i(Z0);
  function i(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function o(s) {
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? o = function(d) {
      return typeof d;
    } : o = function(d) {
      return d && typeof Symbol == "function" && d.constructor === Symbol && d !== Symbol.prototype ? "symbol" : typeof d;
    }, o(s);
  }
  function a(s, u) {
    (0, r.default)(s);
    var d;
    if (Object.prototype.toString.call(u) === "[object Array]") {
      var f = [];
      for (d in u)
        ({}).hasOwnProperty.call(u, d) && (f[d] = (0, n.default)(u[d]));
      return f.indexOf(s) >= 0;
    } else {
      if (o(u) === "object")
        return u.hasOwnProperty(s);
      if (u && typeof u.indexOf == "function")
        return u.indexOf(s) >= 0;
    }
    return !1;
  }
  e.exports = t.default, e.exports.default = t.default;
})(xQe, Iw);
var rb = {}, wQe = {
  get exports() {
    return rb;
  },
  set exports(e) {
    rb = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(xt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o) {
    (0, r.default)(o);
    for (var a = o.replace(/[- ]+/g, ""), s = 0, u, d, f, h = a.length - 1; h >= 0; h--)
      u = a.substring(h, h + 1), d = parseInt(u, 10), f ? (d *= 2, d >= 10 ? s += d % 10 + 1 : s += d) : s += d, f = !f;
    return !!(s % 10 === 0 && a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(wQe, rb);
var Nw = {}, MQe = {
  get exports() {
    return Nw;
  },
  set exports(e) {
    Nw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = i(xt), n = i(rb);
  function i(u) {
    return u && u.__esModule ? u : { default: u };
  }
  var o = {
    amex: /^3[47][0-9]{13}$/,
    dinersclub: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
    discover: /^6(?:011|5[0-9][0-9])[0-9]{12,15}$/,
    jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
    mastercard: /^5[1-5][0-9]{2}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/,
    // /^[25][1-7][0-9]{14}$/;
    unionpay: /^(6[27][0-9]{14}|^(81[0-9]{14,17}))$/,
    visa: /^(?:4[0-9]{12})(?:[0-9]{3,6})?$/
  }, a = function() {
    var u = [];
    for (var d in o)
      o.hasOwnProperty(d) && u.push(o[d]);
    return u;
  }();
  function s(u) {
    var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (0, r.default)(u);
    var f = d.provider, h = u.replace(/[- ]+/g, "");
    if (f && f.toLowerCase() in o) {
      if (!o[f.toLowerCase()].test(h))
        return !1;
    } else {
      if (f && !(f.toLowerCase() in o))
        throw new Error("".concat(f, " is not a valid credit card provider."));
      if (!a.some(function(g) {
        return g.test(h);
      }))
        return !1;
    }
    return (0, n.default)(u);
  }
  e.exports = t.default, e.exports.default = t.default;
})(MQe, Nw);
var zw = {}, CQe = {
  get exports() {
    return zw;
  },
  set exports(e) {
    zw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = i(xt), n = i(Lp);
  function i(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var o = {
    PL: function(u) {
      (0, r.default)(u);
      var d = {
        1: 1,
        2: 3,
        3: 7,
        4: 9,
        5: 1,
        6: 3,
        7: 7,
        8: 9,
        9: 1,
        10: 3,
        11: 0
      };
      if (u != null && u.length === 11 && (0, n.default)(u, {
        allow_leading_zeroes: !0
      })) {
        var f = u.split("").slice(0, -1), h = f.reduce(function(v, w, x) {
          return v + Number(w) * d[x + 1];
        }, 0), g = h % 10, m = Number(u.charAt(u.length - 1));
        if (g === 0 && m === 0 || m === 10 - g)
          return !0;
      }
      return !1;
    },
    ES: function(u) {
      (0, r.default)(u);
      var d = /^[0-9X-Z][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/, f = {
        X: 0,
        Y: 1,
        Z: 2
      }, h = ["T", "R", "W", "A", "G", "M", "Y", "F", "P", "D", "X", "B", "N", "J", "Z", "S", "Q", "V", "H", "L", "C", "K", "E"], g = u.trim().toUpperCase();
      if (!d.test(g))
        return !1;
      var m = g.slice(0, -1).replace(/[X,Y,Z]/g, function(v) {
        return f[v];
      });
      return g.endsWith(h[m % 23]);
    },
    FI: function(u) {
      if ((0, r.default)(u), u.length !== 11 || !u.match(/^\d{6}[\-A\+]\d{3}[0-9ABCDEFHJKLMNPRSTUVWXY]{1}$/))
        return !1;
      var d = "0123456789ABCDEFHJKLMNPRSTUVWXY", f = parseInt(u.slice(0, 6), 10) * 1e3 + parseInt(u.slice(7, 10), 10), h = f % 31, g = d[h];
      return g === u.slice(10, 11);
    },
    IN: function(u) {
      var d = /^[1-9]\d{3}\s?\d{4}\s?\d{4}$/, f = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]], h = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]], g = u.trim();
      if (!d.test(g))
        return !1;
      var m = 0, v = g.replace(/\s/g, "").split("").map(Number).reverse();
      return v.forEach(function(w, x) {
        m = f[m][h[x % 8][w]];
      }), m === 0;
    },
    IR: function(u) {
      if (!u.match(/^\d{10}$/) || (u = "0000".concat(u).slice(u.length - 6), parseInt(u.slice(3, 9), 10) === 0))
        return !1;
      for (var d = parseInt(u.slice(9, 10), 10), f = 0, h = 0; h < 9; h++)
        f += parseInt(u.slice(h, h + 1), 10) * (10 - h);
      return f %= 11, f < 2 && d === f || f >= 2 && d === 11 - f;
    },
    IT: function(u) {
      return u.length !== 9 || u === "CA00000AA" ? !1 : u.search(/C[A-Z][0-9]{5}[A-Z]{2}/i) > -1;
    },
    NO: function(u) {
      var d = u.trim();
      if (isNaN(Number(d)) || d.length !== 11 || d === "00000000000")
        return !1;
      var f = d.split("").map(Number), h = (11 - (3 * f[0] + 7 * f[1] + 6 * f[2] + 1 * f[3] + 8 * f[4] + 9 * f[5] + 4 * f[6] + 5 * f[7] + 2 * f[8]) % 11) % 11, g = (11 - (5 * f[0] + 4 * f[1] + 3 * f[2] + 2 * f[3] + 7 * f[4] + 6 * f[5] + 5 * f[6] + 4 * f[7] + 3 * f[8] + 2 * h) % 11) % 11;
      return !(h !== f[9] || g !== f[10]);
    },
    TH: function(u) {
      if (!u.match(/^[1-8]\d{12}$/))
        return !1;
      for (var d = 0, f = 0; f < 12; f++)
        d += parseInt(u[f], 10) * (13 - f);
      return u[12] === ((11 - d % 11) % 10).toString();
    },
    LK: function(u) {
      var d = /^[1-9]\d{8}[vx]$/i, f = /^[1-9]\d{11}$/i;
      return u.length === 10 && d.test(u) ? !0 : !!(u.length === 12 && f.test(u));
    },
    "he-IL": function(u) {
      var d = /^\d{9}$/, f = u.trim();
      if (!d.test(f))
        return !1;
      for (var h = f, g = 0, m, v = 0; v < h.length; v++)
        m = Number(h[v]) * (v % 2 + 1), g += m > 9 ? m - 9 : m;
      return g % 10 === 0;
    },
    "ar-LY": function(u) {
      var d = /^(1|2)\d{11}$/, f = u.trim();
      return !!d.test(f);
    },
    "ar-TN": function(u) {
      var d = /^\d{8}$/, f = u.trim();
      return !!d.test(f);
    },
    "zh-CN": function(u) {
      var d = [
        "11",
        // 北京
        "12",
        // 天津
        "13",
        // 河北
        "14",
        // 山西
        "15",
        // 内蒙古
        "21",
        // 辽宁
        "22",
        // 吉林
        "23",
        // 黑龙江
        "31",
        // 上海
        "32",
        // 江苏
        "33",
        // 浙江
        "34",
        // 安徽
        "35",
        // 福建
        "36",
        // 江西
        "37",
        // 山东
        "41",
        // 河南
        "42",
        // 湖北
        "43",
        // 湖南
        "44",
        // 广东
        "45",
        // 广西
        "46",
        // 海南
        "50",
        // 重庆
        "51",
        // 四川
        "52",
        // 贵州
        "53",
        // 云南
        "54",
        // 西藏
        "61",
        // 陕西
        "62",
        // 甘肃
        "63",
        // 青海
        "64",
        // 宁夏
        "65",
        // 新疆
        "71",
        // 台湾
        "81",
        // 香港
        "82",
        // 澳门
        "91"
        // 国外
      ], f = ["7", "9", "10", "5", "8", "4", "2", "1", "6", "3", "7", "9", "10", "5", "8", "4", "2"], h = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"], g = function(T) {
        return d.includes(T);
      }, m = function(T) {
        var A = parseInt(T.substring(0, 4), 10), D = parseInt(T.substring(4, 6), 10), E = parseInt(T.substring(6), 10), N = new Date(A, D - 1, E);
        return N > new Date() ? !1 : N.getFullYear() === A && N.getMonth() === D - 1 && N.getDate() === E;
      }, v = function(T) {
        for (var A = T.substring(0, 17), D = 0, E = 0; E < 17; E++)
          D += parseInt(A.charAt(E), 10) * parseInt(f[E], 10);
        var N = D % 11;
        return h[N];
      }, w = function(T) {
        return v(T) === T.charAt(17).toUpperCase();
      }, x = function(T) {
        var A = /^[1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}$/.test(T);
        if (!A)
          return !1;
        var D = T.substring(0, 2);
        if (A = g(D), !A)
          return !1;
        var E = "19".concat(T.substring(6, 12));
        return A = m(E), !!A;
      }, y = function(T) {
        var A = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/.test(T);
        if (!A)
          return !1;
        var D = T.substring(0, 2);
        if (A = g(D), !A)
          return !1;
        var E = T.substring(6, 14);
        return A = m(E), A ? w(T) : !1;
      }, C = function(T) {
        var A = /^\d{15}|(\d{17}(\d|x|X))$/.test(T);
        return A ? T.length === 15 ? x(T) : y(T) : !1;
      };
      return C(u);
    },
    "zh-HK": function(u) {
      u = u.trim();
      var d = /^[A-Z]{1,2}[0-9]{6}((\([0-9A]\))|(\[[0-9A]\])|([0-9A]))$/, f = /^[0-9]$/;
      if (u = u.toUpperCase(), !d.test(u))
        return !1;
      u = u.replace(/\[|\]|\(|\)/g, ""), u.length === 8 && (u = "3".concat(u));
      for (var h = 0, g = 0; g <= 7; g++) {
        var m = void 0;
        f.test(u[g]) ? m = u[g] : m = (u[g].charCodeAt(0) - 55) % 11, h += m * (9 - g);
      }
      h %= 11;
      var v;
      return h === 0 ? v = "0" : h === 1 ? v = "A" : v = String(11 - h), v === u[u.length - 1];
    },
    "zh-TW": function(u) {
      var d = {
        A: 10,
        B: 11,
        C: 12,
        D: 13,
        E: 14,
        F: 15,
        G: 16,
        H: 17,
        I: 34,
        J: 18,
        K: 19,
        L: 20,
        M: 21,
        N: 22,
        O: 35,
        P: 23,
        Q: 24,
        R: 25,
        S: 26,
        T: 27,
        U: 28,
        V: 29,
        W: 32,
        X: 30,
        Y: 31,
        Z: 33
      }, f = u.trim().toUpperCase();
      return /^[A-Z][0-9]{9}$/.test(f) ? Array.from(f).reduce(function(h, g, m) {
        if (m === 0) {
          var v = d[g];
          return v % 10 * 9 + Math.floor(v / 10);
        }
        return m === 9 ? (10 - h % 10 - Number(g)) % 10 === 0 : h + Number(g) * (9 - m);
      }, 0) : !1;
    }
  };
  function a(s, u) {
    if ((0, r.default)(s), u in o)
      return o[u](s);
    if (u === "any") {
      for (var d in o)
        if (o.hasOwnProperty(d)) {
          var f = o[d];
          if (f(s))
            return !0;
        }
      return !1;
    }
    throw new Error("Invalid locale '".concat(u, "'"));
  }
  e.exports = t.default, e.exports.default = t.default;
})(CQe, zw);
var $w = {}, SQe = {
  get exports() {
    return $w;
  },
  set exports(e) {
    $w = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = d;
  var r = n(xt);
  function n(f) {
    return f && f.__esModule ? f : { default: f };
  }
  var i = 8, o = 14, a = /^(\d{8}|\d{13}|\d{14})$/;
  function s(f, h) {
    return f === i || f === o ? h % 2 === 0 ? 3 : 1 : h % 2 === 0 ? 1 : 3;
  }
  function u(f) {
    var h = f.slice(0, -1).split("").map(function(m, v) {
      return Number(m) * s(f.length, v);
    }).reduce(function(m, v) {
      return m + v;
    }, 0), g = 10 - h % 10;
    return g < 10 ? g : 0;
  }
  function d(f) {
    (0, r.default)(f);
    var h = Number(f.slice(-1));
    return a.test(f) && h === u(f);
  }
  e.exports = t.default, e.exports.default = t.default;
})(SQe, $w);
var Ow = {}, TQe = {
  get exports() {
    return Ow;
  },
  set exports(e) {
    Ow = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(xt);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var i = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/;
  function o(a) {
    if ((0, r.default)(a), !i.test(a))
      return !1;
    for (var s = !0, u = 0, d = a.length - 2; d >= 0; d--)
      if (a[d] >= "A" && a[d] <= "Z")
        for (var f = a[d].charCodeAt(0) - 55, h = f % 10, g = Math.trunc(f / 10), m = 0, v = [h, g]; m < v.length; m++) {
          var w = v[m];
          s ? w >= 5 ? u += 1 + (w - 5) * 2 : u += w * 2 : u += w, s = !s;
        }
      else {
        var x = a[d].charCodeAt(0) - "0".charCodeAt(0);
        s ? x >= 5 ? u += 1 + (x - 5) * 2 : u += x * 2 : u += x, s = !s;
      }
    var y = Math.trunc((u + 9) / 10) * 10 - u;
    return +a[a.length - 1] === y;
  }
  e.exports = t.default, e.exports.default = t.default;
})(TQe, Ow);
var _w = {}, kQe = {
  get exports() {
    return _w;
  },
  set exports(e) {
    _w = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = n(xt);
  function n(u) {
    return u && u.__esModule ? u : { default: u };
  }
  var i = /^(?:[0-9]{9}X|[0-9]{10})$/, o = /^(?:[0-9]{13})$/, a = [1, 3];
  function s(u, d) {
    (0, r.default)(u);
    var f = String((d == null ? void 0 : d.version) || d);
    if (!(d != null && d.version || d))
      return s(u, {
        version: 10
      }) || s(u, {
        version: 13
      });
    var h = u.replace(/[\s-]+/g, ""), g = 0;
    if (f === "10") {
      if (!i.test(h))
        return !1;
      for (var m = 0; m < f - 1; m++)
        g += (m + 1) * h.charAt(m);
      if (h.charAt(9) === "X" ? g += 10 * 10 : g += 10 * h.charAt(9), g % 11 === 0)
        return !0;
    } else if (f === "13") {
      if (!o.test(h))
        return !1;
      for (var v = 0; v < 12; v++)
        g += a[v % 2] * h.charAt(v);
      if (h.charAt(12) - (10 - g % 10) % 10 === 0)
        return !0;
    }
    return !1;
  }
  e.exports = t.default, e.exports.default = t.default;
})(kQe, _w);
var Lw = {}, DQe = {
  get exports() {
    return Lw;
  },
  set exports(e) {
    Lw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(xt);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var i = "^\\d{4}-?\\d{3}[\\dX]$";
  function o(a) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (0, r.default)(a);
    var u = i;
    if (u = s.require_hyphen ? u.replace("?", "") : u, u = s.case_sensitive ? new RegExp(u) : new RegExp(u, "i"), !u.test(a))
      return !1;
    for (var d = a.replace("-", "").toUpperCase(), f = 0, h = 0; h < d.length; h++) {
      var g = d[h];
      f += (g === "X" ? 10 : +g) * (8 - h);
    }
    return f % 11 === 0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(DQe, Lw);
var Pw = {}, AQe = {
  get exports() {
    return Pw;
  },
  set exports(e) {
    Pw = e;
  }
}, wh = {};
Object.defineProperty(wh, "__esModule", {
  value: !0
});
wh.iso7064Check = EQe;
wh.luhnCheck = IQe;
wh.reverseMultiplyAndSum = NQe;
wh.verhoeffCheck = zQe;
function EQe(e) {
  for (var t = 10, r = 0; r < e.length - 1; r++)
    t = (parseInt(e[r], 10) + t) % 10 === 0 ? 10 * 2 % 11 : (parseInt(e[r], 10) + t) % 10 * 2 % 11;
  return t = t === 1 ? 0 : 11 - t, t === parseInt(e[10], 10);
}
function IQe(e) {
  for (var t = 0, r = !1, n = e.length - 1; n >= 0; n--) {
    if (r) {
      var i = parseInt(e[n], 10) * 2;
      i > 9 ? t += i.toString().split("").map(function(o) {
        return parseInt(o, 10);
      }).reduce(function(o, a) {
        return o + a;
      }, 0) : t += i;
    } else
      t += parseInt(e[n], 10);
    r = !r;
  }
  return t % 10 === 0;
}
function NQe(e, t) {
  for (var r = 0, n = 0; n < e.length; n++)
    r += e[n] * (t - n);
  return r;
}
function zQe(e) {
  for (var t = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]], r = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]], n = e.split("").reverse().join(""), i = 0, o = 0; o < n.length; o++)
    i = t[i][r[o % 8][parseInt(n[o], 10)]];
  return i === 0;
}
(function(e, t) {
  function r(W) {
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(H) {
      return typeof H;
    } : r = function(H) {
      return H && typeof Symbol == "function" && H.constructor === Symbol && H !== Symbol.prototype ? "symbol" : typeof H;
    }, r(W);
  }
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = rt;
  var n = u(xt), i = s(wh), o = u(J0);
  function a() {
    if (typeof WeakMap != "function")
      return null;
    var W = /* @__PURE__ */ new WeakMap();
    return a = function() {
      return W;
    }, W;
  }
  function s(W) {
    if (W && W.__esModule)
      return W;
    if (W === null || r(W) !== "object" && typeof W != "function")
      return { default: W };
    var P = a();
    if (P && P.has(W))
      return P.get(W);
    var H = {}, se = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var pe in W)
      if (Object.prototype.hasOwnProperty.call(W, pe)) {
        var ae = se ? Object.getOwnPropertyDescriptor(W, pe) : null;
        ae && (ae.get || ae.set) ? Object.defineProperty(H, pe, ae) : H[pe] = W[pe];
      }
    return H.default = W, P && P.set(W, H), H;
  }
  function u(W) {
    return W && W.__esModule ? W : { default: W };
  }
  function d(W) {
    return m(W) || g(W) || h(W) || f();
  }
  function f() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function h(W, P) {
    if (W) {
      if (typeof W == "string")
        return v(W, P);
      var H = Object.prototype.toString.call(W).slice(8, -1);
      if (H === "Object" && W.constructor && (H = W.constructor.name), H === "Map" || H === "Set")
        return Array.from(W);
      if (H === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(H))
        return v(W, P);
    }
  }
  function g(W) {
    if (typeof Symbol < "u" && Symbol.iterator in Object(W))
      return Array.from(W);
  }
  function m(W) {
    if (Array.isArray(W))
      return v(W);
  }
  function v(W, P) {
    (P == null || P > W.length) && (P = W.length);
    for (var H = 0, se = new Array(P); H < P; H++)
      se[H] = W[H];
    return se;
  }
  function w(W) {
    var P = W.slice(0, 2), H = parseInt(W.slice(2, 4), 10);
    H > 40 ? (H -= 40, P = "20".concat(P)) : H > 20 ? (H -= 20, P = "18".concat(P)) : P = "19".concat(P), H < 10 && (H = "0".concat(H));
    var se = "".concat(P, "/").concat(H, "/").concat(W.slice(4, 6));
    if (!(0, o.default)(se, "YYYY/MM/DD"))
      return !1;
    for (var pe = W.split("").map(function(ke) {
      return parseInt(ke, 10);
    }), ae = [2, 4, 8, 5, 10, 9, 7, 3, 6], Me = 0, fe = 0; fe < ae.length; fe++)
      Me += pe[fe] * ae[fe];
    return Me = Me % 11 === 10 ? 0 : Me % 11, Me === pe[9];
  }
  function x(W) {
    var P = W.split(""), H = P.filter(function(pe, ae) {
      return ae % 2;
    }).map(function(pe) {
      return Number(pe) * 2;
    }).join("").split(""), se = P.filter(function(pe, ae) {
      return !(ae % 2);
    }).concat(H).map(function(pe) {
      return Number(pe);
    }).reduce(function(pe, ae) {
      return pe + ae;
    });
    return se % 10 === 0;
  }
  function y(W) {
    W = W.replace(/\W/, "");
    var P = parseInt(W.slice(0, 2), 10);
    if (W.length === 10)
      P < 54 ? P = "20".concat(P) : P = "19".concat(P);
    else {
      if (W.slice(6) === "000")
        return !1;
      if (P < 54)
        P = "19".concat(P);
      else
        return !1;
    }
    P.length === 3 && (P = [P.slice(0, 2), "0", P.slice(2)].join(""));
    var H = parseInt(W.slice(2, 4), 10);
    if (H > 50 && (H -= 50), H > 20) {
      if (parseInt(P, 10) < 2004)
        return !1;
      H -= 20;
    }
    H < 10 && (H = "0".concat(H));
    var se = "".concat(P, "/").concat(H, "/").concat(W.slice(4, 6));
    if (!(0, o.default)(se, "YYYY/MM/DD"))
      return !1;
    if (W.length === 10 && parseInt(W, 10) % 11 !== 0) {
      var pe = parseInt(W.slice(0, 9), 10) % 11;
      if (parseInt(P, 10) < 1986 && pe === 10) {
        if (parseInt(W.slice(9), 10) !== 0)
          return !1;
      } else
        return !1;
    }
    return !0;
  }
  function C(W) {
    return i.luhnCheck(W);
  }
  function S(W) {
    for (var P = W.split("").map(function(ke) {
      return parseInt(ke, 10);
    }), H = [], se = 0; se < P.length - 1; se++) {
      H.push("");
      for (var pe = 0; pe < P.length - 1; pe++)
        P[se] === P[pe] && (H[se] += pe);
    }
    if (H = H.filter(function(ke) {
      return ke.length > 1;
    }), H.length !== 2 && H.length !== 3)
      return !1;
    if (H[0].length === 3) {
      for (var ae = H[0].split("").map(function(ke) {
        return parseInt(ke, 10);
      }), Me = 0, fe = 0; fe < ae.length - 1; fe++)
        ae[fe] + 1 === ae[fe + 1] && (Me += 1);
      if (Me === 2)
        return !1;
    }
    return i.iso7064Check(W);
  }
  function T(W) {
    W = W.replace(/\W/, "");
    var P = parseInt(W.slice(4, 6), 10), H = W.slice(6, 7);
    switch (H) {
      case "0":
      case "1":
      case "2":
      case "3":
        P = "19".concat(P);
        break;
      case "4":
      case "9":
        P < 37 ? P = "20".concat(P) : P = "19".concat(P);
        break;
      default:
        if (P < 37)
          P = "20".concat(P);
        else if (P > 58)
          P = "18".concat(P);
        else
          return !1;
        break;
    }
    P.length === 3 && (P = [P.slice(0, 2), "0", P.slice(2)].join(""));
    var se = "".concat(P, "/").concat(W.slice(2, 4), "/").concat(W.slice(0, 2));
    if (!(0, o.default)(se, "YYYY/MM/DD"))
      return !1;
    for (var pe = W.split("").map(function(ke) {
      return parseInt(ke, 10);
    }), ae = 0, Me = 4, fe = 0; fe < 9; fe++)
      ae += pe[fe] * Me, Me -= 1, Me === 1 && (Me = 7);
    return ae %= 11, ae === 1 ? !1 : ae === 0 ? pe[9] === 0 : pe[9] === 11 - ae;
  }
  function A(W) {
    for (var P = W.slice(0, 8).split("").map(function(ae) {
      return parseInt(ae, 10);
    }), H = 0, se = 1; se < P.length; se += 2)
      H += P[se];
    for (var pe = 0; pe < P.length; pe += 2)
      P[pe] < 2 ? H += 1 - P[pe] : (H += 2 * (P[pe] - 2) + 5, P[pe] > 4 && (H += 2));
    return String.fromCharCode(H % 26 + 65) === W.charAt(8);
  }
  function D(W) {
    for (var P = W.split("").map(function(pe) {
      return parseInt(pe, 10);
    }), H = 0, se = 0; se < 8; se++)
      H += P[se] * Math.pow(2, 8 - se);
    return H % 11 % 10 === P[8];
  }
  function E(W) {
    var P = i.reverseMultiplyAndSum(W.split("").slice(0, 7).map(function(H) {
      return parseInt(H, 10);
    }), 8);
    return W.length === 9 && W[8] !== "W" && (P += (W[8].charCodeAt(0) - 64) * 9), P %= 23, P === 0 ? W[7].toUpperCase() === "W" : W[7].toUpperCase() === String.fromCharCode(64 + P);
  }
  var N = {
    andover: ["10", "12"],
    atlanta: ["60", "67"],
    austin: ["50", "53"],
    brookhaven: ["01", "02", "03", "04", "05", "06", "11", "13", "14", "16", "21", "22", "23", "25", "34", "51", "52", "54", "55", "56", "57", "58", "59", "65"],
    cincinnati: ["30", "32", "35", "36", "37", "38", "61"],
    fresno: ["15", "24"],
    internet: ["20", "26", "27", "45", "46", "47"],
    kansas: ["40", "44"],
    memphis: ["94", "95"],
    ogden: ["80", "90"],
    philadelphia: ["33", "39", "41", "42", "43", "46", "48", "62", "63", "64", "66", "68", "71", "72", "73", "74", "75", "76", "77", "81", "82", "83", "84", "85", "86", "87", "88", "91", "92", "93", "98", "99"],
    sba: ["31"]
  };
  function I() {
    var W = [];
    for (var P in N)
      N.hasOwnProperty(P) && W.push.apply(W, d(N[P]));
    return W;
  }
  function $(W) {
    return I().indexOf(W.slice(0, 2)) !== -1;
  }
  function _(W) {
    var P = W.toUpperCase().split("");
    if (isNaN(parseInt(P[0], 10)) && P.length > 1) {
      var H = 0;
      switch (P[0]) {
        case "Y":
          H = 1;
          break;
        case "Z":
          H = 2;
          break;
      }
      P.splice(0, 1, H);
    } else
      for (; P.length < 9; )
        P.unshift(0);
    var se = ["T", "R", "W", "A", "G", "M", "Y", "F", "P", "D", "X", "B", "N", "J", "Z", "S", "Q", "V", "H", "L", "C", "K", "E"];
    P = P.join("");
    var pe = parseInt(P.slice(0, 8), 10) % 23;
    return P[8] === se[pe];
  }
  function R(W) {
    var P = W.slice(1, 3), H = W.slice(0, 1);
    switch (H) {
      case "1":
      case "2":
        P = "18".concat(P);
        break;
      case "3":
      case "4":
        P = "19".concat(P);
        break;
      default:
        P = "20".concat(P);
        break;
    }
    var se = "".concat(P, "/").concat(W.slice(3, 5), "/").concat(W.slice(5, 7));
    if (!(0, o.default)(se, "YYYY/MM/DD"))
      return !1;
    for (var pe = W.split("").map(function(Le) {
      return parseInt(Le, 10);
    }), ae = 0, Me = 1, fe = 0; fe < 10; fe++)
      ae += pe[fe] * Me, Me += 1, Me === 10 && (Me = 1);
    if (ae % 11 === 10) {
      ae = 0, Me = 3;
      for (var ke = 0; ke < 10; ke++)
        ae += pe[ke] * Me, Me += 1, Me === 10 && (Me = 1);
      if (ae % 11 === 10)
        return pe[10] === 0;
    }
    return ae % 11 === pe[10];
  }
  function U(W) {
    var P = W.slice(4, 6), H = W.slice(6, 7);
    switch (H) {
      case "+":
        P = "18".concat(P);
        break;
      case "-":
        P = "19".concat(P);
        break;
      default:
        P = "20".concat(P);
        break;
    }
    var se = "".concat(P, "/").concat(W.slice(2, 4), "/").concat(W.slice(0, 2));
    if (!(0, o.default)(se, "YYYY/MM/DD"))
      return !1;
    var pe = parseInt(W.slice(0, 6) + W.slice(7, 10), 10) % 31;
    if (pe < 10)
      return pe === parseInt(W.slice(10), 10);
    pe -= 10;
    var ae = ["A", "B", "C", "D", "E", "F", "H", "J", "K", "L", "M", "N", "P", "R", "S", "T", "U", "V", "W", "X", "Y"];
    return ae[pe] === W.slice(10);
  }
  function Q(W) {
    if (W.slice(2, 4) !== "00" || W.slice(4, 6) !== "00") {
      var P = "".concat(W.slice(0, 2), "/").concat(W.slice(2, 4), "/").concat(W.slice(4, 6));
      if (!(0, o.default)(P, "YY/MM/DD"))
        return !1;
    }
    var H = 97 - parseInt(W.slice(0, 9), 10) % 97, se = parseInt(W.slice(9, 11), 10);
    return !(H !== se && (H = 97 - parseInt("2".concat(W.slice(0, 9)), 10) % 97, H !== se));
  }
  function Z(W) {
    W = W.replace(/\s/g, "");
    var P = parseInt(W.slice(0, 10), 10) % 511, H = parseInt(W.slice(10, 13), 10);
    return P === H;
  }
  function X(W) {
    var P = "".concat(W.slice(0, 4), "/").concat(W.slice(4, 6), "/").concat(W.slice(6, 8));
    return !(0, o.default)(P, "YYYY/MM/DD") || !i.luhnCheck(W.slice(0, 12)) ? !1 : i.verhoeffCheck("".concat(W.slice(0, 11)).concat(W[12]));
  }
  function re(W) {
    return i.iso7064Check(W);
  }
  function ue(W) {
    for (var P = W.split("").map(function(pe) {
      return parseInt(pe, 10);
    }), H = 8, se = 1; se < 9; se++)
      H += P[se] * (se + 1);
    return H % 11 === P[9];
  }
  function he(W) {
    for (var P = !1, H = !1, se = 0; se < 3; se++)
      if (!P && /[AEIOU]/.test(W[se]))
        P = !0;
      else if (!H && P && W[se] === "X")
        H = !0;
      else if (se > 0 && (P && !H && !/[AEIOU]/.test(W[se]) || H && !/X/.test(W[se])))
        return !1;
    return !0;
  }
  function te(W) {
    var P = W.toUpperCase().split("");
    if (!he(P.slice(0, 3)) || !he(P.slice(3, 6)))
      return !1;
    for (var H = [6, 7, 9, 10, 12, 13, 14], se = {
      L: "0",
      M: "1",
      N: "2",
      P: "3",
      Q: "4",
      R: "5",
      S: "6",
      T: "7",
      U: "8",
      V: "9"
    }, pe = 0, ae = H; pe < ae.length; pe++) {
      var Me = ae[pe];
      P[Me] in se && P.splice(Me, 1, se[P[Me]]);
    }
    var fe = {
      A: "01",
      B: "02",
      C: "03",
      D: "04",
      E: "05",
      H: "06",
      L: "07",
      M: "08",
      P: "09",
      R: "10",
      S: "11",
      T: "12"
    }, ke = fe[P[8]], Le = parseInt(P[9] + P[10], 10);
    Le > 40 && (Le -= 40), Le < 10 && (Le = "0".concat(Le));
    var dt = "".concat(P[6]).concat(P[7], "/").concat(ke, "/").concat(Le);
    if (!(0, o.default)(dt, "YY/MM/DD"))
      return !1;
    for (var Mt = 0, Ct = 1; Ct < P.length - 1; Ct += 2) {
      var er = parseInt(P[Ct], 10);
      isNaN(er) && (er = P[Ct].charCodeAt(0) - 65), Mt += er;
    }
    for (var Vt = {
      // Maps of characters at odd places
      A: 1,
      B: 0,
      C: 5,
      D: 7,
      E: 9,
      F: 13,
      G: 15,
      H: 17,
      I: 19,
      J: 21,
      K: 2,
      L: 4,
      M: 18,
      N: 20,
      O: 11,
      P: 3,
      Q: 6,
      R: 8,
      S: 12,
      T: 14,
      U: 16,
      V: 10,
      W: 22,
      X: 25,
      Y: 24,
      Z: 23,
      0: 1,
      1: 0
    }, jt = 0; jt < P.length - 1; jt += 2) {
      var at = 0;
      if (P[jt] in Vt)
        at = Vt[P[jt]];
      else {
        var St = parseInt(P[jt], 10);
        at = 2 * St + 1, St > 4 && (at += 2);
      }
      Mt += at;
    }
    return String.fromCharCode(65 + Mt % 26) === P[15];
  }
  function de(W) {
    W = W.replace(/\W/, "");
    var P = W.slice(0, 2);
    if (P !== "32") {
      var H = W.slice(2, 4);
      if (H !== "00") {
        var se = W.slice(4, 6);
        switch (W[6]) {
          case "0":
            se = "18".concat(se);
            break;
          case "1":
            se = "19".concat(se);
            break;
          default:
            se = "20".concat(se);
            break;
        }
        var pe = "".concat(se, "/").concat(W.slice(2, 4), "/").concat(P);
        if (!(0, o.default)(pe, "YYYY/MM/DD"))
          return !1;
      }
      for (var ae = 1101, Me = [1, 6, 3, 7, 9, 10, 5, 8, 4, 2], fe = 0; fe < W.length - 1; fe++)
        ae -= parseInt(W[fe], 10) * Me[fe];
      return parseInt(W[10], 10) === ae % 11;
    }
    return !0;
  }
  function De(W) {
    if (W.length !== 9) {
      for (var P = W.toUpperCase().split(""); P.length < 8; )
        P.unshift(0);
      switch (W[7]) {
        case "A":
        case "P":
          if (parseInt(P[6], 10) === 0)
            return !1;
          break;
        default: {
          var H = parseInt(P.join("").slice(0, 5), 10);
          if (H > 32e3)
            return !1;
          var se = parseInt(P.join("").slice(5, 7), 10);
          if (H === se)
            return !1;
        }
      }
    }
    return !0;
  }
  function Oe(W) {
    return i.reverseMultiplyAndSum(W.split("").slice(0, 8).map(function(P) {
      return parseInt(P, 10);
    }), 9) % 11 === parseInt(W[8], 10);
  }
  function Qe(W) {
    if (W.length === 10) {
      for (var P = [6, 5, 7, 2, 3, 4, 5, 6, 7], H = 0, se = 0; se < P.length; se++)
        H += parseInt(W[se], 10) * P[se];
      return H %= 11, H === 10 ? !1 : H === parseInt(W[9], 10);
    }
    var pe = W.slice(0, 2), ae = parseInt(W.slice(2, 4), 10);
    ae > 80 ? (pe = "18".concat(pe), ae -= 80) : ae > 60 ? (pe = "22".concat(pe), ae -= 60) : ae > 40 ? (pe = "21".concat(pe), ae -= 40) : ae > 20 ? (pe = "20".concat(pe), ae -= 20) : pe = "19".concat(pe), ae < 10 && (ae = "0".concat(ae));
    var Me = "".concat(pe, "/").concat(ae, "/").concat(W.slice(4, 6));
    if (!(0, o.default)(Me, "YYYY/MM/DD"))
      return !1;
    for (var fe = 0, ke = 1, Le = 0; Le < W.length - 1; Le++)
      fe += parseInt(W[Le], 10) * ke % 10, ke += 2, ke > 10 ? ke = 1 : ke === 5 && (ke += 2);
    return fe = 10 - fe % 10, fe === parseInt(W[10], 10);
  }
  function Ae(W) {
    if (W.length === 11) {
      var P, H;
      if (P = 0, // Reject known invalid CPFs
      W === "11111111111" || W === "22222222222" || W === "33333333333" || W === "44444444444" || W === "55555555555" || W === "66666666666" || W === "77777777777" || W === "88888888888" || W === "99999999999" || W === "00000000000")
        return !1;
      for (var se = 1; se <= 9; se++)
        P += parseInt(W.substring(se - 1, se), 10) * (11 - se);
      if (H = P * 10 % 11, H === 10 && (H = 0), H !== parseInt(W.substring(9, 10), 10))
        return !1;
      P = 0;
      for (var pe = 1; pe <= 10; pe++)
        P += parseInt(W.substring(pe - 1, pe), 10) * (12 - pe);
      return H = P * 10 % 11, H === 10 && (H = 0), H === parseInt(W.substring(10, 11), 10);
    }
    if (
      // Reject know invalid CNPJs
      W === "00000000000000" || W === "11111111111111" || W === "22222222222222" || W === "33333333333333" || W === "44444444444444" || W === "55555555555555" || W === "66666666666666" || W === "77777777777777" || W === "88888888888888" || W === "99999999999999"
    )
      return !1;
    for (var ae = W.length - 2, Me = W.substring(0, ae), fe = W.substring(ae), ke = 0, Le = ae - 7, dt = ae; dt >= 1; dt--)
      ke += Me.charAt(ae - dt) * Le, Le -= 1, Le < 2 && (Le = 9);
    var Mt = ke % 11 < 2 ? 0 : 11 - ke % 11;
    if (Mt !== parseInt(fe.charAt(0), 10))
      return !1;
    ae += 1, Me = W.substring(0, ae), ke = 0, Le = ae - 7;
    for (var Ct = ae; Ct >= 1; Ct--)
      ke += Me.charAt(ae - Ct) * Le, Le -= 1, Le < 2 && (Le = 9);
    return Mt = ke % 11 < 2 ? 0 : 11 - ke % 11, Mt === parseInt(fe.charAt(1), 10);
  }
  function Ne(W) {
    var P = 11 - i.reverseMultiplyAndSum(W.split("").slice(0, 8).map(function(H) {
      return parseInt(H, 10);
    }), 9) % 11;
    return P > 9 ? parseInt(W[8], 10) === 0 : P === parseInt(W[8], 10);
  }
  function $e(W) {
    if (W.slice(0, 4) !== "9000") {
      var P = W.slice(1, 3);
      switch (W[0]) {
        case "1":
        case "2":
          P = "19".concat(P);
          break;
        case "3":
        case "4":
          P = "18".concat(P);
          break;
        case "5":
        case "6":
          P = "20".concat(P);
          break;
      }
      var H = "".concat(P, "/").concat(W.slice(3, 5), "/").concat(W.slice(5, 7));
      if (H.length === 8) {
        if (!(0, o.default)(H, "YY/MM/DD"))
          return !1;
      } else if (!(0, o.default)(H, "YYYY/MM/DD"))
        return !1;
      for (var se = W.split("").map(function(fe) {
        return parseInt(fe, 10);
      }), pe = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9], ae = 0, Me = 0; Me < pe.length; Me++)
        ae += se[Me] * pe[Me];
      return ae % 11 === 10 ? se[12] === 1 : se[12] === ae % 11;
    }
    return !0;
  }
  function et(W) {
    if (W.length === 9) {
      if (W = W.replace(/\W/, ""), W.slice(6) === "000")
        return !1;
      var P = parseInt(W.slice(0, 2), 10);
      if (P > 53)
        return !1;
      P < 10 ? P = "190".concat(P) : P = "19".concat(P);
      var H = parseInt(W.slice(2, 4), 10);
      H > 50 && (H -= 50), H < 10 && (H = "0".concat(H));
      var se = "".concat(P, "/").concat(H, "/").concat(W.slice(4, 6));
      if (!(0, o.default)(se, "YYYY/MM/DD"))
        return !1;
    }
    return !0;
  }
  function Ge(W) {
    var P = 11 - i.reverseMultiplyAndSum(W.split("").slice(0, 7).map(function(H) {
      return parseInt(H, 10);
    }), 8) % 11;
    return P === 10 ? parseInt(W[7], 10) === 0 : P === parseInt(W[7], 10);
  }
  function Ee(W) {
    var P = W.slice(0);
    W.length > 11 && (P = P.slice(2));
    var H = "", se = P.slice(2, 4), pe = parseInt(P.slice(4, 6), 10);
    if (W.length > 11)
      H = W.slice(0, 4);
    else if (H = W.slice(0, 2), W.length === 11 && pe < 60) {
      var ae = new Date().getFullYear().toString(), Me = parseInt(ae.slice(0, 2), 10);
      if (ae = parseInt(ae, 10), W[6] === "-")
        parseInt("".concat(Me).concat(H), 10) > ae ? H = "".concat(Me - 1).concat(H) : H = "".concat(Me).concat(H);
      else if (H = "".concat(Me - 1).concat(H), ae - parseInt(H, 10) < 100)
        return !1;
    }
    pe > 60 && (pe -= 60), pe < 10 && (pe = "0".concat(pe));
    var fe = "".concat(H, "/").concat(se, "/").concat(pe);
    if (fe.length === 8) {
      if (!(0, o.default)(fe, "YY/MM/DD"))
        return !1;
    } else if (!(0, o.default)(fe, "YYYY/MM/DD"))
      return !1;
    return i.luhnCheck(W.replace(/\W/, ""));
  }
  var qe = {
    "bg-BG": /^\d{10}$/,
    "cs-CZ": /^\d{6}\/{0,1}\d{3,4}$/,
    "de-AT": /^\d{9}$/,
    "de-DE": /^[1-9]\d{10}$/,
    "dk-DK": /^\d{6}-{0,1}\d{4}$/,
    "el-CY": /^[09]\d{7}[A-Z]$/,
    "el-GR": /^([0-4]|[7-9])\d{8}$/,
    "en-CA": /^\d{9}$/,
    "en-GB": /^\d{10}$|^(?!GB|NK|TN|ZZ)(?![DFIQUV])[A-Z](?![DFIQUVO])[A-Z]\d{6}[ABCD ]$/i,
    "en-IE": /^\d{7}[A-W][A-IW]{0,1}$/i,
    "en-US": /^\d{2}[- ]{0,1}\d{7}$/,
    "es-ES": /^(\d{0,8}|[XYZKLM]\d{7})[A-HJ-NP-TV-Z]$/i,
    "et-EE": /^[1-6]\d{6}(00[1-9]|0[1-9][0-9]|[1-6][0-9]{2}|70[0-9]|710)\d$/,
    "fi-FI": /^\d{6}[-+A]\d{3}[0-9A-FHJ-NPR-Y]$/i,
    "fr-BE": /^\d{11}$/,
    "fr-FR": /^[0-3]\d{12}$|^[0-3]\d\s\d{2}(\s\d{3}){3}$/,
    // Conforms both to official spec and provided example
    "fr-LU": /^\d{13}$/,
    "hr-HR": /^\d{11}$/,
    "hu-HU": /^8\d{9}$/,
    "it-IT": /^[A-Z]{6}[L-NP-V0-9]{2}[A-EHLMPRST][L-NP-V0-9]{2}[A-ILMZ][L-NP-V0-9]{3}[A-Z]$/i,
    "lv-LV": /^\d{6}-{0,1}\d{5}$/,
    // Conforms both to DG TAXUD spec and original research
    "mt-MT": /^\d{3,7}[APMGLHBZ]$|^([1-8])\1\d{7}$/i,
    "nl-NL": /^\d{9}$/,
    "pl-PL": /^\d{10,11}$/,
    "pt-BR": /(?:^\d{11}$)|(?:^\d{14}$)/,
    "pt-PT": /^\d{9}$/,
    "ro-RO": /^\d{13}$/,
    "sk-SK": /^\d{6}\/{0,1}\d{3,4}$/,
    "sl-SI": /^[1-9]\d{7}$/,
    "sv-SE": /^(\d{6}[-+]{0,1}\d{4}|(18|19|20)\d{6}[-+]{0,1}\d{4})$/
  };
  qe["lb-LU"] = qe["fr-LU"], qe["lt-LT"] = qe["et-EE"], qe["nl-BE"] = qe["fr-BE"], qe["fr-CA"] = qe["en-CA"];
  var Ue = {
    "bg-BG": w,
    "cs-CZ": y,
    "de-AT": C,
    "de-DE": S,
    "dk-DK": T,
    "el-CY": A,
    "el-GR": D,
    "en-CA": x,
    "en-IE": E,
    "en-US": $,
    "es-ES": _,
    "et-EE": R,
    "fi-FI": U,
    "fr-BE": Q,
    "fr-FR": Z,
    "fr-LU": X,
    "hr-HR": re,
    "hu-HU": ue,
    "it-IT": te,
    "lv-LV": de,
    "mt-MT": De,
    "nl-NL": Oe,
    "pl-PL": Qe,
    "pt-BR": Ae,
    "pt-PT": Ne,
    "ro-RO": $e,
    "sk-SK": et,
    "sl-SI": Ge,
    "sv-SE": Ee
  };
  Ue["lb-LU"] = Ue["fr-LU"], Ue["lt-LT"] = Ue["et-EE"], Ue["nl-BE"] = Ue["fr-BE"], Ue["fr-CA"] = Ue["en-CA"];
  var ot = /[-\\\/!@#$%\^&\*\(\)\+\=\[\]]+/g, Ie = {
    "de-AT": ot,
    "de-DE": /[\/\\]/g,
    "fr-BE": ot
  };
  Ie["nl-BE"] = Ie["fr-BE"];
  function rt(W) {
    var P = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US";
    (0, n.default)(W);
    var H = W.slice(0);
    if (P in qe)
      return P in Ie && (H = H.replace(Ie[P], "")), qe[P].test(H) ? P in Ue ? Ue[P](H) : !0 : !1;
    throw new Error("Invalid locale '".concat(P, "'"));
  }
  e.exports = t.default, e.exports.default = t.default;
})(AQe, Pw);
var jb = {};
Object.defineProperty(jb, "__esModule", {
  value: !0
});
jb.default = _Qe;
jb.locales = void 0;
var $Qe = OQe(xt);
function OQe(e) {
  return e && e.__esModule ? e : { default: e };
}
var ti = {
  "am-AM": /^(\+?374|0)((10|[9|7][0-9])\d{6}$|[2-4]\d{7}$)/,
  "ar-AE": /^((\+?971)|0)?5[024568]\d{7}$/,
  "ar-BH": /^(\+?973)?(3|6)\d{7}$/,
  "ar-DZ": /^(\+?213|0)(5|6|7)\d{8}$/,
  "ar-LB": /^(\+?961)?((3|81)\d{6}|7\d{7})$/,
  "ar-EG": /^((\+?20)|0)?1[0125]\d{8}$/,
  "ar-IQ": /^(\+?964|0)?7[0-9]\d{8}$/,
  "ar-JO": /^(\+?962|0)?7[789]\d{7}$/,
  "ar-KW": /^(\+?965)([569]\d{7}|41\d{6})$/,
  "ar-LY": /^((\+?218)|0)?(9[1-6]\d{7}|[1-8]\d{7,9})$/,
  "ar-MA": /^(?:(?:\+|00)212|0)[5-7]\d{8}$/,
  "ar-OM": /^((\+|00)968)?(9[1-9])\d{6}$/,
  "ar-PS": /^(\+?970|0)5[6|9](\d{7})$/,
  "ar-SA": /^(!?(\+?966)|0)?5\d{8}$/,
  "ar-SD": /^((\+?249)|0)?(9[012369]|1[012])\d{7}$/,
  "ar-SY": /^(!?(\+?963)|0)?9\d{8}$/,
  "ar-TN": /^(\+?216)?[2459]\d{7}$/,
  "az-AZ": /^(\+994|0)(10|5[015]|7[07]|99)\d{7}$/,
  "bs-BA": /^((((\+|00)3876)|06))((([0-3]|[5-6])\d{6})|(4\d{7}))$/,
  "be-BY": /^(\+?375)?(24|25|29|33|44)\d{7}$/,
  "bg-BG": /^(\+?359|0)?8[789]\d{7}$/,
  "bn-BD": /^(\+?880|0)1[13456789][0-9]{8}$/,
  "ca-AD": /^(\+376)?[346]\d{5}$/,
  "cs-CZ": /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  "da-DK": /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
  "de-DE": /^((\+49|0)1)(5[0-25-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7,9}$/,
  "de-AT": /^(\+43|0)\d{1,4}\d{3,12}$/,
  "de-CH": /^(\+41|0)([1-9])\d{1,9}$/,
  "de-LU": /^(\+352)?((6\d1)\d{6})$/,
  "dv-MV": /^(\+?960)?(7[2-9]|9[1-9])\d{5}$/,
  "el-GR": /^(\+?30|0)?6(8[5-9]|9(?![26])[0-9])\d{7}$/,
  "el-CY": /^(\+?357?)?(9(9|6)\d{6})$/,
  "en-AI": /^(\+?1|0)264(?:2(35|92)|4(?:6[1-2]|76|97)|5(?:3[6-9]|8[1-4])|7(?:2(4|9)|72))\d{4}$/,
  "en-AU": /^(\+?61|0)4\d{8}$/,
  "en-AG": /^(?:\+1|1)268(?:464|7(?:1[3-9]|[28]\d|3[0246]|64|7[0-689]))\d{4}$/,
  "en-BM": /^(\+?1)?441(((3|7)\d{6}$)|(5[0-3][0-9]\d{4}$)|(59\d{5}$))/,
  "en-BS": /^(\+?1[-\s]?|0)?\(?242\)?[-\s]?\d{3}[-\s]?\d{4}$/,
  "en-GB": /^(\+?44|0)7\d{9}$/,
  "en-GG": /^(\+?44|0)1481\d{6}$/,
  "en-GH": /^(\+233|0)(20|50|24|54|27|57|26|56|23|28|55|59)\d{7}$/,
  "en-GY": /^(\+592|0)6\d{6}$/,
  "en-HK": /^(\+?852[-\s]?)?[456789]\d{3}[-\s]?\d{4}$/,
  "en-MO": /^(\+?853[-\s]?)?[6]\d{3}[-\s]?\d{4}$/,
  "en-IE": /^(\+?353|0)8[356789]\d{7}$/,
  "en-IN": /^(\+?91|0)?[6789]\d{9}$/,
  "en-JM": /^(\+?876)?\d{7}$/,
  "en-KE": /^(\+?254|0)(7|1)\d{8}$/,
  "fr-CF": /^(\+?236| ?)(70|75|77|72|21|22)\d{6}$/,
  "en-SS": /^(\+?211|0)(9[1257])\d{7}$/,
  "en-KI": /^((\+686|686)?)?( )?((6|7)(2|3|8)[0-9]{6})$/,
  "en-KN": /^(?:\+1|1)869(?:46\d|48[89]|55[6-8]|66\d|76[02-7])\d{4}$/,
  "en-LS": /^(\+?266)(22|28|57|58|59|27|52)\d{6}$/,
  "en-MT": /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
  "en-MU": /^(\+?230|0)?\d{8}$/,
  "en-NA": /^(\+?264|0)(6|8)\d{7}$/,
  "en-NG": /^(\+?234|0)?[789]\d{9}$/,
  "en-NZ": /^(\+?64|0)[28]\d{7,9}$/,
  "en-PG": /^(\+?675|0)?(7\d|8[18])\d{6}$/,
  "en-PK": /^((00|\+)?92|0)3[0-6]\d{8}$/,
  "en-PH": /^(09|\+639)\d{9}$/,
  "en-RW": /^(\+?250|0)?[7]\d{8}$/,
  "en-SG": /^(\+65)?[3689]\d{7}$/,
  "en-SL": /^(\+?232|0)\d{8}$/,
  "en-TZ": /^(\+?255|0)?[67]\d{8}$/,
  "en-UG": /^(\+?256|0)?[7]\d{8}$/,
  "en-US": /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
  "en-ZA": /^(\+?27|0)\d{9}$/,
  "en-ZM": /^(\+?26)?09[567]\d{7}$/,
  "en-ZW": /^(\+263)[0-9]{9}$/,
  "en-BW": /^(\+?267)?(7[1-8]{1})\d{6}$/,
  "es-AR": /^\+?549(11|[2368]\d)\d{8}$/,
  "es-BO": /^(\+?591)?(6|7)\d{7}$/,
  "es-CO": /^(\+?57)?3(0(0|1|2|4|5)|1\d|2[0-4]|5(0|1))\d{7}$/,
  "es-CL": /^(\+?56|0)[2-9]\d{1}\d{7}$/,
  "es-CR": /^(\+506)?[2-8]\d{7}$/,
  "es-CU": /^(\+53|0053)?5\d{7}$/,
  "es-DO": /^(\+?1)?8[024]9\d{7}$/,
  "es-HN": /^(\+?504)?[9|8|3|2]\d{7}$/,
  "es-EC": /^(\+?593|0)([2-7]|9[2-9])\d{7}$/,
  "es-ES": /^(\+?34)?[6|7]\d{8}$/,
  "es-PE": /^(\+?51)?9\d{8}$/,
  "es-MX": /^(\+?52)?(1|01)?\d{10,11}$/,
  "es-NI": /^(\+?505)\d{7,8}$/,
  "es-PA": /^(\+?507)\d{7,8}$/,
  "es-PY": /^(\+?595|0)9[9876]\d{7}$/,
  "es-SV": /^(\+?503)?[67]\d{7}$/,
  "es-UY": /^(\+598|0)9[1-9][\d]{6}$/,
  "es-VE": /^(\+?58)?(2|4)\d{9}$/,
  "et-EE": /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
  "fa-IR": /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
  "fi-FI": /^(\+?358|0)\s?(4[0-6]|50)\s?(\d\s?){4,8}$/,
  "fj-FJ": /^(\+?679)?\s?\d{3}\s?\d{4}$/,
  "fo-FO": /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
  "fr-BF": /^(\+226|0)[67]\d{7}$/,
  "fr-BJ": /^(\+229)\d{8}$/,
  "fr-CD": /^(\+?243|0)?(8|9)\d{8}$/,
  "fr-CM": /^(\+?237)6[0-9]{8}$/,
  "fr-FR": /^(\+?33|0)[67]\d{8}$/,
  "fr-GF": /^(\+?594|0|00594)[67]\d{8}$/,
  "fr-GP": /^(\+?590|0|00590)[67]\d{8}$/,
  "fr-MQ": /^(\+?596|0|00596)[67]\d{8}$/,
  "fr-PF": /^(\+?689)?8[789]\d{6}$/,
  "fr-RE": /^(\+?262|0|00262)[67]\d{8}$/,
  "fr-WF": /^(\+681)?\d{6}$/,
  "he-IL": /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
  "hu-HU": /^(\+?36|06)(20|30|31|50|70)\d{7}$/,
  "id-ID": /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
  "ir-IR": /^(\+98|0)?9\d{9}$/,
  "it-IT": /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
  "it-SM": /^((\+378)|(0549)|(\+390549)|(\+3780549))?6\d{5,9}$/,
  "ja-JP": /^(\+81[ \-]?(\(0\))?|0)[6789]0[ \-]?\d{4}[ \-]?\d{4}$/,
  "ka-GE": /^(\+?995)?(79\d{7}|5\d{8})$/,
  "kk-KZ": /^(\+?7|8)?7\d{9}$/,
  "kl-GL": /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
  "ko-KR": /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
  "ky-KG": /^(\+?7\s?\+?7|0)\s?\d{2}\s?\d{3}\s?\d{4}$/,
  "lt-LT": /^(\+370|8)\d{8}$/,
  "lv-LV": /^(\+?371)2\d{7}$/,
  "mg-MG": /^((\+?261|0)(2|3)\d)?\d{7}$/,
  "mn-MN": /^(\+|00|011)?976(77|81|88|91|94|95|96|99)\d{6}$/,
  "my-MM": /^(\+?959|09|9)(2[5-7]|3[1-2]|4[0-5]|6[6-9]|7[5-9]|9[6-9])[0-9]{7}$/,
  "ms-MY": /^(\+?60|0)1(([0145](-|\s)?\d{7,8})|([236-9](-|\s)?\d{7}))$/,
  "mz-MZ": /^(\+?258)?8[234567]\d{7}$/,
  "nb-NO": /^(\+?47)?[49]\d{7}$/,
  "ne-NP": /^(\+?977)?9[78]\d{8}$/,
  "nl-BE": /^(\+?32|0)4\d{8}$/,
  "nl-NL": /^(((\+|00)?31\(0\))|((\+|00)?31)|0)6{1}\d{8}$/,
  "nl-AW": /^(\+)?297(56|59|64|73|74|99)\d{5}$/,
  "nn-NO": /^(\+?47)?[49]\d{7}$/,
  "pl-PL": /^(\+?48)? ?([5-8]\d|45) ?\d{3} ?\d{2} ?\d{2}$/,
  "pt-BR": /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[1-9]{1}\d{3}\-?\d{4}))$/,
  "pt-PT": /^(\+?351)?9[1236]\d{7}$/,
  "pt-AO": /^(\+244)\d{9}$/,
  "ro-MD": /^(\+?373|0)((6(0|1|2|6|7|8|9))|(7(6|7|8|9)))\d{6}$/,
  "ro-RO": /^(\+?40|0)\s?7\d{2}(\/|\s|\.|-)?\d{3}(\s|\.|-)?\d{3}$/,
  "ru-RU": /^(\+?7|8)?9\d{9}$/,
  "si-LK": /^(?:0|94|\+94)?(7(0|1|2|4|5|6|7|8)( |-)?)\d{7}$/,
  "sl-SI": /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
  "sk-SK": /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  "so-SO": /^(\+?252|0)((6[0-9])\d{7}|(7[1-9])\d{7})$/,
  "sq-AL": /^(\+355|0)6[789]\d{6}$/,
  "sr-RS": /^(\+3816|06)[- \d]{5,9}$/,
  "sv-SE": /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
  "tg-TJ": /^(\+?992)?[5][5]\d{7}$/,
  "th-TH": /^(\+66|66|0)\d{9}$/,
  "tr-TR": /^(\+?90|0)?5\d{9}$/,
  "tk-TM": /^(\+993|993|8)\d{8}$/,
  "uk-UA": /^(\+?38|8)?0\d{9}$/,
  "uz-UZ": /^(\+?998)?(6[125-79]|7[1-69]|88|9\d)\d{7}$/,
  "vi-VN": /^((\+?84)|0)((3([2-9]))|(5([25689]))|(7([0|6-9]))|(8([1-9]))|(9([0-9])))([0-9]{7})$/,
  "zh-CN": /^((\+|00)86)?(1[3-9]|9[28])\d{9}$/,
  "zh-TW": /^(\+?886\-?|0)?9\d{8}$/,
  "dz-BT": /^(\+?975|0)?(17|16|77|02)\d{6}$/,
  "ar-YE": /^(((\+|00)9677|0?7)[0137]\d{7}|((\+|00)967|0)[1-7]\d{6})$/,
  "ar-EH": /^(\+?212|0)[\s\-]?(5288|5289)[\s\-]?\d{5}$/,
  "fa-AF": /^(\+93|0)?(2{1}[0-8]{1}|[3-5]{1}[0-4]{1})(\d{7})$/
};
ti["en-CA"] = ti["en-US"];
ti["fr-CA"] = ti["en-CA"];
ti["fr-BE"] = ti["nl-BE"];
ti["zh-HK"] = ti["en-HK"];
ti["zh-MO"] = ti["en-MO"];
ti["ga-IE"] = ti["en-IE"];
ti["fr-CH"] = ti["de-CH"];
ti["it-CH"] = ti["fr-CH"];
function _Qe(e, t, r) {
  if ((0, $Qe.default)(e), r && r.strictMode && !e.startsWith("+"))
    return !1;
  if (Array.isArray(t))
    return t.some(function(o) {
      if (ti.hasOwnProperty(o)) {
        var a = ti[o];
        if (a.test(e))
          return !0;
      }
      return !1;
    });
  if (t in ti)
    return ti[t].test(e);
  if (!t || t === "any") {
    for (var n in ti)
      if (ti.hasOwnProperty(n)) {
        var i = ti[n];
        if (i.test(e))
          return !0;
      }
    return !1;
  }
  throw new Error("Invalid locale '".concat(t, "'"));
}
var LQe = Object.keys(ti);
jb.locales = LQe;
var Rw = {}, PQe = {
  get exports() {
    return Rw;
  },
  set exports(e) {
    Rw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(xt);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var i = /^(0x)[0-9a-f]{40}$/i;
  function o(a) {
    return (0, r.default)(a), i.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(PQe, Rw);
var jw = {}, RQe = {
  get exports() {
    return jw;
  },
  set exports(e) {
    jw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = i(ao), n = i(xt);
  function i(u) {
    return u && u.__esModule ? u : { default: u };
  }
  function o(u) {
    var d = "\\d{".concat(u.digits_after_decimal[0], "}");
    u.digits_after_decimal.forEach(function(C, S) {
      S !== 0 && (d = "".concat(d, "|\\d{").concat(C, "}"));
    });
    var f = "(".concat(u.symbol.replace(/\W/, function(C) {
      return "\\".concat(C);
    }), ")").concat(u.require_symbol ? "" : "?"), h = "-?", g = "[1-9]\\d*", m = "[1-9]\\d{0,2}(\\".concat(u.thousands_separator, "\\d{3})*"), v = ["0", g, m], w = "(".concat(v.join("|"), ")?"), x = "(\\".concat(u.decimal_separator, "(").concat(d, "))").concat(u.require_decimal ? "" : "?"), y = w + (u.allow_decimal || u.require_decimal ? x : "");
    return u.allow_negatives && !u.parens_for_negatives && (u.negative_sign_after_digits ? y += h : u.negative_sign_before_digits && (y = h + y)), u.allow_negative_sign_placeholder ? y = "( (?!\\-))?".concat(y) : u.allow_space_after_symbol ? y = " ?".concat(y) : u.allow_space_after_digits && (y += "( (?!$))?"), u.symbol_after_digits ? y += f : y = f + y, u.allow_negatives && (u.parens_for_negatives ? y = "(\\(".concat(y, "\\)|").concat(y, ")") : u.negative_sign_before_digits || u.negative_sign_after_digits || (y = h + y)), new RegExp("^(?!-? )(?=.*\\d)".concat(y, "$"));
  }
  var a = {
    symbol: "$",
    require_symbol: !1,
    allow_space_after_symbol: !1,
    symbol_after_digits: !1,
    allow_negatives: !0,
    parens_for_negatives: !1,
    negative_sign_before_digits: !1,
    negative_sign_after_digits: !1,
    allow_negative_sign_placeholder: !1,
    thousands_separator: ",",
    decimal_separator: ".",
    allow_decimal: !0,
    require_decimal: !1,
    digits_after_decimal: [2],
    allow_space_after_digits: !1
  };
  function s(u, d) {
    return (0, n.default)(u), d = (0, r.default)(d, a), o(d).test(u);
  }
  e.exports = t.default, e.exports.default = t.default;
})(RQe, jw);
var Fw = {}, jQe = {
  get exports() {
    return Fw;
  },
  set exports(e) {
    Fw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(xt);
  function n(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var i = /^(bc1)[a-z0-9]{25,39}$/, o = /^(1|3)[A-HJ-NP-Za-km-z1-9]{25,39}$/;
  function a(s) {
    return (0, r.default)(s), i.test(s) || o.test(s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(jQe, Fw);
var Fb = {};
Object.defineProperty(Fb, "__esModule", {
  value: !0
});
Fb.isISO6346 = dG;
Fb.isFreightContainerID = void 0;
var FQe = BQe(xt);
function BQe(e) {
  return e && e.__esModule ? e : { default: e };
}
var UQe = /^[A-Z]{3}(U[0-9]{7})|([J,Z][0-9]{6,7})$/, HQe = /^[0-9]$/;
function dG(e) {
  if ((0, FQe.default)(e), e = e.toUpperCase(), !UQe.test(e))
    return !1;
  if (e.length === 11) {
    for (var t = 0, r = 0; r < e.length - 1; r++)
      if (HQe.test(e[r]))
        t += e[r] * Math.pow(2, r);
      else {
        var n = void 0, i = e.charCodeAt(r) - 55;
        i < 11 ? n = i : i >= 11 && i <= 20 ? n = 12 + i % 11 : i >= 21 && i <= 30 ? n = 23 + i % 21 : n = 34 + i % 31, t += n * Math.pow(2, r);
      }
    var o = t % 11;
    return Number(e[e.length - 1]) === o;
  }
  return !0;
}
var WQe = dG;
Fb.isFreightContainerID = WQe;
var Bw = {}, VQe = {
  get exports() {
    return Bw;
  },
  set exports(e) {
    Bw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(xt);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var i = /* @__PURE__ */ new Set(["aa", "ab", "ae", "af", "ak", "am", "an", "ar", "as", "av", "ay", "az", "az", "ba", "be", "bg", "bh", "bi", "bm", "bn", "bo", "br", "bs", "ca", "ce", "ch", "co", "cr", "cs", "cu", "cv", "cy", "da", "de", "dv", "dz", "ee", "el", "en", "eo", "es", "et", "eu", "fa", "ff", "fi", "fj", "fo", "fr", "fy", "ga", "gd", "gl", "gn", "gu", "gv", "ha", "he", "hi", "ho", "hr", "ht", "hu", "hy", "hz", "ia", "id", "ie", "ig", "ii", "ik", "io", "is", "it", "iu", "ja", "jv", "ka", "kg", "ki", "kj", "kk", "kl", "km", "kn", "ko", "kr", "ks", "ku", "kv", "kw", "ky", "la", "lb", "lg", "li", "ln", "lo", "lt", "lu", "lv", "mg", "mh", "mi", "mk", "ml", "mn", "mr", "ms", "mt", "my", "na", "nb", "nd", "ne", "ng", "nl", "nn", "no", "nr", "nv", "ny", "oc", "oj", "om", "or", "os", "pa", "pi", "pl", "ps", "pt", "qu", "rm", "rn", "ro", "ru", "rw", "sa", "sc", "sd", "se", "sg", "si", "sk", "sl", "sm", "sn", "so", "sq", "sr", "ss", "st", "su", "sv", "sw", "ta", "te", "tg", "th", "ti", "tk", "tl", "tn", "to", "tr", "ts", "tt", "tw", "ty", "ug", "uk", "ur", "uz", "ve", "vi", "vo", "wa", "wo", "xh", "yi", "yo", "za", "zh", "zu"]);
  function o(a) {
    return (0, r.default)(a), i.has(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(VQe, Bw);
var Uw = {}, YQe = {
  get exports() {
    return Uw;
  },
  set exports(e) {
    Uw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = n(xt);
  function n(u) {
    return u && u.__esModule ? u : { default: u };
  }
  var i = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, o = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, a = function(d) {
    var f = d.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);
    if (f) {
      var h = Number(f[1]), g = Number(f[2]);
      return h % 4 === 0 && h % 100 !== 0 || h % 400 === 0 ? g <= 366 : g <= 365;
    }
    var m = d.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number), v = m[1], w = m[2], x = m[3], y = w && "0".concat(w).slice(-2), C = x && "0".concat(x).slice(-2), S = new Date("".concat(v, "-").concat(y || "01", "-").concat(C || "01"));
    return w && x ? S.getUTCFullYear() === v && S.getUTCMonth() + 1 === w && S.getUTCDate() === x : !0;
  };
  function s(u) {
    var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (0, r.default)(u);
    var f = d.strictSeparator ? o.test(u) : i.test(u);
    return f && d.strict ? a(u) : f;
  }
  e.exports = t.default, e.exports.default = t.default;
})(YQe, Uw);
var Hw = {}, QQe = {
  get exports() {
    return Hw;
  },
  set exports(e) {
    Hw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = y;
  var r = n(xt);
  function n(C) {
    return C && C.__esModule ? C : { default: C };
  }
  var i = /[0-9]{4}/, o = /(0[1-9]|1[0-2])/, a = /([12]\d|0[1-9]|3[01])/, s = /([01][0-9]|2[0-3])/, u = /[0-5][0-9]/, d = /([0-5][0-9]|60)/, f = /(\.[0-9]+)?/, h = new RegExp("[-+]".concat(s.source, ":").concat(u.source)), g = new RegExp("([zZ]|".concat(h.source, ")")), m = new RegExp("".concat(s.source, ":").concat(u.source, ":").concat(d.source).concat(f.source)), v = new RegExp("".concat(i.source, "-").concat(o.source, "-").concat(a.source)), w = new RegExp("".concat(m.source).concat(g.source)), x = new RegExp("^".concat(v.source, "[ tT]").concat(w.source, "$"));
  function y(C) {
    return (0, r.default)(C), x.test(C);
  }
  e.exports = t.default, e.exports.default = t.default;
})(QQe, Hw);
var Ww = {}, qQe = {
  get exports() {
    return Ww;
  },
  set exports(e) {
    Ww = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(xt);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var i = /* @__PURE__ */ new Set(["AFG", "ALA", "ALB", "DZA", "ASM", "AND", "AGO", "AIA", "ATA", "ATG", "ARG", "ARM", "ABW", "AUS", "AUT", "AZE", "BHS", "BHR", "BGD", "BRB", "BLR", "BEL", "BLZ", "BEN", "BMU", "BTN", "BOL", "BES", "BIH", "BWA", "BVT", "BRA", "IOT", "BRN", "BGR", "BFA", "BDI", "KHM", "CMR", "CAN", "CPV", "CYM", "CAF", "TCD", "CHL", "CHN", "CXR", "CCK", "COL", "COM", "COG", "COD", "COK", "CRI", "CIV", "HRV", "CUB", "CUW", "CYP", "CZE", "DNK", "DJI", "DMA", "DOM", "ECU", "EGY", "SLV", "GNQ", "ERI", "EST", "ETH", "FLK", "FRO", "FJI", "FIN", "FRA", "GUF", "PYF", "ATF", "GAB", "GMB", "GEO", "DEU", "GHA", "GIB", "GRC", "GRL", "GRD", "GLP", "GUM", "GTM", "GGY", "GIN", "GNB", "GUY", "HTI", "HMD", "VAT", "HND", "HKG", "HUN", "ISL", "IND", "IDN", "IRN", "IRQ", "IRL", "IMN", "ISR", "ITA", "JAM", "JPN", "JEY", "JOR", "KAZ", "KEN", "KIR", "PRK", "KOR", "KWT", "KGZ", "LAO", "LVA", "LBN", "LSO", "LBR", "LBY", "LIE", "LTU", "LUX", "MAC", "MKD", "MDG", "MWI", "MYS", "MDV", "MLI", "MLT", "MHL", "MTQ", "MRT", "MUS", "MYT", "MEX", "FSM", "MDA", "MCO", "MNG", "MNE", "MSR", "MAR", "MOZ", "MMR", "NAM", "NRU", "NPL", "NLD", "NCL", "NZL", "NIC", "NER", "NGA", "NIU", "NFK", "MNP", "NOR", "OMN", "PAK", "PLW", "PSE", "PAN", "PNG", "PRY", "PER", "PHL", "PCN", "POL", "PRT", "PRI", "QAT", "REU", "ROU", "RUS", "RWA", "BLM", "SHN", "KNA", "LCA", "MAF", "SPM", "VCT", "WSM", "SMR", "STP", "SAU", "SEN", "SRB", "SYC", "SLE", "SGP", "SXM", "SVK", "SVN", "SLB", "SOM", "ZAF", "SGS", "SSD", "ESP", "LKA", "SDN", "SUR", "SJM", "SWZ", "SWE", "CHE", "SYR", "TWN", "TJK", "TZA", "THA", "TLS", "TGO", "TKL", "TON", "TTO", "TUN", "TUR", "TKM", "TCA", "TUV", "UGA", "UKR", "ARE", "GBR", "USA", "UMI", "URY", "UZB", "VUT", "VEN", "VNM", "VGB", "VIR", "WLF", "ESH", "YEM", "ZMB", "ZWE"]);
  function o(a) {
    return (0, r.default)(a), i.has(a.toUpperCase());
  }
  e.exports = t.default, e.exports.default = t.default;
})(qQe, Ww);
var Bb = {};
Object.defineProperty(Bb, "__esModule", {
  value: !0
});
Bb.default = KQe;
Bb.CurrencyCodes = void 0;
var GQe = ZQe(xt);
function ZQe(e) {
  return e && e.__esModule ? e : { default: e };
}
var fG = /* @__PURE__ */ new Set(["AED", "AFN", "ALL", "AMD", "ANG", "AOA", "ARS", "AUD", "AWG", "AZN", "BAM", "BBD", "BDT", "BGN", "BHD", "BIF", "BMD", "BND", "BOB", "BOV", "BRL", "BSD", "BTN", "BWP", "BYN", "BZD", "CAD", "CDF", "CHE", "CHF", "CHW", "CLF", "CLP", "CNY", "COP", "COU", "CRC", "CUC", "CUP", "CVE", "CZK", "DJF", "DKK", "DOP", "DZD", "EGP", "ERN", "ETB", "EUR", "FJD", "FKP", "GBP", "GEL", "GHS", "GIP", "GMD", "GNF", "GTQ", "GYD", "HKD", "HNL", "HRK", "HTG", "HUF", "IDR", "ILS", "INR", "IQD", "IRR", "ISK", "JMD", "JOD", "JPY", "KES", "KGS", "KHR", "KMF", "KPW", "KRW", "KWD", "KYD", "KZT", "LAK", "LBP", "LKR", "LRD", "LSL", "LYD", "MAD", "MDL", "MGA", "MKD", "MMK", "MNT", "MOP", "MRU", "MUR", "MVR", "MWK", "MXN", "MXV", "MYR", "MZN", "NAD", "NGN", "NIO", "NOK", "NPR", "NZD", "OMR", "PAB", "PEN", "PGK", "PHP", "PKR", "PLN", "PYG", "QAR", "RON", "RSD", "RUB", "RWF", "SAR", "SBD", "SCR", "SDG", "SEK", "SGD", "SHP", "SLL", "SOS", "SRD", "SSP", "STN", "SVC", "SYP", "SZL", "THB", "TJS", "TMT", "TND", "TOP", "TRY", "TTD", "TWD", "TZS", "UAH", "UGX", "USD", "USN", "UYI", "UYU", "UYW", "UZS", "VES", "VND", "VUV", "WST", "XAF", "XAG", "XAU", "XBA", "XBB", "XBC", "XBD", "XCD", "XDR", "XOF", "XPD", "XPF", "XPT", "XSU", "XTS", "XUA", "XXX", "YER", "ZAR", "ZMW", "ZWL"]);
function KQe(e) {
  return (0, GQe.default)(e), fG.has(e.toUpperCase());
}
var XQe = fG;
Bb.CurrencyCodes = XQe;
var Vw = {}, JQe = {
  get exports() {
    return Vw;
  },
  set exports(e) {
    Vw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  var r = i(xt), n = i(ao);
  function i(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var o = /^[A-Z2-7]+=*$/, a = /^[A-HJKMNP-TV-Z0-9]+$/, s = {
    crockford: !1
  };
  function u(d, f) {
    if ((0, r.default)(d), f = (0, n.default)(f, s), f.crockford)
      return a.test(d);
    var h = d.length;
    return !!(h % 8 === 0 && o.test(d));
  }
  e.exports = t.default, e.exports.default = t.default;
})(JQe, Vw);
var Yw = {}, eqe = {
  get exports() {
    return Yw;
  },
  set exports(e) {
    Yw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(xt);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var i = /^[A-HJ-NP-Za-km-z1-9]*$/;
  function o(a) {
    return (0, r.default)(a), !!i.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(eqe, Yw);
var Qw = {}, tqe = {
  get exports() {
    return Qw;
  },
  set exports(e) {
    Qw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = n(xt);
  function n(u) {
    return u && u.__esModule ? u : { default: u };
  }
  var i = /^[a-z]+\/[a-z0-9\-\+\._]+$/i, o = /^[a-z\-]+=[a-z0-9\-]+$/i, a = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i;
  function s(u) {
    (0, r.default)(u);
    var d = u.split(",");
    if (d.length < 2)
      return !1;
    var f = d.shift().trim().split(";"), h = f.shift();
    if (h.slice(0, 5) !== "data:")
      return !1;
    var g = h.slice(5);
    if (g !== "" && !i.test(g))
      return !1;
    for (var m = 0; m < f.length; m++)
      if (!(m === f.length - 1 && f[m].toLowerCase() === "base64") && !o.test(f[m]))
        return !1;
    for (var v = 0; v < d.length; v++)
      if (!a.test(d[v]))
        return !1;
    return !0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(tqe, Qw);
var qw = {}, rqe = {
  get exports() {
    return qw;
  },
  set exports(e) {
    qw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(xt);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var i = /(?:^magnet:\?|[^?&]&)xt(?:\.1)?=urn:(?:(?:aich|bitprint|btih|ed2k|ed2khash|kzhash|md5|sha1|tree:tiger):[a-z0-9]{32}(?:[a-z0-9]{8})?|btmh:1220[a-z0-9]{64})(?:$|&)/i;
  function o(a) {
    return (0, r.default)(a), a.indexOf("magnet:?") !== 0 ? !1 : i.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(rqe, qw);
var Gw = {}, nqe = {
  get exports() {
    return Gw;
  },
  set exports(e) {
    Gw = e;
  }
}, nb = {}, iqe = {
  get exports() {
    return nb;
  },
  set exports(e) {
    nb = e;
  }
}, ib = {}, oqe = {
  get exports() {
    return ib;
  },
  set exports(e) {
    ib = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(xt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o, a) {
    if ((0, r.default)(o), a) {
      var s = new RegExp("[".concat(a.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "]+$"), "g");
      return o.replace(s, "");
    }
    for (var u = o.length - 1; /\s/.test(o.charAt(u)); )
      u -= 1;
    return o.slice(0, u + 1);
  }
  e.exports = t.default, e.exports.default = t.default;
})(oqe, ib);
var ob = {}, aqe = {
  get exports() {
    return ob;
  },
  set exports(e) {
    ob = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(xt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o, a) {
    (0, r.default)(o);
    var s = a ? new RegExp("^[".concat(a.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "]+"), "g") : /^\s+/g;
    return o.replace(s, "");
  }
  e.exports = t.default, e.exports.default = t.default;
})(aqe, ob);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = i(ib), n = i(ob);
  function i(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function o(a, s) {
    return (0, r.default)((0, n.default)(a, s), s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(iqe, nb);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = v;
  var r = o(nb), n = o(K0), i = o(xt);
  function o(w) {
    return w && w.__esModule ? w : { default: w };
  }
  function a(w, x) {
    return d(w) || u(w, x) || h(w, x) || s();
  }
  function s() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function u(w, x) {
    if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(w)))) {
      var y = [], C = !0, S = !1, T = void 0;
      try {
        for (var A = w[Symbol.iterator](), D; !(C = (D = A.next()).done) && (y.push(D.value), !(x && y.length === x)); C = !0)
          ;
      } catch (E) {
        S = !0, T = E;
      } finally {
        try {
          !C && A.return != null && A.return();
        } finally {
          if (S)
            throw T;
        }
      }
      return y;
    }
  }
  function d(w) {
    if (Array.isArray(w))
      return w;
  }
  function f(w, x) {
    var y;
    if (typeof Symbol > "u" || w[Symbol.iterator] == null) {
      if (Array.isArray(w) || (y = h(w)) || x && w && typeof w.length == "number") {
        y && (w = y);
        var C = 0, S = function() {
        };
        return { s: S, n: function() {
          return C >= w.length ? { done: !0 } : { done: !1, value: w[C++] };
        }, e: function(N) {
          throw N;
        }, f: S };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var T = !0, A = !1, D;
    return { s: function() {
      y = w[Symbol.iterator]();
    }, n: function() {
      var N = y.next();
      return T = N.done, N;
    }, e: function(N) {
      A = !0, D = N;
    }, f: function() {
      try {
        !T && y.return != null && y.return();
      } finally {
        if (A)
          throw D;
      }
    } };
  }
  function h(w, x) {
    if (w) {
      if (typeof w == "string")
        return g(w, x);
      var y = Object.prototype.toString.call(w).slice(8, -1);
      if (y === "Object" && w.constructor && (y = w.constructor.name), y === "Map" || y === "Set")
        return Array.from(w);
      if (y === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(y))
        return g(w, x);
    }
  }
  function g(w, x) {
    (x == null || x > w.length) && (x = w.length);
    for (var y = 0, C = new Array(x); y < x; y++)
      C[y] = w[y];
    return C;
  }
  function m(w) {
    var x = /* @__PURE__ */ new Set(["subject", "body", "cc", "bcc"]), y = {
      cc: "",
      bcc: ""
    }, C = !1, S = w.split("&");
    if (S.length > 4)
      return !1;
    var T = f(S), A;
    try {
      for (T.s(); !(A = T.n()).done; ) {
        var D = A.value, E = D.split("="), N = a(E, 2), I = N[0], $ = N[1];
        if (I && !x.has(I)) {
          C = !0;
          break;
        }
        $ && (I === "cc" || I === "bcc") && (y[I] = $), I && x.delete(I);
      }
    } catch (_) {
      T.e(_);
    } finally {
      T.f();
    }
    return C ? !1 : y;
  }
  function v(w, x) {
    if ((0, i.default)(w), w.indexOf("mailto:") !== 0)
      return !1;
    var y = w.replace("mailto:", "").split("?"), C = a(y, 2), S = C[0], T = S === void 0 ? "" : S, A = C[1], D = A === void 0 ? "" : A;
    if (!T && !D)
      return !0;
    var E = m(D);
    return E ? "".concat(T, ",").concat(E.cc, ",").concat(E.bcc).split(",").every(function(N) {
      return N = (0, r.default)(N, " "), N ? (0, n.default)(N, x) : !0;
    }) : !1;
  }
  e.exports = t.default, e.exports.default = t.default;
})(nqe, Gw);
var Zw = {}, lqe = {
  get exports() {
    return Zw;
  },
  set exports(e) {
    Zw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = n(xt);
  function n(u) {
    return u && u.__esModule ? u : { default: u };
  }
  var i = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+_]{1,100}$/i, o = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i, a = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i;
  function s(u) {
    return (0, r.default)(u), i.test(u) || o.test(u) || a.test(u);
  }
  e.exports = t.default, e.exports.default = t.default;
})(lqe, Zw);
var Kw = {}, sqe = {
  get exports() {
    return Kw;
  },
  set exports(e) {
    Kw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = f;
  var r = i(xt), n = i(ao);
  function i(h) {
    return h && h.__esModule ? h : { default: h };
  }
  var o = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/, a = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/, s = /^(([1-8]?\d)\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|90\D+0\D+0)\D+[NSns]?$/i, u = /^\s*([1-7]?\d{1,2}\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|180\D+0\D+0)\D+[EWew]?$/i, d = {
    checkDMS: !1
  };
  function f(h, g) {
    if ((0, r.default)(h), g = (0, n.default)(g, d), !h.includes(","))
      return !1;
    var m = h.split(",");
    return m[0].startsWith("(") && !m[1].endsWith(")") || m[1].endsWith(")") && !m[0].startsWith("(") ? !1 : g.checkDMS ? s.test(m[0]) && u.test(m[1]) : o.test(m[0]) && a.test(m[1]);
  }
  e.exports = t.default, e.exports.default = t.default;
})(sqe, Kw);
var Ub = {};
Object.defineProperty(Ub, "__esModule", {
  value: !0
});
Ub.default = fqe;
Ub.locales = void 0;
var uqe = cqe(xt);
function cqe(e) {
  return e && e.__esModule ? e : { default: e };
}
var qF = /^\d{3}$/, Na = /^\d{4}$/, Qo = /^\d{5}$/, LN = /^\d{6}$/, Qh = {
  AD: /^AD\d{3}$/,
  AT: Na,
  AU: Na,
  AZ: /^AZ\d{4}$/,
  BA: /^([7-8]\d{4}$)/,
  BE: Na,
  BG: Na,
  BR: /^\d{5}-\d{3}$/,
  BY: /^2[1-4]\d{4}$/,
  CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
  CH: Na,
  CN: /^(0[1-7]|1[012356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[1-5]|8[1345]|9[09])\d{4}$/,
  CZ: /^\d{3}\s?\d{2}$/,
  DE: Qo,
  DK: Na,
  DO: Qo,
  DZ: Qo,
  EE: Qo,
  ES: /^(5[0-2]{1}|[0-4]{1}\d{1})\d{3}$/,
  FI: Qo,
  FR: /^\d{2}\s?\d{3}$/,
  GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
  GR: /^\d{3}\s?\d{2}$/,
  HR: /^([1-5]\d{4}$)/,
  HT: /^HT\d{4}$/,
  HU: Na,
  ID: Qo,
  IE: /^(?!.*(?:o))[A-Za-z]\d[\dw]\s\w{4}$/i,
  IL: /^(\d{5}|\d{7})$/,
  IN: /^((?!10|29|35|54|55|65|66|86|87|88|89)[1-9][0-9]{5})$/,
  IR: /^(?!(\d)\1{3})[13-9]{4}[1346-9][013-9]{5}$/,
  IS: qF,
  IT: Qo,
  JP: /^\d{3}\-\d{4}$/,
  KE: Qo,
  KR: /^(\d{5}|\d{6})$/,
  LI: /^(948[5-9]|949[0-7])$/,
  LT: /^LT\-\d{5}$/,
  LU: Na,
  LV: /^LV\-\d{4}$/,
  LK: Qo,
  MG: qF,
  MX: Qo,
  MT: /^[A-Za-z]{3}\s{0,1}\d{4}$/,
  MY: Qo,
  NL: /^\d{4}\s?[a-z]{2}$/i,
  NO: Na,
  NP: /^(10|21|22|32|33|34|44|45|56|57)\d{3}$|^(977)$/i,
  NZ: Na,
  PL: /^\d{2}\-\d{3}$/,
  PR: /^00[679]\d{2}([ -]\d{4})?$/,
  PT: /^\d{4}\-\d{3}?$/,
  RO: LN,
  RU: LN,
  SA: Qo,
  SE: /^[1-9]\d{2}\s?\d{2}$/,
  SG: LN,
  SI: Na,
  SK: /^\d{3}\s?\d{2}$/,
  TH: Qo,
  TN: Na,
  TW: /^\d{3}(\d{2})?$/,
  UA: Qo,
  US: /^\d{5}(-\d{4})?$/,
  ZA: Na,
  ZM: Qo
}, dqe = Object.keys(Qh);
Ub.locales = dqe;
function fqe(e, t) {
  if ((0, uqe.default)(e), t in Qh)
    return Qh[t].test(e);
  if (t === "any") {
    for (var r in Qh)
      if (Qh.hasOwnProperty(r)) {
        var n = Qh[r];
        if (n.test(e))
          return !0;
      }
    return !1;
  }
  throw new Error("Invalid locale '".concat(t, "'"));
}
var Xw = {}, hqe = {
  get exports() {
    return Xw;
  },
  set exports(e) {
    Xw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(xt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o) {
    return (0, r.default)(o), o.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\//g, "&#x2F;").replace(/\\/g, "&#x5C;").replace(/`/g, "&#96;");
  }
  e.exports = t.default, e.exports.default = t.default;
})(hqe, Xw);
var Jw = {}, pqe = {
  get exports() {
    return Jw;
  },
  set exports(e) {
    Jw = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(xt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o) {
    return (0, r.default)(o), o.replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#x2F;/g, "/").replace(/&#x5C;/g, "\\").replace(/&#96;/g, "`").replace(/&amp;/g, "&");
  }
  e.exports = t.default, e.exports.default = t.default;
})(pqe, Jw);
var eM = {}, gqe = {
  get exports() {
    return eM;
  },
  set exports(e) {
    eM = e;
  }
}, ab = {}, mqe = {
  get exports() {
    return ab;
  },
  set exports(e) {
    ab = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(xt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o, a) {
    return (0, r.default)(o), o.replace(new RegExp("[".concat(a, "]+"), "g"), "");
  }
  e.exports = t.default, e.exports.default = t.default;
})(mqe, ab);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = i(xt), n = i(ab);
  function i(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function o(a, s) {
    (0, r.default)(a);
    var u = s ? "\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F" : "\\x00-\\x1F\\x7F";
    return (0, n.default)(a, u);
  }
  e.exports = t.default, e.exports.default = t.default;
})(gqe, eM);
var tM = {}, vqe = {
  get exports() {
    return tM;
  },
  set exports(e) {
    tM = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(xt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o, a) {
    return (0, r.default)(o), o.replace(new RegExp("[^".concat(a, "]+"), "g"), "");
  }
  e.exports = t.default, e.exports.default = t.default;
})(vqe, tM);
var rM = {}, bqe = {
  get exports() {
    return rM;
  },
  set exports(e) {
    rM = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(xt);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i(o, a) {
    (0, r.default)(o);
    for (var s = o.length - 1; s >= 0; s--)
      if (a.indexOf(o[s]) === -1)
        return !1;
    return !0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(bqe, rM);
var nM = {}, yqe = {
  get exports() {
    return nM;
  },
  set exports(e) {
    nM = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = f;
  var r = n(ao);
  function n(h) {
    return h && h.__esModule ? h : { default: h };
  }
  var i = {
    // The following options apply to all email addresses
    // Lowercases the local part of the email address.
    // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
    // The domain is always lowercased, as per RFC 1035
    all_lowercase: !0,
    // The following conversions are specific to GMail
    // Lowercases the local part of the GMail address (known to be case-insensitive)
    gmail_lowercase: !0,
    // Removes dots from the local part of the email address, as that's ignored by GMail
    gmail_remove_dots: !0,
    // Removes the subaddress (e.g. "+foo") from the email address
    gmail_remove_subaddress: !0,
    // Conversts the googlemail.com domain to gmail.com
    gmail_convert_googlemaildotcom: !0,
    // The following conversions are specific to Outlook.com / Windows Live / Hotmail
    // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
    outlookdotcom_lowercase: !0,
    // Removes the subaddress (e.g. "+foo") from the email address
    outlookdotcom_remove_subaddress: !0,
    // The following conversions are specific to Yahoo
    // Lowercases the local part of the Yahoo address (known to be case-insensitive)
    yahoo_lowercase: !0,
    // Removes the subaddress (e.g. "-foo") from the email address
    yahoo_remove_subaddress: !0,
    // The following conversions are specific to Yandex
    // Lowercases the local part of the Yandex address (known to be case-insensitive)
    yandex_lowercase: !0,
    // The following conversions are specific to iCloud
    // Lowercases the local part of the iCloud address (known to be case-insensitive)
    icloud_lowercase: !0,
    // Removes the subaddress (e.g. "+foo") from the email address
    icloud_remove_subaddress: !0
  }, o = ["icloud.com", "me.com"], a = ["hotmail.at", "hotmail.be", "hotmail.ca", "hotmail.cl", "hotmail.co.il", "hotmail.co.nz", "hotmail.co.th", "hotmail.co.uk", "hotmail.com", "hotmail.com.ar", "hotmail.com.au", "hotmail.com.br", "hotmail.com.gr", "hotmail.com.mx", "hotmail.com.pe", "hotmail.com.tr", "hotmail.com.vn", "hotmail.cz", "hotmail.de", "hotmail.dk", "hotmail.es", "hotmail.fr", "hotmail.hu", "hotmail.id", "hotmail.ie", "hotmail.in", "hotmail.it", "hotmail.jp", "hotmail.kr", "hotmail.lv", "hotmail.my", "hotmail.ph", "hotmail.pt", "hotmail.sa", "hotmail.sg", "hotmail.sk", "live.be", "live.co.uk", "live.com", "live.com.ar", "live.com.mx", "live.de", "live.es", "live.eu", "live.fr", "live.it", "live.nl", "msn.com", "outlook.at", "outlook.be", "outlook.cl", "outlook.co.il", "outlook.co.nz", "outlook.co.th", "outlook.com", "outlook.com.ar", "outlook.com.au", "outlook.com.br", "outlook.com.gr", "outlook.com.pe", "outlook.com.tr", "outlook.com.vn", "outlook.cz", "outlook.de", "outlook.dk", "outlook.es", "outlook.fr", "outlook.hu", "outlook.id", "outlook.ie", "outlook.in", "outlook.it", "outlook.jp", "outlook.kr", "outlook.lv", "outlook.my", "outlook.ph", "outlook.pt", "outlook.sa", "outlook.sg", "outlook.sk", "passport.com"], s = ["rocketmail.com", "yahoo.ca", "yahoo.co.uk", "yahoo.com", "yahoo.de", "yahoo.fr", "yahoo.in", "yahoo.it", "ymail.com"], u = ["yandex.ru", "yandex.ua", "yandex.kz", "yandex.com", "yandex.by", "ya.ru"];
  function d(h) {
    return h.length > 1 ? h : "";
  }
  function f(h, g) {
    g = (0, r.default)(g, i);
    var m = h.split("@"), v = m.pop(), w = m.join("@"), x = [w, v];
    if (x[1] = x[1].toLowerCase(), x[1] === "gmail.com" || x[1] === "googlemail.com") {
      if (g.gmail_remove_subaddress && (x[0] = x[0].split("+")[0]), g.gmail_remove_dots && (x[0] = x[0].replace(/\.+/g, d)), !x[0].length)
        return !1;
      (g.all_lowercase || g.gmail_lowercase) && (x[0] = x[0].toLowerCase()), x[1] = g.gmail_convert_googlemaildotcom ? "gmail.com" : x[1];
    } else if (o.indexOf(x[1]) >= 0) {
      if (g.icloud_remove_subaddress && (x[0] = x[0].split("+")[0]), !x[0].length)
        return !1;
      (g.all_lowercase || g.icloud_lowercase) && (x[0] = x[0].toLowerCase());
    } else if (a.indexOf(x[1]) >= 0) {
      if (g.outlookdotcom_remove_subaddress && (x[0] = x[0].split("+")[0]), !x[0].length)
        return !1;
      (g.all_lowercase || g.outlookdotcom_lowercase) && (x[0] = x[0].toLowerCase());
    } else if (s.indexOf(x[1]) >= 0) {
      if (g.yahoo_remove_subaddress) {
        var y = x[0].split("-");
        x[0] = y.length > 1 ? y.slice(0, -1).join("-") : y[0];
      }
      if (!x[0].length)
        return !1;
      (g.all_lowercase || g.yahoo_lowercase) && (x[0] = x[0].toLowerCase());
    } else
      u.indexOf(x[1]) >= 0 ? ((g.all_lowercase || g.yandex_lowercase) && (x[0] = x[0].toLowerCase()), x[1] = "yandex.ru") : g.all_lowercase && (x[0] = x[0].toLowerCase());
    return x.join("@");
  }
  e.exports = t.default, e.exports.default = t.default;
})(yqe, nM);
var iM = {}, xqe = {
  get exports() {
    return iM;
  },
  set exports(e) {
    iM = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(xt);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var i = /^[^\s-_](?!.*?[-_]{2,})[a-z0-9-\\][^\s]*[^-_\s]$/;
  function o(a) {
    return (0, r.default)(a), i.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(xqe, iM);
var oM = {}, wqe = {
  get exports() {
    return oM;
  },
  set exports(e) {
    oM = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(xt);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var i = {
    "cs-CZ": function(s) {
      return /^(([ABCDEFHIJKLMNPRSTUVXYZ]|[0-9])-?){5,8}$/.test(s);
    },
    "de-DE": function(s) {
      return /^((A|AA|AB|AC|AE|AH|AK|AM|AN|AÖ|AP|AS|AT|AU|AW|AZ|B|BA|BB|BC|BE|BF|BH|BI|BK|BL|BM|BN|BO|BÖ|BS|BT|BZ|C|CA|CB|CE|CO|CR|CW|D|DA|DD|DE|DH|DI|DL|DM|DN|DO|DU|DW|DZ|E|EA|EB|ED|EE|EF|EG|EH|EI|EL|EM|EN|ER|ES|EU|EW|F|FB|FD|FF|FG|FI|FL|FN|FO|FR|FS|FT|FÜ|FW|FZ|G|GA|GC|GD|GE|GF|GG|GI|GK|GL|GM|GN|GÖ|GP|GR|GS|GT|GÜ|GV|GW|GZ|H|HA|HB|HC|HD|HE|HF|HG|HH|HI|HK|HL|HM|HN|HO|HP|HR|HS|HU|HV|HX|HY|HZ|IK|IL|IN|IZ|J|JE|JL|K|KA|KB|KC|KE|KF|KG|KH|KI|KK|KL|KM|KN|KO|KR|KS|KT|KU|KW|KY|L|LA|LB|LC|LD|LF|LG|LH|LI|LL|LM|LN|LÖ|LP|LR|LU|M|MA|MB|MC|MD|ME|MG|MH|MI|MK|ML|MM|MN|MO|MQ|MR|MS|MÜ|MW|MY|MZ|N|NB|ND|NE|NF|NH|NI|NK|NM|NÖ|NP|NR|NT|NU|NW|NY|NZ|OA|OB|OC|OD|OE|OF|OG|OH|OK|OL|OP|OS|OZ|P|PA|PB|PE|PF|PI|PL|PM|PN|PR|PS|PW|PZ|R|RA|RC|RD|RE|RG|RH|RI|RL|RM|RN|RO|RP|RS|RT|RU|RV|RW|RZ|S|SB|SC|SE|SG|SI|SK|SL|SM|SN|SO|SP|SR|ST|SU|SW|SY|SZ|TE|TF|TG|TO|TP|TR|TS|TT|TÜ|ÜB|UE|UH|UL|UM|UN|V|VB|VG|VK|VR|VS|W|WA|WB|WE|WF|WI|WK|WL|WM|WN|WO|WR|WS|WT|WÜ|WW|WZ|Z|ZE|ZI|ZP|ZR|ZW|ZZ)[- ]?[A-Z]{1,2}[- ]?\d{1,4}|(ABG|ABI|AIB|AIC|ALF|ALZ|ANA|ANG|ANK|APD|ARN|ART|ASL|ASZ|AUR|AZE|BAD|BAR|BBG|BCH|BED|BER|BGD|BGL|BID|BIN|BIR|BIT|BIW|BKS|BLB|BLK|BNA|BOG|BOH|BOR|BOT|BRA|BRB|BRG|BRK|BRL|BRV|BSB|BSK|BTF|BÜD|BUL|BÜR|BÜS|BÜZ|CAS|CHA|CLP|CLZ|COC|COE|CUX|DAH|DAN|DAU|DBR|DEG|DEL|DGF|DIL|DIN|DIZ|DKB|DLG|DON|DUD|DÜW|EBE|EBN|EBS|ECK|EIC|EIL|EIN|EIS|EMD|EMS|ERB|ERH|ERK|ERZ|ESB|ESW|FDB|FDS|FEU|FFB|FKB|FLÖ|FOR|FRG|FRI|FRW|FTL|FÜS|GAN|GAP|GDB|GEL|GEO|GER|GHA|GHC|GLA|GMN|GNT|GOA|GOH|GRA|GRH|GRI|GRM|GRZ|GTH|GUB|GUN|GVM|HAB|HAL|HAM|HAS|HBN|HBS|HCH|HDH|HDL|HEB|HEF|HEI|HER|HET|HGN|HGW|HHM|HIG|HIP|HMÜ|HOG|HOH|HOL|HOM|HOR|HÖS|HOT|HRO|HSK|HST|HVL|HWI|IGB|ILL|JÜL|KEH|KEL|KEM|KIB|KLE|KLZ|KÖN|KÖT|KÖZ|KRU|KÜN|KUS|KYF|LAN|LAU|LBS|LBZ|LDK|LDS|LEO|LER|LEV|LIB|LIF|LIP|LÖB|LOS|LRO|LSZ|LÜN|LUP|LWL|MAB|MAI|MAK|MAL|MED|MEG|MEI|MEK|MEL|MER|MET|MGH|MGN|MHL|MIL|MKK|MOD|MOL|MON|MOS|MSE|MSH|MSP|MST|MTK|MTL|MÜB|MÜR|MYK|MZG|NAB|NAI|NAU|NDH|NEA|NEB|NEC|NEN|NES|NEW|NMB|NMS|NOH|NOL|NOM|NOR|NVP|NWM|OAL|OBB|OBG|OCH|OHA|ÖHR|OHV|OHZ|OPR|OSL|OVI|OVL|OVP|PAF|PAN|PAR|PCH|PEG|PIR|PLÖ|PRÜ|QFT|QLB|RDG|REG|REH|REI|RID|RIE|ROD|ROF|ROK|ROL|ROS|ROT|ROW|RSL|RÜD|RÜG|SAB|SAD|SAN|SAW|SBG|SBK|SCZ|SDH|SDL|SDT|SEB|SEE|SEF|SEL|SFB|SFT|SGH|SHA|SHG|SHK|SHL|SIG|SIM|SLE|SLF|SLK|SLN|SLS|SLÜ|SLZ|SMÜ|SOB|SOG|SOK|SÖM|SON|SPB|SPN|SRB|SRO|STA|STB|STD|STE|STL|SUL|SÜW|SWA|SZB|TBB|TDO|TET|TIR|TÖL|TUT|UEM|UER|UFF|USI|VAI|VEC|VER|VIB|VIE|VIT|VOH|WAF|WAK|WAN|WAR|WAT|WBS|WDA|WEL|WEN|WER|WES|WHV|WIL|WIS|WIT|WIZ|WLG|WMS|WND|WOB|WOH|WOL|WOR|WOS|WRN|WSF|WST|WSW|WTL|WTM|WUG|WÜM|WUN|WUR|WZL|ZEL|ZIG)[- ]?(([A-Z][- ]?\d{1,4})|([A-Z]{2}[- ]?\d{1,3})))[- ]?(E|H)?$/.test(s);
    },
    "de-LI": function(s) {
      return /^FL[- ]?\d{1,5}[UZ]?$/.test(s);
    },
    "en-IN": function(s) {
      return /^[A-Z]{2}[ -]?[0-9]{1,2}(?:[ -]?[A-Z])(?:[ -]?[A-Z]*)?[ -]?[0-9]{4}$/.test(s);
    },
    "es-AR": function(s) {
      return /^(([A-Z]{2} ?[0-9]{3} ?[A-Z]{2})|([A-Z]{3} ?[0-9]{3}))$/.test(s);
    },
    "fi-FI": function(s) {
      return /^(?=.{4,7})(([A-Z]{1,3}|[0-9]{1,3})[\s-]?([A-Z]{1,3}|[0-9]{1,5}))$/.test(s);
    },
    "hu-HU": function(s) {
      return /^((((?!AAA)(([A-NPRSTVZWXY]{1})([A-PR-Z]{1})([A-HJ-NPR-Z]))|(A[ABC]I)|A[ABC]O|A[A-W]Q|BPI|BPO|UCO|UDO|XAO)-(?!000)\d{3})|(M\d{6})|((CK|DT|CD|HC|H[ABEFIKLMNPRSTVX]|MA|OT|R[A-Z]) \d{2}-\d{2})|(CD \d{3}-\d{3})|(C-(C|X) \d{4})|(X-(A|B|C) \d{4})|(([EPVZ]-\d{5}))|(S A[A-Z]{2} \d{2})|(SP \d{2}-\d{2}))$/.test(s);
    },
    "pt-BR": function(s) {
      return /^[A-Z]{3}[ -]?[0-9][A-Z][0-9]{2}|[A-Z]{3}[ -]?[0-9]{4}$/.test(s);
    },
    "pt-PT": function(s) {
      return /^([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})$/.test(s);
    },
    "sq-AL": function(s) {
      return /^[A-Z]{2}[- ]?((\d{3}[- ]?(([A-Z]{2})|T))|(R[- ]?\d{3}))$/.test(s);
    },
    "sv-SE": function(s) {
      return /^[A-HJ-PR-UW-Z]{3} ?[\d]{2}[A-HJ-PR-UW-Z1-9]$|(^[A-ZÅÄÖ ]{2,7}$)/.test(s.trim());
    }
  };
  function o(a, s) {
    if ((0, r.default)(a), s in i)
      return i[s](a);
    if (s === "any") {
      for (var u in i) {
        var d = i[u];
        if (d(a))
          return !0;
      }
      return !1;
    }
    throw new Error("Invalid locale '".concat(s, "'"));
  }
  e.exports = t.default, e.exports.default = t.default;
})(wqe, oM);
var aM = {}, Mqe = {
  get exports() {
    return aM;
  },
  set exports(e) {
    aM = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = m;
  var r = i(ao), n = i(xt);
  function i(v) {
    return v && v.__esModule ? v : { default: v };
  }
  var o = /^[A-Z]$/, a = /^[a-z]$/, s = /^[0-9]$/, u = /^[-#!$@£%^&*()_+|~=`{}\[\]:";'<>?,.\/ ]$/, d = {
    minLength: 8,
    minLowercase: 1,
    minUppercase: 1,
    minNumbers: 1,
    minSymbols: 1,
    returnScore: !1,
    pointsPerUnique: 1,
    pointsPerRepeat: 0.5,
    pointsForContainingLower: 10,
    pointsForContainingUpper: 10,
    pointsForContainingNumber: 10,
    pointsForContainingSymbol: 10
  };
  function f(v) {
    var w = {};
    return Array.from(v).forEach(function(x) {
      var y = w[x];
      y ? w[x] += 1 : w[x] = 1;
    }), w;
  }
  function h(v) {
    var w = f(v), x = {
      length: v.length,
      uniqueChars: Object.keys(w).length,
      uppercaseCount: 0,
      lowercaseCount: 0,
      numberCount: 0,
      symbolCount: 0
    };
    return Object.keys(w).forEach(function(y) {
      o.test(y) ? x.uppercaseCount += w[y] : a.test(y) ? x.lowercaseCount += w[y] : s.test(y) ? x.numberCount += w[y] : u.test(y) && (x.symbolCount += w[y]);
    }), x;
  }
  function g(v, w) {
    var x = 0;
    return x += v.uniqueChars * w.pointsPerUnique, x += (v.length - v.uniqueChars) * w.pointsPerRepeat, v.lowercaseCount > 0 && (x += w.pointsForContainingLower), v.uppercaseCount > 0 && (x += w.pointsForContainingUpper), v.numberCount > 0 && (x += w.pointsForContainingNumber), v.symbolCount > 0 && (x += w.pointsForContainingSymbol), x;
  }
  function m(v) {
    var w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    (0, n.default)(v);
    var x = h(v);
    return w = (0, r.default)(w || {}, d), w.returnScore ? g(x, w) : x.length >= w.minLength && x.lowercaseCount >= w.minLowercase && x.uppercaseCount >= w.minUppercase && x.numberCount >= w.minNumbers && x.symbolCount >= w.minSymbols;
  }
  e.exports = t.default, e.exports.default = t.default;
})(Mqe, aM);
var Hb = {};
function R1(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? R1 = function(r) {
    return typeof r;
  } : R1 = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, R1(e);
}
Object.defineProperty(Hb, "__esModule", {
  value: !0
});
Hb.default = Aqe;
Hb.vatMatchers = void 0;
var GF = Tqe(xt), Cqe = Sqe(wh);
function hG() {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap();
  return hG = function() {
    return e;
  }, e;
}
function Sqe(e) {
  if (e && e.__esModule)
    return e;
  if (e === null || R1(e) !== "object" && typeof e != "function")
    return { default: e };
  var t = hG();
  if (t && t.has(e))
    return t.get(e);
  var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      var o = n ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(r, i, o) : r[i] = e[i];
    }
  return r.default = e, t && t.set(e, r), r;
}
function Tqe(e) {
  return e && e.__esModule ? e : { default: e };
}
var kqe = function(t) {
  var r = function(i) {
    var o = i.pop(), a = [5, 4, 3, 2, 7, 6, 5, 4], s = (11 - i.reduce(function(u, d, f) {
      return u + d * a[f];
    }, 0) % 11) % 11;
    return o === s;
  };
  return /^(CHE[- ]?)?(\d{9}|(\d{3}\.\d{3}\.\d{3})|(\d{3} \d{3} \d{3})) ?(TVA|MWST|IVA)?$/.test(t) && r(t.match(/\d/g).map(function(n) {
    return +n;
  }));
}, Dqe = function(t) {
  var r = t.match(/^(PT)?(\d{9})$/);
  if (!r)
    return !1;
  var n = r[2], i = 11 - Cqe.reverseMultiplyAndSum(n.split("").slice(0, 8).map(function(o) {
    return parseInt(o, 10);
  }), 9) % 11;
  return i > 9 ? parseInt(n[8], 10) === 0 : i === parseInt(n[8], 10);
}, yO = {
  /**
   * European Union VAT identification numbers
   */
  AT: function(t) {
    return /^(AT)?U\d{8}$/.test(t);
  },
  BE: function(t) {
    return /^(BE)?\d{10}$/.test(t);
  },
  BG: function(t) {
    return /^(BG)?\d{9,10}$/.test(t);
  },
  HR: function(t) {
    return /^(HR)?\d{11}$/.test(t);
  },
  CY: function(t) {
    return /^(CY)?\w{9}$/.test(t);
  },
  CZ: function(t) {
    return /^(CZ)?\d{8,10}$/.test(t);
  },
  DK: function(t) {
    return /^(DK)?\d{8}$/.test(t);
  },
  EE: function(t) {
    return /^(EE)?\d{9}$/.test(t);
  },
  FI: function(t) {
    return /^(FI)?\d{8}$/.test(t);
  },
  FR: function(t) {
    return /^(FR)?\w{2}\d{9}$/.test(t);
  },
  DE: function(t) {
    return /^(DE)?\d{9}$/.test(t);
  },
  EL: function(t) {
    return /^(EL)?\d{9}$/.test(t);
  },
  HU: function(t) {
    return /^(HU)?\d{8}$/.test(t);
  },
  IE: function(t) {
    return /^(IE)?\d{7}\w{1}(W)?$/.test(t);
  },
  IT: function(t) {
    return /^(IT)?\d{11}$/.test(t);
  },
  LV: function(t) {
    return /^(LV)?\d{11}$/.test(t);
  },
  LT: function(t) {
    return /^(LT)?\d{9,12}$/.test(t);
  },
  LU: function(t) {
    return /^(LU)?\d{8}$/.test(t);
  },
  MT: function(t) {
    return /^(MT)?\d{8}$/.test(t);
  },
  NL: function(t) {
    return /^(NL)?\d{9}B\d{2}$/.test(t);
  },
  PL: function(t) {
    return /^(PL)?(\d{10}|(\d{3}-\d{3}-\d{2}-\d{2})|(\d{3}-\d{2}-\d{2}-\d{3}))$/.test(t);
  },
  PT: Dqe,
  RO: function(t) {
    return /^(RO)?\d{2,10}$/.test(t);
  },
  SK: function(t) {
    return /^(SK)?\d{10}$/.test(t);
  },
  SI: function(t) {
    return /^(SI)?\d{8}$/.test(t);
  },
  ES: function(t) {
    return /^(ES)?\w\d{7}[A-Z]$/.test(t);
  },
  SE: function(t) {
    return /^(SE)?\d{12}$/.test(t);
  },
  /**
   * VAT numbers of non-EU countries
   */
  AL: function(t) {
    return /^(AL)?\w{9}[A-Z]$/.test(t);
  },
  MK: function(t) {
    return /^(MK)?\d{13}$/.test(t);
  },
  AU: function(t) {
    return /^(AU)?\d{11}$/.test(t);
  },
  BY: function(t) {
    return /^(УНП )?\d{9}$/.test(t);
  },
  CA: function(t) {
    return /^(CA)?\d{9}$/.test(t);
  },
  IS: function(t) {
    return /^(IS)?\d{5,6}$/.test(t);
  },
  IN: function(t) {
    return /^(IN)?\d{15}$/.test(t);
  },
  ID: function(t) {
    return /^(ID)?(\d{15}|(\d{2}.\d{3}.\d{3}.\d{1}-\d{3}.\d{3}))$/.test(t);
  },
  IL: function(t) {
    return /^(IL)?\d{9}$/.test(t);
  },
  KZ: function(t) {
    return /^(KZ)?\d{9}$/.test(t);
  },
  NZ: function(t) {
    return /^(NZ)?\d{9}$/.test(t);
  },
  NG: function(t) {
    return /^(NG)?(\d{12}|(\d{8}-\d{4}))$/.test(t);
  },
  NO: function(t) {
    return /^(NO)?\d{9}MVA$/.test(t);
  },
  PH: function(t) {
    return /^(PH)?(\d{12}|\d{3} \d{3} \d{3} \d{3})$/.test(t);
  },
  RU: function(t) {
    return /^(RU)?(\d{10}|\d{12})$/.test(t);
  },
  SM: function(t) {
    return /^(SM)?\d{5}$/.test(t);
  },
  SA: function(t) {
    return /^(SA)?\d{15}$/.test(t);
  },
  RS: function(t) {
    return /^(RS)?\d{9}$/.test(t);
  },
  CH: kqe,
  TR: function(t) {
    return /^(TR)?\d{10}$/.test(t);
  },
  UA: function(t) {
    return /^(UA)?\d{12}$/.test(t);
  },
  GB: function(t) {
    return /^GB((\d{3} \d{4} ([0-8][0-9]|9[0-6]))|(\d{9} \d{3})|(((GD[0-4])|(HA[5-9]))[0-9]{2}))$/.test(t);
  },
  UZ: function(t) {
    return /^(UZ)?\d{9}$/.test(t);
  },
  /**
   * VAT numbers of Latin American countries
   */
  AR: function(t) {
    return /^(AR)?\d{11}$/.test(t);
  },
  BO: function(t) {
    return /^(BO)?\d{7}$/.test(t);
  },
  BR: function(t) {
    return /^(BR)?((\d{2}.\d{3}.\d{3}\/\d{4}-\d{2})|(\d{3}.\d{3}.\d{3}-\d{2}))$/.test(t);
  },
  CL: function(t) {
    return /^(CL)?\d{8}-\d{1}$/.test(t);
  },
  CO: function(t) {
    return /^(CO)?\d{10}$/.test(t);
  },
  CR: function(t) {
    return /^(CR)?\d{9,12}$/.test(t);
  },
  EC: function(t) {
    return /^(EC)?\d{13}$/.test(t);
  },
  SV: function(t) {
    return /^(SV)?\d{4}-\d{6}-\d{3}-\d{1}$/.test(t);
  },
  GT: function(t) {
    return /^(GT)?\d{7}-\d{1}$/.test(t);
  },
  HN: function(t) {
    return /^(HN)?$/.test(t);
  },
  MX: function(t) {
    return /^(MX)?\w{3,4}\d{6}\w{3}$/.test(t);
  },
  NI: function(t) {
    return /^(NI)?\d{3}-\d{6}-\d{4}\w{1}$/.test(t);
  },
  PA: function(t) {
    return /^(PA)?$/.test(t);
  },
  PY: function(t) {
    return /^(PY)?\d{6,8}-\d{1}$/.test(t);
  },
  PE: function(t) {
    return /^(PE)?\d{11}$/.test(t);
  },
  DO: function(t) {
    return /^(DO)?(\d{11}|(\d{3}-\d{7}-\d{1})|[1,4,5]{1}\d{8}|([1,4,5]{1})-\d{2}-\d{5}-\d{1})$/.test(t);
  },
  UY: function(t) {
    return /^(UY)?\d{12}$/.test(t);
  },
  VE: function(t) {
    return /^(VE)?[J,G,V,E]{1}-(\d{9}|(\d{8}-\d{1}))$/.test(t);
  }
};
Hb.vatMatchers = yO;
function Aqe(e, t) {
  if ((0, GF.default)(e), (0, GF.default)(t), t in yO)
    return yO[t](e);
  throw new Error("Invalid country code: '".concat(t, "'"));
}
(function(e, t) {
  function r(kr) {
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(hi) {
      return typeof hi;
    } : r = function(hi) {
      return hi && typeof Symbol == "function" && hi.constructor === Symbol && hi !== Symbol.prototype ? "symbol" : typeof hi;
    }, r(kr);
  }
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var n = ct(Op), i = ct(G0), o = ct(Bx), a = ct(Ux), s = ct(Hx), u = ct(Wx), d = ct(Vx), f = ct(K0), h = ct(Yx), g = ct(Qx), m = ct(lh), v = ct(qx), w = ct(_p), x = ct(J0), y = ct(Gx), C = ct(Zx), S = ct(Kx), T = Wr(Lb), A = Wr(Pb), D = ct(Xx), E = ct(Jx), N = ct(ew), I = ct(tw), $ = ct(rw), _ = ct(nw), R = ct(iw), U = ct(rg), Q = ct(ng), Z = ct(ow), X = ct(aw), re = ct(lw), ue = ct(uw), he = ct(Lp), te = Wr(tg), de = ct(cw), De = ct(eb), Oe = ct(fw), Qe = ct(hw), Ae = ct(pw), Ne = ct(gw), $e = ct(mw), et = ct(vw), Ge = Wr(Rb), Ee = ct(yw), qe = ct(xw), Ue = ct(ww), ot = ct(Mw), Ie = ct(Cw), rt = ct(Sw), W = ct(Tw), P = ct(X0), H = ct(kw), se = ct(Dw), pe = ct(Aw), ae = ct(Ew), Me = ct(Iw), fe = ct(rb), ke = ct(Nw), Le = ct(zw), dt = ct($w), Mt = ct(Ow), Ct = ct(_w), er = ct(Lw), Vt = ct(Pw), jt = Wr(jb), at = ct(Rw), St = ct(jw), ve = ct(Fw), We = Fb, ne = ct(Bw), Se = ct(Uw), _e = ct(Hw), ut = ct(ig), ht = ct(Ww), ye = ct(Bb), Ze = ct(Vw), st = ct(Yw), Nt = ct(tb), Te = ct(Qw), Ke = ct(qw), xe = ct(Gw), Xe = ct(Zw), At = ct(Kw), Ht = Wr(Ub), zt = ct(ob), ge = ct(ib), Fe = ct(nb), Tt = ct(Xw), lr = ct(Jw), gr = ct(eM), Or = ct(tM), ri = ct(ab), xi = ct(rM), wi = ct(nM), Pi = ct(iM), Mi = ct(oM), ze = ct(aM), wt = ct(Hb);
  function Ut() {
    if (typeof WeakMap != "function")
      return null;
    var kr = /* @__PURE__ */ new WeakMap();
    return Ut = function() {
      return kr;
    }, kr;
  }
  function Wr(kr) {
    if (kr && kr.__esModule)
      return kr;
    if (kr === null || r(kr) !== "object" && typeof kr != "function")
      return { default: kr };
    var Xi = Ut();
    if (Xi && Xi.has(kr))
      return Xi.get(kr);
    var hi = {}, gl = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var so in kr)
      if (Object.prototype.hasOwnProperty.call(kr, so)) {
        var ia = gl ? Object.getOwnPropertyDescriptor(kr, so) : null;
        ia && (ia.get || ia.set) ? Object.defineProperty(hi, so, ia) : hi[so] = kr[so];
      }
    return hi.default = kr, Xi && Xi.set(kr, hi), hi;
  }
  function ct(kr) {
    return kr && kr.__esModule ? kr : { default: kr };
  }
  var en = "13.11.0", Ci = {
    version: en,
    toDate: n.default,
    toFloat: i.default,
    toInt: o.default,
    toBoolean: a.default,
    equals: s.default,
    contains: u.default,
    matches: d.default,
    isEmail: f.default,
    isURL: h.default,
    isMACAddress: g.default,
    isIP: m.default,
    isIPRange: v.default,
    isFQDN: w.default,
    isBoolean: C.default,
    isIBAN: Ge.default,
    isBIC: Ee.default,
    isAlpha: T.default,
    isAlphaLocales: T.locales,
    isAlphanumeric: A.default,
    isAlphanumericLocales: A.locales,
    isNumeric: D.default,
    isPassportNumber: E.default,
    isPort: N.default,
    isLowercase: I.default,
    isUppercase: $.default,
    isAscii: R.default,
    isFullWidth: U.default,
    isHalfWidth: Q.default,
    isVariableWidth: Z.default,
    isMultibyte: X.default,
    isSemVer: re.default,
    isSurrogatePair: ue.default,
    isInt: he.default,
    isIMEI: _.default,
    isFloat: te.default,
    isFloatLocales: te.locales,
    isDecimal: de.default,
    isHexadecimal: De.default,
    isOctal: Oe.default,
    isDivisibleBy: Qe.default,
    isHexColor: Ae.default,
    isRgbColor: Ne.default,
    isHSL: $e.default,
    isISRC: et.default,
    isMD5: qe.default,
    isHash: Ue.default,
    isJWT: ot.default,
    isJSON: Ie.default,
    isEmpty: rt.default,
    isLength: W.default,
    isLocale: S.default,
    isByteLength: P.default,
    isUUID: H.default,
    isMongoId: se.default,
    isAfter: pe.default,
    isBefore: ae.default,
    isIn: Me.default,
    isLuhnNumber: fe.default,
    isCreditCard: ke.default,
    isIdentityCard: Le.default,
    isEAN: dt.default,
    isISIN: Mt.default,
    isISBN: Ct.default,
    isISSN: er.default,
    isMobilePhone: jt.default,
    isMobilePhoneLocales: jt.locales,
    isPostalCode: Ht.default,
    isPostalCodeLocales: Ht.locales,
    isEthereumAddress: at.default,
    isCurrency: St.default,
    isBtcAddress: ve.default,
    isISO6346: We.isISO6346,
    isFreightContainerID: We.isFreightContainerID,
    isISO6391: ne.default,
    isISO8601: Se.default,
    isRFC3339: _e.default,
    isISO31661Alpha2: ut.default,
    isISO31661Alpha3: ht.default,
    isISO4217: ye.default,
    isBase32: Ze.default,
    isBase58: st.default,
    isBase64: Nt.default,
    isDataURI: Te.default,
    isMagnetURI: Ke.default,
    isMailtoURI: xe.default,
    isMimeType: Xe.default,
    isLatLong: At.default,
    ltrim: zt.default,
    rtrim: ge.default,
    trim: Fe.default,
    escape: Tt.default,
    unescape: lr.default,
    stripLow: gr.default,
    whitelist: Or.default,
    blacklist: ri.default,
    isWhitelisted: xi.default,
    normalizeEmail: wi.default,
    toString,
    isSlug: Pi.default,
    isStrongPassword: ze.default,
    isTaxID: Vt.default,
    isDate: x.default,
    isTime: y.default,
    isLicensePlate: Mi.default,
    isVAT: wt.default,
    ibanLocales: Ge.locales
  }, na = Ci;
  t.default = na, e.exports = t.default, e.exports.default = t.default;
})(HVe, dp);
const Eqe = /^{{.{1,}}}$/gim, pG = /* @__PURE__ */ oe({
  __name: "LinkModal",
  props: {
    editor: {
      type: Object,
      required: !0
    },
    showModal: Boolean,
    initialValues: Object,
    modalContainer: {
      type: String,
      default: null
    },
    customValues: {
      type: Array,
      required: !1,
      default: () => []
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  emits: ["onSave", "onModalClose", "onRemove"],
  setup(e, { emit: t }) {
    const r = e, n = {
      href: "",
      target: "_blank"
    };
    Qq(Zf, "handleEmpty", function() {
      return this.transform((v) => isNaN(v) ? void 0 : v);
    });
    const i = lt("locale") ?? Dn[r.language], o = [
      {
        value: "_self",
        label: i.link.self
      },
      {
        value: "_blank",
        label: i.link.newWindow
      }
    ], a = G(null), s = G(
      r.initialValues ? r.initialValues : Object.create(n)
    ), u = {
      href: {
        required: !0,
        trigger: ["change"],
        message: i.common.invalidURL,
        validator: (v, w) => Pu().test(
          "customOrWebURL",
          i.common.invalidURL,
          m
        ).isValidSync(w)
      },
      target: {
        required: !0,
        trigger: ["change"],
        message: i.common.targetNeeded
      }
    }, d = () => {
      var v;
      s.value = Object.create(n), (v = a.value) == null || v.getForm().restoreValidation(), t("onModalClose");
    }, f = () => {
      var v;
      (v = a.value) == null || v.getForm().validate().then(() => {
        t("onSave", {
          ...s.value,
          type: r.customValues.length ? "custom" : "default"
        }), d();
      }).catch();
    }, h = () => {
      t("onRemove"), d();
    }, g = (v) => {
      const w = v == null ? void 0 : v.trim();
      return w.startsWith("tel:") ? dp.isMobilePhone(w.split("tel:")[1]) : w.startsWith("mailto:") ? dp.isMailtoURI(w) : dp.isURL(w);
    }, m = (v) => !!(g(v) || Eqe.test(v));
    return (v, w) => (ie(), Pe(B(ip), {
      id: "blog-editor_link-embed",
      show: e.showModal,
      to: e.modalContainer
    }, {
      header: we(() => [
        Re(B(_0), {
          id: "warning-confirmation",
          type: "warning",
          title: B(i).linkEmbed.title,
          onClose: d
        }, null, 8, ["title"])
      ]),
      footer: we(() => [
        Re(B(L0), {
          id: "editor__link-embed-footer",
          "positive-text": B(i).common.save,
          "negative-text": B(i).common.cancel,
          disabled: !s.value.href,
          onPositiveClick: f,
          onNegativeClick: d
        }, {
          actionLeft: we(() => {
            var x;
            return [
              (x = e.initialValues) != null && x.href ? (ie(), Pe(B(on), {
                key: 0,
                id: "editor__video-picker--remove",
                type: "error",
                onClick: h
              }, {
                default: we(() => [
                  zr(ar(B(i).common.remove), 1)
                ]),
                _: 1
              })) : yt("", !0)
            ];
          }),
          _: 1
        }, 8, ["positive-text", "negative-text", "disabled"])
      ]),
      default: we(() => [
        Re(B(P0), null, {
          default: we(() => [
            Re(B(np), {
              id: "link-embed_form",
              ref_key: "formRef",
              ref: a,
              model: s.value,
              rules: u
            }, {
              default: we(() => [
                Re(B(ca), {
                  label: B(i).common.url,
                  path: "href"
                }, {
                  default: we(() => [
                    Re(B(xs), {
                      id: "editor_link-embed-href",
                      modelValue: s.value.href,
                      "onUpdate:modelValue": w[1] || (w[1] = (x) => s.value.href = x),
                      size: "large",
                      min: 0
                    }, fb({ _: 2 }, [
                      e.customValues.length ? {
                        name: "suffix",
                        fn: we(() => [
                          Re(B(n0), {
                            options: e.customValues,
                            onOnSelect: w[0] || (w[0] = (x) => s.value.href = x)
                          }, {
                            trigger: we(() => [
                              Re(B(on), {
                                id: "customValuesTrigger",
                                quaternary: ""
                              }, {
                                default: we(() => [
                                  Re(B(VZ), { class: "icon" })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["options"])
                        ]),
                        key: "0"
                      } : void 0
                    ]), 1032, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                Re(B(ca), {
                  label: B(i).common.action,
                  path: "target"
                }, {
                  default: we(() => [
                    Re(B(ws), {
                      id: "editor_link-embed-target",
                      value: s.value.target,
                      "onUpdate:value": w[2] || (w[2] = (x) => s.value.target = x),
                      options: o,
                      disabled: !s.value.href,
                      size: "large",
                      min: 0
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show", "to"]));
  }
});
const Iqe = {
  name: "RTEControlEmbedLink",
  inheritAttrs: !1,
  components: { LinkModal: pG, ToolbarButton: Br }
}, PN = /* @__PURE__ */ oe({
  ...Iqe,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    modalContainer: {
      type: String,
      default: null
    },
    tooltipLabel: {
      type: String
    },
    tooltipPosition: {
      type: String,
      default: "top"
    },
    customValues: {
      type: Array,
      required: !1
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  setup(e) {
    const t = e, r = function() {
      if (!lt("locale")) {
        const f = Dn[t.language];
        return tr("locale", f), f;
      }
      return lt("locale");
    }(), n = G(!1), i = G(void 0), o = (f) => {
      var h, g;
      if (f.href) {
        const m = f.href;
        (h = t == null ? void 0 : t.editor) == null || h.chain().focus().extendMarkRange(Qv.Link).setLink({
          href: m,
          target: f.target
        }).run();
      } else
        (g = t == null ? void 0 : t.editor) == null || g.chain().focus().unsetLink().run();
    }, a = () => {
      var f;
      (f = t == null ? void 0 : t.editor) == null || f.chain().focus().unsetLink().run();
    }, s = ({
      editor: f
    }) => {
      const h = f.getAttributes("link");
      i.value = void 0, hn.isEmpty(h) || (i.value = h);
    };
    br(() => {
      var f;
      (f = t == null ? void 0 : t.editor) == null || f.on("transaction", s);
    }), Nc(() => {
      var f;
      (f = t == null ? void 0 : t.editor) == null || f.off("transaction", s);
    }), fi(() => {
      var f;
      (f = t == null ? void 0 : t.editor) == null || f.on("transaction", s);
    }), Gr(() => {
      var f;
      (f = t == null ? void 0 : t.editor) == null || f.off("transaction", s);
    });
    const u = j(
      () => {
        var f;
        return t.editor.state.selection.empty && !((f = t.editor) != null && f.isActive(Qv.Link));
      }
    ), d = j(
      () => {
        var f;
        return (f = t == null ? void 0 : t.editor) == null ? void 0 : f.isActive(Qv.Image);
      }
    );
    return (f, h) => {
      var g;
      return ie(), Ve(Lr, null, [
        Re(Br, {
          id: B(Er).toolbarButtonShowLinkEmbed,
          disabled: B(u) || B(d),
          active: (g = e.editor) == null ? void 0 : g.isActive(B(Qv).Link),
          onOnClick: h[0] || (h[0] = (m) => n.value = !0),
          "tooltip-label": e.tooltipLabel ?? B(r).linkEmbed.tooltip,
          "tooltip-position": e.tooltipPosition
        }, {
          default: we(() => [
            Re(B(PZ), { class: "toolbar-button__icon" })
          ]),
          _: 1
        }, 8, ["id", "disabled", "active", "tooltip-label", "tooltip-position"]),
        n.value ? (ie(), Pe(pG, {
          key: 0,
          editor: e.editor,
          "show-modal": n.value,
          "initial-values": i.value,
          "modal-container": e.modalContainer,
          customValues: t.customValues,
          onOnSave: o,
          onOnModalClose: h[1] || (h[1] = (m) => n.value = !1),
          onOnRemove: a
        }, null, 8, ["editor", "show-modal", "initial-values", "modal-container", "customValues"])) : yt("", !0)
      ], 64);
    };
  }
});
PN.install = (e) => {
  e.component(PN.name, PN);
};
const Nqe = /^```([a-z]+)?[\s\n]$/, zqe = /^~~~([a-z]+)?[\s\n]$/, gG = Lo.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: null,
        parseHTML: (e) => {
          var o;
          const { languageClassPrefix: t } = this.options, i = [...((o = e.firstElementChild) == null ? void 0 : o.classList) || []].filter((a) => a.startsWith(t)).map((a) => a.replace(t, ""))[0];
          return i || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    return [
      "pre",
      _n(this.options.HTMLAttributes, t),
      [
        "code",
        {
          class: e.attrs.language ? this.options.languageClassPrefix + e.attrs.language : null
        },
        0
      ]
    ];
  },
  addCommands() {
    return {
      setCodeBlock: (e) => ({ commands: t }) => t.setNode(this.name, e),
      toggleCodeBlock: (e) => ({ commands: t }) => t.toggleNode(this.name, "paragraph", e)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: e, $anchor: t } = this.editor.state.selection, r = t.pos === 1;
        return !e || t.parent.type.name !== this.name ? !1 : r || !t.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // exit node on triple enter
      Enter: ({ editor: e }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: t } = e, { selection: r } = t, { $from: n, empty: i } = r;
        if (!i || n.parent.type !== this.type)
          return !1;
        const o = n.parentOffset === n.parent.nodeSize - 2, a = n.parent.textContent.endsWith(`

`);
        return !o || !a ? !1 : e.chain().command(({ tr: s }) => (s.delete(n.pos - 2, n.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: e }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: t } = e, { selection: r, doc: n } = t, { $from: i, empty: o } = r;
        if (!o || i.parent.type !== this.type || !(i.parentOffset === i.parent.nodeSize - 2))
          return !1;
        const s = i.after();
        return s === void 0 || n.nodeAt(s) ? !1 : e.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      H$({
        find: Nqe,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      }),
      H$({
        find: zqe,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new ra({
        key: new _o("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (e, t) => {
            if (!t.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const r = t.clipboardData.getData("text/plain"), n = t.clipboardData.getData("vscode-editor-data"), i = n ? JSON.parse(n) : void 0, o = i == null ? void 0 : i.mode;
            if (!r || !o)
              return !1;
            const { tr: a } = e.state;
            return a.replaceSelectionWith(this.type.create({ language: o })), a.setSelection(
              pr.near(
                a.doc.resolve(Math.max(0, a.selection.from - 2))
              )
            ), a.insertText(r.replace(/\r\n?/g, `
`)), a.setMeta("paste", !0), e.dispatch(a), !0;
          }
        }
      })
    ];
  }
}), $qe = /(?:^|\s)((?:`)((?:[^`]+))(?:`))$/, Oqe = /(?:^|\s)((?:`)((?:[^`]+))(?:`))/g, mG = Ua.create({
  name: "inlineCode",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [{ tag: "code" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "code",
      _n(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      setInlineCode: () => ({ commands: e }) => e.setMark(this.name),
      toggleInlineCode: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetInlineCode: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleInlineCode()
    };
  },
  addInputRules() {
    return [
      oh({
        find: $qe,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ec({
        find: Oqe,
        type: this.type
      })
    ];
  }
}), vKe = Fn.create({
  name: "codeFormats",
  addExtensions() {
    return [mG, gG];
  }
}), _qe = ["href", "rel"], Lqe = { key: 2 }, Pqe = /* @__PURE__ */ oe({
  __name: "ImageResizer",
  props: {
    editor: {
      type: Object,
      required: !0
    },
    node: {
      type: Object,
      required: !0
    },
    updateAttributes: {
      type: Function,
      required: !0
    },
    language: {
      type: String,
      default: Cn.English_US
    }
  },
  setup(e) {
    const t = e, r = lt("locale") ?? Dn[t.language], n = G(!1), i = G(!1), o = G(null), a = G({ width: 0, height: 0 }), s = G(-1), u = G(-1), d = G(null), f = G(0), h = j(() => `;width: ${t.node.attrs.width}px;height: ${t.node.attrs.height}px;`), g = j(() => {
      const D = t.node.attrs["data-wrap"] ?? null, E = t.node.attrs["data-alignment"] ?? null;
      return D ? ` wrap-${D} ` : E ? ` alignment-${E} ` : "";
    }), m = (D) => S(D, "horizontal"), v = (D) => S(D, "vertical"), w = (D) => {
      n.value = !0, s.value = D.clientX, document.addEventListener("mousemove", m), document.addEventListener("mouseup", x);
    }, x = () => {
      n.value = !1, s.value = -1, document.removeEventListener("mousemove", m), document.removeEventListener("mouseup", x);
    }, y = (D) => {
      i.value = !0, u.value = D.clientY, document.addEventListener("mousemove", v), document.addEventListener("mouseup", C);
    }, C = () => {
      i.value = !0, u.value = -1, document.removeEventListener("mousemove", v), document.removeEventListener("mouseup", C);
    };
    br(() => {
      const D = document.querySelector(".ProseMirror");
      D && (f.value = D == null ? void 0 : D.clientWidth), d.value && (d.value.onload = () => {
        var N;
        const E = (N = d.value.getClientRects()) == null ? void 0 : N[0];
        E && (a.value = {
          width: E.width,
          height: E.height
        }), E.width && E.height ? o.value = Math.abs(E.width / E.height) ?? null : console.warn(
          `GHL-text-editor - unable to set aspect ratio with dimensions :${E}`
        );
      });
    });
    const S = (D, E) => {
      var N, I, $, _;
      switch (E) {
        case "horizontal":
        default: {
          const { clientX: R } = D, U = s.value - R;
          s.value = R;
          const Q = {
            width: (N = d.value) == null ? void 0 : N.width,
            height: (I = d.value) == null ? void 0 : I.height
          };
          U > 0 ? Q.width = Q.width - Math.abs(U) > 1 ? Q.width - Math.abs(U) : 1 : Q.width = Q.width + Math.abs(U), o.value && (Q.height = Q.width / o.value), Q.width > f.value && (Q.width = f.value), t.updateAttributes(Q);
          break;
        }
        case "vertical": {
          if (!i.value)
            return;
          const { clientY: R } = D, U = u.value - R;
          if (u.value = R, U === 0)
            return;
          const Q = U > 0 ? "up" : "down";
          if (!d.value) {
            console.error("Media ref is undefined|null", {
              resizableImg: d.value
            });
            return;
          }
          const Z = {
            width: ($ = d.value) == null ? void 0 : $.width,
            height: (_ = d.value) == null ? void 0 : _.height
          };
          Q === "up" ? Z.height = Z.height - Math.abs(U) > 1 ? Z.height - Math.abs(U) : 1 : Z.height = Z.height + Math.abs(U), o.value && (Z.width = Z.height * o.value), t.updateAttributes(Z);
        }
      }
    }, T = () => {
      var D, E;
      o.value = o.value ? null : Math.abs(((D = d.value) == null ? void 0 : D.width) / ((E = d.value) == null ? void 0 : E.height));
    }, A = j(() => {
      var D, E;
      return ((D = t.node.attrs) == null ? void 0 : D.width) > 30 && ((E = t.node.attrs) == null ? void 0 : E.height) > 30;
    });
    return (D, E) => (ie(), Pe(B(P5e), {
      as: "article",
      class: Jr(["draggable__wrapper", B(A) ? "" : "inline-block"])
    }, {
      default: we(() => [
        Ye("div", {
          class: Jr(
            [
              "draggable__container",
              B(g),
              e.editor.isActive("image") ? "active" : null
            ].join(" ")
          ),
          style: Jf(B(h))
        }, [
          e.node.attrs["data-image-link"] ? (ie(), Ve("a", {
            key: 0,
            href: e.node.attrs["data-image-link"],
            rel: e.node.attrs["data-image-link-rel"],
            target: "_blank"
          }, [
            Ye("img", ir(e.node.attrs, {
              ref_key: "resizableImg",
              ref: d,
              class: "draggable__media",
              draggable: "true",
              "data-drag-handle": ""
            }), null, 16)
          ], 8, _qe)) : (ie(), Ve("img", ir({ key: 1 }, e.node.attrs, {
            ref_key: "resizableImg",
            ref: d,
            class: "draggable__media",
            draggable: "true",
            "data-drag-handle": ""
          }), null, 16)),
          e.editor.isActive("image") ? (ie(), Ve("div", Lqe, [
            Ye("div", {
              class: "draggable__controls draggable__controls--right",
              onMousedown: w,
              onMouseup: x
            }, null, 32),
            Ye("div", {
              class: "draggable__controls draggable__controls--bottom",
              onMousedown: y,
              onMouseup: C
            }, null, 32),
            Re(B(ys), {
              disabled: !B(A)
            }, {
              trigger: we(() => [
                Jn(Ye("div", {
                  class: "draggable__aspect-ratio",
                  onClick: T
                }, [
                  o.value ? (ie(), Pe(B(RZ), {
                    key: 0,
                    class: "icon"
                  })) : (ie(), Pe(B(jZ), {
                    key: 1,
                    class: "icon"
                  }))
                ], 512), [
                  [Ra, B(A)]
                ])
              ]),
              default: we(() => [
                Ye("span", null, ar(o.value ? B(r).imageEmbed.unlockAspect : B(r).imageEmbed.lockAspect), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])) : yt("", !0)
        ], 6)
      ]),
      _: 1
    }, 8, ["class"]));
  }
});
function Rqe(e) {
  return new ra({
    key: new _o("handleClickLink"),
    props: {
      handleClick: (t, r, n) => {
        var i;
        if (e.type.name === "image") {
          const o = (i = n.target) == null ? void 0 : i.closest("a");
          o == null || o.addEventListener("click", (a) => {
            a.preventDefault();
          }), n.preventDefault();
        }
      }
    }
  });
}
const jqe = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/, Fqe = Lo.create({
  name: "image",
  addOptions() {
    return {
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {},
      resizable: !0
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      class: {
        default: null
      },
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      },
      style: {
        default: null
      },
      width: {
        default: null,
        rendered: !1
      },
      height: {
        default: null,
        rendered: !1
      },
      "data-alignment": {
        default: null,
        rendered: !1
      },
      "data-wrap": {
        default: null,
        rendered: !1
      },
      "data-image-link": {
        default: null,
        rendered: !1
      },
      "data-image-link-rel": {
        default: null,
        rendered: !1
      },
      "data-image-link-target": {
        default: "_self",
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "img[src]" : 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    var i, o;
    const r = lL((i = e.attrs.width) == null ? void 0 : i.toString()), n = sL((o = e.attrs.height) == null ? void 0 : o.toString());
    return t.style = tG(e.attrs.style), t.style += `width: ${r ? r + "px" : "100%"}; max-width: 100%;`, t.style += `height: ${n ? n + "px" : "auto"};`, t.style += "clear:both;", t.width = r, t.height = n, t.alt = e.attrs.alt, t.title = e.attrs.alt, e.attrs["data-wrap"] && (t.style += cL(e.attrs["data-wrap"]), t["data-wrap"] = e.attrs["data-wrap"]), e.attrs["data-alignment"] && (t.style += uL(e.attrs["data-alignment"]), t.style += "float: none;", t["data-alignment"] = e.attrs["data-alignment"]), e.attrs["data-image-link"] ? (t["data-image-link"] = e.attrs["data-image-link"], t["data-image-link-rel"] = e.attrs["data-image-link-rel"], t["data-image-link-target"] = e.attrs["data-image-link-target"], [
      "a",
      {
        href: e.attrs["data-image-link"],
        rel: e.attrs["data-image-link-rel"],
        target: e.attrs["data-image-link-target"]
      },
      ["img", _n(this.options.HTMLAttributes, t)]
    ]) : ["img", _n(this.options.HTMLAttributes, t)];
  },
  addCommands() {
    return {
      setImage: (e) => ({ commands: t }) => t.insertContent({
        type: this.name,
        attrs: e
      })
    };
  },
  addInputRules() {
    return [
      x3e({
        find: jqe,
        type: this.type,
        getAttributes: (e) => {
          const [, , t, r, n] = e;
          return { src: r, alt: t, title: n };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const e = [];
    return e.push(
      Rqe({
        type: this.type
      })
    ), e;
  },
  addNodeView() {
    return this.options.resizable ? F5e(Pqe) : ({ node: e }) => e;
  }
}), Bqe = Fn.create({
  name: "placeholder",
  addOptions() {
    return {
      showForAllNodes: !0,
      color: "#adb5bd",
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      placeholder: "Write something …",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    return [
      new ra({
        key: new _o("placeholder"),
        props: {
          decorations: ({ doc: e, selection: t }) => {
            const r = this.editor.isEditable || !this.options.showOnlyWhenEditable, { anchor: n } = t, i = [];
            if (!r)
              return null;
            const o = e.type.createAndFill(), a = (o == null ? void 0 : o.sameMarkup(e)) && o.content.findDiffStart(e.content) === null;
            return e.descendants((s, u) => {
              const d = n >= u && n <= u + s.nodeSize, f = !s.isLeaf && !s.childCount;
              if ((d || !this.options.showOnlyCurrent) && f) {
                const h = [];
                a && h.push(this.options.emptyEditorClass), this.options.showForAllNodes && h.push(this.options.emptyNodeClass);
                const g = Nb.node(u, u + s.nodeSize, {
                  class: h.join(" "),
                  style: `--text-color:${this.options.color};`,
                  "data-placeholder": typeof this.options.placeholder == "function" ? this.options.placeholder({
                    editor: this.editor,
                    node: s,
                    pos: u,
                    hasAnchor: d
                  }) : this.options.placeholder
                });
                i.push(g);
              }
              return this.options.includeChildren;
            }), Ms.create(e, i);
          }
        }
      })
    ];
  }
}), dL = Lo.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [{ tag: "p" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "p",
      _n(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      setCustomParagraph: (e) => ({ commands: t }) => t.setNode(this.name, e)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => {
        let e = this.editor.getAttributes("heading");
        return hn.isEmpty(e) && (e = this.editor.getAttributes("paragraph")), this.editor.commands.setCustomParagraph({ ...e });
      }
    };
  }
}), Uqe = Fn.create({
  name: "textAlign",
  addOptions() {
    return {
      types: [],
      alignments: ["left", "center", "right", "justify"],
      defaultAlignment: "left"
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: (e) => e.style.textAlign || this.options.defaultAlignment,
            renderHTML: (e) => e.textAlign === this.options.defaultAlignment ? {} : { style: `text-align: ${e.textAlign}` }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlign: (e) => ({ commands: t }) => this.options.alignments.includes(e) ? this.options.types.every(
        (r) => t.updateAttributes(r, { textAlign: e })
      ) : !1,
      unsetTextAlign: () => ({ commands: e }) => this.options.types.every(
        (t) => e.resetAttributes(t, "textAlign")
      )
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
    };
  }
}), vG = Lo.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [{ tag: "blockquote" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "blockquote",
      _n(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: e }) => e.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: e }) => e.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: e }) => e.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      U0({
        find: SG,
        type: this.type
      })
    ];
  }
}), bG = Ua.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (e) => e.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight",
        getAttrs: (e) => /^(bold(er)?|[5-9]\d{2,})$/.test(e) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "strong",
      _n(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: e }) => e.setMark(this.name),
      toggleBold: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetBold: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      oh({
        find: Kq,
        type: this.type
      }),
      oh({
        find: Jq,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ec({
        find: Xq,
        type: this.type
      }),
      Ec({
        find: eG,
        type: this.type
      })
    ];
  }
}), Hqe = /(?:^|\s)((?:==)((?:[^~=]+))(?:==))$/, Wqe = /(?:^|\s)((?:==)((?:[^~=]+))(?:==))/g, yG = Ua.create({
  name: "highlight",
  addOptions() {
    return {
      multicolor: !0,
      HTMLAttributes: {}
    };
  },
  addAttributes() {
    return this.options.multicolor ? {
      color: {
        default: null,
        parseHTML: (e) => e.getAttribute("data-color") || e.style.backgroundColor,
        renderHTML: (e) => e.color ? {
          "data-color": e.color,
          style: `background-color: ${e.color}; color: inherit`
        } : {}
      }
    } : {};
  },
  parseHTML() {
    return [
      {
        tag: "mark"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "mark",
      _n(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      setHighlight: (e) => ({ commands: t }) => t.setMark(this.name, e),
      toggleHighlight: (e) => ({ commands: t }) => t.toggleMark(this.name, e),
      unsetHighlight: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-h": () => this.editor.commands.toggleHighlight()
    };
  },
  addInputRules() {
    return [
      oh({
        find: Hqe,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ec({
        find: Wqe,
        type: this.type
      })
    ];
  }
}), Pp = Ua.create({
  name: "textStyle",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (e) => e.hasAttribute("style") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "span",
      _n(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      removeEmptyTextStyle: () => ({ state: e, commands: t }) => {
        const r = O_(e, this.type);
        return Object.entries(r).some(
          ([, i]) => !!i
        ) ? !0 : t.unsetMark(this.name);
      }
    };
  }
}), xG = Fn.create({
  name: "color",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (e) => {
              var t;
              return (t = e.style.color) == null ? void 0 : t.replace(/['"]+/g, "");
            },
            renderHTML: (e) => e.color ? {
              style: `color: ${e.color}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setColor: (e) => ({ chain: t }) => t().setMark(Pp.name, { color: `${e} !important` }).run(),
      unsetColor: () => ({ chain: e }) => e().setMark(Pp.name, { color: null }).removeEmptyTextStyle().run()
    };
  }
}), Vqe = Fn.create({
  name: "color",
  addExtensions() {
    return [xG, Pp, yG];
  }
}), Yqe = Fn.create({
  name: "fontFamily",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontFamily: {
            default: null,
            parseHTML: (e) => {
              var t;
              return (t = e.style.fontFamily) == null ? void 0 : t.replace(/['"]+/g, "");
            },
            renderHTML: (e) => e.fontFamily ? {
              style: `font-family: ${e.fontFamily}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontFamily: (e) => ({ chain: t }) => t().setMark("textStyle", { fontFamily: e }).run(),
      unsetFontFamily: () => ({ chain: e }) => e().setMark("textStyle", { fontFamily: null }).removeEmptyTextStyle().run()
    };
  }
}), wG = Fn.create({
  name: "fontSize",
  addExtensions() {
    const e = [];
    return e.push(Yqe, Pp), e;
  }
}), MG = Ua.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (e) => e.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "em",
      _n(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: e }) => e.setMark(this.name),
      toggleItalic: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetItalic: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      oh({
        find: Kq,
        type: this.type
      }),
      oh({
        find: Jq,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ec({
        find: Xq,
        type: this.type
      }),
      Ec({
        find: eG,
        type: this.type
      })
    ];
  }
}), CG = Fn.create({
  name: "lineHeight",
  addOptions() {
    return {
      types: ["paragraph", "heading"],
      defaultLineHeight: "inherit"
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          lineHeight: {
            default: this.options.defaultLineHeight,
            parseHTML: (e) => e.style.lineHeight || this.options.defaultLineHeight,
            renderHTML: (e) => e.lineHeight === this.options.defaultLineHeight ? {} : { style: `line-height: ${e.lineHeight}` }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setLineHeight: (e) => ({ commands: t }) => this.options.types.every(
        (r) => t.updateAttributes(r, { lineHeight: e })
      )
    };
  }
}), SG = /(?:^|\s)((?:~~)((?:[^~]+))(?:~~))$/, Qqe = /(?:^|\s)((?:~~)((?:[^~]+))(?:~~))/g, TG = Ua.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "s",
      _n(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: e }) => e.setMark(this.name),
      toggleStrike: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetStrike: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-x": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      oh({
        find: SG,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ec({
        find: Qqe,
        type: this.type
      })
    ];
  }
}), kG = Ua.create({
  name: "subscript",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "sub"
      },
      {
        style: "vertical-align",
        getAttrs(e) {
          return e !== "sub" ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "sub",
      _n(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      toggleSubscript: () => ({ commands: e }) => e.toggleMark(this.name)
    };
  }
}), DG = Ua.create({
  name: "superscript",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "sup"
      },
      {
        style: "vertical-align",
        getAttrs(e) {
          return e !== "super" ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "sup",
      _n(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      toggleSuperscript: () => ({ commands: e }) => e.toggleMark(this.name)
    };
  }
}), AG = Lo.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((e) => ({
      tag: `h${e}`,
      attrs: { level: e }
    }));
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    return [
      `h${this.options.levels.includes(e.attrs.level) ? e.attrs.level : this.options.levels[0]}`,
      _n(this.options.HTMLAttributes, t),
      0
    ];
  },
  addCommands() {
    return {
      setHeading: (e) => ({ commands: t }) => this.options.levels.includes(e.level) ? t.setNode(this.name, e) : !1,
      toggleHeading: (e) => ({ commands: t }) => this.options.levels.includes(e.level) ? t.toggleNode(this.name, "heading", e) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce(
      (e, t) => ({
        ...e,
        [`Mod-Alt-${t}`]: () => {
          let r = this.editor.getAttributes("heading");
          hn.isEmpty(r) && (r = this.editor.getAttributes("paragraph")), this.editor.commands.toggleHeading({ ...r, level: t });
        }
      }),
      {}
    );
  },
  addInputRules() {
    return this.options.levels.map((e) => H$({
      find: new RegExp(`^(#{1,${e}})\\s$`),
      type: this.type,
      getAttributes: {
        level: e
      }
    }));
  }
}), qqe = Fn.create({
  name: "textBlocks",
  addExtensions() {
    const e = [];
    return e.push(dL, AG), e;
  }
}), fL = Fn.create({
  name: "fontSize",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (e) => e.style.fontSize.replace(/['"]+/g, ""),
            renderHTML: (e) => e.fontSize ? {
              style: `font-size: ${e.fontSize}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontSize: (e) => ({ chain: t }) => t().setMark("textStyle", { fontSize: e }).run(),
      unsetFontSize: () => ({ chain: e }) => e().setMark("textStyle", { fontSize: null }).removeEmptyTextStyle().run()
    };
  }
}), Gqe = Fn.create({
  name: "fontSize",
  addExtensions() {
    const e = [];
    return e.push(fL, Pp), e;
  }
}), EG = Ua.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "u",
      _n(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: e }) => e.setMark(this.name),
      toggleUnderline: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetUnderline: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
}), lM = Fn.create({
  name: "textExtensions",
  addExtensions() {
    const e = [];
    return e.push(
      fL,
      Pp,
      bG,
      MG,
      EG,
      TG,
      qqe,
      wG,
      CG,
      Vqe,
      DG,
      kG,
      vG
    ), e;
  }
}), hL = g1.extend({
  addAttributes() {
    return {
      textAlign: {
        default: null,
        parseHTML: (e) => e.style.textAlign || null,
        renderHTML: (e) => e.textAlign ? {
          style: `text-align:${e.textAlign}`
        } : {}
      },
      listColor: {
        default: null,
        parseHTML: (e) => e.style.color,
        renderHTML: (e) => e.listColor ? {
          style: `color: ${e.listColor}`
        } : {}
      }
    };
  }
}), IG = Lo.create({
  name: "doc",
  topNode: !0,
  content: "block+"
}), NG = Lo.create({
  name: "text",
  group: "inline"
}), Wb = function(e) {
  for (var t = 0; ; t++)
    if (e = e.previousSibling, !e)
      return t;
}, zG = function(e, t, r, n) {
  return r && (ZF(e, t, r, n, -1) || ZF(e, t, r, n, 1));
}, Zqe = /^(img|br|input|textarea|hr)$/i;
function ZF(e, t, r, n, i) {
  for (; ; ) {
    if (e == r && t == n)
      return !0;
    if (t == (i < 0 ? 0 : sM(e))) {
      let o = e.parentNode;
      if (!o || o.nodeType != 1 || Xqe(e) || Zqe.test(e.nodeName) || e.contentEditable == "false")
        return !1;
      t = Wb(e) + (i < 0 ? 0 : 1), e = o;
    } else if (e.nodeType == 1) {
      if (e = e.childNodes[t + (i < 0 ? -1 : 0)], e.contentEditable == "false")
        return !1;
      t = i < 0 ? sM(e) : 0;
    } else
      return !1;
  }
}
function sM(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function Kqe(e, t, r) {
  for (let n = t == 0, i = t == sM(e); n || i; ) {
    if (e == r)
      return !0;
    let o = Wb(e);
    if (e = e.parentNode, !e)
      return !1;
    n = n && o == 0, i = i && o == sM(e);
  }
}
function Xqe(e) {
  let t;
  for (let r = e; r && !(t = r.pmViewDesc); r = r.parentNode)
    ;
  return t && t.node && t.node.isBlock && (t.dom == e || t.contentDOM == e);
}
const $G = function(e) {
  return e.focusNode && zG(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset);
};
function OG(e, t) {
  let r = document.createEvent("Event");
  return r.initEvent("keydown", !0, !0), r.keyCode = e, r.key = r.code = t, r;
}
const Ic = typeof navigator < "u" ? navigator : null, KF = typeof document < "u" ? document : null, Yc = Ic && Ic.userAgent || "", xO = /Edge\/(\d+)/.exec(Yc), _G = /MSIE \d/.exec(Yc), wO = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Yc), Vb = !!(_G || wO || xO), LG = _G ? document.documentMode : wO ? +wO[1] : xO ? +xO[1] : 0, bC = !Vb && /gecko\/(\d+)/i.test(Yc);
bC && +(/Firefox\/(\d+)/.exec(Yc) || [0, 0])[1];
const MO = !Vb && /Chrome\/(\d+)/.exec(Yc), og = !!MO, Jqe = MO ? +MO[1] : 0, Mh = !Vb && !!Ic && /Apple Computer/.test(Ic.vendor), pL = Mh && (/Mobile\/\w+/.test(Yc) || !!Ic && Ic.maxTouchPoints > 2), Ja = pL || (Ic ? /Mac/.test(Ic.platform) : !1), Yb = /Android \d/.test(Yc), gL = !!KF && "webkitFontSmoothing" in KF.documentElement.style, eGe = gL ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function tGe(e, t = null) {
  let r = e.domSelectionRange(), n = e.state.doc;
  if (!r.focusNode)
    return null;
  let i = e.docView.nearestDesc(r.focusNode), o = i && i.size == 0, a = e.docView.posFromDOM(r.focusNode, r.focusOffset, 1);
  if (a < 0)
    return null;
  let s = n.resolve(a), u, d;
  if ($G(r)) {
    for (u = s; i && !i.node; )
      i = i.parent;
    let f = i.node;
    if (i && f.isAtom && Bt.isSelectable(f) && i.parent && !(f.isInline && Kqe(r.focusNode, r.focusOffset, i.dom))) {
      let h = i.posBefore;
      d = new Bt(a == h ? s : n.resolve(h));
    }
  } else {
    let f = e.docView.posFromDOM(r.anchorNode, r.anchorOffset, 1);
    if (f < 0)
      return null;
    u = n.resolve(f);
  }
  if (!d) {
    let f = t == "pointer" || e.state.selection.head < s.pos && !o ? 1 : -1;
    d = RG(e, u, s, f);
  }
  return d;
}
function PG(e) {
  return e.editable ? e.hasFocus() : oGe(e) && document.activeElement && document.activeElement.contains(e.dom);
}
function mL(e, t = !1) {
  let r = e.state.selection;
  if (iGe(e, r), !!PG(e)) {
    if (!t && e.input.mouseDown && e.input.mouseDown.allowDefault && og) {
      let n = e.domSelectionRange(), i = e.domObserver.currentSelection;
      if (n.anchorNode && i.anchorNode && zG(n.anchorNode, n.anchorOffset, i.anchorNode, i.anchorOffset)) {
        e.input.mouseDown.delayedSelectionSync = !0, e.domObserver.setCurSelection();
        return;
      }
    }
    if (e.domObserver.disconnectSelection(), e.cursorWrapper)
      nGe(e);
    else {
      let { anchor: n, head: i } = r, o, a;
      XF && !(r instanceof pr) && (r.$from.parent.inlineContent || (o = JF(e, r.from)), !r.empty && !r.$from.parent.inlineContent && (a = JF(e, r.to))), e.docView.setSelection(n, i, e.root, t), XF && (o && eB(o), a && eB(a)), r.visible ? e.dom.classList.remove("ProseMirror-hideselection") : (e.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && rGe(e));
    }
    e.domObserver.setCurSelection(), e.domObserver.connectSelection();
  }
}
const XF = Mh || og && Jqe < 63;
function JF(e, t) {
  let { node: r, offset: n } = e.docView.domFromPos(t, 0), i = n < r.childNodes.length ? r.childNodes[n] : null, o = n ? r.childNodes[n - 1] : null;
  if (Mh && i && i.contentEditable == "false")
    return RN(i);
  if ((!i || i.contentEditable == "false") && (!o || o.contentEditable == "false")) {
    if (i)
      return RN(i);
    if (o)
      return RN(o);
  }
}
function RN(e) {
  return e.contentEditable = "true", Mh && e.draggable && (e.draggable = !1, e.wasDraggable = !0), e;
}
function eB(e) {
  e.contentEditable = "false", e.wasDraggable && (e.draggable = !0, e.wasDraggable = null);
}
function rGe(e) {
  let t = e.dom.ownerDocument;
  t.removeEventListener("selectionchange", e.input.hideSelectionGuard);
  let r = e.domSelectionRange(), n = r.anchorNode, i = r.anchorOffset;
  t.addEventListener("selectionchange", e.input.hideSelectionGuard = () => {
    (r.anchorNode != n || r.anchorOffset != i) && (t.removeEventListener("selectionchange", e.input.hideSelectionGuard), setTimeout(() => {
      (!PG(e) || e.state.selection.visible) && e.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function nGe(e) {
  let t = e.domSelection(), r = document.createRange(), n = e.cursorWrapper.dom, i = n.nodeName == "IMG";
  i ? r.setEnd(n.parentNode, Wb(n) + 1) : r.setEnd(n, 0), r.collapse(!1), t.removeAllRanges(), t.addRange(r), !i && !e.state.selection.visible && Vb && LG <= 11 && (n.disabled = !0, n.disabled = !1);
}
function iGe(e, t) {
  if (t instanceof Bt) {
    let r = e.docView.descAt(t.from);
    r != e.lastSelectedViewDesc && (tB(e), r && r.selectNode(), e.lastSelectedViewDesc = r);
  } else
    tB(e);
}
function tB(e) {
  e.lastSelectedViewDesc && (e.lastSelectedViewDesc.parent && e.lastSelectedViewDesc.deselectNode(), e.lastSelectedViewDesc = void 0);
}
function RG(e, t, r, n) {
  return e.someProp("createSelectionBetween", (i) => i(e, t, r)) || pr.between(t, r, n);
}
function oGe(e) {
  let t = e.domSelectionRange();
  if (!t.anchorNode)
    return !1;
  try {
    return e.dom.contains(t.anchorNode.nodeType == 3 ? t.anchorNode.parentNode : t.anchorNode) && (e.editable || e.dom.contains(t.focusNode.nodeType == 3 ? t.focusNode.parentNode : t.focusNode));
  } catch {
    return !1;
  }
}
function CO(e, t) {
  let { $anchor: r, $head: n } = e.selection, i = t > 0 ? r.max(n) : r.min(n), o = i.parent.inlineContent ? i.depth ? e.doc.resolve(t > 0 ? i.after() : i.before()) : null : i;
  return o && Ar.findFrom(o, t);
}
function If(e, t) {
  return e.dispatch(e.state.tr.setSelection(t).scrollIntoView()), !0;
}
function rB(e, t, r) {
  let n = e.state.selection;
  if (n instanceof pr) {
    if (!n.empty || r.indexOf("s") > -1)
      return !1;
    if (e.endOfTextblock(t > 0 ? "right" : "left")) {
      let i = CO(e.state, t);
      return i && i instanceof Bt ? If(e, i) : !1;
    } else if (!(Ja && r.indexOf("m") > -1)) {
      let i = n.$head, o = i.textOffset ? null : t < 0 ? i.nodeBefore : i.nodeAfter, a;
      if (!o || o.isText)
        return !1;
      let s = t < 0 ? i.pos - o.nodeSize : i.pos;
      return o.isAtom || (a = e.docView.descAt(s)) && !a.contentDOM ? Bt.isSelectable(o) ? If(e, new Bt(t < 0 ? e.state.doc.resolve(i.pos - o.nodeSize) : i)) : gL ? If(e, new pr(e.state.doc.resolve(t < 0 ? s : s + o.nodeSize))) : !1 : !1;
    }
  } else {
    if (n instanceof Bt && n.node.isInline)
      return If(e, new pr(t > 0 ? n.$to : n.$from));
    {
      let i = CO(e.state, t);
      return i ? If(e, i) : !1;
    }
  }
}
function uM(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function d0(e) {
  let t = e.pmViewDesc;
  return t && t.size == 0 && (e.nextSibling || e.nodeName != "BR");
}
function jN(e) {
  let t = e.domSelectionRange(), r = t.focusNode, n = t.focusOffset;
  if (!r)
    return;
  let i, o, a = !1;
  for (bC && r.nodeType == 1 && n < uM(r) && d0(r.childNodes[n]) && (a = !0); ; )
    if (n > 0) {
      if (r.nodeType != 1)
        break;
      {
        let s = r.childNodes[n - 1];
        if (d0(s))
          i = r, o = --n;
        else if (s.nodeType == 3)
          r = s, n = r.nodeValue.length;
        else
          break;
      }
    } else {
      if (jG(r))
        break;
      {
        let s = r.previousSibling;
        for (; s && d0(s); )
          i = r.parentNode, o = Wb(s), s = s.previousSibling;
        if (s)
          r = s, n = uM(r);
        else {
          if (r = r.parentNode, r == e.dom)
            break;
          n = 0;
        }
      }
    }
  a ? SO(e, r, n) : i && SO(e, i, o);
}
function FN(e) {
  let t = e.domSelectionRange(), r = t.focusNode, n = t.focusOffset;
  if (!r)
    return;
  let i = uM(r), o, a;
  for (; ; )
    if (n < i) {
      if (r.nodeType != 1)
        break;
      let s = r.childNodes[n];
      if (d0(s))
        o = r, a = ++n;
      else
        break;
    } else {
      if (jG(r))
        break;
      {
        let s = r.nextSibling;
        for (; s && d0(s); )
          o = s.parentNode, a = Wb(s) + 1, s = s.nextSibling;
        if (s)
          r = s, n = 0, i = uM(r);
        else {
          if (r = r.parentNode, r == e.dom)
            break;
          n = i = 0;
        }
      }
    }
  o && SO(e, o, a);
}
function jG(e) {
  let t = e.pmViewDesc;
  return t && t.node && t.node.isBlock;
}
function SO(e, t, r) {
  let n = e.domSelection();
  if ($G(n)) {
    let o = document.createRange();
    o.setEnd(t, r), o.setStart(t, r), n.removeAllRanges(), n.addRange(o);
  } else
    n.extend && n.extend(t, r);
  e.domObserver.setCurSelection();
  let { state: i } = e;
  setTimeout(() => {
    e.state == i && mL(e);
  }, 50);
}
function nB(e, t, r) {
  let n = e.state.selection;
  if (n instanceof pr && !n.empty || r.indexOf("s") > -1 || Ja && r.indexOf("m") > -1)
    return !1;
  let { $from: i, $to: o } = n;
  if (!i.parent.inlineContent || e.endOfTextblock(t < 0 ? "up" : "down")) {
    let a = CO(e.state, t);
    if (a && a instanceof Bt)
      return If(e, a);
  }
  if (!i.parent.inlineContent) {
    let a = t < 0 ? i : o, s = n instanceof ol ? Ar.near(a, t) : Ar.findFrom(a, t);
    return s ? If(e, s) : !1;
  }
  return !1;
}
function iB(e, t) {
  if (!(e.state.selection instanceof pr))
    return !0;
  let { $head: r, $anchor: n, empty: i } = e.state.selection;
  if (!r.sameParent(n))
    return !0;
  if (!i)
    return !1;
  if (e.endOfTextblock(t > 0 ? "forward" : "backward"))
    return !0;
  let o = !r.textOffset && (t < 0 ? r.nodeBefore : r.nodeAfter);
  if (o && !o.isText) {
    let a = e.state.tr;
    return t < 0 ? a.delete(r.pos - o.nodeSize, r.pos) : a.delete(r.pos, r.pos + o.nodeSize), e.dispatch(a), !0;
  }
  return !1;
}
function oB(e, t, r) {
  e.domObserver.stop(), t.contentEditable = r, e.domObserver.start();
}
function aGe(e) {
  if (!Mh || e.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: t, focusOffset: r } = e.domSelectionRange();
  if (t && t.nodeType == 1 && r == 0 && t.firstChild && t.firstChild.contentEditable == "false") {
    let n = t.firstChild;
    oB(e, n, "true"), setTimeout(() => oB(e, n, "false"), 20);
  }
  return !1;
}
function lGe(e) {
  let t = "";
  return e.ctrlKey && (t += "c"), e.metaKey && (t += "m"), e.altKey && (t += "a"), e.shiftKey && (t += "s"), t;
}
function sGe(e, t) {
  let r = t.keyCode, n = lGe(t);
  return r == 8 || Ja && r == 72 && n == "c" ? iB(e, -1) || jN(e) : r == 46 || Ja && r == 68 && n == "c" ? iB(e, 1) || FN(e) : r == 13 || r == 27 ? !0 : r == 37 || Ja && r == 66 && n == "c" ? rB(e, -1, n) || jN(e) : r == 39 || Ja && r == 70 && n == "c" ? rB(e, 1, n) || FN(e) : r == 38 || Ja && r == 80 && n == "c" ? nB(e, -1, n) || jN(e) : r == 40 || Ja && r == 78 && n == "c" ? aGe(e) || nB(e, 1, n) || FN(e) : n == (Ja ? "m" : "c") && (r == 66 || r == 73 || r == 89 || r == 90);
}
function FG(e, t) {
  e.someProp("transformCopied", (m) => {
    t = m(t, e);
  });
  let r = [], { content: n, openStart: i, openEnd: o } = t;
  for (; i > 1 && o > 1 && n.childCount == 1 && n.firstChild.childCount == 1; ) {
    i--, o--;
    let m = n.firstChild;
    r.push(m.type.name, m.attrs != m.type.defaultAttrs ? m.attrs : null), n = m.content;
  }
  let a = e.someProp("clipboardSerializer") || _u.fromSchema(e.state.schema), s = YG(), u = s.createElement("div");
  u.appendChild(a.serializeFragment(n, { document: s }));
  let d = u.firstChild, f, h = 0;
  for (; d && d.nodeType == 1 && (f = VG[d.nodeName.toLowerCase()]); ) {
    for (let m = f.length - 1; m >= 0; m--) {
      let v = s.createElement(f[m]);
      for (; u.firstChild; )
        v.appendChild(u.firstChild);
      u.appendChild(v), h++;
    }
    d = u.firstChild;
  }
  d && d.nodeType == 1 && d.setAttribute("data-pm-slice", `${i} ${o}${h ? ` -${h}` : ""} ${JSON.stringify(r)}`);
  let g = e.someProp("clipboardTextSerializer", (m) => m(t, e)) || t.content.textBetween(0, t.content.size, `

`);
  return { dom: u, text: g };
}
function BG(e, t, r, n, i) {
  let o = i.parent.type.spec.code, a, s;
  if (!r && !t)
    return null;
  let u = t && (n || o || !r);
  if (u) {
    if (e.someProp("transformPastedText", (g) => {
      t = g(t, o || n, e);
    }), o)
      return t ? new Ot(bt.from(e.state.schema.text(t.replace(/\r\n?/g, `
`))), 0, 0) : Ot.empty;
    let h = e.someProp("clipboardTextParser", (g) => g(t, i, n, e));
    if (h)
      s = h;
    else {
      let g = i.marks(), { schema: m } = e.state, v = _u.fromSchema(m);
      a = document.createElement("div"), t.split(/(?:\r\n?|\n)+/).forEach((w) => {
        let x = a.appendChild(document.createElement("p"));
        w && x.appendChild(v.serializeNode(m.text(w, g)));
      });
    }
  } else
    e.someProp("transformPastedHTML", (h) => {
      r = h(r, e);
    }), a = dGe(r), gL && fGe(a);
  let d = a && a.querySelector("[data-pm-slice]"), f = d && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(d.getAttribute("data-pm-slice") || "");
  if (f && f[3])
    for (let h = +f[3]; h > 0; h--) {
      let g = a.firstChild;
      for (; g && g.nodeType != 1; )
        g = g.nextSibling;
      if (!g)
        break;
      a = g;
    }
  if (s || (s = (e.someProp("clipboardParser") || e.someProp("domParser") || Tp.fromSchema(e.state.schema)).parseSlice(a, {
    preserveWhitespace: !!(u || f),
    context: i,
    ruleFromNode(g) {
      return g.nodeName == "BR" && !g.nextSibling && g.parentNode && !uGe.test(g.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), f)
    s = hGe(aB(s, +f[1], +f[2]), f[4]);
  else if (s = Ot.maxOpen(cGe(s.content, i), !0), s.openStart || s.openEnd) {
    let h = 0, g = 0;
    for (let m = s.content.firstChild; h < s.openStart && !m.type.spec.isolating; h++, m = m.firstChild)
      ;
    for (let m = s.content.lastChild; g < s.openEnd && !m.type.spec.isolating; g++, m = m.lastChild)
      ;
    s = aB(s, h, g);
  }
  return e.someProp("transformPasted", (h) => {
    s = h(s, e);
  }), s;
}
const uGe = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function cGe(e, t) {
  if (e.childCount < 2)
    return e;
  for (let r = t.depth; r >= 0; r--) {
    let i = t.node(r).contentMatchAt(t.index(r)), o, a = [];
    if (e.forEach((s) => {
      if (!a)
        return;
      let u = i.findWrapping(s.type), d;
      if (!u)
        return a = null;
      if (d = a.length && o.length && HG(u, o, s, a[a.length - 1], 0))
        a[a.length - 1] = d;
      else {
        a.length && (a[a.length - 1] = WG(a[a.length - 1], o.length));
        let f = UG(s, u);
        a.push(f), i = i.matchType(f.type), o = u;
      }
    }), a)
      return bt.from(a);
  }
  return e;
}
function UG(e, t, r = 0) {
  for (let n = t.length - 1; n >= r; n--)
    e = t[n].create(null, bt.from(e));
  return e;
}
function HG(e, t, r, n, i) {
  if (i < e.length && i < t.length && e[i] == t[i]) {
    let o = HG(e, t, r, n.lastChild, i + 1);
    if (o)
      return n.copy(n.content.replaceChild(n.childCount - 1, o));
    if (n.contentMatchAt(n.childCount).matchType(i == e.length - 1 ? r.type : e[i + 1]))
      return n.copy(n.content.append(bt.from(UG(r, e, i + 1))));
  }
}
function WG(e, t) {
  if (t == 0)
    return e;
  let r = e.content.replaceChild(e.childCount - 1, WG(e.lastChild, t - 1)), n = e.contentMatchAt(e.childCount).fillBefore(bt.empty, !0);
  return e.copy(r.append(n));
}
function TO(e, t, r, n, i, o) {
  let a = t < 0 ? e.firstChild : e.lastChild, s = a.content;
  return i < n - 1 && (s = TO(s, t, r, n, i + 1, o)), i >= r && (s = t < 0 ? a.contentMatchAt(0).fillBefore(s, e.childCount > 1 || o <= i).append(s) : s.append(a.contentMatchAt(a.childCount).fillBefore(bt.empty, !0))), e.replaceChild(t < 0 ? 0 : e.childCount - 1, a.copy(s));
}
function aB(e, t, r) {
  return t < e.openStart && (e = new Ot(TO(e.content, -1, t, e.openStart, 0, e.openEnd), t, e.openEnd)), r < e.openEnd && (e = new Ot(TO(e.content, 1, r, e.openEnd, 0, 0), e.openStart, r)), e;
}
const VG = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let lB = null;
function YG() {
  return lB || (lB = document.implementation.createHTMLDocument("title"));
}
function dGe(e) {
  let t = /^(\s*<meta [^>]*>)*/.exec(e);
  t && (e = e.slice(t[0].length));
  let r = YG().createElement("div"), n = /<([a-z][^>\s]+)/i.exec(e), i;
  if ((i = n && VG[n[1].toLowerCase()]) && (e = i.map((o) => "<" + o + ">").join("") + e + i.map((o) => "</" + o + ">").reverse().join("")), r.innerHTML = e, i)
    for (let o = 0; o < i.length; o++)
      r = r.querySelector(i[o]) || r;
  return r;
}
function fGe(e) {
  let t = e.querySelectorAll(og ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let r = 0; r < t.length; r++) {
    let n = t[r];
    n.childNodes.length == 1 && n.textContent == " " && n.parentNode && n.parentNode.replaceChild(e.ownerDocument.createTextNode(" "), n);
  }
}
function hGe(e, t) {
  if (!e.size)
    return e;
  let r = e.content.firstChild.type.schema, n;
  try {
    n = JSON.parse(t);
  } catch {
    return e;
  }
  let { content: i, openStart: o, openEnd: a } = e;
  for (let s = n.length - 2; s >= 0; s -= 2) {
    let u = r.nodes[n[s]];
    if (!u || u.hasRequiredAttrs())
      break;
    i = bt.from(u.create(n[s + 1], i)), o++, a++;
  }
  return new Ot(i, o, a);
}
const es = {}, Ha = {};
function fc(e, t) {
  e.input.lastSelectionOrigin = t, e.input.lastSelectionTime = Date.now();
}
Ha.keydown = (e, t) => {
  let r = t;
  if (e.input.shiftKey = r.keyCode == 16 || r.shiftKey, !qG(e, r) && (e.input.lastKeyCode = r.keyCode, e.input.lastKeyCodeTime = Date.now(), !(Yb && og && r.keyCode == 13)))
    if (r.keyCode != 229 && e.domObserver.forceFlush(), pL && r.keyCode == 13 && !r.ctrlKey && !r.altKey && !r.metaKey) {
      let n = Date.now();
      e.input.lastIOSEnter = n, e.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        e.input.lastIOSEnter == n && (e.someProp("handleKeyDown", (i) => i(e, OG(13, "Enter"))), e.input.lastIOSEnter = 0);
      }, 200);
    } else
      e.someProp("handleKeyDown", (n) => n(e, r)) || sGe(e, r) ? r.preventDefault() : fc(e, "key");
};
Ha.keyup = (e, t) => {
  t.keyCode == 16 && (e.input.shiftKey = !1);
};
Ha.keypress = (e, t) => {
  let r = t;
  if (qG(e, r) || !r.charCode || r.ctrlKey && !r.altKey || Ja && r.metaKey)
    return;
  if (e.someProp("handleKeyPress", (i) => i(e, r))) {
    r.preventDefault();
    return;
  }
  let n = e.state.selection;
  if (!(n instanceof pr) || !n.$from.sameParent(n.$to)) {
    let i = String.fromCharCode(r.charCode);
    !/[\r\n]/.test(i) && !e.someProp("handleTextInput", (o) => o(e, n.$from.pos, n.$to.pos, i)) && e.dispatch(e.state.tr.insertText(i).scrollIntoView()), r.preventDefault();
  }
};
function yC(e) {
  return { left: e.clientX, top: e.clientY };
}
function pGe(e, t) {
  let r = t.x - e.clientX, n = t.y - e.clientY;
  return r * r + n * n < 100;
}
function vL(e, t, r, n, i) {
  if (n == -1)
    return !1;
  let o = e.state.doc.resolve(n);
  for (let a = o.depth + 1; a > 0; a--)
    if (e.someProp(t, (s) => a > o.depth ? s(e, r, o.nodeAfter, o.before(a), i, !0) : s(e, r, o.node(a), o.before(a), i, !1)))
      return !0;
  return !1;
}
function fp(e, t, r) {
  e.focused || e.focus();
  let n = e.state.tr.setSelection(t);
  r == "pointer" && n.setMeta("pointer", !0), e.dispatch(n);
}
function gGe(e, t) {
  if (t == -1)
    return !1;
  let r = e.state.doc.resolve(t), n = r.nodeAfter;
  return n && n.isAtom && Bt.isSelectable(n) ? (fp(e, new Bt(r), "pointer"), !0) : !1;
}
function mGe(e, t) {
  if (t == -1)
    return !1;
  let r = e.state.selection, n, i;
  r instanceof Bt && (n = r.node);
  let o = e.state.doc.resolve(t);
  for (let a = o.depth + 1; a > 0; a--) {
    let s = a > o.depth ? o.nodeAfter : o.node(a);
    if (Bt.isSelectable(s)) {
      n && r.$from.depth > 0 && a >= r.$from.depth && o.before(r.$from.depth + 1) == r.$from.pos ? i = o.before(r.$from.depth) : i = o.before(a);
      break;
    }
  }
  return i != null ? (fp(e, Bt.create(e.state.doc, i), "pointer"), !0) : !1;
}
function vGe(e, t, r, n, i) {
  return vL(e, "handleClickOn", t, r, n) || e.someProp("handleClick", (o) => o(e, t, n)) || (i ? mGe(e, r) : gGe(e, r));
}
function bGe(e, t, r, n) {
  return vL(e, "handleDoubleClickOn", t, r, n) || e.someProp("handleDoubleClick", (i) => i(e, t, n));
}
function yGe(e, t, r, n) {
  return vL(e, "handleTripleClickOn", t, r, n) || e.someProp("handleTripleClick", (i) => i(e, t, n)) || xGe(e, r, n);
}
function xGe(e, t, r) {
  if (r.button != 0)
    return !1;
  let n = e.state.doc;
  if (t == -1)
    return n.inlineContent ? (fp(e, pr.create(n, 0, n.content.size), "pointer"), !0) : !1;
  let i = n.resolve(t);
  for (let o = i.depth + 1; o > 0; o--) {
    let a = o > i.depth ? i.nodeAfter : i.node(o), s = i.before(o);
    if (a.inlineContent)
      fp(e, pr.create(n, s + 1, s + 1 + a.content.size), "pointer");
    else if (Bt.isSelectable(a))
      fp(e, Bt.create(n, s), "pointer");
    else
      continue;
    return !0;
  }
}
function bL(e) {
  return cM(e);
}
const QG = Ja ? "metaKey" : "ctrlKey";
es.mousedown = (e, t) => {
  let r = t;
  e.input.shiftKey = r.shiftKey;
  let n = bL(e), i = Date.now(), o = "singleClick";
  i - e.input.lastClick.time < 500 && pGe(r, e.input.lastClick) && !r[QG] && (e.input.lastClick.type == "singleClick" ? o = "doubleClick" : e.input.lastClick.type == "doubleClick" && (o = "tripleClick")), e.input.lastClick = { time: i, x: r.clientX, y: r.clientY, type: o };
  let a = e.posAtCoords(yC(r));
  a && (o == "singleClick" ? (e.input.mouseDown && e.input.mouseDown.done(), e.input.mouseDown = new wGe(e, a, r, !!n)) : (o == "doubleClick" ? bGe : yGe)(e, a.pos, a.inside, r) ? r.preventDefault() : fc(e, "pointer"));
};
class wGe {
  constructor(t, r, n, i) {
    this.view = t, this.pos = r, this.event = n, this.flushed = i, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = t.state.doc, this.selectNode = !!n[QG], this.allowDefault = n.shiftKey;
    let o, a;
    if (r.inside > -1)
      o = t.state.doc.nodeAt(r.inside), a = r.inside;
    else {
      let f = t.state.doc.resolve(r.pos);
      o = f.parent, a = f.depth ? f.before() : 0;
    }
    const s = i ? null : n.target, u = s ? t.docView.nearestDesc(s, !0) : null;
    this.target = u ? u.dom : null;
    let { selection: d } = t.state;
    (n.button == 0 && o.type.spec.draggable && o.type.spec.selectable !== !1 || d instanceof Bt && d.from <= a && d.to > a) && (this.mightDrag = {
      node: o,
      pos: a,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && bC && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), t.root.addEventListener("mouseup", this.up = this.up.bind(this)), t.root.addEventListener("mousemove", this.move = this.move.bind(this)), fc(t, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => mL(this.view)), this.view.input.mouseDown = null;
  }
  up(t) {
    if (this.done(), !this.view.dom.contains(t.target))
      return;
    let r = this.pos;
    this.view.state.doc != this.startDoc && (r = this.view.posAtCoords(yC(t))), this.updateAllowDefault(t), this.allowDefault || !r ? fc(this.view, "pointer") : vGe(this.view, r.pos, r.inside, t, this.selectNode) ? t.preventDefault() : t.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    Mh && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    og && !this.view.state.selection.visible && Math.min(Math.abs(r.pos - this.view.state.selection.from), Math.abs(r.pos - this.view.state.selection.to)) <= 2) ? (fp(this.view, Ar.near(this.view.state.doc.resolve(r.pos)), "pointer"), t.preventDefault()) : fc(this.view, "pointer");
  }
  move(t) {
    this.updateAllowDefault(t), fc(this.view, "pointer"), t.buttons == 0 && this.done();
  }
  updateAllowDefault(t) {
    !this.allowDefault && (Math.abs(this.event.x - t.clientX) > 4 || Math.abs(this.event.y - t.clientY) > 4) && (this.allowDefault = !0);
  }
}
es.touchstart = (e) => {
  e.input.lastTouch = Date.now(), bL(e), fc(e, "pointer");
};
es.touchmove = (e) => {
  e.input.lastTouch = Date.now(), fc(e, "pointer");
};
es.contextmenu = (e) => bL(e);
function qG(e, t) {
  return e.composing ? !0 : Mh && Math.abs(t.timeStamp - e.input.compositionEndedAt) < 500 ? (e.input.compositionEndedAt = -2e8, !0) : !1;
}
const MGe = Yb ? 5e3 : -1;
Ha.compositionstart = Ha.compositionupdate = (e) => {
  if (!e.composing) {
    e.domObserver.flush();
    let { state: t } = e, r = t.selection.$from;
    if (t.selection.empty && (t.storedMarks || !r.textOffset && r.parentOffset && r.nodeBefore.marks.some((n) => n.type.spec.inclusive === !1)))
      e.markCursor = e.state.storedMarks || r.marks(), cM(e, !0), e.markCursor = null;
    else if (cM(e), bC && t.selection.empty && r.parentOffset && !r.textOffset && r.nodeBefore.marks.length) {
      let n = e.domSelectionRange();
      for (let i = n.focusNode, o = n.focusOffset; i && i.nodeType == 1 && o != 0; ) {
        let a = o < 0 ? i.lastChild : i.childNodes[o - 1];
        if (!a)
          break;
        if (a.nodeType == 3) {
          e.domSelection().collapse(a, a.nodeValue.length);
          break;
        } else
          i = a, o = -1;
      }
    }
    e.input.composing = !0;
  }
  GG(e, MGe);
};
Ha.compositionend = (e, t) => {
  e.composing && (e.input.composing = !1, e.input.compositionEndedAt = t.timeStamp, GG(e, 20));
};
function GG(e, t) {
  clearTimeout(e.input.composingTimeout), t > -1 && (e.input.composingTimeout = setTimeout(() => cM(e), t));
}
function CGe(e) {
  for (e.composing && (e.input.composing = !1, e.input.compositionEndedAt = SGe()); e.input.compositionNodes.length > 0; )
    e.input.compositionNodes.pop().markParentsDirty();
}
function SGe() {
  let e = document.createEvent("Event");
  return e.initEvent("event", !0, !0), e.timeStamp;
}
function cM(e, t = !1) {
  if (!(Yb && e.domObserver.flushingSoon >= 0)) {
    if (e.domObserver.forceFlush(), CGe(e), t || e.docView && e.docView.dirty) {
      let r = tGe(e);
      return r && !r.eq(e.state.selection) ? e.dispatch(e.state.tr.setSelection(r)) : e.updateState(e.state), !0;
    }
    return !1;
  }
}
function TGe(e, t) {
  if (!e.dom.parentNode)
    return;
  let r = e.dom.parentNode.appendChild(document.createElement("div"));
  r.appendChild(t), r.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let n = getSelection(), i = document.createRange();
  i.selectNodeContents(t), e.dom.blur(), n.removeAllRanges(), n.addRange(i), setTimeout(() => {
    r.parentNode && r.parentNode.removeChild(r), e.focus();
  }, 50);
}
const Rp = Vb && LG < 15 || pL && eGe < 604;
es.copy = Ha.cut = (e, t) => {
  let r = t, n = e.state.selection, i = r.type == "cut";
  if (n.empty)
    return;
  let o = Rp ? null : r.clipboardData, a = n.content(), { dom: s, text: u } = FG(e, a);
  o ? (r.preventDefault(), o.clearData(), o.setData("text/html", s.innerHTML), o.setData("text/plain", u)) : TGe(e, s), i && e.dispatch(e.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function kGe(e) {
  return e.openStart == 0 && e.openEnd == 0 && e.content.childCount == 1 ? e.content.firstChild : null;
}
function DGe(e, t) {
  if (!e.dom.parentNode)
    return;
  let r = e.input.shiftKey || e.state.selection.$from.parent.type.spec.code, n = e.dom.parentNode.appendChild(document.createElement(r ? "textarea" : "div"));
  r || (n.contentEditable = "true"), n.style.cssText = "position: fixed; left: -10000px; top: 10px", n.focus(), setTimeout(() => {
    e.focus(), n.parentNode && n.parentNode.removeChild(n), r ? kO(e, n.value, null, e.input.shiftKey, t) : kO(e, n.textContent, n.innerHTML, e.input.shiftKey, t);
  }, 50);
}
function kO(e, t, r, n, i) {
  let o = BG(e, t, r, n, e.state.selection.$from);
  if (e.someProp("handlePaste", (u) => u(e, i, o || Ot.empty)))
    return !0;
  if (!o)
    return !1;
  let a = kGe(o), s = a ? e.state.tr.replaceSelectionWith(a, e.input.shiftKey) : e.state.tr.replaceSelection(o);
  return e.dispatch(s.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
Ha.paste = (e, t) => {
  let r = t;
  if (e.composing && !Yb)
    return;
  let n = Rp ? null : r.clipboardData;
  n && kO(e, n.getData("text/plain"), n.getData("text/html"), e.input.shiftKey, r) ? r.preventDefault() : DGe(e, r);
};
class AGe {
  constructor(t, r) {
    this.slice = t, this.move = r;
  }
}
const ZG = Ja ? "altKey" : "ctrlKey";
es.dragstart = (e, t) => {
  let r = t, n = e.input.mouseDown;
  if (n && n.done(), !r.dataTransfer)
    return;
  let i = e.state.selection, o = i.empty ? null : e.posAtCoords(yC(r));
  if (!(o && o.pos >= i.from && o.pos <= (i instanceof Bt ? i.to - 1 : i.to))) {
    if (n && n.mightDrag)
      e.dispatch(e.state.tr.setSelection(Bt.create(e.state.doc, n.mightDrag.pos)));
    else if (r.target && r.target.nodeType == 1) {
      let d = e.docView.nearestDesc(r.target, !0);
      d && d.node.type.spec.draggable && d != e.docView && e.dispatch(e.state.tr.setSelection(Bt.create(e.state.doc, d.posBefore)));
    }
  }
  let a = e.state.selection.content(), { dom: s, text: u } = FG(e, a);
  r.dataTransfer.clearData(), r.dataTransfer.setData(Rp ? "Text" : "text/html", s.innerHTML), r.dataTransfer.effectAllowed = "copyMove", Rp || r.dataTransfer.setData("text/plain", u), e.dragging = new AGe(a, !r[ZG]);
};
es.dragend = (e) => {
  let t = e.dragging;
  window.setTimeout(() => {
    e.dragging == t && (e.dragging = null);
  }, 50);
};
Ha.dragover = Ha.dragenter = (e, t) => t.preventDefault();
Ha.drop = (e, t) => {
  let r = t, n = e.dragging;
  if (e.dragging = null, !r.dataTransfer)
    return;
  let i = e.posAtCoords(yC(r));
  if (!i)
    return;
  let o = e.state.doc.resolve(i.pos), a = n && n.slice;
  a ? e.someProp("transformPasted", (v) => {
    a = v(a, e);
  }) : a = BG(e, r.dataTransfer.getData(Rp ? "Text" : "text/plain"), Rp ? null : r.dataTransfer.getData("text/html"), !1, o);
  let s = !!(n && !r[ZG]);
  if (e.someProp("handleDrop", (v) => v(e, r, a || Ot.empty, s))) {
    r.preventDefault();
    return;
  }
  if (!a)
    return;
  r.preventDefault();
  let u = a ? qY(e.state.doc, o.pos, a) : o.pos;
  u == null && (u = o.pos);
  let d = e.state.tr;
  s && d.deleteSelection();
  let f = d.mapping.map(u), h = a.openStart == 0 && a.openEnd == 0 && a.content.childCount == 1, g = d.doc;
  if (h ? d.replaceRangeWith(f, f, a.content.firstChild) : d.replaceRange(f, f, a), d.doc.eq(g))
    return;
  let m = d.doc.resolve(f);
  if (h && Bt.isSelectable(a.content.firstChild) && m.nodeAfter && m.nodeAfter.sameMarkup(a.content.firstChild))
    d.setSelection(new Bt(m));
  else {
    let v = d.mapping.map(u);
    d.mapping.maps[d.mapping.maps.length - 1].forEach((w, x, y, C) => v = C), d.setSelection(RG(e, m, d.doc.resolve(v)));
  }
  e.focus(), e.dispatch(d.setMeta("uiEvent", "drop"));
};
es.focus = (e) => {
  e.input.lastFocus = Date.now(), e.focused || (e.domObserver.stop(), e.dom.classList.add("ProseMirror-focused"), e.domObserver.start(), e.focused = !0, setTimeout(() => {
    e.docView && e.hasFocus() && !e.domObserver.currentSelection.eq(e.domSelectionRange()) && mL(e);
  }, 20));
};
es.blur = (e, t) => {
  let r = t;
  e.focused && (e.domObserver.stop(), e.dom.classList.remove("ProseMirror-focused"), e.domObserver.start(), r.relatedTarget && e.dom.contains(r.relatedTarget) && e.domObserver.currentSelection.clear(), e.focused = !1);
};
es.beforeinput = (e, t) => {
  if (og && Yb && t.inputType == "deleteContentBackward") {
    e.domObserver.flushSoon();
    let { domChangeCount: n } = e.input;
    setTimeout(() => {
      if (e.input.domChangeCount != n || (e.dom.blur(), e.focus(), e.someProp("handleKeyDown", (o) => o(e, OG(8, "Backspace")))))
        return;
      let { $cursor: i } = e.state.selection;
      i && i.pos > 0 && e.dispatch(e.state.tr.delete(i.pos - 1, i.pos).scrollIntoView());
    }, 50);
  }
};
for (let e in Ha)
  es[e] = Ha[e];
function lb(e, t) {
  if (e == t)
    return !0;
  for (let r in e)
    if (e[r] !== t[r])
      return !1;
  for (let r in t)
    if (!(r in e))
      return !1;
  return !0;
}
class yL {
  constructor(t, r) {
    this.toDOM = t, this.spec = r || Kf, this.side = this.spec.side || 0;
  }
  map(t, r, n, i) {
    let { pos: o, deleted: a } = t.mapResult(r.from + i, this.side < 0 ? -1 : 1);
    return a ? null : new Pl(o - n, o - n, this);
  }
  valid() {
    return !0;
  }
  eq(t) {
    return this == t || t instanceof yL && (this.spec.key && this.spec.key == t.spec.key || this.toDOM == t.toDOM && lb(this.spec, t.spec));
  }
  destroy(t) {
    this.spec.destroy && this.spec.destroy(t);
  }
}
class mc {
  constructor(t, r) {
    this.attrs = t, this.spec = r || Kf;
  }
  map(t, r, n, i) {
    let o = t.map(r.from + i, this.spec.inclusiveStart ? -1 : 1) - n, a = t.map(r.to + i, this.spec.inclusiveEnd ? 1 : -1) - n;
    return o >= a ? null : new Pl(o, a, this);
  }
  valid(t, r) {
    return r.from < r.to;
  }
  eq(t) {
    return this == t || t instanceof mc && lb(this.attrs, t.attrs) && lb(this.spec, t.spec);
  }
  static is(t) {
    return t.type instanceof mc;
  }
  destroy() {
  }
}
class xL {
  constructor(t, r) {
    this.attrs = t, this.spec = r || Kf;
  }
  map(t, r, n, i) {
    let o = t.mapResult(r.from + i, 1);
    if (o.deleted)
      return null;
    let a = t.mapResult(r.to + i, -1);
    return a.deleted || a.pos <= o.pos ? null : new Pl(o.pos - n, a.pos - n, this);
  }
  valid(t, r) {
    let { index: n, offset: i } = t.content.findIndex(r.from), o;
    return i == r.from && !(o = t.child(n)).isText && i + o.nodeSize == r.to;
  }
  eq(t) {
    return this == t || t instanceof xL && lb(this.attrs, t.attrs) && lb(this.spec, t.spec);
  }
  destroy() {
  }
}
class Pl {
  /**
  @internal
  */
  constructor(t, r, n) {
    this.from = t, this.to = r, this.type = n;
  }
  /**
  @internal
  */
  copy(t, r) {
    return new Pl(t, r, this.type);
  }
  /**
  @internal
  */
  eq(t, r = 0) {
    return this.type.eq(t.type) && this.from + r == t.from && this.to + r == t.to;
  }
  /**
  @internal
  */
  map(t, r, n) {
    return this.type.map(t, this, r, n);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(t, r, n) {
    return new Pl(t, t, new yL(r, n));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(t, r, n, i) {
    return new Pl(t, r, new mc(n, i));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(t, r, n, i) {
    return new Pl(t, r, new xL(n, i));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof mc;
  }
}
const qh = [], Kf = {};
class $i {
  /**
  @internal
  */
  constructor(t, r) {
    this.local = t.length ? t : qh, this.children = r.length ? r : qh;
  }
  /**
  Create a set of decorations, using the structure of the given
  document.
  */
  static create(t, r) {
    return r.length ? dM(r, t, 0, Kf) : Go;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(t, r, n) {
    let i = [];
    return this.findInner(t ?? 0, r ?? 1e9, i, 0, n), i;
  }
  findInner(t, r, n, i, o) {
    for (let a = 0; a < this.local.length; a++) {
      let s = this.local[a];
      s.from <= r && s.to >= t && (!o || o(s.spec)) && n.push(s.copy(s.from + i, s.to + i));
    }
    for (let a = 0; a < this.children.length; a += 3)
      if (this.children[a] < r && this.children[a + 1] > t) {
        let s = this.children[a] + 1;
        this.children[a + 2].findInner(t - s, r - s, n, i + s, o);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(t, r, n) {
    return this == Go || t.maps.length == 0 ? this : this.mapInner(t, r, 0, 0, n || Kf);
  }
  /**
  @internal
  */
  mapInner(t, r, n, i, o) {
    let a;
    for (let s = 0; s < this.local.length; s++) {
      let u = this.local[s].map(t, n, i);
      u && u.type.valid(r, u) ? (a || (a = [])).push(u) : o.onRemove && o.onRemove(this.local[s].spec);
    }
    return this.children.length ? EGe(this.children, a || [], t, r, n, i, o) : a ? new $i(a.sort(Xf), qh) : Go;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Needs access to the current document to
  create the appropriate tree structure.
  */
  add(t, r) {
    return r.length ? this == Go ? $i.create(t, r) : this.addInner(t, r, 0) : this;
  }
  addInner(t, r, n) {
    let i, o = 0;
    t.forEach((s, u) => {
      let d = u + n, f;
      if (f = XG(r, s, d)) {
        for (i || (i = this.children.slice()); o < i.length && i[o] < u; )
          o += 3;
        i[o] == u ? i[o + 2] = i[o + 2].addInner(s, f, d + 1) : i.splice(o, 0, u, u + s.nodeSize, dM(f, s, d + 1, Kf)), o += 3;
      }
    });
    let a = KG(o ? JG(r) : r, -n);
    for (let s = 0; s < a.length; s++)
      a[s].type.valid(t, a[s]) || a.splice(s--, 1);
    return new $i(a.length ? this.local.concat(a).sort(Xf) : this.local, i || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(t) {
    return t.length == 0 || this == Go ? this : this.removeInner(t, 0);
  }
  removeInner(t, r) {
    let n = this.children, i = this.local;
    for (let o = 0; o < n.length; o += 3) {
      let a, s = n[o] + r, u = n[o + 1] + r;
      for (let f = 0, h; f < t.length; f++)
        (h = t[f]) && h.from > s && h.to < u && (t[f] = null, (a || (a = [])).push(h));
      if (!a)
        continue;
      n == this.children && (n = this.children.slice());
      let d = n[o + 2].removeInner(a, s + 1);
      d != Go ? n[o + 2] = d : (n.splice(o, 3), o -= 3);
    }
    if (i.length) {
      for (let o = 0, a; o < t.length; o++)
        if (a = t[o])
          for (let s = 0; s < i.length; s++)
            i[s].eq(a, r) && (i == this.local && (i = this.local.slice()), i.splice(s--, 1));
    }
    return n == this.children && i == this.local ? this : i.length || n.length ? new $i(i, n) : Go;
  }
  /**
  @internal
  */
  forChild(t, r) {
    if (this == Go)
      return this;
    if (r.isLeaf)
      return $i.empty;
    let n, i;
    for (let s = 0; s < this.children.length; s += 3)
      if (this.children[s] >= t) {
        this.children[s] == t && (n = this.children[s + 2]);
        break;
      }
    let o = t + 1, a = o + r.content.size;
    for (let s = 0; s < this.local.length; s++) {
      let u = this.local[s];
      if (u.from < a && u.to > o && u.type instanceof mc) {
        let d = Math.max(o, u.from) - o, f = Math.min(a, u.to) - o;
        d < f && (i || (i = [])).push(u.copy(d, f));
      }
    }
    if (i) {
      let s = new $i(i.sort(Xf), qh);
      return n ? new Nf([s, n]) : s;
    }
    return n || Go;
  }
  /**
  @internal
  */
  eq(t) {
    if (this == t)
      return !0;
    if (!(t instanceof $i) || this.local.length != t.local.length || this.children.length != t.children.length)
      return !1;
    for (let r = 0; r < this.local.length; r++)
      if (!this.local[r].eq(t.local[r]))
        return !1;
    for (let r = 0; r < this.children.length; r += 3)
      if (this.children[r] != t.children[r] || this.children[r + 1] != t.children[r + 1] || !this.children[r + 2].eq(t.children[r + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(t) {
    return wL(this.localsInner(t));
  }
  /**
  @internal
  */
  localsInner(t) {
    if (this == Go)
      return qh;
    if (t.inlineContent || !this.local.some(mc.is))
      return this.local;
    let r = [];
    for (let n = 0; n < this.local.length; n++)
      this.local[n].type instanceof mc || r.push(this.local[n]);
    return r;
  }
}
$i.empty = new $i([], []);
$i.removeOverlap = wL;
const Go = $i.empty;
class Nf {
  constructor(t) {
    this.members = t;
  }
  map(t, r) {
    const n = this.members.map((i) => i.map(t, r, Kf));
    return Nf.from(n);
  }
  forChild(t, r) {
    if (r.isLeaf)
      return $i.empty;
    let n = [];
    for (let i = 0; i < this.members.length; i++) {
      let o = this.members[i].forChild(t, r);
      o != Go && (o instanceof Nf ? n = n.concat(o.members) : n.push(o));
    }
    return Nf.from(n);
  }
  eq(t) {
    if (!(t instanceof Nf) || t.members.length != this.members.length)
      return !1;
    for (let r = 0; r < this.members.length; r++)
      if (!this.members[r].eq(t.members[r]))
        return !1;
    return !0;
  }
  locals(t) {
    let r, n = !0;
    for (let i = 0; i < this.members.length; i++) {
      let o = this.members[i].localsInner(t);
      if (o.length)
        if (!r)
          r = o;
        else {
          n && (r = r.slice(), n = !1);
          for (let a = 0; a < o.length; a++)
            r.push(o[a]);
        }
    }
    return r ? wL(n ? r : r.sort(Xf)) : qh;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(t) {
    switch (t.length) {
      case 0:
        return Go;
      case 1:
        return t[0];
      default:
        return new Nf(t.every((r) => r instanceof $i) ? t : t.reduce((r, n) => r.concat(n instanceof $i ? n : n.members), []));
    }
  }
}
function EGe(e, t, r, n, i, o, a) {
  let s = e.slice();
  for (let d = 0, f = o; d < r.maps.length; d++) {
    let h = 0;
    r.maps[d].forEach((g, m, v, w) => {
      let x = w - v - (m - g);
      for (let y = 0; y < s.length; y += 3) {
        let C = s[y + 1];
        if (C < 0 || g > C + f - h)
          continue;
        let S = s[y] + f - h;
        m >= S ? s[y + 1] = g <= S ? -2 : -1 : v >= i && x && (s[y] += x, s[y + 1] += x);
      }
      h += x;
    }), f = r.maps[d].map(f, -1);
  }
  let u = !1;
  for (let d = 0; d < s.length; d += 3)
    if (s[d + 1] < 0) {
      if (s[d + 1] == -2) {
        u = !0, s[d + 1] = -1;
        continue;
      }
      let f = r.map(e[d] + o), h = f - i;
      if (h < 0 || h >= n.content.size) {
        u = !0;
        continue;
      }
      let g = r.map(e[d + 1] + o, -1), m = g - i, { index: v, offset: w } = n.content.findIndex(h), x = n.maybeChild(v);
      if (x && w == h && w + x.nodeSize == m) {
        let y = s[d + 2].mapInner(r, x, f + 1, e[d] + o + 1, a);
        y != Go ? (s[d] = h, s[d + 1] = m, s[d + 2] = y) : (s[d + 1] = -2, u = !0);
      } else
        u = !0;
    }
  if (u) {
    let d = IGe(s, e, t, r, i, o, a), f = dM(d, n, 0, a);
    t = f.local;
    for (let h = 0; h < s.length; h += 3)
      s[h + 1] < 0 && (s.splice(h, 3), h -= 3);
    for (let h = 0, g = 0; h < f.children.length; h += 3) {
      let m = f.children[h];
      for (; g < s.length && s[g] < m; )
        g += 3;
      s.splice(g, 0, f.children[h], f.children[h + 1], f.children[h + 2]);
    }
  }
  return new $i(t.sort(Xf), s);
}
function KG(e, t) {
  if (!t || !e.length)
    return e;
  let r = [];
  for (let n = 0; n < e.length; n++) {
    let i = e[n];
    r.push(new Pl(i.from + t, i.to + t, i.type));
  }
  return r;
}
function IGe(e, t, r, n, i, o, a) {
  function s(u, d) {
    for (let f = 0; f < u.local.length; f++) {
      let h = u.local[f].map(n, i, d);
      h ? r.push(h) : a.onRemove && a.onRemove(u.local[f].spec);
    }
    for (let f = 0; f < u.children.length; f += 3)
      s(u.children[f + 2], u.children[f] + d + 1);
  }
  for (let u = 0; u < e.length; u += 3)
    e[u + 1] == -1 && s(e[u + 2], t[u] + o + 1);
  return r;
}
function XG(e, t, r) {
  if (t.isLeaf)
    return null;
  let n = r + t.nodeSize, i = null;
  for (let o = 0, a; o < e.length; o++)
    (a = e[o]) && a.from > r && a.to < n && ((i || (i = [])).push(a), e[o] = null);
  return i;
}
function JG(e) {
  let t = [];
  for (let r = 0; r < e.length; r++)
    e[r] != null && t.push(e[r]);
  return t;
}
function dM(e, t, r, n) {
  let i = [], o = !1;
  t.forEach((s, u) => {
    let d = XG(e, s, u + r);
    if (d) {
      o = !0;
      let f = dM(d, s, r + u + 1, n);
      f != Go && i.push(u, u + s.nodeSize, f);
    }
  });
  let a = KG(o ? JG(e) : e, -r).sort(Xf);
  for (let s = 0; s < a.length; s++)
    a[s].type.valid(t, a[s]) || (n.onRemove && n.onRemove(a[s].spec), a.splice(s--, 1));
  return a.length || i.length ? new $i(a, i) : Go;
}
function Xf(e, t) {
  return e.from - t.from || e.to - t.to;
}
function wL(e) {
  let t = e;
  for (let r = 0; r < t.length - 1; r++) {
    let n = t[r];
    if (n.from != n.to)
      for (let i = r + 1; i < t.length; i++) {
        let o = t[i];
        if (o.from == n.from) {
          o.to != n.to && (t == e && (t = e.slice()), t[i] = o.copy(o.from, n.to), sB(t, i + 1, o.copy(n.to, o.to)));
          continue;
        } else {
          o.from < n.to && (t == e && (t = e.slice()), t[r] = n.copy(n.from, o.from), sB(t, i, n.copy(o.from, n.to)));
          break;
        }
      }
  }
  return t;
}
function sB(e, t, r) {
  for (; t < e.length && Xf(r, e[t]) > 0; )
    t++;
  e.splice(t, 0, r);
}
const NGe = typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : !1;
function zGe(e) {
  let t = e.split(/-(?!$)/), r = t[t.length - 1];
  r == "Space" && (r = " ");
  let n, i, o, a;
  for (let s = 0; s < t.length - 1; s++) {
    let u = t[s];
    if (/^(cmd|meta|m)$/i.test(u))
      a = !0;
    else if (/^a(lt)?$/i.test(u))
      n = !0;
    else if (/^(c|ctrl|control)$/i.test(u))
      i = !0;
    else if (/^s(hift)?$/i.test(u))
      o = !0;
    else if (/^mod$/i.test(u))
      NGe ? a = !0 : i = !0;
    else
      throw new Error("Unrecognized modifier name: " + u);
  }
  return n && (r = "Alt-" + r), i && (r = "Ctrl-" + r), a && (r = "Meta-" + r), o && (r = "Shift-" + r), r;
}
function $Ge(e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let r in e)
    t[zGe(r)] = e[r];
  return t;
}
function BN(e, t, r = !0) {
  return t.altKey && (e = "Alt-" + e), t.ctrlKey && (e = "Ctrl-" + e), t.metaKey && (e = "Meta-" + e), r && t.shiftKey && (e = "Shift-" + e), e;
}
function OGe(e) {
  let t = $Ge(e);
  return function(r, n) {
    let i = S_e(n), o, a = t[BN(i, n)];
    if (a && a(r.state, r.dispatch, r))
      return !0;
    if (i.length == 1 && i != " ") {
      if (n.shiftKey) {
        let s = t[BN(i, n, !1)];
        if (s && s(r.state, r.dispatch, r))
          return !0;
      }
      if ((n.shiftKey || n.altKey || n.metaKey || i.charCodeAt(0) > 127) && (o = Ac[n.keyCode]) && o != i) {
        let s = t[BN(o, n)];
        if (s && s(r.state, r.dispatch, r))
          return !0;
      }
    }
    return !1;
  };
}
var DO, AO;
if (typeof WeakMap < "u") {
  let e = /* @__PURE__ */ new WeakMap();
  DO = (t) => e.get(t), AO = (t, r) => (e.set(t, r), r);
} else {
  const e = [];
  let r = 0;
  DO = (n) => {
    for (let i = 0; i < e.length; i += 2)
      if (e[i] == n)
        return e[i + 1];
  }, AO = (n, i) => (r == 10 && (r = 0), e[r++] = n, e[r++] = i);
}
var gi = class {
  constructor(e, t, r, n) {
    this.width = e, this.height = t, this.map = r, this.problems = n;
  }
  findCell(e) {
    for (let t = 0; t < this.map.length; t++) {
      const r = this.map[t];
      if (r != e)
        continue;
      const n = t % this.width, i = t / this.width | 0;
      let o = n + 1, a = i + 1;
      for (let s = 1; o < this.width && this.map[t + s] == r; s++)
        o++;
      for (let s = 1; a < this.height && this.map[t + this.width * s] == r; s++)
        a++;
      return { left: n, top: i, right: o, bottom: a };
    }
    throw new RangeError(`No cell with offset ${e} found`);
  }
  colCount(e) {
    for (let t = 0; t < this.map.length; t++)
      if (this.map[t] == e)
        return t % this.width;
    throw new RangeError(`No cell with offset ${e} found`);
  }
  nextCell(e, t, r) {
    const { left: n, right: i, top: o, bottom: a } = this.findCell(e);
    return t == "horiz" ? (r < 0 ? n == 0 : i == this.width) ? null : this.map[o * this.width + (r < 0 ? n - 1 : i)] : (r < 0 ? o == 0 : a == this.height) ? null : this.map[n + this.width * (r < 0 ? o - 1 : a)];
  }
  rectBetween(e, t) {
    const {
      left: r,
      right: n,
      top: i,
      bottom: o
    } = this.findCell(e), {
      left: a,
      right: s,
      top: u,
      bottom: d
    } = this.findCell(t);
    return {
      left: Math.min(r, a),
      top: Math.min(i, u),
      right: Math.max(n, s),
      bottom: Math.max(o, d)
    };
  }
  cellsInRect(e) {
    const t = [], r = {};
    for (let n = e.top; n < e.bottom; n++)
      for (let i = e.left; i < e.right; i++) {
        const o = n * this.width + i, a = this.map[o];
        r[a] || (r[a] = !0, !(i == e.left && i && this.map[o - 1] == a || n == e.top && n && this.map[o - this.width] == a) && t.push(a));
      }
    return t;
  }
  positionAt(e, t, r) {
    for (let n = 0, i = 0; ; n++) {
      const o = i + r.child(n).nodeSize;
      if (n == e) {
        let a = t + e * this.width;
        const s = (e + 1) * this.width;
        for (; a < s && this.map[a] < i; )
          a++;
        return a == s ? o - 1 : this.map[a];
      }
      i = o;
    }
  }
  static get(e) {
    return DO(e) || AO(e, _Ge(e));
  }
};
function _Ge(e) {
  if (e.type.spec.tableRole != "table")
    throw new RangeError("Not a table node: " + e.type.name);
  const t = LGe(e), r = e.childCount, n = [];
  let i = 0, o = null;
  const a = [];
  for (let d = 0, f = t * r; d < f; d++)
    n[d] = 0;
  for (let d = 0, f = 0; d < r; d++) {
    const h = e.child(d);
    f++;
    for (let v = 0; ; v++) {
      for (; i < n.length && n[i] != 0; )
        i++;
      if (v == h.childCount)
        break;
      const w = h.child(v), { colspan: x, rowspan: y, colwidth: C } = w.attrs;
      for (let S = 0; S < y; S++) {
        if (S + d >= r) {
          (o || (o = [])).push({
            type: "overlong_rowspan",
            pos: f,
            n: y - S
          });
          break;
        }
        const T = i + S * t;
        for (let A = 0; A < x; A++) {
          n[T + A] == 0 ? n[T + A] = f : (o || (o = [])).push({
            type: "collision",
            row: d,
            pos: f,
            n: x - A
          });
          const D = C && C[A];
          if (D) {
            const E = (T + A) % t * 2, N = a[E];
            N == null || N != D && a[E + 1] == 1 ? (a[E] = D, a[E + 1] = 1) : N == D && a[E + 1]++;
          }
        }
      }
      i += x, f += w.nodeSize;
    }
    const g = (d + 1) * t;
    let m = 0;
    for (; i < g; )
      n[i++] == 0 && m++;
    m && (o || (o = [])).push({ type: "missing", row: d, n: m }), f++;
  }
  const s = new gi(t, r, n, o);
  let u = !1;
  for (let d = 0; !u && d < a.length; d += 2)
    a[d] != null && a[d + 1] < r && (u = !0);
  return u && PGe(s, a, e), s;
}
function LGe(e) {
  let t = -1, r = !1;
  for (let n = 0; n < e.childCount; n++) {
    const i = e.child(n);
    let o = 0;
    if (r)
      for (let a = 0; a < n; a++) {
        const s = e.child(a);
        for (let u = 0; u < s.childCount; u++) {
          const d = s.child(u);
          a + d.attrs.rowspan > n && (o += d.attrs.colspan);
        }
      }
    for (let a = 0; a < i.childCount; a++) {
      const s = i.child(a);
      o += s.attrs.colspan, s.attrs.rowspan > 1 && (r = !0);
    }
    t == -1 ? t = o : t != o && (t = Math.max(t, o));
  }
  return t;
}
function PGe(e, t, r) {
  e.problems || (e.problems = []);
  const n = {};
  for (let i = 0; i < e.map.length; i++) {
    const o = e.map[i];
    if (n[o])
      continue;
    n[o] = !0;
    const a = r.nodeAt(o);
    if (!a)
      throw new RangeError(`No cell with offset ${o} found`);
    let s = null;
    const u = a.attrs;
    for (let d = 0; d < u.colspan; d++) {
      const f = (i + d) % e.width, h = t[f * 2];
      h != null && (!u.colwidth || u.colwidth[d] != h) && ((s || (s = RGe(u)))[d] = h);
    }
    s && e.problems.unshift({
      type: "colwidth mismatch",
      pos: o,
      colwidth: s
    });
  }
}
function RGe(e) {
  if (e.colwidth)
    return e.colwidth.slice();
  const t = [];
  for (let r = 0; r < e.colspan; r++)
    t.push(0);
  return t;
}
function Oo(e) {
  let t = e.cached.tableNodeTypes;
  if (!t) {
    t = e.cached.tableNodeTypes = {};
    for (const r in e.nodes) {
      const n = e.nodes[r], i = n.spec.tableRole;
      i && (t[i] = n);
    }
  }
  return t;
}
var lc = new _o("selectingCells");
function ag(e) {
  for (let t = e.depth - 1; t > 0; t--)
    if (e.node(t).type.spec.tableRole == "row")
      return e.node(0).resolve(e.before(t + 1));
  return null;
}
function jGe(e) {
  for (let t = e.depth; t > 0; t--) {
    const r = e.node(t).type.spec.tableRole;
    if (r === "cell" || r === "header_cell")
      return e.node(t);
  }
  return null;
}
function ts(e) {
  const t = e.selection.$head;
  for (let r = t.depth; r > 0; r--)
    if (t.node(r).type.spec.tableRole == "row")
      return !0;
  return !1;
}
function xC(e) {
  const t = e.selection;
  if ("$anchorCell" in t && t.$anchorCell)
    return t.$anchorCell.pos > t.$headCell.pos ? t.$anchorCell : t.$headCell;
  if ("node" in t && t.node && t.node.type.spec.tableRole == "cell")
    return t.$anchor;
  const r = ag(t.$head) || FGe(t.$head);
  if (r)
    return r;
  throw new RangeError(`No cell found around position ${t.head}`);
}
function FGe(e) {
  for (let t = e.nodeAfter, r = e.pos; t; t = t.firstChild, r++) {
    const n = t.type.spec.tableRole;
    if (n == "cell" || n == "header_cell")
      return e.doc.resolve(r);
  }
  for (let t = e.nodeBefore, r = e.pos; t; t = t.lastChild, r--) {
    const n = t.type.spec.tableRole;
    if (n == "cell" || n == "header_cell")
      return e.doc.resolve(r - t.nodeSize);
  }
}
function EO(e) {
  return e.parent.type.spec.tableRole == "row" && !!e.nodeAfter;
}
function BGe(e) {
  return e.node(0).resolve(e.pos + e.nodeAfter.nodeSize);
}
function ML(e, t) {
  return e.depth == t.depth && e.pos >= t.start(-1) && e.pos <= t.end(-1);
}
function eZ(e, t, r) {
  const n = e.node(-1), i = gi.get(n), o = e.start(-1), a = i.nextCell(e.pos - o, t, r);
  return a == null ? null : e.node(0).resolve(o + a);
}
function sh(e, t, r = 1) {
  const n = { ...e, colspan: e.colspan - r };
  return n.colwidth && (n.colwidth = n.colwidth.slice(), n.colwidth.splice(t, r), n.colwidth.some((i) => i > 0) || (n.colwidth = null)), n;
}
function tZ(e, t, r = 1) {
  const n = { ...e, colspan: e.colspan + r };
  if (n.colwidth) {
    n.colwidth = n.colwidth.slice();
    for (let i = 0; i < r; i++)
      n.colwidth.splice(t, 0, 0);
  }
  return n;
}
function UGe(e, t, r) {
  const n = Oo(t.type.schema).header_cell;
  for (let i = 0; i < e.height; i++)
    if (t.nodeAt(e.map[r + i * e.width]).type != n)
      return !1;
  return !0;
}
var Xr = class extends Ar {
  constructor(e, t = e) {
    const r = e.node(-1), n = gi.get(r), i = e.start(-1), o = n.rectBetween(
      e.pos - i,
      t.pos - i
    ), a = e.node(0), s = n.cellsInRect(o).filter((d) => d != t.pos - i);
    s.unshift(t.pos - i);
    const u = s.map((d) => {
      const f = r.nodeAt(d);
      if (!f)
        throw RangeError(`No cell with offset ${d} found`);
      const h = i + d + 1;
      return new eQ(
        a.resolve(h),
        a.resolve(h + f.content.size)
      );
    });
    super(u[0].$from, u[0].$to, u), this.$anchorCell = e, this.$headCell = t;
  }
  map(e, t) {
    const r = e.resolve(t.map(this.$anchorCell.pos)), n = e.resolve(t.map(this.$headCell.pos));
    if (EO(r) && EO(n) && ML(r, n)) {
      const i = this.$anchorCell.node(-1) != r.node(-1);
      return i && this.isRowSelection() ? Xr.rowSelection(r, n) : i && this.isColSelection() ? Xr.colSelection(r, n) : new Xr(r, n);
    }
    return pr.between(r, n);
  }
  content() {
    const e = this.$anchorCell.node(-1), t = gi.get(e), r = this.$anchorCell.start(-1), n = t.rectBetween(
      this.$anchorCell.pos - r,
      this.$headCell.pos - r
    ), i = {}, o = [];
    for (let s = n.top; s < n.bottom; s++) {
      const u = [];
      for (let d = s * t.width + n.left, f = n.left; f < n.right; f++, d++) {
        const h = t.map[d];
        if (i[h])
          continue;
        i[h] = !0;
        const g = t.findCell(h);
        let m = e.nodeAt(h);
        if (!m)
          throw RangeError(`No cell with offset ${h} found`);
        const v = n.left - g.left, w = g.right - n.right;
        if (v > 0 || w > 0) {
          let x = m.attrs;
          if (v > 0 && (x = sh(x, 0, v)), w > 0 && (x = sh(
            x,
            x.colspan - w,
            w
          )), g.left < n.left) {
            if (m = m.type.createAndFill(x), !m)
              throw RangeError(
                `Could not create cell with attrs ${JSON.stringify(x)}`
              );
          } else
            m = m.type.create(x, m.content);
        }
        if (g.top < n.top || g.bottom > n.bottom) {
          const x = {
            ...m.attrs,
            rowspan: Math.min(g.bottom, n.bottom) - Math.max(g.top, n.top)
          };
          g.top < n.top ? m = m.type.createAndFill(x) : m = m.type.create(x, m.content);
        }
        u.push(m);
      }
      o.push(e.child(s).copy(bt.from(u)));
    }
    const a = this.isColSelection() && this.isRowSelection() ? e : o;
    return new Ot(bt.from(a), 1, 1);
  }
  replace(e, t = Ot.empty) {
    const r = e.steps.length, n = this.ranges;
    for (let o = 0; o < n.length; o++) {
      const { $from: a, $to: s } = n[o], u = e.mapping.slice(r);
      e.replace(
        u.map(a.pos),
        u.map(s.pos),
        o ? Ot.empty : t
      );
    }
    const i = Ar.findFrom(
      e.doc.resolve(e.mapping.slice(r).map(this.to)),
      -1
    );
    i && e.setSelection(i);
  }
  replaceWith(e, t) {
    this.replace(e, new Ot(bt.from(t), 0, 0));
  }
  forEachCell(e) {
    const t = this.$anchorCell.node(-1), r = gi.get(t), n = this.$anchorCell.start(-1), i = r.cellsInRect(
      r.rectBetween(
        this.$anchorCell.pos - n,
        this.$headCell.pos - n
      )
    );
    for (let o = 0; o < i.length; o++)
      e(t.nodeAt(i[o]), n + i[o]);
  }
  isColSelection() {
    const e = this.$anchorCell.index(-1), t = this.$headCell.index(-1);
    if (Math.min(e, t) > 0)
      return !1;
    const r = e + this.$anchorCell.nodeAfter.attrs.rowspan, n = t + this.$headCell.nodeAfter.attrs.rowspan;
    return Math.max(r, n) == this.$headCell.node(-1).childCount;
  }
  static colSelection(e, t = e) {
    const r = e.node(-1), n = gi.get(r), i = e.start(-1), o = n.findCell(e.pos - i), a = n.findCell(t.pos - i), s = e.node(0);
    return o.top <= a.top ? (o.top > 0 && (e = s.resolve(i + n.map[o.left])), a.bottom < n.height && (t = s.resolve(
      i + n.map[n.width * (n.height - 1) + a.right - 1]
    ))) : (a.top > 0 && (t = s.resolve(i + n.map[a.left])), o.bottom < n.height && (e = s.resolve(
      i + n.map[n.width * (n.height - 1) + o.right - 1]
    ))), new Xr(e, t);
  }
  isRowSelection() {
    const e = this.$anchorCell.node(-1), t = gi.get(e), r = this.$anchorCell.start(-1), n = t.colCount(this.$anchorCell.pos - r), i = t.colCount(this.$headCell.pos - r);
    if (Math.min(n, i) > 0)
      return !1;
    const o = n + this.$anchorCell.nodeAfter.attrs.colspan, a = i + this.$headCell.nodeAfter.attrs.colspan;
    return Math.max(o, a) == t.width;
  }
  eq(e) {
    return e instanceof Xr && e.$anchorCell.pos == this.$anchorCell.pos && e.$headCell.pos == this.$headCell.pos;
  }
  static rowSelection(e, t = e) {
    const r = e.node(-1), n = gi.get(r), i = e.start(-1), o = n.findCell(e.pos - i), a = n.findCell(t.pos - i), s = e.node(0);
    return o.left <= a.left ? (o.left > 0 && (e = s.resolve(
      i + n.map[o.top * n.width]
    )), a.right < n.width && (t = s.resolve(
      i + n.map[n.width * (a.top + 1) - 1]
    ))) : (a.left > 0 && (t = s.resolve(i + n.map[a.top * n.width])), o.right < n.width && (e = s.resolve(
      i + n.map[n.width * (o.top + 1) - 1]
    ))), new Xr(e, t);
  }
  toJSON() {
    return {
      type: "cell",
      anchor: this.$anchorCell.pos,
      head: this.$headCell.pos
    };
  }
  static fromJSON(e, t) {
    return new Xr(e.resolve(t.anchor), e.resolve(t.head));
  }
  static create(e, t, r = t) {
    return new Xr(e.resolve(t), e.resolve(r));
  }
  getBookmark() {
    return new rZ(this.$anchorCell.pos, this.$headCell.pos);
  }
};
Xr.prototype.visible = !1;
Ar.jsonID("cell", Xr);
var rZ = class {
  constructor(e, t) {
    this.anchor = e, this.head = t;
  }
  map(e) {
    return new rZ(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    const t = e.resolve(this.anchor), r = e.resolve(this.head);
    return t.parent.type.spec.tableRole == "row" && r.parent.type.spec.tableRole == "row" && t.index() < t.parent.childCount && r.index() < r.parent.childCount && ML(t, r) ? new Xr(t, r) : Ar.near(r, 1);
  }
};
function HGe(e) {
  if (!(e.selection instanceof Xr))
    return null;
  const t = [];
  return e.selection.forEachCell((r, n) => {
    t.push(
      Pl.node(n, n + r.nodeSize, { class: "selectedCell" })
    );
  }), $i.create(e.doc, t);
}
function WGe({ $from: e, $to: t }) {
  if (e.pos == t.pos || e.pos < e.pos - 6)
    return !1;
  let r = e.pos, n = t.pos, i = e.depth;
  for (; i >= 0 && !(e.after(i + 1) < e.end(i)); i--, r++)
    ;
  for (let o = t.depth; o >= 0 && !(t.before(o + 1) > t.start(o)); o--, n--)
    ;
  return r == n && /row|table/.test(e.node(i).type.spec.tableRole);
}
function VGe({ $from: e, $to: t }) {
  let r, n;
  for (let i = e.depth; i > 0; i--) {
    const o = e.node(i);
    if (o.type.spec.tableRole === "cell" || o.type.spec.tableRole === "header_cell") {
      r = o;
      break;
    }
  }
  for (let i = t.depth; i > 0; i--) {
    const o = t.node(i);
    if (o.type.spec.tableRole === "cell" || o.type.spec.tableRole === "header_cell") {
      n = o;
      break;
    }
  }
  return r !== n && t.parentOffset === 0;
}
function YGe(e, t, r) {
  const n = (t || e).selection, i = (t || e).doc;
  let o, a;
  if (n instanceof Bt && (a = n.node.type.spec.tableRole)) {
    if (a == "cell" || a == "header_cell")
      o = Xr.create(i, n.from);
    else if (a == "row") {
      const s = i.resolve(n.from + 1);
      o = Xr.rowSelection(s, s);
    } else if (!r) {
      const s = gi.get(n.node), u = n.from + 1, d = u + s.map[s.width * s.height - 1];
      o = Xr.create(i, u + 1, d);
    }
  } else
    n instanceof pr && WGe(n) ? o = pr.create(i, n.from) : n instanceof pr && VGe(n) && (o = pr.create(i, n.$from.start(), n.$from.end()));
  return o && (t || (t = e.tr)).setSelection(o), t;
}
var QGe = new _o("fix-tables");
function nZ(e, t, r, n) {
  const i = e.childCount, o = t.childCount;
  e:
    for (let a = 0, s = 0; a < o; a++) {
      const u = t.child(a);
      for (let d = s, f = Math.min(i, a + 3); d < f; d++)
        if (e.child(d) == u) {
          s = d + 1, r += u.nodeSize;
          continue e;
        }
      n(u, r), s < i && e.child(s).sameMarkup(u) ? nZ(e.child(s), u, r + 1, n) : u.nodesBetween(0, u.content.size, n, r + 1), r += u.nodeSize;
    }
}
function iZ(e, t) {
  let r;
  const n = (i, o) => {
    i.type.spec.tableRole == "table" && (r = qGe(e, i, o, r));
  };
  return t ? t.doc != e.doc && nZ(t.doc, e.doc, 0, n) : e.doc.descendants(n), r;
}
function qGe(e, t, r, n) {
  const i = gi.get(t);
  if (!i.problems)
    return n;
  n || (n = e.tr);
  const o = [];
  for (let u = 0; u < i.height; u++)
    o.push(0);
  for (let u = 0; u < i.problems.length; u++) {
    const d = i.problems[u];
    if (d.type == "collision") {
      const f = t.nodeAt(d.pos);
      if (!f)
        continue;
      const h = f.attrs;
      for (let g = 0; g < h.rowspan; g++)
        o[d.row + g] += d.n;
      n.setNodeMarkup(
        n.mapping.map(r + 1 + d.pos),
        null,
        sh(h, h.colspan - d.n, d.n)
      );
    } else if (d.type == "missing")
      o[d.row] += d.n;
    else if (d.type == "overlong_rowspan") {
      const f = t.nodeAt(d.pos);
      if (!f)
        continue;
      n.setNodeMarkup(n.mapping.map(r + 1 + d.pos), null, {
        ...f.attrs,
        rowspan: f.attrs.rowspan - d.n
      });
    } else if (d.type == "colwidth mismatch") {
      const f = t.nodeAt(d.pos);
      if (!f)
        continue;
      n.setNodeMarkup(n.mapping.map(r + 1 + d.pos), null, {
        ...f.attrs,
        colwidth: d.colwidth
      });
    }
  }
  let a, s;
  for (let u = 0; u < o.length; u++)
    o[u] && (a == null && (a = u), s = u);
  for (let u = 0, d = r + 1; u < i.height; u++) {
    const f = t.child(u), h = d + f.nodeSize, g = o[u];
    if (g > 0) {
      let m = "cell";
      f.firstChild && (m = f.firstChild.type.spec.tableRole);
      const v = [];
      for (let x = 0; x < g; x++) {
        const y = Oo(e.schema)[m].createAndFill();
        y && v.push(y);
      }
      const w = (u == 0 || a == u - 1) && s == u ? d + 1 : h - 1;
      n.insert(n.mapping.map(w), v);
    }
    d = h;
  }
  return n.setMeta(QGe, { fixTables: !0 });
}
function GGe(e) {
  if (!e.size)
    return null;
  let { content: t, openStart: r, openEnd: n } = e;
  for (; t.childCount == 1 && (r > 0 && n > 0 || t.child(0).type.spec.tableRole == "table"); )
    r--, n--, t = t.child(0).content;
  const i = t.child(0), o = i.type.spec.tableRole, a = i.type.schema, s = [];
  if (o == "row")
    for (let u = 0; u < t.childCount; u++) {
      let d = t.child(u).content;
      const f = u ? 0 : Math.max(0, r - 1), h = u < t.childCount - 1 ? 0 : Math.max(0, n - 1);
      (f || h) && (d = IO(
        Oo(a).row,
        new Ot(d, f, h)
      ).content), s.push(d);
    }
  else if (o == "cell" || o == "header_cell")
    s.push(
      r || n ? IO(
        Oo(a).row,
        new Ot(t, r, n)
      ).content : t
    );
  else
    return null;
  return ZGe(a, s);
}
function ZGe(e, t) {
  const r = [];
  for (let i = 0; i < t.length; i++) {
    const o = t[i];
    for (let a = o.childCount - 1; a >= 0; a--) {
      const { rowspan: s, colspan: u } = o.child(a).attrs;
      for (let d = i; d < i + s; d++)
        r[d] = (r[d] || 0) + u;
    }
  }
  let n = 0;
  for (let i = 0; i < r.length; i++)
    n = Math.max(n, r[i]);
  for (let i = 0; i < r.length; i++)
    if (i >= t.length && t.push(bt.empty), r[i] < n) {
      const o = Oo(e).cell.createAndFill(), a = [];
      for (let s = r[i]; s < n; s++)
        a.push(o);
      t[i] = t[i].append(bt.from(a));
    }
  return { height: t.length, width: n, rows: t };
}
function IO(e, t) {
  const r = e.createAndFill();
  return new JY(r).replace(0, r.content.size, t).doc;
}
function KGe({ width: e, height: t, rows: r }, n, i) {
  if (e != n) {
    const o = [], a = [];
    for (let s = 0; s < r.length; s++) {
      const u = r[s], d = [];
      for (let f = o[s] || 0, h = 0; f < n; h++) {
        let g = u.child(h % u.childCount);
        f + g.attrs.colspan > n && (g = g.type.createChecked(
          sh(
            g.attrs,
            g.attrs.colspan,
            f + g.attrs.colspan - n
          ),
          g.content
        )), d.push(g), f += g.attrs.colspan;
        for (let m = 1; m < g.attrs.rowspan; m++)
          o[s + m] = (o[s + m] || 0) + g.attrs.colspan;
      }
      a.push(bt.from(d));
    }
    r = a, e = n;
  }
  if (t != i) {
    const o = [];
    for (let a = 0, s = 0; a < i; a++, s++) {
      const u = [], d = r[s % t];
      for (let f = 0; f < d.childCount; f++) {
        let h = d.child(f);
        a + h.attrs.rowspan > i && (h = h.type.create(
          {
            ...h.attrs,
            rowspan: Math.max(1, i - h.attrs.rowspan)
          },
          h.content
        )), u.push(h);
      }
      o.push(bt.from(u));
    }
    r = o, t = i;
  }
  return { width: e, height: t, rows: r };
}
function XGe(e, t, r, n, i, o, a) {
  const s = e.doc.type.schema, u = Oo(s);
  let d, f;
  if (i > t.width)
    for (let h = 0, g = 0; h < t.height; h++) {
      const m = r.child(h);
      g += m.nodeSize;
      const v = [];
      let w;
      m.lastChild == null || m.lastChild.type == u.cell ? w = d || (d = u.cell.createAndFill()) : w = f || (f = u.header_cell.createAndFill());
      for (let x = t.width; x < i; x++)
        v.push(w);
      e.insert(e.mapping.slice(a).map(g - 1 + n), v);
    }
  if (o > t.height) {
    const h = [];
    for (let v = 0, w = (t.height - 1) * t.width; v < Math.max(t.width, i); v++) {
      const x = v >= t.width ? !1 : r.nodeAt(t.map[w + v]).type == u.header_cell;
      h.push(
        x ? f || (f = u.header_cell.createAndFill()) : d || (d = u.cell.createAndFill())
      );
    }
    const g = u.row.create(null, bt.from(h)), m = [];
    for (let v = t.height; v < o; v++)
      m.push(g);
    e.insert(e.mapping.slice(a).map(n + r.nodeSize - 2), m);
  }
  return !!(d || f);
}
function uB(e, t, r, n, i, o, a, s) {
  if (a == 0 || a == t.height)
    return !1;
  let u = !1;
  for (let d = i; d < o; d++) {
    const f = a * t.width + d, h = t.map[f];
    if (t.map[f - t.width] == h) {
      u = !0;
      const g = r.nodeAt(h), { top: m, left: v } = t.findCell(h);
      e.setNodeMarkup(e.mapping.slice(s).map(h + n), null, {
        ...g.attrs,
        rowspan: a - m
      }), e.insert(
        e.mapping.slice(s).map(t.positionAt(a, v, r)),
        g.type.createAndFill({
          ...g.attrs,
          rowspan: m + g.attrs.rowspan - a
        })
      ), d += g.attrs.colspan - 1;
    }
  }
  return u;
}
function cB(e, t, r, n, i, o, a, s) {
  if (a == 0 || a == t.width)
    return !1;
  let u = !1;
  for (let d = i; d < o; d++) {
    const f = d * t.width + a, h = t.map[f];
    if (t.map[f - 1] == h) {
      u = !0;
      const g = r.nodeAt(h), m = t.colCount(h), v = e.mapping.slice(s).map(h + n);
      e.setNodeMarkup(
        v,
        null,
        sh(
          g.attrs,
          a - m,
          g.attrs.colspan - (a - m)
        )
      ), e.insert(
        v + g.nodeSize,
        g.type.createAndFill(
          sh(g.attrs, 0, a - m)
        )
      ), d += g.attrs.rowspan - 1;
    }
  }
  return u;
}
function dB(e, t, r, n, i) {
  let o = r ? e.doc.nodeAt(r - 1) : e.doc;
  if (!o)
    throw new Error("No table found");
  let a = gi.get(o);
  const { top: s, left: u } = n, d = u + i.width, f = s + i.height, h = e.tr;
  let g = 0;
  function m() {
    if (o = r ? h.doc.nodeAt(r - 1) : h.doc, !o)
      throw new Error("No table found");
    a = gi.get(o), g = h.mapping.maps.length;
  }
  XGe(h, a, o, r, d, f, g) && m(), uB(h, a, o, r, u, d, s, g) && m(), uB(h, a, o, r, u, d, f, g) && m(), cB(h, a, o, r, s, f, u, g) && m(), cB(h, a, o, r, s, f, d, g) && m();
  for (let v = s; v < f; v++) {
    const w = a.positionAt(v, u, o), x = a.positionAt(v, d, o);
    h.replace(
      h.mapping.slice(g).map(w + r),
      h.mapping.slice(g).map(x + r),
      new Ot(i.rows[v - s], 0, 0)
    );
  }
  m(), h.setSelection(
    new Xr(
      h.doc.resolve(r + a.positionAt(s, u, o)),
      h.doc.resolve(r + a.positionAt(f - 1, d - 1, o))
    )
  ), t(h);
}
var JGe = OGe({
  ArrowLeft: jy("horiz", -1),
  ArrowRight: jy("horiz", 1),
  ArrowUp: jy("vert", -1),
  ArrowDown: jy("vert", 1),
  "Shift-ArrowLeft": Fy("horiz", -1),
  "Shift-ArrowRight": Fy("horiz", 1),
  "Shift-ArrowUp": Fy("vert", -1),
  "Shift-ArrowDown": Fy("vert", 1),
  Backspace: By,
  "Mod-Backspace": By,
  Delete: By,
  "Mod-Delete": By
});
function j1(e, t, r) {
  return r.eq(e.selection) ? !1 : (t && t(e.tr.setSelection(r).scrollIntoView()), !0);
}
function jy(e, t) {
  return (r, n, i) => {
    if (!i)
      return !1;
    const o = r.selection;
    if (o instanceof Xr)
      return j1(
        r,
        n,
        Ar.near(o.$headCell, t)
      );
    if (e != "horiz" && !o.empty)
      return !1;
    const a = oZ(i, e, t);
    if (a == null)
      return !1;
    if (e == "horiz")
      return j1(
        r,
        n,
        Ar.near(r.doc.resolve(o.head + t), t)
      );
    {
      const s = r.doc.resolve(a), u = eZ(s, e, t);
      let d;
      return u ? d = Ar.near(u, 1) : t < 0 ? d = Ar.near(r.doc.resolve(s.before(-1)), -1) : d = Ar.near(r.doc.resolve(s.after(-1)), 1), j1(r, n, d);
    }
  };
}
function Fy(e, t) {
  return (r, n, i) => {
    if (!i)
      return !1;
    const o = r.selection;
    let a;
    if (o instanceof Xr)
      a = o;
    else {
      const u = oZ(i, e, t);
      if (u == null)
        return !1;
      a = new Xr(r.doc.resolve(u));
    }
    const s = eZ(a.$headCell, e, t);
    return s ? j1(
      r,
      n,
      new Xr(a.$anchorCell, s)
    ) : !1;
  };
}
function By(e, t) {
  const r = e.selection;
  if (!(r instanceof Xr))
    return !1;
  if (t) {
    const n = e.tr, i = Oo(e.schema).cell.createAndFill().content;
    r.forEachCell((o, a) => {
      o.content.eq(i) || n.replace(
        n.mapping.map(a + 1),
        n.mapping.map(a + o.nodeSize - 1),
        new Ot(i, 0, 0)
      );
    }), n.docChanged && t(n);
  }
  return !0;
}
function eZe(e, t) {
  const r = e.state.doc, n = ag(r.resolve(t));
  return n ? (e.dispatch(e.state.tr.setSelection(new Xr(n))), !0) : !1;
}
function tZe(e, t, r) {
  if (!ts(e.state))
    return !1;
  let n = GGe(r);
  const i = e.state.selection;
  if (i instanceof Xr) {
    n || (n = {
      width: 1,
      height: 1,
      rows: [
        bt.from(
          IO(Oo(e.state.schema).cell, r)
        )
      ]
    });
    const o = i.$anchorCell.node(-1), a = i.$anchorCell.start(-1), s = gi.get(o).rectBetween(
      i.$anchorCell.pos - a,
      i.$headCell.pos - a
    );
    return n = KGe(n, s.right - s.left, s.bottom - s.top), dB(e.state, e.dispatch, a, s, n), !0;
  } else if (n) {
    const o = xC(e.state), a = o.start(-1);
    return dB(
      e.state,
      e.dispatch,
      a,
      gi.get(o.node(-1)).findCell(o.pos - a),
      n
    ), !0;
  } else
    return !1;
}
function rZe(e, t) {
  var r;
  if (t.ctrlKey || t.metaKey)
    return;
  const n = fB(e, t.target);
  let i;
  if (t.shiftKey && e.state.selection instanceof Xr)
    o(e.state.selection.$anchorCell, t), t.preventDefault();
  else if (t.shiftKey && n && (i = ag(e.state.selection.$anchor)) != null && ((r = UN(e, t)) == null ? void 0 : r.pos) != i.pos)
    o(i, t), t.preventDefault();
  else if (!n)
    return;
  function o(u, d) {
    let f = UN(e, d);
    const h = lc.getState(e.state) == null;
    if (!f || !ML(u, f))
      if (h)
        f = u;
      else
        return;
    const g = new Xr(u, f);
    if (h || !e.state.selection.eq(g)) {
      const m = e.state.tr.setSelection(g);
      h && m.setMeta(lc, u.pos), e.dispatch(m);
    }
  }
  function a() {
    e.root.removeEventListener("mouseup", a), e.root.removeEventListener("dragstart", a), e.root.removeEventListener("mousemove", s), lc.getState(e.state) != null && e.dispatch(e.state.tr.setMeta(lc, -1));
  }
  function s(u) {
    const d = u, f = lc.getState(e.state);
    let h;
    if (f != null)
      h = e.state.doc.resolve(f);
    else if (fB(e, d.target) != n && (h = UN(e, t), !h))
      return a();
    h && o(h, d);
  }
  e.root.addEventListener("mouseup", a), e.root.addEventListener("dragstart", a), e.root.addEventListener("mousemove", s);
}
function oZ(e, t, r) {
  if (!(e.state.selection instanceof pr))
    return null;
  const { $head: n } = e.state.selection;
  for (let i = n.depth - 1; i >= 0; i--) {
    const o = n.node(i);
    if ((r < 0 ? n.index(i) : n.indexAfter(i)) != (r < 0 ? 0 : o.childCount))
      return null;
    if (o.type.spec.tableRole == "cell" || o.type.spec.tableRole == "header_cell") {
      const s = n.before(i), u = t == "vert" ? r > 0 ? "down" : "up" : r > 0 ? "right" : "left";
      return e.endOfTextblock(u) ? s : null;
    }
  }
  return null;
}
function fB(e, t) {
  for (; t && t != e.dom; t = t.parentNode)
    if (t.nodeName == "TD" || t.nodeName == "TH")
      return t;
  return null;
}
function UN(e, t) {
  const r = e.posAtCoords({
    left: t.clientX,
    top: t.clientY
  });
  return r && r ? ag(e.state.doc.resolve(r.pos)) : null;
}
var nZe = class {
  constructor(t, r) {
    this.node = t, this.cellMinWidth = r, this.dom = document.createElement("div"), this.dom.className = "tableWrapper", this.table = this.dom.appendChild(document.createElement("table")), this.colgroup = this.table.appendChild(document.createElement("colgroup")), NO(t, this.colgroup, this.table, r), this.contentDOM = this.table.appendChild(document.createElement("tbody"));
  }
  update(t) {
    return t.type != this.node.type ? !1 : (this.node = t, NO(t, this.colgroup, this.table, this.cellMinWidth), !0);
  }
  ignoreMutation(t) {
    return t.type == "attributes" && (t.target == this.table || this.colgroup.contains(t.target));
  }
};
function NO(e, t, r, n, i, o) {
  var a;
  let s = 0, u = !0, d = t.firstChild;
  const f = e.firstChild;
  if (f) {
    for (let h = 0, g = 0; h < f.childCount; h++) {
      const { colspan: m, colwidth: v } = f.child(h).attrs;
      for (let w = 0; w < m; w++, g++) {
        const x = i == g ? o : v && v[w], y = x ? x + "px" : "";
        s += x || n, x || (u = !1), d ? (d.style.width != y && (d.style.width = y), d = d.nextSibling) : t.appendChild(document.createElement("col")).style.width = y;
      }
    }
    for (; d; ) {
      const h = d.nextSibling;
      (a = d.parentNode) == null || a.removeChild(d), d = h;
    }
    u ? (r.style.width = s + "px", r.style.minWidth = "") : (r.style.width = "", r.style.minWidth = s + "px");
  }
}
var tl = new _o(
  "tableColumnResizing"
);
function iZe({
  handleWidth: e = 5,
  cellMinWidth: t = 25,
  View: r = nZe,
  lastColumnResizable: n = !0
} = {}) {
  const i = new ra({
    key: tl,
    state: {
      init(o, a) {
        return i.spec.props.nodeViews[Oo(a.schema).table.name] = (s, u) => new r(s, t, u), new F1(-1, !1);
      },
      apply(o, a) {
        return a.apply(o);
      }
    },
    props: {
      attributes: (o) => {
        const a = tl.getState(o);
        return a && a.activeHandle > -1 ? { class: "resize-cursor" } : {};
      },
      handleDOMEvents: {
        mousemove: (o, a) => {
          oZe(
            o,
            a,
            e,
            t,
            n
          );
        },
        mouseleave: (o) => {
          aZe(o);
        },
        mousedown: (o, a) => {
          lZe(o, a, t);
        }
      },
      decorations: (o) => {
        const a = tl.getState(o);
        if (a && a.activeHandle > -1)
          return hZe(o, a.activeHandle);
      },
      nodeViews: {}
    }
  });
  return i;
}
var F1 = class {
  constructor(e, t) {
    this.activeHandle = e, this.dragging = t;
  }
  apply(e) {
    const t = this, r = e.getMeta(tl);
    if (r && r.setHandle != null)
      return new F1(r.setHandle, !1);
    if (r && r.setDragging !== void 0)
      return new F1(t.activeHandle, r.setDragging);
    if (t.activeHandle > -1 && e.docChanged) {
      let n = e.mapping.map(t.activeHandle, -1);
      return EO(e.doc.resolve(n)) || (n = -1), new F1(n, t.dragging);
    }
    return t;
  }
};
function oZe(e, t, r, n, i) {
  const o = tl.getState(e.state);
  if (o && !o.dragging) {
    const a = uZe(t.target);
    let s = -1;
    if (a) {
      const { left: u, right: d } = a.getBoundingClientRect();
      t.clientX - u <= r ? s = hB(e, t, "left") : d - t.clientX <= r && (s = hB(e, t, "right"));
    }
    if (s != o.activeHandle) {
      if (!i && s !== -1) {
        const u = e.state.doc.resolve(s), d = u.node(-1), f = gi.get(d), h = u.start(-1);
        if (f.colCount(u.pos - h) + u.nodeAfter.attrs.colspan - 1 == f.width - 1)
          return;
      }
      aZ(e, s);
    }
  }
}
function aZe(e) {
  const t = tl.getState(e.state);
  t && t.activeHandle > -1 && !t.dragging && aZ(e, -1);
}
function lZe(e, t, r) {
  const n = tl.getState(e.state);
  if (!n || n.activeHandle == -1 || n.dragging)
    return !1;
  const i = e.state.doc.nodeAt(n.activeHandle), o = sZe(e, n.activeHandle, i.attrs);
  e.dispatch(
    e.state.tr.setMeta(tl, {
      setDragging: { startX: t.clientX, startWidth: o }
    })
  );
  function a(u) {
    window.removeEventListener("mouseup", a), window.removeEventListener("mousemove", s);
    const d = tl.getState(e.state);
    d != null && d.dragging && (cZe(
      e,
      d.activeHandle,
      pB(d.dragging, u, r)
    ), e.dispatch(
      e.state.tr.setMeta(tl, { setDragging: null })
    ));
  }
  function s(u) {
    if (!u.which)
      return a(u);
    const d = tl.getState(e.state);
    if (d && d.dragging) {
      const f = pB(d.dragging, u, r);
      dZe(e, d.activeHandle, f, r);
    }
  }
  return window.addEventListener("mouseup", a), window.addEventListener("mousemove", s), t.preventDefault(), !0;
}
function sZe(e, t, { colspan: r, colwidth: n }) {
  const i = n && n[n.length - 1];
  if (i)
    return i;
  const o = e.domAtPos(t);
  let s = o.node.childNodes[o.offset].offsetWidth, u = r;
  if (n)
    for (let d = 0; d < r; d++)
      n[d] && (s -= n[d], u--);
  return s / u;
}
function uZe(e) {
  for (; e && e.nodeName != "TD" && e.nodeName != "TH"; )
    e = e.classList && e.classList.contains("ProseMirror") ? null : e.parentNode;
  return e;
}
function hB(e, t, r) {
  const n = e.posAtCoords({ left: t.clientX, top: t.clientY });
  if (!n)
    return -1;
  const { pos: i } = n, o = ag(e.state.doc.resolve(i));
  if (!o)
    return -1;
  if (r == "right")
    return o.pos;
  const a = gi.get(o.node(-1)), s = o.start(-1), u = a.map.indexOf(o.pos - s);
  return u % a.width == 0 ? -1 : s + a.map[u - 1];
}
function pB(e, t, r) {
  const n = t.clientX - e.startX;
  return Math.max(r, e.startWidth + n);
}
function aZ(e, t) {
  e.dispatch(
    e.state.tr.setMeta(tl, { setHandle: t })
  );
}
function cZe(e, t, r) {
  const n = e.state.doc.resolve(t), i = n.node(-1), o = gi.get(i), a = n.start(-1), s = o.colCount(n.pos - a) + n.nodeAfter.attrs.colspan - 1, u = e.state.tr;
  for (let d = 0; d < o.height; d++) {
    const f = d * o.width + s;
    if (d && o.map[f] == o.map[f - o.width])
      continue;
    const h = o.map[f], g = i.nodeAt(h).attrs, m = g.colspan == 1 ? 0 : s - o.colCount(h);
    if (g.colwidth && g.colwidth[m] == r)
      continue;
    const v = g.colwidth ? g.colwidth.slice() : fZe(g.colspan);
    v[m] = r, u.setNodeMarkup(a + h, null, { ...g, colwidth: v });
  }
  u.docChanged && e.dispatch(u);
}
function dZe(e, t, r, n) {
  const i = e.state.doc.resolve(t), o = i.node(-1), a = i.start(-1), s = gi.get(o).colCount(i.pos - a) + i.nodeAfter.attrs.colspan - 1;
  let u = e.domAtPos(i.start(-1)).node;
  for (; u && u.nodeName != "TABLE"; )
    u = u.parentNode;
  u && NO(
    o,
    u.firstChild,
    u,
    n,
    s,
    r
  );
}
function fZe(e) {
  return Array(e).fill(0);
}
function hZe(e, t) {
  const r = [], n = e.doc.resolve(t), i = n.node(-1);
  if (!i)
    return $i.empty;
  const o = gi.get(i), a = n.start(-1), s = o.colCount(n.pos - a) + n.nodeAfter.attrs.colspan;
  for (let u = 0; u < o.height; u++) {
    const d = s + u * o.width - 1;
    if ((s == o.width || o.map[d] != o.map[d + 1]) && (u == 0 || o.map[d - 1] != o.map[d - 1 - o.width])) {
      const f = o.map[d], h = a + f + i.nodeAt(f).nodeSize - 1, g = document.createElement("div");
      g.className = "column-resize-handle", r.push(Pl.widget(h, g));
    }
  }
  return $i.create(e.doc, r);
}
function $s(e) {
  const t = e.selection, r = xC(e), n = r.node(-1), i = r.start(-1), o = gi.get(n);
  return { ...t instanceof Xr ? o.rectBetween(
    t.$anchorCell.pos - i,
    t.$headCell.pos - i
  ) : o.findCell(r.pos - i), tableStart: i, map: o, table: n };
}
function lZ(e, { map: t, tableStart: r, table: n }, i) {
  let o = i > 0 ? -1 : 0;
  UGe(t, n, i + o) && (o = i == 0 || i == t.width ? null : 0);
  for (let a = 0; a < t.height; a++) {
    const s = a * t.width + i;
    if (i > 0 && i < t.width && t.map[s - 1] == t.map[s]) {
      const u = t.map[s], d = n.nodeAt(u);
      e.setNodeMarkup(
        e.mapping.map(r + u),
        null,
        tZ(d.attrs, i - t.colCount(u))
      ), a += d.attrs.rowspan - 1;
    } else {
      const u = o == null ? Oo(n.type.schema).cell : n.nodeAt(t.map[s + o]).type, d = t.positionAt(a, i, n);
      e.insert(e.mapping.map(r + d), u.createAndFill());
    }
  }
  return e;
}
function pZe(e, t) {
  if (!ts(e))
    return !1;
  if (t) {
    const r = $s(e);
    t(lZ(e.tr, r, r.left));
  }
  return !0;
}
function gZe(e, t) {
  if (!ts(e))
    return !1;
  if (t) {
    const r = $s(e);
    t(lZ(e.tr, r, r.right));
  }
  return !0;
}
function mZe(e, { map: t, table: r, tableStart: n }, i) {
  const o = e.mapping.maps.length;
  for (let a = 0; a < t.height; ) {
    const s = a * t.width + i, u = t.map[s], d = r.nodeAt(u), f = d.attrs;
    if (i > 0 && t.map[s - 1] == u || i < t.width - 1 && t.map[s + 1] == u)
      e.setNodeMarkup(
        e.mapping.slice(o).map(n + u),
        null,
        sh(f, i - t.colCount(u))
      );
    else {
      const h = e.mapping.slice(o).map(n + u);
      e.delete(h, h + d.nodeSize);
    }
    a += f.rowspan;
  }
}
function vZe(e, t) {
  if (!ts(e))
    return !1;
  if (t) {
    const r = $s(e), n = e.tr;
    if (r.left == 0 && r.right == r.map.width)
      return !1;
    for (let i = r.right - 1; mZe(n, r, i), i != r.left; i--) {
      const o = r.tableStart ? n.doc.nodeAt(r.tableStart - 1) : n.doc;
      if (!o)
        throw RangeError("No table found");
      r.table = o, r.map = gi.get(o);
    }
    t(n);
  }
  return !0;
}
function bZe(e, t, r) {
  var n;
  const i = Oo(t.type.schema).header_cell;
  for (let o = 0; o < e.width; o++)
    if (((n = t.nodeAt(e.map[o + r * e.width])) == null ? void 0 : n.type) != i)
      return !1;
  return !0;
}
function sZ(e, { map: t, tableStart: r, table: n }, i) {
  var o;
  let a = r;
  for (let d = 0; d < i; d++)
    a += n.child(d).nodeSize;
  const s = [];
  let u = i > 0 ? -1 : 0;
  bZe(t, n, i + u) && (u = i == 0 || i == t.height ? null : 0);
  for (let d = 0, f = t.width * i; d < t.width; d++, f++)
    if (i > 0 && i < t.height && t.map[f] == t.map[f - t.width]) {
      const h = t.map[f], g = n.nodeAt(h).attrs;
      e.setNodeMarkup(r + h, null, {
        ...g,
        rowspan: g.rowspan + 1
      }), d += g.colspan - 1;
    } else {
      const h = u == null ? Oo(n.type.schema).cell : (o = n.nodeAt(t.map[f + u * t.width])) == null ? void 0 : o.type, g = h == null ? void 0 : h.createAndFill();
      g && s.push(g);
    }
  return e.insert(a, Oo(n.type.schema).row.create(null, s)), e;
}
function yZe(e, t) {
  if (!ts(e))
    return !1;
  if (t) {
    const r = $s(e);
    t(sZ(e.tr, r, r.top));
  }
  return !0;
}
function xZe(e, t) {
  if (!ts(e))
    return !1;
  if (t) {
    const r = $s(e);
    t(sZ(e.tr, r, r.bottom));
  }
  return !0;
}
function wZe(e, { map: t, table: r, tableStart: n }, i) {
  let o = 0;
  for (let u = 0; u < i; u++)
    o += r.child(u).nodeSize;
  const a = o + r.child(i).nodeSize, s = e.mapping.maps.length;
  e.delete(o + n, a + n);
  for (let u = 0, d = i * t.width; u < t.width; u++, d++) {
    const f = t.map[d];
    if (i > 0 && f == t.map[d - t.width]) {
      const h = r.nodeAt(f).attrs;
      e.setNodeMarkup(e.mapping.slice(s).map(f + n), null, {
        ...h,
        rowspan: h.rowspan - 1
      }), u += h.colspan - 1;
    } else if (i < t.width && f == t.map[d + t.width]) {
      const h = r.nodeAt(f), g = h.attrs, m = h.type.create(
        { ...g, rowspan: h.attrs.rowspan - 1 },
        h.content
      ), v = t.positionAt(i + 1, u, r);
      e.insert(e.mapping.slice(s).map(n + v), m), u += g.colspan - 1;
    }
  }
}
function MZe(e, t) {
  if (!ts(e))
    return !1;
  if (t) {
    const r = $s(e), n = e.tr;
    if (r.top == 0 && r.bottom == r.map.height)
      return !1;
    for (let i = r.bottom - 1; wZe(n, r, i), i != r.top; i--) {
      const o = r.tableStart ? n.doc.nodeAt(r.tableStart - 1) : n.doc;
      if (!o)
        throw RangeError("No table found");
      r.table = o, r.map = gi.get(r.table);
    }
    t(n);
  }
  return !0;
}
function gB(e) {
  const t = e.content;
  return t.childCount == 1 && t.child(0).isTextblock && t.child(0).childCount == 0;
}
function CZe({ width: e, height: t, map: r }, n) {
  let i = n.top * e + n.left, o = i, a = (n.bottom - 1) * e + n.left, s = i + (n.right - n.left - 1);
  for (let u = n.top; u < n.bottom; u++) {
    if (n.left > 0 && r[o] == r[o - 1] || n.right < e && r[s] == r[s + 1])
      return !0;
    o += e, s += e;
  }
  for (let u = n.left; u < n.right; u++) {
    if (n.top > 0 && r[i] == r[i - e] || n.bottom < t && r[a] == r[a + e])
      return !0;
    i++, a++;
  }
  return !1;
}
function mB(e, t) {
  const r = e.selection;
  if (!(r instanceof Xr) || r.$anchorCell.pos == r.$headCell.pos)
    return !1;
  const n = $s(e), { map: i } = n;
  if (CZe(i, n))
    return !1;
  if (t) {
    const o = e.tr, a = {};
    let s = bt.empty, u, d;
    for (let f = n.top; f < n.bottom; f++)
      for (let h = n.left; h < n.right; h++) {
        const g = i.map[f * i.width + h], m = n.table.nodeAt(g);
        if (!(a[g] || !m))
          if (a[g] = !0, u == null)
            u = g, d = m;
          else {
            gB(m) || (s = s.append(m.content));
            const v = o.mapping.map(g + n.tableStart);
            o.delete(v, v + m.nodeSize);
          }
      }
    if (u == null || d == null)
      return !0;
    if (o.setNodeMarkup(u + n.tableStart, null, {
      ...tZ(
        d.attrs,
        d.attrs.colspan,
        n.right - n.left - d.attrs.colspan
      ),
      rowspan: n.bottom - n.top
    }), s.size) {
      const f = u + 1 + d.content.size, h = gB(d) ? u + 1 : f;
      o.replaceWith(h + n.tableStart, f + n.tableStart, s);
    }
    o.setSelection(
      new Xr(o.doc.resolve(u + n.tableStart))
    ), t(o);
  }
  return !0;
}
function vB(e, t) {
  const r = Oo(e.schema);
  return SZe(({ node: n }) => r[n.type.spec.tableRole])(e, t);
}
function SZe(e) {
  return (t, r) => {
    var n;
    const i = t.selection;
    let o, a;
    if (i instanceof Xr) {
      if (i.$anchorCell.pos != i.$headCell.pos)
        return !1;
      o = i.$anchorCell.nodeAfter, a = i.$anchorCell.pos;
    } else {
      if (o = jGe(i.$from), !o)
        return !1;
      a = (n = ag(i.$from)) == null ? void 0 : n.pos;
    }
    if (o == null || a == null || o.attrs.colspan == 1 && o.attrs.rowspan == 1)
      return !1;
    if (r) {
      let s = o.attrs;
      const u = [], d = s.colwidth;
      s.rowspan > 1 && (s = { ...s, rowspan: 1 }), s.colspan > 1 && (s = { ...s, colspan: 1 });
      const f = $s(t), h = t.tr;
      for (let m = 0; m < f.right - f.left; m++)
        u.push(
          d ? {
            ...s,
            colwidth: d && d[m] ? [d[m]] : null
          } : s
        );
      let g;
      for (let m = f.top; m < f.bottom; m++) {
        let v = f.map.positionAt(m, f.left, f.table);
        m == f.top && (v += o.nodeSize);
        for (let w = f.left, x = 0; w < f.right; w++, x++)
          w == f.left && m == f.top || h.insert(
            g = h.mapping.map(v + f.tableStart, 1),
            e({ node: o, row: m, col: w }).createAndFill(u[x])
          );
      }
      h.setNodeMarkup(
        a,
        e({ node: o, row: f.top, col: f.left }),
        u[0]
      ), i instanceof Xr && h.setSelection(
        new Xr(
          h.doc.resolve(i.$anchorCell.pos),
          g ? h.doc.resolve(g) : void 0
        )
      ), r(h);
    }
    return !0;
  };
}
function TZe(e, t) {
  return function(r, n) {
    if (!ts(r))
      return !1;
    const i = xC(r);
    if (i.nodeAfter.attrs[e] === t)
      return !1;
    if (n) {
      const o = r.tr;
      r.selection instanceof Xr ? r.selection.forEachCell((a, s) => {
        a.attrs[e] !== t && o.setNodeMarkup(s, null, {
          ...a.attrs,
          [e]: t
        });
      }) : o.setNodeMarkup(i.pos, null, {
        ...i.nodeAfter.attrs,
        [e]: t
      }), n(o);
    }
    return !0;
  };
}
function kZe(e) {
  return function(t, r) {
    if (!ts(t))
      return !1;
    if (r) {
      const n = Oo(t.schema), i = $s(t), o = t.tr, a = i.map.cellsInRect(
        e == "column" ? {
          left: i.left,
          top: 0,
          right: i.right,
          bottom: i.map.height
        } : e == "row" ? {
          left: 0,
          top: i.top,
          right: i.map.width,
          bottom: i.bottom
        } : i
      ), s = a.map((u) => i.table.nodeAt(u));
      for (let u = 0; u < a.length; u++)
        s[u].type == n.header_cell && o.setNodeMarkup(
          i.tableStart + a[u],
          n.cell,
          s[u].attrs
        );
      if (o.steps.length == 0)
        for (let u = 0; u < a.length; u++)
          o.setNodeMarkup(
            i.tableStart + a[u],
            n.header_cell,
            s[u].attrs
          );
      r(o);
    }
    return !0;
  };
}
function bB(e, t, r) {
  const n = t.map.cellsInRect({
    left: 0,
    top: 0,
    right: e == "row" ? t.map.width : 1,
    bottom: e == "column" ? t.map.height : 1
  });
  for (let i = 0; i < n.length; i++) {
    const o = t.table.nodeAt(n[i]);
    if (o && o.type !== r.header_cell)
      return !1;
  }
  return !0;
}
function sb(e, t) {
  return t = t || { useDeprecatedLogic: !1 }, t.useDeprecatedLogic ? kZe(e) : function(r, n) {
    if (!ts(r))
      return !1;
    if (n) {
      const i = Oo(r.schema), o = $s(r), a = r.tr, s = bB("row", o, i), u = bB(
        "column",
        o,
        i
      ), f = (e === "column" ? s : e === "row" ? u : !1) ? 1 : 0, h = e == "column" ? {
        left: 0,
        top: f,
        right: 1,
        bottom: o.map.height
      } : e == "row" ? {
        left: f,
        top: 0,
        right: o.map.width,
        bottom: 1
      } : o, g = e == "column" ? u ? i.cell : i.header_cell : e == "row" ? s ? i.cell : i.header_cell : i.cell;
      o.map.cellsInRect(h).forEach((m) => {
        const v = m + o.tableStart, w = a.doc.nodeAt(v);
        w && a.setNodeMarkup(v, g, w.attrs);
      }), n(a);
    }
    return !0;
  };
}
sb("row", {
  useDeprecatedLogic: !0
});
sb("column", {
  useDeprecatedLogic: !0
});
var DZe = sb("cell", {
  useDeprecatedLogic: !0
});
function AZe(e, t) {
  if (t < 0) {
    const r = e.nodeBefore;
    if (r)
      return e.pos - r.nodeSize;
    for (let n = e.index(-1) - 1, i = e.before(); n >= 0; n--) {
      const o = e.node(-1).child(n), a = o.lastChild;
      if (a)
        return i - 1 - a.nodeSize;
      i -= o.nodeSize;
    }
  } else {
    if (e.index() < e.parent.childCount - 1)
      return e.pos + e.nodeAfter.nodeSize;
    const r = e.node(-1);
    for (let n = e.indexAfter(-1), i = e.after(); n < r.childCount; n++) {
      const o = r.child(n);
      if (o.childCount)
        return i + 1;
      i += o.nodeSize;
    }
  }
  return null;
}
function yB(e) {
  return function(t, r) {
    if (!ts(t))
      return !1;
    const n = AZe(xC(t), e);
    if (n == null)
      return !1;
    if (r) {
      const i = t.doc.resolve(n);
      r(
        t.tr.setSelection(pr.between(i, BGe(i))).scrollIntoView()
      );
    }
    return !0;
  };
}
function EZe(e, t) {
  const r = e.selection.$anchor;
  for (let n = r.depth; n > 0; n--)
    if (r.node(n).type.spec.tableRole == "table")
      return t && t(
        e.tr.delete(r.before(n), r.after(n)).scrollIntoView()
      ), !0;
  return !1;
}
function IZe({
  allowTableNodeSelection: e = !1
} = {}) {
  return new ra({
    key: lc,
    state: {
      init() {
        return null;
      },
      apply(t, r) {
        const n = t.getMeta(lc);
        if (n != null)
          return n == -1 ? null : n;
        if (r == null || !t.docChanged)
          return r;
        const { deleted: i, pos: o } = t.mapping.mapResult(r);
        return i ? null : o;
      }
    },
    props: {
      decorations: HGe,
      handleDOMEvents: {
        mousedown: rZe
      },
      createSelectionBetween(t) {
        return lc.getState(t.state) != null ? t.state.selection : null;
      },
      handleTripleClick: eZe,
      handleKeyDown: JGe,
      handlePaste: tZe
    },
    appendTransaction(t, r, n) {
      return YGe(
        n,
        iZ(n, r),
        e
      );
    }
  });
}
function xB(e, t, r, n, i, o) {
  let a = 0, s = !0, u = t.firstChild;
  const d = e.firstChild;
  for (let f = 0, h = 0; f < d.childCount; f += 1) {
    const { colspan: g, colwidth: m } = d.child(f).attrs;
    for (let v = 0; v < g; v += 1, h += 1) {
      const w = i === h ? o : m && m[v], x = w ? `${w}px` : "";
      a += w || n, w || (s = !1), u ? (u.style.width !== x && (u.style.width = x), u = u.nextSibling) : t.appendChild(document.createElement("col")).style.width = x;
    }
  }
  for (; u; ) {
    const f = u.nextSibling;
    u.parentNode.removeChild(u), u = f;
  }
  s ? (r.style.width = `${a}px`, r.style.minWidth = "") : (r.style.width = "", r.style.minWidth = `${a}px`);
}
class NZe {
  constructor(t, r) {
    df(this, "node");
    df(this, "cellMinWidth");
    df(this, "dom");
    df(this, "table");
    df(this, "colgroup");
    df(this, "contentDOM");
    this.node = t, this.cellMinWidth = r, this.dom = document.createElement("div"), this.dom.className = "tableWrapper", this.table = this.dom.appendChild(document.createElement("table")), this.colgroup = this.table.appendChild(document.createElement("colgroup")), xB(t, this.colgroup, this.table, r), this.contentDOM = this.table.appendChild(document.createElement("tbody"));
  }
  update(t) {
    return t.type !== this.node.type ? !1 : (this.node = t, xB(t, this.colgroup, this.table, this.cellMinWidth), !0);
  }
  ignoreMutation(t) {
    return t.type === "attributes" && (t.target === this.table || this.colgroup.contains(t.target));
  }
}
function wB(e, t) {
  return t ? e.createChecked(null, t) : e.createAndFill();
}
function zZe(e) {
  if (e.cached.tableNodeTypes)
    return e.cached.tableNodeTypes;
  const t = {};
  return Object.keys(e.nodes).forEach((r) => {
    const n = e.nodes[r];
    n.spec.tableRole && (t[n.spec.tableRole] = n);
  }), e.cached.tableNodeTypes = t, t;
}
function $Ze(e, t, r, n, i) {
  const o = zZe(e), a = [], s = [];
  for (let d = 0; d < r; d += 1) {
    const f = wB(o.cell, i);
    if (f && s.push(f), n) {
      const h = wB(o.header_cell, i);
      h && a.push(h);
    }
  }
  const u = [];
  for (let d = 0; d < t; d += 1)
    u.push(
      o.row.createChecked(
        null,
        n && d === 0 ? a : s
      )
    );
  return o.table.createChecked(null, u);
}
function OZe(e) {
  return e instanceof Xr;
}
const Uy = ({
  editor: e
}) => {
  const { selection: t } = e.state;
  if (!OZe(t))
    return !1;
  let r = 0;
  const n = _Q(t.ranges[0].$from, (o) => o.type.name === "table");
  return n == null || n.node.descendants((o) => {
    if (o.type.name === "table")
      return !1;
    ["tableCell", "tableHeader"].includes(o.type.name) && (r += 1);
  }), r === t.ranges.length ? (e.commands.deleteTable(), !0) : !1;
}, uZ = Lo.create({
  name: "table",
  // @ts-ignore
  addOptions() {
    return {
      HTMLAttributes: {},
      resizable: !1,
      handleWidth: 5,
      cellMinWidth: 25,
      // TODO: fix
      View: NZe,
      lastColumnResizable: !0,
      allowTableNodeSelection: !1
    };
  },
  addAttributes() {
    return {
      class: {
        rendered: !0,
        default: null,
        parseHTML: (e) => e.getAttribute("class"),
        renderHTML: (e) => {
          if (e.class)
            return {
              class: e.class
            };
        }
      }
    };
  },
  content: "tableRow+",
  tableRole: "table",
  isolating: !0,
  group: "block",
  parseHTML() {
    return [{ tag: "table" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "table",
      _n(this.options.HTMLAttributes, e),
      ["tbody", 0]
    ];
  },
  addCommands() {
    return {
      insertTable: ({ rows: e = 3, cols: t = 3, withHeaderRow: r = !0 } = {}) => ({ tr: n, dispatch: i, editor: o }) => {
        const a = $Ze(o.schema, e, t, r);
        if (i) {
          const s = n.selection.anchor + 1;
          n.replaceSelectionWith(a).scrollIntoView().setSelection(pr.near(n.doc.resolve(s)));
        }
        return !0;
      },
      addColumnBefore: () => ({ state: e, dispatch: t }) => pZe(e, t),
      addColumnAfter: () => ({ state: e, dispatch: t }) => gZe(e, t),
      deleteColumn: () => ({ state: e, dispatch: t }) => vZe(e, t),
      addRowBefore: () => ({ state: e, dispatch: t }) => yZe(e, t),
      addRowAfter: () => ({ state: e, dispatch: t }) => xZe(e, t),
      deleteRow: () => ({ state: e, dispatch: t }) => MZe(e, t),
      deleteTable: () => ({ state: e, dispatch: t }) => EZe(e, t),
      mergeCells: () => ({ state: e, dispatch: t }) => mB(e, t),
      splitCell: () => ({ state: e, dispatch: t }) => vB(e, t),
      toggleHeaderColumn: () => ({ state: e, dispatch: t }) => sb("column")(e, t),
      toggleHeaderRow: () => ({ state: e, dispatch: t }) => sb("row")(e, t),
      toggleHeaderCell: () => ({ state: e, dispatch: t }) => DZe(e, t),
      mergeOrSplit: () => ({ state: e, dispatch: t }) => mB(e, t) ? !0 : vB(e, t),
      setCellAttribute: (e, t) => ({ state: r, dispatch: n }) => TZe(e, t)(r, n),
      goToNextCell: () => ({ state: e, dispatch: t }) => yB(1)(e, t),
      goToPreviousCell: () => ({ state: e, dispatch: t }) => yB(-1)(e, t),
      fixTables: () => ({ state: e, dispatch: t }) => (t && iZ(e), !0),
      setCellSelection: (e) => ({ tr: t, dispatch: r }) => {
        if (r) {
          const n = Xr.create(
            t.doc,
            e.anchorCell,
            e.headCell
          );
          t.setSelection(n);
        }
        return !0;
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      Tab: () => this.editor.commands.goToNextCell() ? !0 : this.editor.can().addRowAfter() ? this.editor.chain().addRowAfter().goToNextCell().run() : !1,
      "Shift-Tab": () => this.editor.commands.goToPreviousCell(),
      Backspace: Uy,
      "Mod-Backspace": Uy,
      Delete: Uy,
      "Mod-Delete": Uy
    };
  },
  addProseMirrorPlugins() {
    return [
      ...this.options.resizable && this.editor.isEditable ? [
        iZe({
          handleWidth: this.options.handleWidth,
          cellMinWidth: this.options.cellMinWidth,
          // @ts-ignore (incorrect type)
          View: this.options.View,
          // TODO: PR for @types/prosemirror-tables
          // @ts-ignore (incorrect type)
          lastColumnResizable: this.options.lastColumnResizable
        })
      ] : [],
      IZe({
        allowTableNodeSelection: this.options.allowTableNodeSelection
      })
    ];
  },
  extendNodeSchema(e) {
    const t = {
      name: e.name,
      options: e.options,
      storage: e.storage
    };
    return {
      tableRole: di(
        qi(e, "tableRole", t)
      )
    };
  }
}), cZ = Lo.create({
  name: "tableCell",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: (e) => {
          const t = e.getAttribute("colwidth");
          return t ? [parseInt(t, 10)] : null;
        }
      },
      class: {
        default: null
      },
      style: {
        default: null
      }
    };
  },
  tableRole: "cell",
  isolating: !0,
  parseHTML() {
    return [{ tag: "td" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "td",
      _n(this.options.HTMLAttributes, e),
      0
    ];
  }
}), dZ = Lo.create({
  name: "tableHeader",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: (e) => {
          const t = e.getAttribute("colwidth");
          return t ? [parseInt(t, 10)] : null;
        }
      },
      class: {
        default: null
      },
      style: {
        default: null
      }
    };
  },
  tableRole: "header_cell",
  isolating: !0,
  parseHTML() {
    return [{ tag: "th" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "th",
      _n(this.options.HTMLAttributes, e),
      0
    ];
  }
}), fZ = Lo.create({
  name: "tableRow",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  addAttributes() {
    return {
      class: {
        default: null
      },
      style: {
        default: null
      }
    };
  },
  content: "(tableCell | tableHeader)*",
  tableRole: "row",
  parseHTML() {
    return [{ tag: "tr" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "tr",
      _n(this.options.HTMLAttributes, e),
      0
    ];
  }
}), yKe = Fn.create({
  name: "tableExtensions",
  addExtensions() {
    return [uZ, cZ, dZ, fZ];
  }
}), xKe = Fn.create({
  name: "allExtensions",
  addExtensions() {
    var a, s, u, d, f;
    const e = [
      Gqe,
      bG.configure((a = this.options) == null ? void 0 : a.bold),
      MG.configure((s = this.options) == null ? void 0 : s.italic),
      EG.configure(this.options.underline),
      TG.configure(this.options.strike),
      kG.configure(this.options.subScript),
      DG.configure(this.options.superScript),
      fL.configure(this.options.fontSize),
      vG.configure(this.options.bulletList),
      wG.configure(this.options.fontFamily),
      AG.configure(this.options.heading),
      Uqe.configure(this.options.textAlignment),
      xG,
      yG,
      CG.configure(this.options.lineHeight),
      Bqe.configure(this.options.placeholder)
    ], t = [
      IG,
      NG,
      dL.configure((u = this.options) == null ? void 0 : u.paragraph)
    ], r = [
      _Ze.configure(this.options.bulletList),
      tKe.configure(this.options.orderedList),
      hL.configure(this.options.customList)
    ], n = [
      zWe.configure((d = this.options) == null ? void 0 : d.video),
      $We.configure(this.options.youtube),
      Fqe.configure((f = this.options) == null ? void 0 : f.image),
      eKe
    ], i = [
      uZ.configure(this.options.table),
      cZ.configure(this.options.tableCell),
      dZ.configure(this.options.tableHeader),
      fZ.configure(this.options.tableRow)
      // StyledTable.configure(this.options.table),
    ], o = [
      mG.configure(this.options.inlineCode),
      gG.configure(this.options.codeBlock)
    ];
    return [
      ...t,
      ...e,
      ...r,
      ...n,
      ...i,
      ...o
    ];
  }
}), MB = /^\s*([-+*])\s$/, _Ze = Lo.create({
  name: "bulletList",
  addAttributes() {
    return {
      listStyle: {
        default: null,
        parseHTML: (e) => e.style.listStyleType ?? "disc",
        renderHTML: (e) => e.listStyle ? {
          style: `list-style-type:${e.listStyle}`
        } : {}
      }
    };
  },
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  content() {
    return `${this.options.itemTypeName}+`;
  },
  group: "block list",
  parseHTML() {
    return [{ tag: "ul" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "ul",
      _n(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      toggleCustomBulletList: (e) => ({ chain: t }) => {
        var n;
        const r = (n = this.editor.getAttributes("bulletList")) == null ? void 0 : n.listStyle;
        return r !== void 0 && r !== e.type ? t().updateAttributes("bulletList", { listStyle: e.type }).run() : this.options.keepAttributes ? t().toggleList(this.name, this.options.itemTypeName).updateAttributes(
          hL.name,
          this.editor.getAttributes(lM.name)
        ).run() : t().toggleList(this.name, this.options.itemTypeName).updateAttributes("bulletList", { listStyle: e.type }).run();
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleCustomBulletList()
    };
  },
  addInputRules() {
    let e = U0({
      find: MB,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = U0({
      find: MB,
      type: this.type,
      getAttributes: () => this.editor.getAttributes(lM.name)
    })), [e];
  }
}), LZe = "aaa1rp3barth4b_ott3vie4c1le2ogado5udhabi7c_ademy5centure6ountant_s9o1tor4d_s1ult4e_g1ro2tna4f_l1rica5g_akhan5ency5i_g1rbus3force5tel5kdn3l_faromeo7ibaba4pay4lfinanz6state5y2sace3tom5m_azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o_l2partments8p_le4q_uarelle8r_ab1mco4chi3my2pa2t_e3s_da2ia2sociates9t_hleta5torney7u_ction5di_ble3o3spost5thor3o_s4vianca6w_s2x_a2z_ure5ba_by2idu3namex3narepublic11d1k2r_celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b_c1t1va3cg1n2d1e_ats2uty4er2ntley5rlin4st_buy5t2f1g1h_arti5i_ble3d1ke2ng_o3o1z2j1lack_friday9ockbuster8g1omberg7ue3m_s1w2n_pparibas9o_ats3ehringer8fa2m1nd2o_k_ing5sch2tik2on4t1utique6x2r_adesco6idgestone9oadway5ker3ther5ussels7s1t1uild_ers6siness6y1zz3v1w1y1z_h3ca_b1fe2l_l1vinklein9m_era3p2non3petown5ital_one8r_avan4ds2e_er_s4s2sa1e1h1ino4t_ering5holic7ba1n1re2s2c1d1enter4o1rn3f_a1d2g1h_anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i_priani6rcle4sco3tadel4i_c2y_eats7k1l_aims4eaning6ick2nic1que6othing5ud3ub_med6m1n1o_ach3des3ffee4llege4ogne5m_cast4mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking_channel11l1p2rsica5untry4pon_s4rses6pa2r_edit_card4union9icket5own3s1uise_s6u_isinella9v1w1x1y_mru3ou3z2dabur3d1nce3ta1e1ing3sun4y2clk3ds2e_al_er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si_gn4v2hl2iamonds6et2gital5rect_ory7scount3ver5h2y2j1k1m1np2o_cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c_o2deka3u_cation8e1g1mail3erck5nergy4gineer_ing9terprises10pson4quipment8r_icsson6ni3s_q1tate5t_isalat7u_rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n_s2rm_ers5shion4t3edex3edback6rrari3ero6i_at2delity5o2lm2nal1nce1ial7re_stone6mdale6sh_ing5t_ness6j1k1lickr3ghts4r2orist4wers5y2m1o_o_d_network8tball6rd1ex2sale4um3undation8x2r_ee1senius7l1ogans4ntdoor4ier7tr2ujitsu5n_d2rniture7tbol5yi3ga_l_lery3o1up4me_s3p1rden4y2b_iz3d_n2e_a1nt_ing5orge5f1g_ee3h1i_ft_s3ves2ing5l_ass3e1obal2o4m_ail3bh2o1x2n1odaddy5ld_point6f2o_dyear5g_le4p1t1v2p1q1r_ainger5phics5tis4een3ipe3ocery4up4s1t1u_ardian6cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc_bank7ealth_care8lp1sinki6re1mes5gtv3iphop4samitsu7tachi5v2k_t2m1n1ockey4ldings5iday5medepot5goods5s_ense7nda3rse3spital5t_ing5t_eles2s3mail5use3w2r1sbc3t1u_ghes5yatt3undai7ibm2cbc2e1u2d1e_ee3fm2kano4l1m_amat4db2mo_bilien9n_c1dustries8finiti5o2g1k1stitute6urance4e4t_ernational10uit4vestments10o1piranga7q1r_ish4s_maili5t_anbul7t_au2v3jaguar4va3cb2e_ep2tzt3welry6io2ll2m_p2nj2o_bs1urg4t1y2p_morgan6rs3uegos4niper7kaufen5ddi3e_rryhotels6logistics9properties14fh2g1h1i_a1ds2m1nder2le4tchen5wi3m1n1oeln3matsu5sher5p_mg2n2r_d1ed3uokgroup8w1y_oto4z2la_caixa5mborghini8er3ncaster5ia3d_rover6xess5salle5t_ino3robe5w_yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i_dl2fe_insurance9style7ghting6ke2lly3mited4o2ncoln4de2k2psy3ve1ing5k1lc1p2oan_s3cker3us3l1ndon4tte1o3ve3pl_financial11r1s1t_d_a3u_ndbeck6xe1ury5v1y2ma_cys3drid4if1son4keup4n_agement7go3p1rket_ing3s4riott5shalls7serati6ttel5ba2c_kinsey7d1e_d_ia3et2lbourne7me1orial6n_u2rckmsd7g1h1iami3crosoft7l1ni1t2t_subishi9k1l_b1s2m_a2n1o_bi_le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to_rcycles9v_ie4p1q1r1s_d2t_n1r2u_seum3ic3tual5v1w1x1y1z2na_b1goya4me2tura4vy3ba2c1e_c1t_bank4flix4work5ustar5w_s2xt_direct7us4f_l2g_o2hk2i_co2ke1on3nja3ssan1y5l1o_kia3rthwesternmutual14on4w_ruz3tv4p1r_a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan_group9dnavy5lo3m_ega4ne1g1l_ine5oo2pen3racle3nge4g_anic5igins6saka4tsuka4t2vh3pa_ge2nasonic7ris2s1tners4s1y3ssagens7y2ccw3e_t2f_izer5g1h_armacy6d1ilips5one2to_graphy6s4ysio5ics1tet2ures6d1n_g1k2oneer5zza4k1l_ace2y_station9umbing5s3m1n_c2ohl2ker3litie5rn2st3r_america6xi3ess3ime3o_d_uctions8f1gressive8mo2perties3y5tection8u_dential9s1t1ub2w_c2y2qa1pon3uebec3st5racing4dio4e_ad1lestate6tor2y4cipes5d_stone5umbrella9hab3ise_n3t2liance6n_t_als5pair3ort3ublican8st_aurant8view_s5xroth6ich_ardli6oh3l1o1p2o_cher3ks3deo3gers4om3s_vp3u_gby3hr2n2w_e2yukyu6sa_arland6fe_ty4kura4le1on3msclub4ung5ndvik_coromant12ofi4p1rl2s1ve2xo3b_i1s2c_a1b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e_arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x_y3fr2g1h_angrila6rp2w2ell3ia1ksha5oes2p_ping5uji3w_time7i_lk2na1gles5te3j1k_i_n2y_pe4l_ing4m_art3ile4n_cf3o_ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa_ce3ort2t3r_l2s1t_ada2ples4r1tebank4farm7c_group6ockholm6rage3e3ream4udio2y3yle4u_cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y_dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x_i3c_i2d_k2eam2ch_nology8l1masek5nnis4va3f1g1h_d1eater2re6iaa2ckets5enda4ffany5ps2res2ol4j_maxx4x2k_maxx5l1m_all4n1o_day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r_ade1ing4ining5vel_channel7ers_insurance16ust3v2t1ube2i1nes3shu4v_s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va_cations7na1guard7c1e_gas3ntures6risign5mögensberater2ung14sicherung10t2g1i_ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lkswagen7vo3te1ing3o2yage5u_elos6wales2mart4ter4ng_gou5tch_es6eather_channel12bcam3er2site5d_ding5ibo2r3f1hoswho6ien2ki2lliamhill9n_dows4e1ners6me2olterskluwer11odside6rk_s2ld3w2s1tc1f3xbox3erox4finity6ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u_tube6t1un3za_ppos4ra3ero3ip2m1one3uerich6w2", PZe = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5تصالات6رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत_म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里_大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", jp = (e, t) => {
  for (const r in t)
    e[r] = t[r];
  return e;
}, zO = "numeric", $O = "ascii", OO = "alpha", B1 = "asciinumeric", Hy = "alphanumeric", _O = "domain", hZ = "emoji", RZe = "scheme", jZe = "slashscheme", CB = "whitespace";
function FZe(e, t) {
  return e in t || (t[e] = []), t[e];
}
function Rf(e, t, r) {
  t[zO] && (t[B1] = !0, t[Hy] = !0), t[$O] && (t[B1] = !0, t[OO] = !0), t[B1] && (t[Hy] = !0), t[OO] && (t[Hy] = !0), t[Hy] && (t[_O] = !0), t[hZ] && (t[_O] = !0);
  for (const n in t) {
    const i = FZe(n, r);
    i.indexOf(e) < 0 && i.push(e);
  }
}
function BZe(e, t) {
  const r = {};
  for (const n in t)
    t[n].indexOf(e) >= 0 && (r[n] = !0);
  return r;
}
function da(e) {
  e === void 0 && (e = null), this.j = {}, this.jr = [], this.jd = null, this.t = e;
}
da.groups = {};
da.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(e) {
    const t = this, r = t.j[e];
    if (r)
      return r;
    for (let n = 0; n < t.jr.length; n++) {
      const i = t.jr[n][0], o = t.jr[n][1];
      if (o && i.test(e))
        return o;
    }
    return t.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(e, t) {
    return t === void 0 && (t = !1), t ? e in this.j : !!this.go(e);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(e, t, r, n) {
    for (let i = 0; i < e.length; i++)
      this.tt(e[i], t, r, n);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(e, t, r, n) {
    n = n || da.groups;
    let i;
    return t && t.j ? i = t : (i = new da(t), r && n && Rf(t, r, n)), this.jr.push([e, i]), i;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(e, t, r, n) {
    let i = this;
    const o = e.length;
    if (!o)
      return i;
    for (let a = 0; a < o - 1; a++)
      i = i.tt(e[a]);
    return i.tt(e[o - 1], t, r, n);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(e, t, r, n) {
    n = n || da.groups;
    const i = this;
    if (t && t.j)
      return i.j[e] = t, t;
    const o = t;
    let a, s = i.go(e);
    if (s ? (a = new da(), jp(a.j, s.j), a.jr.push.apply(a.jr, s.jr), a.jd = s.jd, a.t = s.t) : a = new da(), o) {
      if (n)
        if (a.t && typeof a.t == "string") {
          const u = jp(BZe(a.t, n), r);
          Rf(o, u, n);
        } else
          r && Rf(o, r, n);
      a.t = o;
    }
    return i.j[e] = a, a;
  }
};
const rr = (e, t, r, n, i) => e.ta(t, r, n, i), Ga = (e, t, r, n, i) => e.tr(t, r, n, i), SB = (e, t, r, n, i) => e.ts(t, r, n, i), Dt = (e, t, r, n, i) => e.tt(t, r, n, i), Eu = "WORD", LO = "UWORD", ub = "LOCALHOST", PO = "TLD", RO = "UTLD", U1 = "SCHEME", Gh = "SLASH_SCHEME", fM = "NUM", pZ = "WS", CL = "NL", Kh = "OPENBRACE", f0 = "OPENBRACKET", h0 = "OPENANGLEBRACKET", p0 = "OPENPAREN", zf = "CLOSEBRACE", Xh = "CLOSEBRACKET", Jh = "CLOSEANGLEBRACKET", $f = "CLOSEPAREN", hM = "AMPERSAND", pM = "APOSTROPHE", gM = "ASTERISK", ic = "AT", mM = "BACKSLASH", vM = "BACKTICK", bM = "CARET", sc = "COLON", SL = "COMMA", yM = "DOLLAR", is = "DOT", xM = "EQUALS", TL = "EXCLAMATION", as = "HYPHEN", wM = "PERCENT", MM = "PIPE", CM = "PLUS", SM = "POUND", TM = "QUERY", kL = "QUOTE", DL = "SEMI", zu = "SLASH", g0 = "TILDE", kM = "UNDERSCORE", gZ = "EMOJI", DM = "SYM";
var mZ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  WORD: Eu,
  UWORD: LO,
  LOCALHOST: ub,
  TLD: PO,
  UTLD: RO,
  SCHEME: U1,
  SLASH_SCHEME: Gh,
  NUM: fM,
  WS: pZ,
  NL: CL,
  OPENBRACE: Kh,
  OPENBRACKET: f0,
  OPENANGLEBRACKET: h0,
  OPENPAREN: p0,
  CLOSEBRACE: zf,
  CLOSEBRACKET: Xh,
  CLOSEANGLEBRACKET: Jh,
  CLOSEPAREN: $f,
  AMPERSAND: hM,
  APOSTROPHE: pM,
  ASTERISK: gM,
  AT: ic,
  BACKSLASH: mM,
  BACKTICK: vM,
  CARET: bM,
  COLON: sc,
  COMMA: SL,
  DOLLAR: yM,
  DOT: is,
  EQUALS: xM,
  EXCLAMATION: TL,
  HYPHEN: as,
  PERCENT: wM,
  PIPE: MM,
  PLUS: CM,
  POUND: SM,
  QUERY: TM,
  QUOTE: kL,
  SEMI: DL,
  SLASH: zu,
  TILDE: g0,
  UNDERSCORE: kM,
  EMOJI: gZ,
  SYM: DM
});
const Fh = /[a-z]/, HN = /\p{L}/u, WN = /\p{Emoji}/u, VN = /\d/, TB = /\s/, kB = `
`, UZe = "️", HZe = "‍";
let Wy = null, Vy = null;
function WZe(e) {
  e === void 0 && (e = []);
  const t = {};
  da.groups = t;
  const r = new da();
  Wy == null && (Wy = DB(LZe)), Vy == null && (Vy = DB(PZe)), Dt(r, "'", pM), Dt(r, "{", Kh), Dt(r, "[", f0), Dt(r, "<", h0), Dt(r, "(", p0), Dt(r, "}", zf), Dt(r, "]", Xh), Dt(r, ">", Jh), Dt(r, ")", $f), Dt(r, "&", hM), Dt(r, "*", gM), Dt(r, "@", ic), Dt(r, "`", vM), Dt(r, "^", bM), Dt(r, ":", sc), Dt(r, ",", SL), Dt(r, "$", yM), Dt(r, ".", is), Dt(r, "=", xM), Dt(r, "!", TL), Dt(r, "-", as), Dt(r, "%", wM), Dt(r, "|", MM), Dt(r, "+", CM), Dt(r, "#", SM), Dt(r, "?", TM), Dt(r, '"', kL), Dt(r, "/", zu), Dt(r, ";", DL), Dt(r, "~", g0), Dt(r, "_", kM), Dt(r, "\\", mM);
  const n = Ga(r, VN, fM, {
    [zO]: !0
  });
  Ga(n, VN, n);
  const i = Ga(r, Fh, Eu, {
    [$O]: !0
  });
  Ga(i, Fh, i);
  const o = Ga(r, HN, LO, {
    [OO]: !0
  });
  Ga(o, Fh), Ga(o, HN, o);
  const a = Ga(r, TB, pZ, {
    [CB]: !0
  });
  Dt(r, kB, CL, {
    [CB]: !0
  }), Dt(a, kB), Ga(a, TB, a);
  const s = Ga(r, WN, gZ, {
    [hZ]: !0
  });
  Ga(s, WN, s), Dt(s, UZe, s);
  const u = Dt(s, HZe);
  Ga(u, WN, s);
  const d = [[Fh, i]], f = [[Fh, null], [HN, o]];
  for (let h = 0; h < Wy.length; h++)
    ec(r, Wy[h], PO, Eu, d);
  for (let h = 0; h < Vy.length; h++)
    ec(r, Vy[h], RO, LO, f);
  Rf(PO, {
    tld: !0,
    ascii: !0
  }, t), Rf(RO, {
    utld: !0,
    alpha: !0
  }, t), ec(r, "file", U1, Eu, d), ec(r, "mailto", U1, Eu, d), ec(r, "http", Gh, Eu, d), ec(r, "https", Gh, Eu, d), ec(r, "ftp", Gh, Eu, d), ec(r, "ftps", Gh, Eu, d), Rf(U1, {
    scheme: !0,
    ascii: !0
  }, t), Rf(Gh, {
    slashscheme: !0,
    ascii: !0
  }, t), e = e.sort((h, g) => h[0] > g[0] ? 1 : -1);
  for (let h = 0; h < e.length; h++) {
    const g = e[h][0], v = e[h][1] ? {
      [RZe]: !0
    } : {
      [jZe]: !0
    };
    g.indexOf("-") >= 0 ? v[_O] = !0 : Fh.test(g) ? VN.test(g) ? v[B1] = !0 : v[$O] = !0 : v[zO] = !0, SB(r, g, g, v);
  }
  return SB(r, "localhost", ub, {
    ascii: !0
  }), r.jd = new da(DM), {
    start: r,
    tokens: jp({
      groups: t
    }, mZ)
  };
}
function VZe(e, t) {
  const r = YZe(t.replace(/[A-Z]/g, (s) => s.toLowerCase())), n = r.length, i = [];
  let o = 0, a = 0;
  for (; a < n; ) {
    let s = e, u = null, d = 0, f = null, h = -1, g = -1;
    for (; a < n && (u = s.go(r[a])); )
      s = u, s.accepts() ? (h = 0, g = 0, f = s) : h >= 0 && (h += r[a].length, g++), d += r[a].length, o += r[a].length, a++;
    o -= h, a -= g, d -= h, i.push({
      t: f.t,
      // token type/name
      v: t.slice(o - d, o),
      // string value
      s: o - d,
      // start index
      e: o
      // end index (excluding)
    });
  }
  return i;
}
function YZe(e) {
  const t = [], r = e.length;
  let n = 0;
  for (; n < r; ) {
    let i = e.charCodeAt(n), o, a = i < 55296 || i > 56319 || n + 1 === r || (o = e.charCodeAt(n + 1)) < 56320 || o > 57343 ? e[n] : e.slice(n, n + 2);
    t.push(a), n += a.length;
  }
  return t;
}
function ec(e, t, r, n, i) {
  let o;
  const a = t.length;
  for (let s = 0; s < a - 1; s++) {
    const u = t[s];
    e.j[u] ? o = e.j[u] : (o = new da(n), o.jr = i.slice(), e.j[u] = o), e = o;
  }
  return o = new da(r), o.jr = i.slice(), e.j[t[a - 1]] = o, o;
}
function DB(e) {
  const t = [], r = [];
  let n = 0, i = "0123456789";
  for (; n < e.length; ) {
    let o = 0;
    for (; i.indexOf(e[n + o]) >= 0; )
      o++;
    if (o > 0) {
      t.push(r.join(""));
      let a = parseInt(e.substring(n, n + o), 10);
      for (; a > 0; a--)
        r.pop();
      n += o;
    } else
      e[n] === "_" ? (t.push(r.join("")), n++) : (r.push(e[n]), n++);
  }
  return t;
}
const cb = {
  defaultProtocol: "http",
  events: null,
  format: AB,
  formatHref: AB,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function AL(e, t) {
  t === void 0 && (t = null);
  let r = jp({}, cb);
  e && (r = jp(r, e instanceof AL ? e.o : e));
  const n = r.ignoreTags, i = [];
  for (let o = 0; o < n.length; o++)
    i.push(n[o].toUpperCase());
  this.o = r, t && (this.defaultRender = t), this.ignoreTags = i;
}
AL.prototype = {
  o: cb,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(e) {
    return e;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(e) {
    return this.get("validate", e.toString(), e);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(e, t, r) {
    const n = t != null;
    let i = this.o[e];
    return i && (typeof i == "object" ? (i = r.t in i ? i[r.t] : cb[e], typeof i == "function" && n && (i = i(t, r))) : typeof i == "function" && n && (i = i(t, r.t, r)), i);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(e, t, r) {
    let n = this.o[e];
    return typeof n == "function" && t != null && (n = n(t, r.t, r)), n;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(e) {
    const t = e.render(this);
    return (this.get("render", null, e) || this.defaultRender)(t, e.t, e);
  }
};
function AB(e) {
  return e;
}
function vZ(e, t) {
  this.t = "token", this.v = e, this.tk = t;
}
vZ.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
  */
  toHref(e) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(e) {
    const t = this.toString(), r = e.get("truncate", t, this), n = e.get("format", t, this);
    return r && n.length > r ? n.substring(0, r) + "…" : n;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(e) {
    return e.get("formatHref", this.toHref(e.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(e) {
    return e === void 0 && (e = cb.defaultProtocol), {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(e) {
    return {
      type: this.t,
      value: this.toFormattedString(e),
      isLink: this.isLink,
      href: this.toFormattedHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(e) {
    return e.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(e) {
    const t = this, r = this.toFormattedHref(e), n = e.get("tagName", r, t), i = this.toFormattedString(e), o = {}, a = e.get("className", r, t), s = e.get("target", r, t), u = e.get("rel", r, t), d = e.getObj("attributes", r, t), f = e.getObj("events", r, t);
    return o.href = r, a && (o.class = a), s && (o.target = s), u && (o.rel = u), d && jp(o, d), {
      tagName: n,
      attributes: o,
      content: i,
      eventListeners: f
    };
  }
};
function wC(e, t) {
  class r extends vZ {
    constructor(i, o) {
      super(i, o), this.t = e;
    }
  }
  for (const n in t)
    r.prototype[n] = t[n];
  return r.t = e, r;
}
const EB = wC("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), IB = wC("text"), QZe = wC("nl"), Mf = wC("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(e) {
    return e === void 0 && (e = cb.defaultProtocol), this.hasProtocol() ? this.v : `${e}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const e = this.tk;
    return e.length >= 2 && e[0].t !== ub && e[1].t === sc;
  }
}), Ji = (e) => new da(e);
function qZe(e) {
  let {
    groups: t
  } = e;
  const r = t.domain.concat([hM, gM, ic, mM, vM, bM, yM, xM, as, fM, wM, MM, CM, SM, zu, DM, g0, kM]), n = [pM, Jh, zf, Xh, $f, sc, SL, is, TL, h0, Kh, f0, p0, TM, kL, DL], i = [hM, pM, gM, mM, vM, bM, zf, yM, xM, as, fM, Kh, wM, MM, CM, SM, TM, zu, DM, g0, kM], o = Ji(), a = Dt(o, g0);
  rr(a, i, a), rr(a, t.domain, a);
  const s = Ji(), u = Ji(), d = Ji();
  rr(o, t.domain, s), rr(o, t.scheme, u), rr(o, t.slashscheme, d), rr(s, i, a), rr(s, t.domain, s);
  const f = Dt(s, ic);
  Dt(a, ic, f), Dt(u, ic, f), Dt(d, ic, f);
  const h = Dt(a, is);
  rr(h, i, a), rr(h, t.domain, a);
  const g = Ji();
  rr(f, t.domain, g), rr(g, t.domain, g);
  const m = Dt(g, is);
  rr(m, t.domain, g);
  const v = Ji(EB);
  rr(m, t.tld, v), rr(m, t.utld, v), Dt(f, ub, v);
  const w = Dt(g, as);
  rr(w, t.domain, g), rr(v, t.domain, g), Dt(v, is, m), Dt(v, as, w);
  const x = Dt(v, sc);
  rr(x, t.numeric, EB);
  const y = Dt(s, as), C = Dt(s, is);
  rr(y, t.domain, s), rr(C, i, a), rr(C, t.domain, s);
  const S = Ji(Mf);
  rr(C, t.tld, S), rr(C, t.utld, S), rr(S, t.domain, s), rr(S, i, a), Dt(S, is, C), Dt(S, as, y), Dt(S, ic, f);
  const T = Dt(S, sc), A = Ji(Mf);
  rr(T, t.numeric, A);
  const D = Ji(Mf), E = Ji();
  rr(D, r, D), rr(D, n, E), rr(E, r, D), rr(E, n, E), Dt(S, zu, D), Dt(A, zu, D);
  const N = Dt(u, sc), I = Dt(d, sc), $ = Dt(I, zu);
  Dt($, zu, N), rr(u, t.domain, s), Dt(u, is, C), Dt(u, as, y), rr(d, t.domain, s), Dt(d, is, C), Dt(d, as, y), rr(N, t.domain, D), Dt(N, zu, D);
  const _ = Dt(D, Kh), R = Dt(D, f0), U = Dt(D, h0), Q = Dt(D, p0);
  Dt(E, Kh, _), Dt(E, f0, R), Dt(E, h0, U), Dt(E, p0, Q), Dt(_, zf, D), Dt(R, Xh, D), Dt(U, Jh, D), Dt(Q, $f, D), Dt(_, zf, D);
  const Z = Ji(Mf), X = Ji(Mf), re = Ji(Mf), ue = Ji(Mf);
  rr(_, r, Z), rr(R, r, X), rr(U, r, re), rr(Q, r, ue);
  const he = Ji(), te = Ji(), de = Ji(), De = Ji();
  return rr(_, n), rr(R, n), rr(U, n), rr(Q, n), rr(Z, r, Z), rr(X, r, X), rr(re, r, re), rr(ue, r, ue), rr(Z, n, Z), rr(X, n, X), rr(re, n, re), rr(ue, n, ue), rr(he, r, he), rr(te, r, X), rr(de, r, re), rr(De, r, ue), rr(he, n, he), rr(te, n, te), rr(de, n, de), rr(De, n, De), Dt(X, Xh, D), Dt(re, Jh, D), Dt(ue, $f, D), Dt(Z, zf, D), Dt(te, Xh, D), Dt(de, Jh, D), Dt(De, $f, D), Dt(he, $f, D), Dt(o, ub, S), Dt(o, CL, QZe), {
    start: o,
    tokens: mZ
  };
}
function GZe(e, t, r) {
  let n = r.length, i = 0, o = [], a = [];
  for (; i < n; ) {
    let s = e, u = null, d = null, f = 0, h = null, g = -1;
    for (; i < n && !(u = s.go(r[i].t)); )
      a.push(r[i++]);
    for (; i < n && (d = u || s.go(r[i].t)); )
      u = null, s = d, s.accepts() ? (g = 0, h = s) : g >= 0 && g++, i++, f++;
    if (g < 0)
      i -= f, i < n && (a.push(r[i]), i++);
    else {
      a.length > 0 && (o.push(YN(IB, t, a)), a = []), i -= g, f -= g;
      const m = h.t, v = r.slice(i - f, i);
      o.push(YN(m, t, v));
    }
  }
  return a.length > 0 && o.push(YN(IB, t, a)), o;
}
function YN(e, t, r) {
  const n = r[0].s, i = r[r.length - 1].e, o = t.slice(n, i);
  return new e(o, r);
}
const Ai = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function ZZe() {
  da.groups = {}, Ai.scanner = null, Ai.parser = null, Ai.tokenQueue = [], Ai.pluginQueue = [], Ai.customSchemes = [], Ai.initialized = !1;
}
function KZe() {
  Ai.scanner = WZe(Ai.customSchemes);
  for (let e = 0; e < Ai.tokenQueue.length; e++)
    Ai.tokenQueue[e][1]({
      scanner: Ai.scanner
    });
  Ai.parser = qZe(Ai.scanner.tokens);
  for (let e = 0; e < Ai.pluginQueue.length; e++)
    Ai.pluginQueue[e][1]({
      scanner: Ai.scanner,
      parser: Ai.parser
    });
  Ai.initialized = !0;
}
function bZ(e) {
  return Ai.initialized || KZe(), GZe(Ai.parser.start, e, VZe(Ai.scanner.start, e));
}
function EL(e, t, r) {
  if (t === void 0 && (t = null), r === void 0 && (r = null), t && typeof t == "object") {
    if (r)
      throw Error(`linkifyjs: Invalid link type ${t}; must be a string`);
    r = t, t = null;
  }
  const n = new AL(r), i = bZ(e), o = [];
  for (let a = 0; a < i.length; a++) {
    const s = i[a];
    s.isLink && (!t || s.t === t) && o.push(s.toFormattedObject(n));
  }
  return o;
}
function NB(e, t) {
  t === void 0 && (t = null);
  const r = bZ(e);
  return r.length === 1 && r[0].isLink && (!t || r[0].t === t);
}
function XZe(e) {
  return new ra({
    key: new _o("autolink"),
    appendTransaction: (t, r, n) => {
      const i = t.some((f) => f.docChanged) && !r.doc.eq(n.doc), o = t.some(
        (f) => f.getMeta("preventAutolink")
      );
      if (!i || o)
        return;
      const { tr: a } = n, s = WLe(r.doc, [...t]), { mapping: u } = s;
      if (KLe(s).forEach(({ oldRange: f, newRange: h }) => {
        Ox(f.from, f.to, r.doc).filter((w) => w.mark.type === e.type).forEach((w) => {
          const x = u.map(w.from), y = u.map(w.to), C = Ox(
            x,
            y,
            n.doc
          ).filter((N) => N.mark.type === e.type);
          if (!C.length)
            return;
          const S = C[0], T = r.doc.textBetween(
            w.from,
            w.to,
            void 0,
            " "
          ), A = n.doc.textBetween(
            S.from,
            S.to,
            void 0,
            " "
          ), D = NB(T), E = NB(A);
          D && !E && a.removeMark(S.from, S.to, e.type);
        });
        const g = YLe(
          n.doc,
          h,
          (w) => w.isTextblock
        );
        let m, v;
        if (g.length > 1 ? (m = g[0], v = n.doc.textBetween(
          m.pos,
          m.pos + m.node.nodeSize,
          void 0,
          " "
        )) : g.length && // We want to make sure to include the block seperator argument to treat hard breaks like spaces
        n.doc.textBetween(h.from, h.to, " ", " ").endsWith(" ") && (m = g[0], v = n.doc.textBetween(
          m.pos,
          h.to,
          void 0,
          " "
        )), m && v) {
          const w = v.split(" ").filter((C) => C !== "");
          if (w.length <= 0)
            return !1;
          const x = w[w.length - 1], y = m.pos + v.lastIndexOf(x);
          if (!x)
            return !1;
          EL(x).filter((C) => C.isLink).filter((C) => e.validate ? e.validate(C.value) : !0).map((C) => ({
            ...C,
            from: y + C.start + 1,
            to: y + C.end + 1
          })).forEach((C) => {
            a.addMark(
              C.from,
              C.to,
              e.type.create({
                href: C.href
              })
            );
          });
        }
      }), !!a.steps.length)
        return a;
    }
  });
}
function JZe(e) {
  return new ra({
    key: new _o("handlePasteLink"),
    props: {
      handlePaste: (t, r, n) => {
        const { state: i } = t, { selection: o } = i, { empty: a } = o;
        if (a)
          return !1;
        let s = "";
        n.content.forEach((d) => {
          s += d.textContent;
        });
        const u = EL(s).find(
          (d) => d.isLink && d.value === s
        );
        return !s || !u ? !1 : (e.editor.commands.setMark(e.type, {
          href: u.href
        }), !0);
      }
    }
  });
}
const eKe = Ua.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  onDestroy() {
    ZZe();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      HTMLAttributes: {
        target: "_blank",
        title: "",
        class: void 0
      },
      validate: void 0
    };
  },
  addAttributes() {
    return {
      href: {
        default: null
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      title: {
        default: null
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      style: {
        default: null
      }
    };
  },
  parseHTML() {
    return [{ tag: 'a[href]:not([href *= "javascript:" i])' }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "a",
      _n(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      setLink: (e) => ({ chain: t }) => t().setMark(this.name, e).setMeta("preventAutolink", !0).run(),
      toggleLink: (e) => ({ chain: t }) => t().toggleMark(this.name, e, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run(),
      unsetLink: () => ({ chain: e }) => e().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      Ec({
        find: (e) => EL(e).filter((t) => this.options.validate ? this.options.validate(t.value) : !0).filter((t) => t.isLink).map((t) => ({
          text: t.value,
          index: t.start,
          data: t
        })),
        type: this.type,
        getAttributes: (e) => {
          var t;
          return {
            href: (t = e.data) == null ? void 0 : t.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const e = [];
    return this.options.autolink && e.push(
      XZe({
        type: this.type,
        validate: (t) => !!/^(http(s)?:\/\/)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.+~#?&//=]*)$/.test(t)
      })
    ), this.options.openOnClick && e.push(
      rG(
        {
          type: this.type
        },
        "a"
      )
    ), this.options.linkOnPaste && e.push(
      JZe({
        editor: this.editor,
        type: this.type
      })
    ), e;
  }
}), zB = /^(\d+)\.\s$/, tKe = Lo.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      listStyle: {
        default: null,
        parseHTML: (e) => e.style.listStyleType ?? "decimal",
        renderHTML: (e) => e.listStyle ? {
          style: `list-style-type:${e.listStyle}`
        } : {}
      },
      start: {
        default: 1,
        parseHTML: (e) => e.hasAttribute("start") ? parseInt(e.getAttribute("start") || "", 10) : 1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    const { start: t, ...r } = e;
    return t === 1 ? [
      "ol",
      _n(this.options.HTMLAttributes, r),
      0
    ] : ["ol", _n(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      toggleCustomOrderedList: (e) => ({ chain: t }) => {
        var n;
        const r = (n = this.editor.getAttributes("orderedList")) == null ? void 0 : n.listStyle;
        return r !== void 0 && r !== e.type ? t().updateAttributes("orderedList", { listStyle: e.type }).run() : this.options.keepAttributes ? t().toggleList(this.name, this.options.itemTypeName).updateAttributes(
          hL.name,
          this.editor.getAttributes(lM.name)
        ).run() : t().toggleList(this.name, this.options.itemTypeName).updateAttributes("orderedList", { listStyle: e.type }).run();
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let e = U0({
      find: zB,
      type: this.type,
      getAttributes: (t) => ({ start: +t[1] }),
      joinPredicate: (t, r) => r.childCount + r.attrs.start === +t[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = U0({
      find: zB,
      type: this.type,
      getAttributes: (t) => ({
        start: +t[1],
        ...this.editor.getAttributes(lM.name)
      }),
      joinPredicate: (t, r) => r.childCount + r.attrs.start === +t[1]
    })), [e];
  }
}), wKe = Fn.create({
  name: "requiredExtensions",
  addExtensions() {
    var e;
    return [IG, NG, dL.configure((e = this.options) == null ? void 0 : e.paragraph)];
  }
}), QN = {
  RTEControlBold: z1,
  RTEControlItalic: $1,
  RTEControlUnderline: P1,
  RTEControlStrike: O1,
  RTEControlTextBlocks: I1,
  RTEControlTextAlignment: E1,
  RTEControlFontFamily: M1,
  RTEControlLineHeight: T1,
  RTEControlCustomSelect: v1,
  RTEControlEmbedVideo: x1,
  RTEControlEmbedImage: y1,
  RTEControlFontSize: C1,
  UIRichTextEditor: UVe,
  RTEControlResetStyles: D1,
  RTEControlList: k1,
  RTEControlColorPicker: m1,
  RTEControlHistory: S1,
  RTEControlCode: f1,
  RTEControlSuperscript: L1,
  RTEControlSubscript: _1,
  RTEControl: Br,
  RTEControlBlockQuote: N1,
  RTEControlTable: A1
};
function rKe(e) {
  for (const t in QN)
    e.component(QN[t].name, QN[t]);
}
const MKe = { install: rKe };
export {
  xKe as AllExtensions,
  vG as Blockquote,
  bG as Bold,
  _Ze as BulletList,
  gG as CodeBlock,
  vKe as CodeFormats,
  Vqe as Color,
  wG as FontFamily,
  Fqe as Image,
  mG as InlineCode,
  MG as Italic,
  CG as LineHeight,
  eKe as Link,
  hL as ListItem,
  tKe as OrderedList,
  Bqe as Placeholder,
  Br as RTEControl,
  N1 as RTEControlBlockQuote,
  z1 as RTEControlBold,
  f1 as RTEControlCode,
  m1 as RTEControlColorPicker,
  v1 as RTEControlCustomSelect,
  y1 as RTEControlEmbedImage,
  PN as RTEControlEmbedLink,
  x1 as RTEControlEmbedVideo,
  M1 as RTEControlFontFamily,
  C1 as RTEControlFontSize,
  S1 as RTEControlHistory,
  $1 as RTEControlItalic,
  T1 as RTEControlLineHeight,
  k1 as RTEControlList,
  D1 as RTEControlResetStyles,
  O1 as RTEControlStrike,
  _1 as RTEControlSubscript,
  L1 as RTEControlSuperscript,
  A1 as RTEControlTable,
  E1 as RTEControlTextAlignment,
  I1 as RTEControlTextBlocks,
  P1 as RTEControlUnderline,
  wKe as RequiredExtensions,
  TG as Strike,
  kG as Subscript,
  DG as Superscript,
  uZ as Table,
  cZ as TableCell,
  Qr as TableControlActions,
  yKe as TableExtensions,
  dZ as TableHeader,
  fZ as TableRow,
  Uqe as TextAlign,
  qqe as TextBlocks,
  lM as TextExtensions,
  Gqe as TextSize,
  UVe as UIRichTextEditor,
  EG as Underline,
  zWe as Video,
  $We as Youtube,
  MKe as default
};
